webpackJsonp([8],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = __webpack_require__(961);
var URI = __webpack_require__(120);
var session_1 = __webpack_require__(1197);
var browserURI = URI(window.location);
var configuration = {};
browserURI.hasQuery("octopus.server", function (octopusServerURI) {
    configuration.serverEndpoint = octopusServerURI;
});
var client = new client_1.Client(configuration);
exports.client = client;
var repository = new client_1.Repository(client);
exports.repository = repository;
var session = new session_1.default();
exports.session = session;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\clientInstance.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\clientInstance.ts"); } } })();

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var store_1 = __webpack_require__(123);
var reducers_1 = __webpack_require__(546);
var reducers_2 = __webpack_require__(354);
var logger_1 = __webpack_require__(102);
var BaseComponent = (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.unmounted = false;
        _this.provideErrorHandlingToTopLevelMethods();
        _this.addUnmountedHook();
        return _this;
    }
    // tslint:enable:unified-signatures
    BaseComponent.prototype.setState = function (m, callback) {
        if (this.unmounted) {
            return;
        }
        _super.prototype.setState.call(this, m, callback);
    };
    BaseComponent.prototype.setChildState1 = function (first, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], state),
                _a);
            var _a;
        }, callback);
    };
    BaseComponent.prototype.setChildState2 = function (first, second, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], (_b = {}, _b[second] = __assign({}, prev[first][second], state), _b)),
                _a);
            var _a, _b;
        }, callback);
    };
    BaseComponent.prototype.setChildState3 = function (first, second, third, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], (_b = {}, _b[second] = __assign({}, prev[first][second], (_c = {}, _c[third] = __assign({}, prev[first][second][third], state), _c)), _b)),
                _a);
            var _a, _b, _c;
        }, callback);
    };
    BaseComponent.prototype.setChildState4 = function (first, second, third, fourth, state, callback) {
        this.setState(function (prev) {
            return (_a = {},
                _a[first] = __assign({}, prev[first], (_b = {}, _b[second] = __assign({}, prev[first][second], (_c = {}, _c[third] = __assign({}, prev[first][second][third], (_d = {}, _d[fourth] = __assign({}, prev[first][second][third][fourth], state), _d)), _c)), _b)),
                _a);
            var _a, _b, _c, _d;
        }, callback);
    };
    BaseComponent.prototype.provideErrorHandling = function (func) {
        var name = this.findNameOf(func);
        this.provideErrorHandlingByName(name);
    };
    BaseComponent.prototype.clearError = function () {
        store_1.default.dispatch(reducers_2.clearUnhandledErrorAction());
    };
    BaseComponent.prototype.provideErrorHandlingByName = function (name) {
        var _this = this;
        var originalMethod = this[name].bind(this);
        var wrapper = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                var result = originalMethod.apply(void 0, args);
                if (result instanceof Promise) {
                    return result.catch(function (error) {
                        _this.handleError(error, name);
                    });
                }
                else {
                    return result;
                }
            }
            catch (error) {
                _this.handleError(error, name);
                throw error;
            }
        };
        this[name] = wrapper;
    };
    BaseComponent.prototype.handleError = function (error, name) {
        logger_1.default.error("Error occurred in " + name);
        logger_1.default.error(error);
        store_1.default.dispatch(reducers_1.raiseUnhandledErrorAction(error));
        throw error;
    };
    BaseComponent.prototype.addUnmountedHook = function () {
        var _this = this;
        var componentWillUnmount = this["componentWillUnmount"];
        var originalMethod = componentWillUnmount && componentWillUnmount.bind(this);
        this["componentWillUnmount"] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.unmounted = true;
                            if (!originalMethod) return [3 /*break*/, 2];
                            return [4 /*yield*/, originalMethod.apply(void 0, args)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
    };
    BaseComponent.prototype.findNameOf = function (func) {
        var _this = this;
        return Object.getOwnPropertyNames(this).filter(function (name) { return _this[name] === func; })[0];
    };
    BaseComponent.prototype.provideErrorHandlingToTopLevelMethods = function () {
        var _this = this;
        Object.getOwnPropertyNames(Object.getPrototypeOf(this)).forEach(function (name) {
            if (BaseComponent.methodsToCapture.includes(name)) {
                _this.provideErrorHandlingByName(name);
            }
        });
    };
    BaseComponent.methodsToCapture = ["componentDidMount", "componentWillMount", "componentDidUpdate", "componentWillUnmount",
        "shouldComponentUpdate", "componentWillUpdate", "componentWillReceiveProps"];
    return BaseComponent;
}(React.Component));
exports.BaseComponent = BaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\BaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\BaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// import Form from "./Form";
var Text_1 = __webpack_require__(50);
exports.Text = Text_1.default;
var DatePicker_1 = __webpack_require__(1706);
exports.DatePicker = DatePicker_1.default;
var Select_1 = __webpack_require__(40);
exports.Select = Select_1.default;
var Checkbox_1 = __webpack_require__(121);
exports.Checkbox = Checkbox_1.default;
var StringCheckbox_1 = __webpack_require__(41);
exports.StringCheckbox = StringCheckbox_1.default;
var FileUpload_1 = __webpack_require__(834);
exports.FileUpload = FileUpload_1.default;
var FormFieldProps_1 = __webpack_require__(1712);
exports.FormFieldProps = FormFieldProps_1.default;
var ExpandableFormSection_1 = __webpack_require__(30);
exports.ExpandableFormSection = ExpandableFormSection_1.default;
var Summary_1 = __webpack_require__(44);
exports.Summary = Summary_1.default;
exports.SummaryNodeProps = Summary_1.SummaryNodeProps;
exports.SummaryNode = Summary_1.SummaryNode;
var ExpansionButtons_1 = __webpack_require__(457);
exports.ExpansionButtons = ExpansionButtons_1.default;
var UnstructuredFormSection_1 = __webpack_require__(475);
exports.UnstructuredFormSection = UnstructuredFormSection_1.default;
var FormSectionHeading_1 = __webpack_require__(48);
exports.FormSectionHeading = FormSectionHeading_1.default;
var RadioButtonGroup_1 = __webpack_require__(36);
exports.StringRadioButtonGroup = RadioButtonGroup_1.StringRadioButtonGroup;
exports.BooleanRadioButtonGroup = RadioButtonGroup_1.BooleanRadioButtonGroup;
var RadioButtonGroup_2 = __webpack_require__(36);
exports.RadioButtonGroup = RadioButtonGroup_2.default;
var RadioButton_1 = __webpack_require__(32);
exports.RadioButton = RadioButton_1.default;
var ErrorPanel_1 = __webpack_require__(85);
exports.ErrorPanel = ErrorPanel_1.default;
var ColorPicker_1 = __webpack_require__(799);
exports.ColorPicker = ColorPicker_1.default;
var MoreInfo_1 = __webpack_require__(326);
exports.MoreInfo = MoreInfo_1.default;
var MarkdownEditor_1 = __webpack_require__(304);
exports.MarkdownEditor = MarkdownEditor_1.default;
var LogoEditor_1 = __webpack_require__(480);
exports.LogoEditor = LogoEditor_1.default;
var Note_1 = __webpack_require__(20);
exports.Note = Note_1.default;
var FormSection_1 = __webpack_require__(706);
exports.FormSection = FormSection_1.default;
var Sensitive_1 = __webpack_require__(93);
exports.Sensitive = Sensitive_1.default;
var SensitiveFileUpload_1 = __webpack_require__(800);
exports.SensitiveFileUpload = SensitiveFileUpload_1.default;
var LogoEditor_2 = __webpack_require__(480);
exports.LogoEditorSettings = LogoEditor_2.LogoEditorSettings;
var TimePicker_1 = __webpack_require__(1730);
exports.TimePicker = TimePicker_1.default;
__export(__webpack_require__(199));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\index.ts"); } } })();

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));
__export(__webpack_require__(970));
__export(__webpack_require__(971));
__export(__webpack_require__(452));
__export(__webpack_require__(972));
__export(__webpack_require__(973));
__export(__webpack_require__(974));
__export(__webpack_require__(975));
__export(__webpack_require__(976));
__export(__webpack_require__(977));
__export(__webpack_require__(978));
__export(__webpack_require__(979));
__export(__webpack_require__(980));
__export(__webpack_require__(981));
__export(__webpack_require__(982));
__export(__webpack_require__(983));
__export(__webpack_require__(984));
__export(__webpack_require__(985));
__export(__webpack_require__(986));
__export(__webpack_require__(987));
__export(__webpack_require__(988));
__export(__webpack_require__(989));
__export(__webpack_require__(990));
__export(__webpack_require__(991));
__export(__webpack_require__(992));
__export(__webpack_require__(993));
__export(__webpack_require__(994));
__export(__webpack_require__(995));
__export(__webpack_require__(996));
__export(__webpack_require__(264));
__export(__webpack_require__(997));
__export(__webpack_require__(477));
__export(__webpack_require__(998));
__export(__webpack_require__(999));
__export(__webpack_require__(1000));
__export(__webpack_require__(1001));
__export(__webpack_require__(1002));
__export(__webpack_require__(1003));
__export(__webpack_require__(1004));
__export(__webpack_require__(1005));
__export(__webpack_require__(1006));
__export(__webpack_require__(1007));
__export(__webpack_require__(1008));
__export(__webpack_require__(824));
__export(__webpack_require__(1009));
__export(__webpack_require__(825));
__export(__webpack_require__(1010));
__export(__webpack_require__(1011));
__export(__webpack_require__(1012));
__export(__webpack_require__(1013));
__export(__webpack_require__(1014));
__export(__webpack_require__(1015));
__export(__webpack_require__(1016));
__export(__webpack_require__(1017));
__export(__webpack_require__(1018));
__export(__webpack_require__(826));
__export(__webpack_require__(1019));
__export(__webpack_require__(1020));
__export(__webpack_require__(213));
__export(__webpack_require__(1021));
__export(__webpack_require__(827));
__export(__webpack_require__(1022));
__export(__webpack_require__(1023));
__export(__webpack_require__(51));
__export(__webpack_require__(1024));
__export(__webpack_require__(1025));
__export(__webpack_require__(1026));
__export(__webpack_require__(1027));
__export(__webpack_require__(1028));
__export(__webpack_require__(1029));
__export(__webpack_require__(1030));
__export(__webpack_require__(544));
__export(__webpack_require__(1031));
__export(__webpack_require__(1032));
__export(__webpack_require__(1033));
__export(__webpack_require__(55));
__export(__webpack_require__(1034));
__export(__webpack_require__(1035));
__export(__webpack_require__(1036));
__export(__webpack_require__(1037));
__export(__webpack_require__(1038));
__export(__webpack_require__(1039));
__export(__webpack_require__(1040));
__export(__webpack_require__(1041));
__export(__webpack_require__(1042));
__export(__webpack_require__(1043));
__export(__webpack_require__(1044));
__export(__webpack_require__(1045));
__export(__webpack_require__(765));
__export(__webpack_require__(1046));
__export(__webpack_require__(1047));
__export(__webpack_require__(450));
__export(__webpack_require__(433));
__export(__webpack_require__(1048));
__export(__webpack_require__(310));
__export(__webpack_require__(1049));
__export(__webpack_require__(1050));
__export(__webpack_require__(1051));
__export(__webpack_require__(1052));
__export(__webpack_require__(349));
__export(__webpack_require__(478));
__export(__webpack_require__(1053));
__export(__webpack_require__(1054));
__export(__webpack_require__(1055));
__export(__webpack_require__(1056));
__export(__webpack_require__(1057));
__export(__webpack_require__(1058));
__export(__webpack_require__(1059));
__export(__webpack_require__(1060));
__export(__webpack_require__(1061));
__export(__webpack_require__(1062));
__export(__webpack_require__(1063));
__export(__webpack_require__(1064));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\index.ts"); } } })();

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Allows other parties to register 'plugins' that provide the view and edit experience for
// custom deployment actions and conventions.
//
//   var module = angular.module('myPlugin', [], function(pluginRegistry) {
//      pluginRegistry.registerDeploymentAction("Octopus.TentaclePackage", {
//        title: "Deploy a NuGet package",               // Display text for users adding the step
//        summary: "Deploys a NuGet package...",         // Help text to show
//        summaryTemplateUrl: "area/foo/bar.html",       // Template for a short summary on the process overview page
//        summaryLink: function (scope, element) {       // Angular directive-style link function
//          var action = scope.action;                   // Get the action we are rendering
//          var step = scope.step;                       // Get the step we are rendering
//          var jQueryElement = element;                 // The HTML element for the bar.html we just inserted
//        },
//        editTemplate: "area/bar/baz.html"              // Template for editing
//      });
//
//      pluginRegistry.registerFeature("Octopus.Features.CustomPackageDirectory", {
//        isEnabled: function(action, step) {  },
//        enable: function(action, step) {  },
//        disable: function(action, step) {  },
//        editTemplateUrl: "area/foo/bar.html",
//        editLink: function(scope, element) { }
//      });
//   });
Object.defineProperty(exports, "__esModule", { value: true });
var PluginRegistry = (function () {
    function PluginRegistry() {
        this.registeredActions = {};
        this.registeredFeatures = {};
    }
    PluginRegistry.prototype.registerDeploymentAction = function (registration) {
        this.registeredActions[registration.actionType] = registration;
    };
    PluginRegistry.prototype.registerFeature = function (registration) {
        this.registeredFeatures[registration.featureName] = registration;
    };
    PluginRegistry.prototype.resolve = function (container, key) {
        var result = container[key];
        //callback(result, key);
        return result;
    };
    PluginRegistry.prototype.resolveAll = function (container) {
        var _this = this;
        return Object.keys(container).map(function (key) {
            return _this.resolve(container, key);
        }).sort(function (item) { return item.priority; });
    };
    PluginRegistry.prototype.getDeploymentAction = function (actionType) {
        var registration = this.resolve(this.registeredActions, actionType);
        if (!registration) {
            throw new Error("There is no plugin registered for " + actionType + " action type.");
        }
        return registration;
    };
    PluginRegistry.prototype.getAllActions = function () {
        return this.resolveAll(this.registeredActions);
    };
    PluginRegistry.prototype.getFeature = function (featureName) {
        var feature = this.resolve(this.registeredFeatures, featureName);
        if (!feature) {
            throw new Error("There is no plugin registered for " + featureName + " feature type.");
        }
        return feature;
    };
    PluginRegistry.prototype.getAllFeatures = function () {
        return this.resolveAll(this.registeredFeatures);
    };
    PluginRegistry.prototype.hasFeaturesForAction = function (actionType) {
        var actionPlugin = this.getDeploymentAction(actionType);
        var featuresForAction = this.getAllFeatures()
            .filter(function (f) { return actionPlugin.features && actionPlugin.features.optional && actionPlugin.features.optional.includes(f.featureName); });
        return featuresForAction.length > 0;
    };
    return PluginRegistry;
}());
var pluginRegistry = new PluginRegistry();
exports.default = pluginRegistry;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\pluginRegistry.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\pluginRegistry.ts"); } } })();

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var formStyles = __webpack_require__(1280);
var Note = function (props) {
    var customStyle = props.checkboxNote ? __assign({}, props.style, { marginLeft: "40px" }) : props.style;
    return React.createElement("div", { className: formStyles.note, style: customStyle }, props.children);
};
exports.default = Note;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Note\\Note.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Note\\Note.tsx"); } } })();

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookup_1 = __webpack_require__(288);
var Text_1 = __webpack_require__(50);
var TextWithInputRef = function (props) { return React.createElement(Text_1.default, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupText = VariableLookup_1.withVariableLookup()(TextWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookupText.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookupText.tsx"); } } })();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var projectRouteLinks_1 = __webpack_require__(1293);
var tenantRouteLinks_1 = __webpack_require__(809);
var libraryRouteLinks_1 = __webpack_require__(1294);
var infrastructureRouteLinks_1 = __webpack_require__(1295);
var taskRouteLinks_1 = __webpack_require__(1296);
var configurationRouteLinks_1 = __webpack_require__(1580);
var projectGroupRouteLinks_1 = __webpack_require__(1581);
var deploymentRouteLinks_1 = __webpack_require__(1582);
var userProfileRouteLinks_1 = __webpack_require__(1583);
var dashboardRouteLinks_1 = __webpack_require__(1584);
exports.parameterizedRouteLinks = function (root) { return (__assign({ root: root ? root : "/", dashboard: dashboardRouteLinks_1.default(root) }, projectRouteLinks_1.default(root), tenantRouteLinks_1.default(root), taskRouteLinks_1.default(root), projectGroupRouteLinks_1.default(root), deploymentRouteLinks_1.default(root), { currentUser: userProfileRouteLinks_1.default(root), library: libraryRouteLinks_1.default(root), infrastructure: infrastructureRouteLinks_1.default(root), configuration: configurationRouteLinks_1.default(root), styleGuide: root + "/style-guide", codeGuide: root + "/code-guide" })); };
exports.default = exports.parameterizedRouteLinks("");


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\routeLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\routeLinks.ts"); } } })();

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chip_1 = __webpack_require__(314);
var Icon_1 = __webpack_require__(781);
var React = __webpack_require__(0);
var Avatar_1 = __webpack_require__(384);
var account_circle_1 = __webpack_require__(1690);
var group_1 = __webpack_require__(832);
var call_split_1 = __webpack_require__(1691);
var local_offer_1 = __webpack_require__(1692);
var colors_1 = __webpack_require__(31);
var moment = __webpack_require__(119);
var colors_2 = __webpack_require__(31);
var LookupResourceChip_1 = __webpack_require__(493);
var InternalLink_1 = __webpack_require__(43);
var styles = __webpack_require__(1693);
var iconStyles = {
    margin: 5,
    fill: colors_2.primaryText,
    width: 14,
    height: 14
};
exports.avatarStyles = {
    width: 24,
    height: 24,
};
var chipWithAvatar = function (text, SvgIcon, props, customAvatar, description, labelColor, customIconStyles, fullWidth) {
    if (fullWidth === void 0) { fullWidth = false; }
    var theChip = React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.secondaryBackground, fullWidth: fullWidth, labelColor: labelColor || colors_2.primaryText, description: description || text, avatar: React.createElement(Avatar_1.default, { style: customAvatar ? customAvatar : exports.avatarStyles, size: exports.avatarStyles.width, icon: React.createElement(SvgIcon, { style: customIconStyles || iconStyles }) }) }, props), text);
    if (props.to) {
        return React.createElement(InternalLink_1.default, { to: props.to, className: styles.clickableChip }, theChip);
    }
    return theChip;
};
var ChipIcon;
(function (ChipIcon) {
    ChipIcon[ChipIcon["Project"] = 0] = "Project";
    ChipIcon[ChipIcon["Machine"] = 1] = "Machine";
    ChipIcon[ChipIcon["ExcludedMachine"] = 2] = "ExcludedMachine";
    ChipIcon[ChipIcon["Environment"] = 3] = "Environment";
    ChipIcon[ChipIcon["ExcludedEnvironment"] = 4] = "ExcludedEnvironment";
    ChipIcon[ChipIcon["Role"] = 5] = "Role";
    ChipIcon[ChipIcon["Tenant"] = 6] = "Tenant";
    ChipIcon[ChipIcon["Channel"] = 7] = "Channel";
    ChipIcon[ChipIcon["Team"] = 8] = "Team";
    ChipIcon[ChipIcon["Step"] = 9] = "Step";
    ChipIcon[ChipIcon["StepAction"] = 10] = "StepAction";
    ChipIcon[ChipIcon["ProjectGroup"] = 11] = "ProjectGroup";
    ChipIcon[ChipIcon["CommunicationStyle"] = 12] = "CommunicationStyle";
    ChipIcon[ChipIcon["EventCategory"] = 13] = "EventCategory";
    ChipIcon[ChipIcon["EventGroup"] = 14] = "EventGroup";
    ChipIcon[ChipIcon["MachineModelHealthStatus"] = 15] = "MachineModelHealthStatus";
    ChipIcon[ChipIcon["DocumentType"] = 16] = "DocumentType";
    ChipIcon[ChipIcon["LibraryVariableSet"] = 17] = "LibraryVariableSet";
})(ChipIcon = exports.ChipIcon || (exports.ChipIcon = {}));
// NOTE:
// This is used to show the user only what they can see, it may be filtered away by permissions
function matchesToChips(set, selected, createChip) {
    return set
        .filter(function (item) { return selected.indexOf(item.Id) !== -1; })
        .map(function (item) { return createChip(item); });
}
exports.matchesToChips = matchesToChips;
function channelChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(ChannelChip, { channelName: x.Name, key: x.Id }); });
}
exports.channelChipList = channelChipList;
function environmentChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EnvironmentChip, { environmentName: x.Name, key: x.Id }); });
}
exports.environmentChipList = environmentChipList;
function workerPoolChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(WorkerPoolChip, { workerPoolName: x.Name, key: x.Id }); });
}
exports.workerPoolChipList = workerPoolChipList;
// NOTE:
// We have some inconsistency in the application where on summaries we filter away what the user cannot see due to permissions
// eg environments, but if they expand the multiselect we show them missing chips
// we should aim to move to this approach in `environmentChipListIncludingMissing` and SHOW them Ids and Names
// it will require a new API (as not to break other things)
// the objective is to  drive people to Spaces for isolation instead of using the permissions system awkwardly
function environmentChipListIncludingMissing(set, selectedIds) {
    var EnvironmentLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return selectedIds.map(function (id) { return React.createElement(EnvironmentLookupChipInternal, { lookupCollection: set, key: id, lookupId: id, type: ChipIcon.Environment, chipRender: function (item) { return React.createElement(EnvironmentChip, { environmentName: item.Name }); } }); });
}
exports.environmentChipListIncludingMissing = environmentChipListIncludingMissing;
function tenantChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(TenantChip, { tenant: x, key: x.Id }); });
}
exports.tenantChipList = tenantChipList;
// Same applies environmentChipListIncludingMissing
// future goal to replace all the variants with this approach
function tenantChipListIncludingMissing(set, selectedIds) {
    var TenantLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return selectedIds.map(function (id) { return React.createElement(TenantLookupChipInternal, { lookupCollection: set, key: id, lookupId: id, type: ChipIcon.Tenant, chipRender: function (item) { return React.createElement(TenantChip, { tenant: item }); } }); });
}
exports.tenantChipListIncludingMissing = tenantChipListIncludingMissing;
function projectGroupChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(ProjectGroupChip, { projectGroup: x, key: x.Id }); });
}
exports.projectGroupChipList = projectGroupChipList;
function projectChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(ProjectChip, { project: x, key: x.Id }); });
}
exports.projectChipList = projectChipList;
function documentChipList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(DocumentTypeChip, { documentType: x, key: x.Id }); });
}
exports.documentChipList = documentChipList;
function eventCategoryList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EventCategoryChip, { eventCategory: x, key: x.Id }); });
}
exports.eventCategoryList = eventCategoryList;
function eventGroupList(set, selectedIds) {
    return matchesToChips(set, selectedIds, function (x) { return React.createElement(EventGroupChip, { eventGroup: x, key: x.Id }); });
}
exports.eventGroupList = eventGroupList;
var MissingChip = function (props) {
    var lookupId = props.lookupId, type = props.type, rest = __rest(props, ["lookupId", "type"]);
    var text = "Missing Resource";
    // There are cases where this isn't right, but will just have 1 message to simplify
    // e.g. Variable Snapshots will show this for deleted environments, it's not an issue in that case, but good to show this.
    var description = "The " + ChipIcon[type] + " document '" + lookupId + "' referenced by this record is no longer available or "
        + "you do not have permissions to see this resource. Please check with you Octopus Administrator regarding your "
        + "permissions. If you believe the resource is missing (and this is not permissions-related), please let Octopus "
        + "support know so that we can prevent this from happening in the future.";
    var customIconStyles = __assign({}, iconStyles, { fill: colors_1.white, backgroundColor: colors_1.danger });
    var chip = function (svg) { return chipWithAvatar(text, svg, __assign({}, rest, { backgroundColor: colors_1.dangerHighlight }), __assign({}, exports.avatarStyles, { backgroundColor: colors_1.danger }), description, colors_1.danger, customIconStyles); };
    switch (type) {
        case ChipIcon.Project:
            return chip(Icon_1.ProjectIcon);
        case ChipIcon.Machine:
            return chip(Icon_1.MachineIcon);
        case ChipIcon.ExcludedMachine:
            return chip(Icon_1.ExcludedMachineIcon);
        case ChipIcon.Environment:
            return chip(Icon_1.EnvironmentIcon);
        case ChipIcon.ExcludedEnvironment:
            return chip(Icon_1.ExcludedEnvironmentIcon);
        case ChipIcon.Role:
            return chip(local_offer_1.default);
        case ChipIcon.Tenant:
            return chip(account_circle_1.default);
        case ChipIcon.Channel:
            return chip(call_split_1.default);
        case ChipIcon.Team:
            return chip(group_1.default);
        case ChipIcon.Step:
        case ChipIcon.StepAction:
        case ChipIcon.ProjectGroup:
        case ChipIcon.CommunicationStyle:
        case ChipIcon.EventCategory:
        case ChipIcon.EventGroup:
        case ChipIcon.MachineModelHealthStatus:
        case ChipIcon.DocumentType:
            return React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.dangerHighlight, labelColor: colors_1.danger, description: description }, rest), text);
        default:
            return React.createElement(Chip_1.default, __assign({ backgroundColor: colors_1.dangerHighlight, labelColor: colors_1.danger, description: description }, rest), text);
    }
};
exports.MissingChip = MissingChip;
var ProjectChip = function (props) {
    var project = props.project, rest = __rest(props, ["project"]);
    return chipWithAvatar(project.Name, Icon_1.ProjectIcon, __assign({ description: "Project: " + project.Name }, rest));
};
exports.ProjectChip = ProjectChip;
var ProjectGroupChip = function (props) {
    var projectGroup = props.projectGroup, rest = __rest(props, ["projectGroup"]);
    var description = "Project group: " + projectGroup.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), projectGroup.Name);
};
exports.ProjectGroupChip = ProjectGroupChip;
var MachineModelHealthStatusChip = function (props) {
    var healthStatus = props.healthStatus, rest = __rest(props, ["healthStatus"]);
    var description = "Machine health: " + healthStatus.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), healthStatus.Name);
};
exports.MachineModelHealthStatusChip = MachineModelHealthStatusChip;
var EndpointCommunicationStyleChip = function (props) {
    var commStyle = props.commStyle, rest = __rest(props, ["commStyle"]);
    var description = "Communications style: " + commStyle.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), commStyle.Name);
};
exports.EndpointCommunicationStyleChip = EndpointCommunicationStyleChip;
var EnvironmentChip = function (props) {
    var environmentName = props.environmentName, isExcluded = props.isExcluded, rest = __rest(props, ["environmentName", "isExcluded"]);
    return chipWithAvatar(environmentName, isExcluded ? Icon_1.ExcludedEnvironmentIcon : Icon_1.EnvironmentIcon, __assign({ description: "Environment: " + environmentName }, rest, { markAsRemoved: isExcluded }));
};
exports.EnvironmentChip = EnvironmentChip;
var WorkerPoolChip = function (props) {
    var workerPoolName = props.workerPoolName, isExcluded = props.isExcluded, rest = __rest(props, ["workerPoolName", "isExcluded"]);
    return chipWithAvatar(workerPoolName, isExcluded ? Icon_1.ExcludedEnvironmentIcon : Icon_1.WorkerPoolIcon, __assign({ description: "Worker pool: " + workerPoolName }, rest, { markAsRemoved: isExcluded }));
};
exports.WorkerPoolChip = WorkerPoolChip;
var MachineChip = function (props) {
    var machineName = props.machineName, isExcluded = props.isExcluded, isDisable = props.isDisable, rest = __rest(props, ["machineName", "isExcluded", "isDisable"]);
    return chipWithAvatar(machineName, (isExcluded || isDisable) ? Icon_1.ExcludedMachineIcon : Icon_1.MachineIcon, __assign({ description: "Machine: " + machineName }, rest, { markAsRemoved: isExcluded, backgroundColor: isDisable ? colors_1.disable : colors_1.secondaryBackground, labelColor: isDisable ? colors_1.danger : colors_2.primaryText }), isDisable ? __assign({}, exports.avatarStyles, { backgroundColor: colors_1.danger }) : exports.avatarStyles);
};
exports.MachineChip = MachineChip;
var TenantChip = function (props) {
    var tenant = props.tenant, rest = __rest(props, ["tenant"]);
    return chipWithAvatar(tenant.Name, account_circle_1.default, __assign({ description: "Tenant: " + tenant.Name }, rest));
};
exports.TenantChip = TenantChip;
var TeamChip = function (props) {
    var team = props.team, rest = __rest(props, ["team"]);
    return chipWithAvatar(team.Name, group_1.default, __assign({ description: "Team: " + team.Name }, rest));
};
exports.TeamChip = TeamChip;
var ChannelChip = function (props) {
    var channelName = props.channelName, rest = __rest(props, ["channelName"]);
    return chipWithAvatar(channelName, call_split_1.default, __assign({ description: "Channel: " + channelName }, rest));
};
exports.ChannelChip = ChannelChip;
var RoleChip = function (props) {
    var role = props.role, rest = __rest(props, ["role"]);
    return chipWithAvatar(role, local_offer_1.default, __assign({ description: "Role: " + role }, rest));
};
exports.RoleChip = RoleChip;
var CertificateExpiryChip = function (props) {
    var certificate = props.certificate, rest = __rest(props, ["certificate"]);
    var now = moment();
    var certificateExpiry = moment(certificate.NotAfter);
    var prefix = certificateExpiry.isAfter(now)
        ? "Expires "
        : "Expired ";
    var expiry = prefix + certificateExpiry.fromNow();
    var color = colors_1.success;
    if (certificateExpiry.isBefore(now)) {
        color = colors_1.danger;
    }
    else if (certificateExpiry.isBefore(now.add(20, "days"))) {
        color = colors_1.alert;
    }
    var description = "Certificate expiry: " + expiry;
    return React.createElement(Chip_1.default, __assign({ description: description, backgroundColor: "rgba(0,0,0,0)", bordercolor: color, labelColor: color }, rest), expiry);
};
exports.CertificateExpiryChip = CertificateExpiryChip;
var StepChip = function (props) {
    var stepName = props.stepName, suffix = props.suffix, rest = __rest(props, ["stepName", "suffix"]);
    var description = "Step: " + stepName;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest),
        stepName,
        suffix);
};
exports.StepChip = StepChip;
var UserRoleChip = function (props) {
    var userRole = props.userRole, rest = __rest(props, ["userRole"]);
    var description = "User role: " + userRole.Name;
    return React.createElement(Chip_1.default, __assign({}, rest), userRole.Name);
};
exports.UserRoleChip = UserRoleChip;
var ExternalSecurityGroupChip = function (props) {
    var group = props.group, rest = __rest(props, ["group"]);
    var text = group.DisplayIdAndName ? group.DisplayName + " (" + group.Id + ")" : group.DisplayName;
    return React.createElement(Chip_1.default, __assign({}, rest), text);
};
exports.ExternalSecurityGroupChip = ExternalSecurityGroupChip;
var ExternalSecurityGroupNameChip = function (props) {
    var groupName = props.groupName, rest = __rest(props, ["groupName"]);
    return React.createElement(Chip_1.default, __assign({ description: "Indirectly assigned via " + groupName }, rest), groupName);
};
exports.ExternalSecurityGroupNameChip = ExternalSecurityGroupNameChip;
var FilterTextChip = function (props) {
    var filterText = props.filterText, rest = __rest(props, ["filterText"]);
    return React.createElement(Chip_1.default, __assign({}, rest), filterText);
};
exports.FilterTextChip = FilterTextChip;
var EventCategoryChip = function (props) {
    var eventCategory = props.eventCategory, rest = __rest(props, ["eventCategory"]);
    var description = "Event category: " + eventCategory.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventCategory.Name);
};
exports.EventCategoryChip = EventCategoryChip;
var EventCategoryPreviewChip = function (props) {
    var eventCategory = props.eventCategory, rest = __rest(props, ["eventCategory"]);
    var description = "Event category: " + eventCategory.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventCategory.Name);
};
exports.EventCategoryPreviewChip = EventCategoryPreviewChip;
var DocumentTypeChip = function (props) {
    var documentType = props.documentType, rest = __rest(props, ["documentType"]);
    var description = "Document type: " + documentType.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), documentType.Name);
};
exports.DocumentTypeChip = DocumentTypeChip;
var EventGroupChip = function (props) {
    var eventGroup = props.eventGroup, rest = __rest(props, ["eventGroup"]);
    var description = "Event group: " + eventGroup.Name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), eventGroup.Name);
};
exports.EventGroupChip = EventGroupChip;
var DisabledChip = function (props) {
    return React.createElement(Chip_1.default, __assign({}, props, { bordercolor: colors_1.secondaryText, labelColor: colors_1.secondaryText, backgroundColor: "rgba(0,0,0,0)" }), "Disabled");
};
exports.DisabledChip = DisabledChip;
var DefaultOptionChip = function (props) {
    return React.createElement(Chip_1.default, __assign({}, props), "Default");
};
exports.DefaultOptionChip = DefaultOptionChip;
var LookupTenantChip = function (props) {
    var TenantLookupChipInternal = LookupResourceChip_1.LookupResourceChipComponent();
    return React.createElement(TenantLookupChipInternal, { lookupCollection: props.lookupTenants, key: props.id, lookupId: props.id, type: ChipIcon.Tenant, chipRender: function (item) { return React.createElement(TenantChip, { tenant: item, to: props.to }); } });
};
exports.LookupTenantChip = LookupTenantChip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\index.tsx"); } } })();

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = __webpack_require__(323);
var PromiseConfirmationDialog_1 = __webpack_require__(1949);
var ActionTemplateEditor_1 = __webpack_require__(1950);
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(17);
var pluginRegistry_1 = __webpack_require__(18);
var lodash_1 = __webpack_require__(11);
var clientInstance_1 = __webpack_require__(10);
var FormBaseComponent_1 = __webpack_require__(431);
var FormPaperLayout_1 = __webpack_require__(195);
var Text_1 = __webpack_require__(50);
var form_1 = __webpack_require__(16);
var ActionEditor_1 = __webpack_require__(851);
var lodash_2 = __webpack_require__(11);
var FeatureEditor_1 = __webpack_require__(852);
var form_2 = __webpack_require__(16);
var Callout_1 = __webpack_require__(58);
var MultiSelect_1 = __webpack_require__(75);
var FeatureToggle_1 = __webpack_require__(305);
var FeatureToggle_2 = __webpack_require__(249);
var Checkbox_1 = __webpack_require__(121);
var Chips_1 = __webpack_require__(24);
var ParseHelper_1 = __webpack_require__(66);
var permission_1 = __webpack_require__(51);
var StartTriggerExpander_1 = __webpack_require__(739);
var RunTriggerExpander_1 = __webpack_require__(740);
var PackageRequirementExpander_1 = __webpack_require__(1976);
var OpenFeatureDialog_1 = __webpack_require__(853);
var projectsArea_1 = __webpack_require__(243);
var react_redux_1 = __webpack_require__(64);
var DeploymentProcessRoute_1 = __webpack_require__(328);
var routeLinks_1 = __webpack_require__(22);
var Environments_1 = __webpack_require__(1981);
var ExecutionPlan_1 = __webpack_require__(1982);
var TenantsExpander_1 = __webpack_require__(1988);
var getActionLogoUrl_1 = __webpack_require__(498);
var WarningFormSection_1 = __webpack_require__(134);
var InternalRedirect_1 = __webpack_require__(45);
var StepName_1 = __webpack_require__(742);
var TransitionAnimation_1 = __webpack_require__(82);
var EnvironmentOption;
(function (EnvironmentOption) {
    EnvironmentOption["All"] = "all";
    EnvironmentOption["Include"] = "include";
    EnvironmentOption["Exclude"] = "exclude";
})(EnvironmentOption = exports.EnvironmentOption || (exports.EnvironmentOption = {}));
var RunOn;
(function (RunOn) {
    RunOn["OctopusServer"] = "OctopusServer";
    RunOn["WorkerPool"] = "WorkerPool";
    RunOn["WorkerPoolForRoles"] = "WorkerPoolForRoles";
    RunOn["OctopusServerForRoles"] = "OctopusServerForRoles";
    RunOn["DeploymentTarget"] = "DeploymentTarget";
})(RunOn = exports.RunOn || (exports.RunOn = {}));
var TargetRoles;
(function (TargetRoles) {
    TargetRoles[TargetRoles["Optional"] = 0] = "Optional";
    TargetRoles[TargetRoles["None"] = 1] = "None";
    TargetRoles[TargetRoles["Required"] = 2] = "Required";
})(TargetRoles = exports.TargetRoles || (exports.TargetRoles = {}));
var ActionDetailsInternal = (function (_super) {
    __extends(ActionDetailsInternal, _super);
    function ActionDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.calculateEnvironmentConditions = function () {
            var action = _this.props.action;
            var knownEnvironments = _this.props.environments.map(function (e) { return e.Id; });
            var unavailableEnvironments = lodash_1.difference(action.Environments || [], knownEnvironments);
            var unavailableExcludedEnvironments = lodash_1.difference(action.ExcludedEnvironments || [], knownEnvironments);
            var inclusiveEnvironments = lodash_1.intersection(action.Environments || [], knownEnvironments);
            var exclusiveEnvironments = lodash_1.intersection(action.ExcludedEnvironments || [], knownEnvironments);
            var hasHiddenEnvironments = unavailableExcludedEnvironments.length + unavailableExcludedEnvironments.length > 0;
            return {
                unavailable: unavailableEnvironments,
                unavailableExclusive: unavailableExcludedEnvironments,
                inclusive: inclusiveEnvironments,
                exclusive: exclusiveEnvironments,
                hasHiddenEnvironments: hasHiddenEnvironments
            };
        };
        _this.availableRunConditions = function () {
            return (_this.props.isFirstStep) ?
                [resources_1.RunCondition.Success, resources_1.RunCondition.Always, resources_1.RunCondition.Variable] :
                [resources_1.RunCondition.Success, resources_1.RunCondition.Failure, resources_1.RunCondition.Always, resources_1.RunCondition.Variable];
        };
        _this.isConditionEditable = function () {
            var action = _this.props.action;
            if (!action) {
                return true;
            }
            var step = _this.props.step;
            return (step.Actions.length === 1 && step.Actions[0] === action) || step.Actions.length === 0;
        };
        _this.doBusyForChildren = function (action) {
            // don't clear errors on child tasks since they should just
            // be loading and we don't want to clear a Save error
            // just because we load some lookup data
            return _this.doBusyTask(action, false);
        };
        _this.setActionProperties = function (properties, initialise) {
            _this.setState(function (state) {
                return (state && state.model && state.model.action) ? {
                    model: __assign({}, state.model, { action: __assign({}, state.model.action, { Properties: __assign({}, state.model.action.Properties, properties) }) })
                } : {};
            }, function () {
                if (initialise) {
                    _this.initialiseModel();
                }
            });
        };
        _this.setActionPackages = function (packages, initialise) {
            _this.setActionState({ Packages: packages }, function () {
                if (initialise) {
                    _this.initialiseModel();
                }
            });
        };
        _this.initialiseModel = function () {
            _this.setState(function (prev) { return ({
                cleanModel: lodash_2.cloneDeep(prev.model)
            }); });
        };
        _this.setStepProperties = function (properties) {
            _this.setState(function (state) {
                return (state && state.model && state.model.step) ? {
                    model: __assign({}, state.model, { step: __assign({}, state.model.step, { Properties: __assign({}, state.model.step.Properties, properties) }) })
                } : {};
            });
        };
        _this.actionClass = function (action) {
            return action.ActionType.replace(".", "").toLowerCase();
        };
        _this.runsOnServer = function (action, executionLocation) {
            return action && executionLocation &&
                (executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer ||
                    (executionLocation === resources_1.ActionExecutionLocation.TargetOrServer && action.Properties["Octopus.Action.RunOnServer"] === "true"));
        };
        _this.findAction = function (deploymentProcess, id) {
            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
                var step = deploymentProcess.Steps[i];
                for (var j = 0; j < step.Actions.length; j++) {
                    var action = step.Actions[j];
                    if (action.Id === id) {
                        return { action: action, step: step, actionIndex: j, stepIndex: i };
                    }
                }
            }
            return null;
        };
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state && this.state.model)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.save(this.state.model)];
                                    case 1:
                                        result = _a.sent();
                                        this.reloadThePage(result);
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.applyChange = function (deploymentProcess) { return __awaiter(_this, void 0, void 0, function () {
            var process;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(deploymentProcess)];
                    case 1:
                        process = _a.sent();
                        this.props.onProjectStepsUpdated(process.Steps ? process.Steps.length : 0);
                        return [2 /*return*/, process];
                }
            });
        }); };
        _this.state = {
            showAdvancedSettings: true,
            openTennantPreview: false,
            pageTitle: "Step",
            canRunBeforeAcquisition: props.canRunBeforeAcquisition,
        };
        return _this;
    }
    Object.defineProperty(ActionDetailsInternal.prototype, "isNew", {
        get: function () {
            return !!(this.state && this.state.model && this.state.model.action && !this.state.model.action.Id);
        },
        enumerable: true,
        configurable: true
    });
    ActionDetailsInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var action, environmentOption, model;
            return __generator(this, function (_a) {
                action = this.props.action;
                environmentOption = (action.Environments || []).length > 0
                    ? EnvironmentOption.Include
                    : ((action.ExcludedEnvironments || []).length > 0)
                        ? EnvironmentOption.Exclude
                        : EnvironmentOption.All;
                model = {
                    step: this.props.step,
                    runOn: this.whereToRun(action),
                    action: action,
                    environmentOption: environmentOption,
                    condition: this.calculateEnvironmentConditions()
                };
                this.setState({
                    model: model,
                    cleanModel: lodash_2.cloneDeep(model)
                });
                return [2 /*return*/];
            });
        });
    };
    ActionDetailsInternal.prototype.render = function () {
        var _this = this;
        var action = this.state.model && this.state.model.action;
        var step = this.state.model && this.state.model.step;
        var addFeaturesElement = (this.props.hasFeatures && !this.props.actionTemplate && action)
            ? React.createElement(OpenFeatureDialog_1.default, { actionType: action.ActionType, properties: action.Properties, saveDone: function (x) {
                    return _this.setActionProperties((_a = {}, _a["Octopus.Action.EnabledFeatures"] = x, _a));
                    var _a;
                } })
            : null;
        var actionEditorAdditionalActions = {
            packageAcquisition: {
                canRunBeforeAcquisition: this.state.canRunBeforeAcquisition,
                stepPackageRequirement: this.props.step.PackageRequirement,
                onCanRunBeforeAcquisitionChanged: function (x) {
                    _this.setState({ canRunBeforeAcquisition: x });
                },
                onStepPackageRequirementChanged: function (x) {
                    _this.setStepState({ PackageRequirement: x });
                }
            },
            stepTargetRoles: this.props.step.Properties["Octopus.Action.TargetRoles"],
            actionType: this.props.plugin.actionType,
            workerPoolId: action && action.WorkerPoolId
        };
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo });
        }
        var breadcrumbTitle = "Process";
        var link = routeLinks_1.default.project(this.props.project.Slug).process;
        var breadcrumbPath = link.root;
        var isNewChildStep = this.props.match.params.stepId && this.isNew;
        if (!this.props.match.params.stepId) {
            // Redirect back to step template screen instead.
            breadcrumbTitle = "Step Templates";
            breadcrumbPath = link.stepTemplates;
        }
        else if (isNewChildStep) {
            // Redirect back to parent's step template screen instead.
            breadcrumbTitle = "Step Templates";
            breadcrumbPath = link.childStepTemplates(this.props.match.params.stepId).root;
        }
        var hasManualInterventionResponsibleTeams = action && resources_1.HasManualInterventionResponsibleTeams(action);
        return React.createElement(FormPaperLayout_1.default, { title: React.createElement(StepName_1.default, { name: action && action.Name, number: this.props.stepNumber }), titleLogo: action && React.createElement(Logo_1.default, { url: getActionLogoUrl_1.default(action) }), breadcrumbTitle: breadcrumbTitle, breadcrumbPath: breadcrumbPath, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: {
                permission: permission_1.default.ProcessEdit,
                project: this.props.project.Id,
            }, onSaveClick: this.handleSaveClick, secondaryAction: addFeaturesElement, saveText: "Step details updated", isNewRecord: this.isNew, disableHeaderAnimations: true }, this.state.model && action && React.createElement(TransitionAnimation_1.default, null,
            React.createElement("div", null,
                this.state.confirmReadPromise &&
                    React.createElement(PromiseConfirmationDialog_1.default, { title: "Conflict", continueButtonLabel: "Restore the step", deferred: this.state.confirmReadPromise }, "Someone else has deleted this step from the deployment process. Would you like to add the step back?"),
                this.state.cleanModel && this.state.cleanModel.action.IsDisabled && React.createElement(WarningFormSection_1.default, null,
                    React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning }, "This step is currently disabled.")),
                React.createElement(form_2.ExpandableFormSection, { isExpandedByDefault: !action.Name, errorKey: "Name", title: "Step Name", focusOnExpandAll: true, summary: action.Name
                        ? form_2.Summary.summary(action.Name)
                        : form_2.Summary.placeholder("Please enter a name for your step"), help: "A short, memorable, unique name for this step." },
                    React.createElement(Text_1.default, { value: action.Name, onChange: function (x) { return _this.setActionState({ Name: x }); }, label: "Step name", error: this.getFieldError("Name"), validate: form_1.required("Please enter a step name"), autoFocus: true })),
                React.createElement(ExecutionPlan_1.default, { projectId: this.props.project.Id, expandedByDefault: !action.Name, executionLocation: this.props.plugin.executionLocation, runOn: this.state.model.runOn, onRunOnChanged: function (runOn) {
                        _this.setModelState({ runOn: runOn });
                        _this.setActionProperties((_a = {}, _a["Octopus.Action.RunOnServer"] = runOn === RunOn.DeploymentTarget ? "false" : "true", _a));
                        var _a;
                    }, targetRoleOption: this.props.plugin.targetRoleOption(action), targetRoles: this.state.model.step.Properties["Octopus.Action.TargetRoles"], disableAddTargetRoles: this.props.plugin.disableAddTargetRoles, onTargetRolesChanged: function (roles) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.TargetRoles"] = ParseHelper_1.default.encodeCSV(roles), _a));
                        var _a;
                    }, targetRolesError: this.getFieldError("Octopus.Action.TargetRoles"), isChildStep: this.props.isChildStep, maxParallelism: this.state.model.step.Properties["Octopus.Action.MaxParallelism"], onMaxParallelismChanged: function (max) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = max, _a));
                        var _a;
                    }, availableRoles: this.props.availableRoles, availableWorkerPools: this.props.availableWorkerPools, canRunOnWorker: this.canRunOnWorker(), isBuiltInWorkerEnabled: this.props.isBuiltInWorkerEnabled, targetWorkerPool: this.state.model.action.WorkerPoolId, onTargetWorkerPoolChanged: function (targetWorkerPool) { return _this.setActionState({ WorkerPoolId: targetWorkerPool }); }, runsOnServer: this.runsOnServer(this.state.model.action, this.props.plugin.executionLocation) }),
                !this.props.actionTemplate && React.createElement("div", null,
                    React.createElement(ActionEditor_1.default, { plugin: this.props.plugin, projectId: this.props.project.Id, isNew: this.isNew, doBusyTask: this.doBusyForChildren, busy: this.state.busy, properties: this.state.model.action.Properties, packages: this.state.model.action.Packages, runOn: this.state.model.runOn, setProperties: function (p, i) { return _this.setActionProperties(p, i); }, setPackages: function (p, i) { return _this.setActionPackages(p, i); }, additionalActions: actionEditorAdditionalActions, getFieldError: this.getFieldError, errors: this.state.errors, expandedByDefault: !action.Name }),
                    this.props.hasFeatures &&
                        React.createElement("div", null,
                            action.Properties["Octopus.Action.EnabledFeatures"] &&
                                React.createElement(form_2.FormSectionHeading, { title: "Features" }),
                            React.createElement(FeatureEditor_1.default, { plugin: this.props.plugin, projectId: this.props.project.Id, isNew: this.isNew, doBusyTask: this.doBusyForChildren, busy: this.props.busy, properties: this.state.model.action.Properties, packages: this.state.model.action.Packages, runOn: this.state.model.runOn, setProperties: function (p, i) { return _this.setActionProperties(p, i); }, setPackages: function (p, i) { return _this.setActionPackages(p, i); }, enabledFeatures: action.Properties["Octopus.Action.EnabledFeatures"] || "", getFieldError: this.getFieldError, errors: this.state.errors, expandedByDefault: !action.Name, openFeaturesElement: addFeaturesElement }))),
                this.props.actionTemplate && React.createElement(ActionTemplateEditor_1.default, { actionTemplate: this.props.actionTemplate, projectId: this.props.project.Id, process: this.props.deploymentProcess, actionId: this.props.action.Id, properties: this.state.model.action.Properties, setProperties: function (p) { return _this.setActionProperties(p); }, doBusyTask: this.doBusyForChildren }),
                React.createElement(form_2.FormSectionHeading, { title: "Conditions" }),
                React.createElement(Environments_1.default, { environmentOption: this.state.model.environmentOption, hasHiddenEnvironments: this.state.model.condition.hasHiddenEnvironments, environments: this.props.environments, inclusiveEnvironments: this.state.model.condition.inclusive, exclusiveEnvironments: this.state.model.condition.exclusive, onEnvironmentOptionChanged: function (environmentOption) { return _this.setModelState({ environmentOption: environmentOption }); }, onInclusiveEnvironmentsChanged: function (val) { return _this.setChildState2("model", "condition", { inclusive: val }); }, onExclusiveEnvironmentsChanged: function (val) { return _this.setChildState2("model", "condition", { exclusive: val }); } }),
                (action.Channels.length > 0 || this.props.channels.length > 1) && React.createElement(form_2.ExpandableFormSection, { title: "Channels", help: "Choose which channels this step applies to.", summary: this.channelsSummary(), errorKey: "channels" },
                    React.createElement(form_1.Note, null, "If nothing is selected this step will run for releases in any channel, otherwise it will only run for releases belonging to the selected channels."),
                    React.createElement(MultiSelect_1.ChannelMultiSelect, { items: this.props.channels, onChange: function (val) { return _this.setActionState({ Channels: val }); }, value: this.state.model.action.Channels })),
                React.createElement(FeatureToggle_2.default, { feature: FeatureToggle_1.Feature.MultiTenancy }, ((this.props.project.TenantedDeploymentMode !== resources_1.TenantedDeploymentMode.Untenanted) || action.TenantTags.length > 0)
                    && React.createElement(TenantsExpander_1.default, { doBusyTask: this.doBusyTask, tenantTags: action.TenantTags, tagIndex: this.props.tagIndex, onTenantTagsChange: function (tags) { return _this.setActionState({ TenantTags: tags }); } })),
                this.isConditionEditable() && step && React.createElement(RunTriggerExpander_1.default, { isFirstStep: this.props.isFirstStep, condition: this.state.model.step.Condition, onConditionChange: function (val) { return _this.setStepState({ Condition: val }); }, variableExpression: step.Properties["Octopus.Action.ConditionVariableExpression"], onVariableExpressionChange: function (x) {
                        return _this.setStepProperties((_a = {}, _a["Octopus.Action.ConditionVariableExpression"] = x, _a));
                        var _a;
                    }, projectId: this.props.project.Id }),
                this.isConditionEditable() && !this.props.isFirstStep &&
                    React.createElement(StartTriggerExpander_1.default, { startTrigger: this.state.model.step.StartTrigger, onChange: function (val) { return _this.setStepState({ StartTrigger: val }); } }),
                this.state.canRunBeforeAcquisition && step &&
                    React.createElement(PackageRequirementExpander_1.default, { packageRequirement: this.state.model.step.PackageRequirement, onChange: function (val) { return _this.setStepState({ PackageRequirement: val }); } }),
                React.createElement(form_2.ExpandableFormSection, { title: "Required", summary: this.state.model.action.IsRequired || hasManualInterventionResponsibleTeams
                        ? form_2.Summary.summary(React.createElement("span", null,
                            "This step is ",
                            React.createElement("strong", null, "required"),
                            " and cannot be skipped"))
                        : form_2.Summary.summary(React.createElement("span", null,
                            "This step is ",
                            React.createElement("strong", null, "not required"),
                            " and can be skipped")), help: "Required steps cannot be skipped when deploying a release", errorKey: "required" },
                    hasManualInterventionResponsibleTeams &&
                        React.createElement(form_1.Note, null, "Responsible teams are specified, therefore this step is always required."),
                    React.createElement(Checkbox_1.default, { value: this.state.model.action.IsRequired || hasManualInterventionResponsibleTeams, label: "Prevent this step from being skipped when deploying", disabled: hasManualInterventionResponsibleTeams, onChange: function (val) { return _this.setActionState({ IsRequired: val }); } })))));
    };
    ActionDetailsInternal.prototype.canRunOnWorker = function () {
        return this.props.plugin.canRunOnWorker === false ? this.props.plugin.canRunOnWorker : true;
    };
    ActionDetailsInternal.prototype.whereToRun = function (action) {
        var runsOnServer = this.runsOnServer(action, this.props.plugin.executionLocation);
        if (!runsOnServer) {
            return RunOn.DeploymentTarget;
        }
        if (this.props.availableWorkerPools.length > 0 && this.canRunOnWorker()) {
            return this.showRolesForServer(this.props) ? RunOn.WorkerPoolForRoles : RunOn.WorkerPool;
        }
        else if (this.props.isBuiltInWorkerEnabled) {
            return this.showRolesForServer(this.props) ? RunOn.OctopusServerForRoles : RunOn.OctopusServer;
        }
        else {
            return RunOn.DeploymentTarget;
        }
    };
    ActionDetailsInternal.prototype.setActionState = function (state, callback) {
        this.setChildState2("model", "action", state, callback);
    };
    ActionDetailsInternal.prototype.setStepState = function (state, callback) {
        this.setChildState2("model", "step", state, callback);
    };
    ActionDetailsInternal.prototype.channelsSummary = function () {
        var _this = this;
        return this.state.model && this.state.model.action.Channels.length > 0
            ? form_2.Summary.summary(React.createElement("span", null,
                "This step will only run for releases in ",
                this.state.model.action.Channels.map(function (ch) { return _this.getChipForChannel(ch); })))
            : form_2.Summary.default("This step will run for releases in any channel");
    };
    ActionDetailsInternal.prototype.getChipForChannel = function (id) {
        var channel = this.props.channels.find(function (c) { return c.Id === id; });
        return channel ? React.createElement(Chips_1.ChannelChip, { key: channel.Id, channelName: channel.Name }) : React.createElement(Chips_1.MissingChip, { lookupId: id, type: Chips_1.ChipIcon.Channel });
    };
    ActionDetailsInternal.prototype.getPossibleFeatures = function () {
        if (!this.props.plugin.features) {
            return {};
        }
        return lodash_1.keyBy((this.props.plugin.features.initial || []).concat((this.props.plugin.features.optional || []), (this.props.plugin.features.permanent || [])), function (x) { return x; });
    };
    ActionDetailsInternal.prototype.updateFeatures = function (action) {
        var enabledFeatureNames = (action.Properties["Octopus.Action.EnabledFeatures"] || "")
            .split(",")
            .filter(function (name) {
            return name !== "";
        });
        var possibleFeatures = this.getPossibleFeatures();
        var enabledFeatures = enabledFeatureNames.map(function (f) {
            return pluginRegistry_1.default.getFeature(f);
        });
        var errors = {};
        enabledFeatures.forEach(function (feature) {
            if (feature.validate) {
                feature.validate(action.Properties, errors);
            }
        });
        if (Object.keys(errors).length > 0) {
            var exception = new resources_1.OctopusError(0, "There was a problem with your request.");
            exception.Errors = Object.values(errors);
            exception.Details = errors;
            throw exception;
        }
        var properties = __assign({}, action.Properties);
        pluginRegistry_1.default.getAllFeatures().forEach(function (feature) {
            if (enabledFeatureNames.indexOf(feature.featureName) === -1) {
                if (feature.disable && possibleFeatures.hasOwnProperty(feature.featureName)) {
                    feature.disable(properties);
                }
            }
        });
        enabledFeatures.forEach(function (feature) {
            if (feature.preSave) {
                feature.preSave(properties);
            }
        });
        action.Properties = properties;
    };
    ActionDetailsInternal.prototype.updateEnvironments = function (action) {
        if (!this.state.model) {
            return;
        }
        action.Environments = lodash_1.uniq((this.state.model.condition.inclusive || []).concat(this.state.model.condition.unavailable));
        action.ExcludedEnvironments = lodash_1.uniq((this.state.model.condition.exclusive || []).concat(this.state.model.condition.unavailableExclusive));
        if (this.state.model.environmentOption !== EnvironmentOption.Include) {
            action.Environments.splice(0);
        }
        if (this.state.model.environmentOption !== EnvironmentOption.Exclude) {
            action.ExcludedEnvironments.splice(0);
        }
    };
    ActionDetailsInternal.prototype.reloadThePage = function (saveResult) {
        if (this.isNew) {
            var newActionId = this.findNewActionId(saveResult);
            var redirectTo = newActionId
                ? routeLinks_1.default.project(this.props.match.params.projectSlug).process.step(newActionId)
                : routeLinks_1.default.project(this.props.match.params.projectSlug).process.root;
            this.setState({ redirectTo: redirectTo });
        }
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    ActionDetailsInternal.prototype.findNewActionId = function (saveResult) {
        // tslint:disable-next-line:prefer-for-of
        for (var s = 0; s < saveResult.Steps.length; s++) {
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < saveResult.Steps[s].Actions.length; i++) {
                if (this.state.model && this.state.model.action && saveResult.Steps[s].Actions[i].Name === this.state.model.action.Name) {
                    return saveResult.Steps[s].Actions[i].Id;
                }
            }
        }
        return null;
    };
    ActionDetailsInternal.prototype.save = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var action, step, primaryPackage, actionIndex, deploymentProcess, s, foundAction, deferred, result, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        action = model.action;
                        step = model.step;
                        if (model.runOn === RunOn.OctopusServer || model.runOn === RunOn.WorkerPool) {
                            step.Properties["Octopus.Action.TargetRoles"] = "";
                        }
                        if (model.runOn === RunOn.DeploymentTarget) {
                            action.WorkerPoolId = null;
                        }
                        if (action) {
                            if (!action.Name || action.Name.length === 0) {
                                primaryPackage = resources_1.GetPrimaryPackageReference(action.Packages);
                                if (primaryPackage) {
                                    action.Name = primaryPackage.PackageId;
                                }
                            }
                            this.updateFeatures(action);
                            this.updateEnvironments(action);
                        }
                        actionIndex = step.Actions.findIndex(function (a) { return a.Id === action.Id; });
                        step.Actions[actionIndex] = action;
                        if (step.Actions.length === 1) {
                            // Step name should always match action name if there is only one action
                            step.Name = step.Actions[0].Name;
                        }
                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.project.DeploymentProcessId)];
                    case 1:
                        deploymentProcess = _a.sent();
                        if (this.props.match.params.actionType) {
                            if (this.props.match.params.stepId) {
                                s = lodash_1.find(deploymentProcess.Steps, function (st) { return st.Id === _this.props.match.params.stepId; });
                                if (s) {
                                    s.Actions.push(action);
                                }
                            }
                            else {
                                deploymentProcess.Steps.push(step);
                            }
                            return [2 /*return*/, this.applyChange(deploymentProcess)];
                        }
                        foundAction = this.findAction(deploymentProcess, this.props.match.params.stepId);
                        if (!!foundAction) return [3 /*break*/, 4];
                        deferred = new PromiseConfirmationDialog_1.Deferred();
                        this.setState({ confirmReadPromise: deferred });
                        return [4 /*yield*/, deferred.promise];
                    case 2:
                        result = _a.sent();
                        if (result === false) {
                            // throw an error so the user gets a clear visual indication of what we are doing.
                            throw new resources_1.OctopusError(500, "Someone else has deleted this step from the deployment process. Step not saved.");
                        }
                        index = this.props.deploymentProcess.Steps.indexOf(step);
                        deploymentProcess.Steps.splice(index, 0, step);
                        return [4 /*yield*/, this.applyChange(deploymentProcess)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        foundAction.step.Actions[foundAction.actionIndex] = action;
                        foundAction.step.Name = step.Name;
                        foundAction.step.PackageRequirement = step.PackageRequirement;
                        foundAction.step.Condition = step.Condition;
                        foundAction.step.StartTrigger = step.StartTrigger;
                        Object.keys(step.Properties).forEach(function (key) { return foundAction.step.Properties[key] = step.Properties[key]; });
                        return [4 /*yield*/, this.applyChange(deploymentProcess)];
                    case 5: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ActionDetailsInternal.prototype.showRolesForServer = function (props) {
        var hasRoles = !!props.step.Properties["Octopus.Action.TargetRoles"];
        return hasRoles || props.plugin.targetRoleOption(props.action) === TargetRoles.Required;
    };
    return ActionDetailsInternal;
}(FormBaseComponent_1.default));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var mapStateToProps = function (state) {
    return {
        isBuiltInWorkerEnabled: state.configurationArea.features.isBuiltInWorkerEnabled
    };
};
var ActionDetails = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ActionDetailsInternal);
exports.default = ActionDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ActionDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ActionDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink = function (props) {
    if (props.href == null) {
        return null;
    }
    var parseUrl = function (href) {
        try {
            var ignored = new URL(href);
            return true;
        }
        catch (error) {
            return false;
        }
    };
    var formatUrl = function (href) {
        if (parseUrl(href)) {
            return href;
        }
        return "https://g.octopushq.com/" + href;
    };
    var onClick = function (e) {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };
    return React.createElement("a", { href: formatUrl(props.href), target: props.openInSelf ? "_self" : "_blank", onClick: onClick },
        props.children,
        props.showIcon && React.createElement("em", { style: { marginLeft: "0.250rem" }, className: "fa fa-external-link", "aria-hidden": "true" }));
};
ExternalLink.defaultProps = {
    showIcon: true,
    openInSelf: false
};
exports.default = ExternalLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\ExternalLink\\ExternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\ExternalLink\\ExternalLink.tsx"); } } })();

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
// Repositories provide a helpful abstraction around the Octopus Deploy API
var BasicRepository = (function () {
    function BasicRepository(collectionLinkName, client) {
        this.collectionLinkName = collectionLinkName;
        this.client = client;
    }
    BasicRepository.prototype.create = function (resource, args) {
        return this.client.create(this.client.getRootDocument().Links[this.collectionLinkName], resource, args);
    };
    BasicRepository.prototype.modify = function (resource, args) {
        return this.client.update(resource.Links.Self, resource, args);
    };
    BasicRepository.prototype.del = function (resource) {
        return this.client.del(resource.Links.Self);
    };
    BasicRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], args);
    };
    BasicRepository.prototype.get = function (id, args) {
        var allArgs = this.extend(args || {}, { id: id });
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], allArgs);
    };
    BasicRepository.prototype.all = function (args) {
        if (args !== undefined && args.ids instanceof Array && args.ids.length === 0) {
            return new Promise(function (res) { res([]); });
        }
        // http.sys has a max query string of about 16k chars. Our typical max id length is 50 chars
        // so if we are doing requests by id and have more than 300, split into multiple requests
        var maxIds = 300;
        if (args !== undefined && args.ids instanceof Array && args.ids.length > maxIds) {
            return this.batchRequestsById(args, maxIds);
        }
        var allArgs = this.extend(args || {}, { id: "all" });
        return this.client.get(this.client.getRootDocument().Links[this.collectionLinkName], allArgs);
    };
    BasicRepository.prototype.allById = function (args) {
        return this.all(args).then(function (result) { return result.reduce(function (acc, resource) {
            acc[resource.Id] = resource;
            return acc;
        }, {}); });
    };
    BasicRepository.prototype.save = function (resource) {
        if (isExistingResource(resource)) {
            return this.modify(resource);
        }
        else {
            return this.create(resource);
        }
        function isExistingResource(r) {
            return !!r.Links && !!r.Id;
        }
    };
    BasicRepository.prototype.extend = function (arg1, arg2) {
        return __assign({}, arg1, arg2);
    };
    BasicRepository.prototype.batchRequestsById = function (args, batchSize) {
        var _this = this;
        var idArrays = lodash_1.chunk(args.ids, batchSize);
        var promises = idArrays.map(function (ids) {
            var newArgs = __assign({}, args, { ids: ids, id: "all" });
            return _this.client.get(_this.client.getRootDocument().Links[_this.collectionLinkName], newArgs);
        });
        return Promise.all(promises).then(function (result) { return lodash_1.flatten(result); });
    };
    return BasicRepository;
}());
exports.default = BasicRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\basicRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\basicRepository.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var CardExpandable_1 = __webpack_require__(812);
var styles = __webpack_require__(117);
var cn = __webpack_require__(19);
var FormSectionBase_1 = __webpack_require__(292);
var Expandable_1 = __webpack_require__(668);
var uiTestClasses_1 = __webpack_require__(86);
var Menu_1 = __webpack_require__(774);
var Summary_1 = __webpack_require__(44);
exports.SummaryNode = Summary_1.SummaryNode;
var CardFill;
(function (CardFill) {
    CardFill[CardFill["None"] = 0] = "None";
    CardFill[CardFill["FillRight"] = 1] = "FillRight";
    CardFill[CardFill["FillAll"] = 2] = "FillAll";
})(CardFill = exports.CardFill || (exports.CardFill = {}));
var ExpandableFormSectionInternal = (function (_super) {
    __extends(ExpandableFormSectionInternal, _super);
    function ExpandableFormSectionInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.focusControl = false;
        _this.ignore = false;
        // we can't just use actAsExpander on card Title because it eats the click
        // and we can't add links to the title in help text or our show more info link
        _this.handleExpand = function (e) {
            if (e.target.tagName.toLowerCase() !== "a") {
                e.preventDefault();
                var isSelectingText = window.getSelection().toString().length > 0;
                if (isSelectingText) {
                    // usability: Don't expand/collapse in cases where the user is just trying to select/copy text
                    // from our expander's title, summary or help text.
                    return;
                }
                _this.props.onExpandedChanged(!_this.props.isExpanded);
            }
        };
        _this.alterChild = function (child) {
            var focusOnExpand = _this.props.expandingAll === false || _this.props.focusOnExpandAll;
            if (focusOnExpand && _this.focusControl && _this.isFocusableControl(child)) {
                _this.focusControl = false;
                return React.cloneElement(child, __assign({}, child.props, { autoFocus: true }));
            }
            else {
                return child;
            }
        };
        _this.isFocusableControl = function (child) {
            return child.props && (child.props.onChange || child.props.setProperties) && !child.props.doNotAutoFocus;
        };
        _this.ignore = _this.props.isExpandedByDefault; //don't focus the first time we expand due to being expandedByDefault
        return _this;
    }
    ExpandableFormSectionInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isExpanded === false && nextProps.isExpanded === true) {
            if (this.ignore) {
                this.ignore = false;
            }
            else {
                this.focusControl = true;
            }
        }
    };
    ExpandableFormSectionInternal.prototype.render = function () {
        var Summary = this.props.summary;
        var summary = React.createElement(Summary, { forceMobileBehaviour: this.props.forceMobileBehaviour, overflow: !!this.props.overflowMenuItems });
        var subtitle = this.props.isExpanded ? this.help(this.props.help) : summary;
        var title = this.title(this.props.title, subtitle);
        var bodyclasses = cn((_a = {},
            _a[styles.cardMedia] = true,
            _a[styles.cardMediaForceMobile] = this.props.forceMobileBehaviour,
            _a[styles.cardMediaFillRight] = this.props.fillCardWidth === CardFill.FillRight || this.props.fillCardWidth === CardFill.FillAll,
            _a[styles.cardMediaFillAll] = this.props.fillCardWidth === CardFill.FillAll,
            _a));
        return React.createElement(Card_1.Card, { className: uiTestClasses_1.formSectionClass + " " + styles.formExpander, onExpandChange: this.props.onExpandedChanged, expanded: this.props.isExpanded },
            React.createElement(Card_1.CardTitle, { title: title, onClick: this.handleExpand, showExpandableButton: false }),
            this.body(bodyclasses, true),
            this.moreInformation());
        var _a;
    };
    ExpandableFormSectionInternal.prototype.title = function (title, subtitle) {
        return React.createElement("div", { className: cn(styles.cardTitleContainer, this.props.forceMobileBehaviour && styles.cardTitleContainerForceMobile) },
            React.createElement("span", { className: cn(uiTestClasses_1.formSectionTitleClass, styles.cardTitle, this.props.forceMobileBehaviour && styles.cardTitleForceMobile) }, title),
            subtitle,
            this.props.overflowMenuItems && React.createElement("div", { className: styles.overflowMenuActions },
                React.createElement(Menu_1.OverflowMenu, { menuItems: this.props.overflowMenuItems })),
            React.createElement("div", { className: styles.expandCollapse },
                React.createElement(CardExpandable_1.default, { tabIndex: this.props.isExpanded ? -1 : 0, expanded: this.props.isExpanded })));
    };
    return ExpandableFormSectionInternal;
}(FormSectionBase_1.FormSectionBase));
exports.ExpandableFormSectionInternal = ExpandableFormSectionInternal;
var ExpandableFormSection = Expandable_1.default(ExpandableFormSectionInternal);
exports.default = ExpandableFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\ExpandableFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\ExpandableFormSection.tsx"); } } })();

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.white = "#ffffff";
exports.primaryText = "#333333";
exports.secondaryText = "#9e9e9e";
exports.ternaryText = "#666666";
exports.primary = "#2f93e0";
exports.primaryDarkest = "#0F2535";
exports.primaryDark = "#0A67B1";
exports.primaryLight = "#74c0fb";
exports.secondaryDark = "#053B62";
exports.hover = "rgba(153, 153, 153, 0.08)";
exports.divider = "#cccccc";
exports.disabledBackground = "rgba(153, 153, 153, 0.7)";
exports.secondaryBackground = "#e0e0e0";
exports.info = "#0A67B1";
exports.success = "#48B350";
exports.danger = "#db4437";
exports.alert = "#fb8c00";
exports.disable = "#fbe1e9";
exports.dangerHighlight = "#f8e8e6";
exports.shadow40 = "rgba(0, 0, 0, 0.4)";
exports.shadow60 = "rgba(0, 0, 0, 0.6)";
exports.theme = {}; //empty on purpose


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\colors.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\colors.ts"); } } })();

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButton_1 = __webpack_require__(626);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(412);
var radio_button_checked_1 = __webpack_require__(628);
var RadioButton = (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButton.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            // this digs into the RadioButton implementation to set focus
            var internalSwitch = this.radioButtonImpl.refs.enhancedSwitch;
            internalSwitch.refs.checkbox.focus();
            internalSwitch.tabPressed = true;
            internalSwitch.handleFocus();
        }
    };
    RadioButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, isDefault = _a.isDefault, label = _a.label, image = _a.image, otherProps = __rest(_a, ["isDefault", "label", "image"]);
        var newlabel = isDefault
            ? React.createElement("span", { className: styles.isDefault }, label)
            : label;
        return React.createElement(RadioButton_1.default, __assign({ ref: function (ref) { return _this.radioButtonImpl = ref; }, label: newlabel, labelStyle: this.props.disabled ? { color: colors_1.secondaryText } : {}, checkedIcon: React.createElement(radio_button_checked_1.default, { style: { fill: colors_1.primary } }), image: image }, otherProps));
    };
    return RadioButton;
}(React.Component));
RadioButton.defaultProps = {
    checked: false,
    isDefault: false
};
exports.default = RadioButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButton.tsx"); } } })();

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButtonGroupInternal_1 = __webpack_require__(1718);
var styles = __webpack_require__(412);
var cn = __webpack_require__(19);
var InputLabel_1 = __webpack_require__(1720);
var BoundField_1 = __webpack_require__(100);
var RadioButtonGroup = (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showExternalError: true
        };
        return _this;
    }
    RadioButtonGroup.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    RadioButtonGroup.prototype.handleChange = function (event, value) {
        if (this.props.validate) {
            var result = this.props.validate(value);
            this.setState({ error: result });
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.setState({ showExternalError: false });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, value = _a.value, label = _a.label, validate = _a.validate, children = _a.children, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, horizontal = _a.horizontal, noMargin = _a.noMargin, otherProps = __rest(_a, ["className", "value", "label", "validate", "children", "error", "onChange", "onValidate", "horizontal", "noMargin"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var classes = [styles.radioButtonGroup, className];
        if (horizontal) {
            classes.push(styles.horizontal);
        }
        return (React.createElement("div", { className: cn(styles.container, (_b = {}, _b[styles.topMargin] = !noMargin, _b)) },
            React.createElement(InputLabel_1.default, { label: label }),
            React.createElement(RadioButtonGroupInternal_1.default, __assign({ className: cn(classes), name: name, onChange: function (e, v) { return _this.handleChange(e, v); }, floatingLabelText: label, valueSelected: value }, otherProps), children),
            err && React.createElement("div", { className: styles.errorText }, err)));
        var _b;
    };
    return RadioButtonGroup;
}(React.Component));
var StringRadioButtonGroup = (function (_super) {
    __extends(StringRadioButtonGroup, _super);
    function StringRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StringRadioButtonGroup;
}(RadioButtonGroup));
exports.StringRadioButtonGroup = StringRadioButtonGroup;
var BooleanRadioButtonGroup = (function (_super) {
    __extends(BooleanRadioButtonGroup, _super);
    function BooleanRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BooleanRadioButtonGroup;
}(RadioButtonGroup));
exports.BooleanRadioButtonGroup = BooleanRadioButtonGroup;
exports.BoundStringRadioButtonGroup = BoundField_1.withBoundField(StringRadioButtonGroup);
exports.BoundRadioButtonGroup = BoundField_1.withBoundField(RadioButtonGroup);
exports.default = RadioButtonGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroup.tsx"); } } })();

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TargetList_1 = __webpack_require__(1942);
var index_1 = __webpack_require__(24);
var ParseHelper_1 = __webpack_require__(66);
var RolesList = (function (_super) {
    __extends(RolesList, _super);
    function RolesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RolesList;
}(TargetList_1.default));
var Roles = function (props) {
    var roles = ParseHelper_1.default.parseCSV(props.rolesAsCSV);
    return React.createElement("span", null,
        roles.length === 1 ? "role" : "roles",
        " ",
        React.createElement(RolesList, { targets: roles, renderTarget: (function (role) { return React.createElement(index_1.RoleChip, { key: role, role: role }); }) }));
};
Roles.displayName = "Roles";
exports.default = Roles;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\Roles.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\Roles.tsx"); } } })();

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(60);
var resources_1 = __webpack_require__(17);
var refresh_loop_1 = __webpack_require__(588);
var DataBaseComponent = (function (_super) {
    __extends(DataBaseComponent, _super);
    function DataBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.busies = [];
        _this.doBusyTask = function (action, clearCurrentErrors) {
            if (clearCurrentErrors === void 0) { clearCurrentErrors = true; }
            return _this.doBusyTaskInternal(action, clearCurrentErrors);
        };
        _this.getFieldError = function (fieldName) {
            if (_this.state.errors && _this.state.errors.fieldErrors) {
                var found = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.toLowerCase() === fieldName.toLowerCase(); });
                if (found) {
                    return _this.state.errors.fieldErrors[found];
                }
                var foundPartialMatch = Object.keys(_this.state.errors.fieldErrors).find(function (k) { return k.endsWith("." + fieldName); });
                if (foundPartialMatch) {
                    return _this.state.errors.fieldErrors[foundPartialMatch];
                }
            }
            return "";
        };
        _this.setError = function (message, details, fieldErrors) {
            if (details === void 0) { details = []; }
            if (fieldErrors === void 0) { fieldErrors = {}; }
            _this.setState({ errors: {
                    message: message,
                    details: details,
                    fieldErrors: fieldErrors
                } });
        };
        _this.doBusyTaskInternal = function (action, clearCurrentErrors) { return __awaiter(_this, void 0, void 0, function () {
            var busy, singlePromise, e_1, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        // Sometimes child components will load some lookup data while a parent component
                        // is displaying an error. The child uses the parent's doBusyTask so that the busy
                        // indicator and errors display correctly. But we shouldn't clear existing errors
                        // from that child load.
                        if (clearCurrentErrors) {
                            this.setState({
                                errors: null
                            });
                        }
                        busy = action();
                        this.busies = [busy].concat(this.busies);
                        singlePromise = Promise.all(this.busies).then(function (v) { });
                        this.setState({ busy: singlePromise });
                        return [4 /*yield*/, busy];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof resources_1.OctopusError) {
                            errors = this.mapToOctopusError(e_1);
                            this.setState({ errors: errors });
                            return [2 /*return*/, false];
                        }
                        throw e_1;
                    case 3:
                        this.busies = this.busies.filter(function (b) { return b !== busy; });
                        // we need to return null here when done
                        // because some buttons etc just check for the
                        // existance of a busy promise
                        this.setState({ busy: this.busies.length > 0 ? Promise.all(this.busies).then(function (v) { }) : null });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.provideErrorHandling(_this.doBusyTaskInternal);
        return _this;
    }
    DataBaseComponent.prototype.componentWillUnmount = function () {
        if (this.stopRefreshLoop !== undefined) {
            this.stopRefreshLoop();
        }
    };
    DataBaseComponent.prototype.createRefreshLoop = function (getData, refreshInterval, noBusyIndicator) {
        if (noBusyIndicator === void 0) { noBusyIndicator = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var loop, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.stopRefreshLoop !== undefined) {
                            throw new Error("Can't create more than one loop in a component");
                        }
                        loop = new refresh_loop_1.default(function (isLoopStillRunning) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            var refreshData;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        refreshData = function () { return __awaiter(_this, void 0, void 0, function () {
                                            var data;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, getData()];
                                                    case 1:
                                                        data = _a.sent();
                                                        if (isLoopStillRunning()) {
                                                            this.setState(data);
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); };
                                        if (!noBusyIndicator) return [3 /*break*/, 2];
                                        return [4 /*yield*/, refreshData()];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 4];
                                    case 2: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, refreshData()];
                                                case 1: return [2 /*return*/, _a.sent()];
                                            }
                                        }); }); })];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, refreshInterval);
                        this.stopRefreshLoop = loop.stop;
                        _a = this.setState;
                        return [4 /*yield*/, getData()];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        loop.start();
                        return [2 /*return*/, loop.refresh];
                }
            });
        });
    };
    DataBaseComponent.prototype.mapToOctopusError = function (err) {
        // we override this in subclasses so don't remove
        return createErrorsFromOctopusError(err);
    };
    return DataBaseComponent;
}(BaseComponent_1.default));
exports.DataBaseComponent = DataBaseComponent;
function createErrorsFromOctopusError(err) {
    return {
        message: err.ErrorMessage,
        details: err.Errors || [],
        detailLinks: err.ParsedHelpLinks,
        helpLink: err.HelpLink,
        helpText: err.HelpText,
        fullException: err.FullException,
        fieldErrors: {}
    };
}
exports.createErrorsFromOctopusError = createErrorsFromOctopusError;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataBaseComponent\\DataBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataBaseComponent\\DataBaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SelectField_1 = __webpack_require__(828);
var MenuItem_1 = __webpack_require__(109);
var colors_1 = __webpack_require__(31);
var FilterSearchBox_1 = __webpack_require__(198);
var fontWeights_1 = __webpack_require__(83);
var styles = __webpack_require__(1531);
var LabelStrategy_1 = __webpack_require__(167);
var BoundField_1 = __webpack_require__(100);
var SelectInternal = (function (_super) {
    __extends(SelectInternal, _super);
    function SelectInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (_, __, value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.setState({
                filter: null,
                filteredItems: null,
                showExternalError: false
            });
            _this.props.onChange(value);
        };
        _this.handleFilterChanged = function (value) {
            var filteredItems = _this.props.items.filter(function (item) {
                return item.text.toLowerCase().search(value.toLowerCase()) !== -1;
            });
            _this.setState({
                filter: value,
                filteredItems: filteredItems
            });
        };
        _this.handleOnClose = function () {
            if (_this.state.filter) {
                _this.setState({
                    filter: null,
                    filteredItems: null
                });
            }
        };
        _this.state = {
            filter: null,
            filteredItems: null,
            showExternalError: true
        };
        return _this;
    }
    SelectInternal.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    SelectInternal.prototype.render = function () {
        var _a = this.props, value = _a.value, label = _a.label, fixedLabel = _a.fixedLabel, items = _a.items, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, validate = _a.validate, warning = _a.warning, hintText = _a.hintText, allowClear = _a.allowClear, allowFilter = _a.allowFilter, otherProps = __rest(_a, ["value", "label", "fixedLabel", "items", "error", "onChange", "onValidate", "validate", "warning", "hintText", "allowClear", "allowFilter"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var errorText = err || warning;
        var errorStyle = { bottom: "0px", color: err ? colors_1.danger : colors_1.alert };
        // We need to hack the labelStyle to stop MaterialUI from overflowing other controls that may be sitting underneath this.
        var labelStyle = {
            height: "40px",
            lineHeight: "40px",
        };
        return (React.createElement("div", { className: styles.container },
            React.createElement(SelectField_1.default, __assign({ className: styles.select, value: value, allowClear: allowClear, hintText: hintText, labelStyle: labelStyle, onChange: this.handleChange, errorText: errorText, errorStyle: errorStyle, floatingLabelText: label, floatingLabelStyle: { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal }, floatingLabelFocusStyle: errorText ? errorStyle : { color: colors_1.primary, fontWeight: fontWeights_1.normal }, floatingLabelFixed: !!hintText, selectedMenuItemStyle: { color: colors_1.primary }, underlineFocusStyle: { borderColor: colors_1.primary }, underlineStyle: { borderColor: colors_1.secondaryText, position: "relative" }, dropDownMenuProps: { onClose: this.handleOnClose }, iconStyle: { fill: colors_1.secondaryText }, filter: allowFilter && React.createElement("div", { className: styles.filter },
                    React.createElement(FilterSearchBox_1.default, { hintText: "Find...", autoFocus: true, value: this.state.filter, onChange: this.handleFilterChanged })) }, otherProps), (this.state.filteredItems || items).map(function (item) {
                return React.createElement(MenuItem_1.default, { key: item.value, value: item.value, leftIcon: item.icon, primaryText: item.text, style: item.style });
            }))));
    };
    return SelectInternal;
}(React.Component));
exports.SelectInternal = SelectInternal;
var Select = LabelStrategy_1.default(SelectInternal, function (fieldName) { return "Select " + fieldName; });
exports.default = Select;
exports.BoundSelect = BoundField_1.withBoundField(Select);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\Select.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\Select.tsx"); } } })();

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(121);
var BoundField_1 = __webpack_require__(100);
var StringCheckbox = (function (_super) {
    __extends(StringCheckbox, _super);
    function StringCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (isChecked) {
            var trueValue = _this.props.trueValue || "True";
            var falseValue = _this.props.falseValue || "False";
            var value = isChecked ? trueValue : falseValue;
            if (_this.props.validate) {
                var validateResult = _this.props.validate(value);
                _this.props.onValidate(validateResult);
            }
            _this.props.onChange(value);
        };
        return _this;
    }
    StringCheckbox.prototype.render = function () {
        var _a = this.props, value = _a.value, onChange = _a.onChange, onValidate = _a.onValidate, validate = _a.validate, note = _a.note, otherProps = __rest(_a, ["value", "onChange", "onValidate", "validate", "note"]);
        var val = (value || "").toLowerCase() === "true";
        return React.createElement(Checkbox_1.default, __assign({ value: val, title: this.props.title, onChange: this.handleChange, note: this.props.note }, otherProps));
    };
    return StringCheckbox;
}(React.Component));
exports.default = StringCheckbox;
exports.BoundStringCheckbox = BoundField_1.withBoundField(StringCheckbox);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Checkbox\\StringCheckbox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Checkbox\\StringCheckbox.tsx"); } } })();

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var PermissionCheck = function (_a) {
    var render = _a.render, props = __rest(_a, ["render"]);
    var allowed = isAllowed(props);
    var alternate = props.alternate || null;
    var children = props.children || null;
    if (render) {
        return allowed ? render() : alternate;
    }
    var renderChildren = function () {
        return children && typeof children === "function"
            ? children() : children;
    };
    return React.createElement("div", null, allowed ? renderChildren() : alternate);
};
function hasPermission(permission) {
    return isAllowed({ permission: permission, wildcard: true });
}
exports.hasPermission = hasPermission;
function isAllowed(props) {
    var pid = props.project || (props.wildcard ? "*" : null);
    var eid = props.environment || (props.wildcard ? "*" : null);
    var gid = props.projectGroup || (props.wildcard ? "*" : null);
    var tid = props.tenant || (props.wildcard ? "*" : null);
    var permissions = (props.permission instanceof Array)
        ? props.permission
        : [props.permission];
    var checks = permissions.map(function (p) {
        return clientInstance_1.session.currentPermissions.isAuthorized({
            permission: p,
            projectId: pid,
            environmentId: eid,
            projectGroupId: gid,
            tenantId: tid
        });
    });
    return checks.some(function (x) { return x; });
}
exports.isAllowed = isAllowed;
function firstAuthorized(permissions) {
    return clientInstance_1.session.currentPermissions.firstAuthorized(permissions);
}
exports.firstAuthorized = firstAuthorized;
exports.default = PermissionCheck;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PermissionCheck\\PermissionCheck.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PermissionCheck\\PermissionCheck.tsx"); } } })();

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var styles = __webpack_require__(596);
var react_router_1 = __webpack_require__(76);
var exposeComponentAsClass_1 = __webpack_require__(380);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var cn = __webpack_require__(19);
var InternalLink = function (props) {
    var onClick = function (e) {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };
    var style = {};
    if (props.size) {
        style.fontSize = props.size + "rem";
    }
    if (props.weight) {
        style.fontWeight = props.weight;
    }
    if (props.width) {
        style.width = props.width;
    }
    if (props.color) {
        style.color = props.color;
    }
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_dom_1.Link, { className: cn(styles.internalLink, props.className), style: style, to: resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId), target: props.openInSelf ? "_self" : "_blank", onClick: onClick }, props.children);
};
InternalLink.defaultProps = {
    openInSelf: true
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(InternalLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\InternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\InternalLink.tsx"); } } })();

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(117);
var cn = __webpack_require__(19);
var recompose_1 = __webpack_require__(186);
function withClassNames(classNames) {
    return function (Component) {
        var WithClassNames = function (props) {
            var _a = props, className = _a.className, rest = __rest(_a, ["className"]);
            return React.createElement(Component, __assign({ className: cn(classNames, className) }, rest));
        };
        return WithClassNames;
    };
}
exports.withClassNames = withClassNames;
function withMappedClassNames(mapper) {
    return recompose_1.mapProps(function (props) {
        var _a = props, className = _a.className, forceMobileBehaviour = _a.forceMobileBehaviour, rest = __rest(_a, ["className", "forceMobileBehaviour"]);
        return __assign({ className: mapper(props) }, rest);
    });
}
exports.withMappedClassNames = withMappedClassNames;
var withSummaryClasses = withMappedClassNames(function (props) {
    return cn(props.className, (_a = {}, _a[styles.cardSubTitleForceMobile] = props.forceMobileBehaviour, _a));
    var _a;
});
var SummarySpan = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("span", { className: className, children: children });
};
exports.PlaceholderSummary = withSummaryClasses(withClassNames(styles.cardPlaceholderSubTitle)(SummarySpan));
exports.DefaultSummary = withSummaryClasses(withClassNames(styles.cardDefaultSubTitle)(SummarySpan));
exports.OverflowSummary = withSummaryClasses(withClassNames(styles.cardSubTitle)(SummarySpan));
var Summary = (function () {
    function Summary() {
    }
    Summary.placeholder = function (node) {
        return function (props) { return React.createElement(exports.PlaceholderSummary, __assign({}, props), node); };
    };
    Summary.default = function (node) {
        return function (props) { return React.createElement(exports.DefaultSummary, __assign({}, props), node); };
    };
    Summary.summary = function (node) {
        return function (props) {
            return React.createElement(exports.OverflowSummary, __assign({ className: cn((_a = {}, _a[styles.cardSubTitleWithOverflowMenu] = props.overflow, _a)) }, props), node);
            var _a;
        };
    };
    return Summary;
}());
exports.default = Summary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\Summary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\Summary.tsx"); } } })();

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(76);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var InternalRedirect = function (props) {
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_1.Redirect, { from: props.from, to: resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId), push: props.push, exact: props.exact });
};
exports.default = react_router_1.withRouter(InternalRedirect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalRedirect\\InternalRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalRedirect\\InternalRedirect.tsx"); } } })();

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionExecutionLocation;
(function (ActionExecutionLocation) {
    ActionExecutionLocation["AlwaysOnTarget"] = "AlwaysOnTarget";
    ActionExecutionLocation["AlwaysOnServer"] = "AlwaysOnServer";
    ActionExecutionLocation["TargetOrServer"] = "TargetOrServer";
})(ActionExecutionLocation = exports.ActionExecutionLocation || (exports.ActionExecutionLocation = {}));
exports.default = ActionExecutionLocation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionExecutionLocation.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionExecutionLocation.ts"); } } })();

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NavigationButton_1 = __webpack_require__(197);
exports.NavigationButton = NavigationButton_1.NavigationButton;
exports.NavigationButtonType = NavigationButton_1.NavigationButtonType;
var ActionButton_1 = __webpack_require__(49);
exports.ActionButton = ActionButton_1.ActionButton;
exports.ActionButtonType = ActionButton_1.ActionButtonType;
var CloseButton_1 = __webpack_require__(583);
exports.CloseButton = CloseButton_1.default;
var PagingControlButton_1 = __webpack_require__(1266);
exports.PagingControlButton = PagingControlButton_1.default;
var OpenDeleteDialogButton_1 = __webpack_require__(808);
exports.OpenDeleteDialogButton = OpenDeleteDialogButton_1.default;
exports.default = ActionButton_1.ActionButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\index.tsx"); } } })();

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(117);
var FormSectionHeading = (function (_super) {
    __extends(FormSectionHeading, _super);
    function FormSectionHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSectionHeading.prototype.render = function () {
        return React.createElement("div", { className: styles.sectionHeading },
            React.createElement("div", { className: styles.sectionHeadingTitle }, this.props.title));
    };
    return FormSectionHeading;
}(React.Component));
exports.default = FormSectionHeading;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSectionHeading.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSectionHeading.tsx"); } } })();

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(241);
var FlatButton_1 = __webpack_require__(115);
var BusyFromPromise_1 = __webpack_require__(582);
var colors_1 = __webpack_require__(31);
var cn = __webpack_require__(19);
var styles = __webpack_require__(271);
var fontWeights_1 = __webpack_require__(83);
var ActionButtonType;
(function (ActionButtonType) {
    ActionButtonType[ActionButtonType["Primary"] = 0] = "Primary";
    ActionButtonType[ActionButtonType["Secondary"] = 1] = "Secondary";
    ActionButtonType[ActionButtonType["Ternary"] = 2] = "Ternary";
    ActionButtonType[ActionButtonType["Save"] = 3] = "Save";
    ActionButtonType[ActionButtonType["Delete"] = 4] = "Delete";
    ActionButtonType[ActionButtonType["CreateRelease"] = 5] = "CreateRelease";
})(ActionButtonType = exports.ActionButtonType || (exports.ActionButtonType = {}));
var ActionButton = (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ActionButton.prototype.onClick = function (event) {
        var _this = this;
        if (!this.props.onClick) {
            return;
        }
        if (event.preventDefault) {
            event.preventDefault();
        }
        var promise = (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.props.onClick(event)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); })();
        this.setState({ invocation: promise });
        return promise;
    };
    ActionButton.prototype.getButton = function (busy, disabled) {
        var _this = this;
        var props = this.props;
        var otherPropsForButtons = {
            tabIndex: props.tabIndex,
            className: cn(styles.globalActionButtonAndLinks, styles.globalActionButton, props.className),
        };
        var otherPropsForLinks = {
            tabIndex: props.tabIndex,
            className: cn(styles.globalActionButtonAndLinks, props.className),
        };
        var commonLabelStyle = {
            fontSize: "0.8125rem",
        };
        var labelStyle = __assign({ color: colors_1.primary, opacity: props.disabled ? 0.5 : 1, whiteSpace: "nowrap" }, commonLabelStyle, props.labelProps);
        var label = busy && props.busyLabel ? props.busyLabel : props.label;
        var onClick = disabled ? null : function (e) { return _this.onClick(e); };
        switch (props.type) {
            case ActionButtonType.Primary:
                return React.createElement(RaisedButton_1.default, __assign({ type: "submit", label: label, title: label, disabled: disabled, icon: props.icon, backgroundColor: colors_1.success, labelColor: colors_1.white, labelStyle: commonLabelStyle, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, onClick: onClick, onFocus: props.onFocus, keyboardFocused: this.props.keyboardFocused }, otherPropsForButtons));
            case ActionButtonType.CreateRelease:
                return React.createElement(RaisedButton_1.default, { type: "submit", keyboardFocused: this.props.keyboardFocused, label: label, title: label, disabled: disabled, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, backgroundColor: colors_1.secondaryDark, labelColor: colors_1.white, labelStyle: commonLabelStyle, onClick: onClick });
            case ActionButtonType.Save:
                return React.createElement(RaisedButton_1.default, { type: "submit", keyboardFocused: this.props.keyboardFocused, label: label, title: label, disabled: disabled, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, backgroundColor: colors_1.success, labelColor: colors_1.white, labelStyle: commonLabelStyle, onClick: onClick });
            case ActionButtonType.Delete:
                return React.createElement(RaisedButton_1.default, { type: "submit", keyboardFocused: this.props.keyboardFocused, label: label, title: label, disabled: disabled, backgroundColor: colors_1.danger, labelColor: colors_1.white, labelStyle: commonLabelStyle, onClick: onClick, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white });
            case ActionButtonType.Ternary:
                var contents = props.icon
                    ? [props.icon, label]
                    : label;
                var height = 36 / fontWeights_1.baseSizeInPx + "rem";
                return React.createElement("a", __assign({ href: "#", title: label, onClick: onClick, onFocus: props.onFocus, style: {
                        height: height,
                        lineHeight: height,
                        marginLeft: "0.5rem",
                        marginRight: "0.5rem",
                        fontSize: "0.8125rem",
                        fontWeight: fontWeights_1.normal,
                        textTransform: "uppercase"
                    } }, otherPropsForLinks), contents);
            // Fallthrough to Secondary
            default:
                var style = this.props.style ? this.props.style : { margin: "inherit" };
                // Div allows margin to be added
                return React.createElement(FlatButton_1.default, __assign({ label: label, title: label, labelStyle: labelStyle, style: style, icon: props.icon, disabled: disabled, onClick: onClick, onFocus: props.onFocus, keyboardFocused: this.props.keyboardFocused }, otherPropsForButtons));
        }
    };
    ActionButton.prototype.render = function () {
        var _this = this;
        return React.createElement(BusyFromPromise_1.default, { promise: this.state.invocation }, function (busy) { return React.createElement(BusyFromPromise_1.default, { promise: _this.props.disabled }, function (disabled) { return _this.getButton(busy, disabled || busy); }); });
    };
    return ActionButton;
}(React.Component));
exports.ActionButton = ActionButton;
exports.default = ActionButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\ActionButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\ActionButton.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TextField_1 = __webpack_require__(666);
var colors_1 = __webpack_require__(31);
var LabelStrategy_1 = __webpack_require__(167);
var colors_2 = __webpack_require__(31);
var fontWeights_1 = __webpack_require__(83);
var UniqueSequenceGenerator_1 = __webpack_require__(404);
var styles = __webpack_require__(1514);
var TextInternal = (function (_super) {
    __extends(TextInternal, _super);
    function TextInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.getSelection = function () {
            var input = _this.textField.getInputNode();
            return { start: input.selectionStart, end: input.selectionEnd };
        };
        _this.setValueAndSelection = function (selection, value) {
            var input = _this.textField.getInputNode();
            input.value = value;
            input.selectionStart = selection.start;
            input.selectionEnd = selection.end;
            _this.callValidateAndChange(input.value);
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.callValidateAndChange(value);
        };
        _this.callValidateAndChange = function (value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.setState({ showExternalError: false });
            _this.props.onChange(value);
        };
        _this.handleKeyPress = function (event) {
            if (_this.props.onKeyPress) {
                _this.props.onKeyPress(event);
            }
        };
        _this.handleKeyDown = function (event) {
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(event);
            }
        };
        _this.state = {
            error: null,
            showExternalError: true
        };
        _this.genericName = "name" + TextInternal.sequence.next().toString();
        return _this;
    }
    TextInternal.prototype.componentWillMount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(this);
        }
    };
    TextInternal.prototype.componentWillUnmount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(null);
        }
    };
    TextInternal.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    TextInternal.prototype.isFocused = function () {
        return this.textField && this.textField.getInputNode() === document.activeElement;
    };
    TextInternal.prototype.select = function () {
        if (this.textField) {
            this.textField.select();
        }
    };
    TextInternal.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    TextInternal.prototype.insertAtCursor = function (value) {
        if (!this.textField) {
            return;
        }
        var input = this.textField.getInputNode();
        if (input.selectionStart || input.selectionStart === 0) {
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + value
                + input.value.substring(endPos, input.value.length);
            input.selectionStart = startPos + value.length;
            input.selectionEnd = startPos + value.length;
        }
        else {
            input.value += value;
        }
        this.callValidateAndChange(input.value);
    };
    TextInternal.prototype.forceHasValue = function () {
        if (this.textField) {
            return this.textField.setState({ hasValue: true });
        }
    };
    TextInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onClick = _a.onClick, onValidate = _a.onValidate, type = _a.type, value = _a.value, min = _a.min, max = _a.max, name = _a.name, hintText = _a.hintText, underlineShow = _a.underlineShow, warning = _a.warning, monoSpacedFont = _a.monoSpacedFont, rowsMax = _a.rowsMax, onKeyPress = _a.onKeyPress, rows = _a.rows, multiLine = _a.multiLine, applyMaxWidth = _a.applyMaxWidth, showBorder = _a.showBorder, textInputRef = _a.textInputRef, showValueAsTitleAttribute = _a.showValueAsTitleAttribute, autoComplete = _a.autoComplete, otherProps = __rest(_a, ["id", "label", "validate", "error", "onChange", "onClick", "onValidate", "type", "value", "min", "max", "name", "hintText", "underlineShow", "warning", "monoSpacedFont", "rowsMax", "onKeyPress", "rows", "multiLine", "applyMaxWidth", "showBorder", "textInputRef", "showValueAsTitleAttribute", "autoComplete"]);
        var err = this.state.error || (this.state.showExternalError && error);
        var errorText = err || warning;
        var val = value ? value : "";
        // Transform underlineShow to a style, so that animations work if you toggle underlineShow to true
        var underlineStyle = underlineShow || underlineShow === undefined ?
            { borderColor: colors_1.secondaryText, position: "relative", marginRight: "0.5rem" }
            :
                { visibility: "hidden" };
        // margin-top caused overflow because material-ui text field uses border-box and margins are not included in calculations in that mode.
        // This is why we've replaced margin with padding.
        // Unfortunately, text-overflow: ellipsis doesn't work in IE11 or edge, unless the input is readonly.
        // We haven't worked around this in any way yet, but some people do some nasty hacks to get it working
        // in these browsers, like: https://frontendtricksandmagic.wordpress.com/2015/03/07/how-to-make-text-overflow-ellipsis-work-for-inputs-in-ie/
        var inputStyle = { marginTop: "0px", textOverflow: "ellipsis", overflow: "hidden" };
        // margin/padding is only required when there is a label
        inputStyle.paddingTop = label && !multiLine ? "18px" : "0px";
        var hintStyle = { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal, height: "24px", whiteSpace: "nowrap", width: "90%", overflow: "hidden", textOverflow: "ellipsis" };
        var widthStyle = applyMaxWidth ? { maxWidth: "100%" } : {};
        var borderStyle = showBorder ? { padding: "0.5rem", border: "0.0625rem solid", borderColor: colors_2.divider, marginBottom: "0.5rem" } : {};
        // We are not using margin so there is no need to manually position the error text.
        var errorStyle = { bottom: "0px", color: err ? colors_1.danger : colors_1.alert };
        return (React.createElement("div", { className: styles.container },
            React.createElement(TextField_1.default, __assign({ className: monoSpacedFont ? [styles.text, styles.monospacedText].join(" ") : styles.text, ref: function (textField) { return _this.textField = textField; }, id: id, autoComplete: autoComplete ? autoComplete : "off", type: type, hintText: hintText, name: name || this.genericName, hintStyle: hintStyle, value: val, title: showValueAsTitleAttribute ? val : hintText, onClick: onClick, onChange: this.handleChange, errorText: errorText, errorStyle: errorStyle, floatingLabelStyle: { color: colors_1.secondaryText, fontWeight: fontWeights_1.normal }, floatingLabelFocusStyle: errorText ? { color: err ? colors_1.danger : colors_1.alert } : { color: colors_1.primary, fontWeight: fontWeights_1.normal }, floatingLabelFixed: !!hintText, floatingLabelText: label, underlineStyle: underlineStyle, underlineFocusStyle: { borderColor: colors_1.primary, bottom: "10px" }, underlineDisabledStyle: { borderBottom: "0.0625rem solid rgb(224, 224, 224)" }, min: min, max: max, rows: multiLine ? (rows || 3) : rows, rowsMax: rowsMax, multiLine: multiLine, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown, inputStyle: inputStyle, style: __assign({}, widthStyle, borderStyle) }, otherProps))));
    };
    TextInternal.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    TextInternal.defaultProps = {
        type: "text",
        autoFocus: false,
        applyMaxWidth: false,
        showBorder: false,
        textInputRef: function (input) { }
    };
    return TextInternal;
}(React.Component));
var Text = LabelStrategy_1.default(TextInternal, function (fieldName) { return fieldName; });
exports.default = Text;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\Text.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\Text.tsx"); } } })();

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//Enums can't be keys in a dictionary so we might need to convert this to a list of static strings
var Permission;
(function (Permission) {
    Permission["None"] = "None";
    Permission["AdministerSystem"] = "AdministerSystem";
    Permission["ProjectEdit"] = "ProjectEdit";
    Permission["ProjectView"] = "ProjectView";
    Permission["ProjectCreate"] = "ProjectCreate";
    Permission["ProjectDelete"] = "ProjectDelete";
    Permission["ProcessView"] = "ProcessView";
    Permission["ProcessEdit"] = "ProcessEdit";
    Permission["VariableEdit"] = "VariableEdit";
    Permission["VariableEditUnscoped"] = "VariableEditUnscoped";
    Permission["VariableView"] = "VariableView";
    Permission["VariableViewUnscoped"] = "VariableViewUnscoped";
    Permission["ReleaseCreate"] = "ReleaseCreate";
    Permission["ReleaseView"] = "ReleaseView";
    Permission["ReleaseEdit"] = "ReleaseEdit";
    Permission["ReleaseDelete"] = "ReleaseDelete";
    Permission["DefectReport"] = "DefectReport";
    Permission["DefectResolve"] = "DefectResolve";
    Permission["DeploymentCreate"] = "DeploymentCreate";
    Permission["DeploymentDelete"] = "DeploymentDelete";
    Permission["DeploymentView"] = "DeploymentView";
    Permission["EnvironmentView"] = "EnvironmentView";
    Permission["EnvironmentCreate"] = "EnvironmentCreate";
    Permission["EnvironmentEdit"] = "EnvironmentEdit";
    Permission["EnvironmentDelete"] = "EnvironmentDelete";
    Permission["MachineCreate"] = "MachineCreate";
    Permission["MachineEdit"] = "MachineEdit";
    Permission["MachineView"] = "MachineView";
    Permission["MachineDelete"] = "MachineDelete";
    Permission["ArtifactView"] = "ArtifactView";
    Permission["ArtifactCreate"] = "ArtifactCreate";
    Permission["ArtifactEdit"] = "ArtifactEdit";
    Permission["ArtifactDelete"] = "ArtifactDelete";
    Permission["FeedView"] = "FeedView";
    Permission["EventView"] = "EventView";
    Permission["LibraryVariableSetView"] = "LibraryVariableSetView";
    Permission["LibraryVariableSetCreate"] = "LibraryVariableSetCreate";
    Permission["LibraryVariableSetEdit"] = "LibraryVariableSetEdit";
    Permission["LibraryVariableSetDelete"] = "LibraryVariableSetDelete";
    Permission["ProjectGroupView"] = "ProjectGroupView";
    Permission["ProjectGroupCreate"] = "ProjectGroupCreate";
    Permission["ProjectGroupEdit"] = "ProjectGroupEdit";
    Permission["ProjectGroupDelete"] = "ProjectGroupDelete";
    Permission["TeamCreate"] = "TeamCreate";
    Permission["TeamView"] = "TeamView";
    Permission["TeamEdit"] = "TeamEdit";
    Permission["TeamDelete"] = "TeamDelete";
    Permission["UserView"] = "UserView";
    Permission["UserEdit"] = "UserEdit";
    Permission["UserInvite"] = "UserInvite";
    Permission["UserRoleView"] = "UserRoleView";
    Permission["UserRoleEdit"] = "UserRoleEdit";
    Permission["TaskView"] = "TaskView";
    Permission["TaskViewLog"] = "TaskViewLog";
    Permission["TaskCreate"] = "TaskCreate";
    Permission["TaskCancel"] = "TaskCancel";
    Permission["TaskEdit"] = "TaskEdit";
    Permission["InterruptionView"] = "InterruptionView";
    Permission["InterruptionSubmit"] = "InterruptionSubmit";
    Permission["InterruptionViewSubmitResponsible"] = "InterruptionViewSubmitResponsible";
    Permission["BuiltInFeedPush"] = "BuiltInFeedPush";
    Permission["BuiltInFeedAdminister"] = "BuiltInFeedAdminister";
    Permission["BuiltInFeedDownload"] = "BuiltInFeedDownload";
    Permission["ActionTemplateView"] = "ActionTemplateView";
    Permission["ActionTemplateCreate"] = "ActionTemplateCreate";
    Permission["ActionTemplateEdit"] = "ActionTemplateEdit";
    Permission["ActionTemplateDelete"] = "ActionTemplateDelete";
    Permission["LifecycleCreate"] = "LifecycleCreate";
    Permission["LifecycleView"] = "LifecycleView";
    Permission["LifecycleEdit"] = "LifecycleEdit";
    Permission["LifecycleDelete"] = "LifecycleDelete";
    Permission["AccountView"] = "AccountView";
    Permission["AccountEdit"] = "AccountEdit";
    Permission["AccountCreate"] = "AccountCreate";
    Permission["AccountDelete"] = "AccountDelete";
    Permission["AuditView"] = "AuditView";
    Permission["TenantCreate"] = "TenantCreate";
    Permission["TenantEdit"] = "TenantEdit";
    Permission["TenantView"] = "TenantView";
    Permission["TenantDelete"] = "TenantDelete";
    Permission["TagSetCreate"] = "TagSetCreate";
    Permission["TagSetEdit"] = "TagSetEdit";
    Permission["TagSetDelete"] = "TagSetDelete";
    Permission["MachinePolicyCreate"] = "MachinePolicyCreate";
    Permission["MachinePolicyView"] = "MachinePolicyView";
    Permission["MachinePolicyEdit"] = "MachinePolicyEdit";
    Permission["MachinePolicyDelete"] = "MachinePolicyDelete";
    Permission["ProxyCreate"] = "ProxyCreate";
    Permission["ProxyView"] = "ProxyView";
    Permission["ProxyEdit"] = "ProxyEdit";
    Permission["ProxyDelete"] = "ProxyDelete";
    Permission["SubscriptionCreate"] = "SubscriptionCreate";
    Permission["SubscriptionView"] = "SubscriptionView";
    Permission["SubscriptionEdit"] = "SubscriptionEdit";
    Permission["SubscriptionDelete"] = "SubscriptionDelete";
    Permission["TriggerCreate"] = "TriggerCreate";
    Permission["TriggerView"] = "TriggerView";
    Permission["TriggerEdit"] = "TriggerEdit";
    Permission["TriggerDelete"] = "TriggerDelete";
    Permission["CertificateView"] = "CertificateView";
    Permission["CertificateCreate"] = "CertificateCreate";
    Permission["CertificateEdit"] = "CertificateEdit";
    Permission["CertificateDelete"] = "CertificateDelete";
    Permission["CertificateExportPrivateKey"] = "CertificateExportPrivateKey";
    Permission["ConfigureServer"] = "ConfigureServer";
    Permission["FeedEdit"] = "FeedEdit";
    Permission["WorkerEdit"] = "WorkerEdit";
    Permission["WorkerView"] = "WorkerView";
})(Permission = exports.Permission || (exports.Permission = {}));
exports.default = Permission;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permission.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permission.ts"); } } })();

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1536);
var FlatButton_1 = __webpack_require__(115);
var IconButton_1 = __webpack_require__(67);
var crop_original_1 = __webpack_require__(1538);
var index_1 = __webpack_require__(74);
var cn = __webpack_require__(19);
var refresh_1 = __webpack_require__(1543);
var add_1 = __webpack_require__(1544);
var search_1 = __webpack_require__(665);
var visibility_1 = __webpack_require__(1545);
var visibility_off_1 = __webpack_require__(1546);
var delete_1 = __webpack_require__(1547);
var mode_edit_1 = __webpack_require__(1548);
var clear_1 = __webpack_require__(204);
var file_upload_1 = __webpack_require__(1549);
var arrow_drop_down_1 = __webpack_require__(387);
var arrow_drop_up_1 = __webpack_require__(1550);
var colors_1 = __webpack_require__(31);
var Icon;
(function (Icon) {
    Icon[Icon["UseDefaultImage"] = 0] = "UseDefaultImage";
    Icon[Icon["EnterFullScreen"] = 1] = "EnterFullScreen";
    Icon[Icon["ExitFullScreen"] = 2] = "ExitFullScreen";
    Icon[Icon["Refresh"] = 3] = "Refresh";
    Icon[Icon["Add"] = 4] = "Add";
    Icon[Icon["Search"] = 5] = "Search";
    Icon[Icon["Show"] = 6] = "Show";
    Icon[Icon["Hide"] = 7] = "Hide";
    Icon[Icon["Edit"] = 8] = "Edit";
    Icon[Icon["Remove"] = 9] = "Remove";
    Icon[Icon["Cancel"] = 10] = "Cancel";
    Icon[Icon["ArrowDown"] = 11] = "ArrowDown";
    Icon[Icon["Upload"] = 12] = "Upload";
    Icon[Icon["ArrowUp"] = 13] = "ArrowUp";
})(Icon = exports.Icon || (exports.Icon = {}));
var IconButton = function (props) {
    if (props.icon !== null) {
        if (typeof props.icon === "string") {
            return iconButton(React.createElement("img", { className: styles.imageIcon, src: props.icon, alt: "" }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
        }
        switch (props.icon) {
            case Icon.EnterFullScreen: return fontAwesomeIconButton("fa-expand", props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ExitFullScreen: return fontAwesomeIconButton("fa-compress", props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.UseDefaultImage: return materialIconButton(React.createElement(crop_original_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Refresh: return materialIconButton(React.createElement(refresh_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Add: return materialIconButton(React.createElement(add_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Search: return materialIconButton(React.createElement(search_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Show: return materialIconButton(React.createElement(visibility_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Hide: return materialIconButton(React.createElement(visibility_off_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Edit: return materialIconButton(React.createElement(mode_edit_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Cancel: return materialIconButton(React.createElement(clear_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Remove: return materialIconButton(React.createElement(delete_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.Upload: return materialIconButton(React.createElement(file_upload_1.default, null), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ArrowDown: return materialIconButton(React.createElement(arrow_drop_down_1.default, { color: colors_1.secondaryText }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
            case Icon.ArrowUp: return materialIconButton(React.createElement(arrow_drop_up_1.default, { color: colors_1.secondaryText }), props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
        }
    }
    return materialIconButton(props.customIcon, props.onClick, props.toolTipContent, props.disabled, props.tabIndex, props.buttonRef);
};
function materialIconButton(icon, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    var elem = React.createElement(IconButton_1.default, { className: styles.materialUIIcon, disabled: disabled, tabIndex: tabIndex, onClick: onClick, ref: buttonRef }, icon);
    if (!toolTipContent) {
        return elem;
    }
    return withToolTip(elem, toolTipContent);
}
function fontAwesomeIconButton(iconClassName, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    return iconButton(React.createElement("em", { className: cn("fa", iconClassName, styles.fontAwesomeIcon), "aria-hidden": "true" }), onClick, toolTipContent, disabled, tabIndex, buttonRef);
}
function iconButton(label, onClick, toolTipContent, disabled, tabIndex, buttonRef) {
    return withToolTip(React.createElement(FlatButton_1.default, { className: styles.materialUIIcon, disabled: disabled, tabIndex: tabIndex, onClick: onClick, ref: buttonRef, label: label }), toolTipContent);
}
function withToolTip(button, toolTipContent) {
    return React.createElement(index_1.default, { content: toolTipContent }, button);
}
IconButton.displayName = "IconButton";
exports.default = IconButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButton\\IconButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButton\\IconButton.tsx"); } } })();

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var InternalLink_1 = __webpack_require__(238);
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var feedResource_1 = __webpack_require__(73);
var Callout_1 = __webpack_require__(58);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var routeLinks_1 = __webpack_require__(22);
var clientInstance_1 = __webpack_require__(10);
var AutoComplete_1 = __webpack_require__(2042);
var feedResource_2 = __webpack_require__(73);
var SelectWithAddRefresh_1 = __webpack_require__(736);
var Button_1 = __webpack_require__(47);
var _ = __webpack_require__(11);
var PackageSelector = (function (_super) {
    __extends(PackageSelector, _super);
    function PackageSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.checkIfLooksLikeVersion = function () {
            var looksLikeVersion = false;
            var packageId = _this.props.packageId;
            if (packageId) {
                if (packageId.match(/\.[0-9]+\.?$/)) {
                    looksLikeVersion = true;
                }
            }
            _this.setState({ looksLikeVersion: looksLikeVersion });
        };
        _this.getPackageOptions = function (searchText, feed) { return __awaiter(_this, void 0, void 0, function () {
            var items, packages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (feed === null) {
                            items = [];
                            return [2 /*return*/, {
                                    items: items,
                                    containsAllResults: true
                                }];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.searchPackages(feed, { term: searchText, take: 11, skip: 0 })];
                    case 1:
                        packages = _a.sent();
                        return [2 /*return*/, {
                                items: packages.Items.slice(0, 10).map(function (p) { return ({ Id: p.Id, Name: p.Id }); }),
                                containsAllResults: packages.Items.length !== 11
                            }];
                }
            });
        }); };
        _this.packageChanged = function (packageId) {
            _this.props.onPackageIdChange(packageId);
            _this.checkIfLooksLikeVersion();
        };
        _this.feedChanged = function (feedId) {
            _this.props.onFeedIdChange(feedId);
        };
        _this.defaultFeedId = function (feeds) {
            if (feeds.length === 0) {
                return null;
            }
            var buildtIn = feeds.find(function (f) { return f.Id === feedResource_1.BuiltInFeedId; });
            if (buildtIn) {
                return buildtIn.Id;
            }
            return feeds[0].Id;
        };
        _this.getSelectedFeed = function (feeds) {
            if (feeds.length === 0) {
                return null;
            }
            if (_this.props.feedId) {
                var feed = feeds.find(function (f) { return f.Id === _this.props.feedId; });
                if (feed) {
                    return feed;
                }
            }
            return null;
        };
        _this.state = {
            looksLikeVersion: false,
            showBuiltIn: !!props.showBuiltIn
        };
        return _this;
    }
    PackageSelector.prototype.componentDidMount = function () {
        // Default to built-in feed.
        if (!this.props.feedId) {
            this.props.onFeedIdChange(feedResource_1.BuiltInFeedId);
        }
    };
    PackageSelector.prototype.render = function () {
        var _this = this;
        var feeds = this.props.feeds.filter(function (f) {
            return !feedResource_1.isOctopusProjectFeed(f.FeedType) &&
                ((!_this.props.feedType || _this.props.feedType.length === 0) || _this.props.feedType.some(function (feedType) { return feedType === f.FeedType; }) ||
                    (_this.state.showBuiltIn && f.Id === "feeds-builtin"));
        });
        if (feeds.length === 0) {
            return this.noFeedsWarning();
        }
        var defaultFeedId = this.defaultFeedId(feeds);
        var selectedFeedId = this.props.feedId;
        if (selectedFeedId === null) {
            selectedFeedId = defaultFeedId;
        }
        var selectedFeed = this.getSelectedFeed(feeds);
        return React.createElement("div", null,
            React.createElement(SelectWithAddRefresh_1.BoundSelectWithAddRefresh, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: defaultFeedId, value: selectedFeedId, onChange: this.feedChanged, items: feeds.map(function (f) { return ({ value: f.Id, text: f.Name }); }), error: this.props.feedIdError, autoFocus: this.props.autoFocus, label: "Package feed", addUrl: "#" + routeLinks_1.default.library.feeds, onRequestRefresh: this.props.refreshFeeds }),
            React.createElement(Note_1.default, null,
                "The feed containing this package. Learn about ",
                React.createElement(ExternalLink_1.default, { href: "DynamicPackageFeeds" }, "Dynamically Selecting Packages at Deployment Time"),
                "."),
            React.createElement(AutoComplete_1.BoundAutoComplete, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", label: "Package ID", value: this.props.packageId || "", onChange: this.packageChanged, hintText: "Enter package ID", allowAnyTextValue: true, getOptions: function (searchText) { return _this.getPackageOptions(searchText, selectedFeed); }, error: this.props.packageIdError, showEmpty: selectedFeed && feedResource_2.feedTypeCanSearchEmpty(selectedFeed.FeedType) }),
            React.createElement(Note_1.default, null,
                "Enter the ID of the package.",
                selectedFeed && selectedFeed.FeedType === feedResource_1.FeedType.Maven && React.createElement("span", null,
                    " The format of the package ID is ",
                    React.createElement("em", null, "Group:Artifact"),
                    " for example ",
                    React.createElement("em", null, "com.google.guava:guava"),
                    " or ",
                    React.createElement("em", null, "junit:junit"),
                    ".")),
            this.state.looksLikeVersion && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information, title: "Package version not required" }, "Hey there! It looks like you might be including the package version number in this field. You shouldn't include the package version number here, just the package ID."));
    };
    PackageSelector.prototype.noFeedsWarning = function () {
        var requiresContainerImageRegistryFeed = _.every(this.props.feedType, function (f) { return feedResource_2.isContainerImageRegistry(f); });
        var requiresHelmChartFeed = this.props.feedType.length === 1 && this.props.feedType[0] === feedResource_1.FeedType.Helm;
        var feedTypeText = requiresContainerImageRegistryFeed
            ? "Container Image Registry"
            : requiresHelmChartFeed
                ? "Helm Chart Repository"
                : "Package"; // This option should never actually be used, as the built-in feed will always be available
        return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: feedTypeText + " Feed required" },
            "A ",
            feedTypeText,
            " feed is required before this step can be configured. Please add an appropriate feed in the ",
            React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.feeds, openInSelf: false }, "External Feeds"),
            " area and try again.",
            React.createElement("div", null,
                React.createElement(Button_1.default, { type: Button_1.ActionButtonType.Ternary, label: "Refresh", onClick: this.props.refreshFeeds })));
    };
    return PackageSelector;
}(BaseComponent_1.BaseComponent));
exports.default = PackageSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PackageSelector\\PackageSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PackageSelector\\PackageSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isBound = function (value, fallback) {
    if (fallback === void 0) { fallback = true; }
    if (value) {
        return value.includes("#{");
    }
    return fallback;
};
exports.default = isBound;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\BoundField\\isBound.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\BoundField\\isBound.ts"); } } })();

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Resource = (function () {
    function Resource() {
    }
    return Resource;
}());
exports.Resource = Resource;
exports.default = Resource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\resource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\resource.ts"); } } })();

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1651);
var CalloutType;
(function (CalloutType) {
    CalloutType[CalloutType["Information"] = 0] = "Information";
    CalloutType[CalloutType["Success"] = 1] = "Success";
    CalloutType[CalloutType["Warning"] = 2] = "Warning";
    CalloutType[CalloutType["Danger"] = 3] = "Danger";
})(CalloutType = exports.CalloutType || (exports.CalloutType = {}));
exports.Callout = function (props) {
    var iconName = null;
    var style = styles.none;
    switch (props.type) {
        case CalloutType.Information:// blue = information
            iconName = "sticky-note-o";
            style = styles.information;
            break;
        case CalloutType.Success:// green = success
            iconName = "lightbulb-o";
            style = styles.success;
            break;
        case CalloutType.Warning:// yellow = warning
            iconName = "exclamation-circle";
            style = styles.warning;
            break;
        case CalloutType.Danger:// red = danger
            iconName = "exclamation-triangle";
            style = styles.danger;
            break;
    }
    return (React.createElement("div", { className: style },
        props.title && React.createElement("div", { className: styles.title },
            iconName &&
                React.createElement("em", { style: { marginRight: "0.250rem" }, className: "fa fa-" + iconName, "aria-hidden": "true" }),
            React.createElement("strong", null, props.title)),
        React.createElement("div", null, props.children)));
};
exports.Callout.displayName = "Callout";
exports.default = exports.Callout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Callout\\Callout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Callout\\Callout.tsx"); } } })();

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Callout_1 = __webpack_require__(57);
exports.Callout = Callout_1.Callout;
exports.CalloutType = Callout_1.CalloutType;
exports.default = Callout_1.Callout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Callout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Callout\\index.tsx"); } } })();

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
exports.default = BaseComponent_1.BaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\index.ts"); } } })();

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(17);
var index_1 = __webpack_require__(24);
var form_1 = __webpack_require__(16);
var TenantTagsList_1 = __webpack_require__(321);
var React = __webpack_require__(0);
var scriptingLanguage_1 = __webpack_require__(157);
var CommonSummaryHelper = (function () {
    function CommonSummaryHelper() {
    }
    CommonSummaryHelper.resourceSummary = function (resourceId, resources, resourceType) {
        if (resourceId) {
            var resource = resources.find(function (x) { return x.Id === resourceId; });
            return resource
                ? form_1.Summary.summary(resource.Name)
                : form_1.Summary.placeholder("Using " + resourceType + " with id: " + resourceId); // Failed to find the resource.
        }
        return form_1.Summary.placeholder("No " + resourceType);
    };
    CommonSummaryHelper.tenantDeploymentModeSummary = function (deploymentMode, tenantIds, tenantTags) {
        var hasTags = tenantTags.length > 0;
        var hasTenants = tenantIds.length > 0;
        var hasTagOrTenant = hasTags || hasTenants;
        switch (deploymentMode) {
            case resources_1.TenantedDeploymentMode.Untenanted:
                return form_1.Summary.default(React.createElement("span", null, "Only available for untenanted deployments"));
            case resources_1.TenantedDeploymentMode.TenantedOrUntenanted:
                return hasTagOrTenant
                    ? form_1.Summary.summary(React.createElement("span", null, "Available for both untenanted deployments, and deployments to the associated tenants"))
                    : form_1.Summary.summary(React.createElement("span", null,
                        React.createElement("strong", null, "Only available in untenanted deployments"),
                        " until you choose some tenants"));
            case resources_1.TenantedDeploymentMode.Tenanted:
                return hasTagOrTenant
                    ? form_1.Summary.summary(React.createElement("span", null, "Only available for deployments to the associated tenants"))
                    : form_1.Summary.summary(React.createElement("span", null,
                        React.createElement("strong", null, "Not available for any deployments"),
                        " until you choose some tenants"));
        }
        return form_1.Summary.placeholder("Unknown tenant mode: " + deploymentMode);
    };
    CommonSummaryHelper.tenantSummary = function (tenantIds, tenantTags, tenants, showMissing) {
        var tenantChips = !!showMissing ? index_1.tenantChipListIncludingMissing(tenants, tenantIds) : index_1.tenantChipList(tenants, tenantIds);
        var hasTags = tenantTags.length > 0;
        var hasTenants = tenantIds.length > 0;
        var tenantDetails = React.createElement("span", null,
            hasTenants && React.createElement("span", null, tenantChips),
            hasTags && React.createElement("span", null,
                hasTenants ? "plus any" : "Any",
                " tenants tagged with ",
                React.createElement(TenantTagsList_1.default, { tags: tenantTags })));
        var hasTagOrTenant = hasTags || hasTenants;
        return hasTagOrTenant
            ? form_1.Summary.summary(React.createElement("span", null, tenantDetails))
            : form_1.Summary.summary("No tenants have been selected");
    };
    CommonSummaryHelper.portSummary = function (port, textIfEmpty) {
        if (textIfEmpty === void 0) { textIfEmpty = null; }
        return port ? form_1.Summary.summary(port) : form_1.Summary.placeholder(textIfEmpty ? textIfEmpty : "No port");
    };
    CommonSummaryHelper.packageSummary = function (pkg, feeds, placeholder) {
        if (placeholder === void 0) { placeholder = "Choose a package to be deployed"; }
        var summary = [];
        if (pkg) {
            if (pkg.PackageId) {
                summary.push(React.createElement("span", null,
                    "Package ",
                    React.createElement("strong", null, pkg.PackageId)));
            }
            else {
                return form_1.Summary.placeholder(placeholder);
            }
            if (pkg.FeedId) {
                var feed = feeds.find(function (f) { return f.Id === pkg.FeedId; });
                if (feed) {
                    summary.push(React.createElement("span", null,
                        " from feed ",
                        React.createElement("strong", null, feed.Name)));
                }
            }
        }
        if (summary.length > 0) {
            return form_1.Summary.summary(React.Children.toArray(summary));
        }
        return form_1.Summary.placeholder(placeholder);
    };
    CommonSummaryHelper.scriptSummary = function (scriptBody, syntax) {
        if (!scriptBody) {
            return form_1.Summary.placeholder("The script body has not been defined");
        }
        if (syntax === scriptingLanguage_1.ScriptingLanguage.FSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "An ",
                React.createElement("strong", null, "F#"),
                " script will be run"));
        }
        else if (syntax === scriptingLanguage_1.ScriptingLanguage.CSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "A ",
                React.createElement("strong", null, "C#"),
                " script will be run"));
        }
        return form_1.Summary.summary(React.createElement("span", null,
            "A ",
            React.createElement("strong", null, syntax),
            " script will be run"));
    };
    return CommonSummaryHelper;
}());
exports.default = CommonSummaryHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\CommonSummaryHelper\\CommonSummaryHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\CommonSummaryHelper\\CommonSummaryHelper.tsx"); } } })();

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(49);
var DialogLayout_1 = __webpack_require__(158);
var DialogLayoutConnect_1 = __webpack_require__(318);
var PermissionCheck_1 = __webpack_require__(42);
var FormComponent_1 = __webpack_require__(250);
var styles = __webpack_require__(247);
var OkDialogLayoutInternal = (function (_super) {
    __extends(OkDialogLayoutInternal, _super);
    function OkDialogLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.okClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onOkClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.close();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isDisabled()) {
                    this.okClick();
                }
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    OkDialogLayoutInternal.prototype.isDisabled = function () {
        return this.props.okButtonDisabled || this.props.busy;
    };
    OkDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var hasPermissionForOk = !!this.props.okButtonPermission ? PermissionCheck_1.isAllowed(this.props.okButtonPermission) : true;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var ok = React.createElement(ActionButton_1.ActionButton, { key: "Ok", label: this.props.okButtonLabel || "Ok", disabled: this.isDisabled(), onClick: this.okClick, type: ActionButton_1.ActionButtonType.Primary });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: this.props.cancelButtonLabel || "Cancel", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        var actions = [!this.props.hideCancel && cancel, hasPermissionForOk && ok].filter(function (a) { return !!a; });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: actions, closeDialog: this.props.close }, other),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.submitForm, className: styles.dialogWrapper }, children));
    };
    return OkDialogLayoutInternal;
}(React.Component));
var OkDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(OkDialogLayoutInternal);
OkDialogLayout.displayName = "OkDialogLayout";
exports.default = OkDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\OkDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\OkDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper = (function () {
    function ParseHelper() {
    }
    // Numbers
    ParseHelper.safeParseInt = function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        // so we don't display NaN
        var result = parseInt(value, 10);
        return isNaN(result) ? defaultValue : result;
    };
    // Comma Seperated Values
    ParseHelper.encodeCSV = function (val) {
        return val.join(",");
    };
    ParseHelper.parseCSV = function (val) {
        if (!val || val === "") {
            return [];
        }
        return val.split(",");
    };
    return ParseHelper;
}());
exports.default = ParseHelper;
function arrayValueFromQueryString(param, canBeCommaSeparated) {
    if (canBeCommaSeparated === void 0) { canBeCommaSeparated = false; }
    //URIjs in its infinite wisdom returns array if there are more than 1 parameter instance, or string if only one
    if (Array.isArray(param)) {
        return param;
    }
    if (typeof param === "string") {
        return canBeCommaSeparated ?
            param.split(",") :
            [param];
    }
    return [];
}
exports.arrayValueFromQueryString = arrayValueFromQueryString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ParseHelper\\ParseHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ParseHelper\\ParseHelper.tsx"); } } })();

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(47);
var PermissionCheck_1 = __webpack_require__(42);
var Dialog_1 = __webpack_require__(133);
var styles = __webpack_require__(378);
var DialogTrigger_1 = __webpack_require__(1767);
var OpenDialogButton = (function (_super) {
    __extends(OpenDialogButton, _super);
    function OpenDialogButton(props) {
        return _super.call(this, props) || this;
    }
    OpenDialogButton.prototype.render = function () {
        var _this = this;
        var disabledDueToPermission = !!this.props.permission ? !PermissionCheck_1.isAllowed(this.props.permission) : false;
        return React.createElement(DialogTrigger_1.default, { render: function (_a) {
                var open = _a.open, openDialog = _a.openDialog, sequence = _a.sequence, closeDialog = _a.closeDialog;
                return (React.createElement("div", { className: styles.buttonDialogContainer },
                    React.createElement(Button_1.ActionButton, { type: _this.props.type, icon: _this.props.icon, label: _this.props.label, disabled: disabledDueToPermission || _this.props.disabled, onClick: openDialog }),
                    _this.props.renderDialog ? _this.props.renderDialog({ open: open, openDialog: openDialog, sequence: sequence, closeDialog: closeDialog }) :
                        React.createElement(Dialog_1.default, { open: open, wide: _this.props.wideDialog }, _this.props.children)));
            } });
    };
    return OpenDialogButton;
}(React.Component));
exports.default = OpenDialogButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogButton.tsx"); } } })();

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeedType;
(function (FeedType) {
    FeedType["Nuget"] = "NuGet";
    FeedType["Docker"] = "Docker";
    FeedType["Maven"] = "Maven";
    FeedType["GitHub"] = "GitHub";
    FeedType["Helm"] = "Helm";
    FeedType["AwsElasticContainerRegistry"] = "AwsElasticContainerRegistry";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
var BuiltInFeedId = "feeds-builtin";
exports.BuiltInFeedId = BuiltInFeedId;
var OctopusReleaseFeedId = "feeds-builtin-releases";
exports.OctopusReleaseFeedId = OctopusReleaseFeedId;
function feedTypeCanSearchEmpty(feed) {
    return ![FeedType.Docker, FeedType.AwsElasticContainerRegistry, FeedType.Maven, FeedType.GitHub].includes(feed);
}
exports.feedTypeCanSearchEmpty = feedTypeCanSearchEmpty;
function feedTypeSupportsExtraction(feed) {
    // Container images can not be extracted
    return ![FeedType.Docker, FeedType.AwsElasticContainerRegistry].includes(feed);
}
exports.feedTypeSupportsExtraction = feedTypeSupportsExtraction;
function isOctopusProjectFeed(feed) {
    return feed === "OctopusProject";
}
exports.isOctopusProjectFeed = isOctopusProjectFeed;
function isContainerImageRegistry(feed) {
    return [FeedType.Docker, FeedType.AwsElasticContainerRegistry].includes(feed);
}
exports.isContainerImageRegistry = isContainerImageRegistry;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\feedResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\feedResource.ts"); } } })();

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ToolTip_1 = __webpack_require__(201);
var ToolTip_2 = __webpack_require__(201);
exports.ToolTipPosition = ToolTip_2.ToolTipPosition;
exports.ToolTipContent = ToolTip_2.ToolTipContent;
exports.default = ToolTip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ToolTip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ToolTip\\index.tsx"); } } })();

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MultiSelect_1 = __webpack_require__(111);
exports.MultiSelect = MultiSelect_1.default;
var EnvironmentMultiSelect_1 = __webpack_require__(309);
exports.EnvironmentMultiSelect = EnvironmentMultiSelect_1.default;
var WorkerPoolMultiSelect_1 = __webpack_require__(1751);
exports.WorkerPoolMultiSelect = WorkerPoolMultiSelect_1.default;
var EventCategoryMultiSelect_1 = __webpack_require__(1752);
exports.EventCategoryMultiSelect = EventCategoryMultiSelect_1.default;
var EventGroupMultiSelect_1 = __webpack_require__(1753);
exports.EventGroupMultiSelect = EventGroupMultiSelect_1.default;
var DocumentTypeMultiSelect_1 = __webpack_require__(1754);
exports.DocumentTypeMultiSelect = DocumentTypeMultiSelect_1.default;
var MachineMultiSelect_1 = __webpack_require__(777);
exports.MachineMultiSelect = MachineMultiSelect_1.default;
var ProjectMultiSelect_1 = __webpack_require__(495);
exports.ProjectMultiSelect = ProjectMultiSelect_1.default;
var RoleMultiSelect_1 = __webpack_require__(458);
exports.RoleMultiSelect = RoleMultiSelect_1.default;
var TeamMultiSelect_1 = __webpack_require__(320);
exports.TeamMultiSelect = TeamMultiSelect_1.default;
var TenantMultiSelect_1 = __webpack_require__(481);
exports.TenantMultiSelect = TenantMultiSelect_1.default;
var TenantTagMultiSelect_1 = __webpack_require__(327);
exports.TenantTagMultiSelect = TenantTagMultiSelect_1.default;
var UserMultiSelect_1 = __webpack_require__(836);
exports.UserMultiSelect = UserMultiSelect_1.default;
var StepMultiSelect_1 = __webpack_require__(470);
exports.StepMultiSelect = StepMultiSelect_1.default;
var ChannelMultiSelect_1 = __webpack_require__(791);
exports.ChannelMultiSelect = ChannelMultiSelect_1.default;
var MachineModelHealthStatusMultiSelect_1 = __webpack_require__(1755);
exports.MachineModelHealthStatusMultiSelect = MachineModelHealthStatusMultiSelect_1.default;
var EndpointCommunicationStyleMultiSelect_1 = __webpack_require__(1756);
exports.EndpointCommunicationStyleMultiSelect = EndpointCommunicationStyleMultiSelect_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\index.ts"); } } })();

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1518);
var SectionHeadingType;
(function (SectionHeadingType) {
    SectionHeadingType[SectionHeadingType["Heading1"] = 0] = "Heading1";
    SectionHeadingType[SectionHeadingType["Heading2"] = 1] = "Heading2";
    SectionHeadingType[SectionHeadingType["Heading3"] = 2] = "Heading3";
    SectionHeadingType[SectionHeadingType["Heading4"] = 3] = "Heading4";
})(SectionHeadingType = exports.SectionHeadingType || (exports.SectionHeadingType = {}));
var Section = (function (_super) {
    __extends(Section, _super);
    function Section() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Section.prototype.render = function () {
        return (React.createElement("section", { className: cn(this.props.className, this.props.sectionHeader ? styles.section : styles.sectionNoHeader) },
            this.renderSectionHeading(),
            React.createElement("div", { className: cn(styles.sectionBody, this.props.bodyClassName) }, this.props.children)));
    };
    Section.prototype.renderSectionHeading = function () {
        if (!this.props.sectionHeader) {
            return null;
        }
        switch (this.props.headingType) {
            case SectionHeadingType.Heading1:
                return React.createElement("h1", { className: styles.sectionHeader }, this.props.sectionHeader);
            case SectionHeadingType.Heading2:
                return React.createElement("h2", { className: styles.sectionHeader }, this.props.sectionHeader);
            case SectionHeadingType.Heading3:
                return React.createElement("h3", { className: styles.sectionHeader }, this.props.sectionHeader);
            default:
                return React.createElement("h4", { className: styles.sectionHeader }, this.props.sectionHeader);
        }
    };
    return Section;
}(React.Component));
exports.Section = Section;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Section\\Section.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Section\\Section.tsx"); } } })();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1505);
var TransitionAnimationType;
(function (TransitionAnimationType) {
    TransitionAnimationType[TransitionAnimationType["Fade"] = 0] = "Fade";
})(TransitionAnimationType = exports.TransitionAnimationType || (exports.TransitionAnimationType = {}));
var TransitionAnimation = (function (_super) {
    __extends(TransitionAnimation, _super);
    function TransitionAnimation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isLoaded: false };
        return _this;
    }
    TransitionAnimation.prototype.componentDidMount = function () {
        this.setState({ isLoaded: true });
    };
    TransitionAnimation.prototype.render = function () {
        return React.createElement("div", { className: cn(!this.props.disableAnimation &&
                (this.state.isLoaded
                    ? styles.fadeIn
                    : styles.notVisible), this.props.className) }, this.props.children);
    };
    return TransitionAnimation;
}(React.Component));
exports.default = TransitionAnimation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TransitionAnimation\\TransitionAnimation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TransitionAnimation\\TransitionAnimation.tsx"); } } })();

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.normal = 400;
exports.light = 300;
exports.semibold = 500;
exports.bold = 600;
exports.baseSizeInPx = 16;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\fontWeights.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\fontWeights.ts"); } } })();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_event_listener_1 = __webpack_require__(68);
var material_ui_1 = __webpack_require__(101);
var IconButton_1 = __webpack_require__(67);
var clear_1 = __webpack_require__(204);
var BaseComponent_1 = __webpack_require__(12);
var lodash_1 = __webpack_require__(11);
var styles = __webpack_require__(1771);
var BorderedListItem_1 = __webpack_require__(816);
var WindowHelper_1 = __webpack_require__(817);
var RemoveItemsList = (function (_super) {
    __extends(RemoveItemsList, _super);
    function RemoveItemsList(props) {
        var _this = _super.call(this, props) || this;
        _this.updateButtonsVisibility = _this.updateButtonsVisibility.bind(_this);
        _this.handleResize = lodash_1.throttle(_this.updateButtonsVisibility, 100);
        _this.handleScroll = lodash_1.throttle(_this.updateButtonsVisibility, 50);
        return _this;
    }
    RemoveItemsList.prototype.componentDidMount = function () {
        var _this = this;
        this.updateButtonsVisibility();
        this.pollInterval = setInterval(function () {
            _this.updateButtonsVisibility();
        }, 1000);
    };
    RemoveItemsList.prototype.componentWillUnmount = function () {
        this.handleResize.cancel();
        this.handleScroll.cancel();
        clearInterval(this.pollInterval);
    };
    RemoveItemsList.prototype.render = function () {
        var _this = this;
        var actions = (this.props.listActions || []).map(function (action, index) { return React.cloneElement(action, { key: index }); });
        return (React.createElement("div", null,
            React.createElement(react_event_listener_1.default, { target: "window", onResize: this.handleResize, onScroll: react_event_listener_1.withOptions(this.handleScroll, { passive: true, capture: false }) }),
            React.createElement("div", { ref: function (el) { return _this.topActionsMenu = el; }, className: styles.actionsMenu }, actions),
            this.props.data.length === 0 && this.props.empty && React.createElement("div", { className: styles.emptyList }, this.props.empty),
            this.props.data.length !== 0 && React.createElement(material_ui_1.List, null, this.props.data.map(function (item, index) { return _this.buildItem(item, index); })),
            React.createElement("div", { ref: function (el) { return _this.bottomActionsMenu = el; }, style: { visibility: "hidden" }, className: styles.actionsMenu }, actions)));
    };
    RemoveItemsList.prototype.updateButtonsVisibility = function () {
        if (this.topActionsMenu && this.bottomActionsMenu) {
            var result = "visible";
            if (WindowHelper_1.default.isElementInViewport(this.topActionsMenu) && WindowHelper_1.default.isElementCenterTouchable(this.topActionsMenu)) {
                result = "hidden";
            }
            else if (!WindowHelper_1.default.isElementInViewport(this.bottomActionsMenu)) {
                // If neither are visible, it might be that we're in a tab that isn't showing
                // so hide the bottom one so we don't show both when we come back.
                result = "hidden";
            }
            this.bottomActionsMenu.style.visibility = result;
        }
    };
    RemoveItemsList.prototype.buildItem = function (item, index) {
        var _this = this;
        var clearButton = this.props.onRemoveRow ? React.createElement(IconButton_1.default, { tooltip: this.props.clearButtonToolTip, onClick: function (e) {
                e.stopPropagation();
                _this.props.onRemoveRow(item);
            } },
            React.createElement(clear_1.default, null)) : null;
        return React.createElement(BorderedListItem_1.default, { key: item.Id || index, rightIconButton: clearButton, onClick: this.props.onRowTouch ? function (e) { return _this.onTouch(item); } : null, disabled: this.props.onRowTouch ? false : true }, this.props.onRow(item, index));
    };
    RemoveItemsList.prototype.onTouch = function (item) {
        if (this.props.onRowTouch) {
            this.props.onRowTouch(item);
        }
    };
    return RemoveItemsList;
}(BaseComponent_1.BaseComponent));
exports.RemoveItemsList = RemoveItemsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RemoveItemsList\\RemoveItemsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RemoveItemsList\\RemoveItemsList.tsx"); } } })();

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1201);
var Button_1 = __webpack_require__(47);
var smoothscroll_1 = __webpack_require__(1279);
var ExternalLink_1 = __webpack_require__(26);
var Note_1 = __webpack_require__(20);
var uiTestClasses_1 = __webpack_require__(86);
var Button_2 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var ErrorPanel = (function (_super) {
    __extends(ErrorPanel, _super);
    function ErrorPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            showFullException: false
        });
        return _this;
    }
    ErrorPanel.prototype.componentDidMount = function () {
        if (this.props.scrollToPanel) {
            smoothscroll_1.default.scrollTo(this.panel);
        }
    };
    ErrorPanel.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { ref: function (ref) { return _this.panel = ref; }, className: styles.error, style: {
                display: this.props.fullWidth ? "block" : "inline-block",
                width: this.props.fullWidth ? "100%" : "auto"
            } },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("span", { className: styles.title }, this.props.message),
                React.createElement("div", null, this.props.canClose && React.createElement(Button_1.CloseButton, { size: "1.5rem", onClose: this.props.onErrorClose }))),
            this.props.details && this.props.details.length > 0 &&
                React.createElement("ul", null, this.props.details.map(function (e, index) { return _this.detailFor(e, index); })),
            this.props.helpText && React.createElement(Note_1.default, null, this.props.helpText),
            this.props.helpLink && React.createElement(ExternalLink_1.default, { href: this.props.helpLink }, "More information..."),
            this.props.fullException &&
                React.createElement("div", null,
                    React.createElement(Button_2.ActionButton, { type: Button_2.ActionButtonType.Ternary, label: this.state.showFullException ? "hide full exception" : "show full exception", onClick: function () { return _this.setState({ showFullException: !_this.state.showFullException }); } }),
                    this.state.showFullException &&
                        React.createElement("pre", null,
                            "Octopus v",
                            clientInstance_1.client.version,
                            React.createElement("br", null),
                            React.createElement("br", null),
                            this.props.fullException)));
    };
    ErrorPanel.prototype.detailFor = function (error, index) {
        var detailLinks = this.props.detailLinks;
        var detailLink = detailLinks && detailLinks.length > index && detailLinks[index];
        return React.createElement("li", { key: index, className: uiTestClasses_1.octopusErrorClass },
            error,
            detailLink && React.createElement("div", { className: styles.detailLink },
                React.createElement(ExternalLink_1.default, { href: detailLink }, "More information...")));
    };
    ErrorPanel.defaultProps = {
        fullWidth: true,
        scrollToPanel: true
    };
    return ErrorPanel;
}(React.Component));
exports.default = ErrorPanel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\ErrorPanel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\ErrorPanel.tsx"); } } })();

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// These class names are all used by UI E2E tests to identify certain parts of the page.
// They same values are used in the UI E2E tests project in the "Selectors" class.
// So if you change something here, you will probably need to change it in that file as well, and then update the tests
exports.tagSetClass = "tag-set";
exports.deploymentPartNameClass = "deployment-part-name";
exports.packageRowClass = "package-row";
exports.releaseVersionClass = "release-version";
exports.stepCardClass = "add-step-card";
exports.dialogClass = "octopus-dialog";
exports.busyIndicatorClass = "busy-indicator";
exports.octopusErrorClass = "octopus-error";
exports.formSectionClass = "form-section-container";
exports.formSectionTitleClass = "form-section-title";
exports.formSectionBodyClass = "form-section-body";
exports.overflowMenuClass = "overflow-menu";
exports.navLinksClass = "secondary-navigation";
exports.linkMenuClassName = "links-menu-popover";
exports.tagClass = "tag-set-tag";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\uiTestClasses.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\uiTestClasses.ts"); } } })();

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(84);
var form_1 = __webpack_require__(16);
var ActionButton_1 = __webpack_require__(49);
var styles = __webpack_require__(743);
var cn = __webpack_require__(19);
var VariableLookupText_1 = __webpack_require__(21);
var KeyValueRemoveItemsList = (function (_super) {
    __extends(KeyValueRemoveItemsList, _super);
    function KeyValueRemoveItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return KeyValueRemoveItemsList;
}(RemoveItemsList_1.RemoveItemsList));
var noop = function () { return undefined; };
var KeyValueEditList = (function (_super) {
    __extends(KeyValueEditList, _super);
    function KeyValueEditList(props) {
        var _this = _super.call(this, props) || this;
        _this.adding = false;
        _this.handleRemoveRow = function (item) {
            var data = _this.state.source;
            data.splice(data.indexOf(item), 1);
            _this.invokeOnChange(data);
        };
        _this.handleRowRef = function (idx) { return function (input) {
            if (input && _this.adding && idx === 0) {
                input.focus();
                _this.adding = false;
            }
        }; };
        _this.handleKeyChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].key = val;
            _this.invokeOnChange(data);
        }; };
        _this.handleValueChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].value = val;
            _this.invokeOnChange(data);
        }; };
        _this.invokeOnChange = function (data) {
            _this.props.onChange(data.slice());
        };
        _this.handleAddClick = function () {
            _this.adding = true;
            _this.setState(function (prev) { return (__assign({}, prev, { source: prev.source.concat([{ key: "", value: "" }]) })); });
        };
        _this.renderRow = function (item, idx) {
            var fields = [React.createElement("div", { className: cn(styles.textControl, styles.textControlKey), key: "key" }, _this.props.hideBindOnKey
                    ? React.createElement(form_1.Text, { textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })
                    : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })),
                React.createElement("span", { className: styles.separator, key: "seperator" }, _this.props.separator),
                React.createElement("div", { className: styles.textControl, key: "value" },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: "value", textInputRef: _this.props.reverseLayout ? _this.handleRowRef(idx) : noop, value: item.value, onChange: _this.handleValueChange(idx), label: _this.props.valueLabel, hintText: _this.props.valueHintText }))];
            if (_this.props.reverseLayout) {
                fields = fields.reverse();
            }
            return React.createElement("div", { key: "KVI-" + idx, className: styles.itemContainer }, fields);
        };
        _this.state = {
            source: props.items()
        };
        return _this;
    }
    KeyValueEditList.prototype.render = function () {
        var actionButton = React.createElement(ActionButton_1.default, { key: "Add", label: "Add " + this.props.name, onClick: this.handleAddClick });
        return React.createElement(KeyValueRemoveItemsList, { listActions: [actionButton], data: this.state.source, onRemoveRow: this.handleRemoveRow, onRow: this.renderRow, clearButtonToolTip: "Remove " + this.props.name });
    };
    return KeyValueEditList;
}(React.PureComponent));
exports.KeyValueEditList = KeyValueEditList;
function stringToKeyValues(value) {
    if (value === null || value === undefined) {
        return [];
    }
    try {
        var source_1 = JSON.parse(value || "{}");
        return Object.keys(source_1).reduce(function (arr, key) {
            arr.push({ key: key, value: source_1[key] });
            return arr;
        }, []);
    }
    catch (e) {
        return [];
    }
}
function keyValuesToHash(values) {
    return values.reduce(function (idx, item) {
        idx[item.key] = item.value;
        return idx;
    }, {});
}
var StringKeyValueEditList = function (_a) {
    var items = _a.items, onChange = _a.onChange, rest = __rest(_a, ["items", "onChange"]);
    return (React.createElement(KeyValueEditList, __assign({ items: function () { return stringToKeyValues(items); }, onChange: function (values) { return onChange(JSON.stringify(keyValuesToHash(values))); } }, rest)));
};
exports.default = StringKeyValueEditList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\KeyValueEditList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\KeyValueEditList.tsx"); } } })();

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var permission_1 = __webpack_require__(51);
var PermissionCheck_1 = __webpack_require__(42);
var clientInstance_1 = __webpack_require__(10);
function getFeedName(id) {
    return __awaiter(this, void 0, void 0, function () {
        var feedName, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.FeedView })) return [3 /*break*/, 2];
                    return [4 /*yield*/, clientInstance_1.repository.Feeds.get(id)];
                case 1:
                    _a = (_b.sent()).Name;
                    return [3 /*break*/, 3];
                case 2:
                    _a = "(Feed unknown: " + permission_1.Permission.FeedView + " permission required)";
                    _b.label = 3;
                case 3:
                    feedName = _a;
                    return [2 /*return*/, feedName];
            }
        });
    });
}
exports.getFeedName = getFeedName;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\getFeedName.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\getFeedName.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ValueInPropertiesOrErrorsHasChanged(keysObject, newProps, props) {
    return newProps.errors !== props.errors || Object.keys(keysObject).some(function (p) { return newProps.properties[p] !== props.properties[p]; });
}
exports.ValueInPropertiesOrErrorsHasChanged = ValueInPropertiesOrErrorsHasChanged;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ShouldUpdate\\ValueInPropertiesHasChanged.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ShouldUpdate\\ValueInPropertiesHasChanged.ts"); } } })();

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataBaseComponent_1 = __webpack_require__(39);
exports.DataBaseComponent = DataBaseComponent_1.DataBaseComponent;
exports.DataBaseComponentState = DataBaseComponent_1.DataBaseComponentState;
exports.Errors = DataBaseComponent_1.Errors;
exports.default = DataBaseComponent_1.DataBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataBaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataBaseComponent\\index.ts"); } } })();

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(26);
exports.default = ExternalLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\ExternalLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\ExternalLink\\index.tsx"); } } })();

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Fragment = function (props) { return props.children; };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Fragment.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Fragment.tsx"); } } })();

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var Text_1 = __webpack_require__(50);
var IconButton_1 = __webpack_require__(52);
var IconButtonList_1 = __webpack_require__(124);
var InputWithActions_1 = __webpack_require__(163);
var BoundField_1 = __webpack_require__(100);
exports.ObfuscatedPlaceholder = "******";
function createInitialSensitiveState(originalValue) {
    var value = originalValue || {
        HasValue: false,
    };
    return {
        valueBeforeEditing: null,
        isEditing: !value.HasValue,
        isHidden: true,
        originalValue: lodash_1.cloneDeep(value)
    };
}
exports.createInitialSensitiveState = createInitialSensitiveState;
var StatefulSensitive = (function (_super) {
    __extends(StatefulSensitive, _super);
    function StatefulSensitive(props) {
        var _this = _super.call(this, props) || this;
        _this.state = createInitialSensitiveState(props.value);
        return _this;
    }
    StatefulSensitive.prototype.render = function () {
        var _this = this;
        return React.createElement(StatelessSensitive, __assign({ onStateChanged: function (state) { return _this.setState(state); } }, this.props, this.state));
    };
    return StatefulSensitive;
}(React.Component));
var StatelessSensitive = (function (_super) {
    __extends(StatelessSensitive, _super);
    function StatelessSensitive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textField = null;
        _this.handleChange = function (value) {
            _this.props.onChange({
                HasValue: true,
                NewValue: value,
            });
        };
        _this.currentValue = function () {
            return _this.props.value || {
                HasValue: false,
            };
        };
        _this.enterEditMode = function () {
            var valueBeforeEditing = lodash_1.cloneDeep(_this.currentValue());
            _this.onStateChanged({ isEditing: true, valueBeforeEditing: valueBeforeEditing });
            _this.props.onChange({
                HasValue: valueBeforeEditing.HasValue,
                NewValue: ""
            });
        };
        _this.handleRemove = function (e) {
            var originalValue = {
                HasValue: false,
                NewValue: null
            };
            _this.onStateChanged({ isEditing: false, originalValue: originalValue });
            _this.props.onChange(originalValue);
        };
        _this.handleCancel = function (e) {
            _this.onStateChanged({ isEditing: false });
            _this.props.onChange(_this.props.valueBeforeEditing);
        };
        _this.toggleVisibility = function () {
            _this.onStateChanged({ isHidden: !_this.props.isHidden });
        };
        return _this;
    }
    StatelessSensitive.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isEditing && !prevProps.isEditing) {
            this.textField.focus();
        }
    };
    StatelessSensitive.prototype.select = function () {
        if (this.props.isEditing) {
            if (this.textField && !this.textField.isFocused()) {
                this.textField.select();
            }
        }
        else {
            if (this.changeButton) {
                this.changeButton.button.button.focus();
            }
        }
    };
    StatelessSensitive.prototype.render = function () {
        var _this = this;
        var currentValue = this.currentValue();
        var _a = this.props, onChange = _a.onChange, value = _a.value, valueBeforeEditing = _a.valueBeforeEditing, removeTabIndex = _a.removeTabIndex, changeSetTabIndex = _a.changeSetTabIndex, showHideTabIndex = _a.showHideTabIndex, cancelTabIndex = _a.cancelTabIndex, canRemove = _a.canRemove, originalValue = _a.originalValue, isEditing = _a.isEditing, isHidden = _a.isHidden, hintText = _a.hintText, onStateChanged = _a.onStateChanged, applyMaxWidth = _a.applyMaxWidth, otherProps = __rest(_a, ["onChange", "value", "valueBeforeEditing", "removeTabIndex", "changeSetTabIndex", "showHideTabIndex", "cancelTabIndex", "canRemove", "originalValue", "isEditing", "isHidden", "hintText", "onStateChanged", "applyMaxWidth"]);
        // isEditing is used when you don't originally have a value, otherwise its value is meaningless
        // The reason we don't use this all the time is because we don't necessarily want the field to focus
        // when isEditingDerived becomes true, for example, after you have deleted the value
        var isEditingDerived = isEditing || !originalValue.HasValue;
        var hintTextDerived = currentValue.HasValue && !isEditingDerived ? exports.ObfuscatedPlaceholder : hintText ? hintText : "";
        var newValue = currentValue.NewValue ? currentValue.NewValue : "";
        var displayValue = newValue;
        var inputStyle = applyMaxWidth ? { maxWidth: "26.5rem" } : {};
        return (React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, __assign({ disabled: !isEditingDerived, type: isHidden ? "password" : "text", hintText: hintTextDerived, value: displayValue, onChange: this.handleChange, applyMaxWidth: applyMaxWidth, underlineShow: this.props.underlineShow, textInputRef: function (textField) { return _this.textField = textField; } }, otherProps)), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons(isEditingDerived, currentValue) }), applyMaxWidth: applyMaxWidth }));
    };
    StatelessSensitive.prototype.onStateChanged = function (newState) {
        var previousState = {
            valueBeforeEditing: this.props.valueBeforeEditing,
            originalValue: this.props.originalValue,
            isEditing: this.props.isEditing,
            isHidden: this.props.isHidden
        };
        this.props.onStateChanged(__assign({}, previousState, newState));
    };
    StatelessSensitive.prototype.buttons = function (isEditing, currentValue) {
        var _this = this;
        var buttons = new Array();
        buttons.push(isEditing && currentValue.NewValue &&
            React.createElement(IconButton_1.default, { toolTipContent: this.props.isHidden ? "Show" : "Hide", icon: this.props.isHidden ? IconButton_1.Icon.Show : IconButton_1.Icon.Hide, tabIndex: this.props.showHideTabIndex, onClick: this.toggleVisibility }));
        buttons.push(!isEditing && this.props.originalValue.HasValue &&
            React.createElement(IconButton_1.default, { toolTipContent: currentValue.HasValue ? "Change" : "Set", buttonRef: function (changeButton) { return _this.changeButton = changeButton; }, onClick: this.enterEditMode, tabIndex: this.props.changeSetTabIndex, icon: IconButton_1.Icon.Edit }));
        buttons.push(!isEditing && currentValue.HasValue && this.props.canRemove &&
            React.createElement(IconButton_1.default, { toolTipContent: "Remove", onClick: this.handleRemove, tabIndex: this.props.removeTabIndex, icon: IconButton_1.Icon.Remove }));
        buttons.push(isEditing && this.props.originalValue.HasValue &&
            React.createElement(IconButton_1.default, { toolTipContent: "Cancel", onClick: this.handleCancel, tabIndex: this.props.cancelTabIndex, icon: IconButton_1.Icon.Cancel }));
        return buttons.filter(function (b) { return !!b; });
    };
    StatelessSensitive.defaultProps = {
        autoFocus: false,
        canRemove: true,
        applyMaxWidth: false,
    };
    return StatelessSensitive;
}(React.Component));
exports.StatelessSensitive = StatelessSensitive;
var Sensitive = StatefulSensitive;
exports.default = Sensitive;
exports.BoundSensitive = BoundField_1.withBoundField(StatefulSensitive);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sensitive\\Sensitive.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sensitive\\Sensitive.tsx"); } } })();

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var ErrorBoundary_1 = __webpack_require__(1200);
var ReloadableRoute = (function (_super) {
    __extends(ReloadableRoute, _super);
    function ReloadableRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accumulate = function (acc, paramName, params) {
            return acc ? acc + "/" + params[paramName] : params[paramName];
        };
        return _this;
    }
    ReloadableRoute.prototype.render = function () {
        // We are tagging the parent route of each component with a key made out of params it depends on so redirects to the same component with different
        // params unmount it and mount it again.
        // This can also be done by responding to changes in props but this is a lot of work to do it correctly and it is very easy to forget about it.
        // Details: https://github.com/ReactTraining/react-router/issues/1982
        var key = this.getComponentKey(this.props.computedMatch);
        return React.createElement(ErrorBoundary_1.default, null,
            React.createElement(react_router_dom_1.Route, __assign({}, this.props, { key: key })));
    };
    ReloadableRoute.prototype.getComponentKey = function (match) {
        var _this = this;
        var params = match && match.params;
        return params ? Object.keys(params).reduce(function (acc, paramName) { return _this.accumulate(acc, paramName, params); }, null) : null;
    };
    return ReloadableRoute;
}(React.Component));
exports.default = ReloadableRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ReloadableRoute\\ReloadableRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ReloadableRoute\\ReloadableRoute.tsx"); } } })();

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LinearProgress_1 = __webpack_require__(472);
var CircularProgress_1 = __webpack_require__(589);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(1269);
var uiTestClasses_1 = __webpack_require__(86);
var BusyIndicator = function (props) {
    if (props.inline) {
        return props.show &&
            React.createElement("span", { className: uiTestClasses_1.busyIndicatorClass + " " + styles.circularBusyIndicator },
                React.createElement(CircularProgress_1.default, { mode: "indeterminate", color: colors_1.primaryLight, size: 22, thickness: 2 }));
    }
    else {
        return props.show
            ? React.createElement("div", { className: uiTestClasses_1.busyIndicatorClass + " " + styles.busyIndicator },
                React.createElement(LinearProgress_1.default, { mode: "indeterminate", color: colors_1.primaryLight }))
            : React.createElement("div", { className: styles.busyIndicatorHiddenSpacer });
    }
};
BusyIndicator.displayName = "BusyIndicator";
exports.default = BusyIndicator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyIndicator\\BusyIndicator.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyIndicator\\BusyIndicator.tsx"); } } })();

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1507);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(54);
var Text_1 = __webpack_require__(50);
var VariableLookupText_1 = __webpack_require__(21);
var IconButton_1 = __webpack_require__(52);
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var styles = __webpack_require__(1554);
var bindIcon = __webpack_require__(1556);
var unbindIcon = __webpack_require__(1557);
// This is a placeholder until we can implement BoundField to match the new designs
exports.withBoundField = function (Comp) {
    return _a = (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                // I really want to type the index signature below, but Typescript has broken support for enums in indexers.
                // I could use [index in ControlType] but that means all enum values need to be present, not just a subset.
                _this.parameterUnboundValueRanges = {
                    Checkbox: function (param, value) {
                        if (!value) {
                            return false;
                        }
                        var lower = value.toLowerCase();
                        return lower === "true" || lower === "false";
                    },
                    Select: function (param, value) {
                        var selectOptions = param["Octopus.SelectOptions"];
                        var allOptions = selectOptions ? param["Octopus.SelectOptions"].split("\n") : [];
                        return allOptions.map(function (option) { return option.split("|")[0]; }).indexOf(value) >= 0;
                    },
                    Sensitive: function (param, value) {
                        return typeof value === "undefined" || typeof value === "object";
                    }
                };
                _this.bindUnbind = function () {
                    // this is debounced as we are getting two clicks when hitting enter to
                    // activate the button and can't get to the bottom of it
                    if (_this.getIsBound()) {
                        _this.unbind();
                    }
                    else {
                        _this.bind();
                    }
                };
                _this.bind = function () {
                    var value = _this.props.value || "";
                    if (typeof (value) !== "string") {
                        _this.props.onChange("");
                    }
                    _this.setState({ isBound: true });
                    if (_this.props.onIsBoundChanged) {
                        _this.props.onIsBoundChanged(true);
                    }
                };
                _this.unbind = function () {
                    _this.setState({ isBound: false });
                    if (_this.props.onIsBoundChanged) {
                        _this.props.onIsBoundChanged(false);
                    }
                    var resetValue = _this.props.resetValue;
                    var valueResource = (typeof resetValue === "function") ? resetValue() : resetValue;
                    _this.props.onChange(valueResource);
                };
                _this.bindUnbind = lodash_1.debounce(_this.bindUnbind, 500);
                var shouldBind = _this.shouldBind(props.value, props.parameter);
                _this.state = { isBound: shouldBind };
                if (shouldBind && _this.props.onIsBoundChanged) {
                    _this.props.onIsBoundChanged(true);
                }
                return _this;
            }
            class_1.prototype.render = function () {
                var component = this.getIsBound()
                    ? this.props.variableLookup
                        ? React.createElement(VariableLookupText_1.VariableLookupText, { syntax: this.props.variableLookup.syntax, projectId: this.props.variableLookup.projectId, localNames: this.props.variableLookup.localNames, label: this.props.label, value: this.props.value, onChange: this.props.onChange, multiLine: true, rows: this.props.boundRows || 5, rowsMax: this.props.boundRows || 5 })
                        : React.createElement(Text_1.default, { label: this.props.label, value: this.props.value, onChange: this.props.onChange, multiLine: true, rows: this.props.boundRows || 5, rowsMax: this.props.boundRows || 5 })
                    : React.createElement(Comp, __assign({}, this.getWrappedComponentProps()));
                return React.createElement("div", { className: styles.container },
                    component,
                    React.createElement("div", { className: styles.buttons }, this.binding()));
            };
            class_1.prototype.getWrappedComponentProps = function () {
                var _a = this.props, resetValue = _a.resetValue, parameter = _a.parameter, hideBindButton = _a.hideBindButton, desIsBound = _a.isBound, onIsBoundChanged = _a.onIsBoundChanged, variableLookup = _a.variableLookup, otherProps = __rest(_a, ["resetValue", "parameter", "hideBindButton", "isBound", "onIsBoundChanged", "variableLookup"]); // `as any` because object rest not support in generics yet, tracked by https://github.com/Microsoft/TypeScript/issues/10727
                return otherProps;
            };
            class_1.prototype.getIsBound = function () {
                return this.props.isBound || this.state.isBound;
            };
            class_1.prototype.binding = function () {
                if (this.props.hideBindButton) {
                    return null;
                }
                var text = this.getIsBound()
                    ? "Unbind"
                    : "Bind";
                var icon = this.getIsBound()
                    ? unbindIcon
                    : bindIcon;
                return React.createElement(IconButton_1.default, { onClick: this.bindUnbind, toolTipContent: text, icon: icon });
            };
            // TODO: This needs the <Clear/> unbind icon set up properly so it switches from code icon to clear icon.
            // The clear icons is used on fields to remove or reset so this felt consistent.
            class_1.prototype.shouldBind = function (value, parameter) {
                if (value && typeof (value) === "string") {
                    if (isBound_1.default(value)) {
                        return true;
                    }
                    if (parameter) {
                        var displaySettings = parameter.DisplaySettings;
                        var controlType = displaySettings["Octopus.ControlType"];
                        var isInRange = this.parameterUnboundValueRanges[controlType];
                        if (isInRange) {
                            if (!isInRange(displaySettings, value)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            };
            class_1.prototype.boundText = function () {
                if (this.getIsBound()) {
                    return "Remove custom bindings from this field";
                }
                return "Apply custom bindings to this field";
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = {
            hideBindButton: false
        },
        _a;
    var _a;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\BoundField\\BoundField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\BoundField\\BoundField.tsx"); } } })();

/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Logger = (function () {
    function Logger() {
    }
    Logger.consoleWrapper = function (name) {
        if (window && window.console && window.console[name]) {
            var console_1 = window.console;
            if (console_1[name].apply) {
                /* tslint:disable */ return function () {
                    console_1[name].apply(console_1, arguments);
                };
            }
            else {
                /* tslint:disable */ return function () {
                    var message = Array.prototype.join.call(arguments, ', ');
                    console_1[name](message);
                };
            }
        }
        else {
            return function () { };
        }
    };
    Logger.log = Logger.consoleWrapper('log');
    Logger.info = Logger.consoleWrapper('info');
    Logger.warn = Logger.consoleWrapper('warn');
    Logger.error = Logger.consoleWrapper('error');
    return Logger;
}());
;
exports.default = Logger;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\logger.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\logger.ts"); } } })();

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LookupReferenceDataItemChip_1 = __webpack_require__(814);
exports.default = LookupReferenceDataItemChip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupReferenceDataItemChip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupReferenceDataItemChip\\index.tsx"); } } })();

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(11);
var JsonUtils = (function () {
    function JsonUtils() {
    }
    /**
     * Try to parse the text as JSON
     * @param {string} template The text to parse
     * @returns {boolean} true if the text could be parsed as JSON, and false otherwise
     */
    JsonUtils.tryParseJson = function (template) {
        try {
            JSON.parse(template);
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Try to parse the text as JSON
     * @param template The text to parse
     * @param defaultValue The value to return if parsing fails
     * @returns the parsed result, or the default value if parsing failed
     */
    JsonUtils.tryParse = function (json, defaultValue) {
        try {
            return JSON.parse(json);
        }
        catch (e) {
            return defaultValue;
        }
    };
    /**
     * Try to parse the text as JSON array
     * @param template The text to parse
     * @param defaultValue The value to return if parsing fails
     * @returns the parsed result, or the default value if parsing failed
     */
    JsonUtils.tryParseArray = function (json, defaultValue) {
        try {
            var array = JSON.parse(json);
            if (_.isArray(array)) {
                return array;
            }
            return defaultValue;
        }
        catch (e) {
            return defaultValue;
        }
    };
    return JsonUtils;
}());
exports.JsonUtils = JsonUtils;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\jsonUtils.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\jsonUtils.ts"); } } })();

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var scriptingLanguage_1 = __webpack_require__(157);
var InputLabel_1 = __webpack_require__(287);
var IconButton_1 = __webpack_require__(52);
var styles = __webpack_require__(1912);
var VariableLookup_1 = __webpack_require__(288);
var Fragment_1 = __webpack_require__(92);
var CodeMirror = __webpack_require__(845);
var codeMirror = __webpack_require__(1917);
__webpack_require__(1921);
__webpack_require__(732);
__webpack_require__(1922);
__webpack_require__(1923);
__webpack_require__(1924);
__webpack_require__(424);
__webpack_require__(1925);
__webpack_require__(733);
__webpack_require__(1926);
__webpack_require__(1927);
__webpack_require__(1928);
__webpack_require__(1930);
__webpack_require__(1932);
__webpack_require__(56);
__webpack_require__(1933);
var noop = function () { return; };
var Language;
(function (Language) {
    Language["HTML"] = "HTML";
    Language["CSS"] = "CSS";
    Language["Markdown"] = "Markdown";
    Language["DockerFile"] = "DockerFile";
    Language["INI"] = "INI";
    Language["CoffeeScript"] = "CoffeeScript";
})(Language = exports.Language || (exports.Language = {}));
var TextFormat;
(function (TextFormat) {
    TextFormat["JSON"] = "JSON";
    TextFormat["PlainText"] = "PlainText";
    TextFormat["XML"] = "XML";
    TextFormat["YAML"] = "YAML";
})(TextFormat = exports.TextFormat || (exports.TextFormat = {}));
var CodeEditor = (function (_super) {
    __extends(CodeEditor, _super);
    function CodeEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.cursorPosition = null;
        _this.onFocusChange = function (focused) {
            if (!focused) {
                _this.cursorPosition = _this.codeMirrorInstance.getCodeMirror().getCursor();
            }
        };
        _this.handleChange = function (value) {
            _this.props.onChange(value);
        };
        _this.toggleFullScreen = function () {
            var current = _this.codeMirrorInstance.getCodeMirror().getOption("fullScreen");
            var containerClassName = current ? styles.codeEditorContainer : styles.codeEditorContainerFullScreen;
            _this.setState({ containerClassName: containerClassName, isInFullScreen: !current });
            _this.codeMirrorInstance.getCodeMirror().setOption("fullScreen", !current);
        };
        _this.state = {
            containerClassName: styles.codeEditorContainer,
            isInFullScreen: false
        };
        return _this;
    }
    CodeEditor.prototype.componentDidMount = function () {
        var _this = this;
        requestAnimationFrame(function () {
            //Code mirror has some issues with refreshing things, so queue things to focus and refresh as soon as we are done mounting
            //this fixes issues where the editor isn't rendered, focused or line numbers don't align.
            if (_this.props.autoFocus) {
                _this.focus();
            }
            _this.codeMirrorInstance ? _this.codeMirrorInstance.getCodeMirror().refresh() : noop();
        });
    };
    CodeEditor.prototype.componentWillMount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(this);
        }
    };
    CodeEditor.prototype.componentWillUnmount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(null);
        }
        if (this.state.isInFullScreen) {
            this.toggleFullScreen();
        }
    };
    CodeEditor.prototype.render = function () {
        var _this = this;
        var options = {
            mode: this.toMode(this.props.language),
            lineNumbers: true,
            extraKeys: {},
            readOnly: this.props.readOnly ? "nocursor" : false
        };
        var val = this.props.value ? this.props.value : "";
        if (this.props.allowFullScreen) {
            options.extraKeys = {
                Esc: function (cm) {
                    if (cm.getOption("fullScreen")) {
                        _this.toggleFullScreen();
                    }
                }
            };
        }
        // This one override the full screen rule as user wants to handle it explicitly
        if (this.props.onEscPressed) {
            options.extraKeys = {
                Esc: function () {
                    _this.props.onEscPressed();
                },
            };
        }
        return (React.createElement(Fragment_1.Fragment, null,
            this.props.label && React.createElement(InputLabel_1.default, { label: this.props.label }),
            React.createElement("div", { className: this.state.containerClassName },
                this.props.allowFullScreen && this.fullScreenToggle(),
                React.createElement(CodeMirror, { ref: function (ref) { return _this.codeMirrorInstance = ref; }, preserveScrollPosition: true, value: val, onFocusChange: this.onFocusChange, onChange: this.handleChange, options: options }))));
    };
    CodeEditor.prototype.focus = function () {
        if (this.codeMirrorInstance) {
            this.codeMirrorInstance.focus();
            if (this.cursorPosition) {
                this.codeMirrorInstance.getCodeMirror().setCursor(this.cursorPosition);
            }
        }
    };
    CodeEditor.prototype.blur = function () {
        if (this.codeMirrorInstance) {
            this.codeMirrorInstance.getCodeMirror().getInputField().blur();
        }
    };
    CodeEditor.prototype.insertAtCursor = function (value) {
        this.codeMirrorInstance.getCodeMirror().replaceSelection(value, "end");
        this.cursorPosition = this.codeMirrorInstance.getCodeMirror().getCursor();
    };
    CodeEditor.prototype.toMode = function (language) {
        switch (language) {
            case scriptingLanguage_1.ScriptingLanguage.Bash: return "shell";
            case scriptingLanguage_1.ScriptingLanguage.CSharp: return "text/x-csharp";
            case scriptingLanguage_1.ScriptingLanguage.FSharp: return "text/x-fsharp";
            case TextFormat.JSON: return "application/json";
            case TextFormat.PlainText: return "null";
            case scriptingLanguage_1.ScriptingLanguage.PowerShell: return "powershell";
            case TextFormat.XML: return "text/html";
            case TextFormat.YAML: return "text/x-yaml";
            case Language.CoffeeScript: return "application/vnd.coffeescript";
            case Language.CSS: return "text/css";
            case Language.DockerFile: return "text/x-dockerfile";
            case Language.HTML: return "text/html";
            case Language.INI: return "text/x-ini";
            case Language.Markdown: return "text/x-markdown";
            default: return "null";
        }
    };
    CodeEditor.prototype.fullScreenToggle = function () {
        var isInFullScreen = this.state.isInFullScreen;
        return React.createElement("div", { className: isInFullScreen ? styles.exitFullScreen : styles.enterFullScreen },
            React.createElement("div", null,
                React.createElement(IconButton_1.default, { toolTipContent: (isInFullScreen ? "Exit" : "Enter") + " full screen", onClick: this.toggleFullScreen, icon: isInFullScreen ? IconButton_1.Icon.ExitFullScreen : IconButton_1.Icon.EnterFullScreen })));
    };
    CodeEditor.defaultProps = {
        readOnly: false
    };
    return CodeEditor;
}(React.Component));
exports.default = CodeEditor;
var CodeEditorWithInputRef = function (props) { return React.createElement(CodeEditor, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupCodeEditor = VariableLookup_1.withVariableLookup()(CodeEditorWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CodeEditor\\CodeEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CodeEditor\\CodeEditor.tsx"); } } })();

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(133);
var dialogIdGenerator_1 = __webpack_require__(293);
var OpenDialogConnect_1 = __webpack_require__(411);
var DialogOpenerInternal = (function (_super) {
    __extends(DialogOpenerInternal, _super);
    function DialogOpenerInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    DialogOpenerInternal.prototype.componentDidMount = function () {
        if (!this.props.openDialogs[this.uniqueId] && this.props.open) {
            this.props.openDialog(this.uniqueId);
        }
    };
    DialogOpenerInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.openDialogs[this.uniqueId] && !nextProps.openDialogs[this.uniqueId] && !this.props.open && nextProps.open) {
            this.props.openDialog(this.uniqueId);
        }
        if (this.props.openDialogs[this.uniqueId] && !nextProps.openDialogs[this.uniqueId] && this.props.onClose) {
            this.props.onClose();
        }
    };
    DialogOpenerInternal.prototype.render = function () {
        return React.createElement(Dialog_1.default, { open: this.props.openDialogs[this.uniqueId], wide: this.props.wideDialog, repositionOnUpdate: this.props.repositionOnUpdate }, this.props.children);
    };
    return DialogOpenerInternal;
}(React.Component));
exports.DialogOpenerInternal = DialogOpenerInternal;
var DialogOpener = OpenDialogConnect_1.OpenDialogConnect.to(DialogOpenerInternal, true);
exports.default = DialogOpener;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogOpener.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogOpener.tsx"); } } })();

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ToolTip_1 = __webpack_require__(74);
var Markdown_1 = __webpack_require__(132);
var DebounceValue_1 = __webpack_require__(1747);
var IconButton_1 = __webpack_require__(1748);
var Popover_1 = __webpack_require__(246);
var IconButton_2 = __webpack_require__(52);
var Text_1 = __webpack_require__(50);
var VirtualListWithKeyboard_1 = __webpack_require__(407);
var styles = __webpack_require__(1749);
var LabelStrategy_1 = __webpack_require__(167);
var DebounceText = DebounceValue_1.default(Text_1.default);
function MultiSelect() {
    var VirtualList = VirtualListWithKeyboard_1.default();
    var MultiSelectInternal = (function (_super) {
        __extends(MultiSelectInternal, _super);
        function MultiSelectInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.skipOpenningOnNextFocus = false;
            _this.onTextBlur = function () {
                // We using a timout here to stop the flickering, see https://medium.com/@jessebeach/dealing-with-focus-and-blur-in-a-composite-widget-in-react-90d3c3b49a9b
                _this.timeoutId = setTimeout(function () {
                    if (_this.state.isFocused) {
                        _this.setState({
                            isFocused: false
                        });
                    }
                }, 0);
            };
            _this.onTextFocus = function () {
                clearTimeout(_this.timeoutId);
                if (!_this.state.isFocused) {
                    _this.setState({ isFocused: true });
                }
                if (!_this.skipOpenningOnNextFocus) {
                    _this.setState({
                        open: _this.props.openOnFocus !== undefined ? _this.props.openOnFocus : false
                    });
                }
                _this.skipOpenningOnNextFocus = false;
            };
            _this.focusText = function (skipOpenningOnNextFocus) {
                _this.skipOpenningOnNextFocus = skipOpenningOnNextFocus;
                if (_this.textField) {
                    _this.textField.focus();
                }
            };
            _this.onTextKeyDown = function (event, filteredList) {
                if (event.key === "ArrowDown") {
                    _this.setState({
                        open: true
                    });
                    if (_this.state.open) {
                        _this.virtualList.focus();
                    }
                    event.preventDefault();
                }
                if (event.key === "Tab") {
                    _this.onRequestClose();
                }
                // To stop ppl accidentally triggering deployments when using multi-selects in deployment screens!
                if (event.key === "Enter") {
                    event.preventDefault();
                    _this.executeOnNewHandlerOnEnter();
                }
            };
            _this.onKeyEsc = function (event) {
                if (event.key === "Escape") {
                    _this.onRequestClose(function () { return _this.focusText(true); });
                }
            };
            _this.onSearchTextChange = function (val) {
                _this.setState({
                    open: true,
                    filter: val
                });
            };
            _this.onToggle = function () {
                _this.setState(function (prevState) { return ({
                    open: !prevState.open
                }); });
            };
            _this.onRequestClose = function (callback) {
                _this.setState({
                    filter: "",
                    open: false
                }, callback);
            };
            _this.renderChip = function (id, index) {
                var item = _this.props.items && _this.props.items.find(function (i) { return i.Id === id; });
                var element = _this.props.renderChip(item || { Id: id, Name: id }, function (event) {
                    _this.props.onChange(_this.props.value && _this.props.value.filter(function (i) { return i !== id; }));
                });
                if (!React.isValidElement(element)) {
                    return null;
                }
                return React.createElement("span", { key: id }, element);
            };
            _this.state = {
                filter: "",
                open: false,
                isFocused: false,
            };
            return _this;
        }
        MultiSelectInternal.prototype.focus = function () {
            this.focusText();
        };
        MultiSelectInternal.prototype.componentDidMount = function () {
            this.props.multiSelectRef(this);
        };
        MultiSelectInternal.prototype.componentWillUnmount = function () {
            this.props.multiSelectRef(null);
        };
        MultiSelectInternal.prototype.componentWillMount = function () {
            var uniqueId = "MultiSelect-" + Math.floor(Math.random() * 0xFFFF);
            this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, "");
        };
        MultiSelectInternal.prototype.render = function () {
            var _this = this;
            var errorTextElement = this.props.error && (React.createElement("div", { className: styles.error }, this.props.error));
            // TODO: Replace with better null checking solution, discuss with team how to handle this situation.
            var value = this.props.value ? this.props.value : [];
            var items = this.props.items ? this.props.items : [];
            var hasInput = value.length > 0 || this.state.filter.length > 0;
            var showFloatingLabel = hasInput || this.state.isFocused;
            var floatingLabelTextElement = this.props.label && !(!!this.props.hideFloatingLabel) && (React.createElement("label", { className: styles.label, style: !showFloatingLabel ? { visibility: "hidden" } : {}, htmlFor: this.uniqueId },
                this.props.description && React.createElement(ToolTip_1.default, { content: React.createElement(Markdown_1.default, { markup: this.props.description }) }, this.props.label),
                !this.props.description && this.props.label));
            var filteredList = this.filteredList(items, value, this.state.filter);
            var newItem = null;
            if (this.state.filter.length > 0 && this.props.onNew) {
                // TODO: The case insensitive comparison here is specific to roles
                // (which is the only use of `newItem` at the moment) and probably shouldn't be hard-coded here.
                // Either toggle this behavior from a prop, or extract it from this component entirely
                var val_1 = this.state.filter.toLowerCase();
                if (items.find(function (i) { return i.Name.toLowerCase() === val_1; }) === undefined &&
                    !value.find(function (i) { return i && (i.toLowerCase() === val_1); })) {
                    newItem = { Id: "", Name: this.state.filter };
                }
            }
            if (newItem) {
                filteredList.unshift(newItem);
            }
            return React.createElement("div", null,
                floatingLabelTextElement,
                React.createElement("div", null, value.map(this.renderChip)),
                React.createElement("div", { ref: function (el) { return _this.textAnchor = el; }, className: styles.textContainer },
                    React.createElement(DebounceText, { id: this.uniqueId, textInputRef: function (textField) { return _this.textField = textField; }, hintText: this.props.label, value: this.state.filter, autoFocus: this.props.autoFocus, onKeyDown: function (e) { return _this.onTextKeyDown(e, filteredList); }, onChange: this.onSearchTextChange, onFocus: this.onTextFocus, onBlur: this.onTextBlur, onClick: function () { return _this.setState({ open: true }); }, autoComplete: "off", debounceDelay: 100 }),
                    React.createElement("div", { className: styles.iconContainer },
                        React.createElement(IconButton_1.default, { icon: IconButton_2.Icon.ArrowDown, onClick: this.onToggle, tabIndex: -1 }))),
                errorTextElement,
                React.createElement(Popover_1.default, { open: this.state.open, useLayerForClickAway: true, anchorEl: this.textAnchor, onRequestClose: function () { return _this.onRequestClose(); }, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" } },
                    React.createElement("div", { style: { minWidth: this.textAnchor ? this.textAnchor.offsetWidth + "px" : undefined }, onKeyDown: this.onKeyEsc },
                        React.createElement(VirtualList, { multiSelectRef: function (el) { return _this.virtualList = el; }, items: filteredList, onSelected: function (id) {
                                _this.onRequestClose(function () { return _this.focusText(true); });
                                if (items.find(function (i) { return i.Id === id; })) {
                                    _this.props.onChange(value.concat(id));
                                }
                                else {
                                    _this.props.onNew(newItem.Name);
                                }
                            }, onResized: function () {
                                // When the content's size changes, we re-render so that the
                                // popover can re-position itself based on the new `VirtualList` size
                                _this.forceUpdate();
                            }, renderItem: this.props.renderItem, addNewTemplate: function () { return _this.props.addNewTemplate(newItem.Name); }, onBlur: function () { return _this.textField.focus(); } }))));
        };
        MultiSelectInternal.prototype.executeOnNewHandlerOnEnter = function () {
            // If they've typed a new entry and hit enter...
            if (this.state.filter.length > 0 && this.props.onNew) {
                // TODO: The case insensitive comparison here is specific to roles
                // (which is the only use of `newItem` at the moment) and probably shouldn't be hard-coded here.
                // Either toggle this behavior from a prop, or extract it from this component entirely
                var val_2 = this.state.filter.toLowerCase();
                var items = this.props.items ? this.props.items : [];
                var value = this.props.value ? this.props.value : [];
                var newItem = null;
                if (items.find(function (i) { return i.Name.toLowerCase() === val_2; }) === undefined &&
                    !value.find(function (i) { return i && (i.toLowerCase() === val_2); })) {
                    newItem = { Id: "", Name: this.state.filter };
                }
                if (newItem) {
                    this.props.onNew(newItem.Name);
                    this.setState({
                        open: false,
                        filter: "",
                    });
                }
            }
        };
        MultiSelectInternal.prototype.filteredList = function (items, value, filter) {
            var results = items.slice(); //clone array
            if (filter.length > 0) {
                var search_1 = filter.toLowerCase();
                results = items.filter(function (i) { return i.Name.toLowerCase().includes(search_1); });
            }
            results = results.filter(function (i) { return !value.includes(i.Id); }); // filter out existing selected items
            return results;
        };
        MultiSelectInternal.defaultProps = {
            addNewTemplate: function (text) { return text + " (add new)"; },
            multiSelectRef: function (multiSelect) { },
            renderItem: function (item) { return ({ primaryText: item.Name }); },
            items: [],
            value: [],
        };
        return MultiSelectInternal;
    }(React.Component));
    return LabelStrategy_1.default(MultiSelectInternal, function (fieldName) { return "Select " + fieldName; });
}
exports.default = MultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MultiSelect.tsx"); } } })();

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfigurationRepository = (function () {
    function ConfigurationRepository(configurationLinkName, client) {
        this.configurationLinkName = configurationLinkName;
        this.client = client;
    }
    ConfigurationRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links[this.configurationLinkName]);
    };
    ConfigurationRepository.prototype.modify = function (resource) {
        return this.client.update(resource.Links["Self"], resource);
    };
    return ConfigurationRepository;
}());
exports.default = ConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\configurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\configurationRepository.ts"); } } })();

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1713);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var BaseComponent_1 = __webpack_require__(12);
var Note_1 = __webpack_require__(20);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var ActionDetails_1 = __webpack_require__(25);
var isBound_1 = __webpack_require__(54);
var PackageDownloadOptions = (function (_super) {
    __extends(PackageDownloadOptions, _super);
    function PackageDownloadOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageDownloadOptions.radioButtons = function (locations, defaultLocation) {
        var elements = [];
        if (locations.includes(packageAcquisitionLocation_1.PackageAcquisitionLocation.Server)) {
            elements.push(React.createElement(RadioButton_1.default, { value: packageAcquisitionLocation_1.PackageAcquisitionLocation.Server, label: "Octopus Server will download the package, then securely upload it to the Tentacles", key: packageAcquisitionLocation_1.PackageAcquisitionLocation.Server, isDefault: defaultLocation === packageAcquisitionLocation_1.PackageAcquisitionLocation.Server }));
        }
        if (locations.includes(packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget)) {
            elements.push(React.createElement(RadioButton_1.default, { value: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget, label: "The package will be downloaded directly from the feed on the execution target", key: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget, isDefault: defaultLocation === packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget }));
            elements.push(React.createElement(Note_1.default, { key: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget + "_note" }, "The execution target will be either a Tentacle or SSH deployment target, or a worker in a pool."));
        }
        if (locations.includes(packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired)) {
            elements.push(React.createElement(RadioButton_1.default, { value: packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired, label: "The package will not be acquired", key: packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired, isDefault: defaultLocation === packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired }));
            elements.push(React.createElement(Note_1.default, { key: packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired + "_note" },
                "The package will not be downloaded. Package metadata variables will be still be available (e.g. ",
                React.createElement("em", null, "Octopus.Action.Package.PackageId"),
                ")"));
        }
        return elements;
    };
    PackageDownloadOptions.prototype.componentDidMount = function () {
        this.ensureAppropriateDefaultForFeed(this.props.feed);
    };
    PackageDownloadOptions.prototype.componentWillReceiveProps = function (nextProps) {
        if (!_.isEqual(this.props.feed, nextProps.feed)) {
            this.ensureAppropriateDefaultForFeed(nextProps.feed);
        }
    };
    PackageDownloadOptions.prototype.render = function () {
        var _this = this;
        var feed = this.props.feed; // This may be null (for example if a variable expression is used for the feed)
        // Determine which acquisition location options to display (first will be the default)
        var locations = this.acquisitionLocations(feed);
        // If there are not at least possible acquisition locations, then there is no selectin' to be done
        if (locations.length < 2) {
            return null;
        }
        // The first supported location is considered the default
        var defaultLocation = locations[0];
        return React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                localNames: this.props.localNames,
                projectId: this.props.projectId
            }, value: this.props.packageAcquisitionLocation, resetValue: this.props.packageAcquisitionLocation, onChange: function (val) { return _this.props.onPackageAcquisitionLocationChanged(val); } }, PackageDownloadOptions.radioButtons(locations, defaultLocation));
    };
    // Returns available package-acquisition locations, with the default as the first
    PackageDownloadOptions.prototype.acquisitionLocations = function (feed) {
        var _this = this;
        // If a feed has been selected, we will start with the acquisition locations it supports.
        // Otherwise we have to assume all options are potentially valid
        var locationsSupportedByFeed = !!feed
            ? feed.PackageAcquisitionLocationOptions
            : Object.keys(packageAcquisitionLocation_1.PackageAcquisitionLocation);
        return _.chain(locationsSupportedByFeed)
            .filter(function (location) {
            switch (location) {
                case packageAcquisitionLocation_1.PackageAcquisitionLocation.Server:
                    return true;
                case packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget:
                    // If we know the action will run on the server, then we won't show `ExecutionTarget`
                    return !_this.actionWillRunOnServer();
                case packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired:
                    // The parent component can decide whether ot not to show `NotAcquired`
                    return !!_this.props.showNotAcquiredOption;
            }
        })
            .map(function (location) { return location; })
            .value();
    };
    // Ensure we don't have incompatible feed and acquisition-location selected
    PackageDownloadOptions.prototype.ensureAppropriateDefaultForFeed = function (feed) {
        // If we don't have a feed, then there's nothing we can do.
        if (!feed) {
            return;
        }
        // If they have bound the acquisition-location to a variable-expression, then they're also on their own
        if (isBound_1.default(this.props.packageAcquisitionLocation, false)) {
            return;
        }
        var availableLocations = this.acquisitionLocations(feed).map(function (x) { return x; });
        // If the selected location isn't a valid option, then select the default
        if (availableLocations.length > 0 && !availableLocations.includes(this.props.packageAcquisitionLocation)) {
            this.props.onPackageAcquisitionLocationChanged(_.head(availableLocations));
        }
    };
    PackageDownloadOptions.prototype.actionWillRunOnServer = function () {
        var runOn = this.props.runOn;
        return runOn &&
            (runOn === ActionDetails_1.RunOn.OctopusServer || runOn === ActionDetails_1.RunOn.OctopusServerForRoles);
    };
    return PackageDownloadOptions;
}(BaseComponent_1.BaseComponent));
exports.default = PackageDownloadOptions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PackageDownloadOptions\\PackageDownloadOptions.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PackageDownloadOptions\\PackageDownloadOptions.tsx"); } } })();

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(275);
var check_box_1 = __webpack_require__(611);
var check_box_outline_blank_1 = __webpack_require__(610);
var colors_1 = __webpack_require__(31);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1525);
var InputLabel_1 = __webpack_require__(287);
var Note_1 = __webpack_require__(20);
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event, isChecked) {
            if (_this.props.validate) {
                var validateResult = _this.props.validate(isChecked);
                _this.props.onValidate(validateResult);
            }
            _this.props.onChange(isChecked);
        };
        return _this;
    }
    Checkbox.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            // this digs into the Checkbox implementation to set focus
            var internalSwitch = this.checkBoxField.refs.enhancedSwitch;
            internalSwitch.refs.checkbox.focus();
            internalSwitch.tabPressed = true;
            internalSwitch.handleFocus();
        }
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, label = _a.label, className = _a.className, value = _a.value, noMargin = _a.noMargin, onChange = _a.onChange, hintText = _a.hintText, note = _a.note, error = _a.error, warning = _a.warning, otherProps = __rest(_a, ["title", "label", "className", "value", "noMargin", "onChange", "hintText", "note", "error", "warning"]);
        var isMessageProvided = (error && error.length > 0) || (warning && warning.length > 0);
        var message = isMessageProvided && (error || warning);
        var messageColor = isMessageProvided && (message === error ? colors_1.danger : colors_1.alert);
        return (React.createElement("div", { className: cn(className, (_b = {}, _b[styles.topMargin] = !noMargin, _b)) },
            title && React.createElement(InputLabel_1.default, { label: title }),
            React.createElement(Checkbox_1.default, __assign({ ref: function (ref) { return _this.checkBoxField = ref; }, label: label, checked: value, onCheck: this.handleChange, labelStyle: { width: "100%" }, checkedIcon: React.createElement(check_box_1.default, { style: { fill: colors_1.primary } }), uncheckedIcon: React.createElement(check_box_outline_blank_1.default, { style: { fill: colors_1.primaryText } }) }, otherProps)),
            message && React.createElement("div", { style: { color: messageColor }, className: styles.message },
                React.createElement("hr", { style: { borderColor: messageColor } }),
                message),
            React.createElement("div", { className: styles.checkboxNote },
                React.createElement(Note_1.default, { children: note }))));
        var _b;
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Checkbox\\Checkbox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Checkbox\\Checkbox.tsx"); } } })();

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Breadcrumb_1 = __webpack_require__(595);
var PageTitleHelper_1 = __webpack_require__(245);
var InternalNavLink_1 = __webpack_require__(248);
var styles = __webpack_require__(1576);
var AreaTitle = (function (_super) {
    __extends(AreaTitle, _super);
    function AreaTitle(props) {
        var _this = _super.call(this, props) || this;
        PageTitleHelper_1.default.setPageTitle(props.title, props.breadcrumbTitle);
        return _this;
    }
    AreaTitle.prototype.render = function () {
        return React.createElement("div", { className: styles.titleBar },
            React.createElement("div", { className: styles.title },
                React.createElement(Breadcrumb_1.default, { title: this.props.breadcrumbTitle, path: this.props.breadcrumbPath, isAreaLevelBreadcrumb: true }),
                React.createElement("h1", null,
                    React.createElement(InternalNavLink_1.default, { className: styles.pageTitleLink, to: this.props.link }, this.props.title))),
            React.createElement("div", null, this.props.children));
    };
    return AreaTitle;
}(React.Component));
exports.default = AreaTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AreaTitle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AreaTitle\\index.tsx"); } } })();

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var redux_thunk_1 = __webpack_require__(1066);
var reducers_1 = __webpack_require__(1067);
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
var store = redux_1.createStore(reducers_1.reducers, composeEnhancers(redux_1.applyMiddleware(redux_thunk_1.default)));
exports.default = store;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\store.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\store.ts"); } } })();

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1710);
var IconButtonList = function (props) {
    return React.createElement("div", { className: styles.buttonList }, props.buttons.map(function (button, index) { return !button ? null : React.cloneElement(button, __assign({}, button.props, { key: index })); }));
};
IconButtonList.displayName = "IconButtonList";
exports.default = IconButtonList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButtonList\\IconButtonList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButtonList\\IconButtonList.tsx"); } } })();

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pathToRegexp = __webpack_require__(485);
function resolvePathWithSpaceId(to, spaceId) {
    if (typeof to !== "string") {
        return __assign({}, to, { pathname: resolveStringPathWithSpaceId(to.pathname, spaceId) });
    }
    return resolveStringPathWithSpaceId(to, spaceId);
}
exports.resolvePathWithSpaceId = resolvePathWithSpaceId;
var FakeSpaceId = "Spaces-0";
function resolveStringPathWithSpaceId(path, spaceId) {
    // path contains space id parameter so it needs to be resolved even if space id is not provided
    spaceId = spaceId ? spaceId : FakeSpaceId;
    // Switch to generatePath once a new version of router is released : https://github.com/ReactTraining/react-router/issues/6024
    var link = pathToRegexp.compile(path)({ spaceId: spaceId });
    return spaceId === FakeSpaceId ? link.replace(FakeSpaceId, "").replace("//", "/") : link;
}
exports.resolveStringPathWithSpaceId = resolveStringPathWithSpaceId;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\resolvePathWithSpaceId.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\resolvePathWithSpaceId.tsx"); } } })();

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var BusyFromPromise_1 = __webpack_require__(161);
var BusyIndicator_1 = __webpack_require__(95);
var SectionTitle_1 = __webpack_require__(1297);
var ErrorPanel_1 = __webpack_require__(85);
var styles = __webpack_require__(1418);
var Sticky_1 = __webpack_require__(473);
var PageTitleHelper_1 = __webpack_require__(245);
var TransitionAnimation_1 = __webpack_require__(82);
exports.headerId = "paperlayoutstickyheader";
var PaperLayout = (function (_super) {
    __extends(PaperLayout, _super);
    function PaperLayout(props) {
        var _this = _super.call(this, props) || this;
        PageTitleHelper_1.default.setPageTitle(props.title, props.breadcrumbTitle);
        _this.state = {
            stickyState: 0
        };
        return _this;
    }
    PaperLayout.prototype.componentWillReceiveProps = function (nextProps) {
        // For various screen, we update the title dynamically...
        if (this.props.title !== nextProps.title) {
            PageTitleHelper_1.default.setPageTitle(nextProps.title, nextProps.breadcrumbTitle);
        }
    };
    PaperLayout.prototype.renderHeader = function () {
        var _this = this;
        if (this.props.title || this.props.sectionControl) {
            return React.createElement(Sticky_1.default, { top: "#toppanel", innerZ: 10, onStateChange: function (x) { return _this.setState({ stickyState: x.status }); } },
                React.createElement("div", { id: exports.headerId, className: styles.headerContainer },
                    this.renderBusy(),
                    React.createElement(TransitionAnimation_1.default, { disableAnimation: this.props.disableAnimations || this.props.disableHeaderAnimations },
                        React.createElement(SectionTitle_1.default, { title: this.props.title, titleLogo: this.props.titleLogo, breadcrumbTitle: this.props.breadcrumbTitle, breadcrumbPath: this.props.breadcrumbPath, sectionControl: this.props.sectionControl, className: cn(styles.title, (_a = {}, _a[styles.stickied] = this.state.stickyState === Sticky_1.StickyStatus.STATUS_FIXED, _a)), busy: this.props.busy, enableLessIntrusiveLoadingIndicator: this.props.enableLessIntrusiveLoadingIndicator }))));
        }
        return this.renderBusy();
        var _a;
    };
    PaperLayout.prototype.renderBusy = function () {
        var _this = this;
        // Note: Don't show the horizontal loading bar on subsequent auto-reloads (it "blips" too quickly and annoys everybody).
        return React.createElement("div", { className: styles.busyFromPromise },
            React.createElement(BusyFromPromise_1.default, { promise: this.props.busy }, function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy && !_this.props.enableLessIntrusiveLoadingIndicator }); }));
    };
    PaperLayout.prototype.renderErrors = function () {
        var errors = this.props.errors;
        if (!errors) {
            return null;
        }
        return React.createElement(ErrorPanel_1.default, { message: errors.message, details: errors.details, detailLinks: errors.detailLinks, helpText: errors.helpText, fullException: errors.fullException, helpLink: errors.helpLink });
    };
    PaperLayout.prototype.render = function () {
        return React.createElement("div", { className: cn(styles.container, this.props.className) },
            React.createElement("div", { className: cn(this.props.flatStyle ? styles.paperContentFlat : styles.paperContent, this.props.fullWidth && styles.paperFullWidth, this.props.innerClassName) },
                this.renderHeader(),
                React.createElement(TransitionAnimation_1.default, null,
                    this.renderErrors(),
                    this.props.children)));
    };
    return PaperLayout;
}(React.Component));
exports.default = PaperLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PaperLayout\\PaperLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PaperLayout\\PaperLayout.tsx"); } } })();

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Markdown_1 = __webpack_require__(835);
exports.default = Markdown_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Markdown\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Markdown\\index.tsx"); } } })();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(181);
var styles = __webpack_require__(378);
var uiTestClasses_1 = __webpack_require__(86);
var Dialog = function (props) {
    var bodyStyle = {
        padding: "0",
        color: "inherit",
        fontSize: "inherit",
        display: "flex",
        overflow: "hidden"
    };
    var contentStyle = !props.wide ? {
        width: "75%",
        maxWidth: "550px"
    } : null;
    return React.createElement(Dialog_1.default, { className: uiTestClasses_1.dialogClass, open: props.open || false, bodyStyle: bodyStyle, contentStyle: contentStyle, contentClassName: styles.materialDialogContent, autoDetectWindowHeight: true, repositionOnUpdate: props.repositionOnUpdate }, props.open && props.children);
};
Dialog.displayName = "Dialog";
exports.default = Dialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\Dialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\Dialog.tsx"); } } })();

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var styles = __webpack_require__(117);
var FormSectionBase_1 = __webpack_require__(292);
// like Unstructured form section with no margin so warnings fill the panel
var WarningFormSection = (function (_super) {
    __extends(WarningFormSection, _super);
    function WarningFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WarningFormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: styles.formNonExpander, expanded: true }, this.body(styles.cardMediaWarning, false));
    };
    return WarningFormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = WarningFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\WarningFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\WarningFormSection.tsx"); } } })();

/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InputWithActions_1 = __webpack_require__(163);
exports.default = InputWithActions_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\InputWithActions\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\InputWithActions\\index.tsx"); } } })();

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconMenu_1 = __webpack_require__(617);
var IconButton_1 = __webpack_require__(67);
var MenuItem_1 = __webpack_require__(109);
var Divider_1 = __webpack_require__(162);
var more_vert_1 = __webpack_require__(1714);
var OpenDeleteDialogMenuItem_1 = __webpack_require__(705);
var PermissionCheck_1 = __webpack_require__(42);
var lodash_1 = __webpack_require__(11);
var BaseComponent_1 = __webpack_require__(12);
var OpenDialogMenuItem_1 = __webpack_require__(704);
var styles = __webpack_require__(1715);
var uiTestClasses_1 = __webpack_require__(86);
var OverflowMenuLink_1 = __webpack_require__(1717);
var OverflowMenuItemKind;
(function (OverflowMenuItemKind) {
    OverflowMenuItemKind[OverflowMenuItemKind["Delete"] = 0] = "Delete";
    OverflowMenuItemKind[OverflowMenuItemKind["Dialog"] = 1] = "Dialog";
    OverflowMenuItemKind[OverflowMenuItemKind["Generic"] = 2] = "Generic";
    OverflowMenuItemKind[OverflowMenuItemKind["Disabled"] = 3] = "Disabled";
    OverflowMenuItemKind[OverflowMenuItemKind["Navigation"] = 4] = "Navigation";
    OverflowMenuItemKind[OverflowMenuItemKind["Download"] = 5] = "Download";
    OverflowMenuItemKind[OverflowMenuItemKind["Remove"] = 6] = "Remove";
})(OverflowMenuItemKind || (OverflowMenuItemKind = {}));
function isGroup(item) {
    return Array.isArray(item);
}
function isOverflowMenuDialogItem(item) {
    return item.kind === OverflowMenuItemKind.Dialog;
}
function isOverflowMenuDeleteItem(item) {
    return item.kind === OverflowMenuItemKind.Delete;
}
function isOverflowMenuRemoveItem(item) {
    return item.kind === OverflowMenuItemKind.Remove;
}
function isOverflowMenuDownloadItem(item) {
    return item.kind === OverflowMenuItemKind.Download;
}
function isOverflowMenuNavLink(item) {
    return item.kind === OverflowMenuItemKind.Navigation;
}
function isOverflowMenuDisabledItem(item) {
    return item.kind === OverflowMenuItemKind.Disabled;
}
function isOverflowMenuGenericItem(item) {
    return item.kind === OverflowMenuItemKind.Generic;
}
var OverflowMenu = (function (_super) {
    __extends(OverflowMenu, _super);
    function OverflowMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverflowMenu.dialogItem = function (text, child, permission) {
        return { text: text, child: child, kind: OverflowMenuItemKind.Dialog, permission: permission };
    };
    OverflowMenu.removeItem = function (text, title, onClick, content, permission) {
        return { text: text, title: title, onClick: onClick, content: content, permission: permission, kind: OverflowMenuItemKind.Remove };
    };
    OverflowMenu.deleteItem = function (text, title, onClick, content, permission) {
        return { text: text, title: title, onClick: onClick, content: content, permission: permission, kind: OverflowMenuItemKind.Delete };
    };
    OverflowMenu.deleteItemDefault = function (name, onClick, permission, customMessage, customContent) {
        return {
            text: "Delete",
            title: "Are you sure you want to delete this " + name + "?",
            onClick: onClick,
            permission: permission,
            kind: OverflowMenuItemKind.Delete,
            content: React.createElement("div", null,
                React.createElement("p", null,
                    "Deleting this ",
                    name,
                    " is permanent, there is no going back."),
                customMessage && React.createElement("p", null, customMessage),
                customContent,
                React.createElement("p", null, "Do you wish to continue?"))
        };
    };
    OverflowMenu.navItem = function (text, path, queryString, permission) {
        return { text: text, path: path, queryString: queryString, permission: permission, kind: OverflowMenuItemKind.Navigation };
    };
    OverflowMenu.disabledItem = function (text, reason) {
        return { text: text, reason: reason, kind: OverflowMenuItemKind.Disabled };
    };
    OverflowMenu.item = function (text, onClick, permission) {
        return { text: text, onClick: onClick, permission: permission, kind: OverflowMenuItemKind.Generic };
    };
    OverflowMenu.downloadItem = function (text, filename, link) {
        return { text: text, link: link, filename: filename, kind: OverflowMenuItemKind.Download };
    };
    OverflowMenu.prototype.render = function () {
        var _this = this;
        // Permissions may cause null entries in our menuItems, so we do null checking before map.
        var result = this.props.menuItems && this.props.menuItems.filter(function (item) { return !!item; }).map(function (item, index) {
            if (isGroup(item)) {
                var results = item.filter(function (subItem) { return !!subItem; }).map(function (groupItem) { return _this.convert(groupItem); });
                if (results.length === 0) {
                    return null;
                }
                // This should be smart enough to know if it needs to add a divider at the start or end of a grouping/array.
                if (index > 0 && !isGroup(_this.props.menuItems[index - 1])) {
                    // Show the divider at the start of this grouping.
                    // I.e. The last thing wasn't a group, so we're good to create one here to indicate the start of a grouping.
                    results.splice(0, 0, { menuItem: React.createElement(Divider_1.default, { key: index }) });
                }
                else if (index < _this.props.menuItems.length - 1) {
                    // Show the divider at the end of this grouping.
                    results.push({ menuItem: React.createElement(Divider_1.default, { key: index }) });
                }
                return results;
            }
            return [_this.convert(item)];
        });
        var dialogs = [];
        var menuItems = lodash_1.flatten(result).filter(function (r) { return !!r; }).map(function (r) {
            if (r.dialog) {
                dialogs.push(r.dialog);
            }
            return r.menuItem;
        });
        return React.createElement("div", { onClick: this.iconMenuOnClickOverride },
            dialogs,
            menuItems && menuItems.length > 0 &&
                React.createElement(IconMenu_1.default, { iconButtonElement: React.createElement(IconButton_1.default, { className: uiTestClasses_1.overflowMenuClass + " " + styles.menuIcon, tabIndex: this.props.tabIndex, title: "Options" },
                        React.createElement(more_vert_1.default, { focusable: this.props.tabIndex === -1 ? "false" : "", tabIndex: this.props.tabIndex, color: this.props.colorOverride ? this.props.colorOverride : "initial" })), anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } }, menuItems));
    };
    OverflowMenu.prototype.iconMenuOnClickOverride = function (e) {
        e.preventDefault();
        e.stopPropagation(); //prevent this click toggling expanders (when IconMenus are used in expanders).
    };
    OverflowMenu.prototype.convertDeleteMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDeleteDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, disabled: false, dialogTitle: item.title, key: this.props.menuKey + "-" + item.text, onDeleteClick: item.onClick }, item.content);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.convert = function (item) {
        if (isOverflowMenuDialogItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertDialogMenuItem(item);
        }
        if (isOverflowMenuDeleteItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertDeleteMenuItem(item);
        }
        if (isOverflowMenuRemoveItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return this.convertRemoveMenuItem(item);
        }
        if (isOverflowMenuDownloadItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return {
                menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, containerElement: React.createElement(OverflowMenuLink_1.default, { resolve: false, downloadFileName: item.filename, to: item.link }) })
            };
        }
        if (isOverflowMenuNavLink(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
            return {
                menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, containerElement: React.createElement(OverflowMenuLink_1.default, { to: { pathname: item.path, search: item.queryString } }) })
            };
        }
        if (isOverflowMenuDisabledItem(item)) {
            return {
                menuItem: React.createElement(MenuItem_1.default, { key: this.props.menuKey + "-" + item.text, disabled: true },
                    React.createElement("a", { href: "#", onClick: function (e) { return e.preventDefault(); }, className: styles.disabledItem, title: item.reason }, item.text))
            };
        }
        if (isOverflowMenuGenericItem(item)) {
            if (item.permission && !PermissionCheck_1.isAllowed(item.permission)) {
                return this.alternate(item.permission.alternate);
            }
        }
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: item.onClick })
        };
    };
    OverflowMenu.prototype.convertRemoveMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDeleteDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, disabled: false, dialogTitle: item.title, deleteButtonLabel: "Remove", deleteButtonBusyLabel: "Removing", key: this.props.menuKey + "-" + item.text, onDeleteClick: item.onClick }, item.content);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.convertDialogMenuItem = function (item) {
        var dialog;
        var dialogMenuItem = React.createElement(OpenDialogMenuItem_1.default, { ref: function (d) { return dialog = d; }, label: item.text, key: this.props.menuKey + "-" + item.text }, item.child);
        return {
            menuItem: React.createElement(MenuItem_1.default, { primaryText: item.text, key: this.props.menuKey + "-" + item.text, onClick: function () { return dialog.getWrappedInstance().onClick(); } }),
            dialog: dialogMenuItem
        };
    };
    OverflowMenu.prototype.alternate = function (alternate) {
        return alternate && { menuItem: React.createElement(MenuItem_1.default, { key: alternate, primaryText: alternate }) };
    };
    return OverflowMenu;
}(BaseComponent_1.BaseComponent));
exports.default = OverflowMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OverflowMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OverflowMenu.tsx"); } } })();

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(49);
var DialogLayout_1 = __webpack_require__(158);
var DialogLayoutConnect_1 = __webpack_require__(318);
var PermissionCheck_1 = __webpack_require__(42);
var FormComponent_1 = __webpack_require__(250);
var styles = __webpack_require__(247);
var SaveDialogLayoutInternal = (function (_super) {
    __extends(SaveDialogLayoutInternal, _super);
    function SaveDialogLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSaveClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.close();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.submitForm = function () {
            if (!_this.isSaveButtonDisabled()) {
                _this.saveClick();
            }
        };
        return _this;
    }
    SaveDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var save = this.props.hideSave ? null : React.createElement(ActionButton_1.ActionButton, { key: "Save", type: ActionButton_1.ActionButtonType.Save, label: this.props.saveButtonLabel || "Save", busyLabel: this.props.busyButtonLabel || "Saving...", onClick: this.saveClick, disabled: this.isSaveButtonDisabled() });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: this.props.cancelButtonLabel || "Cancel", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: [cancel, save] }, other, { closeDialog: this.props.close }),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.submitForm, className: styles.dialogWrapper }, children));
    };
    SaveDialogLayoutInternal.prototype.isSaveButtonDisabled = function () {
        var disabledDueToPermission = !!this.props.savePermission ? !PermissionCheck_1.isAllowed(this.props.savePermission) : false;
        return !!(this.props.saveButtonDisabled || disabledDueToPermission || this.props.busy);
    };
    SaveDialogLayoutInternal.defaultProps = {
        hideSave: false
    };
    return SaveDialogLayoutInternal;
}(React.Component));
var SaveDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(SaveDialogLayoutInternal);
SaveDialogLayout.displayName = "SaveDialogLayout";
exports.default = SaveDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\SaveDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\SaveDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaperLayout_1 = __webpack_require__(131);
exports.default = PaperLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PaperLayout\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PaperLayout\\index.ts"); } } })();

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var matchErrorsToFieldNames_1 = __webpack_require__(837);
var DataBaseComponent_1 = __webpack_require__(90);
// This base class is deprecated. Use `FormBaseComponent` instead which does not have an optional model
var OptionalFormBaseComponent = (function (_super) {
    __extends(OptionalFormBaseComponent, _super);
    function OptionalFormBaseComponent(props) {
        return _super.call(this, props) || this;
    }
    OptionalFormBaseComponent.prototype.setModel = function (model) {
        this.setState({
            model: model,
            cleanModel: lodash_1.cloneDeep(model)
        });
    };
    OptionalFormBaseComponent.prototype.setModelState = function (state, callback) {
        this.setChildState1("model", state, callback);
    };
    OptionalFormBaseComponent.prototype.mapToOctopusError = function (err) {
        var error = _super.prototype.mapToOctopusError.call(this, err);
        error.fieldErrors = matchErrorsToFieldNames_1.default(err, this.state.model);
        return error;
    };
    return OptionalFormBaseComponent;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = OptionalFormBaseComponent;
var FormBaseComponent = (function (_super) {
    __extends(FormBaseComponent, _super);
    function FormBaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormBaseComponent.prototype.setModel = function (model) {
        this.setState({
            model: model,
            cleanModel: lodash_1.cloneDeep(model)
        });
    };
    FormBaseComponent.prototype.setModelState = function (state, callback) {
        this.setChildState1("model", state, callback);
    };
    FormBaseComponent.prototype.mapToOctopusError = function (err) {
        var error = _super.prototype.mapToOctopusError.call(this, err);
        error.fieldErrors = matchErrorsToFieldNames_1.default(err, this.state.model);
        return error;
    };
    return FormBaseComponent;
}(DataBaseComponent_1.DataBaseComponent));
exports.FormBaseComponent = FormBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\FormBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\FormBaseComponent.tsx"); } } })();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var tagSeperator = "/";
var getAll = function () {
    return clientInstance_1.repository.TagSets.all();
};
exports.getAll = getAll;
var getTagIndex = function () { return __awaiter(_this, void 0, void 0, function () {
    var tagSets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAll()];
            case 1:
                tagSets = _a.sent();
                return [2 /*return*/, getTagIndexForTagSets(tagSets)];
        }
    });
}); };
exports.getTagIndex = getTagIndex;
var getTagIndexForTagSets = function (tagSets) {
    var idx = {};
    tagSets.forEach(function (t) { return t.Tags.forEach(function (tag) { return idx[tag.CanonicalTagName] = tag; }); });
    return idx;
};
exports.getTagIndexForTagSets = getTagIndexForTagSets;
var groupByTagSet = function (canonicalTagNames) {
    var unorderedTagSets = [];
    canonicalTagNames.forEach(function (canonicalTagName) {
        var name = canonicalTagName.split(tagSeperator)[0];
        var tagSet = unorderedTagSets.find(function (x) { return x.name === name; });
        if (tagSet) {
            tagSet.tags.push(canonicalTagName);
        }
        else {
            unorderedTagSets.push({ name: name, tags: [canonicalTagName] });
        }
    });
    return unorderedTagSets;
};
exports.groupByTagSet = groupByTagSet;
var groupAndOrderByTagSet = function (canonicalTagNames, tagSets) {
    var unorderedTagSets = groupByTagSet(canonicalTagNames);
    return unorderedTagSets.sort(function (a, b) { return tagSets.find(function (x) { return x.Name === a.name; }).SortOrder - tagSets.find(function (x) { return x.Name === b.name; }).SortOrder; });
};
exports.groupAndOrderByTagSet = groupAndOrderByTagSet;
var flattenGroup = function (groups) {
    return groups.reduce(function (a, group) { return a.concat(group.tags); }, []);
};
exports.flattenGroup = flattenGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\tenantTagsets.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\tenantTagsets.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScriptingLanguage;
(function (ScriptingLanguage) {
    ScriptingLanguage["Bash"] = "Bash";
    ScriptingLanguage["CSharp"] = "CSharp";
    ScriptingLanguage["FSharp"] = "FSharp";
    ScriptingLanguage["PowerShell"] = "PowerShell";
})(ScriptingLanguage = exports.ScriptingLanguage || (exports.ScriptingLanguage = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\scriptingLanguage.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\scriptingLanguage.ts"); } } })();

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BusyIndicator_1 = __webpack_require__(95);
var BusyFromPromise_1 = __webpack_require__(161);
var ErrorPanel_1 = __webpack_require__(85);
var styles = __webpack_require__(247);
var react_event_listener_1 = __webpack_require__(68);
var lodash_1 = __webpack_require__(11);
var KeyboardHandler_1 = __webpack_require__(377);
var DialogLayout = (function (_super) {
    __extends(DialogLayout, _super);
    function DialogLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            // ie11 flexbox doesn't work correctly if the parent element is
            // having its size set by max-height, but the parent element to this
            // is material-ui and maxHeight is how they dynamically resize dialogs
            // so rather than change that, if we're in ie11 set the contents
            // max-height.
            if (_this.topLevel) {
                var parentHeight = _this.topLevel.parentElement.style.maxHeight;
                _this.setState({ style: { maxHeight: parentHeight } });
            }
        };
        _this.onEscKeyPressed = function () {
            if (_this.props.closeDialog) {
                _this.props.closeDialog();
                return true;
            }
            return false;
        };
        _this.ie11 = typeof (Event) !== "function";
        _this.state = { style: {} };
        _this.onResizeThrottled = lodash_1.throttle(_this.onResize, 100);
        return _this;
    }
    DialogLayout.prototype.componentDidMount = function () {
        var _this = this;
        if (this.ie11) {
            window.setTimeout(function () { return _this.onResize(); }, 250);
        }
    };
    DialogLayout.prototype.render = function () {
        var _this = this;
        if (this.props.busy && (typeof this.props.busy) !== "boolean") {
            // Workaround for a bug in material-ui dialog: https://github.com/callemall/material-ui/issues/5793#issuecomment-301282845
            this.props.busy.then(function () { return setTimeout(function () {
                if (_this.ie11) {
                    var event = document.createEvent("Event");
                    event.initEvent("resize", true, true);
                    window.dispatchEvent(event);
                }
                else {
                    window.dispatchEvent(new Event("resize"));
                }
            }, 10); });
        }
        var keyboardRegistrations = [{ key: KeyboardHandler_1.Key.Esc, onKeyPressed: this.onEscKeyPressed }];
        return React.createElement("div", { className: styles.layout, ref: function (r) { return _this.topLevel = r; }, style: this.state.style },
            React.createElement(KeyboardHandler_1.default, { registrations: keyboardRegistrations, className: styles.dialogWrapper },
                this.ie11 && React.createElement(react_event_listener_1.default, { target: "window", onResize: react_event_listener_1.withOptions(this.onResize, { passive: true }) }),
                React.createElement("div", { className: this.props.headerClassName },
                    React.createElement(BusyFromPromise_1.default, { promise: this.props.busy }, function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy }); }),
                    React.createElement("div", { className: styles.title },
                        this.props.titleIcon && React.createElement("div", { className: styles.titleIcon }, this.props.titleIcon),
                        this.props.title),
                    this.props.extraHeaderContent && this.props.extraHeaderContent(styles.headerContentAlignment)),
                this.props.errors &&
                    React.createElement(ErrorPanel_1.default, { message: this.props.errors.message, details: this.props.errors.details }),
                React.createElement("div", { className: styles.body }, this.props.children),
                React.createElement("div", { className: styles.actions },
                    React.createElement("div", { className: styles.secondaryActions }, this.props.additionalActions),
                    React.createElement("div", { className: styles.primaryActions }, this.props.actions))));
    };
    return DialogLayout;
}(React.Component));
exports.DialogLayout = DialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\DialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\DialogLayout.tsx"); } } })();

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var lodash_2 = __webpack_require__(11);
function DebounceValue(Comp) {
    return (function (_super) {
        __extends(DebounceValueInternal, _super);
        function DebounceValueInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                value: props.value
            };
            _this.onChange = lodash_2.debounce(function (value) { return _this.props.onChange(value); }, _this.props.debounceDelay ? _this.props.debounceDelay : 250);
            return _this;
        }
        DebounceValueInternal.prototype.componentWillReceiveProps = function (nextProps) {
            if (!lodash_1.isEqual(nextProps.value, this.props.value)) {
                this.setState({ value: nextProps.value });
                this.onChange.cancel();
            }
        };
        DebounceValueInternal.prototype.render = function () {
            var _this = this;
            var _a = this.props, debounceDelay = _a.debounceDelay, innerRef = _a.innerRef, otherProps = __rest(_a, ["debounceDelay", "innerRef"]); // `as any` because object rest not support in generics yet, tracked by https://github.com/Microsoft/TypeScript/issues/10727
            return React.createElement(Comp, __assign({}, otherProps, { value: this.state.value, ref: function (c) { if (innerRef) {
                    innerRef(c);
                } }, onChange: function (value) {
                    _this.setState({ value: value });
                    _this.onChange(value);
                } }));
        };
        return DebounceValueInternal;
    }(React.Component));
}
exports.default = DebounceValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DebounceValue\\DebounceValue.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DebounceValue\\DebounceValue.tsx"); } } })();

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LookupResourceChip_1 = __webpack_require__(493);
exports.default = LookupResourceChip_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupResourceChip\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupResourceChip\\index.tsx"); } } })();

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var BusyFromPromise = (function (_super) {
    __extends(BusyFromPromise, _super);
    function BusyFromPromise(props) {
        var _this = _super.call(this, props) || this;
        _this.current = null;
        _this.resetState = function (promise) {
            // don't turn off the busy indicator if a new promise is running
            // we don't worry about order of promises finishing here, callers
            // should maintain an array of "requests" and pass in Promise.all
            // on them when it updates so we only need to worry about latest.
            if (promise === _this.current) {
                _this.current = null;
                _this.setState({ busy: false });
            }
        };
        _this.determineState = function (props) {
            if (props.promise) {
                if (typeof props.promise === "boolean") {
                    _this.current = null;
                    return { busy: props.promise };
                }
                else {
                    _this.current = props.promise;
                    props.promise.then(function () { return _this.resetState(props.promise); }, function () { return _this.resetState(props.promise); });
                    return { busy: true };
                }
            }
            else {
                return { busy: false };
            }
        };
        _this.state = _this.determineState(props);
        return _this;
    }
    BusyFromPromise.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.promise !== this.props.promise) {
            this.setState(this.determineState(nextProps));
        }
    };
    BusyFromPromise.prototype.render = function () {
        return (this.props.children)(this.state.busy);
    };
    return BusyFromPromise;
}(BaseComponent_1.BaseComponent));
exports.default = BusyFromPromise;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyFromPromise\\BusyFromPromise.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyFromPromise\\BusyFromPromise.tsx"); } } })();

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Divider_1 = __webpack_require__(274);
var colors_1 = __webpack_require__(31);
exports.Divider = function (props) {
    var margin = props.fullHeight ? { marginTop: 0 } : {};
    return React.createElement(Divider_1.default, { style: __assign({ backgroundColor: colors_1.divider }, margin) });
};
exports.default = exports.Divider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Divider\\Divider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Divider\\Divider.tsx"); } } })();

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1707);
var sizes_1 = __webpack_require__(1709);
var InputWithActions = function (props) {
    var inputStyle = props.applyMaxWidth ? { maxWidth: sizes_1.maxInputWidth } : (props.maxWidthInRem ? { maxWidth: props.maxWidthInRem + "rem" } : {});
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.input, style: inputStyle }, props.input),
        React.createElement("div", { className: styles.actions }, props.actions));
};
InputWithActions.displayName = "InputWithActions";
InputWithActions.defaultProps = {
    applyMaxWidth: false
};
exports.default = InputWithActions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\InputWithActions\\InputWithActions.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\InputWithActions\\InputWithActions.tsx"); } } })();

/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var scriptingLanguage_1 = __webpack_require__(157);
var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage[SupportedLanguage["All"] = 0] = "All";
    SupportedLanguage[SupportedLanguage["PowerShell"] = 1] = "PowerShell";
    SupportedLanguage[SupportedLanguage["PowerShellAndBash"] = 2] = "PowerShellAndBash";
})(SupportedLanguage || (SupportedLanguage = {}));
exports.SupportedLanguage = SupportedLanguage;
var ScriptingLanguageSelector = function (props) {
    var options = determineAvailableLanguages(props.supportedLanguages || SupportedLanguage.All, props);
    return React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { horizontal: true, value: props.value, autoFocus: props.autoFocus, onChange: props.onChange }, options);
};
function determineAvailableLanguages(supportedLanguages, props) {
    var options = [React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.PowerShell, label: "PowerShell", key: scriptingLanguage_1.ScriptingLanguage.PowerShell })];
    if (supportedLanguages === SupportedLanguage.All) {
        options.push(React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.CSharp, label: "C#", key: scriptingLanguage_1.ScriptingLanguage.CSharp }));
    }
    if (supportedLanguages !== SupportedLanguage.PowerShell && !props.onlyRunnableOnServer) {
        options.push(React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.Bash, label: "Bash", key: scriptingLanguage_1.ScriptingLanguage.Bash }));
    }
    if (supportedLanguages === SupportedLanguage.All) {
        options.push(React.createElement(RadioButton_1.default, { value: scriptingLanguage_1.ScriptingLanguage.FSharp, label: "F#", key: scriptingLanguage_1.ScriptingLanguage.FSharp }));
    }
    return options;
}
ScriptingLanguageSelector.displayName = "ScriptingLanguageSelector";
ScriptingLanguageSelector.defaultProps = {
    doNotAutoFocus: true
};
exports.default = ScriptingLanguageSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ScriptingLanguageSelector\\ScriptingLanguageSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ScriptingLanguageSelector\\ScriptingLanguageSelector.tsx"); } } })();

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PackageAcquisitionLocation;
(function (PackageAcquisitionLocation) {
    PackageAcquisitionLocation["Server"] = "Server";
    PackageAcquisitionLocation["ExecutionTarget"] = "ExecutionTarget";
    PackageAcquisitionLocation["NotAcquired"] = "NotAcquired";
})(PackageAcquisitionLocation = exports.PackageAcquisitionLocation || (exports.PackageAcquisitionLocation = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\packageAcquisitionLocation.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\packageAcquisitionLocation.ts"); } } })();

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var prop_types_1 = __webpack_require__(1);
function generateLabel(fieldName, labelStrategy, fallbackLabelStrategy) {
    if (labelStrategy) {
        return labelStrategy(fieldName);
    }
    return fallbackLabelStrategy(fieldName);
}
var LabelStrategyContextTypes = {
    labelStrategy: prop_types_1.func
};
/* This component is used to set a "labeling" strategy on the react context.
* This strategy is used to determine how labels for input components are generated
* This allows us to do things like say that all inputs within the filter panel
* should have labels of the form "By [fieldName]", eg "By environments".
* For components to use the label strategy to generate their label, they should use the `UseLabelStrategy` HOC*/
var SetLabelStrategy = (function (_super) {
    __extends(SetLabelStrategy, _super);
    function SetLabelStrategy(props) {
        var _this = _super.call(this, props) || this;
        // Capture the label strategy so that it can't change (not a good idea to change things on context)
        _this.labelStrategy = props.labelStrategy;
        return _this;
    }
    SetLabelStrategy.prototype.getChildContext = function () {
        var context = {
            labelStrategy: this.labelStrategy
        };
        return context;
    };
    SetLabelStrategy.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    SetLabelStrategy.childContextTypes = LabelStrategyContextTypes;
    return SetLabelStrategy;
}(React.Component));
exports.SetLabelStrategy = SetLabelStrategy;
/* This clears any label strategy that might be on the context (see `SetLabelStrategy`),
* so that any descendant components won't use that label strategy
* This is useful for things like dialogs, which are usually placed at some arbitrary point
* in the component hierarchy because they have to go somewhere, and therefore don't necessarily
* want to inherit the provided label strategy.*/
var ResetLabelStrategy = (function (_super) {
    __extends(ResetLabelStrategy, _super);
    function ResetLabelStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResetLabelStrategy.prototype.getChildContext = function () {
        var context = {
            labelStrategy: undefined
        };
        return context;
    };
    ResetLabelStrategy.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    ResetLabelStrategy.childContextTypes = LabelStrategyContextTypes;
    return ResetLabelStrategy;
}(React.Component));
exports.ResetLabelStrategy = ResetLabelStrategy;
/* This HOC wraps a component and makes it use the label strategy on the react context in order to generate its label
* It is mainly used by input components, like `Text` and `Select`
* In order to provide a label strategy on the context, use `SetLabelStrategy`*/
function UseLabelStrategy(Comp, fallbackLabelStrategy) {
    return _a = (function (_super) {
            __extends(UseLabelStrategyInternal, _super);
            function UseLabelStrategyInternal(props, context) {
                var _this = _super.call(this, props) || this;
                _this.labelStrategy = context.labelStrategy;
                return _this;
            }
            UseLabelStrategyInternal.prototype.render = function () {
                var _a = this.props, fieldName = _a.fieldName, label = _a.label, other = __rest(_a, ["fieldName", "label"]);
                var derivedLabel = label || (fieldName
                    ? generateLabel(fieldName, this.labelStrategy, fallbackLabelStrategy)
                    : undefined);
                return React.createElement(Comp, __assign({}, other, { label: derivedLabel }));
            };
            return UseLabelStrategyInternal;
        }(React.Component)),
        _a.contextTypes = LabelStrategyContextTypes,
        _a;
    var _a;
}
exports.default = UseLabelStrategy;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LabelStrategy\\LabelStrategy.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LabelStrategy\\LabelStrategy.tsx"); } } })();

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// State Type
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["happy"] = 0] = "happy";
    NotificationType[NotificationType["info"] = 1] = "info";
    NotificationType[NotificationType["warn"] = 2] = "warn";
    NotificationType[NotificationType["error"] = 3] = "error";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
// Actions
var NotificationActions = {
    RAISE: "NotificationActions/RAISE",
    DISMISS: "NotificationActions/DISMISS"
};
// Action Creator
exports.raiseNotification = function (dispatch) { return function (notification) {
    dispatch({ type: NotificationActions.RAISE, notification: notification });
}; };
exports.dismissNotification = function (dispatch) { return function (notificationType) {
    dispatch({ type: NotificationActions.DISMISS, notificationType: notificationType });
}; };
// Reducer
exports.notificationReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case NotificationActions.RAISE:
            var notification = action.notification;
            return __assign({}, state, (_a = {}, _a[notification.id] = notification, _a));
        case NotificationActions.DISMISS:
            var newState = __assign({}, state);
            delete newState[action.notificationType];
            return newState;
    }
    return state;
    var _a;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\notifications.redux.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\notifications.redux.ts"); } } })();

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpecialVariables = {
    Action: {
        TargetRoles: "Octopus.Action.TargetRoles",
        RunOnServer: "Octopus.Action.RunOnServer",
        HealthCheck: {
            Type: "Octopus.Action.HealthCheck.Type"
        },
        Email: {
            To: "Octopus.Action.Email.To",
            ToTeamIds: "Octopus.Action.Email.ToTeamIds",
            CC: "Octopus.Action.Email.CC",
            CCTeamIds: "Octopus.Action.Email.CCTeamIds",
            Bcc: "Octopus.Action.Email.Bcc",
            BccTeamIds: "Octopus.Action.Email.BccTeamIds'"
        },
        MaxParallelism: "Octopus.Action.MaxParallelism",
        Certificate: {
            Variable: "Octopus.Action.Certificate.Variable",
            StoreLocation: "Octopus.Action.Certificate.StoreLocation"
        }
    }
};
exports.default = SpecialVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\specialVariables.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\specialVariables.ts"); } } })();

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1941);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var IconButtonList_1 = __webpack_require__(124);
var InputWithActions_1 = __webpack_require__(136);
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var resources_1 = __webpack_require__(17);
var variableResource_1 = __webpack_require__(430);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(40);
var index_1 = __webpack_require__(312);
var IconButton_1 = __webpack_require__(52);
var BoundField_1 = __webpack_require__(100);
var CertificateVariableSelect = (function (_super) {
    __extends(CertificateVariableSelect, _super);
    function CertificateVariableSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (certificateVariable) {
            var value = certificateVariable === "" ? null : certificateVariable;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.goTo = function () {
            window.open("#/projects/" + _this.props.projectId + "/variables", "_blank");
        };
        _this.getCertificateVariables = function (project) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var libraryVariableSets, templates, variableSetIds, variableResults, variables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(project.IncludedLibraryVariableSetIds.map(function (libraryVariableSetId) { return clientInstance_1.repository.LibraryVariableSets.get(libraryVariableSetId); }))];
                    case 1:
                        libraryVariableSets = _a.sent();
                        templates = _.union(project.Templates, _.flattenDeep(libraryVariableSets.map(function (lvs) { return lvs.Templates; })))
                            .filter(function (template) {
                            return !!template.DisplaySettings && template.DisplaySettings["Octopus.ControlType"] === resources_1.ControlType.Certificate;
                        });
                        variableSetIds = _.union([project.VariableSetId], libraryVariableSets.map(function (lvs) { return lvs.VariableSetId; }));
                        return [4 /*yield*/, Promise.all(variableSetIds.map(function (variableSetId) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Variables.get(variableSetId)];
                                    case 1: return [2 /*return*/, (_a.sent()).Variables];
                                }
                            }); }); }))];
                    case 2:
                        variableResults = _a.sent();
                        variables = _.flattenDeep(variableResults)
                            .filter(function (v) { return v.Type === variableResource_1.VariableType.Certificate; });
                        return [2 /*return*/, _.chain(variables)
                                .union(templates)
                                .map(function (v) { return v.Name; })
                                .sort()
                                .uniq()
                                .value()];
                }
            });
        }); };
        _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var variables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ refreshing: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.getCertificateVariables(this.state.project)];
                    case 2:
                        variables = _a.sent();
                        this.setState({ variables: variables });
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ refreshing: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            error: null,
            refreshing: false,
            project: null,
            variables: [],
            isDataLoaded: false
        };
        return _this;
    }
    CertificateVariableSelect.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project, variables;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                return [4 /*yield*/, this.getCertificateVariables(project)];
                            case 2:
                                variables = _a.sent();
                                this.setState({ project: project, variables: variables, isDataLoaded: true });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    CertificateVariableSelect.prototype.render = function () {
        if (!this.state.isDataLoaded) {
            return React.createElement(index_1.default, { show: true, inline: true });
        }
        var _a = this.props, onChange = _a.onChange, onValidate = _a.onValidate, projectId = _a.projectId, doBusyTask = _a.doBusyTask, otherProps = __rest(_a, ["onChange", "onValidate", "projectId", "doBusyTask"]);
        return (React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select certificate variable" }, otherProps, { allowFilter: true, error: this.state.error || this.props.error, onChange: this.handleChange, items: this.state.variables.map(function (v) { return ({ value: v, text: v }); }) })), actions: React.createElement(IconButtonList_1.default, { buttons: this.getButtons() }) }));
    };
    CertificateVariableSelect.prototype.getButtons = function () {
        var buttons = [];
        if (!this.state.refreshing) {
            buttons.push(React.createElement(IconButton_1.default, { toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh, onClick: this.onRequestRefresh }));
        }
        else {
            buttons.push(React.createElement(index_1.default, { show: true, inline: true }));
        }
        buttons.push(React.createElement(IconButton_1.default, { toolTipContent: "Add", icon: IconButton_1.Icon.Add, onClick: this.goTo }));
        return buttons;
    };
    return CertificateVariableSelect;
}(React.Component));
exports.default = CertificateVariableSelect;
exports.BoundCertificateVariableSelect = BoundField_1.withBoundField(CertificateVariableSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateVariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateVariableSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(26);
var AzurePowerShellScriptInfo = function (props) {
    var preamble = props.actionType === "Octopus.AzurePowerShell"
        ? "As this step is running a PowerShell script"
        : "If you are running a PowerShell script as part of this step";
    return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
        preamble,
        " ",
        React.createElement(ExternalLink_1.default, { href: "WindowsManagementFramework5Download" }, "Windows Management Framework 5"),
        " (or newer) must be installed on the ",
        React.createElement("strong", null, "Octopus Server"),
        ".");
};
exports.default = AzurePowerShellScriptInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellScriptInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellScriptInfo.tsx"); } } })();

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(84);
var form_1 = __webpack_require__(16);
var Select_1 = __webpack_require__(40);
var ActionButton_1 = __webpack_require__(49);
var styles = __webpack_require__(743);
var VariableLookupText_1 = __webpack_require__(21);
var VariableLookupAutoComplete_1 = __webpack_require__(757);
var colors_1 = __webpack_require__(31);
var _ = __webpack_require__(11);
var errorStyle = { bottom: "0px", color: colors_1.danger };
var KeyValueOptionRemoveItemsList = (function (_super) {
    __extends(KeyValueOptionRemoveItemsList, _super);
    function KeyValueOptionRemoveItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return KeyValueOptionRemoveItemsList;
}(RemoveItemsList_1.RemoveItemsList));
var noop = function () { return undefined; };
/**
 * The extended key value list supports:
 * - Select boxes
 * - Suggestion boxes
 * - Errors on items
 * - On add callback
 * - More inputs (between 2 and 4)
 * - Adding new items to the top of the list
 */
var ExtendedKeyValueEditList = (function (_super) {
    __extends(ExtendedKeyValueEditList, _super);
    function ExtendedKeyValueEditList(props) {
        var _this = _super.call(this, props) || this;
        _this.adding = false;
        _this.handleRemoveRow = function (item) {
            var data = _this.state.source;
            data.splice(data.indexOf(item), 1);
            _this.invokeOnChange(data);
        };
        _this.handleRowRef = function (idx) { return function (input) {
            if (input && _this.adding && idx === 0) {
                input.focus();
                _this.adding = false;
            }
        }; };
        _this.handleKeyChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].key = val;
            _this.invokeOnChange(data);
        }; };
        _this.handleValueChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].value = val;
            _this.invokeOnChange(data);
        }; };
        _this.handleOptionChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].option = val;
            _this.invokeOnChange(data);
        }; };
        _this.handleOption2Change = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx].option2 = val;
            _this.invokeOnChange(data);
        }; };
        _this.invokeOnChange = function (data) {
            _this.props.onChange(data.slice());
        };
        _this.invokeOnAdd = function () {
            if (_this.props.onAdd) {
                _this.props.onAdd(_this.state.source.slice());
            }
        };
        _this.handleAddClick = function () {
            _this.adding = true;
            if (_this.props.addToTop) {
                _this.setState(function (prev) { return (__assign({}, prev, { source: [{
                            key: "",
                            keyError: null,
                            value: "",
                            valueError: null,
                            option: "",
                            optionError: null,
                            option2: "",
                            option2Error: null
                        }].concat(prev.source) })); }, _this.invokeOnAdd);
            }
            else {
                _this.setState(function (prev) { return (__assign({}, prev, { source: prev.source.concat([{
                            key: "",
                            keyError: null,
                            value: "",
                            valueError: null,
                            option: "",
                            optionError: null,
                            option2: "",
                            option2Error: null
                        }]) })); }, _this.invokeOnAdd);
            }
        };
        _this.renderRow = function (item, idx) {
            var fields = [
                React.createElement("div", { className: styles.textControl, key: "key" }, _this.props.hideBindOnKey
                    ? React.createElement(form_1.Text, { textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })
                    : _this.props.getOptions
                        ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { value: item.key, label: _this.props.keyLabel, hintText: _this.props.keyHintText, getOptions: _this.props.getOptions, onChange: _this.handleKeyChange(idx), allowAnyTextValue: true })
                        : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, textInputRef: _this.props.reverseLayout ? noop : _this.handleRowRef(idx), value: item.key, onChange: _this.handleKeyChange(idx), label: _this.props.keyLabel, hintText: _this.props.keyHintText })),
                _this.errorText(item.keyError)
            ];
            if (_this.props.valueLabel) {
                fields.push(React.createElement("div", { className: styles.textControl, key: "value" }, _this.props.getValueOptions
                    ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { value: item.value, hintText: _this.props.valueHintText, label: _this.props.valueLabel, getOptions: _this.props.getValueOptions, onChange: _this.handleValueChange(idx), allowAnyTextValue: true })
                    : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: "value", textInputRef: _this.props.reverseLayout ? _this.handleRowRef(idx) : noop, value: item.value, onChange: _this.handleValueChange(idx), label: _this.props.valueLabel, hintText: _this.props.valueHintText })), _this.errorText(item.valueError));
            }
            if (_this.props.optionLabel) {
                fields.push(React.createElement("div", { className: styles.textControl, key: "option" }, _this.props.optionValues
                    ? React.createElement(Select_1.BoundSelect, { label: _this.props.optionLabel, onChange: _this.handleOptionChange(idx), value: item.option, items: _this.props.optionValues, resetValue: _this.props.optionReset, boundRows: 1 })
                    : _this.props.getOptionOptions
                        ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { value: item.option, hintText: _this.props.optionHintText, label: _this.props.optionLabel, getOptions: _this.props.getOptionOptions, onChange: _this.handleOptionChange(idx), allowAnyTextValue: true })
                        : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: "option", textInputRef: _this.props.reverseLayout ? _this.handleRowRef(idx) : noop, value: item.option, onChange: _this.handleOptionChange(idx), label: _this.props.optionLabel, hintText: _this.props.optionHintText })), _this.errorText(item.optionError));
            }
            if (_this.props.option2Label) {
                fields.push(React.createElement("div", { className: styles.textControl, key: "option2" }, _this.props.option2Values
                    ? React.createElement(Select_1.BoundSelect, { label: _this.props.option2Label, onChange: _this.handleOption2Change(idx), value: item.option2, items: _this.props.option2Values, resetValue: _this.props.option2Reset, boundRows: 1 })
                    : _this.props.getOption2Options
                        ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { value: item.option2, hintText: _this.props.option2HintText, label: _this.props.option2Label, getOptions: _this.props.getOption2Options, onChange: _this.handleOption2Change(idx), allowAnyTextValue: true })
                        : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: "option2", textInputRef: _this.props.reverseLayout ? _this.handleRowRef(idx) : noop, value: item.option2, onChange: _this.handleOption2Change(idx), label: _this.props.option2Label, hintText: _this.props.option2HintText })), _this.errorText(item.option2Error));
            }
            if (_this.props.reverseLayout) {
                fields = fields.reverse();
            }
            return React.createElement("div", { key: "KVOI-" + idx, className: styles.threeItemContainer }, fields);
        };
        _this.state = {
            source: props.items()
        };
        return _this;
    }
    ExtendedKeyValueEditList.prototype.render = function () {
        var actionButton = React.createElement(ActionButton_1.default, { key: "Add", label: (this.props.verb || "Add") + " " + this.props.name, onClick: this.handleAddClick });
        return React.createElement(KeyValueOptionRemoveItemsList, { listActions: [actionButton], data: this.state.source, onRemoveRow: this.handleRemoveRow, onRow: this.renderRow, clearButtonToolTip: "Remove " + this.props.name });
    };
    ExtendedKeyValueEditList.prototype.errorText = function (error) {
        if (error) {
            return React.createElement("div", { style: __assign({}, styles.error, errorStyle) }, error);
        }
    };
    return ExtendedKeyValueEditList;
}(React.PureComponent));
exports.ExtendedKeyValueEditList = ExtendedKeyValueEditList;
function stringToKeyValueOptions(value) {
    if (value === null || value === undefined) {
        return [];
    }
    var arrayValue = JSON.parse(value);
    /*
        Swapping between UI elements can lead to objects (i.e. {"key": "value"} being saved
        and arrays (i.e [{"key":"value"}]) being expected. So make sure we actually received
        and array.
     */
    return _.isArray(arrayValue) ? arrayValue : [];
}
var StringExtendedKeyValueEditList = function (_a) {
    var items = _a.items, onChange = _a.onChange, rest = __rest(_a, ["items", "onChange"]);
    return (React.createElement(ExtendedKeyValueEditList, __assign({ items: function () { return stringToKeyValueOptions(items); }, onChange: function (values) { return onChange(JSON.stringify(values)); } }, rest)));
};
exports.default = StringExtendedKeyValueEditList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\ExtendedKeyValueEditList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\ExtendedKeyValueEditList.tsx"); } } })();

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var AccountVariableSelect_1 = __webpack_require__(737);
var form_1 = __webpack_require__(16);
var ExternalLink_1 = __webpack_require__(91);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var VariableLookupText_1 = __webpack_require__(21);
var RadioButtonGroup_1 = __webpack_require__(36);
var Callout_1 = __webpack_require__(57);
var StringProperties = {
    "Octopus.Action.AwsAccount.Variable": "",
    "Octopus.Action.AwsAccount.UseInstanceRole": "",
    "Octopus.Action.Aws.AssumeRole": "",
    "Octopus.Action.Aws.AssumedRoleArn": "",
    "Octopus.Action.Aws.AssumedRoleSession": "",
    "Octopus.Action.Aws.Region": ""
};
var AllProperties = __assign({}, StringProperties);
/**
 * A component that displays the connection details for an AWS account
 */
var AwsLoginComponent = (function (_super) {
    __extends(AwsLoginComponent, _super);
    function AwsLoginComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsLoginComponent.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(AllProperties, newProps, this.props);
    };
    AwsLoginComponent.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.AwsAccount.Variable|Octopus.Action.Aws.AssumedRoleArn|Octopus.Action.Aws.AssumedRoleSession", isExpandedByDefault: this.props.expandedByDefault, title: "AWS Account", help: "The AWS account details", summary: this.awsAccountSummary() },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "False", value: this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"], onChange: function (x) {
                        _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.UseInstanceRole"] = x, _a));
                        _this.props.setProperties((_b = {}, _b["Octopus.Action.AwsAccount.Variable"] = "", _b));
                        var _a, _b;
                    }, label: "Execute using the AWS service role for an EC2 instance" },
                    React.createElement(form_1.RadioButton, { value: "True", label: "Yes" }),
                    React.createElement(form_1.RadioButton, { value: "False", label: "No" })),
                this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"] === "False" && (this.props.projectId
                    ? React.createElement(AccountVariableSelect_1.AwsBoundAccountVariableSelect, { projectId: this.props.projectId, resetValue: "", allowClear: true, doBusyTask: this.props.doBusyTask, value: this.props.properties["Octopus.Action.AwsAccount.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.Variable"] = val, _a));
                            var _a;
                        } })
                    : React.createElement(VariableLookupText_1.VariableLookupText, { label: "AWS Account variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.AwsAccount.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.AwsAccount.Variable"] = val, _a));
                            var _a;
                        } })),
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "False", value: this.props.properties["Octopus.Action.Aws.AssumeRole"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumeRole"] = x, _a));
                        var _a;
                    }, label: "Assume a different AWS service role" },
                    React.createElement(form_1.RadioButton, { value: "True", label: "Yes" }),
                    React.createElement(form_1.RadioButton, { value: "False", label: "No" })),
                this.props.properties["Octopus.Action.Aws.AssumeRole"] === "True" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { label: "Assumed role ARN", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.AssumedRoleArn"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumedRoleArn"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.AssumedRoleArn") }),
                        React.createElement(VariableLookupText_1.VariableLookupText, { label: "Assumed role session name", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.AssumedRoleSession"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumedRoleSession"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.AssumedRoleSession") }))),
            React.createElement(form_1.UnstructuredFormSection, null,
                React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "More information can be found regarding terminology for roles and assuming roles \u00A0",
                    React.createElement(ExternalLink_1.default, { href: "AwsDocsRolesTermsAndConcepts" }, "here"),
                    ".")));
    };
    AwsLoginComponent.prototype.awsAccountSummary = function () {
        var accountVariable = this.props.properties["Octopus.Action.AwsAccount.Variable"];
        var assumedRoleArn = this.props.properties["Octopus.Action.Aws.AssumedRoleArn"];
        var assumedRole = this.props.properties["Octopus.Action.Aws.AssumeRole"] === "True";
        var useInstanceRole = this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"] === "True";
        if (useInstanceRole) {
            return form_1.Summary.summary(React.createElement("span", null,
                "The AWS service role for an EC2 instance will be used ",
                assumedRole && assumedRoleArn &&
                    React.createElement("span", null,
                        " to assume the AWS service role ",
                        React.createElement("strong", null, assumedRoleArn))));
        }
        return accountVariable
            ? form_1.Summary.summary(React.createElement("span", null,
                "The AWS account ",
                React.createElement("strong", null, accountVariable),
                " will be used",
                assumedRole && assumedRoleArn && React.createElement("span", null,
                    " to assume the AWS service role ",
                    React.createElement("strong", null, assumedRoleArn))))
            : form_1.Summary.placeholder("The account variable has not been provided");
    };
    return AwsLoginComponent;
}(BaseComponent_1.BaseComponent));
exports.default = AwsLoginComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsLoginComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsLoginComponent.tsx"); } } })();

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(131);
var Snackbar_1 = __webpack_require__(631);
var ExpansionButtons_1 = __webpack_require__(457);
var react_router_1 = __webpack_require__(76);
var lodash_1 = __webpack_require__(11);
var ActionList_1 = __webpack_require__(813);
var PermissionCheck_1 = __webpack_require__(42);
var OverflowMenu_1 = __webpack_require__(152);
var styles = __webpack_require__(1738);
var ActionButton_1 = __webpack_require__(49);
var BaseComponent_1 = __webpack_require__(12);
var FormComponent_1 = __webpack_require__(250);
var InternalRedirect_1 = __webpack_require__(45);
var store_1 = __webpack_require__(123);
var reducers_1 = __webpack_require__(566);
var FormPaperLayout = (function (_super) {
    __extends(FormPaperLayout, _super);
    function FormPaperLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSnackbarClose = function () {
            _this.setState({
                showSnackbar: false,
            });
        };
        _this.handleMenuClick = function (link) {
            if (link.onClick) {
                link.onClick();
            }
            else {
                _this.setState({ redirect: link.url });
            }
        };
        _this.isDisableDueToPermission = function () {
            return !!_this.props.savePermission ? !PermissionCheck_1.isAllowed(_this.props.savePermission) : false;
        };
        _this.shouldBeDisabled = function () {
            return ((!_this.state.dirty || _this.props.busy) && !_this.props.disableDirtyFormChecking && !_this.props.isNewRecord) || _this.props.forceDisableFormSaveButton;
        };
        _this.onCtrlEnterPressed = function () { return __awaiter(_this, void 0, void 0, function () {
            var disabledDueToPermission, isSaveDisable;
            return __generator(this, function (_a) {
                disabledDueToPermission = this.isDisableDueToPermission();
                isSaveDisable = disabledDueToPermission || this.shouldBeDisabled();
                if (!isSaveDisable && !this.props.disableKeyboardFormSubmission) {
                    this.save();
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.save()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSaveClick()];
                    case 1:
                        _a.sent();
                        if (!this.props.errors) {
                            if (this.props.saveText) {
                                this.setState({ showSnackbar: true });
                            }
                            ExpansionButtons_1.toggleExpandos(false);
                        }
                        return [2 /*return*/, !this.props.errors];
                }
            });
        }); };
        _this.state = {
            dirty: false,
            showSnackbar: false,
            redirect: null
        };
        return _this;
    }
    FormPaperLayout.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.disableDirtyFormChecking) {
            var dirty = !lodash_1.isEqual(nextProps.model, nextProps.cleanModel);
            this.setState({ dirty: dirty });
        }
    };
    FormPaperLayout.prototype.componentDidMount = function () {
        store_1.default.dispatch(reducers_1.createFormPaperLayoutMountedAction(this.save));
    };
    FormPaperLayout.prototype.componentWillUnmount = function () {
        store_1.default.dispatch(reducers_1.createFormPaperLayoutMountedAction(null));
    };
    FormPaperLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, model = _a.model, errors = _a.errors, rest = __rest(_a, ["children", "model", "errors"]);
        var overFlowMenu = this.props.overFlowActions && this.props.overFlowActions.length > 0
            && React.createElement(OverflowMenu_1.default, { menuItems: this.props.overFlowActions });
        var disabledDueToPermission = this.isDisableDueToPermission();
        var permissionLabel = this.getPermissionLabel();
        var label = disabledDueToPermission ? permissionLabel + " permission required" : (this.props.saveButtonLabel || "Save");
        var save = React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Save, onClick: this.handleSave, label: label, busyLabel: this.props.saveButtonBusyLabel || "Saving", disabled: disabledDueToPermission || this.shouldBeDisabled() });
        if (this.state.redirect) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirect, push: true });
        }
        var sectionControl = this.props.hideSectionControls
            ? null
            : React.createElement(ActionList_1.default, { actions: [this.props.secondaryAction, save, overFlowMenu].filter(function (action) { return !!action; }) });
        return React.createElement(FormComponent_1.default, { onFormSubmit: this.onCtrlEnterPressed },
            React.createElement(PaperLayout_1.default, __assign({}, rest, { sectionControl: sectionControl, errors: this.props.errors }),
                React.createElement(react_router_1.Prompt, { when: this.state.dirty && !this.props.disableDirtyFormChecking, message: function (location) { return _this.getPromptMessage(location); } }),
                !this.props.hideExpandAll &&
                    React.createElement(ExpansionButtons_1.default, { errors: errors, expandAllOnMount: this.props.expandAllOnMount }),
                React.createElement("div", { className: styles.formContainer }, children),
                this.props.saveText && React.createElement(Snackbar_1.default, { open: this.state.showSnackbar, message: this.props.saveText, autoHideDuration: 3500, onRequestClose: this.handleSnackbarClose })));
    };
    FormPaperLayout.prototype.getPermissionLabel = function () {
        if (this.props.savePermission === undefined) {
            return "No";
        }
        if (Array.isArray(this.props.savePermission.permission)) {
            return this.props.savePermission.permission.join(", ");
        }
        return this.props.savePermission.permission;
    };
    FormPaperLayout.prototype.getPromptMessage = function (location) {
        // If the pathname hasn't changed, return true which will allow the transition.
        // This is so we can ignore filter changes which only modify the query string.
        if (location.pathname === this.props.location.pathname) {
            return true;
        }
        return "If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?";
    };
    FormPaperLayout.defaultProps = {
        expandAllOnMount: false,
        saveText: "Details updated"
    };
    return FormPaperLayout;
}(BaseComponent_1.BaseComponent));
exports.default = react_router_1.withRouter(FormPaperLayout);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\FormPaperLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\FormPaperLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1801);
var ListTitle = function (props) {
    return React.createElement("h3", { className: styles.listTitle }, props.children);
};
ListTitle.displayName = "ListTitle";
exports.default = ListTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ListTitle\\ListTitle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ListTitle\\ListTitle.tsx"); } } })();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(241);
var FlatButton_1 = __webpack_require__(115);
var URI = __webpack_require__(120);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(271);
var InternalRedirect_1 = __webpack_require__(45);
var NavigationButtonType;
(function (NavigationButtonType) {
    NavigationButtonType[NavigationButtonType["Primary"] = 0] = "Primary";
    NavigationButtonType[NavigationButtonType["Secondary"] = 1] = "Secondary";
})(NavigationButtonType = exports.NavigationButtonType || (exports.NavigationButtonType = {}));
var NavigationButton = (function (_super) {
    __extends(NavigationButton, _super);
    function NavigationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            e.preventDefault();
            _this.setState({ navigate: true });
        };
        return _this;
    }
    NavigationButton.prototype.getPath = function () {
        if (typeof this.props.href === "string") {
            return this.props.href;
        }
        var query = URI.buildQuery(this.props.href.search);
        return {
            pathname: this.props.href.path,
            search: "?" + query
        };
    };
    NavigationButton.prototype.render = function () {
        if (this.state && this.state.navigate) {
            if (this.props.external) {
                this.setState({ navigate: false });
                window.open(this.props.href);
            }
            else {
                return React.createElement(InternalRedirect_1.default, { to: this.getPath(), push: true });
            }
        }
        switch (this.props.type) {
            case NavigationButtonType.Primary:
                var labelStylePrimary = {
                    fontSize: "0.8125rem",
                };
                return React.createElement(RaisedButton_1.default, { onClick: this.handleOnClick, label: this.props.label, title: this.props.titleAltText !== null ? this.props.titleAltText : this.props.label, icon: this.props.icon, disabled: this.props.disabled, backgroundColor: colors_1.success, labelColor: colors_1.white, labelStyle: labelStylePrimary, disabledBackgroundColor: colors_1.disabledBackground, disabledLabelColor: colors_1.white, className: styles.globalActionButton });
            default:
                var labelStyle = {
                    color: this.props.disabled ? colors_1.secondaryText : colors_1.primary,
                    opacity: 1,
                    fontSize: "0.8125rem",
                };
                return React.createElement(FlatButton_1.default, { onClick: this.handleOnClick, label: this.props.label, title: this.props.titleAltText !== null ? this.props.titleAltText : this.props.label, icon: this.props.icon, labelStyle: labelStyle, disabled: this.props.disabled, className: styles.globalActionButton });
        }
    };
    return NavigationButton;
}(React.Component));
exports.NavigationButton = NavigationButton;
exports.default = NavigationButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\NavigationButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\NavigationButton.tsx"); } } })();

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var search_1 = __webpack_require__(665);
var DebounceValue_1 = __webpack_require__(159);
var Text_1 = __webpack_require__(50);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1516);
var MobileDetect = __webpack_require__(479);
var colors_1 = __webpack_require__(31);
var FilterSearchBoxInternal = (function (_super) {
    __extends(FilterSearchBoxInternal, _super);
    function FilterSearchBoxInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = null;
        _this.setRef = function (el) {
            _this.ref = el;
        };
        return _this;
    }
    FilterSearchBoxInternal.prototype.focus = function () {
        this.ref.focus();
    };
    FilterSearchBoxInternal.prototype.render = function () {
        var _this = this;
        // Disable autoFocus filtering for mobile (Android has issues and is annoying users).
        var md = new MobileDetect(window.navigator.userAgent);
        var autoFocus = md.isPhoneSized() ? false : this.props.autoFocus;
        return (React.createElement("div", { className: cn(this.props.containerClassName, styles.filterField) },
            React.createElement(search_1.default, { className: styles.searchIcon, color: this.props.iconColor ? this.props.iconColor : colors_1.secondaryText, style: this.props.iconStyle }),
            React.createElement(Text_1.default, { textInputRef: this.setRef, type: "search", hintText: this.props.hintText, value: this.props.value, onChange: function (value) { return _this.props.onChange(value); }, autoFocus: autoFocus, onKeyDown: this.props.onKeyDown, className: cn(this.props.inputClassName, this.props.fullWidth ? styles.filterTextBoxFullWidth : styles.filterTextBoxStandardWidth) })));
    };
    return FilterSearchBoxInternal;
}(React.Component));
exports.default = DebounceValue_1.default(FilterSearchBoxInternal);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FilterSearchBox\\FilterSearchBox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FilterSearchBox\\FilterSearchBox.tsx"); } } })();

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.required = function (message) {
    return function (value) {
        if (!value || value.length < 1) {
            return message;
        }
        return "";
    };
};
exports.email = function (message) {
    return function (value) {
        if (!value || !value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            return message;
        }
        return "";
    };
};
exports.minimum = function (message, min) {
    return function (value) {
        var result = Number(value);
        if (isNaN(result)) {
            return message;
        }
        return result < min ? message : "";
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Validators.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Validators.ts"); } } })();

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_lazyload_1 = __webpack_require__(702);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
var styles = __webpack_require__(1682);
var Logo = (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // We need to force a recheck because LazyLoad only rechecks on scrolling, but because our screens support filtering, that bypasses the scrolling event
    Logo.prototype.componentDidUpdate = function () {
        Logo.recheckVisibility();
    };
    Logo.prototype.render = function () {
        var resolvedUrl = this.props.url.startsWith("~") || this.props.url.startsWith("/") ? clientInstance_1.client.resolve(this.props.url) : this.props.url;
        return React.createElement("div", { className: styles.logo, style: { width: this.props.size, height: this.props.size, minWidth: this.props.size } },
            React.createElement(react_lazyload_1.default, { once: true, height: this.props.size },
                React.createElement("img", { src: resolvedUrl, style: {
                        maxWidth: this.props.size,
                        maxHeight: this.props.size
                    }, className: this.props.isDisabled ? styles.disabled : null, alt: "Logo" })));
    };
    Logo.defaultProps = {
        size: "3.1rem"
    };
    // This is static because we want it to be debounced so that when we have lots of Logos calling it we are not rechecking it for every single one
    Logo.recheckVisibility = lodash_1.debounce(function () {
        react_lazyload_1.forceCheck();
    }, 800);
    return Logo;
}(React.Component));
exports.default = Logo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Logo\\Logo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Logo\\Logo.tsx"); } } })();

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_tippy_1 = __webpack_require__(1539);
__webpack_require__(1541);
var ToolTipPosition;
(function (ToolTipPosition) {
    ToolTipPosition["Right"] = "right";
    ToolTipPosition["Left"] = "left";
    ToolTipPosition["Top"] = "top";
    ToolTipPosition["Bottom"] = "bottom";
})(ToolTipPosition = exports.ToolTipPosition || (exports.ToolTipPosition = {}));
var ToolTip = function (props) {
    var content = props.content;
    if (typeof content === "function") {
        content = content();
    }
    var position = props.position ? props.position : ToolTipPosition.Top;
    return React.createElement(react_tippy_1.Tooltip, { open: props.open, trigger: props.trigger, arrow: true, position: position, html: React.createElement("span", null, content), size: "small" }, props.children);
};
exports.default = ToolTip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ToolTip\\ToolTip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ToolTip\\ToolTip.tsx"); } } })();

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1963);
var accountResource_1 = __webpack_require__(452);
var Note_1 = __webpack_require__(20);
var routeLinks_1 = __webpack_require__(22);
var AccountIcons_1 = __webpack_require__(787);
var BoundField_1 = __webpack_require__(100);
var SelectWithAddRefresh_1 = __webpack_require__(736);
var AccountSelect = (function (_super) {
    __extends(AccountSelect, _super);
    function AccountSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (accountId) {
            var value = accountId === "" ? null : accountId;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.selectionRenderer = function (accountId) {
            var account = _this.props.items.find(function (acc) { return acc.Id === accountId; });
            if (!account) {
                return accountId;
            }
            return React.createElement("div", { className: styles.innerContainer },
                React.createElement("span", { className: styles.selectedIcon },
                    React.createElement(AccountIcons_1.AccountIcon, { accountType: account.AccountType })),
                " ",
                account.Name);
        };
        _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ refreshing: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.onRequestRefresh()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ refreshing: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            error: null,
            refreshing: false
        };
        return _this;
    }
    AccountSelect.prototype.getItems = function () {
        var map = function (acc) { return ({ value: acc.Id, text: acc.Name, icon: React.createElement(AccountIcons_1.AccountIcon, { accountType: acc.AccountType }) }); };
        var types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];
        return this.props.items.filter(function (a) { return types.find(function (t) { return a.AccountType === t; }); }).map(map);
    };
    AccountSelect.prototype.onlyTypeIs = function (type) {
        var types = (Array.isArray(this.props.type)) ? this.props.type : [this.props.type];
        return types.length === 1 && types[0] === type;
    };
    AccountSelect.prototype.render = function () {
        var _a = this.props, items = _a.items, onChange = _a.onChange, onValidate = _a.onValidate, onRequestRefresh = _a.onRequestRefresh, otherProps = __rest(_a, ["items", "onChange", "onValidate", "onRequestRefresh"]);
        var warning = "";
        if (this.onlyTypeIs(accountResource_1.AccountType.AzureSubscription)) {
            warning = "Only Azure Management Certificate Accounts may be selected.";
        }
        if (this.onlyTypeIs(accountResource_1.AccountType.AzureServicePrincipal)) {
            warning = "Only Azure Service Principal Accounts may be selected.";
        }
        if (this.onlyTypeIs(accountResource_1.AccountType.AmazonWebServicesAccount)) {
            warning = "Only Amazon Web Service Accounts may be selected.";
        }
        return (React.createElement("div", { className: styles.outerContainer },
            React.createElement(SelectWithAddRefresh_1.default, __assign({ addUrl: "#" + routeLinks_1.default.infrastructure.accounts.root, onRequestRefresh: this.onRequestRefresh, label: "Select account" }, otherProps, { allowFilter: true, onChange: this.handleChange, error: this.state.error || this.props.error, items: this.getItems(), selectionRenderer: this.selectionRenderer })),
            warning && React.createElement(Note_1.default, null, warning)));
    };
    return AccountSelect;
}(React.Component));
exports.default = AccountSelect;
exports.BoundAccountSelect = BoundField_1.withBoundField(AccountSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\AccountSelect\\AccountSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\AccountSelect\\AccountSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BusyFromPromise_1 = __webpack_require__(582);
var styles = __webpack_require__(1961);
var BusyRefreshIndicator_1 = __webpack_require__(597);
var BusyRefreshContainer = function (props) {
    return React.createElement("div", { className: styles.controlWithRefreshContainer },
        props.children,
        React.createElement("div", { className: styles.refreshContainer },
            React.createElement(BusyFromPromise_1.default, { promise: props.busy }, function (busy) { return React.createElement(BusyRefreshIndicator_1.default, { show: busy }); })));
};
BusyRefreshContainer.displayName = "BusyRefreshContainer";
exports.default = BusyRefreshContainer;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyRefreshContainer\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyRefreshContainer\\index.tsx"); } } })();

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(47);
var BaseComponent_1 = __webpack_require__(60);
var BusyIndicator_1 = __webpack_require__(95);
var FilterSearchBox_1 = __webpack_require__(198);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
var Section_1 = __webpack_require__(81);
var styles = __webpack_require__(1520);
var RequestRaceConditioner_1 = __webpack_require__(453);
var NumberedPagingBar_1 = __webpack_require__(492);
var Fragment_1 = __webpack_require__(92);
var PagingBaseComponent = (function (_super) {
    __extends(PagingBaseComponent, _super);
    function PagingBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.requestRaceConditioner = new RequestRaceConditioner_1.default();
        _this.onFilter = function (_) { return true; };
        _this.onLoadMore = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var nextPageIndex, skip, requestUri, requestParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loadingMore: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        if (!(this.props.onLoadMore != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onLoadMore()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        nextPageIndex = this.state.currentPageIndex + 1;
                        this.setState({
                            currentPageIndex: nextPageIndex,
                        });
                        skip = nextPageIndex * this.state.itemsPerPage;
                        requestUri = this.state.data.Links["Template"];
                        requestParams = {
                            // Don't skip, just increase the take size.
                            take: (skip + this.state.itemsPerPage)
                        };
                        requestParams = this.addCommonRequestParameters(requestParams);
                        return [4 /*yield*/, this.requestRaceConditioner.avoidStaleResponsesForRequest(clientInstance_1.client.get(requestUri, requestParams), function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var updatedItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.props.onNewItems) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.props.onNewItems(response.Items)];
                                        case 1:
                                            updatedItems = _a.sent();
                                            response.Items = updatedItems || [];
                                            _a.label = 2;
                                        case 2:
                                            this.setState({
                                                data: response,
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.setState({ loadingMore: false });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onPageSelected = function (skip, p) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var requestUri, requestParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.state.data && this.state.data.Links)) return [3 /*break*/, 6];
                        this.setState({ loadingMore: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        if (!(this.props.onPageSelected != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onPageSelected(skip, p)];
                    case 2:
                        _a.sent();
                        this.setState({
                            currentPageIndex: p,
                        });
                        return [2 /*return*/];
                    case 3:
                        requestUri = this.state.data.Links["Template"];
                        requestParams = {
                            skip: skip,
                            take: this.state.itemsPerPage,
                        };
                        requestParams = this.addCommonRequestParameters(requestParams);
                        return [4 /*yield*/, this.requestRaceConditioner.avoidStaleResponsesForRequest(clientInstance_1.client.get(requestUri, requestParams), function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var updatedItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.props.onNewItems) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.props.onNewItems(response.Items)];
                                        case 1:
                                            updatedItems = _a.sent();
                                            response.Items = updatedItems || [];
                                            _a.label = 2;
                                        case 2:
                                            this.setState({
                                                data: response,
                                                currentPageIndex: p,
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.setState({ loadingMore: false });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onSearch = function (keywordSearch) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ keywordSearch: keywordSearch, filter: keywordSearch, isSearching: true }, function () { return __awaiter(_this, void 0, void 0, function () {
                    var isShowingSearchResults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.onPageSelected(0, 0)];
                            case 1:
                                _a.sent(); // New search should reset to page 0.
                                isShowingSearchResults = true;
                                if (!keywordSearch) {
                                    isShowingSearchResults = false;
                                }
                                this.setState({ isShowingSearchResults: isShowingSearchResults, isSearching: false });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        _this.onFilter = props.onFilter || _this.onFilter;
        _this.provideErrorHandling(_this.onLoadMore);
        _this.provideErrorHandling(_this.onPageSelected);
        _this.provideErrorHandling(_this.onSearch);
        _this.state = {
            filter: "",
            keywordSearch: "",
            isShowingSearchResults: false,
            loadingMore: true,
            isSearching: false,
            currentPageIndex: _this.props.currentPageIndex ? _this.props.currentPageIndex : 0,
            itemsPerPage: _this.props.initialData.ItemsPerPage,
        };
        return _this;
    }
    PagingBaseComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, updatedItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.data != null) {
                            return [2 /*return*/];
                        }
                        initialData = this.props.initialData;
                        if (!this.props.onNewItems) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onNewItems(initialData.Items)];
                    case 1:
                        updatedItems = _a.sent();
                        initialData.Items = updatedItems || [];
                        _a.label = 2;
                    case 2:
                        this.setState({
                            data: initialData,
                            loadingMore: false,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PagingBaseComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.initialData !== nextProps.initialData) {
            this.setState({
                data: nextProps.initialData,
                loadingMore: false,
                currentPageIndex: this.props.currentPageIndex ? this.props.currentPageIndex : 0,
            });
        }
    };
    PagingBaseComponent.prototype.renderFilterSearchBox = function () {
        var _this = this;
        if (!this.props.filterSearchEnabled) {
            return null;
        }
        // We switch between a search box that either "filters" or "searches". ie. Filtering data in-line vs searching the API.
        var needToShowSearch = this.state.isShowingSearchResults || this.state.data.Items.length < this.state.data.TotalResults;
        var searchBoxHintText = this.props.filterHintText || (this.props.filterSearchEnabled && !needToShowSearch ? "Filter..." : "Search...");
        return React.createElement("div", { key: "filterSearch" },
            React.createElement(FilterSearchBox_1.default, { autoFocus: this.props.autoFocusOnFilterSearch, hintText: searchBoxHintText, debounceDelay: 500, onChange: function (keyword) { return _this.onFilterSearch(keyword); } }),
            this.props.filterSearchEnabled && needToShowSearch && this.props.apiSearchParams && this.props.apiSearchParams.length > 0 &&
                React.createElement(BusyIndicator_1.default, { show: this.state.isSearching, inline: true }));
    };
    PagingBaseComponent.prototype.onFilterSearch = function (keyword) {
        var needToShowSearch = this.state.isShowingSearchResults || this.state.data.Items.length < this.state.data.TotalResults;
        if (this.props.filterSearchEnabled && !needToShowSearch) {
            this.setState({ filter: keyword });
        }
        else {
            this.onSearch(keyword);
        }
    };
    PagingBaseComponent.prototype.renderFilterSearchComponents = function () {
        if (!this.props.filterSearchEnabled) {
            return null;
        }
        return this.props.showFilterWithinSection
            ? React.createElement(Section_1.Section, null, this.renderFilterSearchBox())
            : this.renderFilterSearchBox();
    };
    PagingBaseComponent.prototype.showPagingInNumberedStyle = function () {
        var _this = this;
        var data = this.state.data;
        return React.createElement(NumberedPagingBar_1.default, { totalItems: data.TotalResults, currentPageIndex: this.state.currentPageIndex, pageSize: data.ItemsPerPage, onPageSelected: function (s, p) { return _this.onPageSelected(s, p); } });
    };
    PagingBaseComponent.prototype.showPagingInLoadMoreStyle = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.loadMoreContainer },
            React.createElement("div", { className: styles.loadMoreActions },
                !this.state.loadingMore && React.createElement(Fragment_1.Fragment, null,
                    React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Secondary, label: "Load more", onClick: function () { return _this.onLoadMore(); } }),
                    React.createElement("div", { className: styles.loadMoreSubText }, "Or use filters to narrow the search results")),
                this.state.loadingMore && React.createElement(BusyIndicator_1.default, { show: true }))));
    };
    PagingBaseComponent.prototype.navigate = function (item) {
        var redirectTo = getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    PagingBaseComponent.prototype.addCommonRequestParameters = function (requestParams) {
        var _this = this;
        // If a keywordSearch has been provided, supply it for all potential apiSearchParams.
        // Eg. Some APIs have filters for both "name", "description" and "packageVersion" etc. So this lets us
        // quickly search them all for the given keyword.
        if (this.state.keywordSearch) {
            lodash_1.each(this.props.apiSearchParams, function (param) {
                requestParams[param] = _this.state.keywordSearch;
            });
        }
        // Consumers may want to supply additional request params for filters etc.
        if (this.props.additionalRequestParams) {
            this.props.additionalRequestParams.forEach(function (value, key) {
                requestParams[key] = value; // Do not encodeURIComponent here. That is the responsibility of our client's url resolving code.
            });
        }
        return requestParams;
    };
    return PagingBaseComponent;
}(BaseComponent_1.default));
exports.PagingBaseComponent = PagingBaseComponent;
function getNavigationUrl(_a, item) {
    var match = _a.match, onRowRedirectUrl = _a.onRowRedirectUrl;
    if (onRowRedirectUrl) {
        return onRowRedirectUrl(item);
    }
    else if (match && item.Id) {
        return match.url + "/" + item.Id;
    }
    return null;
}
exports.getNavigationUrl = getNavigationUrl;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\PagingBaseComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\PagingBaseComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var NamedResource = (function (_super) {
    __extends(NamedResource, _super);
    function NamedResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NamedResource;
}(resource_1.default));
exports.NamedResource = NamedResource;
var NewNamedResource = (function () {
    function NewNamedResource() {
    }
    return NewNamedResource;
}());
exports.NewNamedResource = NewNamedResource;
exports.default = NamedResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\namedResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\namedResource.ts"); } } })();

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1648);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var specialVariables_1 = __webpack_require__(189);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var form_1 = __webpack_require__(16);
var PackageSelector_1 = __webpack_require__(53);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var Note_1 = __webpack_require__(20);
var CodeEditor_1 = __webpack_require__(107);
var ExternalLink_1 = __webpack_require__(26);
var clientInstance_1 = __webpack_require__(10);
var Chips_1 = __webpack_require__(24);
var VariableLookupText_1 = __webpack_require__(21);
var PackageDownloadOptions_1 = __webpack_require__(118);
var scriptingLanguage_1 = __webpack_require__(157);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var ExpandableFormSection_1 = __webpack_require__(30);
var ActionDetails_1 = __webpack_require__(25);
var resources_2 = __webpack_require__(17);
var RemoveItemsList_1 = __webpack_require__(84);
var Button_1 = __webpack_require__(47);
var DialogOpener_1 = __webpack_require__(110);
var ScriptPackageReferenceDialog_1 = __webpack_require__(428);
var _ = __webpack_require__(11);
var ListTitle_1 = __webpack_require__(196);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var getFeedName_1 = __webpack_require__(88);
var Fragment_1 = __webpack_require__(92);
var ScriptActionSummary = (function (_super) {
    __extends(ScriptActionSummary, _super);
    function ScriptActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feedNames: new Map(),
        };
        return _this;
    }
    ScriptActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var feedNames, _i, _a, feedId, feedName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        feedNames = new Map();
                        _i = 0, _a = this.props.packages.map(function (pkg) { return pkg.FeedId; });
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        feedId = _a[_i];
                        if (!feedId) return [3 /*break*/, 3];
                        return [4 /*yield*/, getFeedName_1.getFeedName(feedId)];
                    case 2:
                        feedName = _b.sent();
                        feedNames.set(feedId, feedName || feedId);
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.setState({ feedNames: feedNames });
                        return [2 /*return*/];
                }
            });
        });
    };
    ScriptActionSummary.prototype.render = function () {
        var runsOnServer = this.props.properties[specialVariables_1.default.Action.RunOnServer] === "true";
        var summary = [];
        if (this.props.worker) {
            summary.push(React.createElement("div", null,
                "Run a script on a Worker from pool  ",
                React.createElement(Chips_1.WorkerPoolChip, { workerPoolName: this.props.worker }),
                this.props.targetRolesAsCSV &&
                    React.createElement("span", null,
                        "on behalf of targets in ",
                        React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }))));
        }
        else {
            summary.push(runsOnServer
                ? React.createElement("div", null,
                    "Run a script on the Octopus Server ",
                    this.props.targetRolesAsCSV &&
                        React.createElement("span", null,
                            "on behalf of targets in ",
                            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })))
                : React.createElement("div", null,
                    "Run a script across targets in ",
                    React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
        }
        var packageContainingScript = resources_1.GetPrimaryPackageReference(this.props.packages);
        var packageReferences = resources_1.GetNamedPackageReferences(this.props.packages);
        if (!!packageContainingScript) {
            summary.push(React.createElement("div", null,
                "Script is contained in package ",
                this.packageAndFeed(packageContainingScript),
                packageReferences.length > 0
                    ? React.createElement("span", null,
                        " and ",
                        this.packageReferenceSummary(packageReferences))
                    : ""));
        }
        else {
            if (packageReferences.length > 0) {
                summary.push(React.createElement("div", null,
                    "Script ",
                    this.packageReferenceSummary(packageReferences)));
            }
        }
        return React.createElement("div", null, summary);
    };
    ScriptActionSummary.prototype.packageReferenceSummary = function (packageReferences) {
        var _this = this;
        if (packageReferences.length === 0) {
            return null;
        }
        if (packageReferences.length === 1) {
            return React.createElement("span", null,
                "references package ",
                this.packageAndFeed(packageReferences[0]));
        }
        if (packageReferences.length < 3) {
            return React.createElement(Fragment_1.Fragment, null,
                React.createElement("span", null, "references packages:"),
                packageReferences.map(function (pkg) {
                    return React.createElement("div", null, _this.packageAndFeed(pkg));
                }));
        }
        return React.createElement("span", null,
            "references ",
            packageReferences.length,
            " packages");
    };
    ScriptActionSummary.prototype.packageAndFeed = function (pkg) {
        return React.createElement("span", null,
            React.createElement("strong", null, pkg.PackageId),
            " from ",
            React.createElement("strong", null, this.state.feedNames.get(pkg.FeedId)));
    };
    return ScriptActionSummary;
}(BaseComponent_1.BaseComponent));
var PackageReferenceList = (function (_super) {
    __extends(PackageReferenceList, _super);
    function PackageReferenceList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageReferenceList;
}(RemoveItemsList_1.RemoveItemsList));
// Note: this is also used in the Azure PowerShell step and the ServiceFabric PowerShell step
var ScriptActionEdit = (function (_super) {
    __extends(ScriptActionEdit, _super);
    function ScriptActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.inlineScriptFormSections = function (runOnServer, localNames) {
            var properties = _this.props.properties;
            var packageReferences = resources_1.GetNamedPackageReferences(_this.props.packages);
            return React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: _this.props.expandedByDefault, errorKey: "Octopus.Action.Script.ScriptBody", title: "Inline Source Code", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: _this.scriptBodySummary(), help: _this.isPowershellOnly()
                        ? "Enter the body of the script that will be executed."
                        : "Select the script language and enter the body of the script that will be executed." },
                    React.createElement(Note_1.default, null,
                        "Scripts can contain ",
                        React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferences" }, "package references"),
                        " below and ",
                        React.createElement(ExternalLink_1.default, { href: "DocumentationVariables" }, "variables"),
                        " can be added by the ",
                        React.createElement("em", null, "Insert a variable"),
                        " button."),
                    packageReferences.length > 0 && React.createElement(Note_1.default, null,
                        "There are referenced packages. See the ",
                        React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferencesFromCustomScripts" }, "documentation"),
                        " for information on consuming packages from your scripts."),
                    !_this.isPowershellOnly() &&
                        React.createElement(ScriptingLanguageSelector_1.default, { supportedLanguages: _this.props.supportedLanguages, value: properties["Octopus.Action.Script.Syntax"], onlyRunnableOnServer: runOnServer && (!_this.props.additionalActions || !_this.props.additionalActions.workerPoolId), onChange: function (syntax) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.Syntax"] = syntax, _a));
                                var _a;
                            } }),
                    _this.isPowershellOnly() && React.createElement("h4", null, "PowerShell script"),
                    React.createElement(CodeEditor_1.VariableLookupCodeEditor, { localNames: localNames, projectId: _this.props.projectId, syntax: properties["Octopus.Action.Script.Syntax"], value: properties["Octopus.Action.Script.ScriptBody"], language: properties["Octopus.Action.Script.Syntax"], allowFullScreen: true, onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptBody"] = x, _a));
                            var _a;
                        } })),
                _this.packagesFormSection());
        };
        _this.packageScriptFormSections = function (localNamesWithPackageVariables) {
            var properties = _this.props.properties;
            var primaryPackage = resources_1.GetPrimaryPackageReference(_this.props.packages);
            var primaryPackageFeed = primaryPackage ? _.find(_this.state.feeds, function (f) { return f.Id === primaryPackage.FeedId; }) : null;
            return React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.FeedId|Octopus.Action.Package.PackageId|Octopus.Action.Script.ScriptFileName|Octopus.Action.Script.ScriptParameters", isExpandedByDefault: _this.props.expandedByDefault, title: "Script File in Package", summary: _this.scriptFileFromPackageSummary(), help: React.createElement("span", null, "Select the package containing your script") },
                    React.createElement(Note_1.default, null,
                        React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more"),
                        " about what your packages should contain, and how to create them."),
                    React.createElement(PackageSelector_1.default, { packageId: primaryPackage.PackageId, feedId: primaryPackage.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: _this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: _this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: _this.props.projectId, feeds: _this.state.feeds, localNames: _this.props.localNames, refreshFeeds: _this.loadFeeds }),
                    React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: primaryPackage.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                            return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                        }, feed: primaryPackageFeed, runOn: _this.props.runOn, projectId: _this.props.projectId, localNames: _this.props.localNames }),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: localNamesWithPackageVariables, projectId: _this.props.projectId, value: properties["Octopus.Action.Script.ScriptFileName"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptFileName"] = x, _a));
                            var _a;
                        }, error: _this.props.getFieldError("Octopus.Action.Script.ScriptFileName"), label: "Script file name" }),
                    React.createElement(Note_1.default, null,
                        "The relative path to the script file within the package.",
                        React.createElement("br", null),
                        "e.g. ",
                        React.createElement("code", null, "MyScript.ps1"),
                        " or ",
                        React.createElement("code", null, "Scripts\\MyScript.ps1")),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: localNamesWithPackageVariables, projectId: _this.props.projectId, value: properties["Octopus.Action.Script.ScriptParameters"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Script.ScriptParameters"] = x, _a));
                            var _a;
                        }, error: _this.props.getFieldError("Octopus.Action.Script.ScriptParameters"), label: "Script parameters" }),
                    _this.isPowershellOnly()
                        ? React.createElement(Note_1.default, null,
                            "Parameters expected by the script. Use platform specific calling convention.",
                            React.createElement("br", null),
                            "e.g. ",
                            React.createElement("code", null,
                                "-Path #", "{VariableStoringPath}"),
                            " for PowerShell")
                        : React.createElement(Note_1.default, null,
                            "Parameters expected by the script. Use platform specific calling convention.",
                            React.createElement("br", null),
                            "e.g. ",
                            React.createElement("code", null,
                                "-Path #", "{VariableStoringPath}"),
                            " for PowerShell or ",
                            React.createElement("code", null,
                                "-- #", "{VariableStoringPath}"),
                            " for ScriptCS")),
                _this.packagesFormSection());
        };
        _this.packagesFormSection = function () {
            var packageReferences = resources_1.GetNamedPackageReferences(_this.props.packages);
            return React.createElement(form_1.ExpandableFormSection, { title: _this.scriptSourceIsPackage() ? "Additional Packages" : "Referenced Packages", isExpandedByDefault: _this.props.expandedByDefault, errorKey: "Octopus.Action.Script.Packages", summary: _this.packageReferenceSummary(), help: _this.scriptSourceIsPackage()
                    ? "Add additional package references"
                    : "Add packages to be referenced by your scripts at execution-time" },
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferences" }, "package references"),
                    "."),
                React.createElement(PackageReferenceList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add", onClick: function () { return _this.addPackageReference(); } })], data: packageReferences, onRow: function (p) { return _this.packageReferenceListItem(p); }, onRowTouch: function (pkg) { return _this.editPackageReference(pkg); }, onRemoveRow: function (pkg) { return _this.removePackageReference(pkg); } }));
        };
        _this.packageReferenceSummary = function () {
            var namedPackageReferences = resources_1.GetNamedPackageReferences(_this.props.packages);
            var scriptSourceIsPackage = _this.scriptSourceIsPackage();
            if (namedPackageReferences.length === 0) {
                return form_1.Summary.placeholder(scriptSourceIsPackage ? "No additional packages referenced" : "No packages referenced");
            }
            return form_1.Summary.summary(namedPackageReferences.length + " package references");
        };
        _this.addPackageReference = function () {
            var additionalPackage = {
                Name: null,
                FeedId: null,
                PackageId: null,
                AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.Server,
                Properties: { Extract: "True" }
            };
            _this.setState({ editPackageReference: additionalPackage, editPackageReferenceIndex: null });
        };
        _this.editPackageReference = function (pkg) {
            _this.setState({
                editPackageReference: _.clone(pkg),
                editPackageReferenceIndex: _this.props.packages.indexOf(pkg)
            });
        };
        _this.removePackageReference = function (pkg) {
            var packages = _this.props.packages.slice();
            packages.splice(packages.indexOf(pkg), 1);
            _this.props.setPackages(packages);
        };
        _this.packageReferenceListItem = function (pkg) {
            var feed = _this.state.feeds.find(function (f) { return f.Id === pkg.FeedId; });
            return React.createElement("div", null,
                React.createElement(ListTitle_1.default, null, pkg.Name),
                React.createElement("div", null,
                    React.createElement("strong", null, pkg.PackageId),
                    " from feed ",
                    React.createElement("strong", null, !!feed ? feed.Name : pkg.FeedId),
                    React.createElement(Note_1.default, null,
                        "Extracted: ",
                        React.createElement("strong", null, pkg.Properties.Extract))));
        };
        _this.resetSelectedPackageReference = function () {
            _this.setState({
                editPackageReference: null,
                editPackageReferenceIndex: null
            });
        };
        _this.packageVariableNames = function () {
            return _.flatten(resources_1.GetNamedPackageReferences(_this.props.packages)
                .map(function (pkg) { return [
                "Octopus.Action.Package[" + pkg.Name + "].PackageId",
                "Octopus.Action.Package[" + pkg.Name + "].FeedId",
                "Octopus.Action.Package[" + pkg.Name + "].PackageVersion",
                "Octopus.Action.Package[" + pkg.Name + "].ExtractedPath",
                "Octopus.Action.Package[" + pkg.Name + "].PackageFilePath",
                "Octopus.Action.Package[" + pkg.Name + "].PackageFileName",
            ]; }));
        };
        _this.isPowershellOnly = function () {
            return _this.props.supportedLanguages === ScriptingLanguageSelector_1.SupportedLanguage.PowerShell;
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        var packageAcquisition = props.additionalActions && props.additionalActions.packageAcquisition;
        _this.state = {
            feeds: [],
            originalCanRunBeforeAcquisition: packageAcquisition ? packageAcquisition.canRunBeforeAcquisition : false,
            originalStepPackageRequirement: packageAcquisition ? packageAcquisition.stepPackageRequirement : resources_2.PackageRequirement.LetOctopusDecide,
            editPackageReference: null,
            editPackageReferenceIndex: null,
        };
        return _this;
    }
    ScriptActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        if (!this.props.properties["Octopus.Action.Script.ScriptSource"]) {
                            this.handleScriptSourceChanged("Inline", true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ScriptActionEdit.prototype.handleScriptSourceChanged = function (val, initialise) {
        if (initialise === void 0) { initialise = false; }
        var isRunFromPackage = val === "Package";
        var properties = (_a = {}, _a["Octopus.Action.Script.ScriptSource"] = val, _a);
        if (isRunFromPackage) {
            properties["Octopus.Action.Script.Syntax"] = null;
            properties["Octopus.Action.Script.ScriptBody"] = null;
            this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), initialise);
        }
        else {
            if (!this.props.properties["Octopus.Action.Script.Syntax"]) {
                properties["Octopus.Action.Script.Syntax"] = scriptingLanguage_1.ScriptingLanguage.PowerShell;
            }
            properties["Octopus.Action.Script.ScriptFileName"] = null;
            this.props.setPackages(resources_1.RemovePrimaryPackageReference(this.props.packages), initialise);
        }
        this.props.setProperties(properties, initialise);
        // if we are pulling the script from a package we might need to override things
        // if the user has set this step to run before package acquisition
        if (this.props.additionalActions) {
            if (isRunFromPackage) {
                this.props.additionalActions.packageAcquisition.onCanRunBeforeAcquisitionChanged(false);
            }
            else {
                this.props.additionalActions.packageAcquisition.onCanRunBeforeAcquisitionChanged(this.state.originalCanRunBeforeAcquisition);
            }
            if (this.state.originalStepPackageRequirement === resources_2.PackageRequirement.BeforePackageAcquisition) {
                var newValue = isRunFromPackage
                    ? resources_2.PackageRequirement.LetOctopusDecide
                    : this.state.originalStepPackageRequirement;
                this.props.additionalActions.packageAcquisition.onStepPackageRequirementChanged(newValue);
            }
        }
        var _a;
    };
    ScriptActionEdit.prototype.scriptSourceIsPackage = function () {
        return this.props.properties["Octopus.Action.Script.ScriptSource"] && this.props.properties["Octopus.Action.Script.ScriptSource"] === "Package";
    };
    ScriptActionEdit.prototype.scriptSourceSummary = function () {
        if (this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline") {
            return form_1.Summary.default("The script is defined below");
        }
        else {
            return form_1.Summary.summary("The script is contained in a package");
        }
    };
    ScriptActionEdit.prototype.scriptBodySummary = function () {
        if (!this.props.properties["Octopus.Action.Script.ScriptBody"]) {
            return form_1.Summary.placeholder("The script body has not been defined");
        }
        if (this.isPowershellOnly()) {
            return form_1.Summary.summary("The script body has been defined");
        }
        var syntax = this.props.properties["Octopus.Action.Script.Syntax"];
        if (syntax === scriptingLanguage_1.ScriptingLanguage.FSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "An ",
                React.createElement("strong", null, "F#"),
                " script has been defined"));
        }
        else if (syntax === scriptingLanguage_1.ScriptingLanguage.CSharp) {
            return form_1.Summary.summary(React.createElement("span", null,
                "A ",
                React.createElement("strong", null, "C#"),
                " script has been defined"));
        }
        return form_1.Summary.summary(React.createElement("span", null,
            "A ",
            React.createElement("strong", null, syntax),
            " script has been defined"));
    };
    ScriptActionEdit.prototype.scriptFileFromPackageSummary = function () {
        var packageContainingScript = resources_1.GetPrimaryPackageReference(this.props.packages);
        var fileName = this.props.properties["Octopus.Action.Script.ScriptFileName"];
        if (!packageContainingScript || !packageContainingScript.PackageId) {
            return form_1.Summary.placeholder("Select the package containing the script");
        }
        if (!fileName) {
            return form_1.Summary.placeholder("Enter the path to the script file");
        }
        var feed = this.state.feeds.find(function (f) { return f.Id === packageContainingScript.FeedId; });
        return form_1.Summary.summary(React.createElement("span", null,
            React.createElement("strong", null, fileName),
            " in package ",
            React.createElement("strong", null, packageContainingScript.PackageId),
            " from feed ",
            React.createElement("strong", null, !!feed ? feed.Name : packageContainingScript.FeedId)));
    };
    ScriptActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var runOnServer = this.props.properties
            && this.props.properties["Octopus.Action.RunOnServer"]
            && this.props.properties["Octopus.Action.RunOnServer"].toLowerCase() === "true";
        var localNames = _.concat(this.props.localNames ? this.props.localNames : [], this.packageVariableNames());
        var editPackageReferenceDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editPackageReference, onClose: this.resetSelectedPackageReference },
            React.createElement(ScriptPackageReferenceDialog_1.ScriptPackageReferenceDialog, { packageReference: this.state.editPackageReference, runOn: this.props.runOn, feeds: this.state.feeds, localNames: localNames, projectId: this.props.projectId, onChange: function (packageReference) { return _this.savePackageReference(packageReference); }, refreshFeeds: this.loadFeeds }));
        return React.createElement("div", null,
            editPackageReferenceDialog,
            React.createElement(form_1.FormSectionHeading, { title: "Script" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "scriptsource", isExpandedByDefault: this.props.expandedByDefault, title: "Script Source", summary: this.scriptSourceSummary(), help: "Select where the script is defined." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.Script.ScriptSource"], onChange: function (val) { return _this.handleScriptSourceChanged(val); } },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Inline source code (with optional package references)" }),
                    React.createElement(Note_1.default, null, "The script body is defined in the Inline Source Code field below, Referenced Packages below this"),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "Script file inside a package" }),
                    React.createElement(Note_1.default, null, "The script is contained in a package that will be deployed"))),
            properties["Octopus.Action.Script.ScriptSource"] === "Inline" && this.inlineScriptFormSections(runOnServer, localNames),
            properties["Octopus.Action.Script.ScriptSource"] === "Package" && this.packageScriptFormSections(localNames));
    };
    ScriptActionEdit.prototype.savePackageReference = function (packageReference) {
        var packageReferences = this.props.packages.slice();
        if (this.state.editPackageReferenceIndex === null) {
            packageReferences.push(packageReference);
        }
        else {
            packageReferences[this.state.editPackageReferenceIndex] = packageReference;
        }
        this.props.setPackages(packageReferences);
        this.resetSelectedPackageReference();
        return true;
    };
    ScriptActionEdit.defaultProps = {
        supportedLanguages: ScriptingLanguageSelector_1.SupportedLanguage.All
    };
    return ScriptActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ScriptActionEdit = ScriptActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.Script",
    summary: function (properties, targetRolesAsCSV, packages, worker) {
        return React.createElement(ScriptActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages, worker: worker });
    },
    edit: ScriptActionEdit,
    canHaveChildren: function (step) { return !!step.Properties[specialVariables_1.default.Action.TargetRoles]; },
    canBeChild: true,
    executionLocation: resources_1.ActionExecutionLocation.TargetOrServer,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) {
        if (action.Properties && action.Properties["Octopus.Action.Script.ScriptSource"] === "Package") {
            return true;
        }
        return false;
    },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables",
            "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\script\\scriptAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\script\\scriptAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.af93096ee4f17f3ce6d6363747b45e97.hashedasset.eot";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper_1 = __webpack_require__(490);
exports.default = StringHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\StringHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\StringHelper\\index.tsx"); } } })();

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateFormatter_1 = __webpack_require__(773);
exports.default = DateFormatter_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DateFormatter\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DateFormatter\\index.tsx"); } } })();

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InternalLink_1 = __webpack_require__(43);
exports.default = InternalLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\index.tsx"); } } })();

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Markdown_1 = __webpack_require__(132);
var styles = __webpack_require__(1819);
// This is purely to give us a styling wrapper for all resource descriptions (eg. when shown in lists etc).
var MarkdownDescription = function (props) {
    return props.markup ? React.createElement("div", { className: styles.description },
        React.createElement(Markdown_1.default, { markup: props.markup })) : null;
};
exports.default = MarkdownDescription;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MarkdownDescription\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MarkdownDescription\\index.tsx"); } } })();

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Tag_1 = __webpack_require__(308);
exports.default = Tag_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Tag\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Tag\\index.tsx"); } } })();

/***/ }),
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DimensionTypes;
(function (DimensionTypes) {
    DimensionTypes[DimensionTypes["None"] = 0] = "None";
    DimensionTypes[DimensionTypes["Release"] = 1] = "Release";
    DimensionTypes[DimensionTypes["Channel"] = 2] = "Channel";
    DimensionTypes[DimensionTypes["Environment"] = 3] = "Environment";
    DimensionTypes[DimensionTypes["Tenant"] = 4] = "Tenant";
    DimensionTypes[DimensionTypes["TagSet"] = 5] = "TagSet";
    DimensionTypes[DimensionTypes["Project"] = 6] = "Project";
    DimensionTypes[DimensionTypes["ProjectGroup"] = 7] = "ProjectGroup";
    DimensionTypes[DimensionTypes["ProjectName"] = 8] = "ProjectName"; //for filtering only
})(DimensionTypes || (DimensionTypes = {}));
exports.DimensionTypes = DimensionTypes;
var DimensionGetters = (_a = {},
    _a[DimensionTypes.Channel] = function (item) { return item.ChannelId; },
    _a[DimensionTypes.Release] = function (item) { return item.ReleaseId; },
    _a[DimensionTypes.Environment] = function (item) { return item.EnvironmentId; },
    _a[DimensionTypes.Tenant] = function (item) { return item.TenantId; },
    _a[DimensionTypes.Project] = function (item) { return item.ProjectId; },
    _a[DimensionTypes.None] = function (item) { return null; },
    _a);
exports.DimensionGetters = DimensionGetters;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataCube.tsx"); } } })();

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectActions = {
    PROJECT_FETCHED: "PROJECT_FETCHED",
    PROJECT_SAVED: "PROJECT_SAVED",
    PROJECT_STEPS_UPDATED: "PROJECT_STEPS_UPDATED",
    PROJECT_UPDATED: "PROJECT_UPDATED",
};
function projectFetched(state) {
    return { type: ProjectActions.PROJECT_FETCHED, state: state };
}
exports.projectFetched = projectFetched;
function projectSaved(newState) {
    return { type: ProjectActions.PROJECT_SAVED, state: newState };
}
exports.projectSaved = projectSaved;
function projectStepsUpdated(numberOfSteps) {
    var _this = this;
    // We need to update just the numberOfSteps property of our currentProject...
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var currentProject;
        return __generator(this, function (_a) {
            currentProject = getState().projectsArea.currentProject;
            dispatch(projectUpdated({
                id: currentProject.id,
                name: currentProject.name,
                description: currentProject.description,
                logoUrl: currentProject.logoUrl,
                isDisabled: currentProject.isDisabled,
                slug: currentProject.slug,
                numberOfSteps: numberOfSteps,
            }));
            return [2 /*return*/];
        });
    }); };
}
exports.projectStepsUpdated = projectStepsUpdated;
function projectUpdated(state) {
    return { type: ProjectActions.PROJECT_UPDATED, state: state };
}
exports.projectUpdated = projectUpdated;
var projectsArea = function (state, action) {
    if (state === void 0) { state = { currentProject: null }; }
    switch (action.type) {
        case ProjectActions.PROJECT_SAVED:
        case ProjectActions.PROJECT_FETCHED:
        case ProjectActions.PROJECT_STEPS_UPDATED:
        case ProjectActions.PROJECT_UPDATED:
            var project = action.state;
            return {
                currentProject: {
                    name: project.name,
                    description: project.description,
                    logoUrl: project.logoUrl,
                    id: project.id,
                    isDisabled: project.isDisabled,
                    numberOfSteps: project.numberOfSteps,
                    slug: project.slug
                },
            };
        default:
            return state;
    }
};
exports.default = projectsArea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\reducers\\projectsArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\reducers\\projectsArea.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DialogActions = {
    DIALOG_OPEN: "DIALOG_OPEN",
    DIALOG_CLOSE: "DIALOG_CLOSE"
};
function openDialog(key) {
    return { type: DialogActions.DIALOG_OPEN, key: key };
}
exports.openDialog = openDialog;
function onDialogClose() {
    return { type: DialogActions.DIALOG_CLOSE };
}
exports.onDialogClose = onDialogClose;
var dialogs = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case DialogActions.DIALOG_OPEN:
            var updated = {}; // only one open
            updated[action.key] = true;
            return updated;
        case DialogActions.DIALOG_CLOSE:
            return {}; // close all
    }
    return state;
};
exports.default = dialogs;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\reducers\\dialog.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\reducers\\dialog.ts"); } } })();

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper_1 = __webpack_require__(236);
var PageTitleHelper = (function () {
    function PageTitleHelper() {
    }
    PageTitleHelper.setPageTitle = function (title, breadcrumbTitle) {
        // This intentionally only sets the title if we're given one (don't set a default here). This lets us
        // call this helper in a fall-through style. ie. From our layouts first (via AreaTitle), then through to the
        // page (via PaperLayout).
        if (title && typeof title === "string" && title !== StringHelper_1.default.ellipsis) {
            var octopusDeploy = "Octopus Deploy";
            var pageTitle = octopusDeploy;
            // tslint:disable-next-line:prefer-conditional-expression
            if (breadcrumbTitle) {
                pageTitle = breadcrumbTitle + " > " + title + " - " + octopusDeploy; // Similar to TeamCity, show the most-relevant title first.
            }
            else {
                pageTitle = title + " - " + octopusDeploy; // Similar to TeamCity, show the most-relevant title first.
            }
            document.title = pageTitle;
        }
    };
    PageTitleHelper.setRootPageTitle = function () {
        document.title = "Octopus Deploy";
    };
    return PageTitleHelper;
}());
exports.default = PageTitleHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\PageTitleHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\PageTitleHelper\\index.tsx"); } } })();

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var Popover = (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popover.prototype.render = function () {
        return React.createElement(material_ui_1.Popover, __assign({ scrollableContainer: "window" }, this.props), this.props.children);
    };
    return Popover;
}(React.Component));
exports.default = Popover;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Popover\\Popover.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Popover\\Popover.tsx"); } } })();

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1271);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var react_router_1 = __webpack_require__(76);
var exposeComponentAsClass_1 = __webpack_require__(380);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var isUrlActive_1 = __webpack_require__(406);
var toPath_1 = __webpack_require__(1575);
var InternalNavLink = function (props) {
    var resolvedTo = resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId);
    /* tslint:disable:jsx-ban-elements */
    return React.createElement(react_router_dom_1.NavLink, { className: props.className, key: props.to, to: resolvedTo, exact: props.exact, isActive: function () { return isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, toPath_1.toPath(resolvedTo), props.exact); }, activeClassName: props.activeClassName }, props.children);
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(InternalNavLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalNavLink\\InternalNavLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalNavLink\\InternalNavLink.tsx"); } } })();

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(64);
var Feature;
(function (Feature) {
    Feature[Feature["MultiTenancy"] = 0] = "MultiTenancy";
    Feature[Feature["CommunityActionTemplates"] = 1] = "CommunityActionTemplates";
    Feature[Feature["BuiltInRepoSync"] = 2] = "BuiltInRepoSync";
})(Feature = exports.Feature || (exports.Feature = {}));
var FeatureToggle = function (props) {
    var featureStatus;
    switch (props.feature) {
        case Feature.MultiTenancy:
            featureStatus = props.features.isMultiTenancyEnabled;
            break;
        case Feature.CommunityActionTemplates:
            featureStatus = props.features.isCommunityActionTemplatesEnabled;
            break;
        case Feature.BuiltInRepoSync:
            featureStatus = props.features.isBuiltInRepoSyncEnabled;
            break;
    }
    if ((featureStatus && props.enabled) || (!featureStatus && !props.enabled)) {
        return (React.createElement("span", null, props.children));
    }
    return null;
};
FeatureToggle.defaultProps = { enabled: true };
var mapStateToProps = function (state) {
    return {
        features: state.configurationArea.features
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(FeatureToggle);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureToggle\\FeatureToggle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureToggle\\FeatureToggle.tsx"); } } })();

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var KeyboardHandler_1 = __webpack_require__(377);
var BaseComponent_1 = __webpack_require__(12);
var FormComponent = (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onEnter = function (event) {
            var target = event.target ? event.target : event.srcElement;
            var tagName = target.tagName;
            if (tagName.toUpperCase() === "INPUT") {
                _this.props.onFormSubmit();
                return true;
            }
            return false;
        };
        _this.onCtrlEnter = function (event) {
            _this.props.onFormSubmit();
            return true;
        };
        return _this;
    }
    FormComponent.prototype.render = function () {
        var keyboardRegistrations = [
            { key: KeyboardHandler_1.Key.Enter, onKeyPressed: this.onEnter },
            { key: KeyboardHandler_1.Key.CtrlEnter, onKeyPressed: this.onCtrlEnter },
        ];
        return React.createElement("div", { style: { width: "100%" }, className: this.props.className },
            React.createElement(KeyboardHandler_1.default, { registrations: keyboardRegistrations, className: this.props.className }, this.props.children));
    };
    return FormComponent;
}(BaseComponent_1.BaseComponent));
exports.default = FormComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormComponent\\FormComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormComponent\\FormComponent.tsx"); } } })();

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeploymentStepResource = (function () {
    function DeploymentStepResource() {
    }
    return DeploymentStepResource;
}());
exports.DeploymentStepResource = DeploymentStepResource;
var StartTrigger;
(function (StartTrigger) {
    StartTrigger["StartWithPrevious"] = "StartWithPrevious";
    StartTrigger["StartAfterPrevious"] = "StartAfterPrevious";
})(StartTrigger = exports.StartTrigger || (exports.StartTrigger = {}));
var RunCondition;
(function (RunCondition) {
    RunCondition["Success"] = "Success";
    RunCondition["Failure"] = "Failure";
    RunCondition["Always"] = "Always";
    RunCondition["Variable"] = "Variable";
})(RunCondition = exports.RunCondition || (exports.RunCondition = {}));
var PackageRequirement;
(function (PackageRequirement) {
    PackageRequirement["LetOctopusDecide"] = "LetOctopusDecide";
    PackageRequirement["BeforePackageAcquisition"] = "BeforePackageAcquisition";
    PackageRequirement["AfterPackageAcquisition"] = "AfterPackageAcquisition";
})(PackageRequirement = exports.PackageRequirement || (exports.PackageRequirement = {}));
exports.default = DeploymentStepResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentStepResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentStepResource.ts"); } } })();

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentValue = function (id) {
    return localStorage.getItem("NotificationItemValue-" + id);
};
exports.getCurrentValue = getCurrentValue;
var setCurrentValue = function (id, value) {
    if (value === void 0) { value = new Date() + ""; }
    localStorage.setItem("NotificationItemValue-" + id, value);
};
exports.setCurrentValue = setCurrentValue;
var clearValue = function (id) {
    localStorage.removeItem("NotificationItemValue-" + id);
};
exports.clearValue = clearValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\notificationLocalState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\notificationLocalState.ts"); } } })();

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Environment = (function () {
    function Environment() {
    }
    Environment.isInDevelopmentMode = function () {
        return !"production" || "production" !== "production";
    };
    return Environment;
}());
exports.default = Environment;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\environment.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\environment.ts"); } } })();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var logger_1 = __webpack_require__(102);
var ErrorPanel_1 = __webpack_require__(85);
var clientInstance_1 = __webpack_require__(10);
var StackTrace = __webpack_require__(1282);
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.stringify = function (frame) {
            var normalizedFrame = __assign({}, frame, { fileName: _this.normalizeFileName(frame.fileName) });
            return normalizedFrame.functionName + " (" + normalizedFrame.fileName + ":" + normalizedFrame.lineNumber + ":" + normalizedFrame.columnNumber + ")";
        };
        _this.state = {};
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        logger_1.default.error(error);
        logger_1.default.error(errorInfo);
        this.setState({ error: { originalError: error, info: errorInfo } });
        this.mapToOriginalSourceCode(error);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error) {
            return React.createElement(ErrorPanel_1.default, { message: "An unexpected error occurred in Octopus v" + clientInstance_1.client.version + ": \"" + this.state.error.originalError.name + ": " + this.state.error.originalError.message + "\"", details: this.state.error.info.componentStack.split("\n").slice(1), fullException: this.state.error.mappedStackTrace || this.state.error.originalError.stack });
        }
        return this.props.children;
    };
    ErrorBoundary.prototype.mapToOriginalSourceCode = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var frames, mappedStackTrace;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, StackTrace.fromError(error)];
                    case 1:
                        frames = _a.sent();
                        mappedStackTrace = error.stack.split("\n")[0] + "\n\n" + frames.map(this.stringify).join("\n");
                        this.setState(function (prevState) { return (__assign({}, prevState, { error: __assign({}, prevState.error, { mappedStackTrace: mappedStackTrace }) })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ErrorBoundary.prototype.normalizeFileName = function (fileName) {
        var index = Math.max(fileName.indexOf("/app"), fileName.indexOf("/node_modules"));
        if (index === -1) {
            return fileName;
        }
        return fileName.substr(index);
    };
    return ErrorBoundary;
}(React.Component));
exports.default = ErrorBoundary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorBoundary\\ErrorBoundary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorBoundary\\ErrorBoundary.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1255);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1527);
var InputLabel = function (props) {
    return React.createElement("div", { className: styles.label }, props.label);
};
exports.default = InputLabel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InputLabel\\InputLabel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InputLabel\\InputLabel.tsx"); } } })();

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var InsertVariableButton_1 = __webpack_require__(1533);
var React = __webpack_require__(0);
var styles = __webpack_require__(1552);
function withVariableLookup() {
    return function (Comp) { return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var _this = this;
            var _a = this.props, localNames = _a.localNames, projectId = _a.projectId, syntax = _a.syntax, textInputRef = _a.textInputRef, wide = _a.wide, otherProps = __rest(_a, ["localNames", "projectId", "syntax", "textInputRef", "wide"]);
            return React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.wide },
                    React.createElement(Comp, __assign({ key: "component", textInputRef: function (ref) { return _this.textInputRef = ref; } }, otherProps))),
                React.createElement("div", { key: "buttons", className: styles.buttons },
                    React.createElement(InsertVariableButton_1.default, { syntax: this.props.syntax, projectId: this.props.projectId, localNames: this.props.localNames, onSelected: function (v) { return _this.insert(v); } })));
        };
        class_1.prototype.insert = function (val) {
            if (this.textInputRef) {
                this.textInputRef.insertAtCursor(val);
                this.textInputRef.focus();
            }
        };
        return class_1;
    }(React.Component)); };
}
exports.withVariableLookup = withVariableLookup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookup\\VariableLookup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookup\\VariableLookup.tsx"); } } })();

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1591);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var styles = __webpack_require__(117);
var uiTestClasses_1 = __webpack_require__(86);
var cn = __webpack_require__(19);
var FormSectionBase = (function (_super) {
    __extends(FormSectionBase, _super);
    function FormSectionBase(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleShowMoreInfo = function (e) {
            e.preventDefault();
            e.stopPropagation(); //prevent clicking the link toggling the panel
            _this.setState(function (state) { return ({ moreInformationExpanded: !state.moreInformationExpanded }); });
        };
        _this.handleMoreInfoClick = function (content) {
            _this.setState({
                moreInformationExpanded: true,
                moreInformation: content
            });
        };
        _this.hideMoreInfo = function (e) {
            e.preventDefault();
            _this.setState({
                moreInformationExpanded: false
            });
        };
        _this.isMoreInfo = function (child) {
            return child.props && child.props.hasOwnProperty("isMoreInfo");
        };
        _this.renderChild = function (child) {
            if (!child) {
                return child;
            }
            var children = child.props && child.props.children
                ? { children: _this.renderChildren(child.props.children) }
                : null;
            if (_this.isMoreInfo(child)) {
                return React.cloneElement(child, __assign({}, child.props, { onClick: _this.handleMoreInfoClick }));
            }
            if (_this.alterChild) {
                child = _this.alterChild(child);
            }
            var props = children ? __assign({}, child.props, children) : child.props;
            return React.isValidElement(child) ? React.cloneElement(child, props) : child;
        };
        _this.renderChildren = function (children) {
            return React.Children.map(children, _this.renderChild);
        };
        _this.state = {
            moreInformationExpanded: false,
            moreInformation: null
        };
        return _this;
    }
    FormSectionBase.prototype.title = function (title, subtitle) {
        return React.createElement("div", { className: styles.cardTitleContainer },
            React.createElement("span", { className: uiTestClasses_1.formSectionTitleClass + " " + styles.cardTitle }, title),
            subtitle);
    };
    FormSectionBase.prototype.help = function (help) {
        return React.createElement("span", { className: cn(styles.cardSubTitle, this.props.forceMobileBehaviour && styles.cardSubTitleForceMobile) }, this.renderChild(help || React.createElement("div", null)));
    };
    FormSectionBase.prototype.body = function (className, expandable) {
        return React.createElement(Card_1.CardMedia, { className: uiTestClasses_1.formSectionBodyClass + " " + className, expandable: expandable },
            React.createElement("div", null, this.renderChildren(this.props.children)));
    };
    FormSectionBase.prototype.moreInformation = function () {
        return this.state.moreInformationExpanded
            ? React.createElement("div", { className: styles.moreInformation },
                React.createElement("div", { className: styles.hide },
                    React.createElement("a", { href: "#", onClick: this.hideMoreInfo }, "hide")),
                this.state.moreInformation)
            : React.createElement("span", null);
    };
    return FormSectionBase;
}(React.Component));
exports.FormSectionBase = FormSectionBase;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSectionBase.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSectionBase.tsx"); } } })();

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// The visibility of dialogs is stored in the Redux store so we need make sure each dialog is identified by
// a unique value. Otherwise, we risk opening multiple unrelated dialogs at the same time.
var UniqueSequenceGenerator_1 = __webpack_require__(404);
var DialogIdGenerator = (function () {
    function DialogIdGenerator() {
        this.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    }
    DialogIdGenerator.prototype.next = function () {
        return this.sequence.next().toString();
    };
    return DialogIdGenerator;
}());
var dialogIdGenerator = new DialogIdGenerator();
exports.default = dialogIdGenerator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\dialogIdGenerator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\dialogIdGenerator.ts"); } } })();

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1993);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(26);
var AzureServerTargetRolesInfo = function (props) {
    return props.stepTargetRoles
        ? React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "Ensure you have at least one active deployment target matching the selected role(s) at the time of your deployment.",
            props.isCompatibleWithCloudRegions && React.createElement("span", null,
                React.createElement(ExternalLink_1.default, { href: "CloudRegionTargets" }, "Cloud Region targets"),
                " can be used when deploying cloud applications to multiple geographic regions."))
        : null;
};
exports.default = AzureServerTargetRolesInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzureServerTargetRolesInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzureServerTargetRolesInfo.tsx"); } } })();

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(49);
var BaseLayout_1 = __webpack_require__(2058);
var DialogFrames_1 = __webpack_require__(2062);
var Fragment_1 = __webpack_require__(92);
var PermissionCheck_1 = __webpack_require__(42);
var BusyIndicator_1 = __webpack_require__(95);
var BusyFromPromise_1 = __webpack_require__(161);
var ErrorPanel_1 = __webpack_require__(85);
var DialogTitleBar_1 = __webpack_require__(2065);
var cn = __webpack_require__(19);
var recompose_1 = __webpack_require__(186);
var styles = __webpack_require__(2068);
function isButtonDisabled(flag, savePermission) {
    var disabledDueToPermission = !!savePermission ? !PermissionCheck_1.isAllowed(savePermission) : false;
    return !!(flag || disabledDueToPermission);
}
var continueIf = function (predicate, action) {
    return function () { return predicate().then(function (x) {
        if (x) {
            action();
        }
        return x;
    }); };
};
var DialogContent = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: cn(styles.content, className) }, children);
};
exports.SaveDialogActions = function (_a) {
    var _b = _a.cancelButtonLabel, cancelButtonLabel = _b === void 0 ? "Cancel" : _b, _c = _a.saveButtonLabel, saveButtonLabel = _c === void 0 ? "Save" : _c, _d = _a.saveDisabled, saveDisabled = _d === void 0 ? false : _d, rest = __rest(_a, ["cancelButtonLabel", "saveButtonLabel", "saveDisabled"]);
    return React.createElement(Fragment_1.Fragment, null,
        React.createElement(ActionButton_1.default, { label: cancelButtonLabel, onClick: rest.close, type: ActionButton_1.ActionButtonType.Secondary }),
        React.createElement(ActionButton_1.default, { label: saveButtonLabel, onClick: continueIf(rest.onSaveClick, rest.close), type: ActionButton_1.ActionButtonType.Save, disabled: isButtonDisabled(saveDisabled, rest.savePermission) }));
};
exports.SaveDialogTitleBar = recompose_1.defaultProps({ title: "Edit Details" })(DialogTitleBar_1.default);
var CustomSaveDialogLayout = function (_a) {
    var _b = _a.frame, Frame = _b === void 0 ? DialogFrames_1.HugeDialogFrame : _b, busy = _a.busy, errors = _a.errors, _c = _a.renderTitle, RenderTitle = _c === void 0 ? exports.SaveDialogTitleBar : _c, _d = _a.renderActions, RenderActions = _d === void 0 ? exports.SaveDialogActions : _d, open = _a.open, close = _a.close, props = __rest(_a, ["frame", "busy", "errors", "renderTitle", "renderActions", "open", "close"]);
    return React.createElement(BaseLayout_1.default, { open: open, close: close, render: function (renderProps) {
            return React.createElement(Frame, null,
                RenderTitle && React.createElement(RenderTitle, __assign({}, renderProps, { onSaveClick: props.onSaveClick, savePermission: props.savePermission })),
                busy && React.createElement(BusyFromPromise_1.default, { promise: busy }, function (isBusy) { return React.createElement(BusyIndicator_1.default, { show: isBusy }); }),
                errors && React.createElement(ErrorPanel_1.default, { message: errors.message, details: errors.details }),
                React.createElement(DialogContent, null, props.children),
                RenderActions && React.createElement(RenderActions, __assign({}, renderProps, { onSaveClick: props.onSaveClick, savePermission: props.savePermission })));
        } });
};
exports.CustomSaveDialogLayout = CustomSaveDialogLayout;
exports.default = CustomSaveDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\SaveDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\SaveDialogLayout.tsx"); } } })();

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberRegex = /^\d+$/;
/**
 * http://yaml.org/type/bool.html
 */
exports.BooleanRegex = /^(true|True|TRUE|false|False|FALSE)$/;
exports.KubernetesResourceQuantityRegex = /^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$/;
exports.KubernetesNameRegex = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?$/;
exports.KubernetesWildcardIngressHostRegex = /^\*\.[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/;
exports.KubernetesIngressHostRegex = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesValidation.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesValidation.ts"); } } })();

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var resources_1 = __webpack_require__(17);
var awsLoginComponent_1 = __webpack_require__(194);
var CodeEditor_1 = __webpack_require__(107);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(30);
var Note_1 = __webpack_require__(20);
var RadioButton_1 = __webpack_require__(32);
var OpenDialogButton_1 = __webpack_require__(72);
var PackageSelector_1 = __webpack_require__(53);
var RadioButtonGroup_1 = __webpack_require__(36);
var clientInstance_1 = __webpack_require__(10);
var DynamicForm_1 = __webpack_require__(502);
var VariableLookupText_1 = __webpack_require__(21);
var ExternalLink_1 = __webpack_require__(26);
var StringCheckbox_1 = __webpack_require__(41);
var UnstructuredFormSection_1 = __webpack_require__(475);
var sourceCodeDialog_1 = __webpack_require__(429);
var TerraformActionEdit = (function (_super) {
    __extends(TerraformActionEdit, _super);
    function TerraformActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: []
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus" };
        return _this;
    }
    TerraformActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c, _d, _e, _f, _g;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.AssumeRole"] = "False", _c), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                                            this.props.setProperties((_d = {}, _d["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _d), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Terraform.ManagedAccount"]) {
                                            this.props.setProperties((_e = {}, _e["Octopus.Action.Terraform.ManagedAccount"] = "None", _e), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"]) {
                                            this.props.setProperties((_f = {}, _f["Octopus.Action.Terraform.AllowPluginDownloads"] = "True", _f), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Script.ScriptSource"]) {
                                            this.props.setProperties((_g = {}, _g["Octopus.Action.Script.ScriptSource"] = "Inline", _g), true);
                                        }
                                        _a = this.setState;
                                        _b = {};
                                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        _a.apply(this, [(_b.accounts = _h.sent(),
                                                _b)]);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    TerraformActionEdit.prototype.componentWillMount = function () {
        if (this.props.properties["Octopus.Action.Script.ScriptSource"] &&
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline") {
            this.refreshParametersFromTemplate(this.props.properties["Octopus.Action.Terraform.Template"]);
        }
    };
    TerraformActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Script.ScriptSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    TerraformActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Script.ScriptSource"] = value,
            _a["Octopus.Action.Terraform.Template"] = "",
            _a["Octopus.Action.Terraform.TemplateParameters"] = "",
            _a));
        // If the inline option is selected, we clear out the package selection
        if (value === "Inline") {
            this.props.setPackages(resources_1.RemovePrimaryPackageReference(this.props.packages));
        }
        else {
            this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages));
        }
        var _a;
    };
    TerraformActionEdit.prototype.optionsSummary = function () {
        return form_1.Summary.summary(React.createElement("span", null,
            this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"] === "True" &&
                React.createElement("span", null, "Allowing additional plugins downloads"),
            this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"] !== "True" &&
                React.createElement("span", null, "Preventing additional plugins downloads"),
            this.props.properties["Octopus.Action.Terraform.PluginsDirectory"] &&
                this.props.properties["Octopus.Action.Terraform.PluginsDirectory"].trim() &&
                React.createElement("span", null,
                    " to the custom plugin cache directory of ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.Terraform.PluginsDirectory"].trim())),
            this.props.properties["Octopus.Action.Terraform.Workspace"] &&
                React.createElement("span", null,
                    ", and using the ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.Terraform.Workspace"]),
                    " workspace")));
    };
    TerraformActionEdit.prototype.render = function () {
        var _this = this;
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Managed Account" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Terraform.ManagedAccount", isExpandedByDefault: this.props.expandedByDefault, title: "Managed Account", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.managedAccountSummary(), help: "Select the managed account to use." },
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Terraform.ManagedAccount"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.ManagedAccount"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Terraform.ManagedAccount") },
                    React.createElement(RadioButton_1.default, { value: "None", label: "None" }),
                    React.createElement(RadioButton_1.default, { value: "AWS", label: "AWS Account" })),
                React.createElement(Note_1.default, null, "You can optionally prepare the environment that Terraform runs in using the details defined in an account managed by Octopus. If an account is selected then those credentials do not need to be included in the Terraform template.")),
            this.props.properties["Octopus.Action.Terraform.ManagedAccount"] === "AWS" &&
                React.createElement("div", null,
                    React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region", isExpandedByDefault: this.props.expandedByDefault, title: "Region", summary: this.regionSummary(), help: "Specify the default region" },
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                        React.createElement(Note_1.default, null,
                            "View the ",
                            React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                            " documentation for a current list of the available region codes."))),
            React.createElement(FormSectionHeading_1.default, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Script.ScriptSource|Octopus.Action.Terraform.Template", isExpandedByDefault: this.props.expandedByDefault, title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(Note_1.default, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Script.ScriptSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Aws.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Terraform.Template"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Terraform.Template"], language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Terraform.Template"] ? "Edit Source Code" : "Add Source Code", wideDialog: true, renderDialog: function (openProps) {
                                return React.createElement(sourceCodeDialog_1.default, { open: openProps.open, close: openProps.closeDialog, template: _this.props.properties["Octopus.Action.Terraform.Template"], doBusyTask: _this.props.doBusyTask, saveDone: function (template, metadata) {
                                        _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.Template"] = template, _a));
                                        _this.refreshParametersFromMetadata(metadata);
                                        var _a;
                                    }, textFormat: CodeEditor_1.TextFormat.JSON, metadata: "Terraform" });
                            } })))),
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.FeedId|Octopus.Action.Package.PackageId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds }),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.TemplateDirectory"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.TemplateDirectory"] = x, _a));
                            var _a;
                        }, label: "Terraform template directory", error: this.props.getFieldError("Octopus.Action.Terraform.TemplateDirectory") }),
                    React.createElement(Note_1.default, null, "Specify the optional directory in the package from which Terraform will be run."),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.FileSubstitution"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.FileSubstitution"] = x, _a));
                            var _a;
                        }, label: "Target files", error: this.props.getFieldError("Octopus.Action.Terraform.FileSubstitution"), multiLine: true }),
                    React.createElement(Note_1.default, null,
                        "A newline-separated list of file names to transform (in addition to all ",
                        React.createElement("em", null, "*.tf"),
                        ", ",
                        React.createElement("em", null, "*.tfvars"),
                        ", ",
                        React.createElement("em", null, "*.tf.json"),
                        " and ",
                        React.createElement("em", null, "*.tfvars.json"),
                        " files), relative to the package contents. Extended wildcard syntax is supported. E.g., ",
                        React.createElement("em", null, "Notes.txt"),
                        ", ",
                        React.createElement("em", null, "Config\\*.json"),
                        ", ",
                        React.createElement("em", null, "**\\specific-folder\\*.config."),
                        React.createElement("br", null),
                        "This field supports extended template syntax. Conditional ",
                        React.createElement("code", null, "if"),
                        " and ",
                        React.createElement("code", null, "unless"),
                        ":",
                        React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                        "Iteration over variable sets or comma-separated values with ",
                        React.createElement("code", null, "each"),
                        ":",
                        React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.VarFiles"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.VarFiles"] = x, _a));
                            var _a;
                        }, label: "Additional variable files", error: this.props.getFieldError("Octopus.Action.Terraform.VarFiles"), multiLine: true }),
                    React.createElement(Note_1.default, null,
                        "An optional newline-separated list of files that are passed as ",
                        React.createElement("strong", null, "-var-file"),
                        " parameters. Note that files called ",
                        React.createElement("strong", null, "terraform.tfvars"),
                        ", ",
                        React.createElement("strong", null, "terraform.tfvars.json"),
                        ",",
                        React.createElement("strong", null, "*.auto.tfvars"),
                        " and ",
                        React.createElement("strong", null, "*.auto.tfvars.json"),
                        " are automatically loaded by Terraform, and do not need to be listed here. Each line in this text area is passed as an individual ",
                        React.createElement("strong", null, "-var-file"),
                        " parameter."))),
            this.props.properties["Octopus.Action.Script.ScriptSource"] === "Inline" && this.state.parameterTypes && React.createElement("div", null,
                React.createElement(FormSectionHeading_1.default, { title: "Variables" }),
                React.createElement(UnstructuredFormSection_1.default, null,
                    React.createElement(Note_1.default, null, "Terraform variables are either strings, lists or maps."),
                    React.createElement(Note_1.default, null,
                        "Strings (including numbers and true/false) are supplied without quotes e.g. ",
                        React.createElement("strong", null, "my string"),
                        ", ",
                        React.createElement("strong", null, "true"),
                        " or ",
                        React.createElement("strong", null, "3.1415"),
                        ". Lists and maps are supplied as raw HCL or JSON structures, depending on the format of the template. For example, if the template is written in HCL, a list variable would be provided as ",
                        React.createElement("strong", null,
                            "[\"item1\", ",
                            "{",
                            "item2=\"embedded map\"",
                            "}",
                            "]"),
                        " and a map variable would be provided as ",
                        React.createElement("strong", null,
                            "{",
                            "item1=\"hi\", item2=\"there\"",
                            "}"),
                        ". If the template is written is JSON, a list variable would be provided as ",
                        React.createElement("strong", null,
                            "[\"item1\", ",
                            "{",
                            "\"item2\": \"embedded map\" ",
                            "}",
                            "]"),
                        " and a map variable would be provided as ",
                        React.createElement("strong", null,
                            "{",
                            "\"item1\": \"hi\", \"item2\": \"there\"",
                            "}"),
                        ".")),
                React.createElement(DynamicForm_1.default, { types: this.state.parameterTypes, values: this.state.parameterValues, isBindable: true, onChange: function (data) { return _this.updateParameters(data); }, getBoundFieldProps: function () { return ({ projectId: _this.props.projectId, localNames: _this.props.localNames }); } })),
            React.createElement(FormSectionHeading_1.default, { title: "Advanced Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Terraform.PreventDownload|Octopus.Action.Terraform.PluginsDirectory", isExpandedByDefault: this.props.expandedByDefault, title: "Terraform Options", help: "Specify the optional advanced options for Terraform", summary: this.optionsSummary() },
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Terraform workspace", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.Workspace"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.Workspace"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Terraform.Workspace") }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.PluginsDirectory"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.PluginsDirectory"] = x, _a));
                        var _a;
                    }, label: "Terraform plugin cache directory", error: this.props.getFieldError("Octopus.Action.Terraform.PluginsDirectory") }),
                React.createElement(Note_1.default, null, "Specify the optional directory that holds the Terraform plugins. This is useful when you want targets to share plugins instead of downloading their own local copy."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: this.props.properties["Octopus.Action.Terraform.AllowPluginDownloads"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AllowPluginDownloads"] = x, _a));
                        var _a;
                    }, label: "Allow additional plugin downloads", note: React.createElement("span", null, "Selecting this option allows Terraform to download plugins that are not found.") }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.AdditionalInitParams"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AdditionalInitParams"] = x, _a));
                        var _a;
                    }, label: "Custom terraform init parameters", error: this.props.getFieldError("Octopus.Action.Terraform.AdditionalInitParams") }),
                React.createElement(Note_1.default, null,
                    "An optional list of additional parameters to pass to the ",
                    React.createElement("strong", null, "terraform init"),
                    " command."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Terraform.AdditionalActionParams"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.AdditionalActionParams"] = x, _a));
                        var _a;
                    }, label: React.createElement("span", null,
                        "Custom terraform ",
                        this.props.actionName,
                        " parameters"), error: this.props.getFieldError("Octopus.Action.Terraform.AdditionalActionParams") }),
                React.createElement(Note_1.default, null,
                    "An optional list of additional parameters to pass to the ",
                    React.createElement("strong", null,
                        "terraform ",
                        this.props.actionName),
                    " command.")));
    };
    TerraformActionEdit.prototype.regionSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.Region"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.Region"]),
                " as the default region"));
        }
        return form_1.Summary.placeholder("Specify the default AWS region");
    };
    TerraformActionEdit.prototype.managedAccountSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Terraform.ManagedAccount"] && properties["Octopus.Action.Terraform.ManagedAccount"] !== "None") {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using an ",
                React.createElement("strong", null, properties["Octopus.Action.Terraform.ManagedAccount"]),
                " account"));
        }
        return form_1.Summary.summary("Not using an account");
    };
    TerraformActionEdit.prototype.refreshParametersFromTemplate = function (template) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.CloudTemplates.getMetadata(template, "Terraform")];
                    case 1:
                        response = _a.sent();
                        this.refreshParametersFromMetadata(response);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TerraformActionEdit.prototype.refreshParametersFromMetadata = function (metadataResponse) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var storedParameters, _a;
            return __generator(this, function (_b) {
                storedParameters = this.flattenParameters();
                Object.keys(metadataResponse.Values).forEach(function (key) {
                    if (typeof storedParameters[key] !== "undefined") {
                        metadataResponse.Values[key] = storedParameters[key];
                    }
                });
                this.props.setProperties((_a = {},
                    _a["Octopus.Action.Terraform.TemplateParameters"] = JSON.stringify(metadataResponse.Values),
                    _a));
                this.setState({ parameterTypes: metadataResponse.Metadata.Types, parameterValues: metadataResponse.Values });
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * Takes the JSON representation of the variables (i.e. the tool specific format, in this case terraform)
     * and returns the flat data structure used by the dynamic form.
     * @returns {DataContext} The variable information for the dynamic form
     */
    TerraformActionEdit.prototype.flattenParameters = function () {
        try {
            if (this.props.properties["Octopus.Action.Terraform.TemplateParameters"]) {
                return JSON.parse(this.props.properties["Octopus.Action.Terraform.TemplateParameters"]);
            }
        }
        catch (ex) {
            // this.props.properties["Octopus.Action.Terraform.TemplateParametersRaw"] probably isn't
            // valid JSON, so return the empty data context.
        }
        return {};
    };
    /**
     * Takes the dynamic form variable information, and saves it in the tool specific JSON representation.
     * @param {DataContext} data The dynamic form variable data
     */
    TerraformActionEdit.prototype.updateParameters = function (data) {
        this.props.setProperties((_a = {}, _a["Octopus.Action.Terraform.TemplateParameters"] = JSON.stringify(data), _a));
        this.setState({ parameterTypes: this.state.parameterTypes, parameterValues: data });
        var _a;
    };
    return TerraformActionEdit;
}(BaseComponent_1.BaseComponent));
exports.default = TerraformActionEdit;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1736);
var ActionList = function (props) {
    var centerStyle = props.center ? { justifyContent: "center" } : {};
    return React.createElement("div", { className: styles.actionList, style: { centerStyle: centerStyle } }, props.actions.map(function (action, index) { return !action ? null : React.cloneElement(action, __assign({}, action.props, { key: index })); }));
};
ActionList.displayName = "ActionList";
exports.default = ActionList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionList\\ActionList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionList\\ActionList.tsx"); } } })();

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FlatButton_1 = __webpack_require__(115);
var styles = __webpack_require__(1723);
var cn = __webpack_require__(19);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var Text_1 = __webpack_require__(50);
var ToolTip_1 = __webpack_require__(201);
var MarkdownProvider_1 = __webpack_require__(1725);
var VariableLookup_1 = __webpack_require__(288);
var MarkdownEditor = (function (_super) {
    __extends(MarkdownEditor, _super);
    function MarkdownEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            _this.callValidateAndChange(value);
        };
        _this.getInputState = function () {
            var value = _this.props.value == null ? "" : _this.props.value;
            var selection = _this.text.getSelection();
            return new MarkdownProvider_1.MarkdownProvider(value, selection.start, selection.end);
        };
        _this.setInputState = function (value, selectionStart, selectionEnd) {
            var selection = {
                start: selectionStart,
                end: selectionEnd
            };
            _this.text.setValueAndSelection(selection, value);
            _this.text.focus();
        };
        _this.bold = function () {
            _this.getInputState()
                .insertBefore("**")
                .insertAfter("**")
                .emptySelectionText("Bold text")
                .apply(_this.setInputState);
        };
        _this.italic = function () {
            _this.getInputState()
                .insertBefore("_")
                .insertAfter("_")
                .emptySelectionText("Italic text")
                .apply(_this.setInputState);
        };
        _this.bullet = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("- ")
                .emptySelectionText("List item")
                .apply(_this.setInputState);
        };
        _this.number = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("1. ")
                .emptySelectionText("List item")
                .apply(_this.setInputState);
        };
        _this.quote = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("> ")
                .insertAfterNewlineInSelection("> ")
                .emptySelectionText("Quoted text")
                .apply(_this.setInputState);
        };
        _this.code = function () {
            _this.getInputState()
                .surroundWithNewlines()
                .insertBefore("```\n")
                .insertAfter("\n```")
                .emptySelectionText("Code")
                .apply(_this.setInputState);
        };
        _this.link = function () {
            var url = prompt("Please enter a url for the link:", "http://");
            if (url) {
                _this.getInputState()
                    .insertBefore("[")
                    .insertAfter("](" + url + ")")
                    .emptySelectionText("Enter link description here")
                    .apply(_this.setInputState);
            }
        };
        _this.image = function () {
            var url = prompt("Please enter a url for the image:", "http://");
            if (url) {
                _this.getInputState()
                    .insertBefore("![")
                    .insertAfter("](" + url + ")")
                    .emptySelectionText("Enter image description here")
                    .apply(_this.setInputState);
            }
        };
        _this.state = {
            error: null,
            showExternalError: true
        };
        return _this;
    }
    MarkdownEditor.prototype.componentWillReceiveProps = function (nextProps) {
        var isNewExternalErrorAvailable = nextProps.error !== this.props.error;
        if (isNewExternalErrorAvailable) {
            this.setState({ showExternalError: true });
        }
    };
    MarkdownEditor.prototype.callValidateAndChange = function (value) {
        if (this.props.validate) {
            var validateResult = this.props.validate(value);
            this.setState({ error: validateResult });
            if (this.props.onValidate) {
                this.props.onValidate(validateResult);
            }
        }
        this.setState({ showExternalError: false });
        this.props.onChange(value);
    };
    MarkdownEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, hintText = _a.hintText, textInputRef = _a.textInputRef, otherProps = __rest(_a, ["value", "label", "validate", "error", "onChange", "onValidate", "hintText", "textInputRef"]);
        var errorText = this.state.error || (this.state.showExternalError && error);
        var val = value ? value : "";
        return (React.createElement("div", { className: cn(styles.markdownEditorContainer, this.props.restrictHeight && styles.restrictedHeight) },
            this.createButtons(),
            React.createElement(Text_1.default, __assign({ textInputRef: function (text) {
                    if (_this.props.textInputRef) {
                        _this.props.textInputRef(text);
                    }
                    _this.text = text;
                }, value: val, onChange: this.handleChange, error: errorText, label: label, hintText: hintText, multiLine: true, rows: 3, showBorder: true }, otherProps)),
            React.createElement(Note_1.default, null,
                React.createElement(ExternalLink_1.default, { href: "MasteringMarkdown" },
                    React.createElement("em", { className: "fa fa-pencil " + styles.markdownSupported, "aria-hidden": "true" }),
                    "Styling with Markdown is supported"))));
    };
    MarkdownEditor.prototype.createButtons = function () {
        return React.createElement("div", { className: styles.iconButtonContainer }, [
            this.editAction("Bold", "fa-bold", this.bold),
            this.editAction("Italic", "fa-italic", this.italic),
            this.editAction("Bulleted list", "fa-list-ul", this.bullet),
            this.editAction("Numeric list", "fa-list-ol", this.number),
            this.editAction("Picture", "fa-image", this.image),
            this.editAction("Link", "fa-link", this.link),
            this.editAction("Code", "fa-code", this.code),
            this.editAction("Quotes", "fa-quote-left", this.quote),
        ]);
    };
    MarkdownEditor.prototype.editAction = function (label, faIcon, onClick) {
        return React.createElement(ToolTip_1.default, { content: label, key: "tooltip_" + faIcon },
            React.createElement(FlatButton_1.default, { tabIndex: -1, className: styles.iconButton, onClick: onClick, label: React.createElement("em", { className: "fa " + faIcon, "aria-hidden": "true" }) }));
    };
    MarkdownEditor.defaultProps = {
        autoFocus: false
    };
    return MarkdownEditor;
}(React.Component));
exports.default = MarkdownEditor;
var MarkdownEditorWithInputRef = function (props) { return React.createElement(MarkdownEditor, __assign({ textInputRef: props.textInputRef }, props)); };
exports.VariableLookupMarkdownEditor = VariableLookup_1.withVariableLookup()(MarkdownEditorWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownEditor.tsx"); } } })();

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FeatureToggle_1 = __webpack_require__(249);
exports.FeatureToggle = FeatureToggle_1.default;
exports.Feature = FeatureToggle_1.Feature;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureToggle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureToggle\\index.tsx"); } } })();

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataTable_1 = __webpack_require__(771);
exports.DataTable = DataTable_1.DataTable;
var DataTableHeader_1 = __webpack_require__(779);
exports.DataTableHeader = DataTableHeader_1.DataTableHeader;
var DataTableHeaderColumn_1 = __webpack_require__(780);
exports.DataTableHeaderColumn = DataTableHeaderColumn_1.DataTableHeaderColumn;
var DataTableRowHeaderColumn_1 = __webpack_require__(796);
exports.DataTableRowHeaderColumn = DataTableRowHeaderColumn_1.DataTableRowHeaderColumn;
var DataTableBody_1 = __webpack_require__(766);
exports.DataTableBody = DataTableBody_1.DataTableBody;
var DataTableToolsRow_1 = __webpack_require__(1508);
exports.DataTableToolsRow = DataTableToolsRow_1.DataTableToolsRow;
var DataTableRow_1 = __webpack_require__(767);
exports.DataTableRow = DataTableRow_1.DataTableRow;
var DataTableRowColumn_1 = __webpack_require__(768);
exports.DataTableRowColumn = DataTableRowColumn_1.DataTableRowColumn;
var DataTableFooter_1 = __webpack_require__(1509);
exports.DataTableFooter = DataTableFooter_1.DataTableFooter;
var DataTableFooterColumn_1 = __webpack_require__(1510);
exports.DataTableFooterColumn = DataTableFooterColumn_1.DataTableFooterColumn;
var DataTableFooterRow_1 = __webpack_require__(1511);
exports.DataTableFooterRow = DataTableFooterRow_1.DataTableFooterRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\index.tsx"); } } })();

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(76);
var URI = __webpack_require__(120);
var QueryStringFiltersInternal = (function (_super) {
    __extends(QueryStringFiltersInternal, _super);
    function QueryStringFiltersInternal(props) {
        var _this = _super.call(this, props) || this;
        if (props.location.search) {
            _this.updateFiltersFromQueryString(props.location.search);
        }
        return _this;
    }
    QueryStringFiltersInternal.prototype.componentWillReceiveProps = function (props) {
        if (!lodash_1.isEqual(props.filter, this.props.filter)) {
            this.updateQueryStringFromFilters(props.filter);
            return;
        }
        if (props.location.search !== this.props.location.search) {
            this.updateFiltersFromQueryString(props.location.search);
        }
    };
    QueryStringFiltersInternal.prototype.render = function () {
        return null;
    };
    QueryStringFiltersInternal.prototype.updateQueryStringFromFilters = function (filter) {
        var query = this.props.getQuery(filter);
        var queryString = convertQueryToQueryString(query);
        if (this.props.location.search !== queryString) {
            var location = __assign({}, this.props.history, { search: queryString });
            this.props.history.replace(location);
        }
    };
    QueryStringFiltersInternal.prototype.updateFiltersFromQueryString = function (queryString) {
        var query = URI(queryString).search(true);
        var filter = this.props.getFilter(query);
        if (!lodash_1.isEqual(filter, this.props.filter)) {
            this.props.onFilterChange(filter);
        }
    };
    return QueryStringFiltersInternal;
}(React.Component));
function convertQueryToQueryString(query) {
    var normalisedQuery = normaliseQuery(query);
    return new URI().search(normalisedQuery).search();
}
exports.convertQueryToQueryString = convertQueryToQueryString;
function normaliseQuery(query) {
    var normalisedQuery = {};
    for (var key in query) {
        if (!query.hasOwnProperty(key)) {
            continue;
        }
        var value = query[key];
        normalisedQuery[key] = value instanceof Array
            ? value.length ? value : undefined
            : value || undefined;
    }
    return normalisedQuery;
}
exports.normaliseQuery = normaliseQuery;
var QueryStringFilters = (function (_super) {
    __extends(QueryStringFilters, _super);
    function QueryStringFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueryStringFilters;
}((react_router_1.withRouter((function (_super) {
    __extends(class_1, _super);
    function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return class_1;
}(QueryStringFiltersInternal))))));
exports.QueryStringFilters = QueryStringFilters;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\QueryStringFilters\\QueryStringFilters.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\QueryStringFilters\\QueryStringFilters.tsx"); } } })();

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(74);
var Chip_1 = __webpack_require__(314);
var colors_1 = __webpack_require__(31);
var uiTestClasses_1 = __webpack_require__(86);
var styles = __webpack_require__(1684);
var InternalLink_1 = __webpack_require__(43);
var Tag = function (props) {
    var tagName = props.tagName, tagColor = props.tagColor, tabIndex = props.tabIndex, description = props.description, _a = props.small, small = _a === void 0 ? false : _a;
    var tagDescription = (description ? tagName + ": " + description : "Tag: " + tagName);
    if (!small) {
        var theTag = React.createElement(Chip_1.default, { className: uiTestClasses_1.tagClass, tabIndex: tabIndex, onClick: props.onClick, onRequestDelete: props.onRequestDelete, backgroundColor: tagColor, description: tagDescription, labelColor: colors_1.white }, tagName);
        if (props.to) {
            return React.createElement(InternalLink_1.default, { to: props.to, className: styles.clickableTag }, theTag);
        }
        return theTag;
    }
    return (React.createElement(index_1.default, { content: tagName },
        React.createElement("em", { className: "fa fa-square tag-swatch" + " " + uiTestClasses_1.tagClass, style: { color: tagColor, marginLeft: "0.0625rem", marginRight: "0.0625rem" } })));
};
exports.default = Tag;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Tag\\Tag.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Tag\\Tag.tsx"); } } })();

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var MultiSelect_1 = __webpack_require__(111);
exports.EnvironmentTypedMultiSelect = MultiSelect_1.default();
var EnvironmentMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Environment, chipRender: function (item) { return React.createElement(Chips_1.EnvironmentChip, { onRequestDelete: onRequestDelete, environmentName: item.Name }); } });
    };
    return React.createElement(exports.EnvironmentTypedMultiSelect, __assign({ items: props.items, fieldName: "environments", renderChip: chipRenderer }, props));
};
exports.default = EnvironmentMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EnvironmentMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EnvironmentMultiSelect.tsx"); } } })();

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TenantedDeploymentMode;
(function (TenantedDeploymentMode) {
    TenantedDeploymentMode["Untenanted"] = "Untenanted";
    TenantedDeploymentMode["TenantedOrUntenanted"] = "TenantedOrUntenanted";
    TenantedDeploymentMode["Tenanted"] = "Tenanted";
})(TenantedDeploymentMode = exports.TenantedDeploymentMode || (exports.TenantedDeploymentMode = {}));
exports.default = TenantedDeploymentMode;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantedDeploymentMode.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantedDeploymentMode.ts"); } } })();

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeploymentCreateGoal;
(function (DeploymentCreateGoal) {
    DeploymentCreateGoal["To"] = "to";
    DeploymentCreateGoal["TryAgain"] = "try-again";
})(DeploymentCreateGoal = exports.DeploymentCreateGoal || (exports.DeploymentCreateGoal = {}));
function createLink(root, releaseVersion, goal, previousId, tenantIds) {
    var previousSegment = previousId ? "/" + previousId : "";
    var uri = root + "/releases/" + releaseVersion + "/deployments/create/" + goal + previousSegment;
    if (!tenantIds) {
        return uri;
    }
    var tenants = (Array.isArray(tenantIds)) ? tenantIds : [tenantIds];
    return uri + "/" + tenants.join(",");
}
exports.default = function (root) { return ({
    releases: root + "/releases",
    releaseCreate: root + "/releases/create",
    release: function (releaseVersion) {
        if (!!releaseVersion && typeof releaseVersion !== "string") {
            releaseVersion = releaseVersion.Version;
        }
        return {
            root: root + "/releases/" + releaseVersion,
            edit: root + "/releases/" + releaseVersion + "/edit",
            deployments: {
                specific: function (deploymentId) {
                    if (typeof deploymentId !== "string") {
                        deploymentId = deploymentId.Id;
                    }
                    return root + "/releases/" + releaseVersion + "/deployments/" + deploymentId;
                },
                retry: function (previousDeploymentId) {
                    return createLink(root, releaseVersion, DeploymentCreateGoal.TryAgain, previousDeploymentId);
                },
                create: function (goal, previousId, tenantIds) {
                    return createLink(root, releaseVersion, goal, previousId, tenantIds);
                }
            }
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\Releases\\ReleasesRoutes\\releaseRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\Releases\\ReleasesRoutes\\releaseRouteLinks.ts"); } } })();

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BusyIndicator_1 = __webpack_require__(95);
exports.default = BusyIndicator_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyIndicator\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyIndicator\\index.tsx"); } } })();

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SimpleDataTable_1 = __webpack_require__(466);
exports.default = SimpleDataTable_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleDataTable\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleDataTable\\index.tsx"); } } })();

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chip_1 = __webpack_require__(612);
var colors_1 = __webpack_require__(31);
var lodash_1 = __webpack_require__(11);
var ToolTip_1 = __webpack_require__(201);
var fontWeights_1 = __webpack_require__(83);
var defaultChip = {
    style: {
        lineHeight: "1.5rem",
        height: "1.5rem",
        // multiple chips in a row where some do/don't contain an avatar. E.g. environments list).
        margin: 4,
        display: "inline-flex",
        backgroundColor: colors_1.secondaryBackground,
        borderWidth: "0",
        borderStyle: "none",
        borderColor: "rgba(0,0,0,0)",
        cursor: "inherit",
        verticalAlign: "middle"
    },
    labelStyle: {
        lineHeight: "1.5rem",
        fontSize: "0.75rem",
        color: colors_1.primaryText,
        fontWeight: fontWeights_1.normal,
        maxWidth: "12.5rem",
        textDecoration: "none",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    deleteIconStyle: {
        margin: "0.0625rem 0.25rem 0 -8px",
        width: "1.375rem",
        height: "1.375rem"
    }
};
var Chip = function (props) {
    var chipStyle = lodash_1.merge({}, defaultChip);
    var markAsRemoved = props.markAsRemoved, avatar = props.avatar, fullWidth = props.fullWidth, noMargin = props.noMargin, rest = __rest(props, ["markAsRemoved", "avatar", "fullWidth", "noMargin"]);
    var otherProps = __assign({ tabIndex: -1 }, rest);
    chipStyle.labelStyle.textDecoration = markAsRemoved ? "line-through" : "none";
    if (props.backgroundColor) {
        chipStyle.style["backgroundColor"] = props.backgroundColor;
    }
    if (props.bordercolor) {
        chipStyle.style["borderWidth"] = "0.0625rem";
        chipStyle.style["borderStyle"] = "solid";
        chipStyle.style["borderColor"] = props.bordercolor;
    }
    if (props.labelColor) {
        chipStyle.labelStyle["color"] = props.labelColor;
    }
    if (props.fullWidth) {
        chipStyle.labelStyle["maxWidth"] = "none";
    }
    if (props.noMargin) {
        chipStyle.style["margin"] = 0;
    }
    return React.createElement(Chip_1.default, __assign({ style: chipStyle.style, labelStyle: chipStyle.labelStyle, deleteIconStyle: chipStyle.deleteIconStyle }, otherProps),
        avatar,
        React.createElement(ToolTip_1.default, { content: React.createElement("span", null, props.description || props.children) }, props.children));
};
exports.default = Chip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\Chip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\Chip.tsx"); } } })();

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var ExpanderActions = {
    EXPANDER_STATE_CHANGED: "EXPANDER_STATE_CHANGED",
    EXPANDER_CONTAINER_DESTROYED: "EXPANDER_CONTAINER_DESTROYED",
    EXPANDER_CONTAINER_INITIAL_STATE: "EXPANDER_CONTAINER_INITIAL_STATE",
    EXPANDER_EXPAND_ERRORS: "EXPANDER_EXPAND_ERRORS",
    EXPANDER_TOGGLE_ALL: "EXPANDER_TOGGLE_ALL",
    EXPANDER_CREATED: "EXPANDER_CREATED",
    ALL_EXPANDERS_CREATED: "ALL_EXPANDERS_CREATED",
};
function onExpandErrors(containerKey, expandersWithErrors) {
    return { type: ExpanderActions.EXPANDER_EXPAND_ERRORS, containerKey: containerKey, expandersWithErrors: expandersWithErrors };
}
exports.onExpandErrors = onExpandErrors;
function onToggleAll(containerKey, expanded) {
    return { type: ExpanderActions.EXPANDER_TOGGLE_ALL, containerKey: containerKey, expanded: expanded };
}
exports.onToggleAll = onToggleAll;
function onExpanderCreated(containerKey, key, expanded) {
    return { type: ExpanderActions.EXPANDER_CREATED, containerKey: containerKey, key: key, expanded: expanded };
}
exports.onExpanderCreated = onExpanderCreated;
function onAllExpandersCreated(containerKey, keys, expanded) {
    return { type: ExpanderActions.ALL_EXPANDERS_CREATED, containerKey: containerKey, keys: keys, expanded: expanded };
}
exports.onAllExpandersCreated = onAllExpandersCreated;
function onExpanderContainerDestroyed(containerKey) {
    return { type: ExpanderActions.EXPANDER_CONTAINER_DESTROYED, containerKey: containerKey };
}
exports.onExpanderContainerDestroyed = onExpanderContainerDestroyed;
function onExpanderStateChanged(containerKey, key, expanded) {
    return { type: ExpanderActions.EXPANDER_STATE_CHANGED, containerKey: containerKey, key: key, expanded: expanded };
}
exports.onExpanderStateChanged = onExpanderStateChanged;
function onExpanderSetInitialState(containerKey, initialState) {
    return { type: ExpanderActions.EXPANDER_CONTAINER_INITIAL_STATE, containerKey: containerKey, initialState: initialState };
}
exports.onExpanderSetInitialState = onExpanderSetInitialState;
exports.defaultContainerKey = "default";
var expanders = function (state, action) {
    if (state === void 0) { state = {}; }
    var containerKey = action.containerKey || exports.defaultContainerKey;
    switch (action.type) {
        case ExpanderActions.EXPANDER_EXPAND_ERRORS:
            return expanderExpandErrors(state, action, containerKey);
        case ExpanderActions.EXPANDER_TOGGLE_ALL:
            return expanderToggleAll(state, action, containerKey);
        case ExpanderActions.EXPANDER_STATE_CHANGED:
            return expanderStateChanged(state, action, containerKey);
        case ExpanderActions.EXPANDER_CONTAINER_DESTROYED:
            return expanderContainerDestroyed(state, action, containerKey);
        case ExpanderActions.EXPANDER_CONTAINER_INITIAL_STATE:
            return expanderContainerInitialState(state, action, containerKey);
        case ExpanderActions.EXPANDER_CREATED:
            return expanderCreated(state, action, containerKey);
        case ExpanderActions.ALL_EXPANDERS_CREATED:
            return allExpandersCreated(state, action, containerKey);
        default:
            return state;
    }
};
function expanderExpandErrors(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var errored = action.expandersWithErrors
        .map(function (e) { return findMatchingKey(container.expanderValues, e); })
        .filter(function (e) { return e !== null; })
        .reduce(function (p, c) {
        return (__assign({}, p, (_a = {}, _a[c] = true, _a)));
        var _a;
    }, {});
    var updatedContainer = __assign({}, container, { expanderValues: __assign({}, container.expanderValues, errored) });
    if (lodash_1.isEqual(container, updatedContainer)) {
        return state;
    }
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function findMatchingKey(expanderValues, key) {
    // given an object with some pipe-delimited keys like:
    // {
    //     "first|second": true
    // }
    // given "first" return "first|second". This allows us to set errorkeys that
    // match multiple possible errors (ie if you have an expander with mutiple controls)
    // remove "Steps[12]." and "Actions[0]." from the start of the error key. Our validation adds that
    // to indicate which step the error is in
    var modKey = key.replace(/^Steps\[[0-9]+\]\./, "");
    modKey = modKey.replace(/^Actions\[[0-9]+\]\./, "");
    return Object.keys(expanderValues).find(function (k) { return k.split("|").some(function (f) { return f === modKey; }); });
}
function expanderToggleAll(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var updatedContainer = __assign({}, container, { expandingAll: action.expanded, expanderValues: setAllToValue(container.expanderValues, action.expanded) });
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function expanderStateChanged(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var updatedContainer = __assign({}, container, { expandingAll: false, expanderValues: __assign({}, container.expanderValues, (_a = {}, _a[action.key] = action.expanded, _a)) });
    return __assign({}, state, (_b = {}, _b[containerKey] = updatedContainer, _b));
    var _a, _b;
}
function expanderContainerDestroyed(state, action, containerKey) {
    var copy = __assign({}, state);
    delete copy[containerKey];
    return copy;
}
function expanderContainerInitialState(state, action, containerKey) {
    // set the initial state of the expander container, if there are already
    // expanders attached, set them to that state as well
    var container = state[containerKey] || defaultValue();
    var updatedContainer = {
        expanderValues: setAllToValue(container.expanderValues, null),
        initialState: action.initialState,
        expandingAll: false
    };
    return __assign({}, state, (_a = {}, _a[containerKey] = updatedContainer, _a));
    var _a;
}
function expanderCreated(state, action, containerKey) {
    var container = state[containerKey] || defaultValue();
    var existingValue = container.expanderValues[action.key];
    var expanderValue = existingValue !== undefined ? existingValue : action.expanded;
    var updatedContainer = __assign({}, container, { expanderValues: __assign({}, container.expanderValues, (_a = {}, _a[action.key] = expanderValue, _a)) });
    return __assign({}, state, (_b = {}, _b[containerKey] = updatedContainer, _b));
    var _a, _b;
}
function allExpandersCreated(state, action, containerKey) {
    // add a full set of expanders to a container. overwrite any existing.
    var container = state[containerKey] || defaultValue();
    var expanderValues = action.keys.reduce(function (acc, key) {
        acc[key] = action.expanded;
        return acc;
    }, {});
    return __assign({}, state, (_a = {}, _a[containerKey] = __assign({}, container, { expanderValues: expanderValues }), _a));
    var _a;
}
function defaultValue() {
    return { initialState: false, expanderValues: {}, expandingAll: false };
}
function setAllToValue(expanderValues, to) {
    var newExpanderValues = {};
    Object.keys(expanderValues).forEach(function (k) { newExpanderValues[k] = to; });
    return newExpanderValues;
}
exports.default = expanders;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\reducers\\expanders.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\reducers\\expanders.ts"); } } })();

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FilterSearchBox_1 = __webpack_require__(198);
exports.default = FilterSearchBox_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FilterSearchBox\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FilterSearchBox\\index.tsx"); } } })();

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(64);
var dialog_1 = __webpack_require__(244);
var DialogLayoutConnect = (function () {
    function DialogLayoutConnect() {
    }
    DialogLayoutConnect.to = function (internal) {
        var mapDispatchToProps = function (dispatch) {
            return {
                close: function () {
                    dispatch(dialog_1.onDialogClose());
                }
            };
        };
        return react_redux_1.connect(null, mapDispatchToProps)(internal);
    };
    return DialogLayoutConnect;
}());
exports.DialogLayoutConnect = DialogLayoutConnect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogLayoutConnect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogLayoutConnect.tsx"); } } })();

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var DashboardRenderMode;
(function (DashboardRenderMode) {
    DashboardRenderMode["VirtualizeColumns"] = "VirtualizeColumns";
    DashboardRenderMode["VirtualizeRowsAndColumns"] = "VirtualizeRowsAndColumns";
})(DashboardRenderMode = exports.DashboardRenderMode || (exports.DashboardRenderMode = {}));
var PerformanceConfigurationResource = (function (_super) {
    __extends(PerformanceConfigurationResource, _super);
    function PerformanceConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PerformanceConfigurationResource;
}(resource_1.default));
exports.PerformanceConfigurationResource = PerformanceConfigurationResource;
exports.default = PerformanceConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\performanceConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\performanceConfigurationResource.ts"); } } })();

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(111);
var Chips_1 = __webpack_require__(24);
var LookupResourceChip_1 = __webpack_require__(160);
var Chips_2 = __webpack_require__(24);
var TeamTypedMultiSelect = MultiSelect_1.default();
var LookupTeamChip = LookupResourceChip_1.default();
var TeamMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupTeamChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Team, chipRender: function (item) { return React.createElement(Chips_1.TeamChip, { onRequestDelete: onRequestDelete, team: item }); } });
    };
    return React.createElement(TeamTypedMultiSelect, __assign({ items: props.items, label: "Select teams", renderChip: chipRenderer }, props));
};
exports.default = TeamMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TeamMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TeamMultiSelect.tsx"); } } })();

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var tenantTagsets = __webpack_require__(156);
var Tag_1 = __webpack_require__(240);
var TenantTagsList = (function (_super) {
    __extends(TenantTagsList, _super);
    function TenantTagsList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { tagIndex: null, tagSets: null };
        return _this;
    }
    TenantTagsList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tagSets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tenantTagsets.getAll()];
                    case 1:
                        tagSets = _a.sent();
                        this.setState({
                            tagIndex: tenantTagsets.getTagIndexForTagSets(tagSets),
                            tagSets: tagSets,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantTagsList.prototype.render = function () {
        var _this = this;
        if (!this.state.tagIndex) {
            return null;
        }
        var groupedTagsets = tenantTagsets.groupAndOrderByTagSet(this.props.tags, this.state.tagSets);
        var items = [];
        groupedTagsets.forEach(function (tagSet) {
            var missingTags = tagSet.tags;
            if (items.length > 0) {
                items.push(React.createElement("span", { key: items.length }, " and "));
            }
            if (missingTags.length === 1) {
                var tag = _this.state.tagIndex[missingTags[0]];
                items.push(React.createElement(Tag_1.default, { key: items.length, description: tag.Description, tagName: tag.Name, tagColor: tag.Color, small: false }));
                return;
            }
            if (groupedTagsets.length > 1) {
                items.push(React.createElement("span", { key: items.length }, "("));
            }
            for (var index = 0; index < missingTags.length; index++) {
                var tag = _this.state.tagIndex[missingTags[index]];
                if (index === missingTags.length - 1) {
                    items.push(React.createElement("span", { key: items.length }, " or "));
                }
                else if (index !== 0) {
                    items.push(React.createElement("span", { key: items.length }, ", "));
                }
                items.push(React.createElement(Tag_1.default, { key: items.length, tagName: tag.Name, description: tag.Description, tagColor: tag.Color, small: false }));
            }
            if (groupedTagsets.length > 1) {
                items.push(React.createElement("span", { key: items.length }, ")"));
            }
        });
        return React.createElement("span", null, items);
    };
    return TenantTagsList;
}(React.Component));
exports.default = TenantTagsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagsList\\TenantTagsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagsList\\TenantTagsList.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(50);
var Popover_1 = __webpack_require__(246);
var DataBaseComponent_1 = __webpack_require__(39);
var BusyIndicator_1 = __webpack_require__(95);
var BusyFromPromise_1 = __webpack_require__(161);
var DebounceValue_1 = __webpack_require__(159);
var styles = __webpack_require__(1830);
var IconButton_1 = __webpack_require__(52);
var ErrorPanel_1 = __webpack_require__(85);
var LabelStrategy_1 = __webpack_require__(167);
var IconButtonList_1 = __webpack_require__(124);
var VirtualListWithKeyboard_1 = __webpack_require__(407);
var BoundField_1 = __webpack_require__(100);
var keycode = __webpack_require__(59);
var DebounceText = DebounceValue_1.default(Text_1.default);
var VirtualList = VirtualListWithKeyboard_1.default();
var AutoCompleteInternal = (function (_super) {
    __extends(AutoCompleteInternal, _super);
    function AutoCompleteInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.textField = null;
        _this.setValueAndSelection = function (selection, value) {
            _this.textField.setValueAndSelection(selection, value);
        };
        _this.getSelection = function () {
            return _this.textField && _this.textField.getSelection();
        };
        _this.cancelTimerToTrackNavigateAway = function () {
            clearTimeout(_this.timeoutId);
            _this.timeoutId = undefined;
        };
        _this.startTimerToTrackNavigateAway = function () {
            if (_this.timeoutId === undefined) {
                _this.timeoutId = setTimeout(function () { return _this.onNavigateAwayFromAutoComplete(); }, 0);
            }
        };
        _this.onFocus = function () {
            _this.cancelTimerToTrackNavigateAway();
            _this.setState({ hintText: _this.props.hintText });
            if (!_this.props.showEmpty && (!_this.state || _this.state.displayedValue === "")) {
                _this.setState({ open: false, options: null });
                return;
            }
            if (!_this.state.open) {
                _this.setState({ open: true, options: null });
                _this.requestOptions(_this.state.displayedValue);
            }
        };
        _this.onGlobalKeyDown = function (event) {
            var code = keycode(event);
            if (code === "esc") {
                if (_this.state.open) {
                    _this.setState({ open: false, options: null, displayedValue: _this.props.value });
                }
            }
        };
        _this.state = {
            open: false,
            displayedValue: props.value,
            options: null,
            hintText: null
        };
        return _this;
    }
    AutoCompleteInternal.prototype.componentWillMount = function () {
        if (this.props.textInputRef) {
            this.props.textInputRef(this);
        }
    };
    AutoCompleteInternal.prototype.componentDidMount = function () {
        window.document.addEventListener("keydown", this.onGlobalKeyDown);
    };
    AutoCompleteInternal.prototype.componentWillUnmount = function () {
        this.cancelTimerToTrackNavigateAway();
        window.document.removeEventListener("keydown", this.onGlobalKeyDown);
        if (this.props.textInputRef) {
            this.props.textInputRef(null);
        }
    };
    AutoCompleteInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({ displayedValue: nextProps.value });
        }
    };
    AutoCompleteInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.autoCompleteContainer },
            React.createElement("div", { ref: function (textAnchor) { return _this.textAnchor = textAnchor; }, className: styles.textContainer, onKeyDown: function (ev) { return _this.onKeyDown(ev); } },
                React.createElement(DebounceText, { textInputRef: function (textField) { return _this.textField = textField; }, label: this.props.label, value: this.state.displayedValue, error: this.props.error, hintText: this.state.hintText, onChange: function (value) { return _this.onSearchTextChange(value); }, onFocus: this.onFocus, onClick: function (ev) {
                        ev.stopPropagation(); // This could bubble up and close the popup, even though the same mousedown event opened it (by focusing the input)
                        _this.onFocus();
                    }, onBlur: function (ev) { return _this.onBlurFromText(ev); } }),
                React.createElement("div", { className: styles.buttons },
                    React.createElement(IconButtonList_1.default, { buttons: this.buttons() }))),
            React.createElement(Popover_1.default, { open: this.state.open, anchorEl: this.textAnchor, onRequestClose: function () { return _this.setState({ open: false }); }, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, useLayerForClickAway: false, className: styles.popover },
                React.createElement("div", { onFocus: this.cancelTimerToTrackNavigateAway, onBlur: this.startTimerToTrackNavigateAway, 
                    // Todo: review this change. It was added to allow annotation suggestions to be displayed
                    // at a reasonable size.
                    style: { minWidth: this.textAnchor ? Math.max(450, this.textAnchor.offsetWidth) + "px" : undefined }, ref: function (popoverContent) { return _this.popoverContent = popoverContent; } },
                    React.createElement("div", { className: styles.popoverContent },
                        React.createElement(BusyFromPromise_1.default, { promise: this.state.busy, children: function (busy) { return React.createElement(BusyIndicator_1.default, { show: busy }); } }),
                        this.renderErrors(),
                        !this.state.options && this.state.busy &&
                            React.createElement("div", { className: styles.popoverInfoText }, "Searching..."),
                        this.state.options && React.createElement(VirtualList, { maxHeightInRem: 17.5, multiSelectRef: function (el) { return _this.virtualList = el; }, items: this.state.options.items, renderItem: function (item) { return ({ primaryText: item.display || item.Name }); }, onSelected: function (id) { return _this.selectOption(id); }, onResized: function () {
                                // When the content's size changes, we re-render so that the
                                // popover can re-position itself based on the new `VirtualList` size
                                _this.forceUpdate();
                            }, onBlur: function () { return _this.textField.focus(); } })),
                    this.state.options && !this.state.options.containsAllResults &&
                        React.createElement("div", { className: styles.warning },
                            "Only showing ",
                            this.state.options.items.length,
                            " options, for more results narrow your search criteria"))));
    };
    AutoCompleteInternal.prototype.renderErrors = function () {
        var errors = this.state.errors;
        if (!errors) {
            return null;
        }
        return React.createElement(ErrorPanel_1.default, { message: errors.message, details: errors.details, detailLinks: errors.detailLinks, helpText: errors.helpText, fullException: errors.fullException, helpLink: errors.helpLink, scrollToPanel: false });
    };
    AutoCompleteInternal.prototype.isFocused = function () {
        return this.textField && this.textField.isFocused();
    };
    AutoCompleteInternal.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    AutoCompleteInternal.prototype.forceHasValue = function () {
        if (this.textField) {
            return this.textField.forceHasValue();
        }
    };
    AutoCompleteInternal.prototype.insertAtCursor = function (value) {
        if (!this.textField) {
            return;
        }
        this.textField.insertAtCursor(value);
    };
    AutoCompleteInternal.prototype.select = function () {
        if (this.textField) {
            this.textField.select();
        }
    };
    AutoCompleteInternal.prototype.focusText = function () {
        if (this.textField && !this.textField.isFocused()) {
            this.textField.focus();
        }
    };
    AutoCompleteInternal.prototype.onBlurFromText = function (ev) {
        this.setState({ hintText: null });
        this.startTimerToTrackNavigateAway();
    };
    AutoCompleteInternal.prototype.onNavigateAwayFromAutoComplete = function () {
        this.setState({ open: false, displayedValue: this.props.value });
    };
    AutoCompleteInternal.prototype.onKeyDown = function (ev) {
        var code = keycode(ev);
        if (code === "down") {
            if (this.virtualList && this.state.options && this.state.options.items.length) {
                ev.preventDefault();
                this.virtualList.focus();
            }
        }
    };
    AutoCompleteInternal.prototype.onSearchTextChange = function (searchText) {
        var open = searchText !== "" || this.props.showEmpty;
        this.setState(function (prev) { return ({ displayedValue: searchText, open: open, options: prev.open ? prev.options : null }); });
        if (this.props.allowAnyTextValue) {
            this.props.onChange(searchText);
        }
        if (open) {
            this.requestOptions(searchText);
        }
    };
    AutoCompleteInternal.prototype.requestOptions = function (searchText) {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.getOptions(searchText)];
                    case 1:
                        options = _a.sent();
                        this.setState({ options: options });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AutoCompleteInternal.prototype.selectOption = function (id) {
        var option = this.state.options.items.find(function (i) { return i.Id === id; });
        this.setState({ displayedValue: option.Name, open: false });
        this.props.onChange(option.Id);
    };
    AutoCompleteInternal.prototype.clearValue = function () {
        this.setState({ open: false, displayedValue: "" });
        this.props.onChange("");
    };
    AutoCompleteInternal.prototype.buttons = function () {
        var _this = this;
        return [
            !!this.props.value && React.createElement(IconButton_1.default, { icon: IconButton_1.Icon.Cancel, onClick: function () { return _this.clearValue(); }, tabIndex: -1 }),
            React.createElement(IconButton_1.default, { icon: IconButton_1.Icon.ArrowDown, onClick: function () { return _this.focusText(); }, tabIndex: -1 })
        ].filter(function (b) { return !!b; });
    };
    AutoCompleteInternal.defaultProps = {
        showEmpty: true
    };
    return AutoCompleteInternal;
}(DataBaseComponent_1.DataBaseComponent));
var AutoComplete = LabelStrategy_1.default(AutoCompleteInternal, function (fieldName) { return fieldName; });
exports.default = AutoComplete;
exports.BoundAutoComplete = BoundField_1.withBoundField(function (props) {
    return React.createElement("div", { style: { display: "flex", alignItems: "baseline", width: "100%" } },
        React.createElement(AutoComplete, __assign({}, props)));
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AutoComplete\\AutoComplete.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AutoComplete\\AutoComplete.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = __webpack_require__(200);
exports.default = Logo_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Logo\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Logo\\index.tsx"); } } })();

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Note_1 = __webpack_require__(20);
var MoreInfo = (function (_super) {
    __extends(MoreInfo, _super);
    function MoreInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.openMoreInfo = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.content);
            }
        };
        return _this;
    }
    MoreInfo.prototype.render = function () {
        return React.createElement(Note_1.default, null,
            React.createElement("a", { href: "#", onClick: this.openMoreInfo }, this.props.label || "More information"));
    };
    return MoreInfo;
}(React.Component));
MoreInfo.defaultProps = {
    isMoreInfo: true
};
exports.default = MoreInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\MoreInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\MoreInfo.tsx"); } } })();

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(111);
var Tag_1 = __webpack_require__(240);
var tenantTagsets = __webpack_require__(156);
var TagResourceMultiSelect = MultiSelect_1.default();
var TenantTagMultiSelect = (function (_super) {
    __extends(TenantTagMultiSelect, _super);
    function TenantTagMultiSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.chipRenderer = function (tagSet, r, onRequestDelete) {
            var tag = tagSet.Tags.find(function (t) { return t.Id === r.Id; });
            return React.createElement(Tag_1.default, { onRequestDelete: onRequestDelete, description: tag.Description, tagName: tag.Name, tagColor: tag.Color });
        };
        _this.state = {
            tagSets: (_this.props.items ?
                (typeof _this.props.items === "function" ?
                    _this.props.items() :
                    _this.props.items).sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) :
                null)
        };
        return _this;
    }
    TenantTagMultiSelect.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var tagSets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.state.tagSets) return [3 /*break*/, 2];
                        return [4 /*yield*/, tenantTagsets.getAll()];
                    case 1:
                        tagSets = _a.sent();
                        this.setState({ tagSets: tagSets.sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagMultiSelect.prototype.onChange = function (tagSet, tagIds) {
        var oldState = tenantTagsets.groupByTagSet(this.props.value);
        var tagSetFromState = oldState.find(function (x) { return x.name === tagSet.Name; });
        var squashedList = tagIds.map(function (id) { return tagSet.Tags.find(function (p) { return p.Id === id; }).CanonicalTagName; });
        if (tagSetFromState) {
            tagSetFromState.tags = squashedList;
        }
        else {
            oldState.push({ name: tagSet.Name, tags: squashedList });
        }
        var newState = tenantTagsets.flattenGroup(oldState);
        this.props.onChange(newState);
    };
    TenantTagMultiSelect.prototype.render = function () {
        var _this = this;
        if (!this.state.tagSets) {
            return null;
        }
        var options = this.state.tagSets.map(function (ts, index) {
            // No point showing the selector if this tagset has no tags.
            if (!ts.Tags || ts.Tags.length === 0) {
                return null;
            }
            var selected = _this.props.value
                ? ts.Tags.filter(function (t) { return _this.props.value.indexOf(t.CanonicalTagName) !== -1; }).map(function (t) { return t.Id; })
                : [];
            return React.createElement(TagResourceMultiSelect, { onChange: function (items) { return _this.onChange(ts, items); }, key: ts.Id, value: selected, items: ts.Tags ? ts.Tags.sort(function (t1, t2) { return t1.SortOrder - t2.SortOrder; }) : null, renderChip: function (r, dc) { return _this.chipRenderer(ts, r, dc); }, fieldName: ts.Name + " tags", description: ts.Description, autoFocus: _this.props.autoFocus && index === 0 });
        });
        return React.createElement("div", null, options);
    };
    return TenantTagMultiSelect;
}(React.Component));
exports.default = TenantTagMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TenantTagMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TenantTagMultiSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(456);
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DeploymentProcessOverview_1 = __webpack_require__(1936);
var StepDetailsLoader_1 = __webpack_require__(1948);
var ActionTemplateSelector_1 = __webpack_require__(1991);
var ReloadableRoute_1 = __webpack_require__(94);
var DeploymentProcessRoute = (function (_super) {
    __extends(DeploymentProcessRoute, _super);
    function DeploymentProcessRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentProcessRoute.nextStepReloadPath = function (currentPath, currentKey) {
        var path = currentPath;
        if (currentKey) {
            var keyNum = ParseHelper_1.default.safeParseInt(currentKey, 0) + 1;
            path = path.slice(0, -currentKey.length) + keyNum.toString();
        }
        else {
            path = path + "/1";
        }
        return path;
    };
    DeploymentProcessRoute.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/new/:actionType/:template?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/:stepId/new/:actionType/:template?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/step/:stepId/:reloadKey?", component: StepDetailsLoader_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/steptemplates", component: ActionTemplateSelector_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: match.path + "/childsteptemplates/:parentStepId", component: ActionTemplateSelector_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: "" + match.path, component: DeploymentProcessOverview_1.default })));
    };
    return DeploymentProcessRoute;
}(React.Component));
exports.DeploymentProcessRoute = DeploymentProcessRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessRoute.tsx"); } } })();

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(84);
var ParseHelper_1 = __webpack_require__(66);
var ActionButton_1 = __webpack_require__(49);
var VariableLookupText_1 = __webpack_require__(21);
var StringRemoveItemsList = (function (_super) {
    __extends(StringRemoveItemsList, _super);
    function StringRemoveItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StringRemoveItemsList;
}(RemoveItemsList_1.RemoveItemsList));
var StringEditList = (function (_super) {
    __extends(StringEditList, _super);
    function StringEditList(props) {
        var _this = _super.call(this, props) || this;
        _this.adding = false;
        _this.handleRemoveRow = function (item) {
            var data = _this.state.source;
            data.splice(data.indexOf(item), 1);
            _this.invokeOnChange(data);
        };
        _this.handleRowRef = function (idx) { return function (input) {
            if (input && _this.adding && idx === 0) {
                input.focus();
                _this.adding = false;
            }
        }; };
        _this.handleRowChange = function (idx) { return function (val) {
            var data = _this.state.source;
            data[idx] = val;
            _this.invokeOnChange(data);
        }; };
        _this.invokeOnChange = function (data) {
            _this.props.onChange(ParseHelper_1.default.encodeCSV(data.filter(function (t) { return t != null && t !== ""; })));
        };
        _this.handleAddClick = function () {
            var data = _this.state.source;
            _this.adding = true;
            _this.setState({ source: [""].concat(data) });
        };
        _this.renderRow = function (item, idx) {
            var data = _this.state.source;
            var warning = data.filter(function (t) { return t === item; }).length > 1 ? "This value has already been added" : null;
            return React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, textInputRef: _this.handleRowRef(idx), key: "KEYY-" + idx, value: item, onChange: _this.handleRowChange(idx), warning: warning, label: _this.props.label, hintText: _this.props.hintText });
        };
        _this.state = {
            source: []
        };
        return _this;
    }
    StringEditList.prototype.componentDidMount = function () {
        this.setInternalState(this.props);
    };
    StringEditList.prototype.setInternalState = function (props) {
        this.setState({ source: ParseHelper_1.default.parseCSV(this.props.items || "") });
    };
    StringEditList.prototype.render = function () {
        var name = this.props.name || this.props.label;
        var actionButton = React.createElement(ActionButton_1.default, { key: "Add", label: "Add " + name, onClick: this.handleAddClick });
        return React.createElement(StringRemoveItemsList, { listActions: [actionButton], data: this.state.source, onRemoveRow: this.handleRemoveRow, onRow: this.renderRow, clearButtonToolTip: "Remove " + name });
    };
    return StringEditList;
}(React.PureComponent));
exports.default = StringEditList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\StringEditList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\StringEditList.tsx"); } } })();

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerFilterResource = (function () {
    function TriggerFilterResource() {
    }
    return TriggerFilterResource;
}());
exports.TriggerFilterResource = TriggerFilterResource;
var TriggerActionResource = (function () {
    function TriggerActionResource() {
    }
    return TriggerActionResource;
}());
exports.TriggerActionResource = TriggerActionResource;
var MachineFilterResource = (function (_super) {
    __extends(MachineFilterResource, _super);
    function MachineFilterResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = TriggerFilterType.MachineFilter;
        return _this;
    }
    return MachineFilterResource;
}(TriggerFilterResource));
exports.MachineFilterResource = MachineFilterResource;
var AutoDeployActionResource = (function (_super) {
    __extends(AutoDeployActionResource, _super);
    function AutoDeployActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = TriggerActionType.AutoDeploy;
        return _this;
    }
    return AutoDeployActionResource;
}(TriggerActionResource));
exports.AutoDeployActionResource = AutoDeployActionResource;
var TriggerFilterType;
(function (TriggerFilterType) {
    TriggerFilterType["MachineFilter"] = "MachineFilter";
    TriggerFilterType["DailySchedule"] = "DailySchedule";
    TriggerFilterType["DaysPerWeekSchedule"] = "DaysPerWeekSchedule";
    TriggerFilterType["DaysPerMonthSchedule"] = "DaysPerMonthSchedule";
    TriggerFilterType["CronExpressionSchedule"] = "CronExpressionSchedule";
})(TriggerFilterType = exports.TriggerFilterType || (exports.TriggerFilterType = {}));
var TriggerActionType;
(function (TriggerActionType) {
    TriggerActionType["AutoDeploy"] = "AutoDeploy";
    TriggerActionType["DeployLatestRelease"] = "DeployLatestRelease";
    TriggerActionType["DeployNewRelease"] = "DeployNewRelease";
})(TriggerActionType = exports.TriggerActionType || (exports.TriggerActionType = {}));
function isExistingTriggerResource(resource) {
    return resource.Links !== undefined;
}
exports.isExistingTriggerResource = isExistingTriggerResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\triggerResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\triggerResource.ts"); } } })();

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_actions_1 = __webpack_require__(547);
var ActionTypes = {
    UNHANDLED_ERROR_CLEARED: "UNHANDLED_ERROR_CLEARED",
};
function clearUnhandledErrorAction() {
    return { type: ActionTypes.UNHANDLED_ERROR_CLEARED };
}
exports.clearUnhandledErrorAction = clearUnhandledErrorAction;
var clearUnhandledError = redux_actions_1.handleActions((_a = {},
    _a[ActionTypes.UNHANDLED_ERROR_CLEARED] = function (state, action) {
        return null;
    },
    _a), null);
exports.default = clearUnhandledError;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\reducers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\reducers.tsx"); } } })();

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
function uploadLogo(resource, logo) {
    var fd = new FormData();
    fd.append("fileToUpload", logo);
    return clientInstance_1.client.post(resource.Links["Logo"], fd);
}
exports.uploadLogo = uploadLogo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\logoUpload.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\logoUpload.ts"); } } })();

/***/ }),
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var keycode = __webpack_require__(59);
var Key;
(function (Key) {
    Key["Esc"] = "esc";
    Key["Enter"] = "enter";
    Key["CtrlEnter"] = "ctrlenter";
})(Key = exports.Key || (exports.Key = {}));
var KeyboardHandler = (function (_super) {
    __extends(KeyboardHandler, _super);
    function KeyboardHandler(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEsc = function (event) {
            if (!event.defaultPrevented) {
                for (var _i = 0, _a = _this.keyboardRegistrations; _i < _a.length; _i++) {
                    var registration = _a[_i];
                    if (keycode.codes.esc === keycode(registration.key) && keycode.codes.esc === keycode(keycode(event))) {
                        if (registration.onKeyPressed(event)) {
                            event.preventDefault();
                        }
                    }
                }
            }
        };
        _this.handleKey = function (e) {
            var event = e.nativeEvent;
            if (!event.defaultPrevented) {
                var keyName = keycode(event);
                for (var _i = 0, _a = _this.keyboardRegistrations; _i < _a.length; _i++) {
                    var registration = _a[_i];
                    if (keyName === keycode(keycode.codes.enter)) {
                        if (event.ctrlKey) {
                            // Ctrl + Enter
                            if (registration.key === Key.CtrlEnter) {
                                if (registration.onKeyPressed(event)) {
                                    event.preventDefault();
                                }
                            }
                        }
                        else {
                            // Enter, mac command+enter will fall into here
                            if (registration.key === Key.Enter) {
                                if (registration.onKeyPressed(event)) {
                                    event.preventDefault();
                                }
                            }
                        }
                    }
                    else {
                        // Any other keys
                        var code = keycode(keyName);
                        if (code !== undefined // don't want to fall through when undefined === undefined
                            && code === keycode(registration.key)) {
                            if (registration.onKeyPressed(event)) {
                                event.preventDefault();
                            }
                        }
                    }
                }
            }
        };
        _this.keyboardRegistrations = props.registrations;
        return _this;
    }
    KeyboardHandler.prototype.render = function () {
        return React.createElement("div", { onKeyDown: this.handleKey, style: { width: "100%" }, className: this.props.className }, this.props.children);
    };
    KeyboardHandler.prototype.componentDidMount = function () {
        if (this.hasEscRegistration()) {
            window.document.addEventListener("keydown", this.handleEsc);
        }
    };
    KeyboardHandler.prototype.componentWillUnmount = function () {
        if (this.hasEscRegistration()) {
            window.document.removeEventListener("keydown", this.handleEsc);
        }
    };
    KeyboardHandler.prototype.hasEscRegistration = function () {
        var escBinding = this.keyboardRegistrations.find(function (r) { return r.key === Key.Esc; });
        return !!escBinding;
    };
    return KeyboardHandler;
}(React.Component));
exports.default = KeyboardHandler;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\KeyboardHandler\\KeyboardHandler.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\KeyboardHandler\\KeyboardHandler.tsx"); } } })();

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1278);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
function exposeComponentAsClass(Component) {
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(Component, __assign({}, this.props));
        };
        return class_1;
    }(React.Component));
}
exports.exposeComponentAsClass = exposeComponentAsClass;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\exposeComponentAsClass.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\exposeComponentAsClass.tsx"); } } })();

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UniqueSequenceGenerator = (function () {
    function UniqueSequenceGenerator() {
        this.currentValue = 0;
    }
    UniqueSequenceGenerator.prototype.next = function () {
        this.currentValue++;
        return this.currentValue;
    };
    return UniqueSequenceGenerator;
}());
exports.UniqueSequenceGenerator = UniqueSequenceGenerator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\UniqueSequenceGenerator\\UniqueSequenceGenerator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\UniqueSequenceGenerator\\UniqueSequenceGenerator.ts"); } } })();

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1522);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resolvePathWithSpaceId_1 = __webpack_require__(130);
function isUrlActive(currentUrl, spaceId, toUrl, exact) {
    var resolvedToUrl = toUrl ? resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(toUrl, spaceId) : toUrl;
    return exact ? currentUrl === resolvedToUrl : currentUrl.startsWith(resolvedToUrl);
}
exports.isUrlActive = isUrlActive;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\isUrlActive.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\isUrlActive.tsx"); } } })();

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FocustListItem_1 = __webpack_require__(1595);
var react_virtualized_1 = __webpack_require__(317);
var styles = __webpack_require__(1638);
var fontWeights_1 = __webpack_require__(83);
function VirtualListWithKeyboard() {
    var VirtualListWithKeyboardInternal = (function (_super) {
        __extends(VirtualListWithKeyboardInternal, _super);
        function VirtualListWithKeyboardInternal(props) {
            var _this = _super.call(this, props) || this;
            _this.unmounted = false;
            _this.onListKeyDown = function (event, filteredList) {
                if (event.key === "ArrowDown" || (!event.shiftKey && event.key === "Tab")) {
                    var lastIndex_1 = filteredList.length - 1;
                    _this.setState(function (prevState) {
                        return { focusedRow: prevState.focusedRow <= lastIndex_1 ? prevState.focusedRow + 1 : lastIndex_1 };
                    });
                    event.preventDefault();
                }
                if (event.key === "ArrowUp" || (event.shiftKey && event.key === "Tab")) {
                    if (_this.state.focusedRow === 0) {
                        if (_this.props.onBlur) {
                            _this.props.onBlur();
                        }
                        _this.setState({ focusedRow: -1 });
                    }
                    else {
                        _this.setState(function (prevState) {
                            return { focusedRow: prevState.focusedRow > 0 ? prevState.focusedRow - 1 : 0 };
                        });
                    }
                    event.preventDefault();
                }
            };
            _this.rowHeight = function (params) {
                return _this.cellMeasurerCache.rowHeight(params);
            };
            _this.renderRow = function (filteredList, key, index, isVisible, style, parent) {
                var item = filteredList[index];
                var primaryText = null;
                var secondaryText = null;
                var secondaryTextLines = 1;
                var leftIcon = null;
                if (item.Id) {
                    var result = _this.props.renderItem(item);
                    primaryText = result.primaryText;
                    secondaryText = result.secondaryText;
                    secondaryTextLines = result.secondaryTextLines;
                    leftIcon = result.leftIcon;
                }
                else {
                    primaryText = _this.props.addNewTemplate();
                }
                return React.createElement(react_virtualized_1.CellMeasurer, { cache: _this.cellMeasurerCache, columnIndex: 0, key: key, parent: parent, rowIndex: index },
                    React.createElement("span", { style: style },
                        React.createElement(FocustListItem_1.default, { isFocused: index === _this.state.focusedRow, containerElement: _this.props.containerElement && _this.props.containerElement(item), primaryText: primaryText, secondaryText: secondaryText, secondaryTextLines: secondaryTextLines, leftIcon: leftIcon, onRequestClose: function () {
                                _this.props.onSelected(item.Id);
                            } })));
            };
            _this.state = {
                focusedRow: -1,
                containerHeight: VirtualListWithKeyboardInternal.defaultRowSize
            };
            _this.cellMeasurerCache = new react_virtualized_1.CellMeasurerCache({
                minHeight: VirtualListWithKeyboardInternal.defaultRowSize,
                defaultHeight: VirtualListWithKeyboardInternal.defaultRowSize,
                fixedWidth: true
            });
            return _this;
        }
        VirtualListWithKeyboardInternal.prototype.focus = function () {
            if (this.props.items.length > 0) {
                this.virtualList.scrollToRow(0);
                this.setState({
                    focusedRow: 0
                });
            }
        };
        VirtualListWithKeyboardInternal.prototype.componentDidMount = function () {
            if (this.props.multiSelectRef) {
                this.props.multiSelectRef(this);
            }
        };
        VirtualListWithKeyboardInternal.prototype.componentWillUnmount = function () {
            this.unmounted = true;
            if (this.props.multiSelectRef) {
                this.props.multiSelectRef(null);
            }
        };
        VirtualListWithKeyboardInternal.prototype.render = function () {
            var _this = this;
            setTimeout(function () { return _this.adjustContainerHeight(); }, 0);
            return React.createElement("div", { onKeyDown: function (e) { return _this.onListKeyDown(e, _this.props.items); } },
                this.props.items.length === 0 && React.createElement("div", { className: styles.empty }, "No results found"),
                React.createElement("div", { className: styles.menuContainer },
                    React.createElement(react_virtualized_1.AutoSizer, { disableHeight: true }, function (_a) {
                        var width = _a.width;
                        return React.createElement(react_virtualized_1.List, { ref: function (el) { return _this.virtualList = el; }, tabIndex: -1, height: _this.state.containerHeight, rowCount: _this.props.items.length, estimatedRowSize: VirtualListWithKeyboardInternal.defaultRowSize, deferredMeasurementCache: _this.cellMeasurerCache, rowHeight: _this.rowHeight, rowRenderer: function (_a) {
                                var index = _a.index, key = _a.key, isVisible = _a.isVisible, style = _a.style, parent = _a.parent;
                                return _this.renderRow(_this.props.items, key, index, isVisible, style, parent);
                            }, width: width });
                    })));
        };
        VirtualListWithKeyboardInternal.prototype.adjustContainerHeight = function () {
            if (this.unmounted || this.props.items.length === 0) {
                return;
            }
            var height = VirtualListWithKeyboardInternal.defaultRowSize * this.props.items.length;
            var maxHeightInPx = fontWeights_1.baseSizeInPx * this.props.maxHeightInRem;
            if (height > maxHeightInPx) {
                height = maxHeightInPx;
            }
            else {
                height = 0;
                // Measure the first 10 to get a more accurate height
                for (var index = 0; index < this.props.items.length; index++) {
                    height += this.cellMeasurerCache.rowHeight({ index: index });
                    if (height > maxHeightInPx) {
                        height = maxHeightInPx;
                        break;
                    }
                }
            }
            if (this.state.containerHeight === height) {
                return;
            }
            this.setState({ containerHeight: height });
            this.props.onResized();
        };
        VirtualListWithKeyboardInternal.defaultProps = {
            maxHeightInRem: 25
        };
        VirtualListWithKeyboardInternal.defaultRowSize = 48;
        return VirtualListWithKeyboardInternal;
    }(React.Component));
    return VirtualListWithKeyboardInternal;
}
exports.default = VirtualListWithKeyboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\VirtualListWithKeyboard\\VirtualListWithKeyboard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\VirtualListWithKeyboard\\VirtualListWithKeyboard.tsx"); } } })();

/***/ }),
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(64);
var dialog_1 = __webpack_require__(244);
var OpenDialogConnect = (function () {
    function OpenDialogConnect() {
    }
    OpenDialogConnect.to = function (internal, withRef) {
        if (withRef === void 0) { withRef = false; }
        var mapDispatchToProps = function (dispatch) {
            return {
                openDialog: function (key) {
                    dispatch(dialog_1.openDialog(key));
                }
            };
        };
        var mapStateToProps = function (state) { return ({
            openDialogs: state.dialogs || {}
        }); };
        return react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { withRef: withRef })(internal);
    };
    return OpenDialogConnect;
}());
exports.OpenDialogConnect = OpenDialogConnect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogConnect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogConnect.tsx"); } } })();

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var CopyToClipboardButton_1 = __webpack_require__(459);
__export(__webpack_require__(459));
exports.default = CopyToClipboardButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CopyToClipboardButton\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CopyToClipboardButton\\index.ts"); } } })();

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(17);
var CertificateSelect_1 = __webpack_require__(807);
var AccountSelect_1 = __webpack_require__(202);
var Sensitive_1 = __webpack_require__(93);
var styles = __webpack_require__(1967);
var AccountVariableSelect_1 = __webpack_require__(737);
var CertificateVariableSelect_1 = __webpack_require__(191);
var Options_1 = __webpack_require__(483);
var getResetValue_1 = __webpack_require__(426);
var DebounceValue_1 = __webpack_require__(159);
var Text_1 = __webpack_require__(50);
var Select_1 = __webpack_require__(40);
var StringCheckbox_1 = __webpack_require__(41);
var VariableLookupText_1 = __webpack_require__(21);
var lodash_1 = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var Fragment_1 = __webpack_require__(92);
var ActionTemplateParameterInput = (function (_super) {
    __extends(ActionTemplateParameterInput, _super);
    function ActionTemplateParameterInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getInputControl = function () {
            var _a = _this.props, warning = _a.warning, _b = _a.sourceItems, sourceItems = _b === void 0 ? {} : _b, doBusyTask = _a.doBusyTask, value = _a.value, localNames = _a.localNames, projectId = _a.projectId, error = _a.error, rest = __rest(_a, ["warning", "sourceItems", "doBusyTask", "value", "localNames", "projectId", "error"]);
            var resetValue = getResetValueFromParameter(_this.props.parameter);
            var type = _this.props.parameter.DisplaySettings["Octopus.ControlType"];
            var label = _this.props.parameter.Label || _this.props.parameter.Name;
            var formProps = __assign({}, rest, { label: label });
            var evaluatedResetValue = (typeof resetValue === "function" ? resetValue() : resetValue);
            var fieldValue = value !== undefined
                ? value
                : evaluatedResetValue;
            var usingDefaultValue = lodash_1.isEqual(fieldValue, evaluatedResetValue);
            var defaultValueIndicator = evaluatedResetValue && usingDefaultValue
                ? React.createElement(Note_1.default, null, "Using default value.")
                : React.createElement(Note_1.default, null,
                    React.createElement("a", { href: "#", onClick: function (e) {
                            e.preventDefault();
                            _this.props.onChange(evaluatedResetValue);
                        } }, "Reset to default"));
            switch (type) {
                case resources_1.ControlType.SingleLineText:
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(VariableLookupText_1.VariableLookupText, __assign({ projectId: sourceItems.projectId, localNames: localNames, warning: warning }, formProps, { value: fieldValue })),
                        defaultValueIndicator);
                case resources_1.ControlType.MultiLineText:
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(VariableLookupText_1.VariableLookupText, __assign({ projectId: sourceItems.projectId, localNames: localNames, multiLine: true, warning: warning }, formProps, { value: fieldValue })),
                        defaultValueIndicator);
                case resources_1.ControlType.Select: {
                    var options = Options_1.default(_this.props.parameter.DisplaySettings["Octopus.SelectOptions"]);
                    var allowClear = _this.props.parameter.AllowClear !== undefined ? _this.props.parameter.AllowClear : true;
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(Select_1.BoundSelect, __assign({ variableLookup: {
                                localNames: localNames,
                                projectId: sourceItems.projectId
                            }, resetValue: resetValue, items: options, warning: warning, allowClear: allowClear, value: fieldValue }, formProps)),
                        defaultValueIndicator);
                }
                case resources_1.ControlType.Checkbox: {
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, __assign({ variableLookup: {
                                localNames: localNames,
                                projectId: sourceItems.projectId
                            }, resetValue: resetValue, warning: warning }, formProps, { value: fieldValue })),
                        defaultValueIndicator);
                }
                case resources_1.ControlType.Sensitive:
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(Sensitive_1.BoundSensitive, __assign({ variableLookup: {
                                localNames: localNames,
                                projectId: sourceItems.projectId
                            }, value: fieldValue, resetValue: resetValue }, formProps)),
                        defaultValueIndicator);
                case resources_1.ControlType.StepName:
                    var items = sourceItems.stepNames ? sourceItems.stepNames.map(function (s) { return ({ value: s, text: s }); }) : [];
                    return React.createElement(Fragment_1.Fragment, null,
                        React.createElement(Select_1.BoundSelect, __assign({ variableLookup: {
                                localNames: localNames,
                                projectId: sourceItems.projectId
                            }, resetValue: resetValue, items: items, value: fieldValue, warning: warning }, formProps)),
                        defaultValueIndicator);
                case resources_1.ControlType.Certificate:
                    return React.createElement(Fragment_1.Fragment, null,
                        sourceItems.projectId
                            ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, __assign({ variableLookup: {
                                    localNames: _this.props.localNames,
                                    projectId: _this.props.projectId
                                }, resetValue: resetValue, value: fieldValue, projectId: sourceItems.projectId, doBusyTask: _this.props.doBusyTask, allowClear: true }, formProps))
                            : React.createElement(CertificateSelect_1.BoundCertificateSelect, __assign({ variableLookup: {
                                    localNames: localNames,
                                    projectId: sourceItems.projectId
                                }, resetValue: resetValue, value: fieldValue, warning: warning, doBusyTask: doBusyTask, tenantId: _this.props.sourceItems.tenantId, allowClear: true }, formProps)),
                        defaultValueIndicator);
                case resources_1.ControlType.AmazonWebServicesAccount:
                    return React.createElement(Fragment_1.Fragment, null,
                        sourceItems.projectId ?
                            React.createElement(AccountVariableSelect_1.AwsBoundAccountVariableSelect, __assign({ value: fieldValue, resetValue: resetValue, projectId: sourceItems.projectId, doBusyTask: _this.props.doBusyTask, allowClear: true }, formProps)) :
                            React.createElement(AccountSelect_1.BoundAccountSelect, __assign({ resetValue: resetValue, value: fieldValue, onRequestRefresh: sourceItems.accounts ? sourceItems.accounts.onRequestRefresh : _this.noop, items: sourceItems.accounts ? sourceItems.accounts.items : [], type: [resources_1.AccountType.AmazonWebServicesAccount], warning: warning, allowClear: true }, formProps)),
                        defaultValueIndicator);
                case resources_1.ControlType.AzureAccount:
                    return React.createElement(Fragment_1.Fragment, null,
                        sourceItems.projectId ?
                            React.createElement(AccountVariableSelect_1.AzureBoundAccountVariableSelect, __assign({ value: fieldValue, resetValue: resetValue, projectId: sourceItems.projectId, doBusyTask: _this.props.doBusyTask, allowClear: true }, formProps)) :
                            React.createElement(AccountSelect_1.BoundAccountSelect, __assign({ variableLookup: {
                                    localNames: localNames,
                                    projectId: sourceItems.projectId
                                }, resetValue: resetValue, value: fieldValue, onRequestRefresh: sourceItems.accounts ? sourceItems.accounts.onRequestRefresh : _this.noop, items: sourceItems.accounts ? sourceItems.accounts.items : [], type: sourceItems.accounts ? sourceItems.accounts.type : [], warning: warning, allowClear: true }, formProps)),
                        defaultValueIndicator);
                default:
                    return React.createElement(Text_1.default, __assign({ warning: warning }, formProps, { value: fieldValue }));
            }
        };
        _this.noop = function () {
            return Promise.resolve();
        };
        return _this;
    }
    ActionTemplateParameterInput.prototype.render = function () {
        return React.createElement("div", { className: styles.container }, this.getInputControl());
    };
    return ActionTemplateParameterInput;
}(React.Component));
function getResetValueFromParameter(parameter) {
    return parameter.DisplaySettings &&
        parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive" ? getResetValue_1.default(parameter.DefaultValue) : parameter.DefaultValue;
}
exports.default = DebounceValue_1.default(ActionTemplateParameterInput);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInput.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInput.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
// Returns a reset-value function for use with bound-field directive
var getResetValue = function (model) {
    // If not an object, then it wasn't a sensitive-value
    if (typeof (model) !== "object") {
        return function () {
            return { HasValue: false };
        };
    }
    var initial = lodash_1.clone(model);
    return function () {
        return lodash_1.clone(initial);
    };
};
exports.default = getResetValue;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sensitive\\getResetValue.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sensitive\\getResetValue.ts"); } } })();

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var form_1 = __webpack_require__(16);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var ExternalLink_1 = __webpack_require__(26);
var InternalLink_1 = __webpack_require__(43);
var FormSectionHeading_1 = __webpack_require__(48);
var CommonSummaryHelper_1 = __webpack_require__(62);
var routeLinks_1 = __webpack_require__(22);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var feedResource_1 = __webpack_require__(73);
var TentaclePackageAction = (function (_super) {
    __extends(TentaclePackageAction, _super);
    function TentaclePackageAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    TentaclePackageAction.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    TentaclePackageAction.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy package ",
            React.createElement("strong", null,
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return TentaclePackageAction;
}(BaseComponent_1.BaseComponent));
var TentaclePackageActionEdit = (function (_super) {
    __extends(TentaclePackageActionEdit, _super);
    function TentaclePackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    TentaclePackageActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    TentaclePackageActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy the contents of a package to one or more machines. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab. The package that you wish to deploy should contain all the files needed to run your application. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "package", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven, feedResource_1.FeedType.GitHub], refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })));
    };
    return TentaclePackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.TentaclePackageActionEdit = TentaclePackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.TentaclePackage",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(TentaclePackageAction, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TentaclePackageActionEdit,
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles",
            "Octopus.Features.IisHome", "Octopus.Features.IISWebSite", "Octopus.Features.RedGateDatabase", "Octopus.Features.WindowsService"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tentaclePackage\\tentaclePackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tentaclePackage\\tentaclePackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(90);
var OkDialogLayout_1 = __webpack_require__(65);
var form_1 = __webpack_require__(16);
var PackageSelector_1 = __webpack_require__(53);
var feedResource_1 = __webpack_require__(73);
var StringCheckbox_1 = __webpack_require__(41);
var PackageDownloadOptions_1 = __webpack_require__(118);
var _ = __webpack_require__(11);
var Callout_1 = __webpack_require__(58);
var isBound_1 = __webpack_require__(54);
var ExternalLink_1 = __webpack_require__(26);
var Note_1 = __webpack_require__(20);
var Fragment_1 = __webpack_require__(92);
var ScriptPackageReferenceDialog = (function (_super) {
    __extends(ScriptPackageReferenceDialog, _super);
    function ScriptPackageReferenceDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            if (!_this.state.name) {
                _this.setError("Please enter a name");
                return false;
            }
            if (!_this.state.packageId) {
                _this.setError("Please select a package ID");
                return false;
            }
            if (!_this.state.feedId) {
                _this.setError("Please select a feed ID");
                return false;
            }
            var packageReference = {
                Name: _this.state.name,
                PackageId: _this.state.packageId,
                FeedId: _this.state.feedId,
                AcquisitionLocation: _this.state.acquisitionLocation,
                Properties: { Extract: _this.state.extract }
            };
            return _this.props.onChange(packageReference);
        };
        _this.onPackageIdChange = function (packageId) {
            var name = _this.state.name;
            var showNameDefaultedMessage = false;
            var showNameChangeWarning = false;
            // If `Name` was the default value (the previous package ID), then update it to the new package ID
            if ((!!packageId && !isBound_1.default(packageId) && !(!!_this.state.originalName && _this.state.originalName !== _this.sanitizeName(_this.state.originalPackageId)))) {
                name = _this.sanitizeName(packageId);
                showNameChangeWarning = _this.shouldShowNameChangeWarning(name);
                showNameDefaultedMessage = !showNameChangeWarning; // Showing both the info and the warning gets a bit noisy
            }
            _this.setState({
                packageId: packageId,
                name: name,
                showNameDefaultedMessage: showNameDefaultedMessage,
                showNameChangeWarning: showNameChangeWarning
            });
        };
        _this.onFeedIdChange = function (feedId) {
            _this.setState({ feedId: feedId });
            // If the feed doesn't support extracting packages, then reset extract to "False"
            if (!_this.shouldShowExtractOption(feedId)) {
                _this.setState({ extract: "False" });
            }
        };
        _this.onNameChange = function (name) {
            _this.setState({
                name: name,
                showNameChangeWarning: _this.shouldShowNameChangeWarning(name)
            });
        };
        _this.shouldShowExtractOption = function (feedId) {
            var feed = _.find(_this.props.feeds, function (f) { return f.Id === feedId; });
            // Show the option to extract if the feed-type supports it
            // or if the feed is bound to a variable.
            return !feed || feedResource_1.feedTypeSupportsExtraction(feed.FeedType);
        };
        _this.shouldShowNameChangeWarning = function (name) {
            // If the name is changing from a previous value, then we'll show a warning regarding external dependencies
            return !!name && !!_this.state.originalName && name !== _this.state.originalName;
        };
        // Some package ID's are invalid names, so we will try and sanitize them into valid a name
        _this.sanitizeName = function (name) {
            if (!name) {
                return name;
            }
            // Container image ID's may contain `/`
            // Maven package ID's will contain `:`
            // We will take everything to the right of the last invalid-char as the name.
            // e.g. hashicorp/http-echo -> http-echo
            // e.g. org.acme:acme-web -> acme-web
            // Of course there may be other invalid characters, but these are two common ones, so we optimize for them.
            // Any others will fail server-side validation.
            var lastInvalidCharIndex = name.search("[/,:]");
            // If no invalid chars found
            if (lastInvalidCharIndex < 0) {
                return name;
            }
            // If the last character is an invalid char?  We'll just clear the name to force them to set it manually.
            if (lastInvalidCharIndex === name.length - 1) {
                return "";
            }
            // Return everything after the last invalid char
            return name.substring(lastInvalidCharIndex + 1);
        };
        _this.state = {
            name: _this.props.packageReference.Name,
            packageId: _this.props.packageReference.PackageId,
            feedId: _this.props.packageReference.FeedId,
            extract: _this.props.packageReference.Properties["Extract"],
            acquisitionLocation: _this.props.packageReference.AcquisitionLocation,
            originalName: _this.props.packageReference.Name,
            originalPackageId: _this.props.packageReference.PackageId,
            showNameDefaultedMessage: false,
            showNameChangeWarning: false
        };
        return _this;
    }
    ScriptPackageReferenceDialog.prototype.render = function () {
        var _this = this;
        var feed = _.find(this.props.feeds, function (f) { return f.Id === _this.state.feedId; });
        var showExtract = this.shouldShowExtractOption(this.state.feedId);
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Reference a Package" }, this.props.packageReference && React.createElement("div", null,
            React.createElement(PackageSelector_1.default, { packageId: this.state.packageId, feedId: this.state.feedId, onPackageIdChange: function (packageId) { return _this.onPackageIdChange(packageId); }, onFeedIdChange: function (feedId) { return _this.onFeedIdChange(feedId); }, localNames: this.props.localNames, projectId: this.props.projectId, feeds: this.props.feeds, refreshFeeds: this.props.refreshFeeds }),
            this.state.showNameDefaultedMessage && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                "The name has been defaulted to the selected Package ID. This is appropriate for most scenarios (see the ",
                React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferenceName" }, "documentation"),
                " for more information)."),
            this.state.showNameChangeWarning && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning }, "The name has been changed. If you have external dependencies on this field (custom scripts, build-server plugins, etc) these will need to be updated."),
            React.createElement(form_1.Text, { label: "Name", value: this.state.name, onChange: function (name) { return _this.onNameChange(name); }, validate: form_1.required("Please supply a Name") }),
            React.createElement(Note_1.default, null,
                "The name is used to identify the package reference. Learn more about the ",
                React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferenceName" }, "package name"),
                "."),
            React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: this.state.acquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) { return _this.setState({ acquisitionLocation: acquisitionLocation }); }, runOn: this.props.runOn, showNotAcquiredOption: true, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames }),
            showExtract && React.createElement(Fragment_1.Fragment, null,
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: this.props.packageReference.Properties["Extract"], value: this.state.extract, label: "Extract package during deployment", onChange: function (extract) { return _this.setState({ extract: extract }); } }),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "ScriptStepPackageReferencesFromCustomScripts" }, "Accessing Package References from a Custom Script"),
                    "."))));
    };
    return ScriptPackageReferenceDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.ScriptPackageReferenceDialog = ScriptPackageReferenceDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\script\\ScriptPackageReferenceDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\script\\ScriptPackageReferenceDialog.tsx"); } } })();

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var SaveDialogLayout_1 = __webpack_require__(300);
var CodeEditor_1 = __webpack_require__(107);
var clientInstance_1 = __webpack_require__(10);
var CopyToClipboardButton_1 = __webpack_require__(415);
var SaveDialogLayout_2 = __webpack_require__(300);
var DialogActions_1 = __webpack_require__(749);
var TemplateSourceCodeDialog = (function (_super) {
    __extends(TemplateSourceCodeDialog, _super);
    function TemplateSourceCodeDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            metadata: null,
            template: _this.props.template
        };
        return _this;
    }
    TemplateSourceCodeDialog.prototype.getMetadata = function (template) {
        return clientInstance_1.repository.CloudTemplates.getMetadata(template, this.props.metadata);
    };
    TemplateSourceCodeDialog.prototype.componentWillReceiveProps = function (newprops) {
        if (!newprops.open) {
            this.setState({ errors: null, template: newprops.template });
        }
    };
    TemplateSourceCodeDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getMetadata(this.state.template)];
                    case 1:
                        metadata = _a.sent();
                        this.props.saveDone(this.state.template, metadata);
                        return [2 /*return*/, true];
                    case 2:
                        err_1 = _a.sent();
                        this.setState({ errors: { message: err_1.ErrorMessage, details: err_1.Errors ? err_1.Errors.map(function (x) { return x.toString(); }) : null, fieldErrors: {} } });
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TemplateSourceCodeDialog.prototype.onFocusedEditorEscapePressed = function () {
        if (this.editor) {
            this.editor.blur();
        }
    };
    TemplateSourceCodeDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { open: this.props.open, close: this.props.close, renderTitle: function () { return React.createElement(SaveDialogLayout_2.SaveDialogTitleBar, { title: _this.props.title ? _this.props.title : "Edit Source" }); }, errors: this.state.errors, onSaveClick: function () { return _this.save(); }, renderActions: function (renderProps) { return (React.createElement(DialogActions_1.DialogActions, { actions: React.createElement(SaveDialogLayout_2.SaveDialogActions, { close: renderProps.close, onSaveClick: renderProps.onSaveClick, savePermission: renderProps.savePermission }), additionalActions: React.createElement(CopyToClipboardButton_1.default, { value: _this.state.template }) })); }, busy: null },
            React.createElement(CodeEditor_1.default, { value: this.state.template, ref: function (e) { return _this.editor = e; }, language: this.props.textFormat || CodeEditor_1.TextFormat.JSON, allowFullScreen: false, onChange: function (template) { _this.setState({ template: template }); }, autoFocus: this.props.template == null || this.props.template === undefined || this.props.template.length === 0, onEscPressed: function () { return _this.onFocusedEditorEscapePressed(); } }));
    };
    return TemplateSourceCodeDialog;
}(BaseComponent_1.default));
exports.default = TemplateSourceCodeDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SourceCodeDialog\\sourceCodeDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SourceCodeDialog\\sourceCodeDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariableType;
(function (VariableType) {
    VariableType["String"] = "String";
    VariableType["Sensitive"] = "Sensitive";
    VariableType["Certificate"] = "Certificate";
    VariableType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
    VariableType["AzureAccount"] = "AzureAccount";
})(VariableType = exports.VariableType || (exports.VariableType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\variableResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\variableResource.ts"); } } })();

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormBaseComponent_1 = __webpack_require__(155);
exports.FormBaseComponent = FormBaseComponent_1.default;
exports.OptionalFormBaseComponentState = FormBaseComponent_1.OptionalFormBaseComponentState;
exports.default = FormBaseComponent_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\index.ts"); } } })();

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var List_1 = __webpack_require__(451);
var SimpleList_1 = __webpack_require__(464);
exports.SimpleList = SimpleList_1.SimpleList;
exports.default = List_1.List;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\index.tsx"); } } })();

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskState;
(function (TaskState) {
    TaskState["Queued"] = "Queued";
    TaskState["Executing"] = "Executing";
    TaskState["Failed"] = "Failed";
    TaskState["Canceled"] = "Canceled";
    TaskState["TimedOut"] = "TimedOut";
    TaskState["Success"] = "Success";
    TaskState["Cancelling"] = "Cancelling";
})(TaskState = exports.TaskState || (exports.TaskState = {}));
exports.default = TaskState;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskState.ts"); } } })();

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-Regular.3e1af3ef546b9e6ecef9f3ba197bf7d2.hashedasset.ttf";

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-italic.42bbe4eefcde1297b11dc4b6491e9746.hashedasset.ttf";

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-light.fc84e998bc29b297ea20321e4c90b6ed.hashedasset.ttf";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-medium.d08840599e05db7345652d3d417574a9.hashedasset.ttf";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Roboto-bold.ee7b96fa85d8fdb8c126409326ac2d2b.hashedasset.ttf";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.8acc0c7e45d7d6f690a7342d70180835.hashedasset.woff";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.5eed1ba76b15097fa82835184a007327.hashedasset.ttf";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fontoctopus.84200d09800b6f6d6b36c793c47c0be5.hashedasset.svg";

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Divider_1 = __webpack_require__(162);
var styles = __webpack_require__(1565);
var SidebarSide;
(function (SidebarSide) {
    SidebarSide[SidebarSide["Right"] = 0] = "Right";
    SidebarSide[SidebarSide["Left"] = 1] = "Left";
})(SidebarSide = exports.SidebarSide || (exports.SidebarSide = {}));
var SidebarLayout = function (props) {
    var sidebarSide = props.side ? props.side : SidebarSide.Right;
    return React.createElement("div", { className: styles.bodyWithSides },
        sidebarSide === SidebarSide.Left && renderSidebar(styles.sideBarLeft, props),
        React.createElement("div", { className: styles.main + " " + (props.overflowXHidden ? styles.overflowXHidden : "") },
            props.sideBar && !props.hideTopDivider ? React.createElement(Divider_1.default, { fullHeight: true }) : null,
            React.createElement("div", { className: !props.extendContentToEdges && props.sideBar ? styles.mainContent : "" }, props.children)),
        sidebarSide === SidebarSide.Right && renderSidebar(styles.sideBarRight, props));
};
function renderSidebar(dividerClassName, props) {
    if (!props.sideBar) {
        return null;
    }
    var className = styles.sidebarContainer + " " + (props.hideSidebarDivider ? "" : dividerClassName) + " " + styles.sideBar;
    var containerStyle = {};
    if (props.flexBasis) {
        containerStyle.flexBasis = props.flexBasis;
    }
    return React.createElement("div", { className: className, style: containerStyle },
        !props.hideTopDivider ? React.createElement(Divider_1.default, { fullHeight: true }) : null,
        React.createElement("div", { className: "" + (props.extendSidebarToEdges ? "" : styles.sideBarPadding) }, props.sideBar));
}
exports.default = SidebarLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SidebarLayout\\SidebarLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SidebarLayout\\SidebarLayout.tsx"); } } })();

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormPaperLayout_1 = __webpack_require__(195);
exports.default = FormPaperLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\index.tsx"); } } })();

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskRestrictedTo;
(function (TaskRestrictedTo) {
    TaskRestrictedTo["DeploymentTargets"] = "DeploymentTargets";
    TaskRestrictedTo["Workers"] = "Workers";
    TaskRestrictedTo["Policies"] = "Policies";
    TaskRestrictedTo["Unrestricted"] = "Unrestricted";
})(TaskRestrictedTo = exports.TaskRestrictedTo || (exports.TaskRestrictedTo = {}));
var TaskName;
(function (TaskName) {
    TaskName["Backup"] = "Backup";
    TaskName["Deploy"] = "Deploy";
    TaskName["Health"] = "Health";
    TaskName["AdHocScript"] = "AdHocScript";
    TaskName["AutoDeploy"] = "AutoDeploy";
    TaskName["ConfigureLetsEncrypt"] = "ConfigureLetsEncrypt";
    TaskName["Upgrade"] = "Upgrade";
    TaskName["TestEmail"] = "TestEmail";
    TaskName["TestAzureAccount"] = "TestAzureAccount";
    TaskName["TestAccount"] = "TestAccount";
    TaskName["Retention"] = "Retention";
    TaskName["Delete"] = "Delete";
    TaskName["SystemIntegrityCheck"] = "SystemIntegrityCheck";
    TaskName["SyncCommunityActionTemplates"] = "SyncCommunityActionTemplates";
    TaskName["SynchronizeBuiltInPackageRepositoryIndex"] = "SynchronizeBuiltInPackageRepositoryIndex";
    TaskName["SynchronizeExternalSecurityGroupsForUsers"] = "SynchronizeExternalSecurityGroupsForUsers";
    TaskName["UpdateCalamari"] = "UpdateCalamari";
    TaskName["Subscription"] = "Subscription";
    TaskName["MigrationSpacePartialExport"] = "MigrationSpacePartialExport";
    TaskName["MigrationSpaceImport"] = "MigrationSpaceImport";
})(TaskName = exports.TaskName || (exports.TaskName = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskResource.ts"); } } })();

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var PagingBaseComponent_1 = __webpack_require__(491);
var ListInternalLink_1 = __webpack_require__(496);
var styles = __webpack_require__(405);
var colors_1 = __webpack_require__(31);
var PagingBaseComponent_2 = __webpack_require__(206);
var Section_1 = __webpack_require__(81);
var Divider_1 = __webpack_require__(162);
var InternalRedirect_1 = __webpack_require__(45);
var TransitionAnimation_1 = __webpack_require__(82);
var List = (function (_super) {
    __extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.empty = (React.createElement("div", null, "No results"));
        _this.empty = props.empty || _this.empty;
        return _this;
    }
    List.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.state.data || !this.state.data.Items) {
            return React.createElement(Section_1.Section, null);
        }
        return (React.createElement(TransitionAnimation_1.default, null,
            this.renderFilterSearchComponents(),
            this.state.data.Items.length === 0
                ? React.createElement("div", { className: styles.emptyList }, this.empty)
                : React.createElement(material_ui_1.List, null,
                    this.state.data.Items.filter(function (item) { return _this.onFilter(_this.state.filter, item); })
                        .map(function (item, index) { return _this.buildItem(item, index); }),
                    this.state.data.Items.length < this.state.data.TotalResults
                        ?
                            this.props.showPagingInNumberedStyle
                                ? this.showPagingInNumberedStyle()
                                : this.showPagingInLoadMoreStyle()
                        : null)));
    };
    List.prototype.buildItem = function (item, index) {
        var _this = this;
        var redirectUrl = PagingBaseComponent_2.getNavigationUrl(this.props, item);
        var nodeRow = this.props.onRow(item);
        if (redirectUrl) {
            // Make these actual href links, so people can still right-click > open new window (this is expected usability for things you can click).
            nodeRow = React.createElement(ListInternalLink_1.default, { to: redirectUrl }, nodeRow);
        }
        var nodes = [
            React.createElement(material_ui_1.ListItem, { key: item.Id, className: styles.listItem, onClick: function (e) { return _this.navigate(item); }, hoverColor: colors_1.hover }, nodeRow)
        ];
        if (index < (this.state.data.Items.length - 1)) {
            nodes.push(React.createElement(Divider_1.default, null));
        }
        return (React.Children.toArray(nodes));
    };
    return List;
}(PagingBaseComponent_1.default));
exports.List = List;
List.defaultProps = {
    showFilterWithinSection: true,
    autoFocusOnFilterSearch: true
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\List.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\List.tsx"); } } })();

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(213);
var AccountType;
(function (AccountType) {
    AccountType["None"] = "None";
    AccountType["UsernamePassword"] = "UsernamePassword";
    AccountType["Token"] = "Token";
    AccountType["SshKeyPair"] = "SshKeyPair";
    AccountType["AzureSubscription"] = "AzureSubscription";
    AccountType["AzureServicePrincipal"] = "AzureServicePrincipal";
    AccountType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AccountResource = (function (_super) {
    __extends(AccountResource, _super);
    function AccountResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AccountResource;
}(namedResource_1.default));
exports.AccountResource = AccountResource;
var AzureServicePrincipalAccountResource = (function (_super) {
    __extends(AzureServicePrincipalAccountResource, _super);
    function AzureServicePrincipalAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AzureServicePrincipal;
        return _this;
    }
    return AzureServicePrincipalAccountResource;
}(AccountResource));
exports.AzureServicePrincipalAccountResource = AzureServicePrincipalAccountResource;
var AzureSubscriptionAccountResource = (function (_super) {
    __extends(AzureSubscriptionAccountResource, _super);
    function AzureSubscriptionAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AzureSubscription;
        return _this;
    }
    return AzureSubscriptionAccountResource;
}(AccountResource));
exports.AzureSubscriptionAccountResource = AzureSubscriptionAccountResource;
var SshKeyPairAccountResource = (function (_super) {
    __extends(SshKeyPairAccountResource, _super);
    function SshKeyPairAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.SshKeyPair;
        return _this;
    }
    return SshKeyPairAccountResource;
}(AccountResource));
exports.SshKeyPairAccountResource = SshKeyPairAccountResource;
var UsernamePasswordAccountResource = (function (_super) {
    __extends(UsernamePasswordAccountResource, _super);
    function UsernamePasswordAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.UsernamePassword;
        return _this;
    }
    return UsernamePasswordAccountResource;
}(AccountResource));
exports.UsernamePasswordAccountResource = UsernamePasswordAccountResource;
var TokenAccountResource = (function (_super) {
    __extends(TokenAccountResource, _super);
    function TokenAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.Token;
        return _this;
    }
    return TokenAccountResource;
}(AccountResource));
exports.TokenAccountResource = TokenAccountResource;
var AmazonWebServicesAccountResource = (function (_super) {
    __extends(AmazonWebServicesAccountResource, _super);
    function AmazonWebServicesAccountResource() {
        var _this = _super.call(this) || this;
        _this.AccountType = AccountType.AmazonWebServicesAccount;
        return _this;
    }
    return AmazonWebServicesAccountResource;
}(AccountResource));
exports.AmazonWebServicesAccountResource = AmazonWebServicesAccountResource;
exports.default = AccountResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\accountResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\accountResource.ts"); } } })();

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(102);
var RequestRaceConditioner = (function () {
    function RequestRaceConditioner() {
    }
    // To avoid race conditions, this helps check we are only showing the LAST request's response.
    // This was necessary on screens with a side-filter panel, as users can quickly select multiple
    // filters, causing multiple API requests, so this guarantees that "the last request wins".
    RequestRaceConditioner.prototype.avoidStaleResponsesForRequest = function (promise, completionCallback, staleCallback) {
        if (staleCallback === void 0) { staleCallback = null; }
        return __awaiter(this, void 0, void 0, function () {
            var requestTimestamp, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestTimestamp = Date.now();
                        this.requestTimestamp = requestTimestamp;
                        return [4 /*yield*/, promise];
                    case 1:
                        response = _a.sent();
                        if (this.requestTimestamp === requestTimestamp) {
                            completionCallback(response);
                        }
                        else {
                            logger_1.default.log("Ignoring stale response (this request has been superceded)");
                            if (staleCallback) {
                                staleCallback(response);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return RequestRaceConditioner;
}());
exports.default = RequestRaceConditioner;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\RequestRaceConditioner\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\RequestRaceConditioner\\index.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PermissionCheck_1 = __webpack_require__(42);
exports.PermissionCheck = PermissionCheck_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PermissionCheck\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PermissionCheck\\index.tsx"); } } })();

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(66);
exports.default = ParseHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ParseHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ParseHelper\\index.tsx"); } } })();

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(64);
var expanders_1 = __webpack_require__(315);
var store_1 = __webpack_require__(123);
var styles = __webpack_require__(117);
var lodash_1 = __webpack_require__(11);
exports.toggleExpandos = function (expanded, containerKey) {
    store_1.default.dispatch(expanders_1.onToggleAll(containerKey, expanded));
};
var ExpansionButtonsInternal = (function (_super) {
    __extends(ExpansionButtonsInternal, _super);
    function ExpansionButtonsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpand = function (isExpanded) {
            _this.props.onToggleAll(_this.props.containerKey, isExpanded);
        };
        _this.toggleExpandInt = function (e, isExpanded) {
            e.preventDefault();
            _this.toggleExpand(isExpanded);
        };
        return _this;
    }
    ExpansionButtonsInternal.prototype.componentDidMount = function () {
        this.props.onMount(this.props.containerKey, this.props.expandAllOnMount);
    };
    ExpansionButtonsInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.linkContainer },
            this.expandedValues().some(function (e) { return e === false; }) && React.createElement("a", { href: "#", className: styles.expandLink, onClick: function (e) { return _this.toggleExpandInt(e, true); } }, "EXPAND ALL"),
            this.expandedValues().some(function (e) { return e === true; }) && React.createElement("a", { href: "#", className: styles.expandLink, onClick: function (e) { return _this.toggleExpandInt(e, false); } }, "COLLAPSE ALL"));
    };
    ExpansionButtonsInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.containerKey !== this.props.containerKey) {
            this.props.onDestroy(this.props.containerKey);
        }
        if (nextProps.containerKey !== this.props.containerKey || nextProps.expandAllOnMount !== this.props.expandAllOnMount) {
            this.props.onMount(this.props.containerKey, nextProps.expandAllOnMount);
        }
        this.openExpandersWithErrors(nextProps);
    };
    ExpansionButtonsInternal.prototype.componentWillUnmount = function () {
        this.props.onDestroy(this.props.containerKey);
    };
    ExpansionButtonsInternal.prototype.openExpandersWithErrors = function (nextProps) {
        // ref comparison seems to be okay here.
        if (nextProps.errors && !lodash_1.isEqual(nextProps.errors, this.props.errors)) {
            this.props.onExpandErrors(this.props.containerKey, Object.keys(nextProps.errors.fieldErrors));
        }
    };
    ExpansionButtonsInternal.prototype.expandedValues = function () {
        return this.props.expanded;
    };
    return ExpansionButtonsInternal;
}(React.Component));
ExpansionButtonsInternal.defaultProps = {
    expandAllOnMount: false
};
var mapStateToProps = function (state, ownProps) {
    var containerKey = ownProps.containerKey || expanders_1.defaultContainerKey;
    var container = state.expanders && state.expanders.hasOwnProperty(containerKey) ? state.expanders[containerKey] : null;
    var initialState = container && container.initialState;
    var storedValues = container ? container.expanderValues : {};
    var expanded = Object.keys(storedValues).map(getValueForKey);
    return { expanded: expanded };
    function getValueForKey(errorKey) {
        var value = storedValues[errorKey];
        return value === undefined || value === null ? initialState : value;
    }
};
var mapDispatchToProps = function (dispatch) {
    return {
        onToggleAll: function (containerKey, expanded) {
            exports.toggleExpandos(expanded, containerKey);
        },
        onExpandErrors: function (containerKey, errorKeys) {
            dispatch(expanders_1.onExpandErrors(containerKey, errorKeys));
        },
        onDestroy: function (containerKey) {
            dispatch(expanders_1.onExpanderContainerDestroyed(containerKey));
        },
        onMount: function (containerKey, initialState) {
            dispatch(expanders_1.onExpanderSetInitialState(containerKey, initialState));
        }
    };
};
var ExpansionButtons = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpansionButtonsInternal);
exports.default = ExpansionButtons;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\ExpansionButtons.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\ExpansionButtons.tsx"); } } })();

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(24);
var MultiSelect_1 = __webpack_require__(75);
var RoleTypedMultiSelect = MultiSelect_1.MultiSelect();
var RoleMultiSelect = function (props) {
    var onAdd = function (value) {
        props.onChange(props.value.concat(value));
    };
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(Chips_1.RoleChip, { onRequestDelete: onRequestDelete, role: r.Name });
    };
    return React.createElement(RoleTypedMultiSelect, { items: props.items.map(function (i) { return ({ Id: i, Name: i }); }), fieldName: "target roles", label: props.label, renderChip: chipRenderer, onNew: props.canAdd ? onAdd : null, value: props.value, onChange: props.onChange, error: props.error, openOnFocus: props.openOnFocus, autoFocus: props.autoFocus, hideFloatingLabel: props.hideFloatingLabel, addNewTemplate: function (text) { return "\"" + text + "\" (add new role)"; } });
};
exports.default = RoleMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\RoleMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\RoleMultiSelect.tsx"); } } })();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Clipboard = __webpack_require__(1774);
var ToolTip_1 = __webpack_require__(74);
var IconButton_1 = __webpack_require__(67);
var content_copy_1 = __webpack_require__(1782);
var styles = __webpack_require__(1783);
var CopyToClipboard = (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (el) {
            _this.element = el;
        };
        _this.state = { showConfirmation: false };
        return _this;
    }
    CopyToClipboard.prototype.componentDidMount = function () {
        var _this = this;
        this.clipboard = new Clipboard(this.element, {
            text: function () { return _this.props.value; }
        });
        this.clipboard.on("success", function () { return _this.onCopy(); });
    };
    CopyToClipboard.prototype.componentWillUnmount = function () {
        this.clipboard.destroy();
        if (this.hideTimeoutId) {
            window.clearTimeout(this.hideTimeoutId);
        }
    };
    CopyToClipboard.prototype.render = function () {
        var button = React.createElement("span", null,
            React.createElement(IconButton_1.default, { className: styles.defaultIconButton },
                React.createElement(content_copy_1.default, null)));
        return React.createElement("span", { ref: this.setRef },
            this.state.showConfirmation && React.createElement(ToolTip_1.default, { content: "Copied!", trigger: "manual", open: true }, button),
            !this.state.showConfirmation && React.createElement(ToolTip_1.default, { content: "Copy to clipboard" }, button));
    };
    CopyToClipboard.prototype.onCopy = function () {
        var _this = this;
        this.setState({ showConfirmation: true });
        if (this.hideTimeoutId) {
            window.clearTimeout(this.hideTimeoutId);
        }
        this.hideTimeoutId = window.setTimeout(function () { return _this.onHide(); }, 3500);
    };
    CopyToClipboard.prototype.onHide = function () {
        this.setState({ showConfirmation: false });
        this.hideTimeoutId = null;
    };
    return CopyToClipboard;
}(React.Component));
exports.default = CopyToClipboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CopyToClipboardButton\\CopyToClipboardButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CopyToClipboardButton\\CopyToClipboardButton.tsx"); } } })();

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var moment = __webpack_require__(119);
var DateFormatter_1 = __webpack_require__(237);
var styles = __webpack_require__(1789);
var TimeFromNowLabel = function (props) {
    return React.createElement("span", { className: styles.when }, props.useShortDateFormat
        ? React.createElement("abbr", { title: DateFormatter_1.default.momentAgo(props.time) }, DateFormatter_1.default.dateToShortFormat(props.time))
        : React.createElement("abbr", { title: DateFormatter_1.default.dateToLongFormat(props.time) }, moment(props.time).fromNow()));
};
exports.default = TimeFromNowLabel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TimeLabels\\TimeFromNowLabel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TimeLabels\\TimeFromNowLabel.tsx"); } } })();

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariableSetContentType;
(function (VariableSetContentType) {
    VariableSetContentType["Variables"] = "Variables";
    VariableSetContentType["ScriptModule"] = "ScriptModule";
})(VariableSetContentType = exports.VariableSetContentType || (exports.VariableSetContentType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\libraryVariableSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\libraryVariableSetResource.ts"); } } })();

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var moment = __webpack_require__(119);
var iconStyle_1 = __webpack_require__(1558);
exports.iconStyle = iconStyle_1.default;
var index_1 = __webpack_require__(74);
var resources_1 = __webpack_require__(17);
function momentFromFilter(fromDate, toDate) {
    if (!fromDate) {
        return null;
    }
    var fromMoment = moment(fromDate);
    var toMoment = toDate ? moment(toDate) : moment();
    var diff = fromMoment.diff(toMoment);
    var duration = moment.duration(diff);
    var mins = duration.minutes();
    var hours = duration.hours();
    var days = Math.floor(duration.asDays());
    var result = (mins === 1 ? "1 minute" : mins + " minutes");
    result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
    result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
    return result;
}
function inspector(task) {
    var pendingInterruptions = task.HasPendingInterruptions;
    var warningsOrErrors = task.HasWarningsOrErrors;
    var duration = task.Duration;
    var errorMessage = task.ErrorMessage;
    var description = task.State;
    var tip = "";
    var html = React.createElement("em", null);
    if (pendingInterruptions && !task.IsCompleted) {
        html = React.createElement("em", { className: "fa fa-eye" });
        description = "Waiting...";
        tip = "This task is waiting for manual intervention. Duration: " + duration;
    }
    else if (task.State === resources_1.TaskState.Cancelling) {
        html = React.createElement("em", { className: "fa fa-user-times" });
        description = "Cancelling";
        tip = "Cancellation has been requested, attempting to stop the task.";
    }
    else if (task.State === resources_1.TaskState.Queued) {
        html = React.createElement("em", { className: "fa fa-clock-o" });
        description = "Queued...";
        var timeQueued = moment(task.QueueTime).calendar();
        tip = "This task was queued to run " + timeQueued;
    }
    else if (task.State === resources_1.TaskState.Executing) {
        html = React.createElement("em", { className: "fa fa-spinner fa-pulse" });
        tip = "This task is being executed by the Octopus Server. Duration: " + duration;
    }
    else if (task.State === resources_1.TaskState.Failed) {
        html = React.createElement("em", { className: "fa fa-exclamation-triangle" });
        tip = "An error occurred while processing this task";
        tip = errorMessage && errorMessage.length > 0 ? tip + ": " + errorMessage : tip + ". See the task details for more information.";
    }
    else if (task.State === resources_1.TaskState.Canceled) {
        html = React.createElement("em", { className: "fa fa-user-times" });
        tip = "This task was canceled by a user.";
    }
    else if (task.State === resources_1.TaskState.TimedOut) {
        html = React.createElement("em", { className: "fa fa-clock-o" });
        description = "Timed out";
        var queueTime = moment(task.QueueTime).calendar();
        var expiryTime = momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
        var lastUpdated = moment(task.LastUpdatedTime).calendar();
        tip = "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server " +
            "attempted to run the task " + lastUpdated + ". This can happen when the Octopus Server is too busy to process the task.";
    }
    else if (task.State === resources_1.TaskState.Success) {
        if (warningsOrErrors) {
            html = (React.createElement("span", { style: { position: "relative" } },
                React.createElement("em", { className: "fa fa-check" }),
                React.createElement("span", { className: "status-overlay", style: { position: "absolute", bottom: "-8px", right: "-0.0625rem", fontSize: "10px" } },
                    React.createElement("em", { className: "fa fa-exclamation-triangle" }))));
            tip = "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
        }
        else {
            html = React.createElement("em", { className: "fa fa-check" });
            tip = "This task completed without any problems. Duration: " + duration;
        }
    }
    return {
        tip: tip,
        html: html,
        description: description
    };
}
var TaskStatusIcon = function (props) {
    var _a = inspector(props.item), tip = _a.tip, html = _a.html, description = _a.description;
    return (React.createElement(index_1.default, { content: tip },
        React.createElement("span", { className: iconStyle_1.default(props.item, props.smallIcon) }, html)));
};
exports.TaskStatusIcon = TaskStatusIcon;
TaskStatusIcon.displayName = "TaskStatusIcon";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\TaskStatusIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\TaskStatusIcon.tsx"); } } })();

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.renderWithLayout = function (layoutComponent, componentProps) {
    if (componentProps === void 0) { componentProps = {}; }
    return function (Component) {
        var RenderWithLayout = function (props) {
            var Layout = layoutComponent;
            return (React.createElement(Layout, __assign({}, props),
                React.createElement(Component, __assign({}, componentProps, props))));
        };
        return RenderWithLayout;
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RenderWithLayout\\RenderWithLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RenderWithLayout\\RenderWithLayout.tsx"); } } })();

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var Section_1 = __webpack_require__(81);
var FilterSearchBox_1 = __webpack_require__(198);
var ListInternalLink_1 = __webpack_require__(496);
var styles = __webpack_require__(405);
var PagingBaseComponent_1 = __webpack_require__(206);
var Divider_1 = __webpack_require__(162);
var NumberedPagingBar_1 = __webpack_require__(492);
var InternalRedirect_1 = __webpack_require__(45);
var TransitionAnimation_1 = __webpack_require__(82);
var SimpleList = (function (_super) {
    __extends(SimpleList, _super);
    function SimpleList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { currentPageIndex: 0 };
        return _this;
    }
    SimpleList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.pageSize) {
            var newLastPageIndex = nextProps.items.length === 0 ? 1 : Math.ceil(nextProps.items.length / nextProps.pageSize);
            if (newLastPageIndex < this.state.currentPageIndex) {
                this.setState({ currentPageIndex: newLastPageIndex });
            }
        }
    };
    SimpleList.prototype.onFilter = function (item) {
        var filter = this.state.filter;
        if (!filter || filter === "" || !this.props.onFilter) {
            return true;
        }
        return this.props.onFilter(this.state.filter, item);
    };
    SimpleList.prototype.renderEmpty = function () {
        return this.props.empty ? this.props.empty : React.createElement("div", null, "No results");
    };
    SimpleList.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.props.items) {
            return null;
        }
        var filteredList = this.props.items
            .filter(function (item) { return _this.onFilter(item); });
        if (this.props.pageSize) {
            var firstItemIndex = this.props.pageSize * this.state.currentPageIndex;
            filteredList = filteredList.slice(firstItemIndex, firstItemIndex + this.props.pageSize);
        }
        return React.createElement(TransitionAnimation_1.default, null,
            React.createElement(material_ui_1.List, null,
                this.props.onFilter && this.renderFilterSearchComponents(),
                (filteredList.length === 0) && React.createElement("div", { className: styles.emptyList }, this.renderEmpty()),
                filteredList.map(function (item, index) { return _this.buildItem(item, index); }),
                this.props.pageSize &&
                    React.createElement(NumberedPagingBar_1.default, { currentPageIndex: this.state.currentPageIndex, totalItems: this.props.items.length, pageSize: this.props.pageSize, onPageSelected: function (skip, currentPageIndex) { return _this.setState({ currentPageIndex: currentPageIndex }); } })));
    };
    SimpleList.prototype.buildItem = function (item, index) {
        var _this = this;
        var redirectUrl = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        var nodeRow = this.props.onRow(item);
        if (redirectUrl) {
            // Make these actual href links, so people can still right-click > open new window (this is expected usability for things you can click).
            nodeRow = React.createElement(ListInternalLink_1.default, { to: redirectUrl }, nodeRow);
        }
        var nodes = [
            React.createElement(material_ui_1.ListItem, { key: 0, className: styles.listItem, onClick: function (e) { return _this.navigate(item); }, disabled: this.props.disableListItem }, nodeRow)
        ];
        if (index < (this.props.items.length - 1)) {
            nodes.push(React.createElement(Divider_1.default, null));
        }
        return (React.Children.toArray(nodes));
    };
    SimpleList.prototype.navigate = function (item) {
        var redirectTo = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    SimpleList.prototype.renderFilterSearchComponents = function () {
        var _this = this;
        return (React.createElement(Section_1.Section, null,
            React.createElement(FilterSearchBox_1.default, { hintText: "Filter...", onChange: function (filter) { return _this.setState({ filter: filter }); }, autoFocus: this.props.autoFocusOnFilterSearch })));
    };
    return SimpleList;
}(React.Component));
exports.SimpleList = SimpleList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\SimpleList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\List\\SimpleList.tsx"); } } })();

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(122);
var react_router_dom_1 = __webpack_require__(61);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var notFoundImage = __webpack_require__(1806);
var styles = __webpack_require__(1807);
var RedirectAs404 = function () { return React.createElement(react_router_dom_1.Route, { render: function (_a) {
        var location = _a.location;
        return React.createElement(InternalRedirect_1.default, { to: __assign({}, location, { state: { is404: true } }) });
    } }); };
exports.RedirectAs404 = RedirectAs404;
var NotFound = function () {
    return React.createElement("main", { id: "maincontent" },
        React.createElement(index_1.default, { link: routeLinks_1.default.root, title: "Page not found" }),
        React.createElement("div", { className: styles.container },
            React.createElement("img", { src: notFoundImage, alt: "Page couldn't be found" }),
            React.createElement("h4", null, "Page not found."),
            React.createElement("p", null, "Sorry, the page you are looking for could not be found.")));
};
exports.NotFound = NotFound;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NotFound\\NotFound.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NotFound\\NotFound.tsx"); } } })();

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataTable_1 = __webpack_require__(306);
var BaseComponent_1 = __webpack_require__(60);
var styles = __webpack_require__(1910);
var cn = __webpack_require__(19);
var PagingBaseComponent_1 = __webpack_require__(206);
var InternalRedirect_1 = __webpack_require__(45);
var TransitionAnimation_1 = __webpack_require__(82);
var SimpleDataTable = (function (_super) {
    __extends(SimpleDataTable, _super);
    function SimpleDataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SimpleDataTable.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var _a = this.props, onToolsSection = _a.onToolsSection, data = _a.data, headerColumns = _a.headerColumns, headerColumnClassName = _a.headerColumnClassName, rowColumnClassName = _a.rowColumnClassName, onRow = _a.onRow, onEmpty = _a.onEmpty;
        if (!data) {
            return null;
        }
        return React.createElement(TransitionAnimation_1.default, null,
            React.createElement(DataTable_1.DataTable, null,
                React.createElement(DataTable_1.DataTableHeader, null,
                    onToolsSection ?
                        React.createElement(DataTable_1.DataTableToolsRow, null,
                            React.createElement(DataTable_1.DataTableHeaderColumn, { colSpan: headerColumns.length }, onToolsSection()))
                        : null,
                    data.length > 0
                        ? this.buildTableHeader(headerColumns, headerColumnClassName)
                        : null),
                React.createElement(DataTable_1.DataTableBody, null, data.length > 0
                    ? data.map(function (item, index) {
                        return _this.buildTableRow(item, index, onRow(item), rowColumnClassName);
                    })
                    : React.createElement(DataTable_1.DataTableRow, { displayNoBorder: true },
                        React.createElement(DataTable_1.DataTableRowColumn, null, onEmpty)))));
    };
    SimpleDataTable.prototype.buildTableHeader = function (headerColumns, className) {
        return (React.createElement(DataTable_1.DataTableRow, null, headerColumns.map(function (col, index) {
            var props = {
                key: index
            };
            if (className) {
                props["className"] = className;
            }
            return (React.createElement(DataTable_1.DataTableHeaderColumn, __assign({}, props), col));
        })));
    };
    SimpleDataTable.prototype.buildTableRow = function (item, index, rowColumns, className) {
        var _this = this;
        // Only some tables include a redirect, so only show cursor if necessary.
        var redirectUrl = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        var linkClassName = redirectUrl ? styles.linkableItem : null;
        return (React.createElement(DataTable_1.DataTableRow, { key: index, onClick: function (e) { return _this.navigate(item); } }, rowColumns.map(function (col, idx) {
            var props = {
                key: idx
            };
            if (className) {
                props["className"] = cn(className, props["className"]);
            }
            if (linkClassName) {
                props["className"] = cn(linkClassName, props["className"]);
            }
            return (React.createElement(DataTable_1.DataTableRowColumn, __assign({}, props), col));
        })));
    };
    SimpleDataTable.prototype.navigate = function (item) {
        var redirectTo = PagingBaseComponent_1.getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo: redirectTo });
    };
    return SimpleDataTable;
}(BaseComponent_1.default));
exports.default = SimpleDataTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleDataTable\\SimpleDataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleDataTable\\SimpleDataTable.tsx"); } } })();

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var ActionKeys;
(function (ActionKeys) {
    ActionKeys["CONFIGURATION_FEATURES_FETCHED"] = "CONFIGURATION_FEATURES_FETCHED";
    ActionKeys["OTHER_ACTION"] = "__any_other_action_type__";
})(ActionKeys || (ActionKeys = {}));
exports.configurationActions = {
    featuresFetched: function (features) { return ({
        type: ActionKeys.CONFIGURATION_FEATURES_FETCHED,
        features: features
    }); }
};
var featuresReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case ActionKeys.CONFIGURATION_FEATURES_FETCHED:
            if (!action.features) {
                return null;
            }
            return {
                isBuiltInRepoSyncEnabled: action.features.IsBuiltInRepoSyncEnabled,
                isCommunityActionTemplatesEnabled: action.features.IsCommunityActionTemplatesEnabled,
                isMultiTenancyEnabled: action.features.IsMultiTenancyEnabled,
                isBuiltInWorkerEnabled: action.features.IsBuiltInWorkerEnabled,
                isKubernetesEnabled: action.features.IsKubernetesEnabled
            };
        default:
            return state;
    }
};
exports.configurationArea = redux_1.combineReducers({
    features: featuresReducer
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\reducers\\configurationArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\reducers\\configurationArea.ts"); } } })();

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataTable_1 = __webpack_require__(306);
var PagingBaseComponent_1 = __webpack_require__(491);
var lodash_1 = __webpack_require__(11);
var styles = __webpack_require__(1523);
var BusyIndicator_1 = __webpack_require__(95);
var cn = __webpack_require__(19);
var PagingBaseComponent_2 = __webpack_require__(206);
var Checkbox_1 = __webpack_require__(121);
var lodash_2 = __webpack_require__(11);
var InternalRedirect_1 = __webpack_require__(45);
var TransitionAnimation_1 = __webpack_require__(82);
var PagingDataTable = (function (_super) {
    __extends(PagingDataTable, _super);
    function PagingDataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.empty = (React.createElement("div", null, "No results"));
        _this.toggleAllChecked = function (state) {
            var checkedItems = {};
            if (state) {
                checkedItems = _this.state.data.Items
                    .filter(function (item) { return _this.onFilter(_this.state.filter, item); })
                    .reduce(function (idx, item) {
                    idx[item.Id] = true;
                    return idx;
                }, {});
            }
            _this.setState({ checkedItems: checkedItems }, function () { return _this.props.onItemsChecked(Object.keys(checkedItems)); });
        };
        _this.itemChecked = function (item, state) {
            var checkedItems = __assign({}, _this.state.checkedItems);
            if (state) {
                checkedItems[item.Id] = true;
            }
            else {
                delete checkedItems[item.Id];
            }
            _this.setState({ checkedItems: checkedItems }, function () {
                _this.props.onItemsChecked(Object.keys(_this.state.checkedItems));
            });
        };
        _this.state = __assign({}, _this.state, { checkedItems: {} });
        _this.empty = props.empty || _this.empty;
        return _this;
    }
    PagingDataTable.prototype.componentWillUpdate = function (newProps, newState) {
        this.reEvaluateCheckedItems(newState);
    };
    PagingDataTable.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        if (!this.state.data) {
            return React.createElement(BusyIndicator_1.default, { show: true });
        }
        var _a = this.props, onToolsSection = _a.onToolsSection, headerColumns = _a.headerColumns, headerColumnClassNames = _a.headerColumnClassNames, rowColumnClassName = _a.rowColumnClassName, onRow = _a.onRow, onEmpty = _a.onEmpty;
        var data = this.state.data;
        var thereIsData = data && data.Items && data.Items.length > 0;
        var items = thereIsData ?
            data.Items.filter(function (item) { return _this.onFilter(_this.state.filter, item); }) :
            null;
        var allChecked = thereIsData && items.length > 0 && this.props.onItemsChecked ?
            Object.keys(this.state.checkedItems).length === items.length :
            false;
        var fullColLength = this.props.onItemsChecked ? (headerColumns.length + 1) : headerColumns.length;
        return React.createElement(TransitionAnimation_1.default, null,
            React.createElement(DataTable_1.DataTable, null,
                React.createElement(DataTable_1.DataTableHeader, null,
                    (this.props.filterSearchEnabled || onToolsSection) &&
                        React.createElement(DataTable_1.DataTableToolsRow, null,
                            React.createElement(DataTable_1.DataTableHeaderColumn, { colSpan: fullColLength },
                                this.renderFilterSearchComponents(),
                                onToolsSection && onToolsSection())),
                    thereIsData
                        ? this.buildTableHeader(headerColumns, headerColumnClassNames, allChecked)
                        : null),
                React.createElement(DataTable_1.DataTableBody, null, thereIsData
                    ? items.map(function (item, index) { return _this.buildTableRow(item, index, onRow(item), rowColumnClassName); })
                    : React.createElement(DataTable_1.DataTableRow, { displayNoBorder: true },
                        React.createElement(DataTable_1.DataTableRowColumn, null, onEmpty ? onEmpty() : null))),
                thereIsData && data.Items.length < this.state.data.TotalResults
                    ? React.createElement(DataTable_1.DataTableFooter, null,
                        React.createElement(DataTable_1.DataTableToolsRow, null,
                            React.createElement(DataTable_1.DataTableFooterColumn, { colSpan: fullColLength }, this.props.showPagingInNumberedStyle
                                ? this.showPagingInNumberedStyle()
                                : this.showPagingInLoadMoreStyle())))
                    : null));
    };
    PagingDataTable.prototype.buildTableHeader = function (headerColumns, columnClassNames, allChecked) {
        var _this = this;
        return (React.createElement(DataTable_1.DataTableRow, null,
            this.props.onItemsChecked && React.createElement(DataTable_1.DataTableHeaderColumn, null,
                React.createElement(Checkbox_1.default, { noMargin: true, value: allChecked, onChange: function (state) { return _this.toggleAllChecked(state); } })),
            headerColumns.map(function (col, index) {
                var props = {
                    key: index
                };
                if (columnClassNames) {
                    var className = columnClassNames[index];
                    props["className"] = className;
                }
                return (React.createElement(DataTable_1.DataTableHeaderColumn, __assign({}, props), col));
            })));
    };
    PagingDataTable.prototype.buildTableRow = function (item, index, rowColumns, className) {
        var _this = this;
        // Only some tables include a redirect, so only show cursor if necessary.
        var redirectUrl = PagingBaseComponent_2.getNavigationUrl(this.props, item);
        var linkClassName = redirectUrl ? styles.linkableItem : null;
        return (React.createElement(DataTable_1.DataTableRow, { key: index, onClick: function (e) { return _this.navigate(item); } },
            this.props.onItemsChecked && React.createElement(DataTable_1.DataTableRowColumn, null,
                React.createElement(Checkbox_1.default, { value: !!this.state.checkedItems[item.Id], noMargin: true, onChange: function (val) { return _this.itemChecked(item, val); } })),
            rowColumns.map(function (col, idx) {
                var props = {
                    key: idx
                };
                if (className) {
                    props["className"] = cn(className, props["className"]);
                }
                if (linkClassName) {
                    props["className"] = cn(linkClassName, props["className"]);
                }
                return (React.createElement(DataTable_1.DataTableRowColumn, __assign({}, props), col));
            })));
    };
    // When the list is filtered or changed we need to re-evaluate which ones are selected.
    PagingDataTable.prototype.reEvaluateCheckedItems = function (newState) {
        var _this = this;
        if (!this.props.onItemsChecked || !newState.data) {
            return; // Selection isn't possible
        }
        if (this.state.data === newState.data && this.state.filter === newState.filter) {
            return; // Nothing has changed that should affect the selected items
        }
        var currentChecked = Object.keys(this.state.checkedItems);
        if (currentChecked.length === 0) {
            return; // Nothing selected already so no need to check what else has loaded
        }
        var validItems = newState.data.Items
            .filter(function (item) { return _this.onFilter(_this.state.filter, item); })
            .map(function (item) { return item.Id; });
        var newChecked = lodash_2.intersection(currentChecked, validItems)
            .reduce(function (idx, id) {
            idx[id] = true;
            return idx;
        }, {});
        // Only trigger change if there is a change in items
        if (!lodash_1.isEqual(currentChecked, Object.keys(newChecked))) {
            this.setState({ checkedItems: newChecked }, function () { return _this.props.onItemsChecked(Object.keys(_this.state.checkedItems)); });
        }
    };
    return PagingDataTable;
}(PagingBaseComponent_1.default));
exports.PagingDataTable = PagingDataTable;
PagingDataTable.defaultProps = {
    showFilterWithinSection: false,
    autoFocusOnFilterSearch: true
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingDataTable\\PagingDataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingDataTable\\PagingDataTable.tsx"); } } })();

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var SidebarLayout_1 = __webpack_require__(448);
var Section_1 = __webpack_require__(81);
var filter_list_1 = __webpack_require__(1567);
var ActionButton_1 = __webpack_require__(49);
var styles = __webpack_require__(1568);
var SimpleExpander_1 = __webpack_require__(797);
var cn = __webpack_require__(19);
var LabelStrategy_1 = __webpack_require__(167);
var sidebarFilterLabelStrategy = function (fieldName) { return "By " + fieldName; };
var headerFilterLabelStrategy = function (fieldName) { return "Filter by " + fieldName; };
var AdvancedFilterLayout = (function (_super) {
    __extends(AdvancedFilterLayout, _super);
    function AdvancedFilterLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShowingFilter: _this.props.initiallyShowFilter
        };
        return _this;
    }
    AdvancedFilterLayout.prototype.componentWillReceiveProps = function (props) {
        if (!this.state.isShowingFilter
            && props.queryFilter
            && !lodash_1.isEqual(props.queryFilter, this.props.queryFilter)
            && !this.isDefaultFilter(props.queryFilter, props.defaultFilter)) {
            this.setState({ isShowingFilter: true });
        }
    };
    AdvancedFilterLayout.prototype.render = function () {
        var _this = this;
        var hasFilterPanelContent = !!this.props.filterSections.length;
        var panelLabel = this.props.additionalHeaderFilters && !!this.props.additionalHeaderFilters.length
            ? "Advanced Filter" : "Filter";
        var matchCountText = this.props.filterResult
            ? React.createElement("div", null,
                React.createElement("span", { className: cn(styles.matchInfo, styles.info) }, (this.props.filterResult.numberOfMatches !== 1 ?
                    this.props.filterResult.numberOfMatches + " " + this.props.filterResult.pluralText + " match" :
                    "1 " + this.props.filterResult.singleText + " matches")))
            : null;
        return React.createElement("div", { className: styles.fullHeightContainer },
            React.createElement(LabelStrategy_1.SetLabelStrategy, { labelStrategy: headerFilterLabelStrategy },
                React.createElement(Section_1.Section, null,
                    React.createElement("div", { className: styles.headingSection },
                        React.createElement("div", { className: styles.filterHeaderContainer, role: "search" },
                            this.props.additionalHeaderFilters && this.props.additionalHeaderFilters.map(function (f, i) {
                                return React.createElement("div", { key: i, className: styles.additionalHeaderFilter }, f);
                            }),
                            matchCountText && matchCountText,
                            hasFilterPanelContent && React.createElement("div", null,
                                React.createElement(ActionButton_1.default, { label: (!this.state.isShowingFilter ? "Show" : "Hide") + " " + panelLabel + "s", icon: React.createElement(filter_list_1.default, null), onClick: function () { return _this.setState({ isShowingFilter: !_this.state.isShowingFilter }); } }))),
                        !!this.props.filterByChips && React.createElement("div", { className: styles.filteringBy },
                            React.createElement("div", null, "Filtering by: "),
                            React.createElement("div", { className: styles.filteringByItems }, this.props.filterByChips))))),
            React.createElement(SidebarLayout_1.default, { sideBar: hasFilterPanelContent && this.state.isShowingFilter &&
                    React.createElement(LabelStrategy_1.SetLabelStrategy, { labelStrategy: sidebarFilterLabelStrategy },
                        React.createElement(Section_1.Section, null,
                            React.createElement("h4", { className: styles.heading },
                                React.createElement("div", { className: styles.headingText }, panelLabel),
                                React.createElement(ActionButton_1.default, { className: styles.resetButton, disabled: this.isDefaultFilter(this.props.filter, this.props.defaultFilter), label: "Reset", type: ActionButton_1.ActionButtonType.Secondary, onClick: function () { return _this.props.onFilterReset(_this.props.defaultFilter); } }))),
                        this.props.filterSections.map(function (s, index) {
                            if (s.sectionName) {
                                return React.createElement(SimpleExpander_1.default, { key: index, errorKey: s.sectionName, containerKey: "filter", isExpandedByDefault: !!s.isNotDefaultFilter, title: React.createElement(Section_1.Section, null,
                                        React.createElement("h4", null, s.sectionName)) },
                                    React.createElement(Section_1.Section, null, s.render));
                            }
                            return React.createElement(Section_1.Section, { key: index }, s.render);
                        })), side: SidebarLayout_1.SidebarSide.Left, extendContentToEdges: this.props.extendContentToEdges, extendSidebarToEdges: true, hideTopDivider: true, hideSidebarDivider: this.props.hideDivider, overflowXHidden: this.props.overflowXHidden }, this.props.renderContent(this.state.isShowingFilter)));
    };
    AdvancedFilterLayout.prototype.isDefaultFilter = function (filter, defaultFilter) {
        return lodash_1.isEqual(filter, defaultFilter);
    };
    return AdvancedFilterLayout;
}(React.Component));
exports.default = AdvancedFilterLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\AdvancedFilterLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\AdvancedFilterLayout.tsx"); } } })();

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(111);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var StepTypedMultiSelect = MultiSelect_1.default();
var StepMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Environment, chipRender: function (item) { return React.createElement(Chips_1.StepChip, { onRequestDelete: onRequestDelete, stepName: item.Name, suffix: item.suffix }); } });
    };
    return React.createElement(StepTypedMultiSelect, __assign({ items: props.items, fieldName: "steps", renderChip: chipRenderer }, props));
};
exports.default = StepMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\StepMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\StepMultiSelect.tsx"); } } })();

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1934);
var PageDivider = function (props) {
    return React.createElement("p", { className: styles.pageDivider }, props.children);
};
exports.default = PageDivider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PageDivider\\PageDivider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PageDivider\\PageDivider.tsx"); } } })();

/***/ }),
/* 472 */,
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var StickyNode = __webpack_require__(1420);
// This is a monkey patch to fix this issue: https://github.com/yahoo/react-stickynode/issues/46
// We should go back and submit a PR to that repo when we have more time
// This is required for the variable editor headers
StickyNode.prototype.getTargetHeight = function (target) {
    return target && (target.offsetHeight + target.getBoundingClientRect().top) || 0;
};
// When you have multiple sticky components around the place that depend on each others positions,
// It looks like they need to be repositioned in a certain order so that they are all positioned correctly with respect to each other
// In fact, I think you even need to position a child sticky in a timeout after the parent/anchor sticky is positioned.
// This is a hack to help get around that issue... It doesn't seem to be entirely reliable but improves things considerably
// It repeatedly positions/renders the stickies until the position becomes stable. It will do this at least twice
var originalUpdateInitialDimension = StickyNode.prototype.updateInitialDimension;
function updateInitialDimension(options) {
    var _this = this;
    originalUpdateInitialDimension.call(this, options);
    var position = null;
    window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
    function positionCheckingUpdateInitialDimension() {
        var _this = this;
        var oldPosition = position;
        var stickyElement = this.refs.inner;
        var outerElement = this.refs.outer;
        if (stickyElement || outerElement) {
            position = stickyElement.getBoundingClientRect();
            if (oldPosition === null
                || oldPosition.bottom !== position.bottom
                || oldPosition.top !== position.top
                || oldPosition.left !== position.left
                || oldPosition.right !== position.right
                || oldPosition.height !== position.height
                || oldPosition.width !== position.width) {
                originalUpdateInitialDimension.call(this, options);
                this.update();
                window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
            }
        }
        else {
            window.setTimeout(function () { return positionCheckingUpdateInitialDimension.call(_this); }, 0);
        }
    }
}
StickyNode.prototype.updateInitialDimension = updateInitialDimension;
var StickyStatus;
(function (StickyStatus) {
    StickyStatus[StickyStatus["STATUS_ORIGINAL"] = 0] = "STATUS_ORIGINAL";
    StickyStatus[StickyStatus["STATUS_RELEASED"] = 1] = "STATUS_RELEASED";
    StickyStatus[StickyStatus["STATUS_FIXED"] = 2] = "STATUS_FIXED";
})(StickyStatus = exports.StickyStatus || (exports.StickyStatus = {}));
var Sticky = function (props) {
    return React.createElement(StickyNode, __assign({}, props));
};
exports.default = Sticky;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Sticky\\Sticky.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Sticky\\Sticky.tsx"); } } })();

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1642);
var avatarPlaceHolder = __webpack_require__(1644);
var octopusServiceImage = __webpack_require__(1645);
var userDefaultImage = __webpack_require__(1646);
exports.Avatar = function (props) {
    var size = props.size || 25;
    var imageSource = avatarPlaceHolder;
    if (!props.user) {
        imageSource = octopusServiceImage;
    }
    else if (props.user.IsService) {
        imageSource = octopusServiceImage;
    }
    else if (props.user.Links && props.user.Links.Avatar) {
        imageSource = props.user.Links.Avatar + "&s=" + size;
    }
    return (
    // Note: Do NOT use Material-UI's Avatar component to render avatars, as we need a fallback background image and
    // if you try to do this with the <img> tag, it'll then show broken external images on closed networks (I.e. networks
    // that can't access gravatar).
    React.createElement("div", { className: styles.avatarContainer, style: {
            backgroundImage: "url(\"" + userDefaultImage + "\")",
            width: size + "px",
            height: size + "px"
        } },
        React.createElement("div", { className: styles.avatarContainer, style: {
                backgroundImage: "url(\"" + imageSource + "\")",
                width: "100%",
                height: "100%"
            } })));
};
exports.default = exports.Avatar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Avatar\\Avatar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Avatar\\Avatar.tsx"); } } })();

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var styles = __webpack_require__(117);
var FormSectionBase_1 = __webpack_require__(292);
var UnstructuredFormSection = (function (_super) {
    __extends(UnstructuredFormSection, _super);
    function UnstructuredFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnstructuredFormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: styles.formNonExpander, expanded: true }, this.body(styles.cardMediaNonExpander, false));
    };
    return UnstructuredFormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = UnstructuredFormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\UnstructuredFormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\UnstructuredFormSection.tsx"); } } })();

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LifecycleMapInternal_1 = __webpack_require__(1823);
var MapProgressionToStatus_1 = __webpack_require__(844);
var MarkdownDescription_1 = __webpack_require__(239);
var LifecycleMap = function (props) {
    var phases = props.lifecyclePreview.Phases
        ? props.lifecyclePreview.Phases
        : [];
    var lifecycleStatus = MapProgressionToStatus_1.mapProgressionToStatus();
    return React.createElement("div", null,
        props.showDescription && React.createElement(MarkdownDescription_1.default, { markup: props.lifecyclePreview.Description }),
        React.createElement(LifecycleMapInternal_1.default, { phases: phases, environmentsById: props.environmentsById, lifecycleStatus: lifecycleStatus, className: props.className }));
};
exports.default = LifecycleMap;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMap.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMap.tsx"); } } })();

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(213);
var CommunicationStyle;
(function (CommunicationStyle) {
    CommunicationStyle["None"] = "None";
    CommunicationStyle["TentaclePassive"] = "TentaclePassive";
    CommunicationStyle["TentacleActive"] = "TentacleActive";
    CommunicationStyle["Ssh"] = "Ssh";
    CommunicationStyle["OfflineDrop"] = "OfflineDrop";
    CommunicationStyle["AzureWebApp"] = "AzureWebApp";
    CommunicationStyle["Ftp"] = "Ftp";
    CommunicationStyle["AzureCloudService"] = "AzureCloudService";
    CommunicationStyle["AzureServiceFabricCluster"] = "AzureServiceFabricCluster";
    CommunicationStyle["Kubernetes"] = "Kubernetes";
})(CommunicationStyle = exports.CommunicationStyle || (exports.CommunicationStyle = {}));
var EndpointResource = (function (_super) {
    __extends(EndpointResource, _super);
    function EndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EndpointResource;
}(namedResource_1.default));
exports.EndpointResource = EndpointResource;
var TentacleEndpointResource = (function (_super) {
    __extends(TentacleEndpointResource, _super);
    function TentacleEndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TentacleEndpointResource;
}(EndpointResource));
exports.TentacleEndpointResource = TentacleEndpointResource;
var ListeningTentacleEndpointResource = (function (_super) {
    __extends(ListeningTentacleEndpointResource, _super);
    function ListeningTentacleEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.TentaclePassive;
        return _this;
    }
    return ListeningTentacleEndpointResource;
}(TentacleEndpointResource));
exports.ListeningTentacleEndpointResource = ListeningTentacleEndpointResource;
var PollingTentacleEndpointResource = (function (_super) {
    __extends(PollingTentacleEndpointResource, _super);
    function PollingTentacleEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.TentacleActive;
        return _this;
    }
    return PollingTentacleEndpointResource;
}(TentacleEndpointResource));
exports.PollingTentacleEndpointResource = PollingTentacleEndpointResource;
// tslint:disable-next-line:no-empty-interface
var AgentlessEndpointResource = (function (_super) {
    __extends(AgentlessEndpointResource, _super);
    function AgentlessEndpointResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgentlessEndpointResource;
}(EndpointResource));
exports.AgentlessEndpointResource = AgentlessEndpointResource;
var AzureWebAppEndpointResource = (function (_super) {
    __extends(AzureWebAppEndpointResource, _super);
    function AzureWebAppEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.AzureWebApp;
        return _this;
    }
    return AzureWebAppEndpointResource;
}(AgentlessEndpointResource));
exports.AzureWebAppEndpointResource = AzureWebAppEndpointResource;
exports.KubernetesCertificate = "KubernetesCertificate";
exports.KubernetesStandard = "KubernetesStandard";
exports.KubernetesAzure = "KubernetesAzure";
exports.KubernetesAws = "KubernetesAws";
var KubernetesCertificateAuthentication = (function () {
    function KubernetesCertificateAuthentication() {
        this.AuthenticationType = exports.KubernetesCertificate;
    }
    return KubernetesCertificateAuthentication;
}());
exports.KubernetesCertificateAuthentication = KubernetesCertificateAuthentication;
var KubernetesStandardAccountAuthentication = (function () {
    function KubernetesStandardAccountAuthentication() {
        this.AuthenticationType = exports.KubernetesStandard;
    }
    return KubernetesStandardAccountAuthentication;
}());
exports.KubernetesStandardAccountAuthentication = KubernetesStandardAccountAuthentication;
var KubernetesAzureAuthentication = (function (_super) {
    __extends(KubernetesAzureAuthentication, _super);
    function KubernetesAzureAuthentication() {
        var _this = _super.call(this) || this;
        _this.AuthenticationType = exports.KubernetesAzure;
        return _this;
    }
    return KubernetesAzureAuthentication;
}(KubernetesStandardAccountAuthentication));
exports.KubernetesAzureAuthentication = KubernetesAzureAuthentication;
var KubernetesAwsAuthentication = (function (_super) {
    __extends(KubernetesAwsAuthentication, _super);
    function KubernetesAwsAuthentication() {
        var _this = _super.call(this) || this;
        _this.AuthenticationType = exports.KubernetesAws;
        return _this;
    }
    return KubernetesAwsAuthentication;
}(KubernetesStandardAccountAuthentication));
exports.KubernetesAwsAuthentication = KubernetesAwsAuthentication;
var KubernetesEndpointResource = (function (_super) {
    __extends(KubernetesEndpointResource, _super);
    function KubernetesEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.Kubernetes;
        return _this;
    }
    return KubernetesEndpointResource;
}(AgentlessEndpointResource));
exports.KubernetesEndpointResource = KubernetesEndpointResource;
var AzureServiceFabricClusterEndpointResource = (function (_super) {
    __extends(AzureServiceFabricClusterEndpointResource, _super);
    function AzureServiceFabricClusterEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.AzureServiceFabricCluster;
        return _this;
    }
    return AzureServiceFabricClusterEndpointResource;
}(AgentlessEndpointResource));
exports.AzureServiceFabricClusterEndpointResource = AzureServiceFabricClusterEndpointResource;
var AzureServiceFabricSecurityMode;
(function (AzureServiceFabricSecurityMode) {
    AzureServiceFabricSecurityMode["Unsecure"] = "Unsecure";
    AzureServiceFabricSecurityMode["SecureClientCertificate"] = "SecureClientCertificate";
    AzureServiceFabricSecurityMode["SecureAzureAD"] = "SecureAzureAD";
})(AzureServiceFabricSecurityMode = exports.AzureServiceFabricSecurityMode || (exports.AzureServiceFabricSecurityMode = {}));
var AADCredentialType;
(function (AADCredentialType) {
    AADCredentialType["ClientCredential"] = "ClientCredential";
    AADCredentialType["UserCredential"] = "UserCredential";
})(AADCredentialType = exports.AADCredentialType || (exports.AADCredentialType = {}));
var AzureCloudServiceEndpointDeploymentSlot;
(function (AzureCloudServiceEndpointDeploymentSlot) {
    AzureCloudServiceEndpointDeploymentSlot["Staging"] = "Staging";
    AzureCloudServiceEndpointDeploymentSlot["Production"] = "Production";
})(AzureCloudServiceEndpointDeploymentSlot = exports.AzureCloudServiceEndpointDeploymentSlot || (exports.AzureCloudServiceEndpointDeploymentSlot = {}));
var AzureCloudServiceEndpointResource = (function (_super) {
    __extends(AzureCloudServiceEndpointResource, _super);
    function AzureCloudServiceEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.AzureCloudService;
        return _this;
    }
    return AzureCloudServiceEndpointResource;
}(AgentlessEndpointResource));
exports.AzureCloudServiceEndpointResource = AzureCloudServiceEndpointResource;
var CloudRegionEndpointResource = (function (_super) {
    __extends(CloudRegionEndpointResource, _super);
    function CloudRegionEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.None;
        return _this;
    }
    return CloudRegionEndpointResource;
}(AgentlessEndpointResource));
exports.CloudRegionEndpointResource = CloudRegionEndpointResource;
var OfflineDropEndpointResource = (function (_super) {
    __extends(OfflineDropEndpointResource, _super);
    function OfflineDropEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.OfflineDrop;
        return _this;
    }
    return OfflineDropEndpointResource;
}(AgentlessEndpointResource));
exports.OfflineDropEndpointResource = OfflineDropEndpointResource;
var SshEndpointResource = (function (_super) {
    __extends(SshEndpointResource, _super);
    function SshEndpointResource() {
        var _this = _super.call(this) || this;
        _this.CommunicationStyle = CommunicationStyle.Ssh;
        return _this;
    }
    return SshEndpointResource;
}(AgentlessEndpointResource));
exports.SshEndpointResource = SshEndpointResource;
exports.default = EndpointResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\endpointResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\endpointResource.ts"); } } })();

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var UpgradeNotificationMode;
(function (UpgradeNotificationMode) {
    UpgradeNotificationMode["AlwaysShow"] = "AlwaysShow";
    UpgradeNotificationMode["ShowOnlyMajorMinor"] = "ShowOnlyMajorMinor";
    UpgradeNotificationMode["NeverShow"] = "NeverShow";
})(UpgradeNotificationMode = exports.UpgradeNotificationMode || (exports.UpgradeNotificationMode = {}));
var UpgradeConfigurationResource = (function (_super) {
    __extends(UpgradeConfigurationResource, _super);
    function UpgradeConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpgradeConfigurationResource;
}(resource_1.default));
exports.UpgradeConfigurationResource = UpgradeConfigurationResource;
exports.default = UpgradeConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\upgradeConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\upgradeConfigurationResource.ts"); } } })();

/***/ }),
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var IconButtonList_1 = __webpack_require__(124);
var InputWithActions_1 = __webpack_require__(136);
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var styles = __webpack_require__(1726);
var Text_1 = __webpack_require__(50);
var IconButton_1 = __webpack_require__(52);
var chooseImage = __webpack_require__(1728);
var LogoEditor = (function (_super) {
    __extends(LogoEditor, _super);
    function LogoEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFileChange = function (e) {
            if (e.target.files.length < 1) {
                _this.onValidate("No file selected");
                return;
            }
            var file = e.target.files[0];
            var ValidImageTypes = ["image/gif", "image/jpeg", "image/png"];
            if (ValidImageTypes.indexOf(file.type) < 0) {
                _this.onValidate("Selected file was not an image");
                return;
            }
            _this.onValidate("");
            var value = {
                file: file,
                reset: false
            };
            _this.props.onChange(value);
        };
        _this.useDefault = function () {
            var value = {
                file: null,
                reset: true
            };
            _this.props.onChange(value);
        };
        _this.clear = function () {
            var value = {
                file: null,
                reset: false
            };
            _this.props.onChange(value);
        };
        _this.chooseFile = function () {
            _this.input.click();
        };
        _this.noop = function () {
            //empty on purpose
        };
        return _this;
    }
    LogoEditor.prototype.onValidate = function (message) {
        if (this.props.onValidate) {
            this.props.onValidate(message);
        }
    };
    LogoEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, error = _a.error, hintText = _a.hintText;
        var v = (value == null || (value.file == null && !value.reset))
            ? "Current logo"
            : (value.file ? value.file.name : "Default logo");
        var removeFromScreen = {
            cursor: "pointer",
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            width: "100%",
            opacity: 0,
        };
        //TODO Use choose-image.svg rather than Image
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.logoContainer },
                React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { type: "text", onChange: this.noop, hintText: hintText, value: v, error: error, onClick: this.chooseFile }), actions: React.createElement(IconButtonList_1.default, { buttons: [
                            React.createElement(IconButton_1.default, { onClick: this.chooseFile, icon: chooseImage, toolTipContent: "Choose image" }),
                            React.createElement(IconButton_1.default, { onClick: this.useDefault, icon: IconButton_1.Icon.UseDefaultImage, toolTipContent: "Use default image" })
                        ] }) }),
                React.createElement("input", { type: "file", style: removeFromScreen, onChange: this.handleFileChange, ref: function (input) { _this.input = input; } })),
            React.createElement(form_1.Note, null, "A transparent PNG, no larger than 100x100 pixels, is recommended. JPG and gif are also suitable.")));
    };
    return LogoEditor;
}(React.Component));
exports.default = LogoEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\LogoEditor\\LogoEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\LogoEditor\\LogoEditor.tsx"); } } })();

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(111);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var TenantTypedMultiSelect = MultiSelect_1.default();
var TenantMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Tenant, chipRender: function (item) { return React.createElement(Chips_1.TenantChip, { onRequestDelete: onRequestDelete, tenant: item }); } });
    };
    return React.createElement(TenantTypedMultiSelect, __assign({ items: props.items, fieldName: "tenants", renderChip: chipRenderer }, props));
};
exports.default = TenantMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TenantMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\TenantMultiSelect.tsx"); } } })();

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Tag_1 = __webpack_require__(240);
var index_1 = __webpack_require__(74);
var TagsList = function (props) {
    var tags = props.canonicalNames.map(function (name) { return props.tagIndex[name]; });
    return React.createElement("span", null, tags.map(function (tag) { return props.small ?
        React.createElement(index_1.default, { content: tag.Name, key: tag.Name },
            React.createElement(Tag_1.default, { tagName: tag.Name, tagColor: tag.Color, description: tag.Description, small: true }))
        :
            React.createElement(Tag_1.default, { key: tag.Name, description: tag.Description, tagName: tag.Name, tagColor: tag.Color }); }));
};
exports.default = TagsList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TagsList\\TagsList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TagsList\\TagsList.tsx"); } } })();

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function selectOptionsToItems(selectOptions) {
    var options = selectOptions || "";
    return options.split("\n")
        .filter(function (line) { return line.length !== 0; })
        .map(function (line) { return line.split("|"); })
        .map(function (keyValuePair) { return keyValuePair.length > 1 ? keyValuePair : [keyValuePair[0], keyValuePair[0]]; })
        .map(function (keyValuePair) { return ({
        value: keyValuePair[0].trim(),
        text: keyValuePair[1].trim()
    }); });
}
exports.default = selectOptionsToItems;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\Options.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\Options.tsx"); } } })();

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ThumbprintText_1 = __webpack_require__(1956);
exports.default = ThumbprintText_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ThumbprintText\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ThumbprintText\\index.tsx"); } } })();

/***/ }),
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var DialogLayout_1 = __webpack_require__(158);
var ActionButton_1 = __webpack_require__(49);
var Dialog_1 = __webpack_require__(133);
var DeleteDialog = (function (_super) {
    __extends(DeleteDialog, _super);
    function DeleteDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    DeleteDialog.prototype.onDeleteClick = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onDeleteClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeleteDialog.prototype.render = function () {
        var _this = this;
        var del = React.createElement(ActionButton_1.ActionButton, { key: "Continue", label: this.props.deleteButtonLabel || "Delete", type: ActionButton_1.ActionButtonType.Delete, busyLabel: this.props.deleteButtonBusyLabel || "Deleting...", disabled: this.state.busy, onClick: function () { return _this.onDeleteClick(); } });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: "Cancel", disabled: this.state.busy, onClick: function () { return _this.props.onClose(); } });
        return React.createElement(Dialog_1.default, { open: this.props.open || false },
            React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel, del], title: this.props.title, busy: this.state.busy, closeDialog: this.props.onClose, errors: this.state.errors }, this.props.open && this.props.children));
    };
    return DeleteDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeleteDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DeleteDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DeleteDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper = (function () {
    function StringHelper() {
    }
    StringHelper.capitalizeFirstLetter = function (value) {
        return value === null || typeof value === "undefined" || value.length === 0
            ? value
            : value.charAt(0).toUpperCase() + value.slice(1);
    };
    StringHelper.isNullOrWhiteSpace = function (value) {
        return value === null || typeof value === "undefined" || value.trim().length === 0;
    };
    StringHelper.join = function (values, separator) {
        return values.reduce(function (prev, cur) { return prev + separator + cur; });
    };
    StringHelper.formatDiff = function (diff) {
        if (!diff) {
            return diff;
        }
        var replaced = diff.replace(new RegExp("\r&para;", "g"), "");
        return replaced;
    };
    StringHelper.ellipsis = "...";
    return StringHelper;
}());
exports.default = StringHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\StringHelper\\StringHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\StringHelper\\StringHelper.tsx"); } } })();

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PagingBaseComponent_1 = __webpack_require__(206);
exports.PagingBaseProps = PagingBaseComponent_1.PagingBaseProps;
exports.PagingBaseState = PagingBaseComponent_1.PagingBaseState;
exports.Page = PagingBaseComponent_1.Page;
exports.HasId = PagingBaseComponent_1.HasId;
exports.default = PagingBaseComponent_1.PagingBaseComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\index.tsx"); } } })();

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(236);
var index_2 = __webpack_require__(47);
var styles = __webpack_require__(405);
var BusyIndicator_1 = __webpack_require__(95);
var NumberedPagingBar = function (props) {
    if (props.totalItems <= props.pageSize) {
        return null;
    }
    var currentPageIndex = props.currentPageIndex;
    var totalPages = props.totalItems === 0 ? 1 : Math.ceil(props.totalItems / props.pageSize);
    var pages = [];
    function addPage(i, text) {
        var page = {
            index: i,
            isActive: currentPageIndex === i,
            skip: i * props.pageSize,
            number: text
        };
        pages.push(page);
    }
    var pagesToShow = 16;
    var halfPagesToShow = 8;
    var isStartCollapsed = false;
    var isEndCollapsed = false;
    if (totalPages > 0) {
        addPage(0, "<<");
    }
    for (var i = 0; i < totalPages; i++) {
        var skip = !(totalPages < pagesToShow || ((i - currentPageIndex) < halfPagesToShow && (i - currentPageIndex) > -halfPagesToShow));
        if (skip && i < currentPageIndex && !isStartCollapsed) {
            addPage(Math.max(currentPageIndex - pagesToShow, 0), index_1.default.ellipsis);
            isStartCollapsed = true;
        }
        if (!skip) {
            addPage(i, String(i + 1));
        }
        if (skip && i > currentPageIndex && !isEndCollapsed) {
            addPage(Math.min(currentPageIndex + pagesToShow, totalPages - 1), index_1.default.ellipsis);
            isEndCollapsed = true;
        }
    }
    if (totalPages > 0) {
        addPage(totalPages - 1, ">>");
    }
    var pagingComponents = pages.map(function (page, i) {
        return React.createElement(index_2.PagingControlButton, { key: i, label: page.number, isActive: page.isActive, onPageSelected: function (e) { return props.onPageSelected(page.skip, page.index); } });
    });
    var classes = props.loadingMore ? styles.pagingControlContainer + " " + styles.disablePagingEvents : styles.pagingControlContainer;
    return totalPages > 1 &&
        React.createElement("div", { className: classes },
            React.createElement("div", null,
                pagingComponents,
                " "),
            props.loadingMore && React.createElement(BusyIndicator_1.default, { show: true }));
};
NumberedPagingBar.displayName = "NumberedPagingBar";
exports.default = NumberedPagingBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\NumberedPagingBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PagingBaseComponent\\NumberedPagingBar.tsx"); } } })();

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Lookup_1 = __webpack_require__(494);
var Chips_1 = __webpack_require__(24);
function LookupResourceChipComponent() {
    return function (props) {
        return React.createElement(Lookup_1.default, { lookupCollection: props.lookupCollection, lookupId: props.lookupId, getIdFromElement: function (element) { return element.Id; }, render: function (item) { return props.chipRender(item); }, renderFallback: React.createElement(Chips_1.MissingChip, { lookupId: props.lookupId, type: props.type }) });
    };
}
exports.LookupResourceChipComponent = LookupResourceChipComponent;
exports.default = LookupResourceChipComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupResourceChip\\LookupResourceChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupResourceChip\\LookupResourceChip.tsx"); } } })();

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Lookup = function (props) {
    var item = props.lookupCollection.find(function (element) { return props.getIdFromElement(element) === props.lookupId; });
    if (!!props.allowMissingItem === true && !item) {
        item = { Id: props.lookupId, Name: props.lookupId };
    }
    return item ? props.render(item) : props.renderFallback;
};
exports.default = Lookup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Lookup\\Lookup.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Lookup\\Lookup.tsx"); } } })();

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(111);
var index_1 = __webpack_require__(24);
var LookupResourceChip_1 = __webpack_require__(160);
var Chips_1 = __webpack_require__(24);
var ProjectTypedMultiSelect = MultiSelect_1.default();
var LookupProjectChip = LookupResourceChip_1.default();
var ProjectMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupProjectChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.Project, chipRender: function (item) { return React.createElement(index_1.ProjectChip, { onRequestDelete: onRequestDelete, project: item }); } });
    };
    return React.createElement(ProjectTypedMultiSelect, __assign({ items: props.items, fieldName: "projects", renderChip: chipRenderer }, props));
};
exports.default = ProjectMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ProjectMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ProjectMultiSelect.tsx"); } } })();

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(596);
var InternalLink_1 = __webpack_require__(43);
var ListInternalLink = function (props) {
    return React.createElement(InternalLink_1.default, { className: cn(styles.listInternalLink, props.className), size: props.size, to: props.to, onClick: props.onClick }, props.children);
};
exports.default = ListInternalLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\ListInternalLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\InternalLink\\ListInternalLink.tsx"); } } })();

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1826);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
function getActionLogoUrl(action) {
    var templateId = action.Properties["Octopus.Action.Template.Id"];
    var version = action.Properties["Octopus.Action.Template.Version"];
    return templateId ?
        clientInstance_1.client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: templateId, version: version }) :
        clientInstance_1.client.resolveLinkTemplate("ActionTemplateLogo", { typeOrId: action.ActionType });
}
exports.default = getActionLogoUrl;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\getActionLogoUrl.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\getActionLogoUrl.ts"); } } })();

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(1994);
var colors_1 = __webpack_require__(31);
var MarkdownDescription_1 = __webpack_require__(239);
var Logo_1 = __webpack_require__(200);
var styles = __webpack_require__(298);
var uiTestClasses_1 = __webpack_require__(86);
var ActionTemplateCard = function (props) {
    function formatText(text, maxLength) {
        text = (text || "").trim().replace(/\r?\n|\r/g, " ");
        return text.length > maxLength ? text.substr(0, maxLength) + " ..." : text;
    }
    function getStatusText(template) {
        if (template.IsBuiltIn) {
            return React.createElement("span", { style: { color: colors_1.white } }, "by Octopus Deploy");
        }
        if (template.IsInstalled) {
            return React.createElement("span", null, "Installed");
        }
        return React.createElement("span", { style: { color: colors_1.primary } }, formatText(template.Author, 24));
    }
    function getStatusLogo(template) {
        if (template.IsBuiltIn) {
            return React.createElement("em", { className: "fontoctopus-octopus", style: { color: colors_1.white } });
        }
        if (template.IsInstalled) {
            return React.createElement("em", { className: "fa fa-check-square-o", "aria-hidden": "true", style: { color: colors_1.primary } });
        }
        return React.createElement("em", { className: "fa fa-users", "aria-hidden": "true", style: { color: colors_1.primary } });
    }
    function getStatusClass(template) {
        if (template.IsBuiltIn) {
            return styles.templateStatusBuiltIn;
        }
        if (template.IsInstalled) {
            return styles.templateStatusInstalled;
        }
        return styles.templateStatusNotInstalled;
    }
    function getBackgroundColor(template) {
        if (template.IsBuiltIn) {
            return colors_1.primary;
        }
        if (template.IsInstalled) {
            return colors_1.divider;
        }
        return colors_1.white;
    }
    return React.createElement("li", null,
        React.createElement(Card_1.default, { logo: React.createElement(Logo_1.default, { url: props.template.Links.Logo }), className: uiTestClasses_1.stepCardClass, header: React.createElement("div", { className: styles.name }, formatText(props.template.Name, 46)), content: React.createElement("div", { className: styles.description },
                React.createElement(MarkdownDescription_1.default, { markup: props.template.Description })), includeContentFade: false, footerIcon: getStatusLogo(props.template), footerText: getStatusText(props.template), footerBackgroundColor: getBackgroundColor(props.template), onHoverView: React.createElement("div", { className: styles.onHoverActions },
                React.createElement("div", { className: styles.empty }),
                React.createElement("div", { className: styles.primaryAction }, props.primaryAction),
                props.secondaryAction && React.createElement("div", { className: styles.secondaryAction }, props.secondaryAction)) }));
};
ActionTemplateCard.displayName = "ActionTemplateCard";
exports.default = ActionTemplateCard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCard.tsx"); } } })();

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function matchesFilter(template, filter) {
    if (!filter) {
        return true;
    }
    return (template.Name && template.Name.toLowerCase().includes(filter)) ||
        (template.Description && template.Description.toLowerCase().includes(filter)) ||
        (template.Category && template.Category.toLowerCase().includes(filter));
}
exports.default = matchesFilter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\matchesFilter.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\matchesFilter.ts"); } } })();

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(298);
var ActionTemplateCardList = function (props) {
    return React.createElement("ol", { className: styles.templates }, props.children);
};
exports.default = ActionTemplateCardList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCardList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCardList.tsx"); } } })();

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(17);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Validators_1 = __webpack_require__(199);
var MetadataTypeHelpers_1 = __webpack_require__(856);
var Select_1 = __webpack_require__(40);
var StringCheckbox_1 = __webpack_require__(41);
var Sensitive_1 = __webpack_require__(93);
var Markdown_1 = __webpack_require__(132);
var Section_1 = __webpack_require__(783);
var Either = function (_a) {
    var flag = _a.flag, renderLeft = _a.renderLeft, renderRight = _a.renderRight;
    return (!!flag === true) ? renderRight() : renderLeft();
};
var DynamicForm = function (props) {
    var noValueMessage = "No value provided";
    var getControlType = function (property) {
        if (property.DisplayInfo.ListApi || property.DisplayInfo.Options) {
            return resources_1.ControlType.Select;
        }
        switch (property.Type) {
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
                return resources_1.ControlType.SingleLineText;
            case "bool":
            case "bool?":
            case "boolean":
                return resources_1.ControlType.Checkbox;
            case "string[]":
            case "raw_map":
            case "raw_list":
                return resources_1.ControlType.MultiLineText;
            case "SensitiveValue":
                return resources_1.ControlType.Sensitive;
        }
    };
    var getBooleanDisplayValue = function (value) {
        return value === null || value === false ? "Disabled" : "Enabled";
    };
    var createSummary = function (property, value) {
        switch (property.Type) {
            case "bool":
            case "boolean":
            case "bool?":
                return form_1.Summary.summary(getBooleanDisplayValue(value));
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
            case "raw_map":
            case "raw_list":
                return value === null || value === "" ? form_1.Summary.placeholder(noValueMessage) : form_1.Summary.summary(value);
            case "string[]":
                return form_1.Summary.summary(value && value.join ? value.join(", ") : value);
            case "SensitiveValue":
                return value.HasValue === false ? form_1.Summary.placeholder(noValueMessage) : form_1.Summary.summary("Value set");
        }
    };
    var getReadonlyValue = function (property, value) {
        switch (property.Type) {
            case "bool":
            case "boolean":
            case "bool?":
                return getBooleanDisplayValue(value);
            case "string":
            case "text":
            case "long":
            case "long?":
            case "int":
            case "int?":
            case "string[]":
            case "raw_map":
            case "raw_list":
                return value === null || value === "" ? noValueMessage : value.toString();
            case "SensitiveValue":
                return value.HasValue === false ? noValueMessage : "Value set";
        }
    };
    var getSelectOptions = function (property) {
        if (property.DisplayInfo.Options && property.DisplayInfo.Options.Values) {
            var objectKeys = Object.getOwnPropertyNames(property.DisplayInfo.Options.Values);
            var options = objectKeys.map(function (key) { return ({ value: key.toString(), text: property.DisplayInfo.Options.Values[key].toString() }); });
            return options;
        }
        else if (property.DisplayInfo.ListApi) {
            return []; // TODO: load from api
        }
        else {
            return [];
        }
    };
    var getValidation = function (property) {
        var controlType = getControlType(property);
        if (property.DisplayInfo.Required && controlType !== resources_1.ControlType.Checkbox) {
            return Validators_1.required(MetadataTypeHelpers_1.default.getRequiredMessage(property));
        }
        else {
            return null;
        }
    };
    var getInputControl = function (property, dataContext, getBoundFieldProps) {
        var value = dataContext[property.Name];
        if (value && property.Type === "string[]") {
            // We might have a string value that was changed to an array, so don't
            // assume join is a valid method.
            if (value.join) {
                value = value.join("\n");
            }
        }
        if (property.DisplayInfo.ReadOnly) {
            var displayValue = getReadonlyValue(property, value);
            return React.createElement("span", null, displayValue);
        }
        var inputType = getControlType(property);
        var formProps = {
            label: property.DisplayInfo.Label,
            value: value || "",
            onChange: function (newValue) { return onChange(property, dataContext, newValue); }
        };
        var boundFieldProps = getBoundFieldProps ? getBoundFieldProps() : {};
        switch (inputType) {
            case resources_1.ControlType.SingleLineText:
                return React.createElement(Either, { flag: props.isBindable, renderLeft: function () { return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps)); }, renderRight: function () { return React.createElement(VariableLookupText_1.VariableLookupText, __assign({ id: property.Name }, formProps, boundFieldProps)); } });
            case resources_1.ControlType.MultiLineText:
                return React.createElement(Either, { flag: props.isBindable, renderLeft: function () { return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps, { multiLine: true })); }, renderRight: function () { return React.createElement(VariableLookupText_1.VariableLookupText, __assign({ id: property.Name }, formProps, { multiLine: true }, boundFieldProps)); } });
            case resources_1.ControlType.Select:
                return (React.createElement(Either, { flag: props.isBindable, renderLeft: function () { return (React.createElement(Select_1.default, __assign({ items: getSelectOptions(property), allowClear: false }, formProps))); }, renderRight: function () { return (React.createElement(Select_1.BoundSelect, __assign({ items: getSelectOptions(property), allowClear: false, resetValue: "" }, formProps, boundFieldProps))); } }));
            case resources_1.ControlType.Checkbox: {
                return React.createElement(Either, { flag: props.isBindable, renderLeft: function () { return React.createElement(form_1.Checkbox, __assign({}, formProps)); }, renderRight: function () { return React.createElement(StringCheckbox_1.BoundStringCheckbox, __assign({ resetValue: "" }, formProps, boundFieldProps)); } });
            }
            case resources_1.ControlType.Sensitive:
                return React.createElement(Either, { flag: props.isBindable, renderLeft: function () { return React.createElement(form_1.Sensitive, __assign({}, formProps)); }, renderRight: function () { return (React.createElement(Sensitive_1.BoundSensitive, __assign({ label: property.DisplayInfo.Label, resetValue: "" }, formProps, boundFieldProps))); } });
            default:
                return React.createElement(form_1.Text, __assign({ id: property.Name }, formProps));
        }
    };
    var renderProperty = function (property, dataContext) {
        if (MetadataTypeHelpers_1.default.isCompositeType(property)) {
            var compositeType = props.types.filter(function (t) { return t.Name === property.Type; })[0];
            return renderSection(compositeType, dataContext[property.Name], property.Name);
        }
        var controlType = getControlType(property);
        var selectOptions = getSelectOptions(property);
        var description = property.DisplayInfo && property.DisplayInfo.Description
            ? property.DisplayInfo.Description
            : "Provide a value for " + property.DisplayInfo.Label;
        var controlToRender = getInputControl(property, dataContext, props.getBoundFieldProps);
        return React.createElement(form_1.ExpandableFormSection, { errorKey: property.Name, title: property.DisplayInfo.Label, help: description, key: property.Name, isExpandedByDefault: false, summary: createSummary(property, dataContext[property.Name]) }, controlToRender);
    };
    var renderSection = function (compositeType, dataContext, sectionName) {
        var types = compositeType && compositeType.Properties && compositeType.Properties.map(function (t) { return renderProperty(t, dataContext); });
        var sectionHeading = sectionName && React.createElement(form_1.FormSectionHeading, { title: sectionName, key: sectionName });
        return React.createElement("div", { key: sectionName },
            sectionHeading,
            React.createElement("div", null, types));
    };
    var onChange = function (property, dataContext, value) {
        var boundValue = value;
        if (property.Type === "string[]") {
            boundValue = value.split("\n");
        }
        // mutate state and trigger UI refresh
        // it would be really nice to replace this
        dataContext[property.Name] = boundValue;
        if (props.onChange) {
            props.onChange(props.values);
        }
    };
    if (props && props.types && props.types.length > 0) {
        return React.createElement("div", null,
            props.description && React.createElement(Section_1.default, null,
                React.createElement(Markdown_1.default, { markup: props.description })),
            renderSection(props.types[0], props.values, null));
    }
    else {
        console.error("no types provided");
    }
    return null;
};
exports.default = DynamicForm;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DynamicForm\\DynamicForm.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DynamicForm\\DynamicForm.tsx"); } } })();

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "waiting-for-octopus.55f3fc473fe540b3c66e778a0e31dfd8.hashedasset.svg";

/***/ }),
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReferenceDataItem = (function () {
    function ReferenceDataItem() {
    }
    return ReferenceDataItem;
}());
exports.ReferenceDataItem = ReferenceDataItem;
exports.default = ReferenceDataItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\referenceDataItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\referenceDataItem.ts"); } } })();

/***/ }),
/* 545 */,
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(17);
var redux_actions_1 = __webpack_require__(547);
var ActionTypes = {
    UNHANDLED_ERROR_OCCURRED: "UNHANDLED_ERROR_OCCURRED",
};
function raiseUnhandledErrorAction(error) {
    return { type: ActionTypes.UNHANDLED_ERROR_OCCURRED, error: error };
}
exports.raiseUnhandledErrorAction = raiseUnhandledErrorAction;
var raiseUnhandledError = redux_actions_1.handleActions((_a = {},
    _a[ActionTypes.UNHANDLED_ERROR_OCCURRED] = function (state, action) {
        var error = action.error;
        if (error instanceof resources_1.OctopusError) {
            return {
                message: error.ErrorMessage,
                details: error.Errors
            };
        }
        if (error instanceof Error) {
            return {
                message: error.message,
                details: error.stack.split(" at ")
            };
        }
        return {
            message: JSON.stringify(error)
        };
    },
    _a), null);
exports.default = raiseUnhandledError;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\reducers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BaseComponent\\reducers.tsx"); } } })();

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionKeys;
(function (ActionKeys) {
    ActionKeys["FORM_PAPER_LAYOUT_MOUNTED"] = "FORM_PAPER_LAYOUT_MOUNTED";
    ActionKeys["OTHER_ACTION"] = "__any_other_action_type__";
})(ActionKeys || (ActionKeys = {}));
function createFormPaperLayoutMountedAction(onSaveClick) {
    return { type: ActionKeys.FORM_PAPER_LAYOUT_MOUNTED, onSaveClick: onSaveClick };
}
exports.createFormPaperLayoutMountedAction = createFormPaperLayoutMountedAction;
var formPaperLayoutReducer = function (state, action) {
    if (state === void 0) { state = { onSaveClick: null }; }
    switch (action.type) {
        case ActionKeys.FORM_PAPER_LAYOUT_MOUNTED:
            return { onSaveClick: action.onSaveClick };
        default:
            return state;
    }
};
exports.default = formPaperLayoutReducer;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\reducers.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormPaperLayout\\reducers.ts"); } } })();

/***/ }),
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BusyFromPromise_1 = __webpack_require__(161);
exports.default = BusyFromPromise_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyFromPromise\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyFromPromise\\index.tsx"); } } })();

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconButton_1 = __webpack_require__(67);
var clear_1 = __webpack_require__(204);
var CloseButton = function (props) {
    var style = { verticalAlign: "middle", padding: "0" };
    if (props.size) {
        style.width = props.size;
        style.height = props.size;
    }
    return React.createElement(IconButton_1.default, { style: style, onClick: props.onClose, tooltip: props.tooltip },
        React.createElement(clear_1.default, null));
};
CloseButton.displayName = "CloseButton";
exports.default = CloseButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\CloseButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\CloseButton.tsx"); } } })();

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var RefreshLoop = (function () {
    function RefreshLoop(callback, refreshInterval, config) {
        if (config === void 0) { config = {
            hidden: function () { return document.hidden; },
            now: function () { return Date.now(); },
            setTimeout: function (handler, timeout) { return window.setTimeout(handler, timeout); },
            clearTimeout: function (timeoutId) { return window.clearTimeout(timeoutId); },
            addEventListener: function (type, listener) { return window.document.addEventListener(type, listener); },
            removeEventListener: function (type, listener) { return window.document.removeEventListener(type, listener); }
        }; }
        var _this = this;
        this.callback = callback;
        this.refreshInterval = refreshInterval;
        this.config = config;
        this.refresh = function () {
            _this.replaceLoop();
            return _this.refreshLoop.startAndRefreshImmediately();
        };
        this.stop = function () {
            _this.config.removeEventListener("visibilitychange", _this.visibilityChanged);
            _this.refreshLoop.stop();
        };
        this.callbackInternal = function (refresher) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callback(function () { return _this.isRunning(refresher); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.isRunning = function (refresher) {
            return _this.refreshLoop === refresher && _this.refreshLoop.isRunning();
        };
        this.visibilityChanged = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.replaceLoop();
                        if (!this.config.hidden()) return [3 /*break*/, 1];
                        this.refreshLoop.start();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.refreshLoop.startAndRefreshImmediately()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    RefreshLoop.prototype.start = function () {
        this.refreshLoop = new Loop(this.callbackInternal, this.pollingRefreshInterval, this.config);
        this.config.addEventListener("visibilitychange", this.visibilityChanged);
        this.refreshLoop.start();
    };
    Object.defineProperty(RefreshLoop.prototype, "pollingRefreshInterval", {
        get: function () {
            if (this.config.hidden()) {
                return this.refreshInterval * 12;
            }
            return this.refreshInterval;
        },
        enumerable: true,
        configurable: true
    });
    RefreshLoop.prototype.replaceLoop = function () {
        this.refreshLoop.stop();
        this.refreshLoop = new Loop(this.callbackInternal, this.pollingRefreshInterval, this.config);
    };
    return RefreshLoop;
}());
exports.default = RefreshLoop;
var Loop = (function () {
    function Loop(callback, refreshInterval, config) {
        var _this = this;
        this.callback = callback;
        this.refreshInterval = refreshInterval;
        this.config = config;
        this.stopped = true;
        this.isRunning = function () { return !_this.stopped; };
        this.loop = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.stopped) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.callback(this)];
                    case 1:
                        _a.sent();
                        if (this.stopped) {
                            return [2 /*return*/];
                        }
                        this.timeoutId = this.config.setTimeout(this.loop, this.refreshInterval);
                        return [2 /*return*/];
                }
            });
        }); };
    }
    Loop.prototype.stop = function () {
        this.stopped = true;
        this.config.clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
    };
    Loop.prototype.start = function () {
        this.stopped = false;
        this.timeoutId = this.config.setTimeout(this.loop, this.refreshInterval);
    };
    Loop.prototype.startAndRefreshImmediately = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopped = false;
                        return [4 /*yield*/, this.loop()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Loop;
}());


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\RefreshLoop\\refresh-loop.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\RefreshLoop\\refresh-loop.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InternalLink_1 = __webpack_require__(43);
var styles = __webpack_require__(1299);
var Breadcrumb = function (props) {
    return props.title
        ? React.createElement("div", { className: styles.breadcrumb }, props.path
            ? React.createElement(InternalLink_1.default, { className: props.isAreaLevelBreadcrumb ? styles.breadcrumbLink : null, to: props.path }, props.title)
            : React.createElement("div", null, props.title))
        : null;
};
exports.default = Breadcrumb;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Breadcrumb\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Breadcrumb\\index.tsx"); } } })();

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1298);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var colors_1 = __webpack_require__(31);
var BusyRefreshIndicator = function (props) {
    return props.show &&
        React.createElement(material_ui_1.RefreshIndicator, { size: 28, left: 10, top: 0, status: "loading", loadingColor: colors_1.secondaryText, style: {
                display: "inline-block",
                position: "relative",
                boxShadow: "unset",
            } });
};
BusyRefreshIndicator.displayName = "BusyRefreshIndicator";
exports.default = BusyRefreshIndicator;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyRefreshIndicator\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BusyRefreshIndicator\\index.tsx"); } } })();

/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(33);
var recompose_1 = __webpack_require__(186);
var transitions_1 = __webpack_require__(28);
var EnhancedTextarea_1 = __webpack_require__(1513);
var TextFieldHint_1 = __webpack_require__(598);
var TextFieldLabel_1 = __webpack_require__(599);
var TextFieldUnderline_1 = __webpack_require__(600);
var warning = __webpack_require__(34);
var colors_1 = __webpack_require__(31);
var fontWeights_1 = __webpack_require__(83);
var getStyles = function (props, context, state) {
    var _a = context.muiTheme, baseTheme = _a.baseTheme, _b = _a.textField, floatingLabelColor = _b.floatingLabelColor, focusColor = _b.focusColor, textColor = _b.textColor, disabledTextColor = _b.disabledTextColor, backgroundColor = _b.backgroundColor, errorColor = _b.errorColor;
    var styles = {
        root: {
            fontSize: fontWeights_1.baseSizeInPx,
            lineHeight: '1.5rem',
            width: props.fullWidth ? '100%' : 256,
            height: (props.rows - 1) * 24 + (!props.multiLine && props.floatingLabelText ? 62 : 48),
            display: 'inline-block',
            position: 'relative',
            backgroundColor: backgroundColor,
            fontFamily: baseTheme.fontFamily,
            transition: transitions_1.default.easeOut('200ms', 'height'),
            cursor: props.disabled ? 'not-allowed' : 'auto',
            marginTop: 0,
        },
        error: {
            position: 'relative',
            bottom: 2,
            fontSize: 12,
            lineHeight: '12px',
            color: errorColor,
            transition: transitions_1.default.easeOut(),
        },
        floatingLabel: {
            color: props.disabled ? disabledTextColor : floatingLabelColor,
            pointerEvents: 'none',
            top: 28,
        },
        input: {
            padding: 0,
            position: 'relative',
            width: '100%',
            border: 'none',
            outline: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            color: props.disabled ? disabledTextColor : textColor,
            cursor: 'inherit',
            font: 'inherit',
            WebkitOpacity: 1,
            WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        },
        inputNative: {
            appearance: 'textfield',
        },
        underlineStyle: {
            borderColor: colors_1.secondaryText,
        },
        disabledTextColor: {
            color: colors_1.secondaryText,
        }
    };
    styles.textarea = Object.assign({}, styles.input, {
        marginTop: props.floatingLabelText ? 36 : 12,
        marginBottom: props.floatingLabelText ? -36 : -12,
        boxSizing: 'border-box',
        font: 'inherit',
    });
    // Do not assign a height to the textarea as he handles it on his own.
    styles.input.height = '100%';
    if (state.isFocused) {
        styles.floatingLabel.color = focusColor;
    }
    if (props.floatingLabelText) {
        styles.input.boxSizing = 'border-box';
        if (!props.multiLine) {
            styles.input.marginTop = 0;
        }
        else {
            // Don't ask, multilines are a pita >< #MultiLineHacks2018
            styles.textarea.marginTop = 16;
            styles.textarea.marginBottom = -16;
        }
        if (state.errorText) {
            styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
        }
    }
    if (state.errorText) {
        if (state.isFocused) {
            styles.floatingLabel.color = styles.error.color;
        }
    }
    return styles;
};
/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
    return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}
var TextField = (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
            errorText: undefined,
            hasValue: false,
        };
        _this.handleInputBlur = function (event) {
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleInputChange = function (event) {
            if (!_this.props.hasOwnProperty('value')) {
                _this.setState({ hasValue: isValid(event.target.value) });
            }
            if (_this.props.onChange) {
                _this.props.onChange(event, event.target.value);
            }
        };
        _this.handleInputFocus = function (event) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleHeightChange = function (event, height) {
            var newHeight = height + 24;
            if (_this.props.floatingLabelText) {
                newHeight += 24;
            }
            ReactDOM.findDOMNode(_this).style.height = newHeight + "px";
        };
        return _this;
    }
    TextField.prototype.componentWillMount = function () {
        var _a = this.props, children = _a.children, name = _a.name, hintText = _a.hintText, floatingLabelText = _a.floatingLabelText, id = _a.id;
        var propsLeaf = children ? children.props : this.props;
        this.setState({
            errorText: this.props.errorText,
            hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue),
        });
        warning(name || hintText || floatingLabelText || id, "Material-UI: We don't have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.");
        var uniqueId = name + "-" + hintText + "-" + floatingLabelText + "-" + Math.floor(Math.random() * 0xFFFF);
        this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    };
    TextField.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.disabled && !this.props.disabled) {
            this.setState({
                isFocused: false,
            });
        }
        if (nextProps.errorText !== this.props.errorText) {
            this.setState({
                errorText: nextProps.errorText,
            });
        }
        if (nextProps.children && nextProps.children.props) {
            nextProps = nextProps.children.props;
        }
        if (nextProps.hasOwnProperty('value')) {
            var hasValue = isValid(nextProps.value);
            this.setState({
                hasValue: hasValue,
            });
        }
    };
    TextField.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return (!recompose_1.shallowEqual(this.props, nextProps) ||
            !recompose_1.shallowEqual(this.state, nextState) ||
            !recompose_1.shallowEqual(this.context, nextContext));
    };
    TextField.prototype.blur = function () {
        if (this.input) {
            this.getInputNode().blur();
        }
    };
    TextField.prototype.focus = function () {
        if (this.input) {
            this.getInputNode().focus();
        }
    };
    TextField.prototype.select = function () {
        if (this.input) {
            this.getInputNode().select();
        }
    };
    TextField.prototype.getValue = function () {
        return this.input ? this.getInputNode().value : undefined;
    };
    TextField.prototype.getInputNode = function () {
        return (this.props.children || this.props.multiLine) ?
            this.input.getInputNode() : ReactDOM.findDOMNode(this.input);
    };
    TextField.prototype._isControlled = function () {
        return this.props.hasOwnProperty('value');
    };
    TextField.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, errorStyle = _a.errorStyle, errorText = _a.errorText, // eslint-disable-line no-unused-vars
        floatingLabelFixed = _a.floatingLabelFixed, floatingLabelFocusStyle = _a.floatingLabelFocusStyle, floatingLabelShrinkStyle = _a.floatingLabelShrinkStyle, floatingLabelStyle = _a.floatingLabelStyle, floatingLabelText = _a.floatingLabelText, fullWidth = _a.fullWidth, // eslint-disable-line no-unused-vars
        hintText = _a.hintText, hintStyle = _a.hintStyle, id = _a.id, inputStyle = _a.inputStyle, multiLine = _a.multiLine, onBlur = _a.onBlur, // eslint-disable-line no-unused-vars
        onChange = _a.onChange, // eslint-disable-line no-unused-vars
        onFocus = _a.onFocus, // eslint-disable-line no-unused-vars
        style = _a.style, type = _a.type, underlineDisabledStyle = _a.underlineDisabledStyle, underlineFocusStyle = _a.underlineFocusStyle, underlineShow = _a.underlineShow, underlineStyle = _a.underlineStyle, rows = _a.rows, rowsMax = _a.rowsMax, textareaStyle = _a.textareaStyle, other = __rest(_a, ["children", "className", "disabled", "errorStyle", "errorText", "floatingLabelFixed", "floatingLabelFocusStyle", "floatingLabelShrinkStyle", "floatingLabelStyle", "floatingLabelText", "fullWidth", "hintText", "hintStyle", "id", "inputStyle", "multiLine", "onBlur", "onChange", "onFocus", "style", "type", "underlineDisabledStyle", "underlineFocusStyle", "underlineShow", "underlineStyle", "rows", "rowsMax", "textareaStyle"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context, this.state);
        var inputId = id || this.uniqueId;
        var errorTextElement = this.state.errorText && (React.createElement("div", { style: prepareStyles(Object.assign(styles.error, errorStyle)) }, this.state.errorText));
        var floatingLabelTextElement = floatingLabelText && (React.createElement(TextFieldLabel_1.default, { muiTheme: this.context.muiTheme, style: Object.assign(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null), shrinkStyle: floatingLabelShrinkStyle, htmlFor: inputId, shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed, disabled: disabled }, floatingLabelText));
        var inputProps = {
            id: inputId,
            ref: function (elem) { return _this.input = elem; },
            disabled: this.props.disabled,
            onBlur: this.handleInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
        };
        var childStyleMerged = Object.assign(styles.input, inputStyle);
        var inputElement;
        if (children) {
            inputElement = React.cloneElement(children, __assign({}, inputProps, children.props, { style: Object.assign(childStyleMerged, children.props.style) }));
        }
        else {
            inputElement = multiLine ? (React.createElement(EnhancedTextarea_1.default, __assign({ style: childStyleMerged, textareaStyle: Object.assign(styles.textarea, styles.inputNative, textareaStyle), rows: rows, rowsMax: rowsMax, hintText: hintText }, other, inputProps, { onHeightChange: this.handleHeightChange }))) : (React.createElement("input", __assign({ type: type, style: prepareStyles(Object.assign(styles.inputNative, childStyleMerged)) }, other, inputProps)));
        }
        var rootProps = {};
        if (children) {
            rootProps = other;
        }
        return (React.createElement("div", __assign({}, rootProps, { className: className, style: prepareStyles(Object.assign(styles.root, style)) }),
            floatingLabelTextElement,
            hintText ?
                React.createElement(TextFieldHint_1.default, { muiTheme: this.context.muiTheme, show: !(this.state.hasValue || (floatingLabelText && !this.state.isFocused)) ||
                        (!this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused), style: hintStyle, text: hintText }) :
                null,
            inputElement,
            underlineShow ?
                React.createElement(TextFieldUnderline_1.default, { disabled: disabled, disabledStyle: underlineDisabledStyle, error: !!this.state.errorText, errorStyle: errorStyle, focus: this.state.isFocused, focusStyle: underlineFocusStyle, muiTheme: this.context.muiTheme, style: underlineStyle }) :
                null,
            errorTextElement));
    };
    TextField.propTypes = {
        children: PropTypes.node,
        /**
         * The css class name of the root element.
         */
        className: PropTypes.string,
        /**
         * The text string to use for the default value.
         */
        defaultValue: PropTypes.any,
        /**
         * Disables the text field if set to true.
         */
        disabled: PropTypes.bool,
        /**
         * The style object to use to override error styles.
         */
        errorStyle: PropTypes.object,
        /**
         * The error content to display.
         */
        errorText: PropTypes.node,
        /**
         * If true, the floating label will float even when there is no value.
         */
        floatingLabelFixed: PropTypes.bool,
        /**
         * The style object to use to override floating label styles when focused.
         */
        floatingLabelFocusStyle: PropTypes.object,
        /**
         * The style object to use to override floating label styles when shrunk.
         */
        floatingLabelShrinkStyle: PropTypes.object,
        /**
         * The style object to use to override floating label styles.
         */
        floatingLabelStyle: PropTypes.object,
        /**
         * The content to use for the floating label element.
         */
        floatingLabelText: PropTypes.node,
        /**
         * If true, the field receives the property width 100%.
         */
        fullWidth: PropTypes.bool,
        /**
         * Override the inline-styles of the TextField's hint text element.
         */
        hintStyle: PropTypes.object,
        /**
         * The hint content to display.
         */
        hintText: PropTypes.node,
        /**
         * The id prop for the text field.
         */
        id: PropTypes.string,
        /**
         * Override the inline-styles of the TextField's input element.
         * When multiLine is false: define the style of the input element.
         * When multiLine is true: define the style of the container of the textarea.
         */
        inputStyle: PropTypes.object,
        /**
         * If true, a textarea element will be rendered.
         * The textarea also grows and shrinks according to the number of lines.
         */
        multiLine: PropTypes.bool,
        /**
         * Name applied to the input.
         */
        name: PropTypes.string,
        /** @ignore */
        onBlur: PropTypes.func,
        /**
         * Callback function that is fired when the textfield's value changes.
         *
         * @param {object} event Change event targeting the text field.
         * @param {string} newValue The new value of the text field.
         */
        onChange: PropTypes.func,
        /** @ignore */
        onFocus: PropTypes.func,
        /**
         * Number of rows to display when multiLine option is set to true.
         */
        rows: PropTypes.number,
        /**
         * Maximum number of rows to display when
         * multiLine option is set to true.
         */
        rowsMax: PropTypes.number,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        /**
         * Override the inline-styles of the TextField's textarea element.
         * The TextField use either a textarea or an input,
         * this property has effects only when multiLine is true.
         */
        textareaStyle: PropTypes.object,
        /**
         * Specifies the type of input to display
         * such as "password" or "text".
         */
        type: PropTypes.string,
        /**
         * Override the inline-styles of the
         * TextField's underline element when disabled.
         */
        underlineDisabledStyle: PropTypes.object,
        /**
         * Override the inline-styles of the TextField's
         * underline element when focussed.
         */
        underlineFocusStyle: PropTypes.object,
        /**
         * If true, shows the underline for the text field.
         */
        underlineShow: PropTypes.bool,
        /**
         * Override the inline-styles of the TextField's underline element.
         */
        underlineStyle: PropTypes.object,
        /**
         * The value of the text field.
         */
        value: PropTypes.any,
    };
    TextField.defaultProps = {
        disabled: false,
        floatingLabelFixed: false,
        multiLine: false,
        fullWidth: false,
        type: 'text',
        underlineShow: true,
        rows: 1,
    };
    TextField.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return TextField;
}(React.Component));
exports.default = TextField;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\TextField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\TextField.tsx"); } } })();

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var styles = __webpack_require__(1570);
var Expandable_1 = __webpack_require__(668);
var SimpleExpanderInternal = (function (_super) {
    __extends(SimpleExpanderInternal, _super);
    function SimpleExpanderInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // we can't just use actAsExpander on card Title because it eats the click
        // and we can't add links to the title in help text or our show more info link
        _this.handleExpand = function (e) {
            e.preventDefault();
            var isExpanded = !_this.props.isExpanded;
            _this.props.onExpandedChanged(isExpanded);
        };
        _this.renderChild = function (child) {
            if (!child) {
                return child;
            }
            var children = child.props && child.props.children
                ? { children: _this.renderChildren(child.props.children) }
                : null;
            var props = children ? __assign({}, child.props, children) : child.props;
            return React.isValidElement(child) ? React.cloneElement(child, props) : child;
        };
        _this.renderChildren = function (children) {
            return React.Children.map(children, _this.renderChild);
        };
        return _this;
    }
    SimpleExpanderInternal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isExpanded !== nextProps.isExpanded) {
            if (nextProps.onDidExpand) {
                nextProps.onDidExpand(nextProps.isExpanded);
            }
        }
    };
    SimpleExpanderInternal.prototype.render = function () {
        var _this = this;
        return React.createElement(Card_1.Card, { className: styles.formExpander, expanded: this.props.isExpanded },
            React.createElement(Card_1.CardTitle, { title: this.props.title, onClick: function (e) { return _this.handleExpand(e); }, showExpandableButton: true }),
            React.createElement(Card_1.CardMedia, { className: styles.cardMedia, expandable: true },
                React.createElement("div", null, this.renderChildren(this.props.children))));
    };
    return SimpleExpanderInternal;
}(React.Component));
exports.SimpleExpanderInternal = SimpleExpanderInternal;
var SimpleExpander = Expandable_1.default(SimpleExpanderInternal);
exports.default = SimpleExpander;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleExpander\\SimpleExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleExpander\\SimpleExpander.tsx"); } } })();

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(64);
var expanders_1 = __webpack_require__(315);
// HOC that hooks up a component that manages expansion to the redux store
function Expandable(Comp) {
    var ExpandableInternal = (function (_super) {
        __extends(ExpandableInternal, _super);
        function ExpandableInternal() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ExpandableInternal.prototype.componentDidMount = function () {
            this.props.onMount(this.props.errorKey, this.props.containerKey, this.props.isExpandedByDefault);
        };
        ExpandableInternal.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.containerKey !== this.props.containerKey || nextProps.errorKey !== this.props.errorKey) {
                this.props.onMount(nextProps.errorKey, nextProps.containerKey, nextProps.isExpandedByDefault);
            }
        };
        ExpandableInternal.prototype.render = function () {
            return React.createElement(Comp, __assign({}, this.props));
        };
        return ExpandableInternal;
    }(React.Component));
    function mapStateToProps(state, ownProps) {
        var containerKey = ownProps.containerKey || expanders_1.defaultContainerKey;
        var parentState = (state.expanders && state.expanders.hasOwnProperty(containerKey)) ? state.expanders[containerKey] : null;
        var expanderState = parentState && parentState.expanderValues[ownProps.errorKey];
        var initialState = (parentState && parentState.initialState);
        var isExpanded = expanderState === undefined || expanderState === null ? initialState : expanderState;
        var expandingAll = parentState ? parentState.expandingAll : false;
        return { isExpanded: isExpanded, expandingAll: expandingAll };
    }
    function mapDispatchToProps(dispatch, ownProps) {
        return {
            onExpandedChanged: function (state) {
                dispatch(expanders_1.onExpanderStateChanged(ownProps.containerKey || expanders_1.defaultContainerKey, ownProps.errorKey, state));
            },
            onMount: function (errorKey, containerKey, expanded) {
                dispatch(expanders_1.onExpanderCreated(containerKey || expanders_1.defaultContainerKey, errorKey, expanded));
            }
        };
    }
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpandableInternal);
}
exports.default = Expandable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Expandable\\Expandable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Expandable\\Expandable.tsx"); } } })();

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(181);
var Toolbar_1 = __webpack_require__(640);
var BaseComponent_1 = __webpack_require__(12);
var GettingStartedDetails_1 = __webpack_require__(689);
var IconButton_1 = __webpack_require__(67);
var clear_1 = __webpack_require__(204);
var GettingStartedDialog = (function (_super) {
    __extends(GettingStartedDialog, _super);
    function GettingStartedDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styles = {
            dialogRoot: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: 0
            },
            dialogContent: {
                position: "relative",
                width: "100%",
                maxWidth: "1300px",
                transform: ""
            },
            dialogBody: {
                paddingBottom: 0
            }
        };
        return _this;
    }
    GettingStartedDialog.prototype.render = function () {
        var _this = this;
        var close = React.createElement(Toolbar_1.Toolbar, { style: { backgroundColor: "initial", height: 0 }, noGutter: true },
            React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true }),
            React.createElement(Toolbar_1.ToolbarGroup, { lastChild: true },
                React.createElement(IconButton_1.default, { tooltip: "Close", onClick: this.props.onClose },
                    React.createElement(clear_1.default, null))));
        return React.createElement(Dialog_1.default, { title: null, open: this.props.open, onRequestClose: this.props.onClose, contentStyle: this.styles.dialogContent, bodyStyle: this.styles.dialogBody, style: this.styles.dialogRoot, repositionOnUpdate: false, autoScrollBodyContent: true },
            close,
            React.createElement(GettingStartedDetails_1.GettingStartedDetails, { onNavigating: function () { return _this.props.onNavigating(); }, highlightSection: this.props.highlightSection }));
    };
    return GettingStartedDialog;
}(BaseComponent_1.BaseComponent));
exports.GettingStartedDialog = GettingStartedDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDialog.tsx"); } } })();

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GettingStartedDetailSection_1 = __webpack_require__(1647);
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var BusyIndicator_1 = __webpack_require__(312);
var cn = __webpack_require__(19);
var gettingStartedLoader_1 = __webpack_require__(690);
var ExternalLink_1 = __webpack_require__(91);
var SectionStepLink_1 = __webpack_require__(1649);
var styles = __webpack_require__(233);
var routeLinks_1 = __webpack_require__(22);
var react_router_1 = __webpack_require__(76);
var WhatsNext_1 = __webpack_require__(691);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var imageOctopus = __webpack_require__(692);
var imageEnvironments = __webpack_require__(693);
var imagePackage = __webpack_require__(694);
var imageProject = __webpack_require__(695);
var imageDeploy = __webpack_require__(696);
var ActionLink = (function () {
    function ActionLink(item) {
        this.path = item.path;
        this.text = item.text;
        this.note = item.note;
        this.complete = item.complete;
        this.enabled = item.enabled;
        this.items = item.items;
    }
    return ActionLink;
}());
var Or = (function () {
    function Or() {
    }
    return Or;
}());
var LearnAbout = (function () {
    function LearnAbout(text, link, note) {
        this.text = text;
        this.link = link;
        this.note = note;
    }
    return LearnAbout;
}());
var GettingStartedDetailsInternal = (function (_super) {
    __extends(GettingStartedDetailsInternal, _super);
    function GettingStartedDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNavigating = function () {
            if (_this.props.onNavigating) {
                _this.props.onNavigating();
            }
        };
        _this.state = {
            next: "",
            projects: [],
            releases: [],
            sections: null,
        };
        return _this;
    }
    GettingStartedDetailsInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tasksStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, gettingStartedLoader_1.gettingStartedLoader.loadStatus()];
                    case 1:
                        tasksStatus = _a.sent();
                        if (!this.unmounted) {
                            this.refresh(tasksStatus);
                            if (!tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                                this.unsubscribe = gettingStartedLoader_1.gettingStartedLoader.subscribe(function (status) { return _this.refresh(status); });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GettingStartedDetailsInternal.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    GettingStartedDetailsInternal.prototype.render = function () {
        var _this = this;
        var isInEnvironmentPage = this.isInEnvironmentPage(this.props.location.pathname, this.props.match.params.spaceId);
        var whatsNext = WhatsNext_1.default(isInEnvironmentPage, this.state.next, this.state.projects, this.state.releases, this.props.onNavigating);
        return React.createElement("div", { className: cn(styles.container, !this.state.sections && styles.liftBusyIndicator) },
            !this.state.sections && React.createElement(BusyIndicator_1.default, { show: true, inline: false }),
            React.createElement("h2", null, "Welcome to Octopus Deploy"),
            React.createElement("p", { style: { textAlign: "center", width: "80%" } }, "The steps below introduce all the key Octopus concepts so you can easily automate deployments for all your applications and services in a safe, reliable and repeatable way."),
            React.createElement("div", { className: styles.gettingStartedSection }, this.state.sections && this.state.sections.items.map(function (section) {
                return React.createElement(GettingStartedDetailSection_1.default, { key: section.area, header: section.header, complete: section.complete, area: section.area, imgSrc: section.image, highlightSection: _this.props.highlightSection === section.area },
                    React.createElement("ul", { className: styles.actionsList }, section.actions.map(function (action, index) {
                        if (action instanceof ActionLink) {
                            return React.createElement("li", { key: action.text, className: cn((_a = {},
                                    _a[styles.edit] = !_this.state.sections.readonly && !action.complete,
                                    _a[styles.disabled] = !_this.state.sections.readonly && !action.enabled,
                                    _a[styles.complete] = !_this.state.sections.readonly && action.complete,
                                    _a[styles.completeReadOnly] = _this.state.sections.readonly,
                                    _a)) },
                                !action.enabled && React.createElement("span", null, action.text),
                                action.enabled && React.createElement(SectionStepLink_1.SectionStepLink, { onNavigating: _this.onNavigating, text: action.text, path: action.path, 
                                    /* given this is an onboarding we don't display more then 5 items in these dropdowns */
                                    items: action.items && action.items.slice(0, 5) }),
                                action.note && React.createElement("div", { className: styles.note }, action.note));
                        }
                        if (action instanceof LearnAbout) {
                            return React.createElement("li", { key: action.text, className: styles.info },
                                React.createElement(ExternalLink_1.default, { href: action.link, showIcon: false }, action.text),
                                React.createElement("div", { className: styles.note }, action.note));
                        }
                        if (action instanceof Or) {
                            return React.createElement("li", { key: section.area + "-" + index },
                                React.createElement("div", { style: { marginBottom: "0.5rem", marginTop: "-0.2rem" }, className: cn(styles.note, (_b = {}, _b[styles.disabled] = _this.state.sections.readonly, _b)) },
                                    React.createElement("strong", null, "OR")));
                        }
                        var _a, _b;
                    })),
                    React.createElement("span", { className: styles.help }, section.help));
            })),
            React.createElement("div", { className: styles.detailsWhatsNextContainer }, whatsNext.element));
    };
    GettingStartedDetailsInternal.prototype.isInEnvironmentPage = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.infrastructure.environments.root, spaceId) === path;
    };
    GettingStartedDetailsInternal.prototype.refresh = function (status) {
        var deployRelease = (function () {
            var project = status.projects.find(function (p) {
                return p.Id === status.releases[0].ProjectId;
            });
            return routeLinks_1.default.project(project).root;
        }).bind(this);
        var deployMultipleRelease = (function () {
            var projectIds = [];
            projectIds = status.releases.reduce(function (state, r) {
                if (!state.includes(r.ProjectId)) {
                    state.push(r.ProjectId);
                }
                return state;
            }, projectIds);
            return status.projects
                .filter(function (p) { return projectIds.includes(p.Id); })
                .map(function (p) { return ({
                label: p.Name,
                link: routeLinks_1.default.project(p).root
            }); });
        }).bind(this);
        var sectionsList = [
            {
                header: "1. Install and set up",
                area: "OCTOPUS SERVER",
                complete: true,
                image: imageOctopus,
                actions: [
                    new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Create home directory"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Configure service account"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Specify SQL Server details"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Set up web portal"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Select authentication mode"
                    }), new ActionLink({
                        complete: true,
                        enabled: true,
                        text: "Create Octopus admin"
                    })
                ]
            },
            {
                header: "2. Configure",
                area: "INFRASTRUCTURE",
                complete: status.tasks.Infrastructure.IsComplete,
                image: imageEnvironments,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingEnvironmentsLearnMore" }, "environments"),
                    ", ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingDeploymentTargetsLearnMore" }, "targets"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingAccountsLearnMore" }, "accounts"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create environments",
                        path: routeLinks_1.default.infrastructure.environments.root,
                        complete: status.tasks.Infrastructure.CreatedEnvironment.IsComplete,
                        enabled: status.tasks.Infrastructure.CreatedEnvironment.IsEnabled,
                        note: "Environments help you organise targets into groups. e.g., Dev, Test and Production."
                    }),
                    new ActionLink({
                        text: "Add deployment target",
                        path: routeLinks_1.default.infrastructure.machines.root,
                        complete: status.tasks.Infrastructure.CreatedMachine.IsComplete,
                        enabled: status.tasks.Infrastructure.CreatedMachine.IsEnabled,
                        note: "Targets are the servers where your applications will be deployed."
                    }),
                    new Or(),
                    new ActionLink({
                        text: "Add an account",
                        path: routeLinks_1.default.infrastructure.accounts.root,
                        complete: status.tasks.Infrastructure.AddedAzureAccount.IsComplete,
                        enabled: status.tasks.Infrastructure.AddedAzureAccount.IsEnabled,
                        note: "Accounts can be associated with deployment targets and include Azure subscriptions, SSH keys, and usernames and passwords."
                    })
                ]
            },
            {
                header: "3. Application",
                area: "PACKAGING",
                complete: status.tasks.Package.IsComplete,
                image: imagePackage,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingVersioningLearnMore" }, "versioning"),
                    ", ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingPackagesLearnMore" }, "packaging"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingPackageRepositoriesLearnMore" }, "external feeds"),
                    "."),
                actions: [
                    new LearnAbout("Learn about packaging and versioning", "OnboardingPackagesLearnMore", "Package and version your applications so they can be deployed."),
                    new ActionLink({
                        text: "Upload package",
                        path: routeLinks_1.default.library.builtInRepository.root,
                        complete: status.tasks.Package.UploadedPackage.IsComplete,
                        enabled: status.tasks.Package.UploadedPackage.IsEnabled,
                        note: "Push packages to the built-in repository manually or integrate with your existing build tool."
                    }),
                    new Or(),
                    new ActionLink({
                        text: "Add external feed",
                        path: routeLinks_1.default.library.feeds,
                        complete: status.tasks.Package.AddedFeed.IsComplete,
                        enabled: status.tasks.Package.AddedFeed.IsEnabled,
                        note: "Octopus can integrate with external package repositories like TeamCity and VSTS."
                    })
                ]
            },
            {
                header: "4. Create a",
                area: "PROJECT",
                complete: status.tasks.Project.IsComplete,
                image: imageProject,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingProjectsLearnMore" }, "projects"),
                    "and ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingDeploymentProcessLearnMore" }, "deployment processes"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create a project",
                        path: routeLinks_1.default.projects,
                        complete: status.tasks.Project.CreatedProject.IsComplete,
                        enabled: status.tasks.Project.CreatedProject.IsEnabled,
                        note: "Octopus projects specify the steps and configuration variables required to deploy your application."
                    }),
                    new ActionLink({
                        text: "Define its process",
                        path: status.projects.length === 1 ? routeLinks_1.default.project(status.projects[0]).process.root : null,
                        complete: status.tasks.Project.AddedProjectStep.IsComplete,
                        enabled: status.tasks.Project.AddedProjectStep.IsEnabled,
                        note: "A deployment process specifies the steps to deploy an application which allows you to deploy new versions consistently every time.",
                        items: status.projects.length > 1 ? status.projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).process.root
                        }); }) : null
                    })
                ]
            },
            {
                header: "5. You're ready to",
                area: "DEPLOY",
                complete: status.tasks.Deploy.IsComplete,
                image: imageDeploy,
                help: React.createElement("span", null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "OnboardingReleasesLearnMore" }, "creating and deploying releases"),
                    "."),
                actions: [
                    new ActionLink({
                        text: "Create a release",
                        path: status.projects.length === 1 ? routeLinks_1.default.project(status.projects[0]).releases : null,
                        complete: status.tasks.Deploy.CreatedRelease.IsComplete,
                        enabled: status.tasks.Deploy.CreatedRelease.IsEnabled,
                        note: (React.createElement("div", null,
                            "Releases contain all project and package details so it can be deployed safely over and over.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            "Creating a release can be done once steps 1-4 are complete.")),
                        items: status.projects.length > 1 ? status.projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).releases
                        }); }) : null
                    }),
                    new ActionLink({
                        text: "Deploy a release",
                        path: status.releases.length === 1 ? deployRelease() : null,
                        complete: status.tasks.Deploy.DeployedRelease.IsComplete,
                        enabled: status.tasks.Deploy.DeployedRelease.IsEnabled,
                        note: "Deploy your first release to complete your journey into deployment automation.",
                        items: status.releases.length > 1 ? deployMultipleRelease() : null
                    })
                ]
            }
        ];
        this.setState({
            sections: {
                readonly: status.tasks.Deploy.DeployedRelease.IsComplete,
                items: sectionsList
            },
            next: status.next,
            projects: status.projects,
            releases: status.releases
        });
    };
    return GettingStartedDetailsInternal;
}(BaseComponent_1.BaseComponent));
exports.GettingStartedDetails = react_router_1.withRouter(GettingStartedDetailsInternal);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var permission_1 = __webpack_require__(51);
var resources_1 = __webpack_require__(17);
var PermissionCheck_1 = __webpack_require__(42);
var refresh_loop_1 = __webpack_require__(588);
var GettingStartedLoader = (function () {
    function GettingStartedLoader() {
        var _this = this;
        this.subscribers = {};
        this.loop = new refresh_loop_1.default(function (isLoopStillRunning) { return __awaiter(_this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadStatus()];
                    case 1:
                        status = _a.sent();
                        if (status.tasks.Deploy.DeployedRelease.IsComplete && isLoopStillRunning) {
                            this.loop.stop();
                        }
                        else {
                            this.triggerSubscribers(status);
                        }
                        return [2 /*return*/];
                }
            });
        }); }, 2000);
        this.loadStatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, this.buildStatus(data.userOnboardingData, data.projects, data.releases)];
                }
            });
        }); };
        this.subscribe = function (callback) {
            var subscriberId = ++GettingStartedLoader.subscriberId;
            _this.subscribers[subscriberId] = callback;
            if (Object.getOwnPropertyNames(_this.subscribers).length === 1) {
                _this.loop.start();
            }
            return function () {
                _this.unsubscribe(subscriberId);
            };
        };
        this.unsubscribe = function (subscriberId) {
            delete _this.subscribers[subscriberId];
            if (Object.getOwnPropertyNames(_this.subscribers).length === 0) {
                _this.loop.stop();
            }
        };
        this.populateReleasesList = function () { return __awaiter(_this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ReleaseView, wildcard: true })) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Releases.list()];
                    case 2: return [2 /*return*/, (_a.sent()).Items];
                    case 3:
                        ex_1 = _a.sent();
                        if (ex_1 instanceof resources_1.OctopusError && ex_1.StatusCode !== 403) {
                            throw ex_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        }); };
        this.populateProjectsList = function () { return __awaiter(_this, void 0, void 0, function () {
            var ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ProjectView, wildcard: true })) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_2 = _a.sent();
                        if (ex_2 instanceof resources_1.OctopusError && ex_2.StatusCode !== 403) {
                            throw ex_2;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        }); };
        this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var userOnboardingData, _a, projects, releases, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.UserOnboarding.get()];
                    case 1:
                        userOnboardingData = _c.sent();
                        if (!!userOnboardingData.Tasks.find(function (t) { return t.Category === "Deploy" && t.Name === "DeployedRelease"; }).IsComplete) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([this.populateProjectsList(), this.populateReleasesList()])];
                    case 2:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b = [[], []];
                        _c.label = 4;
                    case 4:
                        _a = _b, projects = _a[0], releases = _a[1];
                        return [2 /*return*/, {
                                userOnboardingData: userOnboardingData,
                                projects: projects,
                                releases: releases
                            }];
                }
            });
        }); };
        this.triggerSubscribers = function (gettingStartedStatus) {
            var subscriberIds = Object.getOwnPropertyNames(_this.subscribers);
            subscriberIds.forEach(function (s, _, subscribers) {
                try {
                    _this.subscribers[s](gettingStartedStatus);
                }
                catch (ex) {
                    //Ignore on purpose
                }
            }, _this);
        };
        this.buildStatus = function (userOnboardingData, projects, releases) {
            var tasks = { Infrastructure: null, Deploy: null, Package: null, Project: null };
            var next = "";
            for (var _i = 0, _a = userOnboardingData.Tasks; _i < _a.length; _i++) {
                var task = _a[_i];
                tasks[task.Category] = tasks[task.Category] || {};
                tasks[task.Category][task.Name] = tasks[task.Category][task.Name] || {};
                tasks[task.Category][task.Name].IsComplete = task.IsComplete;
                tasks[task.Category][task.Name].IsEnabled = task.IsEnabled;
            }
            tasks.Infrastructure.IsEnabled = tasks.Infrastructure.CreatedEnvironment.IsEnabled;
            tasks.Infrastructure.Percent = 0;
            tasks.Infrastructure.IsComplete = false;
            if (tasks.Infrastructure.CreatedEnvironment.IsComplete) {
                tasks.Infrastructure.Percent += 50;
            }
            else if (!!!next) {
                next = "Infrastructure.CreatedEnvironment";
            }
            if (tasks.Infrastructure.CreatedMachine.IsComplete) {
                tasks.Infrastructure.Percent += 50;
            }
            else if (tasks.Infrastructure.AddedAzureAccount.IsComplete) {
                tasks.Infrastructure.Percent += 50;
            }
            else if (!!!next) {
                next = "Infrastructure.CreatedMachineOrAccount";
            }
            if (tasks.Infrastructure.Percent === 100) {
                tasks.Infrastructure.IsComplete = true;
            }
            tasks.Package.IsEnabled = tasks.Package.UploadedPackage.IsEnabled;
            tasks.Package.Percent = 0;
            tasks.Package.IsComplete = false;
            if (tasks.Package.UploadedPackage.IsComplete) {
                tasks.Package.Percent += 100;
            }
            else if (tasks.Package.AddedFeed.IsComplete) {
                tasks.Package.Percent += 100;
            }
            else if (!!!next) {
                // tslint:disable-next-line
                if (tasks.Deploy.CreatedRelease.IsEnabled && !tasks.Deploy.CreatedRelease.IsComplete) {
                    next = "Deploy.CreatedRelease";
                }
                else if (tasks.Deploy.DeployedRelease.IsEnabled && !tasks.Deploy.DeployedRelease.IsComplete) {
                    next = "Deploy.DeployedRelease";
                }
                else {
                    next = "Package";
                }
            }
            if (tasks.Package.Percent === 100) {
                tasks.Package.IsComplete = true;
            }
            tasks.Project.IsEnabled = tasks.Project.CreatedProject.IsEnabled;
            tasks.Project.Percent = 0;
            tasks.Project.IsComplete = false;
            if (tasks.Project.CreatedProject.IsComplete) {
                tasks.Project.Percent += 50;
            }
            else if (!!!next) {
                next = "Project.CreatedProject";
            }
            if (tasks.Project.AddedProjectStep.IsComplete) {
                tasks.Project.Percent += 50;
            }
            else if (!!!next) {
                next = "Project.AddedProjectStep";
            }
            if (tasks.Project.Percent === 100) {
                tasks.Project.IsComplete = true;
            }
            tasks.Deploy.IsEnabled = tasks.Deploy.CreatedRelease.IsEnabled;
            tasks.Deploy.Percent = 0;
            tasks.Deploy.IsComplete = false;
            if (tasks.Deploy.CreatedRelease.IsComplete) {
                tasks.Deploy.Percent += 50;
            }
            else if (!!!next) {
                next = "Deploy.CreatedRelease";
            }
            if (tasks.Deploy.DeployedRelease.IsComplete) {
                tasks.Deploy.Percent += 50;
            }
            else if (!!!next) {
                next = "Deploy.DeployedRelease";
            }
            if (tasks.Deploy.Percent === 100) {
                tasks.Deploy.IsComplete = true;
            }
            return {
                tasks: tasks,
                next: next,
                projects: projects,
                releases: releases.filter(function (r) { return projects.some(function (p) { return p.Id === r.ProjectId; }); }) //Ensure we only display releases that we have projects for
            };
        };
    }
    GettingStartedLoader.subscriberId = 0;
    return GettingStartedLoader;
}());
exports.gettingStartedLoader = new GettingStartedLoader();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\gettingStartedLoader.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\gettingStartedLoader.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var NextButton_1 = __webpack_require__(1650);
var routeLinks_1 = __webpack_require__(22);
var PermissionCheck_1 = __webpack_require__(42);
var permission_1 = __webpack_require__(51);
var Callout_1 = __webpack_require__(57);
var styles = __webpack_require__(1653);
function getWhatsNext(isInEnvironmentPage, next, projects, releases, onClick) {
    switch (next) {
        case "Infrastructure.CreatedEnvironment":
            return {
                text: "To get started, create an environment.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Create environment", items: [
                            {
                                label: "Create environment",
                                link: routeLinks_1.default.infrastructure.environments.root
                            }
                        ] }))
            };
        case "Infrastructure.CreatedMachineOrAccount":
            return {
                text: "Your new environment needs a deployment target.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.MachineCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.MachineCreate,
                            " permission is required to add a deployment target") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add deployment target", items: [
                                {
                                    label: "Add deployment target",
                                    link: isInEnvironmentPage ? routeLinks_1.default.infrastructure.machines.discover()
                                        : routeLinks_1.default.infrastructure.environments.root
                                }
                            ] })),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.AccountCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.AccountCreate,
                            " permission is required to add an account") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add an account", items: [
                                {
                                    label: "Add an account",
                                    link: routeLinks_1.default.infrastructure.accounts.root
                                }
                            ] })))
            };
        case "Package":
            return {
                text: "Upload package manually, automatically or via an external feed.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.BuiltInFeedPush, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.BuiltInFeedPush,
                            " permission is required to upload a package") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Upload package", items: [
                                {
                                    label: "Upload package",
                                    link: routeLinks_1.default.library.builtInRepository.root
                                }
                            ] })),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.BuiltInFeedPush, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.BuiltInFeedPush,
                            " permission is required to upload a package") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add external feed", items: [
                                {
                                    label: "Add external feed",
                                    link: routeLinks_1.default.library.feeds
                                }
                            ] })))
            };
        case "Project.CreatedProject":
            return {
                text: "You're making great progress!",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProjectCreate, projectGroup: "*", alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.ProjectCreate,
                            " permission is required to add a project") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Add project", items: [
                                {
                                    label: "Add project",
                                    link: routeLinks_1.default.projects
                                }
                            ] })))
            };
        case "Project.AddedProjectStep":
            return {
                text: "To create a release, a deployment process must be configured.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Define your deployment process", items: projects.map(function (p) { return ({
                            label: p.Name,
                            link: routeLinks_1.default.project(p).process.root
                        }); }) }))
            };
        case "Deploy.CreatedRelease":
            return {
                text: "You can now create a release.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ReleaseCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.ReleaseCreate,
                            " permission is required to deploy the release") },
                        React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Create release", items: projects.map(function (p) { return ({
                                label: p.Name,
                                link: routeLinks_1.default.project(p).releases
                            }); }) })))
            };
        case "Deploy.DeployedRelease":
            var deployRelease = (function () {
                var project = projects.find(function (p) {
                    return p.Id === releases[0].ProjectId;
                });
                return {
                    label: project.Name,
                    link: routeLinks_1.default.project(project).root
                };
            });
            var deployMultipleRelease = (function () {
                var projectIds = [];
                projectIds = releases.reduce(function (state, r) {
                    if (!state.includes(r.ProjectId)) {
                        state.push(r.ProjectId);
                    }
                    return state;
                }, projectIds);
                return projects
                    .filter(function (p) { return projectIds.includes(p.Id); })
                    .map(function (p) { return ({
                    label: p.Name,
                    link: routeLinks_1.default.project(p).root
                }); });
            });
            return {
                text: "Woohoo! Your first release is ready to deploy.",
                element: React.createElement("span", { className: styles.whatsNextButtonsContainer },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            permission_1.default.DeploymentCreate,
                            " permission is required to deploy the release") },
                        releases.length === 1 && React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Deploy", items: [deployRelease()] }),
                        releases.length > 1 && React.createElement(NextButton_1.NextButton, { onClick: onClick, defaultLabel: "Deploy", items: deployMultipleRelease() })))
            };
        default:
            return {
                text: null,
                element: null
            };
    }
}
exports.default = getWhatsNext;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\WhatsNext\\WhatsNext.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\WhatsNext\\WhatsNext.tsx"); } } })();

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Octopus.87d099af4960c9e52db0ca1ba0b9718c.hashedasset.svg";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Environments.5eaa2cdf845ba9033d03e9492513d9d1.hashedasset.svg";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Package.b17078af8dacc25c703f3b62fd6a32a9.hashedasset.svg";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Project.c9fc7a11271a55ee2fb44b00548f20e2.hashedasset.svg";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Deploy.35d78df753f0d28f800587e47dabe7d1.hashedasset.svg";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var LinksMenu_1 = __webpack_require__(698);
var LinksMenuButton_1 = __webpack_require__(1656);
var MenuNode_1 = __webpack_require__(699);
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var react_event_listener_1 = __webpack_require__(68);
var react_router_1 = __webpack_require__(76);
var InternalNavLink_1 = __webpack_require__(248);
var isUrlActive_1 = __webpack_require__(406);
var PriorityNavigation = (function (_super) {
    __extends(PriorityNavigation, _super);
    function PriorityNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.widthsArray = [];
        _this.onResize = function () {
            if (_this.containerElement.offsetWidth === _this.lastKnownContainerWidth) {
                return; // Nothing changed
            }
            _this.setState({ availableWidth: null });
        };
        _this.showMoreMenu = function (event) {
            event.preventDefault();
            _this.setState({
                isMoreMenuOpen: !_this.state.isMoreMenuOpen
            });
        };
        _this.hideMoreMenu = function () {
            _this.setState({
                isMoreMenuOpen: false
            });
        };
        _this.setMeasurementDiv = function (el) {
            if (!el) {
                return;
            }
            _this.containerElement = el.parentNode;
            _this.lastKnownContainerWidth = _this.containerElement.offsetWidth;
            _this.setState({
                availableWidth: el.offsetWidth
            }, function () { return _this.updateNavigation(_this.props); });
        };
        _this.setNavigation = function (el) {
            _this.navigation = el;
        };
        _this.updateNavigation = _this.updateNavigation.bind(_this);
        _this.howManyItemsInMenuArray = _this.howManyItemsInMenuArray.bind(_this);
        _this.onResizeThrottled = lodash_1.throttle(_this.onResize, 100);
        _this.state = {
            hasMeasurements: false,
            isMoreMenuOpen: false,
            priorityItems: _this.props.navigationItems,
            moreItems: [],
            availableWidth: null
        };
        return _this;
    }
    PriorityNavigation.prototype.componentDidMount = function () {
        var _this = this;
        //Get width of all items in navigation menu
        this.widthsArray = Array.prototype.slice.call(this.navigation.children).map(function (item) { return item.getBoundingClientRect().width; });
        this.setState({ hasMeasurements: true }, function () { return _this.updateNavigation(_this.props); });
    };
    PriorityNavigation.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateNavigation(nextProps);
    };
    PriorityNavigation.prototype.render = function () {
        var _this = this;
        var _a = this.state, priorityItems = _a.priorityItems, moreItems = _a.moreItems;
        // Do first pass to measure all items
        if (!this.state.hasMeasurements) {
            return React.createElement("nav", { className: this.props.className },
                React.createElement("ul", { ref: this.setNavigation },
                    priorityItems.map(function (item, index) { return React.createElement(RoutedNavItem, { key: "navItem-" + index, item: item, activeItemClassName: _this.props.activeItemClassName }); }),
                    React.createElement(LinksMenuButton_1.LinksMenuButton, { activeItemClassName: this.props.activeItemClassName, label: "More", moreItems: this.state.moreItems })));
        }
        // Measure the container to find out available width
        if (this.state.availableWidth === null) {
            // This div will live in the document for a brief moment, just long
            // enough for it to mount. We then use it to calculate its width, and
            // replace it immediately with the underlying component.
            return React.createElement("div", { style: { flexGrow: 1, width: "100%" }, ref: this.setMeasurementDiv });
        }
        return (React.createElement("nav", { className: this.props.className },
            React.createElement(react_event_listener_1.default, { target: "window", onResize: react_event_listener_1.withOptions(this.onResizeThrottled, { passive: true }) }),
            React.createElement("ul", null,
                priorityItems.map(function (item, index) {
                    return React.createElement(RoutedNavItem, { key: "navItem-" + index, item: item, activeItemClassName: _this.props.activeItemClassName });
                }),
                moreItems.length > 0 && React.createElement(LinksMenuButton_1.LinksMenuButton, { activeItemClassName: this.props.activeItemClassName, icon: this.props.showHamburgerIcon && priorityItems.length === 0 ? "fa fa-bars" : null, label: "More", moreItems: moreItems }))));
    };
    PriorityNavigation.prototype.howManyItemsInMenuArray = function (array, outerWidth, initialWidth, maximumNumberInNav) {
        var total = initialWidth;
        for (var i = 0; i < array.length; i++) {
            if (i > maximumNumberInNav) {
                return maximumNumberInNav;
            }
            total += array[i];
            if (total > outerWidth) {
                return i;
            }
        }
        return array.length;
    };
    PriorityNavigation.prototype.updateNavigation = function (props) {
        if (!(this.state.hasMeasurements && this.state.availableWidth !== null)) {
            return;
        }
        var arrayAmount = this.howManyItemsInMenuArray(this.widthsArray, this.state.availableWidth, this.widthsArray[this.widthsArray.length - 1], props.maxNavigationItems);
        var navItemsCopy = props.navigationItems;
        var priorityItems = navItemsCopy.slice(0, arrayAmount);
        var moreItems = priorityItems.length !== navItemsCopy.length
            ? navItemsCopy.slice(arrayAmount, navItemsCopy.length).filter(function (item) { return !MenuNode_1.isMenuPopper(item); })
            : [];
        this.setState({
            priorityItems: priorityItems,
            moreItems: moreItems
        });
    };
    return PriorityNavigation;
}(BaseComponent_1.BaseComponent));
var NavItem = function (props) {
    var item = props.item;
    if (MenuNode_1.isMenuGroup(item)) {
        var isActive = MenuNode_1.hasActiveDescendants(props.location.pathname, props.match.params.spaceId, item);
        return React.createElement("li", null,
            React.createElement(LinksMenu_1.LinksMenu, { activeItemClassName: isActive ? props.activeItemClassName : null, items: item.children, label: item.label }));
    }
    if (MenuNode_1.isMenuPopper(item)) {
        return React.createElement(MenuPopperLi, { class: isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, item.url, false) ? props.activeItemClassName : null, icon: item.icon, text: item.text, title: item.title, onClick: function (el) { return item.onClick(el); } });
    }
    return React.createElement("li", null,
        React.createElement(InternalNavLink_1.default, { activeClassName: props.activeItemClassName, to: item.url, exact: item.exact, title: item.title },
            item.icon,
            React.createElement("span", null, item.text)));
};
var RoutedNavItem = react_router_1.withRouter(NavItem);
var MenuPopperLi = (function (_super) {
    __extends(MenuPopperLi, _super);
    function MenuPopperLi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event) {
            event.preventDefault();
            _this.props.onClick(_this.anchorEl);
        };
        _this.setRef = function (el) {
            _this.anchorEl = el;
        };
        return _this;
    }
    MenuPopperLi.prototype.render = function () {
        return React.createElement("li", { ref: this.setRef, className: this.props.itemClass },
            React.createElement("a", { className: this.props.class, onClick: this.onClick, href: "#", title: this.props.title }, this.props.icon));
    };
    return MenuPopperLi;
}(React.Component));
exports.default = PriorityNavigation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PriorityNavigation\\PriorityNavigation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PriorityNavigation\\PriorityNavigation.tsx"); } } })();

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MenuNode_1 = __webpack_require__(699);
var material_ui_1 = __webpack_require__(101);
var Popover_1 = __webpack_require__(164);
var React = __webpack_require__(0);
var uiTestClasses_1 = __webpack_require__(86);
var LinksMenu = (function (_super) {
    __extends(LinksMenu, _super);
    function LinksMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.closeMenu = function () {
            _this.setState({ isOpen: false, anchor: null });
        };
        _this.state = { isOpen: false };
        return _this;
    }
    LinksMenu.prototype.render = function () {
        var _this = this;
        return React.createElement("a", { onClick: function (e) { return _this.openMenu(e); }, href: "#", className: this.props.activeItemClassName },
            this.props.icon && React.createElement("em", { className: this.props.icon }),
            !this.props.icon && React.createElement("span", null, this.props.label),
            !this.props.icon && React.createElement("em", { className: "fa fa-caret-down" }),
            React.createElement(Popover_1.default, { className: uiTestClasses_1.linkMenuClassName, open: this.state.isOpen, anchorEl: this.state.anchor, onRequestClose: function () { return _this.closeMenu(); }, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } },
                React.createElement(material_ui_1.Menu, null, this.props.items.map(function (item, i) {
                    return React.createElement(MenuNode_1.MenuNodeComponent, { node: item, key: i, onClick: _this.closeMenu });
                }))));
    };
    LinksMenu.prototype.openMenu = function (event) {
        event.preventDefault();
        var anchor = event.currentTarget;
        this.setState({ isOpen: true, anchor: anchor });
    };
    return LinksMenu;
}(React.Component));
exports.LinksMenu = LinksMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\LinksMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\LinksMenu.tsx"); } } })();

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var MenuItem_1 = __webpack_require__(109);
var navigation_arrow_drop_right_1 = __webpack_require__(1655);
var React = __webpack_require__(0);
var react_router_1 = __webpack_require__(76);
var InternalLink_1 = __webpack_require__(43);
var isUrlActive_1 = __webpack_require__(406);
var MenuNodeComponent = function (props) {
    var activeStyle = { color: "#2f93e0" };
    if (isMenuGroup(props.node)) {
        return React.createElement(MenuItem_1.default, { style: hasActiveDescendants(props.location.pathname, props.match.params.spaceId, props.node) ? activeStyle : {}, primaryText: props.node.label, rightIcon: React.createElement(navigation_arrow_drop_right_1.default, null), menuItems: props.node.children.map(function (c, index) { return React.createElement(RoutedMenuNodeComponent, { node: c, key: index, onClick: props.onClick }); }) });
    }
    if (isMenuPopper(props.node)) {
        return React.createElement(InternalLink_1.default, { to: props.node.url },
            React.createElement(MenuItem_1.default, { leftIcon: props.node.icon, onClick: function () { return props.onClick(); } }));
    }
    return React.createElement(InternalLink_1.default, { to: props.node.url },
        React.createElement(MenuItem_1.default, { style: isUrlActive_1.isUrlActive(props.location.pathname, props.match.params.spaceId, props.node.url, props.node.exact) ? activeStyle : {}, primaryText: props.node.text, onClick: function () { return props.onClick(); } }));
};
var RoutedMenuNodeComponent = react_router_1.withRouter(MenuNodeComponent);
exports.MenuNodeComponent = RoutedMenuNodeComponent;
function isMenuGroup(node) {
    return node.children !== undefined;
}
exports.isMenuGroup = isMenuGroup;
function isMenuPopper(node) {
    return node.onClick !== undefined;
}
exports.isMenuPopper = isMenuPopper;
function hasActiveDescendants(pathname, spaceId, group) {
    var allDescendantLinks = function (_) { return lodash_1.flatten(_.children.map(function (c) {
        if (isMenuGroup(c)) {
            return allDescendantLinks(c);
        }
        return [c];
    })); };
    return allDescendantLinks(group).some(function (l) { return isUrlActive_1.isUrlActive(pathname, spaceId, l.url, l.exact); });
}
exports.hasActiveDescendants = hasActiveDescendants;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\MenuNode.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\MenuNode.tsx"); } } })();

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var notificationLocalState = __webpack_require__(265);
var notifications_redux_1 = __webpack_require__(176);
var store_1 = __webpack_require__(123);
var NotificationPoller = (function (_super) {
    __extends(NotificationPoller, _super);
    function NotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pollingPeriod = 1000 * 60 * 60 * 6; //6 hours
        _this.timeout = -1;
        return _this;
    }
    NotificationPoller.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notificationCheck()];
                    case 1:
                        _a.sent();
                        this.tick();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationPoller.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeout);
    };
    NotificationPoller.prototype.render = function () {
        return null;
    };
    NotificationPoller.prototype.dismissNotification = function () {
        notificationLocalState.clearValue(this.notificationId);
        notifications_redux_1.dismissNotification(store_1.default.dispatch)(this.notificationId);
    };
    NotificationPoller.prototype.raiseNotification = function (notification) {
        notifications_redux_1.raiseNotification(store_1.default.dispatch)(notification);
    };
    NotificationPoller.prototype.tick = function () {
        var _this = this;
        this.timeout = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.unmounted) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.notificationCheck()];
                    case 1:
                        _a.sent();
                        this.tick();
                        return [2 /*return*/];
                }
            });
        }); }, this.pollingPeriod);
    };
    return NotificationPoller;
}(BaseComponent_1.BaseComponent));
exports.NotificationPoller = NotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\NotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\NotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(316);
var index_2 = __webpack_require__(829);
var React = __webpack_require__(0);
var DataCube_1 = __webpack_require__(242);
var BaseComponent_1 = __webpack_require__(12);
var index_3 = __webpack_require__(830);
var DashboardDataSource_1 = __webpack_require__(833);
var AreaTitle_1 = __webpack_require__(122);
var Button_1 = __webpack_require__(47);
var index_4 = __webpack_require__(154);
var styles = __webpack_require__(1704);
var GettingStartedDetails_1 = __webpack_require__(689);
var form_1 = __webpack_require__(16);
var cn = __webpack_require__(19);
var lodash_1 = __webpack_require__(11);
var MobileDetect = __webpack_require__(479);
var routeLinks_1 = __webpack_require__(22);
var QueryStringFilters_1 = __webpack_require__(307);
var performanceConfigurationResource_1 = __webpack_require__(319);
var defaultFilter = {
    projectName: "",
    projectGroupId: ""
};
var DashboardQueryStringFilters = (function (_super) {
    __extends(DashboardQueryStringFilters, _super);
    function DashboardQueryStringFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DashboardQueryStringFilters;
}(QueryStringFilters_1.QueryStringFilters));
var DashboardOverview = (function (_super) {
    __extends(DashboardOverview, _super);
    function DashboardOverview(props) {
        var _this = _super.call(this, props) || this;
        _this.renderDataSource = function (dataSource) {
            if (dataSource.hasInitialLoaded && Object.keys(dataSource.cube.projectIndex).length === 0) {
                return React.createElement(GettingStartedDetails_1.GettingStartedDetails, null);
            }
            return React.createElement(index_4.default, { flatStyle: true, fullWidth: true, busy: dataSource.busy, errors: dataSource.errors, className: styles.paper }, dataSource.hasInitialLoaded && _this.showDashboard(dataSource));
        };
        _this.handleGroupChange = function (projectGroupId) {
            _this.setState(function (prev) { return ({ filter: __assign({}, prev.filter, { projectGroupId: projectGroupId }) }); });
        };
        _this.handleNameChange = function (projectName) {
            _this.setState(function (prev) { return ({ filter: __assign({}, prev.filter, { projectName: projectName }) }); });
        };
        _this.createDashboardFilters = function () {
            var filter = _this.state.filter;
            var groupFilters = filter.projectGroupId !== "" ? (_a = {}, _a[filter.projectGroupId] = true, _a) : null;
            var projectNameFilters = filter.projectName !== "" ? (_b = {}, _b[filter.projectName] = true, _b) : null;
            return _c = {
                    rowDimension: DataCube_1.DimensionTypes.Project,
                    columnDimension: DataCube_1.DimensionTypes.Environment,
                    groupBy: DataCube_1.DimensionTypes.ProjectGroup
                },
                _c[DataCube_1.DimensionTypes.ProjectGroup] = groupFilters,
                _c[DataCube_1.DimensionTypes.ProjectName] = projectNameFilters,
                _c;
            var _a, _b, _c;
        };
        _this.handleProjectCountChange = function (matchCount) {
            // don't re-render is count is the same. Easier to check
            // here than shouldComponentUpdate
            if (matchCount !== _this.state.matchCount) {
                _this.setState({ matchCount: matchCount });
            }
        };
        _this.state = {
            filter: defaultFilter,
            matchCount: 0
        };
        return _this;
    }
    DashboardOverview.prototype.showDashboard = function (dashboardData) {
        var cube = dashboardData.cube;
        var groups = lodash_1.sortBy(cube.projectGroupIndex, function (g) { return g.Name.toLowerCase(); }).map(function (g) { return ({ value: g.Id, text: g.Name }); });
        var hasFilter = !lodash_1.isEqual(defaultFilter, this.state.filter);
        // Disable autoFocus filtering for mobile (Android has issues and is annoying users).
        var md = new MobileDetect(window.navigator.userAgent);
        var autoFocus = md.isPhoneSized() ? false : true;
        return [
            React.createElement("div", { className: styles.filterHeaderContainer, key: "A", role: "search" },
                React.createElement("div", { className: styles.filterFieldContainer },
                    React.createElement(index_2.default, { className: styles.filter },
                        groups.length > 1 && React.createElement("div", { className: styles.filterField },
                            React.createElement(form_1.Select, { label: "Project group", items: groups, onChange: this.handleGroupChange, value: this.state.filter.projectGroupId, allowClear: true })),
                        React.createElement("div", { className: styles.filterField },
                            React.createElement(index_1.default, { hintText: "Project name", value: this.state.filter.projectName, onChange: this.handleNameChange, autoFocus: autoFocus, fullWidth: true })),
                        this.renderWarning(this.state.matchCount, dashboardData.projectLimit, hasFilter)))),
            React.createElement(index_3.default, { key: "B", cube: dashboardData.cube, filters: this.createDashboardFilters(), maximumRows: dashboardData.projectLimit, showDeploymentCounts: true, onProjectCountChanged: this.handleProjectCountChange, dashboardRenderMode: performanceConfigurationResource_1.DashboardRenderMode.VirtualizeColumns })
        ];
    };
    DashboardOverview.prototype.render = function () {
        var _this = this;
        return React.createElement("main", { className: styles.container },
            React.createElement(DashboardQueryStringFilters, { filter: this.state.filter, getQuery: getQueryFromFilters, getFilter: getFilter, onFilterChange: function (filter) { return _this.setState({ filter: filter }); } }),
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.root, title: "Dashboard" },
                React.createElement(Button_1.NavigationButton, { label: "Configure", href: routeLinks_1.default.dashboard.configure })),
            React.createElement(DashboardDataSource_1.default, { filters: this.createDashboardFilters(), render: this.renderDataSource }));
    };
    DashboardOverview.prototype.renderWarning = function (matchCount, projectLimit, hasFilter) {
        var hasLimit = projectLimit !== null && projectLimit !== undefined && projectLimit > 0;
        if (hasLimit && matchCount > projectLimit) {
            return React.createElement("span", { className: cn(styles.help, styles.alert) },
                "Only the first ",
                projectLimit,
                " projects and any projects with failing deployments are shown (",
                matchCount,
                " total)");
        }
        if (hasFilter && matchCount !== 1) {
            return React.createElement("span", { className: cn(styles.help, styles.info) },
                matchCount,
                " projects match");
        }
        if (hasFilter && matchCount === 1) {
            return React.createElement("span", { className: cn(styles.help, styles.info) }, "1 project matches");
        }
        return null;
    };
    return DashboardOverview;
}(BaseComponent_1.BaseComponent));
exports.default = DashboardOverview;
function getQueryFromFilters(filter) {
    return {
        projectGroupId: filter.projectGroupId,
        projectName: filter.projectName
    };
}
function getFilter(query) {
    return {
        projectGroupId: query.projectGroupId || "",
        projectName: query.projectName || ""
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardOverview\\DashboardOverview.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardOverview\\DashboardOverview.tsx"); } } })();

/***/ }),
/* 702 */,
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1701);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(133);
var dialogIdGenerator_1 = __webpack_require__(293);
var OpenDialogConnect_1 = __webpack_require__(411);
var OpenDialogMenuItemInternal = (function (_super) {
    __extends(OpenDialogMenuItemInternal, _super);
    function OpenDialogMenuItemInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.text = _this.props.label;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    OpenDialogMenuItemInternal.prototype.onClick = function () {
        this.props.openDialog(this.uniqueId);
    };
    OpenDialogMenuItemInternal.prototype.render = function () {
        return this.props.renderDialog ? this.props.renderDialog({ open: this.props.openDialogs[this.uniqueId], sequence: this.uniqueId }) : React.createElement(Dialog_1.default, { open: this.props.openDialogs[this.uniqueId] }, this.props.children);
    };
    return OpenDialogMenuItemInternal;
}(React.Component));
exports.OpenDialogMenuItemInternal = OpenDialogMenuItemInternal;
var OpenDialogMenuItem = OpenDialogConnect_1.OpenDialogConnect.to(OpenDialogMenuItemInternal, true);
exports.default = OpenDialogMenuItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OpenDialogMenuItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OpenDialogMenuItem.tsx"); } } })();

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var DeleteDialog_1 = __webpack_require__(486);
var OpenDeleteDialogMenuItem = (function (_super) {
    __extends(OpenDeleteDialogMenuItem, _super);
    function OpenDeleteDialogMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            _this.setState({ open: true });
        };
        _this.state = { open: false };
        return _this;
    }
    OpenDeleteDialogMenuItem.prototype.render = function () {
        var _this = this;
        return React.createElement(DeleteDialog_1.default, { title: this.props.dialogTitle, open: this.state.open, deleteButtonLabel: this.props.deleteButtonLabel, deleteButtonBusyLabel: this.props.deleteButtonBusyLabel, onClose: function () { return _this.setState({ open: false }); }, onDeleteClick: function () { return _this.props.onDeleteClick(); } }, this.props.children);
    };
    return OpenDeleteDialogMenuItem;
}(BaseComponent_1.BaseComponent));
exports.default = OpenDeleteDialogMenuItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OpenDeleteDialogMenuItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OpenDeleteDialogMenuItem.tsx"); } } })();

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Card_1 = __webpack_require__(135);
var styles = __webpack_require__(117);
var FormSectionBase_1 = __webpack_require__(292);
var uiTestClasses_1 = __webpack_require__(86);
var FormSection = (function (_super) {
    __extends(FormSection, _super);
    function FormSection(props) {
        return _super.call(this, props) || this;
    }
    FormSection.prototype.render = function () {
        return React.createElement(Card_1.Card, { className: uiTestClasses_1.formSectionClass + " " + styles.formSection, expanded: true },
            React.createElement(Card_1.CardTitle, { title: this.title(this.props.title, this.help(this.props.help)) }),
            this.body(styles.cardMedia, false),
            this.moreInformation());
    };
    return FormSection;
}(FormSectionBase_1.FormSectionBase));
exports.default = FormSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\FormSection.tsx"); } } })();

/***/ }),
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var colors_1 = __webpack_require__(31);
var BorderedListItem = function (props) {
    return React.createElement(material_ui_1.ListItem, __assign({ style: {
            borderBottom: "0.0625rem solid",
            borderColor: colors_1.divider,
        } }, props), props.children);
};
exports.default = BorderedListItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BorderedListItem\\BorderedListItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BorderedListItem\\BorderedListItem.tsx"); } } })();

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1785);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1822);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./empty.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./empty.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getSkippedState(phase, status) {
    return phase.IsOptionalPhase && !!status.progress[phase.Name] && status.progress[phase.Name] !== "Blocked" && status.progress[phase.Name] !== "Complete"
        && status.progress[phase.Name] !== "Current" && !status.deployed[getSingleDeploymentTarget(phase)];
}
exports.getSkippedState = getSkippedState;
function getSingleDeploymentTarget(phase) {
    if (phase.AutomaticDeploymentTargets.length > 0) {
        return phase.AutomaticDeploymentTargets[0];
    }
    else {
        return phase.OptionalDeploymentTargets[0];
    }
}
exports.getSingleDeploymentTarget = getSingleDeploymentTarget;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\PhaseHelper\\phaseHelpers.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\PhaseHelper\\phaseHelpers.ts"); } } })();

/***/ }),
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var Targets = (function (_super) {
    __extends(Targets, _super);
    function Targets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Targets.prototype.render = function () {
        var targets = this.props.targets;
        return React.createElement("span", null, lodash_1.flatten(targets.map(function (target, index) {
            var nodes = [target];
            if (index === targets.length - 1) {
                return nodes;
            }
            nodes.push(React.createElement("span", { key: targets.length + index }, index === targets.length - 2 ? " and " : ", "));
            return nodes;
        })));
    };
    return Targets;
}(React.Component));
exports.Targets = Targets;
exports.default = Targets;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\Targets.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\Targets.tsx"); } } })();

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "step-rolling.a137e7e36fc6c412b05b522fb2a7bef2.hashedasset.svg";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InputWithActions_1 = __webpack_require__(163);
var BusyIndicator_1 = __webpack_require__(95);
var IconButton_1 = __webpack_require__(52);
var IconButtonList_1 = __webpack_require__(124);
var Select_1 = __webpack_require__(40);
var BoundField_1 = __webpack_require__(100);
var styles = __webpack_require__(1965);
var SelectWithAddRefresh = (function (_super) {
    __extends(SelectWithAddRefresh, _super);
    function SelectWithAddRefresh(props) {
        var _this = _super.call(this, props) || this;
        _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ refreshing: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.onRequestRefresh()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ refreshing: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.openAddWindow = function () {
            window.open(_this.props.addUrl, "_blank");
        };
        _this.state = {
            refreshing: false
        };
        return _this;
    }
    SelectWithAddRefresh.prototype.render = function () {
        var _a = this.props, addUrl = _a.addUrl, onRequestRefresh = _a.onRequestRefresh, selectProps = __rest(_a, ["addUrl", "onRequestRefresh"]);
        return React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({}, selectProps)), actions: React.createElement("div", { className: styles.addRefreshButtons },
                React.createElement(IconButtonList_1.default, { buttons: this.buttons() })) });
    };
    SelectWithAddRefresh.prototype.buttons = function () {
        return [this.state.refreshing
                ? React.createElement(BusyIndicator_1.default, { show: true, inline: true })
                : React.createElement(IconButton_1.default, { onClick: this.onRequestRefresh, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }),
            React.createElement(IconButton_1.default, { toolTipContent: "Add", onClick: this.openAddWindow, icon: IconButton_1.Icon.Add })];
    };
    return SelectWithAddRefresh;
}(React.Component));
exports.default = SelectWithAddRefresh;
exports.BoundSelectWithAddRefresh = BoundField_1.withBoundField(SelectWithAddRefresh);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\SelectWithAddRefresh\\SelectWithAddRefresh.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\SelectWithAddRefresh\\SelectWithAddRefresh.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var withProjectVariables_1 = __webpack_require__(1969);
var withValidateOnChange_1 = __webpack_require__(1972);
var resources_1 = __webpack_require__(17);
var variableResource_1 = __webpack_require__(430);
var recompose_1 = __webpack_require__(186);
var VariableSelect_1 = __webpack_require__(1973);
exports.VariableSelect = VariableSelect_1.default;
var BoundField_1 = __webpack_require__(100);
var enhanceAwsVariable = recompose_1.compose(withProjectVariables_1.default({
    controlType: resources_1.ControlType.AmazonWebServicesAccount,
    variableType: variableResource_1.VariableType.AmazonWebServicesAccount
}), withValidateOnChange_1.default());
exports.enhanceAwsVariable = enhanceAwsVariable;
var enhanceAzureVariable = recompose_1.compose(withProjectVariables_1.default({
    controlType: resources_1.ControlType.AzureAccount,
    variableType: variableResource_1.VariableType.AzureAccount
}), withValidateOnChange_1.default());
exports.enhanceAzureVariable = enhanceAzureVariable;
var awsEnhancedComponent = enhanceAwsVariable(VariableSelect_1.default);
exports.awsEnhancedComponent = awsEnhancedComponent;
var azureEnhancedComponent = enhanceAzureVariable(VariableSelect_1.default);
exports.azureEnhancedComponent = azureEnhancedComponent;
exports.AwsBoundAccountVariableSelect = BoundField_1.withBoundField(awsEnhancedComponent);
exports.AzureBoundAccountVariableSelect = BoundField_1.withBoundField(azureEnhancedComponent);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\AccountSelect\\AccountVariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\AccountSelect\\AccountVariableSelect.tsx"); } } })();

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var IconButtonList_1 = __webpack_require__(124);
var InputWithActions_1 = __webpack_require__(136);
var Select_1 = __webpack_require__(40);
var index_1 = __webpack_require__(312);
var IconButton_1 = __webpack_require__(52);
var routeLinks_1 = __webpack_require__(22);
var Busy = function (_a) {
    var isBusy = _a.isBusy, children = _a.children;
    return isBusy ? React.createElement(index_1.default, { show: true, inline: true }) : React.Children.only(children);
};
var gotoProjectVariables = function (projectId) {
    return function () { return window.open("#" + routeLinks_1.default.project(projectId).variables.root, "_blank"); };
};
var VariableSelect = function (_a) {
    var onChange = _a.onChange, onRequestRefresh = _a.onRequestRefresh, error = _a.error, isRefreshing = _a.isRefreshing, validation = _a.validation, variables = _a.variables, projectId = _a.projectId, otherProps = __rest(_a, ["onChange", "onRequestRefresh", "error", "isRefreshing", "validation", "variables", "projectId"]);
    return (React.createElement(Busy, { isBusy: isRefreshing },
        React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select Account variable" }, otherProps, { allowFilter: true, error: error || validation.error, onChange: onChange, items: variables.map(function (v) { return ({ value: v, text: v }); }) })), actions: React.createElement(IconButtonList_1.default, { buttons: [
                    React.createElement(Busy, { isBusy: isRefreshing },
                        React.createElement(IconButton_1.default, { toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh, onClick: onRequestRefresh })),
                    React.createElement(IconButton_1.default, { toolTipContent: "Add", icon: IconButton_1.Icon.Add, onClick: gotoProjectVariables(projectId) })
                ] }) })));
};
exports.VariableSelect = VariableSelect;
exports.default = VariableSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableSelect\\VariableSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableSelect\\VariableSelect.tsx"); } } })();

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var deploymentStepResource_1 = __webpack_require__(264);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var Callout_1 = __webpack_require__(57);
var ExternalLink_1 = __webpack_require__(26);
var StartConditionText = (_a = {},
    _a[deploymentStepResource_1.StartTrigger.StartAfterPrevious] = "Wait for the previous step to complete, then start",
    _a[deploymentStepResource_1.StartTrigger.StartWithPrevious] = "Run in parallel with the previous step",
    _a);
var StartTriggerRadioButtonGroup = (function (_super) {
    __extends(StartTriggerRadioButtonGroup, _super);
    function StartTriggerRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StartTriggerRadioButtonGroup;
}(RadioButtonGroup_1.default));
var StartTriggerExpandableFormSection = (function (_super) {
    __extends(StartTriggerExpandableFormSection, _super);
    function StartTriggerExpandableFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartTriggerExpandableFormSection.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.startTrigger !== this.props.startTrigger;
    };
    StartTriggerExpandableFormSection.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { title: "Start Trigger", help: "Control whether this step waits for the previous step to complete, or runs in parallel with it.", summary: this.props.startTrigger === deploymentStepResource_1.StartTrigger.StartWithPrevious
                ? form_1.Summary.summary(StartConditionText[this.props.startTrigger])
                : form_1.Summary.default(StartConditionText[this.props.startTrigger]), errorKey: "starttrigger" },
            React.createElement(StartTriggerRadioButtonGroup, { value: this.props.startTrigger, onChange: this.props.onChange }, [deploymentStepResource_1.StartTrigger.StartWithPrevious, deploymentStepResource_1.StartTrigger.StartAfterPrevious]
                .map(function (rc) { return React.createElement(RadioButton_1.default, { value: rc, label: StartConditionText[rc], key: rc }); })),
            (this.props.startTrigger === deploymentStepResource_1.StartTrigger.StartWithPrevious) &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Warning" },
                    "Please note that even with this setting, each target (excluding Azure endpoints) will still be limited to only performing a single deployment activity at once for safety reasons. See how to ",
                    React.createElement(ExternalLink_1.default, { href: "MultipleProcessesOnTentacle" }, "override this behavior"),
                    "."));
    };
    return StartTriggerExpandableFormSection;
}(React.Component));
exports.default = StartTriggerExpandableFormSection;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StartTriggerExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StartTriggerExpander.tsx"); } } })();

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var deploymentStepResource_1 = __webpack_require__(264);
var ExternalLink_1 = __webpack_require__(26);
var form_1 = __webpack_require__(16);
var form_2 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var VariableLookupText_1 = __webpack_require__(21);
var React = __webpack_require__(0);
var RunConditionRadioButtonGroup = (function (_super) {
    __extends(RunConditionRadioButtonGroup, _super);
    function RunConditionRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RunConditionRadioButtonGroup;
}(RadioButtonGroup_1.default));
var RunConditionText = (_a = {},
    _a[deploymentStepResource_1.RunCondition.Success] = "Success: only run when previous steps succeed",
    _a[deploymentStepResource_1.RunCondition.Failure] = "Failure: only run when a previous step failed",
    _a[deploymentStepResource_1.RunCondition.Always] = "Always run",
    _a[deploymentStepResource_1.RunCondition.Variable] = "Variable: only run when the variable expression is true",
    _a);
var RunTriggerExpander = (function (_super) {
    __extends(RunTriggerExpander, _super);
    function RunTriggerExpander() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RunTriggerExpander.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.condition !== this.props.condition
            || nextProps.variableExpression !== this.props.variableExpression;
    };
    RunTriggerExpander.prototype.render = function () {
        var conditions = (this.props.isFirstStep) ?
            [deploymentStepResource_1.RunCondition.Success, deploymentStepResource_1.RunCondition.Always, deploymentStepResource_1.RunCondition.Variable] :
            [deploymentStepResource_1.RunCondition.Success, deploymentStepResource_1.RunCondition.Failure, deploymentStepResource_1.RunCondition.Always, deploymentStepResource_1.RunCondition.Variable];
        return React.createElement(form_2.ExpandableFormSection, { title: "Run Condition", help: "Limit when this step runs by setting a condition.", errorKey: "runcondition", summary: this.props.condition === deploymentStepResource_1.RunCondition.Success ?
                form_2.Summary.default(RunConditionText[this.props.condition]) :
                form_2.Summary.summary(RunConditionText[this.props.condition]) },
            React.createElement(RunConditionRadioButtonGroup, { value: this.props.condition, onChange: this.props.onConditionChange }, conditions.map(function (rc) { return React.createElement(RadioButton_1.default, { value: rc, label: RunConditionText[rc], key: rc }); })),
            this.props.condition === deploymentStepResource_1.RunCondition.Variable && React.createElement("div", null,
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Variable expression", value: this.props.variableExpression, onChange: this.props.onVariableExpressionChange }),
                React.createElement(form_1.Note, null,
                    "Limit when this step runs by setting a boolean variable expression that will be evaluated at run-time. See the ",
                    React.createElement(ExternalLink_1.default, { href: "VariableSubstitutionSyntax" }, "Variable Substitution Syntax"),
                    " documentation for examples.")));
    };
    return RunTriggerExpander;
}(React.Component));
exports.default = RunTriggerExpander;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\RunTriggerExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\RunTriggerExpander.tsx"); } } })();

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var MaxParallelism = function (props) {
    return React.createElement("div", null,
        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: [], projectId: props.projectId, value: props.value, onChange: props.onChange, label: "Window size" }),
        React.createElement(form_1.Note, null, "Octopus will execute the step as quickly as possible using this value as the maximum degree of parallelism."));
};
exports.default = MaxParallelism;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\MaxParallelism.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\MaxParallelism.tsx"); } } })();

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(190);
var StepName = function (props) {
    /* mark.siedle - This is an exception to the usual ellipsis pattern because of the StepDetailsLoader. */
    return React.createElement("span", null,
        React.createElement("span", { className: styles.stepNumber },
            props.number,
            "."),
        props.name || "Step Details");
};
StepName.displayName = "StepName";
exports.default = StepName;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepName.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepName.tsx"); } } })();

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2001);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExtensionManager = (function () {
    function ExtensionManager() {
        this.extensions = {};
    }
    ExtensionManager.prototype.getExtension = function (name, type) {
        return this.extensions && this.extensions[type]
            ? this.extensions[type][name]
            : null;
    };
    ExtensionManager.prototype.registerExtension = function (name, type, extension) {
        if (!this.extensions[type]) {
            this.extensions[type] = { name: name, extension: extension };
        }
        this.extensions[type][name] = extension;
    };
    return ExtensionManager;
}());
exports.ExtensionManager = ExtensionManager;
var extensionManager = new ExtensionManager();
exports.default = extensionManager;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\extensionsManager.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\extensionsManager.ts"); } } })();

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "octopus.9edfb27b59f3259a3ec6501e41aa6748.hashedasset.svg";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(2028);
var CenteredLayout = (function (_super) {
    __extends(CenteredLayout, _super);
    function CenteredLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenteredLayout.prototype.render = function () {
        return React.createElement("div", { className: styles.container }, this.props.children);
    };
    return CenteredLayout;
}(React.Component));
exports.default = CenteredLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CenteredLayout\\CenteredLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\CenteredLayout\\CenteredLayout.tsx"); } } })();

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Theme_1 = __webpack_require__(2033);
exports.default = Theme_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Theme\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Theme\\index.ts"); } } })();

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(11);
var ParameterDataType;
(function (ParameterDataType) {
    ParameterDataType["string"] = "string";
    ParameterDataType["secureString"] = "securestring";
    ParameterDataType["int"] = "int";
    ParameterDataType["bool"] = "bool";
    ParameterDataType["object"] = "object";
    ParameterDataType["secureObject"] = "secureobject";
    ParameterDataType["array"] = "array";
})(ParameterDataType = exports.ParameterDataType || (exports.ParameterDataType = {}));
var Source;
(function (Source) {
    Source["octopus"] = "octopus";
    Source["azureKeyVault"] = "azureKeyVault";
})(Source = exports.Source || (exports.Source = {}));
var ParameterValues = (function () {
    function ParameterValues() {
    }
    return ParameterValues;
}());
exports.ParameterValues = ParameterValues;
var AzureTemplateHelper = (function () {
    function AzureTemplateHelper() {
    }
    //Technically speaking type names should follow camelCase naming convention as per https://azure.microsoft.com/en-us/documentation/articles/resource-group-authoring-templates/
    //but even Visual Studio project does not follow it.
    AzureTemplateHelper.normalizeType = function (type) {
        return type.toLowerCase();
    };
    AzureTemplateHelper.extractParameters = function (templateFile, parametersFile) {
        if (parametersFile === void 0) { parametersFile = ""; }
        var parameterValues = new ParameterValues();
        var errors = [];
        var template;
        var parameters;
        try {
            template = JSON.parse(templateFile);
            parameters = (parametersFile) ? JSON.parse(parametersFile) : {};
            if (template.parameters) {
                _.each(template.parameters, function (parameter, parameterName) {
                    var existingParameterValue = parameters[parameterName];
                    var parameterType = AzureTemplateHelper.normalizeType(parameter.type);
                    var parameterValue = __assign({}, parameter, { type: parameterType, description: (parameter.metadata !== undefined) ? parameter.metadata.description : undefined, value: existingParameterValue
                            ? AzureTemplateHelper.getParameterValue(parameters[parameterName].value)
                            : parameter.defaultValue
                                ? parameter.defaultValue
                                : (parameterType === ParameterDataType.array)
                                    ? "[]"
                                    : (parameterType === ParameterDataType.object)
                                        ? "{}"
                                        : undefined, source: Source.octopus });
                    if (existingParameterValue && existingParameterValue.reference) {
                        parameterValue.keyVaultId = existingParameterValue.reference.keyVault.id;
                        parameterValue.keyVaultSecretName = existingParameterValue.reference.secretName;
                        parameterValue.source = Source.azureKeyVault;
                    }
                    parameterValues[parameterName] = parameterValue;
                });
            }
        }
        catch (e) {
            if (template) {
                // error with parametersFile
                errors.push("The parameter file is not valid JSON");
            }
            else {
                errors.push("The template file is not valid JSON");
            }
        }
        return { value: parameterValues, errors: errors };
    };
    AzureTemplateHelper.exportParameters = function (parameters) {
        var armParams = {};
        var invalidTemplateParameters = [];
        if (parameters) {
            _.each(parameters, function (paramValue, paramName) {
                var armParameterValue = {};
                if (paramValue.source !== Source.azureKeyVault) {
                    if (AzureTemplateHelper.shouldJsonParse(paramValue.type)) {
                        try {
                            armParameterValue.value = JSON.parse(paramValue.value);
                        }
                        catch (e) {
                            //Logger.error("Failed to parse '" + paramValue.value + "' as valid JSON.");
                            invalidTemplateParameters.push(paramName);
                            armParameterValue.value = paramValue.value; // Leave this as what the user typed in ... give them the opportunity to fix it.
                        }
                    }
                    else {
                        armParameterValue.value = paramValue.value;
                    }
                }
                else {
                    armParameterValue.reference = {
                        keyVault: {
                            id: paramValue.keyVaultId
                        },
                        secretName: paramValue.keyVaultSecretName
                    };
                }
                armParams[paramName] = armParameterValue;
            });
        }
        return { value: JSON.stringify(armParams), errors: invalidTemplateParameters };
    };
    AzureTemplateHelper.getParameterValue = function (value) {
        if (_.isObject(value)) {
            return JSON.stringify(value, undefined, 4);
        }
        else {
            return value;
        }
    };
    //Parameters that are of type 'array', 'object' or 'secureObject' needs to be parsed as JSON,
    //otherwise the template will not be deemed valid as they will be used as a string and the deployment
    //will fail with an error message similar to the below:
    //'Hyak.Common.CloudException: InvalidTemplate: Deployment template validation failed:
    //'The provided value for the template parameter '<parameterName>' at line 'x' and column 'y' is not valid.'.
    AzureTemplateHelper.shouldJsonParse = function (type) {
        return type === ParameterDataType.array || type === ParameterDataType.object || type === ParameterDataType.secureObject;
    };
    return AzureTemplateHelper;
}());
exports.AzureTemplateHelper = AzureTemplateHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureTemplateHelper.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureTemplateHelper.ts"); } } })();

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(2070);
exports.DialogActions = function (_a) {
    var className = _a.className, actions = _a.actions, additionalActions = _a.additionalActions;
    return React.createElement("div", { className: cn(styles.actions, className) },
        React.createElement("div", { className: styles.additionalActions }, additionalActions),
        React.createElement("div", { className: styles.primaryActions }, actions));
};
exports.default = exports.DialogActions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogActions.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogActions.tsx"); } } })();

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(26);
var AzureServiceFabricSdkRequiredInfo = function (props) {
    return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
        "The ",
        React.createElement(ExternalLink_1.default, { href: "ServiceFabricSdkDownload" }, "Service Fabric SDK"),
        " must be installed on the ",
        React.createElement("strong", null, "Octopus Server"),
        " for this step.  Additional information about this step can be found in the ",
        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingApps" }, "Deploying to Service Fabric documentation"),
        ".");
};
exports.default = AzureServiceFabricSdkRequiredInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricSdkRequiredInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricSdkRequiredInfo.tsx"); } } })();

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Note_1 = __webpack_require__(20);
var ExpandableFormSection_1 = __webpack_require__(30);
var VariableLookupText_1 = __webpack_require__(21);
var Summary_1 = __webpack_require__(44);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var ExternalLink_1 = __webpack_require__(26);
var CertificateVariableSelect_1 = __webpack_require__(191);
var Sensitive_1 = __webpack_require__(93);
var endpointResource_1 = __webpack_require__(477);
var AzureServiceFabricAccountSelector = (function (_super) {
    __extends(AzureServiceFabricAccountSelector, _super);
    function AzureServiceFabricAccountSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    AzureServiceFabricAccountSelector.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzureServiceFabricAccountSelector.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var securityModeErrorKey = "Octopus.Action.ServiceFabric.SecurityMode|"
            + "Octopus.Action.ServiceFabric.ServerCertThumbprint|"
            + "Octopus.Action.ServiceFabric.ClientCertVariable|"
            + "Octopus.Action.ServiceFabric.AadClientCredentialSecret";
        return React.createElement("div", null,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.ConnectionEndpoint", isExpandedByDefault: this.props.expandedByDefault, title: "Connection Endpoint", summary: this.endpointSummary(), help: "Enter the connection endpoint of your Service Fabric cluster." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"], onChange: function (x) {
                        _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ConnectionEndpoint"] = x, _a));
                        if (!x) {
                            // This is a key field in determining legacy Azure steps, so if this is cleared, also
                            // clear related data that is now contributed by the target.
                            _this.props.setProperties((_b = {}, _b["Octopus.Action.ServiceFabric.SecurityMode"] = null, _b));
                            _this.props.setProperties((_c = {}, _c["Octopus.Action.ServiceFabric.ServerCertThumbprint"] = null, _c));
                            _this.props.setProperties((_d = {}, _d["Octopus.Action.ServiceFabric.ClientCertVariable"] = null, _d));
                            _this.props.setProperties((_e = {}, _e["Octopus.Action.ServiceFabric.AadCredentialType"] = null, _e));
                            _this.props.setProperties((_f = {}, _f["Octopus.Action.ServiceFabric.AadClientCredentialSecret"] = null, _f));
                            _this.props.setProperties((_g = {}, _g["Octopus.Action.ServiceFabric.AadUserCredentialUsername"] = null, _g));
                            _this.props.setProperties((_h = {}, _h["Octopus.Action.ServiceFabric.AadUserCredentialPassword"] = null, _h));
                        }
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ConnectionEndpoint"), label: "Connection endpoint" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: securityModeErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Security Mode", summary: this.securityModeSummary(), help: "Select the security mode use to connect to your Service Fabric cluster." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: endpointResource_1.AzureServiceFabricSecurityMode.Unsecure, value: properties["Octopus.Action.ServiceFabric.SecurityMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.SecurityMode"] = x, _a));
                        var _a;
                    }, label: "Security mode" },
                    React.createElement(RadioButton_1.default, { value: endpointResource_1.AzureServiceFabricSecurityMode.Unsecure, label: "Unsecure", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: endpointResource_1.AzureServiceFabricSecurityMode.SecureClientCertificate, label: "Secure Client Certificate" }),
                    React.createElement(Note_1.default, null,
                        "To learn about client certificate authentication, please see the ",
                        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingAppsAuthClientCerts" }, "Connecting Securely with Client Certificates documentation"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: endpointResource_1.AzureServiceFabricSecurityMode.SecureAzureAD, label: "Secure Azure Active Directory (AAD)" }),
                    React.createElement(Note_1.default, null,
                        "To learn about AAD authentication, please see the ",
                        React.createElement(ExternalLink_1.default, { href: "ServiceFabricDeployingAppsAuthAzureAd" }, "Connecting Securely with Azure Active Directory documentation"),
                        ".")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] !== endpointResource_1.AzureServiceFabricSecurityMode.Unsecure) && React.createElement("div", null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ServerCertThumbprint"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ServerCertThumbprint"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ServerCertThumbprint"), label: "Server certificate thumbprint" }),
                    React.createElement(Note_1.default, null, "The server certificate thumbprint used to communicate with the secure cluster.")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] === endpointResource_1.AzureServiceFabricSecurityMode.SecureClientCertificate) && React.createElement("div", null,
                    this.state.project
                        ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: this.props.clientCertVariableResetValue, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, value: properties["Octopus.Action.ServiceFabric.ClientCertVariable"], error: this.props.getFieldError("Octopus.Action.ServiceFabric.ClientCertVariable"), onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ClientCertVariable"] = x, _a));
                                var _a;
                            } })
                        : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.ClientCertVariable"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.ClientCertVariable"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.ClientCertVariable"), label: "Client certificate" }),
                    React.createElement(Note_1.default, null, "The client certificate used to communicate with the secure cluster.")),
                (properties["Octopus.Action.ServiceFabric.SecurityMode"] === endpointResource_1.AzureServiceFabricSecurityMode.SecureAzureAD) && React.createElement("div", null,
                    false && React.createElement("div", null,
                        React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: endpointResource_1.AADCredentialType.ClientCredential, value: properties["Octopus.Action.ServiceFabric.AadCredentialType"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadCredentialType"] = x, _a));
                                var _a;
                            }, label: "Credential type" },
                            React.createElement(RadioButton_1.default, { value: endpointResource_1.AADCredentialType.ClientCredential, label: "Client credential", isDefault: true }),
                            React.createElement(RadioButton_1.default, { value: endpointResource_1.AADCredentialType.UserCredential, label: "User credential" })),
                        React.createElement(Note_1.default, null, "The credential type to use for AAD authentication.")),
                    (properties["Octopus.Action.ServiceFabric.AadCredentialType"] === endpointResource_1.AADCredentialType.ClientCredential) && React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.AadClientCredentialSecret"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadClientCredentialSecret"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.AadClientCredentialSecret"), label: "Client application secret" }),
                        React.createElement(Note_1.default, null, "The client application secret used to communicate with the secure cluster.")),
                    (properties["Octopus.Action.ServiceFabric.AadCredentialType"] === endpointResource_1.AADCredentialType.UserCredential) && React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.AadUserCredentialUsername"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadUserCredentialUsername"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.AadUserCredentialUsername"), label: "Username" }),
                        React.createElement(Note_1.default, null, "The Azure AD user's username used to communicate with the secure cluster."),
                        React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "", value: properties["Octopus.Action.ServiceFabric.AadUserCredentialPassword"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.AadUserCredentialPassword"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.AadUserCredentialPassword"), label: "Password" }),
                        React.createElement(Note_1.default, null, "The Azure AD user's password used to communicate with the secure cluster.")))));
    };
    AzureServiceFabricAccountSelector.prototype.endpointSummary = function () {
        if (this.props.properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]) {
            return Summary_1.default.summary(this.props.properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
        }
        return Summary_1.default.placeholder("The connection endpoint has not been set");
    };
    AzureServiceFabricAccountSelector.prototype.securityModeSummary = function () {
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === endpointResource_1.AzureServiceFabricSecurityMode.Unsecure) {
            return Summary_1.default.default("Unsecure");
        }
        var summary = [];
        var thumbprint = this.props.properties["Octopus.Action.ServiceFabric.ServerCertThumbprint"];
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === endpointResource_1.AzureServiceFabricSecurityMode.SecureClientCertificate) {
            summary.push(React.createElement("span", null,
                "Security mode is ",
                React.createElement("strong", null, "Client Certificate")));
            this.contributeCertificateThumbprintSummary(thumbprint, summary);
            if (!this.props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]) {
                summary.push(React.createElement("span", null,
                    ",  the client certificate has ",
                    React.createElement("strong", null, "not"),
                    " been set"));
            }
            else {
                summary.push(React.createElement("span", null, ",  the client certificate has been set"));
            }
            return Summary_1.default.summary(React.Children.toArray(summary));
        }
        if (this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"] === endpointResource_1.AzureServiceFabricSecurityMode.SecureAzureAD) {
            summary.push(React.createElement("span", null,
                "Security mode is ",
                React.createElement("strong", null, "Azure Active Directory")));
            this.contributeCertificateThumbprintSummary(thumbprint, summary);
            if (!this.props.properties["Octopus.Action.ServiceFabric.AadUserCredentialUsername"]) {
                summary.push(React.createElement("span", null,
                    ",  the AAD credentials have ",
                    React.createElement("strong", null, "not"),
                    " been set"));
            }
            else {
                summary.push(React.createElement("span", null, ",  the AAD credentials have been set"));
            }
            return Summary_1.default.summary(React.Children.toArray(summary));
        }
        return Summary_1.default.placeholder("Security mode has not been set");
    };
    AzureServiceFabricAccountSelector.prototype.contributeCertificateThumbprintSummary = function (thumbprint, summary) {
        if (!thumbprint) {
            summary.push(React.createElement("span", null,
                ",  the certificate thumbprint has ",
                React.createElement("strong", null, "not"),
                " been set"));
        }
        else {
            summary.push(React.createElement("span", null, ",  the certificate thumbprint has been set"));
        }
    };
    return AzureServiceFabricAccountSelector;
}(React.Component));
exports.default = AzureServiceFabricAccountSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricAccountSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\AzureServiceFabricAccountSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccessType;
(function (AccessType) {
    AccessType["ReadOnly"] = "ReadOnly";
    AccessType["FullControl"] = "FullControl";
})(AccessType = exports.AccessType || (exports.AccessType = {}));
var StoreLocations;
(function (StoreLocations) {
    StoreLocations["LocalMachine"] = "LocalMachine";
    StoreLocations["CurrentUser"] = "CurrentUser";
    StoreLocations["CustomUser"] = "Custom User";
})(StoreLocations = exports.StoreLocations || (exports.StoreLocations = {}));
var StoreNames;
(function (StoreNames) {
    StoreNames["My"] = "My";
    StoreNames["Root"] = "Root";
    StoreNames["CA"] = "CA";
    StoreNames["TrustedPeople"] = "TrustedPeople";
    StoreNames["TrustedPublisher"] = "TrustedPublisher";
    StoreNames["AuthRoot"] = "AuthRoot";
    StoreNames["AddressBook"] = "AddressBook";
    StoreNames["Other"] = "Other";
})(StoreNames = exports.StoreNames || (exports.StoreNames = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\CertificateImportTypes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\CertificateImportTypes.ts"); } } })();

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var StringCheckbox_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(20);
var Select_1 = __webpack_require__(40);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var wildflyProperties_1 = __webpack_require__(2090);
var wildflyConnectionDetailsComponent_1 = __webpack_require__(754);
var VariableLookupText_1 = __webpack_require__(21);
var StringProperties = {
    "WildFly.Deploy.Name": "",
    "WildFly.Deploy.Port": "",
    "WildFly.Deploy.Controller": "",
    "WildFly.Deploy.User": "",
    "WildFly.Deploy.Protocol": "",
    "WildFly.Deploy.ServerType": "",
    "WildFly.Deploy.Enabled": "",
    "WildFly.Deploy.DisabledServerGroup": "",
    "WildFly.Deploy.EnabledServerGroup": "",
};
var SensitiveProperties = {
    "WildFly.Deploy.Password": "",
};
var AllProperties = __assign({}, StringProperties, SensitiveProperties, wildflyProperties_1.WildflyStringProperties, wildflyProperties_1.WildflySensitiveStringProperties);
/**
 * A component that provide the connection details and application details
 * for a application deployment or state change.
 */
var WildflyFeatureTemplate = (function (_super) {
    __extends(WildflyFeatureTemplate, _super);
    function WildflyFeatureTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyFeatureTemplate.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(AllProperties, newProps, this.props);
    };
    WildflyFeatureTemplate.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var properties;
            return __generator(this, function (_a) {
                properties = {};
                if (!this.props.properties["WildFly.Deploy.Controller"]) {
                    properties["WildFly.Deploy.Controller"] = "localhost";
                }
                if (!this.props.properties["WildFly.Deploy.Port"]) {
                    properties["WildFly.Deploy.Port"] = "9990";
                }
                if (!this.props.properties["WildFly.Deploy.Protocol"]) {
                    properties["WildFly.Deploy.Protocol"] = "remote+http";
                }
                if (this.props.properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    this.props.properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                if (!this.props.properties["WildFly.Deploy.Enabled"]) {
                    properties["WildFly.Deploy.Enabled"] = "True";
                }
                this.props.setProperties(properties, true);
                return [2 /*return*/];
            });
        }); });
    };
    WildflyFeatureTemplate.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var applicationErrorKey = "WildFly.Deploy.Name|"
            + "WildFly.Deploy.ServerType|"
            + "WildFly.Deploy.Enabled|"
            + "WildFly.Deploy.EnabledServerGroup|"
            + "WildFly.Deploy.DisabledServerGroup";
        return React.createElement("div", null,
            React.createElement(wildflyConnectionDetailsComponent_1.default, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, projectId: this.props.projectId, applicationServerHostnameNote: this.props.applicationServerHostnameNote, actionDescription: React.createElement("span", null,
                    this.props.actionDescription,
                    " an application via the management interface listening on"), errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: applicationErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Application Details", summary: this.applicationSummary(), help: "Specify the details of the application." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Name"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Name"] = x, _a));
                        var _a;
                    }, label: "Deployment name", error: this.props.getFieldError("WildFly.Deploy.Name") }),
                React.createElement(Note_1.default, null, this.props.applicationNameNote),
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "Standalone", value: properties["WildFly.Deploy.ServerType"], items: [{ text: "Standalone", value: "Standalone" }, { text: "Domain", value: "Domain" }], label: "Standalone or Domain Server", onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ServerType"] = x, _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null, "Select the kind of server you are deploying to."),
                properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                    React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "True", value: properties["WildFly.Deploy.Enabled"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Enabled"] = x, _a));
                                var _a;
                            }, label: "Enable the deployment" }),
                        React.createElement(Note_1.default, null, this.props.applicationStateNote)),
                properties["WildFly.Deploy.ServerType"] === "Domain" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.EnabledServerGroup"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.EnabledServerGroup"] = x, _a));
                                var _a;
                            }, label: "Enabled server groups" }),
                        React.createElement(Note_1.default, null,
                            "A comma separated list that defines the domain server groups where the deployment will be assigned and enabled. This value is ignored when deploying to a standalone instance. Set the ",
                            React.createElement("em", null, "Standalone or Domain Server"),
                            " option to ",
                            React.createElement("em", null, "Standalone"),
                            " to see the ",
                            React.createElement("em", null, "Enable/Disable the Deployment"),
                            " option to control the state of the application when deployed to a standalone server."),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.DisabledServerGroup"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.DisabledServerGroup"] = x, _a));
                                var _a;
                            }, label: "Disabled server groups" }),
                        React.createElement(Note_1.default, null,
                            "A comma separated list that defines the domain server groups where the deployment will be assigned and disabled. This value is ignored when deploying to a standalone instance. Set the ",
                            React.createElement("em", null, "Standalone or Domain Server"),
                            " option to ",
                            React.createElement("em", null, "Standalone"),
                            " to see the ",
                            React.createElement("em", null, "Enable/Disable the Deployment"),
                            " option to control the state of the application when deployed to a standalone server."))));
    };
    WildflyFeatureTemplate.prototype.applicationSummary = function () {
        var properties = this.props.properties;
        if (properties["WildFly.Deploy.ServerType"] === "Standalone") {
            return form_1.Summary.summary(React.createElement("span", null,
                properties["WildFly.Deploy.Enabled"] === "True" ? "Enabling " : "Disabling ",
                "the application",
                properties["WildFly.Deploy.Name"] &&
                    React.createElement("strong", null,
                        "\u00A0",
                        properties["WildFly.Deploy.Name"]),
                "\u00A0in a standalone server."));
        }
        else {
            if (properties["WildFly.Deploy.EnabledServerGroup"] || properties["WildFly.Deploy.DisabledServerGroup"]) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "The application",
                    properties["WildFly.Deploy.Name"] &&
                        React.createElement("strong", null,
                            "\u00A0",
                            properties["WildFly.Deploy.Name"]),
                    properties["WildFly.Deploy.EnabledServerGroup"] &&
                        React.createElement("span", null,
                            "\u00A0will be enabled in server group",
                            properties["WildFly.Deploy.EnabledServerGroup"].indexOf(",") !== -1 && React.createElement("span", null, "s"),
                            "\u00A0",
                            React.createElement("strong", null, properties["WildFly.Deploy.EnabledServerGroup"])),
                    properties["WildFly.Deploy.EnabledServerGroup"] && properties["WildFly.Deploy.DisabledServerGroup"] &&
                        React.createElement("span", null, "\u00A0and"),
                    properties["WildFly.Deploy.DisabledServerGroup"] &&
                        React.createElement("span", null,
                            "\u00A0will be disabled in server group",
                            properties["WildFly.Deploy.DisabledServerGroup"].indexOf(",") !== -1 && React.createElement("span", null, "s"),
                            "\u00A0",
                            React.createElement("strong", null, properties["WildFly.Deploy.DisabledServerGroup"])),
                    "."));
            }
            else {
                return form_1.Summary.placeholder(React.createElement("span", null, this.props.domainDefaultMessage));
            }
        }
    };
    return WildflyFeatureTemplate;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyFeatureTemplate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyFeatureTemplate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyFeatureTemplate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Summary_1 = __webpack_require__(44);
var Sensitive_1 = __webpack_require__(93);
/**
 * A component that displays the connection details for a Wildfly server
 */
var WildflyConnectionDetailsComponent = (function (_super) {
    __extends(WildflyConnectionDetailsComponent, _super);
    function WildflyConnectionDetailsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyConnectionDetailsComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.props.properties["WildFly.Deploy.Controller"]) {
                    this.props.properties["WildFly.Deploy.Controller"] = "localhost";
                }
                if (!this.props.properties["WildFly.Deploy.Port"]) {
                    this.props.properties["WildFly.Deploy.Port"] = "9990";
                }
                if (!this.props.properties["WildFly.Deploy.Protocol"]) {
                    this.props.properties["WildFly.Deploy.Protocol"] = "remote+http";
                }
                if (this.props.properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    this.props.properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    this.props.properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                return [2 /*return*/];
            });
        }); });
    };
    WildflyConnectionDetailsComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var applicationServerErrorKey = "WildFly.Deploy.Controller|"
            + "WildFly.Deploy.Port|"
            + "WildFly.Deploy.Protocol|"
            + "WildFly.Deploy.User|"
            + "WildFly.Deploy.Password";
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: applicationServerErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Application Server Details", summary: this.wildflySummary(), help: "Specify the WildFly server details" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Controller"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Controller"] = x, _a));
                        var _a;
                    }, label: "Management host or IP", error: this.props.getFieldError("WildFly.Deploy.Controller") }),
                React.createElement(Note_1.default, null,
                    this.props.applicationServerHostnameNote,
                    " This value is relative to the host that is executing the step. So if the Tentacle is on the same host as WildFly/Red Hat JBoss EAP, then this value may be something like ",
                    React.createElement("em", null, "localhost"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Port"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Port"] = x, _a));
                        var _a;
                    }, label: "Management port", error: this.props.getFieldError("WildFly.Deploy.Port") }),
                React.createElement(Note_1.default, null,
                    "This is the management port that the application server is listening to. For WildFly 10+ and Red Hat JBoss EAP 7+, the default is ",
                    React.createElement("em", null, "9990"),
                    ". For Red Hat JBoss EAP 6, the default is ",
                    React.createElement("em", null, "9999"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.Protocol"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Protocol"] = x, _a));
                        var _a;
                    }, label: "Management protocol", error: this.props.getFieldError("WildFly.Deploy.Protocol") }),
                React.createElement(Note_1.default, null,
                    "This is the management protocol that the application server is listening to. For WildFly 10+ and Red Hat JBoss EAP 7+, the default is ",
                    React.createElement("em", null, "remote+http"),
                    ", or ",
                    React.createElement("em", null, "remote+https"),
                    " if the management port is configured to use HTTPS. For Red Hat JBoss EAP 6, the default is ",
                    React.createElement("em", null, "remoting"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.User"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.User"] = x, _a));
                        var _a;
                    }, label: "Management user" }),
                React.createElement(Note_1.default, null,
                    "The username to use with the management interface. This is typically configured via the",
                    React.createElement("em", null, " add-user"),
                    " script. By default WildFly does not require credentials for local connections (i.e. if the ",
                    React.createElement("em", null, "Management Host or IP"),
                    " is localhost or 127.0.0.1)."),
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["WildFly.Deploy.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.Password"] = x, _a));
                        var _a;
                    }, label: "Management password" }),
                React.createElement(Note_1.default, null,
                    "The password to use with the management interface. This is typically configured via the",
                    React.createElement("em", null, " add-user"),
                    " script. By default WildFly does not require credentials for local connections (i.e. if the ",
                    React.createElement("em", null, "Management Host or IP"),
                    " is localhost or 127.0.0.1).")));
    };
    WildflyConnectionDetailsComponent.prototype.wildflySummary = function () {
        var properties = this.props.properties;
        if (properties["WildFly.Deploy.Controller"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                React.createElement("span", null,
                    this.props.actionDescription,
                    " an application via the management interface listening on"),
                properties["WildFly.Deploy.Protocol"] &&
                    React.createElement("strong", null,
                        "\u00A0",
                        properties["WildFly.Deploy.Protocol"],
                        "://"),
                React.createElement("strong", null, properties["WildFly.Deploy.Controller"]),
                properties["WildFly.Deploy.Port"] &&
                    React.createElement("strong", null,
                        ":",
                        properties["WildFly.Deploy.Port"]),
                properties["WildFly.Deploy.User"] &&
                    React.createElement("span", null,
                        "\u00A0with user ",
                        React.createElement("strong", null, properties["WildFly.Deploy.User"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Specify the management hostname, port, protocol and credentials"));
    };
    return WildflyConnectionDetailsComponent;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyConnectionDetailsComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyConnectionDetailsComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyConnectionDetailsComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var BaseComponent_1 = __webpack_require__(12);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var CertificateVariableSelect_1 = __webpack_require__(191);
var Sensitive_1 = __webpack_require__(93);
var JavaKeystoreComponent = (function (_super) {
    __extends(JavaKeystoreComponent, _super);
    function JavaKeystoreComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    JavaKeystoreComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    JavaKeystoreComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            this.props.projectId
                ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, projectId: this.props.projectId, resetValue: "", doBusyTask: this.props.doBusyTask, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                        var _a;
                    }, allowClear: true, error: this.props.getFieldError("Java.Certificate.Variable") })
                : React.createElement(VariableLookupText_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Java.Certificate.Variable") }),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                    var _a;
                }, label: "Keystore filename", error: this.props.getFieldError("Java.Certificate.KeystoreFilename") }),
            React.createElement(Note_1.default, null, this.props.keystoreFilenameMessage),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                    var _a;
                }, label: "Private key password" }),
            React.createElement(Note_1.default, null,
                "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password of ",
                React.createElement("em", null, "changeit"),
                " will be used."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                    var _a;
                }, label: "Keystore alias" }),
            React.createElement(Note_1.default, null,
                "The optional alias to assign the private key to. If left blank, the default alias of ",
                React.createElement("em", null, "Octopus"),
                " will be used"));
    };
    return JavaKeystoreComponent;
}(BaseComponent_1.BaseComponent));
exports.default = JavaKeystoreComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Validators_1 = __webpack_require__(199);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var styles = __webpack_require__(2096);
var Sensitive_1 = __webpack_require__(93);
var TomcatFeatureTemplate = (function (_super) {
    __extends(TomcatFeatureTemplate, _super);
    function TomcatFeatureTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TomcatFeatureTemplate.prototype.deploymentSummary = function () {
        var properties = this.props.properties;
        if (properties["Tomcat.Deploy.Name"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploying the package to the ",
                React.createElement("strong", null, this.props.properties["Tomcat.Deploy.Name"]),
                " context in a ",
                this.props.properties["Tomcat.Deploy.Enabled"] === "True" ? "started" : "stopped",
                " state",
                properties["Tomcat.Deploy.Version"] &&
                    React.createElement("span", null,
                        "\u00A0with the version ",
                        React.createElement("strong", null, properties["Tomcat.Deploy.Version"]))));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Specify the Tomcat deployment context and optionally the version"));
    };
    TomcatFeatureTemplate.prototype.tomcatSummary = function () {
        var properties = this.props.properties;
        if (properties["Tomcat.Deploy.Controller"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("span", null,
                    "Deploying to Tomcat Manager hosted at ",
                    React.createElement("strong", null, properties["Tomcat.Deploy.Controller"])),
                properties["Tomcat.Deploy.User"] &&
                    React.createElement("span", null,
                        "\u00A0with the user ",
                        React.createElement("strong", null, properties["Tomcat.Deploy.User"]))));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Specify the Tomcat manager URL, credentials and the state of the application"));
    };
    TomcatFeatureTemplate.prototype.componentDidMount = function () {
        var properties = {};
        if (!this.props.properties["Tomcat.Deploy.Controller"]) {
            properties["Tomcat.Deploy.Controller"] = "http://localhost:8080/manager";
        }
        if (!this.props.properties["Tomcat.Deploy.Enabled"]) {
            properties["Tomcat.Deploy.Enabled"] = "True";
        }
        this.props.setProperties(properties, true);
    };
    TomcatFeatureTemplate.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Tomcat.Deploy.Controller|Tomcat.Deploy.User|Tomcat.Deploy.Password", isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat Details", summary: this.tomcatSummary(), help: "Specify the Tomcat manager URL and credentials." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Controller"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Controller"] = x, _a));
                        var _a;
                    }, label: "Tomcat Manager URL", validate: Validators_1.required("Please enter a Tomcat Manager URL"), error: this.props.getFieldError("Tomcat.Deploy.Controller") }),
                React.createElement(Note_1.default, null,
                    "This is the URL of the Tomcat Manager instance that the package will be uploaded to. This URL is relative to the host that is executing the step. So if the Tentacle is on the same host as Tomcat, then this value may be something like ",
                    React.createElement("em", null, "http://localhost:8080/manager"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.User"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.User"] = x, _a));
                        var _a;
                    }, label: "Management user", validate: Validators_1.required("Please enter a Tomcat Manager user"), error: this.props.getFieldError("Tomcat.Deploy.User") }),
                React.createElement(Note_1.default, null,
                    "The username to use with the management interface. This user must be assigned to the ",
                    React.createElement("em", null, "manager-script"),
                    " group in the ",
                    React.createElement("em", null, "tomcat-users.xml"),
                    " file."),
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Tomcat.Deploy.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Password"] = x, _a));
                        var _a;
                    }, label: "Management password", error: this.props.getFieldError("Tomcat.Deploy.Password") }),
                React.createElement(Note_1.default, null, "The password to use with the management interface.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Tomcat.Deploy.Name|Tomcat.Deploy.Version|Tomcat.Deploy.Enabled", isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat Deployment", summary: this.deploymentSummary(), help: "Specify the Tomcat deployment context, optionally the version and the state of the application." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Name"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Name"] = x, _a));
                        var _a;
                    }, label: "Context path", error: this.props.getFieldError("Tomcat.Deploy.Name") }),
                React.createElement(Note_1.default, null,
                    "This field defines the context path of the deployed artifact. For example, setting this field to ",
                    React.createElement("em", null, "myapp"),
                    " will result in the deployment being having the context path ",
                    React.createElement("em", null, "/myapp"),
                    " in Tomcat. Set the value to ",
                    React.createElement("em", null, "/"),
                    " to deploy to the root context."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Deploy.Version"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Version"] = x, _a));
                        var _a;
                    }, label: "Deployment version" }),
                React.createElement(Note_1.default, null,
                    "Tomcat versions are used with ",
                    React.createElement("a", { href: "https://tomcat.apache.org/tomcat-8.0-doc/config/context.html#Parallel_deployment" }, "parallel deployments"),
                    ".",
                    React.createElement("p", null, "Leave this field blank to to leave the Tomcat version undefined, in which case you will overwrite any existing deployment with the same context path, and parallel deployments will not be enabled."),
                    React.createElement("p", null,
                        "Alternatively you can define a custom Tomcat version. Typically this Tomcat version will match the package version using the variable ",
                        React.createElement("span", { className: styles.nowrap },
                            React.createElement("em", null, "#{Octopus.Action.Package.NuGetPackageVersion}")),
                        ", or the release number with the variable ",
                        React.createElement("span", { className: styles.nowrap },
                            React.createElement("em", null, "#{Octopus.Release.Number}")),
                        ".")),
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "True", value: properties["Tomcat.Deploy.Enabled"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Deploy.Enabled"] = x, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Leave the application running", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Stop the application" }))));
    };
    return TomcatFeatureTemplate;
}(BaseComponent_1.BaseComponent));
exports.default = TomcatFeatureTemplate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\tomcatFeatureTemplate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\tomcatFeatureTemplate.tsx"); } } })();

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookup_1 = __webpack_require__(288);
var AutoComplete_1 = __webpack_require__(322);
var AutoCompleteWithInputRef = function (props) { return React.createElement(AutoComplete_1.default, __assign({}, props)); };
exports.VariableLookupAutoComplete = VariableLookup_1.withVariableLookup()(AutoCompleteWithInputRef);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookupAutoComplete.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableLookupAutoComplete.tsx"); } } })();

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var DialogOpener_1 = __webpack_require__(110);
var Summary_1 = __webpack_require__(44);
var ExpandableFormSection_1 = __webpack_require__(30);
var VariableLookupText_1 = __webpack_require__(21);
var index_1 = __webpack_require__(47);
var RemoveItemsList_1 = __webpack_require__(84);
var lodash_1 = __webpack_require__(11);
var servicePortDialog_1 = __webpack_require__(2110);
var index_2 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var jsonUtils_1 = __webpack_require__(106);
var Note_1 = __webpack_require__(20);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var _ = __webpack_require__(11);
var ExternalLink_1 = __webpack_require__(26);
var ServicePortList = (function (_super) {
    __extends(ServicePortList, _super);
    function ServicePortList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ServicePortList;
}(RemoveItemsList_1.RemoveItemsList));
var KubernetesServiceComponent = (function (_super) {
    __extends(KubernetesServiceComponent, _super);
    function KubernetesServiceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.addServicePortBinding = function () {
            var binding = {
                name: "",
                port: "",
                targetPort: "",
                nodePort: "",
                protocol: "TCP"
            };
            _this.setState({
                editServicePortBinding: binding,
                editServicePortBindingIndex: null
            });
        };
        _this.editServicePortBinding = function (binding) {
            _this.setState({
                editServicePortBinding: lodash_1.clone(binding),
                editServicePortBindingIndex: _this.state.servicePortBindings.indexOf(binding)
            });
        };
        _this.removeServicePortBinding = function (binding) {
            var bindings = _this.state.servicePortBindings.slice();
            bindings.splice(_this.state.servicePortBindings.indexOf(binding), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServicePorts"] = JSON.stringify(bindings), _a));
            var _a;
        };
        _this.resetSelectedBinding = function () {
            _this.setState({
                editServicePortBinding: null,
                editServicePortBindingIndex: null
            });
        };
        _this.saveServicePortBinding = function (binding) {
            var bindings = _this.state.servicePortBindings.slice();
            if (_this.state.editServicePortBindingIndex === null) {
                bindings.push(binding);
            }
            else {
                bindings[_this.state.editServicePortBindingIndex] = binding;
            }
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServicePorts"] = JSON.stringify(bindings), _a));
            _this.resetSelectedBinding();
            return true;
            var _a;
        };
        _this.state = {
            servicePortBindings: [],
            editServicePortBinding: null,
            editServicePortBindingIndex: null,
        };
        return _this;
    }
    KubernetesServiceComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    servicePortBindings: jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.ServicePorts"], [])
                });
                if (!this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"]) {
                    this.props.setProperties({ "Octopus.Action.KubernetesContainers.ServiceType": "NodePort" });
                }
                return [2 /*return*/];
            });
        }); });
    };
    KubernetesServiceComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.KubernetesContainers.ServicePorts"] !==
            nextProps.properties["Octopus.Action.KubernetesContainers.ServicePorts"]) {
            this.setState({ servicePortBindings: jsonUtils_1.JsonUtils.tryParseArray(nextProps.properties["Octopus.Action.KubernetesContainers.ServicePorts"], []) });
        }
    };
    KubernetesServiceComponent.prototype.render = function () {
        var _this = this;
        var editBindingDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editServicePortBinding, onClose: this.resetSelectedBinding },
            React.createElement(servicePortDialog_1.default, { servicePort: this.state.editServicePortBinding, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, onAdd: function (item) { return _this.saveServicePortBinding(item); }, serviceType: this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"], containers: jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.Containers"], []) }));
        return React.createElement("div", null,
            editBindingDialog,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.ServiceName", isExpandedByDefault: this.props.expandedByDefault, title: "Service Name", summary: this.nameSummary(), help: "Enter the service exposing the deployment." },
                React.createElement(Note_1.default, null, "The unique name of the Kubernetes service resource."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#service-name" }, "service name"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.ServiceName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServiceName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.ServiceName"), label: "Service name" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.ServiceType", isExpandedByDefault: this.props.expandedByDefault, title: "Service Type", summary: this.typeSummary(), help: "Select the service type." },
                React.createElement(index_2.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServiceType"] = x, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "ClusterIP", label: "Cluster IP" }),
                    React.createElement(Note_1.default, null, "The cluster IP service resource is accessible to other resources in the Kubernetes cluster."),
                    React.createElement(Note_1.default, null,
                        "Learn more about ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#cluster-ip" }, "cluster IP services"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: "NodePort", label: "Node port" }),
                    React.createElement(Note_1.default, null, "The node port service resource is accessible to other resources in the Kubernetes cluster, and also via ports exposed on the Kubernetes nodes."),
                    React.createElement(Note_1.default, null,
                        "Learn more about ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#node-port" }, "node port services"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: "LoadBalancer", label: "Load balancer" }),
                    React.createElement(Note_1.default, null, "The load balancer service resource is accessible to other resources in the Kubernetes cluster, also via ports exposed on the Kubernetes nodes, and also through an external load balancer device."),
                    React.createElement(Note_1.default, null,
                        "Learn more about ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#load-balancer" }, "load balancer services"),
                        ".")),
                this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"] === "LoadBalancer" &&
                    React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("strong", null, "Annotations"),
                            React.createElement("br", null),
                            "Add annotations to configure the load balancer."),
                        React.createElement(ExtendedKeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.LoadBalancerAnnotations"], name: "Annotation", onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.LoadBalancerAnnotations"] = x, _a));
                                var _a;
                            }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.ServiceClusterIp"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServiceClusterIp"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.ServiceClusterIp"), label: "Cluster IP address" }),
                React.createElement(Note_1.default, null, "An optional value that defines the internal IP address of the service. If left blank, Kubernetes will assign a private IP address to the service."),
                this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"] === "LoadBalancer" &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.ServiceLoadBalancerIp"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ServiceLoadBalancerIp"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.ServiceLoadBalancerIp"), label: "Load balancer IP address" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.ServicePorts", isExpandedByDefault: this.props.expandedByDefault, title: "Service Ports", summary: this.labelsSummary(), help: "Add service ports that are exposed by the service." },
                React.createElement(Note_1.default, null, "Ports must be configured with the ports that the service exposes, and the port that the service directs traffic to."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#ports-1" }, "ports"),
                    "."),
                React.createElement(ServicePortList, { listActions: [React.createElement(index_1.default, { key: "add", label: "Add Port", onClick: function () { return _this.addServicePortBinding(); } })], data: this.state.servicePortBindings, onRow: function (binding) { return React.createElement("div", null,
                        binding.name && React.createElement("p", null,
                            "Name: ",
                            React.createElement("strong", null, binding.name)),
                        binding.port && React.createElement("p", null,
                            "Port: ",
                            React.createElement("strong", null, binding.port)),
                        binding.targetPort ? React.createElement("p", null,
                            "Target Port: ",
                            React.createElement("strong", null, binding.targetPort)) : React.createElement("p", null, "Target Port: Same as Port"),
                        binding.nodePort ? React.createElement("p", null,
                            "Node Port: ",
                            React.createElement("strong", null, binding.nodePort)) : React.createElement("p", null, "Node Port: Automatically assigned"),
                        binding.protocol && React.createElement("p", null,
                            "Protocol: ",
                            React.createElement("strong", null, binding.protocol))); }, onRowTouch: function (binding) { return _this.editServicePortBinding(binding); }, onRemoveRow: function (binding) { return _this.removeServicePortBinding(binding); } })));
    };
    KubernetesServiceComponent.prototype.nameSummary = function () {
        if (!this.props.properties["Octopus.Action.KubernetesContainers.ServiceName"]) {
            return Summary_1.default.placeholder("No name has been provided");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Create a service resource called ",
            React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.ServiceName"])));
    };
    KubernetesServiceComponent.prototype.typeSummary = function () {
        return Summary_1.default.summary(React.createElement("span", null,
            "Create a ",
            React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.ServiceType"]),
            " service",
            this.props.properties["Octopus.Action.KubernetesContainers.ServiceClusterIp"]
                ? React.createElement("span", null,
                    " with the cluster IP address ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.ServiceClusterIp"]))
                : React.createElement("span", null, " with an automatically assigned cluster IP address"),
            this.props.properties["Octopus.Action.KubernetesContainers.ServiceLoadBalancerIp"] &&
                React.createElement("span", null,
                    " with the load balancer IP address ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.ServiceLoadBalancerIp"]))));
    };
    KubernetesServiceComponent.prototype.labelsSummary = function () {
        var ports = jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.ServicePorts"], []);
        if (ports.length === 0) {
            return Summary_1.default.placeholder("No ports have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Exposing port",
            ports.length > 1 && React.createElement("span", null, "s"),
            ": ",
            _.chain(ports)
                .flatMap(function (port) { return _.chain(_.toPairs(port))
                .filter(function (pair) { return pair[1]; })
                .flatMap(function (pair) { return [React.createElement("span", null,
                    pair[0].replace(/([A-Z])/g, " $1").toLowerCase(),
                    " ",
                    React.createElement("strong", null, pair[1])), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value().concat([React.createElement("span", null, "; ")]); })
                .slice(0, -1)
                .value()));
    };
    return KubernetesServiceComponent;
}(BaseComponent_1.BaseComponent));
exports.KubernetesServiceComponent = KubernetesServiceComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesServiceComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesServiceComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveItemsList_1 = __webpack_require__(84);
var BaseComponent_1 = __webpack_require__(12);
var jsonUtils_1 = __webpack_require__(106);
var DialogOpener_1 = __webpack_require__(110);
var ingressRuleDialog_1 = __webpack_require__(2112);
var ExpandableFormSection_1 = __webpack_require__(30);
var VariableLookupText_1 = __webpack_require__(21);
var Button_1 = __webpack_require__(47);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var Note_1 = __webpack_require__(20);
var lodash_1 = __webpack_require__(11);
var Summary_1 = __webpack_require__(44);
var ingressAnnotationsSuggestions_1 = __webpack_require__(2113);
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var ExternalLink_1 = __webpack_require__(26);
var IngressList = (function (_super) {
    __extends(IngressList, _super);
    function IngressList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IngressList;
}(RemoveItemsList_1.RemoveItemsList));
var KubernetesIngressComponent = (function (_super) {
    __extends(KubernetesIngressComponent, _super);
    function KubernetesIngressComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.addIngressRule = function () {
            var binding = {
                host: "",
                http: { paths: [] },
            };
            _this.setState({
                editIngressRule: binding,
                editIngressRuleIndex: null
            });
        };
        _this.editIngressRule = function (binding) {
            _this.setState({
                editIngressRule: lodash_1.clone(binding),
                editIngressRuleIndex: _this.state.ingressRules.indexOf(binding)
            });
        };
        _this.removeIngressRule = function (binding) {
            var bindings = _this.state.ingressRules.slice();
            bindings.splice(_this.state.ingressRules.indexOf(binding), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.IngressRules"] = JSON.stringify(bindings), _a));
            var _a;
        };
        _this.resetIngressRule = function () {
            _this.setState({
                editIngressRule: null,
                editIngressRuleIndex: null
            });
        };
        _this.saveIngressRule = function (binding) {
            var bindings = _this.state.ingressRules.slice();
            if (_this.state.editIngressRuleIndex === null) {
                bindings.push(binding);
            }
            else {
                bindings[_this.state.editIngressRuleIndex] = binding;
            }
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.IngressRules"] = JSON.stringify(bindings), _a));
            _this.resetIngressRule();
            return true;
            var _a;
        };
        _this.getIngressAnnotations = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(ingressAnnotationsSuggestions_1.IngressAnnotations)
                    .filter(function (v) { return !!v; })
                    .filter(function (v) { return v.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f, Name: f }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        _this.state = {
            ingressRules: [],
            editIngressRule: null,
            editIngressRuleIndex: null
        };
        return _this;
    }
    KubernetesIngressComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                this.setState({
                    ingressRules: jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.IngressRules"], [])
                });
                // Sanitise the ingress list, which might have been an object before the input control was switched
                if (jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.IngressAnnotations"], []).length === 0) {
                    this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.IngressAnnotations"] = "[]", _a), true);
                }
                return [2 /*return*/];
            });
        }); });
    };
    KubernetesIngressComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.KubernetesContainers.IngressRules"] !==
            nextProps.properties["Octopus.Action.KubernetesContainers.IngressRules"]) {
            this.setState({ ingressRules: jsonUtils_1.JsonUtils.tryParseArray(nextProps.properties["Octopus.Action.KubernetesContainers.IngressRules"], []) });
        }
    };
    KubernetesIngressComponent.prototype.render = function () {
        var _this = this;
        var editIngressDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editIngressRule, onClose: this.resetIngressRule },
            React.createElement(ingressRuleDialog_1.default, { ingressRule: this.state.editIngressRule, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, onAdd: function (item) { return _this.saveIngressRule(item); }, servicePorts: jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.ServicePorts"], []), standAlone: this.props.standAlone }));
        return React.createElement("div", null,
            editIngressDialog,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.IngressName", isExpandedByDefault: this.props.expandedByDefault, title: "Ingress Name", summary: this.ingressSummary(), help: "Enter the service name exposing the deployment." },
                React.createElement(Note_1.default, null, "The name of the ingress resource."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#ingress-name" }, "ingress name"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.IngressName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.IngressName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.IngressName"), label: "Ingress name" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.IngressAnnotations", isExpandedByDefault: this.props.expandedByDefault, title: "Ingress Annotations", summary: this.ingressAnnotationsSummary(), help: "Add annotations to configure the ingress controller." },
                React.createElement(Note_1.default, null, "Ingress annotations can be specific to the type of ingress controller used by the Kubernetes cluster, and the suggested annotation keys are not exhaustive."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#ingress-annotations" }, "ingress annotations"),
                    "."),
                React.createElement(ExtendedKeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.IngressAnnotations"], name: "Annotation", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.IngressAnnotations"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", getOptions: this.getIngressAnnotations, hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.IngressRules", isExpandedByDefault: this.props.expandedByDefault, title: "Ingress Host Rules", summary: this.ingressRulesSummary(), help: "Add rules to be applied to hosts." },
                React.createElement(Note_1.default, null, "Host rules map incoming requests by their host name and path to ports exposed by the service resource."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#ingress-host-rules" }, "ingress host rules"),
                    "."),
                React.createElement(IngressList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add Host Rule", onClick: function () { return _this.addIngressRule(); } })], data: this.state.ingressRules, onRow: function (binding) { return React.createElement("div", null, binding.http.paths
                        ? React.createElement("div", null,
                            React.createElement("ul", null, binding.http.paths.map(function (path) {
                                return React.createElement("li", null,
                                    React.createElement("strong", null,
                                        binding.host || "*",
                                        path.key),
                                    "\u00A0=>\u00A0",
                                    React.createElement("strong", null,
                                        _this.props.standAlone
                                            ? React.createElement("span", null, path.option)
                                            : React.createElement("span", null, _this.props.properties["Octopus.Action.KubernetesContainers.ServiceName"]),
                                        ":",
                                        path.value));
                            })))
                        : React.createElement("div", null, "No paths defined")); }, onRowTouch: function (binding) { return _this.editIngressRule(binding); }, onRemoveRow: function (binding) { return _this.removeIngressRule(binding); } })));
    };
    KubernetesIngressComponent.prototype.ingressRulesSummary = function () {
        var rules = jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.IngressRules"], []);
        if (rules.length === 0) {
            return Summary_1.default.placeholder("No host rules have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the rule",
            rules.length > 1 && React.createElement("span", null, "s"),
            ": ",
            _.chain(rules)
                .flatMap(function (rule) { return _.chain(rule.http.paths)
                .flatMap(function (pair) { return [React.createElement("span", null,
                    React.createElement("strong", null,
                        rule.host || "*",
                        pair.key),
                    " => ",
                    React.createElement("strong", null, pair.value)), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value().concat([
                React.createElement("span", null, "; ")
            ]); })
                .slice(0, -1)
                .value()));
    };
    KubernetesIngressComponent.prototype.ingressAnnotationsSummary = function () {
        var annotations = jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.IngressAnnotations"], []);
        if (annotations.length === 0) {
            return Summary_1.default.placeholder("No annotations have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the annotation",
            annotations.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(annotations)
                .flatMap(function (annotation) { return [React.createElement("strong", null,
                    annotation.key,
                    ": ",
                    annotation.value), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    KubernetesIngressComponent.prototype.ingressSummary = function () {
        if (!(this.props.properties["Octopus.Action.KubernetesContainers.IngressName"])) {
            return Summary_1.default.placeholder("No name has been provided");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Create an ingress called ",
            React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.IngressName"])));
    };
    return KubernetesIngressComponent;
}(BaseComponent_1.BaseComponent));
exports.KubernetesIngressComponent = KubernetesIngressComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesIngressComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesIngressComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var ExpandableFormSection_1 = __webpack_require__(30);
var React = __webpack_require__(0);
var Summary_1 = __webpack_require__(44);
var VariableLookupText_1 = __webpack_require__(21);
var KeyValueEditList_1 = __webpack_require__(87);
var ScriptPackageReferenceDialog_1 = __webpack_require__(428);
var _ = __webpack_require__(11);
var DialogOpener_1 = __webpack_require__(110);
var resources_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var jsonUtils_1 = __webpack_require__(106);
var KubernetesConfigMapComponent = (function (_super) {
    __extends(KubernetesConfigMapComponent, _super);
    function KubernetesConfigMapComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.resetSelectedPackageReference = function () {
            _this.setState({
                editPackageReference: null,
                editPackageReferenceIndex: null
            });
        };
        _this.packageVariableNames = function () {
            return _.flatten(resources_1.GetNamedPackageReferences(_this.props.packages)
                .map(function (pkg) { return [
                "Octopus.Action.Package[" + pkg.Name + "].PackageId",
                "Octopus.Action.Package[" + pkg.Name + "].FeedId",
                "Octopus.Action.Package[" + pkg.Name + "].PackageVersion",
                "Octopus.Action.Package[" + pkg.Name + "].Path"
            ]; }));
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            originalCanRunBeforeAcquisition: false,
            originalStepPackageRequirement: resources_1.PackageRequirement.LetOctopusDecide,
            editPackageReference: null,
            editPackageReferenceIndex: null
        };
        return _this;
    }
    KubernetesConfigMapComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KubernetesConfigMapComponent.prototype.render = function () {
        var _this = this;
        var localNames = _.concat(this.props.localNames ? this.props.localNames : [], this.packageVariableNames());
        var editPackageReferenceDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editPackageReference, onClose: this.resetSelectedPackageReference },
            React.createElement(ScriptPackageReferenceDialog_1.ScriptPackageReferenceDialog, { packageReference: this.state.editPackageReference, runOn: this.props.runOn, feeds: this.state.feeds, localNames: localNames, projectId: this.props.projectId, onChange: function (packageReference) { return _this.savePackageReference(packageReference); }, refreshFeeds: this.loadFeeds }));
        return React.createElement("div", null,
            editPackageReferenceDialog,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.ConfigMapName", isExpandedByDefault: this.props.expandedByDefault, title: "Config Map Name", summary: this.configMapSummary(), help: "The name of the config map resource" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.ConfigMapName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ConfigMapName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.ConfigMapName"), label: "Config Map name" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.ConfigMapValues", isExpandedByDefault: this.props.expandedByDefault, title: "Config Map Items", summary: this.configMapLiteralSummary(), help: "The config map resource values" },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.ConfigMapValues"], name: "Config map item", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ConfigMapValues"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesConfigMapComponent.prototype.savePackageReference = function (packageReference) {
        var packageReferences = this.props.packages.slice();
        if (this.state.editPackageReferenceIndex === null) {
            packageReferences.push(packageReference);
        }
        else {
            packageReferences[this.state.editPackageReferenceIndex] = packageReference;
        }
        this.props.setPackages(packageReferences);
        this.resetSelectedPackageReference();
        return true;
    };
    KubernetesConfigMapComponent.prototype.configMapSummary = function () {
        if (this.props.properties["Octopus.Action.KubernetesContainers.ConfigMapName"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Create a config map called ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.ConfigMapName"])));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the config map name"));
    };
    KubernetesConfigMapComponent.prototype.configMapLiteralSummary = function () {
        var items = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.ConfigMapValues"], {}));
        if (items.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                React.createElement("span", null, "Create a config map with the values "),
                _.chain(items)
                    .flatMap(function (item) { return [React.createElement("strong", null,
                        item[0],
                        ": ",
                        item[1]), React.createElement("span", null, ", ")]; })
                    .slice(0, -1)
                    .value()));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the config map values"));
    };
    return KubernetesConfigMapComponent;
}(BaseComponent_1.BaseComponent));
exports.KubernetesConfigMapComponent = KubernetesConfigMapComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesConfigMapComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesConfigMapComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var ExpandableFormSection_1 = __webpack_require__(30);
var React = __webpack_require__(0);
var Summary_1 = __webpack_require__(44);
var VariableLookupText_1 = __webpack_require__(21);
var KeyValueEditList_1 = __webpack_require__(87);
var ScriptPackageReferenceDialog_1 = __webpack_require__(428);
var _ = __webpack_require__(11);
var DialogOpener_1 = __webpack_require__(110);
var resources_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var jsonUtils_1 = __webpack_require__(106);
var KubernetesSecretComponent = (function (_super) {
    __extends(KubernetesSecretComponent, _super);
    function KubernetesSecretComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.resetSelectedPackageReference = function () {
            _this.setState({
                editPackageReference: null,
                editPackageReferenceIndex: null
            });
        };
        _this.packageVariableNames = function () {
            return _.flatten(resources_1.GetNamedPackageReferences(_this.props.packages)
                .map(function (pkg) { return [
                "Octopus.Action.Package[" + pkg.Name + "].PackageId",
                "Octopus.Action.Package[" + pkg.Name + "].FeedId",
                "Octopus.Action.Package[" + pkg.Name + "].PackageVersion",
                "Octopus.Action.Package[" + pkg.Name + "].Path"
            ]; }));
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            originalCanRunBeforeAcquisition: false,
            originalStepPackageRequirement: resources_1.PackageRequirement.LetOctopusDecide,
            editPackageReference: null,
            editPackageReferenceIndex: null
        };
        return _this;
    }
    KubernetesSecretComponent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KubernetesSecretComponent.prototype.render = function () {
        var _this = this;
        var localNames = _.concat(this.props.localNames ? this.props.localNames : [], this.packageVariableNames());
        var editPackageReferenceDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editPackageReference, onClose: this.resetSelectedPackageReference },
            React.createElement(ScriptPackageReferenceDialog_1.ScriptPackageReferenceDialog, { packageReference: this.state.editPackageReference, runOn: this.props.runOn, feeds: this.state.feeds, localNames: localNames, projectId: this.props.projectId, onChange: function (packageReference) { return _this.savePackageReference(packageReference); }, refreshFeeds: this.loadFeeds }));
        return React.createElement("div", null,
            editPackageReferenceDialog,
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.SecretName", isExpandedByDefault: this.props.expandedByDefault, title: "Secret Name", summary: this.secretSummary(), help: "The name of the secret resource" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.SecretName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.SecretName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.SecretName"), label: "Secret name" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.SecretValues", isExpandedByDefault: this.props.expandedByDefault, title: "Secret Items", summary: this.secretValuesSummary(), help: "The secret resource values" },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.SecretValues"], name: "Secret Item", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.SecretValues"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesSecretComponent.prototype.savePackageReference = function (packageReference) {
        var packageReferences = this.props.packages.slice();
        if (this.state.editPackageReferenceIndex === null) {
            packageReferences.push(packageReference);
        }
        else {
            packageReferences[this.state.editPackageReferenceIndex] = packageReference;
        }
        this.props.setPackages(packageReferences);
        this.resetSelectedPackageReference();
        return true;
    };
    KubernetesSecretComponent.prototype.secretSummary = function () {
        if (this.props.properties["Octopus.Action.KubernetesContainers.SecretName"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Create a secret called ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.SecretName"])));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the secret name"));
    };
    KubernetesSecretComponent.prototype.secretValuesSummary = function () {
        var items = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.SecretValues"], {}));
        if (items.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                React.createElement("span", null, "Create a secret with the values "),
                _.chain(items)
                    .flatMap(function (item) { return [React.createElement("strong", null,
                        item[0],
                        ": ",
                        item[1]), React.createElement("span", null, ", ")]; })
                    .slice(0, -1)
                    .value()));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the secret values"));
    };
    return KubernetesSecretComponent;
}(BaseComponent_1.BaseComponent));
exports.KubernetesSecretComponent = KubernetesSecretComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesSecretComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesSecretComponent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Fragment_1 = __webpack_require__(92);
var getSummary = function (getProps) {
    var generatedNamed = getProps("Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName") === "True";
    return generatedNamed ?
        form_1.Summary.summary("Change sets will have automatically generated names") :
        form_1.Summary.summary(React.createElement("span", null,
            "Change set named ",
            getProps("Octopus.Action.Aws.CloudFormation.ChangeSet.Name")));
};
var CloudFormationChangesetFeature = (function (_super) {
    __extends(CloudFormationChangesetFeature, _super);
    function CloudFormationChangesetFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloudFormationChangesetFeature.prototype.componentDidMount = function () {
        if (!this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName"]) {
            this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName": "True" });
        }
        if (!this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Defer"]) {
            this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.ChangeSet.Defer": "False" });
        }
    };
    CloudFormationChangesetFeature.prototype.render = function () {
        var _this = this;
        return React.createElement(form_1.ExpandableFormSection, { summary: getSummary(function (prop) { return _this.props.properties[prop]; }), title: "Change Sets", errorKey: "Changesets", isExpandedByDefault: this.props.expandedByDefault },
            React.createElement(form_1.StringCheckbox, { label: "Automatically Generate Change Set Name", value: this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName"], onChange: function (val) { return _this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName": val }); } }),
            this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.GenerateName"] !== "True" && React.createElement(Fragment_1.Fragment, null,
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Changeset Name", error: this.props.getFieldError("Octopus.Action.Aws.CloudFormation.ChangeSet.Name"), value: this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Name"], onChange: function (val) { return _this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.ChangeSet.Name": val }); } }),
                React.createElement(form_1.Note, null, "Please note that change sets must be unique for a given stack.")),
            React.createElement(form_1.StringCheckbox, { label: "Defer Change Set Execution", value: this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Defer"], onChange: function (val) { return _this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.ChangeSet.Defer": val }); } }));
    };
    return CloudFormationChangesetFeature;
}(BaseComponent_1.BaseComponent));
exports.default = function () { return ({
    featureName: "Octopus.Features.CloudFormation.ChangeSet.Feature",
    title: "CloudFormation Change Sets",
    description: "Use Cloud Formation Change sets when updating or creating stacks.",
    edit: CloudFormationChangesetFeature,
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.Aws.CloudFormation.ChangeSet.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    },
    priority: 1
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsCloudFormationChangesetFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsCloudFormationChangesetFeature.tsx"); } } })();

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(2127);
__webpack_require__(2128);
__webpack_require__(2129);
__webpack_require__(2130);
__webpack_require__(2131);
__webpack_require__(2132);
__webpack_require__(2137);
__webpack_require__(2138);
__webpack_require__(2139);
__webpack_require__(2140);
__webpack_require__(2141);
__webpack_require__(2142);
__webpack_require__(2143);
__webpack_require__(2144);
__webpack_require__(2145);
__webpack_require__(2146);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\index.ts"); } } })();

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Panel_1 = __webpack_require__(1821);
var styles = __webpack_require__(713);
var cn = __webpack_require__(19);
var OnboardingPage = (function (_super) {
    __extends(OnboardingPage, _super);
    function OnboardingPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnboardingPage.prototype.render = function () {
        var props = this.props;
        return React.createElement("div", { className: styles.onboardingOuterContainer },
            React.createElement("div", { className: cn(styles.onboardingContainer) },
                React.createElement("div", { className: styles.title },
                    React.createElement("h2", null, props.title),
                    props.intro && React.createElement("p", null, props.intro)),
                React.createElement("div", { className: styles.panels }, props.panels.map(function (panel) {
                    return React.createElement(Panel_1.default, { key: panel.imageSrc, description: panel.description, imageSrc: panel.imageSrc, imageWidth: panel.imageWidth, imageHeight: panel.imageHeight, imageAlt: panel.imageAlt, className: styles.onboardingBlurred });
                })),
                React.createElement("div", { className: styles.onboardingCreateFirst },
                    props.customNavigation,
                    props.learnMore)));
    };
    return OnboardingPage;
}(React.Component));
exports.default = OnboardingPage;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\OnboardingPage.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\OnboardingPage.tsx"); } } })();

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["Pending"] = "Pending";
    ActivityStatus["Running"] = "Running";
    ActivityStatus["Success"] = "Success";
    ActivityStatus["Failed"] = "Failed";
    ActivityStatus["Skipped"] = "Skipped";
    ActivityStatus["SuccessWithWarning"] = "SuccessWithWarning";
    ActivityStatus["Canceled"] = "Canceled";
})(ActivityStatus = exports.ActivityStatus || (exports.ActivityStatus = {}));
var ActivityLogEntryCategory;
(function (ActivityLogEntryCategory) {
    ActivityLogEntryCategory["Trace"] = "Trace";
    ActivityLogEntryCategory["Verbose"] = "Verbose";
    ActivityLogEntryCategory["Info"] = "Info";
    ActivityLogEntryCategory["Highlight"] = "Highlight";
    ActivityLogEntryCategory["Wait"] = "Wait";
    ActivityLogEntryCategory["Gap"] = "Gap";
    ActivityLogEntryCategory["Alert"] = "Alert";
    ActivityLogEntryCategory["Warning"] = "Warning";
    ActivityLogEntryCategory["Error"] = "Error";
    ActivityLogEntryCategory["Fatal"] = "Fatal";
    ActivityLogEntryCategory["Planned"] = "Planned";
    ActivityLogEntryCategory["Updated"] = "Updated";
    ActivityLogEntryCategory["Finished"] = "Finished";
    ActivityLogEntryCategory["Abandoned"] = "Abandoned";
})(ActivityLogEntryCategory = exports.ActivityLogEntryCategory || (exports.ActivityLogEntryCategory = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskDetailsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\taskDetailsResource.ts"); } } })();

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableBody = (function (_super) {
    __extends(DataTableBody, _super);
    function DataTableBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableBody.prototype.render = function () {
        return (React.createElement("tbody", { className: cn(this.props.className, styles.dataTableBody) }, this.props.children));
    };
    return DataTableBody;
}(React.Component));
exports.DataTableBody = DataTableBody;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableBody.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableBody.tsx"); } } })();

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableRow = (function (_super) {
    __extends(DataTableRow, _super);
    function DataTableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableRow.prototype.render = function () {
        var _a = this.props, displayNoBorder = _a.displayNoBorder, className = _a.className, otherProps = __rest(_a, ["displayNoBorder", "className"]);
        return (React.createElement("tr", __assign({}, otherProps, { className: cn(className, styles.dataTableRow, displayNoBorder ? styles.noBorder : "") }), this.props.children));
    };
    return DataTableRow;
}(React.Component));
exports.DataTableRow = DataTableRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRow.tsx"); } } })();

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableRowColumn = function (props) {
    var className = props.className, fullWidth = props.fullWidth, fullHeight = props.fullHeight, otherProps = __rest(props, ["className", "fullWidth", "fullHeight"]);
    var style = {};
    if (fullHeight) {
        style.paddingBottom = 0;
        style.paddingTop = 0;
    }
    if (fullWidth) {
        style.paddingRight = 0;
        style.paddingLeft = 0;
    }
    return (React.createElement("td", __assign({}, otherProps, { style: style, className: cn(className, styles.dataTableRowColumn) }), props.children));
};
exports.DataTableRowColumn = DataTableRowColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRowColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRowColumn.tsx"); } } })();

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var AdvancedFilterLayout_1 = __webpack_require__(469);
__export(__webpack_require__(1572));
__export(__webpack_require__(811));
__export(__webpack_require__(469));
exports.default = AdvancedFilterLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\index.ts"); } } })();

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TenantMultiSelect_1 = __webpack_require__(481);
var TenantTagMultiSelect_1 = __webpack_require__(327);
var TenantTagDesignDialog_1 = __webpack_require__(1832);
var LabelStrategy_1 = __webpack_require__(167);
var AdvancedTenantSelector = function (props) {
    return React.createElement("div", null,
        props.showTenants && React.createElement(TenantMultiSelect_1.default, { value: props.selectedTenantIds, items: props.tenants, onChange: function (tenantIds) { return props.onChange(tenantIds, props.selectedTenantTags); } }),
        React.createElement(TenantTagMultiSelect_1.default, { value: props.selectedTenantTags, items: props.tagSets, onChange: function (includedTenantTags) { return props.onChange(props.selectedTenantIds, includedTenantTags); }, doBusyTask: props.doBusyTask }),
        React.createElement(LabelStrategy_1.ResetLabelStrategy, null,
            React.createElement(TenantTagDesignDialog_1.default, { selectedTags: props.selectedTenantTags, selectedTenants: props.selectedTenantIds, showTenants: props.showTenants, availableTenants: props.tenants ? props.tenants.map(function (t) { return t.Id; }) : null, onUpdate: function (selectedTenants, selectedTags) { return props.onChange(selectedTenants, selectedTags); } })));
};
exports.AdvancedTenantsAndTenantTagsSelector = function (props) {
    return React.createElement(AdvancedTenantSelector, { selectedTenantIds: props.selectedTenantIds, showTenants: true, tenants: props.tenants, selectedTenantTags: props.selectedTenantTags, onChange: props.onChange, doBusyTask: props.doBusyTask });
};
exports.AdvancedTenantTagsSelector = function (props) {
    return React.createElement(AdvancedTenantSelector, { tagSets: props.tagSets, selectedTenantIds: [], showTenants: false, tenants: null, selectedTenantTags: props.selectedTenantTags, onChange: function (tenants, tags) { return props.onChange(tags); }, doBusyTask: props.doBusyTask });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedTenantSelector\\AdvancedTenantSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedTenantSelector\\AdvancedTenantSelector.tsx"); } } })();

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTable = (function (_super) {
    __extends(DataTable, _super);
    function DataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTable.prototype.render = function () {
        return (React.createElement("table", { className: cn(this.props.className, styles.dataTable) }, this.props.children));
    };
    return DataTable;
}(React.Component));
exports.DataTable = DataTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTable.tsx"); } } })();

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dnd_1 = __webpack_require__(454);
var react_dnd_html5_backend_1 = __webpack_require__(805);
var SortableItem_1 = __webpack_require__(1901);
var SortableList = (function (_super) {
    __extends(SortableList, _super);
    function SortableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemMoved = function (dragIndex, hoverIndex) {
            var orderedItems = _this.props.items.slice();
            var dragItem = orderedItems[dragIndex];
            orderedItems.splice(dragIndex, 1);
            orderedItems.splice(hoverIndex, 0, dragItem);
            _this.props.onOrderChanged(orderedItems);
        };
        return _this;
    }
    SortableList.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null, this.props.items.map(function (item, index) { return (React.createElement(SortableItem_1.default, { key: item.Id, index: index, id: item.Id, name: item.Name, onItemMoved: _this.itemMoved })); }));
    };
    return SortableList;
}(React.Component));
exports.default = react_dnd_1.DragDropContext(react_dnd_html5_backend_1.default)(SortableList);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SortableList\\SortableList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SortableList\\SortableList.tsx"); } } })();

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(119);
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.timestamp = function () {
        return Date.now().toString();
    };
    DateFormatter.dateToShortFormat = function (dateTime) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format("lll"); // Sep 11, 2018 1:02 PM
    };
    DateFormatter.dateToLongFormat = function (dateTime) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format("LLLL"); // Tuesday, September 11, 2018 1:02 PM
    };
    DateFormatter.dateToCustomFormat = function (dateTime, format) {
        if (!dateTime) {
            return null;
        }
        var dateMoment = moment(dateTime);
        return dateMoment.format(format);
    };
    DateFormatter.moment = function (input, format) {
        var when = new Date(Date.parse(input));
        var m = moment(when);
        format = format || "LLLL";
        var display = format === "ago" ? m.fromNow() : m.format(format);
        return display;
    };
    DateFormatter.momentAgo = function (input) {
        var when = new Date(Date.parse(input));
        return moment(when).fromNow();
    };
    DateFormatter.momentFrom = function (fromDate, toDate) {
        if (!fromDate) {
            return null;
        }
        var fromMoment = moment(fromDate);
        var toMoment = toDate ? moment(toDate) : moment();
        var diff = fromMoment.diff(toMoment);
        var duration = moment.duration(diff);
        var mins = duration.minutes();
        var hours = duration.hours();
        var days = Math.floor(duration.asDays());
        var result = (mins === 1 ? "1 minute" : mins + " minutes");
        result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
        result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
        return result;
    };
    return DateFormatter;
}());
exports.default = DateFormatter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DateFormatter\\DateFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DateFormatter\\DateFormatter.tsx"); } } })();

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OpenDialogMenuItem_1 = __webpack_require__(704);
exports.OpenDialogMenuItem = OpenDialogMenuItem_1.default;
var OpenDeleteDialogMenuItem_1 = __webpack_require__(705);
exports.OpenDeleteDialogMenuItem = OpenDeleteDialogMenuItem_1.default;
var OverflowMenu_1 = __webpack_require__(152);
exports.OverflowMenu = OverflowMenu_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\index.tsx"); } } })();

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Markdown_1 = __webpack_require__(132);
var PermissionCheck_1 = __webpack_require__(42);
var ReloadableRoute_1 = __webpack_require__(94);
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var MediaQuery = __webpack_require__(815);
var react_router_1 = __webpack_require__(76);
var uiTestClasses_1 = __webpack_require__(86);
var fontWeights_1 = __webpack_require__(83);
var ErrorBoundary_1 = __webpack_require__(267);
var Logo_1 = __webpack_require__(200);
var PriorityNavigation_1 = __webpack_require__(697);
var styles = __webpack_require__(1763);
var InternalNavLink_1 = __webpack_require__(248);
var Navigation = (function () {
    function Navigation() {
    }
    Navigation.navItem = function (label, path, exact, permission) {
        return !permission || PermissionCheck_1.isAllowed(permission) ? { label: label, path: path, exact: !!exact } : null;
    };
    Navigation.navGroup = function (label, path, children, permission) {
        return !permission || PermissionCheck_1.isAllowed(permission) ? { groupLabel: label, defaultChildPath: path, children: children } : null;
    };
    return Navigation;
}());
exports.Navigation = Navigation;
var screenMd = 1279;
var NavigationSidebarLayout = function (props) {
    // we HAVE to use the render prop format here, if we use multiple MediaQuery tags all the content
    // gets torn down and remounted at the mediaquery breakpoints, which means you loose all state.
    // the props.content needs to be the same "shape" with the same key too so that it is retained.
    // Test that form content isn't cleared if you change this.
    return React.createElement("div", null,
        React.createElement(MediaQuery, { minWidth: screenMd }, function (matches) {
            if (matches) {
                return React.createElement("div", { className: styles.sidebarLayout },
                    React.createElement("div", { className: styles.sideMenu },
                        props.logoUrl && React.createElement(Logo_1.default, { url: props.logoUrl, size: 100 / fontWeights_1.baseSizeInPx + "rem" }),
                        props.image && props.image,
                        props.name && React.createElement("div", { className: styles.name }, props.name),
                        props.preNavbarComponent && React.createElement("div", { className: styles.preNav }, props.preNavbarComponent),
                        React.createElement("nav", { className: uiTestClasses_1.navLinksClass + " " + styles.links }, props.navLinks.filter(function (x) { return !!x; }).map(function (link, index) { return React.createElement(NavItemComponent, { item: link, key: index }); })),
                        props.description && React.createElement("div", { className: styles.description },
                            React.createElement(Markdown_1.default, { markup: props.description }))),
                    React.createElement("div", { className: styles.sidebarLayoutContent, key: "content" }, content(props)));
            }
            else {
                return React.createElement("div", { className: styles.stackedLayout },
                    (props.logoUrl || props.name) &&
                        React.createElement("div", { className: styles.title },
                            props.logoUrl &&
                                React.createElement("div", { className: styles.logo },
                                    React.createElement(Logo_1.default, { size: 50 / fontWeights_1.baseSizeInPx + "rem", url: props.logoUrl })),
                            props.name && React.createElement("div", { className: styles.nameHorizontal }, props.name)),
                    props.preNavbarComponent && React.createElement("div", { className: styles.preNav }, props.preNavbarComponent),
                    React.createElement(PriorityNavigation_1.default, { className: uiTestClasses_1.navLinksClass + " " + styles.horizontalLinks, activeItemClassName: styles.selected, maxNavigationItems: 99, navigationItems: props.navLinks.filter(function (x) { return !!x; }).map(convertNavItemToMenuNode) }),
                    React.createElement("div", { key: "content" }, content(props)));
            }
        }));
};
// ErrorBoundary doesn't reset its state when applied at a level lower than route level and that's why we have to do ourselves here.
function content(props) {
    return React.createElement(ErrorBoundary_1.default, { key: props.location.pathname }, props.content);
}
function convertNavItemToMenuNode(item) {
    if (isGroup(item)) {
        return { label: item.groupLabel, children: item.children.map(convertNavItemToMenuNode) };
    }
    return { url: item.path, text: item.label, exact: item.exact };
}
function isGroup(item) {
    return item.children !== undefined;
}
var NavItemComponent = function (props) {
    var item = props.item;
    return isGroup(item)
        ? renderNavLinkGroup(item)
        : renderNavLink(item.label, item.path, item.exact);
    function renderNavLinkGroup(group) {
        return React.createElement(ReloadableRoute_1.default, { render: function (routeProps) {
                return React.createElement(NavLinkGroup, { group: group, location: routeProps.location });
            } });
    }
};
function renderNavLink(label, path, exact) {
    return React.createElement(InternalNavLink_1.default, { to: path, activeClassName: styles.selected, className: styles.link, key: path, exact: exact }, label);
}
var NavLinkGroup = function (props) {
    var allDescendantLinks = getDescendantLinks(props.group);
    var anyDescendantsMatch = allDescendantLinks.some(function (l) { return !!react_router_1.matchPath(props.location.pathname, { path: l.path, exact: l.exact }); });
    return React.createElement("div", null,
        renderNavLink(props.group.groupLabel, props.group.defaultChildPath, anyDescendantsMatch),
        anyDescendantsMatch && React.createElement("div", { className: styles.nestedNavLinks }, props.group.children.map(function (g, index) { return React.createElement(NavItemComponent, { key: index, item: g }); })));
};
function getDescendantLinks(group) {
    return lodash_1.flatten(group.children.map(function (c) {
        if (isGroup(c)) {
            return getDescendantLinks(c);
        }
        return [c];
    }));
}
exports.default = react_router_1.withRouter(NavigationSidebarLayout);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NavigationSidebarLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NavigationSidebarLayout\\index.tsx"); } } })();

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var typesafe_actions_1 = __webpack_require__(545);
exports.machineActions = {
    machineFetched: typesafe_actions_1.createAction("MACHINE_FETCHED", function (machine) { return ({ type: "MACHINE_FETCHED", payload: machine }); }),
    machineSaved: typesafe_actions_1.createAction("MACHINE_SAVED", function (machine) { return ({ type: "MACHINE_SAVED", payload: machine }); }),
    machineCleared: typesafe_actions_1.createAction("MACHINE_CLEARED")
};
var returnOfActions = Object.values(exports.machineActions).map(typesafe_actions_1.getReturnOfExpression);
var currentMachineReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.machineActions.machineFetched):
        case typesafe_actions_1.getType(exports.machineActions.machineSaved):
            return action.payload;
        case typesafe_actions_1.getType(exports.machineActions.machineCleared):
            return null;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({ current: currentMachineReducer });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\machines.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\machines.ts"); } } })();

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var MachineTypedMultiSelect = MultiSelect_1.MultiSelect();
var MachineMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Machine, chipRender: function (item) { return React.createElement(Chips_1.MachineChip, { onRequestDelete: onRequestDelete, machineName: item.Name }); } });
    };
    return React.createElement(MachineTypedMultiSelect, __assign({ items: props.items, fieldName: "targets", renderChip: chipRenderer }, props));
};
exports.default = MachineMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MachineMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MachineMultiSelect.tsx"); } } })();

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var DataBaseComponent_1 = __webpack_require__(39);
var DialogLayout_1 = __webpack_require__(158);
var ActionButton_1 = __webpack_require__(49);
var Dialog_1 = __webpack_require__(133);
var styles = __webpack_require__(1908);
var ConfirmationDialog = (function (_super) {
    __extends(ConfirmationDialog, _super);
    function ConfirmationDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ConfirmationDialog.prototype.onContinueClick = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onContinueClick()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ConfirmationDialog.prototype.render = function () {
        var _this = this;
        var cont = React.createElement(ActionButton_1.ActionButton, { key: "Continue", label: this.props.continueButtonLabel || "Continue", type: this.props.continueButtonType || ActionButton_1.ActionButtonType.Save, busyLabel: this.props.continueButtonBusyLabel, disabled: this.state.busy, onClick: function () { return _this.onContinueClick(); } });
        var cancel = React.createElement(ActionButton_1.ActionButton, { key: "Cancel", label: "Cancel", disabled: this.state.busy, onClick: function () { return _this.props.onClose(); } });
        return React.createElement(Dialog_1.default, { open: this.props.open || false },
            React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel, cont], title: this.props.title, titleIcon: React.createElement("em", { className: cn("fa fa-warning", styles.warningIcon) }), headerClassName: styles.dialogHeader, busy: this.state.busy, closeDialog: this.props.onClose, errors: this.state.errors }, this.props.open && this.props.children));
    };
    return ConfirmationDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ConfirmationDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\ConfirmationDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\ConfirmationDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableHeader = (function (_super) {
    __extends(DataTableHeader, _super);
    function DataTableHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableHeader.prototype.render = function () {
        return (React.createElement("thead", { className: cn(this.props.className, styles.dataTableHeader) }, this.props.children));
    };
    return DataTableHeader;
}(React.Component));
exports.DataTableHeader = DataTableHeader;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableHeader.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableHeader.tsx"); } } })();

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableHeaderColumn = (function (_super) {
    __extends(DataTableHeaderColumn, _super);
    function DataTableHeaderColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableHeaderColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, otherProps = __rest(_a, ["className"]);
        return (React.createElement("th", __assign({ className: cn(className, styles.dataTableHeaderColumn) }, otherProps), this.props.children));
    };
    return DataTableHeaderColumn;
}(React.Component));
exports.DataTableHeaderColumn = DataTableHeaderColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableHeaderColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableHeaderColumn.tsx"); } } })();

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SvgIcon_1 = __webpack_require__(23);
var colors_1 = __webpack_require__(31);
// We are using SVG content directly because SvgIconMaterial doesn't allow us to reference svg files directly.
var EnvironmentIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M14 30v35h172V30zm26 26H23V39h17zM14 83v35h95V83zm26 26H23V92h17zM14 134v35h172v-35zm26 26H23v-17h17z" })); };
exports.EnvironmentIcon = EnvironmentIcon;
var ExcludedEnvironmentIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M6.713 20.367l7.784-8.206 176.512 167.446-7.783 8.205z" }),
    React.createElement("path", { d: "M88.13 83H14v35h95v-15.2zM40 109H23V92h17zM141.89 134H14v35h164.78zM23 160v-17h17v17zM186 160.27V134h-27.69L186 160.27zM85.58 65H186V30H48.69l36.89 35zM32.27 30H14v35h55.16zM23 56V39h17v17z" })); };
exports.ExcludedEnvironmentIcon = ExcludedEnvironmentIcon;
var ProjectIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M174.33 26H25.67A14.67 14.67 0 0 0 11 40.7v14.36h178V40.7A14.67 14.67 0 0 0 174.33 26zM11 63.09v96.21A14.72 14.72 0 0 0 25.67 174h148.66A14.72 14.72 0 0 0 189 159.3V63.09zm59.12 58.42h-37v-37h37zm93.63 17H87.11a4.06 4.06 0 1 1 0-8.11h76.64a4.06 4.06 0 1 1 0 8.11zM83 111.52a4.06 4.06 0 0 1 4.06-4.06h59.31a4.06 4.06 0 1 1 0 8.11H87.11a4.06 4.06 0 0 1-4.11-4.05zm81.61-18.83h-77.5a4.06 4.06 0 0 1 0-8.11h77.56a4.06 4.06 0 1 1 0 8.11z" })); };
exports.ProjectIcon = ProjectIcon;
var MachineIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M119.19 70.52h6.54a27 27 0 0 0-18-18V59a3.87 3.87 0 0 1-3.84 3.84h-7.73A3.87 3.87 0 0 1 92.32 59v-6.53a27 27 0 0 0-18 18h6.54a3.86 3.86 0 0 1 3.83 3.84V82a3.86 3.86 0 0 1-3.83 3.84h-6.59a27 27 0 0 0 18 18.05v-6.5a3.87 3.87 0 0 1 3.84-3.84h7.68a3.87 3.87 0 0 1 3.84 3.84v6.54a27 27 0 0 0 18-18.05h-6.54a3.86 3.86 0 0 1-3.73-3.88v-7.64a3.86 3.86 0 0 1 3.83-3.84z" }),
    React.createElement("path", { d: "M170.17 16.15H29.83A3.82 3.82 0 0 0 26 20v116.71a3.82 3.82 0 0 0 3.83 3.82h65.34v15.74a14.92 14.92 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.66h43.87a14.92 14.92 0 0 0 28.26 0H158a4.83 4.83 0 1 0 0-9.66h-43.87a14.92 14.92 0 0 0-9.3-9.3v-15.74h65.34a3.82 3.82 0 0 0 3.83-3.82V20a3.82 3.82 0 0 0-3.83-3.85zM146.07 82a3.87 3.87 0 0 1-3.84 3.84h-8.58a34.59 34.59 0 0 1-26 26v8.58a3.87 3.87 0 0 1-3.84 3.84h-7.65a3.87 3.87 0 0 1-3.84-3.84v-8.58a34.59 34.59 0 0 1-26-26h-8.55A3.87 3.87 0 0 1 53.93 82v-7.64a3.87 3.87 0 0 1 3.84-3.84h8.58a34.59 34.59 0 0 1 26-26V36a3.87 3.87 0 0 1 3.84-3.84h7.68a3.87 3.87 0 0 1 3.81 3.84v8.58a34.59 34.59 0 0 1 26 26h8.58a3.87 3.87 0 0 1 3.84 3.84z" })); };
exports.MachineIcon = MachineIcon;
var WorkerPoolIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M30.5 13.5v172h35v-172zm26 163h-17v-17h17zM83.5 90.5v95h35v-95zm26 86h-17v-17h17zM134.5 13.5v172h35v-172zm26 163h-17v-17h17z" })); };
exports.WorkerPoolIcon = WorkerPoolIcon;
var WorkerIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { d: "M170.17 16.15H29.83A3.82 3.82 0 0 0 26 20v116.71a3.82 3.82 0 0 0 3.83 3.82h65.34v15.74a14.92 14.92 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.66h43.87a14.92 14.92 0 0 0 28.26 0H158a4.83 4.83 0 1 0 0-9.66h-43.87a14.92 14.92 0 0 0-9.3-9.3v-15.74h65.34a3.82 3.82 0 0 0 3.83-3.82V20a3.82 3.82 0 0 0-3.83-3.85zM94.06 28.08h11.88a8.35 8.35 0 0 1 6.7 3.37l-5 21.51h-15L87 31.89a8.4 8.4 0 0 1 7.06-3.81zm6 98.92a40.74 40.74 0 0 1-40-33.1h80a40.74 40.74 0 0 1-39.95 33.1zm43.4-41.44h-87a6.14 6.14 0 0 1 0-12.28h1.68a41.77 41.77 0 0 1 21.54-36.54l5.74 21.48a4.19 4.19 0 0 0 4 3.09H111a4.18 4.18 0 0 0 4-3.23l5-21.5a41.81 41.81 0 0 1 21.81 36.7h1.67a6.14 6.14 0 1 1 0 12.28z" })); };
exports.WorkerIcon = WorkerIcon;
var ExcludedMachineIcon = function (props) {
    return React.createElement(SvgIcon_1.default, __assign({}, props, { viewBox: "0 0 200 200", style: { fill: colors_1.white, margin: 5, height: 19.2, width: 19.2 } }),
        React.createElement("path", { d: "M6.713 20.367l7.784-8.206 176.512 167.446-7.783 8.205z" }),
        React.createElement("path", { d: "M158 165.57h-43.87a14.92 14.92 0 0 0-9.3-9.3v-15.74h45l-33.6-31.88a34.39 34.39 0 0 1-8.52 3.2v8.58a3.87 3.87 0 0 1-3.84 3.84h-7.71a3.87 3.87 0 0 1-3.84-3.84v-8.58a34.59 34.59 0 0 1-26-26h-8.55A3.87 3.87 0 0 1 53.93 82v-7.64a3.87 3.87 0 0 1 3.84-3.84h8.58a34.57 34.57 0 0 1 2.37-6.91L26 23.08v113.63a3.82 3.82 0 0 0 3.83 3.82h65.34v15.74a14.92 14.92 0 0 0-9.3 9.3H42a4.83 4.83 0 1 0 0 9.66h43.87a14.92 14.92 0 0 0 28.26 0H158a4.83 4.83 0 1 0 0-9.66zM75.23 54.2a34.5 34.5 0 0 1 17.09-9.65V36a3.87 3.87 0 0 1 3.84-3.84h7.68a3.87 3.87 0 0 1 3.84 3.84v8.58a34.59 34.59 0 0 1 26 26h8.58a3.87 3.87 0 0 1 3.84 3.84V82a3.87 3.87 0 0 1-3.84 3.84h-8.58a34.42 34.42 0 0 1-8.39 15.79l41 38.86h3.94a3.82 3.82 0 0 0 3.83-3.82V20a3.82 3.82 0 0 0-3.83-3.82h-135z" }),
        React.createElement("path", { d: "M74.69 69.27c-.15.41-.3.83-.42 1.25H76zM119.71 96.4a26.81 26.81 0 0 0 6-10.52h-6.54a3.86 3.86 0 0 1-3.81-3.88v-7.64a3.86 3.86 0 0 1 3.83-3.84h6.54a27 27 0 0 0-18-18V59a3.87 3.87 0 0 1-3.84 3.84h-7.73A3.87 3.87 0 0 1 92.32 59v-6.53a26.83 26.83 0 0 0-11.53 7zM107.68 100.57v3.36c.87-.26 1.73-.58 2.57-.92zM84.64 78.72V82a3.86 3.86 0 0 1-3.83 3.84h-6.54a27 27 0 0 0 18 18.05v-6.5a3.87 3.87 0 0 1 3.84-3.84h4.12z" }));
};
exports.ExcludedMachineIcon = ExcludedMachineIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Icon\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Icon\\index.tsx"); } } })();

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1817);
var Chips_1 = __webpack_require__(24);
var Card = function (props) {
    var header = null;
    if (props.isDisabled) {
        header = React.createElement("div", null,
            props.header,
            React.createElement("br", null),
            React.createElement(Chips_1.DisabledChip, null));
    }
    else {
        header = props.header;
    }
    return React.createElement("div", { className: cn(props.className, styles.container, props.isDisabled ? styles.disabled : null) },
        props.link && React.createElement("div", { className: styles.link }, props.link),
        React.createElement("div", { className: styles.logo }, props.logo),
        React.createElement("div", { className: styles.header }, header),
        React.createElement("div", { className: cn(styles.content, props.includeContentFade ? styles.contentFade : null) }, props.content),
        (props.footerText || props.footerIcon || props.footerBackgroundColor) && React.createElement("div", { className: styles.footer, style: { backgroundColor: props.footerBackgroundColor } },
            props.footerText,
            React.createElement("span", { className: styles.footerIcon }, props.footerIcon)),
        props.onHoverView && React.createElement("div", { className: styles.onHover }, props.onHoverView));
};
Card.displayName = "Card";
exports.default = Card;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Card\\Card.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Card\\Card.tsx"); } } })();

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Section_1 = __webpack_require__(81);
exports.default = Section_1.Section;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Section\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Section\\index.tsx"); } } })();

/***/ }),
/* 784 */,
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1669);
var cn = __webpack_require__(19);
var ComponentRow = function (props) {
    return React.createElement("div", { className: cn(styles.componentRow, props.className) }, props.children);
};
ComponentRow.displayName = "ComponentRow";
exports.default = ComponentRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ComponentRow\\ComponentRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ComponentRow\\ComponentRow.tsx"); } } })();

/***/ }),
/* 786 */,
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cloud_1 = __webpack_require__(1904); //https://material.io/icons/#ic_cloud
exports.AzureIcon = cloud_1.default;
var lock_1 = __webpack_require__(1905); //https://material.io/icons/#ic_lock
exports.SshKeyIcon = lock_1.default;
var person_1 = __webpack_require__(1906); //https://material.io/icons/#ic_person
exports.UsernamePasswordIcon = person_1.default;
var vpn_key_1 = __webpack_require__(1907);
exports.TokenIcon = vpn_key_1.default;
var SvgIcon_1 = __webpack_require__(23);
var resources_1 = __webpack_require__(17);
var colors_1 = __webpack_require__(31);
var AmazonIcon = function (props) { return (React.createElement(SvgIcon_1.default, __assign({}, props),
    React.createElement("path", { d: "M15.93,17.09C15.75,17.25 15.5,17.26 15.3,17.15C14.41,16.41 14.25,16.07 13.76,15.36C12.29,16.86 11.25,17.31 9.34,17.31C7.09,17.31 5.33,15.92 5.33,13.14C5.33,10.96 6.5,9.5 8.19,8.76C9.65,8.12 11.68,8 13.23,7.83V7.5C13.23,6.84 13.28,6.09 12.9,5.54C12.58,5.05 11.95,4.84 11.4,4.84C10.38,4.84 9.47,5.37 9.25,6.45C9.2,6.69 9,6.93 8.78,6.94L6.18,6.66C5.96,6.61 5.72,6.44 5.78,6.1C6.38,2.95 9.23,2 11.78,2C13.08,2 14.78,2.35 15.81,3.33C17.11,4.55 17,6.18 17,7.95V12.12C17,13.37 17.5,13.93 18,14.6C18.17,14.85 18.21,15.14 18,15.31L15.94,17.09H15.93M13.23,10.56V10C11.29,10 9.24,10.39 9.24,12.67C9.24,13.83 9.85,14.62 10.87,14.62C11.63,14.62 12.3,14.15 12.73,13.4C13.25,12.47 13.23,11.6 13.23,10.56M20.16,19.54C18,21.14 14.82,22 12.1,22C8.29,22 4.85,20.59 2.25,18.24C2.05,18.06 2.23,17.81 2.5,17.95C5.28,19.58 8.75,20.56 12.33,20.56C14.74,20.56 17.4,20.06 19.84,19.03C20.21,18.87 20.5,19.27 20.16,19.54M21.07,18.5C20.79,18.14 19.22,18.33 18.5,18.42C18.31,18.44 18.28,18.26 18.47,18.12C19.71,17.24 21.76,17.5 22,17.79C22.24,18.09 21.93,20.14 20.76,21.11C20.58,21.27 20.41,21.18 20.5,21C20.76,20.33 21.35,18.86 21.07,18.5Z" }))); };
exports.AmazonWebServicesIcon = AmazonIcon;
var AccountIcon = function (_a) {
    var accountType = _a.accountType, rest = __rest(_a, ["accountType"]);
    var defaults = { color: colors_1.secondaryText };
    switch (accountType) {
        case resources_1.AccountType.AmazonWebServicesAccount:
            return React.createElement(AmazonIcon, __assign({}, defaults, rest));
        case resources_1.AccountType.AzureServicePrincipal:
        case resources_1.AccountType.AzureSubscription:
            return React.createElement(cloud_1.default, __assign({}, defaults, rest));
        case resources_1.AccountType.SshKeyPair:
            return React.createElement(lock_1.default, __assign({}, defaults, rest));
        case resources_1.AccountType.UsernamePassword:
            return React.createElement(person_1.default, __assign({}, defaults, rest));
        case resources_1.AccountType.Token:
            return React.createElement(vpn_key_1.default, __assign({}, defaults, rest));
        default: return null;
    }
};
exports.AccountIcon = AccountIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\AccountsLayout\\AccountIcons.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\AccountsLayout\\AccountIcons.tsx"); } } })();

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var ActionKeys;
(function (ActionKeys) {
    ActionKeys["TENANT_FETCHED"] = "TENANT_FETCHED";
    ActionKeys["TENANT_SAVED"] = "TENANT_SAVED";
    ActionKeys["TENANT_VARIABLES_FETCHED"] = "TENANT_VARIABLES_FETCHED";
    ActionKeys["TENANT_ENABLED_FETCHED"] = "TENANT_ENABLED_FETCHED";
    ActionKeys["OTHER_ACTION"] = "__any_other_action_type__";
})(ActionKeys || (ActionKeys = {}));
var currentTenantReducer = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case ActionKeys.TENANT_SAVED:
        case ActionKeys.TENANT_FETCHED:
            var tenant = action.tenant;
            return {
                name: tenant.Name,
                logoUrl: tenant.Links.Logo,
                id: tenant.Id,
                hasMissingVariables: false
            };
        case ActionKeys.TENANT_VARIABLES_FETCHED:
            return __assign({}, state, { hasMissingVariables: action.hasMissingVariables });
        default:
            return state;
    }
};
exports.tenantsActions = {
    tenantFetched: function (tenant) {
        return { type: ActionKeys.TENANT_FETCHED, tenant: tenant };
    },
    tenantSaved: function (tenant) {
        return { type: ActionKeys.TENANT_SAVED, tenant: tenant };
    },
    tenantMissingVariablesFetched: function (tenantMissingVariables) {
        return {
            type: ActionKeys.TENANT_VARIABLES_FETCHED,
            hasMissingVariables: !!tenantMissingVariables
        };
    }
};
exports.tenantsArea = redux_1.combineReducers({
    currentTenant: currentTenantReducer
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\tenantsArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\tenantsArea.ts"); } } })();

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TaskStatusIcon_1 = __webpack_require__(462);
var DateFormatter_1 = __webpack_require__(237);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1561);
var TaskDetails = function (props) {
    var task = props.task;
    return React.createElement("div", { className: cn(styles.taskDetailsContainer, (_a = {}, _a[styles.stripTopBottomPadding] = props.stripTopBottomPadding, _a)) },
        React.createElement(TaskStatusIcon_1.TaskStatusIcon, { item: task }),
        React.createElement("div", { className: styles.details },
            React.createElement("span", { className: styles.description }, task.Description),
            React.createElement("span", { title: DateFormatter_1.default.dateToLongFormat(task.StartTime || task.QueueTime), className: styles.date }, DateFormatter_1.default.dateToCustomFormat(task.StartTime || task.QueueTime, "MMMM Do YYYY"))));
    var _a;
};
TaskDetails.displayName = "TaskDetails";
exports.default = TaskDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TaskDetails\\TaskDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TaskDetails\\TaskDetails.tsx"); } } })();

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var colors_1 = __webpack_require__(31);
var index_1 = __webpack_require__(74);
var MissingVariablesIcon = function (props) {
    if (!props.show) {
        return null;
    }
    return React.createElement(index_1.default, { content: "Some of the required variable values have not been set" },
        React.createElement("em", { className: "fa fa-warning", style: { color: colors_1.alert } }));
};
exports.default = MissingVariablesIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\MissingVariablesIcon\\MissingVariablesIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\MissingVariablesIcon\\MissingVariablesIcon.tsx"); } } })();

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var ChannelTypedMultiSelect = MultiSelect_1.MultiSelect();
var ChannelMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Channel, chipRender: function (item) { return React.createElement(Chips_1.ChannelChip, { onRequestDelete: onRequestDelete, channelName: item.Name }); } });
    };
    return React.createElement(ChannelTypedMultiSelect, __assign({ items: props.items, fieldName: "channels", renderChip: chipRenderer }, props));
};
exports.default = ChannelMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ChannelMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ChannelMultiSelect.tsx"); } } })();

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var clientInstance_1 = __webpack_require__(10);
var List_1 = __webpack_require__(432);
var CertificateSummary_1 = __webpack_require__(1953);
var routeLinks_1 = __webpack_require__(22);
var lodash_1 = __webpack_require__(11);
var CertificateList = (function (_super) {
    __extends(CertificateList, _super);
    function CertificateList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CertificateList;
}(List_1.default));
var CertificateSearch = (function (_super) {
    __extends(CertificateSearch, _super);
    function CertificateSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.buildRow = function (certificate) {
            return [
                React.createElement(CertificateSummary_1.default, { onClick: function () {
                        if (!_this.props.onSelected) {
                            return;
                        }
                        _this.setState({ selectedId: certificate.Id }, function () {
                            _this.props.onSelected(certificate);
                        });
                    }, showSelection: _this.props.onSelected ? true : false, selected: certificate.Id === _this.state.selectedId, key: certificate.Id, certificate: certificate, environments: lodash_1.values(_this.state.environments), tenants: lodash_1.values(_this.state.tenants), tenantTags: _this.state.tenantTags })
            ];
        };
        _this.rowClicked = function (certificate) {
            if (_this.props.onSelected) {
                return null;
            }
            else {
                return routeLinks_1.default.library.certificate(certificate.Id);
            }
        };
        _this.loadRelatedCertificateData = function (certificates) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var environmentIds, tenantIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        environmentIds = lodash_1.xor(certificates.map(function (c) { return c.EnvironmentIds; }).reduce(function (list, ids) { return list.concat(ids); }, []), this.state.environments.map(function (x) { return x.Id; }));
                        tenantIds = lodash_1.xor(certificates.map(function (c) { return c.TenantIds; }).reduce(function (list, ids) { return list.concat(ids); }, []), this.state.tenants.map(function (x) { return x.Id; }));
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a, environments, tenants;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, Promise.all([
                                                clientInstance_1.repository.Environments.all({ ids: environmentIds }),
                                                clientInstance_1.repository.Tenants.all({ ids: tenantIds })
                                            ])];
                                        case 1:
                                            _a = _b.sent(), environments = _a[0], tenants = _a[1];
                                            this.setState(function (x) { return (__assign({}, x, { environments: lodash_1.uniqBy(x.environments.concat(environments), function (env) { return env.Id; }), tenants: lodash_1.uniqBy(x.tenants.concat(tenants), function (tenant) { return tenant.Id; }) })); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, certificates];
                }
            });
        }); };
        _this.state = {
            certificates: _this.props.certificates,
            environments: [],
            tenants: [],
            tenantTags: [],
            busy: false,
            selectedId: _this.props.selectedCertificateId
        };
        return _this;
    }
    CertificateSearch.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var certificates, tenantTags;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                certificates = this.state.certificates;
                                if (!!certificates) return [3 /*break*/, 2];
                                return [4 /*yield*/, clientInstance_1.repository.Certificates.list({ tenant: this.props.tenantId })];
                            case 1:
                                certificates = _a.sent();
                                _a.label = 2;
                            case 2: return [4 /*yield*/, Promise.all([
                                    clientInstance_1.repository.TagSets.all()
                                ])];
                            case 3:
                                tenantTags = (_a.sent())[0];
                                this.setState({
                                    certificates: certificates,
                                    tenantTags: tenantTags
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    CertificateSearch.prototype.applyFilter = function (filter, resource) {
        return !filter || filter.length === 0 || !resource
            || resource.Name.toLowerCase().includes(filter.toLowerCase())
            || (resource.SubjectCommonName && resource.SubjectCommonName.toLowerCase().includes(filter.toLowerCase()))
            || resource.Thumbprint.toLowerCase().includes(filter.toLowerCase());
    };
    CertificateSearch.prototype.render = function () {
        // Note: This is wrapped in a <div> on purpose for CSS transition animations.
        return React.createElement("div", null, this.state.certificates && React.createElement(CertificateList, { initialData: this.state.certificates, onRow: this.buildRow, onRowRedirectUrl: this.rowClicked, onFilter: this.applyFilter, filterSearchEnabled: true, apiSearchParams: ["partialName"], selectedId: this.state.selectedId, filterHintText: "Filter by name, subject, or thumbprint", onNewItems: this.loadRelatedCertificateData }));
    };
    return CertificateSearch;
}(BaseComponent_1.default));
exports.default = CertificateSearch;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSearch.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSearch.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var typesafe_actions_1 = __webpack_require__(545);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
exports.accountActions = {
    fetchAll: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ALL_REQUEST"),
    fetch: typesafe_actions_1.createAction("ACCOUNTS_FETCH_REQUEST"),
    fetchError: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ERROR", function (error) { return ({ type: "ACCOUNTS_FETCH_ERROR", payload: error }); }),
    fetchAllSuccess: typesafe_actions_1.createAction("ACCOUNTS_FETCH_ALL_SUCCESS", function (accounts) { return ({ type: "ACCOUNTS_FETCH_ALL_SUCCESS", payload: accounts }); }),
    fetchSuccess: typesafe_actions_1.createAction("ACCOUNT_FETCH_SUCCESS", function (account) { return ({ type: "ACCOUNT_FETCH_SUCCESS", payload: account }); })
};
var returnOfActions = Object.values(exports.accountActions).map(typesafe_actions_1.getReturnOfExpression);
var accountIdsReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.accountActions.fetchAllSuccess):
            return action.payload.map(function (x) { return x.Id; });
        case typesafe_actions_1.getType(exports.accountActions.fetchSuccess):
            return state.concat([action.payload.Id]);
        default: return state;
    }
};
var convertResource = function (account) { return ({
    accountId: account.Id,
    accountType: account.AccountType,
    name: account.Name,
    description: account.Description
}); };
var accountsByIdReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case typesafe_actions_1.getType(exports.accountActions.fetchAllSuccess):
            return __assign({}, state, lodash_1.keyBy(action.payload.map(convertResource), function (x) { return x.accountId; }));
        case typesafe_actions_1.getType(exports.accountActions.fetchSuccess):
            return __assign({}, state, (_a = {}, _a[action.payload.Id] = convertResource(action.payload), _a));
        default: return state;
    }
    var _a;
};
function fetchAllAccounts() {
    return function (dispatch) {
        dispatch(exports.accountActions.fetchAll());
        return clientInstance_1.repository.Accounts.all().then(function (result) {
            dispatch(exports.accountActions.fetchAllSuccess(result));
        }).catch(function (error) {
            dispatch(exports.accountActions.fetchError(error));
        });
    };
}
exports.fetchAllAccounts = fetchAllAccounts;
exports.default = redux_1.combineReducers({ byId: accountsByIdReducer, allIds: accountIdsReducer });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\accounts.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\accounts.ts"); } } })();

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getInfrastructureState = function (state) { return state.infrastructureArea; };
var getAccountsState = function (state) { return getInfrastructureState(state).accounts; };
var getMachinesState = function (state) { return getInfrastructureState(state).machines; };
var getAccounts = function (state) { return getAccountsState(state).byId; };
exports.getAccountById = function (state, props) {
    return getAccounts(state)[props.accountId];
};
exports.getCurrentMachine = function (state) { return getMachinesState(state).current; };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\selectors.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\selectors.ts"); } } })();

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var ActionTemplateActions = {
    ACTIONTEMPLATE_FETCHED: "ACTIONTEMPLATE_FETCHED",
    ACTIONTEMPLATE_NEWTEMPLATE_SELECTED: "ACTIONTEMPLATE_NEWTEMPLATE_SELECTED",
};
function actionTemplateFetch(actionTemplate) {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var usages, pendingUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.getUsage(actionTemplate)];
                case 1:
                    usages = _a.sent();
                    pendingUpdates = usages.filter(function (u) { return u.Version.toString() !== actionTemplate.Version.toString(); }).length;
                    dispatch(actionTemplateFetched({
                        id: actionTemplate.Id,
                        name: actionTemplate.Name,
                        logo: actionTemplate.Links["Logo"],
                        pendingUpdates: pendingUpdates
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
}
exports.actionTemplateFetch = actionTemplateFetch;
function actionTemplateFetched(state) {
    return { type: ActionTemplateActions.ACTIONTEMPLATE_FETCHED, state: state };
}
exports.actionTemplateFetched = actionTemplateFetched;
function newActionTemplateSelected() {
    return { type: ActionTemplateActions.ACTIONTEMPLATE_NEWTEMPLATE_SELECTED };
}
exports.newActionTemplateSelected = newActionTemplateSelected;
var libraryArea = function (state, action) {
    if (state === void 0) { state = { currentActionTemplate: null }; }
    switch (action.type) {
        case ActionTemplateActions.ACTIONTEMPLATE_FETCHED:
            var actionTemplate = action.state;
            return {
                currentActionTemplate: {
                    id: actionTemplate.id,
                    name: actionTemplate.name,
                    logo: actionTemplate.logo,
                    pendingUpdates: actionTemplate.pendingUpdates
                }
            };
        case ActionTemplateActions.ACTIONTEMPLATE_NEWTEMPLATE_SELECTED:
            return { currentActionTemplate: null };
        default:
            return state;
    }
};
exports.default = libraryArea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\reducers\\libraryArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\reducers\\libraryArea.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableRowHeaderColumn = (function (_super) {
    __extends(DataTableRowHeaderColumn, _super);
    function DataTableRowHeaderColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableRowHeaderColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, inSidebar = _a.inSidebar, otherProps = __rest(_a, ["className", "inSidebar"]);
        return (React.createElement("th", __assign({ className: cn(className, styles.dataTableRowHeaderColumn, inSidebar ? styles.dataTableRowHeaderColumnInSidebar : null) }, otherProps), this.props.children));
    };
    return DataTableRowHeaderColumn;
}(React.Component));
exports.DataTableRowHeaderColumn = DataTableRowHeaderColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRowHeaderColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableRowHeaderColumn.tsx"); } } })();

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleExpander_1 = __webpack_require__(667);
__export(__webpack_require__(667));
exports.default = SimpleExpander_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleExpander\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SimpleExpander\\index.ts"); } } })();

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var AreaTitle_1 = __webpack_require__(122);
var routeLinks_1 = __webpack_require__(22);
var style = __webpack_require__(1578);
var TaskLayout = (function (_super) {
    __extends(TaskLayout, _super);
    function TaskLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskLayout.prototype.render = function () {
        return (React.createElement("main", { id: "maincontent" },
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.tasks.root, title: "Tasks" }),
            React.createElement("div", { className: style.container }, this.props.children)));
    };
    return TaskLayout;
}(BaseComponent_1.default));
exports.default = TaskLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\TaskLayout\\TaskLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\TaskLayout\\TaskLayout.tsx"); } } })();

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1721);
var DialogLayout_1 = __webpack_require__(158);
var Dialog_1 = __webpack_require__(133);
var ActionButton_1 = __webpack_require__(49);
var Text_1 = __webpack_require__(50);
var ColorPicker = (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.renderPaletteSwatch = function (color) {
            return React.createElement("a", { key: color, className: styles.colorPickItem, style: { backgroundColor: color }, title: color, onClick: function (e) {
                    e.preventDefault();
                    _this.handleChange(color);
                    _this.setState({ pickerOpen: false });
                } });
        };
        _this.state = {
            pickerOpen: false,
            error: null
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, onValidate = _a.onValidate, defaultColor = _a.defaultColor, value = _a.value, warning = _a.warning;
        var err = this.state.error || error;
        var errorText = err || warning;
        var val = value ? value : "";
        var colorSet1 = ["#983230", "#A77B22", "#227647", "#52818C", "#203A88", "#752BA5", "#6e6e6e"];
        var colorSet2 = ["#E8634F", "#ECAD3F", "#36A766", "#77B7C5", "#3156B3", "#9786A7", "#9d9d9d"];
        var cancel = React.createElement(ActionButton_1.default, { key: "CancelButton", label: "Cancel", onClick: function () { return _this.setState({ pickerOpen: false }); } });
        return (React.createElement("div", { className: styles.container },
            React.createElement(Text_1.default, { id: id, hintText: defaultColor, value: val, onChange: this.handleChange, error: errorText, label: label }),
            React.createElement("a", { className: styles.colorSwatch, style: { backgroundColor: val || defaultColor }, onClick: function (e) {
                    e.preventDefault();
                    _this.setState({ pickerOpen: true });
                } }),
            React.createElement(Dialog_1.default, { open: this.state.pickerOpen || false },
                React.createElement(DialogLayout_1.DialogLayout, { actions: [cancel], title: "Standard Palette", busy: null, closeDialog: function () { return _this.setState({ pickerOpen: false }); }, errors: null },
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.colorAllOptions }, colorSet1.map(this.renderPaletteSwatch)),
                        React.createElement("div", { className: styles.colorAllOptions }, colorSet2.map(this.renderPaletteSwatch)))))));
    };
    return ColorPicker;
}(React.Component));
exports.default = ColorPicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\ColorPicker\\ColorPicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\ColorPicker\\ColorPicker.tsx"); } } })();

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ByteSizeFormatter_1 = __webpack_require__(801);
var Text_1 = __webpack_require__(50);
var InputWithActions_1 = __webpack_require__(163);
var IconButtonList_1 = __webpack_require__(124);
var IconButton_1 = __webpack_require__(52);
var MaxFileSize = Math.pow(1024, 5);
var SensitiveFileUpload = (function (_super) {
    __extends(SensitiveFileUpload, _super);
    function SensitiveFileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.openSelector = function (e) {
            e.preventDefault();
            _this.input.click();
        };
        _this.handleFileChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var files, file, bytes, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ error: null });
                        files = e.currentTarget.files;
                        if (files.length < 1) {
                            return [2 /*return*/];
                        }
                        file = files[0];
                        if (file.size === 0) {
                            this.reportError("Attached file is empty. Please select a different file.");
                            return [2 /*return*/];
                        }
                        if (file.size > MaxFileSize) {
                            this.reportError("Selected file is too big!");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.loadFileBytes(file)];
                    case 2:
                        bytes = _a.sent();
                        this.props.onChange({ HasValue: true, NewValue: bytes });
                        this.setState({ selectedFile: file });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ error: err_1 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.currentValue = function () {
            return _this.props.value || {
                HasValue: false,
            };
        };
        _this.handleSetOrChange = function () {
            _this.input.click();
        };
        _this.handleRemove = function (e) {
            _this.input.value = null;
            _this.setState({
                selectedFile: null
            }, function () {
                _this.props.onChange({
                    HasValue: false
                });
            });
        };
        _this.noop = function () {
            // Empty on purpose
        };
        _this.state = {};
        return _this;
    }
    SensitiveFileUpload.prototype.reportError = function (error) {
        this.setState({ error: error, selectedFile: null });
    };
    SensitiveFileUpload.prototype.loadFileBytes = function (file) {
        return new Promise(function (res, rej) {
            var reader = new FileReader();
            reader.onload = function (evt) {
                var target = evt.target;
                if (target.readyState === FileReader.DONE) {
                    var b6 = target.result.indexOf("base64,") + 7;
                    var ress = target.result.slice(b6);
                    res(ress);
                }
            };
            reader.onerror = function (evt) {
                rej(evt.message);
            };
            reader.readAsDataURL(file);
        });
    };
    SensitiveFileUpload.prototype.getName = function () {
        if (this.props.value && this.props.value.HasValue && this.props.value.NewValue === null) {
            return this.props.availablePlaceholder || "A file exists";
        }
        var selectedFile = this.state.selectedFile;
        if (selectedFile) {
            return selectedFile.name + " (" + ByteSizeFormatter_1.default(selectedFile.size) + ")";
        }
        return this.props.hintText || "";
    };
    SensitiveFileUpload.prototype.render = function () {
        var _this = this;
        var currentValue = this.currentValue();
        var setOrChange = currentValue.HasValue ? "Change file" : "Choose file";
        var _a = this.props, error = _a.error, warning = _a.warning, label = _a.label, onChange = _a.onChange, value = _a.value, hintText = _a.hintText;
        var err = this.state.error || error;
        var errorText = err || warning;
        return React.createElement("div", null,
            React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { type: "text", hintText: hintText, value: this.getName(), label: label, onChange: this.noop, onClick: this.openSelector, error: errorText }), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons(setOrChange, currentValue) }) }),
            React.createElement("input", { type: "file", style: { display: "none" }, onChange: this.handleFileChange, ref: function (input) { return _this.input = input; } }));
    };
    SensitiveFileUpload.prototype.buttons = function (uploadText, currentValue) {
        return [
            React.createElement(IconButton_1.default, { toolTipContent: uploadText, onClick: this.handleSetOrChange, icon: IconButton_1.Icon.Upload }),
            currentValue.HasValue ? React.createElement(IconButton_1.default, { toolTipContent: "Remove file", onClick: this.handleRemove, icon: IconButton_1.Icon.Remove }) : null
        ].filter(function (b) { return !!b; });
    };
    return SensitiveFileUpload;
}(React.Component));
exports.default = SensitiveFileUpload;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\SensitiveFileUpload\\SensitiveFileUpload.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\SensitiveFileUpload\\SensitiveFileUpload.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ByteSizeFormatter_1 = __webpack_require__(1729);
exports.default = ByteSizeFormatter_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ByteSizeFormatter\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ByteSizeFormatter\\index.tsx"); } } })();

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chip_1 = __webpack_require__(314);
var Chips_1 = __webpack_require__(24);
var UserChip = function (props) {
    var user = props.user, rest = __rest(props, ["user"]);
    var name = userDisplayName(user);
    var description = "User: " + name;
    return React.createElement(Chip_1.default, __assign({ description: description }, rest), name);
};
exports.UserChip = UserChip;
function userDisplayName(resource) {
    return resource.DisplayName !== resource.Username
        ? resource.DisplayName + " (" + resource.Username + ")"
        : resource.DisplayName;
}
exports.userDisplayName = userDisplayName;
function userList(set, selectedIds) {
    return Chips_1.matchesToChips(set, selectedIds, function (x) { return React.createElement(UserChip, { user: x, key: x.Id }); });
}
exports.userList = userList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\UserChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Chips\\UserChip.tsx"); } } })();

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1787);
var NothingToSeeHere = (function (_super) {
    __extends(NothingToSeeHere, _super);
    function NothingToSeeHere() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NothingToSeeHere.prototype.render = function () {
        return React.createElement("p", { className: styles.content }, this.props.content);
    };
    return NothingToSeeHere;
}(React.Component));
exports.NothingToSeeHere = NothingToSeeHere;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NothingToSeeHere\\NothingToSeeHere.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NothingToSeeHere\\NothingToSeeHere.tsx"); } } })();

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var InternalLink_1 = __webpack_require__(43);
var routeLinks_1 = __webpack_require__(22);
var documentTypeToLinkLookups = lodash_1.memoize(function (spaceId) { return linksFor(spaceId); });
function linkTo(documentId, documentType, spaceId) {
    if (!documentId || !documentType) {
        return "";
    }
    var documentTypeSpecificLink = documentTypeToLinkLookups(spaceId)[documentType];
    if (!documentTypeSpecificLink) {
        return "/not-found";
    }
    return documentTypeSpecificLink(documentId);
}
exports.EventFormatter = function (props) {
    var message = props.event.Message;
    var references = props.event.MessageReferences;
    var indexes = !references || references.length === 0 ? [{ reference: null, index: 0 }, { reference: null, index: message.length }]
        : toIndexes(references, message);
    var last = null;
    var parts = [];
    indexes.map(function (index) {
        if (last) {
            parts.push({ reference: last.reference, message: message.substring(last.index, index.index) });
        }
        last = index;
    });
    var encodedParts = parts.map(function (part) {
        var encodedMessage = React.createElement("span", null, part.message);
        if (part.reference) {
            var documentId = part.reference.ReferencedDocumentId;
            var documentType = retrieveDocumentTypeFromId(documentId);
            if (documentType !== "interruption") {
                return React.createElement(InternalLink_1.default, { to: linkTo(documentId, documentType, "") }, encodedMessage);
            }
            else {
                return encodedMessage;
            }
        }
        else {
            return encodedMessage;
        }
    });
    return (React.createElement("span", null, React.Children.toArray(encodedParts)));
};
function retrieveDocumentTypeFromId(documentId) {
    var index = documentId.indexOf("-");
    return index === -1 ? null : documentId.substr(0, index).toLowerCase();
}
function toIndexes(references, message) {
    var indexes = [];
    var refStart = references[0];
    if (refStart.StartIndex !== 0) {
        indexes.push({ reference: null, index: 0 });
    }
    var lastRef = null;
    references.forEach(function (reference) {
        if (!lastRef || lastRef.StartIndex !== reference.StartIndex) {
            indexes.push({ reference: reference, index: reference.StartIndex });
        }
        indexes.push({ reference: null, index: reference.StartIndex + reference.Length });
        lastRef = reference;
    });
    var refEnd = references[references.length - 1];
    var endIndex = (refEnd.StartIndex + refEnd.Length);
    if (endIndex !== message.length) {
        indexes.push({ reference: null, index: message.length });
    }
    return indexes;
}
function linksFor(spaceId) {
    var lookup = {};
    var routeLinks = routeLinks_1.parameterizedRouteLinks(spaceId ? spaceId : "");
    lookup["actiontemplates"] = function (id) { return routeLinks.library.stepTemplate(id).root; };
    lookup["deployments"] = function (id) { return routeLinks.deployment(id).root; };
    lookup["environments"] = function (id) { return routeLinks.infrastructure.environment(id); };
    lookup["feeds"] = function (id) { return routeLinks.library.feed(id).root; };
    lookup["libraryvariablesets"] = function (id) { return routeLinks.library.variableSet(id); };
    lookup["lifecycles"] = function (id) { return routeLinks.library.lifecycle(id); };
    lookup["machinepolicies"] = function (id) { return routeLinks.infrastructure.machinePolicy(id); };
    lookup["machines"] = function (id) { return routeLinks.infrastructure.machine(id).root; };
    lookup["workers"] = function (id) { return routeLinks.infrastructure.workerMachine(id).root; };
    lookup["projects"] = function (id) { return routeLinks.project(id).root; };
    lookup["projectgroups"] = function (id) { return routeLinks.projectGroup(id).root; };
    lookup["proxys"] = function (id) { return routeLinks.infrastructure.proxy(id); };
    lookup["proxies"] = function (id) { return routeLinks.infrastructure.proxy(id); };
    lookup["releases"] = function (id) { return routeLinks.release(id); };
    lookup["servertasks"] = function (id) { return routeLinks.task(id).root; };
    lookup["tagsets"] = function (id) { return routeLinks.library.tagSet(id); };
    lookup["teams"] = function (id) { return routeLinks.configuration.team(id); };
    lookup["tenants"] = function (id) { return routeLinks.tenant(id).root; };
    lookup["users"] = function (id) { return routeLinks.configuration.user(id); };
    lookup["subscriptions"] = function (id) { return routeLinks.configuration.subscription(id); };
    lookup["certificates"] = function (id) { return routeLinks.library.certificate(id); };
    lookup["projecttriggers"] = function (id) { return routeLinks.trigger(id); };
    lookup["channels"] = function (id) { return routeLinks.channel(id); };
    return lookup;
}
exports.default = exports.EventFormatter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventFormatter\\EventFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventFormatter\\EventFormatter.tsx"); } } })();

/***/ }),
/* 805 */,
/* 806 */,
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CertificateSelector_1 = __webpack_require__(1952);
var Select_1 = __webpack_require__(40);
var https_1 = __webpack_require__(806);
var moment = __webpack_require__(119);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(1959);
var OpenDialogIconButton_1 = __webpack_require__(849);
var IconButton_1 = __webpack_require__(52);
var InputWithActions_1 = __webpack_require__(163);
var clientInstance_1 = __webpack_require__(10);
var BusyIndicator_1 = __webpack_require__(95);
var BoundField_1 = __webpack_require__(100);
var Fragment_1 = __webpack_require__(92);
var BusyRefreshContainer_1 = __webpack_require__(205);
var routeLinks_1 = __webpack_require__(22);
var toggleBusy = function (value) { return function (prev, props) { return (__assign({}, prev, { busy: value ? value : !prev.busy })); }; };
var CertificateSelect = (function (_super) {
    __extends(CertificateSelect, _super);
    function CertificateSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (certificateId) {
            var value = certificateId === "" ? null : certificateId;
            if (_this.props.validate) {
                var result = _this.props.validate(value);
                _this.setState({ error: result });
                if (_this.props.onValidate) {
                    _this.props.onValidate(result);
                }
            }
            _this.props.onChange(value);
        };
        _this.selectionRenderer = function (certificateId) {
            var certificate = _this.state.certificates.find(function (acc) { return acc.Id === certificateId; });
            if (!certificate) {
                return certificateId;
            }
            if (_this.isCertificateExpired(certificate)) {
                return React.createElement("div", { style: { color: colors_1.danger } },
                    React.createElement("span", { className: styles.selectedIcon },
                        React.createElement(https_1.default, { color: colors_1.danger })),
                    certificate.Name,
                    " (expired)");
            }
            return React.createElement("div", null,
                React.createElement("span", { className: styles.selectedIcon },
                    React.createElement(https_1.default, null)),
                certificate.Name);
        };
        _this.goToAccounts = function () {
            window.open("#" + routeLinks_1.default.library.certificates.root, "_blank");
        };
        _this.state = {
            error: null,
            showSearchDialog: false,
            certificates: [],
            isDataLoaded: false,
            busy: false
        };
        return _this;
    }
    CertificateSelect.prototype.componentDidMount = function () {
        this.loadData();
    };
    CertificateSelect.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        this.setState(toggleBusy(true));
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var certificates;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Certificates.list({ tenant: this.props.tenantId, take: 1000 })];
                                        case 1:
                                            certificates = (_a.sent()).Items;
                                            this.setState({ certificates: certificates, isDataLoaded: true });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState(toggleBusy(false));
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CertificateSelect.prototype.getItems = function () {
        var _this = this;
        return this.state.certificates.map(function (certificate) {
            var expired = _this.isCertificateExpired(certificate);
            var icon = expired ? React.createElement(https_1.default, { color: colors_1.danger }) : React.createElement(https_1.default, null);
            return {
                value: certificate.Id,
                text: certificate.Name + (expired ? " (expired)" : ""),
                icon: icon,
                style: expired ? { color: colors_1.danger } : null
            };
        });
    };
    CertificateSelect.prototype.render = function () {
        var _this = this;
        if (!this.state.isDataLoaded) {
            return React.createElement(BusyIndicator_1.default, { show: true, inline: true });
        }
        var _a = this.props, onChange = _a.onChange, onValidate = _a.onValidate, tenantId = _a.tenantId, doBusyTask = _a.doBusyTask, otherProps = __rest(_a, ["onChange", "onValidate", "tenantId", "doBusyTask"]);
        return (React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
            React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.default, __assign({ label: "Select certificate" }, otherProps, { allowFilter: true, onChange: this.handleChange, items: this.getItems(), selectionRenderer: this.selectionRenderer })), actions: React.createElement(Fragment_1.Fragment, null,
                    React.createElement(OpenDialogIconButton_1.default, { toolTipContent: "Search", wideDialog: true, icon: IconButton_1.Icon.Search },
                        React.createElement(CertificateSelector_1.default, { onSelected: function (certificate) { return _this.handleChange(certificate.Id); }, selectedCertificateId: this.props.value, tenantId: this.props.tenantId })),
                    React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.loadData(); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }),
                    React.createElement(IconButton_1.default, { toolTipContent: "Add", onClick: this.goToAccounts, icon: IconButton_1.Icon.Add })) })));
    };
    CertificateSelect.prototype.isCertificateExpired = function (certificate) {
        var now = moment();
        var certificateExpiry = moment(certificate.NotAfter);
        return certificateExpiry.isBefore(now);
    };
    return CertificateSelect;
}(React.Component));
exports.default = CertificateSelect;
exports.BoundCertificateSelect = BoundField_1.withBoundField(CertificateSelect);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var styles = __webpack_require__(271);
var DeleteDialog_1 = __webpack_require__(486);
var ActionButton_1 = __webpack_require__(49);
var OpenDeleteDialogButton = (function (_super) {
    __extends(OpenDeleteDialogButton, _super);
    function OpenDeleteDialogButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        return _this;
    }
    OpenDeleteDialogButton.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: styles.buttonWrapper },
            React.createElement(ActionButton_1.default, { type: this.props.type || ActionButton_1.ActionButtonType.Delete, onClick: function () { return _this.setState({ open: true }); }, label: this.props.label, disabled: this.props.disabled }),
            React.createElement(DeleteDialog_1.default, { title: this.props.dialogTitle, deleteButtonLabel: this.props.dialogButtonLabel, deleteButtonBusyLabel: this.props.dialogButtonBusyLabel, open: this.state.open, onClose: function () { return _this.setState({ open: false }); }, onDeleteClick: function () { return _this.props.onDeleteClick(); } }, this.props.children));
    };
    return OpenDeleteDialogButton;
}(BaseComponent_1.BaseComponent));
exports.default = OpenDeleteDialogButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\OpenDeleteDialogButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\OpenDeleteDialogButton.tsx"); } } })();

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VariablesTab;
(function (VariablesTab) {
    VariablesTab["CommonVariables"] = "commonVariables";
    VariablesTab["ProjectVariables"] = "projectVariables";
})(VariablesTab = exports.VariablesTab || (exports.VariablesTab = {}));
exports.default = function (root) { return ({
    tenants: root + "/tenants",
    tenant: function (tenantId) {
        if (typeof tenantId !== "string") {
            tenantId = tenantId.Id;
        }
        var specificRoot = root + "/tenants/" + tenantId;
        return {
            root: specificRoot,
            overview: specificRoot + "/overview",
            settings: specificRoot + "/settings",
            variables: function (activeTab) {
                return {
                    pathname: specificRoot + "/variables",
                    search: activeTab ? "?activeTab=" + activeTab : ""
                };
            }
        };
    },
    v3tenantRoutes: {
        newTenant: root + "/tenants/new"
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\TenantsRoutes\\tenantRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\TenantsRoutes\\tenantRouteLinks.ts"); } } })();

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var DataBaseComponent_1 = __webpack_require__(39);
var PaperLayout_1 = __webpack_require__(131);
var moment = __webpack_require__(119);
var resources_1 = __webpack_require__(17);
var PagingDataTable_1 = __webpack_require__(468);
var InternalLink_1 = __webpack_require__(43);
var Select_1 = __webpack_require__(40);
var DateFormatter_1 = __webpack_require__(237);
var taskResource_1 = __webpack_require__(450);
var TaskDetails_1 = __webpack_require__(789);
var styles = __webpack_require__(1563);
var AdvancedFilterLayout_1 = __webpack_require__(769);
var NavigationButton_1 = __webpack_require__(197);
var PermissionCheck_1 = __webpack_require__(42);
var permission_1 = __webpack_require__(51);
var TaskLayout_1 = __webpack_require__(798);
var routeLinks_1 = __webpack_require__(22);
var FeatureToggle_1 = __webpack_require__(305);
var QueryStringFilters_1 = __webpack_require__(307);
var ParseHelper_1 = __webpack_require__(66);
var TaskResourceDataTable = (function (_super) {
    __extends(TaskResourceDataTable, _super);
    function TaskResourceDataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TaskResourceDataTable;
}(PagingDataTable_1.PagingDataTable));
var FilterLayout = (function (_super) {
    __extends(FilterLayout, _super);
    function FilterLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FilterLayout;
}(AdvancedFilterLayout_1.default));
var TaskFilterState;
(function (TaskFilterState) {
    TaskFilterState["Incomplete"] = "Incomplete";
    TaskFilterState["Running"] = "Running";
    TaskFilterState["Completed"] = "Completed";
    TaskFilterState["Unsuccessful"] = "Unsuccessful";
    TaskFilterState["Queued"] = "Queued";
    TaskFilterState["Executing"] = "Executing";
    TaskFilterState["Cancelling"] = "Cancelling";
    TaskFilterState["Success"] = "Success";
    TaskFilterState["Canceled"] = "Canceled";
    TaskFilterState["TimedOut"] = "TimedOut";
    TaskFilterState["Failed"] = "Failed";
})(TaskFilterState = exports.TaskFilterState || (exports.TaskFilterState = {}));
function getTaskStatesFromFilterState(taskFilterState) {
    switch (taskFilterState) {
        case TaskFilterState.Incomplete:
            return [resources_1.TaskState.Queued, resources_1.TaskState.Executing, resources_1.TaskState.Cancelling].join(",");
        case TaskFilterState.Running:
            return [resources_1.TaskState.Executing, resources_1.TaskState.Cancelling].join(",");
        case TaskFilterState.Completed:
            return [resources_1.TaskState.Canceled, resources_1.TaskState.Success, resources_1.TaskState.Failed, resources_1.TaskState.TimedOut].join(",");
        case TaskFilterState.Unsuccessful:
            return [resources_1.TaskState.Canceled, resources_1.TaskState.Failed, resources_1.TaskState.TimedOut].join(",");
        case TaskFilterState.Queued:
            return resources_1.TaskState.Queued;
        case TaskFilterState.Executing:
            return resources_1.TaskState.Executing;
        case TaskFilterState.Cancelling:
            return resources_1.TaskState.Cancelling;
        case TaskFilterState.Success:
            return resources_1.TaskState.Success;
        case TaskFilterState.Canceled:
            return resources_1.TaskState.Canceled;
        case TaskFilterState.TimedOut:
            return resources_1.TaskState.TimedOut;
        case TaskFilterState.Failed:
            return resources_1.TaskState.Failed;
    }
}
function getFilter(query) {
    return {
        node: query.serverNode,
        state: TaskFilterState[query.state],
        ids: ParseHelper_1.arrayValueFromQueryString(query.ids),
        hasPendingInterruptions: query.hasPendingInterruptions === "true",
        hasWarningsOrErrors: query.hasWarningsOrErrors === "true",
        environment: query.environment,
        project: query.project,
        tenant: query.tenant,
        name: taskResource_1.TaskName[query.name]
    };
}
function getQuery(filter) {
    return {
        serverNode: filter.node,
        state: filter.state,
        ids: filter.ids,
        environment: filter.environment,
        hasPendingInterruptions: filter.hasPendingInterruptions ? "true" : undefined,
        hasWarningsOrErrors: filter.hasWarningsOrErrors ? "true" : undefined,
        name: filter.name,
        project: filter.project,
        tenant: filter.tenant
    };
}
exports.getQuery = getQuery;
var TasksQueryStringFilters = (function (_super) {
    __extends(TasksQueryStringFilters, _super);
    function TasksQueryStringFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TasksQueryStringFilters;
}(QueryStringFilters_1.QueryStringFilters));
var Tasks = (function (_super) {
    __extends(Tasks, _super);
    function Tasks(props) {
        var _this = _super.call(this, props) || this;
        _this.taskNames = [
            { value: taskResource_1.TaskName.Backup, text: "Backup" },
            { value: taskResource_1.TaskName.Deploy, text: "Deployment" },
            { value: taskResource_1.TaskName.Health, text: "Health check" },
            { value: taskResource_1.TaskName.AdHocScript, text: "Script console script" },
            { value: taskResource_1.TaskName.AutoDeploy, text: "Auto-deploy" },
            { value: taskResource_1.TaskName.ConfigureLetsEncrypt, text: "Let's encrypt" },
            { value: taskResource_1.TaskName.Upgrade, text: "Tentacle upgrade" },
            { value: taskResource_1.TaskName.TestEmail, text: "Send test email" },
            { value: taskResource_1.TaskName.TestAzureAccount, text: "Test azure account" },
            { value: taskResource_1.TaskName.TestAccount, text: "Test Account" },
            { value: taskResource_1.TaskName.Retention, text: "Apply retention policies" },
            { value: taskResource_1.TaskName.Delete, text: "Delete document" },
            { value: taskResource_1.TaskName.SystemIntegrityCheck, text: "System integrity check" },
            { value: taskResource_1.TaskName.SyncCommunityActionTemplates, text: "Sync community action templates" },
            { value: taskResource_1.TaskName.SynchronizeBuiltInPackageRepositoryIndex, text: "Sync built-in package repository" },
            { value: taskResource_1.TaskName.UpdateCalamari, text: "Update calamari" },
            { value: taskResource_1.TaskName.Subscription, text: "Process subscriptions" },
            { value: taskResource_1.TaskName.MigrationSpacePartialExport, text: "Migration - partial export" },
            { value: taskResource_1.TaskName.MigrationSpaceImport, text: "Migration - import" },
            { value: taskResource_1.TaskName.SynchronizeExternalSecurityGroupsForUsers, text: "Synchronize external security groups" },
        ].sort(function (a, b) { return a.text.localeCompare(b.text); });
        _this.doRefresh = function () { return Promise.resolve(); };
        _this.handleOnEmpty = function () {
            return (React.createElement("div", null, "No tasks found"));
        };
        _this.buildRow = function (task) {
            return [
                // mark.siedle: We want this InternalLink here so users have the option of standard
                // anchor-behaviour (ie. right click) that you don't get with the onClick from our SimpleDataTable component.
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.task(task).root },
                    React.createElement(TaskDetails_1.default, { task: task, stripTopBottomPadding: true })),
                task.State,
                task.State === resources_1.TaskState.Queued
                    ? DateFormatter_1.default.dateToLongFormat(task.QueueTime) + " (" + moment(task.QueueTime).fromNow() + ")"
                    : DateFormatter_1.default.dateToLongFormat(task.StartTime),
                DateFormatter_1.default.dateToLongFormat(task.CompletedTime),
                task.State === resources_1.TaskState.Queued ? null : task.Duration,
            ];
        };
        _this.state = {
            currentPageIndex: 0,
            filter: createEmptyFilter(),
            environments: [],
            nodes: [],
            projects: [],
            tenants: []
        };
        return _this;
    }
    Tasks.prototype.componentDidMount = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var getProjects, getEnvironments, getNodes, getTenants, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        getProjects = PermissionCheck_1.hasPermission(permission_1.default.ProjectView) ? clientInstance_1.repository.Projects.all() : Promise.resolve([]);
                        getEnvironments = PermissionCheck_1.hasPermission(permission_1.default.EnvironmentView) ? clientInstance_1.repository.Environments.all() : Promise.resolve([]);
                        getNodes = clientInstance_1.repository.OctopusServerNodes.all();
                        getTenants = clientInstance_1.repository.Tenants.all();
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getProjects];
                    case 1:
                        _b.projects = _d.sent();
                        return [4 /*yield*/, getEnvironments];
                    case 2:
                        _b.environments = _d.sent();
                        return [4 /*yield*/, getNodes];
                    case 3:
                        _b.nodes = _d.sent();
                        return [4 /*yield*/, getTenants];
                    case 4:
                        _a.apply(this, [(_b.tenants = _d.sent(),
                                _b)]);
                        _c = this;
                        return [4 /*yield*/, this.createRefreshLoop(function () { return _this.searchInternal(_this.state.filter, _this.state.currentPageIndex); }, 5000)];
                    case 5:
                        _c.doRefresh = _d.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Tasks.prototype.search = function (filter) {
        var _this = this;
        this.setState({ filter: filter, hasLoadedOnce: false, currentPageIndex: 0 }, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.doRefresh()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
    };
    Tasks.prototype.searchInternal = function (filter, currentPageIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var tasks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ currentPageIndex: currentPageIndex });
                        return [4 /*yield*/, clientInstance_1.repository.Tasks.list({
                                states: getTaskStatesFromFilterState(filter.state),
                                project: filter.project,
                                environment: filter.environment,
                                name: filter.name,
                                node: filter.node,
                                tenant: filter.tenant,
                                skip: this.state.tasks ? currentPageIndex * this.state.tasks.ItemsPerPage : 0,
                                ids: filter.ids && filter.ids.length ? filter.ids.join(",") : undefined,
                                hasPendingInterruptions: filter.hasPendingInterruptions ? true : null,
                                hasWarningsOrErrors: filter.hasWarningsOrErrors ? true : null,
                            })];
                    case 1:
                        tasks = _a.sent();
                        return [2 /*return*/, {
                                tasks: tasks,
                                hasLoadedOnce: true,
                            }];
                }
            });
        });
    };
    Tasks.prototype.clear = function () {
        return this.search(createEmptyFilter());
    };
    Tasks.prototype.render = function () {
        var _this = this;
        var list = this.state.tasks &&
            React.createElement(TaskResourceDataTable, { initialData: this.state.tasks, onRow: function (item) { return _this.buildRow(item); }, onRowRedirectUrl: function (task) { return "tasks/" + task.Id; }, rowColumnClassName: styles.taskDetailsCell, headerColumns: ["", "State", "Start Time", "Completed Time", "Duration"], onEmpty: this.handleOnEmpty, showPagingInNumberedStyle: true, currentPageIndex: this.state.currentPageIndex, onPageSelected: function (skip, p) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        this.setState({ hasLoadedOnce: false, currentPageIndex: p }, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.doRefresh()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); });
                        return [2 /*return*/];
                    });
                }); } });
        var filterSections = [
            {
                render: React.createElement("div", null,
                    React.createElement(AdvancedFilterLayout_1.AdvancedFilterCheckbox, { label: "Awaiting manual intervention", value: this.state.filter.hasPendingInterruptions, onChange: function (hasPendingInterruptions) { return _this.search(__assign({}, _this.state.filter, { hasPendingInterruptions: hasPendingInterruptions })); } }),
                    React.createElement(AdvancedFilterLayout_1.AdvancedFilterCheckbox, { label: "Has warnings or errors", value: this.state.filter.hasWarningsOrErrors, onChange: function (hasWarningsOrErrors) { return _this.search(__assign({}, _this.state.filter, { hasWarningsOrErrors: hasWarningsOrErrors })); } }),
                    React.createElement(Select_1.default, { value: this.state.filter.name, onChange: function (name) { return _this.search(__assign({}, _this.state.filter, { name: name })); }, items: this.taskNames, allowClear: true, fieldName: "task type", hintText: "All task types", label: "By task type" }),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProjectView, wildcard: true },
                        React.createElement(Select_1.default, { value: this.state.filter.project, onChange: function (project) { return _this.search(__assign({}, _this.state.filter, { project: project })); }, items: this.state.projects.map(function (p) { return ({ value: p.Id, text: p.Name }); }), allowClear: true, allowFilter: true, fieldName: "project", hintText: "All projects" })),
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.EnvironmentView, wildcard: true },
                        React.createElement(Select_1.default, { value: this.state.filter.environment, onChange: function (environment) { return _this.search(__assign({}, _this.state.filter, { environment: environment })); }, items: this.state.environments.map(function (e) { return ({ value: e.Id, text: e.Name }); }), allowClear: true, allowFilter: true, fieldName: "environment", hintText: "All environments" })),
                    React.createElement(Select_1.default, { value: this.state.filter.node, onChange: function (node) { return _this.search(__assign({}, _this.state.filter, { node: node })); }, items: this.state.nodes.map(function (n) { return ({ value: n.Id, text: n.Name }); }), allowClear: true, label: "By node", hintText: "All nodes" }),
                    React.createElement(FeatureToggle_1.FeatureToggle, { feature: FeatureToggle_1.Feature.MultiTenancy },
                        React.createElement(PermissionCheck_1.default, { permission: permission_1.default.TenantView, tenant: "*" },
                            React.createElement(Select_1.default, { value: this.state.filter.tenant, onChange: function (tenant) { return _this.search(__assign({}, _this.state.filter, { tenant: tenant })); }, items: this.state.tenants.map(function (t) { return ({ value: t.Id, text: t.Name }); }), allowClear: true, allowFilter: true, fieldName: "tenant", hintText: "All tenants", label: "By tenant" }))))
            }
        ];
        var stateFilter = React.createElement("div", { className: styles.states },
            React.createElement(Select_1.default, { value: this.state.filter.state, onChange: function (state) { return _this.search(__assign({}, _this.state.filter, { state: state })); }, items: Object.keys(TaskFilterState).map(function (t) { return ({ value: t, text: t }); }), allowClear: true, fieldName: "task state", hintText: "All task states" }));
        return React.createElement(TaskLayout_1.default, null,
            React.createElement(TasksQueryStringFilters, { filter: this.state.filter, onFilterChange: function (filter) { return _this.search(filter); }, getFilter: getFilter, getQuery: getQuery }),
            React.createElement(PaperLayout_1.default, { title: "Tasks", busy: this.state.busy, enableLessIntrusiveLoadingIndicator: this.state.hasLoadedOnce, errors: this.state.errors, sectionControl: React.createElement(PermissionCheck_1.default, { permission: [permission_1.default.AdministerSystem, permission_1.default.TaskCreate], wildcard: true },
                    React.createElement(NavigationButton_1.default, { label: "Script Console", href: routeLinks_1.default.tasks.console, type: NavigationButton_1.NavigationButtonType.Primary })), fullWidth: true },
                this.state.tasks && this.state.tasks.TotalCounts &&
                    React.createElement(StatisticsPanel, { totals: this.state.tasks.TotalCounts, setFilter: function (filter) { return _this.search(filter); } }),
                React.createElement(FilterLayout, { filter: this.state.filter, defaultFilter: createEmptyFilter(), additionalHeaderFilters: [stateFilter], onFilterReset: function (resetFilter) { return _this.search(resetFilter); }, filterSections: filterSections, renderContent: function () { return list; } })));
    };
    return Tasks;
}(DataBaseComponent_1.DataBaseComponent));
exports.Tasks = Tasks;
var StatisticsPanel = function (props) {
    var addSIfNeeded = function (length) {
        return length > 1 ? "s" : "";
    };
    var stat = function () {
        var result = [];
        var setFilter = function (e, filter) {
            e.preventDefault();
            props.setFilter(filter);
        };
        if (props.totals) {
            if (props.totals.Interrupted > 0) {
                result.push(React.createElement("span", { key: "interrupted" },
                    props.totals.Interrupted,
                    " task",
                    addSIfNeeded(props.totals.Interrupted),
                    " ",
                    React.createElement("a", { href: "#", onClick: function (e) { return setFilter(e, { hasPendingInterruptions: true }); } }, "awaiting intervention")));
            }
            if (props.totals.Executing > 0) {
                result.push(React.createElement("span", { key: "executing" },
                    props.totals.Executing,
                    " task",
                    addSIfNeeded(props.totals.Executing),
                    " ",
                    React.createElement("a", { href: "#", onClick: function (e) { return setFilter(e, { state: TaskFilterState.Executing }); } }, "running")));
            }
            if (props.totals.Cancelling > 0) {
                result.push(React.createElement("span", { key: "cancelling" },
                    props.totals.Cancelling,
                    " task",
                    addSIfNeeded(props.totals.Cancelling),
                    " ",
                    React.createElement("a", { href: "#", onClick: function (e) { return setFilter(e, { state: TaskFilterState.Cancelling }); } }, "cancelling")));
            }
            if (props.totals.Queued > 0) {
                result.push(React.createElement("span", { key: "queued" },
                    props.totals.Queued,
                    " task",
                    addSIfNeeded(props.totals.Queued),
                    " ",
                    React.createElement("a", { href: "#", onClick: function (e) { return setFilter(e, { state: TaskFilterState.Queued }); } }, "waiting in queue")));
            }
        }
        if (result.length === 0) {
            return "No active tasks";
        }
        if (result.length === 1) {
            return result;
        }
        var delimited = result.map(function (v, i) {
            if (i === result.length - 1) {
                return v;
            }
            if (i === result.length - 2) {
                return [v, React.createElement("span", null, " and ")];
            }
            return [v, React.createElement("span", null, ", ")];
        });
        return delimited;
    };
    return React.createElement("div", { className: styles.stats }, stat());
};
function createEmptyFilter() {
    return {};
}
exports.default = Tasks;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\components\\Tasks\\Tasks.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\components\\Tasks\\Tasks.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DebounceValue_1 = __webpack_require__(159);
var Text_1 = __webpack_require__(50);
var DebouncedText = DebounceValue_1.default(Text_1.default);
exports.AdvancedFilterTextInput = function (props) {
    return React.createElement(DebouncedText, { fieldName: props.fieldName, onChange: props.onChange, value: props.value });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\Text\\AdvancedFilterTextInput.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\Text\\AdvancedFilterTextInput.tsx"); } } })();

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// copied from material-ui so that we can set tabIndex
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var keyboard_arrow_up_1 = __webpack_require__(488);
var keyboard_arrow_down_1 = __webpack_require__(489);
var IconButton_1 = __webpack_require__(67);
var CardExpandable = (function (_super) {
    __extends(CardExpandable, _super);
    function CardExpandable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardExpandable.prototype.render = function () {
        return (React.createElement(IconButton_1.default, { onClick: this.props.onExpanding, tabIndex: this.props.tabIndex, title: this.props.expanded ? "Collapse" : "Expand" }, this.props.expanded ? React.createElement(keyboard_arrow_up_1.default, null) : React.createElement(keyboard_arrow_down_1.default, null)));
    };
    CardExpandable.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return CardExpandable;
}(React.Component));
exports.default = CardExpandable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\CardExpandable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\CardExpandable.tsx"); } } })();

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionList_1 = __webpack_require__(303);
exports.default = ActionList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionList\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionList\\index.tsx"); } } })();

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Lookup_1 = __webpack_require__(494);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip = function (props) {
    return React.createElement(Lookup_1.default, { lookupCollection: props.lookupCollection, lookupId: props.lookupId, allowMissingItem: props.allowMissingItem, getIdFromElement: function (element) { return element.Id; }, render: function (item) { return props.chipRender(item); }, renderFallback: React.createElement(Chips_1.MissingChip, { lookupId: props.lookupId, type: props.type }) });
};
exports.default = LookupReferenceDataItemChip;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupReferenceDataItemChip\\LookupReferenceDataItemChip.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LookupReferenceDataItemChip\\LookupReferenceDataItemChip.tsx"); } } })();

/***/ }),
/* 815 */,
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var BorderedListItem_1 = __webpack_require__(711);
__export(__webpack_require__(711));
exports.default = BorderedListItem_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BorderedListItem\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\BorderedListItem\\index.ts"); } } })();

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WindowHelper = (function () {
    function WindowHelper() {
    }
    WindowHelper.isElementInViewport = function (el) {
        var rect = el.getBoundingClientRect();
        var vWidth = window.innerWidth || document.documentElement.clientWidth;
        var vHeight = window.innerHeight || document.documentElement.clientHeight;
        return (rect.bottom > 0 &&
            rect.right > 0 &&
            rect.left < vWidth &&
            rect.top < vHeight);
    };
    WindowHelper.isElementCenterTouchable = function (el) {
        var rect = el.getBoundingClientRect();
        return el.contains(document.elementFromPoint(rect.right - (rect.width / 2), rect.bottom - (rect.height / 2)));
    };
    return WindowHelper;
}());
exports.default = WindowHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\WindowHelper\\WindowHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\WindowHelper\\WindowHelper.tsx"); } } })();

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var PagingDataTable_1 = __webpack_require__(468);
var EventFormatter_1 = __webpack_require__(804);
var clientInstance_1 = __webpack_require__(10);
var permission_1 = __webpack_require__(51);
var PermissionCheck_1 = __webpack_require__(455);
var Callout_1 = __webpack_require__(57);
var ExternalLink_1 = __webpack_require__(26);
var Button_1 = __webpack_require__(47);
var EventDetails_1 = __webpack_require__(841);
var TimeFromNowLabel_1 = __webpack_require__(460);
var styles = __webpack_require__(1795);
var EventListingDataTable = (function (_super) {
    __extends(EventListingDataTable, _super);
    function EventListingDataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventListingDataTable;
}(PagingDataTable_1.PagingDataTable));
var EventListing = (function (_super) {
    __extends(EventListing, _super);
    function EventListing(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnEmpty = function () {
            return (React.createElement("div", null,
                "No events found, or ",
                React.createElement(ExternalLink_1.default, { href: "UserRoles" }, "your permissions"),
                " reduced what you can see."));
        };
        _this.handleShowHideDetails = function (event) {
            event.detailsVisible = !event.detailsVisible;
            _this.setState({});
        };
        _this.state = {
            data: null
        };
        return _this;
    }
    EventListing.prototype.render = function () {
        var _this = this;
        var initialData = this.state.data ? this.state.data : this.props.data;
        return React.createElement("div", null,
            React.createElement(PermissionCheck_1.PermissionCheck, { permission: permission_1.Permission.EventView, wildcard: true, alternate: React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "The ",
                    permission_1.Permission.EventView,
                    " permission is required to view results here.") }, initialData
                ? React.createElement(EventListingDataTable, { initialData: initialData, onRow: function (item) { return _this.buildAuditRow(item); }, headerColumns: ["When", "Who", "What"], headerColumnClassNames: [styles.headerColumnOccurredDate, styles.headerColumnFixedWidth, null], onEmpty: this.handleOnEmpty, showPagingInNumberedStyle: true, onPageSelected: function (skip, p) { return __awaiter(_this, void 0, void 0, function () {
                        var result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.Events.list({ regarding: this.props.regarding, skip: skip })];
                                case 1:
                                    result = _a.sent();
                                    this.setState({ data: result });
                                    return [2 /*return*/];
                            }
                        });
                    }); } })
                : React.createElement("div", null, this.props.noDataMessage || "There's no data to show.")));
    };
    EventListing.prototype.buildAuditRow = function (event) {
        var _this = this;
        return [
            React.createElement("div", null,
                React.createElement(TimeFromNowLabel_1.default, { time: event.Occurred, useShortDateFormat: false })),
            React.createElement("div", { title: event.IdentityEstablishedWith }, event.Username),
            React.createElement("div", null,
                React.createElement(EventFormatter_1.EventFormatter, { event: event }),
                event.Details &&
                    React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Ternary, label: event.detailsVisible ? "hide details" : "show details", onClick: function () { return _this.handleShowHideDetails(event); } }),
                event.Details && event.detailsVisible && React.createElement(EventDetails_1.default, { eventDetails: event.Details }))
        ];
    };
    return EventListing;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = EventListing;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventListing\\EventListing.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventListing\\EventListing.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdHelper_1 = __webpack_require__(1803);
exports.default = IdHelper_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\IdHelper\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\IdHelper\\index.tsx"); } } })();

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(497);
var ExecutingIcon_1 = __webpack_require__(1827);
var phaseHelpers_1 = __webpack_require__(714);
var PhaseStatusIcon = function (props) {
    var classes = getClasses(props.phase, props.status, props.environmentId);
    return showExecutingIcon(classes)
        ? React.createElement(ExecutingIcon_1.default, null)
        : React.createElement("span", { className: cn(styles.phaseIcon, classes) });
};
var showExecutingIcon = function (classes) {
    return classes[styles.executing]
        && !classes[styles.queued]
        && !classes[styles.warning]
        && !classes[styles.skipped];
};
var getClasses = function (phase, status, environmentId) {
    if (!environmentId) {
        return _a = {},
            _a[styles.optional] = phase.IsOptionalPhase,
            _a[styles.blocked] = status.progress[phase.Name] === "Blocked",
            _a[styles.current] = status.progress[phase.Name] === "Current",
            _a[styles.complete] = status.progress[phase.Name] === "Complete",
            _a[styles.automatic] = phase.AutomaticDeploymentTargets.length > 0,
            _a[styles.deployed] = status.deployed[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.executing] = status.executing[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.queued] = status.queued[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.warning] = status.warning[phaseHelpers_1.getSingleDeploymentTarget(phase)],
            _a[styles.skipped] = phaseHelpers_1.getSkippedState(phase, status),
            _a;
    }
    else {
        return _b = {},
            _b[styles.blocked] = phase.AutomaticDeploymentTargets.length > 0 ? false : status.progress[phase.Name] === "Blocked",
            _b[styles.automatic] = status.deployed[environmentId] ? false : phase.AutomaticDeploymentTargets.some(function (envId) { return envId === environmentId; }),
            _b[styles.deployed] = status.deployed[environmentId],
            _b[styles.warning] = status.warning[environmentId],
            _b[styles.executing] = status.executing[environmentId],
            _b[styles.queued] = status.queued[environmentId],
            _b[styles.skipped] = phase.IsOptionalPhase && !status.deployed[environmentId] && status.progress[phase.Name] !== "Blocked",
            _b;
    }
    var _a, _b;
};
exports.default = PhaseStatusIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PhaseStatusIcon\\PhaseStatusIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PhaseStatusIcon\\PhaseStatusIcon.tsx"); } } })();

/***/ }),
/* 821 */,
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Summary_1 = __webpack_require__(44);
var resources_1 = __webpack_require__(17);
var Options_1 = __webpack_require__(483);
var ActionTemplateParameterInput_1 = __webpack_require__(425);
var ExpandableFormSection_1 = __webpack_require__(30);
var ActionTemplateParameterInputRenderer_1 = __webpack_require__(850);
var ActionTemplateParameterInputExpandableFormElement = (function (_super) {
    __extends(ActionTemplateParameterInputExpandableFormElement, _super);
    function ActionTemplateParameterInputExpandableFormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionTemplateParameterInputExpandableFormElement.prototype.shouldComponentUpdate = function (newProps) {
        return ActionTemplateParameterInputRenderer_1.hasParameterChanged(newProps, this.props);
    };
    ActionTemplateParameterInputExpandableFormElement.prototype.render = function () {
        var _a = this.props, isExpandedByDefault = _a.isExpandedByDefault, customHelpText = _a.customHelpText, inputProps = __rest(_a, ["isExpandedByDefault", "customHelpText"]);
        var parameter = inputProps.parameter;
        var options = Options_1.default(parameter.DisplaySettings["Octopus.SelectOptions"]);
        var type = parameter.DisplaySettings["Octopus.ControlType"];
        var label = ActionTemplateParameterInputRenderer_1.getLabel(parameter);
        return React.createElement(ExpandableFormSection_1.default, { errorKey: parameter.Name, title: label, isExpandedByDefault: isExpandedByDefault, help: ActionTemplateParameterInputRenderer_1.getHelpText(parameter, customHelpText), summary: createSummaryFor(label, type, options)(this.props.value) },
            React.createElement(ActionTemplateParameterInput_1.default, __assign({}, inputProps)));
    };
    return ActionTemplateParameterInputExpandableFormElement;
}(React.Component));
exports.default = ActionTemplateParameterInputExpandableFormElement;
function createSummaryFor(label, type, options) {
    return function (value) {
        if (value === undefined || value === null) {
            return Summary_1.default.placeholder("Provide " + label);
        }
        if (typeof value === "object") {
            return Summary_1.default.summary("******");
        }
        if (type === resources_1.ControlType.Select) {
            var option = options.find(function (o) { return o.value === value; });
            if (option) {
                return Summary_1.default.summary(option.text);
            }
        }
        return Summary_1.default.summary(value);
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputExpandableFormElement.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputExpandableFormElement.tsx"); } } })();

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(120);
var URITemplate = __webpack_require__(968);
// The Resolver is used to take URI's like "/api/foo/bar" and turn them into
// fully qualified URI's depending on the Octopus
// server we are talking to (e.g.,
// http://your-octopus/api/foo/bar or perhaps even, http://your-octopus/vdir1/vdir2/api/foo/bar).
var Resolver = (function () {
    function Resolver(baseUri) {
        this.baseUri = baseUri;
        this.baseUri = this.baseUri.endsWith("/") ? this.baseUri : this.baseUri + "/";
        var lastIndexOfMandatorySegment = this.baseUri.lastIndexOf("/api/");
        if (lastIndexOfMandatorySegment >= 1) {
            this.baseUri = this.baseUri.substring(0, lastIndexOfMandatorySegment);
        }
        else {
            if (this.baseUri.endsWith("/api")) {
                this.baseUri = this.baseUri.substring(0, -4);
            }
        }
        this.baseUri = this.baseUri.endsWith("/") ? this.baseUri.substring(0, this.baseUri.length - 1) : this.baseUri;
        var parsed = URI(this.baseUri);
        this.rootUri = parsed.scheme() + "://" + parsed.authority();
        this.rootUri = this.rootUri.endsWith("/") ? this.rootUri.substring(0, this.rootUri.length - 1) : this.rootUri;
    }
    Resolver.prototype.resolve = function (path, uriTemplateParameters) {
        if (!path) {
            throw new Error("The link is not set to a value");
        }
        if (path.startsWith("~/")) {
            path = path.substring(1, path.length);
            path = this.baseUri + path;
        }
        else {
            path = this.rootUri + path;
        }
        var template = new URITemplate(path);
        var result = template.expand(uriTemplateParameters || {});
        return result;
    };
    return Resolver;
}());
exports.default = Resolver;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resolver.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resolver.ts"); } } })();

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LicenseKind;
(function (LicenseKind) {
    LicenseKind["Unlicensed"] = "Unlicensed";
    LicenseKind["Trial"] = "Trial";
    LicenseKind["CommunityEdition"] = "CommunityEdition";
    LicenseKind["CommercialLicense"] = "CommercialLicense";
})(LicenseKind = exports.LicenseKind || (exports.LicenseKind = {}));
var LicenseMessageDisposition;
(function (LicenseMessageDisposition) {
    LicenseMessageDisposition["Information"] = "Information";
    LicenseMessageDisposition["Warning"] = "Warning";
    LicenseMessageDisposition["Error"] = "Error";
})(LicenseMessageDisposition = exports.LicenseMessageDisposition || (exports.LicenseMessageDisposition = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\licenseStatusResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\licenseStatusResource.ts"); } } })();

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PhaseProgress;
(function (PhaseProgress) {
    PhaseProgress["Pending"] = "Pending";
    PhaseProgress["Current"] = "Current";
    PhaseProgress["Complete"] = "Complete";
})(PhaseProgress = exports.PhaseProgress || (exports.PhaseProgress = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\lifecycleProgressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\lifecycleProgressionResource.ts"); } } })();

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineModelHealthStatus;
(function (MachineModelHealthStatus) {
    MachineModelHealthStatus["Healthy"] = "Healthy";
    MachineModelHealthStatus["Unavailable"] = "Unavailable";
    MachineModelHealthStatus["Unknown"] = "Unknown";
    MachineModelHealthStatus["HasWarnings"] = "HasWarnings";
    MachineModelHealthStatus["Unhealthy"] = "Unhealthy";
})(MachineModelHealthStatus = exports.MachineModelHealthStatus || (exports.MachineModelHealthStatus = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineResource.ts"); } } })();

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Octopus prefix is used here as there is already a built-in type called Error
var OctopusError = (function (_super) {
    __extends(OctopusError, _super);
    function OctopusError(StatusCode, message) {
        var _this = _super.call(this, message) || this;
        _this.StatusCode = StatusCode;
        _this.ErrorMessage = message;
        _this.Errors = [];
        Object.setPrototypeOf(_this, OctopusError.prototype);
        return _this;
    }
    OctopusError.create = function (statusCode, response) {
        var e = new OctopusError(statusCode);
        var n = __assign({}, e, response);
        Object.setPrototypeOf(n, OctopusError.prototype);
        return n;
    };
    return OctopusError;
}(Error));
exports.OctopusError = OctopusError;
exports.default = OctopusError;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\octopusError.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\octopusError.ts"); } } })();

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var TextField_1 = __webpack_require__(666);
var DropDownMenu_1 = __webpack_require__(1529);
var colors_1 = __webpack_require__(31);
var fontWeights_1 = __webpack_require__(83);
function getStyles(props, _) {
    return {
        root: {
            marginTop: 0,
        },
        label: {
            paddingLeft: 0,
            top: props.floatingLabelText ? 14 : -4,
        },
        floatingLabelStyle: {
            fontWeight: fontWeights_1.normal,
            color: colors_1.secondaryText,
        },
        icon: {
            right: 0,
            top: props.floatingLabelText ? 8 : 0,
            marginTop: 0,
            fill: colors_1.secondaryText,
        },
        hideDropDownUnderline: {
            borderTop: "none",
        },
        dropDownMenu: {
            display: "block",
        },
    };
}
var SelectField = (function (_super) {
    __extends(SelectField, _super);
    function SelectField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectField.prototype.render = function () {
        var _a = this.props, allowClear = _a.allowClear, autoWidth = _a.autoWidth, multiple = _a.multiple, children = _a.children, style = _a.style, labelStyle = _a.labelStyle, iconStyle = _a.iconStyle, id = _a.id, underlineDisabledStyle = _a.underlineDisabledStyle, underlineFocusStyle = _a.underlineFocusStyle, menuItemStyle = _a.menuItemStyle, selectedMenuItemStyle = _a.selectedMenuItemStyle, underlineStyle = _a.underlineStyle, dropDownMenuProps = _a.dropDownMenuProps, errorStyle = _a.errorStyle, disabled = _a.disabled, floatingLabelFixed = _a.floatingLabelFixed, floatingLabelText = _a.floatingLabelText, floatingLabelStyle = _a.floatingLabelStyle, hintStyle = _a.hintStyle, hintText = _a.hintText, fullWidth = _a.fullWidth, errorText = _a.errorText, listStyle = _a.listStyle, maxHeight = _a.maxHeight, menuStyle = _a.menuStyle, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, selectionRenderer = _a.selectionRenderer, value = _a.value, type = _a.type, filter = _a.filter, autoFocus = _a.autoFocus, other = __rest(_a, ["allowClear", "autoWidth", "multiple", "children", "style", "labelStyle", "iconStyle", "id", "underlineDisabledStyle", "underlineFocusStyle", "menuItemStyle", "selectedMenuItemStyle", "underlineStyle", "dropDownMenuProps", "errorStyle", "disabled", "floatingLabelFixed", "floatingLabelText", "floatingLabelStyle", "hintStyle", "hintText", "fullWidth", "errorText", "listStyle", "maxHeight", "menuStyle", "onFocus", "onBlur", "onChange", "selectionRenderer", "value", "type", "filter", "autoFocus"]);
        var styles = getStyles(this.props, this.context);
        return (React.createElement(TextField_1.default, __assign({}, other, { style: style, disabled: disabled, floatingLabelFixed: floatingLabelFixed, floatingLabelText: floatingLabelText, floatingLabelStyle: Object.assign(styles.floatingLabelStyle, floatingLabelStyle), hintStyle: hintStyle, hintText: (!hintText && !floatingLabelText) ? " " : hintText, fullWidth: fullWidth, errorText: errorText, underlineStyle: { borderColor: colors_1.secondaryText, position: "relative" }, errorStyle: errorStyle, onFocus: onFocus, onBlur: onBlur, id: id, underlineDisabledStyle: underlineDisabledStyle, underlineFocusStyle: { borderColor: colors_1.primary, bottom: "10px" } }),
            React.createElement(DropDownMenu_1.default, __assign({ allowClear: allowClear, disabled: disabled, style: Object.assign(styles.dropDownMenu, menuStyle), labelStyle: Object.assign(styles.label, labelStyle), iconStyle: Object.assign(styles.icon, iconStyle), menuItemStyle: menuItemStyle, selectedMenuItemStyle: selectedMenuItemStyle, underlineStyle: styles.hideDropDownUnderline, listStyle: listStyle, autoWidth: autoWidth, value: value, onChange: onChange, maxHeight: maxHeight, multiple: multiple, selectionRenderer: selectionRenderer, filter: filter, autoFocus: autoFocus }, dropDownMenuProps), children)));
    };
    // static propTypes = {
    //   /**
    //    * If true, the width will automatically be set according to the
    //    * items inside the menu.
    //    * To control the width in CSS instead, leave this prop set to `false`.
    //    */
    //   autoWidth: PropTypes.bool,
    //   /**
    //    * The `MenuItem` elements to populate the select field with.
    //    * If the menu items have a `label` prop, that value will
    //    * represent the selected menu item in the rendered select field.
    //    */
    //   children: PropTypes.node,
    //   /**
    //    * If true, the select field will be disabled.
    //    */
    //   disabled: PropTypes.bool,
    //   /**
    //    * Object that can handle and override any property of component DropDownMenu.
    //    */
    //   dropDownMenuProps: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the error element.
    //    */
    //   errorStyle: PropTypes.object,
    //   /**
    //    * The error content to display.
    //    */
    //   errorText: PropTypes.node,
    //   /**
    //    * If true, the floating label will float even when no value is selected.
    //    */
    //   floatingLabelFixed: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of the floating label.
    //    */
    //   floatingLabelStyle: PropTypes.object,
    //   /**
    //    * The content of the floating label.
    //    */
    //   floatingLabelText: PropTypes.node,
    //   /**
    //    * If true, the select field will take up the full width of its container.
    //    */
    //   fullWidth: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of the hint element.
    //    */
    //   hintStyle: PropTypes.object,
    //   /**
    //    * The hint content to display.
    //    */
    //   hintText: PropTypes.node,
    //   /**
    //    * Override the inline-styles of the icon element.
    //    */
    //   iconStyle: PropTypes.object,
    //   /**
    //    * The id prop for the text field.
    //    */
    //   id: PropTypes.string,
    //   /**
    //    * Override the label style when the select field is inactive.
    //    */
    //   labelStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underlying `List` element.
    //    */
    //   listStyle: PropTypes.object,
    //   /**
    //    * Override the default max-height of the underlying `DropDownMenu` element.
    //    */
    //   maxHeight: PropTypes.number,
    //   /**
    //    * Override the inline-styles of menu items.
    //    */
    //   menuItemStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underlying `DropDownMenu` element.
    //    */
    //   menuStyle: PropTypes.object,
    //   /**
    //    * If true, `value` must be an array and the menu will support
    //    * multiple selections.
    //    */
    //   multiple: PropTypes.bool,
    //   /** @ignore */
    //   onBlur: PropTypes.func,
    //   /**
    //    * Callback function fired when a menu item is selected.
    //    *
    //    * @param {object} event TouchTap event targeting the menu item
    //    * that was selected.
    //    * @param {number} key The index of the selected menu item, or undefined
    //    * if `multiple` is true.
    //    * @param {any} payload If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    */
    //   onChange: PropTypes.func,
    //   /** @ignore */
    //   onFocus: PropTypes.func,
    //   /**
    //    * Override the inline-styles of selected menu items.
    //    */
    //   selectedMenuItemStyle: PropTypes.object,
    //   /**
    //    * Customize the rendering of the selected item.
    //    *
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    * @param {any} menuItem The selected `MenuItem`.
    //    * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
    //    */
    //   selectionRenderer: PropTypes.func,
    //   /**
    //    * Override the inline-styles of the root element.
    //    */
    //   style: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element when the select
    //    * field is disabled.
    //    */
    //   underlineDisabledStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element when the select field
    //    * is focused.
    //    */
    //   underlineFocusStyle: PropTypes.object,
    //   /**
    //    * Override the inline-styles of the underline element.
    //    */
    //   underlineStyle: PropTypes.object,
    //   /**
    //    * If `multiple` is true, an array of the `value`s of the selected
    //    * menu items. Otherwise, the `value` of the selected menu item.
    //    * If provided, the menu will be a controlled component.
    //    */
    //   value: PropTypes.any,
    //   filter: PropTypes.node,
    // };
    SelectField.defaultProps = {
        autoWidth: false,
        disabled: false,
        fullWidth: false,
        multiple: false,
    };
    SelectField.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return SelectField;
}(React.Component));
exports.default = SelectField;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\SelectField.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\SelectField.tsx"); } } })();

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentRow_1 = __webpack_require__(785);
exports.default = ComponentRow_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ComponentRow\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ComponentRow\\index.tsx"); } } })();

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProjectDashboard_1 = __webpack_require__(1671);
exports.default = ProjectDashboard_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\index.tsx"); } } })();

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TaskStatusIcon_1 = __webpack_require__(462);
var cn = __webpack_require__(19);
var DateFormatter_1 = __webpack_require__(237);
var styles = __webpack_require__(1688);
var InternalLink_1 = __webpack_require__(43);
var routeLinks_1 = __webpack_require__(22);
var index_1 = __webpack_require__(24);
var TaskStatusDetails = function (props) {
    var task = props.item;
    var additional = task.IsPrevious ? styles.taskPrevious : (task.IsCurrent === false ? styles.taskArchived : "");
    var link = (props.deploymentId && props.projectSlug) ?
        routeLinks_1.default.project(props.projectSlug).release(task.ReleaseVersion).deployments.specific(props.deploymentId) :
        routeLinks_1.default.task(task.TaskId).root;
    return (React.createElement(InternalLink_1.default, { to: link, className: styles.taskLink, width: "100%" },
        React.createElement("div", { className: cn(styles.container, additional), style: props.style },
            React.createElement(TaskStatusIcon_1.TaskStatusIcon, { item: task, smallIcon: false }),
            React.createElement("div", { className: styles.details },
                React.createElement("span", { className: styles.version }, task.ReleaseVersion),
                props.showName && React.createElement("div", { className: styles.taskName },
                    "\u21E2\u00A0",
                    task.Name),
                props.channelName && React.createElement(index_1.ChannelChip, { channelName: props.channelName, noMargin: true }),
                React.createElement("span", { title: DateFormatter_1.default.dateToLongFormat(task.StartTime || task.QueueTime), className: styles.date }, DateFormatter_1.default.dateToShortFormat(task.StartTime || task.QueueTime))),
            props.additionalDetails && React.createElement("div", { className: styles.additionalDetails }, props.additionalDetails))));
};
exports.TaskStatusDetails = TaskStatusDetails;
TaskStatusDetails.displayName = "TaskStatusDetails";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TaskStatusDetails\\TaskStatusDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TaskStatusDetails\\TaskStatusDetails.tsx"); } } })();

/***/ }),
/* 832 */,
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(17);
var DashboardDataCube_1 = __webpack_require__(1702);
var ProgressionDataCube_1 = __webpack_require__(1703);
var DataCube_1 = __webpack_require__(242);
var tenantTagsets = __webpack_require__(156);
var DataBaseComponent_1 = __webpack_require__(39);
var lodash_1 = __webpack_require__(11);
var refreshIntervalInMs = 6000;
var DashboardDataSource = (function (_super) {
    __extends(DashboardDataSource, _super);
    function DashboardDataSource(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshCube = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this.refreshFunction()];
                    case 1: return [2 /*return*/, (_a.cube = _b.sent(), _a)];
                }
            });
        }); };
        _this.state = {
            hasInitialLoaded: false
        };
        return _this;
    }
    DashboardDataSource.prototype.componentDidMount = function () {
        var _this = this;
        this.project = this.props.project;
        this.filters = this.props.filters;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setupDashboard();
                        _a = this;
                        return [4 /*yield*/, this.createRefreshLoop(this.refreshCube, refreshIntervalInMs, true)];
                    case 1:
                        _a.refresh = _b.sent();
                        this.setState({ hasInitialLoaded: true });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DashboardDataSource.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var shouldRefresh = false;
        if (nextProps.filters !== this.props.filters) {
            shouldRefresh = true;
        }
        if (nextProps.project !== this.props.project) {
            shouldRefresh = true;
        }
        if (!shouldRefresh) {
            return;
        }
        this.project = nextProps.project;
        this.filters = nextProps.filters;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setupDashboard();
                        if (!this.refresh) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.refresh()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    DashboardDataSource.prototype.render = function () {
        return this.props.render(this.state);
    };
    DashboardDataSource.prototype.loadDashboardData = function (releaseId) {
        var args = this.project
            ? { projectId: this.project.Id, showAll: true }
            : { highestLatestVersionPerProjectAndEnvironment: true };
        if (releaseId) {
            args.releaseId = releaseId;
        }
        return clientInstance_1.repository.Dashboards.getDashboard(args);
    };
    DashboardDataSource.prototype.loadProgressionData = function () {
        return clientInstance_1.repository.Progression.getProgression(this.project);
    };
    DashboardDataSource.prototype.loadChannels = function (channelIds) {
        return clientInstance_1.repository.Channels.all({ ids: channelIds });
    };
    DashboardDataSource.prototype.loadReleases = function (releaseId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!releaseId) return [3 /*break*/, 2];
                        _b = (_a = Promise).resolve;
                        return [4 /*yield*/, clientInstance_1.repository.Releases.get(releaseId)];
                    case 1: return [2 /*return*/, _b.apply(_a, [[_c.sent()]])];
                    case 2: return [4 /*yield*/, clientInstance_1.repository.Projects.getReleases(this.project)];
                    case 3:
                        result = _c.sent();
                        return [2 /*return*/, result.Items];
                }
            });
        });
    };
    DashboardDataSource.prototype.filteredRelease = function () {
        if (this.filters[DataCube_1.DimensionTypes.Release]) {
            return Object.keys(this.filters[DataCube_1.DimensionTypes.Release])[0];
        }
        return null;
    };
    DashboardDataSource.prototype.loadPromotionData = function (release) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, clientInstance_1.repository.Releases.getDeploymentTemplate(release)];
            });
        });
    };
    DashboardDataSource.prototype.loadLifecycles = function (channelsAsync) {
        return __awaiter(this, void 0, void 0, function () {
            var channels, lifecycleIds, lifecycles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, channelsAsync];
                    case 1:
                        channels = _a.sent();
                        lifecycleIds = channels.map(function (channel) { return channel.LifecycleId; });
                        return [4 /*yield*/, clientInstance_1.repository.Lifecycles.allById(lifecycleIds)];
                    case 2:
                        lifecycles = _a.sent();
                        return [2 /*return*/, Object.keys(lifecycles).map(function (id) { return lifecycles[id]; })];
                }
            });
        });
    };
    DashboardDataSource.prototype.listTenantsWithMissingVariables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var missingVariables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Tenants.missingVariables({ projectId: this.project.Id }, false)];
                    case 1:
                        missingVariables = _a.sent();
                        return [2 /*return*/, missingVariables.map(function (mv) { return mv.TenantId; })];
                }
            });
        });
    };
    DashboardDataSource.prototype.setupMainDashboard = function () {
        var _this = this;
        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDashboardData()];
                    case 1:
                        data = _a.sent();
                        this.setState({ projectLimit: data.ProjectLimit || 200 });
                        return [2 /*return*/, new DashboardDataCube_1.default(data, data.Tenants, [], [], null, [], [])];
                }
            });
        }); };
    };
    DashboardDataSource.prototype.setupTenantedProjectDashboard = function () {
        var _this = this;
        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
            var releaseId, releases, channeldIds, channelsLoader, _a, data, channels, promotions, tagSets, lifecycles, missingVariableTenants;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        releaseId = this.filteredRelease();
                        return [4 /*yield*/, this.loadReleases(releaseId)];
                    case 1:
                        releases = _b.sent();
                        channeldIds = lodash_1.uniq(releases.map(function (r) { return r.ChannelId; }));
                        channelsLoader = this.loadChannels(channeldIds);
                        return [4 /*yield*/, Promise.all([
                                this.loadDashboardData(releaseId),
                                channelsLoader,
                                releaseId ? this.loadPromotionData(releases[0]) : Promise.resolve(null),
                                tenantTagsets.getAll(),
                                this.loadLifecycles(channelsLoader),
                                this.listTenantsWithMissingVariables()
                            ])];
                    case 2:
                        _a = _b.sent(), data = _a[0], channels = _a[1], promotions = _a[2], tagSets = _a[3], lifecycles = _a[4], missingVariableTenants = _a[5];
                        return [2 /*return*/, new DashboardDataCube_1.default(data, data.Tenants, releases, channels, promotions, tagSets, lifecycles, this.project, releaseId, missingVariableTenants)];
                }
            });
        }); };
    };
    DashboardDataSource.prototype.setupProjectDashboard = function () {
        var _this = this;
        this.refreshFunction = function () { return __awaiter(_this, void 0, void 0, function () {
            var data, channeldIds, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadProgressionData()];
                    case 1:
                        data = _a.sent();
                        channeldIds = Object.keys(data.ChannelEnvironments);
                        return [4 /*yield*/, this.loadChannels(channeldIds)];
                    case 2:
                        channels = _a.sent();
                        return [2 /*return*/, new ProgressionDataCube_1.default(data, channels, this.project)];
                }
            });
        }); };
    };
    DashboardDataSource.prototype.setupDashboard = function () {
        if (!this.project) {
            this.setupMainDashboard();
        }
        else if (this.project.TenantedDeploymentMode !== resources_1.TenantedDeploymentMode.Untenanted) {
            this.setupTenantedProjectDashboard();
        }
        else {
            this.setupProjectDashboard();
        }
    };
    return DashboardDataSource;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DashboardDataSource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataSource.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataSource.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InputWithActions_1 = __webpack_require__(163);
var Text_1 = __webpack_require__(50);
var IconButtonList_1 = __webpack_require__(124);
var IconButton_1 = __webpack_require__(52);
var FileUpload = (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFileChange = function (e) {
            if (e.target.files.length < 1) {
                return;
            }
            var file = e.target.files[0];
            _this.props.onChange(file);
        };
        _this.handleClearSelected = function () {
            _this.input.value = null;
            _this.props.onChange(null);
        };
        _this.openSelector = function () {
            _this.input.click();
        };
        _this.noop = function () {
            // Empty on purpose
        };
        return _this;
    }
    FileUpload.prototype.render = function () {
        var _this = this;
        var name = this.props.value ? this.props.value.name : "";
        return React.createElement("div", null,
            React.createElement(InputWithActions_1.default, { input: React.createElement(Text_1.default, { hintText: this.props.hintText, value: name, onChange: this.noop, label: this.props.label, onClick: this.openSelector }), actions: React.createElement(IconButtonList_1.default, { buttons: this.buttons() }) }),
            React.createElement("input", { type: "file", style: { display: "none" }, onChange: this.handleFileChange, ref: function (input) { return _this.input = input; } }));
    };
    FileUpload.prototype.buttons = function () {
        return [
            React.createElement(IconButton_1.default, { toolTipContent: "Choose file", onClick: this.openSelector, icon: IconButton_1.Icon.Upload }),
            this.props.value ? React.createElement(IconButton_1.default, { toolTipContent: "Remove file", onClick: this.handleClearSelected, icon: IconButton_1.Icon.Remove }) : null
        ].filter(function (b) { return !!b; });
    };
    return FileUpload;
}(React.Component));
exports.default = FileUpload;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\FileUpload\\FileUpload.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\FileUpload\\FileUpload.tsx"); } } })();

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var showdown = __webpack_require__(1740);
var xss = __webpack_require__(1741);
var style = __webpack_require__(1745);
var Markdown = function (props) {
    var converter = new showdown.Converter({
        tables: true,
        strikethrough: true,
        openLinksInNewWindow: true,
        disableForced4SpacesIndentedSublists: true,
        literalMidWordUnderscores: true
    });
    var html = xss(converter.makeHtml(props.markup));
    return React.createElement("div", { className: style.markdown, dangerouslySetInnerHTML: { __html: html } });
};
exports.default = Markdown;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Markdown\\Markdown.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Markdown\\Markdown.tsx"); } } })();

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LookupResourceChip_1 = __webpack_require__(160);
var Chips_1 = __webpack_require__(24);
var MultiSelect_1 = __webpack_require__(111);
var UserChip_1 = __webpack_require__(802);
var UserTypedMultiSelect = MultiSelect_1.default();
var LookupUserChip = LookupResourceChip_1.default();
var UserMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupUserChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.Environment, chipRender: function (item) { return React.createElement(UserChip_1.UserChip, { onRequestDelete: onRequestDelete, user: item }); } });
    };
    var items = props.items, rest = __rest(props, ["items"]);
    return React.createElement(UserTypedMultiSelect, __assign({ items: items.map(function (i) {
            var user = __assign({}, i, { Name: UserChip_1.userDisplayName(i) + " " + (i.EmailAddress || "") });
            return user;
        }), fieldName: "users", renderChip: chipRenderer, renderItem: function (i) { return ({ primaryText: UserChip_1.userDisplayName(i), secondaryText: i.EmailAddress }); } }, rest));
};
exports.default = UserMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\UserMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\UserMultiSelect.tsx"); } } })();

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function findKey(val, template) {
    if (!template) {
        return val;
    }
    var found = Object.keys(template).find(function (k) { return k.toLowerCase() === val.toLowerCase(); });
    return found ? found : val;
}
function matchErrorsToFieldNames(err, template) {
    var details = err.Details
        ? Object.keys(err.Details).reduce(function (acc, val) {
            acc[findKey(val, template)] = err.Details[val];
            return acc;
        }, {})
        : {};
    return __assign({}, details);
}
exports.default = matchErrorsToFieldNames;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\matchErrorsToFieldNames.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FormBaseComponent\\matchErrorsToFieldNames.ts"); } } })();

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var index_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_1 = __webpack_require__(24);
var ProjectGroupTypedMultiSelect = MultiSelect_1.MultiSelect();
exports.ProjectGroupMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.ProjectGroup, chipRender: function (item) { return React.createElement(index_1.ProjectGroupChip, { onRequestDelete: onRequestDelete, projectGroup: item }); } });
    };
    return React.createElement(ProjectGroupTypedMultiSelect, __assign({ items: props.items, label: "Select project groups", renderChip: chipRenderer }, props));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ProjectGroupMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\ProjectGroupMultiSelect.tsx"); } } })();

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Section_1 = __webpack_require__(81);
var OpenDialogButton_1 = __webpack_require__(72);
var RemoveItemsList_1 = __webpack_require__(84);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var AddApiKeyDialog_1 = __webpack_require__(1773);
var NothingToSeeHere_1 = __webpack_require__(1786);
var TimeFromNowLabel_1 = __webpack_require__(460);
var styles = __webpack_require__(712);
var ApiKeyList = (function (_super) {
    __extends(ApiKeyList, _super);
    function ApiKeyList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiKeyList;
}(RemoveItemsList_1.RemoveItemsList));
var UserApiKeysList = (function (_super) {
    __extends(UserApiKeysList, _super);
    function UserApiKeysList(props) {
        var _this = _super.call(this, props) || this;
        _this.renderApiKeys = function () {
            var actions = [React.createElement(OpenDialogButton_1.default, { key: "newKey", label: "New API Key" },
                    React.createElement(AddApiKeyDialog_1.default, { apiKey: _this.state.lastApiKey, onAdd: function (purpose) { return _this.handleKeyAdded(purpose); }, onClose: function () { return _this.setState({ lastApiKey: null }); } }))
            ];
            return React.createElement(ApiKeyList, { listActions: actions, data: _this.state.apiKeyCollection.Items, onRow: function (apiKey) { return React.createElement("div", { key: apiKey.Id },
                    React.createElement("h3", { className: styles.apiKeyEntry }, apiKey.Purpose || "General-purpose API key"),
                    React.createElement("div", null,
                        "Created ",
                        React.createElement(TimeFromNowLabel_1.default, { time: apiKey.Created }))); }, onRemoveRow: function (apiKey) { return _this.handleKeyRemoved(apiKey); } });
        };
        _this.handleKeyRemoved = function (deleteThisApiKey) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.revokeApiKey(deleteThisApiKey)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState(function (state) { return ({
                                            apiKeyCollection: __assign({}, state.apiKeyCollection, { Items: state.apiKeyCollection.Items.filter(function (i) { return i.Id !== deleteThisApiKey.Id; }).slice() })
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = ({
            apiKeyCollection: null,
            purpose: null,
            lastApiKey: null
        });
        return _this;
    }
    UserApiKeysList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apiKeyCollection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.listApiKeys(this.props.user)];
                    case 1:
                        apiKeyCollection = _a.sent();
                        this.setState({
                            apiKeyCollection: apiKeyCollection
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserApiKeysList.prototype.render = function () {
        return React.createElement(Section_1.Section, null,
            this.state.apiKeyCollection && this.renderApiKeys(),
            this.state.apiKeyCollection
                && this.state.apiKeyCollection.Items.length === 0
                && React.createElement(NothingToSeeHere_1.NothingToSeeHere, { content: "There aren't currently any API keys to show." }));
    };
    UserApiKeysList.prototype.handleKeyAdded = function (purpose) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var newKey;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Users.createApiKey(this.props.user, purpose)];
                                    case 1:
                                        newKey = _a.sent();
                                        this.setState(function (state) { return ({
                                            apiKeyCollection: __assign({}, state.apiKeyCollection, { Items: [newKey].concat(state.apiKeyCollection.Items) }),
                                            lastApiKey: newKey.ApiKey
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UserApiKeysList;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserApiKeysList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeysList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeysList.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FormBaseComponent_1 = __webpack_require__(155);
var clientInstance_1 = __webpack_require__(10);
var SaveDialogLayout_1 = __webpack_require__(153);
var Section_1 = __webpack_require__(81);
var form_1 = __webpack_require__(16);
var Validators_1 = __webpack_require__(199);
var UserChangePasswordDialog = (function (_super) {
    __extends(UserChangePasswordDialog, _super);
    function UserChangePasswordDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = __assign({}, this.state.user, { Password: this.state.model.password });
                        if (!this.isConfirmPasswordCorrect()) {
                            this.setState({
                                dontMatch: "The passwords do not match"
                            });
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
            dontMatch: null
        };
        return _this;
    }
    UserChangePasswordDialog.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.props.userId) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.props.userId)];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user)
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChangePasswordDialog.prototype.buildModel = function (user) {
        return user
            ? {
                original: user,
            }
            : {
                original: null,
            };
    };
    UserChangePasswordDialog.prototype.render = function () {
        var _this = this;
        return this.state.model &&
            React.createElement(SaveDialogLayout_1.default, { onSaveClick: function () { return _this.handleSaveClick(); }, busy: this.state.busy, errors: this.state.errors, title: this.isSelf() ? "Change Your Password" : "Change Password for This User" },
                React.createElement(Section_1.Section, null,
                    React.createElement(form_1.Text, { value: this.state.model.password, type: "password", onChange: function (password) { return _this.setModelState({ password: password }); }, label: "New password", autoFocus: true })),
                React.createElement(Section_1.Section, null,
                    React.createElement(form_1.Text, { value: this.state.model.confirmPassword, type: "password", onChange: function (confirmPassword) { return _this.setModelState({ confirmPassword: confirmPassword }); }, label: "Confirm new password", error: this.state.dontMatch, validate: this.isConfirmRequired() })));
    };
    UserChangePasswordDialog.prototype.isConfirmPasswordCorrect = function () {
        if (!this.state.model.password) {
            return true;
        }
        return this.state.model.password
            && this.state.model.password.localeCompare(this.state.model.confirmPassword) === 0;
    };
    UserChangePasswordDialog.prototype.isConfirmRequired = function () {
        return this.isConfirmPasswordCorrect() ? null : Validators_1.required("Passwords don't match");
    };
    UserChangePasswordDialog.prototype.isSelf = function () {
        return clientInstance_1.session.currentUser.Id === this.props.userId;
    };
    return UserChangePasswordDialog;
}(FormBaseComponent_1.default));
exports.default = UserChangePasswordDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\UserChangePasswordDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\UserChangePasswordDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var StringHelper_1 = __webpack_require__(490);
var styles = __webpack_require__(1793);
var EventDetails = function (props) {
    var eventDetails = props.eventDetails, rest = __rest(props, ["eventDetails"]);
    return React.createElement("div", __assign({}, rest),
        React.createElement("pre", { className: styles.preWrapped },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: StringHelper_1.default.formatDiff(eventDetails) } })));
};
EventDetails.displayName = "EventDetails";
exports.default = EventDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventDetails\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EventDetails\\index.tsx"); } } })();

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var BaseComponent_1 = __webpack_require__(60);
var identityType_1 = __webpack_require__(1798);
var ProviderIdentities_1 = __webpack_require__(1799);
var ProviderGroups = (function (_super) {
    __extends(ProviderGroups, _super);
    function ProviderGroups(props) {
        var _this = _super.call(this, props) || this;
        _this.determineType = function (name) {
            /*
            Octopus.Node.Extensibility.Authentication.Extensions.IAuthenticationProvider
            doesn't make use of enum Octopus.Core.Resources.IdentityType
            so just hacking it here till can be solved properly
            */
            if (name.indexOf("Azure") !== -1 || name.indexOf("Google") !== -1) {
                return identityType_1.default.OAuth;
            }
            else if (_this.isActiveDirectory(name)) {
                return identityType_1.default.ActiveDirectory;
            }
            else if (name.indexOf("Guest") !== -1) {
                return identityType_1.default.Guest;
            }
            else {
                return identityType_1.default.UsernamePassword;
            }
        };
        _this.state = {};
        return _this;
    }
    ProviderGroups.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            " ",
            this.props.enabledAuthenticationProviders &&
                this.buildIdentitiesByProvider()
                    .map(function (p) {
                    return React.createElement(ProviderIdentities_1.ProviderIdentities, { key: p.providerName, provider: p, enabledToSupportAdding: _this.props.enabledProvidersMetadata
                            && _this.props.enabledProvidersMetadata.some(function (ep) { return ep.IdentityProviderName === p.providerName; }), canCurrentUserEditIdentitiesForUser: _this.props.canCurrentUserEditIdentitiesForUser, onChange: function (changed) { return _this.providerGroupChanged(changed); } });
                }));
    };
    ProviderGroups.prototype.buildIdentitiesByProvider = function () {
        var _this = this;
        var userIdentities = this.props.userIdentities || [];
        return this.props.enabledAuthenticationProviders
            .filter(function (ap) { return identityType_1.default[ap.IdentityType] === identityType_1.default.ActiveDirectory || identityType_1.default[ap.IdentityType] === identityType_1.default.OAuth; })
            .filter(function (filterOutForServiceAccounts) { return _this.props.isServiceAccount ? _this.isActiveDirectory(filterOutForServiceAccounts.Name) : true; })
            .map(function (p) {
            return {
                providerName: p.Name,
                providerDetails: _this.props.enabledProvidersMetadata.find(function (ep) { return ep.IdentityProviderName === p.Name; }),
                identityType: _this.determineType(p.Name),
                identities: userIdentities ? userIdentities.filter(function (i) { return i.IdentityProviderName === p.Name; }) : []
            };
        })
            .sort(function (a, b) { return a.providerName.localeCompare(b.providerName); });
    };
    ProviderGroups.prototype.providerGroupChanged = function (update) {
        var identityByProvider = this.buildIdentitiesByProvider().filter(function (p) { return p.providerName !== update.providerName; }).concat([
            update
        ]).sort(function (a, b) { return a.providerName.localeCompare(b.providerName); });
        this.props.onChange(lodash_1.flatten(identityByProvider.map(function (ibp) { return ibp.identities; })));
    };
    ProviderGroups.prototype.isActiveDirectory = function (name) {
        return name.indexOf("Directory") !== -1;
    };
    return ProviderGroups;
}(BaseComponent_1.default));
exports.ProviderGroups = ProviderGroups;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderGroups.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderGroups.tsx"); } } })();

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var envCount = function (phase) {
    return lodash_1.union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};
exports.default = envCount;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\envCount.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\envCount.ts"); } } })();

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var taskState_1 = __webpack_require__(433);
function mapProgressionToStatus(progression) {
    var p = {
        deployed: {},
        tasks: {},
        warning: {},
        executing: {},
        queued: {},
        progress: {}
    };
    if (!progression) {
        return p;
    }
    progression.Phases.forEach(function (phase) {
        var phaseStatus = phase.Progress.toString();
        if (phase.Blocked) {
            phaseStatus = "Blocked";
        }
        p.progress[phase.Name] = phaseStatus;
        phase.Deployments.forEach(function (deployment) {
            p.deployed[deployment.Deployment.EnvironmentId] = true;
            p.tasks[deployment.Deployment.EnvironmentId] = deployment.Task.Id;
            p.warning[deployment.Deployment.EnvironmentId] = deployment.Task.HasWarningsOrErrors;
            p.executing[deployment.Deployment.EnvironmentId] = deployment.Task.State !== taskState_1.TaskState.Success;
            p.queued[deployment.Deployment.EnvironmentId] = deployment.Task.State === taskState_1.TaskState.Queued;
        });
    });
    return p;
}
exports.mapProgressionToStatus = mapProgressionToStatus;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\MapProgressionToStatus\\MapProgressionToStatus.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\MapProgressionToStatus\\MapProgressionToStatus.ts"); } } })();

/***/ }),
/* 845 */,
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionButton_1 = __webpack_require__(49);
var DialogLayout_1 = __webpack_require__(158);
var DialogLayoutConnect_1 = __webpack_require__(318);
var FormComponent_1 = __webpack_require__(250);
var styles = __webpack_require__(247);
var InfoDialogLayoutInternal = (function (_super) {
    __extends(InfoDialogLayoutInternal, _super);
    function InfoDialogLayoutInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoDialogLayoutInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var close = React.createElement(ActionButton_1.ActionButton, { label: this.props.closeButtonLabel || "Close", disabled: this.props.busy, onClick: function () { return _this.props.close(); } });
        return React.createElement(DialogLayout_1.DialogLayout, __assign({ actions: close, closeDialog: this.props.close }, other),
            React.createElement(FormComponent_1.default, { onFormSubmit: this.props.close, className: styles.dialogWrapper }, children));
    };
    return InfoDialogLayoutInternal;
}(React.Component));
var InfoDialogLayout = DialogLayoutConnect_1.DialogLayoutConnect.to(InfoDialogLayoutInternal);
InfoDialogLayout.displayName = "InfoDialogLayout";
exports.default = InfoDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\InfoDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\InfoDialogLayout.tsx"); } } })();

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var OpenDialogConnect_1 = __webpack_require__(411);
var Dialog_1 = __webpack_require__(133);
var dialogIdGenerator_1 = __webpack_require__(293);
var styles = __webpack_require__(378);
var IconButton_1 = __webpack_require__(52);
var OpenDialogIconButtonInternal = (function (_super) {
    __extends(OpenDialogIconButtonInternal, _super);
    function OpenDialogIconButtonInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.uniqueId = dialogIdGenerator_1.default.next();
        return _this;
    }
    OpenDialogIconButtonInternal.prototype.render = function () {
        var _this = this;
        var isOpen = this.props.openDialogs[this.uniqueId];
        return React.createElement("div", { className: styles.buttonDialogContainer },
            React.createElement(IconButton_1.default, { icon: this.props.icon, disabled: this.props.disabled, toolTipContent: this.props.toolTipContent, onClick: function () { return _this.props.openDialog(_this.uniqueId); } }),
            React.createElement(Dialog_1.default, { open: isOpen, wide: this.props.wideDialog }, this.props.children));
    };
    return OpenDialogIconButtonInternal;
}(React.Component));
var OpenDialogIconButton = OpenDialogConnect_1.OpenDialogConnect.to(OpenDialogIconButtonInternal);
exports.default = OpenDialogIconButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogIconButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\OpenDialogIconButton.tsx"); } } })();

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(132);
var FormSection_1 = __webpack_require__(706);
var ActionTemplateParameterInput_1 = __webpack_require__(425);
var _ = __webpack_require__(11);
// The purpose of this class is to provide consistent labels/help text etc for components that are external to the actual input
var ActionTemplateParameterInputFormElement = (function (_super) {
    __extends(ActionTemplateParameterInputFormElement, _super);
    function ActionTemplateParameterInputFormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionTemplateParameterInputFormElement.prototype.shouldComponentUpdate = function (newProps) {
        return hasParameterChanged(newProps, this.props);
    };
    ActionTemplateParameterInputFormElement.prototype.render = function () {
        var parameter = this.props.parameter;
        var label = getLabel(parameter);
        return React.createElement(FormSection_1.default, { title: label, help: getHelpText(parameter) },
            React.createElement(ActionTemplateParameterInput_1.default, __assign({}, this.props)));
    };
    return ActionTemplateParameterInputFormElement;
}(React.Component));
exports.default = ActionTemplateParameterInputFormElement;
function hasParameterChanged(newParam, oldParam) {
    return !_.isEqual(newParam.value, oldParam.value) ||
        !_.isEqual(newParam.error, oldParam.error) ||
        !_.isEqual(newParam.warning, oldParam.warning) ||
        !_.isEqual(newParam.sourceItems, oldParam.sourceItems);
}
exports.hasParameterChanged = hasParameterChanged;
function getLabel(parameter) {
    return parameter.Label || parameter.Name;
}
exports.getLabel = getLabel;
function getHelpText(parameter, customEmptyHelpTextMarkup) {
    if (customEmptyHelpTextMarkup === void 0) { customEmptyHelpTextMarkup = null; }
    var label = parameter.Label || parameter.Name;
    var helpText = parameter.HelpText
        ? parameter.HelpText
        : customEmptyHelpTextMarkup ? customEmptyHelpTextMarkup(label) : "Provide a value for " + label;
    return React.createElement(index_1.default, { markup: helpText });
}
exports.getHelpText = getHelpText;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputRenderer.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateParameterInput\\ActionTemplateParameterInputRenderer.tsx"); } } })();

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var ActionEditor = (function (_super) {
    __extends(ActionEditor, _super);
    function ActionEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionEditor.prototype.componentDidMount = function () {
        var properties = __assign({}, this.props.properties);
        if (this.props.isNew) {
            // Enable any permanent or initial features
            if (this.props.plugin.features) {
                var enabledFeatures_1 = [];
                if (this.props.plugin.features.permanent) {
                    this.props.plugin.features.permanent.forEach(function (feature) {
                        var featurePlugin = pluginRegistry_1.default.getFeature(feature);
                        if (featurePlugin.enable) {
                            featurePlugin.enable(properties);
                        }
                        enabledFeatures_1.push(feature);
                    });
                }
                if (this.props.plugin.features.initial) {
                    this.props.plugin.features.initial.forEach(function (feature) {
                        var featurePlugin = pluginRegistry_1.default.getFeature(feature);
                        if (featurePlugin.enable) {
                            featurePlugin.enable(properties);
                        }
                        enabledFeatures_1.push(feature);
                    });
                }
                properties["Octopus.Action.EnabledFeatures"] = enabledFeatures_1.join(",");
                this.props.setProperties(properties, true);
            }
        }
    };
    ActionEditor.prototype.render = function () {
        if (!this.props.plugin.edit) {
            throw new Error("Plugin " + this.props.plugin.actionType + " is missing 'Edit' property");
        }
        return React.createElement(this.props.plugin.edit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, packages: this.props.packages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, setProperties: this.props.setProperties, setPackages: this.props.setPackages, additionalActions: this.props.additionalActions, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault });
    };
    return ActionEditor;
}(React.Component));
exports.default = ActionEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionEditor\\ActionEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionEditor\\ActionEditor.tsx"); } } })();

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var form_1 = __webpack_require__(16);
var styles = __webpack_require__(1974);
var FeatureEditor = (function (_super) {
    __extends(FeatureEditor, _super);
    function FeatureEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            plugins: [],
        };
        return _this;
    }
    FeatureEditor.prototype.componentDidMount = function () {
        this.refreshPlugins(this.props.enabledFeatures);
    };
    FeatureEditor.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.enabledFeatures !== this.props.enabledFeatures) {
            this.refreshPlugins(newProps.enabledFeatures);
        }
    };
    FeatureEditor.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            this.state.plugins.map(function (plugin) {
                return React.createElement(plugin.edit, { key: "featureeditor-" + plugin.featureName, plugin: _this.props.plugin, projectId: _this.props.projectId, localNames: _this.props.localNames, properties: _this.props.properties, packages: _this.props.packages, setPackages: _this.props.setPackages, doBusyTask: _this.props.doBusyTask, setProperties: _this.props.setProperties, getFieldError: _this.props.getFieldError, errors: _this.props.errors, expandedByDefault: _this.props.expandedByDefault });
            }),
            React.createElement(form_1.UnstructuredFormSection, null,
                React.createElement("div", { className: styles.featuresActionContainer },
                    React.createElement("div", null, this.props.openFeaturesElement),
                    React.createElement(form_1.Note, null, "You can add or manage additional features used by this step."))));
    };
    FeatureEditor.prototype.refreshPlugins = function (enabledFeatures) {
        var featureNames = (enabledFeatures || "").split(",");
        var allFeatures = pluginRegistry_1.default.getAllFeatures();
        var plugins = [];
        allFeatures.forEach(function (feature) {
            var isEnabled = featureNames.includes(feature.featureName);
            if (!isEnabled) {
                return;
            }
            plugins.push(feature);
        });
        this.setState({ plugins: plugins });
    };
    return FeatureEditor;
}(React.Component));
exports.default = FeatureEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureEditor\\FeatureEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FeatureEditor\\FeatureEditor.tsx"); } } })();

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var OpenDialogButton_1 = __webpack_require__(72);
var ConfigureFeaturesContent_1 = __webpack_require__(1977);
var OpenFeatureDialog = function (props) {
    return React.createElement(OpenDialogButton_1.default, { label: "Configure features", wideDialog: true },
        React.createElement(ConfigureFeaturesContent_1.default, { actionType: props.actionType, properties: props.properties, saveDone: props.saveDone }));
};
OpenFeatureDialog.displayName = "OpenFeatureDialog";
exports.default = OpenFeatureDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\OpenFeatureDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\OpenFeatureDialog.tsx"); } } })();

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(11);
var ActionTemplateCategory_1 = __webpack_require__(1992);
var ActionTemplateCard_1 = __webpack_require__(499);
var ActionButton_1 = __webpack_require__(49);
var CommunityTemplateInstallation_1 = __webpack_require__(1995);
var matchesFilter_1 = __webpack_require__(500);
var Callout_1 = __webpack_require__(57);
var FeatureToggle_1 = __webpack_require__(249);
var InternalLink_1 = __webpack_require__(43);
var OpenDialogButton_1 = __webpack_require__(72);
var styles = __webpack_require__(298);
var PageDivider_1 = __webpack_require__(471);
var ActionTemplateCardList_1 = __webpack_require__(501);
var routeLinks_1 = __webpack_require__(22);
var InternalRedirect_1 = __webpack_require__(45);
__webpack_require__(1996);
var CommunityActionTemplateList = (function (_super) {
    __extends(CommunityActionTemplateList, _super);
    function CommunityActionTemplateList(props) {
        var _this = _super.call(this, props) || this;
        _this.showCategories = function () {
            _this.setState({ categoryTemplates: [], categories: _this.categoriseTemplates(_this.props.templates) });
        };
        _this.showAllTemplates = function () {
            _this.setState({ categoryTemplates: _this.props.templates, categories: [] });
        };
        _this.installationSucceeded = function (actionTemplate) {
            var url = _this.props.onPostSelectionUrlRequested({ Type: actionTemplate.ActionType, Id: actionTemplate.Id });
            _this.setState({ redirectTo: url });
        };
        _this.state = {
            categories: _this.categoriseTemplates(props.templates),
            categoryTemplates: []
        };
        return _this;
    }
    CommunityActionTemplateList.prototype.categoriseTemplates = function (templates) {
        var categorised = lodash_1.groupBy(templates, function (t) { return t.Category; });
        return Object.keys(categorised).sort(function (category1, category2) { return category1.toLowerCase().localeCompare(category2.toLowerCase()); })
            .map(function (categoryName) { return ({ name: categoryName, templates: categorised[categoryName] }); });
    };
    CommunityActionTemplateList.prototype.showCategoryTemplates = function (templates) {
        // We are setting min-hight here to avoid "screen jumping" when the user switches from categories to templates.
        // Ideally this would be handled by a CSS transform but it did not work.
        this.categoryTemplatesElement.style.minHeight = this.categoriesElement.clientHeight + "px";
        this.setState({ categoryTemplates: templates, categories: [] });
    };
    CommunityActionTemplateList.prototype.isInCategoryMode = function () {
        return this.state.categoryTemplates.length === 0 && this.state.categories.length > 0;
    };
    CommunityActionTemplateList.prototype.isInCategoryTemplatesMode = function () {
        return this.state.categoryTemplates.length > 0 && this.state.categories.length === 0;
    };
    CommunityActionTemplateList.prototype.componentWillReceiveProps = function (nextProps) {
        var nextState = { categories: this.categoriseTemplates(nextProps.templates) };
        if (!nextProps.filter) {
            nextState.categoryTemplates = [];
        }
        this.setState(nextState);
    };
    CommunityActionTemplateList.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var searchAllTemplates = this.props.filter;
        return React.createElement("div", null,
            React.createElement(PageDivider_1.default, null, "Community Contributed Step Templates"),
            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.CommunityActionTemplates, enabled: false },
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "Community library integration is disabled. If you want to take advantage of hundreds of great templates developed by the members of our community then please ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.configuration.features }, "enable the integration feature."))),
            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.CommunityActionTemplates }, this.props.templates.length === 0 && !this.props.filter && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                "Community library integration is enabled but there aren't any community step templates available. Review the community step templates ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.configuration.features }, "feature toggle"),
                " for more information.")),
            !searchAllTemplates ?
                React.createElement("div", null,
                    React.createElement("div", { className: styles.actions },
                        this.isInCategoryMode() && React.createElement(ActionButton_1.ActionButton, { label: "Show all", type: ActionButton_1.ActionButtonType.Ternary, onClick: this.showAllTemplates }),
                        this.isInCategoryTemplatesMode() &&
                            React.createElement(ActionButton_1.ActionButton, { label: "Back", type: ActionButton_1.ActionButtonType.Ternary, onClick: this.showCategories })),
                    React.createElement("div", { className: styles.groupingContainer },
                        React.createElement("ol", { className: styles.categories, ref: function (element) { return _this.categoriesElement = element; } },
                            React.createElement("div", null, this.state.categories.map(function (category) {
                                return _this.withAnimation(category.name, React.createElement(ActionTemplateCategory_1.default, { name: category.name, templates: category.templates, onCategorySelected: function () { return _this.showCategoryTemplates(category.templates); } }));
                            }))),
                        React.createElement("ol", { className: styles.categoryTemplates, ref: function (element) { return _this.categoryTemplatesElement = element; } },
                            React.createElement("div", null, this.state.categoryTemplates.map(function (template) { return _this.renderSingle(template); })))))
                :
                    this.filteredTemplates());
    };
    CommunityActionTemplateList.prototype.filteredTemplates = function () {
        var _this = this;
        var filteredResults = this.props.templates.filter(function (at) { return matchesFilter_1.default(at, _this.props.filter); });
        if (filteredResults.length === 0 && this.props.filter) {
            return React.createElement("p", null, "There are no community step templates that match your filter criteria.");
        }
        return React.createElement(ActionTemplateCardList_1.default, null, filteredResults.map(function (template) { return _this.renderSingle(template); }));
    };
    CommunityActionTemplateList.prototype.renderSingle = function (template) {
        return this.withAnimation(template.Type + template.Id, React.createElement(ActionTemplateCard_1.default, { template: template, primaryAction: this.installationDialog(template), secondaryAction: React.createElement(InternalLink_1.default, { size: 0.75, to: this.props.onDetailsUrlRequested(template) }, "View details") }));
    };
    CommunityActionTemplateList.prototype.withAnimation = function (key, content) {
        return React.createElement("div", { key: key, className: "animated zoomIn" }, content);
    };
    CommunityActionTemplateList.prototype.installationDialog = function (template) {
        return React.createElement(OpenDialogButton_1.default, { label: this.props.installationActionName, type: ActionButton_1.ActionButtonType.Primary },
            React.createElement(CommunityTemplateInstallation_1.default, { communityTemplateId: template.Id, title: this.props.installationActionName, detailsLink: this.props.onDetailsUrlRequested(template), saveDone: this.installationSucceeded }));
    };
    return CommunityActionTemplateList;
}(React.Component));
exports.default = CommunityActionTemplateList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\CommunityActionTemplateList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\CommunityActionTemplateList.tsx"); } } })();

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmailPriority;
(function (EmailPriority) {
    EmailPriority["Low"] = "Low";
    EmailPriority["Normal"] = "Normal";
    EmailPriority["High"] = "High";
})(EmailPriority = exports.EmailPriority || (exports.EmailPriority = {}));
exports.default = EmailPriority;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\emailPriority.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\emailPriority.ts"); } } })();

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MetadataTypeHelpers = (function () {
    function MetadataTypeHelpers() {
    }
    MetadataTypeHelpers.isCompositeType = function (property) {
        var validSimpleTypes = ["raw_list", "raw_map", "bool", "boolean", "string", "string[]", "long", "int", "bool?", "long?", "int?", "SensitiveValue"];
        return !validSimpleTypes.includes(property.Type);
    };
    MetadataTypeHelpers.isValidatableType = function (property) {
        var validValidationTypes = ["string", "string[]", "long", "int", "SensitiveValue"];
        return validValidationTypes.includes(property.Type);
    };
    MetadataTypeHelpers.getRequiredMessage = function (property) {
        return property.DisplayInfo.Label + " is required";
    };
    return MetadataTypeHelpers;
}());
exports.default = MetadataTypeHelpers;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DynamicForm\\MetadataTypeHelpers.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DynamicForm\\MetadataTypeHelpers.tsx"); } } })();

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var EmailLink = function (props) {
    if (props.emailAddress) {
        var href = "mailto:" + props.emailAddress;
        return React.createElement("a", { href: href, "aria-label": props.emailAddress }, props.emailAddress);
    }
    else {
        return null;
    }
};
exports.default = EmailLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EmailLink\\EmailLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EmailLink\\EmailLink.tsx"); } } })();

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(859);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(33);
var react_redux_1 = __webpack_require__(64);
var App_1 = __webpack_require__(940);
__webpack_require__(2037);
var colors_1 = __webpack_require__(31);
var store_1 = __webpack_require__(123);
var extensionsManager_1 = __webpack_require__(744);
var Theme_1 = __webpack_require__(747);
__webpack_require__(2040);
__webpack_require__(763);
var ErrorBoundary_1 = __webpack_require__(267);
window.Octopus = extensionsManager_1.default;
var render = function (Component) {
    ReactDOM.render(React.createElement(ErrorBoundary_1.default, null,
        React.createElement(Theme_1.default, { theme: colors_1.theme },
            React.createElement(react_redux_1.Provider, { store: store_1.default },
                React.createElement(Component, null)))), document.getElementById("app"));
};
render(App_1.default);
//Do NOT move to a separate file as this wil break hot reloading
if (false) {
    module.hot.accept("./reducers", function () {
        // When reducers change, replace them but keep the current app state
        console.log("Store updated. Replacing root reducer");
        // If the callback to hot.accept throws
        // an exception, the HMR update will fail. If using
        // webpack-dev-server, the page will be reloaded,
        // and we lose the error. So try/catch/log.
        //
        try {
            var nextReducer = require("./reducers").reducers;
            store_1.default.replaceReducer(nextReducer);
        }
        catch (err) {
            console.error("Error updating store", err);
        }
    });
    module.hot.accept("./App", function () {
        try {
            var NextApp = require("./App").default;
            render(NextApp);
        }
        catch (err) {
            console.error("Error updating store", err);
        }
    });
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\index.tsx"); } } })();

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(860);
__webpack_require__(871);
__webpack_require__(876);
__webpack_require__(878);
__webpack_require__(880);
__webpack_require__(883);
__webpack_require__(885);
__webpack_require__(887);
__webpack_require__(891);
__webpack_require__(894);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\polyfills.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\polyfills.ts"); } } })();

/***/ }),
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var react_router_dom_2 = __webpack_require__(61);
var SecureRoute_1 = __webpack_require__(959);
var StandardLayout_1 = __webpack_require__(1585);
var SignIn_1 = __webpack_require__(2011);
var SignOut_1 = __webpack_require__(2020);
var Register_1 = __webpack_require__(2024);
var ConfirmNavigate_1 = __webpack_require__(2030);
var AuthenticationLayout_1 = __webpack_require__(2034);
var ReloadableRoute_1 = __webpack_require__(94);
var routeLinks_1 = __webpack_require__(22);
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.render = function () {
        return React.createElement(react_router_dom_2.HashRouter, { getUserConfirmation: ConfirmNavigate_1.default },
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.signIn, render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(SignIn_1.default, __assign({}, props))); } }),
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.signOut, render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(SignOut_1.default, __assign({}, props))); } }),
                React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.register(":inviteCode"), render: function (props) { return React.createElement(AuthenticationLayout_1.default, null,
                        React.createElement(Register_1.default, __assign({}, props))); } }),
                React.createElement(SecureRoute_1.default, { path: routeLinks_1.default.root, component: StandardLayout_1.StandardLayout })));
    };
    return App;
}(React.Component));
exports.default = App;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\App.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\App.tsx"); } } })();

/***/ }),
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SecureRoute_1 = __webpack_require__(960);
exports.default = SecureRoute_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SecureRoute\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SecureRoute\\index.tsx"); } } })();

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ReloadableRoute_1 = __webpack_require__(94);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var SecureRoute = (function (_super) {
    __extends(SecureRoute, _super);
    function SecureRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecureRoute.prototype.render = function () {
        var _a = this.props, Component = _a.component, rest = __rest(_a, ["component"]);
        return (React.createElement(ReloadableRoute_1.default, __assign({}, rest, { render: function (props) {
                return clientInstance_1.session.isAuthenticated() ?
                    React.createElement(Component, __assign({}, rest)) :
                    React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.currentUser.signIn, state: { from: props.location } } });
            } })));
    };
    return SecureRoute;
}(React.Component));
exports.default = SecureRoute;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SecureRoute\\SecureRoute.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SecureRoute\\SecureRoute.tsx"); } } })();

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = __webpack_require__(962);
exports.Client = client_1.default;
var repository_1 = __webpack_require__(1134);
exports.Repository = repository_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\index.ts"); } } })();

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var resolver_1 = __webpack_require__(823);
var logger_1 = __webpack_require__(102);
var ajax_1 = __webpack_require__(969);
var environment_1 = __webpack_require__(266);
// The Octopus Client implements the low-level semantics of the Octopus Deploy REST API
var Client = (function () {
    function Client(configuration) {
        configuration = this.extend({ serverEndpoint: null }, configuration);
        var endpoint = this.normalizeEndpoint(configuration.serverEndpoint);
        logger_1.default.log("Creating Octopus client for endpoint: " + endpoint);
        this.currentResolver = new resolver_1.default(endpoint);
        this.rootDocument = null;
        this.resolve = this.currentResolver.resolve.bind(this.currentResolver);
    }
    Client.prototype.connect = function (progressCallback) {
        var _this = this;
        progressCallback("Checking your credentials. Please wait...", "");
        return new Promise(function (resolve, reject) {
            if (_this.rootDocument) {
                resolve(_this.rootDocument);
                return;
            }
            var attempt = function (success, fail) {
                _this.get("~/api")
                    .then(success, fail);
            };
            var onSuccess = function (root) {
                _this.rootDocument = root;
                _this.version = root.Version;
                resolve(_this.rootDocument);
            };
            var fails = 0;
            var onFail = function (err) {
                if (err.StatusCode !== 503) {
                    fails++;
                }
                if ((err.StatusCode === 0 || err.StatusCode === 503) && fails < 20) {
                    logger_1.default.warn("Unable to connect, trying again in 1 second...", err);
                    if (err.StatusCode === 503) {
                        progressCallback(err.ErrorMessage, "success");
                    }
                    else if (err.StatusCode === 0) {
                        progressCallback("The Octopus Server does not appear to have started, trying again...", "warning");
                    }
                    setTimeout(function () {
                        logger_1.default.warn("Trying again", err);
                        attempt(onSuccess, onFail);
                    }, 1000);
                }
                else {
                    progressCallback("Unable to connect, unexpected error, or timeout exceeded.", "error");
                    logger_1.default.error("Unable to connect, unexpected error, or timeout exceeded", err);
                    reject(err);
                }
            };
            attempt(onSuccess, onFail);
        });
    };
    Client.prototype.get = function (path, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("GET", url);
    };
    Client.prototype.getRaw = function (path, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            new ajax_1.default({
                client: _this,
                method: "GET",
                error: function (e) { return reject(e); },
                url: url,
                raw: true,
                success: function (data) { return resolve(data); }
            }).execute();
        });
    };
    Client.prototype.post = function (path, resource, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("POST", url, resource);
    };
    Client.prototype.create = function (path, resource, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            _this.dispatchRequest("POST", url, resource)
                .then(function (result) {
                _this.dispatchRequest("GET", _this.currentResolver.resolve(result.Links.Self))
                    .then(function (result2) {
                    resolve(result2);
                }, reject);
            }, reject);
        });
    };
    Client.prototype.update = function (path, resource, args) {
        var _this = this;
        var url = this.currentResolver.resolve(path, args);
        return new Promise(function (resolve, reject) {
            _this.dispatchRequest("PUT", url, resource)
                .then(function () {
                _this.dispatchRequest("GET", url)
                    .then(function (result2) {
                    resolve(result2);
                }, reject);
            }, reject);
        });
    };
    Client.prototype.del = function (path, resource, args) {
        var url = this.currentResolver.resolve(path, args);
        return this.dispatchRequest("DELETE", url, resource);
    };
    Client.prototype.put = function (path, resource) {
        var url = this.currentResolver.resolve(path);
        return this.dispatchRequest("PUT", url, resource);
    };
    Client.prototype.getAntiforgeryToken = function () {
        if (!this.isConnected()) {
            return null;
        }
        var installationId = this.getRootDocument().InstallationId;
        if (!installationId) {
            return null;
        }
        // If we have come this far we know we are on a version of Octopus Server which supports anti-forgery tokens
        var antiforgeryCookieName = "Octopus-Csrf-Token_" + installationId;
        var antiforgeryCookies = document.cookie.split(";").filter(function (c) {
            return c.trim().indexOf(antiforgeryCookieName) === 0;
        }).map(function (c) {
            return c.trim();
        });
        if (antiforgeryCookies && antiforgeryCookies.length === 1) {
            var antiforgeryToken = antiforgeryCookies[0].split("=")[1];
            return antiforgeryToken;
        }
        else {
            if (environment_1.default.isInDevelopmentMode()) {
                return "FAKE TOKEN USED FOR DEVELOPMENT";
            }
            return null;
        }
    };
    Client.prototype.getRootDocument = function () {
        if (!this.isConnected()) {
            throw new Error("The Octopus Client has not connected. THIS SHOULD NOT HAPPEN! Please notify support.");
        }
        return this.rootDocument;
    };
    Client.prototype.resolveLinkTemplate = function (link, args) {
        return this.resolve(this.getRootDocument().Links[link], args);
    };
    Client.prototype.extend = function (arg1, arg2) {
        return __assign({}, arg1, arg2);
    };
    Client.prototype.dispatchRequest = function (method, url, requestBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            new ajax_1.default({
                client: _this,
                error: function (e) { return reject(e); },
                method: method,
                url: url,
                requestBody: requestBody,
                success: function (data) { return resolve(data); },
            }).execute();
        });
    };
    Client.prototype.isConnected = function () {
        return this.rootDocument !== null;
    };
    Client.prototype.normalizeEndpoint = function (endpoint) {
        if (endpoint == null || endpoint.length === 0) {
            endpoint = "" + window.location.protocol;
            if (!endpoint.endsWith("//")) {
                endpoint = endpoint + "//";
            }
            endpoint = endpoint + window.location.host;
            var path = window.location.pathname;
            if (!path.startsWith("/")) {
                path = "/" + path;
            }
            if (path.length >= 1) {
                var lastSegmentIndex = path.lastIndexOf("/");
                if (lastSegmentIndex >= 0) {
                    path = path.substring(0, lastSegmentIndex + 1);
                }
            }
            endpoint = endpoint + path;
        }
        return endpoint;
    };
    return Client;
}());
exports.default = Client;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\client.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\client.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 963 */,
/* 964 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// We use our own AJAX function so that we"re not too coupled to jQuery
var logger_1 = __webpack_require__(102);
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(17);
var serverVersionNotificationCheck_1 = __webpack_require__(1065);
var Ajax = (function () {
    function Ajax(options) {
        if (options === void 0) { options = {
            method: "GET",
            nonStale: true,
            raw: false,
            url: null,
            client: null,
            error: function (e) { return undefined; },
            requestBody: null,
            success: function (data) { return undefined; }
        }; }
        var _this = this;
        this.checkAuthentication = function () {
            // If we don't have an anti-forgery token we need to get one by logging in again
            if (clientInstance_1.session.isAuthenticated() && !clientInstance_1.client.getAntiforgeryToken() && !isAnonymous(_this.options.url)) {
                logger_1.default.warn("The expected anti-forgery cookie is missing or has expired. Redirecting to login page, but will return to " + window.location.href + ". " +
                    "See http://g.octopushq.com/CSRF for more details and troubleshooting.");
                _this.reAuthenticateAndReturn();
                return false;
            }
            else {
                return true;
            }
        };
        this.reAuthenticateAndReturn = function () {
            clientInstance_1.repository.Users.signOut().then(function () {
                clientInstance_1.session.end();
                window.location.reload();
            });
        };
        this.handleSuccess = function (request, cachedResult) {
            serverVersionNotificationCheck_1.serverVersionNotificationCheck(request);
            var responseBody = cachedResult;
            if (!responseBody || !clientInstance_1.session.cache.canUseCachedValue(request)) {
                responseBody = request.responseText;
                clientInstance_1.session.cache.updateCache(request, _this.options);
            }
            _this.options.success(deserialize(responseBody, _this.options.raw));
        };
        this.handleError = function (request) {
            var err = generateOctopusError(request);
            if (err.StatusCode === 401 && !isAnonymous(_this.options.url) && !isAuthenticationCheck(_this.options.url)) {
                logger_1.default.warn("Session Auth Cookie has expired or is missing. Redirecting to login page, but will return to " + window.location.href + ".");
                _this.reAuthenticateAndReturn();
            }
            _this.options.error(err);
        };
        this.options = options;
    }
    Ajax.prototype.execute = function () {
        var _this = this;
        var request = createXMLHTTPObject();
        if (!request) {
            return;
        }
        request.open(getMethod(this.options.method).method, this.options.url, true);
        request.withCredentials = true;
        this.setHeaders(request);
        var cachedResult = clientInstance_1.session.cache.setHeaderAndGetValue(request, this.options);
        request.onreadystatechange = function () {
            if (request.readyState !== XMLHttpRequest.DONE) {
                return;
            }
            else if (request.status < 100 || request.status >= 400) {
                _this.handleError(request);
            }
            else {
                _this.handleSuccess(request, cachedResult);
            }
        };
        if (request.readyState === XMLHttpRequest.DONE) {
            return;
        }
        if (!this.checkAuthentication()) {
            logger_1.default.log("Canceled request", request);
            return;
        }
        this.sendRequest(request);
    };
    Ajax.prototype.sendRequest = function (request) {
        var body = this.options.requestBody;
        if (typeof (body) === "undefined") {
            request.send();
        }
        else if (typeof (body) === "string" || isFormData(body)) {
            request.send(body);
        }
        else {
            var bodyJson = JSON.stringify(body);
            request.send(bodyJson);
        }
    };
    Ajax.prototype.setHeaders = function (request) {
        var _a = getMethod(this.options.method), method = _a.method, methodOverride = _a.methodOverride;
        request.setRequestHeader("X-Octopus-User-Agent", "OctopusClient-js/" + this.options.client.version);
        request.setRequestHeader("Accept", "application/json");
        if (this.options.requestBody && !isFormData(this.options.requestBody)) {
            request.setRequestHeader("Content-type", "application/json");
        }
        if (methodOverride) {
            request.setRequestHeader("X-HTTP-Method-Override", methodOverride);
        }
        // Set X-Octopus-Csrf-Token header if there is an antiforgery cookie available and it"s a mutating request
        if (method === "POST" || method === "PUT" || method === "DELETE") {
            var antiforgeryToken = this.options.client.getAntiforgeryToken();
            if (antiforgeryToken) {
                request.setRequestHeader("X-Octopus-Csrf-Token", antiforgeryToken);
            }
        }
    };
    return Ajax;
}());
exports.default = Ajax;
var deserialize = function (responseText, raw, forceJson) {
    if (forceJson === void 0) { forceJson = false; }
    if (raw && !forceJson) {
        return responseText;
    }
    if (responseText && responseText.length) {
        return JSON.parse(responseText);
    }
    return null;
};
var getMethod = function (method) {
    var methodOverride = null;
    if (method === "PUT") {
        methodOverride = "PUT";
        method = "POST";
    }
    if (method === "DELETE") {
        methodOverride = "DELETE";
        method = "POST";
    }
    return { method: method, methodOverride: methodOverride };
};
var isAnonymous = function (url) {
    return url.includes("/users/register/") || url.endsWith("/users/login") || url.endsWith("/users/logout") || url.endsWith("/api");
};
var isAuthenticationCheck = function (url) {
    return url.endsWith("/users/me");
};
var isFormData = function (item) {
    return item instanceof FormData;
};
var generateOctopusError = function (request) {
    var error = new resources_1.OctopusError(request.status);
    try {
        if (request.status === XMLHttpRequest.UNSENT) {
            error.ErrorMessage = "There was a problem with your request.";
            error.Errors = ["Unable to establish a connection to the Octopus Deploy server. " +
                    "The server may be offline. Please check your network connection."];
        }
        else {
            error = resources_1.OctopusError.create(request.status, deserialize(request.responseText, false, true));
            if (!error.ErrorMessage) {
                error.ErrorMessage = "There was a problem with your request.";
                error.Errors = ["The Octopus Deploy server returned a status of: " + request.status];
                error.FullException = request.response;
            }
        }
    }
    catch (err) {
        error.ErrorMessage = "There was a problem with your request.";
        error.Errors = ["Unhandled error when communicating with the Octopus Deploy server. " +
                "The server returned a status of: " + request.status];
        error.FullException = err.toString();
    }
    return error;
};
var XMLHttpFactories = [
    function () {
        return new XMLHttpRequest();
    },
    function () {
        return new ActiveXObject("Msxml2.XMLHTTP");
    },
    function () {
        return new ActiveXObject("Msxml3.XMLHTTP");
    },
    function () {
        return new ActiveXObject("MSXML2.XMLHTTP.3.0");
    },
    function () {
        return new ActiveXObject("Microsoft.XMLHTTP");
    }
];
var createXMLHTTPObject = function () {
    var xmlhttp = null;
    // tslint:disable-next-line
    for (var i = 0; i < XMLHttpFactories.length; i++) {
        try {
            xmlhttp = XMLHttpFactories[i]();
        }
        catch (e) {
            continue;
        }
        break;
    }
    return xmlhttp;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\ajax.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\ajax.ts"); } } })();

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionTemplateResource.ts"); } } })();

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionTemplateParameterResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\actionTemplateParameterResource.ts"); } } })();

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccountUsageResource = (function () {
    function AccountUsageResource() {
    }
    return AccountUsageResource;
}());
exports.AccountUsageResource = AccountUsageResource;
var TargetUsageEntry = (function () {
    function TargetUsageEntry() {
    }
    return TargetUsageEntry;
}());
exports.TargetUsageEntry = TargetUsageEntry;
var ProjectVariableSetUsage = (function () {
    function ProjectVariableSetUsage() {
    }
    return ProjectVariableSetUsage;
}());
exports.ProjectVariableSetUsage = ProjectVariableSetUsage;
var LibraryVariableSetUsageEntry = (function () {
    function LibraryVariableSetUsageEntry() {
    }
    return LibraryVariableSetUsageEntry;
}());
exports.LibraryVariableSetUsageEntry = LibraryVariableSetUsageEntry;
var ReleaseUsage = (function () {
    function ReleaseUsage() {
    }
    return ReleaseUsage;
}());
exports.ReleaseUsage = ReleaseUsage;
var ReleaseUsageEntry = (function () {
    function ReleaseUsageEntry() {
    }
    return ReleaseUsageEntry;
}());
exports.ReleaseUsageEntry = ReleaseUsageEntry;
var StepUsage = (function () {
    function StepUsage() {
    }
    return StepUsage;
}());
exports.StepUsage = StepUsage;
var StepUsageEntry = (function () {
    function StepUsageEntry() {
    }
    return StepUsageEntry;
}());
exports.StepUsageEntry = StepUsageEntry;
exports.default = AccountUsageResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\accountUsageResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\accountUsageResource.ts"); } } })();

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureEnvironment.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureEnvironment.ts"); } } })();

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\artifactResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\artifactResource.ts"); } } })();

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var ApiKeyResource = (function (_super) {
    __extends(ApiKeyResource, _super);
    function ApiKeyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiKeyResource;
}(resource_1.default));
exports.ApiKeyResource = ApiKeyResource;
exports.default = ApiKeyResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\apiKeyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\apiKeyResource.ts"); } } })();

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureWebSite.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureWebSite.ts"); } } })();

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureWebSiteSlot.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\azureWebSiteSlot.ts"); } } })();

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\builtInFeedStatsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\builtInFeedStatsResource.ts"); } } })();

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var BuiltInRepositoryConfigurationResource = (function (_super) {
    __extends(BuiltInRepositoryConfigurationResource, _super);
    function BuiltInRepositoryConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BuiltInRepositoryConfigurationResource;
}(resource_1.default));
exports.BuiltInRepositoryConfigurationResource = BuiltInRepositoryConfigurationResource;
exports.default = BuiltInRepositoryConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\builtInRepositoryConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\builtInRepositoryConfigurationResource.ts"); } } })();

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\channelResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\channelResource.ts"); } } })();

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\channelVersionRuleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\channelVersionRuleResource.ts"); } } })();

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var CertificateConfigurationResource = (function (_super) {
    __extends(CertificateConfigurationResource, _super);
    function CertificateConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CertificateConfigurationResource;
}(resource_1.default));
exports.CertificateConfigurationResource = CertificateConfigurationResource;
exports.default = CertificateConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateConfigurationResource.ts"); } } })();

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CertificateDataFormat;
(function (CertificateDataFormat) {
    CertificateDataFormat["Pkcs12"] = "Pkcs12";
    CertificateDataFormat["Der"] = "Der";
    CertificateDataFormat["Pem"] = "Pem";
})(CertificateDataFormat = exports.CertificateDataFormat || (exports.CertificateDataFormat = {}));
var CertificateExportPemOptions;
(function (CertificateExportPemOptions) {
    CertificateExportPemOptions["PrimaryOnly"] = "PrimaryOnly";
    CertificateExportPemOptions["PrimaryAndChain"] = "PrimaryAndChain";
    CertificateExportPemOptions["ChainOnly"] = "ChainOnly";
})(CertificateExportPemOptions = exports.CertificateExportPemOptions || (exports.CertificateExportPemOptions = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateResource.ts"); } } })();

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateUsageResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\certificateUsageResource.ts"); } } })();

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ControlType;
(function (ControlType) {
    ControlType["SingleLineText"] = "SingleLineText";
    ControlType["MultiLineText"] = "MultiLineText";
    ControlType["Select"] = "Select";
    ControlType["Checkbox"] = "Checkbox";
    ControlType["Sensitive"] = "Sensitive";
    ControlType["StepName"] = "StepName";
    ControlType["AzureAccount"] = "AzureAccount";
    ControlType["Certificate"] = "Certificate";
    ControlType["AmazonWebServicesAccount"] = "AmazonWebServicesAccount";
})(ControlType = exports.ControlType || (exports.ControlType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\controlType.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\controlType.ts"); } } })();

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardConfigurationResource.ts"); } } })();

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardEnvironmentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardEnvironmentResource.ts"); } } })();

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardItemResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardItemResource.ts"); } } })();

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardProjectGroupResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardProjectGroupResource.ts"); } } })();

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardProjectResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardProjectResource.ts"); } } })();

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardResource.ts"); } } })();

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardTenantResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\dashboardTenantResource.ts"); } } })();

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var feedResource_1 = __webpack_require__(73);
var ParseHelper_1 = __webpack_require__(66);
var _ = __webpack_require__(11);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var DeploymentActionResource = (function (_super) {
    __extends(DeploymentActionResource, _super);
    function DeploymentActionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeploymentActionResource;
}(resource_1.default));
exports.DeploymentActionResource = DeploymentActionResource;
exports.default = DeploymentActionResource;
function IsDeployReleaseAction(action) {
    return !!action.Properties["Octopus.Action.DeployRelease.ProjectId"];
}
exports.IsDeployReleaseAction = IsDeployReleaseAction;
function HasManualInterventionResponsibleTeams(action) {
    return _.some(ParseHelper_1.default.parseCSV(action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"]));
}
exports.HasManualInterventionResponsibleTeams = HasManualInterventionResponsibleTeams;
function GetPrimaryPackageReference(packages) {
    return packages.find(function (pkg) { return IsPrimaryPackageReference(pkg); });
}
exports.GetPrimaryPackageReference = GetPrimaryPackageReference;
function IsPrimaryPackageReference(pkg) {
    return !pkg.Name;
}
exports.IsPrimaryPackageReference = IsPrimaryPackageReference;
function IsNamedPackageReference(pkg) {
    return !!pkg.Name;
}
exports.IsNamedPackageReference = IsNamedPackageReference;
function GetNamedPackageReferences(packages) {
    return RemovePrimaryPackageReference(packages);
}
exports.GetNamedPackageReferences = GetNamedPackageReferences;
function SetPrimaryPackageReference(updated, packages) {
    return _.map(packages, function (pkg) {
        if (!IsPrimaryPackageReference(pkg)) {
            return pkg;
        }
        return __assign({}, pkg, updated);
    });
}
exports.SetPrimaryPackageReference = SetPrimaryPackageReference;
function InitialisePrimaryPackageReference(packages, reset) {
    if (reset === void 0) { reset = false; }
    var primaryPackage = GetPrimaryPackageReference(packages);
    if (primaryPackage && !reset) {
        return packages.slice();
    }
    var packagesWithoutDefault = RemovePrimaryPackageReference(packages);
    return [
        {
            PackageId: null,
            FeedId: feedResource_1.BuiltInFeedId,
            AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.Server,
            Properties: {}
        }
    ].concat(packagesWithoutDefault);
}
exports.InitialisePrimaryPackageReference = InitialisePrimaryPackageReference;
function RemovePrimaryPackageReference(packages) {
    return _.filter(packages, function (pkg) { return !IsPrimaryPackageReference(pkg); });
}
exports.RemovePrimaryPackageReference = RemovePrimaryPackageReference;
// Returns true if the names match, where null and empty string are equivalent
function PackageReferenceNamesMatch(nameA, nameB) {
    if (!nameA) {
        return !nameB;
    }
    return nameA === nameB;
}
exports.PackageReferenceNamesMatch = PackageReferenceNamesMatch;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentActionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentActionResource.ts"); } } })();

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var MachineDeploymentPreview = (function (_super) {
    __extends(MachineDeploymentPreview, _super);
    function MachineDeploymentPreview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MachineDeploymentPreview;
}(resource_1.Resource));
exports.MachineDeploymentPreview = MachineDeploymentPreview;
var DeploymentTemplateStep = (function () {
    function DeploymentTemplateStep() {
    }
    return DeploymentTemplateStep;
}());
exports.DeploymentTemplateStep = DeploymentTemplateStep;
var DeploymentPreviewResource = (function (_super) {
    __extends(DeploymentPreviewResource, _super);
    function DeploymentPreviewResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeploymentPreviewResource;
}(resource_1.Resource));
exports.DeploymentPreviewResource = DeploymentPreviewResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentPreviewResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentPreviewResource.ts"); } } })();

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var DeploymentProcessResource = (function (_super) {
    __extends(DeploymentProcessResource, _super);
    function DeploymentProcessResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeploymentProcessResource;
}(resource_1.default));
exports.DeploymentProcessResource = DeploymentProcessResource;
exports.default = DeploymentProcessResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentProcessResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentProcessResource.ts"); } } })();

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentResource.ts"); } } })();

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentTemplateResource.ts"); } } })();

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentResource.ts"); } } })();

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentSummaryResource.ts"); } } })();

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentsSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\environmentsSummaryResource.ts"); } } })();

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\eventResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\eventResource.ts"); } } })();

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\extensionsInfoResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\extensionsInfoResource.ts"); } } })();

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\externalSecurityGroupProviderResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\externalSecurityGroupProviderResource.ts"); } } })();

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var FeaturesConfigurationResource = (function (_super) {
    __extends(FeaturesConfigurationResource, _super);
    function FeaturesConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeaturesConfigurationResource;
}(resource_1.default));
exports.FeaturesConfigurationResource = FeaturesConfigurationResource;
exports.default = FeaturesConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\featuresConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\featuresConfigurationResource.ts"); } } })();

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\interruptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\interruptionResource.ts"); } } })();

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var InvitationResource = (function (_super) {
    __extends(InvitationResource, _super);
    function InvitationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvitationResource;
}(resource_1.default));
exports.InvitationResource = InvitationResource;
exports.default = InvitationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\invitationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\invitationResource.ts"); } } })();

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var LetsEncryptConfigurationResource = (function (_super) {
    __extends(LetsEncryptConfigurationResource, _super);
    function LetsEncryptConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LetsEncryptConfigurationResource;
}(resource_1.default));
exports.LetsEncryptConfigurationResource = LetsEncryptConfigurationResource;
exports.default = LetsEncryptConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\letsEncryptConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\letsEncryptConfigurationResource.ts"); } } })();

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var LicenseResource = (function (_super) {
    __extends(LicenseResource, _super);
    function LicenseResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LicenseResource;
}(resource_1.default));
exports.LicenseResource = LicenseResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\licenseResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\licenseResource.ts"); } } })();

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\lifecycleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\lifecycleResource.ts"); } } })();

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\linksCollection.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\linksCollection.ts"); } } })();

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\loginCommand.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\loginCommand.ts"); } } })();

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\loginState.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\loginState.ts"); } } })();

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeleteMachinesBehavior;
(function (DeleteMachinesBehavior) {
    DeleteMachinesBehavior["DoNotDelete"] = "DoNotDelete";
    DeleteMachinesBehavior["DeleteUnavailableMachines"] = "DeleteUnavailableMachines";
})(DeleteMachinesBehavior = exports.DeleteMachinesBehavior || (exports.DeleteMachinesBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineCleanupPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineCleanupPolicy.ts"); } } })();

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineConnectivityBehavior;
(function (MachineConnectivityBehavior) {
    MachineConnectivityBehavior["ExpectedToBeOnline"] = "ExpectedToBeOnline";
    MachineConnectivityBehavior["MayBeOfflineAndCanBeSkipped"] = "MayBeOfflineAndCanBeSkipped";
})(MachineConnectivityBehavior = exports.MachineConnectivityBehavior || (exports.MachineConnectivityBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineConnectivityPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineConnectivityPolicy.ts"); } } })();

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineConnectionStatus.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineConnectionStatus.ts"); } } })();

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineHealthCheckPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineHealthCheckPolicy.ts"); } } })();

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machinePolicyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machinePolicyResource.ts"); } } })();

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineScriptPolicyRunType;
(function (MachineScriptPolicyRunType) {
    MachineScriptPolicyRunType["InheritFromDefault"] = "InheritFromDefault";
    MachineScriptPolicyRunType["Inline"] = "Inline";
    MachineScriptPolicyRunType["OnlyConnectivity"] = "OnlyConnectivity";
})(MachineScriptPolicyRunType = exports.MachineScriptPolicyRunType || (exports.MachineScriptPolicyRunType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineScriptPolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineScriptPolicy.ts"); } } })();

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalamariUpdateBehavior;
(function (CalamariUpdateBehavior) {
    CalamariUpdateBehavior["UpdateOnDeployment"] = "UpdateOnDeployment";
    CalamariUpdateBehavior["UpdateOnNewMachine"] = "UpdateOnNewMachine";
    CalamariUpdateBehavior["UpdateAlways"] = "UpdateAlways";
})(CalamariUpdateBehavior = exports.CalamariUpdateBehavior || (exports.CalamariUpdateBehavior = {}));
var TentacleUpdateBehavior;
(function (TentacleUpdateBehavior) {
    TentacleUpdateBehavior["NeverUpdate"] = "NeverUpdate";
    TentacleUpdateBehavior["Update"] = "Update";
})(TentacleUpdateBehavior = exports.TentacleUpdateBehavior || (exports.TentacleUpdateBehavior = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineUpdatePolicy.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\machineUpdatePolicy.ts"); } } })();

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var MaintenanceConfigurationResource = (function (_super) {
    __extends(MaintenanceConfigurationResource, _super);
    function MaintenanceConfigurationResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MaintenanceConfigurationResource;
}(resource_1.default));
exports.MaintenanceConfigurationResource = MaintenanceConfigurationResource;
exports.default = MaintenanceConfigurationResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\maintenanceConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\maintenanceConfigurationResource.ts"); } } })();

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\namedReferenceItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\namedReferenceItem.ts"); } } })();

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\octopusServerNodeResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\octopusServerNodeResource.ts"); } } })();

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\packageResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\packageResource.ts"); } } })();

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permissions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permissions.ts"); } } })();

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permissionDescriptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\permissionDescriptionResource.ts"); } } })();

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\progressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\progressionResource.ts"); } } })();

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GuidedFailureMode;
(function (GuidedFailureMode) {
    GuidedFailureMode["EnvironmentDefault"] = "EnvironmentDefault";
    GuidedFailureMode["Off"] = "Off";
    GuidedFailureMode["On"] = "On";
})(GuidedFailureMode = exports.GuidedFailureMode || (exports.GuidedFailureMode = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectResource.ts"); } } })();

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectGroupResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectGroupResource.ts"); } } })();

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\proxyResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\proxyResource.ts"); } } })();

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\propertyValueResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\propertyValueResource.ts"); } } })();

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseProgressionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseProgressionResource.ts"); } } })();

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseResource.ts"); } } })();

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseTemplateResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\releaseTemplateResource.ts"); } } })();

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\resourceCollection.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\resourceCollection.ts"); } } })();

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RetentionUnit;
(function (RetentionUnit) {
    RetentionUnit["Days"] = "Days";
    RetentionUnit["Items"] = "Items";
})(RetentionUnit = exports.RetentionUnit || (exports.RetentionUnit = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\retentionPeriod.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\retentionPeriod.ts"); } } })();

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var RootResource = (function (_super) {
    __extends(RootResource, _super);
    function RootResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RootResource;
}(resource_1.default));
exports.RootResource = RootResource;
exports.default = RootResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\rootResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\rootResource.ts"); } } })();

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\scheduledTaskDetailsResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\scheduledTaskDetailsResource.ts"); } } })();

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Event"] = "Event";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
function isExistingSubscriptionResource(T) {
    return T.Links !== undefined;
}
exports.isExistingSubscriptionResource = isExistingSubscriptionResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\subscriptionResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\subscriptionResource.ts"); } } })();

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverConfigurationResource.ts"); } } })();

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverConfigurationSettingsSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverConfigurationSettingsSetResource.ts"); } } })();

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverStatusResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverStatusResource.ts"); } } })();

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverTimezoneResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\serverTimezoneResource.ts"); } } })();

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\smtpConfigurationResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\smtpConfigurationResource.ts"); } } })();

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\summaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\summaryResource.ts"); } } })();

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var SystemInfoResource = (function (_super) {
    __extends(SystemInfoResource, _super);
    function SystemInfoResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SystemInfoResource;
}(resource_1.default));
exports.SystemInfoResource = SystemInfoResource;
exports.default = SystemInfoResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\systemInfoResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\systemInfoResource.ts"); } } })();

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tagResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tagResource.ts"); } } })();

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tagSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tagSetResource.ts"); } } })();

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\teamResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\teamResource.ts"); } } })();

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantResource.ts"); } } })();

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantMissingVariablesResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantMissingVariablesResource.ts"); } } })();

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantVariableResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\tenantVariableResource.ts"); } } })();

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TimeSpanString = (function (_super) {
    __extends(TimeSpanString, _super);
    function TimeSpanString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeSpanString.Zero = "00:00:00";
    TimeSpanString.OneHour = "0.01:00:00";
    TimeSpanString.TenSeconds = "00:00:10";
    return TimeSpanString;
}(String));
exports.TimeSpanString = TimeSpanString;
exports.default = TimeSpanString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\timeSpan.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\timeSpan.ts"); } } })();

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserPermissionRestriction = (function () {
    function UserPermissionRestriction() {
    }
    return UserPermissionRestriction;
}());
exports.UserPermissionRestriction = UserPermissionRestriction;
exports.default = UserPermissionRestriction;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userPermissionRestriction.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userPermissionRestriction.ts"); } } })();

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = __webpack_require__(55);
var UserPermissionSetResource = (function (_super) {
    __extends(UserPermissionSetResource, _super);
    function UserPermissionSetResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserPermissionSetResource;
}(resource_1.default));
exports.UserPermissionSetResource = UserPermissionSetResource;
exports.default = UserPermissionSetResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userPermissionSetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userPermissionSetResource.ts"); } } })();

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(213);
var UserResource = (function (_super) {
    __extends(UserResource, _super);
    function UserResource() {
        var _this = _super.call(this) || this;
        _this.Name = _this.DisplayName;
        return _this;
    }
    return UserResource;
}(namedResource_1.default));
exports.UserResource = UserResource;
exports.default = UserResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userResource.ts"); } } })();

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var namedResource_1 = __webpack_require__(213);
var UserRoleResource = (function (_super) {
    __extends(UserRoleResource, _super);
    function UserRoleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserRoleResource;
}(namedResource_1.default));
exports.UserRoleResource = UserRoleResource;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userRoleResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\userRoleResource.ts"); } } })();

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\variablesScopedToEnvironmentResponse.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\variablesScopedToEnvironmentResponse.ts"); } } })();

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var referenceDataItem_1 = __webpack_require__(544);
var ProjectedTeamReferenceDataItem = (function (_super) {
    __extends(ProjectedTeamReferenceDataItem, _super);
    function ProjectedTeamReferenceDataItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectedTeamReferenceDataItem;
}(referenceDataItem_1.default));
exports.ProjectedTeamReferenceDataItem = ProjectedTeamReferenceDataItem;
exports.default = ProjectedTeamReferenceDataItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectedTeamReferenceDataItem.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\projectedTeamReferenceDataItem.ts"); } } })();

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolResource.ts"); } } })();

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolSummaryResource.ts"); } } })();

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolsSummaryResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerpoolsSummaryResource.ts"); } } })();

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var triggerResource_1 = __webpack_require__(349);
var TriggerScheduleResource = (function (_super) {
    __extends(TriggerScheduleResource, _super);
    function TriggerScheduleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TriggerScheduleResource;
}(triggerResource_1.TriggerFilterResource));
exports.TriggerScheduleResource = TriggerScheduleResource;
var TriggerScheduleIntervalType;
(function (TriggerScheduleIntervalType) {
    TriggerScheduleIntervalType["OnceDaily"] = "OnceDaily";
    TriggerScheduleIntervalType["OnceHourly"] = "OnceHourly";
    TriggerScheduleIntervalType["OnceEveryMinute"] = "OnceEveryMinute";
})(TriggerScheduleIntervalType = exports.TriggerScheduleIntervalType || (exports.TriggerScheduleIntervalType = {}));
var TriggerScheduleRunType;
(function (TriggerScheduleRunType) {
    TriggerScheduleRunType["ScheduledTime"] = "ScheduledTime";
    TriggerScheduleRunType["Continuously"] = "Continuously";
})(TriggerScheduleRunType = exports.TriggerScheduleRunType || (exports.TriggerScheduleRunType = {}));
var DailyTriggerScheduleResource = (function (_super) {
    __extends(DailyTriggerScheduleResource, _super);
    function DailyTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.Interval = TriggerScheduleIntervalType.OnceDaily;
        _this.FilterType = triggerResource_1.TriggerFilterType.DailySchedule;
        return _this;
    }
    return DailyTriggerScheduleResource;
}(TriggerScheduleResource));
exports.DailyTriggerScheduleResource = DailyTriggerScheduleResource;
var TriggerScheduleIntervalResource = (function () {
    function TriggerScheduleIntervalResource() {
        this.Interval = TriggerScheduleIntervalType.OnceDaily;
    }
    return TriggerScheduleIntervalResource;
}());
exports.TriggerScheduleIntervalResource = TriggerScheduleIntervalResource;
var MonthlyScheduleType;
(function (MonthlyScheduleType) {
    MonthlyScheduleType["DateOfMonth"] = "DateOfMonth";
    MonthlyScheduleType["DayOfMonth"] = "DayOfMonth";
})(MonthlyScheduleType = exports.MonthlyScheduleType || (exports.MonthlyScheduleType = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
    DayOfWeek["Sunday"] = "Sunday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var DaysPerMonthTriggerScheduleResource = (function (_super) {
    __extends(DaysPerMonthTriggerScheduleResource, _super);
    function DaysPerMonthTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.DaysPerMonthSchedule;
        return _this;
    }
    return DaysPerMonthTriggerScheduleResource;
}(TriggerScheduleResource));
exports.DaysPerMonthTriggerScheduleResource = DaysPerMonthTriggerScheduleResource;
var DaysPerWeekTriggerScheduleResource = (function (_super) {
    __extends(DaysPerWeekTriggerScheduleResource, _super);
    function DaysPerWeekTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.DaysPerWeekSchedule;
        return _this;
    }
    return DaysPerWeekTriggerScheduleResource;
}(DailyTriggerScheduleResource));
exports.DaysPerWeekTriggerScheduleResource = DaysPerWeekTriggerScheduleResource;
var CronTriggerScheduleResource = (function (_super) {
    __extends(CronTriggerScheduleResource, _super);
    function CronTriggerScheduleResource() {
        var _this = _super.call(this) || this;
        _this.FilterType = triggerResource_1.TriggerFilterType.CronExpressionSchedule;
        return _this;
    }
    return CronTriggerScheduleResource;
}(TriggerScheduleResource));
exports.CronTriggerScheduleResource = CronTriggerScheduleResource;
var ScopedDeploymentActionResource = (function (_super) {
    __extends(ScopedDeploymentActionResource, _super);
    function ScopedDeploymentActionResource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TenantIds = [];
        _this.TenantTags = [];
        return _this;
    }
    return ScopedDeploymentActionResource;
}(triggerResource_1.TriggerActionResource));
exports.ScopedDeploymentActionResource = ScopedDeploymentActionResource;
var DeployLatestReleaseActionResource = (function (_super) {
    __extends(DeployLatestReleaseActionResource, _super);
    function DeployLatestReleaseActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = triggerResource_1.TriggerActionType.DeployLatestRelease;
        return _this;
    }
    return DeployLatestReleaseActionResource;
}(ScopedDeploymentActionResource));
exports.DeployLatestReleaseActionResource = DeployLatestReleaseActionResource;
var DeployNewReleaseActionResource = (function (_super) {
    __extends(DeployNewReleaseActionResource, _super);
    function DeployNewReleaseActionResource() {
        var _this = _super.call(this) || this;
        _this.ActionType = triggerResource_1.TriggerActionType.DeployNewRelease;
        return _this;
    }
    return DeployNewReleaseActionResource;
}(ScopedDeploymentActionResource));
exports.DeployNewReleaseActionResource = DeployNewReleaseActionResource;
var ScheduleIntervalResource = (function () {
    function ScheduleIntervalResource() {
    }
    return ScheduleIntervalResource;
}());
exports.ScheduleIntervalResource = ScheduleIntervalResource;
var ScheduleIntervalType;
(function (ScheduleIntervalType) {
    ScheduleIntervalType["Once"] = "Once";
    ScheduleIntervalType["Hour"] = "Hour";
    ScheduleIntervalType["Minute"] = "Minute";
})(ScheduleIntervalType = exports.ScheduleIntervalType || (exports.ScheduleIntervalType = {}));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\scheduledProjectTriggerResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\scheduledProjectTriggerResource.ts"); } } })();

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isDeploymentTarget(machine) {
    return machine.EnvironmentIds !== undefined;
}
exports.isDeploymentTarget = isDeploymentTarget;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentTargetResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\deploymentTargetResource.ts"); } } })();

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isWorkerMachine(machine) {
    return machine.WorkerPoolIds !== undefined;
}
exports.isWorkerMachine = isWorkerMachine;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerMachineResource.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\workerMachineResource.ts"); } } })();

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(123);
var notifications_redux_1 = __webpack_require__(176);
var clientInstance_1 = __webpack_require__(10);
var notificationLocalState = __webpack_require__(265);
var notificationId = "Notification/ClientVersionOutdated";
var HTTPHeader = "Octopus-Node";
exports.serverVersionNotificationCheck = function (request) {
    var clientVersion = clientInstance_1.client.version;
    var apiVersion = getApiVersion(request);
    if (!apiVersion) {
        return;
    }
    if (apiVersion === clientVersion) {
        notificationLocalState.clearValue(notificationId);
        notifications_redux_1.dismissNotification(store_1.default.dispatch)(notificationId);
        return;
    }
    var description = "The current web portal is running as version " + clientVersion + " however Octopus Server is\n    running " + apiVersion + ". Refresh this page to ensure you have the latest portal version.";
    notifications_redux_1.raiseNotification(store_1.default.dispatch)({
        id: notificationId,
        value: apiVersion,
        type: notifications_redux_1.NotificationType.info,
        description: description,
        text: "Server version updated",
        links: [{ type: "Refresh", label: "Reload Site" }]
    });
};
function getApiVersion(request) {
    var nodeVersion = request.getResponseHeader(HTTPHeader);
    if (!nodeVersion) {
        return;
    }
    nodeVersion = nodeVersion.split("; ").find(function (v) { return v.startsWith("version="); });
    if (!nodeVersion) {
        return;
    }
    return nodeVersion.substr(8);
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\http\\serverVersionNotificationCheck.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\http\\serverVersionNotificationCheck.tsx"); } } })();

/***/ }),
/* 1066 */,
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(108);
var redux_composers_1 = __webpack_require__(1068);
var infrastructureArea_1 = __webpack_require__(1073);
var libraryArea_1 = __webpack_require__(795);
var projectsArea_1 = __webpack_require__(243);
var reducers_1 = __webpack_require__(546);
var reducers_2 = __webpack_require__(354);
var tenantsArea_1 = __webpack_require__(788);
var expanders_1 = __webpack_require__(315);
var dialog_1 = __webpack_require__(244);
var notifications_redux_1 = __webpack_require__(176);
var configurationArea_1 = __webpack_require__(467);
var reducers_3 = __webpack_require__(566);
var reducers = redux_1.combineReducers({
    libraryArea: libraryArea_1.default,
    infrastructureArea: infrastructureArea_1.default,
    projectsArea: projectsArea_1.default,
    tenantsArea: tenantsArea_1.tenantsArea,
    configurationArea: configurationArea_1.configurationArea,
    expanders: expanders_1.default,
    dialogs: dialog_1.default,
    notifications: notifications_redux_1.notificationReducer,
    unhandledError: redux_composers_1.chainReducers([reducers_1.default, reducers_2.default]),
    formPaperLayoutReducer: reducers_3.default
});
exports.reducers = reducers;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\reducers\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\reducers\\index.ts"); } } })();

/***/ }),
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var machines_1 = __webpack_require__(776);
var accounts_1 = __webpack_require__(793);
var redux_1 = __webpack_require__(108);
__export(__webpack_require__(794));
exports.default = redux_1.combineReducers({
    machines: machines_1.default,
    accounts: accounts_1.default
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\infrastructureArea.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\reducers\\infrastructureArea.ts"); } } })();

/***/ }),
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var letsEncryptConfigurationRepository_1 = __webpack_require__(1135);
var authenticationRepository_1 = __webpack_require__(1136);
var settingsRepository_1 = __webpack_require__(1137);
var accountRepository_1 = __webpack_require__(1138);
var actionTemplateRepository_1 = __webpack_require__(1139);
var artifactRepository_1 = __webpack_require__(1140);
var backupRepository_1 = __webpack_require__(1141);
var builtInRepositoryConfigurationRepository_1 = __webpack_require__(1142);
var certificateConfigurationRepository_1 = __webpack_require__(1143);
var certificateRepository_1 = __webpack_require__(1144);
var channelRepository_1 = __webpack_require__(1145);
var cloudTemplateRepository_1 = __webpack_require__(1146);
var communityActionTemplateRepository_1 = __webpack_require__(1147);
var dashboardRepository_1 = __webpack_require__(1148);
var dashoboardConfigurationRepository_1 = __webpack_require__(1149);
var defectRepository_1 = __webpack_require__(1150);
var deploymentProcessRepository_1 = __webpack_require__(1151);
var deploymentRepository_1 = __webpack_require__(1152);
var environmentRepository_1 = __webpack_require__(1153);
var eventRepository_1 = __webpack_require__(1154);
var externalSecurityGroupProviderRepository_1 = __webpack_require__(1155);
var externalSecurityGroupRepository_1 = __webpack_require__(1156);
var externalUsersRepository_1 = __webpack_require__(1157);
var featuresConfigurationRepository_1 = __webpack_require__(1158);
var feedRepository_1 = __webpack_require__(1159);
var interruptionRepository_1 = __webpack_require__(1160);
var libraryVariableRepository_1 = __webpack_require__(1161);
var licenseRepository_1 = __webpack_require__(1162);
var lifecycleRepository_1 = __webpack_require__(1163);
var machinePolicyRepository_1 = __webpack_require__(1164);
var machineRepository_1 = __webpack_require__(1165);
var machineRoleRepository_1 = __webpack_require__(1166);
var maintenanceConfigurationRepository_1 = __webpack_require__(1167);
var octopusServerNodeRepository_1 = __webpack_require__(1168);
var packageRepository_1 = __webpack_require__(1169);
var performanceConfigurationRepository_1 = __webpack_require__(1170);
var permissionDescriptionRepository_1 = __webpack_require__(1171);
var progressionRepository_1 = __webpack_require__(1172);
var projectGroupRepository_1 = __webpack_require__(1173);
var projectRepository_1 = __webpack_require__(1174);
var projectTriggerRepository_1 = __webpack_require__(1175);
var proxyRepository_1 = __webpack_require__(1176);
var releasesRepository_1 = __webpack_require__(1177);
var retentionPolicyRepository_1 = __webpack_require__(1178);
var schedulerRepository_1 = __webpack_require__(1179);
var serverConfigurationRepository_1 = __webpack_require__(1180);
var serverStatusRepository_1 = __webpack_require__(1181);
var smtpConfigurationRepository_1 = __webpack_require__(1182);
var subscriptionRepository_1 = __webpack_require__(1183);
var tagSetRepository_1 = __webpack_require__(1184);
var taskRepository_1 = __webpack_require__(1185);
var teamRepository_1 = __webpack_require__(1186);
var tenantRepository_1 = __webpack_require__(1187);
var tenantVariableRepository_1 = __webpack_require__(1188);
var upgradeConfigurationRepository_1 = __webpack_require__(1189);
var userIdentityMetadataRepository_1 = __webpack_require__(1190);
var userOnBoardingRepository_1 = __webpack_require__(1191);
var userRepository_1 = __webpack_require__(1192);
var userRoleRepository_1 = __webpack_require__(1193);
var variableRepository_1 = __webpack_require__(1194);
var workerpoolsRepository_1 = __webpack_require__(1195);
var workerRepository_1 = __webpack_require__(1196);
// Repositories provide a helpful abstraction around the Octopus Deploy API
var Repository = (function () {
    function Repository(client) {
        this.takeAll = 2147483647;
        this.resolve = client.resolve;
        this.resolveLinkTemplate = client.resolveLinkTemplate;
        this.Accounts = new accountRepository_1.default(client);
        this.ActionTemplates = new actionTemplateRepository_1.default(client);
        this.Artifacts = new artifactRepository_1.default(client);
        this.Authentication = new authenticationRepository_1.default(client);
        this.Backups = new backupRepository_1.default(client);
        this.BuiltInRepositoryConfiguration = new builtInRepositoryConfigurationRepository_1.default(client);
        this.CertificateConfiguration = new certificateConfigurationRepository_1.default(client);
        this.Certificates = new certificateRepository_1.default(client);
        this.Channels = new channelRepository_1.default(client);
        this.CloudTemplates = new cloudTemplateRepository_1.default(client);
        this.CommunityActionTemplates = new communityActionTemplateRepository_1.default(client);
        this.DashboardConfiguration = new dashoboardConfigurationRepository_1.default(client);
        this.Dashboards = new dashboardRepository_1.default(client);
        this.Defects = new defectRepository_1.default(client);
        this.Deployments = new deploymentRepository_1.default(client);
        this.DeploymentProcesses = new deploymentProcessRepository_1.default(client);
        this.Environments = new environmentRepository_1.default(client);
        this.Events = new eventRepository_1.default(client);
        this.ExternalSecurityGroupProviders = new externalSecurityGroupProviderRepository_1.default(client);
        this.ExternalSecurityGroups = new externalSecurityGroupRepository_1.default(client);
        this.ExternalUsers = new externalUsersRepository_1.default(client);
        this.FeaturesConfiguration = new featuresConfigurationRepository_1.default(client);
        this.Feeds = new feedRepository_1.default(client);
        this.Interruptions = new interruptionRepository_1.default(client);
        this.LetsEncryptConfiguration = new letsEncryptConfigurationRepository_1.default(client);
        this.LibraryVariableSets = new libraryVariableRepository_1.default(client);
        this.Licenses = new licenseRepository_1.default(client);
        this.Lifecycles = new lifecycleRepository_1.default(client);
        this.MachinePolicies = new machinePolicyRepository_1.default(client);
        this.MachineRoles = new machineRoleRepository_1.default(client);
        this.Machines = new machineRepository_1.default(client);
        this.MaintenanceConfiguration = new maintenanceConfigurationRepository_1.default(client);
        this.OctopusServerNodes = new octopusServerNodeRepository_1.default(client);
        this.Packages = new packageRepository_1.default(client);
        this.PerformanceConfiguration = new performanceConfigurationRepository_1.default(client);
        this.PermissionDescriptions = new permissionDescriptionRepository_1.default(client);
        this.Progression = new progressionRepository_1.default(client);
        this.ProjectGroups = new projectGroupRepository_1.default(client);
        this.Projects = new projectRepository_1.default(client);
        this.ProjectTriggers = new projectTriggerRepository_1.default(client);
        this.Proxies = new proxyRepository_1.default(client);
        this.Releases = new releasesRepository_1.default(client);
        this.RetentionPolicies = new retentionPolicyRepository_1.default(client);
        this.Scheduler = new schedulerRepository_1.default(client);
        this.ServerStatus = new serverStatusRepository_1.default(client);
        this.ServerConfiguration = new serverConfigurationRepository_1.default(client);
        this.Settings = new settingsRepository_1.default(client);
        this.SmtpConfiguration = new smtpConfigurationRepository_1.default(client);
        this.Subscriptions = new subscriptionRepository_1.default(client);
        this.TagSets = new tagSetRepository_1.default(client);
        this.Tasks = new taskRepository_1.default(client);
        this.Teams = new teamRepository_1.default(client);
        this.Tenants = new tenantRepository_1.default(client);
        this.TenantVariables = new tenantVariableRepository_1.default(client);
        this.UpgradeConfiguration = new upgradeConfigurationRepository_1.default(client);
        this.UserIdentityMetadata = new userIdentityMetadataRepository_1.default(client);
        this.UserOnboarding = new userOnBoardingRepository_1.default(client);
        this.UserRoles = new userRoleRepository_1.default(client);
        this.Users = new userRepository_1.default(client);
        this.Variables = new variableRepository_1.default(client);
        this.WorkerPools = new workerpoolsRepository_1.default(client);
        this.Workers = new workerRepository_1.default(client);
        this.getRootDocument = client.getRootDocument.bind(client);
    }
    return Repository;
}());
exports.default = Repository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repository.ts"); } } })();

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var LetsEncryptConfigurationRepository = (function (_super) {
    __extends(LetsEncryptConfigurationRepository, _super);
    function LetsEncryptConfigurationRepository(client) {
        return _super.call(this, "LetsEncryptConfiguration", client) || this;
    }
    return LetsEncryptConfigurationRepository;
}(configurationRepository_1.default));
exports.default = LetsEncryptConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\letsEncryptConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\letsEncryptConfigurationRepository.ts"); } } })();

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var AuthenticationRepository = (function (_super) {
    __extends(AuthenticationRepository, _super);
    function AuthenticationRepository(client) {
        return _super.call(this, "Authentication", client) || this;
    }
    AuthenticationRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links["Authentication"]);
    };
    AuthenticationRepository.prototype.wasLoginInitiated = function (encodedQueryString) {
        return this.client.post(this.client.getRootDocument().Links["LoginInitiated"], { EncodedQueryString: encodedQueryString });
    };
    return AuthenticationRepository;
}(basicRepository_1.default));
exports.default = AuthenticationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\authentication\\authenticationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\authentication\\authenticationRepository.ts"); } } })();

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var SettingsRepository = (function (_super) {
    __extends(SettingsRepository, _super);
    function SettingsRepository(client) {
        return _super.call(this, "Configuration", client) || this;
    }
    SettingsRepository.prototype.getById = function (id) {
        return this.client.get(this.client.getRootDocument().Links["Configuration"], { id: id });
    };
    SettingsRepository.prototype.getValues = function (resource) {
        return this.client.get(resource.Links["Values"]);
    };
    SettingsRepository.prototype.getMetadata = function (resource) {
        return this.client.get(resource.Links["Metadata"]);
    };
    SettingsRepository.prototype.saveValues = function (metadataResource, resource) {
        return this.client.put(metadataResource.Links["Values"], resource);
    };
    return SettingsRepository;
}(basicRepository_1.default));
exports.default = SettingsRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\configuration\\settingsRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\configuration\\settingsRepository.ts"); } } })();

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var AccountRepository = (function (_super) {
    __extends(AccountRepository, _super);
    function AccountRepository(client) {
        return _super.call(this, "Accounts", client) || this;
    }
    AccountRepository.prototype.getWebSites = function (account) {
        return this.client.get(account.Links["WebSites"]);
    };
    AccountRepository.prototype.getWebSiteSlots = function (account, resourceGroupName, webSiteName) {
        var args = { resourceGroupName: resourceGroupName, webSiteName: webSiteName };
        return this.client.get(account.Links["WebSiteSlots"], args);
    };
    AccountRepository.prototype.getCloudServices = function (account) {
        return this.client.get(account.Links["CloudServices"]);
    };
    AccountRepository.prototype.getStorageAccounts = function (account) {
        return this.client.get(account.Links["StorageAccounts"]);
    };
    AccountRepository.prototype.getResourceGroups = function (account) {
        return this.client.get(account.Links["ResourceGroups"]);
    };
    AccountRepository.prototype.getFabricApplications = function (account) {
        return this.client.get(account.Links["FabricApplications"]);
    };
    AccountRepository.prototype.getAccountUsages = function (account) {
        return this.client.get(account.Links["Usages"]);
    };
    AccountRepository.prototype.getIsolatedAzureEnvironments = function () {
        return this.client.get(this.client.getRootDocument().Links["Accounts"].concat("/azureenvironments"));
    };
    return AccountRepository;
}(basicRepository_1.default));
exports.default = AccountRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\accountRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\accountRepository.ts"); } } })();

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var logoUpload_1 = __webpack_require__(355);
var ActionTemplateRepository = (function (_super) {
    __extends(ActionTemplateRepository, _super);
    function ActionTemplateRepository(client) {
        return _super.call(this, "ActionTemplates", client) || this;
    }
    ActionTemplateRepository.prototype.getUsage = function (template) {
        return this.client.get(template.Links["Usage"]);
    };
    ActionTemplateRepository.prototype.getByCommunityTemplate = function (communityTemplate) {
        var allArgs = __assign({}, { id: communityTemplate.Id });
        return this.client.get(communityTemplate.Links["InstalledTemplate"], allArgs);
    };
    ActionTemplateRepository.prototype.search = function () {
        return this.client.get(this.client.getRootDocument().Links["ActionTemplatesSearch"]);
    };
    ActionTemplateRepository.prototype.updateActions = function (actionTemplate, actionIdsByProcessId, defaults, overrides) {
        if (defaults === void 0) { defaults = {}; }
        if (overrides === void 0) { overrides = {}; }
        defaults = defaults || {};
        overrides = overrides || {};
        return this.client.post(actionTemplate.Links["ActionsUpdate"], {
            actionIdsByProcessId: actionIdsByProcessId,
            defaultPropertyValues: defaults,
            overrides: overrides,
            version: actionTemplate.Version
        });
    };
    ActionTemplateRepository.prototype.getVersion = function (actionTemplate, version) {
        return this.client.get(actionTemplate.Links["Versions"], { version: version });
    };
    ActionTemplateRepository.prototype.uploadLogo = function (actionTemplate, logo) {
        return logoUpload_1.uploadLogo(actionTemplate, logo);
    };
    return ActionTemplateRepository;
}(basicRepository_1.default));
exports.default = ActionTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\actionTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\actionTemplateRepository.ts"); } } })();

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ArtifactRepository = (function (_super) {
    __extends(ArtifactRepository, _super);
    function ArtifactRepository(client) {
        return _super.call(this, "Artifacts", client) || this;
    }
    return ArtifactRepository;
}(basicRepository_1.default));
exports.default = ArtifactRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\artifactRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\artifactRepository.ts"); } } })();

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BackupRepository = (function () {
    function BackupRepository(client) {
        this.client = client;
    }
    BackupRepository.prototype.getConfiguration = function () {
        return this.client.get(this.client.getRootDocument().Links["BackupConfiguration"]);
    };
    BackupRepository.prototype.updateConfiguration = function (configuration) {
        return this.client.update(configuration.Links["Self"], configuration);
    };
    return BackupRepository;
}());
exports.default = BackupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\backupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\backupRepository.ts"); } } })();

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var BuiltInRepositoryConfigurationRepository = (function (_super) {
    __extends(BuiltInRepositoryConfigurationRepository, _super);
    function BuiltInRepositoryConfigurationRepository(client) {
        return _super.call(this, "RepositoryConfiguration", client) || this;
    }
    return BuiltInRepositoryConfigurationRepository;
}(configurationRepository_1.default));
exports.default = BuiltInRepositoryConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\builtInRepositoryConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\builtInRepositoryConfigurationRepository.ts"); } } })();

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var CertificateConfigurationRepository = (function (_super) {
    __extends(CertificateConfigurationRepository, _super);
    function CertificateConfigurationRepository(client) {
        return _super.call(this, "CertificateConfiguration", client) || this;
    }
    CertificateConfigurationRepository.prototype.global = function () {
        return this.get("certificate-global");
    };
    CertificateConfigurationRepository.prototype.azure = function () {
        return this.get("certificate-azure");
    };
    CertificateConfigurationRepository.prototype.export = function (certificate, exportOptions) {
        return this.client.get(certificate.Links["Export"], exportOptions);
    };
    CertificateConfigurationRepository.prototype.archive = function (certificate) {
        return this.client.post(certificate.Links["Archive"]);
    };
    CertificateConfigurationRepository.prototype.unarchive = function (certificate) {
        return this.client.post(certificate.Links["Unarchive"]);
    };
    CertificateConfigurationRepository.prototype.usage = function (certificate) {
        return this.client.get(certificate.Links["Usages"]);
    };
    CertificateConfigurationRepository.prototype.replace = function (certificate, newCertificateData, newPassword) {
        return this.client.post(certificate.Links["Replace"], {
            certificateData: newCertificateData,
            password: newPassword
        });
    };
    return CertificateConfigurationRepository;
}(basicRepository_1.default));
exports.default = CertificateConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\certificateConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\certificateConfigurationRepository.ts"); } } })();

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var CertificateRepository = (function (_super) {
    __extends(CertificateRepository, _super);
    function CertificateRepository(client) {
        return _super.call(this, "Certificates", client) || this;
    }
    CertificateRepository.prototype.names = function (projectId, projectEnvironmentsFilter) {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    };
    CertificateRepository.prototype.nonPrintableChars = function (variableSet) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    };
    return CertificateRepository;
}(basicRepository_1.default));
exports.default = CertificateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\certificateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\certificateRepository.ts"); } } })();

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ChannelRepository = (function (_super) {
    __extends(ChannelRepository, _super);
    function ChannelRepository(client) {
        return _super.call(this, "Channels", client) || this;
    }
    ChannelRepository.prototype.ruleTest = function (version, searchOptions) {
        return this.client.post(this.client.getRootDocument().Links["VersionRuleTest"], {
            preReleaseTag: searchOptions.preReleaseTag,
            version: version,
            versionRange: searchOptions.versionRange,
            feedType: searchOptions.feedType
        });
    };
    ChannelRepository.prototype.getReleases = function (channel, options) {
        return this.client.get(channel.Links["Releases"], options);
    };
    return ChannelRepository;
}(basicRepository_1.default));
exports.default = ChannelRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\channelRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\channelRepository.ts"); } } })();

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloudTemplateRepository = (function () {
    function CloudTemplateRepository(client) {
        this.client = client;
    }
    CloudTemplateRepository.prototype.getMetadata = function (templateBody, id) {
        var templateResource = { template: encodeURI(templateBody) };
        return this.client.post(this.client.getRootDocument().Links["CloudTemplate"], templateResource, { id: id.toString() });
    };
    return CloudTemplateRepository;
}());
exports.default = CloudTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\cloudTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\cloudTemplateRepository.ts"); } } })();

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommunityActionTemplateRepository = (function () {
    function CommunityActionTemplateRepository(client) {
        this.client = client;
    }
    CommunityActionTemplateRepository.prototype.get = function (id) {
        var allArgs = __assign({}, { id: id });
        return this.client.get(this.client.getRootDocument().Links["CommunityActionTemplates"], allArgs);
    };
    CommunityActionTemplateRepository.prototype.install = function (communityActionTemplate) {
        return this.client.post(communityActionTemplate.Links["Installation"]);
    };
    CommunityActionTemplateRepository.prototype.updateInstallation = function (communityActionTemplate) {
        return this.client.put(communityActionTemplate.Links["Installation"]);
    };
    return CommunityActionTemplateRepository;
}());
exports.default = CommunityActionTemplateRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\communityActionTemplateRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\communityActionTemplateRepository.ts"); } } })();

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardRepository = (function () {
    function DashboardRepository(client) {
        this.client = client;
    }
    DashboardRepository.prototype.getDeploymentsCountedByWeek = function (projectIds) {
        return this.client.get(this.client.getRootDocument().Links["Reporting/DeploymentsCountedByWeek"], { projectIds: projectIds.join(",") });
    };
    DashboardRepository.prototype.getDashboard = function (dashboardFilter) {
        return this.client.get(this.client.getRootDocument().Links["Dashboard"], dashboardFilter);
    };
    return DashboardRepository;
}());
exports.default = DashboardRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\dashboardRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\dashboardRepository.ts"); } } })();

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var DashboardConfigurationRepository = (function (_super) {
    __extends(DashboardConfigurationRepository, _super);
    function DashboardConfigurationRepository(client) {
        return _super.call(this, "DashboardConfiguration", client) || this;
    }
    return DashboardConfigurationRepository;
}(configurationRepository_1.default));
exports.default = DashboardConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\dashoboardConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\dashoboardConfigurationRepository.ts"); } } })();

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DefectRepository = (function () {
    function DefectRepository(client) {
        this.client = client;
    }
    DefectRepository.prototype.all = function (release) {
        return this.client.get(release.Links["Defects"]);
    };
    DefectRepository.prototype.report = function (release, description) {
        return this.client.post(release.Links["ReportDefect"], { Description: description });
    };
    DefectRepository.prototype.resolve = function (release) {
        return this.client.post(release.Links["ResolveDefect"]);
    };
    return DefectRepository;
}());
exports.default = DefectRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\defectRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\defectRepository.ts"); } } })();

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var DeploymentProcessRepository = (function (_super) {
    __extends(DeploymentProcessRepository, _super);
    function DeploymentProcessRepository(client) {
        return _super.call(this, "DeploymentProcesses", client) || this;
    }
    DeploymentProcessRepository.prototype.getTemplate = function (deploymentProcess, channelId, releaseId) {
        return this.client.get(deploymentProcess.Links["Template"], { channel: channelId, releaseId: releaseId });
    };
    return DeploymentProcessRepository;
}(basicRepository_1.default));
exports.default = DeploymentProcessRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\deploymentProcessRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\deploymentProcessRepository.ts"); } } })();

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var DeploymentRepository = (function (_super) {
    __extends(DeploymentRepository, _super);
    function DeploymentRepository(client) {
        return _super.call(this, "Deployments", client) || this;
    }
    return DeploymentRepository;
}(basicRepository_1.default));
exports.default = DeploymentRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\deploymentRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\deploymentRepository.ts"); } } })();

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var EnvironmentRepository = (function (_super) {
    __extends(EnvironmentRepository, _super);
    function EnvironmentRepository(client) {
        return _super.call(this, "Environments", client) || this;
    }
    EnvironmentRepository.prototype.sort = function (order) {
        return this.client.put(this.client.getRootDocument().Links["EnvironmentSortOrder"], order);
    };
    EnvironmentRepository.prototype.variablesScopedOnlyToThisEnvironment = function (environment) {
        return this.client.get(environment.Links["SinglyScopedVariableDetails"]);
    };
    EnvironmentRepository.prototype.machines = function (args) {
        return this.client.get(args.environment.Links["Machines"], args);
    };
    EnvironmentRepository.prototype.summary = function (args) {
        return this.client.get(this.client.getRootDocument().Links["EnvironmentsSummary"], args);
    };
    return EnvironmentRepository;
}(basicRepository_1.default));
exports.default = EnvironmentRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\environmentRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\environmentRepository.ts"); } } })();

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var EventRepository = (function (_super) {
    __extends(EventRepository, _super);
    function EventRepository(client) {
        return _super.call(this, "Events", client) || this;
    }
    EventRepository.prototype.categories = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventCategories"], options);
    };
    EventRepository.prototype.groups = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventGroups"], options);
    };
    EventRepository.prototype.documentTypes = function (options) {
        return this.client.get(this.client.getRootDocument().Links["EventDocumentTypes"], options);
    };
    return EventRepository;
}(basicRepository_1.default));
exports.default = EventRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\eventRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\eventRepository.ts"); } } })();

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalSecurityGroupProviderRepository = (function () {
    function ExternalSecurityGroupProviderRepository(client) {
        this.client = client;
    }
    ExternalSecurityGroupProviderRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["ExternalSecurityGroupProviders"]);
    };
    return ExternalSecurityGroupProviderRepository;
}());
exports.default = ExternalSecurityGroupProviderRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalSecurityGroupProviderRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalSecurityGroupProviderRepository.ts"); } } })();

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalSecurityGroupRepository = (function () {
    function ExternalSecurityGroupRepository(client) {
        this.client = client;
    }
    ExternalSecurityGroupRepository.prototype.search = function (url, partialName) {
        return this.client.get(url, { partialName: partialName });
    };
    return ExternalSecurityGroupRepository;
}());
exports.default = ExternalSecurityGroupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalSecurityGroupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalSecurityGroupRepository.ts"); } } })();

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExternalUsersRepository = (function () {
    function ExternalUsersRepository(client) {
        this.client = client;
    }
    ExternalUsersRepository.prototype.search = function (partialName) {
        return this.client.get(this.client.getRootDocument().Links["ExternalUserSearch"], { partialName: partialName });
    };
    ExternalUsersRepository.prototype.searchProvider = function (providerUrl, partialName) {
        return this.client.get(providerUrl, { partialName: partialName });
    };
    return ExternalUsersRepository;
}());
exports.default = ExternalUsersRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalUsersRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\externalUsersRepository.ts"); } } })();

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var FeaturesConfigurationRepository = (function (_super) {
    __extends(FeaturesConfigurationRepository, _super);
    function FeaturesConfigurationRepository(client) {
        return _super.call(this, "FeaturesConfiguration", client) || this;
    }
    return FeaturesConfigurationRepository;
}(configurationRepository_1.default));
exports.default = FeaturesConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\featuresConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\featuresConfigurationRepository.ts"); } } })();

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var FeedRepository = (function (_super) {
    __extends(FeedRepository, _super);
    function FeedRepository(client) {
        return _super.call(this, "Feeds", client) || this;
    }
    FeedRepository.prototype.searchPackages = function (feed, searchOptions) {
        return this.client.get(feed.Links["SearchPackagesTemplate"], searchOptions);
    };
    FeedRepository.prototype.searchPackageVersions = function (feed, packageId, searchOptions) {
        return this.client.get(feed.Links["SearchPackageVersionsTemplate"], __assign({ packageId: packageId }, searchOptions));
    };
    FeedRepository.prototype.getNotes = function (feed, packageId, version) {
        return this.client.getRaw(feed.Links["NotesTemplate"], { packageId: packageId, version: version });
    };
    return FeedRepository;
}(basicRepository_1.default));
exports.default = FeedRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\feedRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\feedRepository.ts"); } } })();

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var InterruptionRepository = (function (_super) {
    __extends(InterruptionRepository, _super);
    function InterruptionRepository(client) {
        return _super.call(this, "Interruptions", client) || this;
    }
    InterruptionRepository.prototype.submit = function (interruption, result) {
        return this.client.post(interruption.Links["Submit"], result);
    };
    InterruptionRepository.prototype.takeResponsibility = function (interruption) {
        return this.client.put(interruption.Links["Responsible"]);
    };
    return InterruptionRepository;
}(basicRepository_1.default));
exports.default = InterruptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\interruptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\interruptionRepository.ts"); } } })();

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var LibraryVariableRepository = (function (_super) {
    __extends(LibraryVariableRepository, _super);
    function LibraryVariableRepository(client) {
        return _super.call(this, "LibraryVariables", client) || this;
    }
    return LibraryVariableRepository;
}(basicRepository_1.default));
exports.default = LibraryVariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\libraryVariableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\libraryVariableRepository.ts"); } } })();

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var LicenseRepository = (function (_super) {
    __extends(LicenseRepository, _super);
    function LicenseRepository(client) {
        return _super.call(this, "Licenses", client) || this;
    }
    LicenseRepository.prototype.getCurrent = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentLicense"]);
    };
    LicenseRepository.prototype.getCurrentStatus = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentLicenseStatus"]);
    };
    return LicenseRepository;
}(basicRepository_1.default));
exports.default = LicenseRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\licenseRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\licenseRepository.ts"); } } })();

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var LifecycleRepository = (function (_super) {
    __extends(LifecycleRepository, _super);
    function LifecycleRepository(client) {
        return _super.call(this, "Lifecycles", client) || this;
    }
    LifecycleRepository.prototype.preview = function (lifecycle) {
        return this.client.get(lifecycle.Links["Preview"]);
    };
    LifecycleRepository.prototype.projects = function (lifecycle) {
        return this.client.get(lifecycle.Links["Projects"]);
    };
    return LifecycleRepository;
}(basicRepository_1.default));
exports.default = LifecycleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\lifecycleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\lifecycleRepository.ts"); } } })();

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var MachinePolicyRepository = (function (_super) {
    __extends(MachinePolicyRepository, _super);
    function MachinePolicyRepository(client) {
        return _super.call(this, "MachinePolicies", client) || this;
    }
    MachinePolicyRepository.prototype.getMachines = function (machinePolicy) {
        return this.client.get(machinePolicy.Links["Machines"]);
    };
    MachinePolicyRepository.prototype.getWorkers = function (machinePolicy) {
        return this.client.get(machinePolicy.Links["Workers"]);
    };
    return MachinePolicyRepository;
}(basicRepository_1.default));
exports.default = MachinePolicyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machinePolicyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machinePolicyRepository.ts"); } } })();

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var MachineRepository = (function (_super) {
    __extends(MachineRepository, _super);
    function MachineRepository(client) {
        return _super.call(this, "Machines", client) || this;
    }
    MachineRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Machines"], args);
    };
    MachineRepository.prototype.listByEnvironment = function (environment) {
        return this.client.get(environment.Links["Machines"]);
    };
    MachineRepository.prototype.discover = function (host, port, type, proxyId) {
        return this.client.get(this.client.getRootDocument().Links["DiscoverMachine"], { host: host, port: port, type: type, proxyId: proxyId });
    };
    MachineRepository.prototype.getConnectionStatus = function (machine) {
        return this.client.get(machine.Links["Connection"]);
    };
    MachineRepository.prototype.getTasks = function (machine, options) {
        return this.client.get(machine.Links["TasksTemplate"], options);
    };
    MachineRepository.prototype.hosted = function () {
        var allArgs = { id: "hosted" };
        return this.client.get(this.client.getRootDocument().Links["Machines"], allArgs);
    };
    MachineRepository.prototype.listByDeployment = function (deployment) {
        return this.client.get(this.client.getRootDocument().Links["Machines"], { deploymentId: deployment.Id, id: "all" });
    };
    return MachineRepository;
}(basicRepository_1.default));
exports.default = MachineRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machineRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machineRepository.ts"); } } })();

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MachineRoleRepository = (function () {
    function MachineRoleRepository(client) {
        this.client = client;
    }
    MachineRoleRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["MachineRoles"]);
    };
    return MachineRoleRepository;
}());
exports.default = MachineRoleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machineRoleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\machineRoleRepository.ts"); } } })();

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var MaintenanceConfigurationRepository = (function (_super) {
    __extends(MaintenanceConfigurationRepository, _super);
    function MaintenanceConfigurationRepository(client) {
        return _super.call(this, "MaintenanceConfiguration", client) || this;
    }
    return MaintenanceConfigurationRepository;
}(configurationRepository_1.default));
exports.default = MaintenanceConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\maintenanceConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\maintenanceConfigurationRepository.ts"); } } })();

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var OctopusServerNodeRepository = (function (_super) {
    __extends(OctopusServerNodeRepository, _super);
    function OctopusServerNodeRepository(client) {
        return _super.call(this, "OctopusServerNodes", client) || this;
    }
    return OctopusServerNodeRepository;
}(basicRepository_1.default));
exports.default = OctopusServerNodeRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\octopusServerNodeRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\octopusServerNodeRepository.ts"); } } })();

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var PackageRepository = (function (_super) {
    __extends(PackageRepository, _super);
    function PackageRepository(client) {
        return _super.call(this, "Packages", client) || this;
    }
    PackageRepository.prototype.deleteMany = function (packageIds) {
        return this.client.del(this.client.getRootDocument().Links["PackagesBulk"], null, { ids: packageIds });
    };
    PackageRepository.prototype.upload = function (pkg, replace) {
        var fd = new FormData();
        fd.append("fileToUpload", pkg);
        return this.client.post(this.client.getRootDocument().Links["PackageUpload"], fd, { replace: replace });
    };
    PackageRepository.prototype.getNotes = function (packages) {
        var packageIds = packages.reduce(function (result, item) { return result +
            (result.length === 0 ? "" : ",") +
            encodeURIComponent(item.FeedId) + ":" +
            encodeURIComponent(item.PackageId) + ":" +
            encodeURIComponent(item.Version); }, "");
        return this.client.get(this.client.getRootDocument().Links["PackageNotesList"], { packageIds: packageIds });
    };
    return PackageRepository;
}(basicRepository_1.default));
exports.default = PackageRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\packageRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\packageRepository.ts"); } } })();

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var PerformanceConfigurationRepository = (function (_super) {
    __extends(PerformanceConfigurationRepository, _super);
    function PerformanceConfigurationRepository(client) {
        return _super.call(this, "PerformanceConfiguration", client) || this;
    }
    return PerformanceConfigurationRepository;
}(configurationRepository_1.default));
exports.default = PerformanceConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\performanceConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\performanceConfigurationRepository.ts"); } } })();

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PermissionDescriptionRepository = (function () {
    function PermissionDescriptionRepository(client) {
        this.client = client;
    }
    PermissionDescriptionRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["PermissionDescriptions"], null);
    };
    return PermissionDescriptionRepository;
}());
exports.default = PermissionDescriptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\permissionDescriptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\permissionDescriptionRepository.ts"); } } })();

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProgressionRepository = (function () {
    function ProgressionRepository(client) {
        this.client = client;
    }
    ProgressionRepository.prototype.getProgression = function (project, options) {
        return this.client.get(project.Links["Progression"], options);
    };
    return ProgressionRepository;
}());
exports.default = ProgressionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\progressionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\progressionRepository.ts"); } } })();

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ProjectGroupRepository = (function (_super) {
    __extends(ProjectGroupRepository, _super);
    function ProjectGroupRepository(client) {
        return _super.call(this, "ProjectGroups", client) || this;
    }
    return ProjectGroupRepository;
}(basicRepository_1.default));
exports.default = ProjectGroupRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectGroupRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectGroupRepository.ts"); } } })();

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var logoUpload_1 = __webpack_require__(355);
var clientInstance_1 = __webpack_require__(10);
var ProjectRepository = (function (_super) {
    __extends(ProjectRepository, _super);
    function ProjectRepository(client) {
        return _super.call(this, "Projects", client) || this;
    }
    ProjectRepository.prototype.getDeployments = function (project) {
        return this.client.get(this.client.getRootDocument().Links["Deployments"], { projects: project.Id });
    };
    ProjectRepository.prototype.getReleases = function (project, args) {
        return this.client.get(project.Links["Releases"], args);
    };
    ProjectRepository.prototype.getReleaseByVersion = function (project, version) {
        return this.client.get(project.Links["Releases"], { version: version });
    };
    ProjectRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Projects"], args);
    };
    ProjectRepository.prototype.listByGroup = function (projectGroup) {
        return this.client.get(projectGroup.Links["Projects"]);
    };
    ProjectRepository.prototype.getChannels = function (project, skip, take) {
        if (skip === void 0) { skip = 0; }
        if (take === void 0) { take = clientInstance_1.repository.takeAll; }
        return this.client.get(project.Links["Channels"], { skip: skip, take: take });
    };
    ProjectRepository.prototype.getTriggers = function (project, skip, take) {
        return this.client.get(project.Links["Triggers"], { skip: skip, take: take });
    };
    ProjectRepository.prototype.orderChannels = function (project, channelIds) {
        return this.client.post(project.Links["OrderChannels"], channelIds);
    };
    ProjectRepository.prototype.getPulse = function (projects) {
        var projectIds = projects.map(function (p) {
            return p.Id;
        }).join(",");
        return this.client.get(this.client.getRootDocument().Links["ProjectPulse"], { projectIds: projectIds });
    };
    ProjectRepository.prototype.uploadLogo = function (project, logo) {
        return logoUpload_1.uploadLogo(project, logo);
    };
    return ProjectRepository;
}(basicRepository_1.default));
exports.default = ProjectRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectRepository.ts"); } } })();

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ProjectTriggerRepository = (function (_super) {
    __extends(ProjectTriggerRepository, _super);
    function ProjectTriggerRepository(client) {
        return _super.call(this, "ProjectTriggers", client) || this;
    }
    return ProjectTriggerRepository;
}(basicRepository_1.default));
exports.default = ProjectTriggerRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectTriggerRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\projectTriggerRepository.ts"); } } })();

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ProxyRepository = (function (_super) {
    __extends(ProxyRepository, _super);
    function ProxyRepository(client) {
        return _super.call(this, "Proxies", client) || this;
    }
    return ProxyRepository;
}(basicRepository_1.default));
exports.default = ProxyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\proxyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\proxyRepository.ts"); } } })();

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var ReleasesRepository = (function (_super) {
    __extends(ReleasesRepository, _super);
    function ReleasesRepository(client) {
        return _super.call(this, "Releases", client) || this;
    }
    ReleasesRepository.prototype.getDeployments = function (release, options) {
        return this.client.get(release.Links["Deployments"], options);
    };
    ReleasesRepository.prototype.getDeploymentTemplate = function (release) {
        return this.client.get(release.Links["DeploymentTemplate"]);
    };
    ReleasesRepository.prototype.getDeploymentPreview = function (promotionTarget) {
        return this.client.get(promotionTarget.Links["Preview"], { includeDisabledSteps: true });
    };
    ReleasesRepository.prototype.progression = function (release) {
        return this.client.get(release.Links["Progression"]);
    };
    ReleasesRepository.prototype.snapshotVariables = function (release) {
        return this.client.post(release.Links["SnapshotVariables"]);
    };
    return ReleasesRepository;
}(basicRepository_1.default));
exports.default = ReleasesRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\releasesRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\releasesRepository.ts"); } } })();

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var RetentionPolicyRepository = (function (_super) {
    __extends(RetentionPolicyRepository, _super);
    function RetentionPolicyRepository(client) {
        return _super.call(this, "RetentionPolicies", client) || this;
    }
    return RetentionPolicyRepository;
}(basicRepository_1.default));
exports.default = RetentionPolicyRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\retentionPolicyRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\retentionPolicyRepository.ts"); } } })();

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var SchedulerRepository = (function (_super) {
    __extends(SchedulerRepository, _super);
    function SchedulerRepository(client) {
        return _super.call(this, "Scheduler", client) || this;
    }
    SchedulerRepository.prototype.getDetails = function (name, options) {
        var args = __assign({}, options, { name: name });
        return this.client.get(this.client.getRootDocument().Links["Scheduler"], args);
    };
    return SchedulerRepository;
}(basicRepository_1.default));
exports.default = SchedulerRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\schedulerRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\schedulerRepository.ts"); } } })();

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var ServerConfigurationRepository = (function (_super) {
    __extends(ServerConfigurationRepository, _super);
    function ServerConfigurationRepository(client) {
        return _super.call(this, "ServerConfiguration", client) || this;
    }
    ServerConfigurationRepository.prototype.settings = function () {
        return this.client.get(this.client.getRootDocument().Links["ServerConfigurationSettings"]);
    };
    return ServerConfigurationRepository;
}(configurationRepository_1.default));
exports.default = ServerConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\serverConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\serverConfigurationRepository.ts"); } } })();

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerStatusRepository = (function () {
    function ServerStatusRepository(client) {
        this.client = client;
    }
    ServerStatusRepository.prototype.getServerStatus = function () {
        return this.client.get(this.client.getRootDocument().Links["ServerStatus"]);
    };
    ServerStatusRepository.prototype.getLogs = function (status, args) {
        return this.client.get(status.Links["RecentLogs"], args);
    };
    ServerStatusRepository.prototype.getSystemInfo = function (status) {
        return this.client.get(status.Links["SystemInfo"]);
    };
    ServerStatusRepository.prototype.getBuiltInFeedStats = function (status) {
        return this.client.get(status.Links["BuiltInFeedStats"]);
    };
    ServerStatusRepository.prototype.gcCollect = function (status) {
        return this.client.post(status.Links["GCCollect"], status);
    };
    ServerStatusRepository.prototype.getExtensionStats = function () {
        return this.client.get(this.client.getRootDocument().Links["ExtensionStats"]);
    };
    ServerStatusRepository.prototype.getTimezones = function () {
        return this.client.get(this.client.getRootDocument().Links["Timezones"]);
    };
    return ServerStatusRepository;
}());
exports.default = ServerStatusRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\serverStatusRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\serverStatusRepository.ts"); } } })();

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var SmtpConfigurationRepository = (function (_super) {
    __extends(SmtpConfigurationRepository, _super);
    function SmtpConfigurationRepository(client) {
        return _super.call(this, "SmtpConfiguration", client) || this;
    }
    return SmtpConfigurationRepository;
}(configurationRepository_1.default));
exports.default = SmtpConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\smtpConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\smtpConfigurationRepository.ts"); } } })();

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var SubscriptionRepository = (function (_super) {
    __extends(SubscriptionRepository, _super);
    function SubscriptionRepository(client) {
        return _super.call(this, "Subscriptions", client) || this;
    }
    return SubscriptionRepository;
}(basicRepository_1.default));
exports.default = SubscriptionRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\subscriptionRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\subscriptionRepository.ts"); } } })();

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var TagSetRepository = (function (_super) {
    __extends(TagSetRepository, _super);
    function TagSetRepository(client) {
        return _super.call(this, "TagSets", client) || this;
    }
    TagSetRepository.prototype.sort = function (ids) {
        return this.client.put(this.client.getRootDocument().Links["TagSetSortOrder"], ids);
    };
    return TagSetRepository;
}(basicRepository_1.default));
exports.default = TagSetRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tagSetRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tagSetRepository.ts"); } } })();

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var lodash_1 = __webpack_require__(11);
var TaskRepository = (function (_super) {
    __extends(TaskRepository, _super);
    function TaskRepository(client) {
        return _super.call(this, "Tasks", client) || this;
    }
    TaskRepository.prototype.details = function (task, args) {
        return this.client.get(task.Links["Details"], args);
    };
    TaskRepository.prototype.getQueuedBehind = function (task, args) {
        return this.client.get(task.Links["QueuedBehind"], args);
    };
    TaskRepository.prototype.getRaw = function (task) {
        return this.client.getRaw(task.Links["Raw"]);
    };
    TaskRepository.prototype.filter = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Tasks"], args);
    };
    TaskRepository.prototype.rerun = function (task) {
        return this.client.post(task.Links["Rerun"]);
    };
    TaskRepository.prototype.cancel = function (task) {
        return this.client.post(task.Links["Cancel"]);
    };
    TaskRepository.prototype.changeState = function (task, state, reason) {
        return this.client.post(task.Links["State"], { state: state, reason: reason });
    };
    TaskRepository.prototype.list = function (args) {
        return _super.prototype.list.call(this, args);
    };
    TaskRepository.prototype.byIds = function (ids) {
        var _this = this;
        var batchSize = 300;
        var idArrays = lodash_1.chunk(ids, batchSize);
        var promises = idArrays.map(function (i) {
            return _this.list({ ids: i, take: batchSize });
        });
        return Promise.all(promises)
            .then(function (result) { return lodash_1.flatMap(result, function (c) { return c.Items; }); });
    };
    return TaskRepository;
}(basicRepository_1.default));
exports.default = TaskRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\taskRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\taskRepository.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var TeamRepository = (function (_super) {
    __extends(TeamRepository, _super);
    function TeamRepository(client) {
        return _super.call(this, "Teams", client) || this;
    }
    return TeamRepository;
}(basicRepository_1.default));
exports.default = TeamRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\teamRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\teamRepository.ts"); } } })();

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var logoUpload_1 = __webpack_require__(355);
var PermissionCheck_1 = __webpack_require__(42);
var permission_1 = __webpack_require__(51);
var TenantRepository = (function (_super) {
    __extends(TenantRepository, _super);
    function TenantRepository(client) {
        return _super.call(this, "Tenants", client) || this;
    }
    TenantRepository.prototype.tagTest = function (tenantIds, tags) {
        return this.client.get(this.client.getRootDocument().Links["TenantTagTest"], { tenantIds: tenantIds, tags: tags });
    };
    TenantRepository.prototype.getVariables = function (tenant) {
        return this.client.get(tenant.Links["Variables"]);
    };
    TenantRepository.prototype.setVariables = function (tenant, variables) {
        return this.client.put(tenant.Links["Variables"], variables);
    };
    TenantRepository.prototype.missingVariables = function (filterOptions, includeDetails) {
        if (filterOptions === void 0) { filterOptions = {}; }
        if (includeDetails === void 0) { includeDetails = false; }
        var payload = {
            environmentId: filterOptions.environmentId,
            includeDetails: !!includeDetails,
            projectId: filterOptions.projectId,
            tenantId: filterOptions.tenantId
        };
        return this.client.get(this.client.getRootDocument().Links["TenantsMissingVariables"], payload);
    };
    TenantRepository.prototype.uploadLogo = function (tenant, logo) {
        return logoUpload_1.uploadLogo(tenant, logo);
    };
    TenantRepository.prototype.all = function (args) {
        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.TenantView, tenant: "*" })) {
            return Promise.resolve([]);
        }
        return _super.prototype.all.call(this, args);
    };
    return TenantRepository;
}(basicRepository_1.default));
exports.default = TenantRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tenantRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tenantRepository.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var TenantVariableRepository = (function (_super) {
    __extends(TenantVariableRepository, _super);
    function TenantVariableRepository(client) {
        return _super.call(this, "TenantVariables", client) || this;
    }
    return TenantVariableRepository;
}(basicRepository_1.default));
exports.default = TenantVariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tenantVariableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\tenantVariableRepository.ts"); } } })();

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var configurationRepository_1 = __webpack_require__(114);
var UpgradeConfigurationRepository = (function (_super) {
    __extends(UpgradeConfigurationRepository, _super);
    function UpgradeConfigurationRepository(client) {
        return _super.call(this, "UpgradeConfiguration", client) || this;
    }
    return UpgradeConfigurationRepository;
}(configurationRepository_1.default));
exports.default = UpgradeConfigurationRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\upgradeConfigurationRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\upgradeConfigurationRepository.ts"); } } })();

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserIdentityMetadataRepository = (function () {
    function UserIdentityMetadataRepository(client) {
        this.client = client;
    }
    UserIdentityMetadataRepository.prototype.all = function () {
        return this.client.get(this.client.getRootDocument().Links["UserIdentityMetadata"]);
    };
    UserIdentityMetadataRepository.prototype.authenticationConfiguration = function (userId) {
        return this.client.get(this.client.getRootDocument().Links["UserAuthentication"], { userId: userId });
    };
    return UserIdentityMetadataRepository;
}());
exports.default = UserIdentityMetadataRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userIdentityMetadataRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userIdentityMetadataRepository.ts"); } } })();

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserOnBoardingRepository = (function () {
    function UserOnBoardingRepository(client) {
        this.client = client;
    }
    UserOnBoardingRepository.prototype.get = function () {
        return this.client.get(this.client.getRootDocument().Links["UserOnboarding"]);
    };
    return UserOnBoardingRepository;
}());
exports.default = UserOnBoardingRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userOnBoardingRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userOnBoardingRepository.ts"); } } })();

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var clientInstance_1 = __webpack_require__(10);
var UserRepository = (function (_super) {
    __extends(UserRepository, _super);
    function UserRepository(client) {
        return _super.call(this, "Users", client) || this;
    }
    UserRepository.prototype.signIn = function (loginCommand) {
        var _this = this;
        return this.client.post(this.client.getRootDocument().Links["SignIn"], loginCommand)
            .then(function (authenticatedUser) {
            var antiforgeryToken = _this.client.getAntiforgeryToken();
            if (antiforgeryToken) {
                return authenticatedUser;
            }
            else {
                throw new Error("The required anti-forgery cookie is missing. Perhaps your browser " +
                    "or another network device is blocking cookies? " +
                    "See http://g.octopushq.com/CSRF for more details and troubleshooting.");
            }
        });
    };
    UserRepository.prototype.signOut = function () {
        return this.client.post(this.client.getRootDocument().Links["SignOut"], {});
    };
    UserRepository.prototype.getCurrent = function () {
        return this.client.get(this.client.getRootDocument().Links["CurrentUser"]);
    };
    UserRepository.prototype.getPermissions = function (user) {
        return this.client.get(user.Links["Permissions"]);
    };
    UserRepository.prototype.createApiKey = function (user, purpose) {
        return this.client.post(user.Links["ApiKeys"], { Purpose: purpose });
    };
    UserRepository.prototype.listApiKeys = function (user) {
        return this.client.get(user.Links["ApiKeys"], { take: clientInstance_1.repository.takeAll });
    };
    UserRepository.prototype.revokeApiKey = function (apiKey) {
        return this.client.del(apiKey.Links["Self"]);
    };
    UserRepository.prototype.invite = function (teamIds) {
        return this.client.post(this.client.getRootDocument().Links["Invitations"], { AddToTeamIds: teamIds });
    };
    UserRepository.prototype.register = function (registerCommand) {
        return this.client.post(this.client.getRootDocument().Links["Register"], registerCommand);
    };
    UserRepository.prototype.getTriggers = function (user) {
        return this.client.get(user.Links["Triggers"]);
    };
    return UserRepository;
}(basicRepository_1.default));
exports.default = UserRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userRepository.ts"); } } })();

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var UserRoleRepository = (function (_super) {
    __extends(UserRoleRepository, _super);
    function UserRoleRepository(client) {
        return _super.call(this, "UserRoles", client) || this;
    }
    return UserRoleRepository;
}(basicRepository_1.default));
exports.default = UserRoleRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userRoleRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\userRoleRepository.ts"); } } })();

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var VariableRepository = (function (_super) {
    __extends(VariableRepository, _super);
    function VariableRepository(client) {
        return _super.call(this, "Variables", client) || this;
    }
    VariableRepository.prototype.names = function (projectId, projectEnvironmentsFilter) {
        return this.client.get(this.client.getRootDocument().Links["VariableNames"], {
            project: projectId,
            projectEnvironmentsFilter: projectEnvironmentsFilter ?
                projectEnvironmentsFilter.join(",") : projectEnvironmentsFilter
        });
    };
    VariableRepository.prototype.preview = function (projectId, actionId, environmentId, role, machineId, channelId, tenantId) {
        return this.client.get(this.client.getRootDocument().Links["VariablePreview"], {
            project: projectId,
            environment: environmentId,
            channel: channelId,
            tenant: tenantId,
            action: actionId,
            role: role,
            machine: machineId
        });
    };
    VariableRepository.prototype.nonPrintableChars = function (variableSet) {
        return this.client.post(this.client.getRootDocument().Links["VariablesNonPrintableChars"], variableSet);
    };
    return VariableRepository;
}(basicRepository_1.default));
exports.default = VariableRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\variableRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\variableRepository.ts"); } } })();

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var WorkerPoolRepository = (function (_super) {
    __extends(WorkerPoolRepository, _super);
    function WorkerPoolRepository(client) {
        return _super.call(this, "WorkerPools", client) || this;
    }
    WorkerPoolRepository.prototype.machines = function (args) {
        return this.client.get(args.workerpool.Links["Workers"], args);
    };
    WorkerPoolRepository.prototype.summary = function (args) {
        return this.client.get(this.client.getRootDocument().Links["WorkerPoolsSummary"], args);
    };
    WorkerPoolRepository.prototype.sort = function (order) {
        return this.client.put(this.client.getRootDocument().Links["WorkerPoolsSortOrder"], order);
    };
    return WorkerPoolRepository;
}(basicRepository_1.default));
exports.default = WorkerPoolRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\workerpoolsRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\workerpoolsRepository.ts"); } } })();

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var basicRepository_1 = __webpack_require__(29);
var WorkerRepository = (function (_super) {
    __extends(WorkerRepository, _super);
    function WorkerRepository(client) {
        return _super.call(this, "Workers", client) || this;
    }
    WorkerRepository.prototype.list = function (args) {
        return this.client.get(this.client.getRootDocument().Links["Workers"], args);
    };
    WorkerRepository.prototype.getConnectionStatus = function (machine) {
        return this.client.get(machine.Links["Connection"]);
    };
    WorkerRepository.prototype.discover = function (host, port, type, proxyId) {
        return this.client.get(this.client.getRootDocument().Links["DiscoverWorker"], { host: host, port: port, type: type, proxyId: proxyId });
    };
    return WorkerRepository;
}(basicRepository_1.default));
exports.default = WorkerRepository;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\workerRepository.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\repositories\\workerRepository.ts"); } } })();

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var caching_1 = __webpack_require__(1198);
var logger_1 = __webpack_require__(102);
var userPermissions_1 = __webpack_require__(1199);
var store_1 = __webpack_require__(123);
var configurationArea_1 = __webpack_require__(467);
var Session = (function () {
    function Session() {
        this.cache = new caching_1.default();
    }
    Session.prototype.start = function (user, permissions, features) {
        logger_1.default.info("Starting session for " + user.DisplayName + " user.");
        this.currentUser = user;
        this.currentPermissions = new userPermissions_1.UserPermissions(permissions);
        this.setFeatures(features);
    };
    Session.prototype.end = function () {
        if (this.currentUser) {
            logger_1.default.info("Ending session for " + this.currentUser.DisplayName + " user.");
        }
        this.currentUser = null;
        this.currentPermissions = null;
        this.setFeatures(null);
        this.cache.clearAll();
    };
    Session.prototype.refreshPermissions = function (permissions) {
        this.currentPermissions = new userPermissions_1.UserPermissions(permissions);
    };
    Session.prototype.isAuthenticated = function () {
        return this.currentUser != null;
    };
    Session.prototype.setFeatures = function (features) {
        store_1.default.dispatch(configurationArea_1.configurationActions.featuresFetched(features));
    };
    return Session;
}());
exports.default = Session;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\session.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\session.ts"); } } })();

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Caching = (function () {
    function Caching(options) {
        this.cache = {};
        options = options || {};
        this.maxMemory = options.maxMemory || Math.pow(1024, 2) * 1000 / 2; //1GB /2 (1 character in js is 2 bytes)
        this.dataVersionHeader = "X-Octopus-Data-Version";
        this.authorizationHashHeader = "X-Octopus-Authorization-Hash";
    }
    Caching.prototype.clearAll = function () {
        this.cache = {};
    };
    Caching.prototype.setHeaderAndGetValue = function (request, options) {
        if (this.cache[options.url]) {
            request.setRequestHeader(this.dataVersionHeader, this.cache[options.url].dataVersion);
            request.setRequestHeader(this.authorizationHashHeader, this.cache[options.url].authorizationHash);
            this.cache[options.url].lastAccessed = new Date();
            return this.cache[options.url].value;
        }
    };
    Caching.prototype.updateCache = function (request, options) {
        try {
            var dataVersion = request.getResponseHeader(this.dataVersionHeader);
            var authorizationHash = request.getResponseHeader(this.authorizationHashHeader);
            if (!!dataVersion && !!authorizationHash) {
                var item = {
                    dataVersion: dataVersion,
                    authorizationHash: authorizationHash,
                    lastAccessed: new Date(),
                    value: request.responseText
                };
                var itemSize = this.itemSizeInMemory(options.url, item);
                if (itemSize < this.maxMemory) {
                    this.cache[options.url] = item;
                }
                this.memoryPressureCleanup();
            }
            else {
                delete this.cache[options.url];
            }
        }
        catch (e) {
            delete this.cache[options.url];
        }
    };
    Caching.prototype.canUseCachedValue = function (request) {
        return (request.status === 304 && (request.responseText === "" || !request.responseText));
    };
    Caching.prototype.memoryPressureCleanup = function () {
        var currentMemory = this.roughSizeOfReleasableMemory();
        while (currentMemory >= this.maxMemory) {
            this.removeOldest();
            var newMemoryLevel = this.roughSizeOfReleasableMemory();
            if (newMemoryLevel === currentMemory) {
                return;
            }
            currentMemory = newMemoryLevel;
        }
    };
    Caching.prototype.itemSizeInMemory = function (url, item) {
        return url.length + item.value.length;
    };
    Caching.prototype.removeOldest = function () {
        var _this = this;
        var oldestUrl;
        var oldestResponded = -1;
        var now = new Date();
        Object.keys(this.cache).forEach(function (url) {
            var age = now.valueOf() - _this.cache[url].lastAccessed.valueOf();
            if (age > oldestResponded) {
                oldestResponded = age;
                oldestUrl = url;
            }
        });
        delete this.cache[oldestUrl];
    };
    Caching.prototype.roughSizeOfReleasableMemory = function () {
        var _this = this;
        return Object.keys(this.cache).reduce(function (total, url) {
            var item = _this.cache[url];
            return total + _this.itemSizeInMemory(url, item);
        }, 0);
    };
    return Caching;
}());
exports.default = Caching;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\caching.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\caching.ts"); } } })();

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserPermissions = (function () {
    function UserPermissions(permissions) {
        var ps = {};
        Object.keys(permissions).forEach(function (k) {
            ps[k.toLowerCase()] = permissions[k].map(function (e) {
                return {
                    projectIds: (e.RestrictedToProjectIds || []).map(function (id) { return id.toLowerCase(); }),
                    environmentIds: (e.RestrictedToEnvironmentIds || []).map(function (id) { return id.toLowerCase(); }),
                    projectGroupIds: (e.RestrictedToProjectGroupIds || []).map(function (id) { return id.toLowerCase(); }),
                    tenantIds: (e.RestrictedToTenantIds || []).map(function (id) { return id.toLowerCase(); })
                };
            });
        });
        this.internalPermissions = ps;
    }
    UserPermissions.prototype.firstAuthorized = function (permissions) {
        var _this = this;
        var match = null;
        permissions.forEach(function (p) {
            var restrictions = _this.internalPermissions[p.toLowerCase()];
            if (!restrictions) {
                return;
            }
            if (!match) {
                match = p;
            }
        });
        return match;
    };
    UserPermissions.prototype.isAuthorized = function (authorization) {
        var isWildcard = function (s) {
            return s === "*";
        };
        var restrictions = this.internalPermissions[authorization.permission.toLowerCase()];
        if (!restrictions) {
            // User doesn't have the permission in any scope
            return false;
        }
        if (restrictions.length === 0) {
            // No restrictions
            return true;
        }
        for (var _i = 0, restrictions_1 = restrictions; _i < restrictions_1.length; _i++) {
            var restriction = restrictions_1[_i];
            var allowed = true;
            if (restriction.projectIds.length !== 0) {
                if (authorization.projectId == null ||
                    (!isWildcard(authorization.projectId) && !restriction.projectIds.includes(authorization.projectId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.environmentIds.length !== 0) {
                if (authorization.environmentId == null ||
                    (!isWildcard(authorization.environmentId) && !restriction.environmentIds.includes(authorization.environmentId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.projectGroupIds.length !== 0) {
                if (authorization.projectGroupId == null ||
                    (!isWildcard(authorization.projectGroupId) && !restriction.projectGroupIds.includes(authorization.projectGroupId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (restriction.tenantIds.length !== 0) {
                if (authorization.tenantId == null ||
                    (!isWildcard(authorization.tenantId) && !restriction.tenantIds.includes(authorization.tenantId.toLowerCase()))) {
                    allowed = false;
                }
            }
            if (allowed) {
                return true;
            }
        }
        return false;
    };
    return UserPermissions;
}());
exports.UserPermissions = UserPermissions;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\userPermissions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\userPermissions.ts"); } } })();

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorBoundary_1 = __webpack_require__(267);
__export(__webpack_require__(267));
exports.default = ErrorBoundary_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorBoundary\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorBoundary\\index.ts"); } } })();

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1202);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_error__3zI1F{padding:1.5rem 1rem;color:#db4437;background-color:#f8e8e6;text-align:left}.style_error__3zI1F ul{padding-left:1rem;margin-bottom:0;list-style-type:disc;font-weight:400}.style_titleContainer__2bAHe{display:flex;justify-content:space-between}.style_title__A5dbg{font-weight:500}.style_detailLink__3naxR{padding-top:.25rem;padding-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"error": "style_error__3zI1F",
	"titleContainer": "style_titleContainer__2bAHe",
	"title": "style_title__A5dbg",
	"detailLink": "style_detailLink__3naxR"
};

/***/ }),
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1829v{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__XTsGt{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1UGwQ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1za9-{display:none!important}}.style_popoverMenu__1p7R9 a{color:#fff}.style_pagingControlButton__3tD1Z{cursor:pointer;border:0;padding:0 .25rem;margin:0 .0625rem;min-width:1.75rem;height:1.75rem;border-radius:.125rem;background-color:#fff;color:#9e9e9e}@media (max-width:37.4rem){.style_pagingControlButton__3tD1Z{width:2rem;height:2rem}}.style_pagingControlButton__3tD1Z:focus,.style_pagingControlButton__3tD1Z:hover{background-color:#9e9e9e;color:#fff;outline:0}.style_pagingControlButton__3tD1Z:active{background-color:#fff;color:#9e9e9e}.style_pagingControlButton__3tD1Z .style_pagingControlButtonText__2nTLE{width:.5rem;height:1.25rem;font-family:Roboto;font-size:.75rem;line-height:1.36rem;text-align:left}.style_pagingControlButtonActive__3HE6R{background-color:#9e9e9e;color:#fff}.style_pagingControlButtonInactive__rDMPp{background-color:#fff;color:#9e9e9e}.style_buttonWrapper__3gxle{display:inline-block}.style_globalActionButtonAndLinks__1-zdv{white-space:nowrap!important}.style_globalActionButton__2W3W_{font-size:medium!important}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1829v",
	"hideSm": "style_hide-sm__1829v",
	"visible-sm": "style_visible-sm__XTsGt",
	"visibleSm": "style_visible-sm__XTsGt",
	"hide-md": "style_hide-md__1UGwQ",
	"hideMd": "style_hide-md__1UGwQ",
	"visible-md": "style_visible-md__1za9-",
	"visibleMd": "style_visible-md__1za9-",
	"popoverMenu": "style_popoverMenu__1p7R9",
	"pagingControlButton": "style_pagingControlButton__3tD1Z",
	"pagingControlButtonText": "style_pagingControlButtonText__2nTLE",
	"pagingControlButtonActive": "style_pagingControlButtonActive__3HE6R",
	"pagingControlButtonInactive": "style_pagingControlButtonInactive__rDMPp",
	"buttonWrapper": "style_buttonWrapper__3gxle",
	"globalActionButtonAndLinks": "style_globalActionButtonAndLinks__1-zdv",
	"globalActionButton": "style_globalActionButton__2W3W_"
};

/***/ }),
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(271);
var PagingControlButton = function (props) {
    var activeClass = props.isActive ? styles.pagingControlButtonActive : styles.pagingControlButtonInactive;
    return (React.createElement("button", { className: styles.pagingControlButton + " " + activeClass, onClick: props.onPageSelected, title: props.label },
        React.createElement("span", { className: styles.pagingControlButtonText }, props.label)));
};
exports.default = PagingControlButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\PagingControlButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Button\\PagingControlButton.tsx"); } } })();

/***/ }),
/* 1267 */,
/* 1268 */,
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1270);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_busyIndicator__1Ka4K div:first-child{background-color:#ccc}.style_busyIndicatorHiddenSpacer__3iMs6{height:.25rem}.style_circularBusyIndicator__15KpB div:first-child{vertical-align:middle;background-color:transparent}", ""]);

// exports
exports.locals = {
	"busyIndicator": "style_busyIndicator__1Ka4K",
	"busyIndicatorHiddenSpacer": "style_busyIndicatorHiddenSpacer__3iMs6",
	"circularBusyIndicator": "style_circularBusyIndicator__15KpB"
};

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_layout__3F9l_{display:flex;flex-direction:column;width:100%}.style_headerContentAlignment__2DmFe{padding-left:1rem;padding-right:1rem}.style_title__1aUJB{padding:1rem;font-size:1.063rem;font-weight:500}.style_titleIcon__1WDUq{margin-right:.5rem;display:inline-block}.style_body__3C98V{margin-top:.5rem;font-size:.875rem;line-height:1.25rem;padding-left:1rem;padding-right:1rem;padding-bottom:1rem;overflow-y:auto;overflow-x:hidden;flex-direction:column}.style_actions__3f7mN{padding:1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.style_materialDialogBody__1XgjK{padding:0}.style_primaryActions__2EV5A>*{margin-left:.5rem}.style_secondaryActions__1ZOtb>*{margin-right:.5rem}.style_dialogWrapper__11h1h{display:flex;flex-direction:column;height:100%}", ""]);

// exports
exports.locals = {
	"layout": "style_layout__3F9l_",
	"headerContentAlignment": "style_headerContentAlignment__2DmFe",
	"title": "style_title__1aUJB",
	"titleIcon": "style_titleIcon__1WDUq",
	"body": "style_body__3C98V",
	"actions": "style_actions__3f7mN",
	"materialDialogBody": "style_materialDialogBody__1XgjK",
	"primaryActions": "style_primaryActions__2EV5A",
	"secondaryActions": "style_secondaryActions__1ZOtb",
	"dialogWrapper": "style_dialogWrapper__11h1h"
};

/***/ }),
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3DD5e{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1HGi2{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2rwez{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2O3zd{display:none!important}}.style_buttonDialogContainer__J2Ndc{display:inline-block}.style_materialDialogContent__2lizw{padding:0}@media (max-width:37.4rem){.style_materialDialogContent__2lizw{width:90%!important}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3DD5e",
	"hideSm": "style_hide-sm__3DD5e",
	"visible-sm": "style_visible-sm__1HGi2",
	"visibleSm": "style_visible-sm__1HGi2",
	"hide-md": "style_hide-md__2rwez",
	"hideMd": "style_hide-md__2rwez",
	"visible-md": "style_visible-md__2O3zd",
	"visibleMd": "style_visible-md__2O3zd",
	"buttonDialogContainer": "style_buttonDialogContainer__J2Ndc",
	"materialDialogContent": "style_materialDialogContent__2lizw"
};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// https://codepen.io/brian-baum/pen/mJZxJX
var smoothScroll = {
    timer: null,
    stop: function () {
        clearTimeout(this.timer);
    },
    scrollTo: function (node) {
        var settings = {
            duration: 600,
            easing: {
                outQuint: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                }
            }
        };
        var nodeTop = node.offsetTop;
        var nodeHeight = node.offsetHeight;
        var body = document.body;
        var html = document.documentElement;
        var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        var windowHeight = window.innerHeight;
        var offset = window.pageYOffset;
        var delta = nodeTop - offset;
        var bottomScrollableY = height - windowHeight;
        var targetY = (bottomScrollableY < delta) ?
            bottomScrollableY - (height - nodeTop - nodeHeight + offset) :
            delta;
        var startTime = Date.now();
        var percentage = 0;
        if (this.timer) {
            clearInterval(this.timer);
        }
        function step() {
            var yScroll;
            var elapsed = Date.now() - startTime;
            if (elapsed > settings.duration) {
                clearTimeout(this.timer);
            }
            percentage = elapsed / settings.duration;
            if (percentage > 1) {
                clearTimeout(this.timer);
            }
            else {
                yScroll = settings.easing.outQuint(0, elapsed, offset, targetY, settings.duration);
                window.scrollTo(0, yScroll);
                this.timer = setTimeout(step, 10);
            }
        }
        this.timer = setTimeout(step, 10);
    }
};
exports.default = smoothScroll;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\smoothscroll.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\smoothscroll.ts"); } } })();

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1281);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_note__4cGKf{font-family:Roboto;font-size:.75rem;text-align:left;font-weight:300;margin-bottom:.5rem;color:#666}.style_note__4cGKf a{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"note": "style_note__4cGKf"
};

/***/ }),
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var releaseRouteLinks_1 = __webpack_require__(311);
var triggerResource_1 = __webpack_require__(349);
exports.default = function (root) { return ({
    v3projectRoutes: {
        newProject: root + "/projects/new"
    },
    projects: root + "/projects",
    trigger: trigger(root),
    channel: channel(root),
    release: function (releaseId) { return root + "/releases/" + releaseId; },
    project: function (projectSlug) {
        if (!!projectSlug && typeof projectSlug !== "string") {
            projectSlug = projectSlug.Slug;
        }
        var specificRoot = root + "/projects/" + projectSlug;
        return __assign({ root: specificRoot }, releaseRouteLinks_1.default(specificRoot), { overview: specificRoot + "/overview", settings: specificRoot + "/settings", channels: specificRoot + "/channels", channel: channel(specificRoot), triggers: specificRoot + "/triggers", trigger: trigger(specificRoot), scheduledTrigger: function (triggerId) {
                if (!!triggerId && typeof triggerId !== "string") {
                    triggerId = triggerId.Id;
                }
                return specificRoot + "/triggers/scheduled/edit/" + triggerId;
            }, variables: {
                root: specificRoot + "/variables",
                projectTemplates: specificRoot + "/variables/projectvariabletemplates",
                commonTemplates: specificRoot + "/variables/commonvariabletemplates",
                library: specificRoot + "/variables/library",
                preview: specificRoot + "/variables/preview",
                all: specificRoot + "/variables/all"
            }, process: {
                root: specificRoot + "/process",
                stepTemplates: specificRoot + "/process/steptemplates",
                childStepTemplates: function (parentStepId) { return ({
                    root: specificRoot + "/process/childsteptemplates/" + parentStepId
                }); },
                stepNew: function (templateType, parentStepId, templateId) {
                    var base = specificRoot + "/process/step";
                    if (parentStepId) {
                        base = base + "/" + parentStepId;
                    }
                    base = base + "/new/" + templateType;
                    if (templateId) {
                        base = base + "/" + templateId;
                    }
                    return base;
                },
                step: function (actionId) { return specificRoot + "/process/step/" + actionId; }
            }, childStepTemplates: function (parentStepId) { return ({
                root: specificRoot + "/childsteptemplates/" + parentStepId
            }); }, steptemplates: specificRoot + "/steptemplates" });
    }
}); };
function trigger(root) {
    return function (triggerId, triggerType) {
        if (triggerType === void 0) { triggerType = triggerResource_1.TriggerActionType.AutoDeploy; }
        if (!!triggerId && typeof triggerId !== "string") {
            triggerId = triggerId.Id;
        }
        if (triggerType === triggerResource_1.TriggerActionType.AutoDeploy) {
            return root + "/triggers/edit/" + triggerId;
        }
        return root + "/triggers/scheduled/edit/" + triggerId;
    };
}
function channel(root) {
    return function (channelId) {
        if (!!channelId && typeof channelId !== "string") {
            channelId = channelId.Id;
        }
        return root + "/channels/edit/" + channelId;
    };
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectsRoutes\\projectRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectsRoutes\\projectRouteLinks.ts"); } } })();

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var libraryRoot = root + "/library";
    var stepTemplatesRoot = libraryRoot + "/steptemplates";
    return {
        root: libraryRoot,
        feeds: libraryRoot + "/feeds",
        feedCreate: libraryRoot + "/feeds/create",
        feed: function (feedId) { return ({
            root: libraryRoot + "/feeds/" + feedId,
            test: libraryRoot + "/feeds/" + feedId + "/test"
        }); },
        stepTemplates: {
            root: stepTemplatesRoot,
            builtIn: stepTemplatesRoot + "/builtin",
            community: stepTemplatesRoot + "/community",
            installedStep: function (template) { return stepTemplatesRoot + "?installedStep=" + template.Id; },
            new: function (templateSearch) { return stepTemplatesRoot + "/new/" + templateSearch.Type; },
            communityTemplate: function (communityTemplateId, projectId) {
                if (!!communityTemplateId && typeof communityTemplateId !== "string") {
                    communityTemplateId = communityTemplateId.CommunityActionTemplateId;
                }
                return {
                    root: stepTemplatesRoot + "/community/" + communityTemplateId + (projectId ? "?projectId=" + projectId : ""),
                    details: stepTemplatesRoot + "/community/" + communityTemplateId + "/details"
                };
            }
        },
        stepTemplate: function (templateId) {
            if (!!templateId && typeof templateId !== "string") {
                templateId = templateId.Id;
            }
            var stepTemplateRoot = stepTemplatesRoot + "/" + templateId;
            return {
                root: "" + stepTemplateRoot,
                usage: stepTemplateRoot + "/usage",
                run: stepTemplateRoot + "/run"
            };
        },
        lifecycles: libraryRoot + "/lifecycles",
        lifecyclesCreate: libraryRoot + "/lifecycles/create",
        lifecycle: function (lifecycleId) { return libraryRoot + "/lifecycles/" + lifecycleId; },
        certificates: {
            root: libraryRoot + "/certificates",
            archive: libraryRoot + "/certificates/archive",
            create: libraryRoot + "/certificates/create"
        },
        certificate: function (certificateId) { return libraryRoot + "/certificates/" + certificateId; },
        variableSets: libraryRoot + "/variables",
        variableSet: function (variableSetId, activeTab) {
            if (!!variableSetId && typeof variableSetId !== "string") {
                variableSetId = variableSetId.Id;
            }
            return libraryRoot + "/variables/" + variableSetId + (activeTab ? "?activeTab=" + activeTab : "");
        },
        tagSets: {
            root: libraryRoot + "/tagsets",
            create: libraryRoot + "/tagsets/create"
        },
        tagSet: function (tagSetId) { return libraryRoot + "/tagsets/" + tagSetId; },
        builtInRepository: {
            root: libraryRoot + "/builtinrepository",
            package: function (versionedPackage) { return libraryRoot + "/builtinrepository/" + versionedPackage; },
            versions: function (packageId) { return libraryRoot + "/builtinrepository/versions/" + packageId; }
        },
        scripts: {
            root: libraryRoot + "/scripts",
            create: libraryRoot + "/scripts/create",
        },
        script: function (scriptId) { return libraryRoot + "/scripts/" + scriptId; },
        v3routes: {
            certificates: {
                create: libraryRoot + "/certificates/new"
            },
            feeds: {
                create: libraryRoot + "/feeds/new"
            },
            lifecycles: {
                create: libraryRoot + "/lifecycles/new"
            },
            scripts: {
                create: libraryRoot + "/scripts/new"
            },
            tagSets: {
                create: libraryRoot + "/tagsets/new"
            },
            variableSets: {
                create: libraryRoot + "/variables/new"
            }
        }
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\LibraryRoutes\\libraryRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\LibraryRoutes\\libraryRouteLinks.ts"); } } })();

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(120);
var resources_1 = __webpack_require__(17);
exports.default = function (root) {
    var infraRoot = root + "/infrastructure";
    function workerMachineLinks(machineId) {
        var workerMachineRoot = infraRoot + "/workers/" + machineId;
        return {
            root: workerMachineRoot,
            settings: workerMachineRoot + "/settings",
            connection: workerMachineRoot + "/connection",
            events: workerMachineRoot + "/events"
        };
    }
    function deploymentTargetLinks(machineId) {
        var machineRoot = infraRoot + "/machines/" + machineId;
        return {
            root: machineRoot,
            settings: machineRoot + "/settings",
            deployments: machineRoot + "/deployments",
            connection: machineRoot + "/connection",
            events: machineRoot + "/events"
        };
    }
    return {
        root: infraRoot,
        overview: infraRoot + "/overview",
        environments: {
            root: infraRoot + "/environments",
            create: infraRoot + "/environments/create",
            filtered: function (obj) { return infraRoot + "/environments" + (new URI()).search(obj).search(); }
        },
        environment: function (environmentId) {
            if (!!environmentId && typeof environmentId !== "string") {
                environmentId = environmentId.Id;
            }
            return infraRoot + "/environments/" + environmentId;
        },
        machines: {
            root: infraRoot + "/machines",
            create: infraRoot + "/machines/create",
            filtered: function (obj) { return infraRoot + "/machines" + (new URI()).search(obj).search(); },
            discover: function (environmentId) { return infraRoot + "/machines/discover" + (environmentId ? "/" + environmentId : ""); }
        },
        machine: function (machineId) {
            if (!!machineId && typeof machineId !== "string") {
                if (resources_1.isWorkerMachine(machineId)) {
                    return workerMachineLinks(machineId.Id);
                }
                else {
                    return deploymentTargetLinks(machineId.Id);
                }
            }
            else {
                return deploymentTargetLinks(machineId);
            }
        },
        deploymentTarget: function (machineId) {
            if (!!machineId && typeof machineId !== "string") {
                machineId = machineId.Id;
            }
            return deploymentTargetLinks(machineId);
        },
        proxies: {
            root: infraRoot + "/proxies",
            create: infraRoot + "/proxies/create",
        },
        proxy: function (proxyId) { return infraRoot + "/proxies/" + proxyId; },
        machinePolicies: {
            root: infraRoot + "/machinepolicies",
            create: infraRoot + "/machinepolicies/create",
        },
        machinePolicy: function (machinePolicyId) { return infraRoot + "/machinepolicies/" + machinePolicyId; },
        accounts: {
            root: infraRoot + "/accounts",
            create: infraRoot + "/accounts/create"
        },
        account: function (accountId) { return infraRoot + "/accounts/" + accountId; },
        workerMachines: {
            root: infraRoot + "/workers",
            create: infraRoot + "/workers/create",
            filtered: function (obj) { return infraRoot + "/workers" + (new URI()).search(obj).search(); },
            discover: function (workerPoolId) { return infraRoot + "/workers/discover" + (workerPoolId ? "/" + workerPoolId : ""); }
        },
        workerMachine: function (machineId) {
            if (!!machineId && typeof machineId !== "string") {
                machineId = machineId.Id;
            }
            return workerMachineLinks(machineId);
        },
        workerPools: {
            root: infraRoot + "/workerpools",
            create: infraRoot + "/workerpools/create",
            filtered: function (obj) { return infraRoot + "/workerpools" + (new URI()).search(obj).search(); }
        },
        workerPool: function (workerPoolId) {
            if (!!workerPoolId && typeof workerPoolId !== "string") {
                workerPoolId = workerPoolId.Id;
            }
            return infraRoot + "/workerpools/" + workerPoolId;
        }
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\infrastructureRouteLinks.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\infrastructureRouteLinks.tsx"); } } })();

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Tasks_1 = __webpack_require__(810);
var QueryStringFilters_1 = __webpack_require__(307);
exports.default = function (root) {
    var taskRoot = root + "/tasks";
    return {
        tasks: {
            root: taskRoot,
            console: taskRoot + "/console",
            filtered: function (tasksFilter) {
                var queryString = QueryStringFilters_1.convertQueryToQueryString(Tasks_1.getQuery(tasksFilter));
                return "" + taskRoot + queryString;
            }
        },
        task: function (taskId) {
            if (!!taskId && typeof taskId !== "string") {
                taskId = isDeploymentResource(taskId) ? taskId.TaskId : taskId.Id;
            }
            return {
                root: taskRoot + "/" + taskId,
                raw: taskRoot + "/" + taskId + "/raw",
            };
        }
    };
};
function isDeploymentResource(resource) {
    return !!resource.TaskId;
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\components\\TaskRoutes\\taskRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tasks\\components\\TaskRoutes\\taskRouteLinks.ts"); } } })();

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Breadcrumb_1 = __webpack_require__(595);
var BusyFromPromise_1 = __webpack_require__(161);
var BusyRefreshIndicator_1 = __webpack_require__(597);
var styles = __webpack_require__(1416);
var SectionTitle = function (props) {
    return React.createElement("div", { className: cn(styles.container, props.className) },
        React.createElement("div", { className: styles.titleContainer },
            React.createElement(Breadcrumb_1.default, { title: props.breadcrumbTitle, path: props.breadcrumbPath }),
            React.createElement("div", { className: styles.title },
                props.titleLogo && React.createElement("div", { className: styles.logo }, props.titleLogo),
                React.createElement("h2", { className: styles.header }, props.title),
                props.enableLessIntrusiveLoadingIndicator &&
                    React.createElement("div", { className: styles.refreshIndicator },
                        React.createElement(BusyFromPromise_1.default, { promise: props.busy }, function (busy) {
                            return busy && props.enableLessIntrusiveLoadingIndicator
                                ? React.createElement("div", { className: styles.refreshContainer },
                                    React.createElement(BusyRefreshIndicator_1.default, { show: true }))
                                : null;
                        })))),
        props.sectionControl);
};
exports.default = SectionTitle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SectionTitle\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SectionTitle\\index.tsx"); } } })();

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_internalLink__WVl2K{color:#2f93e0;text-decoration:none}.style_internalLink__WVl2K:hover{color:#0a67b1}.style_listInternalLink__3Z097,.style_listInternalLink__3Z097:focus,.style_listInternalLink__3Z097:hover{color:inherit}", ""]);

// exports
exports.locals = {
	"internalLink": "style_internalLink__WVl2K",
	"listInternalLink": "style_listInternalLink__3Z097"
};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1300);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_breadcrumb__qeygb{font-size:.875rem;line-height:1rem;color:#9e9e9e}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO{color:#333;text-decoration:none}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:active,.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:visited{color:#333}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"breadcrumb": "style_breadcrumb__qeygb",
	"breadcrumbLink": "style_breadcrumbLink__20imO"
};

/***/ }),
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1417);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3CsQy{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1mVeX{display:none!important}}@media (max-width:79.9rem){.style_hide-md__XS7Lj{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1huHX{display:none!important}}.style_container__3rXsY{display:flex;padding:1rem;align-items:center;flex-wrap:wrap;justify-content:space-between;min-height:4.25rem}.style_titleContainer__3-W7u{display:flex;flex-direction:column;font-size:1.25rem}.style_header__2STZ0{margin:0;padding:0}.style_title__YSj5Z{display:flex;flex-direction:row;align-items:center;line-height:1.75rem;margin:.25rem 0}.style_logo__13jHw{margin-right:.5rem}.style_refreshContainer__1D4wv{position:relative;height:1.75rem;opacity:.8}.style_refreshIndicator__j1D7G{width:2.5rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3CsQy",
	"hideSm": "style_hide-sm__3CsQy",
	"visible-sm": "style_visible-sm__1mVeX",
	"visibleSm": "style_visible-sm__1mVeX",
	"hide-md": "style_hide-md__XS7Lj",
	"hideMd": "style_hide-md__XS7Lj",
	"visible-md": "style_visible-md__1huHX",
	"visibleMd": "style_visible-md__1huHX",
	"container": "style_container__3rXsY",
	"titleContainer": "style_titleContainer__3-W7u",
	"header": "style_header__2STZ0",
	"title": "style_title__YSj5Z",
	"logo": "style_logo__13jHw",
	"refreshContainer": "style_refreshContainer__1D4wv",
	"refreshIndicator": "style_refreshIndicator__j1D7G"
};

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1419);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__n_Ecp{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__P2EKE{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2DPYJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2OHkK{display:none!important}}.style_paperContent__382gV{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;margin:0 0 1rem}.style_paperContent__382gV,.style_paperContentFlat__QSsBj{width:100%;max-width:1280px;position:relative;display:flex;align-items:stretch;flex-direction:column}.style_paperContentFlat__QSsBj{box-shadow:0;background-color:transparent;margin:0 1rem}@media (max-width:37.4rem){.style_paperContentFlat__QSsBj{margin:.8rem}}.style_paperFullWidth__8SfP3{max-width:none}.style_container__23_qZ{display:flex;width:100%;justify-content:center}.style_headerContainer__1Wp7n{background:#fff}.style_busyFromPromise__m7JN_{width:100%}.style_title__1zL1H{word-wrap:break-word;background-color:#fff}.style_stickied__3AmB4{box-shadow:0 .0625rem .1875rem -.0625rem rgba(0,0,0,.34)}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__n_Ecp",
	"hideSm": "style_hide-sm__n_Ecp",
	"visible-sm": "style_visible-sm__P2EKE",
	"visibleSm": "style_visible-sm__P2EKE",
	"hide-md": "style_hide-md__2DPYJ",
	"hideMd": "style_hide-md__2DPYJ",
	"visible-md": "style_visible-md__2OHkK",
	"visibleMd": "style_visible-md__2OHkK",
	"paperContent": "style_paperContent__382gV",
	"paperContentFlat": "style_paperContentFlat__QSsBj",
	"paperFullWidth": "style_paperFullWidth__8SfP3",
	"container": "style_container__23_qZ",
	"headerContainer": "style_headerContainer__1Wp7n",
	"busyFromPromise": "style_busyFromPromise__m7JN_",
	"title": "style_title__1zL1H",
	"stickied": "style_stickied__3AmB4"
};

/***/ }),
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1506);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_notVisible__1aZcP{opacity:0}.style_fadeIn__38sqA{opacity:1;transition:opacity .3s ease-in;-moz-transition:opacity .3s ease-in;-webkit-transition:opacity .3s ease-in}", ""]);

// exports
exports.locals = {
	"notVisible": "style_notVisible__1aZcP",
	"fadeIn": "style_fadeIn__38sqA"
};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3DfJC{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2tYxV{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3z8Vd{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3p5Xu{display:none!important}}.style_dataTable__whkhc{border-collapse:collapse;background-color:#fff;width:100%;font-size:.875rem;line-height:1rem}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i{border-top:none}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:focus,.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:hover{background-color:transparent}.style_dataTableHeaderColumn__2MIVp{color:#9e9e9e;padding:0 1.125rem .75rem;line-height:1rem;font-weight:400;padding-bottom:1rem;padding-top:1rem;box-sizing:border-box;text-align:left}.style_dataTableRowHeaderColumn__3t3gr{vertical-align:top;padding-top:.875rem;text-align:right;width:16rem}.style_dataTableRowHeaderColumnInSidebar__1XNmt{width:8rem!important}.style_dataTableFooterColumn__1l7bp{color:#9e9e9e;padding:0;line-height:1rem;font-weight:400;padding-bottom:1rem;text-align:left;box-sizing:border-box}.style_dataTableRow__1qs4i{border-top:.0625rem solid #ccc}.style_dataTableRow__1qs4i:last-child{border-bottom:.0625rem solid #ccc}.style_dataTableRow__1qs4i:focus,.style_dataTableRow__1qs4i:hover{background-color:hsla(0,0%,60%,.08)}.style_dataTableRow__1qs4i.style_noBorder__vK-uc{border:none}.style_dataTableRow__1qs4i.style_noBorder__vK-uc:focus,.style_dataTableRow__1qs4i.style_noBorder__vK-uc:hover{background-color:transparent}.style_dataTableRowColumn__3K1eH{box-sizing:border-box;color:#333;vertical-align:top;padding:.875rem 1.125rem}.style_dataTableRowColumn__3K1eH:first-child{font-weight:500}.style_dataTableRowColumn__3K1eH a{text-align:left;color:#2f93e0}@media (max-width:37.4rem){.style_dataTable__whkhc,.style_dataTableBody__2iZtk,.style_dataTableFooterColumn__1l7bp,.style_dataTableHeader__2-Fqn,.style_dataTableHeaderColumn__2MIVp,.style_dataTableRow__1qs4i,.style_dataTableRowColumn__3K1eH{display:block}.style_dataTable__whkhc{border:none}.style_dataTableHeader__2-Fqn .style_dataTableRow__1qs4i:not(.style_dataTableToolsRow__DQOfG){position:absolute;top:-9999px;left:-9999px}.style_dataTableRowColumn__3K1eH{border:none;position:relative;line-height:1.5rem;padding-top:.5rem;padding-bottom:0;max-width:100%}.style_dataTableRowHeaderColumn__3t3gr{padding:.875rem 1.125rem;text-align:left;width:unset}.style_dataTableRowHeaderColumnInSidebar__1XNmt{width:unset}.style_dataTableRowColumn__3K1eH:first-child,.style_dataTableRowColumn__3K1eH:not(:first-child){width:100%}.style_dataTableRowColumn__3K1eH:not(:first-child){padding-top:0}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3DfJC",
	"hideSm": "style_hide-sm__3DfJC",
	"visible-sm": "style_visible-sm__2tYxV",
	"visibleSm": "style_visible-sm__2tYxV",
	"hide-md": "style_hide-md__3z8Vd",
	"hideMd": "style_hide-md__3z8Vd",
	"visible-md": "style_visible-md__3p5Xu",
	"visibleMd": "style_visible-md__3p5Xu",
	"dataTable": "style_dataTable__whkhc",
	"dataTableHeader": "style_dataTableHeader__2-Fqn",
	"dataTableRow": "style_dataTableRow__1qs4i",
	"dataTableHeaderColumn": "style_dataTableHeaderColumn__2MIVp",
	"dataTableRowHeaderColumn": "style_dataTableRowHeaderColumn__3t3gr",
	"dataTableRowHeaderColumnInSidebar": "style_dataTableRowHeaderColumnInSidebar__1XNmt",
	"dataTableFooterColumn": "style_dataTableFooterColumn__1l7bp",
	"noBorder": "style_noBorder__vK-uc",
	"dataTableRowColumn": "style_dataTableRowColumn__3K1eH",
	"dataTableBody": "style_dataTableBody__2iZtk",
	"dataTableToolsRow": "style_dataTableToolsRow__DQOfG"
};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableToolsRow = (function (_super) {
    __extends(DataTableToolsRow, _super);
    function DataTableToolsRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableToolsRow.prototype.render = function () {
        return (React.createElement("tr", { className: cn(this.props.className, styles.dataTableToolsRow) }, this.props.children));
    };
    return DataTableToolsRow;
}(React.Component));
exports.DataTableToolsRow = DataTableToolsRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableToolsRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableToolsRow.tsx"); } } })();

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableFooter = (function (_super) {
    __extends(DataTableFooter, _super);
    function DataTableFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooter.prototype.render = function () {
        return (React.createElement("tfoot", { className: cn(this.props.className, styles.dataTableFooter) }, this.props.children));
    };
    return DataTableFooter;
}(React.Component));
exports.DataTableFooter = DataTableFooter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooter.tsx"); } } })();

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableFooterColumn = (function (_super) {
    __extends(DataTableFooterColumn, _super);
    function DataTableFooterColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooterColumn.prototype.render = function () {
        var _a = this.props, className = _a.className, otherProps = __rest(_a, ["className"]);
        return (React.createElement("td", __assign({ className: cn(className, styles.dataTableFooterColumn) }, otherProps), this.props.children));
    };
    return DataTableFooterColumn;
}(React.Component));
exports.DataTableFooterColumn = DataTableFooterColumn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooterColumn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooterColumn.tsx"); } } })();

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(99);
var DataTableFooterRow = (function (_super) {
    __extends(DataTableFooterRow, _super);
    function DataTableFooterRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTableFooterRow.prototype.render = function () {
        return (React.createElement("tr", { className: cn(this.props.className, styles.dataTableFooterRow) }, this.props.children));
    };
    return DataTableFooterRow;
}(React.Component));
exports.DataTableFooterRow = DataTableFooterRow;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooterRow.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DataTable\\DataTableFooterRow.tsx"); } } })();

/***/ }),
/* 1512 */,
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var react_event_listener_1 = __webpack_require__(68);
var rowsHeight = 24;
function getStyles(props, context, state) {
    return {
        root: {
            position: 'relative',
        },
        textarea: {
            height: state.height,
            width: '100%',
            resize: 'none',
            font: 'inherit',
            padding: 0,
            cursor: 'inherit',
        },
        shadow: {
            resize: 'none',
            // Overflow also needed to here to remove the extra row
            // added to textareas in Firefox.
            overflow: 'hidden',
            // Visibility needed to hide the extra text area on ipads
            visibility: 'hidden',
            position: 'absolute',
            height: 'auto',
        },
    };
}
var EnhancedTextarea = (function (_super) {
    __extends(EnhancedTextarea, _super);
    function EnhancedTextarea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null,
        };
        _this.handleResize = function (event) {
            _this.syncHeightWithShadow(_this.props.value, event);
        };
        _this.handleChange = function (event) {
            if (!_this.props.hasOwnProperty('value')) {
                _this.syncHeightWithShadow(event.target.value);
            }
            if (_this.props.hasOwnProperty('valueLink')) {
                _this.props.valueLink.requestChange(event.target.value);
            }
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        return _this;
    }
    EnhancedTextarea.prototype.componentWillMount = function () {
        this.setState({
            height: this.props.rows * rowsHeight,
        });
    };
    EnhancedTextarea.prototype.componentDidMount = function () {
        this.syncHeightWithShadow(this.props.value);
    };
    EnhancedTextarea.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value ||
            nextProps.rowsMax !== this.props.rowsMax) {
            this.syncHeightWithShadow(nextProps.value, null, nextProps);
        }
    };
    EnhancedTextarea.prototype.getInputNode = function () {
        return this.refs.input;
    };
    EnhancedTextarea.prototype.setValue = function (value) {
        this.getInputNode().value = value;
        this.syncHeightWithShadow(value);
    };
    EnhancedTextarea.prototype.syncHeightWithShadow = function (newValue, event, props) {
        if (event === void 0) { event = undefined; }
        if (props === void 0) { props = undefined; }
        var shadow = this.refs.shadow;
        var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ?
            this.props.hintText : newValue;
        if (displayText !== undefined) {
            shadow.value = displayText;
        }
        var newHeight = shadow.scrollHeight;
        // Guarding for jsdom, where scrollHeight isn't present.
        // See https://github.com/tmpvar/jsdom/issues/1013
        if (newHeight === undefined)
            return;
        props = props || this.props;
        if (props.rowsMax >= props.rows) {
            newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
        }
        newHeight = Math.max(newHeight, rowsHeight);
        if (this.state.height !== newHeight) {
            var input_1 = this.refs.input;
            var cursorPosition_1 = input_1.selectionStart;
            this.setState({
                height: newHeight,
            }, function () {
                if (input_1 === document.activeElement) {
                    input_1.setSelectionRange(cursorPosition_1, cursorPosition_1);
                }
            });
            if (props.onHeightChange) {
                props.onHeightChange(event, newHeight);
            }
        }
    };
    EnhancedTextarea.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, // eslint-disable-line no-unused-vars
        onHeightChange = _a.onHeightChange, // eslint-disable-line no-unused-vars
        rows = _a.rows, // eslint-disable-line no-unused-vars
        rowsMax = _a.rowsMax, // eslint-disable-line no-unused-vars
        shadowStyle = _a.shadowStyle, style = _a.style, hintText = _a.hintText, // eslint-disable-line no-unused-vars
        textareaStyle = _a.textareaStyle, valueLink = _a.valueLink, // eslint-disable-line no-unused-vars
        other = __rest(_a, ["onChange", "onHeightChange", "rows", "rowsMax", "shadowStyle", "style", "hintText", "textareaStyle", "valueLink"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context, this.state);
        var rootStyles = Object.assign(styles.root, style);
        var textareaStyles = Object.assign(styles.textarea, textareaStyle);
        var shadowStyles = Object.assign({}, textareaStyles, styles.shadow, shadowStyle);
        if (this.props.hasOwnProperty('valueLink')) {
            other.value = this.props.valueLink.value;
        }
        return (React.createElement("div", { style: prepareStyles(rootStyles) },
            React.createElement(react_event_listener_1.default, { target: "window", onResize: this.handleResize }),
            React.createElement("textarea", { ref: "shadow", style: prepareStyles(shadowStyles), tabIndex: -1, rows: this.props.rows, defaultValue: this.props.defaultValue, readOnly: true, value: this.props.value }),
            React.createElement("textarea", __assign({}, other, { ref: "input", rows: this.props.rows, style: prepareStyles(textareaStyles), onChange: this.handleChange }))));
    };
    EnhancedTextarea.propTypes = {
        defaultValue: PropTypes.any,
        disabled: PropTypes.bool,
        hintText: PropTypes.node,
        onChange: PropTypes.func,
        onHeightChange: PropTypes.func,
        rows: PropTypes.number,
        rowsMax: PropTypes.number,
        shadowStyle: PropTypes.object,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        textareaStyle: PropTypes.object,
        value: PropTypes.string,
        valueLink: PropTypes.object,
    };
    EnhancedTextarea.defaultProps = {
        rows: 1,
    };
    EnhancedTextarea.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return EnhancedTextarea;
}(React.Component));
exports.default = EnhancedTextarea;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\EnhancedTextarea.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Text\\EnhancedTextarea.tsx"); } } })();

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1515);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:Roboto;src:url(" + __webpack_require__(434) + ");font-weight:400}@font-face{font-family:Roboto;src:url(" + __webpack_require__(435) + ");font-weight:400;font-style:italic}@font-face{font-family:Roboto;src:url(" + __webpack_require__(436) + ");font-weight:300}@font-face{font-family:Roboto;src:url(" + __webpack_require__(437) + ");font-weight:500}@font-face{font-family:Roboto;src:url(" + __webpack_require__(438) + ");font-weight:600}@font-face{font-family:fontoctopus;src:url(" + __webpack_require__(235) + ");src:url(" + __webpack_require__(235) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(439) + ") format(\"woff\"),url(" + __webpack_require__(440) + ") format(\"truetype\"),url(" + __webpack_require__(441) + ") format(\"svg\");font-weight:400;font-style:normal}.style_fontoctopus-octopus__2N8AD{display:inline-block;font:normal normal normal 1em fontoctopus;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}.style_fontoctopus-octopus__2N8AD:before{content:\"\\E800\"}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(442) + ");src:url(" + __webpack_require__(443) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(444) + ") format(\"woff2\"),url(" + __webpack_require__(445) + ") format(\"woff\"),url(" + __webpack_require__(446) + ") format(\"truetype\"),url(" + __webpack_require__(447) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.style_fa__2Stzz{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.style_fa-lg__1bG3h{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.style_fa-2x__2_hqT{font-size:2em}.style_fa-3x__Stup6{font-size:3em}.style_fa-4x___nR0M{font-size:4em}.style_fa-5x__vUgdf{font-size:5em}.style_fa-fw__1jESs{width:1.28571429em;text-align:center}.style_fa-ul__22z2m{padding-left:0;margin-left:2.14285714em;list-style-type:none}.style_fa-ul__22z2m>li{position:relative}.style_fa-li__1xMKd{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.style_fa-li__1xMKd.style_fa-lg__1bG3h{left:-1.85714286em}.style_fa-border__N_IDS{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.style_fa-pull-left__19hOZ{float:left}.style_fa-pull-right__1IGi0{float:right}.style_fa__2Stzz.style_fa-pull-left__19hOZ{margin-right:.3em}.style_fa__2Stzz.style_fa-pull-right__1IGi0{margin-left:.3em}.style_pull-right__Ekb6T{float:right}.style_pull-left__6kkds{float:left}.style_fa__2Stzz.style_pull-left__6kkds{margin-right:.3em}.style_fa__2Stzz.style_pull-right__Ekb6T{margin-left:.3em}.style_fa-spin__3OLtN{-webkit-animation:style_fa-spin__3OLtN 2s infinite linear;animation:style_fa-spin__3OLtN 2s infinite linear}.style_fa-pulse__3YIU7{-webkit-animation:style_fa-spin__3OLtN 1s infinite steps(8);animation:style_fa-spin__3OLtN 1s infinite steps(8)}@-webkit-keyframes style_fa-spin__3OLtN{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes style_fa-spin__3OLtN{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.style_fa-rotate-90__V_q9A{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.style_fa-rotate-180__AlfVc{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.style_fa-rotate-270__zfwx-{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.style_fa-flip-horizontal__SlkBZ{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.style_fa-flip-vertical__oocW6{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .style_fa-flip-horizontal__SlkBZ,:root .style_fa-flip-vertical__oocW6,:root .style_fa-rotate-90__V_q9A,:root .style_fa-rotate-180__AlfVc,:root .style_fa-rotate-270__zfwx-{filter:none}.style_fa-stack__2CYwt{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.style_fa-stack-1x__1VBdj,.style_fa-stack-2x__3ku48{position:absolute;left:0;width:100%;text-align:center}.style_fa-stack-1x__1VBdj{line-height:inherit}.style_fa-stack-2x__3ku48{font-size:2em}.style_fa-inverse__1m291{color:#fff}.style_fa-glass__16k7J:before{content:\"\\F000\"}.style_fa-music__kkflz:before{content:\"\\F001\"}.style_fa-search__qCxf9:before{content:\"\\F002\"}.style_fa-envelope-o__xXTWd:before{content:\"\\F003\"}.style_fa-heart__3Ug_1:before{content:\"\\F004\"}.style_fa-star__3N6qV:before{content:\"\\F005\"}.style_fa-star-o__2CD-u:before{content:\"\\F006\"}.style_fa-user__3khUP:before{content:\"\\F007\"}.style_fa-film__gBI0K:before{content:\"\\F008\"}.style_fa-th-large__2fszA:before{content:\"\\F009\"}.style_fa-th__2awmn:before{content:\"\\F00A\"}.style_fa-th-list__2FtcN:before{content:\"\\F00B\"}.style_fa-check__3AIyn:before{content:\"\\F00C\"}.style_fa-close__1knvb:before,.style_fa-remove__3cnS0:before,.style_fa-times__3yoPt:before{content:\"\\F00D\"}.style_fa-search-plus__33Lij:before{content:\"\\F00E\"}.style_fa-search-minus__2yHac:before{content:\"\\F010\"}.style_fa-power-off__3QfoZ:before{content:\"\\F011\"}.style_fa-signal__2LNOs:before{content:\"\\F012\"}.style_fa-cog__2S0eu:before,.style_fa-gear__1aqXg:before{content:\"\\F013\"}.style_fa-trash-o__Jy4Qd:before{content:\"\\F014\"}.style_fa-home__2aA7l:before{content:\"\\F015\"}.style_fa-file-o__2XOwD:before{content:\"\\F016\"}.style_fa-clock-o__2WKaF:before{content:\"\\F017\"}.style_fa-road__2emGR:before{content:\"\\F018\"}.style_fa-download__2Jf5l:before{content:\"\\F019\"}.style_fa-arrow-circle-o-down__1zZ7Q:before{content:\"\\F01A\"}.style_fa-arrow-circle-o-up__KMZ50:before{content:\"\\F01B\"}.style_fa-inbox__3BPi6:before{content:\"\\F01C\"}.style_fa-play-circle-o__1PlJd:before{content:\"\\F01D\"}.style_fa-repeat__2EtMa:before,.style_fa-rotate-right__1U5RB:before{content:\"\\F01E\"}.style_fa-refresh__1BjiR:before{content:\"\\F021\"}.style_fa-list-alt__2UUVE:before{content:\"\\F022\"}.style_fa-lock__2AxqE:before{content:\"\\F023\"}.style_fa-flag__1u53R:before{content:\"\\F024\"}.style_fa-headphones__3Yhkq:before{content:\"\\F025\"}.style_fa-volume-off__3LfY-:before{content:\"\\F026\"}.style_fa-volume-down__1JuvK:before{content:\"\\F027\"}.style_fa-volume-up__3rdlp:before{content:\"\\F028\"}.style_fa-qrcode__2UZke:before{content:\"\\F029\"}.style_fa-barcode__3NqNI:before{content:\"\\F02A\"}.style_fa-tag__2O9hk:before{content:\"\\F02B\"}.style_fa-tags__-8Rh_:before{content:\"\\F02C\"}.style_fa-book__3Nk-f:before{content:\"\\F02D\"}.style_fa-bookmark__3qaOT:before{content:\"\\F02E\"}.style_fa-print__YyG1f:before{content:\"\\F02F\"}.style_fa-camera__aUjmZ:before{content:\"\\F030\"}.style_fa-font__gGxlk:before{content:\"\\F031\"}.style_fa-bold__ks_J4:before{content:\"\\F032\"}.style_fa-italic__20ogU:before{content:\"\\F033\"}.style_fa-text-height___0LQ7:before{content:\"\\F034\"}.style_fa-text-width__jeOjf:before{content:\"\\F035\"}.style_fa-align-left__22Zw8:before{content:\"\\F036\"}.style_fa-align-center__3Iq_1:before{content:\"\\F037\"}.style_fa-align-right__Eka7e:before{content:\"\\F038\"}.style_fa-align-justify__pARZF:before{content:\"\\F039\"}.style_fa-list__1OD3U:before{content:\"\\F03A\"}.style_fa-dedent__YI-PY:before,.style_fa-outdent__Q3A49:before{content:\"\\F03B\"}.style_fa-indent__1jwPG:before{content:\"\\F03C\"}.style_fa-video-camera__3zM_P:before{content:\"\\F03D\"}.style_fa-image__1Zij8:before,.style_fa-photo__12fAw:before,.style_fa-picture-o__2kh9I:before{content:\"\\F03E\"}.style_fa-pencil__SPg_-:before{content:\"\\F040\"}.style_fa-map-marker__2B57R:before{content:\"\\F041\"}.style_fa-adjust__22duV:before{content:\"\\F042\"}.style_fa-tint__2hInd:before{content:\"\\F043\"}.style_fa-edit__2hUlG:before,.style_fa-pencil-square-o__E9ibP:before{content:\"\\F044\"}.style_fa-share-square-o__2RDHE:before{content:\"\\F045\"}.style_fa-check-square-o__2K-Dz:before{content:\"\\F046\"}.style_fa-arrows__35WFl:before{content:\"\\F047\"}.style_fa-step-backward__1CcyE:before{content:\"\\F048\"}.style_fa-fast-backward__1Blqo:before{content:\"\\F049\"}.style_fa-backward__3e-fg:before{content:\"\\F04A\"}.style_fa-play__ETJ_t:before{content:\"\\F04B\"}.style_fa-pause__3ro_2:before{content:\"\\F04C\"}.style_fa-stop__3ZrVE:before{content:\"\\F04D\"}.style_fa-forward__38fYD:before{content:\"\\F04E\"}.style_fa-fast-forward__12ERo:before{content:\"\\F050\"}.style_fa-step-forward__1HhqA:before{content:\"\\F051\"}.style_fa-eject__3iYgQ:before{content:\"\\F052\"}.style_fa-chevron-left__3n6Ih:before{content:\"\\F053\"}.style_fa-chevron-right__17qWa:before{content:\"\\F054\"}.style_fa-plus-circle__1_Hd6:before{content:\"\\F055\"}.style_fa-minus-circle__2lFkp:before{content:\"\\F056\"}.style_fa-times-circle__3sN8j:before{content:\"\\F057\"}.style_fa-check-circle__2wkS0:before{content:\"\\F058\"}.style_fa-question-circle__2fk1Y:before{content:\"\\F059\"}.style_fa-info-circle__2gaYm:before{content:\"\\F05A\"}.style_fa-crosshairs__1LEU-:before{content:\"\\F05B\"}.style_fa-times-circle-o__2TSHm:before{content:\"\\F05C\"}.style_fa-check-circle-o__3WaoE:before{content:\"\\F05D\"}.style_fa-ban__2Qhpz:before{content:\"\\F05E\"}.style_fa-arrow-left__1Tt32:before{content:\"\\F060\"}.style_fa-arrow-right__1FESc:before{content:\"\\F061\"}.style_fa-arrow-up__3wcyR:before{content:\"\\F062\"}.style_fa-arrow-down__3Mskv:before{content:\"\\F063\"}.style_fa-mail-forward__2NDhk:before,.style_fa-share__3l_NS:before{content:\"\\F064\"}.style_fa-expand__3GAJ3:before{content:\"\\F065\"}.style_fa-compress__2wbOP:before{content:\"\\F066\"}.style_fa-plus__22pw4:before{content:\"\\F067\"}.style_fa-minus__poN8Q:before{content:\"\\F068\"}.style_fa-asterisk__33jbA:before{content:\"\\F069\"}.style_fa-exclamation-circle__1xJgn:before{content:\"\\F06A\"}.style_fa-gift__3nKN8:before{content:\"\\F06B\"}.style_fa-leaf__FnNeM:before{content:\"\\F06C\"}.style_fa-fire__iabFV:before{content:\"\\F06D\"}.style_fa-eye__zJEkG:before{content:\"\\F06E\"}.style_fa-eye-slash__2bjSj:before{content:\"\\F070\"}.style_fa-exclamation-triangle__1FI1o:before,.style_fa-warning__3f1BB:before{content:\"\\F071\"}.style_fa-plane__r9HNn:before{content:\"\\F072\"}.style_fa-calendar__1lGhc:before{content:\"\\F073\"}.style_fa-random__3oSfN:before{content:\"\\F074\"}.style_fa-comment__1XcXN:before{content:\"\\F075\"}.style_fa-magnet__3Ra7v:before{content:\"\\F076\"}.style_fa-chevron-up__1IJay:before{content:\"\\F077\"}.style_fa-chevron-down__3VgR7:before{content:\"\\F078\"}.style_fa-retweet__3bBmk:before{content:\"\\F079\"}.style_fa-shopping-cart__wsIiy:before{content:\"\\F07A\"}.style_fa-folder__3pZY8:before{content:\"\\F07B\"}.style_fa-folder-open__2e7-y:before{content:\"\\F07C\"}.style_fa-arrows-v__3lYN9:before{content:\"\\F07D\"}.style_fa-arrows-h__2AKrb:before{content:\"\\F07E\"}.style_fa-bar-chart-o__1N0Fi:before,.style_fa-bar-chart__2GC9g:before{content:\"\\F080\"}.style_fa-twitter-square__25459:before{content:\"\\F081\"}.style_fa-facebook-square__34MaH:before{content:\"\\F082\"}.style_fa-camera-retro__3UpEF:before{content:\"\\F083\"}.style_fa-key__PomoZ:before{content:\"\\F084\"}.style_fa-cogs__2mWvc:before,.style_fa-gears__3bHU8:before{content:\"\\F085\"}.style_fa-comments__1TsY2:before{content:\"\\F086\"}.style_fa-thumbs-o-up__CdiXO:before{content:\"\\F087\"}.style_fa-thumbs-o-down__z4NN5:before{content:\"\\F088\"}.style_fa-star-half__Iest8:before{content:\"\\F089\"}.style_fa-heart-o__2m_lH:before{content:\"\\F08A\"}.style_fa-sign-out__1lcQa:before{content:\"\\F08B\"}.style_fa-linkedin-square__3kZOS:before{content:\"\\F08C\"}.style_fa-thumb-tack__1o_WC:before{content:\"\\F08D\"}.style_fa-external-link__1PHHE:before{content:\"\\F08E\"}.style_fa-sign-in__1qcVV:before{content:\"\\F090\"}.style_fa-trophy__3_XYL:before{content:\"\\F091\"}.style_fa-github-square__2Ylwu:before{content:\"\\F092\"}.style_fa-upload__1fS8f:before{content:\"\\F093\"}.style_fa-lemon-o__2eZyK:before{content:\"\\F094\"}.style_fa-phone__3YoRI:before{content:\"\\F095\"}.style_fa-square-o__1N8kv:before{content:\"\\F096\"}.style_fa-bookmark-o__jfvFO:before{content:\"\\F097\"}.style_fa-phone-square__3ZRc_:before{content:\"\\F098\"}.style_fa-twitter__2yG2o:before{content:\"\\F099\"}.style_fa-facebook-f__2lRUc:before,.style_fa-facebook__32LSL:before{content:\"\\F09A\"}.style_fa-github__2Ke1H:before{content:\"\\F09B\"}.style_fa-unlock__3LTVN:before{content:\"\\F09C\"}.style_fa-credit-card__17tW0:before{content:\"\\F09D\"}.style_fa-feed__2gj0C:before,.style_fa-rss__2TJ7S:before{content:\"\\F09E\"}.style_fa-hdd-o__3p7M9:before{content:\"\\F0A0\"}.style_fa-bullhorn__2nBQr:before{content:\"\\F0A1\"}.style_fa-bell__xhSCD:before{content:\"\\F0F3\"}.style_fa-certificate__1UjXn:before{content:\"\\F0A3\"}.style_fa-hand-o-right__170tV:before{content:\"\\F0A4\"}.style_fa-hand-o-left__1bZCj:before{content:\"\\F0A5\"}.style_fa-hand-o-up__FOPJs:before{content:\"\\F0A6\"}.style_fa-hand-o-down__3EtW7:before{content:\"\\F0A7\"}.style_fa-arrow-circle-left__4Si1c:before{content:\"\\F0A8\"}.style_fa-arrow-circle-right__o2B_F:before{content:\"\\F0A9\"}.style_fa-arrow-circle-up__1t6C_:before{content:\"\\F0AA\"}.style_fa-arrow-circle-down__2JhhB:before{content:\"\\F0AB\"}.style_fa-globe__25Cen:before{content:\"\\F0AC\"}.style_fa-wrench__258HL:before{content:\"\\F0AD\"}.style_fa-tasks__2oxZT:before{content:\"\\F0AE\"}.style_fa-filter__3HM1H:before{content:\"\\F0B0\"}.style_fa-briefcase__2JNBT:before{content:\"\\F0B1\"}.style_fa-arrows-alt__1sD0o:before{content:\"\\F0B2\"}.style_fa-group__20X3W:before,.style_fa-users__1Wv4i:before{content:\"\\F0C0\"}.style_fa-chain__3gkVR:before,.style_fa-link__15zB7:before{content:\"\\F0C1\"}.style_fa-cloud__1Ddfl:before{content:\"\\F0C2\"}.style_fa-flask__1wJvc:before{content:\"\\F0C3\"}.style_fa-cut___XyZV:before,.style_fa-scissors__AYHcI:before{content:\"\\F0C4\"}.style_fa-copy__1Ossh:before,.style_fa-files-o__3sJJ-:before{content:\"\\F0C5\"}.style_fa-paperclip__1hTCr:before{content:\"\\F0C6\"}.style_fa-floppy-o__2TnBm:before,.style_fa-save__1LOCv:before{content:\"\\F0C7\"}.style_fa-square__28Zx1:before{content:\"\\F0C8\"}.style_fa-bars__Wlajt:before,.style_fa-navicon__1X1U8:before,.style_fa-reorder__18Czt:before{content:\"\\F0C9\"}.style_fa-list-ul__2D7G5:before{content:\"\\F0CA\"}.style_fa-list-ol__C0x7T:before{content:\"\\F0CB\"}.style_fa-strikethrough__3t6ML:before{content:\"\\F0CC\"}.style_fa-underline__1SFb4:before{content:\"\\F0CD\"}.style_fa-table__19Se0:before{content:\"\\F0CE\"}.style_fa-magic___i3Nz:before{content:\"\\F0D0\"}.style_fa-truck__ZtSgC:before{content:\"\\F0D1\"}.style_fa-pinterest__22id1:before{content:\"\\F0D2\"}.style_fa-pinterest-square__369gS:before{content:\"\\F0D3\"}.style_fa-google-plus-square__hBjwt:before{content:\"\\F0D4\"}.style_fa-google-plus__3y50_:before{content:\"\\F0D5\"}.style_fa-money__1Qjqs:before{content:\"\\F0D6\"}.style_fa-caret-down__2x_8t:before{content:\"\\F0D7\"}.style_fa-caret-up__26GUW:before{content:\"\\F0D8\"}.style_fa-caret-left__irqU0:before{content:\"\\F0D9\"}.style_fa-caret-right__P8lmz:before{content:\"\\F0DA\"}.style_fa-columns__2tlq9:before{content:\"\\F0DB\"}.style_fa-sort__OJrdh:before,.style_fa-unsorted__1Kqx5:before{content:\"\\F0DC\"}.style_fa-sort-desc__2XfG6:before,.style_fa-sort-down__1Ru3s:before{content:\"\\F0DD\"}.style_fa-sort-asc__U5a_d:before,.style_fa-sort-up__24qNy:before{content:\"\\F0DE\"}.style_fa-envelope__1AvyZ:before{content:\"\\F0E0\"}.style_fa-linkedin__reVK3:before{content:\"\\F0E1\"}.style_fa-rotate-left__1KZgM:before,.style_fa-undo__3TtfA:before{content:\"\\F0E2\"}.style_fa-gavel__6RQAi:before,.style_fa-legal__3kLMa:before{content:\"\\F0E3\"}.style_fa-dashboard__2DuDP:before,.style_fa-tachometer__1cwGN:before{content:\"\\F0E4\"}.style_fa-comment-o__1JPzx:before{content:\"\\F0E5\"}.style_fa-comments-o__1bL7J:before{content:\"\\F0E6\"}.style_fa-bolt__2jVjr:before,.style_fa-flash__3nAJC:before{content:\"\\F0E7\"}.style_fa-sitemap__3DNmq:before{content:\"\\F0E8\"}.style_fa-umbrella__O7zIG:before{content:\"\\F0E9\"}.style_fa-clipboard__1gVaK:before,.style_fa-paste__1DC1m:before{content:\"\\F0EA\"}.style_fa-lightbulb-o__rfE_N:before{content:\"\\F0EB\"}.style_fa-exchange__32Bx_:before{content:\"\\F0EC\"}.style_fa-cloud-download__3HJaV:before{content:\"\\F0ED\"}.style_fa-cloud-upload__2mTgC:before{content:\"\\F0EE\"}.style_fa-user-md__2an77:before{content:\"\\F0F0\"}.style_fa-stethoscope__1Vpz0:before{content:\"\\F0F1\"}.style_fa-suitcase__3CTJq:before{content:\"\\F0F2\"}.style_fa-bell-o__zcNr6:before{content:\"\\F0A2\"}.style_fa-coffee__2sCU6:before{content:\"\\F0F4\"}.style_fa-cutlery__3Ya5Y:before{content:\"\\F0F5\"}.style_fa-file-text-o__20xzO:before{content:\"\\F0F6\"}.style_fa-building-o__2YAYY:before{content:\"\\F0F7\"}.style_fa-hospital-o__2nAdh:before{content:\"\\F0F8\"}.style_fa-ambulance__367f4:before{content:\"\\F0F9\"}.style_fa-medkit__2umfr:before{content:\"\\F0FA\"}.style_fa-fighter-jet__1XQZm:before{content:\"\\F0FB\"}.style_fa-beer__3F4Fo:before{content:\"\\F0FC\"}.style_fa-h-square__3UZBQ:before{content:\"\\F0FD\"}.style_fa-plus-square__2pCA8:before{content:\"\\F0FE\"}.style_fa-angle-double-left__34cFJ:before{content:\"\\F100\"}.style_fa-angle-double-right__sfWlQ:before{content:\"\\F101\"}.style_fa-angle-double-up__XjAIq:before{content:\"\\F102\"}.style_fa-angle-double-down__2eg81:before{content:\"\\F103\"}.style_fa-angle-left__DUgjE:before{content:\"\\F104\"}.style_fa-angle-right__3V_P0:before{content:\"\\F105\"}.style_fa-angle-up__2csFP:before{content:\"\\F106\"}.style_fa-angle-down__1gNw4:before{content:\"\\F107\"}.style_fa-desktop__2xX4m:before{content:\"\\F108\"}.style_fa-laptop__3MT5H:before{content:\"\\F109\"}.style_fa-tablet__1JL66:before{content:\"\\F10A\"}.style_fa-mobile-phone__32S3m:before,.style_fa-mobile__1pbSy:before{content:\"\\F10B\"}.style_fa-circle-o__1Yyd-:before{content:\"\\F10C\"}.style_fa-quote-left__DjQVx:before{content:\"\\F10D\"}.style_fa-quote-right__1mvs9:before{content:\"\\F10E\"}.style_fa-spinner__3HVZk:before{content:\"\\F110\"}.style_fa-circle__2snKq:before{content:\"\\F111\"}.style_fa-mail-reply__2AC6z:before,.style_fa-reply__3G6Se:before{content:\"\\F112\"}.style_fa-github-alt__x_v-T:before{content:\"\\F113\"}.style_fa-folder-o__2VA-0:before{content:\"\\F114\"}.style_fa-folder-open-o__3RqaW:before{content:\"\\F115\"}.style_fa-smile-o__3KiYu:before{content:\"\\F118\"}.style_fa-frown-o__3H7-N:before{content:\"\\F119\"}.style_fa-meh-o__3-bgG:before{content:\"\\F11A\"}.style_fa-gamepad__mPyU7:before{content:\"\\F11B\"}.style_fa-keyboard-o__wAOHk:before{content:\"\\F11C\"}.style_fa-flag-o__321XR:before{content:\"\\F11D\"}.style_fa-flag-checkered__2VtGO:before{content:\"\\F11E\"}.style_fa-terminal__1fUHJ:before{content:\"\\F120\"}.style_fa-code__SRKGP:before{content:\"\\F121\"}.style_fa-mail-reply-all__Lz9Ih:before,.style_fa-reply-all__1t63J:before{content:\"\\F122\"}.style_fa-star-half-empty__19XZq:before,.style_fa-star-half-full__3Y45l:before,.style_fa-star-half-o__a-5to:before{content:\"\\F123\"}.style_fa-location-arrow__2qgJ1:before{content:\"\\F124\"}.style_fa-crop__2OK7-:before{content:\"\\F125\"}.style_fa-code-fork__1WC5P:before{content:\"\\F126\"}.style_fa-chain-broken__UtNIl:before,.style_fa-unlink__2vPUr:before{content:\"\\F127\"}.style_fa-question__3Y6e1:before{content:\"\\F128\"}.style_fa-info__1YJhf:before{content:\"\\F129\"}.style_fa-exclamation__1gQg6:before{content:\"\\F12A\"}.style_fa-superscript__2w6Zr:before{content:\"\\F12B\"}.style_fa-subscript__14RTM:before{content:\"\\F12C\"}.style_fa-eraser__S3iJb:before{content:\"\\F12D\"}.style_fa-puzzle-piece__199HV:before{content:\"\\F12E\"}.style_fa-microphone__27dax:before{content:\"\\F130\"}.style_fa-microphone-slash__3oZE7:before{content:\"\\F131\"}.style_fa-shield__3DkNX:before{content:\"\\F132\"}.style_fa-calendar-o__S43Cp:before{content:\"\\F133\"}.style_fa-fire-extinguisher__pDFqQ:before{content:\"\\F134\"}.style_fa-rocket__35oGO:before{content:\"\\F135\"}.style_fa-maxcdn__fFV60:before{content:\"\\F136\"}.style_fa-chevron-circle-left__3Ylxn:before{content:\"\\F137\"}.style_fa-chevron-circle-right__3cfR0:before{content:\"\\F138\"}.style_fa-chevron-circle-up__1NCOc:before{content:\"\\F139\"}.style_fa-chevron-circle-down__1ZTjz:before{content:\"\\F13A\"}.style_fa-html5__2AmMy:before{content:\"\\F13B\"}.style_fa-css3__197Tg:before{content:\"\\F13C\"}.style_fa-anchor__CwQXw:before{content:\"\\F13D\"}.style_fa-unlock-alt__33y20:before{content:\"\\F13E\"}.style_fa-bullseye__3Fzdl:before{content:\"\\F140\"}.style_fa-ellipsis-h__1xO9Y:before{content:\"\\F141\"}.style_fa-ellipsis-v__DGE5R:before{content:\"\\F142\"}.style_fa-rss-square__1EZtw:before{content:\"\\F143\"}.style_fa-play-circle__1UNzy:before{content:\"\\F144\"}.style_fa-ticket__2Hhzi:before{content:\"\\F145\"}.style_fa-minus-square__3rxP2:before{content:\"\\F146\"}.style_fa-minus-square-o__3Qd79:before{content:\"\\F147\"}.style_fa-level-up__3W8ml:before{content:\"\\F148\"}.style_fa-level-down__2hdzw:before{content:\"\\F149\"}.style_fa-check-square__PXToN:before{content:\"\\F14A\"}.style_fa-pencil-square__3BxAj:before{content:\"\\F14B\"}.style_fa-external-link-square__1BIFy:before{content:\"\\F14C\"}.style_fa-share-square__1V1tB:before{content:\"\\F14D\"}.style_fa-compass__2SPjB:before{content:\"\\F14E\"}.style_fa-caret-square-o-down__2E4Mb:before,.style_fa-toggle-down__3JopC:before{content:\"\\F150\"}.style_fa-caret-square-o-up__1VOkN:before,.style_fa-toggle-up__1vJD0:before{content:\"\\F151\"}.style_fa-caret-square-o-right__2U1ay:before,.style_fa-toggle-right__1vs4i:before{content:\"\\F152\"}.style_fa-eur__3MXW5:before,.style_fa-euro__1jXcx:before{content:\"\\F153\"}.style_fa-gbp__2Ps1g:before{content:\"\\F154\"}.style_fa-dollar__3Pc9r:before,.style_fa-usd__3Iq-9:before{content:\"\\F155\"}.style_fa-inr__XhhvZ:before,.style_fa-rupee__1NZ0t:before{content:\"\\F156\"}.style_fa-cny__2vF4f:before,.style_fa-jpy__6ngge:before,.style_fa-rmb__14IpQ:before,.style_fa-yen__3rbpG:before{content:\"\\F157\"}.style_fa-rouble__2UTPI:before,.style_fa-rub__3PmCg:before,.style_fa-ruble__1MHOp:before{content:\"\\F158\"}.style_fa-krw__11g7e:before,.style_fa-won__1buvn:before{content:\"\\F159\"}.style_fa-bitcoin__1Pk94:before,.style_fa-btc__3b4vn:before{content:\"\\F15A\"}.style_fa-file__3PW0K:before{content:\"\\F15B\"}.style_fa-file-text__1i0b9:before{content:\"\\F15C\"}.style_fa-sort-alpha-asc__3Wl8L:before{content:\"\\F15D\"}.style_fa-sort-alpha-desc__X0x0e:before{content:\"\\F15E\"}.style_fa-sort-amount-asc__2VAur:before{content:\"\\F160\"}.style_fa-sort-amount-desc__3wj0k:before{content:\"\\F161\"}.style_fa-sort-numeric-asc__2roSh:before{content:\"\\F162\"}.style_fa-sort-numeric-desc__1qZDn:before{content:\"\\F163\"}.style_fa-thumbs-up__1Wg1I:before{content:\"\\F164\"}.style_fa-thumbs-down__2xAxS:before{content:\"\\F165\"}.style_fa-youtube-square__3nFIw:before{content:\"\\F166\"}.style_fa-youtube__31ODZ:before{content:\"\\F167\"}.style_fa-xing__27cX2:before{content:\"\\F168\"}.style_fa-xing-square__35esg:before{content:\"\\F169\"}.style_fa-youtube-play__2C5gj:before{content:\"\\F16A\"}.style_fa-dropbox__1d8d4:before{content:\"\\F16B\"}.style_fa-stack-overflow__2GZ-H:before{content:\"\\F16C\"}.style_fa-instagram__3fb9Q:before{content:\"\\F16D\"}.style_fa-flickr__WhIVy:before{content:\"\\F16E\"}.style_fa-adn__3-Z8l:before{content:\"\\F170\"}.style_fa-bitbucket__CbNjZ:before{content:\"\\F171\"}.style_fa-bitbucket-square__t0VxH:before{content:\"\\F172\"}.style_fa-tumblr__2_oM_:before{content:\"\\F173\"}.style_fa-tumblr-square__3F7CC:before{content:\"\\F174\"}.style_fa-long-arrow-down__2oVs-:before{content:\"\\F175\"}.style_fa-long-arrow-up__bklzU:before{content:\"\\F176\"}.style_fa-long-arrow-left__3APTL:before{content:\"\\F177\"}.style_fa-long-arrow-right__21tW8:before{content:\"\\F178\"}.style_fa-apple__1wtga:before{content:\"\\F179\"}.style_fa-windows__19Xi6:before{content:\"\\F17A\"}.style_fa-android__2vJKQ:before{content:\"\\F17B\"}.style_fa-linux__1dLmz:before{content:\"\\F17C\"}.style_fa-dribbble__ZWptF:before{content:\"\\F17D\"}.style_fa-skype__27gQr:before{content:\"\\F17E\"}.style_fa-foursquare__3QNVL:before{content:\"\\F180\"}.style_fa-trello__2sbpV:before{content:\"\\F181\"}.style_fa-female__2gRF2:before{content:\"\\F182\"}.style_fa-male__1CNvk:before{content:\"\\F183\"}.style_fa-gittip__mo97w:before,.style_fa-gratipay__3YS56:before{content:\"\\F184\"}.style_fa-sun-o__2iTX9:before{content:\"\\F185\"}.style_fa-moon-o__1SqMg:before{content:\"\\F186\"}.style_fa-archive__3VLlT:before{content:\"\\F187\"}.style_fa-bug__2fFru:before{content:\"\\F188\"}.style_fa-vk__3KpkN:before{content:\"\\F189\"}.style_fa-weibo__2RfmV:before{content:\"\\F18A\"}.style_fa-renren__1QDdr:before{content:\"\\F18B\"}.style_fa-pagelines__fm95T:before{content:\"\\F18C\"}.style_fa-stack-exchange__2qfzD:before{content:\"\\F18D\"}.style_fa-arrow-circle-o-right__K7ffa:before{content:\"\\F18E\"}.style_fa-arrow-circle-o-left__3EN-J:before{content:\"\\F190\"}.style_fa-caret-square-o-left__3gHuI:before,.style_fa-toggle-left__2etkD:before{content:\"\\F191\"}.style_fa-dot-circle-o__1QlOs:before{content:\"\\F192\"}.style_fa-wheelchair__3DlnR:before{content:\"\\F193\"}.style_fa-vimeo-square__2QJq0:before{content:\"\\F194\"}.style_fa-try__B8huM:before,.style_fa-turkish-lira__uIPlz:before{content:\"\\F195\"}.style_fa-plus-square-o__15P7a:before{content:\"\\F196\"}.style_fa-space-shuttle__zzUXH:before{content:\"\\F197\"}.style_fa-slack__1WXhk:before{content:\"\\F198\"}.style_fa-envelope-square__3j9ps:before{content:\"\\F199\"}.style_fa-wordpress__2xzZ6:before{content:\"\\F19A\"}.style_fa-openid__D94GP:before{content:\"\\F19B\"}.style_fa-bank__3rkbQ:before,.style_fa-institution__2hjdN:before,.style_fa-university__3HLWm:before{content:\"\\F19C\"}.style_fa-graduation-cap__Mv-zi:before,.style_fa-mortar-board__lir21:before{content:\"\\F19D\"}.style_fa-yahoo__3KkpO:before{content:\"\\F19E\"}.style_fa-google__3FGuH:before{content:\"\\F1A0\"}.style_fa-reddit__11v_6:before{content:\"\\F1A1\"}.style_fa-reddit-square__3lV5F:before{content:\"\\F1A2\"}.style_fa-stumbleupon-circle__3aLV5:before{content:\"\\F1A3\"}.style_fa-stumbleupon__YCZC2:before{content:\"\\F1A4\"}.style_fa-delicious__3_9p9:before{content:\"\\F1A5\"}.style_fa-digg__Aqqnb:before{content:\"\\F1A6\"}.style_fa-pied-piper-pp__2Jh-d:before{content:\"\\F1A7\"}.style_fa-pied-piper-alt__1RYAN:before{content:\"\\F1A8\"}.style_fa-drupal__2CBnI:before{content:\"\\F1A9\"}.style_fa-joomla__2jLpt:before{content:\"\\F1AA\"}.style_fa-language__12ZtE:before{content:\"\\F1AB\"}.style_fa-fax__2brsY:before{content:\"\\F1AC\"}.style_fa-building__3gMtm:before{content:\"\\F1AD\"}.style_fa-child__aLfmj:before{content:\"\\F1AE\"}.style_fa-paw__3AdLQ:before{content:\"\\F1B0\"}.style_fa-spoon__31Ta2:before{content:\"\\F1B1\"}.style_fa-cube__E4C4A:before{content:\"\\F1B2\"}.style_fa-cubes__1Oc2M:before{content:\"\\F1B3\"}.style_fa-behance__3xSZc:before{content:\"\\F1B4\"}.style_fa-behance-square__3Nx9s:before{content:\"\\F1B5\"}.style_fa-steam__1qOBr:before{content:\"\\F1B6\"}.style_fa-steam-square__1uMzy:before{content:\"\\F1B7\"}.style_fa-recycle__109Ji:before{content:\"\\F1B8\"}.style_fa-automobile__rH9KD:before,.style_fa-car__3jJSC:before{content:\"\\F1B9\"}.style_fa-cab__2AAWR:before,.style_fa-taxi__16hc8:before{content:\"\\F1BA\"}.style_fa-tree__3TAew:before{content:\"\\F1BB\"}.style_fa-spotify__3zndM:before{content:\"\\F1BC\"}.style_fa-deviantart__k7QPs:before{content:\"\\F1BD\"}.style_fa-soundcloud__21KtU:before{content:\"\\F1BE\"}.style_fa-database__3x11l:before{content:\"\\F1C0\"}.style_fa-file-pdf-o__1UWXX:before{content:\"\\F1C1\"}.style_fa-file-word-o__Zxcy6:before{content:\"\\F1C2\"}.style_fa-file-excel-o__3tuIt:before{content:\"\\F1C3\"}.style_fa-file-powerpoint-o__2ldG5:before{content:\"\\F1C4\"}.style_fa-file-image-o__1N9tp:before,.style_fa-file-photo-o__3syks:before,.style_fa-file-picture-o__1ZXeo:before{content:\"\\F1C5\"}.style_fa-file-archive-o__10aGo:before,.style_fa-file-zip-o__1AycK:before{content:\"\\F1C6\"}.style_fa-file-audio-o__Gfwou:before,.style_fa-file-sound-o__VeT3V:before{content:\"\\F1C7\"}.style_fa-file-movie-o__3ichx:before,.style_fa-file-video-o__3Jcv3:before{content:\"\\F1C8\"}.style_fa-file-code-o__2K797:before{content:\"\\F1C9\"}.style_fa-vine__3OeCe:before{content:\"\\F1CA\"}.style_fa-codepen__1dXdy:before{content:\"\\F1CB\"}.style_fa-jsfiddle__3UgBp:before{content:\"\\F1CC\"}.style_fa-life-bouy__1_S3D:before,.style_fa-life-buoy__ve2oz:before,.style_fa-life-ring__25W_g:before,.style_fa-life-saver__ACpfj:before,.style_fa-support__3m5m6:before{content:\"\\F1CD\"}.style_fa-circle-o-notch__3cukx:before{content:\"\\F1CE\"}.style_fa-ra__1BSfX:before,.style_fa-rebel__yZmt9:before,.style_fa-resistance__1R8LL:before{content:\"\\F1D0\"}.style_fa-empire__2MYaA:before,.style_fa-ge__3Jxbo:before{content:\"\\F1D1\"}.style_fa-git-square__2fz0z:before{content:\"\\F1D2\"}.style_fa-git__273FN:before{content:\"\\F1D3\"}.style_fa-hacker-news__1BOsy:before,.style_fa-y-combinator-square__1kZaq:before,.style_fa-yc-square__2rvQu:before{content:\"\\F1D4\"}.style_fa-tencent-weibo__3QMpj:before{content:\"\\F1D5\"}.style_fa-qq__32_v9:before{content:\"\\F1D6\"}.style_fa-wechat__3RMBl:before,.style_fa-weixin__PIRz-:before{content:\"\\F1D7\"}.style_fa-paper-plane__22F4t:before,.style_fa-send__XzgHa:before{content:\"\\F1D8\"}.style_fa-paper-plane-o__rthxb:before,.style_fa-send-o__1VUws:before{content:\"\\F1D9\"}.style_fa-history__3jmj5:before{content:\"\\F1DA\"}.style_fa-circle-thin__pujpG:before{content:\"\\F1DB\"}.style_fa-header__3M7hI:before{content:\"\\F1DC\"}.style_fa-paragraph__AHVpO:before{content:\"\\F1DD\"}.style_fa-sliders__3qlRM:before{content:\"\\F1DE\"}.style_fa-share-alt__3pA8S:before{content:\"\\F1E0\"}.style_fa-share-alt-square__2TLPh:before{content:\"\\F1E1\"}.style_fa-bomb__9R958:before{content:\"\\F1E2\"}.style_fa-futbol-o__1a0Ku:before,.style_fa-soccer-ball-o__3Zpz3:before{content:\"\\F1E3\"}.style_fa-tty__3dhCE:before{content:\"\\F1E4\"}.style_fa-binoculars__1lRi4:before{content:\"\\F1E5\"}.style_fa-plug__4R_-Z:before{content:\"\\F1E6\"}.style_fa-slideshare__2AFjK:before{content:\"\\F1E7\"}.style_fa-twitch__2pHuI:before{content:\"\\F1E8\"}.style_fa-yelp__3uIb0:before{content:\"\\F1E9\"}.style_fa-newspaper-o__2uVdd:before{content:\"\\F1EA\"}.style_fa-wifi__I10MG:before{content:\"\\F1EB\"}.style_fa-calculator__2peOS:before{content:\"\\F1EC\"}.style_fa-paypal__3ZedC:before{content:\"\\F1ED\"}.style_fa-google-wallet__1xZG3:before{content:\"\\F1EE\"}.style_fa-cc-visa__3wYa7:before{content:\"\\F1F0\"}.style_fa-cc-mastercard__x-8Hg:before{content:\"\\F1F1\"}.style_fa-cc-discover__WkJEt:before{content:\"\\F1F2\"}.style_fa-cc-amex__QATKk:before{content:\"\\F1F3\"}.style_fa-cc-paypal__31MqT:before{content:\"\\F1F4\"}.style_fa-cc-stripe__27I4-:before{content:\"\\F1F5\"}.style_fa-bell-slash__2wVQT:before{content:\"\\F1F6\"}.style_fa-bell-slash-o__3q6J0:before{content:\"\\F1F7\"}.style_fa-trash__2nsCq:before{content:\"\\F1F8\"}.style_fa-copyright__36jSb:before{content:\"\\F1F9\"}.style_fa-at__1gbqK:before{content:\"\\F1FA\"}.style_fa-eyedropper__2sfZR:before{content:\"\\F1FB\"}.style_fa-paint-brush__29gLz:before{content:\"\\F1FC\"}.style_fa-birthday-cake__2LFE-:before{content:\"\\F1FD\"}.style_fa-area-chart__2xoVG:before{content:\"\\F1FE\"}.style_fa-pie-chart__Lt9J9:before{content:\"\\F200\"}.style_fa-line-chart__v5Vz7:before{content:\"\\F201\"}.style_fa-lastfm__3Xbey:before{content:\"\\F202\"}.style_fa-lastfm-square__rcQZJ:before{content:\"\\F203\"}.style_fa-toggle-off__1RgJ-:before{content:\"\\F204\"}.style_fa-toggle-on__JzsTX:before{content:\"\\F205\"}.style_fa-bicycle__2Hi3o:before{content:\"\\F206\"}.style_fa-bus__2uqLm:before{content:\"\\F207\"}.style_fa-ioxhost__dz7I5:before{content:\"\\F208\"}.style_fa-angellist__1qU9h:before{content:\"\\F209\"}.style_fa-cc__1KTQC:before{content:\"\\F20A\"}.style_fa-ils__3RZz4:before,.style_fa-shekel__1TsRx:before,.style_fa-sheqel__2JXWS:before{content:\"\\F20B\"}.style_fa-meanpath__s-P0R:before{content:\"\\F20C\"}.style_fa-buysellads__31FsM:before{content:\"\\F20D\"}.style_fa-connectdevelop__3vxtL:before{content:\"\\F20E\"}.style_fa-dashcube__2SiAc:before{content:\"\\F210\"}.style_fa-forumbee__1N2en:before{content:\"\\F211\"}.style_fa-leanpub__GsGbD:before{content:\"\\F212\"}.style_fa-sellsy__3Voml:before{content:\"\\F213\"}.style_fa-shirtsinbulk__3Uicd:before{content:\"\\F214\"}.style_fa-simplybuilt__1S1iQ:before{content:\"\\F215\"}.style_fa-skyatlas__1lEy_:before{content:\"\\F216\"}.style_fa-cart-plus__6xtgm:before{content:\"\\F217\"}.style_fa-cart-arrow-down__TN9vq:before{content:\"\\F218\"}.style_fa-diamond__38kag:before{content:\"\\F219\"}.style_fa-ship__3jBZU:before{content:\"\\F21A\"}.style_fa-user-secret__1MNpY:before{content:\"\\F21B\"}.style_fa-motorcycle__2pfNe:before{content:\"\\F21C\"}.style_fa-street-view__2FFQt:before{content:\"\\F21D\"}.style_fa-heartbeat__10Izl:before{content:\"\\F21E\"}.style_fa-venus__25JDj:before{content:\"\\F221\"}.style_fa-mars__288UC:before{content:\"\\F222\"}.style_fa-mercury__2Q58M:before{content:\"\\F223\"}.style_fa-intersex__3kLL4:before,.style_fa-transgender__28Vug:before{content:\"\\F224\"}.style_fa-transgender-alt__2Nq6s:before{content:\"\\F225\"}.style_fa-venus-double__3h-Iv:before{content:\"\\F226\"}.style_fa-mars-double__bq6_W:before{content:\"\\F227\"}.style_fa-venus-mars__2vx7g:before{content:\"\\F228\"}.style_fa-mars-stroke__JBS4E:before{content:\"\\F229\"}.style_fa-mars-stroke-v__2DjaF:before{content:\"\\F22A\"}.style_fa-mars-stroke-h__2XBCX:before{content:\"\\F22B\"}.style_fa-neuter__tkR2L:before{content:\"\\F22C\"}.style_fa-genderless__3g8-C:before{content:\"\\F22D\"}.style_fa-facebook-official__1fixN:before{content:\"\\F230\"}.style_fa-pinterest-p__2Uacv:before{content:\"\\F231\"}.style_fa-whatsapp__5M37Z:before{content:\"\\F232\"}.style_fa-server__2Js8W:before{content:\"\\F233\"}.style_fa-user-plus__2FeQ9:before{content:\"\\F234\"}.style_fa-user-times__Z2cdB:before{content:\"\\F235\"}.style_fa-bed__165DP:before,.style_fa-hotel__3RJFT:before{content:\"\\F236\"}.style_fa-viacoin__1Mu6P:before{content:\"\\F237\"}.style_fa-train__1Z4yd:before{content:\"\\F238\"}.style_fa-subway__2F9i5:before{content:\"\\F239\"}.style_fa-medium__3M6ms:before{content:\"\\F23A\"}.style_fa-y-combinator__4aqOG:before,.style_fa-yc__ISZRJ:before{content:\"\\F23B\"}.style_fa-optin-monster__3bMTf:before{content:\"\\F23C\"}.style_fa-opencart__2Pd3y:before{content:\"\\F23D\"}.style_fa-expeditedssl__3lRxq:before{content:\"\\F23E\"}.style_fa-battery-4__nkX2e:before,.style_fa-battery-full__3k_LA:before,.style_fa-battery__1_1Ry:before{content:\"\\F240\"}.style_fa-battery-3__38FV_:before,.style_fa-battery-three-quarters__3_3TH:before{content:\"\\F241\"}.style_fa-battery-2__1LDMi:before,.style_fa-battery-half__3Lta2:before{content:\"\\F242\"}.style_fa-battery-1__1AjVY:before,.style_fa-battery-quarter__3KT3K:before{content:\"\\F243\"}.style_fa-battery-0__34q9q:before,.style_fa-battery-empty__NN-XE:before{content:\"\\F244\"}.style_fa-mouse-pointer__1se8l:before{content:\"\\F245\"}.style_fa-i-cursor__3-J0x:before{content:\"\\F246\"}.style_fa-object-group__8uZFN:before{content:\"\\F247\"}.style_fa-object-ungroup__3AfpG:before{content:\"\\F248\"}.style_fa-sticky-note__qC99I:before{content:\"\\F249\"}.style_fa-sticky-note-o__1shOs:before{content:\"\\F24A\"}.style_fa-cc-jcb__2JWFq:before{content:\"\\F24B\"}.style_fa-cc-diners-club__3aTNT:before{content:\"\\F24C\"}.style_fa-clone__3ICmj:before{content:\"\\F24D\"}.style_fa-balance-scale__15vCS:before{content:\"\\F24E\"}.style_fa-hourglass-o__2hHT1:before{content:\"\\F250\"}.style_fa-hourglass-1__2xFOM:before,.style_fa-hourglass-start__2oPRM:before{content:\"\\F251\"}.style_fa-hourglass-2__LMzUF:before,.style_fa-hourglass-half__8Nr-6:before{content:\"\\F252\"}.style_fa-hourglass-3__33jx-:before,.style_fa-hourglass-end__7sF5b:before{content:\"\\F253\"}.style_fa-hourglass__2hNrb:before{content:\"\\F254\"}.style_fa-hand-grab-o__1XsHN:before,.style_fa-hand-rock-o__1o7JV:before{content:\"\\F255\"}.style_fa-hand-paper-o__2D9tl:before,.style_fa-hand-stop-o__2tfzy:before{content:\"\\F256\"}.style_fa-hand-scissors-o__1RKVE:before{content:\"\\F257\"}.style_fa-hand-lizard-o__1zYpr:before{content:\"\\F258\"}.style_fa-hand-spock-o__YbrEg:before{content:\"\\F259\"}.style_fa-hand-pointer-o__1JnN-:before{content:\"\\F25A\"}.style_fa-hand-peace-o__yLVOp:before{content:\"\\F25B\"}.style_fa-trademark__3u2jI:before{content:\"\\F25C\"}.style_fa-registered__2qgyG:before{content:\"\\F25D\"}.style_fa-creative-commons__vPYgb:before{content:\"\\F25E\"}.style_fa-gg__3IYl-:before{content:\"\\F260\"}.style_fa-gg-circle__3-1rl:before{content:\"\\F261\"}.style_fa-tripadvisor__2L5A9:before{content:\"\\F262\"}.style_fa-odnoklassniki__nVekf:before{content:\"\\F263\"}.style_fa-odnoklassniki-square__16pjb:before{content:\"\\F264\"}.style_fa-get-pocket__104ns:before{content:\"\\F265\"}.style_fa-wikipedia-w__X8BYC:before{content:\"\\F266\"}.style_fa-safari__2sTvN:before{content:\"\\F267\"}.style_fa-chrome__2_0YB:before{content:\"\\F268\"}.style_fa-firefox__2CaNy:before{content:\"\\F269\"}.style_fa-opera__j5rM7:before{content:\"\\F26A\"}.style_fa-internet-explorer__322q3:before{content:\"\\F26B\"}.style_fa-television__2RVy1:before,.style_fa-tv__3YwR3:before{content:\"\\F26C\"}.style_fa-contao__23lBh:before{content:\"\\F26D\"}.style_fa-500px__17Jvu:before{content:\"\\F26E\"}.style_fa-amazon__1ymX6:before{content:\"\\F270\"}.style_fa-calendar-plus-o__3llpH:before{content:\"\\F271\"}.style_fa-calendar-minus-o__1eQIz:before{content:\"\\F272\"}.style_fa-calendar-times-o__1W9qV:before{content:\"\\F273\"}.style_fa-calendar-check-o__2qp9Q:before{content:\"\\F274\"}.style_fa-industry__32YjN:before{content:\"\\F275\"}.style_fa-map-pin__26nyt:before{content:\"\\F276\"}.style_fa-map-signs__1R7I6:before{content:\"\\F277\"}.style_fa-map-o__1B_Uf:before{content:\"\\F278\"}.style_fa-map__3Asmz:before{content:\"\\F279\"}.style_fa-commenting__2eYPk:before{content:\"\\F27A\"}.style_fa-commenting-o__1iYBT:before{content:\"\\F27B\"}.style_fa-houzz__1sfmW:before{content:\"\\F27C\"}.style_fa-vimeo__314lZ:before{content:\"\\F27D\"}.style_fa-black-tie__1Kqx8:before{content:\"\\F27E\"}.style_fa-fonticons__2zdba:before{content:\"\\F280\"}.style_fa-reddit-alien__2UPcO:before{content:\"\\F281\"}.style_fa-edge__1mSW1:before{content:\"\\F282\"}.style_fa-credit-card-alt__3UiPe:before{content:\"\\F283\"}.style_fa-codiepie__1EoyT:before{content:\"\\F284\"}.style_fa-modx__ISmGq:before{content:\"\\F285\"}.style_fa-fort-awesome__2C8ry:before{content:\"\\F286\"}.style_fa-usb__2bSi9:before{content:\"\\F287\"}.style_fa-product-hunt__WmzHD:before{content:\"\\F288\"}.style_fa-mixcloud__26EqX:before{content:\"\\F289\"}.style_fa-scribd__1nd52:before{content:\"\\F28A\"}.style_fa-pause-circle__2P49M:before{content:\"\\F28B\"}.style_fa-pause-circle-o__xcp3U:before{content:\"\\F28C\"}.style_fa-stop-circle__2rV8_:before{content:\"\\F28D\"}.style_fa-stop-circle-o__3k47o:before{content:\"\\F28E\"}.style_fa-shopping-bag__3TzmQ:before{content:\"\\F290\"}.style_fa-shopping-basket__1n0W7:before{content:\"\\F291\"}.style_fa-hashtag__1Au2Q:before{content:\"\\F292\"}.style_fa-bluetooth__f-IoV:before{content:\"\\F293\"}.style_fa-bluetooth-b__2ZV1n:before{content:\"\\F294\"}.style_fa-percent__3GeyB:before{content:\"\\F295\"}.style_fa-gitlab__2-Bar:before{content:\"\\F296\"}.style_fa-wpbeginner__2u02I:before{content:\"\\F297\"}.style_fa-wpforms__1PAVg:before{content:\"\\F298\"}.style_fa-envira__2Vlp_:before{content:\"\\F299\"}.style_fa-universal-access__1gPZ1:before{content:\"\\F29A\"}.style_fa-wheelchair-alt__PYJAx:before{content:\"\\F29B\"}.style_fa-question-circle-o__VU9cE:before{content:\"\\F29C\"}.style_fa-blind__14GsC:before{content:\"\\F29D\"}.style_fa-audio-description__193tW:before{content:\"\\F29E\"}.style_fa-volume-control-phone__1wydK:before{content:\"\\F2A0\"}.style_fa-braille__1Zz06:before{content:\"\\F2A1\"}.style_fa-assistive-listening-systems__2HSSD:before{content:\"\\F2A2\"}.style_fa-american-sign-language-interpreting__WTHMO:before,.style_fa-asl-interpreting__2_Ohd:before{content:\"\\F2A3\"}.style_fa-deaf__gNpY3:before,.style_fa-deafness__1RQ5h:before,.style_fa-hard-of-hearing__dxouv:before{content:\"\\F2A4\"}.style_fa-glide__2JkuE:before{content:\"\\F2A5\"}.style_fa-glide-g__7lw0r:before{content:\"\\F2A6\"}.style_fa-sign-language__3Kh8E:before,.style_fa-signing__1LBGN:before{content:\"\\F2A7\"}.style_fa-low-vision__3kvJs:before{content:\"\\F2A8\"}.style_fa-viadeo__VoezI:before{content:\"\\F2A9\"}.style_fa-viadeo-square__2UHUK:before{content:\"\\F2AA\"}.style_fa-snapchat__2jKmj:before{content:\"\\F2AB\"}.style_fa-snapchat-ghost__2xwud:before{content:\"\\F2AC\"}.style_fa-snapchat-square__2ay8Y:before{content:\"\\F2AD\"}.style_fa-pied-piper__1cKv9:before{content:\"\\F2AE\"}.style_fa-first-order__1aHV7:before{content:\"\\F2B0\"}.style_fa-yoast__3l7Nw:before{content:\"\\F2B1\"}.style_fa-themeisle__IVgBM:before{content:\"\\F2B2\"}.style_fa-google-plus-circle__3YTOV:before,.style_fa-google-plus-official__3j2-g:before{content:\"\\F2B3\"}.style_fa-fa__16B4w:before,.style_fa-font-awesome__a8j_I:before{content:\"\\F2B4\"}.style_fa-handshake-o__14uNQ:before{content:\"\\F2B5\"}.style_fa-envelope-open__1mSeC:before{content:\"\\F2B6\"}.style_fa-envelope-open-o__3IpGG:before{content:\"\\F2B7\"}.style_fa-linode__3MNS1:before{content:\"\\F2B8\"}.style_fa-address-book__3-Qpd:before{content:\"\\F2B9\"}.style_fa-address-book-o__aCKzG:before{content:\"\\F2BA\"}.style_fa-address-card__3k6ik:before,.style_fa-vcard__6M2eg:before{content:\"\\F2BB\"}.style_fa-address-card-o__3QTYS:before,.style_fa-vcard-o__iyiuV:before{content:\"\\F2BC\"}.style_fa-user-circle__1_cde:before{content:\"\\F2BD\"}.style_fa-user-circle-o__2YUao:before{content:\"\\F2BE\"}.style_fa-user-o__1V2Up:before{content:\"\\F2C0\"}.style_fa-id-badge__1CYVn:before{content:\"\\F2C1\"}.style_fa-drivers-license__e2Mlt:before,.style_fa-id-card__3sBIr:before{content:\"\\F2C2\"}.style_fa-drivers-license-o__QjBUI:before,.style_fa-id-card-o__24M2v:before{content:\"\\F2C3\"}.style_fa-quora__3pF-w:before{content:\"\\F2C4\"}.style_fa-free-code-camp__mJ0F4:before{content:\"\\F2C5\"}.style_fa-telegram__1SQJJ:before{content:\"\\F2C6\"}.style_fa-thermometer-4__18hgc:before,.style_fa-thermometer-full__zru6l:before,.style_fa-thermometer__2FEkA:before{content:\"\\F2C7\"}.style_fa-thermometer-3__2zo1R:before,.style_fa-thermometer-three-quarters__3rjIl:before{content:\"\\F2C8\"}.style_fa-thermometer-2__12ejr:before,.style_fa-thermometer-half__2tRDU:before{content:\"\\F2C9\"}.style_fa-thermometer-1__24a3O:before,.style_fa-thermometer-quarter__f5Fhv:before{content:\"\\F2CA\"}.style_fa-thermometer-0__3739I:before,.style_fa-thermometer-empty__1SOIG:before{content:\"\\F2CB\"}.style_fa-shower__2wAa7:before{content:\"\\F2CC\"}.style_fa-bath__aZawX:before,.style_fa-bathtub__1i6ao:before,.style_fa-s15__24ar6:before{content:\"\\F2CD\"}.style_fa-podcast__lVPTY:before{content:\"\\F2CE\"}.style_fa-window-maximize__2RO54:before{content:\"\\F2D0\"}.style_fa-window-minimize__3IN2X:before{content:\"\\F2D1\"}.style_fa-window-restore__3QFHb:before{content:\"\\F2D2\"}.style_fa-times-rectangle__BvQG5:before,.style_fa-window-close__2mrEp:before{content:\"\\F2D3\"}.style_fa-times-rectangle-o__wCN68:before,.style_fa-window-close-o__3apzx:before{content:\"\\F2D4\"}.style_fa-bandcamp__HoVp0:before{content:\"\\F2D5\"}.style_fa-grav__3c47r:before{content:\"\\F2D6\"}.style_fa-etsy__2I3s2:before{content:\"\\F2D7\"}.style_fa-imdb__vfJgy:before{content:\"\\F2D8\"}.style_fa-ravelry__1zUZZ:before{content:\"\\F2D9\"}.style_fa-eercast__3WehH:before{content:\"\\F2DA\"}.style_fa-microchip__1OQ4R:before{content:\"\\F2DB\"}.style_fa-snowflake-o__2yftS:before{content:\"\\F2DC\"}.style_fa-superpowers__3oE6q:before{content:\"\\F2DD\"}.style_fa-wpexplorer__2Fz14:before{content:\"\\F2DE\"}.style_fa-meetup__3VCYC:before{content:\"\\F2E0\"}.style_sr-only__28X0u{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.style_sr-only-focusable__3hrEM:active,.style_sr-only-focusable__3hrEM:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.style_monospace__3wtSm{font-family:Consolas,Menlo,Monaco,Courier New,monospace;line-height:1.2rem}.style_text__2pyMd{vertical-align:baseline!important;width:100%!important;min-width:0!important}.style_container__1dFxU{width:100%}.style_monospacedText__1120V{font-family:Consolas,Menlo,Monaco,Courier New,monospace!important;font-size:1rem!important}", ""]);

// exports
exports.locals = {
	"fontoctopus-octopus": "style_fontoctopus-octopus__2N8AD",
	"fontoctopusOctopus": "style_fontoctopus-octopus__2N8AD",
	"fa": "style_fa__2Stzz",
	"fa-lg": "style_fa-lg__1bG3h",
	"faLg": "style_fa-lg__1bG3h",
	"fa-2x": "style_fa-2x__2_hqT",
	"fa2X": "style_fa-2x__2_hqT",
	"fa-3x": "style_fa-3x__Stup6",
	"fa3X": "style_fa-3x__Stup6",
	"fa-4x": "style_fa-4x___nR0M",
	"fa4X": "style_fa-4x___nR0M",
	"fa-5x": "style_fa-5x__vUgdf",
	"fa5X": "style_fa-5x__vUgdf",
	"fa-fw": "style_fa-fw__1jESs",
	"faFw": "style_fa-fw__1jESs",
	"fa-ul": "style_fa-ul__22z2m",
	"faUl": "style_fa-ul__22z2m",
	"fa-li": "style_fa-li__1xMKd",
	"faLi": "style_fa-li__1xMKd",
	"fa-border": "style_fa-border__N_IDS",
	"faBorder": "style_fa-border__N_IDS",
	"fa-pull-left": "style_fa-pull-left__19hOZ",
	"faPullLeft": "style_fa-pull-left__19hOZ",
	"fa-pull-right": "style_fa-pull-right__1IGi0",
	"faPullRight": "style_fa-pull-right__1IGi0",
	"pull-right": "style_pull-right__Ekb6T",
	"pullRight": "style_pull-right__Ekb6T",
	"pull-left": "style_pull-left__6kkds",
	"pullLeft": "style_pull-left__6kkds",
	"fa-spin": "style_fa-spin__3OLtN",
	"faSpin": "style_fa-spin__3OLtN",
	"fa-pulse": "style_fa-pulse__3YIU7",
	"faPulse": "style_fa-pulse__3YIU7",
	"fa-rotate-90": "style_fa-rotate-90__V_q9A",
	"faRotate90": "style_fa-rotate-90__V_q9A",
	"fa-rotate-180": "style_fa-rotate-180__AlfVc",
	"faRotate180": "style_fa-rotate-180__AlfVc",
	"fa-rotate-270": "style_fa-rotate-270__zfwx-",
	"faRotate270": "style_fa-rotate-270__zfwx-",
	"fa-flip-horizontal": "style_fa-flip-horizontal__SlkBZ",
	"faFlipHorizontal": "style_fa-flip-horizontal__SlkBZ",
	"fa-flip-vertical": "style_fa-flip-vertical__oocW6",
	"faFlipVertical": "style_fa-flip-vertical__oocW6",
	"fa-stack": "style_fa-stack__2CYwt",
	"faStack": "style_fa-stack__2CYwt",
	"fa-stack-1x": "style_fa-stack-1x__1VBdj",
	"faStack1X": "style_fa-stack-1x__1VBdj",
	"fa-stack-2x": "style_fa-stack-2x__3ku48",
	"faStack2X": "style_fa-stack-2x__3ku48",
	"fa-inverse": "style_fa-inverse__1m291",
	"faInverse": "style_fa-inverse__1m291",
	"fa-glass": "style_fa-glass__16k7J",
	"faGlass": "style_fa-glass__16k7J",
	"fa-music": "style_fa-music__kkflz",
	"faMusic": "style_fa-music__kkflz",
	"fa-search": "style_fa-search__qCxf9",
	"faSearch": "style_fa-search__qCxf9",
	"fa-envelope-o": "style_fa-envelope-o__xXTWd",
	"faEnvelopeO": "style_fa-envelope-o__xXTWd",
	"fa-heart": "style_fa-heart__3Ug_1",
	"faHeart": "style_fa-heart__3Ug_1",
	"fa-star": "style_fa-star__3N6qV",
	"faStar": "style_fa-star__3N6qV",
	"fa-star-o": "style_fa-star-o__2CD-u",
	"faStarO": "style_fa-star-o__2CD-u",
	"fa-user": "style_fa-user__3khUP",
	"faUser": "style_fa-user__3khUP",
	"fa-film": "style_fa-film__gBI0K",
	"faFilm": "style_fa-film__gBI0K",
	"fa-th-large": "style_fa-th-large__2fszA",
	"faThLarge": "style_fa-th-large__2fszA",
	"fa-th": "style_fa-th__2awmn",
	"faTh": "style_fa-th__2awmn",
	"fa-th-list": "style_fa-th-list__2FtcN",
	"faThList": "style_fa-th-list__2FtcN",
	"fa-check": "style_fa-check__3AIyn",
	"faCheck": "style_fa-check__3AIyn",
	"fa-remove": "style_fa-remove__3cnS0",
	"faRemove": "style_fa-remove__3cnS0",
	"fa-close": "style_fa-close__1knvb",
	"faClose": "style_fa-close__1knvb",
	"fa-times": "style_fa-times__3yoPt",
	"faTimes": "style_fa-times__3yoPt",
	"fa-search-plus": "style_fa-search-plus__33Lij",
	"faSearchPlus": "style_fa-search-plus__33Lij",
	"fa-search-minus": "style_fa-search-minus__2yHac",
	"faSearchMinus": "style_fa-search-minus__2yHac",
	"fa-power-off": "style_fa-power-off__3QfoZ",
	"faPowerOff": "style_fa-power-off__3QfoZ",
	"fa-signal": "style_fa-signal__2LNOs",
	"faSignal": "style_fa-signal__2LNOs",
	"fa-gear": "style_fa-gear__1aqXg",
	"faGear": "style_fa-gear__1aqXg",
	"fa-cog": "style_fa-cog__2S0eu",
	"faCog": "style_fa-cog__2S0eu",
	"fa-trash-o": "style_fa-trash-o__Jy4Qd",
	"faTrashO": "style_fa-trash-o__Jy4Qd",
	"fa-home": "style_fa-home__2aA7l",
	"faHome": "style_fa-home__2aA7l",
	"fa-file-o": "style_fa-file-o__2XOwD",
	"faFileO": "style_fa-file-o__2XOwD",
	"fa-clock-o": "style_fa-clock-o__2WKaF",
	"faClockO": "style_fa-clock-o__2WKaF",
	"fa-road": "style_fa-road__2emGR",
	"faRoad": "style_fa-road__2emGR",
	"fa-download": "style_fa-download__2Jf5l",
	"faDownload": "style_fa-download__2Jf5l",
	"fa-arrow-circle-o-down": "style_fa-arrow-circle-o-down__1zZ7Q",
	"faArrowCircleODown": "style_fa-arrow-circle-o-down__1zZ7Q",
	"fa-arrow-circle-o-up": "style_fa-arrow-circle-o-up__KMZ50",
	"faArrowCircleOUp": "style_fa-arrow-circle-o-up__KMZ50",
	"fa-inbox": "style_fa-inbox__3BPi6",
	"faInbox": "style_fa-inbox__3BPi6",
	"fa-play-circle-o": "style_fa-play-circle-o__1PlJd",
	"faPlayCircleO": "style_fa-play-circle-o__1PlJd",
	"fa-rotate-right": "style_fa-rotate-right__1U5RB",
	"faRotateRight": "style_fa-rotate-right__1U5RB",
	"fa-repeat": "style_fa-repeat__2EtMa",
	"faRepeat": "style_fa-repeat__2EtMa",
	"fa-refresh": "style_fa-refresh__1BjiR",
	"faRefresh": "style_fa-refresh__1BjiR",
	"fa-list-alt": "style_fa-list-alt__2UUVE",
	"faListAlt": "style_fa-list-alt__2UUVE",
	"fa-lock": "style_fa-lock__2AxqE",
	"faLock": "style_fa-lock__2AxqE",
	"fa-flag": "style_fa-flag__1u53R",
	"faFlag": "style_fa-flag__1u53R",
	"fa-headphones": "style_fa-headphones__3Yhkq",
	"faHeadphones": "style_fa-headphones__3Yhkq",
	"fa-volume-off": "style_fa-volume-off__3LfY-",
	"faVolumeOff": "style_fa-volume-off__3LfY-",
	"fa-volume-down": "style_fa-volume-down__1JuvK",
	"faVolumeDown": "style_fa-volume-down__1JuvK",
	"fa-volume-up": "style_fa-volume-up__3rdlp",
	"faVolumeUp": "style_fa-volume-up__3rdlp",
	"fa-qrcode": "style_fa-qrcode__2UZke",
	"faQrcode": "style_fa-qrcode__2UZke",
	"fa-barcode": "style_fa-barcode__3NqNI",
	"faBarcode": "style_fa-barcode__3NqNI",
	"fa-tag": "style_fa-tag__2O9hk",
	"faTag": "style_fa-tag__2O9hk",
	"fa-tags": "style_fa-tags__-8Rh_",
	"faTags": "style_fa-tags__-8Rh_",
	"fa-book": "style_fa-book__3Nk-f",
	"faBook": "style_fa-book__3Nk-f",
	"fa-bookmark": "style_fa-bookmark__3qaOT",
	"faBookmark": "style_fa-bookmark__3qaOT",
	"fa-print": "style_fa-print__YyG1f",
	"faPrint": "style_fa-print__YyG1f",
	"fa-camera": "style_fa-camera__aUjmZ",
	"faCamera": "style_fa-camera__aUjmZ",
	"fa-font": "style_fa-font__gGxlk",
	"faFont": "style_fa-font__gGxlk",
	"fa-bold": "style_fa-bold__ks_J4",
	"faBold": "style_fa-bold__ks_J4",
	"fa-italic": "style_fa-italic__20ogU",
	"faItalic": "style_fa-italic__20ogU",
	"fa-text-height": "style_fa-text-height___0LQ7",
	"faTextHeight": "style_fa-text-height___0LQ7",
	"fa-text-width": "style_fa-text-width__jeOjf",
	"faTextWidth": "style_fa-text-width__jeOjf",
	"fa-align-left": "style_fa-align-left__22Zw8",
	"faAlignLeft": "style_fa-align-left__22Zw8",
	"fa-align-center": "style_fa-align-center__3Iq_1",
	"faAlignCenter": "style_fa-align-center__3Iq_1",
	"fa-align-right": "style_fa-align-right__Eka7e",
	"faAlignRight": "style_fa-align-right__Eka7e",
	"fa-align-justify": "style_fa-align-justify__pARZF",
	"faAlignJustify": "style_fa-align-justify__pARZF",
	"fa-list": "style_fa-list__1OD3U",
	"faList": "style_fa-list__1OD3U",
	"fa-dedent": "style_fa-dedent__YI-PY",
	"faDedent": "style_fa-dedent__YI-PY",
	"fa-outdent": "style_fa-outdent__Q3A49",
	"faOutdent": "style_fa-outdent__Q3A49",
	"fa-indent": "style_fa-indent__1jwPG",
	"faIndent": "style_fa-indent__1jwPG",
	"fa-video-camera": "style_fa-video-camera__3zM_P",
	"faVideoCamera": "style_fa-video-camera__3zM_P",
	"fa-photo": "style_fa-photo__12fAw",
	"faPhoto": "style_fa-photo__12fAw",
	"fa-image": "style_fa-image__1Zij8",
	"faImage": "style_fa-image__1Zij8",
	"fa-picture-o": "style_fa-picture-o__2kh9I",
	"faPictureO": "style_fa-picture-o__2kh9I",
	"fa-pencil": "style_fa-pencil__SPg_-",
	"faPencil": "style_fa-pencil__SPg_-",
	"fa-map-marker": "style_fa-map-marker__2B57R",
	"faMapMarker": "style_fa-map-marker__2B57R",
	"fa-adjust": "style_fa-adjust__22duV",
	"faAdjust": "style_fa-adjust__22duV",
	"fa-tint": "style_fa-tint__2hInd",
	"faTint": "style_fa-tint__2hInd",
	"fa-edit": "style_fa-edit__2hUlG",
	"faEdit": "style_fa-edit__2hUlG",
	"fa-pencil-square-o": "style_fa-pencil-square-o__E9ibP",
	"faPencilSquareO": "style_fa-pencil-square-o__E9ibP",
	"fa-share-square-o": "style_fa-share-square-o__2RDHE",
	"faShareSquareO": "style_fa-share-square-o__2RDHE",
	"fa-check-square-o": "style_fa-check-square-o__2K-Dz",
	"faCheckSquareO": "style_fa-check-square-o__2K-Dz",
	"fa-arrows": "style_fa-arrows__35WFl",
	"faArrows": "style_fa-arrows__35WFl",
	"fa-step-backward": "style_fa-step-backward__1CcyE",
	"faStepBackward": "style_fa-step-backward__1CcyE",
	"fa-fast-backward": "style_fa-fast-backward__1Blqo",
	"faFastBackward": "style_fa-fast-backward__1Blqo",
	"fa-backward": "style_fa-backward__3e-fg",
	"faBackward": "style_fa-backward__3e-fg",
	"fa-play": "style_fa-play__ETJ_t",
	"faPlay": "style_fa-play__ETJ_t",
	"fa-pause": "style_fa-pause__3ro_2",
	"faPause": "style_fa-pause__3ro_2",
	"fa-stop": "style_fa-stop__3ZrVE",
	"faStop": "style_fa-stop__3ZrVE",
	"fa-forward": "style_fa-forward__38fYD",
	"faForward": "style_fa-forward__38fYD",
	"fa-fast-forward": "style_fa-fast-forward__12ERo",
	"faFastForward": "style_fa-fast-forward__12ERo",
	"fa-step-forward": "style_fa-step-forward__1HhqA",
	"faStepForward": "style_fa-step-forward__1HhqA",
	"fa-eject": "style_fa-eject__3iYgQ",
	"faEject": "style_fa-eject__3iYgQ",
	"fa-chevron-left": "style_fa-chevron-left__3n6Ih",
	"faChevronLeft": "style_fa-chevron-left__3n6Ih",
	"fa-chevron-right": "style_fa-chevron-right__17qWa",
	"faChevronRight": "style_fa-chevron-right__17qWa",
	"fa-plus-circle": "style_fa-plus-circle__1_Hd6",
	"faPlusCircle": "style_fa-plus-circle__1_Hd6",
	"fa-minus-circle": "style_fa-minus-circle__2lFkp",
	"faMinusCircle": "style_fa-minus-circle__2lFkp",
	"fa-times-circle": "style_fa-times-circle__3sN8j",
	"faTimesCircle": "style_fa-times-circle__3sN8j",
	"fa-check-circle": "style_fa-check-circle__2wkS0",
	"faCheckCircle": "style_fa-check-circle__2wkS0",
	"fa-question-circle": "style_fa-question-circle__2fk1Y",
	"faQuestionCircle": "style_fa-question-circle__2fk1Y",
	"fa-info-circle": "style_fa-info-circle__2gaYm",
	"faInfoCircle": "style_fa-info-circle__2gaYm",
	"fa-crosshairs": "style_fa-crosshairs__1LEU-",
	"faCrosshairs": "style_fa-crosshairs__1LEU-",
	"fa-times-circle-o": "style_fa-times-circle-o__2TSHm",
	"faTimesCircleO": "style_fa-times-circle-o__2TSHm",
	"fa-check-circle-o": "style_fa-check-circle-o__3WaoE",
	"faCheckCircleO": "style_fa-check-circle-o__3WaoE",
	"fa-ban": "style_fa-ban__2Qhpz",
	"faBan": "style_fa-ban__2Qhpz",
	"fa-arrow-left": "style_fa-arrow-left__1Tt32",
	"faArrowLeft": "style_fa-arrow-left__1Tt32",
	"fa-arrow-right": "style_fa-arrow-right__1FESc",
	"faArrowRight": "style_fa-arrow-right__1FESc",
	"fa-arrow-up": "style_fa-arrow-up__3wcyR",
	"faArrowUp": "style_fa-arrow-up__3wcyR",
	"fa-arrow-down": "style_fa-arrow-down__3Mskv",
	"faArrowDown": "style_fa-arrow-down__3Mskv",
	"fa-mail-forward": "style_fa-mail-forward__2NDhk",
	"faMailForward": "style_fa-mail-forward__2NDhk",
	"fa-share": "style_fa-share__3l_NS",
	"faShare": "style_fa-share__3l_NS",
	"fa-expand": "style_fa-expand__3GAJ3",
	"faExpand": "style_fa-expand__3GAJ3",
	"fa-compress": "style_fa-compress__2wbOP",
	"faCompress": "style_fa-compress__2wbOP",
	"fa-plus": "style_fa-plus__22pw4",
	"faPlus": "style_fa-plus__22pw4",
	"fa-minus": "style_fa-minus__poN8Q",
	"faMinus": "style_fa-minus__poN8Q",
	"fa-asterisk": "style_fa-asterisk__33jbA",
	"faAsterisk": "style_fa-asterisk__33jbA",
	"fa-exclamation-circle": "style_fa-exclamation-circle__1xJgn",
	"faExclamationCircle": "style_fa-exclamation-circle__1xJgn",
	"fa-gift": "style_fa-gift__3nKN8",
	"faGift": "style_fa-gift__3nKN8",
	"fa-leaf": "style_fa-leaf__FnNeM",
	"faLeaf": "style_fa-leaf__FnNeM",
	"fa-fire": "style_fa-fire__iabFV",
	"faFire": "style_fa-fire__iabFV",
	"fa-eye": "style_fa-eye__zJEkG",
	"faEye": "style_fa-eye__zJEkG",
	"fa-eye-slash": "style_fa-eye-slash__2bjSj",
	"faEyeSlash": "style_fa-eye-slash__2bjSj",
	"fa-warning": "style_fa-warning__3f1BB",
	"faWarning": "style_fa-warning__3f1BB",
	"fa-exclamation-triangle": "style_fa-exclamation-triangle__1FI1o",
	"faExclamationTriangle": "style_fa-exclamation-triangle__1FI1o",
	"fa-plane": "style_fa-plane__r9HNn",
	"faPlane": "style_fa-plane__r9HNn",
	"fa-calendar": "style_fa-calendar__1lGhc",
	"faCalendar": "style_fa-calendar__1lGhc",
	"fa-random": "style_fa-random__3oSfN",
	"faRandom": "style_fa-random__3oSfN",
	"fa-comment": "style_fa-comment__1XcXN",
	"faComment": "style_fa-comment__1XcXN",
	"fa-magnet": "style_fa-magnet__3Ra7v",
	"faMagnet": "style_fa-magnet__3Ra7v",
	"fa-chevron-up": "style_fa-chevron-up__1IJay",
	"faChevronUp": "style_fa-chevron-up__1IJay",
	"fa-chevron-down": "style_fa-chevron-down__3VgR7",
	"faChevronDown": "style_fa-chevron-down__3VgR7",
	"fa-retweet": "style_fa-retweet__3bBmk",
	"faRetweet": "style_fa-retweet__3bBmk",
	"fa-shopping-cart": "style_fa-shopping-cart__wsIiy",
	"faShoppingCart": "style_fa-shopping-cart__wsIiy",
	"fa-folder": "style_fa-folder__3pZY8",
	"faFolder": "style_fa-folder__3pZY8",
	"fa-folder-open": "style_fa-folder-open__2e7-y",
	"faFolderOpen": "style_fa-folder-open__2e7-y",
	"fa-arrows-v": "style_fa-arrows-v__3lYN9",
	"faArrowsV": "style_fa-arrows-v__3lYN9",
	"fa-arrows-h": "style_fa-arrows-h__2AKrb",
	"faArrowsH": "style_fa-arrows-h__2AKrb",
	"fa-bar-chart-o": "style_fa-bar-chart-o__1N0Fi",
	"faBarChartO": "style_fa-bar-chart-o__1N0Fi",
	"fa-bar-chart": "style_fa-bar-chart__2GC9g",
	"faBarChart": "style_fa-bar-chart__2GC9g",
	"fa-twitter-square": "style_fa-twitter-square__25459",
	"faTwitterSquare": "style_fa-twitter-square__25459",
	"fa-facebook-square": "style_fa-facebook-square__34MaH",
	"faFacebookSquare": "style_fa-facebook-square__34MaH",
	"fa-camera-retro": "style_fa-camera-retro__3UpEF",
	"faCameraRetro": "style_fa-camera-retro__3UpEF",
	"fa-key": "style_fa-key__PomoZ",
	"faKey": "style_fa-key__PomoZ",
	"fa-gears": "style_fa-gears__3bHU8",
	"faGears": "style_fa-gears__3bHU8",
	"fa-cogs": "style_fa-cogs__2mWvc",
	"faCogs": "style_fa-cogs__2mWvc",
	"fa-comments": "style_fa-comments__1TsY2",
	"faComments": "style_fa-comments__1TsY2",
	"fa-thumbs-o-up": "style_fa-thumbs-o-up__CdiXO",
	"faThumbsOUp": "style_fa-thumbs-o-up__CdiXO",
	"fa-thumbs-o-down": "style_fa-thumbs-o-down__z4NN5",
	"faThumbsODown": "style_fa-thumbs-o-down__z4NN5",
	"fa-star-half": "style_fa-star-half__Iest8",
	"faStarHalf": "style_fa-star-half__Iest8",
	"fa-heart-o": "style_fa-heart-o__2m_lH",
	"faHeartO": "style_fa-heart-o__2m_lH",
	"fa-sign-out": "style_fa-sign-out__1lcQa",
	"faSignOut": "style_fa-sign-out__1lcQa",
	"fa-linkedin-square": "style_fa-linkedin-square__3kZOS",
	"faLinkedinSquare": "style_fa-linkedin-square__3kZOS",
	"fa-thumb-tack": "style_fa-thumb-tack__1o_WC",
	"faThumbTack": "style_fa-thumb-tack__1o_WC",
	"fa-external-link": "style_fa-external-link__1PHHE",
	"faExternalLink": "style_fa-external-link__1PHHE",
	"fa-sign-in": "style_fa-sign-in__1qcVV",
	"faSignIn": "style_fa-sign-in__1qcVV",
	"fa-trophy": "style_fa-trophy__3_XYL",
	"faTrophy": "style_fa-trophy__3_XYL",
	"fa-github-square": "style_fa-github-square__2Ylwu",
	"faGithubSquare": "style_fa-github-square__2Ylwu",
	"fa-upload": "style_fa-upload__1fS8f",
	"faUpload": "style_fa-upload__1fS8f",
	"fa-lemon-o": "style_fa-lemon-o__2eZyK",
	"faLemonO": "style_fa-lemon-o__2eZyK",
	"fa-phone": "style_fa-phone__3YoRI",
	"faPhone": "style_fa-phone__3YoRI",
	"fa-square-o": "style_fa-square-o__1N8kv",
	"faSquareO": "style_fa-square-o__1N8kv",
	"fa-bookmark-o": "style_fa-bookmark-o__jfvFO",
	"faBookmarkO": "style_fa-bookmark-o__jfvFO",
	"fa-phone-square": "style_fa-phone-square__3ZRc_",
	"faPhoneSquare": "style_fa-phone-square__3ZRc_",
	"fa-twitter": "style_fa-twitter__2yG2o",
	"faTwitter": "style_fa-twitter__2yG2o",
	"fa-facebook-f": "style_fa-facebook-f__2lRUc",
	"faFacebookF": "style_fa-facebook-f__2lRUc",
	"fa-facebook": "style_fa-facebook__32LSL",
	"faFacebook": "style_fa-facebook__32LSL",
	"fa-github": "style_fa-github__2Ke1H",
	"faGithub": "style_fa-github__2Ke1H",
	"fa-unlock": "style_fa-unlock__3LTVN",
	"faUnlock": "style_fa-unlock__3LTVN",
	"fa-credit-card": "style_fa-credit-card__17tW0",
	"faCreditCard": "style_fa-credit-card__17tW0",
	"fa-feed": "style_fa-feed__2gj0C",
	"faFeed": "style_fa-feed__2gj0C",
	"fa-rss": "style_fa-rss__2TJ7S",
	"faRss": "style_fa-rss__2TJ7S",
	"fa-hdd-o": "style_fa-hdd-o__3p7M9",
	"faHddO": "style_fa-hdd-o__3p7M9",
	"fa-bullhorn": "style_fa-bullhorn__2nBQr",
	"faBullhorn": "style_fa-bullhorn__2nBQr",
	"fa-bell": "style_fa-bell__xhSCD",
	"faBell": "style_fa-bell__xhSCD",
	"fa-certificate": "style_fa-certificate__1UjXn",
	"faCertificate": "style_fa-certificate__1UjXn",
	"fa-hand-o-right": "style_fa-hand-o-right__170tV",
	"faHandORight": "style_fa-hand-o-right__170tV",
	"fa-hand-o-left": "style_fa-hand-o-left__1bZCj",
	"faHandOLeft": "style_fa-hand-o-left__1bZCj",
	"fa-hand-o-up": "style_fa-hand-o-up__FOPJs",
	"faHandOUp": "style_fa-hand-o-up__FOPJs",
	"fa-hand-o-down": "style_fa-hand-o-down__3EtW7",
	"faHandODown": "style_fa-hand-o-down__3EtW7",
	"fa-arrow-circle-left": "style_fa-arrow-circle-left__4Si1c",
	"faArrowCircleLeft": "style_fa-arrow-circle-left__4Si1c",
	"fa-arrow-circle-right": "style_fa-arrow-circle-right__o2B_F",
	"faArrowCircleRight": "style_fa-arrow-circle-right__o2B_F",
	"fa-arrow-circle-up": "style_fa-arrow-circle-up__1t6C_",
	"faArrowCircleUp": "style_fa-arrow-circle-up__1t6C_",
	"fa-arrow-circle-down": "style_fa-arrow-circle-down__2JhhB",
	"faArrowCircleDown": "style_fa-arrow-circle-down__2JhhB",
	"fa-globe": "style_fa-globe__25Cen",
	"faGlobe": "style_fa-globe__25Cen",
	"fa-wrench": "style_fa-wrench__258HL",
	"faWrench": "style_fa-wrench__258HL",
	"fa-tasks": "style_fa-tasks__2oxZT",
	"faTasks": "style_fa-tasks__2oxZT",
	"fa-filter": "style_fa-filter__3HM1H",
	"faFilter": "style_fa-filter__3HM1H",
	"fa-briefcase": "style_fa-briefcase__2JNBT",
	"faBriefcase": "style_fa-briefcase__2JNBT",
	"fa-arrows-alt": "style_fa-arrows-alt__1sD0o",
	"faArrowsAlt": "style_fa-arrows-alt__1sD0o",
	"fa-group": "style_fa-group__20X3W",
	"faGroup": "style_fa-group__20X3W",
	"fa-users": "style_fa-users__1Wv4i",
	"faUsers": "style_fa-users__1Wv4i",
	"fa-chain": "style_fa-chain__3gkVR",
	"faChain": "style_fa-chain__3gkVR",
	"fa-link": "style_fa-link__15zB7",
	"faLink": "style_fa-link__15zB7",
	"fa-cloud": "style_fa-cloud__1Ddfl",
	"faCloud": "style_fa-cloud__1Ddfl",
	"fa-flask": "style_fa-flask__1wJvc",
	"faFlask": "style_fa-flask__1wJvc",
	"fa-cut": "style_fa-cut___XyZV",
	"faCut": "style_fa-cut___XyZV",
	"fa-scissors": "style_fa-scissors__AYHcI",
	"faScissors": "style_fa-scissors__AYHcI",
	"fa-copy": "style_fa-copy__1Ossh",
	"faCopy": "style_fa-copy__1Ossh",
	"fa-files-o": "style_fa-files-o__3sJJ-",
	"faFilesO": "style_fa-files-o__3sJJ-",
	"fa-paperclip": "style_fa-paperclip__1hTCr",
	"faPaperclip": "style_fa-paperclip__1hTCr",
	"fa-save": "style_fa-save__1LOCv",
	"faSave": "style_fa-save__1LOCv",
	"fa-floppy-o": "style_fa-floppy-o__2TnBm",
	"faFloppyO": "style_fa-floppy-o__2TnBm",
	"fa-square": "style_fa-square__28Zx1",
	"faSquare": "style_fa-square__28Zx1",
	"fa-navicon": "style_fa-navicon__1X1U8",
	"faNavicon": "style_fa-navicon__1X1U8",
	"fa-reorder": "style_fa-reorder__18Czt",
	"faReorder": "style_fa-reorder__18Czt",
	"fa-bars": "style_fa-bars__Wlajt",
	"faBars": "style_fa-bars__Wlajt",
	"fa-list-ul": "style_fa-list-ul__2D7G5",
	"faListUl": "style_fa-list-ul__2D7G5",
	"fa-list-ol": "style_fa-list-ol__C0x7T",
	"faListOl": "style_fa-list-ol__C0x7T",
	"fa-strikethrough": "style_fa-strikethrough__3t6ML",
	"faStrikethrough": "style_fa-strikethrough__3t6ML",
	"fa-underline": "style_fa-underline__1SFb4",
	"faUnderline": "style_fa-underline__1SFb4",
	"fa-table": "style_fa-table__19Se0",
	"faTable": "style_fa-table__19Se0",
	"fa-magic": "style_fa-magic___i3Nz",
	"faMagic": "style_fa-magic___i3Nz",
	"fa-truck": "style_fa-truck__ZtSgC",
	"faTruck": "style_fa-truck__ZtSgC",
	"fa-pinterest": "style_fa-pinterest__22id1",
	"faPinterest": "style_fa-pinterest__22id1",
	"fa-pinterest-square": "style_fa-pinterest-square__369gS",
	"faPinterestSquare": "style_fa-pinterest-square__369gS",
	"fa-google-plus-square": "style_fa-google-plus-square__hBjwt",
	"faGooglePlusSquare": "style_fa-google-plus-square__hBjwt",
	"fa-google-plus": "style_fa-google-plus__3y50_",
	"faGooglePlus": "style_fa-google-plus__3y50_",
	"fa-money": "style_fa-money__1Qjqs",
	"faMoney": "style_fa-money__1Qjqs",
	"fa-caret-down": "style_fa-caret-down__2x_8t",
	"faCaretDown": "style_fa-caret-down__2x_8t",
	"fa-caret-up": "style_fa-caret-up__26GUW",
	"faCaretUp": "style_fa-caret-up__26GUW",
	"fa-caret-left": "style_fa-caret-left__irqU0",
	"faCaretLeft": "style_fa-caret-left__irqU0",
	"fa-caret-right": "style_fa-caret-right__P8lmz",
	"faCaretRight": "style_fa-caret-right__P8lmz",
	"fa-columns": "style_fa-columns__2tlq9",
	"faColumns": "style_fa-columns__2tlq9",
	"fa-unsorted": "style_fa-unsorted__1Kqx5",
	"faUnsorted": "style_fa-unsorted__1Kqx5",
	"fa-sort": "style_fa-sort__OJrdh",
	"faSort": "style_fa-sort__OJrdh",
	"fa-sort-down": "style_fa-sort-down__1Ru3s",
	"faSortDown": "style_fa-sort-down__1Ru3s",
	"fa-sort-desc": "style_fa-sort-desc__2XfG6",
	"faSortDesc": "style_fa-sort-desc__2XfG6",
	"fa-sort-up": "style_fa-sort-up__24qNy",
	"faSortUp": "style_fa-sort-up__24qNy",
	"fa-sort-asc": "style_fa-sort-asc__U5a_d",
	"faSortAsc": "style_fa-sort-asc__U5a_d",
	"fa-envelope": "style_fa-envelope__1AvyZ",
	"faEnvelope": "style_fa-envelope__1AvyZ",
	"fa-linkedin": "style_fa-linkedin__reVK3",
	"faLinkedin": "style_fa-linkedin__reVK3",
	"fa-rotate-left": "style_fa-rotate-left__1KZgM",
	"faRotateLeft": "style_fa-rotate-left__1KZgM",
	"fa-undo": "style_fa-undo__3TtfA",
	"faUndo": "style_fa-undo__3TtfA",
	"fa-legal": "style_fa-legal__3kLMa",
	"faLegal": "style_fa-legal__3kLMa",
	"fa-gavel": "style_fa-gavel__6RQAi",
	"faGavel": "style_fa-gavel__6RQAi",
	"fa-dashboard": "style_fa-dashboard__2DuDP",
	"faDashboard": "style_fa-dashboard__2DuDP",
	"fa-tachometer": "style_fa-tachometer__1cwGN",
	"faTachometer": "style_fa-tachometer__1cwGN",
	"fa-comment-o": "style_fa-comment-o__1JPzx",
	"faCommentO": "style_fa-comment-o__1JPzx",
	"fa-comments-o": "style_fa-comments-o__1bL7J",
	"faCommentsO": "style_fa-comments-o__1bL7J",
	"fa-flash": "style_fa-flash__3nAJC",
	"faFlash": "style_fa-flash__3nAJC",
	"fa-bolt": "style_fa-bolt__2jVjr",
	"faBolt": "style_fa-bolt__2jVjr",
	"fa-sitemap": "style_fa-sitemap__3DNmq",
	"faSitemap": "style_fa-sitemap__3DNmq",
	"fa-umbrella": "style_fa-umbrella__O7zIG",
	"faUmbrella": "style_fa-umbrella__O7zIG",
	"fa-paste": "style_fa-paste__1DC1m",
	"faPaste": "style_fa-paste__1DC1m",
	"fa-clipboard": "style_fa-clipboard__1gVaK",
	"faClipboard": "style_fa-clipboard__1gVaK",
	"fa-lightbulb-o": "style_fa-lightbulb-o__rfE_N",
	"faLightbulbO": "style_fa-lightbulb-o__rfE_N",
	"fa-exchange": "style_fa-exchange__32Bx_",
	"faExchange": "style_fa-exchange__32Bx_",
	"fa-cloud-download": "style_fa-cloud-download__3HJaV",
	"faCloudDownload": "style_fa-cloud-download__3HJaV",
	"fa-cloud-upload": "style_fa-cloud-upload__2mTgC",
	"faCloudUpload": "style_fa-cloud-upload__2mTgC",
	"fa-user-md": "style_fa-user-md__2an77",
	"faUserMd": "style_fa-user-md__2an77",
	"fa-stethoscope": "style_fa-stethoscope__1Vpz0",
	"faStethoscope": "style_fa-stethoscope__1Vpz0",
	"fa-suitcase": "style_fa-suitcase__3CTJq",
	"faSuitcase": "style_fa-suitcase__3CTJq",
	"fa-bell-o": "style_fa-bell-o__zcNr6",
	"faBellO": "style_fa-bell-o__zcNr6",
	"fa-coffee": "style_fa-coffee__2sCU6",
	"faCoffee": "style_fa-coffee__2sCU6",
	"fa-cutlery": "style_fa-cutlery__3Ya5Y",
	"faCutlery": "style_fa-cutlery__3Ya5Y",
	"fa-file-text-o": "style_fa-file-text-o__20xzO",
	"faFileTextO": "style_fa-file-text-o__20xzO",
	"fa-building-o": "style_fa-building-o__2YAYY",
	"faBuildingO": "style_fa-building-o__2YAYY",
	"fa-hospital-o": "style_fa-hospital-o__2nAdh",
	"faHospitalO": "style_fa-hospital-o__2nAdh",
	"fa-ambulance": "style_fa-ambulance__367f4",
	"faAmbulance": "style_fa-ambulance__367f4",
	"fa-medkit": "style_fa-medkit__2umfr",
	"faMedkit": "style_fa-medkit__2umfr",
	"fa-fighter-jet": "style_fa-fighter-jet__1XQZm",
	"faFighterJet": "style_fa-fighter-jet__1XQZm",
	"fa-beer": "style_fa-beer__3F4Fo",
	"faBeer": "style_fa-beer__3F4Fo",
	"fa-h-square": "style_fa-h-square__3UZBQ",
	"faHSquare": "style_fa-h-square__3UZBQ",
	"fa-plus-square": "style_fa-plus-square__2pCA8",
	"faPlusSquare": "style_fa-plus-square__2pCA8",
	"fa-angle-double-left": "style_fa-angle-double-left__34cFJ",
	"faAngleDoubleLeft": "style_fa-angle-double-left__34cFJ",
	"fa-angle-double-right": "style_fa-angle-double-right__sfWlQ",
	"faAngleDoubleRight": "style_fa-angle-double-right__sfWlQ",
	"fa-angle-double-up": "style_fa-angle-double-up__XjAIq",
	"faAngleDoubleUp": "style_fa-angle-double-up__XjAIq",
	"fa-angle-double-down": "style_fa-angle-double-down__2eg81",
	"faAngleDoubleDown": "style_fa-angle-double-down__2eg81",
	"fa-angle-left": "style_fa-angle-left__DUgjE",
	"faAngleLeft": "style_fa-angle-left__DUgjE",
	"fa-angle-right": "style_fa-angle-right__3V_P0",
	"faAngleRight": "style_fa-angle-right__3V_P0",
	"fa-angle-up": "style_fa-angle-up__2csFP",
	"faAngleUp": "style_fa-angle-up__2csFP",
	"fa-angle-down": "style_fa-angle-down__1gNw4",
	"faAngleDown": "style_fa-angle-down__1gNw4",
	"fa-desktop": "style_fa-desktop__2xX4m",
	"faDesktop": "style_fa-desktop__2xX4m",
	"fa-laptop": "style_fa-laptop__3MT5H",
	"faLaptop": "style_fa-laptop__3MT5H",
	"fa-tablet": "style_fa-tablet__1JL66",
	"faTablet": "style_fa-tablet__1JL66",
	"fa-mobile-phone": "style_fa-mobile-phone__32S3m",
	"faMobilePhone": "style_fa-mobile-phone__32S3m",
	"fa-mobile": "style_fa-mobile__1pbSy",
	"faMobile": "style_fa-mobile__1pbSy",
	"fa-circle-o": "style_fa-circle-o__1Yyd-",
	"faCircleO": "style_fa-circle-o__1Yyd-",
	"fa-quote-left": "style_fa-quote-left__DjQVx",
	"faQuoteLeft": "style_fa-quote-left__DjQVx",
	"fa-quote-right": "style_fa-quote-right__1mvs9",
	"faQuoteRight": "style_fa-quote-right__1mvs9",
	"fa-spinner": "style_fa-spinner__3HVZk",
	"faSpinner": "style_fa-spinner__3HVZk",
	"fa-circle": "style_fa-circle__2snKq",
	"faCircle": "style_fa-circle__2snKq",
	"fa-mail-reply": "style_fa-mail-reply__2AC6z",
	"faMailReply": "style_fa-mail-reply__2AC6z",
	"fa-reply": "style_fa-reply__3G6Se",
	"faReply": "style_fa-reply__3G6Se",
	"fa-github-alt": "style_fa-github-alt__x_v-T",
	"faGithubAlt": "style_fa-github-alt__x_v-T",
	"fa-folder-o": "style_fa-folder-o__2VA-0",
	"faFolderO": "style_fa-folder-o__2VA-0",
	"fa-folder-open-o": "style_fa-folder-open-o__3RqaW",
	"faFolderOpenO": "style_fa-folder-open-o__3RqaW",
	"fa-smile-o": "style_fa-smile-o__3KiYu",
	"faSmileO": "style_fa-smile-o__3KiYu",
	"fa-frown-o": "style_fa-frown-o__3H7-N",
	"faFrownO": "style_fa-frown-o__3H7-N",
	"fa-meh-o": "style_fa-meh-o__3-bgG",
	"faMehO": "style_fa-meh-o__3-bgG",
	"fa-gamepad": "style_fa-gamepad__mPyU7",
	"faGamepad": "style_fa-gamepad__mPyU7",
	"fa-keyboard-o": "style_fa-keyboard-o__wAOHk",
	"faKeyboardO": "style_fa-keyboard-o__wAOHk",
	"fa-flag-o": "style_fa-flag-o__321XR",
	"faFlagO": "style_fa-flag-o__321XR",
	"fa-flag-checkered": "style_fa-flag-checkered__2VtGO",
	"faFlagCheckered": "style_fa-flag-checkered__2VtGO",
	"fa-terminal": "style_fa-terminal__1fUHJ",
	"faTerminal": "style_fa-terminal__1fUHJ",
	"fa-code": "style_fa-code__SRKGP",
	"faCode": "style_fa-code__SRKGP",
	"fa-mail-reply-all": "style_fa-mail-reply-all__Lz9Ih",
	"faMailReplyAll": "style_fa-mail-reply-all__Lz9Ih",
	"fa-reply-all": "style_fa-reply-all__1t63J",
	"faReplyAll": "style_fa-reply-all__1t63J",
	"fa-star-half-empty": "style_fa-star-half-empty__19XZq",
	"faStarHalfEmpty": "style_fa-star-half-empty__19XZq",
	"fa-star-half-full": "style_fa-star-half-full__3Y45l",
	"faStarHalfFull": "style_fa-star-half-full__3Y45l",
	"fa-star-half-o": "style_fa-star-half-o__a-5to",
	"faStarHalfO": "style_fa-star-half-o__a-5to",
	"fa-location-arrow": "style_fa-location-arrow__2qgJ1",
	"faLocationArrow": "style_fa-location-arrow__2qgJ1",
	"fa-crop": "style_fa-crop__2OK7-",
	"faCrop": "style_fa-crop__2OK7-",
	"fa-code-fork": "style_fa-code-fork__1WC5P",
	"faCodeFork": "style_fa-code-fork__1WC5P",
	"fa-unlink": "style_fa-unlink__2vPUr",
	"faUnlink": "style_fa-unlink__2vPUr",
	"fa-chain-broken": "style_fa-chain-broken__UtNIl",
	"faChainBroken": "style_fa-chain-broken__UtNIl",
	"fa-question": "style_fa-question__3Y6e1",
	"faQuestion": "style_fa-question__3Y6e1",
	"fa-info": "style_fa-info__1YJhf",
	"faInfo": "style_fa-info__1YJhf",
	"fa-exclamation": "style_fa-exclamation__1gQg6",
	"faExclamation": "style_fa-exclamation__1gQg6",
	"fa-superscript": "style_fa-superscript__2w6Zr",
	"faSuperscript": "style_fa-superscript__2w6Zr",
	"fa-subscript": "style_fa-subscript__14RTM",
	"faSubscript": "style_fa-subscript__14RTM",
	"fa-eraser": "style_fa-eraser__S3iJb",
	"faEraser": "style_fa-eraser__S3iJb",
	"fa-puzzle-piece": "style_fa-puzzle-piece__199HV",
	"faPuzzlePiece": "style_fa-puzzle-piece__199HV",
	"fa-microphone": "style_fa-microphone__27dax",
	"faMicrophone": "style_fa-microphone__27dax",
	"fa-microphone-slash": "style_fa-microphone-slash__3oZE7",
	"faMicrophoneSlash": "style_fa-microphone-slash__3oZE7",
	"fa-shield": "style_fa-shield__3DkNX",
	"faShield": "style_fa-shield__3DkNX",
	"fa-calendar-o": "style_fa-calendar-o__S43Cp",
	"faCalendarO": "style_fa-calendar-o__S43Cp",
	"fa-fire-extinguisher": "style_fa-fire-extinguisher__pDFqQ",
	"faFireExtinguisher": "style_fa-fire-extinguisher__pDFqQ",
	"fa-rocket": "style_fa-rocket__35oGO",
	"faRocket": "style_fa-rocket__35oGO",
	"fa-maxcdn": "style_fa-maxcdn__fFV60",
	"faMaxcdn": "style_fa-maxcdn__fFV60",
	"fa-chevron-circle-left": "style_fa-chevron-circle-left__3Ylxn",
	"faChevronCircleLeft": "style_fa-chevron-circle-left__3Ylxn",
	"fa-chevron-circle-right": "style_fa-chevron-circle-right__3cfR0",
	"faChevronCircleRight": "style_fa-chevron-circle-right__3cfR0",
	"fa-chevron-circle-up": "style_fa-chevron-circle-up__1NCOc",
	"faChevronCircleUp": "style_fa-chevron-circle-up__1NCOc",
	"fa-chevron-circle-down": "style_fa-chevron-circle-down__1ZTjz",
	"faChevronCircleDown": "style_fa-chevron-circle-down__1ZTjz",
	"fa-html5": "style_fa-html5__2AmMy",
	"faHtml5": "style_fa-html5__2AmMy",
	"fa-css3": "style_fa-css3__197Tg",
	"faCss3": "style_fa-css3__197Tg",
	"fa-anchor": "style_fa-anchor__CwQXw",
	"faAnchor": "style_fa-anchor__CwQXw",
	"fa-unlock-alt": "style_fa-unlock-alt__33y20",
	"faUnlockAlt": "style_fa-unlock-alt__33y20",
	"fa-bullseye": "style_fa-bullseye__3Fzdl",
	"faBullseye": "style_fa-bullseye__3Fzdl",
	"fa-ellipsis-h": "style_fa-ellipsis-h__1xO9Y",
	"faEllipsisH": "style_fa-ellipsis-h__1xO9Y",
	"fa-ellipsis-v": "style_fa-ellipsis-v__DGE5R",
	"faEllipsisV": "style_fa-ellipsis-v__DGE5R",
	"fa-rss-square": "style_fa-rss-square__1EZtw",
	"faRssSquare": "style_fa-rss-square__1EZtw",
	"fa-play-circle": "style_fa-play-circle__1UNzy",
	"faPlayCircle": "style_fa-play-circle__1UNzy",
	"fa-ticket": "style_fa-ticket__2Hhzi",
	"faTicket": "style_fa-ticket__2Hhzi",
	"fa-minus-square": "style_fa-minus-square__3rxP2",
	"faMinusSquare": "style_fa-minus-square__3rxP2",
	"fa-minus-square-o": "style_fa-minus-square-o__3Qd79",
	"faMinusSquareO": "style_fa-minus-square-o__3Qd79",
	"fa-level-up": "style_fa-level-up__3W8ml",
	"faLevelUp": "style_fa-level-up__3W8ml",
	"fa-level-down": "style_fa-level-down__2hdzw",
	"faLevelDown": "style_fa-level-down__2hdzw",
	"fa-check-square": "style_fa-check-square__PXToN",
	"faCheckSquare": "style_fa-check-square__PXToN",
	"fa-pencil-square": "style_fa-pencil-square__3BxAj",
	"faPencilSquare": "style_fa-pencil-square__3BxAj",
	"fa-external-link-square": "style_fa-external-link-square__1BIFy",
	"faExternalLinkSquare": "style_fa-external-link-square__1BIFy",
	"fa-share-square": "style_fa-share-square__1V1tB",
	"faShareSquare": "style_fa-share-square__1V1tB",
	"fa-compass": "style_fa-compass__2SPjB",
	"faCompass": "style_fa-compass__2SPjB",
	"fa-toggle-down": "style_fa-toggle-down__3JopC",
	"faToggleDown": "style_fa-toggle-down__3JopC",
	"fa-caret-square-o-down": "style_fa-caret-square-o-down__2E4Mb",
	"faCaretSquareODown": "style_fa-caret-square-o-down__2E4Mb",
	"fa-toggle-up": "style_fa-toggle-up__1vJD0",
	"faToggleUp": "style_fa-toggle-up__1vJD0",
	"fa-caret-square-o-up": "style_fa-caret-square-o-up__1VOkN",
	"faCaretSquareOUp": "style_fa-caret-square-o-up__1VOkN",
	"fa-toggle-right": "style_fa-toggle-right__1vs4i",
	"faToggleRight": "style_fa-toggle-right__1vs4i",
	"fa-caret-square-o-right": "style_fa-caret-square-o-right__2U1ay",
	"faCaretSquareORight": "style_fa-caret-square-o-right__2U1ay",
	"fa-euro": "style_fa-euro__1jXcx",
	"faEuro": "style_fa-euro__1jXcx",
	"fa-eur": "style_fa-eur__3MXW5",
	"faEur": "style_fa-eur__3MXW5",
	"fa-gbp": "style_fa-gbp__2Ps1g",
	"faGbp": "style_fa-gbp__2Ps1g",
	"fa-dollar": "style_fa-dollar__3Pc9r",
	"faDollar": "style_fa-dollar__3Pc9r",
	"fa-usd": "style_fa-usd__3Iq-9",
	"faUsd": "style_fa-usd__3Iq-9",
	"fa-rupee": "style_fa-rupee__1NZ0t",
	"faRupee": "style_fa-rupee__1NZ0t",
	"fa-inr": "style_fa-inr__XhhvZ",
	"faInr": "style_fa-inr__XhhvZ",
	"fa-cny": "style_fa-cny__2vF4f",
	"faCny": "style_fa-cny__2vF4f",
	"fa-rmb": "style_fa-rmb__14IpQ",
	"faRmb": "style_fa-rmb__14IpQ",
	"fa-yen": "style_fa-yen__3rbpG",
	"faYen": "style_fa-yen__3rbpG",
	"fa-jpy": "style_fa-jpy__6ngge",
	"faJpy": "style_fa-jpy__6ngge",
	"fa-ruble": "style_fa-ruble__1MHOp",
	"faRuble": "style_fa-ruble__1MHOp",
	"fa-rouble": "style_fa-rouble__2UTPI",
	"faRouble": "style_fa-rouble__2UTPI",
	"fa-rub": "style_fa-rub__3PmCg",
	"faRub": "style_fa-rub__3PmCg",
	"fa-won": "style_fa-won__1buvn",
	"faWon": "style_fa-won__1buvn",
	"fa-krw": "style_fa-krw__11g7e",
	"faKrw": "style_fa-krw__11g7e",
	"fa-bitcoin": "style_fa-bitcoin__1Pk94",
	"faBitcoin": "style_fa-bitcoin__1Pk94",
	"fa-btc": "style_fa-btc__3b4vn",
	"faBtc": "style_fa-btc__3b4vn",
	"fa-file": "style_fa-file__3PW0K",
	"faFile": "style_fa-file__3PW0K",
	"fa-file-text": "style_fa-file-text__1i0b9",
	"faFileText": "style_fa-file-text__1i0b9",
	"fa-sort-alpha-asc": "style_fa-sort-alpha-asc__3Wl8L",
	"faSortAlphaAsc": "style_fa-sort-alpha-asc__3Wl8L",
	"fa-sort-alpha-desc": "style_fa-sort-alpha-desc__X0x0e",
	"faSortAlphaDesc": "style_fa-sort-alpha-desc__X0x0e",
	"fa-sort-amount-asc": "style_fa-sort-amount-asc__2VAur",
	"faSortAmountAsc": "style_fa-sort-amount-asc__2VAur",
	"fa-sort-amount-desc": "style_fa-sort-amount-desc__3wj0k",
	"faSortAmountDesc": "style_fa-sort-amount-desc__3wj0k",
	"fa-sort-numeric-asc": "style_fa-sort-numeric-asc__2roSh",
	"faSortNumericAsc": "style_fa-sort-numeric-asc__2roSh",
	"fa-sort-numeric-desc": "style_fa-sort-numeric-desc__1qZDn",
	"faSortNumericDesc": "style_fa-sort-numeric-desc__1qZDn",
	"fa-thumbs-up": "style_fa-thumbs-up__1Wg1I",
	"faThumbsUp": "style_fa-thumbs-up__1Wg1I",
	"fa-thumbs-down": "style_fa-thumbs-down__2xAxS",
	"faThumbsDown": "style_fa-thumbs-down__2xAxS",
	"fa-youtube-square": "style_fa-youtube-square__3nFIw",
	"faYoutubeSquare": "style_fa-youtube-square__3nFIw",
	"fa-youtube": "style_fa-youtube__31ODZ",
	"faYoutube": "style_fa-youtube__31ODZ",
	"fa-xing": "style_fa-xing__27cX2",
	"faXing": "style_fa-xing__27cX2",
	"fa-xing-square": "style_fa-xing-square__35esg",
	"faXingSquare": "style_fa-xing-square__35esg",
	"fa-youtube-play": "style_fa-youtube-play__2C5gj",
	"faYoutubePlay": "style_fa-youtube-play__2C5gj",
	"fa-dropbox": "style_fa-dropbox__1d8d4",
	"faDropbox": "style_fa-dropbox__1d8d4",
	"fa-stack-overflow": "style_fa-stack-overflow__2GZ-H",
	"faStackOverflow": "style_fa-stack-overflow__2GZ-H",
	"fa-instagram": "style_fa-instagram__3fb9Q",
	"faInstagram": "style_fa-instagram__3fb9Q",
	"fa-flickr": "style_fa-flickr__WhIVy",
	"faFlickr": "style_fa-flickr__WhIVy",
	"fa-adn": "style_fa-adn__3-Z8l",
	"faAdn": "style_fa-adn__3-Z8l",
	"fa-bitbucket": "style_fa-bitbucket__CbNjZ",
	"faBitbucket": "style_fa-bitbucket__CbNjZ",
	"fa-bitbucket-square": "style_fa-bitbucket-square__t0VxH",
	"faBitbucketSquare": "style_fa-bitbucket-square__t0VxH",
	"fa-tumblr": "style_fa-tumblr__2_oM_",
	"faTumblr": "style_fa-tumblr__2_oM_",
	"fa-tumblr-square": "style_fa-tumblr-square__3F7CC",
	"faTumblrSquare": "style_fa-tumblr-square__3F7CC",
	"fa-long-arrow-down": "style_fa-long-arrow-down__2oVs-",
	"faLongArrowDown": "style_fa-long-arrow-down__2oVs-",
	"fa-long-arrow-up": "style_fa-long-arrow-up__bklzU",
	"faLongArrowUp": "style_fa-long-arrow-up__bklzU",
	"fa-long-arrow-left": "style_fa-long-arrow-left__3APTL",
	"faLongArrowLeft": "style_fa-long-arrow-left__3APTL",
	"fa-long-arrow-right": "style_fa-long-arrow-right__21tW8",
	"faLongArrowRight": "style_fa-long-arrow-right__21tW8",
	"fa-apple": "style_fa-apple__1wtga",
	"faApple": "style_fa-apple__1wtga",
	"fa-windows": "style_fa-windows__19Xi6",
	"faWindows": "style_fa-windows__19Xi6",
	"fa-android": "style_fa-android__2vJKQ",
	"faAndroid": "style_fa-android__2vJKQ",
	"fa-linux": "style_fa-linux__1dLmz",
	"faLinux": "style_fa-linux__1dLmz",
	"fa-dribbble": "style_fa-dribbble__ZWptF",
	"faDribbble": "style_fa-dribbble__ZWptF",
	"fa-skype": "style_fa-skype__27gQr",
	"faSkype": "style_fa-skype__27gQr",
	"fa-foursquare": "style_fa-foursquare__3QNVL",
	"faFoursquare": "style_fa-foursquare__3QNVL",
	"fa-trello": "style_fa-trello__2sbpV",
	"faTrello": "style_fa-trello__2sbpV",
	"fa-female": "style_fa-female__2gRF2",
	"faFemale": "style_fa-female__2gRF2",
	"fa-male": "style_fa-male__1CNvk",
	"faMale": "style_fa-male__1CNvk",
	"fa-gittip": "style_fa-gittip__mo97w",
	"faGittip": "style_fa-gittip__mo97w",
	"fa-gratipay": "style_fa-gratipay__3YS56",
	"faGratipay": "style_fa-gratipay__3YS56",
	"fa-sun-o": "style_fa-sun-o__2iTX9",
	"faSunO": "style_fa-sun-o__2iTX9",
	"fa-moon-o": "style_fa-moon-o__1SqMg",
	"faMoonO": "style_fa-moon-o__1SqMg",
	"fa-archive": "style_fa-archive__3VLlT",
	"faArchive": "style_fa-archive__3VLlT",
	"fa-bug": "style_fa-bug__2fFru",
	"faBug": "style_fa-bug__2fFru",
	"fa-vk": "style_fa-vk__3KpkN",
	"faVk": "style_fa-vk__3KpkN",
	"fa-weibo": "style_fa-weibo__2RfmV",
	"faWeibo": "style_fa-weibo__2RfmV",
	"fa-renren": "style_fa-renren__1QDdr",
	"faRenren": "style_fa-renren__1QDdr",
	"fa-pagelines": "style_fa-pagelines__fm95T",
	"faPagelines": "style_fa-pagelines__fm95T",
	"fa-stack-exchange": "style_fa-stack-exchange__2qfzD",
	"faStackExchange": "style_fa-stack-exchange__2qfzD",
	"fa-arrow-circle-o-right": "style_fa-arrow-circle-o-right__K7ffa",
	"faArrowCircleORight": "style_fa-arrow-circle-o-right__K7ffa",
	"fa-arrow-circle-o-left": "style_fa-arrow-circle-o-left__3EN-J",
	"faArrowCircleOLeft": "style_fa-arrow-circle-o-left__3EN-J",
	"fa-toggle-left": "style_fa-toggle-left__2etkD",
	"faToggleLeft": "style_fa-toggle-left__2etkD",
	"fa-caret-square-o-left": "style_fa-caret-square-o-left__3gHuI",
	"faCaretSquareOLeft": "style_fa-caret-square-o-left__3gHuI",
	"fa-dot-circle-o": "style_fa-dot-circle-o__1QlOs",
	"faDotCircleO": "style_fa-dot-circle-o__1QlOs",
	"fa-wheelchair": "style_fa-wheelchair__3DlnR",
	"faWheelchair": "style_fa-wheelchair__3DlnR",
	"fa-vimeo-square": "style_fa-vimeo-square__2QJq0",
	"faVimeoSquare": "style_fa-vimeo-square__2QJq0",
	"fa-turkish-lira": "style_fa-turkish-lira__uIPlz",
	"faTurkishLira": "style_fa-turkish-lira__uIPlz",
	"fa-try": "style_fa-try__B8huM",
	"faTry": "style_fa-try__B8huM",
	"fa-plus-square-o": "style_fa-plus-square-o__15P7a",
	"faPlusSquareO": "style_fa-plus-square-o__15P7a",
	"fa-space-shuttle": "style_fa-space-shuttle__zzUXH",
	"faSpaceShuttle": "style_fa-space-shuttle__zzUXH",
	"fa-slack": "style_fa-slack__1WXhk",
	"faSlack": "style_fa-slack__1WXhk",
	"fa-envelope-square": "style_fa-envelope-square__3j9ps",
	"faEnvelopeSquare": "style_fa-envelope-square__3j9ps",
	"fa-wordpress": "style_fa-wordpress__2xzZ6",
	"faWordpress": "style_fa-wordpress__2xzZ6",
	"fa-openid": "style_fa-openid__D94GP",
	"faOpenid": "style_fa-openid__D94GP",
	"fa-institution": "style_fa-institution__2hjdN",
	"faInstitution": "style_fa-institution__2hjdN",
	"fa-bank": "style_fa-bank__3rkbQ",
	"faBank": "style_fa-bank__3rkbQ",
	"fa-university": "style_fa-university__3HLWm",
	"faUniversity": "style_fa-university__3HLWm",
	"fa-mortar-board": "style_fa-mortar-board__lir21",
	"faMortarBoard": "style_fa-mortar-board__lir21",
	"fa-graduation-cap": "style_fa-graduation-cap__Mv-zi",
	"faGraduationCap": "style_fa-graduation-cap__Mv-zi",
	"fa-yahoo": "style_fa-yahoo__3KkpO",
	"faYahoo": "style_fa-yahoo__3KkpO",
	"fa-google": "style_fa-google__3FGuH",
	"faGoogle": "style_fa-google__3FGuH",
	"fa-reddit": "style_fa-reddit__11v_6",
	"faReddit": "style_fa-reddit__11v_6",
	"fa-reddit-square": "style_fa-reddit-square__3lV5F",
	"faRedditSquare": "style_fa-reddit-square__3lV5F",
	"fa-stumbleupon-circle": "style_fa-stumbleupon-circle__3aLV5",
	"faStumbleuponCircle": "style_fa-stumbleupon-circle__3aLV5",
	"fa-stumbleupon": "style_fa-stumbleupon__YCZC2",
	"faStumbleupon": "style_fa-stumbleupon__YCZC2",
	"fa-delicious": "style_fa-delicious__3_9p9",
	"faDelicious": "style_fa-delicious__3_9p9",
	"fa-digg": "style_fa-digg__Aqqnb",
	"faDigg": "style_fa-digg__Aqqnb",
	"fa-pied-piper-pp": "style_fa-pied-piper-pp__2Jh-d",
	"faPiedPiperPp": "style_fa-pied-piper-pp__2Jh-d",
	"fa-pied-piper-alt": "style_fa-pied-piper-alt__1RYAN",
	"faPiedPiperAlt": "style_fa-pied-piper-alt__1RYAN",
	"fa-drupal": "style_fa-drupal__2CBnI",
	"faDrupal": "style_fa-drupal__2CBnI",
	"fa-joomla": "style_fa-joomla__2jLpt",
	"faJoomla": "style_fa-joomla__2jLpt",
	"fa-language": "style_fa-language__12ZtE",
	"faLanguage": "style_fa-language__12ZtE",
	"fa-fax": "style_fa-fax__2brsY",
	"faFax": "style_fa-fax__2brsY",
	"fa-building": "style_fa-building__3gMtm",
	"faBuilding": "style_fa-building__3gMtm",
	"fa-child": "style_fa-child__aLfmj",
	"faChild": "style_fa-child__aLfmj",
	"fa-paw": "style_fa-paw__3AdLQ",
	"faPaw": "style_fa-paw__3AdLQ",
	"fa-spoon": "style_fa-spoon__31Ta2",
	"faSpoon": "style_fa-spoon__31Ta2",
	"fa-cube": "style_fa-cube__E4C4A",
	"faCube": "style_fa-cube__E4C4A",
	"fa-cubes": "style_fa-cubes__1Oc2M",
	"faCubes": "style_fa-cubes__1Oc2M",
	"fa-behance": "style_fa-behance__3xSZc",
	"faBehance": "style_fa-behance__3xSZc",
	"fa-behance-square": "style_fa-behance-square__3Nx9s",
	"faBehanceSquare": "style_fa-behance-square__3Nx9s",
	"fa-steam": "style_fa-steam__1qOBr",
	"faSteam": "style_fa-steam__1qOBr",
	"fa-steam-square": "style_fa-steam-square__1uMzy",
	"faSteamSquare": "style_fa-steam-square__1uMzy",
	"fa-recycle": "style_fa-recycle__109Ji",
	"faRecycle": "style_fa-recycle__109Ji",
	"fa-automobile": "style_fa-automobile__rH9KD",
	"faAutomobile": "style_fa-automobile__rH9KD",
	"fa-car": "style_fa-car__3jJSC",
	"faCar": "style_fa-car__3jJSC",
	"fa-cab": "style_fa-cab__2AAWR",
	"faCab": "style_fa-cab__2AAWR",
	"fa-taxi": "style_fa-taxi__16hc8",
	"faTaxi": "style_fa-taxi__16hc8",
	"fa-tree": "style_fa-tree__3TAew",
	"faTree": "style_fa-tree__3TAew",
	"fa-spotify": "style_fa-spotify__3zndM",
	"faSpotify": "style_fa-spotify__3zndM",
	"fa-deviantart": "style_fa-deviantart__k7QPs",
	"faDeviantart": "style_fa-deviantart__k7QPs",
	"fa-soundcloud": "style_fa-soundcloud__21KtU",
	"faSoundcloud": "style_fa-soundcloud__21KtU",
	"fa-database": "style_fa-database__3x11l",
	"faDatabase": "style_fa-database__3x11l",
	"fa-file-pdf-o": "style_fa-file-pdf-o__1UWXX",
	"faFilePdfO": "style_fa-file-pdf-o__1UWXX",
	"fa-file-word-o": "style_fa-file-word-o__Zxcy6",
	"faFileWordO": "style_fa-file-word-o__Zxcy6",
	"fa-file-excel-o": "style_fa-file-excel-o__3tuIt",
	"faFileExcelO": "style_fa-file-excel-o__3tuIt",
	"fa-file-powerpoint-o": "style_fa-file-powerpoint-o__2ldG5",
	"faFilePowerpointO": "style_fa-file-powerpoint-o__2ldG5",
	"fa-file-photo-o": "style_fa-file-photo-o__3syks",
	"faFilePhotoO": "style_fa-file-photo-o__3syks",
	"fa-file-picture-o": "style_fa-file-picture-o__1ZXeo",
	"faFilePictureO": "style_fa-file-picture-o__1ZXeo",
	"fa-file-image-o": "style_fa-file-image-o__1N9tp",
	"faFileImageO": "style_fa-file-image-o__1N9tp",
	"fa-file-zip-o": "style_fa-file-zip-o__1AycK",
	"faFileZipO": "style_fa-file-zip-o__1AycK",
	"fa-file-archive-o": "style_fa-file-archive-o__10aGo",
	"faFileArchiveO": "style_fa-file-archive-o__10aGo",
	"fa-file-sound-o": "style_fa-file-sound-o__VeT3V",
	"faFileSoundO": "style_fa-file-sound-o__VeT3V",
	"fa-file-audio-o": "style_fa-file-audio-o__Gfwou",
	"faFileAudioO": "style_fa-file-audio-o__Gfwou",
	"fa-file-movie-o": "style_fa-file-movie-o__3ichx",
	"faFileMovieO": "style_fa-file-movie-o__3ichx",
	"fa-file-video-o": "style_fa-file-video-o__3Jcv3",
	"faFileVideoO": "style_fa-file-video-o__3Jcv3",
	"fa-file-code-o": "style_fa-file-code-o__2K797",
	"faFileCodeO": "style_fa-file-code-o__2K797",
	"fa-vine": "style_fa-vine__3OeCe",
	"faVine": "style_fa-vine__3OeCe",
	"fa-codepen": "style_fa-codepen__1dXdy",
	"faCodepen": "style_fa-codepen__1dXdy",
	"fa-jsfiddle": "style_fa-jsfiddle__3UgBp",
	"faJsfiddle": "style_fa-jsfiddle__3UgBp",
	"fa-life-bouy": "style_fa-life-bouy__1_S3D",
	"faLifeBouy": "style_fa-life-bouy__1_S3D",
	"fa-life-buoy": "style_fa-life-buoy__ve2oz",
	"faLifeBuoy": "style_fa-life-buoy__ve2oz",
	"fa-life-saver": "style_fa-life-saver__ACpfj",
	"faLifeSaver": "style_fa-life-saver__ACpfj",
	"fa-support": "style_fa-support__3m5m6",
	"faSupport": "style_fa-support__3m5m6",
	"fa-life-ring": "style_fa-life-ring__25W_g",
	"faLifeRing": "style_fa-life-ring__25W_g",
	"fa-circle-o-notch": "style_fa-circle-o-notch__3cukx",
	"faCircleONotch": "style_fa-circle-o-notch__3cukx",
	"fa-ra": "style_fa-ra__1BSfX",
	"faRa": "style_fa-ra__1BSfX",
	"fa-resistance": "style_fa-resistance__1R8LL",
	"faResistance": "style_fa-resistance__1R8LL",
	"fa-rebel": "style_fa-rebel__yZmt9",
	"faRebel": "style_fa-rebel__yZmt9",
	"fa-ge": "style_fa-ge__3Jxbo",
	"faGe": "style_fa-ge__3Jxbo",
	"fa-empire": "style_fa-empire__2MYaA",
	"faEmpire": "style_fa-empire__2MYaA",
	"fa-git-square": "style_fa-git-square__2fz0z",
	"faGitSquare": "style_fa-git-square__2fz0z",
	"fa-git": "style_fa-git__273FN",
	"faGit": "style_fa-git__273FN",
	"fa-y-combinator-square": "style_fa-y-combinator-square__1kZaq",
	"faYCombinatorSquare": "style_fa-y-combinator-square__1kZaq",
	"fa-yc-square": "style_fa-yc-square__2rvQu",
	"faYcSquare": "style_fa-yc-square__2rvQu",
	"fa-hacker-news": "style_fa-hacker-news__1BOsy",
	"faHackerNews": "style_fa-hacker-news__1BOsy",
	"fa-tencent-weibo": "style_fa-tencent-weibo__3QMpj",
	"faTencentWeibo": "style_fa-tencent-weibo__3QMpj",
	"fa-qq": "style_fa-qq__32_v9",
	"faQq": "style_fa-qq__32_v9",
	"fa-wechat": "style_fa-wechat__3RMBl",
	"faWechat": "style_fa-wechat__3RMBl",
	"fa-weixin": "style_fa-weixin__PIRz-",
	"faWeixin": "style_fa-weixin__PIRz-",
	"fa-send": "style_fa-send__XzgHa",
	"faSend": "style_fa-send__XzgHa",
	"fa-paper-plane": "style_fa-paper-plane__22F4t",
	"faPaperPlane": "style_fa-paper-plane__22F4t",
	"fa-send-o": "style_fa-send-o__1VUws",
	"faSendO": "style_fa-send-o__1VUws",
	"fa-paper-plane-o": "style_fa-paper-plane-o__rthxb",
	"faPaperPlaneO": "style_fa-paper-plane-o__rthxb",
	"fa-history": "style_fa-history__3jmj5",
	"faHistory": "style_fa-history__3jmj5",
	"fa-circle-thin": "style_fa-circle-thin__pujpG",
	"faCircleThin": "style_fa-circle-thin__pujpG",
	"fa-header": "style_fa-header__3M7hI",
	"faHeader": "style_fa-header__3M7hI",
	"fa-paragraph": "style_fa-paragraph__AHVpO",
	"faParagraph": "style_fa-paragraph__AHVpO",
	"fa-sliders": "style_fa-sliders__3qlRM",
	"faSliders": "style_fa-sliders__3qlRM",
	"fa-share-alt": "style_fa-share-alt__3pA8S",
	"faShareAlt": "style_fa-share-alt__3pA8S",
	"fa-share-alt-square": "style_fa-share-alt-square__2TLPh",
	"faShareAltSquare": "style_fa-share-alt-square__2TLPh",
	"fa-bomb": "style_fa-bomb__9R958",
	"faBomb": "style_fa-bomb__9R958",
	"fa-soccer-ball-o": "style_fa-soccer-ball-o__3Zpz3",
	"faSoccerBallO": "style_fa-soccer-ball-o__3Zpz3",
	"fa-futbol-o": "style_fa-futbol-o__1a0Ku",
	"faFutbolO": "style_fa-futbol-o__1a0Ku",
	"fa-tty": "style_fa-tty__3dhCE",
	"faTty": "style_fa-tty__3dhCE",
	"fa-binoculars": "style_fa-binoculars__1lRi4",
	"faBinoculars": "style_fa-binoculars__1lRi4",
	"fa-plug": "style_fa-plug__4R_-Z",
	"faPlug": "style_fa-plug__4R_-Z",
	"fa-slideshare": "style_fa-slideshare__2AFjK",
	"faSlideshare": "style_fa-slideshare__2AFjK",
	"fa-twitch": "style_fa-twitch__2pHuI",
	"faTwitch": "style_fa-twitch__2pHuI",
	"fa-yelp": "style_fa-yelp__3uIb0",
	"faYelp": "style_fa-yelp__3uIb0",
	"fa-newspaper-o": "style_fa-newspaper-o__2uVdd",
	"faNewspaperO": "style_fa-newspaper-o__2uVdd",
	"fa-wifi": "style_fa-wifi__I10MG",
	"faWifi": "style_fa-wifi__I10MG",
	"fa-calculator": "style_fa-calculator__2peOS",
	"faCalculator": "style_fa-calculator__2peOS",
	"fa-paypal": "style_fa-paypal__3ZedC",
	"faPaypal": "style_fa-paypal__3ZedC",
	"fa-google-wallet": "style_fa-google-wallet__1xZG3",
	"faGoogleWallet": "style_fa-google-wallet__1xZG3",
	"fa-cc-visa": "style_fa-cc-visa__3wYa7",
	"faCcVisa": "style_fa-cc-visa__3wYa7",
	"fa-cc-mastercard": "style_fa-cc-mastercard__x-8Hg",
	"faCcMastercard": "style_fa-cc-mastercard__x-8Hg",
	"fa-cc-discover": "style_fa-cc-discover__WkJEt",
	"faCcDiscover": "style_fa-cc-discover__WkJEt",
	"fa-cc-amex": "style_fa-cc-amex__QATKk",
	"faCcAmex": "style_fa-cc-amex__QATKk",
	"fa-cc-paypal": "style_fa-cc-paypal__31MqT",
	"faCcPaypal": "style_fa-cc-paypal__31MqT",
	"fa-cc-stripe": "style_fa-cc-stripe__27I4-",
	"faCcStripe": "style_fa-cc-stripe__27I4-",
	"fa-bell-slash": "style_fa-bell-slash__2wVQT",
	"faBellSlash": "style_fa-bell-slash__2wVQT",
	"fa-bell-slash-o": "style_fa-bell-slash-o__3q6J0",
	"faBellSlashO": "style_fa-bell-slash-o__3q6J0",
	"fa-trash": "style_fa-trash__2nsCq",
	"faTrash": "style_fa-trash__2nsCq",
	"fa-copyright": "style_fa-copyright__36jSb",
	"faCopyright": "style_fa-copyright__36jSb",
	"fa-at": "style_fa-at__1gbqK",
	"faAt": "style_fa-at__1gbqK",
	"fa-eyedropper": "style_fa-eyedropper__2sfZR",
	"faEyedropper": "style_fa-eyedropper__2sfZR",
	"fa-paint-brush": "style_fa-paint-brush__29gLz",
	"faPaintBrush": "style_fa-paint-brush__29gLz",
	"fa-birthday-cake": "style_fa-birthday-cake__2LFE-",
	"faBirthdayCake": "style_fa-birthday-cake__2LFE-",
	"fa-area-chart": "style_fa-area-chart__2xoVG",
	"faAreaChart": "style_fa-area-chart__2xoVG",
	"fa-pie-chart": "style_fa-pie-chart__Lt9J9",
	"faPieChart": "style_fa-pie-chart__Lt9J9",
	"fa-line-chart": "style_fa-line-chart__v5Vz7",
	"faLineChart": "style_fa-line-chart__v5Vz7",
	"fa-lastfm": "style_fa-lastfm__3Xbey",
	"faLastfm": "style_fa-lastfm__3Xbey",
	"fa-lastfm-square": "style_fa-lastfm-square__rcQZJ",
	"faLastfmSquare": "style_fa-lastfm-square__rcQZJ",
	"fa-toggle-off": "style_fa-toggle-off__1RgJ-",
	"faToggleOff": "style_fa-toggle-off__1RgJ-",
	"fa-toggle-on": "style_fa-toggle-on__JzsTX",
	"faToggleOn": "style_fa-toggle-on__JzsTX",
	"fa-bicycle": "style_fa-bicycle__2Hi3o",
	"faBicycle": "style_fa-bicycle__2Hi3o",
	"fa-bus": "style_fa-bus__2uqLm",
	"faBus": "style_fa-bus__2uqLm",
	"fa-ioxhost": "style_fa-ioxhost__dz7I5",
	"faIoxhost": "style_fa-ioxhost__dz7I5",
	"fa-angellist": "style_fa-angellist__1qU9h",
	"faAngellist": "style_fa-angellist__1qU9h",
	"fa-cc": "style_fa-cc__1KTQC",
	"faCc": "style_fa-cc__1KTQC",
	"fa-shekel": "style_fa-shekel__1TsRx",
	"faShekel": "style_fa-shekel__1TsRx",
	"fa-sheqel": "style_fa-sheqel__2JXWS",
	"faSheqel": "style_fa-sheqel__2JXWS",
	"fa-ils": "style_fa-ils__3RZz4",
	"faIls": "style_fa-ils__3RZz4",
	"fa-meanpath": "style_fa-meanpath__s-P0R",
	"faMeanpath": "style_fa-meanpath__s-P0R",
	"fa-buysellads": "style_fa-buysellads__31FsM",
	"faBuysellads": "style_fa-buysellads__31FsM",
	"fa-connectdevelop": "style_fa-connectdevelop__3vxtL",
	"faConnectdevelop": "style_fa-connectdevelop__3vxtL",
	"fa-dashcube": "style_fa-dashcube__2SiAc",
	"faDashcube": "style_fa-dashcube__2SiAc",
	"fa-forumbee": "style_fa-forumbee__1N2en",
	"faForumbee": "style_fa-forumbee__1N2en",
	"fa-leanpub": "style_fa-leanpub__GsGbD",
	"faLeanpub": "style_fa-leanpub__GsGbD",
	"fa-sellsy": "style_fa-sellsy__3Voml",
	"faSellsy": "style_fa-sellsy__3Voml",
	"fa-shirtsinbulk": "style_fa-shirtsinbulk__3Uicd",
	"faShirtsinbulk": "style_fa-shirtsinbulk__3Uicd",
	"fa-simplybuilt": "style_fa-simplybuilt__1S1iQ",
	"faSimplybuilt": "style_fa-simplybuilt__1S1iQ",
	"fa-skyatlas": "style_fa-skyatlas__1lEy_",
	"faSkyatlas": "style_fa-skyatlas__1lEy_",
	"fa-cart-plus": "style_fa-cart-plus__6xtgm",
	"faCartPlus": "style_fa-cart-plus__6xtgm",
	"fa-cart-arrow-down": "style_fa-cart-arrow-down__TN9vq",
	"faCartArrowDown": "style_fa-cart-arrow-down__TN9vq",
	"fa-diamond": "style_fa-diamond__38kag",
	"faDiamond": "style_fa-diamond__38kag",
	"fa-ship": "style_fa-ship__3jBZU",
	"faShip": "style_fa-ship__3jBZU",
	"fa-user-secret": "style_fa-user-secret__1MNpY",
	"faUserSecret": "style_fa-user-secret__1MNpY",
	"fa-motorcycle": "style_fa-motorcycle__2pfNe",
	"faMotorcycle": "style_fa-motorcycle__2pfNe",
	"fa-street-view": "style_fa-street-view__2FFQt",
	"faStreetView": "style_fa-street-view__2FFQt",
	"fa-heartbeat": "style_fa-heartbeat__10Izl",
	"faHeartbeat": "style_fa-heartbeat__10Izl",
	"fa-venus": "style_fa-venus__25JDj",
	"faVenus": "style_fa-venus__25JDj",
	"fa-mars": "style_fa-mars__288UC",
	"faMars": "style_fa-mars__288UC",
	"fa-mercury": "style_fa-mercury__2Q58M",
	"faMercury": "style_fa-mercury__2Q58M",
	"fa-intersex": "style_fa-intersex__3kLL4",
	"faIntersex": "style_fa-intersex__3kLL4",
	"fa-transgender": "style_fa-transgender__28Vug",
	"faTransgender": "style_fa-transgender__28Vug",
	"fa-transgender-alt": "style_fa-transgender-alt__2Nq6s",
	"faTransgenderAlt": "style_fa-transgender-alt__2Nq6s",
	"fa-venus-double": "style_fa-venus-double__3h-Iv",
	"faVenusDouble": "style_fa-venus-double__3h-Iv",
	"fa-mars-double": "style_fa-mars-double__bq6_W",
	"faMarsDouble": "style_fa-mars-double__bq6_W",
	"fa-venus-mars": "style_fa-venus-mars__2vx7g",
	"faVenusMars": "style_fa-venus-mars__2vx7g",
	"fa-mars-stroke": "style_fa-mars-stroke__JBS4E",
	"faMarsStroke": "style_fa-mars-stroke__JBS4E",
	"fa-mars-stroke-v": "style_fa-mars-stroke-v__2DjaF",
	"faMarsStrokeV": "style_fa-mars-stroke-v__2DjaF",
	"fa-mars-stroke-h": "style_fa-mars-stroke-h__2XBCX",
	"faMarsStrokeH": "style_fa-mars-stroke-h__2XBCX",
	"fa-neuter": "style_fa-neuter__tkR2L",
	"faNeuter": "style_fa-neuter__tkR2L",
	"fa-genderless": "style_fa-genderless__3g8-C",
	"faGenderless": "style_fa-genderless__3g8-C",
	"fa-facebook-official": "style_fa-facebook-official__1fixN",
	"faFacebookOfficial": "style_fa-facebook-official__1fixN",
	"fa-pinterest-p": "style_fa-pinterest-p__2Uacv",
	"faPinterestP": "style_fa-pinterest-p__2Uacv",
	"fa-whatsapp": "style_fa-whatsapp__5M37Z",
	"faWhatsapp": "style_fa-whatsapp__5M37Z",
	"fa-server": "style_fa-server__2Js8W",
	"faServer": "style_fa-server__2Js8W",
	"fa-user-plus": "style_fa-user-plus__2FeQ9",
	"faUserPlus": "style_fa-user-plus__2FeQ9",
	"fa-user-times": "style_fa-user-times__Z2cdB",
	"faUserTimes": "style_fa-user-times__Z2cdB",
	"fa-hotel": "style_fa-hotel__3RJFT",
	"faHotel": "style_fa-hotel__3RJFT",
	"fa-bed": "style_fa-bed__165DP",
	"faBed": "style_fa-bed__165DP",
	"fa-viacoin": "style_fa-viacoin__1Mu6P",
	"faViacoin": "style_fa-viacoin__1Mu6P",
	"fa-train": "style_fa-train__1Z4yd",
	"faTrain": "style_fa-train__1Z4yd",
	"fa-subway": "style_fa-subway__2F9i5",
	"faSubway": "style_fa-subway__2F9i5",
	"fa-medium": "style_fa-medium__3M6ms",
	"faMedium": "style_fa-medium__3M6ms",
	"fa-yc": "style_fa-yc__ISZRJ",
	"faYc": "style_fa-yc__ISZRJ",
	"fa-y-combinator": "style_fa-y-combinator__4aqOG",
	"faYCombinator": "style_fa-y-combinator__4aqOG",
	"fa-optin-monster": "style_fa-optin-monster__3bMTf",
	"faOptinMonster": "style_fa-optin-monster__3bMTf",
	"fa-opencart": "style_fa-opencart__2Pd3y",
	"faOpencart": "style_fa-opencart__2Pd3y",
	"fa-expeditedssl": "style_fa-expeditedssl__3lRxq",
	"faExpeditedssl": "style_fa-expeditedssl__3lRxq",
	"fa-battery-4": "style_fa-battery-4__nkX2e",
	"faBattery4": "style_fa-battery-4__nkX2e",
	"fa-battery": "style_fa-battery__1_1Ry",
	"faBattery": "style_fa-battery__1_1Ry",
	"fa-battery-full": "style_fa-battery-full__3k_LA",
	"faBatteryFull": "style_fa-battery-full__3k_LA",
	"fa-battery-3": "style_fa-battery-3__38FV_",
	"faBattery3": "style_fa-battery-3__38FV_",
	"fa-battery-three-quarters": "style_fa-battery-three-quarters__3_3TH",
	"faBatteryThreeQuarters": "style_fa-battery-three-quarters__3_3TH",
	"fa-battery-2": "style_fa-battery-2__1LDMi",
	"faBattery2": "style_fa-battery-2__1LDMi",
	"fa-battery-half": "style_fa-battery-half__3Lta2",
	"faBatteryHalf": "style_fa-battery-half__3Lta2",
	"fa-battery-1": "style_fa-battery-1__1AjVY",
	"faBattery1": "style_fa-battery-1__1AjVY",
	"fa-battery-quarter": "style_fa-battery-quarter__3KT3K",
	"faBatteryQuarter": "style_fa-battery-quarter__3KT3K",
	"fa-battery-0": "style_fa-battery-0__34q9q",
	"faBattery0": "style_fa-battery-0__34q9q",
	"fa-battery-empty": "style_fa-battery-empty__NN-XE",
	"faBatteryEmpty": "style_fa-battery-empty__NN-XE",
	"fa-mouse-pointer": "style_fa-mouse-pointer__1se8l",
	"faMousePointer": "style_fa-mouse-pointer__1se8l",
	"fa-i-cursor": "style_fa-i-cursor__3-J0x",
	"faICursor": "style_fa-i-cursor__3-J0x",
	"fa-object-group": "style_fa-object-group__8uZFN",
	"faObjectGroup": "style_fa-object-group__8uZFN",
	"fa-object-ungroup": "style_fa-object-ungroup__3AfpG",
	"faObjectUngroup": "style_fa-object-ungroup__3AfpG",
	"fa-sticky-note": "style_fa-sticky-note__qC99I",
	"faStickyNote": "style_fa-sticky-note__qC99I",
	"fa-sticky-note-o": "style_fa-sticky-note-o__1shOs",
	"faStickyNoteO": "style_fa-sticky-note-o__1shOs",
	"fa-cc-jcb": "style_fa-cc-jcb__2JWFq",
	"faCcJcb": "style_fa-cc-jcb__2JWFq",
	"fa-cc-diners-club": "style_fa-cc-diners-club__3aTNT",
	"faCcDinersClub": "style_fa-cc-diners-club__3aTNT",
	"fa-clone": "style_fa-clone__3ICmj",
	"faClone": "style_fa-clone__3ICmj",
	"fa-balance-scale": "style_fa-balance-scale__15vCS",
	"faBalanceScale": "style_fa-balance-scale__15vCS",
	"fa-hourglass-o": "style_fa-hourglass-o__2hHT1",
	"faHourglassO": "style_fa-hourglass-o__2hHT1",
	"fa-hourglass-1": "style_fa-hourglass-1__2xFOM",
	"faHourglass1": "style_fa-hourglass-1__2xFOM",
	"fa-hourglass-start": "style_fa-hourglass-start__2oPRM",
	"faHourglassStart": "style_fa-hourglass-start__2oPRM",
	"fa-hourglass-2": "style_fa-hourglass-2__LMzUF",
	"faHourglass2": "style_fa-hourglass-2__LMzUF",
	"fa-hourglass-half": "style_fa-hourglass-half__8Nr-6",
	"faHourglassHalf": "style_fa-hourglass-half__8Nr-6",
	"fa-hourglass-3": "style_fa-hourglass-3__33jx-",
	"faHourglass3": "style_fa-hourglass-3__33jx-",
	"fa-hourglass-end": "style_fa-hourglass-end__7sF5b",
	"faHourglassEnd": "style_fa-hourglass-end__7sF5b",
	"fa-hourglass": "style_fa-hourglass__2hNrb",
	"faHourglass": "style_fa-hourglass__2hNrb",
	"fa-hand-grab-o": "style_fa-hand-grab-o__1XsHN",
	"faHandGrabO": "style_fa-hand-grab-o__1XsHN",
	"fa-hand-rock-o": "style_fa-hand-rock-o__1o7JV",
	"faHandRockO": "style_fa-hand-rock-o__1o7JV",
	"fa-hand-stop-o": "style_fa-hand-stop-o__2tfzy",
	"faHandStopO": "style_fa-hand-stop-o__2tfzy",
	"fa-hand-paper-o": "style_fa-hand-paper-o__2D9tl",
	"faHandPaperO": "style_fa-hand-paper-o__2D9tl",
	"fa-hand-scissors-o": "style_fa-hand-scissors-o__1RKVE",
	"faHandScissorsO": "style_fa-hand-scissors-o__1RKVE",
	"fa-hand-lizard-o": "style_fa-hand-lizard-o__1zYpr",
	"faHandLizardO": "style_fa-hand-lizard-o__1zYpr",
	"fa-hand-spock-o": "style_fa-hand-spock-o__YbrEg",
	"faHandSpockO": "style_fa-hand-spock-o__YbrEg",
	"fa-hand-pointer-o": "style_fa-hand-pointer-o__1JnN-",
	"faHandPointerO": "style_fa-hand-pointer-o__1JnN-",
	"fa-hand-peace-o": "style_fa-hand-peace-o__yLVOp",
	"faHandPeaceO": "style_fa-hand-peace-o__yLVOp",
	"fa-trademark": "style_fa-trademark__3u2jI",
	"faTrademark": "style_fa-trademark__3u2jI",
	"fa-registered": "style_fa-registered__2qgyG",
	"faRegistered": "style_fa-registered__2qgyG",
	"fa-creative-commons": "style_fa-creative-commons__vPYgb",
	"faCreativeCommons": "style_fa-creative-commons__vPYgb",
	"fa-gg": "style_fa-gg__3IYl-",
	"faGg": "style_fa-gg__3IYl-",
	"fa-gg-circle": "style_fa-gg-circle__3-1rl",
	"faGgCircle": "style_fa-gg-circle__3-1rl",
	"fa-tripadvisor": "style_fa-tripadvisor__2L5A9",
	"faTripadvisor": "style_fa-tripadvisor__2L5A9",
	"fa-odnoklassniki": "style_fa-odnoklassniki__nVekf",
	"faOdnoklassniki": "style_fa-odnoklassniki__nVekf",
	"fa-odnoklassniki-square": "style_fa-odnoklassniki-square__16pjb",
	"faOdnoklassnikiSquare": "style_fa-odnoklassniki-square__16pjb",
	"fa-get-pocket": "style_fa-get-pocket__104ns",
	"faGetPocket": "style_fa-get-pocket__104ns",
	"fa-wikipedia-w": "style_fa-wikipedia-w__X8BYC",
	"faWikipediaW": "style_fa-wikipedia-w__X8BYC",
	"fa-safari": "style_fa-safari__2sTvN",
	"faSafari": "style_fa-safari__2sTvN",
	"fa-chrome": "style_fa-chrome__2_0YB",
	"faChrome": "style_fa-chrome__2_0YB",
	"fa-firefox": "style_fa-firefox__2CaNy",
	"faFirefox": "style_fa-firefox__2CaNy",
	"fa-opera": "style_fa-opera__j5rM7",
	"faOpera": "style_fa-opera__j5rM7",
	"fa-internet-explorer": "style_fa-internet-explorer__322q3",
	"faInternetExplorer": "style_fa-internet-explorer__322q3",
	"fa-tv": "style_fa-tv__3YwR3",
	"faTv": "style_fa-tv__3YwR3",
	"fa-television": "style_fa-television__2RVy1",
	"faTelevision": "style_fa-television__2RVy1",
	"fa-contao": "style_fa-contao__23lBh",
	"faContao": "style_fa-contao__23lBh",
	"fa-500px": "style_fa-500px__17Jvu",
	"fa500Px": "style_fa-500px__17Jvu",
	"fa-amazon": "style_fa-amazon__1ymX6",
	"faAmazon": "style_fa-amazon__1ymX6",
	"fa-calendar-plus-o": "style_fa-calendar-plus-o__3llpH",
	"faCalendarPlusO": "style_fa-calendar-plus-o__3llpH",
	"fa-calendar-minus-o": "style_fa-calendar-minus-o__1eQIz",
	"faCalendarMinusO": "style_fa-calendar-minus-o__1eQIz",
	"fa-calendar-times-o": "style_fa-calendar-times-o__1W9qV",
	"faCalendarTimesO": "style_fa-calendar-times-o__1W9qV",
	"fa-calendar-check-o": "style_fa-calendar-check-o__2qp9Q",
	"faCalendarCheckO": "style_fa-calendar-check-o__2qp9Q",
	"fa-industry": "style_fa-industry__32YjN",
	"faIndustry": "style_fa-industry__32YjN",
	"fa-map-pin": "style_fa-map-pin__26nyt",
	"faMapPin": "style_fa-map-pin__26nyt",
	"fa-map-signs": "style_fa-map-signs__1R7I6",
	"faMapSigns": "style_fa-map-signs__1R7I6",
	"fa-map-o": "style_fa-map-o__1B_Uf",
	"faMapO": "style_fa-map-o__1B_Uf",
	"fa-map": "style_fa-map__3Asmz",
	"faMap": "style_fa-map__3Asmz",
	"fa-commenting": "style_fa-commenting__2eYPk",
	"faCommenting": "style_fa-commenting__2eYPk",
	"fa-commenting-o": "style_fa-commenting-o__1iYBT",
	"faCommentingO": "style_fa-commenting-o__1iYBT",
	"fa-houzz": "style_fa-houzz__1sfmW",
	"faHouzz": "style_fa-houzz__1sfmW",
	"fa-vimeo": "style_fa-vimeo__314lZ",
	"faVimeo": "style_fa-vimeo__314lZ",
	"fa-black-tie": "style_fa-black-tie__1Kqx8",
	"faBlackTie": "style_fa-black-tie__1Kqx8",
	"fa-fonticons": "style_fa-fonticons__2zdba",
	"faFonticons": "style_fa-fonticons__2zdba",
	"fa-reddit-alien": "style_fa-reddit-alien__2UPcO",
	"faRedditAlien": "style_fa-reddit-alien__2UPcO",
	"fa-edge": "style_fa-edge__1mSW1",
	"faEdge": "style_fa-edge__1mSW1",
	"fa-credit-card-alt": "style_fa-credit-card-alt__3UiPe",
	"faCreditCardAlt": "style_fa-credit-card-alt__3UiPe",
	"fa-codiepie": "style_fa-codiepie__1EoyT",
	"faCodiepie": "style_fa-codiepie__1EoyT",
	"fa-modx": "style_fa-modx__ISmGq",
	"faModx": "style_fa-modx__ISmGq",
	"fa-fort-awesome": "style_fa-fort-awesome__2C8ry",
	"faFortAwesome": "style_fa-fort-awesome__2C8ry",
	"fa-usb": "style_fa-usb__2bSi9",
	"faUsb": "style_fa-usb__2bSi9",
	"fa-product-hunt": "style_fa-product-hunt__WmzHD",
	"faProductHunt": "style_fa-product-hunt__WmzHD",
	"fa-mixcloud": "style_fa-mixcloud__26EqX",
	"faMixcloud": "style_fa-mixcloud__26EqX",
	"fa-scribd": "style_fa-scribd__1nd52",
	"faScribd": "style_fa-scribd__1nd52",
	"fa-pause-circle": "style_fa-pause-circle__2P49M",
	"faPauseCircle": "style_fa-pause-circle__2P49M",
	"fa-pause-circle-o": "style_fa-pause-circle-o__xcp3U",
	"faPauseCircleO": "style_fa-pause-circle-o__xcp3U",
	"fa-stop-circle": "style_fa-stop-circle__2rV8_",
	"faStopCircle": "style_fa-stop-circle__2rV8_",
	"fa-stop-circle-o": "style_fa-stop-circle-o__3k47o",
	"faStopCircleO": "style_fa-stop-circle-o__3k47o",
	"fa-shopping-bag": "style_fa-shopping-bag__3TzmQ",
	"faShoppingBag": "style_fa-shopping-bag__3TzmQ",
	"fa-shopping-basket": "style_fa-shopping-basket__1n0W7",
	"faShoppingBasket": "style_fa-shopping-basket__1n0W7",
	"fa-hashtag": "style_fa-hashtag__1Au2Q",
	"faHashtag": "style_fa-hashtag__1Au2Q",
	"fa-bluetooth": "style_fa-bluetooth__f-IoV",
	"faBluetooth": "style_fa-bluetooth__f-IoV",
	"fa-bluetooth-b": "style_fa-bluetooth-b__2ZV1n",
	"faBluetoothB": "style_fa-bluetooth-b__2ZV1n",
	"fa-percent": "style_fa-percent__3GeyB",
	"faPercent": "style_fa-percent__3GeyB",
	"fa-gitlab": "style_fa-gitlab__2-Bar",
	"faGitlab": "style_fa-gitlab__2-Bar",
	"fa-wpbeginner": "style_fa-wpbeginner__2u02I",
	"faWpbeginner": "style_fa-wpbeginner__2u02I",
	"fa-wpforms": "style_fa-wpforms__1PAVg",
	"faWpforms": "style_fa-wpforms__1PAVg",
	"fa-envira": "style_fa-envira__2Vlp_",
	"faEnvira": "style_fa-envira__2Vlp_",
	"fa-universal-access": "style_fa-universal-access__1gPZ1",
	"faUniversalAccess": "style_fa-universal-access__1gPZ1",
	"fa-wheelchair-alt": "style_fa-wheelchair-alt__PYJAx",
	"faWheelchairAlt": "style_fa-wheelchair-alt__PYJAx",
	"fa-question-circle-o": "style_fa-question-circle-o__VU9cE",
	"faQuestionCircleO": "style_fa-question-circle-o__VU9cE",
	"fa-blind": "style_fa-blind__14GsC",
	"faBlind": "style_fa-blind__14GsC",
	"fa-audio-description": "style_fa-audio-description__193tW",
	"faAudioDescription": "style_fa-audio-description__193tW",
	"fa-volume-control-phone": "style_fa-volume-control-phone__1wydK",
	"faVolumeControlPhone": "style_fa-volume-control-phone__1wydK",
	"fa-braille": "style_fa-braille__1Zz06",
	"faBraille": "style_fa-braille__1Zz06",
	"fa-assistive-listening-systems": "style_fa-assistive-listening-systems__2HSSD",
	"faAssistiveListeningSystems": "style_fa-assistive-listening-systems__2HSSD",
	"fa-asl-interpreting": "style_fa-asl-interpreting__2_Ohd",
	"faAslInterpreting": "style_fa-asl-interpreting__2_Ohd",
	"fa-american-sign-language-interpreting": "style_fa-american-sign-language-interpreting__WTHMO",
	"faAmericanSignLanguageInterpreting": "style_fa-american-sign-language-interpreting__WTHMO",
	"fa-deafness": "style_fa-deafness__1RQ5h",
	"faDeafness": "style_fa-deafness__1RQ5h",
	"fa-hard-of-hearing": "style_fa-hard-of-hearing__dxouv",
	"faHardOfHearing": "style_fa-hard-of-hearing__dxouv",
	"fa-deaf": "style_fa-deaf__gNpY3",
	"faDeaf": "style_fa-deaf__gNpY3",
	"fa-glide": "style_fa-glide__2JkuE",
	"faGlide": "style_fa-glide__2JkuE",
	"fa-glide-g": "style_fa-glide-g__7lw0r",
	"faGlideG": "style_fa-glide-g__7lw0r",
	"fa-signing": "style_fa-signing__1LBGN",
	"faSigning": "style_fa-signing__1LBGN",
	"fa-sign-language": "style_fa-sign-language__3Kh8E",
	"faSignLanguage": "style_fa-sign-language__3Kh8E",
	"fa-low-vision": "style_fa-low-vision__3kvJs",
	"faLowVision": "style_fa-low-vision__3kvJs",
	"fa-viadeo": "style_fa-viadeo__VoezI",
	"faViadeo": "style_fa-viadeo__VoezI",
	"fa-viadeo-square": "style_fa-viadeo-square__2UHUK",
	"faViadeoSquare": "style_fa-viadeo-square__2UHUK",
	"fa-snapchat": "style_fa-snapchat__2jKmj",
	"faSnapchat": "style_fa-snapchat__2jKmj",
	"fa-snapchat-ghost": "style_fa-snapchat-ghost__2xwud",
	"faSnapchatGhost": "style_fa-snapchat-ghost__2xwud",
	"fa-snapchat-square": "style_fa-snapchat-square__2ay8Y",
	"faSnapchatSquare": "style_fa-snapchat-square__2ay8Y",
	"fa-pied-piper": "style_fa-pied-piper__1cKv9",
	"faPiedPiper": "style_fa-pied-piper__1cKv9",
	"fa-first-order": "style_fa-first-order__1aHV7",
	"faFirstOrder": "style_fa-first-order__1aHV7",
	"fa-yoast": "style_fa-yoast__3l7Nw",
	"faYoast": "style_fa-yoast__3l7Nw",
	"fa-themeisle": "style_fa-themeisle__IVgBM",
	"faThemeisle": "style_fa-themeisle__IVgBM",
	"fa-google-plus-circle": "style_fa-google-plus-circle__3YTOV",
	"faGooglePlusCircle": "style_fa-google-plus-circle__3YTOV",
	"fa-google-plus-official": "style_fa-google-plus-official__3j2-g",
	"faGooglePlusOfficial": "style_fa-google-plus-official__3j2-g",
	"fa-fa": "style_fa-fa__16B4w",
	"faFa": "style_fa-fa__16B4w",
	"fa-font-awesome": "style_fa-font-awesome__a8j_I",
	"faFontAwesome": "style_fa-font-awesome__a8j_I",
	"fa-handshake-o": "style_fa-handshake-o__14uNQ",
	"faHandshakeO": "style_fa-handshake-o__14uNQ",
	"fa-envelope-open": "style_fa-envelope-open__1mSeC",
	"faEnvelopeOpen": "style_fa-envelope-open__1mSeC",
	"fa-envelope-open-o": "style_fa-envelope-open-o__3IpGG",
	"faEnvelopeOpenO": "style_fa-envelope-open-o__3IpGG",
	"fa-linode": "style_fa-linode__3MNS1",
	"faLinode": "style_fa-linode__3MNS1",
	"fa-address-book": "style_fa-address-book__3-Qpd",
	"faAddressBook": "style_fa-address-book__3-Qpd",
	"fa-address-book-o": "style_fa-address-book-o__aCKzG",
	"faAddressBookO": "style_fa-address-book-o__aCKzG",
	"fa-vcard": "style_fa-vcard__6M2eg",
	"faVcard": "style_fa-vcard__6M2eg",
	"fa-address-card": "style_fa-address-card__3k6ik",
	"faAddressCard": "style_fa-address-card__3k6ik",
	"fa-vcard-o": "style_fa-vcard-o__iyiuV",
	"faVcardO": "style_fa-vcard-o__iyiuV",
	"fa-address-card-o": "style_fa-address-card-o__3QTYS",
	"faAddressCardO": "style_fa-address-card-o__3QTYS",
	"fa-user-circle": "style_fa-user-circle__1_cde",
	"faUserCircle": "style_fa-user-circle__1_cde",
	"fa-user-circle-o": "style_fa-user-circle-o__2YUao",
	"faUserCircleO": "style_fa-user-circle-o__2YUao",
	"fa-user-o": "style_fa-user-o__1V2Up",
	"faUserO": "style_fa-user-o__1V2Up",
	"fa-id-badge": "style_fa-id-badge__1CYVn",
	"faIdBadge": "style_fa-id-badge__1CYVn",
	"fa-drivers-license": "style_fa-drivers-license__e2Mlt",
	"faDriversLicense": "style_fa-drivers-license__e2Mlt",
	"fa-id-card": "style_fa-id-card__3sBIr",
	"faIdCard": "style_fa-id-card__3sBIr",
	"fa-drivers-license-o": "style_fa-drivers-license-o__QjBUI",
	"faDriversLicenseO": "style_fa-drivers-license-o__QjBUI",
	"fa-id-card-o": "style_fa-id-card-o__24M2v",
	"faIdCardO": "style_fa-id-card-o__24M2v",
	"fa-quora": "style_fa-quora__3pF-w",
	"faQuora": "style_fa-quora__3pF-w",
	"fa-free-code-camp": "style_fa-free-code-camp__mJ0F4",
	"faFreeCodeCamp": "style_fa-free-code-camp__mJ0F4",
	"fa-telegram": "style_fa-telegram__1SQJJ",
	"faTelegram": "style_fa-telegram__1SQJJ",
	"fa-thermometer-4": "style_fa-thermometer-4__18hgc",
	"faThermometer4": "style_fa-thermometer-4__18hgc",
	"fa-thermometer": "style_fa-thermometer__2FEkA",
	"faThermometer": "style_fa-thermometer__2FEkA",
	"fa-thermometer-full": "style_fa-thermometer-full__zru6l",
	"faThermometerFull": "style_fa-thermometer-full__zru6l",
	"fa-thermometer-3": "style_fa-thermometer-3__2zo1R",
	"faThermometer3": "style_fa-thermometer-3__2zo1R",
	"fa-thermometer-three-quarters": "style_fa-thermometer-three-quarters__3rjIl",
	"faThermometerThreeQuarters": "style_fa-thermometer-three-quarters__3rjIl",
	"fa-thermometer-2": "style_fa-thermometer-2__12ejr",
	"faThermometer2": "style_fa-thermometer-2__12ejr",
	"fa-thermometer-half": "style_fa-thermometer-half__2tRDU",
	"faThermometerHalf": "style_fa-thermometer-half__2tRDU",
	"fa-thermometer-1": "style_fa-thermometer-1__24a3O",
	"faThermometer1": "style_fa-thermometer-1__24a3O",
	"fa-thermometer-quarter": "style_fa-thermometer-quarter__f5Fhv",
	"faThermometerQuarter": "style_fa-thermometer-quarter__f5Fhv",
	"fa-thermometer-0": "style_fa-thermometer-0__3739I",
	"faThermometer0": "style_fa-thermometer-0__3739I",
	"fa-thermometer-empty": "style_fa-thermometer-empty__1SOIG",
	"faThermometerEmpty": "style_fa-thermometer-empty__1SOIG",
	"fa-shower": "style_fa-shower__2wAa7",
	"faShower": "style_fa-shower__2wAa7",
	"fa-bathtub": "style_fa-bathtub__1i6ao",
	"faBathtub": "style_fa-bathtub__1i6ao",
	"fa-s15": "style_fa-s15__24ar6",
	"faS15": "style_fa-s15__24ar6",
	"fa-bath": "style_fa-bath__aZawX",
	"faBath": "style_fa-bath__aZawX",
	"fa-podcast": "style_fa-podcast__lVPTY",
	"faPodcast": "style_fa-podcast__lVPTY",
	"fa-window-maximize": "style_fa-window-maximize__2RO54",
	"faWindowMaximize": "style_fa-window-maximize__2RO54",
	"fa-window-minimize": "style_fa-window-minimize__3IN2X",
	"faWindowMinimize": "style_fa-window-minimize__3IN2X",
	"fa-window-restore": "style_fa-window-restore__3QFHb",
	"faWindowRestore": "style_fa-window-restore__3QFHb",
	"fa-times-rectangle": "style_fa-times-rectangle__BvQG5",
	"faTimesRectangle": "style_fa-times-rectangle__BvQG5",
	"fa-window-close": "style_fa-window-close__2mrEp",
	"faWindowClose": "style_fa-window-close__2mrEp",
	"fa-times-rectangle-o": "style_fa-times-rectangle-o__wCN68",
	"faTimesRectangleO": "style_fa-times-rectangle-o__wCN68",
	"fa-window-close-o": "style_fa-window-close-o__3apzx",
	"faWindowCloseO": "style_fa-window-close-o__3apzx",
	"fa-bandcamp": "style_fa-bandcamp__HoVp0",
	"faBandcamp": "style_fa-bandcamp__HoVp0",
	"fa-grav": "style_fa-grav__3c47r",
	"faGrav": "style_fa-grav__3c47r",
	"fa-etsy": "style_fa-etsy__2I3s2",
	"faEtsy": "style_fa-etsy__2I3s2",
	"fa-imdb": "style_fa-imdb__vfJgy",
	"faImdb": "style_fa-imdb__vfJgy",
	"fa-ravelry": "style_fa-ravelry__1zUZZ",
	"faRavelry": "style_fa-ravelry__1zUZZ",
	"fa-eercast": "style_fa-eercast__3WehH",
	"faEercast": "style_fa-eercast__3WehH",
	"fa-microchip": "style_fa-microchip__1OQ4R",
	"faMicrochip": "style_fa-microchip__1OQ4R",
	"fa-snowflake-o": "style_fa-snowflake-o__2yftS",
	"faSnowflakeO": "style_fa-snowflake-o__2yftS",
	"fa-superpowers": "style_fa-superpowers__3oE6q",
	"faSuperpowers": "style_fa-superpowers__3oE6q",
	"fa-wpexplorer": "style_fa-wpexplorer__2Fz14",
	"faWpexplorer": "style_fa-wpexplorer__2Fz14",
	"fa-meetup": "style_fa-meetup__3VCYC",
	"faMeetup": "style_fa-meetup__3VCYC",
	"sr-only": "style_sr-only__28X0u",
	"srOnly": "style_sr-only__28X0u",
	"sr-only-focusable": "style_sr-only-focusable__3hrEM",
	"srOnlyFocusable": "style_sr-only-focusable__3hrEM",
	"monospace": "style_monospace__3wtSm",
	"text": "style_text__2pyMd",
	"container": "style_container__1dFxU",
	"monospacedText": "style_monospacedText__1120V"
};

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1517);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_filterField__2Hghd{position:relative;display:inline-block}.style_filterField__2Hghd .style_searchIcon__xNH7f{position:absolute;right:0;top:10px;width:1.5rem;height:1.5rem}.style_filterTextBoxStandardWidth__1ZsgI{width:15.6rem!important}.style_filterTextBoxFullWidth__x0qya{width:100%!important}", ""]);

// exports
exports.locals = {
	"filterField": "style_filterField__2Hghd",
	"searchIcon": "style_searchIcon__xNH7f",
	"filterTextBoxStandardWidth": "style_filterTextBoxStandardWidth__1ZsgI",
	"filterTextBoxFullWidth": "style_filterTextBoxFullWidth__x0qya"
};

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1519);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__12oKq{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2Rcor{display:none!important}}@media (max-width:79.9rem){.style_hide-md__361fe{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2Sczv{display:none!important}}h1{font-size:1.625rem;font-weight:400}@media (max-width:37.4rem){h1{font-size:1.4375rem}}h2{font-size:1.25rem;font-weight:400}@media (max-width:37.4rem){h2{font-size:1.0625rem}}h3{font-size:1.125rem;font-weight:400}@media (max-width:37.4rem){h3{font-size:1.0625rem}}h4{font-size:1.0625rem;font-weight:500;margin:1rem 0 .5rem}h5{font-size:.8125rem;font-weight:400}hr{display:block;height:.0625rem;border:0;border-top:.0625rem solid #ccc;margin:1em 0;padding:0}a{color:#2f93e0}a:hover{color:#0a67b1}p{margin:1rem 0;color:#333}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset!important}input::-ms-clear{width:0;height:0}small{font-size:.875rem;line-height:1.1875rem}.style_secondary__OlUSy{color:#9e9e9e}.style_section__2Jp-W{flex-grow:1}.style_sectionHeader__1WJUP{padding:0 1rem;margin:.5rem 0}.style_sectionBody__2cABV{padding:0 1rem;color:#666;font-size:.875rem}.style_sectionBody__2cABV p{color:#333}.style_sectionNoHeader__2GCHR{margin:.5rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__12oKq",
	"hideSm": "style_hide-sm__12oKq",
	"visible-sm": "style_visible-sm__2Rcor",
	"visibleSm": "style_visible-sm__2Rcor",
	"hide-md": "style_hide-md__361fe",
	"hideMd": "style_hide-md__361fe",
	"visible-md": "style_visible-md__2Sczv",
	"visibleMd": "style_visible-md__2Sczv",
	"secondary": "style_secondary__OlUSy",
	"section": "style_section__2Jp-W",
	"sectionHeader": "style_sectionHeader__1WJUP",
	"sectionBody": "style_sectionBody__2cABV",
	"sectionNoHeader": "style_sectionNoHeader__2GCHR"
};

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1521);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_listItem__20dF_{padding:1.25rem;font-size:.875rem!important}.style_listItem__20dF_>div:first-child{padding:0!important}.style_listItem__20dF_>div:first-child>div:first-child{padding:.875rem 1rem!important}.style_emptyList__Jfq7l{padding:.5rem 1rem;font-size:.875rem;color:#9e9e9e}.style_pagingControlContainer__uFwzY{margin:1.5rem 1rem}.style_disablePagingEvents__NzHoU{pointer-events:none}.style_loadMoreContainer__38w3G{padding:1rem}.style_loadMoreActions__2AGP7{display:flex;justify-content:center;text-align:center;flex-direction:column;align-items:center}.style_loadMoreSubText__2PJQD{font-size:.75rem}", ""]);

// exports
exports.locals = {
	"listItem": "style_listItem__20dF_",
	"emptyList": "style_emptyList__Jfq7l",
	"pagingControlContainer": "style_pagingControlContainer__uFwzY",
	"disablePagingEvents": "style_disablePagingEvents__NzHoU",
	"loadMoreContainer": "style_loadMoreContainer__38w3G",
	"loadMoreActions": "style_loadMoreActions__2AGP7",
	"loadMoreSubText": "style_loadMoreSubText__2PJQD"
};

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_listItem__2xFzu{padding:1.25rem;word-wrap:break-word;font-size:.875rem!important}.style_listItem__2xFzu:hover{background-color:hsla(0,0%,60%,.08)!important}.style_listItem__2xFzu>div:first-child{padding:0!important}.style_listItem__2xFzu>div:first-child>div:first-child{padding:.875rem 1rem!important}.style_emptyList__3wyfm{padding:.5rem 1rem;font-size:.875rem;color:#9e9e9e}.style_loadMore__1aFgx{text-align:center}.style_pagingControlContainer__HVBB1{margin:1.5rem 1rem}.style_disablePagingEvents__1U2Kg{pointer-events:none}", ""]);

// exports
exports.locals = {
	"listItem": "style_listItem__2xFzu",
	"emptyList": "style_emptyList__3wyfm",
	"loadMore": "style_loadMore__1aFgx",
	"pagingControlContainer": "style_pagingControlContainer__HVBB1",
	"disablePagingEvents": "style_disablePagingEvents__1U2Kg"
};

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1524);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_linkableItem__4eNnA{cursor:pointer}", ""]);

// exports
exports.locals = {
	"linkableItem": "style_linkableItem__4eNnA"
};

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1526);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_topMargin__t0_A5{margin-top:1rem;width:100%}.style_title__1j5K0{color:rgba(0,0,0,.3);font-size:.75rem;font-weight:400;margin-bottom:.25rem}.style_checkboxNote__1BltZ{margin-left:40px}.style_message__10cC8{font-size:.75rem}.style_message__10cC8 hr{border-width:2px;margin-bottom-width:.25rem}", ""]);

// exports
exports.locals = {
	"topMargin": "style_topMargin__t0_A5",
	"title": "style_title__1j5K0",
	"checkboxNote": "style_checkboxNote__1BltZ",
	"message": "style_message__10cC8"
};

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1528);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_label__n7Byj{color:#9e9e9e;font-size:.8125rem;font-weight:400;margin-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"label": "style_label__n7Byj"
};

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(33);
var transitions_1 = __webpack_require__(28);
var arrow_drop_down_1 = __webpack_require__(387);
var clear_1 = __webpack_require__(204);
var Menu_1 = __webpack_require__(1530);
var ClearFix_1 = __webpack_require__(615);
var Popover_1 = __webpack_require__(149);
var PopoverAnimationVertical_1 = __webpack_require__(276);
var keycode = __webpack_require__(59);
var events_1 = __webpack_require__(222);
var IconButton_1 = __webpack_require__(67);
var fontWeights_1 = __webpack_require__(83);
function getStyles(props, context) {
    var disabled = props.disabled;
    var spacing = context.muiTheme.baseTheme.spacing;
    var palette = context.muiTheme.baseTheme.palette;
    var accentColor = context.muiTheme.dropDownMenu.accentColor;
    return {
        control: {
            cursor: disabled ? "not-allowed" : "pointer",
            height: "100%",
            position: "relative",
            width: "100%",
        },
        icon: {
            fill: accentColor,
            width: "1.5rem",
            height: "1.5rem",
            padding: 0
        },
        iconChildren: {
            fill: "inherit",
        },
        label: {
            color: disabled ? palette.disabledColor : palette.textColor,
            height: spacing.desktopToolbarHeight + "px",
            lineHeight: spacing.desktopToolbarHeight + "px",
            overflow: "hidden",
            opacity: 1,
            position: "relative",
            paddingLeft: spacing.desktopGutter,
            paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
            textOverflow: "ellipsis",
            top: 0,
            whiteSpace: "nowrap",
        },
        labelWhenOpen: {
            opacity: 0,
            top: (spacing.desktopToolbarHeight / 8),
        },
        root: {
            display: "inline-block",
            fontSize: spacing.desktopDropDownMenuFontSize,
            height: spacing.desktopSubheaderHeight,
            fontFamily: context.muiTheme.baseTheme.fontFamily,
            outline: "none",
            position: "relative",
            transition: transitions_1.default.easeOut(),
        },
        rootWhenOpen: {
            opacity: 1,
        },
        underline: {
            borderTop: "solid 0.0625rem " + accentColor,
            bottom: 1,
            left: 0,
            margin: "-0.0625rem " + spacing.desktopGutter + "px",
            right: 0,
            position: "absolute",
        },
        buttons: {
            position: "absolute",
            right: 0,
            top: 13 / fontWeights_1.baseSizeInPx + "rem"
        }
    };
}
var DropDownMenu = (function (_super) {
    __extends(DropDownMenu, _super);
    function DropDownMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            anchorEl: null
        };
        _this.rootNode = undefined;
        _this.arrowNode = undefined;
        _this.handleTouchTapControl = function (event) {
            event.preventDefault();
            if (!_this.props.disabled) {
                _this.setState({
                    open: !_this.state.open,
                    anchorEl: _this.rootNode,
                });
            }
        };
        _this.handleRequestCloseMenu = function () {
            _this.close(false);
        };
        _this.handleEscKeyDownMenu = function () {
            _this.close(true);
        };
        _this.handleKeyDown = function (event) {
            switch (keycode(event)) {
                case "up":
                case "down":
                case "space":
                case "enter":
                    event.preventDefault();
                    _this.setState({
                        open: true,
                        anchorEl: _this.rootNode,
                    });
                    break;
            }
        };
        _this.handleClearTouchTap = function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (_this.props.onChange) {
                _this.props.onChange(event, undefined, "");
            }
        };
        _this.handleFilterKeyDown = function (event) {
            switch (keycode(event)) {
                case "esc":
                    _this.close(true);
                    break;
                case "down":
                    if (_this.menu && React.Children.count(_this.props.children) > 0) {
                        event.preventDefault();
                        _this.menu.setFocusIndex(event, 0, true);
                    }
                    break;
            }
        };
        _this.handleItemTouchTap = function (event, child, index) {
            if (_this.props.multiple) {
                if (!_this.state.open) {
                    _this.setState({ open: true });
                }
            }
            else {
                event.persist();
                event.preventDefault();
                _this.setState({
                    open: false,
                }, function () {
                    if (_this.props.onChange) {
                        _this.props.onChange(event, index, child.props.value);
                    }
                    _this.close(events_1.default.isKeyboard(event));
                });
            }
        };
        _this.handleChange = function (event, value) {
            if (_this.props.multiple && _this.props.onChange) {
                _this.props.onChange(event, undefined, value);
            }
        };
        _this.close = function (isKeyboard) {
            _this.setState({
                open: false,
            }, function () {
                if (_this.props.onClose) {
                    _this.props.onClose();
                }
                if (isKeyboard) {
                    var dropArrow = _this.arrowNode;
                    var dropNode = ReactDOM.findDOMNode(dropArrow);
                    dropNode.focus();
                    dropArrow.setKeyboardFocus(true);
                }
            });
        };
        return _this;
    }
    DropDownMenu.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.autoWidth) {
            this.setWidth();
        }
        if (this.props.openImmediately) {
            // TODO: Temporary fix to make openImmediately work with popover.
            /* eslint-disable react/no-did-mount-set-state */
            setTimeout(function () { return _this.setState({
                open: true,
                anchorEl: _this.rootNode,
            }); }, 0);
            /* eslint-enable react/no-did-mount-set-state */
        }
        if (this.props.autoFocus) {
            // this focuses
            this.close(true);
        }
    };
    DropDownMenu.prototype.componentWillReceiveProps = function () {
        if (this.props.autoWidth) {
            this.setWidth();
        }
    };
    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    DropDownMenu.prototype.getInputNode = function () {
        var _this = this;
        var rootNode = this.rootNode;
        rootNode.focus = function () {
            if (!_this.props.disabled) {
                _this.setState({
                    open: !_this.state.open,
                    anchorEl: _this.rootNode,
                });
            }
        };
        return rootNode;
    };
    DropDownMenu.prototype.setWidth = function () {
        var el = this.rootNode;
        if (!this.props.style || !this.props.style.hasOwnProperty("width")) {
            el.style.width = "auto";
        }
    };
    DropDownMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, animated = _a.animated, animation = _a.animation, autoWidth = _a.autoWidth, multiple = _a.multiple, children = _a.children, className = _a.className, disabled = _a.disabled, iconStyle = _a.iconStyle, labelStyle = _a.labelStyle, listStyle = _a.listStyle, maxHeight = _a.maxHeight, menuStyleProp = _a.menuStyle, selectionRenderer = _a.selectionRenderer, onClose = _a.onClose, // eslint-disable-line no-unused-vars
        openImmediately = _a.openImmediately, // eslint-disable-line no-unused-vars
        menuItemStyle = _a.menuItemStyle, selectedMenuItemStyle = _a.selectedMenuItemStyle, style = _a.style, underlineStyle = _a.underlineStyle, value = _a.value, iconButton = _a.iconButton, anchorOrigin = _a.anchorOrigin, targetOrigin = _a.targetOrigin, allowClear = _a.allowClear, other = __rest(_a, ["animated", "animation", "autoWidth", "multiple", "children", "className", "disabled", "iconStyle", "labelStyle", "listStyle", "maxHeight", "menuStyle", "selectionRenderer", "onClose", "openImmediately", "menuItemStyle", "selectedMenuItemStyle", "style", "underlineStyle", "value", "iconButton", "anchorOrigin", "targetOrigin", "allowClear"]);
        var _b = this.state, anchorEl = _b.anchorEl, open = _b.open;
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context);
        var displayValue = "";
        if (!multiple) {
            React.Children.forEach(children, function (child) {
                if (child && value === child.props.value) {
                    if (selectionRenderer) {
                        displayValue = selectionRenderer(value, child);
                    }
                    else {
                        // This will need to be improved (in case primaryText is a node)
                        displayValue = child.props.label || child.props.primaryText;
                    }
                }
            });
        }
        else {
            var values_1 = [];
            var selectionRendererChildren_1 = [];
            React.Children.forEach(children, function (child) {
                if (child && value && value.indexOf(child.props.value) > -1) {
                    if (selectionRenderer) {
                        values_1.push(child.props.value);
                        selectionRendererChildren_1.push(child);
                    }
                    else {
                        values_1.push(child.props.label || child.props.primaryText);
                    }
                }
            });
            displayValue = "";
            if (selectionRenderer) {
                displayValue = selectionRenderer(values_1, selectionRendererChildren_1);
            }
            else {
                displayValue = values_1.join(", ");
            }
        }
        var menuStyle;
        if (anchorEl && !autoWidth) {
            menuStyle = Object.assign({
                width: anchorEl.clientWidth,
            }, menuStyleProp);
        }
        else {
            menuStyle = menuStyleProp;
        }
        return (React.createElement("div", __assign({}, other, { ref: function (node) {
                _this.rootNode = node;
            }, className: className, style: prepareStyles(Object.assign({}, styles.root, open && styles.rootWhenOpen, style)) }),
            React.createElement(ClearFix_1.default, { style: styles.control, onClick: this.handleTouchTapControl },
                React.createElement("div", { style: prepareStyles(Object.assign({}, styles.label, open && styles.labelWhenOpen, labelStyle)) }, displayValue),
                React.createElement("div", { style: styles.buttons },
                    allowClear && value && React.createElement(IconButton_1.default, { onFocus: function (e) { e.preventDefault(); e.stopPropagation(); }, disabled: disabled, onClick: this.handleClearTouchTap, style: Object.assign({}, styles.icon, iconStyle), iconStyle: styles.iconChildren },
                        React.createElement(clear_1.default, null)),
                    React.createElement(IconButton_1.default, { disabled: disabled, onKeyDown: this.handleKeyDown, ref: function (node) {
                            _this.arrowNode = node;
                        }, style: Object.assign({}, styles.icon, iconStyle), iconStyle: styles.iconChildren }, iconButton)),
                React.createElement("div", { style: prepareStyles(Object.assign({}, styles.underline, underlineStyle)) })),
            React.createElement(Popover_1.default, { anchorOrigin: anchorOrigin, targetOrigin: targetOrigin, anchorEl: anchorEl, animation: animation || PopoverAnimationVertical_1.default, open: open, animated: animated, onRequestClose: this.handleRequestCloseMenu },
                this.props.filter && React.createElement("div", { onKeyDown: this.handleFilterKeyDown }, this.props.filter),
                React.createElement(Menu_1.default, { ref: function (menu) { return _this.menu = menu; }, disableAutoFocus: this.props.filter && true, multiple: multiple, maxHeight: maxHeight, desktop: true, value: value, onEscKeyDown: this.handleEscKeyDownMenu, style: menuStyle, listStyle: listStyle, onItemTouchTap: this.handleItemTouchTap, onChange: this.handleChange, menuItemStyle: menuItemStyle, selectedMenuItemStyle: selectedMenuItemStyle, autoWidth: autoWidth, width: !autoWidth && menuStyle ? menuStyle.width : null }, children))));
    };
    DropDownMenu.muiName = "DropDownMenu";
    // The nested styles for drop-down-menu are modified by toolbar and possibly
    // other user components, so it will give full access to its js styles rather
    // than just the parent.
    // static propTypes = {
    //   /**
    //    * This is the point on the anchor that the popover"s
    //    * `targetOrigin` will attach to.
    //    * Options:
    //    * vertical: [top, center, bottom]
    //    * horizontal: [left, middle, right].
    //    */
    //   anchorOrigin: propTypes.origin,
    //   /**
    //    * If true, the popover will apply transitions when
    //    * it gets added to the DOM.
    //    */
    //   animated: PropTypes.bool,
    //   /**
    //    * Override the default animation component used.
    //    */
    //   animation: PropTypes.func,
    //   /**
    //    * The width will automatically be set according to the items inside the menu.
    //    * To control this width in css instead, set this prop to `false`.
    //    */
    //   autoWidth: PropTypes.bool,
    //   /**
    //    * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
    //    * prop `label` that value will be used to render the representation of that
    //    * item within the field.
    //    */
    //   children: PropTypes.node,
    //   /**
    //    * The css class name of the root element.
    //    */
    //   className: PropTypes.string,
    //   /**
    //    * Disables the menu.
    //    */
    //   disabled: PropTypes.bool,
    //   /**
    //    * Overrides default `SvgIcon` dropdown arrow component.
    //    */
    //   iconButton: PropTypes.node,
    //   /**
    //    * Overrides the styles of icon element.
    //    */
    //   iconStyle: PropTypes.object,
    //   /**
    //    * Overrides the styles of label when the `DropDownMenu` is inactive.
    //    */
    //   labelStyle: PropTypes.object,
    //   /**
    //    * The style object to use to override underlying list style.
    //    */
    //   listStyle: PropTypes.object,
    //   /**
    //    * The maximum height of the `Menu` when it is displayed.
    //    */
    //   maxHeight: PropTypes.number,
    //   /**
    //    * Override the inline-styles of menu items.
    //    */
    //   menuItemStyle: PropTypes.object,
    //   /**
    //    * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
    //    */
    //   menuStyle: PropTypes.object,
    //   /**
    //    * If true, `value` must be an array and the menu will support
    //    * multiple selections.
    //    */
    //   multiple: PropTypes.bool,
    //   /**
    //    * Callback function fired when a menu item is clicked, other than the one currently selected.
    //    *
    //    * @param {object} event TouchTap event targeting the menu item that was clicked.
    //    * @param {number} key The index of the clicked menu item in the `children` collection.
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    */
    //   onChange: PropTypes.func,
    //   /**
    //    * Callback function fired when the menu is closed.
    //    */
    //   onClose: PropTypes.func,
    //   /**
    //    * Set to true to have the `DropDownMenu` automatically open on mount.
    //    */
    //   openImmediately: PropTypes.bool,
    //   /**
    //    * Override the inline-styles of selected menu items.
    //    */
    //   selectedMenuItemStyle: PropTypes.object,
    //   /**
    //    * Callback function fired when a menu item is clicked, other than the one currently selected.
    //    *
    //    * @param {any} value If `multiple` is true, the menu"s `value`
    //    * array with either the menu item"s `value` added (if
    //    * it wasn"t already selected) or omitted (if it was already selected).
    //    * Otherwise, the `value` of the menu item.
    //    * @param {any} menuItem The selected `MenuItem`.
    //    * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
    //    */
    //   selectionRenderer: PropTypes.func,
    //   /**
    //    * Override the inline-styles of the root element.
    //    */
    //   style: PropTypes.object,
    //   /**
    //    * This is the point on the popover which will attach to
    //    * the anchor"s origin.
    //    * Options:
    //    * vertical: [top, center, bottom]
    //    * horizontal: [left, middle, right].
    //    */
    //   targetOrigin: propTypes.origin,
    //   /**
    //    * Overrides the inline-styles of the underline.
    //    */
    //   underlineStyle: PropTypes.object,
    //   /**
    //    * If `multiple` is true, an array of the `value`s of the selected
    //    * menu items. Otherwise, the `value` of the selected menu item.
    //    * If provided, the menu will be a controlled component.
    //    */
    //   value: PropTypes.any,
    //   filter: PropTypes.node,
    // };
    DropDownMenu.defaultProps = {
        animated: true,
        autoWidth: true,
        disabled: false,
        iconButton: React.createElement(arrow_drop_down_1.default, null),
        openImmediately: false,
        maxHeight: 500,
        multiple: false,
        allowClear: false,
        anchorOrigin: {
            vertical: "top",
            horizontal: "left",
        },
    };
    DropDownMenu.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return DropDownMenu;
}(React.Component));
exports.default = DropDownMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\DropDownMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Select\\DropDownMenu.tsx"); } } })();

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var ReactDOM = __webpack_require__(33);
var recompose_1 = __webpack_require__(186);
var ClickAwayListener_1 = __webpack_require__(273);
var keycode = __webpack_require__(59);
var List_1 = __webpack_require__(325);
var menuUtils_1 = __webpack_require__(602);
function getStyles(props, context) {
    var desktop = props.desktop, maxHeight = props.maxHeight, width = props.width;
    var muiTheme = context.muiTheme;
    var styles = {
        root: {
            // Nested div because the List scales x faster than it scales y
            zIndex: muiTheme.zIndex.menu,
            maxHeight: maxHeight,
            overflowY: maxHeight ? 'auto' : null,
        },
        divider: {
            marginTop: 7,
            marginBottom: 8,
        },
        list: {
            display: 'table-cell',
            paddingBottom: desktop ? 16 : 8,
            paddingTop: desktop ? 16 : 8,
            userSelect: 'none',
            width: width,
        },
        selectedMenuItem: {
            color: muiTheme.menuItem.selectedTextColor,
        },
    };
    return styles;
}
var Menu = (function (_super) {
    __extends(Menu, _super);
    function Menu(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleClickAway = function (event) {
            if (event.defaultPrevented) {
                return;
            }
            var focusIndex = _this.state.focusIndex;
            if (focusIndex < 0) {
                return;
            }
            var filteredChildren = _this.getFilteredChildren(_this.props.children);
            var focusedItem = filteredChildren[focusIndex];
            if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
                return;
            }
            _this.setFocusIndex(event, -1, false);
        };
        _this.handleKeyDown = function (event) {
            var filteredChildren = _this.getFilteredChildren(_this.props.children);
            var key = keycode(event);
            switch (key) {
                case 'down':
                    event.preventDefault();
                    _this.incrementKeyboardFocusIndex(event, filteredChildren);
                    break;
                case 'esc':
                    _this.props.onEscKeyDown(event);
                    break;
                case 'tab':
                    event.preventDefault();
                    if (event.shiftKey) {
                        _this.decrementKeyboardFocusIndex(event);
                    }
                    else {
                        _this.incrementKeyboardFocusIndex(event, filteredChildren);
                    }
                    break;
                case 'up':
                    event.preventDefault();
                    _this.decrementKeyboardFocusIndex(event);
                    break;
                default:
                    if (key && key.length === 1) {
                        var hotKeys = _this.hotKeyHolder.append(key);
                        if (_this.setFocusIndexStartsWith(event, hotKeys)) {
                            event.preventDefault();
                        }
                    }
            }
            _this.props.onKeyDown(event);
        };
        _this.handleOnWheel = function (event) {
            var scrollContainer = _this.refs.scrollContainer;
            // Only scroll lock if the the Menu is scrollable.
            if (scrollContainer.scrollHeight <= scrollContainer.clientHeight)
                return;
            var scrollTop = scrollContainer.scrollTop, scrollHeight = scrollContainer.scrollHeight, clientHeight = scrollContainer.clientHeight;
            var wheelDelta = event.deltaY;
            var isDeltaPositive = wheelDelta > 0;
            if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
                scrollContainer.scrollTop = scrollHeight;
                return _this.cancelScrollEvent(event);
            }
            else if (!isDeltaPositive && -wheelDelta > scrollTop) {
                scrollContainer.scrollTop = 0;
                return _this.cancelScrollEvent(event);
            }
        };
        var filteredChildren = _this.getFilteredChildren(props.children);
        var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
        var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
        if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
            props.onMenuItemFocusChange(null, newFocusIndex);
        }
        _this.state = {
            focusIndex: newFocusIndex,
            isKeyboardFocused: props.initiallyKeyboardFocused,
            keyWidth: props.desktop ? 64 : 56,
        };
        _this.hotKeyHolder = new menuUtils_1.HotKeyHolder();
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        if (this.props.autoWidth) {
            this.setWidth();
        }
        this.setScollPosition();
    };
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        var selectedIndex;
        var filteredChildren = this.getFilteredChildren(nextProps.children);
        selectedIndex = this.state.focusIndex;
        var fallBack = nextProps.disableAutoFocus ? -1 : 0;
        var newFocusIndex = selectedIndex >= 0 ? selectedIndex : fallBack;
        if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
            this.props.onMenuItemFocusChange(null, newFocusIndex);
        }
        this.setState({
            focusIndex: newFocusIndex,
            keyWidth: nextProps.desktop ? 64 : 56,
        });
    };
    Menu.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return (!recompose_1.shallowEqual(this.props, nextProps) ||
            !recompose_1.shallowEqual(this.state, nextState) ||
            !recompose_1.shallowEqual(this.context, nextContext));
    };
    Menu.prototype.componentDidUpdate = function () {
        if (this.props.autoWidth)
            this.setWidth();
    };
    // Do not use outside of this component, it will be removed once valueLink is deprecated
    Menu.prototype.getValueLink = function (props) {
        return props.valueLink || {
            value: props.value,
            requestChange: props.onChange,
        };
    };
    Menu.prototype.setKeyboardFocused = function (keyboardFocused) {
        this.setState({
            isKeyboardFocused: keyboardFocused,
        });
    };
    Menu.prototype.getFilteredChildren = function (children) {
        var filteredChildren = [];
        React.Children.forEach(children, function (child) {
            if (child) {
                filteredChildren.push(child);
            }
        });
        return filteredChildren;
    };
    Menu.prototype.cloneMenuItem = function (child, childIndex, styles, index) {
        var _this = this;
        var childIsDisabled = child.props.disabled;
        var selectedChildStyles = {};
        if (!childIsDisabled) {
            var selected = this.isChildSelected(child, this.props);
            if (selected) {
                Object.assign(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
            }
        }
        var mergedChildStyles = Object.assign({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
        var extraProps = {
            desktop: this.props.desktop,
            style: mergedChildStyles,
        };
        if (!childIsDisabled) {
            var isFocused = childIndex === this.state.focusIndex;
            var focusState = 'none';
            if (isFocused) {
                focusState = this.state.isKeyboardFocused ?
                    'keyboard-focused' : 'focused';
            }
            Object.assign(extraProps, {
                focusState: focusState,
                onClick: function (event) {
                    _this.handleMenuItemTouchTap(event, child, index);
                    if (child.props.onClick)
                        child.props.onClick(event);
                },
                ref: isFocused ? 'focusedMenuItem' : null,
            });
        }
        return React.cloneElement(child, extraProps);
    };
    Menu.prototype.decrementKeyboardFocusIndex = function (event) {
        var index = this.state.focusIndex;
        index--;
        if (index < 0)
            index = 0;
        this.setFocusIndex(event, index, true);
    };
    Menu.prototype.getMenuItemCount = function (filteredChildren) {
        var menuItemCount = 0;
        filteredChildren.forEach(function (child) {
            var childIsADivider = child.type && child.type.muiName === 'Divider';
            var childIsDisabled = child.props.disabled;
            if (!childIsADivider && !childIsDisabled)
                menuItemCount++;
        });
        return menuItemCount;
    };
    Menu.prototype.getLastSelectedIndex = function (props, filteredChildren) {
        var _this = this;
        var selectedIndex = -1;
        var menuItemIndex = 0;
        filteredChildren.forEach(function (child) {
            var childIsADivider = child.type && child.type.muiName === 'Divider';
            if (_this.isChildSelected(child, props))
                selectedIndex = menuItemIndex;
            if (!childIsADivider)
                menuItemIndex++;
        });
        return selectedIndex;
    };
    Menu.prototype.setFocusIndexStartsWith = function (event, keys) {
        var foundIndex = -1;
        React.Children.forEach(this.props.children, function (child, index) {
            if (foundIndex >= 0) {
                return;
            }
            var primaryText = child.props.primaryText;
            if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
                foundIndex = index;
            }
        });
        if (foundIndex >= 0) {
            this.setFocusIndex(event, foundIndex, true);
            return true;
        }
        return false;
    };
    Menu.prototype.handleMenuItemTouchTap = function (event, item, index) {
        var children = this.props.children;
        var multiple = this.props.multiple;
        var valueLink = this.getValueLink(this.props);
        var menuValue = valueLink.value;
        var itemValue = item.props.value;
        var focusIndex = React.isValidElement(children) ? 0 : children.indexOf(item);
        this.setFocusIndex(event, focusIndex, false);
        if (multiple) {
            menuValue = menuValue || [];
            var itemIndex = menuValue.indexOf(itemValue);
            var newMenuValue = menuValue.slice(0);
            if (itemIndex === -1) {
                newMenuValue.push(itemValue);
            }
            else {
                newMenuValue.splice(itemIndex, 1);
            }
            valueLink.requestChange(event, newMenuValue);
        }
        else if (!multiple && itemValue !== menuValue) {
            valueLink.requestChange(event, itemValue);
        }
        this.props.onItemTouchTap(event, item, index);
    };
    Menu.prototype.incrementKeyboardFocusIndex = function (event, filteredChildren) {
        var index = this.state.focusIndex;
        var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
        index++;
        if (index > maxIndex)
            index = maxIndex;
        this.setFocusIndex(event, index, true);
    };
    Menu.prototype.isChildSelected = function (child, props) {
        var menuValue = this.getValueLink(props).value;
        var childValue = child.props.value;
        if (props.multiple) {
            return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
        }
        else {
            return child.props.hasOwnProperty('value') && menuValue === childValue;
        }
    };
    Menu.prototype.setFocusIndex = function (event, newIndex, isKeyboardFocused) {
        if (this.props.onMenuItemFocusChange) {
            // Do this even if `newIndex === this.state.focusIndex` to allow users
            // to detect up-arrow on the first MenuItem or down-arrow on the last.
            this.props.onMenuItemFocusChange(event, newIndex);
        }
        this.setState({
            focusIndex: newIndex,
            isKeyboardFocused: isKeyboardFocused,
        });
    };
    Menu.prototype.setScollPosition = function () {
        var desktop = this.props.desktop;
        var focusedMenuItem = this.refs.focusedMenuItem;
        var menuItemHeight = desktop ? 32 : 48;
        if (focusedMenuItem) {
            var selectedOffSet = ReactDOM.findDOMNode(focusedMenuItem).offsetTop;
            // Make the focused item be the 2nd item in the list the user sees
            var scrollTop = selectedOffSet - menuItemHeight;
            if (scrollTop < menuItemHeight)
                scrollTop = 0;
            ReactDOM.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
        }
    };
    Menu.prototype.cancelScrollEvent = function (event) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    };
    Menu.prototype.setWidth = function () {
        var el = ReactDOM.findDOMNode(this);
        var listEl = ReactDOM.findDOMNode(this.refs.list);
        var elWidth = el.offsetWidth;
        var keyWidth = this.state.keyWidth;
        var minWidth = keyWidth * 1.5;
        var keyIncrements = elWidth / keyWidth;
        var newWidth;
        keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
        newWidth = keyIncrements * keyWidth;
        if (newWidth < minWidth)
            newWidth = minWidth;
        el.style.width = newWidth + "px";
        listEl.style.width = newWidth + "px";
    };
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoWidth = _a.autoWidth, // eslint-disable-line no-unused-vars
        children = _a.children, desktop = _a.desktop, // eslint-disable-line no-unused-vars
        disableAutoFocus = _a.disableAutoFocus, // eslint-disable-line no-unused-vars
        initiallyKeyboardFocused = _a.initiallyKeyboardFocused, // eslint-disable-line no-unused-vars
        listStyle = _a.listStyle, maxHeight = _a.maxHeight, // eslint-disable-line no-unused-vars
        multiple = _a.multiple, // eslint-disable-line no-unused-vars
        onItemTouchTap = _a.onItemTouchTap, // eslint-disable-line no-unused-vars
        onEscKeyDown = _a.onEscKeyDown, // eslint-disable-line no-unused-vars
        onMenuItemFocusChange = _a.onMenuItemFocusChange, // eslint-disable-line no-unused-vars
        selectedMenuItemStyle = _a.selectedMenuItemStyle, // eslint-disable-line no-unused-vars
        menuItemStyle = _a.menuItemStyle, // eslint-disable-line no-unused-vars
        style = _a.style, value = _a.value, // eslint-disable-line no-unused-vars
        valueLink = _a.valueLink, // eslint-disable-line no-unused-vars
        width = _a.width, // eslint-disable-line no-unused-vars
        other = __rest(_a, ["autoWidth", "children", "desktop", "disableAutoFocus", "initiallyKeyboardFocused", "listStyle", "maxHeight", "multiple", "onItemTouchTap", "onEscKeyDown", "onMenuItemFocusChange", "selectedMenuItemStyle", "menuItemStyle", "style", "value", "valueLink", "width"]);
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var styles = getStyles(this.props, this.context);
        var mergedRootStyles = Object.assign(styles.root, style);
        var mergedListStyles = Object.assign(styles.list, listStyle);
        var filteredChildren = this.getFilteredChildren(children);
        var menuItemIndex = 0;
        var newChildren = React.Children.map(filteredChildren, function (child, index) {
            var childIsDisabled = child.props.disabled;
            var childName = child.type ? child.type.muiName : '';
            var newChild = child;
            switch (childName) {
                case 'MenuItem':
                    newChild = _this.cloneMenuItem(child, menuItemIndex, styles, index);
                    break;
                case 'Divider':
                    newChild = React.cloneElement(child, {
                        style: Object.assign({}, styles.divider, child.props.style),
                    });
                    break;
            }
            if (childName === 'MenuItem' && !childIsDisabled) {
                menuItemIndex++;
            }
            return newChild;
        });
        return (React.createElement(ClickAwayListener_1.default, { onClickAway: this.handleClickAway },
            React.createElement("div", { onKeyDown: this.handleKeyDown, onWheel: this.handleOnWheel, style: prepareStyles(mergedRootStyles), ref: "scrollContainer", role: "presentation" },
                React.createElement(List_1.default, __assign({}, other, { ref: "list", style: mergedListStyles, role: "menu" }), newChildren))));
    };
    Menu.propTypes = {
        /**
         * If true, the width of the menu will be set automatically
         * according to the widths of its children,
         * using proper keyline increments (64px for desktop,
         * 56px otherwise).
         */
        autoWidth: PropTypes.bool,
        /**
         * The content of the menu. This is usually used to pass `MenuItem`
         * elements.
         */
        children: PropTypes.node,
        /**
         * If true, the menu item will render with compact desktop styles.
         */
        desktop: PropTypes.bool,
        /**
         * If true, the menu will not be auto-focused.
         */
        disableAutoFocus: PropTypes.bool,
        /**
         * If true, the menu will be keyboard-focused initially.
         */
        initiallyKeyboardFocused: PropTypes.bool,
        /**
         * Override the inline-styles of the underlying `List` element.
         */
        listStyle: PropTypes.object,
        /**
         * The maximum height of the menu in pixels. If specified,
         * the menu will be scrollable if it is taller than the provided
         * height.
         */
        maxHeight: PropTypes.number,
        /**
         * Override the inline-styles of menu items.
         */
        menuItemStyle: PropTypes.object,
        /**
         * If true, `value` must be an array and the menu will support
         * multiple selections.
         */
        multiple: PropTypes.bool,
        /**
         * Callback function fired when a menu item with `value` not
         * equal to the current `value` of the menu is touch-tapped.
         *
         * @param {object} event TouchTap event targeting the menu item.
         * @param {any}  value If `multiple` is true, the menu's `value`
         * array with either the menu item's `value` added (if
         * it wasn't already selected) or omitted (if it was already selected).
         * Otherwise, the `value` of the menu item.
         */
        onChange: PropTypes.func,
        /**
         * Callback function fired when the menu is focused and the *Esc* key
         * is pressed.
         *
         * @param {object} event `keydown` event targeting the menu.
         */
        onEscKeyDown: PropTypes.func,
        /**
         * Callback function fired when a menu item is touch-tapped.
         *
         * @param {object} event TouchTap event targeting the menu item.
         * @param {object} menuItem The menu item.
         * @param {number} index The index of the menu item.
         */
        onItemTouchTap: PropTypes.func,
        /** @ignore */
        onKeyDown: PropTypes.func,
        /**
         * Callback function fired when the focus on a `MenuItem` is changed.
         * There will be some "duplicate" changes reported if two different
         * focusing event happen, for example if a `MenuItem` is focused via
         * the keyboard and then it is clicked on.
         *
         * @param {object} event The event that triggered the focus change.
         * The event can be null since the focus can be changed for non-event
         * reasons such as prop changes.
         * @param {number} newFocusIndex The index of the newly focused
         * `MenuItem` or `-1` if focus was lost.
         */
        onMenuItemFocusChange: PropTypes.func,
        /**
         * Override the inline-styles of selected menu items.
         */
        selectedMenuItemStyle: PropTypes.object,
        /**
         * Override the inline-styles of the root element.
         */
        style: PropTypes.object,
        /**
         * If `multiple` is true, an array of the `value`s of the selected
         * menu items. Otherwise, the `value` of the selected menu item.
         * If provided, the menu will be a controlled component.
         * This component also supports valueLink.
         */
        value: PropTypes.any,
        /**
         * ValueLink for the menu's `value`.
         */
        valueLink: PropTypes.object,
        /**
         * The width of the menu. If not specified, the menu's width
         * will be set according to the widths of its children, using
         * proper keyline increments (64px for desktop, 56px otherwise).
         */
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    };
    Menu.defaultProps = {
        autoWidth: true,
        desktop: false,
        disableAutoFocus: false,
        initiallyKeyboardFocused: false,
        //maxHeight: null,
        multiple: false,
        onChange: function () { },
        onEscKeyDown: function () { },
        onItemTouchTap: function () { },
        onKeyDown: function () { },
    };
    Menu.contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    return Menu;
}(React.Component));
exports.default = Menu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\Menu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\Menu.tsx"); } } })();

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1532);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_select__2_RsT{width:100%!important;min-width:0!important;overflow:visible;display:block!important}.style_filter__2glUo{margin:0 1rem}.style_container__3SU6A{width:100%}", ""]);

// exports
exports.locals = {
	"select": "style_select__2_RsT",
	"filter": "style_filter__2glUo",
	"container": "style_container__3SU6A"
};

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(60);
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var FilterSearchBox_1 = __webpack_require__(316);
var List_1 = __webpack_require__(325);
var clientInstance_1 = __webpack_require__(10);
var Popover_1 = __webpack_require__(246);
var scriptingLanguage_1 = __webpack_require__(157);
var styles = __webpack_require__(1534);
var IconButton_1 = __webpack_require__(52);
var insertVariableIcon = __webpack_require__(1551);
var InsertVariableButton = (function (_super) {
    __extends(InsertVariableButton, _super);
    function InsertVariableButton(props) {
        var _this = _super.call(this, props) || this;
        _this.showInsertPopup = function (event) {
            event.preventDefault();
            _this.setState({
                isInsertPopupOpen: true
            });
        };
        _this.hideInsertPopup = function () {
            _this.setState({
                isInsertPopupOpen: false
            });
        };
        _this.handleSelected = function (value, delimit) {
            var delimited = delimit ? _this.delimit(value) : value;
            _this.props.onSelected(delimited);
            _this.hideInsertPopup();
        };
        _this.onKeyDown = function (event) {
            if (event.keyCode === 27 /*esc*/) {
                _this.setState({ isInsertPopupOpen: false });
            }
        };
        _this.setRef = function (el) {
            _this.showInsertPopupButton = el;
        };
        _this.delimit = function (varname) {
            var syntax = _this.props.syntax;
            if (!syntax) {
                return "#{" + varname + "}";
            }
            // Some escaping is probably required here.
            if (syntax === scriptingLanguage_1.ScriptingLanguage.PowerShell) {
                if (varname.match(/^[A-z0-9]+$/)) {
                    return "$" + varname;
                }
                else {
                    return "$OctopusParameters[\"" + varname + "\"]";
                }
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.CSharp) {
                return "Octopus.Parameters[\"" + varname + "\"]";
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.Bash) {
                return "get_octopusvariable \"" + varname + "\"";
            }
            if (syntax === scriptingLanguage_1.ScriptingLanguage.FSharp) {
                return "Octopus.findVariable \"" + varname + "\"";
            }
            return varname;
        };
        _this.getFunctions = function () {
            return _this.getLanguageFunctions()
                .concat([
                "#{if VariableName}value_if_true#{/if}",
                "#{unless VariableName}value_if_false#{/unless}",
                "#{each item in VariablePrefix}#{item.Postfix}#{/each}",
                "#{each number in NumberArrayVariable}#{number}#{/each}",
                "#{each item in JsonObjectVariable}#{item.Key}: #{item.Value.Property}#{/each}",
                "#{ VariableName | HtmlEscape }",
                "#{ VariableName | JsonEscape }",
                "#{ VariableName | XmlEscape }",
                "#{ VariableName | Markdown }",
                "#{ VariableName | ToLower }",
                "#{ VariableName | ToUpper }",
                "#{ | NowDate }",
                "#{ | NowDateUtc }",
                "#{ | NowDate \\\"HH dd-MMM-yyyy\\\" }",
                "#{ | NowDate zz }",
                "#{ | NowDate #{MyFormat} }",
                "#{ VariableName | Format C}"
            ]);
        };
        _this.getLanguageFunctions = function () {
            switch (_this.props.syntax) {
                case scriptingLanguage_1.ScriptingLanguage.PowerShell:
                    return [
                        "New-OctopusArtifact",
                        "Set-OctopusVariable",
                        "Fail-Step",
                        "Write-Verbose",
                        "Write-Highlight",
                        "Write-Wait",
                        "Write-Warning",
                        "New-OctopusAzureServicePrincipalAccount",
                        "New-OctopusAzureWebAppTarget",
                        "New-OctopusAzureServiceFabricTarget",
                        "New-OctopusAzureCloudServiceTarget",
                        "Remove-OctopusTarget",
                    ];
                case scriptingLanguage_1.ScriptingLanguage.Bash:
                    return [
                        "new_octopusartifact",
                        "set_octopusvariable",
                        "fail_step",
                        "write_verbose",
                        "write_highlight",
                        "write_wait",
                        "write_warning"
                    ];
                case scriptingLanguage_1.ScriptingLanguage.FSharp:
                    return [
                        "createArtifact",
                        "setVariable",
                        "failStep",
                        "writeVerbose",
                        "writeHighlight",
                        "writeWait",
                        "writeWarning"
                    ];
                case scriptingLanguage_1.ScriptingLanguage.CSharp:
                    return [
                        "Octopus.CreateArtifact",
                        "Octopus.SetVariable",
                        "Octopus.FailStep",
                        "Octopus.WriteVerbose",
                        "Octopus.WriteHighlight",
                        "Octopus.WriteWait",
                        "Octopus.WriteWarning"
                    ];
                default:
                    return [];
            }
        };
        _this.state = {
            serverNames: null,
            isInsertPopupOpen: false,
            filter: ""
        };
        return _this;
    }
    InsertVariableButton.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Variables.names(this.props.projectId, this.props.projectEnvironmentsFilter)];
                    case 1:
                        _a.apply(this, [(_b.serverNames = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    InsertVariableButton.prototype.render = function () {
        //TODO Insert variable icon to be added
        var _this = this;
        var allNames = _.concat(this.props.localNames ? this.props.localNames : [], this.state.serverNames);
        var lcFilter = this.state.filter.toLowerCase();
        var filterFunc = function (item) { return !lcFilter || item.toLowerCase().includes(lcFilter); };
        var names = allNames
            .filter(filterFunc)
            .map(function (n, i) { return React.createElement(List_1.ListItem, { key: "item-" + i, primaryText: n, onClick: function () { return _this.handleSelected(n, true); } }); });
        var functions = this.getFunctions()
            .filter(filterFunc)
            .map(function (n, i) { return React.createElement(List_1.ListItem, { key: "item-" + i, primaryText: n, onClick: function () { return _this.handleSelected(n, false); } }); });
        return React.createElement("div", { ref: this.setRef },
            React.createElement(IconButton_1.default, { toolTipContent: "Insert a variable", onClick: this.showInsertPopup, icon: insertVariableIcon }),
            React.createElement(Popover_1.default, { open: this.state.isInsertPopupOpen, anchorEl: this.showInsertPopupButton, onRequestClose: this.hideInsertPopup, anchorOrigin: { horizontal: "middle", vertical: "bottom" }, targetOrigin: { horizontal: "middle", vertical: "top" } },
                React.createElement("div", { className: styles.container, onKeyDown: this.onKeyDown },
                    React.createElement("div", { className: styles.filter },
                        React.createElement(FilterSearchBox_1.default, { autoFocus: true, value: this.state.filter, hintText: "Find...", onChange: function (filter) { return _this.setState({ filter: filter }); } })),
                    this.state.isInsertPopupOpen && React.createElement(List_1.List, { className: styles.menuContainer },
                        names,
                        functions))));
    };
    return InsertVariableButton;
}(BaseComponent_1.default));
exports.default = InsertVariableButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InsertVariableButton\\InsertVariableButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InsertVariableButton\\InsertVariableButton.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1535);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__2kpue{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__2kpue:visited{color:#333}.style_menuIcon__2kpue:hover{opacity:.5}.style_container__3ABIN{display:flex;flex-direction:column;width:31.25rem}.style_menuContainer__2R1aB{overflow-y:auto;height:25rem}.style_filter__251fd{margin:0 1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__2kpue",
	"container": "style_container__3ABIN",
	"menuContainer": "style_menuContainer__2R1aB",
	"filter": "style_filter__251fd"
};

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1537);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_materialUIIcon__PT3Bb{width:1.5rem!important;height:1.5rem!important;min-width:1.5rem!important;line-height:1.5rem!important;padding:0!important;opacity:.7}.style_materialUIIcon__PT3Bb span{padding:0!important}.style_materialUIIcon__PT3Bb:hover{background-color:#fff!important;opacity:1}.style_imageIcon__2Bet0{width:1.5rem;height:1.5rem;opacity:.7}.style_imageIcon__2Bet0:hover{opacity:1}.style_fontAwesomeIcon__24Xxz{opacity:.7}.style_fontAwesomeIcon__24Xxz:hover{opacity:1}", ""]);

// exports
exports.locals = {
	"materialUIIcon": "style_materialUIIcon__PT3Bb",
	"materialUiIcon": "style_materialUIIcon__PT3Bb",
	"imageIcon": "style_imageIcon__2Bet0",
	"fontAwesomeIcon": "style_fontAwesomeIcon__24Xxz"
};

/***/ }),
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "insert-variable.9344cc9087b8f1add3408a7c745b4731.hashedasset.svg";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1553);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1vPog{width:100%;display:flex;flex-direction:row}.style_container__1vPog>.style_wide__3iHkR{flex-grow:1}.style_container__1vPog>.style_buttons__3RezA{padding-top:1rem}.style_container__1vPog>:nth-child(2){margin-left:1rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__1vPog",
	"wide": "style_wide__3iHkR",
	"buttons": "style_buttons__3RezA"
};

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1555);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__gk7RU{font-size:1.375rem;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__gk7RU:visited{color:#333}.style_menuIcon__gk7RU:hover{opacity:.5}.style_container__2DcBs{display:flex;flex-direction:row}.style_container__2DcBs>:nth-child(2){margin-left:1rem}.style_buttons__36Ekq{padding-top:1rem}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__gk7RU",
	"container": "style_container__2DcBs",
	"buttons": "style_buttons__36Ekq"
};

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bind.26969b5c1fed2a000d9605571a26dc2c.hashedasset.svg";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "unbind.e722236d2634c9623af4d451108f729c.hashedasset.svg";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cn = __webpack_require__(19);
var resources_1 = __webpack_require__(17);
var styles = __webpack_require__(1559);
exports.default = function (item, small) {
    if (small === void 0) { small = false; }
    var stateClass = item.State;
    if (item.HasPendingInterruptions && !item.IsCompleted) {
        stateClass = "Paused";
    }
    else if (item.State === resources_1.TaskState.Success && item.HasWarningsOrErrors) {
        stateClass = "SuccessWithWarnings";
    }
    var iconStyles = cn(styles.status, styles[stateClass], small ? styles.small : null);
    if (item.IsPrevious) {
        iconStyles = cn(iconStyles, "status-previous");
    }
    else if (item.IsCurrent === false && item.IsPrevious === false) {
        iconStyles = cn(iconStyles, "status-archive");
    }
    return iconStyles;
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\iconStyle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\TaskStatusIcon\\iconStyle.tsx"); } } })();

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1560);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_status__1M01p{display:flex;justify-content:center;align-items:center;width:2.25rem;height:2.25rem;border-radius:.125rem;font-size:1.25rem;color:#fff}.style_small__1y0Fs{width:1.25rem;height:1.25rem;font-size:.875rem}.style_Queued__h1K9m{background-color:#0878d1}.style_Executing__dnX0l{background-color:#0a67b1}.style_Paused__34Pyd,.style_TimedOut__l4mEw{background-color:#fb8c00}.style_Failed__3c1N0{background-color:#db4437}.style_Canceled__37cqN,.style_Cancelling__3c8CE{background-color:#333}.style_Success__2Lz42,.style_SuccessWithWarnings__39_yv{background-color:#48b350}", ""]);

// exports
exports.locals = {
	"status": "style_status__1M01p",
	"small": "style_small__1y0Fs",
	"Queued": "style_Queued__h1K9m",
	"queued": "style_Queued__h1K9m",
	"Executing": "style_Executing__dnX0l",
	"executing": "style_Executing__dnX0l",
	"Paused": "style_Paused__34Pyd",
	"paused": "style_Paused__34Pyd",
	"TimedOut": "style_TimedOut__l4mEw",
	"timedOut": "style_TimedOut__l4mEw",
	"Failed": "style_Failed__3c1N0",
	"failed": "style_Failed__3c1N0",
	"Canceled": "style_Canceled__37cqN",
	"canceled": "style_Canceled__37cqN",
	"Cancelling": "style_Cancelling__3c8CE",
	"cancelling": "style_Cancelling__3c8CE",
	"Success": "style_Success__2Lz42",
	"success": "style_Success__2Lz42",
	"SuccessWithWarnings": "style_SuccessWithWarnings__39_yv",
	"successWithWarnings": "style_SuccessWithWarnings__39_yv"
};

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1562);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_taskDetailsContainer__LrSRu{display:flex;flex-direction:row;min-width:180px;padding:.5rem;margin:.25rem 0;justify-content:left}.style_taskDetailsContainer__LrSRu .style_details__1fsJb{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding-left:.5rem}.style_taskDetailsContainer__LrSRu .style_description__26x0p{color:#333;font-weight:500;font-size:.875rem;text-align:left}.style_taskDetailsContainer__LrSRu .style_date__3EL-h{color:#666;font-weight:400;font-size:.6875rem;white-space:nowrap}.style_stripTopBottomPadding__XDGZz{padding:0 .5rem;margin:0}", ""]);

// exports
exports.locals = {
	"taskDetailsContainer": "style_taskDetailsContainer__LrSRu",
	"details": "style_details__1fsJb",
	"description": "style_description__26x0p",
	"date": "style_date__3EL-h",
	"stripTopBottomPadding": "style_stripTopBottomPadding__XDGZz"
};

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1564);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_taskDetailsCell__qtmtm{vertical-align:\"middle\"}.style_stats__MyEBG{padding-left:1rem}.style_states__1MbFc{width:16rem}", ""]);

// exports
exports.locals = {
	"taskDetailsCell": "style_taskDetailsCell__qtmtm",
	"stats": "style_stats__MyEBG",
	"states": "style_states__1MbFc"
};

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1566);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__Ia6wX{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__a12PU{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2a0Q-{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2DeIf{display:none!important}}.style_bodyWithSides__1xywl{display:flex;flex:1 1 auto;padding:0}@media (max-width:37.4rem){.style_bodyWithSides__1xywl{flex-direction:column}}@media (min-width:37.4rem){.style_sideBarRight__2_Hml{border-left:.0625rem solid #ccc}}@media (min-width:37.4rem){.style_sideBarLeft__V3RKB{border-right:.0625rem solid #ccc}}.style_sidebarContainer__3MmJB{flex-basis:17.6rem}.style_sideBar__3WzhS{font-size:.875rem}@media (max-width:37.4rem){.style_sideBar__3WzhS{border-top:.0625rem solid #ccc}}.style_sideBarPadding__jE6Gd{padding:0 1rem}.style_main__3txB4{flex-grow:1;flex-basis:1rem;min-width:0}@media (max-width:37.4rem){.style_main__3txB4{flex-basis:auto}}.style_overflowXHidden__Cjipd{overflow-x:hidden}.style_mainContent__2tIQ4{padding-top:0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__Ia6wX",
	"hideSm": "style_hide-sm__Ia6wX",
	"visible-sm": "style_visible-sm__a12PU",
	"visibleSm": "style_visible-sm__a12PU",
	"hide-md": "style_hide-md__2a0Q-",
	"hideMd": "style_hide-md__2a0Q-",
	"visible-md": "style_visible-md__2DeIf",
	"visibleMd": "style_visible-md__2DeIf",
	"bodyWithSides": "style_bodyWithSides__1xywl",
	"sideBarRight": "style_sideBarRight__2_Hml",
	"sideBarLeft": "style_sideBarLeft__V3RKB",
	"sidebarContainer": "style_sidebarContainer__3MmJB",
	"sideBar": "style_sideBar__3WzhS",
	"sideBarPadding": "style_sideBarPadding__jE6Gd",
	"main": "style_main__3txB4",
	"overflowXHidden": "style_overflowXHidden__Cjipd",
	"mainContent": "style_mainContent__2tIQ4"
};

/***/ }),
/* 1567 */,
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1569);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__2onyG{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2P30m{display:none!important}}@media (max-width:79.9rem){.style_hide-md__zpMC1{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3jION{display:none!important}}.style_heading__1XbGR{display:flex;flex-direction:row;align-items:center;margin-top:0}.style_headingText__1nfm2{flex-grow:1}.style_resetButton__2Gdak{margin:0!important}.style_fullHeightContainer__1t46e{display:flex;flex-direction:column;align-items:stretch;flex:1 1 auto}.style_headingSection__1Hze6{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap}.style_filterHeaderContainer__32Xl5{display:flex;flex-direction:row;align-items:center;flex-grow:1}@media (max-width:37.4rem){.style_filterHeaderContainer__32Xl5{flex-direction:column;align-items:flex-start}}.style_filterHeaderContainer__32Xl5 div:nth-child(2){margin-left:.25rem}.style_additionalHeaderFilter__2yEpK{align-self:flex-start}.style_filterHeaderContainer__32Xl5 .style_additionalHeaderFilter__2yEpK:not(:first-child){margin-left:1rem}.style_filteringByItems__20nTV{display:flex;flex-direction:row;flex-wrap:wrap}.style_filteringBy__2q6FZ{width:100%;flex-wrap:wrap;display:flex;align-items:center}.style_matchInfo__2NLs9{margin-left:.75rem}.style_info__3hkVM{color:#0878d1}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__2onyG",
	"hideSm": "style_hide-sm__2onyG",
	"visible-sm": "style_visible-sm__2P30m",
	"visibleSm": "style_visible-sm__2P30m",
	"hide-md": "style_hide-md__zpMC1",
	"hideMd": "style_hide-md__zpMC1",
	"visible-md": "style_visible-md__3jION",
	"visibleMd": "style_visible-md__3jION",
	"heading": "style_heading__1XbGR",
	"headingText": "style_headingText__1nfm2",
	"resetButton": "style_resetButton__2Gdak",
	"fullHeightContainer": "style_fullHeightContainer__1t46e",
	"headingSection": "style_headingSection__1Hze6",
	"filterHeaderContainer": "style_filterHeaderContainer__32Xl5",
	"additionalHeaderFilter": "style_additionalHeaderFilter__2yEpK",
	"filteringByItems": "style_filteringByItems__20nTV",
	"filteringBy": "style_filteringBy__2q6FZ",
	"matchInfo": "style_matchInfo__2NLs9",
	"info": "style_info__3hkVM"
};

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1571);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_formExpander__2bL6B,.style_formNonExpander__1Gaxi{width:100%;box-shadow:none!important;border-radius:0!important;border-width:0!important;margin:0 0 -.0625rem;background-color:inherit!important}.style_formExpander__2bL6B>div:first-child,.style_formExpander__2bL6B>div:first-child>div:first-child,.style_formNonExpander__1Gaxi>div:first-child,.style_formNonExpander__1Gaxi>div:first-child>div:first-child{padding:0!important}.style_formExpander__2bL6B>div:first-child>div:first-child{cursor:pointer}.style_cardMedia__xmmZy{margin:0;padding:0}", ""]);

// exports
exports.locals = {
	"formExpander": "style_formExpander__2bL6B",
	"formNonExpander": "style_formNonExpander__1Gaxi",
	"cardMedia": "style_cardMedia__xmmZy"
};

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(121);
var styles = __webpack_require__(1573);
exports.AdvancedFilterCheckbox = function (props) {
    return React.createElement("div", { className: styles.checkboxContainer },
        React.createElement(Checkbox_1.default, { className: styles.checkbox, value: props.value, onChange: props.onChange, label: props.label, noMargin: true }),
        props.icon && React.createElement("div", { className: styles.checkboxIcon }, props.icon));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\Checkbox\\AdvancedFilterCheckbox.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AdvancedFilterLayout\\Checkbox\\AdvancedFilterCheckbox.tsx"); } } })();

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1574);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_checkboxContainer__JgZp1{display:flex;flex-direction:row;align-items:center}.style_checkbox__-iDYT{flex-grow:1}.style_checkboxIcon__YJzhU{flex-grow:0}", ""]);

// exports
exports.locals = {
	"checkboxContainer": "style_checkboxContainer__JgZp1",
	"checkbox": "style_checkbox__-iDYT",
	"checkboxIcon": "style_checkboxIcon__YJzhU"
};

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function toPath(to) {
    if (typeof to !== "string") {
        return to.pathname;
    }
    return to;
}
exports.toPath = toPath;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\toPath.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navigation\\toPath.ts"); } } })();

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1577);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1rfbU{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2pCpd{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3xdAx{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1SgQn{display:none!important}}.style_titleBar__3251A{background-color:#fff;height:3rem;display:flex;justify-content:space-between;align-items:center;padding:0 1rem}.style_title__Yghwr{flex-grow:1;font-size:1.25rem}.style_title__Yghwr h1,.style_title__Yghwr h2{font-size:1.25rem;margin:0;padding:0}.style_pageTitleLink__10IIo{color:#333;text-decoration:none}.style_pageTitleLink__10IIo>:active,.style_pageTitleLink__10IIo>:visited{color:#333}.style_pageTitleLink__10IIo:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1rfbU",
	"hideSm": "style_hide-sm__1rfbU",
	"visible-sm": "style_visible-sm__2pCpd",
	"visibleSm": "style_visible-sm__2pCpd",
	"hide-md": "style_hide-md__3xdAx",
	"hideMd": "style_hide-md__3xdAx",
	"visible-md": "style_visible-md__1SgQn",
	"visibleMd": "style_visible-md__1SgQn",
	"titleBar": "style_titleBar__3251A",
	"title": "style_title__Yghwr",
	"pageTitleLink": "style_pageTitleLink__10IIo"
};

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1579);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__yr-d1{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__38N33{display:none!important}}@media (max-width:79.9rem){.style_hide-md__NZxWF{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2MtkH{display:none!important}}.style_container__17bog{margin:.875rem 1rem 0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__yr-d1",
	"hideSm": "style_hide-sm__yr-d1",
	"visible-sm": "style_visible-sm__38N33",
	"visibleSm": "style_visible-sm__38N33",
	"hide-md": "style_hide-md__NZxWF",
	"hideMd": "style_hide-md__NZxWF",
	"visible-md": "style_visible-md__2MtkH",
	"visibleMd": "style_visible-md__2MtkH",
	"container": "style_container__17bog"
};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var configRoot = root + "/configuration";
    return {
        root: configRoot,
        userInvites: configRoot + "/userinvites",
        audit: configRoot + "/audit",
        machineEventsForUser: function (user, category) { return configRoot + "/audit?users=" + encodeURIComponent(user) + "&eventCategories=" + category + "&documentTypes=Machines"; },
        eventsForProject: function (projectId) { return configRoot + "/audit?projects=" + encodeURIComponent(projectId); },
        eventsForTenant: function (tenantId) { return configRoot + "/audit?tenants=" + encodeURIComponent(tenantId); },
        eventsForEnvironment: function (envId) { return configRoot + "/audit?environments=" + encodeURIComponent(envId); },
        eventsForUser: function (userId) { return configRoot + "/audit?users=" + encodeURIComponent(userId); },
        eventsRegardingAny: function (regardingIds) {
            var queryString = regardingIds.map(function (x) { return "&regardingAny=" + encodeURIComponent(x); }).join("");
            if (queryString.substring(0, 1) === "&") {
                queryString = queryString.substring(1);
            }
            return configRoot + "/audit?" + queryString;
        },
        deploymentProcessEventsForProject: function (projectId) { return configRoot + "/audit?projects=" + encodeURIComponent(projectId) + "&documentTypes=deploymentprocess"; },
        variableSetEventsForProject: function (projectId) { return configRoot + "/audit?projects=" + encodeURIComponent(projectId) + "&documentTypes=variableset"; },
        libraryVariableSetEventsRegardingAny: function (regardingIds) { return configRoot + "/audit?documentTypes=variableset" + regardingIds.map(function (x) { return "&regardingAny=" + encodeURIComponent(x); }).join(""); },
        backup: configRoot + "/backup",
        features: configRoot + "/features",
        license: configRoot + "/license",
        smtp: configRoot + "/smtp",
        nodes: {
            root: configRoot + "/nodes",
            serverSettings: configRoot + "/nodes/serverSettings",
            config: configRoot + "/nodes/config"
        },
        thumbprint: configRoot + "/thumbprint",
        maintenance: configRoot + "/maintenance",
        v3route: {
            certificates: configRoot + "/certificates",
            usersInvite: configRoot + "/users/invite",
            testPermissions: configRoot + "/teams/test"
        },
        letsEncrypt: {
            root: configRoot + "/letsencrypt",
            configure: configRoot + "/letsencrypt/configure"
        },
        testPermissions: configRoot + "/testpermissions",
        testPermission: function (userId) { return configRoot + "/testpermissions/" + userId; },
        subscriptions: {
            root: configRoot + "/subscriptions",
            create: configRoot + "/subscriptions/create",
        },
        subscription: function (subscriptionId) { return configRoot + "/subscriptions/" + subscriptionId; },
        users: {
            root: configRoot + "/users",
            create: configRoot + "/users/create",
        },
        user: function (userId) {
            if (!!userId && typeof userId !== "string") {
                userId = userId.Id;
            }
            return configRoot + "/users/" + userId;
        },
        spaces: {
            root: configRoot + "/spaces",
            create: configRoot + "/spaces/create",
        },
        teams: {
            root: configRoot + "/teams",
            create: configRoot + "/teams/create",
        },
        team: function (teamId) {
            if (!!teamId && typeof teamId !== "string") {
                teamId = teamId.Id;
            }
            return configRoot + "/teams/" + teamId;
        },
        roles: {
            root: configRoot + "/roles",
            create: configRoot + "/roles/create",
        },
        role: function (roleId) {
            if (!!roleId && typeof roleId !== "string") {
                roleId = roleId.Id;
            }
            return configRoot + "/roles/" + roleId;
        },
        diagnostics: {
            root: configRoot + "/diagnostics",
            logs: {
                root: configRoot + "/diagnostics/logs",
                autoDeploy: configRoot + "/diagnostics/autodeploy",
                scheduledDeploy: configRoot + "/diagnostics/scheduleddeploy",
                machineCleanup: configRoot + "/diagnostics/machinecleanup",
                subscription: configRoot + "/diagnostics/subscription",
            }
        },
        settings: {
            root: configRoot + "/settings",
        },
        setting: function (settingId) {
            return configRoot + "/settings/" + settingId;
        },
        performance: configRoot + "/performance"
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\ConfigurationRoutes\\configurationRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\ConfigurationRoutes\\configurationRouteLinks.ts"); } } })();

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) { return ({
    projectGroup: function (projectGroupId) {
        var specificRoot = root + "/projectGroups/" + projectGroupId;
        return {
            root: specificRoot,
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\projectGroupRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\projectGroupRouteLinks.ts"); } } })();

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) { return ({
    deployments: root + "/deployments",
    deployment: function (deploymentId) {
        var specificRoot = root + "/deployments/" + deploymentId;
        return {
            root: specificRoot,
        };
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\deploymentRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\deploymentRouteLinks.ts"); } } })();

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var users = root + "/users";
    var me = users + "/me";
    return {
        me: me,
        logins: me + "/logins",
        details: me + "/details",
        apiKeys: me + "/apiKeys",
        activity: me + "/activity",
        register: function (inviteCode) { return users + "/register/" + inviteCode; },
        signIn: users + "/sign-in",
        signOut: users + "/sign-out"
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\userProfileRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\userProfileRouteLinks.ts"); } } })();

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (root) {
    var specificRoot = root + "/dashboard";
    return {
        root: specificRoot,
        configure: specificRoot + "/configure"
    };
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardOverview\\dashboardRouteLinks.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardOverview\\dashboardRouteLinks.ts"); } } })();

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StandardLayout_1 = __webpack_require__(1586);
exports.StandardLayout = StandardLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\index.tsx"); } } })();

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StandardLayoutInternal_1 = __webpack_require__(1587);
var react_redux_1 = __webpack_require__(64);
var redux_1 = __webpack_require__(108);
var reducers_1 = __webpack_require__(354);
var StandardLayout = react_redux_1.connect(function (state) {
    return {
        unhandledError: state.unhandledError
    };
}, function (dispatch) {
    return {
        onErrorClose: redux_1.bindActionCreators(reducers_1.clearUnhandledErrorAction, dispatch)
    };
})(StandardLayoutInternal_1.default);
exports.default = StandardLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\StandardLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\StandardLayout.tsx"); } } })();

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Navbar_1 = __webpack_require__(1588);
var ErrorPanel_1 = __webpack_require__(1663);
var RootRoutes_1 = __webpack_require__(1664);
var GettingStartedFooter_1 = __webpack_require__(2002);
var SystemMessagesBanner_1 = __webpack_require__(2008);
var Sticky_1 = __webpack_require__(473);
var clientInstance_1 = __webpack_require__(10);
var StandardLayoutInternal = (function (_super) {
    __extends(StandardLayoutInternal, _super);
    function StandardLayoutInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onErrorClose = function () {
            _this.props.onErrorClose();
        };
        return _this;
    }
    StandardLayoutInternal.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(Sticky_1.default, { innerZ: 10 },
                React.createElement("div", { id: "toppanel" },
                    React.createElement(Navbar_1.Navbar, null),
                    this.props.unhandledError &&
                        React.createElement(ErrorPanel_1.default, { message: "An unexpected error occurred in Octopus v" + clientInstance_1.client.version + ": " + this.props.unhandledError.message, details: this.props.unhandledError.details, fullWidth: true, canClose: true, onErrorClose: this.onErrorClose }),
                    React.createElement(SystemMessagesBanner_1.default, null))),
            React.createElement(RootRoutes_1.default, null),
            React.createElement(GettingStartedFooter_1.default, null));
    };
    return StandardLayoutInternal;
}(React.Component));
exports.default = StandardLayoutInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\StandardLayoutInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\StandardLayout\\StandardLayoutInternal.tsx"); } } })();

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Navbar_1 = __webpack_require__(1589);
exports.Navbar = Navbar_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\index.tsx"); } } })();

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var EAPBar_1 = __webpack_require__(1590);
var ProjectSwitcher_1 = __webpack_require__(1592);
var UserAccountMenu_1 = __webpack_require__(1641);
var PermissionCheck_1 = __webpack_require__(42);
var PriorityNavigation_1 = __webpack_require__(697);
var environment_1 = __webpack_require__(266);
var SvgIcon_1 = __webpack_require__(23);
var React = __webpack_require__(0);
var routeLinks_1 = __webpack_require__(22);
var LicenceNotificationPoller_1 = __webpack_require__(1657);
var UpdateAvailableNotificationPoller_1 = __webpack_require__(1658);
var NotificationsMenu_1 = __webpack_require__(1659);
var styles = __webpack_require__(289);
var react_redux_1 = __webpack_require__(64);
var react_router_1 = __webpack_require__(76);
var ProjectSwitchIcon = function (props) { return React.createElement(SvgIcon_1.default, __assign({}, props, { color: "white", viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M16.2,6.4c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c1.1,0,2.1-0.3,3-0.9l2.6,2.6c0.2,0.2,0.4,0.3,0.7,0.3c0.6,0,1-0.4,1-1c0-0.3-0.1-0.5-0.3-0.7l-2.6-2.6c0.6-0.9,0.9-1.9,0.9-3C21.5,8.8,19.1,6.4,16.2,6.4z M16.3,15.3c-1.9,0-3.4-1.6-3.4-3.4c0-1.9,1.6-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4S18.2,15.3,16.3,15.3z M18.9,17.3c-0.8,0.6-1.7,0.7-2.7,0.7c-2.4,0-4.5-1.3-5.5-3.3l-0.1,0H7.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h3c-0.2-0.5-0.3-1-0.3-1.5H7.4C7.2,12.4,7,12.2,7,12s0.2-0.4,0.4-0.4h2.5c0,0,0,0,0,0c0-0.5,0.1-1,0.2-1.5H7.4C7.2,10.1,7,9.9,7,9.7s0.2-0.4,0.4-0.4h3c0.9-2.3,3.2-3.9,5.8-3.9c1.1,0,2.1,0.3,3,0.8V5.7c0-0.9-0.7-1.6-1.6-1.6H1.8c-0.9,0-1.6,0.7-1.6,1.6v12.7c0,0.9,0.7,1.6,1.6,1.6h15.9c0.9,0,1.6-0.7,1.6-1.6V17C19.3,17,19.2,17.2,18.9,17.3z M5.8,13.2h-4v-4h4V13.2z" })); };
var Navbar = (function (_super) {
    __extends(Navbar, _super);
    function Navbar(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollToMainContent = function () {
            document.getElementById("maincontent").scrollIntoView();
        };
        _this.closeProjectSwitcher = function () {
            _this.setState({
                openProjectSwitcher: false
            });
        };
        _this.toggleProjectSwitcher = function (e) {
            _this.setState({
                openProjectSwitcher: !_this.state.openProjectSwitcher,
                projectSwitcherAnchorEl: e
            });
        };
        _this.state = {
            openProjectSwitcher: false,
            projectSwitcherAnchorEl: null,
            eapIsHidden: false,
        };
        return _this;
    }
    Navbar.prototype.render = function () {
        var _this = this;
        // The topnavbar id is used by E2E UI tests
        return React.createElement("div", { id: "topnavbar", className: styles.topnavbar },
            React.createElement(EAPBar_1.default, { onCloseClicked: function () { return _this.setState({ eapIsHidden: true }); } }),
            React.createElement("div", { className: styles.navbar },
                React.createElement(PriorityNavigation_1.default, { navigationItems: this.getNavigationItems(this.props.isMultiTenancyEnabled, this.state.eapIsHidden), maxNavigationItems: 99, activeItemClassName: styles.navItemActive, className: styles.navbarCenter, showHamburgerIcon: true }),
                PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true }) &&
                    React.createElement(ProjectSwitcher_1.default, { open: this.state.openProjectSwitcher, onRequestClose: this.closeProjectSwitcher, anchorEl: this.state.projectSwitcherAnchorEl }),
                React.createElement("nav", { className: styles.navbarRight },
                    React.createElement(UpdateAvailableNotificationPoller_1.default, null),
                    React.createElement(LicenceNotificationPoller_1.default, null),
                    React.createElement(NotificationsMenu_1.default, null),
                    React.createElement(UserAccountMenu_1.default, { currentUser: clientInstance_1.session.currentUser }))));
    };
    Navbar.prototype.getNavigationItems = function (isMultiTenancyEnabled, eapIsHidden) {
        var navigationItems = [];
        // only show the dashboard icon if no spaces, otherwise spaces will handle it
        navigationItems.push({ url: routeLinks_1.default.root, text: "Dashboard", icon: React.createElement("em", { className: "fontoctopus-octopus" }), exact: true });
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true })) {
            navigationItems.push({ url: routeLinks_1.default.projects, text: "Projects" });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectView, wildcard: true })) {
            navigationItems.push({ url: null, icon: React.createElement(ProjectSwitchIcon, null), title: "Project switcher", onClick: this.toggleProjectSwitcher });
        }
        if (PermissionCheck_1.isAllowed({
            permission: [resources_1.Permission.MachineView, resources_1.Permission.EnvironmentView, resources_1.Permission.WorkerView],
            wildcard: true
        })) {
            navigationItems.push({ url: routeLinks_1.default.infrastructure.root, text: "Infrastructure" });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.TenantView, tenant: "*" })) {
            navigationItems.push({ url: routeLinks_1.default.tenants, text: "Tenants" });
        }
        if (PermissionCheck_1.isAllowed({
            permission: [resources_1.Permission.FeedView, resources_1.Permission.LifecycleEdit, resources_1.Permission.VariableView, resources_1.Permission.ActionTemplateView, resources_1.Permission.CertificateView],
            wildcard: true
        })) {
            navigationItems.push({ url: routeLinks_1.default.library.root, text: "Library" });
        }
        if (PermissionCheck_1.isAllowed({ permission: resources_1.Permission.TaskView, wildcard: true })) {
            navigationItems.push({ url: routeLinks_1.default.tasks.root, text: "Tasks" });
        }
        if (PermissionCheck_1.isAllowed({ permission: [resources_1.Permission.AdministerSystem, resources_1.Permission.AuditView, resources_1.Permission.TeamView, resources_1.Permission.UserView, resources_1.Permission.UserRoleView] })) {
            navigationItems.push({ url: routeLinks_1.default.configuration.root, text: "Configuration" });
        }
        if (environment_1.default.isInDevelopmentMode() && !eapIsHidden) {
            navigationItems.push({ url: routeLinks_1.default.styleGuide, text: "Style Guide [dev]" });
            navigationItems.push({ url: routeLinks_1.default.codeGuide, icon: React.createElement("em", { className: "fa fa-industry" }), text: "Code Guide [dev]" });
        }
        return navigationItems;
    };
    return Navbar;
}(React.Component));
var mapStateToProps = function (state) {
    return {
        isMultiTenancyEnabled: state.configurationArea.features.isMultiTenancyEnabled
    };
};
// Unfortunately this component needs to be connected to the router purely so that it updates when the route changes.
// Otherwise, the connect() breaks all route-related updates.  This might be fixed in React 16.3 which should introduce the new context API
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps)(Navbar));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\Navbar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\Navbar.tsx"); } } })();

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ToolTip_1 = __webpack_require__(74);
var ExternalLink_1 = __webpack_require__(26);
var React = __webpack_require__(0);
var styles = __webpack_require__(289);
var clientInstance_1 = __webpack_require__(10);
var CloseButton_1 = __webpack_require__(583);
var EAPBar = (function (_super) {
    __extends(EAPBar, _super);
    function EAPBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEarlyAccessProgram: false,
            isHidden: false,
            version: ""
        };
        return _this;
    }
    EAPBar.prototype.componentDidMount = function () {
        var root = clientInstance_1.repository.getRootDocument();
        var isEarlyAccessProgram = root.IsEarlyAccessProgram || false;
        var version = root.Version;
        this.setState({
            isEarlyAccessProgram: isEarlyAccessProgram,
            version: version
        });
    };
    EAPBar.prototype.onClose = function () {
        this.setState({ isHidden: true });
        this.props.onCloseClicked();
    };
    EAPBar.prototype.render = function () {
        var _this = this;
        if (!this.state.isEarlyAccessProgram || this.state.isHidden) {
            return null;
        }
        return React.createElement("div", { className: styles.eapBanner },
            React.createElement(ToolTip_1.default, { content: "Due to the unstable nature of EAP releases we do not recommend using them in production, or upgrading them to/from a production instance" },
                React.createElement(ExternalLink_1.default, { href: "WhatIsEAP", showIcon: false },
                    "EAP Release - v",
                    this.state.version)),
            React.createElement("div", { className: styles.closeEAPBanner },
                React.createElement(CloseButton_1.default, { onClose: function () { return _this.onClose(); } })));
    };
    return EAPBar;
}(React.Component));
exports.default = EAPBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\EAPBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\EAPBar.tsx"); } } })();

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1TM0J{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3TDiA{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3CNCJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2JXiF{display:none!important}}.style_topnavbar__16z8s{width:100%;display:flex;flex-direction:column}.style_eapBanner__1pwaF{background-color:#fb8c00;color:#fff;font-size:.8125rem;height:1.5rem;display:flex;justify-content:center;align-items:center;font-weight:600}.style_eapBanner__1pwaF a,.style_eapBanner__1pwaF a:hover{color:#fff}.style_closeEAPBanner__bN6-l{position:absolute;right:0;top:-.75rem;height:auto}.style_navbar__3F4L7{height:3rem;background-color:#2f93e0;display:flex}.style_navbarLeft__3lP5L,.style_navbarRight__1sksi{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;height:100%;flex-grow:0;flex-shrink:0}.style_navbarCenter__x3dqj{flex-grow:1;flex-shrink:1}.style_navbarCenter__x3dqj ul{height:100%;margin:0;display:flex}.style_navbarCenter__x3dqj ul li{display:inline-block;height:100%}.style_navbarCenter__x3dqj ul li a{cursor:pointer;height:100%;color:#fff;padding:0 1rem;display:flex;align-items:center;text-decoration:none}.style_navbarCenter__x3dqj ul li a:hover{background-color:#74c0fb;color:#fff}.style_navbarCenter__x3dqj ul li a:active,.style_navbarCenter__x3dqj ul li a:focus{background-color:#0a67b1}.style_navbarCenter__x3dqj ul li a em{font-size:1.0625rem;padding:0 .5rem}.style_navbarRight__1sksi{float:right}.style_button__25zsx{cursor:pointer;height:100%;color:#fff;padding:0 1rem;display:flex;align-items:center;text-decoration:none}.style_button__25zsx:hover{background-color:#74c0fb;color:#fff}.style_button__25zsx:active,.style_button__25zsx:focus,.style_navItemActive__2Qjuj{background-color:#0a67b1}.style_icon__lbPxK{font-size:1.0625rem;padding:0 .5rem}.style_spaceName__tLekJ,.style_userName__19kyn{text-align:left;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:1rem;padding-left:.5rem;min-width:3rem}.style_spaceName__tLekJ{padding-left:.5rem}.style_navbarRight__1sksi>div{height:100%}@media (max-width:37.4rem){.style_navbar__3F4L7{height:2.5rem}.style_navbarRight__1sksi{margin-right:.5rem}.style_navbarLeft__3lP5L{margin-left:.5rem;margin-right:.5rem;float:none}.style_spaceButton__29TpN{flex-grow:2}.style_spaceName__tLekJ{width:100%}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1TM0J",
	"hideSm": "style_hide-sm__1TM0J",
	"visible-sm": "style_visible-sm__3TDiA",
	"visibleSm": "style_visible-sm__3TDiA",
	"hide-md": "style_hide-md__3CNCJ",
	"hideMd": "style_hide-md__3CNCJ",
	"visible-md": "style_visible-md__2JXiF",
	"visibleMd": "style_visible-md__2JXiF",
	"topnavbar": "style_topnavbar__16z8s",
	"eapBanner": "style_eapBanner__1pwaF",
	"closeEAPBanner": "style_closeEAPBanner__bN6-l",
	"closeEapBanner": "style_closeEAPBanner__bN6-l",
	"navbar": "style_navbar__3F4L7",
	"navbarLeft": "style_navbarLeft__3lP5L",
	"navbarRight": "style_navbarRight__1sksi",
	"navbarCenter": "style_navbarCenter__x3dqj",
	"button": "style_button__25zsx",
	"navItemActive": "style_navItemActive__2Qjuj",
	"icon": "style_icon__lbPxK",
	"userName": "style_userName__19kyn",
	"spaceName": "style_spaceName__tLekJ",
	"spaceButton": "style_spaceButton__29TpN"
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var Popover_1 = __webpack_require__(246);
var FilterSearchBox_1 = __webpack_require__(316);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
var styles = __webpack_require__(1593);
var routeLinks_1 = __webpack_require__(22);
var Section_1 = __webpack_require__(81);
var resources_1 = __webpack_require__(17);
var PermissionCheck_1 = __webpack_require__(42);
var VirtualListWithKeyboard_1 = __webpack_require__(407);
var SwitcherLink_1 = __webpack_require__(1640);
var VirtualList = VirtualListWithKeyboard_1.default();
var ProjectSwitcher = (function (_super) {
    __extends(ProjectSwitcher, _super);
    function ProjectSwitcher(props) {
        var _this = _super.call(this, props) || this;
        _this.setSearchRef = function (el) {
            _this.searchRef = el;
        };
        _this.onRequestClose = function () {
            _this.props.onRequestClose();
        };
        _this.refreshProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            var projectResources, projectGroupMap, showGroup, groups, sortedProjects, projectGroup, projects;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 1:
                        projectResources = _a.sent();
                        projectGroupMap = null;
                        showGroup = false;
                        if (!PermissionCheck_1.isAllowed({ permission: resources_1.Permission.ProjectGroupView, projectGroup: "*" })) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.all()];
                    case 2:
                        groups = _a.sent();
                        if (groups.length > 1) {
                            showGroup = true;
                            projectGroupMap = lodash_1.keyBy(groups, "Id");
                        }
                        _a.label = 3;
                    case 3:
                        sortedProjects = lodash_1.sortBy(projectResources, function (p) { return p.Name.toLowerCase(); });
                        projectGroup = function (gId) {
                            return projectGroupMap.hasOwnProperty(gId) ? projectGroupMap[gId].Name : null;
                        };
                        projects = sortedProjects.map(function (p) { return ({
                            Id: p.Id,
                            Name: p.Name,
                            Slug: p.Slug,
                            Group: projectGroupMap ? projectGroup(p.ProjectGroupId) : null
                        }); });
                        this.setState({ projects: projects, showGroup: showGroup });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onKeyEsc = function (event) {
            if (event.key === "Escape") {
                _this.onRequestClose();
            }
        };
        _this.onArrowDown = function (event) {
            if (event.key === "ArrowDown" || event.key === "Tab") {
                if (_this.filterList(_this.state.filter).length === 0) {
                    return;
                }
                _this.virtualList.focus();
                event.preventDefault();
            }
        };
        _this.handleFilterChanged = function (filter) {
            _this.setState({ filter: filter });
        };
        _this.state = {
            filter: "",
            projects: [],
            filteredList: [],
            showGroup: false
        };
        return _this;
    }
    ProjectSwitcher.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return _this.refreshProjects(); });
    };
    ProjectSwitcher.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.open === nextProps.open) {
            return;
        }
        if (nextProps.open) {
            this.setState({
                filter: "",
            });
            this.refreshProjects();
        }
    };
    ProjectSwitcher.prototype.render = function () {
        var _this = this;
        var filteredList = this.filterList(this.state.filter);
        return React.createElement(Popover_1.default, { style: { overflowY: "hidden" }, open: this.props.open, anchorEl: this.props.anchorEl, onRequestClose: this.onRequestClose, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" } },
            React.createElement("div", { className: styles.container, onKeyDown: this.onKeyEsc },
                this.state.projects.length === 0 && React.createElement("div", { className: styles.empty }, "There are no projects yet!"),
                this.state.projects.length > 0 && React.createElement(Section_1.Section, null,
                    React.createElement(FilterSearchBox_1.default, { innerRef: this.setSearchRef, autoFocus: true, value: this.state.filter, hintText: "Jump to project...", onChange: this.handleFilterChanged, fullWidth: true, onKeyDown: this.onArrowDown, containerClassName: styles.filterFieldContainer })),
                React.createElement("div", { className: styles.menuContainer },
                    React.createElement(VirtualList, { ref: function (el) { return _this.virtualList = el; }, items: filteredList, renderItem: function (item) { return ({
                            primaryText: item.Name,
                            secondaryText: item.Group
                        }); }, containerElement: function (item) { return React.createElement(SwitcherLink_1.default, { to: routeLinks_1.default.project(item.Slug).root }); }, onSelected: this.onRequestClose, onResized: function () {
                            // When the content's size changes, we re-render so that the
                            // popover can re-position itself based on the new `VirtualList` size
                            _this.forceUpdate();
                        }, onBlur: function () { return _this.searchRef.focus(); } }))));
    };
    ProjectSwitcher.prototype.filterList = function (filter) {
        var matchesFilter = function (n) { return n.toLowerCase().includes(filter.toLowerCase()); };
        return (filter.length > 0
            ? this.state.projects.filter(function (p) { return matchesFilter(p.Name) || (p.Group ? matchesFilter(p.Group) : false); })
            : this.state.projects);
    };
    return ProjectSwitcher;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ProjectSwitcher;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\ProjectSwitcher.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\ProjectSwitcher.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1594);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./projectSwitcher.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./projectSwitcher.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".projectSwitcher_container__3P1x6{display:flex;flex-direction:column;width:25rem}.projectSwitcher_menuContainer__1daZ3{overflow-y:auto;height:25rem}.projectSwitcher_filterFieldContainer__2yWyi{width:100%}.projectSwitcher_groupName__QFcSJ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;font-size:.9375rem}.projectSwitcher_empty__3bdIj{padding:.625rem}", ""]);

// exports
exports.locals = {
	"container": "projectSwitcher_container__3P1x6",
	"menuContainer": "projectSwitcher_menuContainer__1daZ3",
	"filterFieldContainer": "projectSwitcher_filterFieldContainer__2yWyi",
	"groupName": "projectSwitcher_groupName__QFcSJ",
	"empty": "projectSwitcher_empty__3bdIj"
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var material_ui_1 = __webpack_require__(101);
var FocusListItem = (function (_super) {
    __extends(FocusListItem, _super);
    function FocusListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setRef = function (el) {
            _this.element = el;
        };
        return _this;
    }
    FocusListItem.prototype.componentDidMount = function () {
        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    };
    FocusListItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.isFocused === this.props.isFocused) {
            return;
        }
        if (this.props.isFocused) {
            this.element.applyFocusState("keyboard-focused");
        }
    };
    FocusListItem.prototype.render = function () {
        return React.createElement(material_ui_1.ListItem, { ref: this.setRef, containerElement: this.props.containerElement, primaryText: this.props.primaryText, secondaryText: this.props.secondaryText, secondaryTextLines: this.props.secondaryTextLines, leftIcon: this.props.leftIcon, onClick: this.props.onRequestClose });
    };
    return FocusListItem;
}(React.Component));
exports.default = FocusListItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FocusListItem\\FocustListItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\FocusListItem\\FocustListItem.tsx"); } } })();

/***/ }),
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1639);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./VirtualListWithKeyboard.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./VirtualListWithKeyboard.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".VirtualListWithKeyboard_menuContainer__3RXtt{max-height:25rem}.VirtualListWithKeyboard_empty__qv1G4{padding:.625rem}", ""]);

// exports
exports.locals = {
	"menuContainer": "VirtualListWithKeyboard_menuContainer__3RXtt",
	"empty": "VirtualListWithKeyboard_empty__qv1G4"
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var SwitcherLink = (function (_super) {
    __extends(SwitcherLink, _super);
    function SwitcherLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SwitcherLink.prototype.render = function () {
        var _a = this.props, staticContext = _a.staticContext, to = _a.to, rest = __rest(_a, ["staticContext", "to"]);
        // tslint:disable-next-line:jsx-ban-elements
        return React.createElement(react_router_dom_1.Link, __assign({}, rest, { to: resolvePathWithSpaceId_1.resolvePathWithSpaceId(to, this.props.match.params.spaceId) }), this.props.children);
    };
    return SwitcherLink;
}(React.Component));
exports.default = react_router_dom_1.withRouter(SwitcherLink);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\SwitcherLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\SwitcherLink.tsx"); } } })();

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Popover_1 = __webpack_require__(164);
var Menu_1 = __webpack_require__(203);
var Avatar_1 = __webpack_require__(474);
var ExternalLink_1 = __webpack_require__(91);
var GettingStartedDialog_1 = __webpack_require__(688);
var MenuItem_1 = __webpack_require__(109);
var clientInstance_1 = __webpack_require__(10);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(289);
var Divider_1 = __webpack_require__(162);
var InternalLink_1 = __webpack_require__(43);
var routeLinks_1 = __webpack_require__(22);
var UserAccountMenu = (function (_super) {
    __extends(UserAccountMenu, _super);
    function UserAccountMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (el) {
            _this.menuButton = el;
        };
        _this.closeGettingStarted = function () {
            _this.setState({ showGettingStarted: false });
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                isMenuOpen: !_this.state.isMenuOpen
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                isMenuOpen: false,
            });
        };
        _this.showGettingStarted = function () {
            _this.setState({
                isMenuOpen: false,
                showGettingStarted: true
            });
        };
        _this.state = {
            isMenuOpen: false,
            showGettingStarted: false,
            version: ""
        };
        return _this;
    }
    UserAccountMenu.prototype.componentDidMount = function () {
        var version = clientInstance_1.repository.getRootDocument().Version;
        this.setState({ version: version });
    };
    UserAccountMenu.prototype.render = function () {
        return React.createElement("div", null,
            this.state.showGettingStarted && React.createElement(GettingStartedDialog_1.GettingStartedDialog, { onNavigating: this.closeGettingStarted, open: this.state.showGettingStarted, onClose: this.closeGettingStarted }),
            React.createElement("a", { className: cn(styles.button), onClick: this.handleTouchTap, href: "#", ref: this.setRef },
                React.createElement(Avatar_1.Avatar, { user: this.props.currentUser, size: 24 }),
                React.createElement("span", { className: cn(styles.userName, "hide-sm") }, this.props.currentUser.DisplayName),
                React.createElement("em", { className: cn("fa fa-caret-down", styles.icon) })),
            React.createElement(Popover_1.default, { open: this.state.isMenuOpen, anchorEl: this.menuButton, onRequestClose: this.handleRequestClose, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } },
                React.createElement(Menu_1.default, null,
                    React.createElement(MenuItem_1.default, { style: { color: colors_1.secondaryText, fontSize: "0.875rem" }, disabled: true }, "Octopus v" + this.state.version),
                    React.createElement(Divider_1.default, null),
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.currentUser.signOut, onClick: this.handleRequestClose },
                        React.createElement(MenuItem_1.default, { primaryText: "Sign Out" })),
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.currentUser.me, onClick: this.handleRequestClose },
                        React.createElement(MenuItem_1.default, { primaryText: "Profile" })),
                    React.createElement(MenuItem_1.default, { primaryText: "Show Getting Started", onClick: this.showGettingStarted }),
                    React.createElement(Divider_1.default, null),
                    React.createElement(ExternalLink_1.default, { href: "DocumentationHome", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Documentation" })),
                    React.createElement(ExternalLink_1.default, { href: window.location.origin + window.location.pathname + "/../swaggerui/", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "API Documentation" })),
                    React.createElement(ExternalLink_1.default, { href: "HelpGeneral", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Support" })),
                    React.createElement(ExternalLink_1.default, { href: "TrainingVideos", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Training Videos" })),
                    React.createElement(ExternalLink_1.default, { href: "HelpMakeSuggestion", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Suggestions" })),
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/downloads", showIcon: false },
                        React.createElement(MenuItem_1.default, { style: { color: colors_1.primary }, onClick: this.handleRequestClose, primaryText: "Downloads" })))));
    };
    return UserAccountMenu;
}(React.Component));
exports.default = UserAccountMenu;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\UserAccountMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\UserAccountMenu.tsx"); } } })();

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1643);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_avatarContainer__g7FH3{display:inline-flex;align-items:center;justify-content:center;border-radius:50%}", ""]);

// exports
exports.locals = {
	"avatarContainer": "style_avatarContainer__g7FH3"
};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar-placeholder.0876f92fb5eea75f41a4872a88b45c39.hashedasset.svg";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "octopus-service-440.d67f868bec6e1167abe0f9f649f4f34f.hashedasset.svg";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user-placeholder.fd4b3910137a5cbcbd834121d24f1877.hashedasset.svg";

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(233);
var GettingStartedDetailSection = function (props) {
    return React.createElement("span", { className: cn(styles.section, (_a = {}, _a[styles.pulseSection] = props.highlightSection, _a)) },
        props.complete && React.createElement("div", { className: styles.complete },
            React.createElement("em", { className: "fa fa-check", "aria-hidden": "true" })),
        React.createElement("div", { className: styles.top },
            React.createElement("img", { src: props.imgSrc, height: "50", alt: props.area }),
            React.createElement("div", null, props.header),
            React.createElement("div", { className: styles.area }, props.area)),
        React.createElement("div", { className: styles.content }, props.children));
    var _a;
};
exports.default = GettingStartedDetailSection;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDetailSection.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedDetailSection.tsx"); } } })();

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1qGL9{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__Isrzx{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1vtbS{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3vFPC{display:none!important}}.style_progressContainer__1TeC3{width:4rem;height:4rem}.style_title__S9Exc{color:#fff;font-size:.5rem;text-align:center;margin-top:.25rem}.style_progressWrapper__2VYT4{flex-direction:column;display:flex;align-items:center;position:relative}.style_progressWrapper__2VYT4 div.style_complete__30TO8{width:1.25rem;height:1.25rem;border-radius:50px;color:#fff;background-color:#48b350;position:absolute;top:.0625rem;right:19px;z-index:10;font-size:.625rem;align-items:center;justify-content:center;display:flex}.style_gettingStartedFooter__3iESu{position:fixed;left:0;bottom:0;height:auto;width:100%;background:#053b62;z-index:30}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep{color:#fff;display:flex;justify-content:center}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep .style_firstSuccessfulDeployment__32UQQ{display:flex;flex-flow:row}.style_gettingStartedFooter__3iESu .style_firstSuccessfulDeploymentContainer__3Xtep .style_firstSuccessfulDeployment__32UQQ div p{color:#fff}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb{position:fixed;margin:.125rem;right:0;z-index:2}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE{color:#fff;min-width:5.3125rem;padding:.1875rem;margin-bottom:2px;display:block;text-align:right;cursor:pointer}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE:hover{background-color:#2f93e0}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE:hover span{display:inline}.style_gettingStartedFooter__3iESu .style_gettingStartedFooterActions__J1Obb .style_gettingStartedButton__yxInE span{font-size:.8125rem;display:none;padding-right:.1875rem;padding-left:.1875rem;vertical-align:middle}.style_gettingStartedFooter__3iESu .style_gettingStartedMinimize__3dHKy{height:1.8125rem}.style_gettingStartedFooter__3iESu .style_whatsNextContainer__1TBd6{display:flex;align-items:center}@media (max-width:79.9rem){.style_gettingStartedFooter__3iESu .style_whatsNextContainer__1TBd6{justify-content:center}}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe{display:flex;padding:.625rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{color:#fff;text-align:left;margin:.3125rem;display:flex;flex-flow:column;align-items:center}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc .style_whatsNextText__1y7bz{font-size:.75rem;font-weight:400;margin-bottom:.3125rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{display:flex;flex-grow:1;justify-content:flex-end;margin-right:5rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g{display:flex;flex-direction:column;min-width:6.25rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g a{cursor:pointer}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k .style_progressStep__1ei9g:hover{color:#333}@media (max-width:79.9rem){.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe{flex-direction:column}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{margin:0}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc .style_whatsNextText__1y7bz{display:inline-block;margin-left:.3125rem;margin-right:.3125rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{margin-right:2.5rem;justify-content:center;margin-right:0}}@media (max-width:37.4rem){.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_whatsNext__3fcgc{text-align:left;width:80%}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStep__1ei9g{margin-top:1.25rem}.style_gettingStartedFooter__3iESu .style_gettingStartedContent__2myTe .style_progressStepWrapper__155_k{display:none}}.style_gettingStartedFooter__3iESu .style_gettingStartedDetail__3Zjm6{background-color:#fff;margin:1.25rem}.style_li-style__l9UpK{font-family:FontAwesome;display:inline-block;padding-right:5px}@keyframes style_section-pulse__9LYyk{0%{transform:scale(1)}30%{transform:scale(1.08)}40%{transform:scale(1)}50%{transform:scale(1.08)}60%{transform:scale(1.02)}70%{transform:scale(1.06)}80%{transform:scale(1)}to{transform:scale(1)}}.style_pulseSection__1BhfS{animation-duration:2s;animation-iteration-count:1;animation-name:style_section-pulse__9LYyk;animation-delay:0s}.style_liftBusyIndicator__molZw div:first-child{margin-top:-1.5rem}.style_gettingStartedSection__2PC-b{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;width:100%;padding-bottom:20px}.style_section__FP2lJ{margin-right:1.25rem;margin-top:.625rem;display:flex;flex-direction:column;width:13.125rem;position:relative;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff}.style_section__FP2lJ div.style_complete__30TO8{width:2.0625rem;height:2.0625rem;border-radius:50px;color:#fff;background-color:#48b350;position:absolute;top:-15px;right:-15px;z-index:1;font-size:.9375rem;align-items:center;justify-content:center;display:flex}.style_section__FP2lJ .style_top__2dj6-{height:9.375rem;font-size:1.125rem;text-align:center;color:#333}.style_section__FP2lJ .style_top__2dj6- .style_area__2gSY9{font-weight:600}.style_section__FP2lJ .style_top__2dj6- img{margin-bottom:.625rem;margin-top:1.25rem}.style_section__FP2lJ .style_content__3p-R-{padding:0 1rem;min-height:33rem;background-color:#fff;position:relative;margin-top:-2px;font-size:.8125rem;display:flex;justify-content:space-between;flex-direction:column}.style_actionsList__2d-tv{list-style:none;text-align:left;padding:0}.style_actionsList__2d-tv li{padding:.125rem;text-indent:-10px;margin-left:1rem}.style_actionsList__2d-tv li.style_complete__30TO8 a{color:#2f93e0}.style_actionsList__2d-tv li.style_complete__30TO8:before{content:\"\\F00C\";color:#48b350;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_edit__FmgWI a{color:#2f93e0}.style_actionsList__2d-tv li.style_edit__FmgWI:before{content:\"\\F14B\";color:#2f93e0;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_info__1Wric a{color:#2f93e0}.style_actionsList__2d-tv li.style_info__1Wric:before{content:\"\\F05A\";color:#2f93e0;font-family:FontAwesome;display:inline-block;padding-right:5px}.style_actionsList__2d-tv li.style_disabled__6Kyhu{opacity:.5}.style_actionsList__2d-tv li.style_disabled__6Kyhu:before{color:#333}.style_actionsList__2d-tv li.style_completeReadOnly__2gim1{font-weight:600;text-indent:0}.style_actionsList__2d-tv li.style_completeReadOnly__2gim1 div.style_note__14HFH{font-weight:400}.style_actionsList__2d-tv li a,.style_actionsList__2d-tv li span{font-weight:600}.style_actionsList__2d-tv li div.style_note__14HFH{text-indent:0;margin-top:4px;margin-bottom:10px}.style_actionsList__2d-tv li div.style_note__14HFH.style_disabled__6Kyhu{opacity:.5}.style_actionsList__2d-tv li ul.style_dropdown-menu__2PnKD li{text-indent:0;margin-left:0}.style_actionsList__2d-tv li ul.style_dropdown-menu__2PnKD a{font-weight:400}.style_help__1LB_v{text-align:left;margin:.625rem .625rem .625rem 0}.style_getting-started-details-next-action__hmR4Y{margin:1.875rem 0}.style_container__1dK4v{display:flex;align-items:center;justify-content:center;flex-direction:column}.style_container__1dK4v>div{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}@media (max-width:543px){.style_container__1dK4v{padding:0 1rem}.style_section__FP2lJ{width:100%;display:block;margin-top:.625rem}.style_section__FP2lJ .style_top__2dj6-{width:100%;padding:.625rem .625rem 0;height:3.4375rem;font-size:.875rem;letter-spacing:-.25px}.style_section__FP2lJ .style_top__2dj6- img{float:left;margin-right:.625rem;width:1.875rem;top:-8px;position:relative;margin-top:0;margin-bottom:0}.style_section__FP2lJ .style_top__2dj6- div{float:left;margin-right:.4375rem;margin-top:.4375rem}.style_section__FP2lJ div.style_complete__30TO8{width:1.5625rem;height:1.5625rem;top:-6px;right:-11px;font-size:.75rem}.style_section__FP2lJ:first-child{margin-top:1.875rem}.style_section__FP2lJ .style_content__3p-R-{min-height:0}.style_section__FP2lJ .style_content__3p-R- .style_help__1LB_v{position:relative;bottom:0;left:0;text-align:left;margin:0}.style_section__FP2lJ .style_content__3p-R- .style_actionsList__2d-tv li p{font-size:.8125rem}}.style_lookLikeALink__1P6_L{color:#2f93e0;cursor:pointer}.style_successAnimation__3ZmEj{height:250px}.style_successAnimation__3ZmEj .style_balloon__2EOj8,.style_successAnimation__3ZmEj .style_fireworkBlue__2FVnb,.style_successAnimation__3ZmEj .style_fireworkWhite__3gac2,.style_successAnimation__3ZmEj .style_octopus__JP07K,.style_successAnimation__3ZmEj .style_thread__1b-OJ{display:none\\9}.style_detailsWhatsNextContainer__14nww{justify-content:center;padding-bottom:1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1qGL9",
	"hideSm": "style_hide-sm__1qGL9",
	"visible-sm": "style_visible-sm__Isrzx",
	"visibleSm": "style_visible-sm__Isrzx",
	"hide-md": "style_hide-md__1vtbS",
	"hideMd": "style_hide-md__1vtbS",
	"visible-md": "style_visible-md__3vFPC",
	"visibleMd": "style_visible-md__3vFPC",
	"progressContainer": "style_progressContainer__1TeC3",
	"title": "style_title__S9Exc",
	"progressWrapper": "style_progressWrapper__2VYT4",
	"complete": "style_complete__30TO8",
	"gettingStartedFooter": "style_gettingStartedFooter__3iESu",
	"firstSuccessfulDeploymentContainer": "style_firstSuccessfulDeploymentContainer__3Xtep",
	"firstSuccessfulDeployment": "style_firstSuccessfulDeployment__32UQQ",
	"gettingStartedFooterActions": "style_gettingStartedFooterActions__J1Obb",
	"gettingStartedButton": "style_gettingStartedButton__yxInE",
	"gettingStartedMinimize": "style_gettingStartedMinimize__3dHKy",
	"whatsNextContainer": "style_whatsNextContainer__1TBd6",
	"gettingStartedContent": "style_gettingStartedContent__2myTe",
	"whatsNext": "style_whatsNext__3fcgc",
	"whatsNextText": "style_whatsNextText__1y7bz",
	"progressStepWrapper": "style_progressStepWrapper__155_k",
	"progressStep": "style_progressStep__1ei9g",
	"gettingStartedDetail": "style_gettingStartedDetail__3Zjm6",
	"li-style": "style_li-style__l9UpK",
	"liStyle": "style_li-style__l9UpK",
	"pulseSection": "style_pulseSection__1BhfS",
	"section-pulse": "style_section-pulse__9LYyk",
	"sectionPulse": "style_section-pulse__9LYyk",
	"liftBusyIndicator": "style_liftBusyIndicator__molZw",
	"gettingStartedSection": "style_gettingStartedSection__2PC-b",
	"section": "style_section__FP2lJ",
	"top": "style_top__2dj6-",
	"area": "style_area__2gSY9",
	"content": "style_content__3p-R-",
	"actionsList": "style_actionsList__2d-tv",
	"edit": "style_edit__FmgWI",
	"info": "style_info__1Wric",
	"disabled": "style_disabled__6Kyhu",
	"completeReadOnly": "style_completeReadOnly__2gim1",
	"note": "style_note__14HFH",
	"dropdown-menu": "style_dropdown-menu__2PnKD",
	"dropdownMenu": "style_dropdown-menu__2PnKD",
	"help": "style_help__1LB_v",
	"getting-started-details-next-action": "style_getting-started-details-next-action__hmR4Y",
	"gettingStartedDetailsNextAction": "style_getting-started-details-next-action__hmR4Y",
	"container": "style_container__1dK4v",
	"lookLikeALink": "style_lookLikeALink__1P6_L",
	"successAnimation": "style_successAnimation__3ZmEj",
	"fireworkBlue": "style_fireworkBlue__2FVnb",
	"fireworkWhite": "style_fireworkWhite__3gac2",
	"balloon": "style_balloon__2EOj8",
	"thread": "style_thread__1b-OJ",
	"octopus": "style_octopus__JP07K",
	"detailsWhatsNextContainer": "style_detailsWhatsNextContainer__14nww"
};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Popover_1 = __webpack_require__(164);
var Menu_1 = __webpack_require__(203);
var MenuItem_1 = __webpack_require__(109);
var colors_1 = __webpack_require__(31);
var styles = __webpack_require__(233);
var InternalLink_1 = __webpack_require__(43);
var popoverStyle = {
    backgroundColor: colors_1.white,
    color: colors_1.primaryText
};
var menuItemStyle = {
    color: colors_1.primaryText
};
var SectionStepLink = (function (_super) {
    __extends(SectionStepLink, _super);
    function SectionStepLink(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavigate = function () {
            _this.setState({
                open: false
            });
            if (_this.props.onNavigating) {
                _this.props.onNavigating();
            }
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                open: true,
                anchor: event.currentTarget
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: false,
            anchor: null,
        };
        return _this;
    }
    SectionStepLink.prototype.render = function () {
        var _this = this;
        if (this.props.items) {
            return (React.createElement("span", null,
                React.createElement(Popover_1.default, { open: this.state.open, style: popoverStyle, canAutoPosition: true, anchorEl: this.state.anchor, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, onRequestClose: this.handleRequestClose },
                    React.createElement(Menu_1.default, null, this.props.items.map(function (item) {
                        return React.createElement(InternalLink_1.default, { key: item.label, to: item.link },
                            React.createElement(MenuItem_1.default, { key: item.label, style: menuItemStyle, primaryText: item.label, onClick: _this.handleNavigate }));
                    }))),
                React.createElement("span", { className: styles.lookLikeALink, onClick: this.handleTouchTap },
                    this.props.text,
                    this.props.items && React.createElement("em", { style: { paddingLeft: "11px" }, className: "fa fa-caret-down" }))));
        }
        if (this.props.path) {
            return React.createElement(InternalLink_1.default, { to: this.props.path },
                React.createElement("span", { className: styles.lookLikeALink, onClick: function () { return _this.handleNavigate(); } }, this.props.text));
        }
        return React.createElement("span", null, this.props.text);
    };
    return SectionStepLink;
}(React.Component));
exports.SectionStepLink = SectionStepLink;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\SectionStepLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\SectionStepLink.tsx"); } } })();

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RaisedButton_1 = __webpack_require__(241);
var Popover_1 = __webpack_require__(164);
var Menu_1 = __webpack_require__(203);
var MenuItem_1 = __webpack_require__(109);
var colors_1 = __webpack_require__(31);
var InternalLink_1 = __webpack_require__(43);
var buttonStyle = {
    labelColor: colors_1.white,
    backgroundColor: colors_1.success,
};
var popoverStyle = {
    backgroundColor: colors_1.success,
    color: colors_1.white
};
var menuItemStyle = {
    color: colors_1.white
};
var NextButton = (function (_super) {
    __extends(NextButton, _super);
    function NextButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.setState({
                open: true,
                anchor: event.currentTarget
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: false,
            anchor: null
        };
        return _this;
    }
    NextButton.prototype.render = function () {
        var _this = this;
        if (this.props.items.length === 0) {
            return null;
        }
        if (this.props.items.length > 1) {
            var popover = (React.createElement(Popover_1.default, { open: this.state.open, style: popoverStyle, canAutoPosition: true, anchorEl: this.state.anchor, anchorOrigin: { horizontal: "left", vertical: "bottom" }, targetOrigin: { horizontal: "left", vertical: "top" }, onRequestClose: this.handleRequestClose },
                React.createElement(Menu_1.default, null, this.props.items.map(function (item) {
                    return React.createElement(InternalLink_1.default, { key: item.label, to: item.link, onClick: _this.props.onClick },
                        React.createElement(MenuItem_1.default, { primaryText: item.label, style: menuItemStyle, onClick: _this.handleRequestClose }));
                }))));
            return (React.createElement("div", null,
                React.createElement(RaisedButton_1.default, __assign({}, buttonStyle, { style: { margin: "0.5rem" }, label: this.props.defaultLabel, labelPosition: "before", icon: React.createElement("em", { className: "fa fa-caret-down", style: { color: colors_1.white } }), onClick: this.handleTouchTap })),
                popover));
        }
        return (React.createElement(InternalLink_1.default, { to: this.props.items[0].link, onClick: this.props.onClick },
            React.createElement(RaisedButton_1.default, __assign({}, buttonStyle, { style: { margin: "0.5rem" }, label: this.props.defaultLabel }))));
    };
    return NextButton;
}(React.Component));
exports.NextButton = NextButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\NextButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\NextButton.tsx"); } } })();

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1652);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_box__WuJnm,.style_information__hNEcB{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_information__hNEcB{background:rgba(8,120,209,.1)}.style_information__hNEcB .style_title__3E4i5{color:#0878d1}.style_success__2MJei{background:rgba(72,179,80,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_success__2MJei .style_title__3E4i5{color:#48b350}.style_warning__mS5OQ{background:rgba(251,140,0,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_warning__mS5OQ .style_title__3E4i5{color:#fb8c00}.style_danger__3pDp5{background:rgba(219,68,55,.1);padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_danger__3pDp5 .style_title__3E4i5{color:#db4437}.style_none__3NoL2{padding:.625rem 1rem;align-self:stretch;font-size:.875rem;color:#333}.style_title__3E4i5{margin-bottom:.625rem}", ""]);

// exports
exports.locals = {
	"box": "style_box__WuJnm",
	"information": "style_information__hNEcB",
	"title": "style_title__3E4i5",
	"success": "style_success__2MJei",
	"warning": "style_warning__mS5OQ",
	"danger": "style_danger__3pDp5",
	"none": "style_none__3NoL2"
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1654);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1u_rv{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__8-REi{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2fzKy{display:none!important}}@media (min-width:79.9rem){.style_visible-md__pCGNQ{display:none!important}}.style_whatsNextButtonsContainer__13Mzc{display:flex;flex-flow:row;align-items:center;justify-content:space-between}@media (max-width:37.4rem){.style_whatsNextButtonsContainer__13Mzc{flex-flow:column}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1u_rv",
	"hideSm": "style_hide-sm__1u_rv",
	"visible-sm": "style_visible-sm__8-REi",
	"visibleSm": "style_visible-sm__8-REi",
	"hide-md": "style_hide-md__2fzKy",
	"hideMd": "style_hide-md__2fzKy",
	"visible-md": "style_visible-md__pCGNQ",
	"visibleMd": "style_visible-md__pCGNQ",
	"whatsNextButtonsContainer": "style_whatsNextButtonsContainer__13Mzc"
};

/***/ }),
/* 1655 */,
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinksMenu_1 = __webpack_require__(698);
var React = __webpack_require__(0);
exports.LinksMenuButton = function (props) { return React.createElement("li", { key: "navItem-more" },
    React.createElement(LinksMenu_1.LinksMenu, { items: props.moreItems, label: props.label, icon: props.icon })); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\LinksMenuButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\LinksMenu\\LinksMenuButton.tsx"); } } })();

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var notifications_redux_1 = __webpack_require__(176);
var NotificationPoller_1 = __webpack_require__(700);
var notificationLocalState = __webpack_require__(265);
var PermissionCheck_1 = __webpack_require__(42);
var permission_1 = __webpack_require__(51);
var routeLinks_1 = __webpack_require__(22);
var moment = __webpack_require__(119);
var LicenceNotificationPoller = (function (_super) {
    __extends(LicenceNotificationPoller, _super);
    function LicenceNotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationId = "Notification/LicenceCheck";
        _this.notificationCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var licenseStatus, isExpired, isExpiringSoon, showLicenseExpiringNotification, isAdmin, licenseRenewalUrl, license;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Licenses.getCurrentStatus()];
                    case 1:
                        licenseStatus = _a.sent();
                        isExpired = licenseStatus.DaysToEffectiveExpiryDate < 0;
                        isExpiringSoon = licenseStatus.DaysToEffectiveExpiryDate >= 0 && licenseStatus.DaysToEffectiveExpiryDate < 15;
                        showLicenseExpiringNotification = licenseStatus.HostingEnvironment !== "OctopusCloud" && (isExpiringSoon || isExpired);
                        if (!showLicenseExpiringNotification) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        if (this.wasDismissedLoadedOverTwoDasyAgo()) {
                            notificationLocalState.clearValue(this.notificationId);
                        }
                        isAdmin = false;
                        licenseRenewalUrl = "Renew";
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.AdministerSystem })) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientInstance_1.repository.Licenses.getCurrent()];
                    case 2:
                        license = _a.sent();
                        isAdmin = license != null;
                        licenseRenewalUrl = "Renew?licenseKey=" + license.SerialNumber;
                        _a.label = 3;
                    case 3:
                        this.raiseNotification({
                            id: this.notificationId,
                            text: isExpired ? "Your license has expired." : "Your license is expiring soon.",
                            description: "Renew now to continue receiving support and updates.",
                            links: isAdmin
                                ? [{ type: "External", label: "Renew Now", href: licenseRenewalUrl },
                                    { type: "Internal", label: "View license details", href: routeLinks_1.default.configuration.license }]
                                : [{ type: "None", label: "Contact your Octopus administrator to review and renew your license." }],
                            type: isExpired ? notifications_redux_1.NotificationType.error : notifications_redux_1.NotificationType.warn
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    LicenceNotificationPoller.prototype.wasDismissedLoadedOverTwoDasyAgo = function () {
        var userReadLicenseRenewalNotificationOnDateString = notificationLocalState.getCurrentValue(this.notificationId);
        if (userReadLicenseRenewalNotificationOnDateString === null) {
            return false;
        }
        var dateAsNumber = Date.parse(userReadLicenseRenewalNotificationOnDateString);
        if (isNaN(dateAsNumber)) {
            return true;
        }
        return moment(dateAsNumber).isBefore(moment().subtract(2, "days"));
    };
    return LicenceNotificationPoller;
}(NotificationPoller_1.NotificationPoller));
exports.default = LicenceNotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\LicenceNotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\LicenceNotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientInstance_1 = __webpack_require__(10);
var upgradeConfigurationResource_1 = __webpack_require__(478);
var notifications_redux_1 = __webpack_require__(176);
var NotificationPoller_1 = __webpack_require__(700);
var UpdateAvailableNotificationPoller = (function (_super) {
    __extends(UpdateAvailableNotificationPoller, _super);
    function UpdateAvailableNotificationPoller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationId = "Notification/UpgradeAvailable";
        _this.notificationCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var status, config, canUpgradeFreeOfCharge, expiryMessage, description;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ServerStatus.getServerStatus()];
                    case 1:
                        status = _a.sent();
                        // No upgrade available
                        if (!status.IsUpgradeAvailable) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.UpgradeConfiguration.get()];
                    case 2:
                        config = _a.sent();
                        if (config.NotificationMode === upgradeConfigurationResource_1.UpgradeNotificationMode.NeverShow ||
                            config.NotificationMode === upgradeConfigurationResource_1.UpgradeNotificationMode.ShowOnlyMajorMinor && !status.IsMajorMinorUpgrade) {
                            return [2 /*return*/, this.dismissNotification()];
                        }
                        canUpgradeFreeOfCharge = status.MaximumAvailableVersion === status.MaximumAvailableVersionCoveredByLicense;
                        expiryMessage = status.MaintenanceExpires != null ? "expired on " + status.MaintenanceExpires : "has expired";
                        description = "Version " + status.MaximumAvailableVersion + " of Octopus has been released\n             " + (canUpgradeFreeOfCharge
                            ? " and you can upgrade free of charge!"
                            : ". Your license " + expiryMessage + " and covers updates through to " + status.MaximumAvailableVersionCoveredByLicense + ".\n             Please renew your license to upgrade to " + status.MaximumAvailableVersion + ".");
                        this.raiseNotification({
                            id: this.notificationId,
                            value: status.MaximumAvailableVersion,
                            text: "New release available.",
                            type: notifications_redux_1.NotificationType.info,
                            description: description,
                            links: [{
                                    type: "External",
                                    href: "ProductDownloadPage",
                                    label: "Download now"
                                }],
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    return UpdateAvailableNotificationPoller;
}(NotificationPoller_1.NotificationPoller));
exports.default = UpdateAvailableNotificationPoller;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\UpdateAvailableNotificationPoller.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationPoller\\UpdateAvailableNotificationPoller.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var Popover_1 = __webpack_require__(164);
var notifications_1 = __webpack_require__(1660);
var ExternalLink_1 = __webpack_require__(91);
var InternalLink_1 = __webpack_require__(238);
var Divider_1 = __webpack_require__(274);
var Badge_1 = __webpack_require__(487);
var styles = __webpack_require__(1661);
var stylesDefault = __webpack_require__(289);
var colors_1 = __webpack_require__(31);
var BaseComponent_1 = __webpack_require__(12);
var lodash_1 = __webpack_require__(11);
var react_redux_1 = __webpack_require__(64);
var notifications_redux_1 = __webpack_require__(176);
var notificationLocalState = __webpack_require__(265);
var NotificationsMenu = (function (_super) {
    __extends(NotificationsMenu, _super);
    function NotificationsMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.checkNotificationsAlert = function (props) {
            var showNewNotificationsAlert = !!props.notifications
                .find(function (n) {
                var currentValue = notificationLocalState.getCurrentValue(n.id);
                var notificationHasValue = !!n.value;
                return !currentValue ||
                    !((notificationHasValue && currentValue === n.value) || !notificationHasValue);
            });
            _this.setState({ showNewNotificationsAlert: showNewNotificationsAlert });
        };
        _this.renderNotification = function (notification, index) {
            return React.createElement("div", { key: notification.text, className: styles.container },
                index > 0 && React.createElement(Divider_1.default, null),
                React.createElement("div", { className: styles.notification },
                    React.createElement("div", { className: styles.grow },
                        React.createElement("div", { className: cn(styles.title, (_a = {},
                                _a[styles.textHappy] = notification.type === notifications_redux_1.NotificationType.happy,
                                _a[styles.textInfo] = notification.type === notifications_redux_1.NotificationType.info,
                                _a[styles.textWarn] = notification.type === notifications_redux_1.NotificationType.warn,
                                _a[styles.textError] = notification.type === notifications_redux_1.NotificationType.error,
                                _a)) }, notification.text),
                        React.createElement("div", { className: styles.description }, notification.description),
                        notification.links && React.createElement("div", { className: styles.links }, notification.links.map(function (link, i) {
                            return React.createElement("span", { key: i },
                                i > 0 && " | ",
                                _this.renderLink(link));
                        }))),
                    React.createElement("div", { className: styles.icon }, _this.displayIcon(notification.type))));
            var _a;
        };
        _this.markNotificationsAsRead = function () {
            _this.props.notifications
                .forEach(function (n) { return notificationLocalState.setCurrentValue(n.id, n.value); });
            _this.setState({
                showNewNotificationsAlert: false
            });
        };
        _this.displayIcon = function (type) {
            switch (type) {
                case notifications_redux_1.NotificationType.happy:
                    return React.createElement("div", { className: cn("fa fa-smile-o", styles.notificationIcon, styles.bgHappy) });
                case notifications_redux_1.NotificationType.info:
                    return React.createElement("div", { className: cn("fa fa-info-circle", styles.notificationIcon, styles.bgInfo) });
                case notifications_redux_1.NotificationType.warn:
                    return React.createElement("div", { className: cn("fa fa-warning", styles.notificationIcon, styles.bgWarn) });
                case notifications_redux_1.NotificationType.error:
                    return React.createElement("div", { className: cn("fa fa-warning", styles.notificationIcon, styles.bgError) });
            }
        };
        _this.setRef = function (el) {
            _this.menuButton = el;
        };
        _this.handleTouchTap = function (event) {
            event.preventDefault();
            _this.markNotificationsAsRead();
            _this.setState({
                isMenuOpen: !_this.state.isMenuOpen
            });
        };
        _this.handleRequestClose = function () {
            _this.setState({
                isMenuOpen: false,
            });
        };
        _this.state = {
            isMenuOpen: false,
            notifications: [NotificationsMenu.defaultNotification],
            showNewNotificationsAlert: false,
        };
        return _this;
    }
    NotificationsMenu.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.checkNotificationsAlert(this.props);
                return [2 /*return*/];
            });
        });
    };
    NotificationsMenu.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.notifications !== newProps.notifications) {
            this.checkNotificationsAlert(newProps);
        }
    };
    NotificationsMenu.prototype.renderBadge = function () {
        if (this.state.showNewNotificationsAlert) {
            return React.createElement(Badge_1.default, { style: { padding: 0 }, badgeContent: "", badgeStyle: {
                    backgroundColor: colors_1.danger,
                    border: "white 2px solid",
                    top: 0,
                    right: 0,
                    width: 12,
                    height: 12
                } },
                React.createElement(notifications_1.default, { color: colors_1.white }));
        }
        return React.createElement(Badge_1.default, { style: { padding: 0 }, badgeContent: "", badgeStyle: { width: 0, height: 0 } },
            React.createElement(notifications_1.default, { color: colors_1.white }));
    };
    NotificationsMenu.prototype.renderLink = function (link) {
        switch (link.type) {
            case "External": {
                return React.createElement(ExternalLink_1.default, { href: link.href }, link.label);
            }
            case "Internal": {
                return React.createElement(InternalLink_1.default, { to: link.href }, link.label);
            }
            case "Refresh": {
                return React.createElement(InternalLink_1.default, { onClick: function () { return window.location.reload(); }, to: {} }, link.label);
            }
            default: {
                return React.createElement("span", null, link.label);
            }
        }
    };
    NotificationsMenu.prototype.render = function () {
        var notifications = this.props.notifications.slice();
        if (notifications.length === 0) {
            notifications.push(NotificationsMenu.defaultNotification);
        }
        return React.createElement("div", null,
            React.createElement("a", { className: stylesDefault.button, onClick: this.handleTouchTap, href: "#", title: "Notifications", ref: this.setRef }, this.renderBadge()),
            React.createElement(Popover_1.default, { open: this.state.isMenuOpen, anchorEl: this.menuButton, onRequestClose: this.handleRequestClose, anchorOrigin: { horizontal: "right", vertical: "bottom" }, targetOrigin: { horizontal: "right", vertical: "top" } }, notifications.map(this.renderNotification)));
    };
    NotificationsMenu.defaultNotification = {
        id: null,
        text: "You have no notifications.",
        type: notifications_redux_1.NotificationType.happy,
        description: "Happy deployments!"
    };
    return NotificationsMenu;
}(BaseComponent_1.BaseComponent));
exports.default = react_redux_1.connect(function (state, props) {
    return {
        notifications: lodash_1.values(state.notifications)
    };
}, function (dispatch) {
    return {};
})(NotificationsMenu);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationsMenu.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Navbar\\NotificationsMenu.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1660 */,
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1662);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./notifications.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./notifications.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.notifications_hide-sm__2ipZG{display:none!important}}@media (min-width:37.4rem){.notifications_visible-sm__2BKM8{display:none!important}}@media (max-width:79.9rem){.notifications_hide-md___eL7A{display:none!important}}@media (min-width:79.9rem){.notifications_visible-md__pp_fZ{display:none!important}}.notifications_container__1gCNU{display:flex;flex-direction:column;width:18.75rem}@media (max-width:37.4rem){.notifications_container__1gCNU{width:16.25rem}}.notifications_grow__3dIkf{flex-grow:1;padding-right:.625rem}.notifications_notification__2xotL{padding:.4375rem .75rem;display:flex}.notifications_title__ItsQn{font-size:.875rem;font-weight:600;padding-bottom:.0625rem}.notifications_description__1DcYx{font-size:.8125rem;color:#666}.notifications_icon__3jaRG{display:flex;align-items:center}.notifications_links__2erm-{margin-top:.625rem;font-size:.8125rem}.notifications_notificationIcon__2I-wP{width:1.625rem;height:1.625rem;line-height:1.625rem!important;text-align:center;border-radius:.125rem;font-size:.875rem;color:#fff}.notifications_textHappy__3uVq4{color:#74c0fb}.notifications_bgHappy__1a-IF{background-color:#74c0fb}.notifications_textInfo__3VQbg{color:#74c0fb}.notifications_bgInfo__1wzjH{background-color:#74c0fb}.notifications_textWarn__-4KTH{color:#fb8c00}.notifications_bgWarn__NaFUU{background-color:#fb8c00}.notifications_textError__1Lb-D{color:#db4437}.notifications_bgError__1nmGI{background-color:#db4437}", ""]);

// exports
exports.locals = {
	"hide-sm": "notifications_hide-sm__2ipZG",
	"hideSm": "notifications_hide-sm__2ipZG",
	"visible-sm": "notifications_visible-sm__2BKM8",
	"visibleSm": "notifications_visible-sm__2BKM8",
	"hide-md": "notifications_hide-md___eL7A",
	"hideMd": "notifications_hide-md___eL7A",
	"visible-md": "notifications_visible-md__pp_fZ",
	"visibleMd": "notifications_visible-md__pp_fZ",
	"container": "notifications_container__1gCNU",
	"grow": "notifications_grow__3dIkf",
	"notification": "notifications_notification__2xotL",
	"title": "notifications_title__ItsQn",
	"description": "notifications_description__1DcYx",
	"icon": "notifications_icon__3jaRG",
	"links": "notifications_links__2erm-",
	"notificationIcon": "notifications_notificationIcon__2I-wP",
	"textHappy": "notifications_textHappy__3uVq4",
	"bgHappy": "notifications_bgHappy__1a-IF",
	"textInfo": "notifications_textInfo__3VQbg",
	"bgInfo": "notifications_bgInfo__1wzjH",
	"textWarn": "notifications_textWarn__-4KTH",
	"bgWarn": "notifications_bgWarn__NaFUU",
	"textError": "notifications_textError__1Lb-D",
	"bgError": "notifications_bgError__1nmGI"
};

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ErrorPanel_1 = __webpack_require__(85);
exports.default = ErrorPanel_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ErrorPanel\\index.tsx"); } } })();

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RootRoutes_1 = __webpack_require__(1665);
exports.default = RootRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\index.tsx"); } } })();

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var importAsync_1 = __webpack_require__(1666);
var DashboardRoutes_1 = __webpack_require__(1667);
var DashboardOverview_1 = __webpack_require__(701);
var UserProfileRoutes_1 = __webpack_require__(1759);
var ProjectGroupLayout_1 = __webpack_require__(1809);
var DeploymentRoutes_1 = __webpack_require__(1811);
var environment_1 = __webpack_require__(266);
var ReloadableRoute_1 = __webpack_require__(94);
var routeLinks_1 = __webpack_require__(22);
var V3EnvironmentRoutes_1 = __webpack_require__(1813);
var V3AccountRoutes_1 = __webpack_require__(1814);
var V3MachineRoutes_1 = __webpack_require__(1815);
var NotFound_1 = __webpack_require__(465);
var InternalRedirect_1 = __webpack_require__(45);
var ProjectChildRedirect_1 = __webpack_require__(1816);
var ProjectRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2148)); }, function (index) { return index.ProjectRoutes; });
var LibraryRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2149)); }, function (index) { return index.LibraryRoutes; });
var InfrastructureRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2150)); }, function (index) { return index.InfrastructureRoutes; });
var TenantsRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 2151)); }, function (index) { return index.TenantsRoutes; });
var ConfigurationRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2152)); }, function (index) { return index.ConfigurationRoutes; });
var TaskRoutes = importAsync_1.default(function () { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2153)); }, function (index) { return index.TaskRoutes; });
var StyleGuide = importAsync_1.default(function () { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2154)); }, function (index) { return index.StyleGuide; }, !environment_1.default.isInDevelopmentMode());
var CodeGuide = importAsync_1.default(function () { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2155)); }, function (index) { return index.CodeGuide; }, !environment_1.default.isInDevelopmentMode());
var RootRoutes = function (props) { return (React.createElement(react_router_dom_1.Route, { render: function (_a) {
        var location = _a.location;
        if (location.state && location.state.is404) {
            return React.createElement(NotFound_1.NotFound, null);
        }
        // some links out in the wild contain / encoded to %2F which the angular router handled but react-router does not
        if (location.pathname.toUpperCase().includes("%2F")) {
            return React.createElement(InternalRedirect_1.default, { to: location.pathname.replace("%2F", "/").replace("%2f", "/").replace("//", "/") });
        }
        return React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { exact: true, path: routeLinks_1.default.root, component: DashboardOverview_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.dashboard.root, component: DashboardRoutes_1.DashboardRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.projects, component: ProjectRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.projectGroup(":ProjectGroupId").root, component: ProjectGroupLayout_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.infrastructure.root, component: InfrastructureRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.tenants, component: TenantsRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.library.root, component: LibraryRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.tasks.root, component: TaskRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.deployments, component: DeploymentRoutes_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.me, component: UserProfileRoutes_1.default }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.configuration.root, component: ConfigurationRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.styleGuide, component: StyleGuide }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.codeGuide, component: CodeGuide }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.release(":releaseId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.ReleaseRedirect, { releaseId: p.match.params.releaseId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.trigger(":triggerId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.TriggerRedirect, { triggerId: p.match.params.triggerId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.channel(":channelId"), render: function (p) { return React.createElement(ProjectChildRedirect_1.ChannelRedirect, { channelId: p.match.params.channelId }); } }),
            React.createElement(ReloadableRoute_1.default, { path: "/manage/console", render: function (p) { return React.createElement(InternalRedirect_1.default, { to: __assign({}, p.location, { pathname: routeLinks_1.default.tasks.console }) }); } }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments", component: V3EnvironmentRoutes_1.V3EnvironmentRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: "/accounts", component: V3AccountRoutes_1.V3AccountRoutes }),
            React.createElement(ReloadableRoute_1.default, { path: "/machines", component: V3MachineRoutes_1.V3MachineRoutes }),
            React.createElement(NotFound_1.RedirectAs404, null));
    } })); };
exports.default = RootRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\RootRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\RootRoutes.tsx"); } } })();

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BusyIndicator_1 = __webpack_require__(95);
//https://medium.com/@apostolos/server-side-rendering-code-splitting-and-hot-reloading-with-react-router-v4-87239cfc172c
function importAsync(getArea, getComponent, deferLoading) {
    if (getComponent === void 0) { getComponent = function (m) { return m.default; }; }
    if (deferLoading === void 0) { deferLoading = false; }
    var asyncComponent = (_a = (function (_super) {
            __extends(AsyncComponent, _super);
            function AsyncComponent() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.mounted = false;
                _this.state = {
                    Component: AsyncComponent.Component
                };
                return _this;
            }
            AsyncComponent.loadInBackground = function () {
                AsyncComponent.load();
            };
            AsyncComponent.componentAccessorToString = function (accessor) {
                return accessor.toString().replace("function", "");
            };
            AsyncComponent.load = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var area, component, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (AsyncComponent.Component) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                console.log("Loading dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                return [4 /*yield*/, getArea()];
                            case 2:
                                area = _a.sent();
                                component = getComponent(area);
                                AsyncComponent.Component = component;
                                console.log("Loaded dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                console.log("Failed to load a dynamic chunk: " + AsyncComponent.componentAccessorToString(getComponent));
                                console.error(error_1);
                                console.log("Reloading application...");
                                location.reload(true);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            AsyncComponent.prototype.componentDidMount = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.mounted = true;
                                if (!(this.state.Component === null)) return [3 /*break*/, 3];
                                if (!!AsyncComponent.Component) return [3 /*break*/, 2];
                                return [4 /*yield*/, AsyncComponent.load()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (this.mounted) {
                                    this.setState({ Component: AsyncComponent.Component });
                                }
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            };
            AsyncComponent.prototype.componentWillUnmount = function () {
                this.mounted = false;
            };
            AsyncComponent.prototype.render = function () {
                var Component = this.state.Component;
                if (Component) {
                    return React.createElement(Component, __assign({}, this.props));
                }
                return React.createElement(BusyIndicator_1.default, { show: true });
            };
            return AsyncComponent;
        }(React.Component)),
        _a.Component = null,
        _a);
    if (!deferLoading) {
        asyncComponent.loadInBackground();
    }
    return asyncComponent;
    var _a;
}
exports.default = importAsync;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\importAsync.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\importAsync.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardRoutes_1 = __webpack_require__(1668);
exports.DashboardRoutes = DashboardRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\index.tsx"); } } })();

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DashboardOverview_1 = __webpack_require__(701);
var DashboardLayout_1 = __webpack_require__(1733);
var DashboardConfiguration_1 = __webpack_require__(1735);
var RenderWithLayout_1 = __webpack_require__(463);
var ReloadableRoute_1 = __webpack_require__(94);
var dashboardConfiguration = RenderWithLayout_1.renderWithLayout(DashboardLayout_1.default)(DashboardConfiguration_1.default);
var DashboardRoutes = function (props) {
    var match = props.match;
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(ReloadableRoute_1.default, { path: match.url + "/configure", component: dashboardConfiguration }),
        React.createElement(ReloadableRoute_1.default, { path: match.url + "/", component: DashboardOverview_1.default })));
};
exports.default = DashboardRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\DashboardRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardRoutes\\DashboardRoutes.tsx"); } } })();

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1670);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3xHNd{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__8M6Jw{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3q4-0{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1EQJe{display:none!important}}.style_componentRow__3veX_{display:flex;flex-direction:row;align-items:flex-start}.style_componentRow__3veX_>*{margin-right:1rem}@media (max-width:37.4rem){.style_componentRow__3veX_>*{margin-right:unset}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3xHNd",
	"hideSm": "style_hide-sm__3xHNd",
	"visible-sm": "style_visible-sm__8M6Jw",
	"visibleSm": "style_visible-sm__8M6Jw",
	"hide-md": "style_hide-md__3q4-0",
	"hideMd": "style_hide-md__3q4-0",
	"visible-md": "style_visible-md__1EQJe",
	"visibleMd": "style_visible-md__1EQJe",
	"componentRow": "style_componentRow__3veX_"
};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cn = __webpack_require__(19);
var resources_1 = __webpack_require__(17);
var performanceConfigurationResource_1 = __webpack_require__(319);
var PaperLayout_1 = __webpack_require__(154);
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var react_virtualized_1 = __webpack_require__(317);
var DashboardLimiter_1 = __webpack_require__(1672);
var NavigationButton_1 = __webpack_require__(197);
var InternalNavLink_1 = __webpack_require__(248);
var routeLinks_1 = __webpack_require__(22);
var DataCube_1 = __webpack_require__(242);
var DataSet_1 = __webpack_require__(1673);
var releaseRouteLinks_1 = __webpack_require__(311);
var DashboardCell_1 = __webpack_require__(1687);
var DashboardGrid_1 = __webpack_require__(1700);
var styles = __webpack_require__(703);
var ToolTip_1 = __webpack_require__(201);
var logger_1 = __webpack_require__(102);
var ActionButton_1 = __webpack_require__(49);
var clientInstance_1 = __webpack_require__(10);
var lodash_2 = __webpack_require__(11);
var ProjectDashboard = (function (_super) {
    __extends(ProjectDashboard, _super);
    function ProjectDashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.boundingDiv = null;
        _this.cellMeasurerCaches = null;
        _this.initialTop = null;
        _this.loadMoreTakeSize = 30;
        _this.emptyGroupMessage = function (dataSet, groupId) {
            var projectId = _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Project)(null, null, null);
            if (projectId === null) {
                return null;
            }
            var releaseCreateUri = routeLinks_1.default.project(_this.props.cube.projectIndex[projectId]).releaseCreate;
            if (dataSet.groupDimension === DataCube_1.DimensionTypes.Channel) {
                return React.createElement("div", { className: styles.emptyCell },
                    "There are no releases for this channel yet. ",
                    React.createElement(InternalNavLink_1.default, { to: releaseCreateUri + "?channelId=" + groupId }, "Create a release"));
            }
            else if (dataSet.groupDimension === DataCube_1.DimensionTypes.None) {
                return React.createElement("div", { className: styles.emptyCell },
                    "There are no releases for this project yet. ",
                    React.createElement(InternalNavLink_1.default, { to: releaseCreateUri }, "Create a release"));
            }
            return null;
        };
        _this.onLoadMore = function (groupId) { return __awaiter(_this, void 0, void 0, function () {
            var newGroupTakeSizeLookup, takeNumberOfRows;
            return __generator(this, function (_a) {
                newGroupTakeSizeLookup = lodash_2.cloneDeep(this.state.groupTakeSizeLookup);
                takeNumberOfRows = this.state.groupTakeSizeLookup[groupId]
                    ? this.state.groupTakeSizeLookup[groupId]
                    : this.loadMoreTakeSize;
                newGroupTakeSizeLookup[groupId] = takeNumberOfRows += this.loadMoreTakeSize;
                this.setState({ groupTakeSizeLookup: newGroupTakeSizeLookup });
                return [2 /*return*/];
            });
        }); };
        _this.onLoadAll = function (groupId) { return __awaiter(_this, void 0, void 0, function () {
            var newGroupTakeSizeLookup;
            return __generator(this, function (_a) {
                newGroupTakeSizeLookup = lodash_2.cloneDeep(this.state.groupTakeSizeLookup);
                newGroupTakeSizeLookup[groupId] = clientInstance_1.repository.takeAll;
                this.setState({ groupTakeSizeLookup: newGroupTakeSizeLookup });
                return [2 /*return*/];
            });
        }); };
        _this.getChannelName = function (channelId) {
            var channel = _this.props.cube.channelIndex[channelId];
            if (channel) {
                return channel.Name;
            }
            return null;
        };
        _this.getReleaseVersion = function (releaseId) {
            var release = _this.props.cube.releaseIndex[releaseId];
            if (release) {
                return release.Version;
            }
            return null;
        };
        _this.cellMeasurerCaches = lodash_1.memoize(_this.getCellMeasurerCache);
        _this.state = {
            height: 0,
            groupTakeSizeLookup: {},
        };
        return _this;
    }
    ProjectDashboard.prototype.componentDidMount = function () {
        this.calculateTop();
        this.calculateHeight();
        window.addEventListener("resize", this.calculateHeight.bind(this));
    };
    ProjectDashboard.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.calculateHeight.bind(this));
    };
    ProjectDashboard.prototype.calculateTop = function () {
        if (this.boundingDiv !== null) {
            this.initialTop = this.boundingDiv.getBoundingClientRect().top;
        }
    };
    ProjectDashboard.prototype.calculateHeight = function () {
        var approxHeightOfPaddingAndOtherJunk = 90;
        var height = window.innerHeight - this.initialTop - approxHeightOfPaddingAndOtherJunk;
        this.setState({ height: height });
    };
    ProjectDashboard.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !lodash_1.isEqual(getPropsForComparison(nextProps), getPropsForComparison(this.props))
            || nextState.height !== this.state.height
            || nextState.groupTakeSizeLookup !== this.state.groupTakeSizeLookup;
        function getPropsForComparison(props) {
            var onProjectCountChanged = props.onProjectCountChanged, rest = __rest(props, ["onProjectCountChanged"]);
            return rest;
        }
    };
    ProjectDashboard.prototype.render = function () {
        var _this = this;
        if (this.state.height === 0) {
            return React.createElement("div", { ref: function (div) { return _this.boundingDiv = div; } });
        }
        var dataSet = DataSet_1.getDataSet(this.props.filters, this.props.cube);
        var deploymentContext = this.getDeploymentContext(dataSet);
        var groups = this.getProjectRowsLimitedToMaximum(dataSet, this.props.maximumRows);
        if (this.props.onProjectCountChanged) {
            // We calling this in a timeout because the parent sets state
            setTimeout(function () { return _this.props.onProjectCountChanged(lodash_1.flatten(groups.map(function (g) { return g.rowsInGroup; })).length); }, 0);
        }
        return this.redrawMatrix(dataSet, groups, deploymentContext);
    };
    ProjectDashboard.prototype.getCellMeasurerCache = function (groupId) {
        // Be careful about changing this width or height. Virtual scrolling requires a set width, but we need to accommodate
        // for a lot of customer scenarios. Too big and we annoy users who have small version numbers. Too small and we annoy
        // customers with long version numbers.
        var width = 260;
        var height = 70;
        return new react_virtualized_1.CellMeasurerCache({
            defaultWidth: width,
            minWidth: width,
            fixedWidth: true,
            defaultHeight: height,
            minHeight: height,
        });
    };
    ProjectDashboard.prototype.getDeploymentContext = function (dataSet) {
        var _this = this;
        return function (groupId, rowId, columnId) { return ({
            environmentId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Environment)(groupId, rowId, columnId),
            releaseId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Release)(groupId, rowId, columnId),
            tenantId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Tenant)(groupId, rowId, columnId),
            projectId: _this.tryGetValue(dataSet, DataCube_1.DimensionTypes.Project)(groupId, rowId, columnId)
        }); };
    };
    ProjectDashboard.prototype.tryGetValue = function (dataSet, dimensionType) {
        var filters = this.props.filters;
        if (dataSet.groupDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return groupId; };
        }
        else if (dataSet.rowDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return rowId; };
        }
        else if (dataSet.columnDimension === dimensionType) {
            return function (groupId, rowId, columnId) { return columnId; };
        }
        else if (filters[dimensionType]) {
            var environmentIds_1 = Object.keys(filters[dimensionType]);
            if (environmentIds_1.length === 1) {
                return function (groupId, rowId, columnId) { return environmentIds_1[0]; };
            }
        }
        return function () { return null; };
    };
    ProjectDashboard.prototype.buildColumnTitle = function (cube, dataSet, groupId, columnId) {
        var environmentId = columnId;
        if (dataSet.columnDimension === DataCube_1.DimensionTypes.Environment &&
            dataSet.rowDimension === DataCube_1.DimensionTypes.Tenant &&
            this.props.filters[DataCube_1.DimensionTypes.Release]) {
            var releaseFilters = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Release]);
            if (releaseFilters.length === 1) {
                var releaseId = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Release])[0];
                var projectId_1 = Object.keys(this.props.filters[DataCube_1.DimensionTypes.Project])[0];
                var groupTenantsWithoutSuccess_1 = dataSet.getRowsForGroup(groupId)
                    .filter(function (tenantId) {
                    return (tenantId !== null && cube.tenantIndex[tenantId].ProjectEnvironments[projectId_1].indexOf(environmentId) !== -1) &&
                        (!dataSet.matrix[groupId] ||
                            !dataSet.matrix[groupId][tenantId] ||
                            !dataSet.matrix[groupId][tenantId][environmentId] ||
                            !dataSet.matrix[groupId][tenantId][environmentId].find(function (item) { return item.State === resources_1.TaskState.Success; }));
                });
                var availableDeployments = ((cube.nextAvailableDeployments[releaseFilters[0]] || {})[environmentId]);
                if (availableDeployments) {
                    var canDeployAll = availableDeployments.filter(function (t) { return groupTenantsWithoutSuccess_1.indexOf(t) !== -1; });
                    if (canDeployAll.length > 0) {
                        var uri = routeLinks_1.default.project(cube.projectIndex[projectId_1])
                            .release(cube.releaseIndex[releaseId] ? cube.releaseIndex[releaseId].Version : releaseId)
                            .deployments.create(releaseRouteLinks_1.DeploymentCreateGoal.To, environmentId, groupTenantsWithoutSuccess_1);
                        return React.createElement("div", { className: styles.deployAllCell },
                            dataSet.columnTitle(columnId),
                            React.createElement(ToolTip_1.default, { content: "Prepare and preview a deployment to this environment" },
                                React.createElement(NavigationButton_1.NavigationButton, { label: "Deploy All...", href: uri })));
                    }
                }
            }
        }
        return dataSet.columnTitle(columnId);
    };
    ProjectDashboard.prototype.redrawMatrix = function (dataSet, groups, deploymentContext) {
        var _this = this;
        if (!dataSet) {
            return null;
        }
        var rowAndColumnCountsPerGroup = groups.map(function (g) {
            var groupId = g.groupId;
            return { row: g.rowsInGroup.length, column: dataSet.getColumnsForGroup(groupId).length };
        });
        var dashboardLimit = new DashboardLimiter_1.default(rowAndColumnCountsPerGroup);
        // We don't want to clutter cells with channel chips if the UI is grouping things by channel already.
        var shouldShowChannelChips = groups && groups.length === 1 && dataSet.groupDimension !== DataCube_1.DimensionTypes.Channel;
        return groups.map(function (g, index) {
            var groupId = g.groupId;
            var rowsInGroup = g.rowsInGroup;
            var columnsInGroup = dataSet.getColumnsForGroup(groupId);
            // If you can't see any environments in this lifecycle due to permissions, do not let
            // this take up unnecessary vertical space.
            if (columnsInGroup.length === 0) {
                logger_1.default.info("No environments were detected for this group (you may not have permissions).");
                return null;
            }
            var emptyGroupMessage = _this.emptyGroupMessage(dataSet, groupId);
            if (rowsInGroup.length === 0) {
                return (!emptyGroupMessage)
                    ? null
                    : React.createElement(PaperLayout_1.default, { key: groupId, fullWidth: true, innerClassName: styles.container, flatStyle: _this.props.flatStyle },
                        React.createElement("div", { className: cn(styles.headerCell, styles.highlightColumn) }, dataSet.groupTitle(groupId) || dataSet.rowLabel()),
                        emptyGroupMessage);
            }
            var group = dataSet.matrix[groupId] || {};
            var cube = _this.props.cube;
            var firstColumns = [
                React.createElement("div", { className: styles.centerCell }, dataSet.groupTitle(groupId) || dataSet.rowLabel())
            ].concat(rowsInGroup.map(function (rowId) { return dataSet.rowTitle(rowId); }));
            var cellRenderer = function (_a) {
                var columnIndex = _a.columnIndex, rowIndex = _a.rowIndex, key = _a.key, style = _a.style, parent = _a.parent;
                if (columnIndex === 0) {
                    return React.createElement(react_virtualized_1.CellMeasurer, { cache: _this.cellMeasurerCaches(groupId), columnIndex: columnIndex, key: key, parent: parent, rowIndex: rowIndex },
                        React.createElement("div", { style: style, className: cn(styles.headerCell, rowIndex > 0 ? styles.border : styles.highlightColumn), key: key }, firstColumns[rowIndex]));
                }
                var columnId = columnsInGroup[columnIndex - 1];
                if (rowIndex === 0) {
                    return React.createElement(react_virtualized_1.CellMeasurer, { cache: _this.cellMeasurerCaches(groupId), columnIndex: columnIndex, key: key, parent: parent, rowIndex: rowIndex },
                        React.createElement("div", { style: style, className: cn(styles.columnHead, styles.centerCell), key: key }, _this.buildColumnTitle(_this.props.cube, dataSet, groupId, columnId)));
                }
                var rowId = rowsInGroup[rowIndex - 1];
                var context = deploymentContext(groupId, rowId, columnId);
                var row = group[rowId] || {};
                var deployments = row[columnId];
                var deployment = _this.getDeployment(deployments);
                return React.createElement(react_virtualized_1.CellMeasurer, { cache: _this.cellMeasurerCaches(groupId), columnIndex: columnIndex, key: key, parent: parent, rowIndex: rowIndex },
                    React.createElement("div", { style: style, className: cn(styles.centerCell, styles.border), key: key },
                        React.createElement(DashboardCell_1.default, { deployment: deployment, deployments: deployments, deploymentContext: context, allowDeployments: _this.props.allowDeployments, showDeploymentCounts: _this.props.showDeploymentCounts, tenants: Object.values(cube.tenantIndex), showChannelChips: Object.keys(cube.channelIndex).length > 1 && shouldShowChannelChips, channelName: deployment ? _this.getChannelName(deployment.ChannelId) : null, hasReleases: Object.keys(cube.releaseIndex).length > 0, environment: cube.environmentIndex[context.environmentId], project: cube.projectIndex[context.projectId], nextAvailableDeploymentEnvironments: cube.nextAvailableDeployments[context.releaseId], releaseVersion: context ? _this.getReleaseVersion(context.releaseId) : null })));
            };
            var rowAndColumnLimit = dashboardLimit.getLimit(index);
            var isLimited = (rowAndColumnLimit.row < rowsInGroup.length)
                || (rowAndColumnLimit.column < columnsInGroup.length);
            // For customers NOT using virtual scrolling for rows, we're implementing client-side paging
            // to avoid rendering performance issues ootb. People can then "load more" when they want to
            // see more data (or "load all"), which will encourage them to use the filters.
            var loadMoreComponent = null;
            var loadMoreHeaderIndicator = null;
            if (_this.props.dashboardRenderMode === performanceConfigurationResource_1.DashboardRenderMode.VirtualizeColumns) {
                var takeNumberOfRows = _this.state.groupTakeSizeLookup[groupId]
                    ? _this.state.groupTakeSizeLookup[groupId]
                    : _this.loadMoreTakeSize;
                var showLoadMoreAction = takeNumberOfRows < rowAndColumnLimit.row;
                rowAndColumnLimit.row = takeNumberOfRows > rowAndColumnLimit.row
                    ? rowAndColumnLimit.row
                    : takeNumberOfRows;
                loadMoreComponent = showLoadMoreAction && React.createElement("div", { className: styles.loadMoreContainer, key: "lm_" + groupId },
                    React.createElement("div", { className: styles.loadMoreActions },
                        React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Secondary, label: "Load more", onClick: function (e) { return _this.onLoadMore(groupId); } }),
                        React.createElement("div", { className: styles.loadMoreSubText },
                            "Or use filters to narrow the dashboard results (or ",
                            React.createElement("a", { href: "#", onClick: function (e) {
                                    e.preventDefault();
                                    _this.onLoadAll(groupId);
                                } }, "load all"),
                            ")")));
                loadMoreHeaderIndicator = showLoadMoreAction && React.createElement("div", { className: styles.loadMoreHeaderInfo }, "Showing " + takeNumberOfRows + " of " + rowsInGroup.length + " total rows.");
            }
            return React.createElement(DashboardGrid_1.default, { key: groupId, rowCount: rowAndColumnLimit.row + 1, columnCount: rowAndColumnLimit.column + 1, cellRenderer: cellRenderer, flatStyle: _this.props.flatStyle, cube: _this.props.cube, cellMeasurerCache: _this.cellMeasurerCaches(groupId), availableHeight: _this.state.height, showCapDataCallout: isLimited, dashboardRenderMode: _this.props.dashboardRenderMode, headerComponent: loadMoreHeaderIndicator, footerComponent: loadMoreComponent });
        });
    };
    ProjectDashboard.prototype.getDeployment = function (deployments) {
        if (!deployments || !deployments.length) {
            return null;
        }
        return deployments.find(function (item) {
            return item.State === resources_1.TaskState.Executing ||
                item.State === resources_1.TaskState.Failed ||
                (item.State === resources_1.TaskState.Success && item.HasWarningsOrErrors);
        })
            || deployments[0];
    };
    ProjectDashboard.prototype.getProjectRowsLimitedToMaximum = function (dataSet, maximumRows) {
        var hasLimit = maximumRows !== null && maximumRows !== undefined && maximumRows > 0;
        var maxRows = hasLimit ? maximumRows : null;
        // get rows for each group, track our use against the limit
        var groups = dataSet.getGroups().reduce(function (acc, groupId) {
            var value = {
                groupId: groupId,
                rowsInGroup: dataSet.getRowsForGroup(groupId, maxRows)
            };
            if (hasLimit) {
                maxRows = maxRows - value.rowsInGroup.length;
            }
            acc.push(value);
            return acc;
        }, []);
        return groups;
    };
    return ProjectDashboard;
}(React.Component));
exports.default = ProjectDashboard;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ProjectDashboard.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\ProjectDashboard.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RowAndColumnCount = (function () {
    function RowAndColumnCount() {
    }
    return RowAndColumnCount;
}());
var DashboardLimiter = (function () {
    function DashboardLimiter(rowsAndColumnsPerSection) {
        this.limitedRowsAndColumnsPerSection = null;
        this.rowsAndColumnsPerSection = rowsAndColumnsPerSection;
    }
    DashboardLimiter.prototype.getLimit = function (index) {
        if (this.limitedRowsAndColumnsPerSection === null) {
            this.calculateLimits();
        }
        return this.limitedRowsAndColumnsPerSection[index];
    };
    DashboardLimiter.prototype.calculateLimits = function () {
        var _this = this;
        var cellLimitPerSection = DashboardLimiter.totalCellsThatCanBeDrawn / this.rowsAndColumnsPerSection.length;
        this.limitedRowsAndColumnsPerSection = this.rowsAndColumnsPerSection.map(function (r) { return _this.limitRowsAndColumnsForSection(r, cellLimitPerSection); });
    };
    DashboardLimiter.prototype.limitRowsAndColumnsForSection = function (rowsAndColumnsForSection, cellLimitPerSection) {
        var aLotOfRows = 20;
        var ieVersion = document["documentMode"];
        var maxColumnsWhenThereAreLotsOfRows = (ieVersion) // this is to prevent horrible vertical scrolling
            ? 10
            : 30;
        return (rowsAndColumnsForSection.row > aLotOfRows)
            ? this.limitColumns(rowsAndColumnsForSection, cellLimitPerSection, maxColumnsWhenThereAreLotsOfRows)
            : this.limitRows(rowsAndColumnsForSection, cellLimitPerSection);
    };
    DashboardLimiter.prototype.limitColumns = function (rowsAndColumnsForSection, cellLimitPerSection, columnLimit) {
        var columnsToDraw = Math.min(rowsAndColumnsForSection.column, columnLimit);
        var cellsToDraw = Math.min(rowsAndColumnsForSection.row * columnsToDraw, cellLimitPerSection);
        var rowsToDraw = Math.ceil((cellsToDraw / columnsToDraw) || 0);
        return { row: rowsToDraw, column: columnsToDraw };
    };
    DashboardLimiter.prototype.limitRows = function (rowsAndColumnsForSection, cellLimitPerSection) {
        var rowsToDraw = rowsAndColumnsForSection.row;
        var cellsToDraw = Math.min(rowsAndColumnsForSection.column * rowsToDraw, cellLimitPerSection);
        var columnsToDraw = Math.ceil((cellsToDraw / rowsToDraw) || 0);
        return { row: rowsToDraw, column: columnsToDraw };
    };
    DashboardLimiter.totalCellsThatCanBeDrawn = 50000;
    return DashboardLimiter;
}());
exports.default = DashboardLimiter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DashboardLimiter\\DashboardLimiter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\DashboardLimiter\\DashboardLimiter.tsx"); } } })();

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataCube_1 = __webpack_require__(242);
var cn = __webpack_require__(19);
var index_1 = __webpack_require__(74);
var InternalLink_1 = __webpack_require__(43);
var styles = __webpack_require__(1674);
var routeLinks_1 = __webpack_require__(22);
var untenantedDeploymentLogo = __webpack_require__(1676);
var Logo_1 = __webpack_require__(200);
var Tag_1 = __webpack_require__(308);
var lodash_1 = __webpack_require__(11);
var MissingVariablesIcon_1 = __webpack_require__(790);
var TenantMatchesFilter_1 = __webpack_require__(1686);
function getDataSet(filter, self) {
    var rowDimension = filter.rowDimension || DataCube_1.DimensionTypes.None;
    var columnDimension = filter.columnDimension || DataCube_1.DimensionTypes.None;
    var groupDimension = filter.groupBy || DataCube_1.DimensionTypes.None;
    var deployments = self.deployments;
    if (filter[DataCube_1.DimensionTypes.Release]) {
        //To make the rest of the process quicker, filter releases (probably could filter any & all)
        deployments = deployments.filter(function (i) {
            return filter[DataCube_1.DimensionTypes.Release][DataCube_1.DimensionGetters[DataCube_1.DimensionTypes.Release](i)];
        });
    }
    var groupedTagSet = groupDimension === DataCube_1.DimensionTypes.TagSet ?
        self.tagSetIndex[filter.groupByExtra] :
        null;
    var matrix = enterTheMatrix(deployments, getGroupGetter(groupDimension, self), rowDimension, columnDimension);
    var showUntenantedRow = showUntenanted(self);
    return {
        matrix: matrix,
        getGroups: function () {
            var groups = [null];
            if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                groups = [null].concat(lodash_1.sortBy(groupedTagSet.Tags, function (t) { return t.SortOrder; }).map(function (t) { return t.CanonicalTagName; }));
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                groups = lodash_1.sortBy(self.projectGroupIndex, function (g) { return g.Name; }).map(function (g) { return g.Id; });
            }
            else if (filter.groupBy === DataCube_1.DimensionTypes.Channel) {
                groups = Object.keys(self.channelIndex)
                    .map(function (c) { return self.channelIndex[c]; })
                    .sort(function (channelA, channelB) {
                    return (
                    // Sort by default channel first
                    channelA.IsDefault === channelB.IsDefault ? 0
                        : channelA.IsDefault ? -1
                            : 1) || (
                    // Then sort by name alphabetically
                    channelA.Name.toLowerCase() === channelB.Name.toLowerCase() ? 0
                        : channelA.Name.toLowerCase() < channelB.Name.toLowerCase() ? -1
                            : 1);
                }).map(function (channel) { return channel.Id; });
            }
            if (filter.groupBy === DataCube_1.DimensionTypes.TagSet) {
                // If we are filtering by the same tag set that we are grouping by,
                // then all tenants within an excluded group will be filtered out in `getRowsForGroup`
                // But we still want to exclude tenants that don't have any tags from the tag set we are grouping by (i.e. the `null` group)
                return groups.filter(function (g) { return g !== null; });
            }
            else if (filter[filter.groupBy]) {
                return groups.filter(function (groupId) { return filter[filter.groupBy][groupId]; });
            }
            return groups;
        },
        groupTitle: function (groupId) {
            if (!groupDimension || !groupId) {
                return null;
            }
            if (groupDimension === DataCube_1.DimensionTypes.Channel) {
                if (Object.keys(self.channelIndex).length < 2) {
                    return null;
                }
                return React.createElement("div", null,
                    "Channel: ",
                    self.channelIndex[groupId].Name);
            }
            else if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                var tag = groupedTagSet.Tags.find(function (t) { return t.CanonicalTagName === groupId; });
                return React.createElement("div", null,
                    groupedTagSet.Name,
                    ": ",
                    React.createElement(Tag_1.default, { tagName: tag.Name, description: tag.Description, tagColor: tag.Color, showTooltip: false }));
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                return self.projectGroupIndex[groupId].Name;
            }
            else if (filter.groupBy === DataCube_1.DimensionTypes.Channel) {
                if (Object.keys(self.channelIndex).length < 2) {
                    return null;
                }
                return React.createElement("div", null,
                    "Channel: ",
                    self.channelIndex[groupId].Name);
            }
            throw new Error("Only Channel Grouping Supported");
        },
        getRowsForGroup: function (groupId, take) {
            var rows = [];
            if (rowDimension === DataCube_1.DimensionTypes.Tenant) {
                rows = Object.keys(self.tenantIndex);
                if (showUntenantedRow) {
                    if (groupDimension !== DataCube_1.DimensionTypes.TagSet ||
                        (groupId === null && groupDimension === DataCube_1.DimensionTypes.TagSet)) {
                        rows = [null].concat(rows);
                    }
                }
                if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
                    rows = rows.filter(function (tenantId) {
                        var tenant = self.tenantIndex[tenantId];
                        if (groupId === null) {
                            return !tenant || !groupedTagSet.Tags.find(function (t) { return tenant.TenantTags.indexOf(t.CanonicalTagName) !== -1; });
                        }
                        else {
                            return tenant && tenant.TenantTags.indexOf(groupId) !== -1;
                        }
                    });
                }
                // Tenant tag filters on the row only really makes sense if the row is tenants
                if (filter[DataCube_1.DimensionTypes.TagSet]) {
                    var filters_1 = Object.keys(filter[DataCube_1.DimensionTypes.TagSet]).filter(function (k) { return filter[DataCube_1.DimensionTypes.TagSet][k]; });
                    var filteredTagsGroupedByTagSet_1 = Object.keys(self.tagSetIndex)
                        .map(function (k) { return self.tagSetIndex[k]; })
                        .map(function (ts) {
                        return ts.Tags.map(function (t) { return t.CanonicalTagName; })
                            .filter(function (t) { return filters_1.includes(t); });
                    })
                        .filter(function (t) { return t.length > 0; });
                    rows = rows.filter(function (tenantId) {
                        var tenant = self.tenantIndex[tenantId];
                        return tenant && TenantMatchesFilter_1.default(tenant.TenantTags, filteredTagsGroupedByTagSet_1);
                    });
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Project) {
                rows = Object.keys(self.projectIndex);
                if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                    rows = rows.filter(function (projectId) { return self.projectIndex[projectId].ProjectGroupId === groupId; });
                    if (filter[DataCube_1.DimensionTypes.ProjectName]) {
                        var filterName_1 = Object.keys(filter[DataCube_1.DimensionTypes.ProjectName])[0];
                        rows = rows.filter(function (projectId) { return self.projectIndex[projectId].Name.toLocaleUpperCase().includes(filterName_1.toLocaleUpperCase()); });
                    }
                    if (take && rows.length > take) {
                        rows = limitProjects(rows, deployments, take);
                    }
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Release) {
                rows = filter.groupBy === DataCube_1.DimensionTypes.Channel ?
                    Object.keys(self.releaseIndex).filter(function (r) { return self.releaseIndex[r].ChannelId === groupId; }) :
                    Object.keys(self.releaseIndex);
            }
            if (filter[rowDimension]) {
                return rows.filter(function (rowId) { return filter[rowDimension][rowId]; });
            }
            return rows;
        },
        rowTitle: function (rowId) {
            if (rowDimension === DataCube_1.DimensionTypes.Tenant) {
                if (rowId === null) {
                    return tile(untenantedDeploymentLogo, "Untenanted");
                }
                else {
                    var hasMissingVariable = self.missingVariableTenants.indexOf(rowId) !== -1;
                    var tenant = self.tenantIndex[rowId];
                    return React.createElement("div", { className: styles.rowHeader, style: { justifyContent: "space-between" } },
                        tile(tenant.Links.Logo, tenant.Name, routeLinks_1.default.tenant(rowId).root),
                        hasMissingVariable && React.createElement(InternalLink_1.default, { to: routeLinks_1.default.tenant(rowId).variables() },
                            React.createElement(MissingVariablesIcon_1.default, { show: true })));
                }
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Project) {
                var project = self.projectIndex[rowId];
                return tile(project.Links.Logo, project.Name, routeLinks_1.default.project(project).root, project.IsDisabled);
            }
            else if (rowDimension === DataCube_1.DimensionTypes.Release) {
                var release = self.releaseIndex[rowId];
                var msg = "This release has been blocked from future deployments. View the release details for more information.";
                return React.createElement("div", { className: styles.rowCell },
                    React.createElement("div", { className: styles.rowHeader },
                        React.createElement(InternalLink_1.default, { to: routeLinks_1.default.project(self.projectIndex[release.ProjectId]).release(release).root }, release.Version)),
                    self.blockedReleases.indexOf(rowId) !== -1 &&
                        React.createElement("div", { className: styles.blockAlert },
                            React.createElement(index_1.default, { content: msg },
                                React.createElement("em", { className: cn("fa fa-exclamation-triangle", styles.blockAlertIcon) }))));
            }
        },
        getColumnsForGroup: function (groupId) {
            var colms = Object.keys(self.environmentIndex);
            if (groupDimension === DataCube_1.DimensionTypes.Channel) {
                colms = self.channelEnvironments[groupId]
                    .filter(function (environmentId) { return colms.includes(environmentId); });
            }
            else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
                var projectEnvironments_1 = Object.keys(self.projectIndex).map(function (p) { return self.projectIndex[p]; })
                    .filter(function (p) { return p.ProjectGroupId === groupId; }).reduce(function (arr, p) { return arr.concat(p.EnvironmentIds); }, []);
                colms = colms.filter(function (environmentId) { return projectEnvironments_1.indexOf(environmentId) !== -1; });
            }
            if (filter[columnDimension]) {
                return colms.filter(function (rowId) { return filter[columnDimension][rowId]; });
            }
            return colms;
        },
        columnTitle: function (columnId) {
            //Currently only supports environments for column
            return self.environmentIndex[columnId].Name;
        },
        rowLabel: function () {
            switch (rowDimension) {
                case DataCube_1.DimensionTypes.Tenant:
                    return "Tenant";
                case DataCube_1.DimensionTypes.Release:
                    return "Release";
                default:
                    return "";
            }
        },
        groupDimension: groupDimension,
        rowDimension: rowDimension,
        columnDimension: columnDimension
    };
}
exports.getDataSet = getDataSet;
function getGroupGetter(groupDimension, cube) {
    if (groupDimension === DataCube_1.DimensionTypes.TagSet) {
        // Tag sets need special getter since they aren't stored on the deployment item itself
        return function (item) { return item.TenantId ? (cube.tenantTagIndex[item.TenantId] || []) : []; };
        //groupedTagSet = cube.tagSetIndex[filter.groupByExtra];
    }
    else if (groupDimension === DataCube_1.DimensionTypes.ProjectGroup) {
        // Project groups need special getter since they aren't stored on the deployment item itself
        return function (item) {
            var project = cube.projectIndex[item.ProjectId]; //the project won't be here if we've filterd due to project limit
            return project ? project.ProjectGroupId : null;
        };
    }
    return DataCube_1.DimensionGetters[groupDimension];
}
function showUntenanted(self) {
    var canPerformUntenanted = self.projectIndex[Object.keys(self.projectIndex)[0]].CanPerformUntenantedDeployment;
    if (canPerformUntenanted) {
        return true;
    }
    return !!self.deployments.find(function (d) { return d.TenantId === null; });
}
function tile(logoUrl, name, toUrl, isDisabled) {
    // These need to be in separate spans (otherwise lots of text smooshes the image, aka. main dashboard).
    if (toUrl) {
        return React.createElement(InternalLink_1.default, { to: toUrl, className: cn(styles.rowHeader, isDisabled ? styles.disabled : null) },
            React.createElement("span", null,
                React.createElement(Logo_1.default, { url: logoUrl, size: "2.25rem", isDisabled: isDisabled })),
            React.createElement("span", { style: { paddingLeft: "0.25rem" }, title: isDisabled ? "Disabled" : "" }, name));
    }
    else {
        return React.createElement("div", { className: cn(styles.rowHeader, isDisabled ? styles.disabled : null) },
            React.createElement("span", null,
                React.createElement(Logo_1.default, { url: logoUrl, size: "2.25rem", isDisabled: isDisabled })),
            React.createElement("span", { style: { paddingLeft: "0.25rem" }, title: isDisabled ? "Disabled" : "" }, name));
    }
}
function enterTheMatrix(deployments, groupByFunction, rowDimension, columnDimension) {
    var rowFromTask = DataCube_1.DimensionGetters[rowDimension];
    var columnFromTask = DataCube_1.DimensionGetters[columnDimension];
    var matrix = {};
    deployments.forEach(function (deploymentTask) {
        var groupingIds = groupByFunction(deploymentTask);
        if (!Array.isArray(groupingIds)) {
            groupingIds = [groupingIds];
        }
        if (groupingIds.length === 0) {
            groupingIds = [null];
        }
        groupingIds.forEach(function (groupingId) {
            var group = matrix[groupingId];
            if (!group) {
                group = matrix[groupingId] = {};
            }
            var rowId = rowFromTask(deploymentTask);
            var row = group[rowId];
            if (!row) {
                row = group[rowId] = {};
            }
            var columnId = columnFromTask(deploymentTask);
            if (!row[columnId]) {
                row[columnId] = [];
            }
            row[columnId].push(deploymentTask);
        });
    });
    Object.keys(matrix)
        .forEach(function (groupId) { return Object.keys(matrix[groupId])
        .forEach(function (rowId) { return Object.keys(matrix[groupId][rowId])
        .forEach(function (columnId) {
        var latestByContext = getLatestDeploymentPerContext(matrix[groupId][rowId][columnId]);
        matrix[groupId][rowId][columnId] = lodash_1.sortBy(latestByContext, [function (t) { return t.ReleaseVersion; }, function (t) { return new Date(t.CompletedTime || t.Created); }]);
    }); }); });
    return matrix;
}
function getLatestDeploymentPerContext(deployments) {
    var latestPerDeploymentContext = deployments.reduce(function (idx, item) {
        var key = item.EnvironmentId + item.ReleaseId + item.TenantId + item.ProjectId;
        var current = idx[key] || null;
        if (!current || new Date(current.CompletedTime || current.Created) < new Date(item.CompletedTime || current.Created)) {
            idx[key] = item;
        }
        return idx;
    }, {});
    return Object.keys(latestPerDeploymentContext).map(function (e) { return latestPerDeploymentContext[e]; });
}
function limitProjects(data, items, limit) {
    if (data.length <= limit) {
        return;
    }
    var included = limit > 0 ? data.slice(0, limit) : [];
    var erroredOrRunning = items.filter(function (p) { return p.HasWarningsOrErrors || !p.IsCompleted; });
    var keep = data
        .slice(limit)
        .filter(function (p) { return erroredOrRunning.some(function (e) { return e.ProjectId === p; }); });
    return included.concat(keep);
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataSet.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DataSet.tsx"); } } })();

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1675);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_rowHeader__FuLu8{display:flex;flex-direction:row;align-items:center;height:100%;justify-content:left;font-weight:500}.style_blockAlert__2Mq41{font-size:1.3rem}.style_blockAlertIcon__7fWsI{font-size:1.25rem;opacity:.2}.style_rowCell__3gFsd{display:flex;justify-content:space-between;align-items:center}.style_disabled__uK73w *{color:#9e9e9e}", ""]);

// exports
exports.locals = {
	"rowHeader": "style_rowHeader__FuLu8",
	"blockAlert": "style_blockAlert__2Mq41",
	"blockAlertIcon": "style_blockAlertIcon__7fWsI",
	"rowCell": "style_rowCell__3gFsd",
	"disabled": "style_disabled__uK73w"
};

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "un-tenanted-deployment-logo.8ea431cf9cc0acc1ad26ca59cc16f376.hashedasset.svg";

/***/ }),
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1683);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_logo__M4qZr{display:flex;align-items:center;align-content:center;justify-content:center}.style_logo__M4qZr img{height:auto;width:auto}.style_logo__M4qZr .style_disabled__LoIvK{-webkit-filter:grayscale(1);filter:grayscale(1);opacity:.4}", ""]);

// exports
exports.locals = {
	"logo": "style_logo__M4qZr",
	"disabled": "style_disabled__LoIvK"
};

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1685);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".styles_clickableTag__2VYzM>div:first-child:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background:hsla(0,0%,100%,.25);opacity:0;transition:all .5s;-webkit-transition:all .5s;-moz-transition:all .5s;border-radius:1rem;z-index:0}.styles_clickableTag__2VYzM>div:first-child:hover:after{opacity:1}.styles_clickableTag__2VYzM>div span{z-index:1}", ""]);

// exports
exports.locals = {
	"clickableTag": "styles_clickableTag__2VYzM"
};

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// This logic matches our logic for filtering by tenant tags as described here:
// https://octopus.com/docs/reference/tenant-tags#TenantTags-Tag-basedfilters
// Ideally, we should be using this function anywhere we filter by tenant tags on the client
function tenantMatchesFilter(tenantTags, filterBy) {
    return filterBy.every(function (tagSet) { return tagSet.some(function (t) { return tenantTags.includes(t); }); });
}
exports.default = tenantMatchesFilter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\TenantMatchesFilter.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\tenants\\TenantMatchesFilter.ts"); } } })();

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TaskStatusDetails_1 = __webpack_require__(831);
var resources_1 = __webpack_require__(17);
var Button_1 = __webpack_require__(47);
var index_1 = __webpack_require__(1695);
var index_2 = __webpack_require__(74);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1698);
var routeLinks_1 = __webpack_require__(22);
var releaseRouteLinks_1 = __webpack_require__(311);
var PermissionCheck_1 = __webpack_require__(42);
var permission_1 = __webpack_require__(51);
var DashboardCell = (function (_super) {
    __extends(DashboardCell, _super);
    function DashboardCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getUnavailableToDeployWarning = function (projectId, environmentId) {
            var missing = [];
            if (!projectId) {
                missing.push("project");
            }
            if (!environmentId) {
                missing.push("environment");
            }
            var missingDescription = "";
            if (missing.length === 1) {
                missingDescription = missing[0];
            }
            else if (missing.length > 1) {
                missingDescription = missing.slice(0, missing.length - 1).join(", ").concat(" and ").concat(missing[missing.length - 1]);
            }
            var text = "Filter the dashboard by " + missingDescription + " to perform a deployment.";
            return (React.createElement(index_2.default, { content: text },
                React.createElement(Button_1.ActionButton, { label: "Filter Required", disabled: true })));
        };
        _this.tenantDeploymentCount = function (visibleDeploymentItem) {
            var _a = _this.props, deployments = _a.deployments, deploymentContext = _a.deploymentContext;
            if (deploymentContext.tenantId) {
                // If tenant already in context, then no point extending in "Z" dimension
                return null;
            }
            var projectId = deploymentContext.projectId;
            if (!projectId) {
                // Seems like tenants aren't involved in this project
                return null;
            }
            var environmentId = deploymentContext.environmentId;
            if (!environmentId) {
                // We need an environment to tell how many tenants are relevant
                return null;
            }
            var tenantsInProjectEnvironment = _this.props.tenants.filter(function (tenant) {
                var projectEnvs = tenant.ProjectEnvironments[projectId];
                return projectEnvs && projectEnvs.indexOf(environmentId) !== -1;
            });
            if (tenantsInProjectEnvironment.length === 0) {
                // No tenants involved in this tenanted project, no point showing anything
                return null;
            }
            var haveCountedTenant = {};
            var progress = deployments.reduce(function (sum, deployment) {
                if (deployment.ReleaseId === visibleDeploymentItem.ReleaseId &&
                    deployment.TenantId && !haveCountedTenant[deployment.TenantId] &&
                    //Only consider if tenant currently in environment (ignore if deployed when previously linked)
                    tenantsInProjectEnvironment.find(function (t) { return t.Id === deployment.TenantId; })) {
                    haveCountedTenant[deployment.TenantId] = true;
                    if (deployment.State === resources_1.TaskState.Success) {
                        return sum + 1;
                    }
                }
                return sum;
            }, 0);
            return React.createElement(index_1.default, { progress: progress, expected: tenantsInProjectEnvironment.length });
        };
        return _this;
    }
    DashboardCell.prototype.render = function () {
        var _a = this.props, deployments = _a.deployments, deploymentContext = _a.deploymentContext, allowDeployments = _a.allowDeployments;
        if (deployments && deployments.length) {
            return this.renderTaskStatusCell();
        }
        if (!allowDeployments) {
            return null;
        }
        var projectId = deploymentContext.projectId, releaseId = deploymentContext.releaseId, environmentId = deploymentContext.environmentId, tenantId = deploymentContext.tenantId;
        // You've got a tenant... but this tenant can't deploy this environment so... nah
        if (!!tenantId) {
            var tenant = this.props.tenants.find(function (t) { return t.Id === tenantId; });
            if (tenant && tenant.ProjectEnvironments[projectId].indexOf(environmentId) === -1) {
                var environment = this.props.environment;
                return React.createElement("div", { className: styles.cell }, this.renderNoDeployCell(tenant.Name + " is not linked to the " + environment.Name + " environment", projectId, environmentId, tenantId));
            }
        }
        // We are looking at an untenanted deployment on a project that can't do untenanted deployments, so... nope.
        if (!tenantId && !this.props.project.CanPerformUntenantedDeployment) {
            return React.createElement("div", { className: styles.cell }, this.renderNoDeployCell("This project can not perform untenanted deployments", projectId, environmentId));
        }
        // No release
        if (!releaseId) {
            var text = "Create a release first to deploy project";
            if (this.props.hasReleases) {
                text = "Filter the dashboard by releases to perform a deployment";
            }
            return React.createElement("div", { className: styles.cell },
                React.createElement(index_2.default, { content: text },
                    React.createElement(Button_1.ActionButton, { label: "Filter Required", disabled: true })));
        }
        // This scenario is likely only available when we add more filters
        if (!environmentId || !projectId) {
            return React.createElement("div", { className: styles.cell }, this.getUnavailableToDeployWarning(projectId, environmentId));
        }
        // Ok... so looks like you can deploy to this environment
        var nextAvailableDeploymentEnvironments = this.props.nextAvailableDeploymentEnvironments;
        if (nextAvailableDeploymentEnvironments) {
            var tenantReleases = nextAvailableDeploymentEnvironments[environmentId];
            if (tenantReleases && tenantReleases.indexOf(tenantId) !== -1) {
                var uri = routeLinks_1.default.project(this.props.project)
                    .release(this.props.releaseVersion)
                    .deployments.create(releaseRouteLinks_1.DeploymentCreateGoal.To, environmentId, tenantId);
                return React.createElement("div", { className: styles.cell },
                    React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, project: projectId, environment: environmentId, tenant: tenantId },
                        React.createElement(index_2.default, { content: "Prepare and preview a deployment to this environment" },
                            React.createElement(Button_1.NavigationButton, { label: "Deploy...", titleAltText: "", href: uri }))));
            }
        }
        return React.createElement("div", { className: styles.cell }, this.renderNoDeployCell("Release " + this.props.releaseVersion + " can not be deployed to the " + this.props.environment.Name + " environment", projectId, environmentId, tenantId));
    };
    DashboardCell.prototype.renderTaskStatusCell = function () {
        var totalDiv = this.props.showDeploymentCounts && this.tenantDeploymentCount(this.props.deployment);
        var project = this.props.project;
        var projectSlug = project ? project.Slug : null;
        return React.createElement("div", { className: styles.taskDetailsCell },
            React.createElement(TaskStatusDetails_1.TaskStatusDetails, { item: this.props.deployment, channelName: this.props.showChannelChips ? this.props.channelName : null, projectSlug: projectSlug, deploymentId: this.props.deployment.DeploymentId, additionalDetails: totalDiv }));
    };
    DashboardCell.prototype.renderNoDeployCell = function (message, projectId, environmentId, tenantId) {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.DeploymentCreate, project: projectId, environment: environmentId, tenant: tenantId },
            React.createElement(index_2.default, { content: message },
                React.createElement("div", { className: styles.blockIcon },
                    React.createElement("em", { className: cn("fa fa-ban") }))));
    };
    return DashboardCell;
}(React.PureComponent));
exports.default = DashboardCell;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardCell\\DashboardCell.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardCell\\DashboardCell.tsx"); } } })();

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1689);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1LhW1{display:flex;flex-direction:row;align-items:center;justify-content:left;min-width:11.25rem;padding:.5rem}.style_container__1LhW1 .style_additionalDetails__q5-QQ{margin-left:.5rem}.style_task-previous__mHeho{opacity:.65}.style_task-archived__G1KfB{opacity:.2}.style_details__10UKL{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding-left:.5rem;width:100%}.style_taskName__z8Cch,.style_version__3y8GX{color:#333;font-weight:500;font-size:.9375rem;display:flex;align-items:center;width:100%}.style_date__1SpQz{color:#666;font-weight:400;font-size:.6875rem}.style_taskLink__1_d2s:hover{background-color:hsla(0,0%,60%,.08)}", ""]);

// exports
exports.locals = {
	"container": "style_container__1LhW1",
	"additionalDetails": "style_additionalDetails__q5-QQ",
	"task-previous": "style_task-previous__mHeho",
	"taskPrevious": "style_task-previous__mHeho",
	"task-archived": "style_task-archived__G1KfB",
	"taskArchived": "style_task-archived__G1KfB",
	"details": "style_details__10UKL",
	"version": "style_version__3y8GX",
	"taskName": "style_taskName__z8Cch",
	"date": "style_date__1SpQz",
	"taskLink": "style_taskLink__1_d2s"
};

/***/ }),
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1694);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".styles_clickableChip__tSjgX>div:first-child:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.2);opacity:0;transition:all .5s;-webkit-transition:all .5s;-moz-transition:all .5s;border-radius:1rem;z-index:0}.styles_clickableChip__tSjgX>div:first-child:hover:after{opacity:1}.styles_clickableChip__tSjgX>div span{z-index:1}", ""]);

// exports
exports.locals = {
	"clickableChip": "styles_clickableChip__tSjgX"
};

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1696);
var TenantDeploymentCount = function (props) {
    return React.createElement("span", { className: styles.container },
        React.createElement("span", { className: styles.progress }, props.progress),
        React.createElement("span", { className: styles.expected },
            "/",
            props.expected),
        "    ");
};
exports.default = TenantDeploymentCount;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TenantDeploymentCount\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\TenantDeploymentCount\\index.tsx"); } } })();

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1697);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1_0si{display:flex;justify-content:center;align-items:center;height:1.25rem;color:#fff;font-size:.69rem;text-shadow:0 -.0625rem 0 rgba(0,0,0,.2);padding:0 .25rem;white-space:nowrap;border-radius:.25em;background:#9e9e9e}.style_expected__voO9P,.style_progress__jXOt-{visibility:visible}", ""]);

// exports
exports.locals = {
	"container": "style_container__1_0si",
	"progress": "style_progress__jXOt-",
	"expected": "style_expected__voO9P"
};

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1699);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_taskDetailsCell__dEHne{display:flex}.style_blockIcon__36wOe{opacity:.2;font-size:2.5rem}.style_cell__357lZ{padding:.5rem}", ""]);

// exports
exports.locals = {
	"taskDetailsCell": "style_taskDetailsCell__dEHne",
	"blockIcon": "style_blockIcon__36wOe",
	"cell": "style_cell__357lZ"
};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var performanceConfigurationResource_1 = __webpack_require__(319);
var Callout_1 = __webpack_require__(58);
var PaperLayout_1 = __webpack_require__(154);
var lodash_1 = __webpack_require__(11);
var React = __webpack_require__(0);
var react_virtualized_1 = __webpack_require__(317);
var styles = __webpack_require__(703);
var DashboardGrid = (function (_super) {
    __extends(DashboardGrid, _super);
    function DashboardGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.virtualGrid = null;
        _this.state = {
            height: _this.calculateGridHeight(_this.props.availableHeight, _this.props.dashboardRenderMode)
        };
        return _this;
    }
    DashboardGrid.prototype.componentDidMount = function () {
        var _this = this;
        if (this.state.height < this.props.availableHeight || this.props.dashboardRenderMode === performanceConfigurationResource_1.DashboardRenderMode.VirtualizeColumns) {
            setTimeout(function () { return _this.setState({ height: _this.calculateGridHeight(_this.props.availableHeight, _this.props.dashboardRenderMode) }); }, 0);
        }
    };
    DashboardGrid.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.availableHeight !== this.props.availableHeight || nextProps.dashboardRenderMode !== this.props.dashboardRenderMode) {
            this.setState({ height: this.calculateGridHeight(nextProps.availableHeight, nextProps.dashboardRenderMode) });
        }
    };
    DashboardGrid.prototype.componentWillUpdate = function (nextProps) {
        var _this = this;
        if (nextProps.rowCount !== this.props.rowCount || nextProps.columnCount !== this.props.columnCount) {
            this.props.cellMeasurerCache.clearAll();
        }
        else if (nextProps.cube !== this.props.cube) {
            lodash_1.range(0, nextProps.columnCount).forEach(function (index) { return _this.props.cellMeasurerCache.clear(0, index); });
        }
    };
    DashboardGrid.prototype.componentDidUpdate = function (nextProps) {
        if (nextProps.rowCount !== this.props.rowCount) {
            this.setState({ height: this.calculateGridHeight(nextProps.availableHeight, nextProps.dashboardRenderMode) });
        }
    };
    DashboardGrid.prototype.calculateGridHeight = function (availableHeight, dashboardRenderMode) {
        var _this = this;
        var scrollbarControlOffset = 20; //TODO: Find a better approach for this long term, but this solves the problem for now.
        var totalRowHeight = lodash_1.range(0, this.props.rowCount)
            .map(function (index) { return _this.props.cellMeasurerCache.rowHeight({ index: index }); })
            .reduce(function (prev, cur) { return prev + cur; }, 0);
        if (dashboardRenderMode === performanceConfigurationResource_1.DashboardRenderMode.VirtualizeColumns) {
            return totalRowHeight + scrollbarControlOffset;
        }
        var rowsThatCanFitIntoAvailableHeight = Math.round(availableHeight / this.props.cellMeasurerCache.defaultHeight);
        var minRowsToShow = this.props.rowCount > 2 // We always need to show some rows for phones/tablets
            ? 3
            : this.props.rowCount + 1;
        var height = minRowsToShow > rowsThatCanFitIntoAvailableHeight
            ? minRowsToShow * this.props.cellMeasurerCache.defaultHeight
            : Math.min(rowsThatCanFitIntoAvailableHeight * this.props.cellMeasurerCache.defaultHeight, totalRowHeight) + scrollbarControlOffset;
        return height;
    };
    DashboardGrid.prototype.render = function () {
        var _this = this;
        return React.createElement(PaperLayout_1.default, { fullWidth: true, innerClassName: styles.container, flatStyle: this.props.flatStyle },
            this.props.showCapDataCallout && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning }, "The following dashboard group has been limited to prevent your computer from melting. Use filters to narrow the dashboard results."),
            this.props.headerComponent,
            React.createElement(react_virtualized_1.AutoSizer, { disableHeight: true }, function (_a) {
                var width = _a.width;
                return (React.createElement(react_virtualized_1.MultiGrid, { height: _this.state.height, width: width, rowCount: _this.props.rowCount ? _this.props.rowCount : 0, rowHeight: _this.props.cellMeasurerCache.rowHeight, estimatedColumnSize: _this.props.cellMeasurerCache.defaultWidth, fixedRowCount: 1, fixedColumnCount: 1, enableFixedRowScroll: true, enableFixedColumnScroll: true, columnCount: _this.props.columnCount ? _this.props.columnCount : 0, columnWidth: _this.props.cellMeasurerCache.columnWidth, estimatedRowSize: _this.props.cellMeasurerCache.defaultHeight, deferredMeasurementCache: _this.props.cellMeasurerCache, cellRenderer: _this.props.cellRenderer, classNameBottomRightGrid: styles.innerGrid, ref: function (virtualGrid) { return _this.virtualGrid = virtualGrid; }, cube: _this.props.cube, virtualRows: _this.props.dashboardRenderMode }));
            }),
            this.props.footerComponent);
    };
    return DashboardGrid;
}(React.Component));
exports.default = DashboardGrid;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardGrid.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectDashboard\\DashboardGrid.tsx"); } } })();

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_group__34D0R{margin-top:4rem}.style_deployAllCell__3A0Pr{display:flex;flex-direction:column;align-items:center}.style_deploy__2LCgp{text-transform:uppercase;text-decoration:none;color:#2f93e0;font-size:.875rem}.style_border__2wzaH,.style_dashboardTable__a5vIL td,.style_spacerCell__1NGeP{border-bottom:.0625rem dashed #ccc}.style_spacerCell__1NGeP{width:100%}.style_headerCell__3CB_E{font-size:1.0625rem;padding:1rem 1.125rem 1rem 1rem;font-weight:500;word-break:break-all}.style_headerCell__3CB_E a{font-weight:500}.style_columnHead__3tL0c{font-size:1.0625rem;padding:1rem 1.125rem 1rem 1rem;font-weight:400;display:flex}.style_highlightColumn__3Ur_n{font-weight:600;padding-left:1rem;display:flex}.style_centerCell__wc3-E{display:flex;align-items:center;justify-content:flex-start;text-align:left;min-width:12.5rem;max-width:18.75rem;word-wrap:break-word;word-break:break-all}.style_blankCell__3syzF{width:.0625rem;height:5rem}.style_container__oYOe7{overflow:hidden;margin-bottom:1rem}.style_scrollableContainer__1ED8p{flex-grow:1;overflow-x:auto}.style_emptyCell__2BvyH{padding:1rem;width:100%}.style_headersOverflowContainer__2ynKo{z-index:2;position:absolute;background-color:#fff;overflow-x:auto}.style_dataContainer__3SK0W,.style_headersContainer__22OIL{display:flex;flex-direction:row}.style_dataContainer__3SK0W{position:relative}.style_firstColumnContainer__3aL_R{display:flex;flex-direction:column;z-index:3}.style_scrollbarPadding__BEZDs{height:20px}.style_hideScrollbarPanel__3RPNf{position:absolute;bottom:0;left:0;z-index:2;background-color:#fff;width:100%;height:20px}.style_rightContainer__xQbeA{overflow-x:hidden;flex-grow:1}.style_scrollableTableContainer__3HKqG{display:flex}.style_innerGrid__1JXFJ{box-sizing:content-box!important;overflow-x:scroll!important;overflow-y:scroll!important;padding-right:1rem;padding-bottom:1rem;-ms-overflow-style:none}.style_innerGrid__1JXFJ:focus{outline:none}.style_innerGrid__1JXFJ::-webkit-scrollbar{display:none}.style_loadMoreContainer__1tLtA{padding:0 1rem 1rem}.style_loadMoreActions__2hTlG{display:flex;justify-content:center;text-align:center;flex-direction:column;align-items:center}.style_loadMoreSubText__2iLti{font-size:.75rem}.style_loadMoreHeaderInfo__9VuNC{color:#0878d1;padding:.5rem 0 0 1rem}", ""]);

// exports
exports.locals = {
	"group": "style_group__34D0R",
	"deployAllCell": "style_deployAllCell__3A0Pr",
	"deploy": "style_deploy__2LCgp",
	"dashboardTable": "style_dashboardTable__a5vIL",
	"border": "style_border__2wzaH",
	"spacerCell": "style_spacerCell__1NGeP",
	"headerCell": "style_headerCell__3CB_E",
	"columnHead": "style_columnHead__3tL0c",
	"highlightColumn": "style_highlightColumn__3Ur_n",
	"centerCell": "style_centerCell__wc3-E",
	"blankCell": "style_blankCell__3syzF",
	"container": "style_container__oYOe7",
	"scrollableContainer": "style_scrollableContainer__1ED8p",
	"emptyCell": "style_emptyCell__2BvyH",
	"headersOverflowContainer": "style_headersOverflowContainer__2ynKo",
	"headersContainer": "style_headersContainer__22OIL",
	"dataContainer": "style_dataContainer__3SK0W",
	"firstColumnContainer": "style_firstColumnContainer__3aL_R",
	"scrollbarPadding": "style_scrollbarPadding__BEZDs",
	"hideScrollbarPanel": "style_hideScrollbarPanel__3RPNf",
	"rightContainer": "style_rightContainer__xQbeA",
	"scrollableTableContainer": "style_scrollableTableContainer__3HKqG",
	"innerGrid": "style_innerGrid__1JXFJ",
	"loadMoreContainer": "style_loadMoreContainer__1tLtA",
	"loadMoreActions": "style_loadMoreActions__2hTlG",
	"loadMoreSubText": "style_loadMoreSubText__2iLti",
	"loadMoreHeaderInfo": "style_loadMoreHeaderInfo__9VuNC"
};

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(11);
var tenantedDeploymentMode_1 = __webpack_require__(310);
var DashboardDataCube = (function () {
    function DashboardDataCube(data, tenants, releases, channels, promotions, tagSets, lifeCycles, project, releaseId, missingVariableTenants) {
        var _this = this;
        this.blockedReleases = [];
        this.nextAvailableDeployments = {};
        this.tagSetIndex = {};
        this.environmentIndex = {};
        this.channelIndex = {};
        this.releaseIndex = {};
        this.tenantIndex = {};
        this.tenantTagIndex = {};
        this.projectIndex = {};
        this.projectGroupIndex = {};
        this.missingVariableTenants = [];
        this.data = data;
        this.releaseIndex = lodash_1.keyBy(releases, function (rel) { return rel.Id; });
        this.projectIndex = lodash_1.keyBy(data.Projects, function (proj) { return proj.Id; });
        this.channelIndex = lodash_1.keyBy(channels, function (ch) { return ch.Id; });
        this.environmentIndex = lodash_1.keyBy(this.data.Environments, function (env) { return env.Id; });
        this.deployments = data.Items;
        this.missingVariableTenants = missingVariableTenants;
        if (project) {
            this.projectIndex[project.Id] = {
                Slug: project.Slug,
                Name: project.Name,
                IsDisabled: project.IsDisabled,
                Id: project.Id,
                Links: project.Links,
                EnvironmentIds: null,
                ProjectGroupId: project.ProjectGroupId,
                CanPerformUntenantedDeployment: project.TenantedDeploymentMode !== tenantedDeploymentMode_1.TenantedDeploymentMode.Tenanted
            };
            this.lifecycleIndex = lodash_1.keyBy(lifeCycles, function (ch) { return ch.Id; });
            // We wont have a project object for main dashboard,
            // but then again we probably wont be grouping by channel or needing lifecycles!
            this.channelEnvironments = channels.reduce(function (b, ch) {
                var lifecycle = _this.lifecycleIndex[ch.LifecycleId];
                if (!lifecycle) {
                    lifecycle = _this.lifecycleIndex[project.LifecycleId];
                }
                if (!lifecycle) {
                    b[ch.Id] = [];
                }
                else {
                    b[ch.Id] = lifecycle.Phases.reduce(function (a, p) {
                        return a.concat(p.AutomaticDeploymentTargets).concat(p.OptionalDeploymentTargets);
                    }, []);
                    if (b[ch.Id].length === 0) {
                        b[ch.Id] = Object.keys(_this.environmentIndex);
                    }
                }
                return b;
            }, {});
        }
        this.projectGroupIndex = lodash_1.keyBy(data.ProjectGroups, function (pj) { return pj.Id; });
        if (releaseId) {
            this.nextAvailableDeployments = (_a = {},
                _a[releaseId] = this.processReleasePromotion(promotions),
                _a);
        }
        this.tenantIndex = {};
        var tagIndex = {};
        this.tenantTagIndex = tenants.reduce(function (idx, tenant) {
            idx[tenant.Id] = tenant.TenantTags;
            _this.tenantIndex[tenant.Id] = tenant;
            tenant.TenantTags.forEach(function (tt) {
                tagIndex[tt] = true;
            });
            return idx;
        }, {});
        tagSets.forEach(function (ts) {
            if (ts.Tags.find(function (t) { return tagIndex[t.CanonicalTagName]; })) {
                _this.tagSetIndex[ts.Id] = ts;
            }
        });
        var _a;
    }
    DashboardDataCube.prototype.processReleasePromotion = function (promotions) {
        var releasePromotions = promotions.PromoteTo.reduce(function (promos, environment) {
            promos[environment.Id] = [null];
            return promos;
        }, {});
        promotions.TenantPromotions.forEach(function (tp) {
            tp.PromoteTo.forEach(function (environment) {
                releasePromotions[environment.Id] = (releasePromotions[environment.Id] || []);
                releasePromotions[environment.Id].push(tp.Id);
            });
        });
        return releasePromotions;
    };
    return DashboardDataCube;
}());
exports.default = DashboardDataCube;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\DashboardDataCube.tsx"); } } })();

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tenantedDeploymentMode_1 = __webpack_require__(310);
var lodash_1 = __webpack_require__(11);
var ProgressionDataCube = (function () {
    function ProgressionDataCube(data, channels, project) {
        var _this = this;
        this.nextAvailableDeployments = {};
        this.blockedReleases = [];
        this.tenantTagIndex = {};
        this.tagSetIndex = {};
        this.channelIndex = {};
        this.releaseIndex = {};
        this.projectIndex = {};
        this.projectGroupIndex = {};
        this.tenantIndex = {};
        this.environmentIndex = {};
        this.missingVariableTenants = [];
        this.deployments = [];
        this.data = data;
        this.channelIndex = lodash_1.keyBy(channels, function (ch) { return ch.Id; });
        this.lifecycleIndex = {};
        this.releaseIndex = {};
        this.nextAvailableDeployments = {};
        this.projectIndex[project.Id] = {
            Slug: project.Slug,
            Name: project.Name,
            IsDisabled: project.IsDisabled,
            Id: project.Id,
            Links: project.Links,
            EnvironmentIds: null,
            ProjectGroupId: project.ProjectGroupId,
            CanPerformUntenantedDeployment: project.TenantedDeploymentMode !== tenantedDeploymentMode_1.TenantedDeploymentMode.Tenanted
        };
        this.channelEnvironments = Object.keys(data.ChannelEnvironments).reduce(function (idx, channelId) {
            idx[channelId] = data.ChannelEnvironments[channelId].map(function (k) { return k.Id; });
            return idx;
        }, {});
        this.deployments = (!data || !data.Releases)
            ? []
            : data.Releases.reduce(function (a, r) {
                if (r.HasUnresolvedDefect) {
                    _this.blockedReleases.push(r.Release.Id);
                }
                _this.releaseIndex[r.Release.Id] = r.Release;
                // may not have access to this due to lacking permission
                if (r.NextDeployments) {
                    _this.nextAvailableDeployments[r.Release.Id] = r.NextDeployments
                        .reduce(function (ax, e) {
                        ax[e] = [null]; //The progression dataset is currently only used for non tenant releases
                        return ax;
                    }, {});
                }
                var g = Object.keys(r.Deployments).map(function (j) { return r.Deployments[j]; });
                a = a.concat.apply(a, g);
                return a;
            }, []);
        this.environmentIndex = lodash_1.keyBy(this.data.Environments, function (env) { return env.Id; });
    }
    return ProgressionDataCube;
}());
exports.default = ProgressionDataCube;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\ProgressionDataCube.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DashboardDataSource\\ProgressionDataCube.tsx"); } } })();

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1705);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__G_FWA{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1Iju0{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3uGtP{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1eIJt{display:none!important}}.style_container__1nbJ-{display:flex;flex-direction:column}.style_paper__1v4cg div:first-child{max-width:none}.style_filterHeaderContainer__3LCpd{display:flex;flex-direction:row;align-items:flex-end;flex:1 0 auto;width:100%}@media (max-width:37.4rem){.style_filterHeaderContainer__3LCpd{flex-direction:column;align-items:flex-start}}.style_filterFieldContainer__V-gTq{display:flex;flex-direction:row;align-items:flex-end;flex:1 0 auto;width:100%;justify-content:flex-start}@media (max-width:37.4rem){.style_filterFieldContainer__V-gTq{flex-direction:column;align-items:flex-start}}.style_filter__2CExS{align-items:flex-end;flex:1 0 auto}@media (max-width:37.4rem){.style_filter__2CExS{flex-direction:column}}.style_filterField__2gTVE{width:100%;max-width:24rem!important}.style_filterField__2gTVE>div{width:100%}.style_help__mi7iM{margin-bottom:12px}.style_alert__14IXe{color:#fb8c00}.style_info__3bm8F{color:#0878d1}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__G_FWA",
	"hideSm": "style_hide-sm__G_FWA",
	"visible-sm": "style_visible-sm__1Iju0",
	"visibleSm": "style_visible-sm__1Iju0",
	"hide-md": "style_hide-md__3uGtP",
	"hideMd": "style_hide-md__3uGtP",
	"visible-md": "style_visible-md__1eIJt",
	"visibleMd": "style_visible-md__1eIJt",
	"container": "style_container__1nbJ-",
	"paper": "style_paper__1v4cg",
	"filterHeaderContainer": "style_filterHeaderContainer__3LCpd",
	"filterFieldContainer": "style_filterFieldContainer__V-gTq",
	"filter": "style_filter__2CExS",
	"filterField": "style_filterField__2gTVE",
	"help": "style_help__mi7iM",
	"alert": "style_alert__14IXe",
	"info": "style_info__3bm8F"
};

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DatePicker_1 = __webpack_require__(613);
var moment = __webpack_require__(119);
var UniqueSequenceGenerator_1 = __webpack_require__(404);
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.genericName = "name" + DatePicker.sequence.next();
        return _this;
    }
    DatePicker.prototype.handleChange = function (_, value) {
        if (this.props.validate) {
            var validateResult = this.props.validate(value);
            if (this.props.onValidate) {
                this.props.onValidate(validateResult);
            }
        }
        this.props.onChange(value);
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, label = _a.label, validate = _a.validate, error = _a.error, onChange = _a.onChange, name = _a.name, onValidate = _a.onValidate, otherProps = __rest(_a, ["value", "label", "validate", "error", "onChange", "name", "onValidate"]);
        var date = value ? moment(value).toDate() : null;
        return (React.createElement(DatePicker_1.default, __assign({ value: date, onChange: function (_, val) { return _this.handleChange(_, val); }, errorText: error, floatingLabelText: label, container: "inline", name: name || this.genericName, mode: "landscape" }, otherProps)));
    };
    DatePicker.sequence = new UniqueSequenceGenerator_1.UniqueSequenceGenerator();
    return DatePicker;
}(React.Component));
exports.default = DatePicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\DatePicker\\DatePicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\DatePicker\\DatePicker.tsx"); } } })();

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1708);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1Zgi2{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3Ot6w{display:none!important}}@media (max-width:79.9rem){.style_hide-md__20yNZ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__22YNx{display:none!important}}.style_container__3dBIA{display:flex;align-items:baseline;flex-wrap:nowrap;width:100%}@media (max-width:37.4rem){.style_container__3dBIA{flex-wrap:wrap}}.style_input__3ISz3{flex:1 1 auto}.style_actions__2ieOf{margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1Zgi2",
	"hideSm": "style_hide-sm__1Zgi2",
	"visible-sm": "style_visible-sm__3Ot6w",
	"visibleSm": "style_visible-sm__3Ot6w",
	"hide-md": "style_hide-md__20yNZ",
	"hideMd": "style_hide-md__20yNZ",
	"visible-md": "style_visible-md__22YNx",
	"visibleMd": "style_visible-md__22YNx",
	"container": "style_container__3dBIA",
	"input": "style_input__3ISz3",
	"actions": "style_actions__2ieOf"
};

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.maxInputWidth = "26rem";


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\sizes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\sizes.ts"); } } })();

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1711);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_buttonList__1GeoC{display:flex;flex-direction:row;align-items:center}.style_buttonList__1GeoC>*{margin-right:1rem}", ""]);

// exports
exports.locals = {
	"buttonList": "style_buttonList__1GeoC"
};

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\FormFieldProps.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\FormFieldProps.ts"); } } })();

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__CfhpE{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__p61Qc{display:none!important}}@media (max-width:79.9rem){.style_hide-md__s2-Mn{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2QaGg{display:none!important}}.style_formExpander__G5da1,.style_formNonExpander__WevSy{width:100%;box-shadow:none!important;border-radius:0!important;border-style:solid;border-width:.0625rem 0;border-color:#ccc;border-bottom:none}.style_formExpander__G5da1>div:first-child,.style_formNonExpander__WevSy>div:first-child{padding:0!important}.style_formExpander__G5da1>div:first-child>div:first-child,.style_formNonExpander__WevSy>div:first-child>div:first-child{padding:.875rem 1rem!important}.style_formExpander__G5da1>div:first-child>div:first-child{cursor:pointer}.style_formSection__23pJN{width:100%;box-shadow:none!important}.style_cardTitleContainer__skChO{display:flex;align-items:top;word-wrap:break-word}@media (max-width:37.4rem){.style_cardTitleContainer__skChO{display:block}}.style_cardTitleContainerForceMobile__qwHzM{display:flex;align-items:top;word-wrap:break-word;display:block}@media (max-width:37.4rem){.style_cardTitleContainerForceMobile__qwHzM{display:block}}.style_cardTitle__Dxdzg{top:1rem;width:15rem!important;min-width:15rem!important;min-height:1.5rem!important;font-family:Roboto!important;font-size:1rem!important;font-weight:600!important;line-height:1.5!important;text-align:right!important;color:#333!important}@media (max-width:37.4rem){.style_cardTitle__Dxdzg{text-align:left!important;position:static!important}}.style_cardTitleForceMobile__2NSK4{top:1rem;width:15rem!important;min-width:15rem!important;min-height:1.5rem!important;font-family:Roboto!important;font-size:1rem!important;font-weight:600!important;line-height:1.5!important;text-align:right!important;color:#333!important;text-align:left!important;position:static!important}@media (max-width:37.4rem){.style_cardTitleForceMobile__2NSK4{text-align:left!important;position:static!important}}.style_cardDefaultSubTitle__3iGhW,.style_cardPlaceholderSubTitle__2k0Zs,.style_cardSubTitle__LHY7-{font-family:Roboto!important;font-size:1rem!important;line-height:1.5!important;text-align:left!important;color:#333!important;margin-left:1.6rem!important;margin-right:2rem!important;display:block!important;word-wrap:break-word;min-width:50%}@media (max-width:37.4rem){.style_cardDefaultSubTitle__3iGhW,.style_cardPlaceholderSubTitle__2k0Zs,.style_cardSubTitle__LHY7-{margin-left:0!important}}.style_cardSubTitle__LHY7->div>p{margin:0}.style_cardSubTitleForceMobile__QYFjy{font-family:Roboto!important;font-size:1rem!important;line-height:1.5!important;text-align:left!important;color:#333!important;margin-left:1.6rem!important;margin-right:2rem!important;display:block!important;word-wrap:break-word;min-width:50%;margin-left:0!important}@media (max-width:37.4rem){.style_cardSubTitleForceMobile__QYFjy{margin-left:0!important}}.style_cardSubTitleForceMobile__QYFjy>div>p{margin:0}.style_cardSubTitleWithOverflowMenu__1IcYw{margin-right:3rem!important}.style_cardPlaceholderSubTitle__2k0Zs{color:#9e9e9e!important}.style_cardDefaultSubTitle__3iGhW:after{content:\" (default)\";color:#9e9e9e!important}.style_cardMedia__fR0T3{margin-left:17.6rem;margin-right:4rem;margin-top:-.5rem;padding-bottom:1rem;max-width:37.5rem}@media (max-width:37.4rem){.style_cardMedia__fR0T3{margin-left:1.1rem!important;margin-right:1.1rem}}.style_cardMediaForceMobile__1fznC{margin-left:17.6rem;margin-right:4rem;margin-top:-.5rem;padding-bottom:1rem;max-width:37.5rem;margin-left:1.1rem!important;margin-right:1.1rem}@media (max-width:37.4rem){.style_cardMediaForceMobile__1fznC{margin-left:1.1rem!important;margin-right:1.1rem}}.style_cardMediaFillRight__M_MJc{max-width:none}.style_cardMediaFillAll__20uwJ{margin-left:0;margin-right:0}.style_cardMedia__fR0T3 .style_container__2kJfg{padding-bottom:.5rem!important}.style_cardMediaNonExpander__21uV8{margin:0 1.1rem;padding:1rem 0}.style_expandLink__VuLUw{width:6rem;height:1.19rem;font-family:Roboto;font-size:.8125rem;line-height:1.36rem;color:#9e9e9e;margin-right:1.5rem}.style_expandLink__VuLUw:hover{color:#2f93e0}.style_linkContainer__2ZGQj{width:100%;text-align:right;padding:.3125rem 0}.style_moreInformation__R6jJv{padding:1rem;background:hsla(0,0%,60%,.08);font-size:.875rem}.style_hide__2Um8X{font-family:Roboto;font-size:.75rem;line-height:1.83rem;text-align:left;color:#9e9e9e;text-align:right}.style_hide__2Um8X a{color:#2f93e0}.style_sectionHeading__13Bbq{width:100%;border-radius:0!important;margin:0 0 -.0725rem}.style_dialogSectionHeading__2qicb,.style_sectionHeading__13Bbq{background:hsla(0,0%,60%,.08);border-style:solid;border-width:.0625rem 0;border-color:#ccc}.style_dialogSectionHeading__2qicb{margin:2rem -1rem 1rem}.style_sectionHeadingTitle__1H3Lk{padding:.6rem 1rem;font-size:1.0625rem}.style_overflowMenuActions__1tQ9E{top:0;bottom:0;right:2.25rem;position:absolute;padding-top:.5rem}.style_expandCollapse__3qTMH{top:0;bottom:0;right:.25rem;position:absolute}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__CfhpE",
	"hideSm": "style_hide-sm__CfhpE",
	"visible-sm": "style_visible-sm__p61Qc",
	"visibleSm": "style_visible-sm__p61Qc",
	"hide-md": "style_hide-md__s2-Mn",
	"hideMd": "style_hide-md__s2-Mn",
	"visible-md": "style_visible-md__2QaGg",
	"visibleMd": "style_visible-md__2QaGg",
	"formExpander": "style_formExpander__G5da1",
	"formNonExpander": "style_formNonExpander__WevSy",
	"formSection": "style_formSection__23pJN",
	"cardTitleContainer": "style_cardTitleContainer__skChO",
	"cardTitleContainerForceMobile": "style_cardTitleContainerForceMobile__qwHzM",
	"cardTitle": "style_cardTitle__Dxdzg",
	"cardTitleForceMobile": "style_cardTitleForceMobile__2NSK4",
	"cardSubTitle": "style_cardSubTitle__LHY7-",
	"cardPlaceholderSubTitle": "style_cardPlaceholderSubTitle__2k0Zs",
	"cardDefaultSubTitle": "style_cardDefaultSubTitle__3iGhW",
	"cardSubTitleForceMobile": "style_cardSubTitleForceMobile__QYFjy",
	"cardSubTitleWithOverflowMenu": "style_cardSubTitleWithOverflowMenu__1IcYw",
	"cardMedia": "style_cardMedia__fR0T3",
	"cardMediaForceMobile": "style_cardMediaForceMobile__1fznC",
	"cardMediaFillRight": "style_cardMediaFillRight__M_MJc",
	"cardMediaFillAll": "style_cardMediaFillAll__20uwJ",
	"container": "style_container__2kJfg",
	"cardMediaNonExpander": "style_cardMediaNonExpander__21uV8",
	"expandLink": "style_expandLink__VuLUw",
	"linkContainer": "style_linkContainer__2ZGQj",
	"moreInformation": "style_moreInformation__R6jJv",
	"hide": "style_hide__2Um8X",
	"sectionHeading": "style_sectionHeading__13Bbq",
	"dialogSectionHeading": "style_dialogSectionHeading__2qicb",
	"sectionHeadingTitle": "style_sectionHeadingTitle__1H3Lk",
	"overflowMenuActions": "style_overflowMenuActions__1tQ9E",
	"expandCollapse": "style_expandCollapse__3qTMH"
};

/***/ }),
/* 1714 */,
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1716);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_menuIcon__rA8-Q{font-size:1.375rem;height:2.25rem!important;padding:0!important;display:flex;align-items:center;text-decoration:none;color:#333}.style_menuIcon__rA8-Q:visited{color:#333}.style_menuIcon__rA8-Q:hover{opacity:.5}.style_disabledItem__1s4p7{cursor:not-allowed;color:#9e9e9e}", ""]);

// exports
exports.locals = {
	"menuIcon": "style_menuIcon__rA8-Q",
	"disabledItem": "style_disabledItem__1s4p7"
};

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var exposeComponentAsClass_1 = __webpack_require__(380);
var react_router_1 = __webpack_require__(76);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var OverflowMenuLink = function (props) {
    var resolvedTo = props.resolve ? resolvePathWithSpaceId_1.resolvePathWithSpaceId(props.to, props.match.params.spaceId) : props.to;
    var href = typeof resolvedTo === "string" ? resolvedTo : props.history.createHref(resolvedTo);
    var download = props.downloadFileName ? { download: props.downloadFileName, target: "_blank" } : {};
    // Ideally we would not use spread operator here. Unfortunately, material-ui injects bunch of properties here
    // and we need to pass all of them so the UI looks consistent.
    var _a = props, staticContext = _a.staticContext, resolve = _a.resolve, to = _a.to, downloadFileName = _a.downloadFileName, rest = __rest(_a, ["staticContext", "resolve", "to", "downloadFileName"]);
    return React.createElement("a", __assign({}, rest, { href: href }, download));
};
OverflowMenuLink.defaultProps = {
    resolve: true
};
exports.default = exposeComponentAsClass_1.exposeComponentAsClass(react_router_1.withRouter(OverflowMenuLink));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OverflowMenuLink.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Menu\\OverflowMenuLink.tsx"); } } })();

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var RadioButton_1 = __webpack_require__(32);
var warning = __webpack_require__(34);
// import {PropTypes} from "prop-types";
var styles = __webpack_require__(412);
// modified to handle children which aren't a radio button
var RadioButtonGroup = (function (_super) {
    __extends(RadioButtonGroup, _super);
    /**
     *
     */
    function RadioButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event, newSelection) {
            _this.updateRadioButtons(newSelection);
            // Successful update
            if (_this.state.numberCheckedRadioButtons === 0) {
                if (_this.props.onChange) {
                    _this.props.onChange(event, newSelection);
                }
            }
        };
        var cnt = 0;
        var selected = "";
        var _a = _this.props, valueSelected = _a.valueSelected, defaultSelected = _a.defaultSelected;
        if (valueSelected !== undefined) {
            selected = valueSelected;
        }
        else if (defaultSelected !== undefined) {
            selected = defaultSelected;
        }
        React.Children.forEach(_this.props.children, function (option) {
            if (_this.hasCheckAttribute(option)) {
                cnt++;
            }
        });
        _this.state = {
            numberCheckedRadioButtons: cnt,
            selected: selected,
        };
        return _this;
    }
    RadioButtonGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.hasOwnProperty("valueSelected")) {
            this.setState({
                selected: nextProps.valueSelected,
            });
        }
    };
    RadioButtonGroup.prototype.hasCheckAttribute = function (radioButton) {
        return radioButton.props && radioButton.props.hasOwnProperty("checked") &&
            radioButton.props.checked;
    };
    RadioButtonGroup.prototype.updateRadioButtons = function (newSelection) {
        if (this.state.numberCheckedRadioButtons === 0) {
            this.setState({ selected: newSelection });
        }
        else {
            warning(false, "Material-UI: Cannot select a different radio button while another radio button\n        has the \"checked\" property set to true.");
        }
    };
    RadioButtonGroup.prototype.getSelectedValue = function () {
        return this.state.selected;
    };
    RadioButtonGroup.prototype.setSelectedValue = function (newSelectionValue) {
        this.updateRadioButtons(newSelectionValue);
    };
    RadioButtonGroup.prototype.clearValue = function () {
        this.setSelectedValue("");
    };
    RadioButtonGroup.prototype.isRadioButton = function (element) {
        return element.props && element.props.hasOwnProperty("checked");
    };
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var prepareStyles = this.context.muiTheme.prepareStyles;
        var autoFocus = this.props.autoFocus;
        var options = React.Children.map(this.props.children, function (child) {
            if (!_this.isRadioButton(child)) {
                return child;
            }
            var _a = child.props, name = _a.name, // eslint-disable-line no-unused-vars
            value = _a.value, // eslint-disable-line no-unused-vars
            label = _a.label, // eslint-disable-line no-unused-vars
            onCheck = _a.onCheck, // eslint-disable-line no-unused-vars
            other = __rest(_a, ["name", "value", "label", "onCheck"]);
            var checked = child.props.value === _this.state.selected;
            return (React.createElement(RadioButton_1.default, __assign({}, other, { className: styles.radioButton, ref: child.props.value, name: _this.props.name, key: child.props.value, value: child.props.value, label: child.props.label, labelPosition: _this.props.labelPosition, onCheck: _this.handleChange, checked: checked, autoFocus: checked && autoFocus })));
        });
        return (React.createElement("div", { style: prepareStyles(__assign({}, this.props.style)), className: this.props.className }, options));
    };
    RadioButtonGroup.defaultProps = {
        style: {}
    };
    RadioButtonGroup.contextTypes = {
        muiTheme: PropTypes.object.isRequired
    };
    return RadioButtonGroup;
}(React.Component));
exports.default = RadioButtonGroup;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroupInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\RadioButton\\RadioButtonGroupInternal.tsx"); } } })();

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1UYNO{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__onwxa{display:none!important}}@media (max-width:79.9rem){.style_hide-md__HxPYA{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1B--X{display:none!important}}.style_errorText__3PMlt{margin-top:.3rem;font-size:.75rem;line-height:.75rem;color:#db4437}.style_isDefault__2FXJR:after{content:\" (default)\";color:#9e9e9e!important}.style_radioButton__CUKRk{margin-bottom:.25rem;font-size:1rem}.style_radioButtonGroup__1ZPDK>:not(.style_radioButton__CUKRk){margin-left:2.5rem}.style_label__2-obS{color:#9e9e9e;font-size:.8125rem;font-weight:400;margin-bottom:.25rem}.style_container__1nYEr{width:100%}.style_topMargin__DJ5-6{margin-top:1rem}.style_horizontal__DoY4a{display:flex;flex-direction:row}@media (max-width:37.4rem){.style_horizontal__DoY4a{flex-direction:column}}.style_horizontal__DoY4a>div{width:auto!important;margin-right:3rem}@media (max-width:37.4rem){.style_horizontal__DoY4a>div{margin-right:unset}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1UYNO",
	"hideSm": "style_hide-sm__1UYNO",
	"visible-sm": "style_visible-sm__onwxa",
	"visibleSm": "style_visible-sm__onwxa",
	"hide-md": "style_hide-md__HxPYA",
	"hideMd": "style_hide-md__HxPYA",
	"visible-md": "style_visible-md__1B--X",
	"visibleMd": "style_visible-md__1B--X",
	"errorText": "style_errorText__3PMlt",
	"isDefault": "style_isDefault__2FXJR",
	"radioButton": "style_radioButton__CUKRk",
	"radioButtonGroup": "style_radioButtonGroup__1ZPDK",
	"label": "style_label__2-obS",
	"container": "style_container__1nYEr",
	"topMargin": "style_topMargin__DJ5-6",
	"horizontal": "style_horizontal__DoY4a"
};

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var InputLabel_1 = __webpack_require__(287);
__export(__webpack_require__(287));
exports.default = InputLabel_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InputLabel\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\InputLabel\\index.ts"); } } })();

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1722);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1aUeT{display:flex;width:7rem;position:relative;flex:0 0 7rem}.style_colorSwatch__2rOye{width:1.5rem;height:1.5rem;border-radius:.25em;position:absolute;bottom:1rem;right:.5rem;cursor:pointer}.style_colorPickItem__249hZ{width:2.5rem;height:2.5rem;cursor:pointer;transition:background-color .1s linear;border-radius:0}.style_colorAllOptions__2ExLA{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center}", ""]);

// exports
exports.locals = {
	"container": "style_container__1aUeT",
	"colorSwatch": "style_colorSwatch__2rOye",
	"colorPickItem": "style_colorPickItem__249hZ",
	"colorAllOptions": "style_colorAllOptions__2ExLA"
};

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1724);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_markdownEditorContainer__1G5rk{position:relative;width:100%}.style_restrictedHeight__kHLAa{max-height:15rem}.style_iconButton___5HNj{width:2rem!important;min-width:2rem!important}.style_iconButton___5HNj:hover span{opacity:1}.style_iconButton___5HNj span{padding-left:0!important;padding-right:0!important;opacity:.6}.style_markdownSupported__2F-aV{padding-right:.25rem}.style_iconButtonContainer__1pHWS{display:flex;flex-direction:row;justify-content:flex-end;background:hsla(0,0%,60%,.08);border:.0625rem solid #ccc;border-bottom:0}.style_textarea__vr5fk{max-width:inherit!important}", ""]);

// exports
exports.locals = {
	"markdownEditorContainer": "style_markdownEditorContainer__1G5rk",
	"restrictedHeight": "style_restrictedHeight__kHLAa",
	"iconButton": "style_iconButton___5HNj",
	"markdownSupported": "style_markdownSupported__2F-aV",
	"iconButtonContainer": "style_iconButtonContainer__1pHWS",
	"textarea": "style_textarea__vr5fk"
};

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MarkdownProvider = (function () {
    function MarkdownProvider(value, selectionStart, selectionEnd) {
        this.value = value;
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
        this.before = "";
        this.after = "";
        this.addNewLine = false;
        this.afterNewline = "";
        this.emptyText = "";
    }
    MarkdownProvider.prototype.insertBefore = function (before) {
        this.before = before;
        return this;
    };
    MarkdownProvider.prototype.insertAfter = function (after) {
        this.after = after;
        return this;
    };
    MarkdownProvider.prototype.surroundWithNewlines = function () {
        this.addNewLine = true;
        return this;
    };
    MarkdownProvider.prototype.insertAfterNewlineInSelection = function (afterNewline) {
        this.afterNewline = afterNewline;
        return this;
    };
    MarkdownProvider.prototype.emptySelectionText = function (emptyText) {
        this.emptyText = emptyText;
        return this;
    };
    MarkdownProvider.prototype.apply = function (callback) {
        this.trimSelection();
        if (this.emptyText && this.selectionStart === this.selectionEnd) {
            this.addEmptyText();
        }
        if (this.addNewLine) {
            this.addNewLineImpl();
        }
        this.value = this.splice(this.value, this.selectionEnd, this.after);
        this.value = this.splice(this.value, this.selectionStart, this.before);
        this.selectionStart = this.selectionStart + this.before.length;
        this.selectionEnd = this.selectionEnd + this.before.length;
        if (this.afterNewline) {
            this.insertAfterNewlineInSelectionImpl();
        }
        callback(this.value, this.selectionStart, this.selectionEnd);
    };
    MarkdownProvider.prototype.splice = function (input, start, newSubStr) {
        return input.slice(0, start) + newSubStr + input.slice(start);
    };
    MarkdownProvider.prototype.addNewLineImpl = function () {
        // add a newline character for lists and comments,
        // but not if there is already one there
        var beforeSelection = this.value[this.selectionStart - 1];
        if (beforeSelection !== "\n" && beforeSelection !== undefined) {
            this.value = this.splice(this.value, this.selectionStart, "\n");
            this.selectionStart += 1;
            this.selectionEnd += 1;
        }
        var afterSelection = this.value[this.selectionEnd];
        if (afterSelection !== "\n" && afterSelection !== undefined) {
            this.value = this.splice(this.value, this.selectionEnd, "\n");
        }
    };
    MarkdownProvider.prototype.trimSelection = function () {
        // trim whitespace from the selection (this was implemented in
        // other online markdown editors when I checked how they handled selection)
        while (this.value[this.selectionStart] === " " && this.selectionStart < this.selectionEnd) {
            this.selectionStart += 1;
        }
        while (this.value[this.selectionEnd - 1] === " " && this.selectionStart < this.selectionEnd) {
            this.selectionEnd -= 1;
        }
    };
    MarkdownProvider.prototype.insertAfterNewlineInSelectionImpl = function () {
        // insert something after each newLine in the selection
        var selectedText = this.value.slice(this.selectionStart, this.selectionEnd);
        var updatedText = selectedText.replace(new RegExp("\n", "g"), "\n" + this.afterNewline);
        this.value = this.value.slice(0, this.selectionStart) + updatedText + this.value.slice(this.selectionEnd);
        this.selectionEnd = this.selectionEnd - selectedText.length + updatedText.length;
    };
    MarkdownProvider.prototype.addEmptyText = function () {
        this.value = this.splice(this.value, this.selectionStart, this.emptyText);
        this.selectionEnd = this.selectionEnd + this.emptyText.length;
    };
    return MarkdownProvider;
}());
exports.MarkdownProvider = MarkdownProvider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownProvider.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\MarkdownEditor\\MarkdownProvider.ts"); } } })();

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1727);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__iiH-l{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__Yt2OF{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1b_oL{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1LxbM{display:none!important}}.style_logoContainer__EB3_j{display:flex;flex-direction:row;flex-wrap:wrap;width:100%;align-items:center}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__iiH-l",
	"hideSm": "style_hide-sm__iiH-l",
	"visible-sm": "style_visible-sm__Yt2OF",
	"visibleSm": "style_visible-sm__Yt2OF",
	"hide-md": "style_hide-md__1b_oL",
	"hideMd": "style_hide-md__1b_oL",
	"visible-md": "style_visible-md__1LxbM",
	"visibleMd": "style_visible-md__1LxbM",
	"logoContainer": "style_logoContainer__EB3_j"
};

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "choose-image.db1937ca7f18c18df016811ab88e75cd.hashedasset.svg";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
function formattedFileSize(bytes) {
    if (isNaN(bytes)) {
        return "";
    }
    if (bytes === 0) {
        return "0 bytes";
    }
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return +(bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
}
exports.default = formattedFileSize;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ByteSizeFormatter\\ByteSizeFormatter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ByteSizeFormatter\\ByteSizeFormatter.tsx"); } } })();

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var NumericInput = __webpack_require__(786);
var fontWeights_1 = __webpack_require__(83);
var styles = __webpack_require__(1731);
var Meridiem;
(function (Meridiem) {
    Meridiem[Meridiem["AM"] = 0] = "AM";
    Meridiem[Meridiem["PM"] = 1] = "PM";
})(Meridiem || (Meridiem = {}));
var TimePicker = (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getMeridiem = function (time) {
            var hour = time.getHours();
            return hour < 12 ? Meridiem.AM : Meridiem.PM;
        };
        _this.getMinutes = function (time) {
            var n = time.getMinutes();
            if (n === 0) {
                return n;
            }
            n = Math.round(n / 15) * 15;
            if (n > 45) {
                n = 45;
            }
            return n;
        };
        _this.getHours = function (time) {
            var hour = time.getHours();
            if (hour > 12) {
                return hour - 12;
            }
            if (hour === 0) {
                return 12;
            }
            return hour;
        };
        _this.updateMeridiem = function (e) {
            e.preventDefault();
            _this.setState({
                meridiem: _this.state.meridiem === Meridiem.AM ? Meridiem.PM : Meridiem.AM
            }, function () { return _this.raiseChange(); });
        };
        _this.padding = function (value) {
            if (value === "0") {
                return "00";
            }
            return value.toString();
        };
        _this.updateHours = function (value) {
            _this.setState({
                hours: value
            }, function () { return _this.raiseChange(); });
        };
        _this.updateMinutes = function (value) {
            _this.setState({
                minutes: value
            }, function () { return _this.raiseChange(); });
        };
        _this.state = _this.initState(_this.props.value);
        return _this;
    }
    TimePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState(this.initState(nextProps.value));
        }
    };
    TimePicker.prototype.render = function () {
        var imputStyle = {
            input: {
                border: "0",
                fontSize: fontWeights_1.baseSizeInPx,
                height: "100%"
            }
        };
        return (React.createElement("div", { className: styles.container },
            React.createElement(NumericInput, { onChange: this.updateHours, value: this.state.hours, min: 1, max: 12, step: 1, size: 1, mobile: true, style: imputStyle }),
            React.createElement("span", { className: styles.separator }, ":"),
            React.createElement(NumericInput, { onChange: this.updateMinutes, value: this.state.minutes, min: 0, max: 45, step: 15, size: 1, snap: true, style: imputStyle, mobile: true, format: this.padding, readOnly: true }),
            React.createElement("a", { className: styles.ampm, href: "#", onClick: this.updateMeridiem }, this.state.meridiem === Meridiem.AM ? "AM" : "PM")));
    };
    TimePicker.prototype.initState = function (value) {
        var time = value || new Date();
        return {
            meridiem: this.getMeridiem(time),
            hours: this.getHours(time),
            minutes: this.getMinutes(time)
        };
    };
    TimePicker.prototype.raiseChange = function () {
        var date = new Date();
        var hours = this.state.hours;
        if (this.state.meridiem === Meridiem.PM) {
            if (hours === 12) {
                hours = 12;
            }
            else {
                hours += 12;
            }
        }
        else {
            if (hours === 12) {
                hours = 0;
            }
        }
        date.setHours(hours, this.state.minutes, 0, 0);
        this.props.onChange(date);
    };
    return TimePicker;
}(React.Component));
exports.default = TimePicker;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\DatePicker\\TimePicker.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\DatePicker\\TimePicker.tsx"); } } })();

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1732);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__9af8H{display:flex;align-items:center}.style_separator__nIuvl{margin:0 .125rem}.style_ampm__3wJd2{margin-left:.1875rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__9af8H",
	"separator": "style_separator__nIuvl",
	"ampm": "style_ampm__3wJd2"
};

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardLayout_1 = __webpack_require__(1734);
exports.default = DashboardLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardLayout\\index.tsx"); } } })();

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var AreaTitle_1 = __webpack_require__(122);
var routeLinks_1 = __webpack_require__(22);
var DashboardLayout = function (props) {
    return (React.createElement("main", { id: "maincontent" },
        React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.root, title: "Dashboard" }),
        props.children));
};
exports.default = DashboardLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardLayout\\DashboardLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardLayout\\DashboardLayout.tsx"); } } })();

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(449);
var EnvironmentMultiSelect_1 = __webpack_require__(309);
var ProjectMultiSelect_1 = __webpack_require__(495);
var form_1 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var form_2 = __webpack_require__(16);
var clientInstance_1 = __webpack_require__(10);
var Text_1 = __webpack_require__(50);
var TenantTagMultiSelect_1 = __webpack_require__(327);
var MultiSelect_1 = __webpack_require__(75);
var Chips_1 = __webpack_require__(24);
var TenantTagsList_1 = __webpack_require__(321);
var FormBaseComponent_1 = __webpack_require__(155);
var permission_1 = __webpack_require__(51);
var styles = __webpack_require__(1757);
var FeatureToggle_1 = __webpack_require__(305);
var PermissionCheck_1 = __webpack_require__(455);
var ProjectGroupMultiSelect_1 = __webpack_require__(838);
var TransitionAnimation_1 = __webpack_require__(82);
exports.DefaultProjectLimit = "200";
var DashboardConfiguration = (function (_super) {
    __extends(DashboardConfiguration, _super);
    function DashboardConfiguration(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a, includeAllEnvironments, includeAllProjectGroups, includeAllProjects, includeAllTenants, dashboardConfig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.model, includeAllEnvironments = _a.includeAllEnvironments, includeAllProjectGroups = _a.includeAllProjectGroups, includeAllProjects = _a.includeAllProjects, includeAllTenants = _a.includeAllTenants, dashboardConfig = __rest(_a, ["includeAllEnvironments", "includeAllProjectGroups", "includeAllProjects", "includeAllTenants"]);
                        if (includeAllProjectGroups) {
                            dashboardConfig.IncludedProjectGroupIds.length = 0;
                        }
                        if (includeAllProjects) {
                            dashboardConfig.IncludedProjectIds.length = 0;
                        }
                        if (includeAllEnvironments) {
                            dashboardConfig.IncludedEnvironmentIds.length = 0;
                        }
                        if (includeAllTenants) {
                            dashboardConfig.IncludedTenantTags.length = 0;
                            dashboardConfig.IncludedTenantIds.length = 0;
                        }
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var resource;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.DashboardConfiguration.modify(dashboardConfig)];
                                        case 1:
                                            resource = _a.sent();
                                            this.setState(function (s) {
                                                return {
                                                    submitted: true,
                                                    model: _this.buildModel(resource),
                                                    cleanModel: _this.buildModel(resource)
                                                };
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            projectGroups: [],
            projects: [],
            environments: [],
            tenants: [],
        };
        return _this;
    }
    DashboardConfiguration.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, projectGroups, projects, environments, tenants, dashboardConfiguration, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, Promise.all([
                                            clientInstance_1.repository.ProjectGroups.all(),
                                            clientInstance_1.repository.Projects.all(),
                                            clientInstance_1.repository.Environments.all(),
                                            clientInstance_1.repository.Tenants.all(),
                                            clientInstance_1.repository.DashboardConfiguration.get()
                                        ])];
                                    case 1:
                                        _a = _d.sent(), projectGroups = _a[0], projects = _a[1], environments = _a[2], tenants = _a[3], dashboardConfiguration = _a[4];
                                        _b = this.setState;
                                        _c = {
                                            model: this.buildModel(dashboardConfiguration),
                                            cleanModel: this.buildModel(dashboardConfiguration)
                                        };
                                        return [4 /*yield*/, projectGroups];
                                    case 2:
                                        _c.projectGroups = _d.sent();
                                        return [4 /*yield*/, projects];
                                    case 3:
                                        _c.projects = _d.sent();
                                        return [4 /*yield*/, environments];
                                    case 4:
                                        _c.environments = _d.sent();
                                        return [4 /*yield*/, tenants];
                                    case 5:
                                        _b.apply(this, [(_c.tenants = _d.sent(),
                                                _c)]);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardConfiguration.prototype.buildModel = function (resource) {
        return __assign({}, resource, { includeAllProjectGroups: !resource.IncludedProjectGroupIds.length, includeAllProjects: !resource.IncludedProjectIds.length, includeAllEnvironments: !resource.IncludedEnvironmentIds.length, includeAllTenants: !resource.IncludedTenantIds.length && !resource.IncludedTenantTags.length });
    };
    DashboardConfiguration.prototype.environmentsSummary = function () {
        return this.state.model.IncludedEnvironmentIds && this.state.model.IncludedEnvironmentIds.length
            ? form_2.Summary.summary(React.createElement("div", null,
                "Only show ",
                Chips_1.environmentChipList(this.state.environments, this.state.model.IncludedEnvironmentIds)))
            : form_2.Summary.default("All environments are shown");
    };
    DashboardConfiguration.prototype.projectGroupsSummary = function () {
        return this.state.model.IncludedProjectGroupIds && this.state.model.IncludedProjectGroupIds.length
            ? form_2.Summary.summary(React.createElement("div", null,
                "Only show ",
                Chips_1.projectGroupChipList(this.state.projectGroups, this.state.model.IncludedProjectGroupIds)))
            : form_2.Summary.default("All project groups are shown");
    };
    DashboardConfiguration.prototype.projectsSummary = function () {
        return this.state.model.IncludedProjectIds && this.state.model.IncludedProjectIds.length
            ? form_2.Summary.summary(React.createElement("div", null,
                "Only show ",
                Chips_1.projectChipList(this.state.projects, this.state.model.IncludedProjectIds)))
            : form_2.Summary.default("All projects are shown");
    };
    DashboardConfiguration.prototype.maximumProjectSummary = function () {
        var limit = this.state.model.ProjectLimit || exports.DefaultProjectLimit;
        var wrapper = this.state.model.ProjectLimit ? form_2.Summary.summary : form_2.Summary.default;
        return wrapper("Only " + limit + " project" + (limit === 1 ? "" : "s") + " will be shown (plus any with failing deployments).");
    };
    DashboardConfiguration.prototype.tenantSummary = function () {
        var tenants = this.state.model.IncludedTenantIds || [];
        var tags = this.state.model.IncludedTenantTags || [];
        if (tenants.length === 0 && tags.length === 0) {
            return form_2.Summary.default("All tenants are included");
        }
        if (tenants.length === 0) {
            return form_2.Summary.summary(React.createElement("span", null,
                "Only show deployments for tenants with ",
                React.createElement(TenantTagsList_1.default, { tags: tags }),
                " tags"));
        }
        return form_2.Summary.summary(React.createElement("span", null,
            "Only show deployments for ",
            Chips_1.tenantChipList(this.state.tenants, tenants),
            tags.length === 0 || React.createElement("span", null,
                " or any tenants with ",
                React.createElement(TenantTagsList_1.default, { tags: tags }),
                " tags")));
    };
    DashboardConfiguration.prototype.render = function () {
        var _this = this;
        return React.createElement(index_1.default, { title: "Configure", className: styles.paper, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick }, this.state.model && React.createElement(TransitionAnimation_1.default, null,
            React.createElement(form_2.ExpandableFormSection, { errorKey: "ProjectLimit", title: "Maximum Projects", focusOnExpandAll: true, summary: this.maximumProjectSummary(), help: "The maximum number of projects to display on the dashboard." },
                React.createElement(Text_1.default, { value: this.convertToString(this.state.model.ProjectLimit), min: 1, type: "number", hintText: exports.DefaultProjectLimit, onChange: function (projectLimit) { return _this.setModelState({ ProjectLimit: _this.parseToInt(projectLimit) }); }, autoFocus: true })),
            React.createElement(form_2.ExpandableFormSection, { errorKey: "includedProjectGroupIds", title: "Project Groups", summary: this.projectGroupsSummary(), help: "Filter the dashboard to only show a subset of your project groups." },
                React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllProjectGroups) { return _this.setModelState({ includeAllProjectGroups: includeAllProjectGroups }); }, value: this.state.model.includeAllProjectGroups },
                    React.createElement(RadioButton_1.default, { value: true, label: "All project groups", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: false, label: "Only selected project groups" })),
                this.state.model.includeAllProjectGroups ||
                    React.createElement(ProjectGroupMultiSelect_1.ProjectGroupMultiSelect, { onChange: function (IncludedProjectGroupIds) { return _this.setModelState({ IncludedProjectGroupIds: IncludedProjectGroupIds }); }, value: this.state.model.IncludedProjectGroupIds, items: this.state.projectGroups })),
            React.createElement(form_2.ExpandableFormSection, { errorKey: "includedProjectIds", title: "Projects", summary: this.projectsSummary(), help: "Filter the dashboard to only show a subset of your projects." },
                React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllProjects) { return _this.setModelState({ includeAllProjects: includeAllProjects }); }, value: this.state.model.includeAllProjects },
                    React.createElement(RadioButton_1.default, { value: true, label: "All projects", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: false, label: "Only selected projects" })),
                this.state.model.includeAllProjects ||
                    React.createElement(ProjectMultiSelect_1.default, { onChange: function (IncludedProjectIds) { return _this.setModelState({ IncludedProjectIds: IncludedProjectIds }); }, value: this.state.model.IncludedProjectIds, items: this.state.projects })),
            React.createElement(form_2.ExpandableFormSection, { errorKey: "includedEnvironmentIds", title: "Environments", summary: this.environmentsSummary(), help: "Filter the dashboard to only show a subset of your environments." },
                React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllEnvironments) { return _this.setModelState({ includeAllEnvironments: includeAllEnvironments }); }, value: this.state.model.includeAllEnvironments },
                    React.createElement(RadioButton_1.default, { value: true, label: "All environments", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: false, label: "Only selected environments" })),
                this.state.model.includeAllEnvironments ||
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.state.environments, onChange: function (IncludedEnvironmentIds) { return _this.setModelState({ IncludedEnvironmentIds: IncludedEnvironmentIds }); }, value: this.state.model.IncludedEnvironmentIds })),
            React.createElement(FeatureToggle_1.FeatureToggle, { feature: FeatureToggle_1.Feature.MultiTenancy },
                React.createElement(PermissionCheck_1.PermissionCheck, { permission: permission_1.default.TenantView, tenant: "*" },
                    React.createElement(form_2.ExpandableFormSection, { errorKey: "Tenants", title: "Tenants", summary: this.tenantSummary(), help: "Filter the dashboard to only show releases for specific tenants." },
                        React.createElement(form_1.BooleanRadioButtonGroup, { onChange: function (includeAllTenants) { return _this.setModelState({ includeAllTenants: includeAllTenants }); }, value: this.state.model.includeAllTenants },
                            React.createElement(RadioButton_1.default, { value: true, label: "All tenants", isDefault: true }),
                            React.createElement(RadioButton_1.default, { value: false, label: "Only selected tenants" })),
                        this.state.model.includeAllTenants ||
                            React.createElement("div", null,
                                React.createElement(MultiSelect_1.TenantMultiSelect, { value: this.state.model.IncludedTenantIds, items: this.state.tenants, onChange: function (IncludedTenantIds) { return _this.setModelState({ IncludedTenantIds: IncludedTenantIds }); } }),
                                React.createElement(TenantTagMultiSelect_1.default, { value: this.state.model.IncludedTenantTags, doBusyTask: this.doBusyTask, onChange: function (IncludedTenantTags) { return _this.setModelState({ IncludedTenantTags: IncludedTenantTags }); } })))))));
    };
    DashboardConfiguration.prototype.convertToString = function (value) {
        return value ? value.toString() : "";
    };
    DashboardConfiguration.prototype.parseToInt = function (value) {
        return value ? parseInt(value, 10) : null;
    };
    return DashboardConfiguration;
}(FormBaseComponent_1.default));
exports.default = DashboardConfiguration;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardConfiguration\\DashboardConfiguration.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\dashboard\\DashboardConfiguration\\DashboardConfiguration.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1737);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_actionList__37i_d{display:flex;flex-direction:row;align-items:flex-start;flex-wrap:wrap}.style_actionList__37i_d>:not(:first-child){margin-left:.25rem!important}", ""]);

// exports
exports.locals = {
	"actionList": "style_actionList__37i_d"
};

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1739);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3vFhG{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__20C9B{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1BZaV{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1kb-w{display:none!important}}.style_formContainer__1XosJ{display:flex;flex-direction:column;align-items:stretch;flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3vFhG",
	"hideSm": "style_hide-sm__3vFhG",
	"visible-sm": "style_visible-sm__20C9B",
	"visibleSm": "style_visible-sm__20C9B",
	"hide-md": "style_hide-md__1BZaV",
	"hideMd": "style_hide-md__1BZaV",
	"visible-md": "style_visible-md__1kb-w",
	"visibleMd": "style_visible-md__1kb-w",
	"formContainer": "style_formContainer__1XosJ"
};

/***/ }),
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1746);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_markdown__14Azh{line-height:normal}.style_markdown__14Azh ul{list-style-type:disc;padding-left:2.5rem}.style_markdown__14Azh ol{list-style-type:decimal;padding-left:2.5rem}.style_markdown__14Azh blockquote{border-left:.25rem solid #ccc;padding-left:1rem}", ""]);

// exports
exports.locals = {
	"markdown": "style_markdown__14Azh"
};

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var DebounceValue_1 = __webpack_require__(159);
__export(__webpack_require__(159));
exports.default = DebounceValue_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DebounceValue\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DebounceValue\\index.ts"); } } })();

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IconButton_1 = __webpack_require__(52);
exports.default = IconButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButton\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\IconButton\\index.tsx"); } } })();

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1750);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./MultiSelect.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./MultiSelect.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".MultiSelect_textContainer__1Hiv8{position:relative}.MultiSelect_iconContainer__2tDbT{position:absolute;right:0;top:0;cursor:pointer;margin:.5625rem}.MultiSelect_error__26LJz{font-Size:.75rem;line-Height:.75rem;color:#db4437;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.MultiSelect_label__2F3iK{line-height:22px;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms;user-select:none;color:#2f93e0;font-size:.75rem;font-weight:400}", ""]);

// exports
exports.locals = {
	"textContainer": "MultiSelect_textContainer__1Hiv8",
	"iconContainer": "MultiSelect_iconContainer__2tDbT",
	"error": "MultiSelect_error__26LJz",
	"label": "MultiSelect_label__2F3iK"
};

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var MultiSelect_1 = __webpack_require__(111);
exports.WorkerPoolTypedMultiSelect = MultiSelect_1.default();
var WorkerPoolMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.Environment, chipRender: function (item) { return React.createElement(Chips_1.WorkerPoolChip, { onRequestDelete: onRequestDelete, workerPoolName: item.Name }); } });
    };
    return React.createElement(exports.WorkerPoolTypedMultiSelect, __assign({ items: props.items, fieldName: "worker pools", renderChip: chipRenderer }, props));
};
exports.default = WorkerPoolMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\WorkerPoolMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\WorkerPoolMultiSelect.tsx"); } } })();

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var index_1 = __webpack_require__(24);
var LookupResourceChip_1 = __webpack_require__(160);
var Chips_1 = __webpack_require__(24);
var EventCategoryTypedMultiSelect = MultiSelect_1.MultiSelect();
var LookupEventCategoryChip = LookupResourceChip_1.default();
var EventCategoryMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupEventCategoryChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.EventCategory, chipRender: function (item) { return React.createElement(index_1.EventCategoryChip, { onRequestDelete: onRequestDelete, eventCategory: item }); } });
    };
    return React.createElement(EventCategoryTypedMultiSelect, __assign({ items: props.items, fieldName: "event categories", renderChip: chipRenderer }, props));
};
exports.default = EventCategoryMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EventCategoryMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EventCategoryMultiSelect.tsx"); } } })();

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var index_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_1 = __webpack_require__(24);
var EventGroupTypedMultiSelect = MultiSelect_1.MultiSelect();
var EventGroupMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.EventGroup, chipRender: function (item) { return React.createElement(index_1.EventGroupChip, { onRequestDelete: onRequestDelete, eventGroup: item }); } });
    };
    return React.createElement(EventGroupTypedMultiSelect, __assign({ items: props.items, fieldName: "event groups", renderChip: chipRenderer }, props));
};
exports.default = EventGroupMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EventGroupMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EventGroupMultiSelect.tsx"); } } })();

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var index_1 = __webpack_require__(24);
var LookupResourceChip_1 = __webpack_require__(160);
var Chips_1 = __webpack_require__(24);
var DocumentTypeTypedMultiSelect = MultiSelect_1.MultiSelect();
var LookupDocumentTypeChip = LookupResourceChip_1.default();
var DocumentTypeMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupDocumentTypeChip, { lookupCollection: props.items, lookupId: r.Id, type: Chips_1.ChipIcon.DocumentType, chipRender: function (item) { return React.createElement(index_1.DocumentTypeChip, { onRequestDelete: onRequestDelete, documentType: item }); } });
    };
    return React.createElement(DocumentTypeTypedMultiSelect, __assign({ items: props.items, fieldName: "document types", renderChip: chipRenderer }, props));
};
exports.default = DocumentTypeMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\DocumentTypeMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\DocumentTypeMultiSelect.tsx"); } } })();

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var MachineModelHealthStatusTypedMultiSelect = MultiSelect_1.MultiSelect();
var MachineModelHealthStatusMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.MachineModelHealthStatus, chipRender: function (item) { return React.createElement(Chips_1.MachineModelHealthStatusChip, { onRequestDelete: onRequestDelete, healthStatus: item }); } });
    };
    return React.createElement(MachineModelHealthStatusTypedMultiSelect, __assign({ items: props.items, fieldName: "health statuses", renderChip: chipRenderer }, props));
};
exports.default = MachineModelHealthStatusMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MachineModelHealthStatusMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\MachineModelHealthStatusMultiSelect.tsx"); } } })();

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var Chips_1 = __webpack_require__(24);
var LookupReferenceDataItemChip_1 = __webpack_require__(105);
var Chips_2 = __webpack_require__(24);
var EndpointCommunicationStyleTypedMultiSelect = MultiSelect_1.MultiSelect();
var EndpointCommunicationStyleMultiSelect = function (props) {
    var chipRenderer = function (r, onRequestDelete) {
        return React.createElement(LookupReferenceDataItemChip_1.default, { lookupCollection: props.items, lookupId: r.Id, type: Chips_2.ChipIcon.CommunicationStyle, chipRender: function (item) { return React.createElement(Chips_1.EndpointCommunicationStyleChip, { onRequestDelete: onRequestDelete, commStyle: item }); } });
    };
    return React.createElement(EndpointCommunicationStyleTypedMultiSelect, __assign({ items: props.items, fieldName: "communication styles", renderChip: chipRenderer }, props));
};
exports.default = EndpointCommunicationStyleMultiSelect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EndpointCommunicationStyleMultiSelect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\MultiSelect\\EndpointCommunicationStyleMultiSelect.tsx"); } } })();

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1758);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_paper__1M1Nb{margin-top:1.5rem}", ""]);

// exports
exports.locals = {
	"paper": "style_paper__1M1Nb"
};

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileRoutes_1 = __webpack_require__(1760);
exports.default = UserProfileRoutes_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\index.tsx"); } } })();

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var UserProfileLayout_1 = __webpack_require__(1761);
var UserApiKeys_1 = __webpack_require__(1766);
var UserProfile_1 = __webpack_require__(1791);
var UserRecentActivity_1 = __webpack_require__(1792);
var UserLogins_1 = __webpack_require__(1797);
var RenderWithLayout_1 = __webpack_require__(463);
var ReloadableRoute_1 = __webpack_require__(94);
var NotFound_1 = __webpack_require__(465);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var userProfile = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserProfile_1.default);
var userRecentActivity = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserRecentActivity_1.default);
var userApiKeys = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserApiKeys_1.default);
var userLogins = RenderWithLayout_1.renderWithLayout(UserProfileLayout_1.default)(UserLogins_1.default);
var UserProfileRoutes = (function (_super) {
    __extends(UserProfileRoutes, _super);
    function UserProfileRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfileRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.details, render: function (props) { return userProfile(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.activity, render: function (props) { return userRecentActivity(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.apiKeys, render: function (props) { return userApiKeys(props); } }),
            React.createElement(ReloadableRoute_1.default, { path: routeLinks_1.default.currentUser.logins, render: function (props) { return userLogins(props); } }),
            React.createElement(InternalRedirect_1.default, { from: routeLinks_1.default.currentUser.me, exact: true, to: routeLinks_1.default.currentUser.details }),
            React.createElement(NotFound_1.RedirectAs404, null)));
    };
    return UserProfileRoutes;
}(React.Component));
exports.UserProfileRoutes = UserProfileRoutes;
exports.default = UserProfileRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\UserProfileRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileRoutes\\UserProfileRoutes.tsx"); } } })();

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileLayout_1 = __webpack_require__(1762);
exports.default = UserProfileLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileLayout\\index.tsx"); } } })();

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var AreaTitle_1 = __webpack_require__(122);
var NavigationSidebarLayout_1 = __webpack_require__(775);
var Gravatar_1 = __webpack_require__(1765);
var resources_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var routeLinks_1 = __webpack_require__(22);
var UserProfileLayout = (function (_super) {
    __extends(UserProfileLayout, _super);
    function UserProfileLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            user: null
        });
        return _this;
    }
    UserProfileLayout.prototype.currentUserId = function () {
        return clientInstance_1.session && clientInstance_1.session.currentUser ? clientInstance_1.session.currentUser.Id : null;
    };
    UserProfileLayout.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentUserId()) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_2.repository.Users.get(this.currentUserId())];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        user = _a;
                        this.setState({ user: user });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfileLayout.prototype.render = function () {
        var navLinks = [
            NavigationSidebarLayout_1.Navigation.navItem("My Profile", routeLinks_1.default.currentUser.details),
            NavigationSidebarLayout_1.Navigation.navItem("My Logins", routeLinks_1.default.currentUser.logins),
            NavigationSidebarLayout_1.Navigation.navItem("My API Keys", routeLinks_1.default.currentUser.apiKeys),
            NavigationSidebarLayout_1.Navigation.navItem("My Recent Activity", routeLinks_1.default.currentUser.activity, null, { permission: resources_1.Permission.EventView, wildcard: true }),
        ];
        return (React.createElement("main", { id: "maincontent" },
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.currentUser.me, title: "My Profile" }),
            React.createElement(NavigationSidebarLayout_1.default, { image: this.state.user ? React.createElement(Gravatar_1.default, { user: this.state.user, size: 200 }) : React.createElement("div", null), navLinks: navLinks, content: this.props.children })));
    };
    return UserProfileLayout;
}(BaseComponent_1.default));
exports.UserProfileLayout = UserProfileLayout;
exports.default = UserProfileLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileLayout\\UserProfileLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfileLayout\\UserProfileLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1764);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3NMdz{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__37riV{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3MEWR{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2Epc5{display:none!important}}.style_sideMenu__3snR5{padding:0 1rem;width:16.6rem;flex:0 0 auto}.style_breakword__1oHZK{word-wrap:break-word;word-break:break-word}.style_name__2PBbU{line-height:1.5rem;padding-top:1.5rem;line-height:1.75rem}.style_name__2PBbU,.style_nameHorizontal__XTzy0{word-wrap:break-word;word-break:break-word;font-size:1.625rem;min-width:50%}.style_nameHorizontal__XTzy0{line-height:1.5rem}.style_description__2TiHz{word-wrap:break-word;word-break:break-word;padding-top:1.5rem}.style_preNav__3QsqB{padding:.875rem 0}.style_links__3g04A{padding-top:.875rem}.style_link__3iy9E{display:block;font-size:1rem;line-height:2.5rem;text-align:left;color:#333;text-decoration:none;padding-left:1rem}.style_link__3iy9E>:active,.style_link__3iy9E>:visited{color:#333}a.style_link__3iy9E:hover{color:#0a67b1;background:#fff}.style_selected__2qZfA{color:#2f93e0!important;font-weight:500}.style_stackedLayout__LzKWO{display:flex;flex-direction:column}.style_title__1XBCO{display:flex;flex-direction:row;margin:.5rem;align-items:center}.style_logo__29wa4{margin-left:.5rem;margin-right:.5rem}.style_horizontalLinks__1bSGP{height:2.5rem;margin:0;padding-bottom:1rem}.style_horizontalLinks__1bSGP ul{margin:0}.style_horizontalLinks__1bSGP ul li{display:inline-block}.style_horizontalLinks__1bSGP ul li a{display:block;font-size:1rem;line-height:2.5rem;text-align:left;color:#333;text-decoration:none;padding-left:1rem;padding-right:1rem}.style_horizontalLinks__1bSGP ul li a>:active,.style_horizontalLinks__1bSGP ul li a>:visited{color:#333}.style_horizontalLinks__1bSGP ul li a:hover{color:#0a67b1;background:hsla(0,0%,60%,.08)}.style_horizontalLinks__1bSGP ul li a em{font-size:1.0625rem;padding:0 .5rem}.style_sidebarLayout__1uGZT{display:flex;margin-top:.875rem;margin-right:1rem}.style_sidebarLayoutContent__uTRUj{flex:1 1 auto;display:flex;justify-content:space-around;padding:.125rem;min-width:0}.style_nestedNavLinks__JgA1U{margin-left:1rem}.style_nestedNavLinks__JgA1U .style_link__3iy9E{line-height:2.25rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3NMdz",
	"hideSm": "style_hide-sm__3NMdz",
	"visible-sm": "style_visible-sm__37riV",
	"visibleSm": "style_visible-sm__37riV",
	"hide-md": "style_hide-md__3MEWR",
	"hideMd": "style_hide-md__3MEWR",
	"visible-md": "style_visible-md__2Epc5",
	"visibleMd": "style_visible-md__2Epc5",
	"sideMenu": "style_sideMenu__3snR5",
	"breakword": "style_breakword__1oHZK",
	"name": "style_name__2PBbU",
	"nameHorizontal": "style_nameHorizontal__XTzy0",
	"description": "style_description__2TiHz",
	"preNav": "style_preNav__3QsqB",
	"links": "style_links__3g04A",
	"link": "style_link__3iy9E",
	"selected": "style_selected__2qZfA",
	"stackedLayout": "style_stackedLayout__LzKWO",
	"title": "style_title__1XBCO",
	"logo": "style_logo__29wa4",
	"horizontalLinks": "style_horizontalLinks__1bSGP",
	"sidebarLayout": "style_sidebarLayout__1uGZT",
	"sidebarLayoutContent": "style_sidebarLayoutContent__uTRUj",
	"nestedNavLinks": "style_nestedNavLinks__JgA1U"
};

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Avatar_1 = __webpack_require__(474);
var ExternalLink_1 = __webpack_require__(91);
var Gravatar = function (props) {
    return React.createElement("div", null,
        React.createElement(Avatar_1.Avatar, { user: props.user, size: props.size }),
        React.createElement("div", null,
            "You can change your picture at ",
            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/Gravatar" }, "Gravatar.com")));
};
Gravatar.displayName = "Gravatar";
exports.default = Gravatar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Gravatar\\Gravatar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Gravatar\\Gravatar.tsx"); } } })();

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(26);
var PaperLayout_1 = __webpack_require__(131);
var Section_1 = __webpack_require__(81);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var UserApiKeysList_1 = __webpack_require__(839);
var TransitionAnimation_1 = __webpack_require__(82);
var UserApiKeys = (function (_super) {
    __extends(UserApiKeys, _super);
    function UserApiKeys(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            user: null
        });
        return _this;
    }
    UserApiKeys.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserApiKeys.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserApiKeys.prototype.render = function () {
        return React.createElement(PaperLayout_1.default, { title: "My API Keys", busy: this.state.busy, errors: this.state.errors },
            React.createElement(Section_1.Section, null,
                "You can use an API key to connect ",
                React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/ExternalToolOctoTools" }, "automated tools"),
                " to Octopus, in place of a username and password. API keys are useful because they avoid the need to record your personal password in configuration files and scripts. A unique API key can be created for each use, and then individually revoked when no longer needed."),
            this.state.user && React.createElement(TransitionAnimation_1.default, null,
                React.createElement(UserApiKeysList_1.default, { user: this.state.user })));
    };
    return UserApiKeys;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserApiKeys;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeys.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\UserApiKeys.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(64);
var actions = __webpack_require__(244);
var selectors = __webpack_require__(1768);
var recompose_1 = __webpack_require__(186);
var withDialogIdentifier_1 = __webpack_require__(1770);
var DialogTrigger = (function (_super) {
    __extends(DialogTrigger, _super);
    function DialogTrigger(props) {
        return _super.call(this, props) || this;
    }
    DialogTrigger.prototype.render = function () {
        var _a = this.props, open = _a.open, closeDialog = _a.closeDialog, openDialog = _a.openDialog, sequence = _a.sequence, render = _a.render;
        return render({ open: open, closeDialog: closeDialog, openDialog: openDialog, sequence: sequence });
    };
    DialogTrigger.prototype.open = function () {
        this.props.openDialog();
    };
    return DialogTrigger;
}(React.PureComponent));
exports.DialogTrigger = DialogTrigger;
var mapStateToProps = function (state, _a) {
    var sequence = _a.sequence;
    return ({
        open: selectors.isDialogOpen(sequence)(state),
        sequence: sequence
    });
};
var mapDialogTriggerDispatchProps = function (dispatch, _a) {
    var sequence = _a.sequence;
    return ({
        openDialog: function () { return dispatch(actions.openDialog(sequence)); },
        closeDialog: function () { return dispatch(actions.onDialogClose()); },
    });
};
function enhancer(comp) {
    return recompose_1.compose(withDialogIdentifier_1.default(), react_redux_1.connect(mapStateToProps, mapDialogTriggerDispatchProps))(comp);
}
exports.withDialogTriggers = enhancer;
var EnhancedDialogTrigger = enhancer(DialogTrigger);
exports.default = EnhancedDialogTrigger;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogTrigger.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\DialogTrigger.tsx"); } } })();

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(1769);
exports.dialogsSelector = function (state) { return state.dialogs; };
exports.isDialogOpen = function (key) {
    return reselect_1.createSelector(exports.dialogsSelector, function (dialogs) {
        return dialogs.hasOwnProperty(key) && !!dialogs[key];
    });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\selectors\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\selectors\\index.ts"); } } })();

/***/ }),
/* 1769 */,
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dialogIdGenerator_1 = __webpack_require__(293);
function withDialogIdentifier(name) {
    return function (component) {
        var WithDialogIdentifier = (function (_super) {
            __extends(WithDialogIdentifier, _super);
            function WithDialogIdentifier(props) {
                var _this = _super.call(this, props) || this;
                var sequence = _this.props.sequence || name || dialogIdGenerator_1.default.next();
                _this.state = { sequence: sequence };
                return _this;
            }
            WithDialogIdentifier.prototype.render = function () {
                var Component = component;
                return React.createElement(Component, __assign({ sequence: this.state.sequence }, this.props));
            };
            return WithDialogIdentifier;
        }(React.Component));
        return WithDialogIdentifier;
    };
}
exports.withDialogIdentifier = withDialogIdentifier;
exports.default = withDialogIdentifier;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\withDialogIdentifier.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\withDialogIdentifier.tsx"); } } })();

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1772);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_emptyList__1cZJE{padding:.5rem 1rem;font-size:.875rem;color:#9e9e9e}.style_actionsMenu__3x1Ih{display:flex;justify-content:flex-end;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"emptyList": "style_emptyList__1cZJE",
	"actionsMenu": "style_actionsMenu__3x1Ih"
};

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Text_1 = __webpack_require__(50);
var OkDialogLayout_1 = __webpack_require__(65);
var Section_1 = __webpack_require__(81);
var DataBaseComponent_1 = __webpack_require__(39);
var CopyToClipboardButton_1 = __webpack_require__(415);
var styles = __webpack_require__(712);
var AddApiKeyDialog = (function (_super) {
    __extends(AddApiKeyDialog, _super);
    function AddApiKeyDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.saveAndShowKey = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.props.apiKey) {
                            this.props.onClose();
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.props.onAdd(this.state.purpose)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        }); };
        _this.state = {};
        return _this;
    }
    AddApiKeyDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: function () { return _this.saveAndShowKey(); }, busy: this.state.busy, errors: this.state.errors, hideCancel: !!this.props.apiKey, title: "Generate New API Key", okButtonLabel: this.props.apiKey ? "Close" : "Generate New" }, this.props.apiKey ? this.renderResult() : this.renderSetupApiKey());
    };
    AddApiKeyDialog.prototype.renderResult = function () {
        return React.createElement("div", null,
            React.createElement(Section_1.Section, null, "Your new API key is:"),
            React.createElement(Section_1.Section, null,
                React.createElement("strong", null, this.props.apiKey),
                React.createElement(CopyToClipboardButton_1.default, { value: this.props.apiKey })),
            React.createElement(Section_1.Section, null, "API keys cannot be retrieved once they are created. Make sure you save this key in a safe place like a password management tool."));
    };
    AddApiKeyDialog.prototype.renderSetupApiKey = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(Section_1.Section, null, "API keys can be used to authenticate with the Octopus Deploy REST API in place of a username and password. Using API keys lets you keep your username and password secret, but the API key itself is still sensitive information that needs to be protected."),
            React.createElement(Section_1.Section, null,
                React.createElement(Text_1.default, { value: this.state.purpose, onChange: function (purpose) { return _this.setState({ purpose: purpose }); }, autoFocus: true, label: "Purpose" })),
            React.createElement(Section_1.Section, null, "Record the purpose of this key so that you can revoke it when no longer required."));
    };
    return AddApiKeyDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = AddApiKeyDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\AddApiKeyDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserApiKeys\\AddApiKeyDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1784);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_defaultIconButton__1I_W4{width:2.25rem!important;height:2.25rem!important;padding:0!important}", ""]);

// exports
exports.locals = {
	"defaultIconButton": "style_defaultIconButton__1I_W4"
};

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_apiKeyEntry__Jm2KX{margin-top:0}", ""]);

// exports
exports.locals = {
	"apiKeyEntry": "style_apiKeyEntry__Jm2KX"
};

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NothingToSeeHere_1 = __webpack_require__(803);
exports.NothingToSeeHere = NothingToSeeHere_1.NothingToSeeHere;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NothingToSeeHere\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\NothingToSeeHere\\index.ts"); } } })();

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1788);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__1i21H{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1v0p6{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2FSnb{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2-vLO{display:none!important}}.style_content__3lySZ{color:#9e9e9e!important;padding:.5rem 1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1i21H",
	"hideSm": "style_hide-sm__1i21H",
	"visible-sm": "style_visible-sm__1v0p6",
	"visibleSm": "style_visible-sm__1v0p6",
	"hide-md": "style_hide-md__2FSnb",
	"hideMd": "style_hide-md__2FSnb",
	"visible-md": "style_visible-md__2-vLO",
	"visibleMd": "style_visible-md__2-vLO",
	"content": "style_content__3lySZ"
};

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1790);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_when__1lHKf abbr[title]{text-decoration:none;cursor:help;border-bottom:.05rem dotted #777}", ""]);

// exports
exports.locals = {
	"when": "style_when__1lHKf"
};

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(195);
var permission_1 = __webpack_require__(51);
var OverflowMenu_1 = __webpack_require__(152);
var clientInstance_2 = __webpack_require__(10);
var OpenDialogButton_1 = __webpack_require__(72);
var FormBaseComponent_1 = __webpack_require__(155);
var routeLinks_1 = __webpack_require__(22);
var UserChangePasswordDialog_1 = __webpack_require__(840);
var form_1 = __webpack_require__(16);
var TransitionAnimation_1 = __webpack_require__(82);
var UserProfile = (function (_super) {
    __extends(UserProfile, _super);
    function UserProfile(props) {
        var _this = _super.call(this, props) || this;
        _this.tenantId = null;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var userDisplaNameChanged, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userDisplaNameChanged = this.state.cleanModel.displayName !== this.state.model.displayName;
                        user = __assign({}, this.state.user, { DisplayName: this.state.model.displayName, EmailAddress: this.state.model.emailAddress, Username: this.state.model.username });
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            if (userDisplaNameChanged) {
                                                // we did this in old portal, and we do it for the feature toggles
                                                window.location.reload();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
        };
        return _this;
    }
    UserProfile.prototype.buildModel = function (user) {
        return user
            ? {
                displayName: user.DisplayName,
                username: user.Username,
                emailAddress: user.EmailAddress,
            }
            : {
                displayName: "",
                username: "",
                emailAddress: "",
            };
    };
    UserProfile.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserProfile.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user),
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserProfile.prototype.render = function () {
        var _this = this;
        return React.createElement(FormPaperLayout_1.default, { title: "My Profile", busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick, overFlowActions: this.createOverflowMenuItems(), secondaryAction: this.changePassword() }, this.state.model && React.createElement(TransitionAnimation_1.default, null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "displayName", title: "Display Name", focusOnExpandAll: true, summary: form_1.Summary.summary(this.state.model.displayName ? this.state.model.displayName : "No display name specified yet."), help: "Your name. This does not need to be unique." },
                React.createElement(form_1.Text, { value: this.state.model.displayName, onChange: function (displayName) { return _this.setModelState({ displayName: displayName }); }, label: "Display name", autoFocus: true })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "emailAddress", title: "Email Address", summary: form_1.Summary.summary(this.state.model.emailAddress ? this.state.model.emailAddress : "Your email is not specified yet."), help: this.state.model.emailAddress ? "Your email address." : "Enter an email address." },
                React.createElement(form_1.Text, { value: this.state.model.emailAddress, onChange: function (emailAddress) { return _this.setModelState({ emailAddress: emailAddress }); }, label: "Email address" }))));
    };
    UserProfile.prototype.createOverflowMenuItems = function () {
        var items = [];
        if (this.state.user && this.state.user.Id) {
            items.push(OverflowMenu_1.default.downloadItem("Download my personal details", this.state.model.username + "-user.json", clientInstance_1.client.resolveLinkTemplate("Users", { id: "" + this.state.user.Id })));
            items.push(OverflowMenu_1.default.navItem("Test Permissions", routeLinks_1.default.configuration.testPermission(this.state.user.Id), null, {
                permission: [permission_1.Permission.TeamEdit, permission_1.Permission.UserView]
            }));
        }
        return items;
    };
    UserProfile.prototype.changePassword = function () {
        return this.state.model &&
            React.createElement(OpenDialogButton_1.default, { label: "Change Password" },
                React.createElement(UserChangePasswordDialog_1.default, { userId: this.currentUserId() }));
    };
    return UserProfile;
}(FormBaseComponent_1.default));
exports.default = UserProfile;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfile\\UserProfile.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserProfile\\UserProfile.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(131);
var Section_1 = __webpack_require__(81);
var EventListing_1 = __webpack_require__(818);
var DataBaseComponent_1 = __webpack_require__(39);
var PermissionCheck_1 = __webpack_require__(42);
var clientInstance_1 = __webpack_require__(10);
var clientInstance_2 = __webpack_require__(10);
var permission_1 = __webpack_require__(51);
var Callout_1 = __webpack_require__(57);
var UserRecentActivity = (function (_super) {
    __extends(UserRecentActivity, _super);
    function UserRecentActivity(props) {
        var _this = _super.call(this, props) || this;
        _this.state = ({
            events: null,
        });
        return _this;
    }
    UserRecentActivity.prototype.currentUserId = function () {
        return clientInstance_2.session && clientInstance_2.session.currentUser ? clientInstance_2.session.currentUser.Id : null;
    };
    UserRecentActivity.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var events;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Events.list({ users: [this.props.userId || this.currentUserId()] })];
                                    case 1:
                                        events = _a.sent();
                                        this.setState({
                                            events: events
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserRecentActivity.prototype.render = function () {
        return React.createElement(PaperLayout_1.default, { title: "My Recent Activity", busy: this.state.busy, errors: this.state.errors },
            React.createElement(PermissionCheck_1.default, { permission: permission_1.Permission.EventView, wildcard: true, alternate: React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "The ",
                    permission_1.Permission.EventView,
                    " permission is required to view recent activity") },
                React.createElement(Section_1.Section, null, this.state.events && React.createElement(EventListing_1.default, { data: this.state.events, regarding: [this.props.userId], noDataMessage: "There's no activity to show" }))));
    };
    return UserRecentActivity;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = UserRecentActivity;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserRecentActivity\\UserRecentActivity.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserRecentActivity\\UserRecentActivity.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1794);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_preWrapped__2WHzi{padding:6.5pt;margin:0 0 7pt;font-size:9pt;word-break:break-all;word-wrap:break-word;background-color:#fff;border:.0625rem solid #ccc;border-radius:.125rem}", ""]);

// exports
exports.locals = {
	"preWrapped": "style_preWrapped__2WHzi"
};

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1796);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumnFixedWidth__2y2mZ{width:9.375rem}.style_headerColumnOccurredDate__11k3c{width:9.375rem;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"headerColumnFixedWidth": "style_headerColumnFixedWidth__2y2mZ",
	"headerColumnOccurredDate": "style_headerColumnOccurredDate__11k3c"
};

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FormBaseComponent_1 = __webpack_require__(155);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(449);
var Section_1 = __webpack_require__(81);
var ProviderGroups_1 = __webpack_require__(842);
var UserLogins = (function (_super) {
    __extends(UserLogins, _super);
    function UserLogins(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = __assign({}, this.state.user, { Identities: this.state.model.identities });
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, clientInstance_1.repository.Users.save(user)];
                                        case 1:
                                            result = _a.sent();
                                            this.setState({
                                                cleanModel: this.buildModel(user),
                                                model: this.buildModel(user)
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            user: null,
            model: null,
            cleanModel: null,
            canCurrentUserEditIdentitiesForUser: true,
            enabledAuthenticationProviders: null,
            enabledProvidersMetadata: null
        };
        return _this;
    }
    UserLogins.prototype.currentUserId = function () {
        return clientInstance_1.session && clientInstance_1.session.currentUser ? clientInstance_1.session.currentUser.Id : null;
    };
    UserLogins.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var user, _a, configDoc, metadataDoc;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.currentUserId()) return [3 /*break*/, 2];
                                        return [4 /*yield*/, clientInstance_1.repository.Users.get(this.currentUserId())];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = null;
                                        _b.label = 3;
                                    case 3:
                                        user = _a;
                                        return [4 /*yield*/, clientInstance_1.repository.UserIdentityMetadata.authenticationConfiguration(user.Id)];
                                    case 4:
                                        configDoc = _b.sent();
                                        return [4 /*yield*/, clientInstance_1.repository.UserIdentityMetadata.all()];
                                    case 5:
                                        metadataDoc = _b.sent();
                                        this.setState({
                                            user: user,
                                            model: this.buildModel(user),
                                            cleanModel: this.buildModel(user),
                                            enabledAuthenticationProviders: configDoc.AuthenticationProviders || [],
                                            canCurrentUserEditIdentitiesForUser: configDoc.CanCurrentUserEditIdentitiesForUser,
                                            enabledProvidersMetadata: metadataDoc.Providers
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserLogins.prototype.handleAddIdentity = function (identity) {
        this.setState(function (state) { return ({
            model: __assign({}, state.model, { identities: [identity].concat(state.model.identities) })
        }); });
        return true;
    };
    UserLogins.prototype.render = function () {
        var _this = this;
        return React.createElement(FormPaperLayout_1.default, { title: "My Logins", busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, onSaveClick: this.handleSaveClick }, this.state.model && this.state.enabledAuthenticationProviders.length > 0
            ? React.createElement(ProviderGroups_1.ProviderGroups, { userIdentities: this.state.model.identities, enabledAuthenticationProviders: this.state.enabledAuthenticationProviders, canCurrentUserEditIdentitiesForUser: this.state.canCurrentUserEditIdentitiesForUser, enabledProvidersMetadata: this.state.enabledProvidersMetadata, isServiceAccount: this.state.user.IsService, onChange: function (identities) { return _this.setModelState({ identities: identities }); } })
            : this.state.enabledAuthenticationProviders &&
                React.createElement(Section_1.Section, null, "There are no providers that support external identities enabled."));
    };
    UserLogins.prototype.buildModel = function (user) {
        return user
            ? {
                original: user,
                identities: user.Identities
            }
            : {
                original: null,
                identities: []
            };
    };
    return UserLogins;
}(FormBaseComponent_1.default));
exports.default = UserLogins;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserLogins\\UserLogins.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\users\\UserLogins\\UserLogins.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdentityType;
(function (IdentityType) {
    IdentityType[IdentityType["Guest"] = 0] = "Guest";
    IdentityType[IdentityType["UsernamePassword"] = 1] = "UsernamePassword";
    IdentityType[IdentityType["ActiveDirectory"] = 2] = "ActiveDirectory";
    IdentityType[IdentityType["OAuth"] = 3] = "OAuth";
})(IdentityType || (IdentityType = {}));
exports.default = IdentityType;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\identityType.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\client\\resources\\identityType.ts"); } } })();

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var RemoveItemsList_1 = __webpack_require__(84);
var DataBaseComponent_1 = __webpack_require__(39);
var OpenDialogButton_1 = __webpack_require__(72);
var AddIdentityDialog_1 = __webpack_require__(1800);
var index_1 = __webpack_require__(74);
var form_1 = __webpack_require__(16);
var ListTitle_1 = __webpack_require__(196);
var IdentityList = (function (_super) {
    __extends(IdentityList, _super);
    function IdentityList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IdentityList;
}(RemoveItemsList_1.RemoveItemsList));
var ProviderIdentities = (function (_super) {
    __extends(ProviderIdentities, _super);
    function ProviderIdentities(props) {
        var _this = _super.call(this, props) || this;
        _this.providerIdentitiesSummary = function () {
            var qty = _this.props.provider.identities.length;
            var msg = qty > 0
                ? _this.identityClaims()
                : "No logins are associated";
            return form_1.Summary.placeholder("" + msg);
        };
        _this.identityClaims = function () {
            var claims = _this.props.provider.identities[0].Claims;
            var claimKey = Object.keys(claims).filter(function (key) { return claims[key].IsIdentifyingClaim; })[0];
            return _this.claimLabel(claimKey, _this.props.provider.providerDetails) + ": " + claims[claimKey].Value;
        };
        _this.renderIdentityDetails = function (provider, identity) {
            var claims = identity.Claims;
            var keys = Object.keys(claims);
            return React.createElement("div", null,
                " ",
                Object.keys(claims).map(function (key, i) { return React.createElement("div", { key: i },
                    " ",
                    claims[key].Value &&
                        React.createElement(index_1.default, { content: _this.claimDescription(key, provider) }, claims[key].IsIdentifyingClaim
                            ? React.createElement(ListTitle_1.default, null,
                                _this.claimLabel(key, provider),
                                ": ",
                                claims[key].Value)
                            : React.createElement("div", null,
                                _this.claimLabel(key, provider),
                                ": ",
                                claims[key].Value))); }));
        };
        _this.addIdentity = function (identity) {
            _this.props.onChange(__assign({}, _this.props.provider, { identities: [identity].concat(_this.props.provider.identities) }));
            return true;
        };
        _this.removeIdentity = function (identity) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.onChange(__assign({}, this.props.provider, { identities: this.props.provider.identities.filter(function (i) { return i !== identity; }).slice() }));
                return [2 /*return*/, true];
            });
        }); };
        return _this;
    }
    ProviderIdentities.prototype.render = function () {
        var _this = this;
        var addAction = React.createElement(OpenDialogButton_1.default, { key: "addIdentity-" + this.props.provider.providerName, label: "Add Login" },
            React.createElement(AddIdentityDialog_1.AddIdentityDialog, { selectedProvider: this.props.provider.providerDetails, key: "addEmail-" + this.props.provider.providerName, onAddIdentity: this.addIdentity }));
        return React.createElement(form_1.ExpandableFormSection, { errorKey: this.props.provider.providerName, title: this.props.provider.providerName, summary: this.providerIdentitiesSummary(), help: "A set of accounts for " + this.props.provider.providerName + "." },
            React.createElement("div", null,
                React.createElement(IdentityList, { data: this.props.provider.identities, listActions: this.props.enabledToSupportAdding &&
                        this.props.canCurrentUserEditIdentitiesForUser &&
                        this.props.provider.identities.length === 0 ? [addAction] : [], onRow: function (identity, i) { return React.createElement("div", { key: _this.props.provider + "-" + i }, _this.renderIdentityDetails(_this.props.provider.providerDetails, identity)); }, onRemoveRow: this.props.canCurrentUserEditIdentitiesForUser ? function (identity) { return _this.removeIdentity(identity); } : null })));
    };
    ProviderIdentities.prototype.claimLabel = function (key, provider) {
        return this.findProviderByKey(key, provider).Label;
    };
    ProviderIdentities.prototype.claimDescription = function (key, provider) {
        return this.findProviderByKey(key, provider).Description;
    };
    ProviderIdentities.prototype.findProviderByKey = function (key, provider) {
        return provider.ClaimDescriptors.find(function (d) { return d.Type === key; });
    };
    return ProviderIdentities;
}(DataBaseComponent_1.DataBaseComponent));
exports.ProviderIdentities = ProviderIdentities;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderIdentities.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\configuration\\components\\Users\\ProviderIdentities.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
var OkDialogLayout_1 = __webpack_require__(65);
var Callout_1 = __webpack_require__(57);
var ListTitle_1 = __webpack_require__(196);
var List_1 = __webpack_require__(432);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var IdHelper_1 = __webpack_require__(819);
var Button_1 = __webpack_require__(47);
var form_1 = __webpack_require__(16);
var Validators_1 = __webpack_require__(199);
var styles = __webpack_require__(1804);
var IdentityResults = (function (_super) {
    __extends(IdentityResults, _super);
    function IdentityResults() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IdentityResults;
}(List_1.SimpleList));
var AddIdentityDialog = (function (_super) {
    __extends(AddIdentityDialog, _super);
    function AddIdentityDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.addIdentity = function () {
            if (_this.state.selectedSearchResultKey) {
                var identityToAdd = _this.state.searchResults
                    .find(function (i) { return i.Id === _this.state.selectedSearchResultKey; });
                if (identityToAdd) {
                    return _this.props.onAddIdentity(identityToAdd);
                }
            }
            return _this.props.onAddIdentity(_this.state.identity);
        };
        _this.setClaim = function (key, value) {
            _this.setState(function (state) {
                var Claims = __assign({}, state.identity.Claims, (_a = {}, _a[key] = __assign({}, state.identity.Claims[key], { Value: value }), _a));
                return { identity: __assign({}, state.identity, { Claims: Claims }) };
                var _a;
            });
        };
        _this.buildSearchResultRow = function (identity) {
            var claims = identity.Claims;
            var entries = Object.keys(claims).map(function (key, i) {
                var keyAndValue = _this.claimLabel(key) + ": " + claims[key].Value;
                return claims[key].Value &&
                    React.createElement("div", { key: i, onClick: function () { return _this.setState({ selectedSearchResultKey: identity.Id }); } }, claims[key].IsIdentifyingClaim
                        ? React.createElement(ListTitle_1.default, null, keyAndValue)
                        : React.createElement("span", null, keyAndValue));
            });
            return React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.select },
                    React.createElement(RadioButtonGroup_1.default, { value: identity.Id === _this.state.selectedSearchResultKey, onChange: null },
                        React.createElement(RadioButton_1.default, { value: true }))),
                React.createElement("div", { className: styles.claimContent }, entries));
        };
        _this.state = {
            identity: _this.createIdentity(),
            supportsSearch: _this.supportsSearch(),
            searchResults: null //when it's an empty list we can show message showing no results
        };
        return _this;
    }
    AddIdentityDialog.prototype.render = function () {
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.addIdentity, okButtonDisabled: this.disableAddIdentity(), busy: this.state.busy, errors: this.state.errors, okButtonLabel: this.state.supportsSearch ? "Select" : "Add", title: "Add Login" },
            React.createElement("h4", null, "External Login Details"),
            this.state.identity
                ? (this.state.supportsSearch ? this.renderSearch() : this.renderControlsForClaim())
                : React.createElement("div", null, "There seems to be a problem with the properties on this identity provider"));
    };
    AddIdentityDialog.prototype.disableAddIdentity = function () {
        if (this.state.supportsSearch) {
            return !this.state.selectedSearchResultKey;
        }
        var claims = this.state.identity.Claims;
        var claimsValues = Object.keys(claims)
            .map(function (key, i) { return ({
            identifying: claims[key].IsIdentifyingClaim,
            value: claims[key].Value
        }); });
        return !claimsValues.some(function (c) { return c.identifying && !!c.value; });
    };
    AddIdentityDialog.prototype.renderControlsForClaim = function () {
        var _this = this;
        var claims = this.state.identity.Claims;
        return Object.keys(claims).map(function (key, i) { return React.createElement("div", { key: i },
            React.createElement(form_1.Text, { value: claims[key].Value, onChange: function (v) { return _this.setClaim(key, v); }, label: _this.claimLabel(key), validate: claims[key].IsIdentifyingClaim && Validators_1.required("Please enter " + _this.claimDescription(key)) })); });
    };
    AddIdentityDialog.prototype.renderSearch = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement("h4", null, "Search"),
            React.createElement("div", { className: styles.inlineSearch },
                React.createElement(form_1.Text, { value: this.state.query, onChange: function (query) { return _this.setState({ query: query }); }, label: "Search" }),
                React.createElement(Button_1.ActionButton, { onClick: function () { return _this.search(); }, label: "Search", busyLabel: "Searching...", disabled: this.state.busy })),
            this.state.searchResults !== null &&
                (this.state.searchResults.length === 0
                    ? React.createElement(Callout_1.default, { title: "No results were found", type: Callout_1.CalloutType.Information }, "Enter the start of a group name. For example, to find \"Domain Users\", type \"Domain\".")
                    : React.createElement(IdentityResults, { items: this.state.searchResults, onRow: this.buildSearchResultRow, onRowRedirectUrl: function () { return null; } })));
    };
    AddIdentityDialog.prototype.createIdentity = function () {
        if (!this.props.selectedProvider) {
            return null;
        }
        var identity = {
            // Id just to help in UI
            Id: IdHelper_1.default.newId(),
            // this structure to support saving
            IdentityProviderName: this.props.selectedProvider.IdentityProviderName,
            Claims: {}
        };
        this.props.selectedProvider.ClaimDescriptors.forEach(function (d) {
            return identity.Claims[d.Type] = {
                Value: "",
                IsIdentifyingClaim: d.IsIdentifyingClaim
            };
        });
        return identity;
    };
    AddIdentityDialog.prototype.supportsSearch = function () {
        return this.props.selectedProvider && this.props.selectedProvider.Links &&
            lodash_1.some(this.props.selectedProvider.Links, function (v, key) { return key === "UserSearch"; });
    };
    AddIdentityDialog.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var uri, partialName, result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.props.selectedProvider.Links) {
                                            this.setState({ searchResults: [] });
                                            return [2 /*return*/];
                                        }
                                        uri = lodash_1.find(this.props.selectedProvider.Links, function (v, key) { return key === "UserSearch"; });
                                        partialName = this.state.query;
                                        return [4 /*yield*/, clientInstance_1.repository.ExternalUsers.searchProvider(uri, partialName)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState({
                                            // add some Ids to help with selecting it for return from this popup
                                            searchResults: result.Identities.map(function (x) { return (__assign({}, x, { Id: IdHelper_1.default.newId() })); }) || [],
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // if the claim object can just be built with these properties via createIdentity then they won't be needed
    AddIdentityDialog.prototype.claimLabel = function (key) {
        return this.findProviderByKey(key).Label;
    };
    AddIdentityDialog.prototype.claimDescription = function (key) {
        return this.findProviderByKey(key).Description;
    };
    AddIdentityDialog.prototype.findProviderByKey = function (key) {
        return this.props.selectedProvider && this.props.selectedProvider.ClaimDescriptors
            && this.props.selectedProvider.ClaimDescriptors.find(function (d) { return d.Type === key; });
    };
    return AddIdentityDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.AddIdentityDialog = AddIdentityDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AddIdentityDialog\\AddIdentityDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AddIdentityDialog\\AddIdentityDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_listTitle__2-j_A{font-size:1.063rem;line-height:1.18rem;color:#2f93e0;margin:.25rem 0;font-weight:500}", ""]);

// exports
exports.locals = {
	"listTitle": "style_listTitle__2-j_A"
};

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IdHelper = (function () {
    function IdHelper() {
    }
    IdHelper.newId = function () {
        return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
    };
    return IdHelper;
}());
exports.default = IdHelper;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\IdHelper\\IdHelper.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\IdHelper\\IdHelper.tsx"); } } })();

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1805);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1ZVzG{display:flex;flex-direction:row;align-items:flex-start}.style_select__1cFb6{display:flex;justify-content:center;align-items:center}.style_inlineSearch__3IJgD{display:flex;flex-direction:row;align-items:baseline}.style_claimContent__gSpai{display:block}", ""]);

// exports
exports.locals = {
	"container": "style_container__1ZVzG",
	"select": "style_select__1cFb6",
	"inlineSearch": "style_inlineSearch__3IJgD",
	"claimContent": "style_claimContent__gSpai"
};

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notfound.42f85dfb624a6cadc92b501d221a7e22.hashedasset.png";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1808);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1wFpO{display:flex;align-items:center;margin:1rem;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__1wFpO"
};

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProjectGroupLayout_1 = __webpack_require__(1810);
exports.default = ProjectGroupLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\index.tsx"); } } })();

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var FormPaperLayout_1 = __webpack_require__(195);
var FormBaseComponent_1 = __webpack_require__(431);
var lodash_1 = __webpack_require__(11);
var Markdown_1 = __webpack_require__(132);
var form_1 = __webpack_require__(16);
var AreaTitle_1 = __webpack_require__(122);
var MarkdownEditor_1 = __webpack_require__(304);
var OverflowMenu_1 = __webpack_require__(152);
var permission_1 = __webpack_require__(51);
var StringHelper_1 = __webpack_require__(236);
var routeLinks_1 = __webpack_require__(22);
var InternalRedirect_1 = __webpack_require__(45);
var TransitionAnimation_1 = __webpack_require__(82);
var ProjectGroupLayout = (function (_super) {
    __extends(ProjectGroupLayout, _super);
    function ProjectGroupLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var isNew, result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        isNew = this.state.model.Id == null;
                                        return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.save(this.state.model)];
                                    case 1:
                                        result = _a.sent();
                                        this.setState({
                                            model: result,
                                            cleanModel: lodash_1.cloneDeep(result),
                                            newId: isNew ? result.Id : null
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleDeleteConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ProjectGroups.del(this.state.model)];
                    case 1:
                        result = _a.sent();
                        this.setState(function (state) {
                            return {
                                model: null,
                                cleanModel: null,
                                deleted: true
                            };
                        });
                        return [2 /*return*/, true];
                }
            });
        }); };
        _this.state = {
            deleted: false,
            newId: null
        };
        return _this;
    }
    ProjectGroupLayout.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var projectGroupPromise, projectGroup;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        projectGroupPromise = clientInstance_1.repository.ProjectGroups.get(this.props.match.params.ProjectGroupId);
                                        return [4 /*yield*/, projectGroupPromise];
                                    case 1:
                                        projectGroup = _a.sent();
                                        this.setState({
                                            model: projectGroup,
                                            cleanModel: lodash_1.cloneDeep(projectGroup)
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectGroupLayout.prototype.descriptionSummary = function () {
        return this.state.model.Description ?
            form_1.Summary.summary(React.createElement(Markdown_1.default, { markup: this.state.model.Description })) :
            form_1.Summary.placeholder("No project group description provided");
    };
    ProjectGroupLayout.prototype.render = function () {
        var _this = this;
        var title = this.props.create
            ? "Create project group"
            : this.state.model
                ? this.state.model.Name
                : StringHelper_1.default.ellipsis;
        var overFlowActions = [];
        if (!this.props.create && this.state.model) {
            overFlowActions.push(OverflowMenu_1.default.deleteItemDefault("project group", this.handleDeleteConfirm, { permission: permission_1.default.ProjectGroupDelete, projectGroup: "*" }));
            overFlowActions.push([OverflowMenu_1.default.navItem("Audit Trail", routeLinks_1.default.configuration.eventsRegardingAny([this.state.model.Id]), null, {
                    permission: permission_1.default.AuditView,
                })]);
        }
        var saveText = this.state.newId
            ? "Project group created"
            : "Project group details updated";
        return React.createElement("main", { id: "maincontent" },
            React.createElement(AreaTitle_1.default, { link: routeLinks_1.default.projects, title: "Projects" }),
            React.createElement(FormPaperLayout_1.default, { title: title, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: { permission: this.props.create ? permission_1.default.ProjectGroupCreate : permission_1.default.ProjectGroupEdit, projectGroup: "*" }, onSaveClick: this.handleSaveClick, saveText: saveText, expandAllOnMount: this.props.create, overFlowActions: overFlowActions },
                this.state.deleted && React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.projects }),
                this.state.newId && React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.projectGroup(this.state.newId).root }),
                this.state.model && React.createElement(TransitionAnimation_1.default, null,
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "Name", title: "Name", summary: this.state.model.Name ? form_1.Summary.summary(this.state.model.Name) : form_1.Summary.placeholder("Please enter a name for your project group"), help: "A short, memorable, unique name for this project group." },
                        React.createElement(form_1.Text, { value: this.state.model.Name, onChange: function (Name) { return _this.setModelState({ Name: Name }); }, label: "Name", validate: form_1.required("Please enter a project group name"), autoFocus: true })),
                    React.createElement(form_1.ExpandableFormSection, { errorKey: "description", title: "Description", summary: this.descriptionSummary(), help: "Enter a description for your project group." },
                        React.createElement(MarkdownEditor_1.default, { value: this.state.model.Description, label: "Project group description", onChange: function (Description) { return _this.setModelState({ Description: Description }); } })))));
    };
    return ProjectGroupLayout;
}(FormBaseComponent_1.default));
exports.default = ProjectGroupLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\ProjectGroupLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ProjectGroupLayout\\ProjectGroupLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var DeploymentToProjectTaskRedirect_1 = __webpack_require__(1812);
var ReloadableRoute_1 = __webpack_require__(94);
var DeploymentRoutes = (function (_super) {
    __extends(DeploymentRoutes, _super);
    function DeploymentRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: match.url + "/:deploymentId", component: DeploymentToProjectTaskRedirect_1.default })));
    };
    return DeploymentRoutes;
}(React.Component));
exports.default = DeploymentRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\DeploymentRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\DeploymentRoutes.tsx"); } } })();

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var DataBaseComponent_1 = __webpack_require__(90);
var routeLinks_1 = __webpack_require__(22);
var PaperLayout_1 = __webpack_require__(154);
var index_1 = __webpack_require__(122);
var InternalRedirect_1 = __webpack_require__(45);
var DeploymentToProjectTaskRedirect = (function (_super) {
    __extends(DeploymentToProjectTaskRedirect, _super);
    function DeploymentToProjectTaskRedirect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            redirectTo: null
        };
        return _this;
    }
    DeploymentToProjectTaskRedirect.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var deploymentId, deployment, release, path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deploymentId = this.props.match.params.deploymentId;
                        return [4 /*yield*/, clientInstance_1.repository.Deployments.get(deploymentId)];
                    case 1:
                        deployment = _a.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Releases.get(deployment.ReleaseId)];
                    case 2:
                        release = _a.sent();
                        path = routeLinks_1.default.project(release.ProjectId).release(release).deployments.specific(deployment);
                        this.setState({
                            redirectTo: path
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeploymentToProjectTaskRedirect.prototype.render = function () {
        var redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return React.createElement("main", { id: "maincontent" },
                React.createElement(index_1.default, { link: routeLinks_1.default.projects, title: "Projects" }),
                React.createElement(PaperLayout_1.default, { busy: this.state.busy, fullWidth: true, errors: this.state.errors }));
        }
        return React.createElement(InternalRedirect_1.default, { push: false, to: { pathname: redirectTo } });
    };
    return DeploymentToProjectTaskRedirect;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeploymentToProjectTaskRedirect;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\DeploymentToProjectTaskRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\deployments\\DeploymentToProjectTaskRedirect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(22);
var ReloadableRoute_1 = __webpack_require__(94);
var InternalRedirect_1 = __webpack_require__(45);
var EditEnvironment = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.environment(props.match.params.environmentId), search: props.location.search } });
};
var EditProxy = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxy(props.match.params.proxyId), search: props.location.search } });
};
var EditMachinePolicy = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicy(props.match.params.machinePolicyId), search: props.location.search } });
};
var V3EnvironmentRoutes = (function (_super) {
    __extends(V3EnvironmentRoutes, _super);
    function V3EnvironmentRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3EnvironmentRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxies.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies/:proxyId", component: EditProxy }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/proxies" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.proxies.root, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicies.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies/:machinePolicyId", component: EditMachinePolicy }),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/machinepolicies" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machinePolicies.root, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.environments.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/environments/:environmentId", component: EditEnvironment }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.infrastructure.environments.root }))));
    };
    return V3EnvironmentRoutes;
}(React.Component));
exports.V3EnvironmentRoutes = V3EnvironmentRoutes;
exports.default = V3EnvironmentRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3EnvironmentRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3EnvironmentRoutes.tsx"); } } })();

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(22);
var ReloadableRoute_1 = __webpack_require__(94);
var InternalRedirect_1 = __webpack_require__(45);
var EditAccount = function (props) {
    return React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.account(props.match.params.accountId), search: props.location.search } });
};
var V3AccountRoutes = (function (_super) {
    __extends(V3AccountRoutes, _super);
    function V3AccountRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3AccountRoutes.prototype.render = function () {
        var match = this.props.match;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/accounts/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.accounts.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/accounts/:accountId", component: EditAccount }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.accounts.root, search: this.props.location.search } }))));
    };
    return V3AccountRoutes;
}(React.Component));
exports.V3AccountRoutes = V3AccountRoutes;
exports.default = V3AccountRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3AccountRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3AccountRoutes.tsx"); } } })();

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(61);
var routeLinks_1 = __webpack_require__(22);
var ReloadableRoute_1 = __webpack_require__(94);
var InternalRedirect_1 = __webpack_require__(45);
var EditMachine = function (props) {
    return React.createElement(react_router_dom_1.Switch, null,
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/connection" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.deploymentTarget(props.match.params.machineId).connection, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/deployments" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.deploymentTarget(props.match.params.machineId).deployments, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, { path: props.match.path + "/events" },
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.deploymentTarget(props.match.params.machineId).events, search: props.location.search } })),
        React.createElement(ReloadableRoute_1.default, null,
            React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.deploymentTarget(props.match.params.machineId).root, search: props.location.search } })));
};
var V3MachineRoutes = (function (_super) {
    __extends(V3MachineRoutes, _super);
    function V3MachineRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    V3MachineRoutes.prototype.render = function () {
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(ReloadableRoute_1.default, { path: "/machines/new" },
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machines.create, search: this.props.location.search } })),
            React.createElement(ReloadableRoute_1.default, { path: "/machines/:machineId", component: EditMachine }),
            React.createElement(ReloadableRoute_1.default, null,
                React.createElement(InternalRedirect_1.default, { to: { pathname: routeLinks_1.default.infrastructure.machines.root, search: this.props.location.search } }))));
    };
    return V3MachineRoutes;
}(React.Component));
exports.V3MachineRoutes = V3MachineRoutes;
exports.default = V3MachineRoutes;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3MachineRoutes.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\infrastructure\\components\\InfrastructureRoutes\\V3MachineRoutes.tsx"); } } })();

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var index_1 = __webpack_require__(90);
var routeLinks_1 = __webpack_require__(22);
var index_2 = __webpack_require__(154);
var index_3 = __webpack_require__(122);
var InternalRedirect_1 = __webpack_require__(45);
var ProjectChildRedirect = (function (_super) {
    __extends(ProjectChildRedirect, _super);
    function ProjectChildRedirect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            redirectTo: null
        };
        return _this;
    }
    ProjectChildRedirect.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var projectId, redirectTo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.getProjectId(clientInstance_1.repository)];
                    case 1:
                        projectId = _a.sent();
                        redirectTo = this.props.getRedirectPath(projectId);
                        this.setState({
                            redirectTo: redirectTo
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ProjectChildRedirect.prototype.render = function () {
        var redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return React.createElement("main", { id: "maincontent" },
                React.createElement(index_3.default, { link: routeLinks_1.default.projects, title: "Projects" }),
                React.createElement(index_2.default, { busy: this.state.busy, fullWidth: true, errors: this.state.errors }));
        }
        return React.createElement(InternalRedirect_1.default, { push: false, to: { pathname: redirectTo } });
    };
    return ProjectChildRedirect;
}(index_1.DataBaseComponent));
exports.ReleaseRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.Releases.get(props.releaseId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).release(props.releaseId).root; } });
};
exports.TriggerRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.ProjectTriggers.get(props.triggerId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).trigger(props.triggerId); } });
};
exports.ChannelRedirect = function (props) {
    return React.createElement(ProjectChildRedirect, { getProjectId: function (r) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, r.Channels.get(props.channelId)];
                case 1: return [2 /*return*/, (_a.sent()).ProjectId];
            }
        }); }); }, getRedirectPath: function (projectId) { return routeLinks_1.default.project(projectId).channel(props.channelId); } });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\ProjectChildRedirect.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\RootRoutes\\ProjectChildRedirect.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1818);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__34AXe{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3Cv2k{display:none!important}}@media (max-width:79.9rem){.style_hide-md__fzmTu{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1-kcH{display:none!important}}.style_container__2HuiA{width:12.75rem;padding:1rem 1rem 0;margin:.8rem;position:relative;display:flex;flex-direction:column;align-items:center;flex:0 1 auto;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff;transition:background-color .1s ease-in}.style_container__2HuiA,.style_container__2HuiA:active,.style_container__2HuiA:visited{color:#333;text-decoration:none}.style_container__2HuiA:hover{box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_container__2HuiA:hover .style_onHover__W0b2Z{background-color:hsla(0,0%,62%,.4);position:absolute;display:flex;flex-direction:column;bottom:0;left:0;height:100%;width:100%;justify-content:center;align-items:center}@media (max-width:37.4rem){.style_container__2HuiA{margin:.8rem 0}}.style_onHover__W0b2Z{display:none}.style_header__2_mHJ{max-width:12.25rem;font-size:1.0625rem;margin-top:1rem;text-align:center;color:#333;word-wrap:break-word;word-break:break-word}.style_link__2dgP6>a{position:absolute;display:flex;flex-direction:column;bottom:0;left:0;height:100%;width:100%;z-index:1}.style_disabled__1TIYv *{color:#9e9e9e}.style_content__3Ox8D{text-align:center;max-width:12.25rem;color:#9e9e9e;font-size:.8125rem;line-height:1rem;max-height:4.5rem;margin-bottom:1rem;height:100%;position:relative;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;font-weight:300}.style_content__3Ox8D p{margin:.5rem 0}.style_contentFade__2BsiQ:after{position:absolute;bottom:-1rem;height:3rem;width:100%;content:\"\";background:linear-gradient(0deg,#fff 40%,hsla(0,0%,100%,0));pointer-events:none;left:0;z-index:1;overflow:hidden}.style_footer__MG2_d{margin-top:auto;width:12.75rem;font-size:.625rem;padding-top:.5rem;padding-bottom:.5rem;text-align:center}.style_footerIcon__2eLyu{margin-left:.1875rem}@media (max-width:37.4rem){.style_content__3Ox8D{display:none}.style_header__2_mHJ{margin-top:auto;margin-bottom:auto;margin-left:.5rem;max-width:none;flex:1 1 auto;text-align:left}.style_container__2HuiA{display:flex;flex-direction:row;justify-content:space-between;align-items:stretch;padding:.5rem;height:auto;width:100%}.style_footer__MG2_d>*{display:none}.style_footer__MG2_d{padding:0;margin:0;width:1.5rem;height:auto;display:flex;align-items:center}.style_footerIcon__2eLyu{display:block}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__34AXe",
	"hideSm": "style_hide-sm__34AXe",
	"visible-sm": "style_visible-sm__3Cv2k",
	"visibleSm": "style_visible-sm__3Cv2k",
	"hide-md": "style_hide-md__fzmTu",
	"hideMd": "style_hide-md__fzmTu",
	"visible-md": "style_visible-md__1-kcH",
	"visibleMd": "style_visible-md__1-kcH",
	"container": "style_container__2HuiA",
	"onHover": "style_onHover__W0b2Z",
	"header": "style_header__2_mHJ",
	"link": "style_link__2dgP6",
	"disabled": "style_disabled__1TIYv",
	"content": "style_content__3Ox8D",
	"contentFade": "style_contentFade__2BsiQ",
	"footer": "style_footer__MG2_d",
	"footerIcon": "style_footerIcon__2eLyu"
};

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1820);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_description__2nM_J{color:#666;font-size:.8125rem;font-weight:300;line-height:1rem}.style_description__2nM_J p{margin:.5rem 0;font-size:.8125rem;color:#666}", ""]);

// exports
exports.locals = {
	"description": "style_description__2nM_J"
};

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(713);
var cn = __webpack_require__(19);
var Panel = function (props) {
    return React.createElement("div", { className: cn(styles.panel, props.className) },
        React.createElement("div", { className: styles.header },
            React.createElement("img", { src: props.imageSrc, alt: props.imageAlt, width: props.imageWidth, height: props.imageHeight })),
        React.createElement("div", { className: styles.body }, props.description));
};
exports.default = Panel;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\Panel.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\Panel.tsx"); } } })();

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.empty_hide-sm__3LFt_{display:none!important}}@media (min-width:37.4rem){.empty_visible-sm__2PbGS{display:none!important}}@media (max-width:79.9rem){.empty_hide-md__2LD03{display:none!important}}@media (min-width:79.9rem){.empty_visible-md__3r2WF{display:none!important}}.empty_panel__2DGYD{position:relative;background-color:#fff;margin:1rem;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12)}.empty_panel__2DGYD .empty_header__3ckCP{margin:0;padding:0 1.25rem;text-align:center}.empty_panel__2DGYD .empty_header__3ckCP img{max-width:90%;height:auto}.empty_panel__2DGYD .empty_body__2QdzK{padding:1.25rem .625rem;font-size:.875rem;line-height:1.1875rem}.empty_panel__2DGYD .empty_body__2QdzK ol,.empty_panel__2DGYD .empty_body__2QdzK ul{padding-left:2.5rem}.empty_panel__2DGYD .empty_body__2QdzK ul{list-style:square}.empty_panel__2DGYD .empty_body__2QdzK ol{list-style:decimal}.empty_panelCard__3rduS{margin-left:.9375rem;margin-right:.9375rem;margin-bottom:1.875rem;position:relative;background-color:#fff;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12);background:#fff;transition:background-color .1s ease-in}.empty_panelCard__3rduS .empty_header__3ckCP{margin:0;padding:0 1.25rem}.empty_panelCard__3rduS .empty_header__3ckCP img{max-width:80%;max-height:80%}.empty_panelCard__3rduS .empty_body__2QdzK{padding:1.25rem .625rem;font-size:.875rem;line-height:1.1875rem}.empty_panelCard__3rduS .empty_body__2QdzK ol,.empty_panelCard__3rduS .empty_body__2QdzK ul{padding-left:2.5rem}.empty_panelCard__3rduS .empty_body__2QdzK ul{list-style:square}.empty_panelCard__3rduS .empty_body__2QdzK ol{list-style:decimal}.empty_onboardingOuterContainer__2B2QR{margin:1rem 3rem;display:flex;flex-direction:column;align-items:center}.empty_onboardingBlurred__3zjuO:hover *{-webkit-filter:unset;filter:unset}.empty_onboardingBlurred__3zjuO *{-webkit-filter:grayscale(1);filter:grayscale(1)}.empty_onboardingContainer__KbjjK{display:flex;flex-direction:column;align-items:center;width:100%}.empty_title__1tqAP{text-align:center;margin-bottom:1rem;width:100%}.empty_onboardingCreateFirst__2F3d4{text-align:center;font-size:.8125rem;color:#9e9e9e}.empty_panels__1kplu{display:flex;flex-wrap:wrap;justify-content:center;width:100%}.empty_panels__1kplu>*{flex-grow:1;max-width:37.5rem;width:30%;box-sizing:border-box}@media (max-width:37.4rem){.empty_panels__1kplu>*{width:100%}.empty_onboardingOuterContainer__2B2QR{margin:.25rem .5rem}}", ""]);

// exports
exports.locals = {
	"hide-sm": "empty_hide-sm__3LFt_",
	"hideSm": "empty_hide-sm__3LFt_",
	"visible-sm": "empty_visible-sm__2PbGS",
	"visibleSm": "empty_visible-sm__2PbGS",
	"hide-md": "empty_hide-md__2LD03",
	"hideMd": "empty_hide-md__2LD03",
	"visible-md": "empty_visible-md__3r2WF",
	"visibleMd": "empty_visible-md__3r2WF",
	"panel": "empty_panel__2DGYD",
	"header": "empty_header__3ckCP",
	"body": "empty_body__2QdzK",
	"panelCard": "empty_panelCard__3rduS",
	"onboardingOuterContainer": "empty_onboardingOuterContainer__2B2QR",
	"onboardingBlurred": "empty_onboardingBlurred__3zjuO",
	"onboardingContainer": "empty_onboardingContainer__KbjjK",
	"title": "empty_title__1tqAP",
	"onboardingCreateFirst": "empty_onboardingCreateFirst__2F3d4",
	"panels": "empty_panels__1kplu"
};

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var envCount_1 = __webpack_require__(843);
var phaseHelpers_1 = __webpack_require__(714);
var styles = __webpack_require__(1824);
var iconStyles = __webpack_require__(497);
var routeLinks_1 = __webpack_require__(22);
var PhaseStatusIcon_1 = __webpack_require__(820);
var LifecycleMapInternal = (function (_super) {
    __extends(LifecycleMapInternal, _super);
    function LifecycleMapInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phaseHasSingleTargetEnvironmentWithSameName = function (p) {
            var env = _this.props.environmentsById[phaseHelpers_1.getSingleDeploymentTarget(p)];
            return envCount_1.default(p) === 1 && env && p.Name === env.Name;
        };
        _this.PhaseOnly = function (props) {
            var s = _this.props.lifecycleStatus;
            var target = phaseHelpers_1.getSingleDeploymentTarget(props.phase);
            var task = s.tasks[target];
            var phaseName = task
                ? React.createElement("a", { className: styles.phaseName, href: routeLinks_1.default.task(task).root }, _this.props.environmentsById[target].Name)
                : React.createElement("span", { className: styles.phaseName }, _this.props.environmentsById[target].Name);
            return React.createElement("div", null,
                React.createElement(PhaseStatusIcon_1.default, { phase: props.phase, status: _this.props.lifecycleStatus }),
                phaseName,
                React.createElement(_this.PhaseConstraintOptional, { phase: props.phase }));
        };
        _this.PhaseAndAllTargetEnvironments = function (props) {
            return React.createElement("div", null,
                React.createElement(PhaseStatusIcon_1.default, { phase: props.phase, status: _this.props.lifecycleStatus }),
                React.createElement("span", { className: styles.phaseName }, props.phase.Name),
                React.createElement(_this.PhaseConstraintAny, { phase: props.phase }),
                React.createElement(_this.PhaseConstraintOptional, { phase: props.phase }),
                React.createElement("ul", null,
                    props.phase.AutomaticDeploymentTargets.map(function (e) {
                        return React.createElement(_this.AutomaticDeploymentTarget, { key: e, target: e });
                    }),
                    props.phase.OptionalDeploymentTargets.map(function (e) {
                        return React.createElement(_this.OptionalDeploymentTarget, { key: e, target: e });
                    })));
        };
        _this.PhaseConstraintAny = function (props) {
            var p = props.phase;
            var show = p.MinimumEnvironmentsBeforePromotion > 0 && p.MinimumEnvironmentsBeforePromotion < envCount_1.default(p) && !p.IsOptionalPhase;
            return show ? React.createElement("span", { className: styles.phaseConstraint },
                " (any ",
                p.MinimumEnvironmentsBeforePromotion,
                ")") : null;
        };
        _this.PhaseConstraintOptional = function (props) {
            return props.phase.IsOptionalPhase ? React.createElement("span", { className: styles.phaseConstraint }, " (optional)") : null;
        };
        _this.AutomaticDeploymentTarget = function (props) {
            return (_this.props.environmentsById[props.target])
                ? React.createElement("li", { className: styles.target, title: "Automatically deploy to this environment", key: props.target },
                    React.createElement("span", { className: cn(iconStyles.phaseIcon, iconStyles.automatic) }),
                    React.createElement(_this.EnvironmentName, __assign({}, props)))
                : null;
        };
        _this.OptionalDeploymentTarget = function (props) {
            return (_this.props.environmentsById[props.target])
                ? React.createElement("li", { className: styles.target, title: "Manually deploy to this environment", key: props.target },
                    React.createElement("span", { className: cn(iconStyles.phaseIcon, iconStyles.optional) }),
                    React.createElement(_this.EnvironmentName, __assign({}, props)))
                : null;
        };
        _this.EnvironmentName = function (props) {
            return _this.props.lifecycleStatus.tasks[props.target]
                ? React.createElement("a", { href: "#/tasks/{{ tasks[e] }}" }, _this.props.environmentsById[props.target].Name)
                : React.createElement("span", null, _this.props.environmentsById[props.target].Name);
        };
        return _this;
    }
    LifecycleMapInternal.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: cn(styles.lifecycleMap, this.props.className) },
            React.createElement("ul", null, this.props.phases.map(function (p) {
                return React.createElement("li", { className: styles.phase, key: p.Name }, _this.phaseHasSingleTargetEnvironmentWithSameName(p)
                    ? React.createElement(_this.PhaseOnly, { phase: p })
                    : React.createElement(_this.PhaseAndAllTargetEnvironments, { phase: p }));
            })));
    };
    return LifecycleMapInternal;
}(React.Component));
exports.default = LifecycleMapInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMapInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\library\\components\\Lifecycle\\LifecycleMap\\LifecycleMapInternal.tsx"); } } })();

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1825);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_lifecycle-map__1YqE4{position:relative;overflow:hidden}.style_lifecycle-map__1YqE4>ul:before{content:\"\";position:absolute;top:1.25rem;bottom:1.5rem;left:.375rem;width:.0625rem;background:#9e9e9e}.style_lifecycle-map__1YqE4 li{position:relative;list-style-type:none;margin:.5rem .25rem .5rem 0;font-size:.875rem;font-weight:400;line-height:1.36rem;text-align:left}.style_lifecycle-map__1YqE4>ul>li.style_phase__sK0_L .style_phase-name__UOlFy{font-weight:500}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L ul{list-style-type:none;margin-left:1.5rem;padding-left:0}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L li{list-style-type:none;margin-left:0;padding-left:0}.style_lifecycle-map__1YqE4 li.style_target__3FUvu:before{content:\"\";position:absolute;top:.5rem;left:-1.125rem;width:1.125rem;height:.0625rem;background:#9e9e9e}.style_lifecycle-map__1YqE4 li.style_phase__sK0_L{padding-left:0}", ""]);

// exports
exports.locals = {
	"lifecycle-map": "style_lifecycle-map__1YqE4",
	"lifecycleMap": "style_lifecycle-map__1YqE4",
	"phase": "style_phase__sK0_L",
	"phase-name": "style_phase-name__UOlFy",
	"phaseName": "style_phase-name__UOlFy",
	"target": "style_target__3FUvu"
};

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_phase-icon__UXMYG{box-sizing:border-box;background:#9e9e9e;width:1rem;height:1rem;display:inline-flex;vertical-align:top;margin-right:.5rem;align-items:center;justify-content:center;color:#fff;border-radius:.125rem}.style_phase-icon-before__5-17V{font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_optional__3mVRg{background:linear-gradient(90deg,#9e9e9e 50%,#fff 0);border:.0625rem solid #9e9e9e}.style_phase-icon__UXMYG.style_blocked__1mQZu{background:#fff!important;border:.0625rem solid #333}.style_phase-icon__UXMYG.style_blocked__1mQZu:after{content:\"\";width:.625rem;height:.625rem;background:#db4437;position:relative;display:inline-block}.style_phase-icon__UXMYG.style_blocked__1mQZu:before{display:none}.style_phase-icon__UXMYG.style_current__7QBG1{background:#2f93e0;border:none}.style_phase-icon__UXMYG.style_current__7QBG1:before{content:\"\\F061\";padding-bottom:.125rem;font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_complete__1UGTu{background:#48b350}.style_phase-icon__UXMYG.style_complete__1UGTu:before{content:\"\\F00C\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_deployed__PtPiA{background:#48b350}.style_phase-icon__UXMYG.style_deployed__PtPiA:before{content:\"\\F00C\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_automatic__1d9gs{background:#fb8c00}.style_phase-icon__UXMYG.style_automatic__1d9gs:before{content:\"\\F0E7\";padding-left:.125rem;font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_queued__1kcdt{background:#0878d1}.style_phase-icon__UXMYG.style_queued__1kcdt:before{content:\"\\F017\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_warning__380pO{background:#48b350}.style_phase-icon__UXMYG.style_warning__380pO:before{content:\"\\F071\";font-family:FontAwesome;font-size:.625rem;position:relative}.style_phase-icon__UXMYG.style_skipped__1hLQB{width:1rem;height:1rem;background:#ccc;border:.125rem dashed #9e9e9e}", ""]);

// exports
exports.locals = {
	"phase-icon": "style_phase-icon__UXMYG",
	"phaseIcon": "style_phase-icon__UXMYG",
	"phase-icon-before": "style_phase-icon-before__5-17V",
	"phaseIconBefore": "style_phase-icon-before__5-17V",
	"optional": "style_optional__3mVRg",
	"blocked": "style_blocked__1mQZu",
	"current": "style_current__7QBG1",
	"complete": "style_complete__1UGTu",
	"deployed": "style_deployed__PtPiA",
	"automatic": "style_automatic__1d9gs",
	"queued": "style_queued__1kcdt",
	"warning": "style_warning__380pO",
	"skipped": "style_skipped__1hLQB"
};

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(1828);
var ExecutingIcon = function () {
    return React.createElement("div", { className: styles.outer },
        React.createElement("div", { className: styles.border },
            React.createElement("div", { className: styles.wrapper },
                React.createElement("div", { className: cn(styles.pie, styles.spinner) }),
                React.createElement("div", { className: cn(styles.pie, styles.filler1) }),
                React.createElement("div", { className: cn(styles.pie, styles.filler2) }),
                React.createElement("div", { className: styles.mask1 }),
                React.createElement("div", { className: styles.mask2 }))));
};
exports.default = ExecutingIcon;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PhaseStatusIcon\\ExecutingIcon.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\PhaseStatusIcon\\ExecutingIcon.tsx"); } } })();

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1829);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./executingStyle.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./executingStyle.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "*{box-sizing:border-box}.executingStyle_outer__2d-m8{display:inline-block;background:#0878d1;width:.875rem;height:.875rem;padding:.0625rem;vertical-align:top;margin-right:.5rem;margin-top:.0625rem}.executingStyle_border__13jj5{background:#0878d1;width:.75rem;height:.75rem;border:.0625rem solid #fff;border-radius:50%;padding:.0625rem}.executingStyle_wrapper__17eop{width:.5rem;height:.5rem;position:relative;background:#0878d1;border-radius:50%}.executingStyle_pie__3CDat{width:50%;height:100%;transform-origin:100% 50%;position:absolute;background:#fff}.executingStyle_spinner__1Omhr{border-radius:.25rem 0 0 .25rem;z-index:200;border-right:none;animation:executingStyle_rota__2wuej 5s linear infinite}.executingStyle_filler1__1cEbx{border-radius:0 .25rem .25rem 0;left:50%;opacity:0;z-index:100;animation:executingStyle_fill1__2_QXK 5s steps(1) infinite;border-left:none}.executingStyle_filler2___mQXq{border-radius:.25rem 0 0 .25rem;opacity:1;z-index:100;animation:executingStyle_fill2__5AU_J 5s steps(1) infinite;border-left:none}.executingStyle_mask1__26Pin{border-radius:.25rem 0 0 .25rem;animation:executingStyle_mask1__26Pin 5s steps(1) infinite}.executingStyle_mask1__26Pin,.executingStyle_mask2__3tLqT{width:50%;height:100%;position:absolute;background:inherit;opacity:1;z-index:300}.executingStyle_mask2__3tLqT{border-radius:0 .25rem .25rem 0;left:50%;animation:executingStyle_mask2__3tLqT 5s steps(1) infinite}@keyframes executingStyle_rota__2wuej{0%{transform:rotate(0deg)}50%{transform:rotate(1turn)}50.01%{transform:rotate(180deg)}to{transform:rotate(540deg)}}@keyframes executingStyle_mask1__26Pin{0%{opacity:1}25%,to{opacity:0}}@keyframes executingStyle_mask2__3tLqT{0%{opacity:0}75%,to{opacity:1}}@keyframes executingStyle_fill1__2_QXK{0%{opacity:0}25%,50%{opacity:1}50.01%,to{opacity:0}}@keyframes executingStyle_fill2__5AU_J{0%{opacity:0}50%,75%{opacity:1}75.01%,to{opacity:0}}", ""]);

// exports
exports.locals = {
	"outer": "executingStyle_outer__2d-m8",
	"border": "executingStyle_border__13jj5",
	"wrapper": "executingStyle_wrapper__17eop",
	"pie": "executingStyle_pie__3CDat",
	"spinner": "executingStyle_spinner__1Omhr",
	"rota": "executingStyle_rota__2wuej",
	"filler1": "executingStyle_filler1__1cEbx",
	"fill1": "executingStyle_fill1__2_QXK",
	"filler2": "executingStyle_filler2___mQXq",
	"fill2": "executingStyle_fill2__5AU_J",
	"mask1": "executingStyle_mask1__26Pin",
	"mask2": "executingStyle_mask2__3tLqT"
};

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1831);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_textContainer__qxe7b{position:relative;display:flex;align-items:flex-end}.style_iconContainer__1baDV{position:absolute;right:0;cursor:pointer;margin:.5625rem;top:18px}.style_autoCompleteContainer__3JypX{width:100%}.style_popover__smxSz>div,.style_popoverContent__3lIcb{overflow-x:hidden}.style_popoverInfoText__2oEe8{margin:1rem}.style_warning__3Z_HM{margin:.5rem 1rem;color:#fb8c00;font-size:.75rem}.style_buttons__30ybd{padding-bottom:.5rem}", ""]);

// exports
exports.locals = {
	"textContainer": "style_textContainer__qxe7b",
	"iconContainer": "style_iconContainer__1baDV",
	"autoCompleteContainer": "style_autoCompleteContainer__3JypX",
	"popover": "style_popover__smxSz",
	"popoverContent": "style_popoverContent__3lIcb",
	"popoverInfoText": "style_popoverInfoText__2oEe8",
	"warning": "style_warning__3Z_HM",
	"buttons": "style_buttons__30ybd"
};

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TenantFilterButton_1 = __webpack_require__(1833);
exports.default = TenantFilterButton_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\index.tsx"); } } })();

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(47);
var TenantTagDesignDialogLayout_1 = __webpack_require__(1834);
var OpenDialogButton_1 = __webpack_require__(72);
var TenantFilterButton = (function (_super) {
    __extends(TenantFilterButton, _super);
    function TenantFilterButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantFilterButton.prototype.render = function () {
        return React.createElement(OpenDialogButton_1.default, { label: "Tenant Preview", type: Button_1.ActionButtonType.Ternary, wideDialog: true },
            React.createElement(TenantTagDesignDialogLayout_1.default, { hideTenantsByName: !this.props.showTenants, availableTenants: this.props.availableTenants, selectedTenants: this.props.selectedTenants, onUpdate: this.props.onUpdate, selectedTags: this.props.selectedTags }));
    };
    return TenantFilterButton;
}(React.Component));
exports.default = TenantFilterButton;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\TenantFilterButton.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\TenantFilterButton.tsx"); } } })();

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MultiSelect_1 = __webpack_require__(75);
var clientInstance_1 = __webpack_require__(10);
var tenantTagsets = __webpack_require__(156);
var TextField_1 = __webpack_require__(182);
var Checkbox_1 = __webpack_require__(121);
var Table_1 = __webpack_require__(633);
var TenantTagsList_1 = __webpack_require__(321);
var index_1 = __webpack_require__(74);
var TagsList_1 = __webpack_require__(482);
var styles = __webpack_require__(1835);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var TenantTagDesignDialogLayout = (function (_super) {
    __extends(TenantTagDesignDialogLayout, _super);
    function TenantTagDesignDialogLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.tagChanged = function (tags) {
            _this.setState({ selectedTags: tags }, function () { return _this.runTagTest(); });
        };
        _this.tenantChanged = function (tags) {
            _this.setState({ selectedTenants: tags }, function () { return _this.runTagTest(); });
        };
        _this.state = {
            selectedTags: _this.props.selectedTags || [],
            selectedTenants: _this.props.selectedTenants || [],
            matchCount: 0,
            allTenants: undefined,
            allTags: undefined,
            tagIndex: null,
            matchResults: [],
            searchText: "",
            onlyShowMatching: true,
            tenantIndex: {}
        };
        return _this;
    }
    TenantTagDesignDialogLayout.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a, allTenants, allTags, tagIndex, tenantIndex, availableTenants;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([clientInstance_1.repository.Tenants.all(), tenantTagsets.getAll(), tenantTagsets.getTagIndex()])];
                    case 1:
                        _a = _b.sent(), allTenants = _a[0], allTags = _a[1], tagIndex = _a[2];
                        tenantIndex = allTenants.reduce(function (idx, item) { idx[item.Id] = item; return idx; }, {});
                        availableTenants = allTenants;
                        if (this.props.availableTenants) {
                            availableTenants = allTenants.filter(function (t) { return _this.props.availableTenants.indexOf(t.Id) !== -1; });
                        }
                        this.setState({ allTenants: availableTenants, allTags: allTags, tenantIndex: tenantIndex, tagIndex: tagIndex }, function () { return _this.runTagTest(); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagDesignDialogLayout.prototype.runTagTest = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var result, matchCount, matchResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Tenants.tagTest(this.state.selectedTenants, this.state.selectedTags)];
                    case 1:
                        result = _a.sent();
                        matchCount = 0;
                        matchResults = Object.keys(result).map(function (tenantId) {
                            var tenantTestResult = result[tenantId];
                            var tenant = _this.state.tenantIndex[tenantId];
                            var isAvailable = !_this.props.availableTenants || _this.props.availableTenants.indexOf(tenantId) !== -1;
                            var isMatch = tenantTestResult.IsMatched && isAvailable;
                            if (isMatch) {
                                matchCount++;
                            }
                            var matchedTags = tenant.TenantTags.filter(function (tag) { return _this.state.selectedTags.indexOf(tag) !== -1; });
                            return {
                                id: tenantId,
                                name: tenant.Name,
                                reason: isAvailable ? tenantTestResult.Reason : "Tenant not available in this context",
                                missingTags: tenantTestResult.MissingTags,
                                isMatchedByName: _this.state.selectedTenants.indexOf(tenantId) !== -1,
                                matchedTags: matchedTags,
                                isMatched: isMatch
                            };
                        }).sort(function (resultA, resultB) {
                            if (resultA.isMatched && !resultB.isMatched) {
                                return -1;
                            }
                            else if (!resultA.isMatched && resultB.isMatched) {
                                return 1;
                            }
                            if (resultA.name < resultB.name) {
                                return -1;
                            }
                            else if (resultA.name > resultB.name) {
                                return 1;
                            }
                            else {
                                return 0;
                            }
                        });
                        this.setState({ matchCount: matchCount, matchResults: matchResults });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    TenantTagDesignDialogLayout.prototype.render = function () {
        var _this = this;
        if (!this.state.allTenants) {
            return null;
        }
        var searchText = this.state.searchText.toLowerCase();
        return React.createElement(OkDialogLayout_1.default, { title: "Tenant Preview", errors: this.state.errors, busy: this.state.busy, onOkClick: function () {
                _this.props.onUpdate(_this.state.selectedTenants, _this.state.selectedTags);
                return true;
            } },
            React.createElement("div", null,
                !this.props.hideTenantsByName && React.createElement("h3", null, "Include tenants by name"),
                !this.props.hideTenantsByName && React.createElement(MultiSelect_1.TenantMultiSelect, { onChange: this.tenantChanged, value: this.state.selectedTenants, items: this.state.allTenants }),
                React.createElement("h3", null, "Include tenants by tags"),
                React.createElement(MultiSelect_1.TenantTagMultiSelect, { onChange: this.tagChanged, value: this.state.selectedTags, doBusyTask: this.doBusyTask, items: this.state.allTags }),
                React.createElement("div", { className: styles.previewHeader },
                    React.createElement("h3", { className: styles.previewTitle },
                        "Preview - ",
                        this.state.matchCount,
                        " matching tenant",
                        this.state.matchCount === 1 ? "" : "s"),
                    React.createElement("div", null,
                        React.createElement(TextField_1.default, { hintText: "Filter results...", value: this.state.searchText, onChange: function (e) { return _this.setState({ searchText: e.target.value }); }, className: styles.previewFilter }),
                        React.createElement(Checkbox_1.default, { label: "Only show matching", value: this.state.onlyShowMatching, onChange: function (e) { return _this.setState({ onlyShowMatching: !_this.state.onlyShowMatching }); } })))),
            React.createElement("div", null,
                React.createElement(Table_1.Table, { selectable: false, multiSelectable: false },
                    React.createElement(Table_1.TableBody, { displayRowCheckbox: false, deselectOnClickaway: false }, this.state.matchResults
                        .filter(function (t) { return (t.isMatched || !_this.state.onlyShowMatching) &&
                        (_this.state.searchText.length < 1 || t.name.toLowerCase().includes(searchText)); })
                        .map(function (row, index) { return (React.createElement(Table_1.TableRow, { key: index },
                        React.createElement(Table_1.TableRowColumn, null, (row.isMatched) && React.createElement("em", { className: "fa fa-check" })),
                        React.createElement(Table_1.TableRowColumn, null, row.name),
                        React.createElement(Table_1.TableRowColumn, { style: { overflow: "visible" } }, _this.renderReason(row)))); })))));
    };
    TenantTagDesignDialogLayout.prototype.renderReason = function (match) {
        if (match.isMatchedByName) {
            return null;
        }
        if (match.isMatched) {
            return React.createElement(TagsList_1.default, { canonicalNames: match.matchedTags, tagIndex: this.state.tagIndex });
        }
        var content = match.reason === "Missing Tags" ?
            React.createElement("div", null,
                React.createElement("div", null, "Missing Tags"),
                React.createElement(TenantTagsList_1.default, { tags: match.missingTags })) : match.reason;
        return content && React.createElement(index_1.default, { content: content },
            React.createElement("em", { className: "fa fa-info-circle" }));
    };
    return TenantTagDesignDialogLayout;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = TenantTagDesignDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\TenantTagDesignDialogLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TenantTagDesignDialog\\TenantTagDesignDialogLayout.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1836);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_previewHeader__29Ste{display:flex;flex-direction:row;align-items:center;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"previewHeader": "style_previewHeader__29Ste"
};

/***/ }),
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(33);
var react_dnd_1 = __webpack_require__(454);
var styles = __webpack_require__(1902);
// Inspired :) by https://github.com/react-dnd/react-dnd/tree/master/examples/04%20Sortable/Simple
var source = {
    beginDrag: function (props) {
        return {
            id: props.id,
            index: props.index,
        };
    },
};
var target = {
    hover: function (props, monitor, component) {
        var dragIndex = monitor.getItem().index;
        var hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }
        // Determine rectangle on screen
        var hoverBoundingRect = react_dom_1.findDOMNode(component).getBoundingClientRect();
        // Get vertical middle
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        var clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }
        // Time to actually perform the action
        props.onItemMoved(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};
var DropTargetInstance = react_dnd_1.DropTarget("SortableItem", target, function (connect) { return ({
    connectDropTarget: connect.dropTarget()
}); });
var DragSourceInstance = react_dnd_1.DragSource("SortableItem", source, function (connect, monitor) { return ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}); });
var SortableItem = (function (_super) {
    __extends(SortableItem, _super);
    function SortableItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortableItem.prototype.render = function () {
        var _a = this.props, name = _a.name, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget;
        var opacity = isDragging ? 0 : 1;
        return connectDragSource(connectDropTarget(React.createElement("div", { className: styles.sortableItem, style: { opacity: opacity } },
            React.createElement("em", { className: "fa fa-sort" }),
            React.createElement("span", { className: styles.name }, name))));
    };
    return SortableItem;
}(React.Component));
exports.default = DropTargetInstance(DragSourceInstance(SortableItem));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SortableList\\SortableItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SortableList\\SortableItem.tsx"); } } })();

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1903);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_sortableItem__1BSoO{border:.0625rem solid #ccc;padding:.5rem 1rem;margin-bottom:.5rem;background-color:hsla(0,0%,60%,.08);cursor:move;color:#000}.style_name__-RgrS{padding-left:1rem}", ""]);

// exports
exports.locals = {
	"sortableItem": "style_sortableItem__1BSoO",
	"name": "style_name__-RgrS"
};

/***/ }),
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1909);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./confirmationDialog.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./confirmationDialog.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".confirmationDialog_dialogHeader__3Axs1{background:#fcf1e2}.confirmationDialog_warningIcon__1WYSq{color:#fb8c00}", ""]);

// exports
exports.locals = {
	"dialogHeader": "confirmationDialog_dialogHeader__3Axs1",
	"warningIcon": "confirmationDialog_warningIcon__1WYSq"
};

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_linkableItem__2Jc-m{cursor:pointer}", ""]);

// exports
exports.locals = {
	"linkableItem": "style_linkableItem__2Jc-m"
};

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1913);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".styles_codeEditorContainer__ZhfWq{position:relative;height:15rem;border:.0625rem solid #ccc}.styles_codeEditorContainerFullScreen__3zcZN{position:fixed;top:0;bottom:0;left:0;right:0;width:auto;height:auto;z-index:999;background:#fff}.styles_enterFullScreen__3y4A-{position:relative;text-align:right;float:right;padding-right:1.25rem;z-index:9}.styles_exitFullScreen__1unSG{text-align:right;position:absolute;z-index:2;top:0;right:0;left:0;padding:.5rem}", ""]);

// exports
exports.locals = {
	"codeEditorContainer": "styles_codeEditorContainer__ZhfWq",
	"codeEditorContainerFullScreen": "styles_codeEditorContainerFullScreen__3zcZN",
	"enterFullScreen": "styles_enterFullScreen__3y4A-",
	"exitFullScreen": "styles_exitFullScreen__1unSG"
};

/***/ }),
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1918);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./codeMirror.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./codeMirror.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports
exports.i(__webpack_require__(1919), "");
exports.i(__webpack_require__(1920), "");

// module
exports.push([module.i, ".CodeMirror{height:inherit;font-family:Consolas,Menlo,Monaco,Courier New,monospace;font-size:1rem}.CodeMirror-fullscreen{top:1.875rem}.ReactCodeMirror{height:100%;top:0;bottom:0;left:0;right:0;position:absolute;font-size:1rem}", ""]);

// exports


/***/ }),
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1935);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".styles_pageDivider__MsBlZ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;margin-right:1rem;font-size:1.0625rem}", ""]);

// exports
exports.locals = {
	"pageDivider": "styles_pageDivider__MsBlZ"
};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ToolTip_1 = __webpack_require__(74);
var Onboarding_1 = __webpack_require__(1937);
var resources_1 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var PaperLayout_1 = __webpack_require__(154);
var specialVariables_1 = __webpack_require__(189);
var DeploymentPart_1 = __webpack_require__(1940);
var Roles_1 = __webpack_require__(37);
var pluginRegistry_1 = __webpack_require__(18);
var NavigationButton_1 = __webpack_require__(197);
var SideBar_1 = __webpack_require__(1943);
var ActionButton_1 = __webpack_require__(49);
var ActionList_1 = __webpack_require__(303);
var DeploymentPartSorter_1 = __webpack_require__(1946);
var OverflowMenu_1 = __webpack_require__(152);
var SelectParentStep_1 = __webpack_require__(1947);
var DataBaseComponent_1 = __webpack_require__(39);
var libraryVariableSetResource_1 = __webpack_require__(461);
var lodash_1 = __webpack_require__(11);
var tenantTagsets = __webpack_require__(156);
var OpenDialogButton_1 = __webpack_require__(72);
var material_ui_1 = __webpack_require__(101);
var colors_1 = __webpack_require__(31);
var SvgIcon_1 = __webpack_require__(23);
var SidebarLayout_1 = __webpack_require__(448);
var projectsArea_1 = __webpack_require__(243);
var react_redux_1 = __webpack_require__(64);
var routeLinks_1 = __webpack_require__(22);
var permission_1 = __webpack_require__(51);
var PermissionCheck_1 = __webpack_require__(42);
var getActionLogoUrl_1 = __webpack_require__(498);
var styles = __webpack_require__(190);
var InternalRedirect_1 = __webpack_require__(45);
var rollingStep = __webpack_require__(735);
var ParallelIcon = function () { return React.createElement(SvgIcon_1.default, { color: "#9E9E9E", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M14.91466 15.012048V12L20 16l-5.08534 4v-3.012048H4v-1.975904M14.91466 7.012048V4L20 8l-5.08534 4V8.987952H4V7.012048" })); };
var Divider = function (props) {
    if (!props.parallel) {
        return React.createElement(material_ui_1.Divider, { style: { backgroundColor: colors_1.divider, height: 1, width: "100%" } });
    }
    return React.createElement("div", { className: styles.divider },
        React.createElement(material_ui_1.Divider, { style: { width: 20, backgroundColor: colors_1.divider, height: 1 } }),
        React.createElement(ToolTip_1.default, { content: "run in parallel" },
            React.createElement(ParallelIcon, null)),
        React.createElement(material_ui_1.Divider, { style: { backgroundColor: colors_1.divider, height: 1, width: "100%" } }));
};
var DeploymentProcessOverviewInternal = (function (_super) {
    __extends(DeploymentProcessOverviewInternal, _super);
    function DeploymentProcessOverviewInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return _this.loadData(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.canBeChildStep = function (step) { return step.Actions.every(function (action) { return pluginRegistry_1.default.getDeploymentAction(action.ActionType).canBeChild; }); };
        _this.state = {
            deploymentProcess: null,
            redirectTo: null,
            project: null,
            open: false,
            isLoaded: false,
            selectedParentStepId: null,
            includedScriptModules: null,
            lifecyclePreview: null,
            tagIndex: null,
            wokerPoolsById: null,
        };
        return _this;
    }
    DeploymentProcessOverviewInternal.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var project, _a, deploymentProcess, scriptModules, environmentsById, lifecycle, channels, tagIndex, wokerPools, lifecyclePreview, _b, channelsById, wokerPoolsById, includedScriptModules;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.match.params.projectSlug)];
                    case 1:
                        project = _c.sent();
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.DeploymentProcesses.get(project.DeploymentProcessId),
                                PermissionCheck_1.isAllowed({ permission: permission_1.default.LibraryVariableSetView }) ? clientInstance_1.repository.LibraryVariableSets.all({ contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule }) : [],
                                clientInstance_1.repository.Environments.allById(),
                                PermissionCheck_1.isAllowed({ permission: permission_1.default.LifecycleView }) ? clientInstance_1.repository.Lifecycles.get(project.LifecycleId) : null,
                                clientInstance_1.repository.Projects.getChannels(project),
                                tenantTagsets.getTagIndex(),
                                clientInstance_1.repository.WorkerPools.all()
                            ])];
                    case 2:
                        _a = _c.sent(), deploymentProcess = _a[0], scriptModules = _a[1], environmentsById = _a[2], lifecycle = _a[3], channels = _a[4], tagIndex = _a[5], wokerPools = _a[6];
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.default.LifecycleView })) return [3 /*break*/, 4];
                        return [4 /*yield*/, clientInstance_1.repository.Lifecycles.preview(lifecycle)];
                    case 3:
                        _b = _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _b = null;
                        _c.label = 5;
                    case 5:
                        lifecyclePreview = _b;
                        channelsById = lodash_1.keyBy(channels.Items, function (ch) { return ch.Id; });
                        wokerPoolsById = lodash_1.keyBy(wokerPools, function (wp) { return wp.Id; });
                        includedScriptModules = scriptModules.filter(function (sm) { return project.IncludedLibraryVariableSetIds.includes(sm.Id); });
                        this.setState({
                            deploymentProcess: deploymentProcess,
                            environmentsById: environmentsById,
                            project: project,
                            includedScriptModules: includedScriptModules,
                            lifecyclePreview: lifecyclePreview,
                            channelsById: channelsById,
                            tagIndex: tagIndex,
                            wokerPoolsById: wokerPoolsById,
                            isLoaded: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return _this.loadData(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: true });
        }
        var actions = [];
        if (this.state.isLoaded) {
            if (this.state.deploymentProcess.Steps && this.state.deploymentProcess.Steps.length > 1) {
                actions.push(this.reorderStepsButton());
            }
            actions.push(this.addStepButton());
            actions.push(React.createElement(OverflowMenu_1.default, { menuItems: [
                    OverflowMenu_1.default.downloadItem("Download as JSON", this.state.project.Slug + "-process.json", clientInstance_1.client.resolveLinkTemplate("DeploymentProcesses", { id: this.state.deploymentProcess.Id })),
                    [OverflowMenu_1.default.navItem("Audit Trail", routeLinks_1.default.configuration.eventsRegardingAny([this.state.deploymentProcess.Id]), null, {
                            permission: permission_1.default.AuditView,
                        })]
                ] }));
        }
        return React.createElement(PaperLayout_1.default, { busy: this.state.busy, errors: this.state.errors, title: "Process", sectionControl: this.state.isLoaded &&
                React.createElement(ActionList_1.default, { actions: actions }) }, this.state.isLoaded &&
            React.createElement(SidebarLayout_1.default, { sideBar: React.createElement(SideBar_1.default, { deploymentProcess: this.state.deploymentProcess, includedScriptModules: this.state.includedScriptModules, lifecyclePreview: this.state.lifecyclePreview, environmentsById: this.state.environmentsById, onDataChanged: function () { return _this.refreshData(); } }) },
                React.createElement("div", null,
                    this.state.deploymentProcess.Steps.length === 0 && React.createElement(Onboarding_1.default, null),
                    React.createElement("div", { className: styles.steps }, this.state.deploymentProcess.Steps.map(function (step, index) { return step.Actions.length === 1 ?
                        _this.buildAction(step, step.Actions[0], index + 1) :
                        _this.buildStep(step, index + 1); })))));
    };
    DeploymentProcessOverviewInternal.prototype.reorderStepsButton = function () {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
            React.createElement(OpenDialogButton_1.default, { label: "Reorder steps", type: ActionButton_1.ActionButtonType.Secondary },
                React.createElement(DeploymentPartSorter_1.default, { title: "Reorder Steps", deploymentProcessId: this.state.project.DeploymentProcessId, saveDone: this.refreshData })));
    };
    DeploymentProcessOverviewInternal.prototype.addStepButton = function () {
        return React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
            React.createElement(NavigationButton_1.NavigationButton, { type: NavigationButton_1.NavigationButtonType.Primary, label: "Add Step", href: routeLinks_1.default.project(this.state.project).steptemplates }));
    };
    DeploymentProcessOverviewInternal.prototype.buildStep = function (step, stepIndex) {
        var _this = this;
        var allActionsOnThisStepAreDisabled = step.Actions && step.Actions.every(function (action) { return !!action.IsDisabled; });
        return React.createElement("div", { key: step.Id },
            stepIndex > 1 && React.createElement(Divider, { parallel: step.StartTrigger === resources_1.StartTrigger.StartWithPrevious }),
            React.createElement(DeploymentPart_1.default, { name: step.Name, logoUrl: rollingStep, index: stepIndex + ".", detailsUrl: this.calculateDetailsUrl(step.Id), menuItems: this.getOverflowMenuItems(step), isDisabled: allActionsOnThisStepAreDisabled, mainAction: React.createElement(PermissionCheck_1.default, { permission: permission_1.default.ProcessEdit, project: this.state.project.Id },
                    React.createElement(NavigationButton_1.NavigationButton, { type: NavigationButton_1.NavigationButtonType.Secondary, label: "Add Child Step", href: this.addChildStepUrl(step) })) },
                step.Properties[specialVariables_1.default.Action.MaxParallelism] ? React.createElement("span", null, "Rolling deployment") :
                    React.createElement("span", null, "Multi-step deployment"),
                " ",
                "across deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: step.Properties[specialVariables_1.default.Action.TargetRoles] })),
            React.createElement("div", { className: styles.actions }, step.Actions.map(function (action, index) { return _this.buildAction(step, action, index + 1, stepIndex); })));
    };
    DeploymentProcessOverviewInternal.prototype.buildAction = function (step, action, actionIndex, stepIndex) {
        var _this = this;
        var isChildAction = !!stepIndex;
        var environmentsUserCanAccess = function (environments) {
            return environments.filter(function (e) { return Object.keys(_this.state.environmentsById).includes(e); });
        };
        return React.createElement("div", { key: action.Id },
            (stepIndex || actionIndex > 1) && React.createElement(Divider, { parallel: isChildAction === false && step.StartTrigger === resources_1.StartTrigger.StartWithPrevious }),
            React.createElement(DeploymentPart_1.default, { name: action.Name, logoUrl: getActionLogoUrl_1.default(action), environments: environmentsUserCanAccess(action.Environments).map(function (id) { return _this.state.environmentsById[id]; }), excludedEnvironments: environmentsUserCanAccess(action.ExcludedEnvironments).map(function (id) { return _this.state.environmentsById[id]; }), channels: action.Channels.map(function (id) { return _this.state.channelsById[id]; }), tags: this.getTags(action), index: stepIndex ? stepIndex + "." + actionIndex + "." : actionIndex + ".", isDisabled: action.IsDisabled, detailsUrl: this.calculateDetailsUrl(action.Id), menuItems: this.getOverflowMenuItems(step, action, isChildAction) }, pluginRegistry_1.default.getDeploymentAction(action.ActionType)
                .summary(action.Properties, isChildAction ? null : step.Properties[specialVariables_1.default.Action.TargetRoles], action.Packages, action.WorkerPoolId ? this.state.wokerPoolsById[action.WorkerPoolId].Name : null)));
    };
    DeploymentProcessOverviewInternal.prototype.getOverflowMenuItems = function (step, action, isChildAction) {
        var _this = this;
        var menuItems = [];
        var processEditPermission = { permission: permission_1.default.ProcessEdit, project: this.state.project.Id };
        var canEdit = PermissionCheck_1.isAllowed(processEditPermission);
        menuItems.push(OverflowMenu_1.default.navItem(canEdit ? "Edit" : "View Details", this.calculateDetailsUrl(action ? action.Id : step.Id)));
        if (!isChildAction) {
            if (!this.canHaveChildren(step)) {
                menuItems.push(OverflowMenu_1.default.disabledItem("Add child step", "This step type does not support child steps"));
            }
            else {
                menuItems.push(OverflowMenu_1.default.navItem("Add child step", this.addChildStepUrl(step), null, processEditPermission));
            }
        }
        if (action) {
            menuItems.push(OverflowMenu_1.default.item(action.IsDisabled ? "Enable" : "Disable", function () { return action.IsDisabled ? _this.enable(action) : _this.disable(action); }, processEditPermission));
        }
        if (!action && this.canHaveChildren(step)) {
            menuItems.push(OverflowMenu_1.default.item("Enable all", function () { return _this.enableAll(step); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.item("Disable all", function () { return _this.disableAll(step); }, processEditPermission));
        }
        if (isChildAction) {
            menuItems.push(OverflowMenu_1.default.item("Move out", function () { return _this.moveOut(step, action); }, processEditPermission));
        }
        if (action) {
            if (!this.canMoveIn(step.Id)) {
                menuItems.push(OverflowMenu_1.default.disabledItem("Move into...", "No steps available that can have children or this step type cannot be a child step."));
            }
            else {
                var stepsToMoveInto = this.state.deploymentProcess.Steps.filter(function (s) { return s.Id !== step.Id && _this.canHaveChildren(s); });
                var selectParentStep = React.createElement(SelectParentStep_1.default, { steps: stepsToMoveInto, actionName: action.Name, currentlyTargetedRoles: step.Properties[specialVariables_1.default.Action.TargetRoles], onStepSelected: function (parentStepId) { return _this.moveIn(step, action, parentStepId); } });
                menuItems.push(OverflowMenu_1.default.dialogItem("Move into...", selectParentStep, processEditPermission));
            }
        }
        if (action) {
            menuItems.push(OverflowMenu_1.default.item("Clone", function () { return _this.cloneStep(step, action); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.deleteItemDefault("step", function () { return _this.deleteStep(step, action); }, processEditPermission));
        }
        else {
            menuItems.push(OverflowMenu_1.default.item("Clone", function () { return _this.cloneStep(step); }, processEditPermission));
            menuItems.push(OverflowMenu_1.default.deleteItemDefault("parent step", function () { return _this.deleteStep(step); }, processEditPermission));
        }
        if (!action) {
            menuItems.push(OverflowMenu_1.default.dialogItem("Reorder child steps", React.createElement(DeploymentPartSorter_1.default, { deploymentProcessId: this.state.project.DeploymentProcessId, title: "Reorder child steps", stepId: step.Id, saveDone: this.refreshData }), processEditPermission));
        }
        return menuItems;
    };
    DeploymentProcessOverviewInternal.prototype.deleteStep = function (step, action) {
        return __awaiter(this, void 0, void 0, function () {
            var deleteStep, actionIndex, stepIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteStep = false;
                        if (action) {
                            actionIndex = step.Actions.indexOf(action);
                            step.Actions.splice(actionIndex, 1);
                            deleteStep = step.Actions.length === 0;
                        }
                        else {
                            deleteStep = true;
                        }
                        if (deleteStep) {
                            stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
                            this.state.deploymentProcess.Steps.splice(stepIndex, 1);
                        }
                        else {
                            if (step.Actions.length === 1) {
                                step.Name = step.Actions[0].Name;
                            }
                        }
                        return [4 /*yield*/, this.saveChanges()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.canHaveChildren = function (step) {
        return step.Actions.filter(function (a) {
            var actionDefinition = pluginRegistry_1.default.getDeploymentAction(a.ActionType);
            return actionDefinition.canHaveChildren(step);
        }).length > 0;
    };
    DeploymentProcessOverviewInternal.prototype.disableAll = function (step) {
        step.Actions.forEach(function (a) { return a.IsDisabled = true; });
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.enableAll = function (step) {
        step.Actions.forEach(function (a) { return a.IsDisabled = false; });
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.moveOut = function (step, action) {
        var newStep = {
            Id: null,
            Name: action.Name,
            PackageRequirement: step.PackageRequirement,
            Properties: step.Properties,
            Condition: step.Condition,
            StartTrigger: step.StartTrigger,
            Actions: [
                action
            ]
        };
        var name = newStep.Name;
        var i = 1;
        var isStep = function (s) { return s.Name === newStep.Name; };
        while (true) {
            if (!this.state.deploymentProcess.Steps.some(isStep)) {
                break;
            }
            newStep.Name = name + " " + i;
            i++;
        }
        var actionIndex = step.Actions.indexOf(action);
        step.Actions.splice(actionIndex, 1);
        if (step.Actions.length === 1) {
            step.Name = step.Actions[0].Name;
        }
        var stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
        this.state.deploymentProcess.Steps.splice(stepIndex + 1, 0, newStep);
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.moveIn = function (step, action, parentStepId) {
        // Copy the action to the new step
        var newParent = this.state.deploymentProcess.Steps.find(function (s) { return s.Id === parentStepId; });
        newParent.Actions.splice(newParent.Actions.length, 0, action);
        // Remove action from the old step
        var actionIndex = step.Actions.indexOf(action);
        step.Actions.splice(actionIndex, 1);
        // Remove parent step if no actions left
        if (step.Actions.length === 0) {
            var stepIndex = this.state.deploymentProcess.Steps.indexOf(step);
            this.state.deploymentProcess.Steps.splice(stepIndex, 1);
        }
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.enable = function (action) {
        action.IsDisabled = false;
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.disable = function (action) {
        action.IsDisabled = true;
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.calculateDetailsUrl = function (id) {
        return routeLinks_1.default.project(this.state.project).process.step(id);
    };
    DeploymentProcessOverviewInternal.prototype.canMoveIn = function (stepId) {
        var _this = this;
        var currentStep = this.state.deploymentProcess.Steps.find(function (step) { return step.Id === stepId; });
        var isChildStep = this.canBeChildStep(currentStep);
        var hasParentStep = this.state.deploymentProcess.Steps.filter(function (step) { return step.Id !== stepId && _this.canHaveChildren(step); }).length > 0;
        return isChildStep && hasParentStep;
    };
    DeploymentProcessOverviewInternal.prototype.cloneStep = function (step, action) {
        var deploymentProcess = this.state.deploymentProcess;
        var nameOfActionExists = function (steps, actionName) {
            return steps.filter(function (s) { return s.Name === actionName || (s.Actions.filter(function (a) { return a.Name === actionName; }).length > 0); })
                .length > 0;
        };
        var getNewActionName = function (steps, clonedAction) {
            var suffix = "";
            var counter = 1;
            while (nameOfActionExists(steps, clonedAction.Name + suffix)) {
                suffix = " - clone (" + counter + ")";
                counter++;
            }
            return clonedAction.Name + suffix;
        };
        var stepNameExists = function (steps, stepName) {
            return steps.filter(function (s) { return s.Name === stepName; }).length > 0;
        };
        var getNewStepName = function (steps, clonedStep) {
            var suffix = "";
            var counter = 1;
            while (stepNameExists(steps, clonedStep.Name + suffix)) {
                suffix = " - clone (" + counter + ")";
                counter++;
            }
            return clonedStep.Name + suffix;
        };
        if (action && step.Actions.length > 1) {
            var clonedAction = JSON.parse(JSON.stringify(action));
            clonedAction.Id = "";
            clonedAction.Name = getNewActionName(deploymentProcess.Steps, clonedAction);
            var actionIndex = step.Actions.indexOf(action);
            step.Actions.splice(actionIndex + 1, 0, clonedAction);
        }
        else {
            var clonedStep_1 = JSON.parse(JSON.stringify(step));
            clonedStep_1.Id = "";
            clonedStep_1.Name = getNewStepName(deploymentProcess.Steps, clonedStep_1);
            clonedStep_1.Actions.forEach(function (a, index) {
                clonedStep_1.Actions[index].Id = "";
                clonedStep_1.Actions[index].Name = getNewActionName(deploymentProcess.Steps, clonedStep_1.Actions[index]);
            });
            var stepIndex = deploymentProcess.Steps.indexOf(step);
            var updatedSteps = deploymentProcess.Steps.splice(stepIndex + 1, 0, clonedStep_1);
        }
        this.saveChanges();
    };
    DeploymentProcessOverviewInternal.prototype.saveChanges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var succeess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(this.state.deploymentProcess)];
                                    case 1:
                                        result = _a.sent();
                                        this.props.onProjectStepsUpdated(result.Steps ? result.Steps.length : null);
                                        this.setState({ deploymentProcess: result });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        succeess = _a.sent();
                        if (!!succeess) return [3 /*break*/, 3];
                        // since our changes mutate this.state.deploymentProcess then save, if we fail reload
                        return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _a = this.setState;
                                            _b = {};
                                            return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.state.project.DeploymentProcessId)];
                                        case 1:
                                            _a.apply(this, [(_b.deploymentProcess = _c.sent(), _b)]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, false)];
                    case 2:
                        // since our changes mutate this.state.deploymentProcess then save, if we fail reload
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeploymentProcessOverviewInternal.prototype.getTags = function (action) {
        var _this = this;
        if (this.state.project.TenantedDeploymentMode === resources_1.TenantedDeploymentMode.Untenanted) {
            return [];
        }
        return action.TenantTags.map(function (name) { return _this.state.tagIndex[name]; });
    };
    DeploymentProcessOverviewInternal.prototype.addChildStepUrl = function (step) {
        return this.props.match.url + "/childsteptemplates/" + step.Id;
    };
    return DeploymentProcessOverviewInternal;
}(DataBaseComponent_1.DataBaseComponent));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var DeploymentProcessOverview = react_redux_1.connect(null, mapDispatchToProps)(DeploymentProcessOverviewInternal);
exports.default = DeploymentProcessOverview;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessOverview.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentProcessOverview.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(26);
var OnboardingPage_1 = __webpack_require__(764);
var Onboarding = function () {
    var panels = [
        {
            imageSrc: __webpack_require__(1938),
            imageWidth: 690,
            imageHeight: 345,
            imageAlt: "Built-in steps",
            description: React.createElement("div", null, "The Octopus built-in steps are powerful and flexible to handle the most common deployment scenarios, such as deploying an IIS Web Site or a Windows Service application.")
        },
        {
            imageSrc: __webpack_require__(1939),
            imageWidth: 690,
            imageHeight: 345,
            imageAlt: "Community steps",
            description: React.createElement("div", null, "Octopus Community Library integration makes it easy to find step templates that work with the frameworks and technologies you use without the need for custom scripting.")
        }
    ];
    return (React.createElement(OnboardingPage_1.default, { title: "Add steps to configure your deployment process", intro: "A deployment process specifies the steps to deploy an application, which allows you to deploy new versions consistently every time.", learnMore: React.createElement("p", null,
            "Learn more about ",
            React.createElement(ExternalLink_1.default, { href: "OnboardingAddStepsLearnMore" }, "adding steps"),
            "."), panels: panels }));
};
exports.default = Onboarding;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Onboarding.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Onboarding.tsx"); } } })();

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "onboarding-steps.941774be14e4bac947aec033f79c915a.hashedasset.svg";

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "onboarding-communitysteps.a1c361a0401543e867f7e6cea476c73c.hashedasset.svg";

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var Logo_1 = __webpack_require__(323);
var InternalLink_1 = __webpack_require__(238);
var ActionList_1 = __webpack_require__(303);
var OverflowMenu_1 = __webpack_require__(152);
var index_1 = __webpack_require__(24);
var Tag_1 = __webpack_require__(308);
var FeatureToggle_1 = __webpack_require__(249);
var uiTestClasses_1 = __webpack_require__(86);
var index_2 = __webpack_require__(24);
var cn = __webpack_require__(19);
var fontWeights_1 = __webpack_require__(83);
var styles = __webpack_require__(190);
var DeploymentPart = (function (_super) {
    __extends(DeploymentPart, _super);
    function DeploymentPart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeploymentPart.prototype.render = function () {
        return React.createElement("div", { className: styles.deploymentPart },
            React.createElement("div", { className: styles.actionSummary },
                React.createElement("div", { className: styles.logo },
                    React.createElement(Logo_1.default, { url: this.props.logoUrl, isDisabled: this.props.isDisabled })),
                React.createElement("div", { className: cn(styles.content, this.props.isDisabled ? styles.disabled : null) },
                    React.createElement("div", { className: styles.contentHeader },
                        React.createElement("span", { className: styles.index }, this.props.index),
                        React.createElement(InternalLink_1.default, { to: this.props.detailsUrl, size: 17 / fontWeights_1.baseSizeInPx }, this.props.isDisabled
                            ? React.createElement("span", { className: "" + uiTestClasses_1.deploymentPartNameClass },
                                this.props.name,
                                " ",
                                React.createElement(index_2.DisabledChip, null))
                            : React.createElement("span", { className: uiTestClasses_1.deploymentPartNameClass }, this.props.name))),
                    React.createElement("div", { className: styles.contentBody },
                        this.props.children,
                        React.createElement("div", null,
                            this.props.environments && this.props.environments.map(function (e) { return React.createElement(index_1.EnvironmentChip, { key: e.Id, environmentName: e.Name }); }),
                            this.props.excludedEnvironments &&
                                this.props.excludedEnvironments.map(function (e) { return React.createElement(index_1.EnvironmentChip, { key: e.Id, environmentName: e.Name, isExcluded: true }); }),
                            this.props.channels && this.props.channels.map(function (ch) { return React.createElement(index_1.ChannelChip, { key: ch.Id, channelName: ch.Name }); }),
                            React.createElement(FeatureToggle_1.default, { feature: FeatureToggle_1.Feature.MultiTenancy, enabled: true }, this.props.tags && this.props.tags.map(function (tag) { return React.createElement(Tag_1.default, { key: tag.Id, description: tag.Description, tagName: tag.Name, tagColor: tag.Color }); }))))),
                React.createElement("div", { className: styles.contextualActions },
                    React.createElement(ActionList_1.default, { actions: [
                            this.props.mainAction,
                            React.createElement(OverflowMenu_1.default, { key: this.props.name + "-overflow", menuKey: this.props.name + "-overflow", menuItems: this.props.menuItems })
                        ].filter(function (a) { return !!a; }) }))));
    };
    return DeploymentPart;
}(BaseComponent_1.default));
exports.default = DeploymentPart;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPart.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPart.tsx"); } } })();

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__OQ0gg{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__3WVtt{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1nJ-R{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3amf3{display:none!important}}.style_deploymentPart__140yQ{min-height:5.1rem}.style_divider__18wfT{display:flex;align-items:center}.style_actionSummary__2r_NW{display:flex;flex-flow:row;padding-top:.875rem;padding-bottom:.875rem}.style_disabled__2CF7p *{color:#9e9e9e}.style_logo__1vCvZ{order:1}.style_content__1oScE{flex:4 0;order:2;margin-left:1rem}.style_contextualActions__2EraV{order:3}.style_actions__10Lga{margin-left:4.1rem;padding-left:0}.style_steps__2n-iJ{padding-left:1rem}.style_index__259qL{margin-right:1rem;font-size:1.0625rem}.style_contentHeader__tW9Nq{margin-bottom:.5rem;font-weight:500}.style_contentBody__1TO-I{font-size:.875rem}.style_environment__32zrj{text-align:right;padding-bottom:.25rem}.style_scriptModulesStatus__DWWLJ{font-size:.875rem;margin:0}.style_includedScriptModules__27G1I{list-style:disc inside;color:#2f93e0}.style_lifeCycleName__1V_RW{font-size:1rem;font-weight:600}.style_scriptModuleDescription__3OBWJ{margin-left:2.5rem;margin-top:.5rem;margin-bottom:.5rem;font-size:.875rem}.style_noteList__26od2{list-style-type:disc;padding:0 1rem;max-width:36rem}.style_stepNumber__2wSBj{padding-right:1rem}.style_row__gYMwc{display:flex;flex-direction:row}.style_row__gYMwc .style_container__1TOUP{width:80%}.style_row__gYMwc .style_images__3aFYl{width:60%;align-items:center;text-align:center}.style_row__gYMwc .style_images__3aFYl img{height:5rem;width:auto;margin:.5rem 0}.style_row__gYMwc .style_images__3aFYl div{text-align:center}@media (max-width:79.9rem){.style_row__gYMwc .style_images__3aFYl div{text-align:left}}@media (max-width:79.9rem){.style_row__gYMwc .style_images__3aFYl{width:100%}}@media (max-width:79.9rem){.style_row__gYMwc{flex-direction:column}}.style_col__2BEoM{display:flex;flex-direction:column;align-items:flex-start}.style_col__2BEoM img{height:5rem;width:auto;margin:.5rem 0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__OQ0gg",
	"hideSm": "style_hide-sm__OQ0gg",
	"visible-sm": "style_visible-sm__3WVtt",
	"visibleSm": "style_visible-sm__3WVtt",
	"hide-md": "style_hide-md__1nJ-R",
	"hideMd": "style_hide-md__1nJ-R",
	"visible-md": "style_visible-md__3amf3",
	"visibleMd": "style_visible-md__3amf3",
	"deploymentPart": "style_deploymentPart__140yQ",
	"divider": "style_divider__18wfT",
	"actionSummary": "style_actionSummary__2r_NW",
	"disabled": "style_disabled__2CF7p",
	"logo": "style_logo__1vCvZ",
	"content": "style_content__1oScE",
	"contextualActions": "style_contextualActions__2EraV",
	"actions": "style_actions__10Lga",
	"steps": "style_steps__2n-iJ",
	"index": "style_index__259qL",
	"contentHeader": "style_contentHeader__tW9Nq",
	"contentBody": "style_contentBody__1TO-I",
	"environment": "style_environment__32zrj",
	"scriptModulesStatus": "style_scriptModulesStatus__DWWLJ",
	"includedScriptModules": "style_includedScriptModules__27G1I",
	"lifeCycleName": "style_lifeCycleName__1V_RW",
	"scriptModuleDescription": "style_scriptModuleDescription__3OBWJ",
	"noteList": "style_noteList__26od2",
	"stepNumber": "style_stepNumber__2wSBj",
	"row": "style_row__gYMwc",
	"container": "style_container__1TOUP",
	"images": "style_images__3aFYl",
	"col": "style_col__2BEoM"
};

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Targets_1 = __webpack_require__(734);
var TargetList = (function (_super) {
    __extends(TargetList, _super);
    function TargetList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TargetList.prototype.render = function () {
        var _this = this;
        return React.createElement(Targets_1.default, { targets: this.props.targets.map(function (target) { return _this.props.renderTarget(target); }) });
    };
    return TargetList;
}(React.Component));
exports.TargetList = TargetList;
exports.default = TargetList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\TargetList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\TargetList.tsx"); } } })();

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var SelectScriptModules_1 = __webpack_require__(1944);
var InternalLink_1 = __webpack_require__(43);
var LifecycleMap_1 = __webpack_require__(476);
var SelectLifecycle_1 = __webpack_require__(1945);
var OpenDialogButton_1 = __webpack_require__(72);
var resources_1 = __webpack_require__(17);
var PermissionCheck_1 = __webpack_require__(42);
var ActionButton_1 = __webpack_require__(49);
var Callout_1 = __webpack_require__(57);
var styles = __webpack_require__(190);
var routeLinks_1 = __webpack_require__(22);
var Note_1 = __webpack_require__(20);
var SideBar = (function (_super) {
    __extends(SideBar, _super);
    function SideBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            largeLifecyleToggle: true
        };
        return _this;
    }
    SideBar.prototype.render = function () {
        var _this = this;
        var largeLifecyle = this.props.lifecyclePreview.Phases.length > 20
            || this.props.lifecyclePreview.Phases.some(function (p) { return p.OptionalDeploymentTargets.length > 20; });
        return (React.createElement("div", null,
            React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.LifecycleView, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "The ",
                    resources_1.Permission.LifecycleView,
                    " permission is required to view the Lifecycle") },
                this.props.lifecyclePreview && React.createElement("div", null,
                    React.createElement("h4", null, "Lifecycle"),
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.lifecycle(this.props.lifecyclePreview.Id) },
                        React.createElement("span", { className: styles.lifeCycleName }, this.props.lifecyclePreview.Name)),
                    console.log("this.props.lifecyclePreview.Phases", this.props.lifecyclePreview.Phases),
                    largeLifecyle && this.props.lifecyclePreview && this.props.lifecyclePreview.Phases
                        && React.createElement(Note_1.default, null, "This lifecycle has many phases / environments"),
                    largeLifecyle && React.createElement(ActionButton_1.default, { onClick: function () { return _this.setState({ largeLifecyleToggle: !_this.state.largeLifecyleToggle }); }, label: this.state.largeLifecyleToggle ? "SHOW LIFECYCLE" : "HIDE LIFECYCLE", type: ActionButton_1.ActionButtonType.Secondary }),
                    React.createElement(OpenDialogButton_1.default, { label: "CHANGE", permission: {
                            permission: resources_1.Permission.ProcessEdit,
                            project: this.props.deploymentProcess.ProjectId,
                        } },
                        React.createElement(SelectLifecycle_1.default, { projectId: this.props.deploymentProcess.ProjectId, saveDone: function () { return _this.props.onDataChanged(); } })),
                    (!largeLifecyle || !this.state.largeLifecyleToggle)
                        && React.createElement(LifecycleMap_1.default, { environmentsById: this.props.environmentsById, lifecyclePreview: this.props.lifecyclePreview })),
                React.createElement(Note_1.default, null,
                    "Lifecycles can be defined in the ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.lifecycles }, "Library"))),
            React.createElement("hr", null),
            React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.LibraryVariableSetView, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "The ",
                    resources_1.Permission.LibraryVariableSetView,
                    " permission is required to view any included script modules") }, this.props.includedScriptModules && React.createElement("div", null,
                React.createElement("h4", null, "Script modules"),
                this.hasScriptModules()
                    ? React.createElement("p", { className: styles.scriptModulesStatus }, "Included script modules:")
                    : React.createElement("div", null,
                        React.createElement("p", null, "No script modules have been included"),
                        React.createElement(Note_1.default, null,
                            "Modules can be created in the ",
                            React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.scripts.root }, "Library"))),
                React.createElement("ul", { className: styles.includedScriptModules }, this.props.includedScriptModules.map(function (sm) { return React.createElement("li", { key: sm.Id },
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.script(sm.Id) }, sm.Name)); })),
                React.createElement(OpenDialogButton_1.default, { label: this.hasScriptModules() ? "CHANGE" : "INCLUDE", permission: {
                        permission: resources_1.Permission.ProcessEdit,
                        project: this.props.deploymentProcess.ProjectId,
                    } },
                    React.createElement(SelectScriptModules_1.default, { projectId: this.props.deploymentProcess.ProjectId, saveDone: function () { return _this.props.onDataChanged(); } }))))));
    };
    SideBar.prototype.hasScriptModules = function () {
        return this.props.includedScriptModules.length > 0;
    };
    return SideBar;
}(BaseComponent_1.default));
exports.default = SideBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SideBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SideBar.tsx"); } } })();

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var form_1 = __webpack_require__(16);
var libraryVariableSetResource_1 = __webpack_require__(461);
var List_1 = __webpack_require__(451);
var InternalLink_1 = __webpack_require__(43);
var SaveDialogLayout_1 = __webpack_require__(153);
var styles = __webpack_require__(190);
var routeLinks_1 = __webpack_require__(22);
var InfoDialogLayout_1 = __webpack_require__(846);
var SimpleList_1 = __webpack_require__(464);
var ScriptModuleList = (function (_super) {
    __extends(ScriptModuleList, _super);
    function ScriptModuleList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScriptModuleList;
}(List_1.List));
var ScriptModuleListSimple = (function (_super) {
    __extends(ScriptModuleListSimple, _super);
    function ScriptModuleListSimple() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScriptModuleListSimple;
}(SimpleList_1.SimpleList));
var SelectScriptModules = (function (_super) {
    __extends(SelectScriptModules, _super);
    function SelectScriptModules(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectionChange = function (state) {
            _this.setState({ onlyCurrentlySelected: state, loaded: false }, function () { return _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var scriptModules, currentlySelectedScriptModules;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this.state.currentlySelectedScriptModules) return [3 /*break*/, 2];
                            return [4 /*yield*/, clientInstance_1.repository.LibraryVariableSets.all({ contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule })];
                        case 1:
                            scriptModules = _a.sent();
                            currentlySelectedScriptModules = scriptModules
                                .filter(function (item) { return _this.state.originallySelected.includes(item.Id); });
                            this.setState({ currentlySelectedScriptModules: currentlySelectedScriptModules, loaded: true });
                            return [3 /*break*/, 3];
                        case 2:
                            this.setState({ loaded: true });
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); }); });
        };
        _this.renderList = function () {
            if (!_this.state.loaded) {
                return null;
            }
            if (_this.state.onlyCurrentlySelected) {
                return React.createElement(ScriptModuleListSimple, { filterHintText: "Filter by name or description", items: _this.state.currentlySelectedScriptModules, onFilter: _this.filter, onRow: _this.buildRow });
            }
            else {
                var additionalRequestParams = new Map();
                additionalRequestParams.set("contentType", libraryVariableSetResource_1.VariableSetContentType.ScriptModule);
                return React.createElement(ScriptModuleList, { filterHintText: "Filter by name or description", showPagingInNumberedStyle: true, initialData: _this.state.scriptModules, onRow: _this.buildRow, onFilter: _this.filter, filterSearchEnabled: true, apiSearchParams: ["partialName"], additionalRequestParams: additionalRequestParams });
            }
        };
        _this.renderCurrentlySelectedCheckbox = function () {
            if (!_this.state.loaded) {
                return null;
            }
            return React.createElement("div", { style: { width: "100%", display: "flex", flexDirection: "row-reverse", height: 0 } },
                React.createElement("div", { style: {
                        top: "1rem",
                        position: "relative"
                    } },
                    React.createElement(form_1.Checkbox, { label: "Only Currently Selected", value: _this.state.onlyCurrentlySelected, onChange: _this.handleSelectionChange })));
        };
        _this.filter = function (filter, item) {
            var matchesFilter = function (n) { return n.toLowerCase().includes(filter.toLowerCase()); };
            return !filter
                || filter.length === 0
                || (item.Name && matchesFilter(item.Name))
                || (item.Description && matchesFilter(item.Description));
        };
        _this.buildRow = function (item) {
            return React.createElement("div", null,
                React.createElement(form_1.Checkbox, { value: _this.state.project.IncludedLibraryVariableSetIds.includes(item.Id), label: item.Name, onChange: function (checked) { return _this.inclusionChanged(checked, item.Id); } }),
                item.Description && React.createElement("p", { className: styles.scriptModuleDescription }, item.Description));
        };
        _this.inclusionChanged = function (checked, id) {
            if (checked) {
                _this.setState(function (state) { return ({
                    project: __assign({}, state.project, { IncludedLibraryVariableSetIds: state.project.IncludedLibraryVariableSetIds.concat([id]) })
                }); });
            }
            else {
                _this.setState(function (state) { return ({
                    project: __assign({}, state.project, { IncludedLibraryVariableSetIds: state.project.IncludedLibraryVariableSetIds.filter(function (value) { return value !== id; }) })
                }); });
            }
        };
        _this.state = {
            loaded: false,
            scriptModules: null,
            currentlySelectedScriptModules: null,
            project: null,
            onlyCurrentlySelected: false,
            originallySelected: null,
        };
        return _this;
    }
    SelectScriptModules.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, scriptModules, project;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.LibraryVariableSets.list({ take: 8, contentType: libraryVariableSetResource_1.VariableSetContentType.ScriptModule }),
                                        clientInstance_1.repository.Projects.get(this.props.projectId)
                                    ])];
                                case 1:
                                    _a = _b.sent(), scriptModules = _a[0], project = _a[1];
                                    this.setState({ scriptModules: scriptModules, project: project, loaded: true, originallySelected: project.IncludedLibraryVariableSetIds });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectScriptModules.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.modify(this.state.project)];
                                case 1:
                                    _a.sent();
                                    this.props.saveDone();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectScriptModules.prototype.render = function () {
        var _this = this;
        if (this.state.loaded && this.state.scriptModules.Items.length === 0) {
            return React.createElement(InfoDialogLayout_1.default, { title: "Include a Script Module", busy: this.state.busy, errors: this.state.errors },
                React.createElement("p", null,
                    React.createElement("strong", null, "The Library is empty."),
                    " Please, go to ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.scripts.root }, " the Library"),
                    " and add some script modules first."));
        }
        return React.createElement(SaveDialogLayout_1.default, { title: "Include a Script Module", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } },
            this.renderCurrentlySelectedCheckbox(),
            this.renderList());
    };
    return SelectScriptModules;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectScriptModules;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectScriptModules.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectScriptModules.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(40);
var LifecycleMap_1 = __webpack_require__(476);
var SaveDialogLayout_1 = __webpack_require__(153);
var SelectLifecycle = (function (_super) {
    __extends(SelectLifecycle, _super);
    function SelectLifecycle(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLifeCycleChange = function (value) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.setChildState1("project", { LifecycleId: value });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.state = {};
        return _this;
    }
    SelectLifecycle.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, lifecycles, project, environmentsById, lifecyclePreviews;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, Promise.all([
                                        clientInstance_1.repository.Lifecycles.all(),
                                        clientInstance_1.repository.Projects.get(this.props.projectId),
                                        clientInstance_1.repository.Environments.allById()
                                    ])];
                                case 1:
                                    _a = _b.sent(), lifecycles = _a[0], project = _a[1], environmentsById = _a[2];
                                    return [4 /*yield*/, Promise.all(lifecycles.map(function (l) { return clientInstance_1.repository.Lifecycles.preview(l); }))];
                                case 2:
                                    lifecyclePreviews = _b.sent();
                                    this.setState({ lifecyclePreviews: lifecyclePreviews, project: project, environmentsById: environmentsById });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    SelectLifecycle.prototype.save = function () {
        var _this = this;
        return this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.modify(this.state.project)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.saveDone()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SelectLifecycle.prototype.render = function () {
        var _this = this;
        var body = this.state.project &&
            React.createElement("div", null,
                React.createElement(Select_1.default, { value: this.state.project.LifecycleId, onChange: this.handleLifeCycleChange, items: this.state.lifecyclePreviews.map(function (l) { return ({ value: l.Id, text: l.Name }); }), autoFocus: true, label: "Lifecycle" }),
                React.createElement(LifecycleMap_1.default, { environmentsById: this.state.environmentsById, lifecyclePreview: this.state.lifecyclePreviews.find(function (l) { return l.Id === _this.state.project.LifecycleId; }), showDescription: true }));
        return React.createElement(SaveDialogLayout_1.default, { title: "Change lifecycle", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    return SelectLifecycle;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectLifecycle;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectLifecycle.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectLifecycle.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var SortableList_1 = __webpack_require__(772);
var SaveDialogLayout_1 = __webpack_require__(153);
var DataBaseComponent_1 = __webpack_require__(39);
var DeploymentPartSorter = (function (_super) {
    __extends(DeploymentPartSorter, _super);
    function DeploymentPartSorter(props) {
        var _this = _super.call(this, props) || this;
        _this.stepsOrderChanged = function (Steps) {
            _this.setChildState1("deploymentProcess", { Steps: Steps });
        };
        _this.actionsOrderChanged = function (actions) {
            _this.setState(function (state) {
                var steps = state.deploymentProcess.Steps.slice();
                var index = steps.findIndex(function (s) { return s.Id === _this.props.stepId; });
                steps[index] = __assign({}, steps[index], { Actions: actions });
                return {
                    deploymentProcess: __assign({}, state.deploymentProcess, { Steps: steps })
                };
            });
        };
        _this.state = {
            deploymentProcess: null
        };
        return _this;
    }
    DeploymentPartSorter.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var deploymentProcess;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.deploymentProcessId)];
                                case 1:
                                    deploymentProcess = _a.sent();
                                    this.setState({ deploymentProcess: deploymentProcess });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DeploymentPartSorter.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(this.state.deploymentProcess)];
                                case 1:
                                    _a.sent();
                                    this.props.saveDone();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    DeploymentPartSorter.prototype.render = function () {
        var _this = this;
        var deploymentProcess = this.state.deploymentProcess;
        var body = deploymentProcess &&
            React.createElement(SortableList_1.default, { onOrderChanged: this.props.stepId ? this.actionsOrderChanged : this.stepsOrderChanged, items: this.props.stepId
                    ? this.getStep(deploymentProcess.Steps, this.props.stepId).Actions
                    : deploymentProcess.Steps });
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.title, busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    DeploymentPartSorter.prototype.getStep = function (steps, stepId) {
        return steps.filter(function (s) { return s.Id === stepId; })[0];
    };
    return DeploymentPartSorter;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = DeploymentPartSorter;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPartSorter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\DeploymentPartSorter.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Select_1 = __webpack_require__(40);
var Callout_1 = __webpack_require__(57);
var specialVariables_1 = __webpack_require__(189);
var DataBaseComponent_1 = __webpack_require__(39);
var OkDialogLayout_1 = __webpack_require__(65);
var SelectParentStep = (function (_super) {
    __extends(SelectParentStep, _super);
    function SelectParentStep(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedStepId: null
        };
        return _this;
    }
    SelectParentStep.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Move into Parent Step", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.onOk(); } },
            React.createElement("p", null,
                "Move the step ",
                React.createElement("strong", null, this.props.actionName),
                " into the new parent step:"),
            this.changeToTargetRoles() &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Confirm target role change" }, "This step previously targeted a different set of roles than the step you are moving it to. This means the step is now likely to run on a different set of machines. Are you sure you wish to move the step?"),
            React.createElement(Select_1.default, { label: "Select step", value: this.state.selectedStepId, error: this.state.errors && this.state.errors.fieldErrors.selectedStepId, items: this.props.steps.map(function (s) { return ({ value: s.Id, text: s.Name }); }), onChange: function (stepId) { return _this.setState({ selectedStepId: stepId, errors: null }); }, allowClear: true }));
    };
    SelectParentStep.prototype.onOk = function () {
        if (!this.state.selectedStepId) {
            this.setState({
                errors: {
                    message: "Please select a step",
                    details: null,
                    fieldErrors: { selectedStepId: "Select a step" }
                }
            });
            return false;
        }
        this.props.onStepSelected(this.state.selectedStepId);
        return true;
    };
    SelectParentStep.prototype.changeToTargetRoles = function () {
        var _this = this;
        return this.state.selectedStepId &&
            this.props.currentlyTargetedRoles !== this.props.steps.find(function (s) { return s.Id === _this.state.selectedStepId; }).Properties[specialVariables_1.default.Action.TargetRoles];
    };
    return SelectParentStep;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SelectParentStep;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectParentStep.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\SelectParentStep.tsx"); } } })();

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resources_1 = __webpack_require__(17);
var pluginRegistry_1 = __webpack_require__(18);
var lodash_1 = __webpack_require__(11);
var clientInstance_1 = __webpack_require__(10);
var PaperLayout_1 = __webpack_require__(131);
var DataBaseComponent_1 = __webpack_require__(90);
var permission_1 = __webpack_require__(51);
var PermissionCheck_1 = __webpack_require__(42);
var tenantTagsets = __webpack_require__(156);
var ActionDetails_1 = __webpack_require__(25);
var ParentStepDetails_1 = __webpack_require__(1990);
var StringHelper_1 = __webpack_require__(236);
var routeLinks_1 = __webpack_require__(22);
var RequestRaceConditioner_1 = __webpack_require__(453);
var StepDetailsLoader = (function (_super) {
    __extends(StepDetailsLoader, _super);
    function StepDetailsLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.requestRaceConditioner = new RequestRaceConditioner_1.default();
        _this.load = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var found, action, step, project, _a, environments, machineRoles, feeds, tagIndex, availableWorkerPools, lookups, _b, getTemplate, _c, channels, actionTemplate, isNewChildStep, stepIndex, actionIndex, isNotFirstStep;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.match.params.projectSlug)];
                    case 1:
                        project = _d.sent();
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.Environments.all(),
                                clientInstance_1.repository.MachineRoles.all(),
                                PermissionCheck_1.isAllowed({ permission: permission_1.Permission.FeedView, project: project.Id, wildcard: true }) ? clientInstance_1.repository.Feeds.all() : [],
                                tenantTagsets.getTagIndex()
                            ])];
                    case 2:
                        _a = _d.sent(), environments = _a[0], machineRoles = _a[1], feeds = _a[2], tagIndex = _a[3];
                        return [4 /*yield*/, this.loadAvailableWorkerPools()];
                    case 3:
                        availableWorkerPools = _d.sent();
                        lookups = {
                            environments: environments,
                            availableRoles: machineRoles,
                            availableWorkerPools: availableWorkerPools,
                            feeds: feeds,
                            project: project,
                            tagIndex: tagIndex
                        };
                        _b = lookups;
                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(lookups.project.DeploymentProcessId)];
                    case 4:
                        _b.deploymentProcess = _d.sent();
                        if (!this.props.match.params.actionType) {
                            found = this.findAction(lookups.deploymentProcess, this.props.match.params.stepId);
                        }
                        getTemplate = this.props.match.params.template
                            ? clientInstance_1.repository.ActionTemplates.get(this.props.match.params.template)
                            : found && found.action.Properties["Octopus.Action.Template.Id"]
                                ? clientInstance_1.repository.ActionTemplates.get(found.action.Properties["Octopus.Action.Template.Id"])
                                : Promise.resolve(null);
                        return [4 /*yield*/, Promise.all([
                                clientInstance_1.repository.Projects.getChannels(project),
                                getTemplate
                            ])];
                    case 5:
                        _c = _d.sent(), channels = _c[0], actionTemplate = _c[1];
                        lookups.channels = channels.Items;
                        lookups.actionTemplate = actionTemplate;
                        if (!this.props.match.params.actionType) {
                            if (found) {
                                step = found.step;
                                action = found.action;
                                //pageTitle(that.step.Name);
                            }
                            else {
                                step = lodash_1.find(lookups.deploymentProcess.Steps, function (s) { return s.Id === _this.props.match.params.stepId; });
                                action = null;
                                //pageTitle(that.step.Name);
                            }
                        }
                        else {
                            if (this.props.match.params.stepId) {
                                step = lodash_1.find(lookups.deploymentProcess.Steps, function (s) {
                                    return s.Id === _this.props.match.params.stepId;
                                });
                                if (step) {
                                    action = {
                                        Id: null,
                                        ActionType: this.props.match.params.actionType,
                                        Name: "",
                                        Environments: [],
                                        ExcludedEnvironments: [],
                                        Channels: [],
                                        TenantTags: [],
                                        Properties: {},
                                        Packages: [],
                                        IsDisabled: false,
                                        Links: null
                                    };
                                }
                                //pageTitle("New step for: " + step.Name);
                            }
                            if (!step) {
                                step = {
                                    Id: null,
                                    Name: "",
                                    Properties: {},
                                    Condition: "Success",
                                    StartTrigger: "StartAfterPrevious",
                                    PackageRequirement: "LetOctopusDecide",
                                    Actions: [
                                        {
                                            Id: null,
                                            ActionType: this.props.match.params.actionType,
                                            Name: "",
                                            Environments: [],
                                            ExcludedEnvironments: [],
                                            Channels: [],
                                            TenantTags: [],
                                            Properties: {},
                                            Packages: [],
                                            IsDisabled: false,
                                            Links: null
                                        }
                                    ]
                                };
                                action = step.Actions[0];
                                //pageTitle("New step");
                            }
                            if (lookups.actionTemplate) {
                                action.Name = step.Name = lookups.actionTemplate.Name;
                                action.Packages = lodash_1.clone(lookups.actionTemplate.Packages);
                                action.Properties = lodash_1.clone(lookups.actionTemplate.Properties);
                                action.Properties["Octopus.Action.Template.Id"] = lookups.actionTemplate.Id;
                                action.Properties["Octopus.Action.Template.Version"] = lookups.actionTemplate.Version;
                                lookups.actionTemplate.Parameters.forEach(function (parameter) {
                                    if (typeof parameter.DefaultValue !== "undefined" && parameter.DefaultValue !== null && parameter.DefaultValue !== "") {
                                        if (parameter.DisplaySettings["Octopus.ControlType"] === "Sensitive") {
                                            if (typeof parameter.DefaultValue === "object") {
                                                action.Properties[parameter.Name] = {
                                                    HasValue: true,
                                                    NewValue: null,
                                                    IsSensitive: true
                                                };
                                            }
                                            else {
                                                action.Properties[parameter.Name] = {
                                                    HasValue: true,
                                                    NewValue: parameter.DefaultValue,
                                                    IsSensitive: true
                                                };
                                            }
                                            return;
                                        }
                                        action.Properties[parameter.Name] = parameter.DefaultValue;
                                    }
                                });
                            }
                        }
                        if (!!action) {
                            // Provide default fallback for script templates.
                            if (action.ActionType === "Octopus.Script" && action.Properties && action.Properties["Octopus.Action.RunOnServer"] == null) {
                                action.Properties["Octopus.Action.RunOnServer"] = "false";
                            }
                            lookups.isNew = (!action.Name);
                            lookups.plugin = pluginRegistry_1.default.getDeploymentAction(action.ActionType);
                            if (lookups.isNew && this.pluginHasPackages(lookups.plugin, action) && lookups.feeds.length === 0) {
                                throw new Error("A NuGet package feed is required before that step can be configured. Please add a feed in the Configuration area and try again.");
                            }
                            // If the execution location is optional, default it to run on the target
                            if (lookups.isNew && lookups.plugin.executionLocation === resources_1.ActionExecutionLocation.TargetOrServer) {
                                action.Properties["Octopus.Action.RunOnServer"] = "false";
                            }
                            // If the execution location is locked, clean up the mess we've made by accidentally setting "Octopus.Action.RunOnServer" for all actions
                            if (lookups.plugin.executionLocation !== resources_1.ActionExecutionLocation.TargetOrServer) {
                                delete action.Properties["Octopus.Action.RunOnServer"];
                            }
                            lookups.hasFeatures = pluginRegistry_1.default.hasFeaturesForAction(action.ActionType);
                            isNewChildStep = lookups.isNew && !!this.props.match.params.stepId;
                            lookups.isChildStep = step.Actions.length > 1 || isNewChildStep;
                        }
                        stepIndex = lookups.deploymentProcess.Steps.indexOf(step);
                        lookups.stepNumber = "" + ((stepIndex === -1 ? lookups.deploymentProcess.Steps.length : stepIndex) + 1);
                        if (action && step.Actions.length > 1) {
                            actionIndex = step.Actions.indexOf(action);
                            lookups.stepNumber += "." + ((actionIndex === -1 ? step.Actions.length : actionIndex) + 1);
                        }
                        isNotFirstStep = (stepIndex > 0 || (stepIndex < 0 && lookups.deploymentProcess.Steps.length > 0));
                        lookups.isFirstStep = !isNotFirstStep;
                        // If we DON'T have an action, or the action does NOT have packages, we canRunBeforeAcquisition
                        lookups.canRunBeforeAcquisition = !action || !this.pluginHasPackages(pluginRegistry_1.default.getDeploymentAction(action.ActionType), action);
                        lookups.deploymentProcess.Steps.forEach(function (s, i) {
                            if (!lookups.canRunBeforeAcquisition) {
                                return;
                            }
                            if (i <= stepIndex || stepIndex < 0) {
                                var hasPackages = s.Actions.some(function (a) {
                                    var actionDefinition = pluginRegistry_1.default.getDeploymentAction(a.ActionType);
                                    return actionDefinition && _this.pluginHasPackages(actionDefinition, a);
                                });
                                if (hasPackages) {
                                    lookups.canRunBeforeAcquisition = false;
                                }
                            }
                        });
                        if (step.Condition === null || step.Condition === "") {
                            step.Condition = resources_1.RunCondition.Success;
                        }
                        this.setState(__assign({}, lookups, { action: action,
                            step: step }));
                        return [2 /*return*/];
                }
            });
        }); };
        _this.findAction = function (deploymentProcess, id) {
            for (var i = 0; i < deploymentProcess.Steps.length; i++) {
                var step = deploymentProcess.Steps[i];
                for (var j = 0; j < step.Actions.length; j++) {
                    var action = step.Actions[j];
                    if (action.Id === id) {
                        return { action: action, step: step, actionIndex: j, stepIndex: i };
                    }
                }
            }
            return null;
        };
        _this.runsOnServer = function (action, executionLocation) {
            return action && executionLocation &&
                (executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer ||
                    (executionLocation === resources_1.ActionExecutionLocation.TargetOrServer && action.Properties["Octopus.Action.RunOnServer"] === "true"));
        };
        _this.state = {};
        return _this;
    }
    StepDetailsLoader.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.load()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    StepDetailsLoader.prototype.render = function () {
        if (this.state && this.state.action) {
            return React.createElement(ActionDetails_1.default, __assign({}, this.props, this.state));
        }
        if (this.state && this.state.step) {
            return React.createElement(ParentStepDetails_1.default, __assign({}, this.props, this.state, { step: this.state.step }));
        }
        return React.createElement(PaperLayout_1.default, { title: StringHelper_1.default.ellipsis, breadcrumbTitle: "Process", breadcrumbPath: routeLinks_1.default.project(this.props.match.params.projectSlug).process.root, busy: this.state ? this.state.busy : null, errors: this.state ? this.state.errors : null, disableHeaderAnimations: true },
            React.createElement("div", null));
    };
    StepDetailsLoader.prototype.loadAvailableWorkerPools = function () {
        return __awaiter(this, void 0, void 0, function () {
            var availableWorkerPools;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        availableWorkerPools = [];
                        return [4 /*yield*/, this.requestRaceConditioner.avoidStaleResponsesForRequest(clientInstance_1.repository.WorkerPools.summary(), function (response) {
                                var workerPoolsSummaries = response;
                                if (workerPoolsSummaries.WorkerPoolSummaries.length === 1) {
                                    if (workerPoolsSummaries.WorkerPoolSummaries[0].WorkerPool.IsDefault && workerPoolsSummaries.WorkerPoolSummaries[0].TotalMachines === 0) {
                                        return availableWorkerPools;
                                    }
                                }
                                workerPoolsSummaries.WorkerPoolSummaries.forEach(function (workerPoolSummary) {
                                    availableWorkerPools.push(workerPoolSummary.WorkerPool);
                                });
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, availableWorkerPools];
                }
            });
        });
    };
    StepDetailsLoader.prototype.pluginHasPackages = function (actionDefinition, action) {
        return actionDefinition.hasPackages ? actionDefinition.hasPackages(action) : false;
    };
    return StepDetailsLoader;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = StepDetailsLoader;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepDetailsLoader.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\StepDetailsLoader.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmationDialog_1 = __webpack_require__(778);
var React = __webpack_require__(0);
var PromiseConfirmationDialog = function (props) {
    var deferred = props.deferred, children = props.children, otherProps = __rest(props, ["deferred", "children"]);
    return (React.createElement(ConfirmationDialog_1.default, __assign({ open: deferred && !deferred.resolved, onClose: function () { return deferred.resolve(false); }, onContinueClick: function () { return deferred.resolve(true); } }, otherProps), props.children));
};
var Deferred = (function () {
    function Deferred() {
        var _this = this;
        this.resolved = false;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = function (value) {
                if (_this.resolved) {
                    return;
                }
                _this.resolved = true;
                resolve(value);
            };
            _this.reject = function (reason) {
                if (_this.resolved) {
                    return;
                }
                _this.resolved = true;
                reject(reason);
            };
        });
    }
    return Deferred;
}());
exports.Deferred = Deferred;
exports.default = PromiseConfirmationDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\PromiseConfirmationDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\PromiseConfirmationDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ParseHelper_1 = __webpack_require__(456);
var Markdown_1 = __webpack_require__(132);
var SimpleDataTable_1 = __webpack_require__(313);
var ActionPropertyTable_1 = __webpack_require__(1951);
var ActionButton_1 = __webpack_require__(49);
var Callout_1 = __webpack_require__(57);
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ActionTemplateParameterInput_1 = __webpack_require__(425);
var form_1 = __webpack_require__(16);
var BaseComponent_1 = __webpack_require__(12);
var react_router_1 = __webpack_require__(76);
var lodash_1 = __webpack_require__(11);
var DeploymentProcessRoute_1 = __webpack_require__(328);
var InternalLink_1 = __webpack_require__(238);
var routeLinks_1 = __webpack_require__(22);
var Note_1 = __webpack_require__(20);
var ActionTemplateParameterInputExpandableFormElement_1 = __webpack_require__(822);
var InternalRedirect_1 = __webpack_require__(45);
var ActionTemplateEditor = (function (_super) {
    __extends(ActionTemplateEditor, _super);
    function ActionTemplateEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.resolveTable = function () {
            return React.createElement(SimpleDataTable_1.default, { data: _this.props.actionTemplate.Parameters, headerColumns: ["Property Name", "Current Property Value", "New Property Value"], onRow: _this.buildRow });
        };
        _this.buildRow = function (parameter) {
            return [
                React.createElement("span", null, parameter.Label || parameter.Name),
                _this.state.currentPropertyValues[parameter.Name],
                React.createElement("div", null,
                    React.createElement(ActionTemplateParameterInput_1.default, { parameter: parameter, doBusyTask: _this.props.doBusyTask, value: _this.state.overrides[parameter.Name], sourceItems: _this.state.sourceItems, onChange: function (x) { return _this.handleParameterInputChanged(parameter.Name, x); } }),
                    React.createElement(Note_1.default, null,
                        React.createElement(Markdown_1.default, { markup: parameter.HelpText })))
            ];
        };
        _this.handleParameterInputChanged = function (name, value) {
            _this.setState(function (state) {
                return ({ overrides: __assign({}, state.overrides, (_a = {}, _a[name] = value, _a)) });
                var _a;
            });
        };
        _this.resolveConflicts = function () {
            _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var overrides, actionIdsByProcessId, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            overrides = __assign({}, this.state.overrides);
                            this.props.actionTemplate.Parameters.forEach(function (p) {
                                if (overrides[p.Name] === undefined) {
                                    overrides[p.Name] = null;
                                }
                            });
                            this.setState({ overrides: overrides });
                            actionIdsByProcessId = {};
                            actionIdsByProcessId[this.props.process.Id] = [this.props.actionId];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.updateActions(this.props.actionTemplate, actionIdsByProcessId, null, overrides)];
                        case 2:
                            _a.sent();
                            this.reloadThePage();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            if (error_1.StatusCode !== 400) {
                                throw error_1;
                            }
                            this.setState({ manualMergeRequired: true });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.mergeLatest = function () {
            _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var actionIdsByProcessId, error_2, overrides_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            actionIdsByProcessId = {};
                            actionIdsByProcessId[this.props.process.Id] = [this.props.actionId];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.updateActions(this.props.actionTemplate, actionIdsByProcessId)];
                        case 2:
                            _a.sent();
                            this.reloadThePage();
                            return [3 /*break*/, 4];
                        case 3:
                            error_2 = _a.sent();
                            if (error_2.StatusCode !== 400) {
                                throw error_2;
                            }
                            overrides_1 = {};
                            this.props.actionTemplate.Parameters.forEach(function (p) {
                                var propertyValue = _this.props.properties[p.Name];
                                if (propertyValue !== undefined) {
                                    overrides_1[p.Name] = propertyValue;
                                }
                            });
                            this.setState({ overrides: overrides_1, manualMergeRequired: true });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        var version = ParseHelper_1.default.safeParseInt(_this.props.properties["Octopus.Action.Template.Version"]);
        var currentPropertyValues = {};
        lodash_1.each(_this.props.properties, function (propertyValue, propertyName) {
            currentPropertyValues[propertyName] = _this.isPropertySensitive(propertyValue)
                ? "******"
                : propertyValue;
        });
        var stepNames = props.process ? lodash_1.flatten(props.process.Steps.map(function (a) { return a.Actions.map(function (action) { return action.Name; }); })) : [];
        _this.state = {
            manualMergeRequired: false,
            isUpToDate: _this.props.actionTemplate.Version === version,
            version: version,
            actionTemplateVersion: null,
            currentPropertyValues: currentPropertyValues,
            sourceItems: { stepNames: stepNames, projectId: _this.props.projectId },
            overrides: {},
            redirectTo: null
        };
        return _this;
    }
    ActionTemplateEditor.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var versionGetter, actionTemplateVersion, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                versionGetter = this.state.isUpToDate
                                    ? Promise.resolve(this.props.actionTemplate)
                                    : clientInstance_1.repository.ActionTemplates.getVersion(this.props.actionTemplate, this.state.version);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, versionGetter];
                            case 2:
                                actionTemplateVersion = _a.sent();
                                this.setState({ actionTemplateVersion: actionTemplateVersion });
                                return [3 /*break*/, 4];
                            case 3:
                                error_3 = _a.sent();
                                if (error_3.StatusCode !== 404) {
                                    throw error_3;
                                }
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ActionTemplateEditor.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo, push: false });
        }
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: this.props.actionTemplate.Name }),
            React.createElement(form_1.UnstructuredFormSection, null,
                React.createElement("span", null,
                    "This step is based on a ",
                    this.props.actionTemplate.CommunityActionTemplateId ? "community" : "custom",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.stepTemplate(this.props.actionTemplate.Id).root },
                        React.createElement("strong", null,
                            " ",
                            this.props.actionTemplate.Name,
                            " ")),
                    "step template.")),
            !this.state.manualMergeRequired && !this.state.isUpToDate && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Danger },
                React.createElement("strong", null, "This step is out of date."),
                React.createElement("br", null),
                "'",
                this.props.actionTemplate.Name,
                "' step template has changed since this step was configured. Update now to merge the latest changes.",
                React.createElement("br", null),
                !this.state.actionTemplateVersion && React.createElement("p", null,
                    "Version '",
                    this.state.version,
                    "' of '",
                    this.props.actionTemplate.Name,
                    "' step template is not available and properties can only be displayed in read-only mode. To start storing all versions of '",
                    this.props.actionTemplate.Name,
                    "' step template and safely update automatically in the future, update to the latest version now."),
                React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Secondary, label: "Update", busyLabel: "Updating...", onClick: this.mergeLatest })),
            !this.state.manualMergeRequired && !this.state.actionTemplateVersion &&
                React.createElement(ActionPropertyTable_1.default, { actionProperties: this.props.properties, currentPropertyValues: this.state.currentPropertyValues }),
            !this.state.manualMergeRequired && this.state.actionTemplateVersion && React.createElement("div", null, this.state.actionTemplateVersion.Parameters.map(function (parameter) {
                return React.createElement(ActionTemplateParameterInputExpandableFormElement_1.default, { parameter: parameter, key: parameter.Name, projectId: _this.props.projectId, localNames: _this.props.localNames, value: _this.props.properties[parameter.Name], doBusyTask: _this.props.doBusyTask, sourceItems: _this.state.sourceItems, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a[parameter.Name] = x, _a));
                        var _a;
                    } });
            })),
            this.state.manualMergeRequired && React.createElement("div", null,
                React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                    "Unfortunately the step must be updated manually because we don't have enough information to do it automatically. Please, review carefully the new property values below and confirm them when you are ready.",
                    React.createElement("br", null),
                    React.createElement(ActionButton_1.default, { type: ActionButton_1.ActionButtonType.Secondary, label: "Confirm", onClick: this.resolveConflicts })),
                this.resolveTable()));
    };
    ActionTemplateEditor.prototype.reloadThePage = function () {
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    ActionTemplateEditor.prototype.isPropertySensitive = function (property) {
        return Object.prototype.toString.call(property) === "[object Object]";
    };
    return ActionTemplateEditor;
}(BaseComponent_1.BaseComponent));
var Editor = react_router_1.withRouter(ActionTemplateEditor);
exports.default = Editor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateEditor\\ActionTemplateEditor.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateEditor\\ActionTemplateEditor.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SimpleDataTable_1 = __webpack_require__(313);
var ActionPropertyTable = function (props) {
    var data = Object.keys(props.actionProperties).map(function (ap) { return ({ name: ap, value: props.currentPropertyValues[ap] }); });
    return React.createElement(SimpleDataTable_1.default, { data: data, headerColumns: ["Property Name", "Property Value"], onRow: buildRow });
};
var buildRow = function (dataPoint) {
    return [
        dataPoint.name,
        dataPoint.value,
    ];
};
exports.default = ActionPropertyTable;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateEditor\\ActionPropertyTable.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplateEditor\\ActionPropertyTable.tsx"); } } })();

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CertificateSearch_1 = __webpack_require__(792);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var CertificateSelector = (function (_super) {
    __extends(CertificateSelector, _super);
    function CertificateSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            certificate: null
        };
        return _this;
    }
    CertificateSelector.prototype.onOk = function () {
        this.props.onSelected(this.state.certificate);
        return true;
    };
    CertificateSelector.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Select Certificate", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.onOk(); } },
            React.createElement(CertificateSearch_1.default, { selectedCertificateId: this.props.selectedCertificateId, tenantId: this.props.tenantId, onSelected: function (certificate) { return _this.setState({ certificate: certificate }); }, doBusyTask: this.doBusyTask }));
    };
    return CertificateSelector;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = CertificateSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSelect\\CertificateSelector.tsx"); } } })();

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var index_1 = __webpack_require__(24);
var colors_1 = __webpack_require__(31);
var account_box_1 = __webpack_require__(847);
var fingerprint_1 = __webpack_require__(821);
var info_outline_1 = __webpack_require__(848);
var index_2 = __webpack_require__(240);
var ListTitle_1 = __webpack_require__(196);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var styles = __webpack_require__(1954);
var ThumbprintText_1 = __webpack_require__(484);
var MarkdownDescription_1 = __webpack_require__(239);
var fontWeights_1 = __webpack_require__(83);
var CertificateSummary = function (props) {
    var certificate = props.certificate;
    return React.createElement("div", { className: styles.container, onClick: props.onClick },
        props.showSelection && React.createElement("div", { className: styles.select },
            React.createElement(RadioButtonGroup_1.default, { value: props.selected, onChange: null },
                React.createElement(RadioButton_1.default, { value: true }))),
        React.createElement("div", { className: styles.summary },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.title },
                    React.createElement(ListTitle_1.default, null, certificate.Name)),
                React.createElement("div", { className: styles.details },
                    React.createElement("span", { className: styles.icon }, certificate.CertificateChain.length > 0 && React.createElement("em", { className: "fa fa-chain", title: "Contains a certificate chain" })),
                    React.createElement("span", { className: styles.icon }, certificate.HasPrivateKey && React.createElement("em", { className: "fa fa-key", title: "Contains a private-key" })),
                    React.createElement(index_1.CertificateExpiryChip, { certificate: certificate }))),
            certificate.Notes && React.createElement("div", { className: styles.row },
                React.createElement(MarkdownDescription_1.default, { markup: certificate.Notes })),
            React.createElement("div", { className: styles.row, style: { fontWeight: fontWeights_1.normal } },
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(info_outline_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement("span", null, certificate.SubjectCommonName || certificate.SubjectOrganization || certificate.SubjectDistinguishedName)),
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(account_box_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement("span", null, certificate.SelfSigned ? ("Self-Signed") : (certificate.IssuerCommonName || certificate.IssuerOrganization || certificate.IssuerDistinguishedName))),
                React.createElement("div", { className: styles.propertyContainer },
                    React.createElement("span", null,
                        React.createElement(fingerprint_1.default, { color: colors_1.primaryText, style: { width: "16px", height: "16px" } })),
                    React.createElement(ThumbprintText_1.default, { thumbprint: certificate.Thumbprint }))),
            React.createElement("div", { className: styles.row },
                React.createElement("span", null, index_1.environmentChipList(props.environments, certificate.EnvironmentIds)),
                (!!certificate.TenantIds.length || !!certificate.TenantTags.length) && React.createElement("span", null,
                    index_1.tenantChipList(props.tenants, certificate.TenantIds),
                    certificate.TenantTags.map(function (tt) {
                        var result = props.tenantTags.find(function (t) { return !!t.Tags.find(function (tag) { return tag.CanonicalTagName === tt; }); });
                        if (result) {
                            var fu = result.Tags.find(function (tag) { return tag.CanonicalTagName === tt; });
                            return React.createElement(index_2.default, { key: fu.Id, description: fu.Description, tagName: fu.Name, tagColor: fu.Color });
                        }
                    })))));
};
exports.default = CertificateSummary;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSummary.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\CertificateSearch\\CertificateSummary.tsx"); } } })();

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1955);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__2wjRD{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2MnDs{display:none!important}}@media (max-width:79.9rem){.style_hide-md__165Gg{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2eyR8{display:none!important}}.style_container__2gDxh{display:flex;flex-direction:row;align-items:flex-start}.style_select__F6zV8{display:flex;justify-content:center;align-items:center;flex:0 0 auto}.style_summary__S_TBQ{display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;flex:1 1 100%}.style_row__1Veoa{display:flex;flex-wrap:wrap;align-items:center;width:100%}.style_row__1Veoa:last-child{margin-top:.5rem}.style_titleContainer__3R39k{display:flex;flex-direction:row;width:100%}.style_title__1AHNH{width:100%}.style_details__11prN{display:flex;flex-direction:row}.style_icon__1mnue{padding:0 0 0 .4rem;align-self:center}.style_propertyContainer__1YqQN{padding:.4rem .4rem 0 0;display:flex;color:#333;font-size:.875rem}.style_propertyContainer__1YqQN span:nth-child(2){margin-left:.25rem;margin-right:.75rem}.style_propertyContainer__1YqQN+.style_thumbprint__2NMpH{font-weight:400}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__2wjRD",
	"hideSm": "style_hide-sm__2wjRD",
	"visible-sm": "style_visible-sm__2MnDs",
	"visibleSm": "style_visible-sm__2MnDs",
	"hide-md": "style_hide-md__165Gg",
	"hideMd": "style_hide-md__165Gg",
	"visible-md": "style_visible-md__2eyR8",
	"visibleMd": "style_visible-md__2eyR8",
	"container": "style_container__2gDxh",
	"select": "style_select__F6zV8",
	"summary": "style_summary__S_TBQ",
	"row": "style_row__1Veoa",
	"titleContainer": "style_titleContainer__3R39k",
	"title": "style_title__1AHNH",
	"details": "style_details__11prN",
	"icon": "style_icon__1mnue",
	"propertyContainer": "style_propertyContainer__1YqQN",
	"thumbprint": "style_thumbprint__2NMpH"
};

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(1957);
var ThumbprintText = (function (_super) {
    __extends(ThumbprintText, _super);
    function ThumbprintText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbprintText.prototype.render = function () {
        return React.createElement("span", { className: styles.thumbprint }, this.props.thumbprint);
    };
    return ThumbprintText;
}(React.PureComponent));
exports.default = ThumbprintText;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ThumbprintText\\ThumbprintText.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ThumbprintText\\ThumbprintText.tsx"); } } })();

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1958);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_thumbprint__EjJv1{font-weight:500}", ""]);

// exports
exports.locals = {
	"thumbprint": "style_thumbprint__EjJv1"
};

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1960);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_selectedIcon__3fJJ7{top:.2rem;position:relative;padding-right:.5rem}", ""]);

// exports
exports.locals = {
	"selectedIcon": "style_selectedIcon__3fJJ7"
};

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1962);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_controlWithRefreshContainer__2bhxp{display:flex;flex-direction:row;justify-content:space-between;align-content:flex-end}.style_controlWithRefreshContainer__2bhxp>div:first-child{width:100%}.style_refreshContainer__1G2t4{align-self:flex-end}", ""]);

// exports
exports.locals = {
	"controlWithRefreshContainer": "style_controlWithRefreshContainer__2bhxp",
	"refreshContainer": "style_refreshContainer__1G2t4"
};

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1964);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__KRYx2{display:flex;width:100%;align-items:flex-end}.style_selectedIcon__sA0M_{top:.2rem;position:relative;padding-right:.5rem}.style_outerContainer__2cu41{width:100%}.style_innerContainer__3mocN{overflow:hidden;text-overflow:ellipsis}.style_actions__1dJnI{margin-left:.5rem}.style_select__3VB4M{flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"container": "style_container__KRYx2",
	"selectedIcon": "style_selectedIcon__sA0M_",
	"outerContainer": "style_outerContainer__2cu41",
	"innerContainer": "style_innerContainer__3mocN",
	"actions": "style_actions__1dJnI",
	"select": "style_select__3VB4M"
};

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1966);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_addRefreshButtons__2EBDl{margin-top:1rem}", ""]);

// exports
exports.locals = {
	"addRefreshButtons": "style_addRefreshButtons__2EBDl"
};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1968);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__14HPx{width:100%}", ""]);

// exports
exports.locals = {
	"container": "style_container__14HPx"
};

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var ProjectVariableCollation_1 = __webpack_require__(1970);
var withProjectVariables = function (_a) {
    var controlType = _a.controlType, variableType = _a.variableType, _b = _a.fetchLibraryVariableSet, fetchLibraryVariableSet = _b === void 0 ? function (id) { return clientInstance_1.repository.LibraryVariableSets.get(id); } : _b, _c = _a.fetchVariableSet, fetchVariableSet = _c === void 0 ? function (id) { return clientInstance_1.repository.Variables.get(id); } : _c, _d = _a.fetchProject, fetchProject = _d === void 0 ? function (id) { return clientInstance_1.repository.Projects.get(id); } : _d;
    return function (Component) {
        var callbacks = { fetchLibraryVariableSet: fetchLibraryVariableSet, fetchVariableSet: fetchVariableSet };
        var fetchVariablesForProject = ProjectVariableCollation_1.collateProjectVariables(callbacks, controlType, variableType);
        var result = (_a = (function (_super) {
                __extends(WithProjectVariables, _super);
                function WithProjectVariables(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onRequestRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
                        var variables;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.setState({ isRefreshing: true });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, , 3, 4]);
                                    return [4 /*yield*/, fetchVariablesForProject(this.state.project)];
                                case 2:
                                    variables = _a.sent();
                                    this.setState({ variables: variables });
                                    return [3 /*break*/, 4];
                                case 3:
                                    this.setState({ isRefreshing: false });
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); };
                    _this.state = {
                        error: null,
                        isRefreshing: false,
                        project: null,
                        variables: [],
                        isDataLoaded: false
                    };
                    return _this;
                }
                WithProjectVariables.prototype.componentDidMount = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var project, variables;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, fetchProject(this.props.projectId)];
                                        case 1:
                                            project = _a.sent();
                                            return [4 /*yield*/, fetchVariablesForProject(project)];
                                        case 2:
                                            variables = _a.sent();
                                            this.setState({ project: project, variables: variables, isDataLoaded: true });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [2 /*return*/];
                        });
                    });
                };
                WithProjectVariables.prototype.render = function () {
                    var _a = this.state, isDataLoaded = _a.isDataLoaded, state = __rest(_a, ["isDataLoaded"]);
                    return (React.createElement(Component, __assign({}, this.props, state, { onRequestRefresh: this.onRequestRefresh })));
                };
                return WithProjectVariables;
            }(React.Component)),
            _a.displayName = "WithProjectVariables(" + (Component.displayName || Component.name) + ")",
            _a);
        return result;
        var _a;
    };
};
exports.withProjectVariables = withProjectVariables;
exports.default = withProjectVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\withProjectVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\withProjectVariables.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1971));


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ProjectVariableCollation\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ProjectVariableCollation\\index.ts"); } } })();

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(11);
var lodash_1 = __webpack_require__(11);
var isControlType = lodash_1.curry(function (controlType, template) {
    return !!template.DisplaySettings && template.DisplaySettings["Octopus.ControlType"] === controlType;
});
exports.isControlType = isControlType;
var isVariableType = lodash_1.curry(function (variableType, resource) {
    return resource.Type === variableType;
});
exports.isVariableType = isVariableType;
var fetchEach = function (callback, ids) { return Promise.all(ids.map(callback)); };
var pickVariableSetId = function (item) { return item.VariableSetId; };
var pickVariables = function (item) { return item.Variables; };
var pickTemplates = function (item) { return item.Templates; };
var pickName = function (item) { return item.Name; };
var collateProjectVariables = lodash_1.curry(function (callbacks, controlType, variableType, project) { return __awaiter(_this, void 0, void 0, function () {
    var libraryVariableSets, variableSetIds, variableResults, variables, templates;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchEach(callbacks.fetchLibraryVariableSet, project.IncludedLibraryVariableSetIds)];
            case 1:
                libraryVariableSets = _a.sent();
                variableSetIds = _.union([project.VariableSetId], libraryVariableSets.map(pickVariableSetId));
                return [4 /*yield*/, fetchEach(callbacks.fetchVariableSet, variableSetIds).then(function (x) { return x.map(pickVariables); })];
            case 2:
                variableResults = _a.sent();
                variables = _.flattenDeep(variableResults).filter(isVariableType(variableType));
                templates = _.union(project.Templates, _.flattenDeep(libraryVariableSets.map(pickTemplates))).filter(isControlType(controlType));
                return [2 /*return*/, _.chain(variables)
                        .union(templates)
                        .map(pickName)
                        .sort()
                        .uniq()
                        .value()];
        }
    });
}); });
exports.collateProjectVariables = collateProjectVariables;
exports.default = collateProjectVariables;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ProjectVariableCollation\\collateProjectVariables.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\utils\\ProjectVariableCollation\\collateProjectVariables.ts"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var withValidateOnChange = function (options) {
    if (options === void 0) { options = {}; }
    return function (Component) {
        return _a = (function (_super) {
                __extends(WithValidateOnChange, _super);
                function WithValidateOnChange(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleChange = function (fieldValue) {
                        var _a = _this.props, validate = _a.validate, onValidate = _a.onValidate, onChange = _a.onChange;
                        var value = fieldValue === "" ? null : fieldValue;
                        if (validate) {
                            var result = validate(value);
                            _this.setState({ error: result });
                            if (onValidate) {
                                onValidate(result);
                            }
                        }
                        if (onChange) {
                            onChange(value);
                        }
                    };
                    _this.state = {
                        error: null
                    };
                    return _this;
                }
                WithValidateOnChange.prototype.render = function () {
                    var validate = { validation: this.state };
                    return (React.createElement(Component, __assign({ onChange: this.handleChange }, this.props, validate)));
                };
                return WithValidateOnChange;
            }(React.Component)),
            _a.displayName = "WithValidateOnChange(" + (Component.displayName || Component.name) + ")",
            _a;
        var _a;
    };
};
exports.withValidateOnChange = withValidateOnChange;
exports.default = withValidateOnChange;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\withValidateOnChange.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\withValidateOnChange.tsx"); } } })();

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(738));
var VariableSelect_1 = __webpack_require__(738);
exports.default = VariableSelect_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableSelect\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\VariableSelect\\index.ts"); } } })();

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1975);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_featuresActionContainer__2bUFI{display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}", ""]);

// exports
exports.locals = {
	"featuresActionContainer": "style_featuresActionContainer__2bUFI"
};

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var deploymentStepResource_1 = __webpack_require__(264);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var PackageRequirementText = (_a = {},
    _a[deploymentStepResource_1.PackageRequirement.LetOctopusDecide] = "Let Octopus decide",
    _a[deploymentStepResource_1.PackageRequirement.AfterPackageAcquisition] = "After package acquisition",
    _a[deploymentStepResource_1.PackageRequirement.BeforePackageAcquisition] = "Before package acquisition",
    _a);
var PackageRequirementRadioButtonGroup = (function (_super) {
    __extends(PackageRequirementRadioButtonGroup, _super);
    function PackageRequirementRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageRequirementRadioButtonGroup;
}(RadioButtonGroup_1.default));
var PackageRequirementExpandableFormSection = (function (_super) {
    __extends(PackageRequirementExpandableFormSection, _super);
    function PackageRequirementExpandableFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageRequirementExpandableFormSection.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.packageRequirement !== this.props.packageRequirement;
    };
    PackageRequirementExpandableFormSection.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { title: "Package Requirement", help: "Controls if this step needs to run before or after package acquisition.", summary: this.props.packageRequirement === deploymentStepResource_1.PackageRequirement.LetOctopusDecide
                ? form_1.Summary.default(PackageRequirementText[this.props.packageRequirement])
                : form_1.Summary.summary(PackageRequirementText[this.props.packageRequirement]), errorKey: "packagerequirement" },
            React.createElement(PackageRequirementRadioButtonGroup, { value: this.props.packageRequirement, onChange: this.props.onChange }, Object.keys(PackageRequirementText)
                .map(function (pr) { return React.createElement(RadioButton_1.default, { value: pr, label: PackageRequirementText[pr], key: pr }); })));
    };
    return PackageRequirementExpandableFormSection;
}(React.Component));
exports.default = PackageRequirementExpandableFormSection;
var _a;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\PackageRequirementExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\PackageRequirementExpander.tsx"); } } })();

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(39);
var pluginRegistry_1 = __webpack_require__(18);
var OkDialogLayout_1 = __webpack_require__(65);
var FeatureList_1 = __webpack_require__(1978);
var Callout_1 = __webpack_require__(58);
var ConfigureFeaturesContent = (function (_super) {
    __extends(ConfigureFeaturesContent, _super);
    function ConfigureFeaturesContent(props) {
        var _this = _super.call(this, props) || this;
        _this.featureToggled = function () {
            var removedFeatures = _this.state.features.filter(function (feature) {
                return feature.wasEnabled && !feature.isEnabled;
            }).map(function (feature) {
                return feature.title;
            });
            _this.setState({
                removedFeatures: removedFeatures
            });
        };
        _this.handleIsEnabledChanged = function (value, featureName) {
            _this.setState(function (prevState) {
                var features = prevState.features.map(function (f) {
                    return f.featureName === featureName
                        ? __assign({}, f, { isEnabled: value }) : f;
                });
                return { features: features };
            }, _this.featureToggled);
        };
        _this.state = {
            features: [],
            removedFeatures: [],
            actionType: null
        };
        return _this;
    }
    ConfigureFeaturesContent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var features, action, allFeatures, enabledFeatures;
                        return __generator(this, function (_a) {
                            features = [];
                            action = pluginRegistry_1.default.getDeploymentAction(this.props.actionType);
                            allFeatures = pluginRegistry_1.default.getAllFeatures();
                            enabledFeatures = (this.props.properties["Octopus.Action.EnabledFeatures"])
                                ? this.props.properties["Octopus.Action.EnabledFeatures"].split(",")
                                : [];
                            if (action.features && action.features.optional) {
                                allFeatures.sort(function (a, b) { return a.priority - b.priority; }).forEach(function (feature) {
                                    if (!action.features.optional.includes(feature.featureName)) {
                                        return;
                                    }
                                    features.push({
                                        featureName: feature.featureName,
                                        title: feature.title,
                                        description: feature.description,
                                        instance: feature,
                                        isEnabled: enabledFeatures.includes(feature.featureName),
                                        wasEnabled: enabledFeatures.includes(feature.featureName)
                                    });
                                });
                            }
                            this.setState({
                                features: features,
                                actionType: action
                            });
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    ConfigureFeaturesContent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        var currentlyEnabled;
                        return __generator(this, function (_a) {
                            currentlyEnabled = (this.state.actionType.features && this.state.actionType.features.permanent)
                                ? this.state.actionType.features.permanent.slice() : [];
                            this.state.features.forEach(function (feature) {
                                if (feature.isEnabled) {
                                    currentlyEnabled.push(feature.featureName);
                                }
                                if (!feature.wasEnabled && feature.isEnabled) {
                                    if (feature.instance.enable) {
                                        feature.instance.enable(_this.props.properties);
                                    }
                                }
                            });
                            this.props.saveDone(currentlyEnabled.join(","));
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    ConfigureFeaturesContent.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { title: "Enabled Features", busy: this.state.busy, errors: this.state.errors, onOkClick: function () { return _this.save(); } }, this.state.features && React.createElement("div", null,
            this.state.removedFeatures.length > 0 && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning },
                React.createElement("span", null,
                    "You have deselected the feature",
                    this.state.removedFeatures.length > 1 ? React.createElement("span", null, "s") : "",
                    " "),
                this.state.removedFeatures.map(function (feature, index, arr) {
                    var last = index === arr.length - 1;
                    var first = index === 0;
                    var middle = !last && !first;
                    return React.createElement("span", { key: "removed" + index },
                        last && !first ? " and " : "",
                        middle ? ", " : "",
                        React.createElement("b", null, feature));
                }),
                React.createElement("span", null,
                    ". This will remove any related settings for ",
                    this.state.removedFeatures.length > 1 ? React.createElement("span", null, "these features") : React.createElement("span", null, "this feature"),
                    ".")),
            React.createElement(FeatureList_1.default, { features: this.state.features, onIsEnabledChanged: this.handleIsEnabledChanged })));
    };
    return ConfigureFeaturesContent;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ConfigureFeaturesContent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\ConfigureFeaturesContent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\ConfigureFeaturesContent.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SimpleDataTable_1 = __webpack_require__(466);
var MarkdownDescription_1 = __webpack_require__(239);
var Checkbox_1 = __webpack_require__(121);
var styles = __webpack_require__(1979);
var FeatureTable = (function (_super) {
    __extends(FeatureTable, _super);
    function FeatureTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeatureTable;
}(SimpleDataTable_1.default));
var FeatureList = function (props) {
    return React.createElement(FeatureTable, { data: props.features, headerColumns: ["Feature", "Description"], headerColumnClassName: styles.headerColumn, rowColumnClassName: styles.rowColumn, onRow: function (res) { return buildResultRow(res, props.onIsEnabledChanged); } });
};
var buildResultRow = function (item, onIsEnabledChanged) {
    return [
        React.createElement(Checkbox_1.default, { value: item.isEnabled, onChange: function (val) { return onIsEnabledChanged(val, item.featureName); }, label: item.title }),
        React.createElement(MarkdownDescription_1.default, { markup: item.description })
    ];
};
FeatureList.displayName = "FeatureList";
exports.default = FeatureList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\FeatureList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\OpenFeatureDialog\\FeatureList.tsx"); } } })();

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1980);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumn__22CvW:first-child{width:18.75rem!important}.style_rowColumn__13kPZ{word-break:normal;white-space:normal;padding:0 1.125rem!important;vertical-align:middle!important}.style_rowColumn__13kPZ p{margin:.5rem 0}.style_center__2WdKe{text-align:center}", ""]);

// exports
exports.locals = {
	"headerColumn": "style_headerColumn__22CvW",
	"rowColumn": "style_rowColumn__13kPZ",
	"center": "style_center__2WdKe"
};

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Chips_1 = __webpack_require__(24);
var Callout_1 = __webpack_require__(58);
var EnvironmentMultiSelect_1 = __webpack_require__(309);
var ExpandableFormSection_1 = __webpack_require__(30);
var form_1 = __webpack_require__(16);
var ActionDetails_1 = __webpack_require__(25);
var Callout_2 = __webpack_require__(58);
var EnvironmentOptionRadioButtonGroup = (function (_super) {
    __extends(EnvironmentOptionRadioButtonGroup, _super);
    function EnvironmentOptionRadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EnvironmentOptionRadioButtonGroup;
}(form_1.RadioButtonGroup));
var Environments = (function (_super) {
    __extends(Environments, _super);
    function Environments() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Environments.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.environmentOption !== this.props.environmentOption
            || nextProps.inclusiveEnvironments !== this.props.inclusiveEnvironments
            || nextProps.exclusiveEnvironments !== this.props.exclusiveEnvironments;
    };
    Environments.prototype.render = function () {
        return React.createElement(ExpandableFormSection_1.default, { title: "Environments", help: "Choose which environments this step applies to.", summary: this.environmentSummary(), errorKey: "environments" },
            React.createElement(EnvironmentOptionRadioButtonGroup, { value: this.props.environmentOption, onChange: this.props.onEnvironmentOptionChanged },
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.All, label: "Run for all applicable Lifecycle environments", disabled: this.props.hasHiddenEnvironments, isDefault: true }),
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.Include, label: "Run only for specific environments", disabled: this.props.hasHiddenEnvironments }),
                this.props.environmentOption === ActionDetails_1.EnvironmentOption.Include && React.createElement("div", null,
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.props.environments, onChange: this.props.onInclusiveEnvironmentsChanged, value: this.props.inclusiveEnvironments }),
                    React.createElement(form_1.Note, null, "Choose the specific environments under which you want this step to run."),
                    this.props.hasHiddenEnvironments && React.createElement(Callout_1.default, { type: Callout_2.CalloutType.Information }, "The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for inclusion.")),
                React.createElement(form_1.RadioButton, { value: ActionDetails_1.EnvironmentOption.Exclude, label: "Skip specific environments", disabled: this.props.hasHiddenEnvironments }),
                this.props.environmentOption === ActionDetails_1.EnvironmentOption.Exclude && React.createElement("div", null,
                    React.createElement(EnvironmentMultiSelect_1.default, { items: this.props.environments, onChange: this.props.onExclusiveEnvironmentsChanged, value: this.props.exclusiveEnvironments }),
                    React.createElement(form_1.Note, null, "Choose the environments for which you want this step to be skipped."),
                    this.props.hasHiddenEnvironments && React.createElement(Callout_1.default, { type: Callout_2.CalloutType.Information }, "The environment condition type cannot be changed because you do not have access to an environment that is specifically marked for inclusion."))));
    };
    Environments.prototype.environmentSummary = function () {
        if (this.props.environmentOption === ActionDetails_1.EnvironmentOption.Include) {
            return form_1.Summary.summary(React.createElement("span", null,
                "This step will only run in ",
                this.getChipsForEnvironments(this.props.inclusiveEnvironments)));
        }
        if (this.props.environmentOption === ActionDetails_1.EnvironmentOption.Exclude) {
            return form_1.Summary.summary(React.createElement("span", null,
                "This step will be run in all applicable Lifecycle environments ",
                React.createElement("em", null, "except"),
                " ",
                this.getChipsForEnvironments(this.props.exclusiveEnvironments)));
        }
        return form_1.Summary.default("This step will run for all applicable Lifecycle environments");
    };
    Environments.prototype.getChipsForEnvironments = function (environments) {
        if (environments.length === 0) {
            return React.createElement("em", null, "please select environments");
        }
        return Chips_1.environmentChipList(this.props.environments, environments);
    };
    return Environments;
}(React.Component));
exports.default = Environments;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Environments.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\Environments.tsx"); } } })();

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resources_1 = __webpack_require__(17);
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var ParseHelper_1 = __webpack_require__(66);
var ActionDetails_1 = __webpack_require__(25);
var Chips_1 = __webpack_require__(24);
var MultiSelect_1 = __webpack_require__(75);
var MaxParallelism_1 = __webpack_require__(741);
var styles = __webpack_require__(190);
var ExternalLink_1 = __webpack_require__(26);
var ExpandableFormSection_1 = __webpack_require__(30);
var TransitionAnimation_1 = __webpack_require__(82);
var Button_1 = __webpack_require__(47);
var Fragment_1 = __webpack_require__(92);
function resolveWorkerPool(runOn, availableWorkerPools, workerPool) {
    if (workerPool) {
        return workerPool;
    }
    if ((runOn === ActionDetails_1.RunOn.WorkerPool || runOn === ActionDetails_1.RunOn.WorkerPoolForRoles)) {
        var found = availableWorkerPools.filter(function (element) { return element.IsDefault; }).pop();
        return found ? found.Id : null;
    }
}
var ExecutionPlan = (function (_super) {
    __extends(ExecutionPlan, _super);
    function ExecutionPlan(props) {
        var _this = _super.call(this, props) || this;
        _this.phaseEnvironments = [];
        _this.environmentNameMap = {};
        _this.renderRunOnOptions = function () {
            var executeTarget = __webpack_require__(1983);
            var executeWorker = __webpack_require__(1984);
            var executeWorkerForRole = __webpack_require__(1985);
            var executeServer = __webpack_require__(1986);
            var executeServerForRole = __webpack_require__(1987);
            var alwaysOnServer = _this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer;
            if (alwaysOnServer && _this.props.targetRoleOption !== ActionDetails_1.TargetRoles.Optional) {
                if (_this.workerPoolsAvailable()) {
                    // Workers
                    return React.createElement("div", null, _this.props.targetRoleOption !== ActionDetails_1.TargetRoles.None
                        ? React.createElement("div", { className: styles.col },
                            " ",
                            React.createElement("span", null,
                                "This step will run once on a ",
                                React.createElement("strong", null, "worker"),
                                " on behalf of each deployment target"),
                            React.createElement("img", { src: executeWorkerForRole, alt: "Worker on behalf of roles" }),
                            React.createElement(form_1.Note, null, "Execute on a worker on behalf of all the deployment targets in selected roles."))
                        : React.createElement("div", { className: styles.col },
                            " ",
                            React.createElement("span", null,
                                "This step will run once on a ",
                                React.createElement("strong", null, "worker")),
                            React.createElement("img", { src: executeWorker, alt: "Worker" }),
                            React.createElement(form_1.Note, null, "Execute once on a worker.")));
                }
                else {
                    // Octopus Server
                    return React.createElement("div", null, _this.props.targetRoleOption !== ActionDetails_1.TargetRoles.None
                        ? React.createElement("div", { className: styles.col },
                            " ",
                            React.createElement("span", null,
                                "This step will run on the ",
                                React.createElement("strong", null, "Octopus Server"),
                                " on behalf of each deployment target"),
                            React.createElement("img", { src: executeServerForRole, alt: "Octopus Server on behalf of roles" }),
                            React.createElement(form_1.Note, null, "Execute on a the Octopus Server on behalf of all the deployment targets in selected roles."))
                        : React.createElement("div", { className: styles.col },
                            " ",
                            React.createElement("span", null,
                                "This step will run on the ",
                                React.createElement("strong", null, "Octopus Server")),
                            React.createElement("img", { src: executeServer, alt: "Octopus Server" }),
                            React.createElement(form_1.Note, null, "Execute once on the Octopus Server.")));
                }
            }
            if (_this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnTarget) {
                return React.createElement("div", { className: styles.col },
                    React.createElement("span", null,
                        "This step will run on each ",
                        React.createElement("strong", null, "deployment target")),
                    React.createElement("img", { src: executeTarget, alt: "Deployment Target" }),
                    React.createElement(form_1.Note, null, "Execute on each deployment target with the selected roles."));
            }
            return React.createElement("div", { className: styles.row },
                React.createElement(form_1.StringRadioButtonGroup, { value: _this.props.runOn, onChange: _this.onRunOnChanged },
                    (!_this.props.isChildStep && _this.workerPoolsAvailable()) && React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.WorkerPool, label: "Run once on a worker" }),
                    (!_this.props.isChildStep && !_this.workerPoolsAvailable()) && React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.OctopusServer, label: "Run on the Octopus Server" }),
                    _this.workerPoolsAvailable()
                        ? React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.WorkerPoolForRoles, label: "Run on a worker on behalf of each deployment target" })
                        : React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.OctopusServerForRoles, label: "Run on the Octopus Server on behalf of each deployment target" }),
                    !alwaysOnServer && React.createElement(form_1.RadioButton, { value: ActionDetails_1.RunOn.DeploymentTarget, label: "Run on each deployment target", isDefault: true })),
                React.createElement("div", { className: styles.images },
                    (_this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget) && React.createElement(TransitionAnimation_1.default, null,
                        React.createElement("img", { src: executeTarget, alt: "Deployment Target" }),
                        React.createElement(form_1.Note, null, "Execute on each deployment target with the selected roles.")),
                    (_this.props.runOn === ActionDetails_1.RunOn.OctopusServer) && React.createElement(TransitionAnimation_1.default, null,
                        React.createElement("img", { src: executeServer, alt: "Octopus Server" }),
                        React.createElement(form_1.Note, null, "Execute once on the Octopus Server.")),
                    (_this.props.runOn === ActionDetails_1.RunOn.OctopusServerForRoles) && React.createElement(TransitionAnimation_1.default, null,
                        React.createElement("img", { src: executeServerForRole, alt: "Octopus Server on behalf of roles" }),
                        React.createElement(form_1.Note, null, "Execute on the Octopus Server on behalf of all the deployment targets in selected roles.")),
                    (_this.props.runOn === ActionDetails_1.RunOn.WorkerPool) && React.createElement(TransitionAnimation_1.default, null,
                        React.createElement("img", { src: executeWorker, alt: "Worker" }),
                        React.createElement(form_1.Note, null, "Execute once on a worker.")),
                    (_this.props.runOn === ActionDetails_1.RunOn.WorkerPoolForRoles) && React.createElement(TransitionAnimation_1.default, null,
                        React.createElement("img", { src: executeWorkerForRole, alt: "Worker on behalf of roles" }),
                        React.createElement(form_1.Note, null, "Execute on a worker on behalf of all the deployment targets in selected roles."))));
        };
        _this.renderRolesOptions = function () {
            if (_this.props.targetRoleOption === ActionDetails_1.TargetRoles.None) {
                return null;
            }
            if (_this.props.isChildStep) {
                return (_this.props.runsOnServer)
                    ? React.createElement(form_1.UnstructuredFormSection, null,
                        React.createElement("p", { className: "text-muted" },
                            "This step is part of a rolling step, which runs on the Octopus Server on behalf of deployment targets in the following roles:",
                            _this.roleList(_this.props.targetRoles)))
                    : React.createElement(form_1.UnstructuredFormSection, null,
                        React.createElement("p", { className: "text-muted" },
                            "This step is part of a rolling step, which runs on deployment targets in the following roles:",
                            _this.roleList(_this.props.targetRoles)));
            }
            var nodes = [];
            if (_this.props.runOn === ActionDetails_1.RunOn.WorkerPool || _this.props.runOn === ActionDetails_1.RunOn.WorkerPoolForRoles) {
                nodes.push(React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: _this.props.expandedByDefault, summary: form_1.Summary.summary(_this.WorkerPoolSummary()), title: "Worker Pool", errorKey: "Octopus.Action.WorkerPoolId", help: "Which worker pool should Octopus use for this step?" },
                    React.createElement(form_1.Select, { items: _this.props.availableWorkerPools.map(function (e) {
                            return { value: e.Id, text: e.Name };
                        }), value: _this.state.targetWorkerPool, validate: function (value) { return value == null ? "Please select a worker pool" : ""; }, label: "Runs on a worker from the pool", onChange: _this.onTargetWorkerPoolChange })));
            }
            var rolePostfix = _this.props.disableAddTargetRoles !== true && " (type to add new)"; // Keep this text short for mobile.
            if (_this.props.runOn === ActionDetails_1.RunOn.OctopusServerForRoles ||
                _this.props.runOn === ActionDetails_1.RunOn.WorkerPoolForRoles ||
                _this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget) {
                nodes.push(React.createElement("div", null,
                    React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: _this.props.expandedByDefault, summary: _this.props.targetRoles
                            ? form_1.Summary.summary(_this.roleList(_this.props.targetRoles))
                            : form_1.Summary.placeholder("No roles selected"), title: _this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget
                            ? "On Targets in Roles"
                            : "On Behalf Of", errorKey: "Octopus.Action.TargetRoles", help: _this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget
                            ? "Run this step on these deployment targets."
                            : "Run this step on behalf of these deployment targets." },
                        React.createElement(MultiSelect_1.RoleMultiSelect, { onChange: _this.props.onTargetRolesChanged, value: ParseHelper_1.default.parseCSV(_this.props.targetRoles), label: _this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget
                                ? "Runs on targets in roles" + rolePostfix
                                : "On behalf of target roles" + rolePostfix, validate: function (roles) { return roles.length === 0 ? "Please enter one or more roles" : ""; }, error: _this.props.targetRolesError, items: _this.props.availableRoles, canAdd: _this.props.disableAddTargetRoles !== true }),
                        React.createElement(form_1.Note, null, "This step will run on all deployment targets with these roles."),
                        !_this.state.showWindowSize && React.createElement(Fragment_1.Fragment, null,
                            React.createElement(Button_1.default, { label: "Configure a rolling deployment", onClick: function () {
                                    _this.setState({ showWindowSize: true });
                                    _this.props.onMaxParallelismChanged("1");
                                } })),
                        _this.state.showWindowSize && React.createElement(Fragment_1.Fragment, null,
                            React.createElement(Button_1.default, { label: "Deploy to all deployment targets in parallel", onClick: function () {
                                    _this.setState({ showWindowSize: false });
                                    _this.props.onMaxParallelismChanged("");
                                } })))));
                if (_this.state.showWindowSize) {
                    nodes.push(React.createElement("div", null,
                        React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: _this.props.expandedByDefault, summary: form_1.Summary.summary(_this.rollingDeploymentSummary()), title: "Rolling Deployment", errorKey: "Octopus.Action.RollingDeployment", help: "Select the rolling window Octopus should use for this step. " },
                            React.createElement(form_1.Note, null,
                                "Learn more about ",
                                React.createElement(ExternalLink_1.default, { href: "rolling-deployments" }, "Rolling Deployments")),
                            React.createElement(MaxParallelism_1.default, { key: "maxparallelism", projectId: _this.props.projectId, value: _this.props.maxParallelism, onChange: function (x) { return _this.props.onMaxParallelismChanged(x); } }))));
                }
            }
            return React.Children.toArray(nodes);
        };
        _this.onRunOnChanged = function (runOn) {
            var targetWorkerPool = resolveWorkerPool(runOn, _this.props.availableWorkerPools, null);
            _this.setState({ targetWorkerPool: targetWorkerPool }, function () { return _this.props.onTargetWorkerPoolChanged(targetWorkerPool); });
            _this.props.onRunOnChanged(runOn);
        };
        _this.onTargetWorkerPoolChange = function (workerPool) {
            _this.setState({
                targetWorkerPool: workerPool
            }, function () { return _this.props.onTargetWorkerPoolChanged(workerPool); });
        };
        _this.state = {
            showWindowSize: props.maxParallelism ? props.maxParallelism.length > 0 : false,
            targetWorkerPool: resolveWorkerPool(props.runOn, props.availableWorkerPools, props.targetWorkerPool)
        };
        return _this;
    }
    ExecutionPlan.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.runOn !== this.props.runOn
            || nextProps.targetRoles !== this.props.targetRoles
            || nextProps.maxParallelism !== this.props.maxParallelism
            || nextProps.targetRolesError !== this.props.targetRolesError
            || nextState.showWindowSize !== this.state.showWindowSize
            || nextState.targetWorkerPool !== this.state.targetWorkerPool;
    };
    ExecutionPlan.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: this.props.expandedByDefault, errorKey: "ActionExecutionLocation", title: "Execution Location", summary: this.executionLocationSummary(), help: "Choose the execution location Octopus should use for this step. ", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight }, this.renderRunOnOptions()),
            this.renderRolesOptions());
    };
    ExecutionPlan.prototype.executionLocationSummary = function () {
        var summary = [React.createElement("span", null, "This step will run")];
        if (this.state.targetWorkerPool) {
            summary.push(React.createElement("span", null,
                " on a ",
                React.createElement("strong", null, "worker"),
                " from the worker pool"));
        }
        else {
            // keeping these as four cases not two and combining the if checks because I am
            // not sure of the priority of Octopus.Action.RunOnServer over props.executionLocation
            if (this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnServer) {
                summary.push(React.createElement("span", null,
                    " on the ",
                    React.createElement("strong", null, "Octopus Server")));
            }
            else if (this.props.executionLocation === resources_1.ActionExecutionLocation.AlwaysOnTarget) {
                summary.push(React.createElement("span", null,
                    " on each ",
                    React.createElement("strong", null, "deployment target")));
            }
            else if (this.props.runOn === ActionDetails_1.RunOn.DeploymentTarget) {
                summary.push(React.createElement("span", null,
                    " on each ",
                    React.createElement("strong", null, "deployment target")));
            }
            else {
                summary.push(React.createElement("span", null,
                    " on the ",
                    React.createElement("strong", null, "Octopus Server")));
            }
        }
        if (this.props.targetRoleOption === ActionDetails_1.TargetRoles.None) {
            summary.push(React.createElement("p", null));
            return form_1.Summary.summary(React.Children.toArray(summary));
        }
        if (this.props.runOn === ActionDetails_1.RunOn.OctopusServerForRoles || this.props.runOn === ActionDetails_1.RunOn.WorkerPoolForRoles) {
            summary.push(React.createElement("span", null, " on behalf of each deployment target"));
        }
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ExecutionPlan.prototype.WorkerPoolSummary = function () {
        var _this = this;
        var worker = this.props.availableWorkerPools.find(function (element) { return element.Id === _this.state.targetWorkerPool; });
        return worker ? React.createElement(Chips_1.WorkerPoolChip, { workerPoolName: worker.Name }) : null;
    };
    ExecutionPlan.prototype.workerPoolsAvailable = function () {
        return this.props.availableWorkerPools.length > 0 && this.props.canRunOnWorker;
    };
    ExecutionPlan.prototype.rollingDeploymentSummary = function () {
        return this.state.showWindowSize
            ? React.createElement("span", null,
                "This is a rolling deployments step that will run on ",
                React.createElement("strong", null,
                    this.props.maxParallelism,
                    " target",
                    this.props.maxParallelism !== "1" ? "s" : ""),
                " at once.")
            :
                React.createElement("span", null, "This step will be run on all deployment targets in parallel.");
    };
    ExecutionPlan.prototype.roleList = function (csv) {
        var list = ParseHelper_1.default.parseCSV(csv);
        return list.map(function (r) { return React.createElement(Chips_1.RoleChip, { role: r, key: "role-" + r }); });
    };
    return ExecutionPlan;
}(React.Component));
exports.default = ExecutionPlan;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ExecutionPlan.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ExecutionPlan.tsx"); } } })();

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "execute-targets.daf80f4e98b07ba2daf3765451f96654.hashedasset.svg";

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "execute-worker.e0e680f0b933fc177af6791910a895cd.hashedasset.svg";

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "execute-worker-roles.9ea296e63b07a9538130fe6f06ffe364.hashedasset.svg";

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "execute-octopus-server.ef2ee1e596133aeab3c28db1773315b8.hashedasset.svg";

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "execute-octopus-server-roles.11234407f0fdf17b59db872a58225dca.hashedasset.svg";

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var TagsList_1 = __webpack_require__(1989);
var AdvancedTenantSelector_1 = __webpack_require__(770);
var TenantsExpander = (function (_super) {
    __extends(TenantsExpander, _super);
    function TenantsExpander() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantsExpander.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.tenantTags !== this.props.tenantTags;
    };
    TenantsExpander.prototype.render = function () {
        var _this = this;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "tenantTags", title: "Tenants", summary: this.props.tenantTags.length > 0
                ? form_1.Summary.summary(React.createElement("span", null,
                    "This step will only run for certain tenants: ",
                    React.createElement(TagsList_1.default, { canonicalNames: this.props.tenantTags, tagIndex: this.props.tagIndex })))
                : form_1.Summary.default("This step will run for all tenants"), help: "Choose which tenants this step applies to." },
            React.createElement(form_1.Note, null, "This step will only run for tenants matching this filter. Clear the filter to make the step run for all tenants. Note: if you define a filter, this step will be skipped when performing un-tenanted deployments."),
            React.createElement(AdvancedTenantSelector_1.AdvancedTenantTagsSelector, { selectedTenantTags: this.props.tenantTags, doBusyTask: this.props.doBusyTask, onChange: function (tags) { return _this.props.onTenantTagsChange(tags); } }));
    };
    return TenantsExpander;
}(React.Component));
exports.default = TenantsExpander;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\TenantsExpander.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\TenantsExpander.tsx"); } } })();

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TagsList_1 = __webpack_require__(482);
exports.default = TagsList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TagsList\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\TagsList\\index.tsx"); } } })();

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Logo_1 = __webpack_require__(323);
var React = __webpack_require__(0);
var FormPaperLayout_1 = __webpack_require__(195);
var FormBaseComponent_1 = __webpack_require__(155);
var Text_1 = __webpack_require__(50);
var form_1 = __webpack_require__(16);
var Chips_1 = __webpack_require__(24);
var lodash_1 = __webpack_require__(11);
var ParseHelper_1 = __webpack_require__(66);
var RoleMultiSelect_1 = __webpack_require__(458);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var clientInstance_1 = __webpack_require__(10);
var RunTriggerExpander_1 = __webpack_require__(740);
var StartTriggerExpander_1 = __webpack_require__(739);
var permission_1 = __webpack_require__(51);
var projectsArea_1 = __webpack_require__(243);
var react_redux_1 = __webpack_require__(64);
var DeploymentProcessRoute_1 = __webpack_require__(328);
var routeLinks_1 = __webpack_require__(22);
var MaxParallelism_1 = __webpack_require__(741);
var InternalRedirect_1 = __webpack_require__(45);
var StepName_1 = __webpack_require__(742);
var rollingStep = __webpack_require__(735);
var ParentStepDetailsInternal = (function (_super) {
    __extends(ParentStepDetailsInternal, _super);
    function ParentStepDetailsInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            var deploymentProcess, originalStep;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(this.props.project.DeploymentProcessId)];
                                    case 1:
                                        deploymentProcess = _a.sent();
                                        originalStep = deploymentProcess.Steps.find(function (s) { return s.Id === _this.props.match.params.stepId; });
                                        originalStep.Name = this.state.model.name;
                                        originalStep.Properties = __assign({}, originalStep.Properties, this.state.model.props);
                                        originalStep.Condition = this.state.model.condition;
                                        originalStep.StartTrigger = this.state.model.startTrigger;
                                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.modify(deploymentProcess)];
                                    case 2:
                                        deploymentProcess = _a.sent();
                                        this.props.onProjectStepsUpdated(deploymentProcess.Steps ? deploymentProcess.Steps.length : null);
                                        this.reloadThePage();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var step = _this.props.step;
        var model = {
            name: step.Name,
            props: step.Properties,
            condition: step.Condition,
            startTrigger: step.StartTrigger
        };
        _this.state = {
            model: model,
            cleanModel: lodash_1.cloneDeep(model),
            showWindowSize: model.props["Octopus.Action.MaxParallelism"]
                ? model.props["Octopus.Action.MaxParallelism"].toString().length > 0
                : false
        };
        return _this;
    }
    ParentStepDetailsInternal.prototype.render = function () {
        var _this = this;
        if (this.state.redirectTo) {
            return React.createElement(InternalRedirect_1.default, { to: this.state.redirectTo });
        }
        return React.createElement(FormPaperLayout_1.default, { title: React.createElement(StepName_1.default, { name: this.state.model && this.state.model.name, number: this.props.stepNumber }), titleLogo: React.createElement(Logo_1.default, { url: rollingStep }), breadcrumbTitle: "Process", breadcrumbPath: routeLinks_1.default.project(this.props.project).process.root, busy: this.state.busy, errors: this.state.errors, model: this.state.model, cleanModel: this.state.cleanModel, savePermission: {
                permission: permission_1.default.ProcessEdit,
                project: this.props.project && this.props.project.Id,
            }, onSaveClick: this.handleSaveClick, saveText: "Step details updated" },
            React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: !this.state.model.name, errorKey: "Name", title: "Step Name", focusOnExpandAll: true, summary: this.state.model.name
                    ? form_1.Summary.summary(this.state.model.name)
                    : form_1.Summary.placeholder("Please enter a name for your step"), help: "A short, memorable, unique name for this step." },
                React.createElement(Text_1.default, { value: this.state.model.name, onChange: function (name) { return _this.setModelState({ name: name }); }, label: "Step name", autoFocus: true })),
            React.createElement(form_1.ExpandableFormSection, { isExpandedByDefault: !this.state.model.name, errorKey: "Octopus.Action.TargetRoles", title: "Execution Plan", summary: this.executionPlanSummary(), help: "Where should this step run?" },
                React.createElement(RoleMultiSelect_1.default, { label: "Runs on targets in roles", onChange: function (roles) {
                        return _this.setProperties((_a = {}, _a["Octopus.Action.TargetRoles"] = ParseHelper_1.default.encodeCSV(roles), _a));
                        var _a;
                    }, value: ParseHelper_1.default.parseCSV(this.state.model.props["Octopus.Action.TargetRoles"]), validate: function (roles) { return roles.length === 0 ? "Please enter one or more roles" : ""; }, error: this.getFieldError("Octopus.Action.TargetRoles"), items: this.props.availableRoles }),
                React.createElement(RadioButtonGroup_1.BooleanRadioButtonGroup, { onChange: function (v) {
                        _this.setState({ showWindowSize: v });
                        _this.setProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = (v ? "1" : ""), _a));
                        var _a;
                    }, value: this.state.showWindowSize },
                    React.createElement(RadioButton_1.default, { value: false, label: "Deploy to all deployment targets in parallel." }),
                    React.createElement(RadioButton_1.default, { value: true, label: "Configure a rolling deployment" })),
                this.state.showWindowSize && this.renderWindowSize()),
            React.createElement(form_1.FormSectionHeading, { title: "Conditions" }),
            React.createElement(RunTriggerExpander_1.default, { isFirstStep: this.props.isFirstStep, condition: this.state.model.condition, onConditionChange: function (condition) { return _this.setModelState({ condition: condition }); }, variableExpression: this.state.model.props["Octopus.Action.ConditionVariableExpression"], onVariableExpressionChange: function (x) {
                    return _this.setProperties((_a = {}, _a["Octopus.Action.ConditionVariableExpression"] = x, _a));
                    var _a;
                }, projectId: this.props.project.Id }),
            !this.props.isFirstStep && React.createElement(StartTriggerExpander_1.default, { startTrigger: this.state.model.startTrigger, onChange: function (startTrigger) { return _this.setModelState({ startTrigger: startTrigger }); } }));
    };
    ParentStepDetailsInternal.prototype.renderWindowSize = function () {
        var _this = this;
        var maxParallelism = this.state.model.props["Octopus.Action.MaxParallelism"];
        return React.createElement(MaxParallelism_1.default, { projectId: this.props.project.Id, value: maxParallelism, onChange: function (x) {
                return _this.setProperties((_a = {}, _a["Octopus.Action.MaxParallelism"] = x, _a));
                var _a;
            } });
    };
    ParentStepDetailsInternal.prototype.setProperties = function (properties) {
        this.setState(function (state) {
            return {
                model: __assign({}, state.model, { props: __assign({}, state.model.props, properties) })
            };
        });
    };
    ParentStepDetailsInternal.prototype.executionPlanSummary = function () {
        var summary = [React.createElement("span", null, "This step will run on")];
        var onBehalf = false;
        var roles = ParseHelper_1.default.parseCSV(this.state.model.props["Octopus.Action.TargetRoles"]);
        var parallelism = this.state.model.props["Octopus.Action.MaxParallelism"];
        if (roles.length > 0) {
            summary.push(onBehalf
                ? React.createElement("span", null, " on behalf of ")
                : roles.length > 1
                    ? React.createElement("span", null, " in roles")
                    : React.createElement("span", null, " in role"));
            roles.forEach(function (r) {
                summary.push(React.createElement(Chips_1.RoleChip, { role: r, key: "role-" + r }));
            });
        }
        if (parallelism) {
            // tslint:disable-next-line
            summary.push(React.createElement("span", null,
                "as ",
                React.createElement("strong", null, "rolling step"),
                " that will run ",
                onBehalf ? "on behalf of" : "on",
                " ",
                React.createElement("strong", null, parallelism),
                " target",
                parallelism !== "1" ? "s" : "",
                " at a time"));
        }
        else {
            summary.push(React.createElement("span", null,
                "with all targets deployed in ",
                React.createElement("strong", null, "parallel")));
        }
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ParentStepDetailsInternal.prototype.reloadThePage = function () {
        var currentPath = this.props.location.pathname;
        var reloadKey = this.props.match.params.reloadKey;
        var path = DeploymentProcessRoute_1.DeploymentProcessRoute.nextStepReloadPath(currentPath, reloadKey);
        this.setState({ redirectTo: path });
    };
    return ParentStepDetailsInternal;
}(FormBaseComponent_1.default));
var mapDispatchToProps = function (dispatch) {
    return {
        onProjectStepsUpdated: function (numberOfSteps) {
            dispatch(projectsArea_1.projectStepsUpdated(numberOfSteps));
        },
    };
};
var ParentStepDetails = react_redux_1.connect(null, mapDispatchToProps)(ParentStepDetailsInternal);
exports.default = ParentStepDetails;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ParentStepDetails.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\DeploymentProcess\\ParentStepDetails.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaperLayout_1 = __webpack_require__(131);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var CommunityActionTemplateList_1 = __webpack_require__(854);
var InstalledActionTemplateList_1 = __webpack_require__(1998);
var pluginRegistry_1 = __webpack_require__(18);
var FilterSearchBox_1 = __webpack_require__(198);
var styles = __webpack_require__(1999);
var routeLinks_1 = __webpack_require__(22);
var ActionTemplateSelector = (function (_super) {
    __extends(ActionTemplateSelector, _super);
    function ActionTemplateSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.getDetailsUrl = function (template) {
            return routeLinks_1.default.library.stepTemplates.communityTemplate(template, _this.props.match.params.projectSlug).root;
        };
        _this.getNewStepUrl = function (template) {
            return routeLinks_1.default.project(_this.props.match.params.projectSlug).process
                .stepNew(template.Type, _this.props.match.params.parentStepId, template.Id);
        };
        _this.state = {
            isLoaded: false,
            templates: [],
            childActionTypes: []
        };
        return _this;
    }
    ActionTemplateSelector.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var templates, childActionTypes;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.ActionTemplates.search()];
                                    case 1:
                                        templates = _a.sent();
                                        childActionTypes = pluginRegistry_1.default.getAllActions()
                                            .filter(function (action) { return action.canBeChild; })
                                            .map(function (action) { return action.actionType; });
                                        this.setState({ isLoaded: true, templates: templates, childActionTypes: childActionTypes });
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActionTemplateSelector.prototype.render = function () {
        var _this = this;
        return React.createElement(PaperLayout_1.default, { title: "Choose Step Template", breadcrumbTitle: "Process", breadcrumbPath: routeLinks_1.default.project(this.props.match.params.projectSlug).process.root, busy: this.state.busy, errors: this.state.errors, fullWidth: true, flatStyle: true }, this.state.isLoaded &&
            React.createElement("div", null,
                React.createElement(FilterSearchBox_1.default, { hintText: "Filter by name, category or description...", onChange: function (value) { return _this.setState({ filterText: value.toLowerCase() }); }, fullWidth: true, containerClassName: styles.filterSearchBoxContainer, autoFocus: true }),
                React.createElement(InstalledActionTemplateList_1.default, { templates: this.installedTemplates(), onDetailsUrlRequested: this.getDetailsUrl, onPostSelectionUrlRequested: this.getNewStepUrl, filter: this.state.filterText }),
                React.createElement(CommunityActionTemplateList_1.default, { templates: this.state.templates.filter(function (at) { return !at.IsInstalled; }), filter: this.state.filterText, installationActionName: "Install and add", onDetailsUrlRequested: this.getDetailsUrl, onPostSelectionUrlRequested: this.getNewStepUrl })));
    };
    ActionTemplateSelector.prototype.installedTemplates = function () {
        var _this = this;
        var installed = this.state.templates.filter(function (at) { return at.IsInstalled; });
        var parentStepId = this.props.match.params.parentStepId;
        if (!parentStepId) {
            return installed;
        }
        return installed.filter(function (at) { return _this.state.childActionTypes.includes(at.Type); });
    };
    return ActionTemplateSelector;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ActionTemplateSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\ActionTemplateSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\ActionTemplateSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Logo_1 = __webpack_require__(200);
var styles = __webpack_require__(298);
var ActionTemplateCategory = function (props) {
    var firstTemplate = props.templates[0];
    return React.createElement("li", { className: styles.actionCategory, onClick: props.onCategorySelected },
        React.createElement("div", { className: styles.logo },
            React.createElement(Logo_1.default, { url: firstTemplate.Links.Logo, size: "4.375rem" })),
        React.createElement("div", { className: styles.categoryName },
            React.createElement("small", null, props.name)));
};
ActionTemplateCategory.displayName = "ActionTemplateCategory";
exports.default = ActionTemplateCategory;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCategory.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\ActionTemplateCategory.tsx"); } } })();

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.styles_hide-sm__lYa4_{display:none!important}}@media (min-width:37.4rem){.styles_visible-sm__3PJu9{display:none!important}}@media (max-width:79.9rem){.styles_hide-md__2FW8f{display:none!important}}@media (min-width:79.9rem){.styles_visible-md__3_nD9{display:none!important}}.styles_templates__3rz1U{display:flex;flex-direction:row;flex-wrap:wrap}.styles_templates__3rz1U li{display:flex}.styles_categories__3n7So>div,.styles_categoryTemplates__1uJoA>div{display:flex;flex-direction:row;flex-wrap:wrap}.styles_categoryTemplates__1uJoA li{display:flex;height:100%}@media (max-width:37.4rem){.styles_categoryTemplates__1uJoA>div,.styles_templates__3rz1U{flex-direction:column}}.styles_actionCategory__2DARh{display:flex;flex-direction:column;justify-content:center;align-items:center;margin-left:1.25rem;margin-bottom:1rem;padding:.625rem;background:#fff;box-shadow:0 .0625rem .25rem 0 rgba(0,0,0,.12)}.styles_actionCategory__2DARh:focus,.styles_actionCategory__2DARh:hover{cursor:pointer;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.styles_categoryName__1jvQG{color:#2f93e0;text-align:center;margin-top:.8125rem;margin-bottom:.8125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:5.9375rem}.styles_actions__3qX0c{text-align:right;margin-right:1rem}.styles_onHoverActions__38l5m{display:flex;flex-direction:column;height:100%;width:100%;align-items:center;background-color:hsla(0,0%,100%,.5)}.styles_primaryAction__3X1hT{flex:4}.styles_secondaryAction__xWXcu{background-color:#fff;padding-bottom:.5rem;padding-top:.5rem;width:100%;text-align:center}.styles_empty__cfcJZ{flex:3}.styles_templateListTitle__2m-nj{background-color:hsla(0,0%,60%,.08);border-top:.0625rem dashed #ccc;border-bottom:.0625rem dashed #ccc;padding:.5rem 1.125rem;margin-right:1rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "styles_hide-sm__lYa4_",
	"hideSm": "styles_hide-sm__lYa4_",
	"visible-sm": "styles_visible-sm__3PJu9",
	"visibleSm": "styles_visible-sm__3PJu9",
	"hide-md": "styles_hide-md__2FW8f",
	"hideMd": "styles_hide-md__2FW8f",
	"visible-md": "styles_visible-md__3_nD9",
	"visibleMd": "styles_visible-md__3_nD9",
	"templates": "styles_templates__3rz1U",
	"categoryTemplates": "styles_categoryTemplates__1uJoA",
	"categories": "styles_categories__3n7So",
	"actionCategory": "styles_actionCategory__2DARh",
	"categoryName": "styles_categoryName__1jvQG",
	"actions": "styles_actions__3qX0c",
	"onHoverActions": "styles_onHoverActions__38l5m",
	"primaryAction": "styles_primaryAction__3X1hT",
	"secondaryAction": "styles_secondaryAction__xWXcu",
	"empty": "styles_empty__cfcJZ",
	"templateListTitle": "styles_templateListTitle__2m-nj"
};

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __webpack_require__(782);
exports.default = Card_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Card\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Card\\index.tsx"); } } })();

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var InternalLink_1 = __webpack_require__(43);
var Callout_1 = __webpack_require__(57);
var ExternalLink_1 = __webpack_require__(26);
var DataBaseComponent_1 = __webpack_require__(39);
var SaveDialogLayout_1 = __webpack_require__(153);
var routeLinks_1 = __webpack_require__(22);
var CommunityTemplateInstallation = (function (_super) {
    __extends(CommunityTemplateInstallation, _super);
    function CommunityTemplateInstallation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    CommunityTemplateInstallation.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                        var communityTemplate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, clientInstance_1.repository.CommunityActionTemplates.get(this.props.communityTemplateId)];
                                case 1:
                                    communityTemplate = _a.sent();
                                    this.setState({ communityTemplate: communityTemplate });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    CommunityTemplateInstallation.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var actionTemplate;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.CommunityActionTemplates.install(this.state.communityTemplate)];
                                    case 1:
                                        actionTemplate = _a.sent();
                                        return [4 /*yield*/, this.props.saveDone(actionTemplate)];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CommunityTemplateInstallation.prototype.render = function () {
        var _this = this;
        var body = this.state.communityTemplate &&
            React.createElement("div", null,
                React.createElement("h4", null,
                    React.createElement(InternalLink_1.default, { to: this.props.detailsLink }, this.state.communityTemplate.Name)),
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "This is a community contributed step that will be installed into your ",
                    React.createElement(InternalLink_1.default, { to: routeLinks_1.default.library.stepTemplates.root }, "step templates"),
                    " library. Read our ",
                    React.createElement(ExternalLink_1.default, { href: "CommunityContributedStepTemplates" }, "community step documentation"),
                    " for more information."));
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.title, busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } }, body);
    };
    return CommunityTemplateInstallation;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = CommunityTemplateInstallation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\CommunityTemplateInstallation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ActionTemplates\\CommunityTemplateInstallation.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1996 */,
/* 1997 */,
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionTemplateCard_1 = __webpack_require__(499);
var NavigationButton_1 = __webpack_require__(197);
var matchesFilter_1 = __webpack_require__(500);
var Callout_1 = __webpack_require__(57);
var permission_1 = __webpack_require__(51);
var ExternalLink_1 = __webpack_require__(26);
var InternalLink_1 = __webpack_require__(43);
var PageDivider_1 = __webpack_require__(471);
var ActionTemplateCardList_1 = __webpack_require__(501);
var PermissionCheck_1 = __webpack_require__(42);
var InstalledActionTemplateList = (function (_super) {
    __extends(InstalledActionTemplateList, _super);
    function InstalledActionTemplateList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InstalledActionTemplateList.prototype.render = function () {
        var _this = this;
        var filteredResults = this.props.templates.filter(function (at) { return matchesFilter_1.default(at, _this.props.filter); });
        if (filteredResults.length === 0 && this.props.filter) {
            return React.createElement("p", null, "There are no installed step templates that match your filter criteria.");
        }
        return React.createElement("div", null,
            React.createElement(PageDivider_1.default, null, "Installed Step Templates"),
            !PermissionCheck_1.isAllowed({ permission: permission_1.Permission.ActionTemplateView }) &&
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                    "You can't see custom installed step templates because you don't have",
                    React.createElement(ExternalLink_1.default, { href: "UserRoles" },
                        " ",
                        permission_1.Permission.ActionTemplateView),
                    " permission."),
            React.createElement(ActionTemplateCardList_1.default, null, filteredResults.map(function (template) {
                return React.createElement(ActionTemplateCard_1.default, { key: template.Type + template.Id, template: template, primaryAction: React.createElement(NavigationButton_1.NavigationButton, { label: "Add", type: NavigationButton_1.NavigationButtonType.Primary, href: _this.props.onPostSelectionUrlRequested(template) }), secondaryAction: template.HasUpdate &&
                        React.createElement(InternalLink_1.default, { size: 0.75, to: _this.props.onDetailsUrlRequested(template) }, "Update available") });
            })));
    };
    return InstalledActionTemplateList;
}(React.Component));
exports.default = InstalledActionTemplateList;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\InstalledActionTemplateList.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\projects\\components\\ActionTemplateSelector\\InstalledActionTemplateList.tsx"); } } })();

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2000);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_filterSearchBoxContainer__2em71{width:320px}", ""]);

// exports
exports.locals = {
	"filterSearchBoxContainer": "style_filterSearchBoxContainer__2em71"
};

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__12ocB{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2Lb4d{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2STES{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1UVop{display:none!important}}.style_textControl__2gK1t{flex:1 1 auto}.style_textControlKey__2qUqO{max-width:12.5rem}.style_separator__2h2-4{margin:0 2rem;font-weight:600}.style_itemContainer__35UFk{display:flex;align-items:baseline}.style_threeItemContainer__1FGh6{flex-direction:column}@media (max-width:79.9rem){.style_textControl__2gK1t{width:100%}.style_itemContainer__35UFk{flex-direction:column}.style_separator__2h2-4{display:none}}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__12ocB",
	"hideSm": "style_hide-sm__12ocB",
	"visible-sm": "style_visible-sm__2Lb4d",
	"visibleSm": "style_visible-sm__2Lb4d",
	"hide-md": "style_hide-md__2STES",
	"hideMd": "style_hide-md__2STES",
	"visible-md": "style_visible-md__1UVop",
	"visibleMd": "style_visible-md__1UVop",
	"textControl": "style_textControl__2gK1t",
	"textControlKey": "style_textControlKey__2qUqO",
	"separator": "style_separator__2h2-4",
	"itemContainer": "style_itemContainer__35UFk",
	"threeItemContainer": "style_threeItemContainer__1FGh6"
};

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GettingStartedProgress_1 = __webpack_require__(2003);
var React = __webpack_require__(0);
var permission_1 = __webpack_require__(51);
var BaseComponent_1 = __webpack_require__(12);
var gettingStartedLoader_1 = __webpack_require__(690);
var styles = __webpack_require__(233);
var GettingStartedDialog_1 = __webpack_require__(688);
var FlatButton_1 = __webpack_require__(115);
var PermissionCheck_1 = __webpack_require__(42);
var react_router_1 = __webpack_require__(76);
var WhatsNext_1 = __webpack_require__(691);
var routeLinks_1 = __webpack_require__(22);
var resolvePathWithSpaceId_1 = __webpack_require__(130);
var imageCongrats = __webpack_require__(2007);
var imageOctopus = __webpack_require__(692);
var imageEnvironments = __webpack_require__(693);
var imagePackage = __webpack_require__(694);
var imageProject = __webpack_require__(695);
var imageDeploy = __webpack_require__(696);
var GettingStartedFooter = (function (_super) {
    __extends(GettingStartedFooter, _super);
    function GettingStartedFooter(props) {
        var _this = _super.call(this, props) || this;
        _this.setDivRef = function (el) {
            _this.divEl = el;
        };
        _this.state = {
            showBar: true,
            expand: true,
            canDismiss: false,
            progressSections: null,
            showDetails: false,
            status: null,
            highlightSection: null,
            spacer: 0,
            isDashboard: _this.isDashboard(_this.props.location.pathname, _this.props.match.params.spaceId)
        };
        return _this;
    }
    GettingStartedFooter.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tasksStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!PermissionCheck_1.isAllowed({ permission: permission_1.Permission.AdministerSystem })) {
                            this.setState({
                                showBar: false
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, gettingStartedLoader_1.gettingStartedLoader.loadStatus()];
                    case 1:
                        tasksStatus = _a.sent();
                        if (!this.unmounted) {
                            if (tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                                this.setState({
                                    showBar: false
                                });
                                return [2 /*return*/];
                            }
                            this.setState({
                                expand: this.isBarExpanded()
                            });
                            if (this.divEl) {
                                this.setState({
                                    spacer: this.divEl.getBoundingClientRect().height
                                });
                            }
                            this.unsubscribe = gettingStartedLoader_1.gettingStartedLoader.subscribe(function (status) { return _this.refresh(status); });
                            this.refresh(tasksStatus);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GettingStartedFooter.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    GettingStartedFooter.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            isDashboard: this.isDashboard(nextProps.location.pathname, nextProps.match.params.spaceId)
        });
    };
    GettingStartedFooter.prototype.componentDidUpdate = function () {
        if (!this.divEl) {
            return;
        }
        var newHeight = this.divEl.getBoundingClientRect().height;
        if (this.state.spacer === newHeight) {
            return;
        }
        this.setState({
            spacer: newHeight
        });
    };
    GettingStartedFooter.prototype.render = function () {
        var _this = this;
        if (this.state.isDashboard || !this.state.showBar || !this.state.progressSections) {
            return null;
        }
        var isInEnvironmentPage = this.isInEnvironmentPage(this.props.location.pathname, this.props.match.params.spaceId);
        return React.createElement("div", null,
            this.state.showDetails && React.createElement(GettingStartedDialog_1.GettingStartedDialog, { onNavigating: function () { return _this.setState({ showDetails: false }); }, highlightSection: this.state.highlightSection, open: this.state.showDetails, onClose: function () { return _this.setState({ showDetails: false }); } }),
            React.createElement("div", { ref: this.setDivRef, className: styles.gettingStartedFooter },
                !this.state.canDismiss && React.createElement("div", { className: styles.gettingStartedFooterActions },
                    React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggle(); } },
                        React.createElement("span", null, "Hide"),
                        React.createElement("em", { className: "fa fa-minus", "aria-hidden": "true" })),
                    React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggleDetail(); } },
                        React.createElement("span", null, "Show detail"),
                        React.createElement("em", { className: "fa fa-window-maximize", "aria-hidden": "true" }))),
                !(this.state.canDismiss || this.state.expand) && React.createElement("div", { className: styles.gettingStartedMinimize },
                    React.createElement("div", { className: styles.gettingStartedFooterActions },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggle(); } },
                            React.createElement("span", null, "Show getting started guide"),
                            React.createElement("em", { className: "fa fa-plus", "aria-hidden": "true" })))),
                this.state.canDismiss && React.createElement("div", { className: styles.gettingStartedMinimize },
                    React.createElement("div", { className: styles.gettingStartedFooterActions },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.dismiss(); } },
                            React.createElement("span", null, "Thanks for your help! I don't need the progress bar anymore."),
                            React.createElement("em", { className: "fa fa-times", "aria-hidden": "true" })))),
                this.state.canDismiss && React.createElement("div", { className: styles.firstSuccessfulDeploymentContainer },
                    React.createElement("div", { className: styles.firstSuccessfulDeployment },
                        React.createElement("div", { className: styles.successAnimation },
                            React.createElement("img", { src: imageCongrats, alt: "Congratulations animation" })),
                        React.createElement("div", null,
                            React.createElement("h3", null,
                                React.createElement("strong", null, "Congratulations!")),
                            React.createElement("p", null,
                                "That was your first successful deployment for this project. We hope everything went smoothly!",
                                React.createElement("br", null),
                                " Celebrate this moment by tweeting about it."),
                            React.createElement("p", null,
                                React.createElement("strong", null, "Happy deployments!"),
                                React.createElement("br", null),
                                "- The team at Octopus"),
                            React.createElement("div", null,
                                React.createElement(FlatButton_1.default, { href: "https://g.octopushq.com/OctopusTweetNow?text=We just completed our first successful deployment with @OctopusDeploy!", target: "_blank", label: "Tweet now", labelStyle: { color: "#2f93e0" }, icon: React.createElement("em", { style: { color: "#2f93e0" }, className: "fa fa-twitter", "aria-hidden": "true" }) }))))),
                !this.state.canDismiss && this.state.expand && React.createElement("div", { className: styles.gettingStartedContent },
                    React.createElement("div", { className: styles.whatsNextContainer }, this.renderWhatsNext(isInEnvironmentPage)),
                    React.createElement("div", { className: styles.progressStepWrapper }, this.state.progressSections.map(function (s) { return React.createElement("span", { key: s.header, className: styles.progressStep },
                        React.createElement("a", { className: styles.gettingStartedButton, onClick: function () { return _this.toggleDetail(s.header); } },
                            React.createElement(GettingStartedProgress_1.default, { percent: s.percent, enabled: s.enabled, imgSrc: s.image, header: s.header }))); })))),
            React.createElement("div", { style: { paddingTop: this.state.spacer + "px" } }));
    };
    GettingStartedFooter.prototype.renderWhatsNext = function (isInEnvironmentPage) {
        var whatsNext = WhatsNext_1.default(isInEnvironmentPage, this.state.status.next, this.state.status.projects, this.state.status.releases);
        return React.createElement("div", { className: styles.whatsNext },
            React.createElement("div", { className: styles.whatsNextText }, whatsNext.text),
            whatsNext.element);
    };
    GettingStartedFooter.prototype.dismiss = function () {
        this.setState({ showBar: false });
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    };
    GettingStartedFooter.prototype.isDashboard = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.root, spaceId) === path ||
            resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.dashboard.root, spaceId) === path;
    };
    GettingStartedFooter.prototype.isInEnvironmentPage = function (path, spaceId) {
        return resolvePathWithSpaceId_1.resolveStringPathWithSpaceId(routeLinks_1.default.infrastructure.environments.root, spaceId) === path;
    };
    GettingStartedFooter.prototype.toggleDetail = function (highlightSection) {
        this.setState({ showDetails: true, highlightSection: highlightSection });
    };
    GettingStartedFooter.prototype.toggle = function () {
        localStorage.setItem("gettingStartedProgressBarExpanded", (!this.state.expand).toString());
        this.setState({
            expand: !this.state.expand
        });
    };
    GettingStartedFooter.prototype.isBarExpanded = function () {
        if (localStorage.getItem("gettingStartedProgressBarExpanded") !== null) {
            return localStorage.getItem("gettingStartedProgressBarExpanded") === "true" ? true : false;
        }
        return true;
    };
    GettingStartedFooter.prototype.refresh = function (status) {
        var sections = [{
                percent: 100,
                enabled: true,
                image: imageOctopus,
                header: "OCTOPUS SERVER"
            },
            {
                percent: status.tasks.Infrastructure.Percent,
                enabled: status.tasks.Infrastructure.IsEnabled,
                image: imageEnvironments,
                header: "INFRASTRUCTURE"
            },
            {
                percent: status.tasks.Package.Percent,
                enabled: status.tasks.Package.IsEnabled,
                image: imagePackage,
                header: "PACKAGING"
            },
            {
                percent: status.tasks.Project.Percent,
                enabled: status.tasks.Project.IsEnabled,
                image: imageProject,
                header: "PROJECT"
            },
            {
                percent: status.tasks.Deploy.Percent,
                enabled: status.tasks.Deploy.IsEnabled,
                image: imageDeploy,
                header: "DEPLOY"
            }];
        if (status.tasks.Deploy.DeployedRelease.IsComplete) {
            this.setState({
                canDismiss: true
            });
        }
        this.setState({
            status: status,
            progressSections: sections
        });
    };
    return GettingStartedFooter;
}(BaseComponent_1.BaseComponent));
exports.default = react_router_1.withRouter(GettingStartedFooter);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedFooter.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedFooter.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CircularProgressbar_1 = __webpack_require__(2004);
var React = __webpack_require__(0);
var styles = __webpack_require__(233);
var GettingStartedProgress = function (props) { return React.createElement("div", { className: styles.progressWrapper },
    props.percent === 100 && React.createElement("div", { className: styles.complete },
        React.createElement("em", { className: "fa fa-check", "aria-hidden": "true" })),
    React.createElement("div", { className: styles.progressContainer },
        React.createElement(CircularProgressbar_1.default, { percentage: props.percent, strokeWidth: 6, image: props.imgSrc })),
    React.createElement("div", { className: styles.title }, props.header)); };
exports.default = GettingStartedProgress;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedProgress.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\GettingStartedProgress.tsx"); } } })();

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(2005);
var MIN_PERCENTAGE = 0;
var MAX_PERCENTAGE = 100;
var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar(props) {
        return _super.call(this, props) || this;
    }
    CircularProgressbar.prototype.getPathDescription = function () {
        var radius = this.getRadius();
        return "\n      M 50,50 m 0,-" + radius + "\n      a " + radius + "," + radius + " 0 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " 0 1 1 0,-" + 2 * radius + "\n    ";
    };
    CircularProgressbar.prototype.getProgressStyle = function () {
        var diameter = Math.PI * 2 * this.getRadius();
        var truncatedPercentage = Math.min(Math.max(this.props.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
        return {
            strokeDasharray: diameter + "px " + diameter + "px",
            strokeDashoffset: ((100 - truncatedPercentage) / 100 * diameter) + "px",
            fill: "#fff"
        };
    };
    CircularProgressbar.prototype.getRadius = function () {
        return (50 - this.props.strokeWidth / 2);
    };
    CircularProgressbar.prototype.render = function () {
        var pathDescription = this.getPathDescription();
        return (React.createElement("svg", { className: styles.CircularProgressbar, viewBox: "0 0 100 100" },
            React.createElement("path", { className: styles.CircularProgressbarTrail, d: pathDescription, strokeWidth: this.props.strokeWidth, fillOpacity: 1 }),
            React.createElement("path", { className: styles.CircularProgressbarPath, d: pathDescription, strokeWidth: this.props.percentage === 0 ? 0 : this.props.strokeWidth, fillOpacity: 1, style: this.getProgressStyle() }),
            React.createElement("image", { xlinkHref: this.props.image, x: 25, y: 27, width: "50", height: "45" })));
    };
    return CircularProgressbar;
}(React.Component));
exports.default = CircularProgressbar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\CircularProgressbar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\GettingStarted\\CircularProgressbar.tsx"); } } })();

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2006);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CircularProgressbar.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CircularProgressbar.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".CircularProgressbar_CircularProgressbar__3sS_v{width:100%}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarPath__3Wumb{stroke:#48b350;stroke-linecap:round;transition:stroke-dashoffset .5s ease 0s}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarTrail__11oh0{stroke:#fff}.CircularProgressbar_CircularProgressbar__3sS_v .CircularProgressbar_CircularProgressbarText__2yDaK{fill:#2f93e0;font-size:1.25rem;text-anchor:middle}", ""]);

// exports
exports.locals = {
	"CircularProgressbar": "CircularProgressbar_CircularProgressbar__3sS_v",
	"circularProgressbar": "CircularProgressbar_CircularProgressbar__3sS_v",
	"CircularProgressbarPath": "CircularProgressbar_CircularProgressbarPath__3Wumb",
	"circularProgressbarPath": "CircularProgressbar_CircularProgressbarPath__3Wumb",
	"CircularProgressbarTrail": "CircularProgressbar_CircularProgressbarTrail__11oh0",
	"circularProgressbarTrail": "CircularProgressbar_CircularProgressbarTrail__11oh0",
	"CircularProgressbarText": "CircularProgressbar_CircularProgressbarText__2yDaK",
	"circularProgressbarText": "CircularProgressbar_CircularProgressbarText__2yDaK"
};

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "success-ani.cff96f558ccecff5d03a7aec739a2efe.hashedasset.svg";

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ExternalLink_1 = __webpack_require__(91);
var clientInstance_1 = __webpack_require__(10);
var Divider_1 = __webpack_require__(162);
var DataBaseComponent_1 = __webpack_require__(39);
var ErrorPanel_1 = __webpack_require__(85);
var Callout_1 = __webpack_require__(57);
var styles = __webpack_require__(2009);
var SystemMessagesBanner = (function (_super) {
    __extends(SystemMessagesBanner, _super);
    function SystemMessagesBanner(props) {
        var _this = _super.call(this, props) || this;
        var browserNotSupported = false;
        var browserName = "";
        var ieVersion = document["documentMode"];
        if (ieVersion && ieVersion <= 10) {
            browserNotSupported = true;
            browserName = "Internet Explorer " + ieVersion;
        }
        _this.state = {
            isInMaintenanceMode: false,
            browserNotSupported: browserNotSupported,
            browserName: browserName
        };
        return _this;
    }
    SystemMessagesBanner.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRefreshLoop(function () { return _this.refreshData(); }, 10000)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SystemMessagesBanner.prototype.refreshData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.ServerStatus.getServerStatus()];
                    case 1:
                        status = _a.sent();
                        return [2 /*return*/, { isInMaintenanceMode: status.IsInMaintenanceMode }];
                }
            });
        });
    };
    SystemMessagesBanner.prototype.render = function () {
        return React.createElement("div", { className: styles.pageBanners },
            this.state.isInMaintenanceMode && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                React.createElement("p", { className: styles.warning }, "This Octopus Server is currently undergoing maintenance, and is read-only. Only Octopus administrators may make changes.")),
            this.state.errors && React.createElement(ErrorPanel_1.default, { message: this.state.errors.message, details: this.state.errors.details }),
            this.state.isInMaintenanceMode && this.state.browserNotSupported && React.createElement(Divider_1.default, null),
            this.state.browserNotSupported && React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                React.createElement("p", { className: styles.warning },
                    "Your current browser, ",
                    React.createElement("strong", null, this.state.browserName),
                    ", is not supported in ",
                    React.createElement("strong", null, "Octopus 4"),
                    ". We still allow you to use Octopus but no guarantee that everything works!",
                    React.createElement("br", null),
                    "If you have any questions or feedback then please share them with us ",
                    React.createElement("strong", null,
                        React.createElement(ExternalLink_1.default, { href: "https://github.com/OctopusDeploy/Issues/issues/3457" }, "here")),
                    ".")));
    };
    return SystemMessagesBanner;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = SystemMessagesBanner;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SystemMessagesBanner\\SystemMessagesBanner.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\SystemMessagesBanner\\SystemMessagesBanner.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2010);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_pageBanners__1DkZ_{display:flex;flex-direction:column;background-color:#fff}.style_warning__luMpL{width:100%;text-align:center}", ""]);

// exports
exports.locals = {
	"pageBanners": "style_pageBanners__1DkZ_",
	"warning": "style_warning__luMpL"
};

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SignIn_1 = __webpack_require__(2012);
exports.default = SignIn_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\index.tsx"); } } })();

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Checkbox_1 = __webpack_require__(121);
var AuthProvider_1 = __webpack_require__(2013);
var clientInstance_1 = __webpack_require__(10);
var URI = __webpack_require__(120);
var logger_1 = __webpack_require__(102);
var cn = __webpack_require__(19);
var form_1 = __webpack_require__(16);
var Button_1 = __webpack_require__(47);
var environment_1 = __webpack_require__(266);
var loginStateCalculator_1 = __webpack_require__(2016);
var ErrorPanel_1 = __webpack_require__(85);
var BaseComponent_1 = __webpack_require__(60);
var ExternalLink_1 = __webpack_require__(91);
var styles = __webpack_require__(2017);
var PageTitleHelper_1 = __webpack_require__(245);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var waitingForOctopusImagePath = __webpack_require__(503);
var SignIn = (function (_super) {
    __extends(SignIn, _super);
    function SignIn(props) {
        var _this = _super.call(this, props) || this;
        _this.passwordField = null;
        _this.authenticate = function (userName, password, rememberMe) { return __awaiter(_this, void 0, void 0, function () {
            var loginCommand, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        logger_1.default.log("Attempting to sign in: " + userName);
                        loginCommand = {
                            Username: userName,
                            Password: password,
                            RememberMe: rememberMe,
                            State: this.state.loginState
                        };
                        return [4 /*yield*/, clientInstance_1.repository.Users.signIn(loginCommand)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onExternalAuthenticationProviderError = function (error) {
            _this.setError(error);
        };
        _this.signIn = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var busyIndicator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        busyIndicator = this.authenticate(this.state.userName, this.state.password, this.state.rememberMe);
                        this.setState({ busyIndicator: busyIndicator });
                        return [4 /*yield*/, busyIndicator];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.signInAsGuest = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticate("guest", "guest", true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.hideAccountTypeSelector = function () {
            _this.setState({ showAccountTypeSelector: false });
        };
        PageTitleHelper_1.default.setRootPageTitle();
        var from = ((_this.props.location && _this.props.location.state) ? _this.props.location.state : { from: { pathname: "/" } }).from;
        _this.state = {
            inProgressMessage: "Trying to connect to Octopus",
            isReady: false,
            redirectToReferrer: false,
            showAccountTypeSelector: false,
            shouldAutoSignIn: false,
            autoSignInProviderName: "",
            userName: "",
            password: "",
            rememberMe: false,
            loginState: _this.calculateLoginState(from.pathname + (from.search || ""))
        };
        return _this;
    }
    SignIn.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var alreadyAuthenticated, browserURI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.client.connect(function (progress, indicator) {
                            logger_1.default.log(progress);
                            _this.setState({ inProgressMessage: progress });
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.continueIfAlreadyAuthenticated()];
                    case 2:
                        alreadyAuthenticated = _a.sent();
                        if (!!alreadyAuthenticated) return [3 /*break*/, 4];
                        browserURI = URI(window.location);
                        browserURI.hasQuery("error", function (error) {
                            if (!error) {
                                return;
                            }
                            _this.setError(error);
                        });
                        return [4 /*yield*/, this.setupAuthenticationProviders()];
                    case 3:
                        _a.sent();
                        this.chromeAutoFillFix();
                        _a.label = 4;
                    case 4:
                        this.setState({ isReady: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.render = function () {
        var _this = this;
        var from = ((this.props.location && this.props.location.state) ? this.props.location.state : { from: { pathname: routeLinks_1.default.root } }).from;
        if (!this.state.isReady) {
            return this.progressStatus();
        }
        if (this.state.redirectToReferrer) {
            return React.createElement(InternalRedirect_1.default, { to: from });
        }
        return React.createElement("div", { className: styles.container }, !this.anyAuthenticationProviders ?
            this.noAuthenticationProvidersEnabled()
            :
                React.createElement("div", null, this.state.showAccountTypeSelector ?
                    this.accountTypeSelection()
                    :
                        React.createElement("div", null,
                            React.createElement("div", { className: styles.content },
                                React.createElement("div", { className: styles.logo },
                                    React.createElement("div", null,
                                        React.createElement("em", { className: "fontoctopus-octopus" })),
                                    !this.state.authenticationError && React.createElement("div", null, this.state.shouldAutoSignIn
                                        ? React.createElement("h4", null, "Signing in, please wait...")
                                        : React.createElement("h4", null, "Welcome! Please sign in."))),
                                this.state.authenticationError && this.showError(this.state.authenticationError),
                                (this.anyFormsAuthenticationProviders || this.formsProvidersWithLinks.length > 0) && !this.state.shouldAutoSignIn &&
                                    React.createElement("div", null,
                                        this.anyFormsAuthenticationProviders &&
                                            React.createElement("form", { onSubmit: this.signIn, className: styles.form },
                                                React.createElement(form_1.Text, { value: this.state.userName, label: "Username", onChange: function (userName) { return _this.setState({ userName: userName }); }, autoFocus: true, name: "userName", id: "userName" }),
                                                React.createElement(form_1.Text, { label: "Password", textInputRef: function (ref) { return _this.passwordField = ref; }, value: this.state.password, name: "password", id: "password", type: "password", onChange: function (password) { return _this.setState({ password: password }); } }),
                                                React.createElement(Checkbox_1.default, { label: "Remember me on this computer", onChange: function (rememberMe) { return _this.setState({ rememberMe: rememberMe }); }, value: this.state.rememberMe, className: styles.rememberMe }),
                                                React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "SIGN IN", busyLabel: "SIGNING IN...", onClick: this.signIn })),
                                        this.formsProvidersWithLinks.map(function (p) {
                                            return React.createElement("div", { className: styles.externalAuthProvider, key: p.Name },
                                                React.createElement(AuthProvider_1.default, { provider: p, shouldAutoSignIn: _this.state.shouldAutoSignIn, autoSignInProviderName: _this.state.autoSignInProviderName, loginState: _this.state.loginState, onError: _this.onExternalAuthenticationProviderError }));
                                        })),
                                this.anyNonFormsAuthenticationProviders &&
                                    React.createElement("div", { className: styles.externalNonFormsProviders }, this.nonFormsAuthenticationProviders.map(function (p) {
                                        return React.createElement("div", { className: styles.externalAuthProvider, key: p.Name },
                                            React.createElement(AuthProvider_1.default, { provider: p, shouldAutoSignIn: _this.state.shouldAutoSignIn, autoSignInProviderName: _this.state.autoSignInProviderName, loginState: _this.state.loginState, onError: _this.onExternalAuthenticationProviderError }));
                                    }))),
                            this.isGuestProviderEnabled &&
                                React.createElement("div", { className: styles.guestProvider, onClick: this.signInAsGuest },
                                    React.createElement("a", null, "I AM A GUEST")))));
    };
    SignIn.prototype.setError = function (error) {
        if (!error) {
            return;
        }
        logger_1.default.error(error);
        var authenticationError = {
            ErrorMessage: error.ErrorMessage || error.message || error.toString(),
            Errors: error.Errors || []
        };
        this.setState({ authenticationError: authenticationError });
    };
    SignIn.prototype.progressStatus = function () {
        return React.createElement("div", null,
            React.createElement("img", { src: waitingForOctopusImagePath, alt: "Waiting" }),
            React.createElement("div", { className: styles.inProgressMessage }, this.state.inProgressMessage),
            this.state.authenticationError && this.showError(this.state.authenticationError));
    };
    SignIn.prototype.accountTypeSelection = function () {
        return React.createElement("div", { className: cn(styles.accountTypeSelection, styles.areas) },
            React.createElement("div", { className: styles.guestAccount, onClick: this.signInAsGuest },
                React.createElement("div", { className: styles.guestAccountIcon }),
                React.createElement("h2", null, "I am a guest")),
            React.createElement("div", { className: styles.authenticatedAccount, onClick: this.hideAccountTypeSelector },
                React.createElement("div", { className: styles.authenticatedAccountIcon }),
                React.createElement("h2", null, "I have an account")));
    };
    SignIn.prototype.setupAuthenticationProviders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var document, formsAuthenticationProviders, singleNonFormsAuthenticationProvider, showAccountTypeSelector, shouldAutoSignIn, autoSignInProviderName, provider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Authentication.get()];
                    case 1:
                        document = _a.sent();
                        this.authenticationProviders = document.AuthenticationProviders;
                        this.nonFormsAuthenticationProviders = this.authenticationProviders.filter(function (p) {
                            return !p.FormsLoginEnabled && !_this.isActiveDirectory(p) && p.IdentityType !== "Guest";
                        });
                        formsAuthenticationProviders = this.authenticationProviders.filter(function (p) {
                            return p.FormsLoginEnabled && p.IdentityType !== "Guest";
                        });
                        this.anyFormsAuthenticationProviders = formsAuthenticationProviders.length > 0;
                        this.anyNonFormsAuthenticationProviders = this.nonFormsAuthenticationProviders.length > 0;
                        this.formsProvidersWithLinks = this.authenticationProviders.filter(this.isActiveDirectory);
                        this.anyAuthenticationProviders = this.anyFormsAuthenticationProviders || this.anyNonFormsAuthenticationProviders || this.formsProvidersWithLinks.length > 0;
                        this.isGuestProviderEnabled = this.authenticationProviders.filter(function (p) { return p.IdentityType === "Guest"; }).length > 0;
                        singleNonFormsAuthenticationProvider = !this.anyFormsAuthenticationProviders &&
                            (this.nonFormsAuthenticationProviders.length === 1 || this.formsProvidersWithLinks.length === 1);
                        showAccountTypeSelector = this.isGuestProviderEnabled && !this.state.authenticationError;
                        shouldAutoSignIn = document.AutoLoginEnabled && !this.state.authenticationError && singleNonFormsAuthenticationProvider && !showAccountTypeSelector;
                        autoSignInProviderName = "";
                        if (shouldAutoSignIn) {
                            autoSignInProviderName = this.authenticationProviders[0].Name;
                        }
                        if (!this.props.location.search) return [3 /*break*/, 3];
                        return [4 /*yield*/, clientInstance_1.repository.Authentication.wasLoginInitiated(this.props.location.search)];
                    case 2:
                        provider = _a.sent();
                        if (provider && provider.WasLoginInitiated) {
                            shouldAutoSignIn = true;
                            autoSignInProviderName = provider.ProviderName;
                        }
                        _a.label = 3;
                    case 3:
                        this.setState({ showAccountTypeSelector: showAccountTypeSelector, shouldAutoSignIn: shouldAutoSignIn, autoSignInProviderName: autoSignInProviderName });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.authenticationSucceeded = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startSession(user)];
                    case 1:
                        _a.sent();
                        this.setState({ redirectToReferrer: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.startSession = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, permissionSet, features, error_2, message, reason, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([clientInstance_1.repository.Users.getPermissions(user), clientInstance_1.repository.FeaturesConfiguration.get()])];
                    case 1:
                        _a = _b.sent(), permissionSet = _a[0], features = _a[1];
                        clientInstance_1.session.start(user, permissionSet.Permissions, features);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        logger_1.default.log(error_2);
                        message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";
                        reason = (error_2.StatusCode === 401)
                            ? "This can happen if the Octopus authentication cookie is blocked."
                            : "There was a problem communicating with the Octopus Server: " + error_2.ErrorMessage;
                        errorMessage = message + reason;
                        this.setError(errorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SignIn.prototype.isActiveDirectory = function (provider) {
        return provider.Name === "Active Directory";
    };
    SignIn.prototype.continueIfAlreadyAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, authenticationError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, clientInstance_1.repository.Users.getCurrent()];
                    case 1:
                        user = _a.sent();
                        logger_1.default.log("User already authenticated");
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        authenticationError_1 = _a.sent();
                        logger_1.default.log(authenticationError_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    SignIn.prototype.noAuthenticationProvidersEnabled = function () {
        return React.createElement("div", null,
            "There are no authentication providers enabled. Learn about enabling ",
            React.createElement(ExternalLink_1.default, { href: "AuthenticationProviders" }, "authentication providers"));
    };
    SignIn.prototype.calculateLoginState = function (redirectToPath) {
        return loginStateCalculator_1.default(location.href, redirectToPath, environment_1.default.isInDevelopmentMode());
    };
    SignIn.prototype.showError = function (authenticationError) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: authenticationError.ErrorMessage, details: authenticationError.Errors }));
    };
    SignIn.prototype.chromeAutoFillFix = function () {
        var _this = this;
        //Sniff for chrome
        if (!window.hasOwnProperty("chrome")) {
            return;
        }
        // When chrome autofills a password it doesn't actually put the value
        // in until the page gets clicked, but it does show the password placeholders.
        // So the text control is still in "no value" state and the label sits
        // under the placeholders.
        // Poll for the appearance of the pseudo-class chrome adds, and if we find
        // it force the control into "has value" mode.
        // More details https://stackoverflow.com/questions/35049555/chrome-autofill-autocomplete-no-value-for-password
        var checkForAutofill = setInterval(function () {
            var filled = document.querySelector("input[type=password]:-webkit-autofill");
            if (filled && _this.passwordField) {
                _this.passwordField.forceHasValue();
                clearInterval(checkForAutofill);
            }
        }, 250);
        setTimeout(function () { return clearInterval(checkForAutofill); }, 5000);
    };
    return SignIn;
}(BaseComponent_1.default));
exports.default = SignIn;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\SignIn.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\SignIn.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthProvider_1 = __webpack_require__(2014);
exports.default = AuthProvider_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthProvider\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthProvider\\index.tsx"); } } })();

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(33);
var clientInstance_1 = __webpack_require__(10);
var logger_1 = __webpack_require__(102);
var extensionsManager_1 = __webpack_require__(744);
var $script = __webpack_require__(2015);
var AuthProvider = (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, provider, loginState, shouldAutoSignIn, autoSignInProviderName, onError;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, provider = _a.provider, loginState = _a.loginState, shouldAutoSignIn = _a.shouldAutoSignIn, autoSignInProviderName = _a.autoSignInProviderName, onError = _a.onError;
                        return [4 /*yield*/, Promise.all(this.loadCSS(provider.CSSLinks))];
                    case 1:
                        _b.sent();
                        $script(provider.JavascriptLinks.map(function (link) {
                            logger_1.default.log("Loading JS " + link);
                            return clientInstance_1.client.resolve(link);
                        }), provider.Name);
                        $script.ready(provider.Name, function () {
                            var extension = extensionsManager_1.default.getExtension(provider.Name, "auth_provider");
                            if (!extension) {
                                logger_1.default.error("Could not find authentication " + provider.Name + " extension");
                            }
                            var authProvider = extension(clientInstance_1.client, provider, loginState, onError);
                            if (!shouldAutoSignIn) {
                                var node = ReactDOM.findDOMNode(_this.refs.root);
                                node.innerHTML = authProvider.LinkHtml;
                                node.addEventListener("click", authProvider.SignIn);
                            }
                            if (shouldAutoSignIn && provider.Name === autoSignInProviderName) {
                                authProvider.SignIn();
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthProvider.prototype.render = function () {
        return (
        // tslint:disable:jsx-no-string-ref
        React.createElement("div", { ref: "root" }));
    };
    AuthProvider.prototype.loadCSS = function (urls) {
        return urls.map(function (url) {
            logger_1.default.log("Loading CSS " + url);
            return new Promise(function (resolve, reject) {
                var linkElement = document.createElement("link");
                linkElement.setAttribute("rel", "stylesheet");
                linkElement.setAttribute("type", "text/css");
                linkElement.setAttribute("href", clientInstance_1.client.resolve(url));
                document.getElementsByTagName("head")[0].appendChild(linkElement);
                resolve();
            });
        });
    };
    return AuthProvider;
}(React.Component));
exports.default = AuthProvider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthProvider\\AuthProvider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthProvider\\AuthProvider.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2015 */,
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URI = __webpack_require__(120);
function calculateLoginState(currentAbsoluteUrl, redirectToPath, isInDevelopmentMode) {
    if (!currentAbsoluteUrl) {
        throw new Error("url must be set to a value");
    }
    var octopusServerKey = "octopus.server";
    var octopusServerIndex = currentAbsoluteUrl.indexOf(octopusServerKey);
    var pathName = octopusServerIndex !== -1 ?
        new URI(currentAbsoluteUrl.substring(octopusServerIndex + octopusServerKey.length + 1)).fragment()
        :
            new URI(currentAbsoluteUrl).fragment();
    var targetUrl = currentAbsoluteUrl.toString().replace(pathName, redirectToPath);
    return {
        RedirectAfterLoginTo: isInDevelopmentMode ? targetUrl : toRelative(targetUrl),
        UsingSecureConnection: currentAbsoluteUrl.startsWith("https://")
    };
}
function toRelative(url) {
    return (new URI(url)).resource();
}
exports.default = calculateLoginState;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\loginStateCalculator.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignIn\\loginStateCalculator.ts"); } } })();

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2018);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__2PH9g{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__n8_HP{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2Arrc{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2qUvv{display:none!important}}.style_container__2bfgY{margin:auto;position:relative;display:table-cell;vertical-align:middle}.style_content__gi25K{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;width:22.5rem}.style_content__gi25K,.style_content__gi25K form{display:flex;flex-direction:column;align-items:center}.style_content__gi25K form{margin:1rem 0 1.5rem}.style_rememberMe__1sdtJ{margin-top:1.5rem;margin-bottom:1.5rem}.style_logo__wUwUk{color:#fff;font-size:2rem;background-color:#2f93e0;display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}.style_logo__wUwUk h4{margin:0 0 1rem!important}.style_logo__wUwUk>div:first-child{margin:1rem 0}.style_externalAuthProvider__r6K6E{text-align:center;width:18rem;margin:1rem auto}.style_externalNonFormsProviders__2i6nn{background:hsla(0,0%,60%,.08);padding:1rem 0;width:100%}.style_guestProvider__3ormK{text-align:center;margin:1rem auto;cursor:pointer;color:#2f93e0}.style_authenticationError__14bBt{width:100%}.style_accountTypeSelection__gPucf{display:flex;flex-direction:row;align-items:center;justify-content:center;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2)}@media (max-width:37.4rem){.style_accountTypeSelection__gPucf{flex-direction:column}}.style_guestAccount__qkhDh{background-color:#fff;color:#2f93e0;cursor:pointer;display:flex;flex-direction:column;justify-content:baseline;width:19rem;height:19rem;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_guestAccount__qkhDh .style_guestAccountIcon__5EoW7{background-image:url(" + __webpack_require__(2019) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_authenticatedAccount__5T_hi{background-color:#2f93e0;color:#fff;cursor:pointer;display:flex;flex-direction:column;justify-content:baseline;width:19rem;height:19rem;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_inProgressMessage__1EGl9{text-align:center}.style_authenticatedAccountIcon__1ZBkV{background-image:url(" + __webpack_require__(745) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_areas__BVG70>div{opacity:1;transition:all .5s linear}.style_areas__BVG70:hover>.style_authenticatedAccount__5T_hi:hover,.style_areas__BVG70:hover>.style_guestAccount__qkhDh:hover{opacity:1;transition:all .5s linear;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_areas__BVG70:hover>.style_authenticatedAccount__5T_hi:not(:hover),.style_areas__BVG70:hover>.style_guestAccount__qkhDh:not(:hover){opacity:.5;transition:all .5s linear}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__2PH9g",
	"hideSm": "style_hide-sm__2PH9g",
	"visible-sm": "style_visible-sm__n8_HP",
	"visibleSm": "style_visible-sm__n8_HP",
	"hide-md": "style_hide-md__2Arrc",
	"hideMd": "style_hide-md__2Arrc",
	"visible-md": "style_visible-md__2qUvv",
	"visibleMd": "style_visible-md__2qUvv",
	"container": "style_container__2bfgY",
	"content": "style_content__gi25K",
	"rememberMe": "style_rememberMe__1sdtJ",
	"logo": "style_logo__wUwUk",
	"externalAuthProvider": "style_externalAuthProvider__r6K6E",
	"externalNonFormsProviders": "style_externalNonFormsProviders__2i6nn",
	"guestProvider": "style_guestProvider__3ormK",
	"authenticationError": "style_authenticationError__14bBt",
	"accountTypeSelection": "style_accountTypeSelection__gPucf",
	"guestAccount": "style_guestAccount__qkhDh",
	"guestAccountIcon": "style_guestAccountIcon__5EoW7",
	"authenticatedAccount": "style_authenticatedAccount__5T_hi",
	"inProgressMessage": "style_inProgressMessage__1EGl9",
	"authenticatedAccountIcon": "style_authenticatedAccountIcon__1ZBkV",
	"areas": "style_areas__BVG70"
};

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "starfish.790888107b17ffd42ac5f115f1b2c956.hashedasset.svg";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SignOut_1 = __webpack_require__(2021);
exports.default = SignOut_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignOut\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignOut\\index.tsx"); } } })();

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Button_1 = __webpack_require__(47);
var clientInstance_1 = __webpack_require__(10);
var BaseComponent_1 = __webpack_require__(60);
var styles = __webpack_require__(2022);
var ErrorPanel_1 = __webpack_require__(85);
var PageTitleHelper_1 = __webpack_require__(245);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var SignOut = (function (_super) {
    __extends(SignOut, _super);
    function SignOut(props) {
        var _this = _super.call(this, props) || this;
        _this.goBack = function () {
            _this.props.history.goBack();
        };
        _this.signOut = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, clientInstance_1.repository.Users.signOut()];
                    case 1:
                        _a.sent();
                        clientInstance_1.session.end();
                        this.setState({ isSignedOut: true });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        error = {
                            message: err_1.ErrorMessage || err_1.message || err_1.toString(),
                            details: err_1.Errors || []
                        };
                        this.setState({ error: error });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        PageTitleHelper_1.default.setRootPageTitle();
        _this.state = { isSignedOut: false };
        return _this;
    }
    SignOut.prototype.render = function () {
        return this.state.isSignedOut ? React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.currentUser.signIn }) :
            React.createElement("div", { className: styles.content },
                !this.state.error && React.createElement("div", { className: styles.logo },
                    React.createElement("em", { className: "fontoctopus-octopus" })),
                this.state.error && this.showError(this.state.error),
                React.createElement("div", { className: styles.description },
                    React.createElement("h3", null, "Are you sure you want to sign out?"),
                    React.createElement("p", null,
                        "Clicking ",
                        React.createElement("strong", null, "Sign out"),
                        " will clear our cookies and log you out on this device."),
                    React.createElement("div", null,
                        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "SIGN OUT", busyLabel: "SIGNING OUT...", onClick: this.signOut })),
                    React.createElement("div", { className: styles.back },
                        React.createElement("a", { href: "#", onClick: this.goBack }, "No, I want to stay!"))));
    };
    SignOut.prototype.showError = function (error) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: error.message, details: error.details }));
    };
    return SignOut;
}(BaseComponent_1.default));
exports.default = SignOut;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignOut\\SignOut.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\SignOut\\SignOut.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2023);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__33tvz{display:flex;flex-direction:column;text-align:center}.style_container__33tvz>*{margin:1.5rem 0 0}.style_content__1LOJa{display:flex;flex-direction:column;align-items:center;background:#fff;width:23.5rem;text-align:center;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14)}.style_description__27bFu{padding:0 1.5rem 1.5rem;width:100%}.style_back__16GgO{padding-top:1.5rem}.style_logo__1S36P{background-color:#2f93e0;color:#fff;font-size:2rem;display:flex;flex-direction:row;width:100%;justify-content:center;align-items:center;padding:.5rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__33tvz",
	"content": "style_content__1LOJa",
	"description": "style_description__27bFu",
	"back": "style_back__16GgO",
	"logo": "style_logo__1S36P"
};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Register_1 = __webpack_require__(2025);
exports.default = Register_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\Register\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\Register\\index.tsx"); } } })();

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var logger_1 = __webpack_require__(102);
var form_1 = __webpack_require__(16);
var Button_1 = __webpack_require__(47);
var ErrorPanel_1 = __webpack_require__(85);
var BaseComponent_1 = __webpack_require__(60);
var ExternalLink_1 = __webpack_require__(91);
var styles = __webpack_require__(2026);
var InternalRedirect_1 = __webpack_require__(45);
var routeLinks_1 = __webpack_require__(22);
var Note_1 = __webpack_require__(20);
var CenteredLayout_1 = __webpack_require__(746);
var waitingForOctopusImagePath = __webpack_require__(503);
var Register = (function (_super) {
    __extends(Register, _super);
    function Register(props) {
        var _this = _super.call(this, props) || this;
        _this.register = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var busyIndicator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        busyIndicator = this.registerUser(this.state.userName, this.state.password);
                        this.setState({ busyIndicator: busyIndicator });
                        return [4 /*yield*/, busyIndicator];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.registerUser = function (userName, password) { return __awaiter(_this, void 0, void 0, function () {
            var result, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (this.state.password !== this.state.confirmPassword) {
                            this.setError({
                                ErrorMessage: "There was a problem with your request.",
                                Errors: ["The passwords you entered do not match."]
                            });
                            return [2 /*return*/];
                        }
                        if (userName === null || userName.trim().length === 0) {
                            this.setError({
                                ErrorMessage: "There was a problem with your request.",
                                Errors: ["Please supply a username."]
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Users.register({
                                Username: userName,
                                DisplayName: this.state.displayName,
                                EmailAddress: this.state.emailAddress,
                                Password: password,
                                InvitationCode: this.state.inviteCode,
                                IsActive: true
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Users.signIn({ Username: userName, Password: password })];
                    case 2:
                        user = _a.sent();
                        return [4 /*yield*/, this.authenticationSucceeded(user)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.setError(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            inProgressMessage: "Trying to connect to Octopus",
            isReady: false,
            redirectToReferrer: false,
            userName: "",
            password: "",
            confirmPassword: "",
            inviteCode: "",
            displayName: "",
            emailAddress: ""
        };
        return _this;
    }
    Register.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var inviteCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.client.connect(function (progress, indicator) {
                            logger_1.default.log(progress);
                            _this.setState({ inProgressMessage: progress });
                        })];
                    case 1:
                        _a.sent();
                        inviteCode = this.props.match.params.inviteCode;
                        this.setState({
                            isReady: true,
                            inviteCodeInUri: !!inviteCode,
                            inviteCode: inviteCode
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.render = function () {
        var _this = this;
        if (!this.state.isReady) {
            return this.progressStatus();
        }
        if (this.state.redirectToReferrer) {
            return React.createElement(InternalRedirect_1.default, { to: routeLinks_1.default.root });
        }
        return React.createElement(CenteredLayout_1.default, null,
            React.createElement("div", { className: styles.content },
                React.createElement("div", { className: styles.logo },
                    React.createElement("div", null,
                        React.createElement("em", { className: "fontoctopus-octopus" })),
                    !this.state.authenticationError && React.createElement("div", null,
                        React.createElement("h4", null, "Create an account to get started."))),
                this.state.authenticationError && this.showError(this.state.authenticationError),
                React.createElement("form", { onSubmit: this.register, className: styles.form },
                    !this.state.inviteCodeInUri &&
                        React.createElement(form_1.Text, { value: this.state.inviteCode, label: "Invitation code", onChange: function (inviteCode) { return _this.setState({ inviteCode: inviteCode }); } }),
                    React.createElement(form_1.Text, { value: this.state.userName, label: "Username", onChange: function (userName) { return _this.setState({ userName: userName }); }, autoFocus: true }),
                    React.createElement(form_1.Text, { value: this.state.displayName, label: "Display name", onChange: function (displayName) { return _this.setState({ displayName: displayName }); } }),
                    React.createElement(form_1.Text, { value: this.state.emailAddress, label: "Email address", onChange: function (emailAddress) { return _this.setState({ emailAddress: emailAddress }); } }),
                    React.createElement(Note_1.default, null,
                        "This will be used to show your ",
                        React.createElement(ExternalLink_1.default, { href: "Gravatar" }, "Gravatar"),
                        "."),
                    React.createElement(form_1.Text, { label: "Password", value: this.state.password, type: "password", onChange: function (password) { return _this.setState({ password: password }); } }),
                    React.createElement(form_1.Text, { value: this.state.confirmPassword, type: "password", onChange: function (confirmPassword) { return _this.setState({ confirmPassword: confirmPassword }); }, label: "Confirm password" }),
                    React.createElement("div", { className: styles.footerActions },
                        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Primary, label: "Create Account", busyLabel: "Creating...", onClick: this.register }),
                        React.createElement("div", null,
                            "or ",
                            React.createElement(Button_1.NavigationButton, { href: routeLinks_1.default.currentUser.signIn, label: "sign in" }))))));
    };
    Register.prototype.progressStatus = function () {
        return React.createElement("div", null,
            React.createElement("img", { src: waitingForOctopusImagePath, alt: "Waiting" }),
            React.createElement("div", { className: styles.inProgressMessage }, this.state.inProgressMessage),
            this.state.authenticationError && this.showError(this.state.authenticationError));
    };
    Register.prototype.authenticationSucceeded = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startSession(user)];
                    case 1:
                        _a.sent();
                        this.setState({ redirectToReferrer: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.startSession = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, permissionSet, features, error_2, message, reason, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([clientInstance_1.repository.Users.getPermissions(user), clientInstance_1.repository.FeaturesConfiguration.get()])];
                    case 1:
                        _a = _b.sent(), permissionSet = _a[0], features = _a[1];
                        clientInstance_1.session.start(user, permissionSet.Permissions, features);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        logger_1.default.log(error_2);
                        message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";
                        reason = (error_2.StatusCode === 401)
                            ? "This can happen if the Octopus authentication cookie is blocked."
                            : "There was a problem communicating with the Octopus Server: " + error_2.ErrorMessage;
                        errorMessage = message + reason;
                        this.setError(errorMessage);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.setError = function (error) {
        if (!error) {
            return;
        }
        logger_1.default.error(error);
        var authenticationError = {
            ErrorMessage: error.ErrorMessage || error.message || error.toString(),
            Errors: error.Errors || []
        };
        this.setState({ authenticationError: authenticationError });
    };
    Register.prototype.showError = function (authenticationError) {
        return React.createElement("div", { className: styles.authenticationError },
            React.createElement(ErrorPanel_1.default, { message: authenticationError.ErrorMessage, details: authenticationError.Errors }));
    };
    return Register;
}(BaseComponent_1.default));
exports.default = Register;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\Register\\Register.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\Register\\Register.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__1B6f-{margin:auto;position:relative;display:table-cell;vertical-align:middle}.style_content__3ipwL{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;width:22.5rem}.style_content__3ipwL,.style_content__3ipwL form{display:flex;flex-direction:column;align-items:center}.style_content__3ipwL form{margin:1rem 0 1.5rem}.style_rememberMe__g7_Zx{margin-top:1.5rem;margin-bottom:1.5rem}.style_logo__a7107{color:#fff;font-size:2rem;background-color:#2f93e0;display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}.style_logo__a7107 h4{margin:0 0 1rem!important}.style_logo__a7107>div:first-child{margin:1rem 0}.style_authenticationError__2jxOi{width:100%}.style_accountTypeSelection__1CPDs{display:flex;width:38rem;height:19rem;box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2)}.style_authenticatedAccount__5vIV-{background-color:#2f93e0;color:#fff;cursor:pointer;width:50%;padding-top:5.5rem;text-align:center;-webkit-transition:all .5s linear;transition:all .5s linear}.style_waitingForOctopus__18CU8{margin:auto;width:22rem;position:relative;display:block;vertical-align:middle;text-align:center}.style_waitingForOctopus__18CU8>div{text-align:center}.style_waitingLogo__MG9Qk{color:#2f93e0;margin:0 auto;font-size:4rem;width:60px;height:63px;object-fit:contain;position:relative;bottom:0;z-index:2;margin-bottom:20px}.style_authenticatedAccountIcon__BuTUQ{background-image:url(" + __webpack_require__(745) + ");background-repeat:no-repeat;height:4rem;background-position:50%;margin-bottom:2rem}.style_areas__oMPzg>div{opacity:1;transition:all .5s linear}.style_areas__oMPzg:hover>.style_authenticatedAccount__5vIV-:hover,.style_areas__oMPzg:hover>.style_guestAccount__1StFV:hover{opacity:1;transition:all .5s linear;box-shadow:0 .0625rem .3125rem 0 rgba(0,0,0,.2),0 .1875rem .25rem 0 rgba(0,0,0,.12),0 .125rem .25rem 0 rgba(0,0,0,.14)}.style_areas__oMPzg:hover>.style_authenticatedAccount__5vIV-:not(:hover),.style_areas__oMPzg:hover>.style_guestAccount__1StFV:not(:hover){opacity:.5;transition:all .5s linear}.style_footerActions__1FPqe{width:100%;display:flex;flex-direction:column;align-items:center;margin-top:1rem}", ""]);

// exports
exports.locals = {
	"container": "style_container__1B6f-",
	"content": "style_content__3ipwL",
	"rememberMe": "style_rememberMe__g7_Zx",
	"logo": "style_logo__a7107",
	"authenticationError": "style_authenticationError__2jxOi",
	"accountTypeSelection": "style_accountTypeSelection__1CPDs",
	"authenticatedAccount": "style_authenticatedAccount__5vIV-",
	"waitingForOctopus": "style_waitingForOctopus__18CU8",
	"waitingLogo": "style_waitingLogo__MG9Qk",
	"authenticatedAccountIcon": "style_authenticatedAccountIcon__BuTUQ",
	"areas": "style_areas__oMPzg",
	"guestAccount": "style_guestAccount__1StFV",
	"footerActions": "style_footerActions__1FPqe"
};

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2029);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_container__2TMMJ{display:flex;align-items:center;height:100vh;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__2TMMJ"
};

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfirmation_1 = __webpack_require__(2031);
exports.default = getUserConfirmation_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\index.ts"); } } })();

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmNavigate_1 = __webpack_require__(2032);
var ReactDOM = __webpack_require__(33);
var React = __webpack_require__(0);
var colors_1 = __webpack_require__(31);
var Theme_1 = __webpack_require__(747);
var store_1 = __webpack_require__(123);
var getUserConfirmation = function (message, callback) {
    var app = document.getElementById("app");
    var modal = document.createElement("div");
    app.appendChild(modal);
    // The name need to be the same as formPaperLayoutReducer in ../FormPaperLayout/reducers.ts, would be nice if we have nameOf
    var formPaperLayoutState = store_1.default.getState()["formPaperLayoutReducer"];
    var withCleanup = function (answer) {
        callback(answer);
        setTimeout(function () {
            // Give the close animation time to do its thing.
            ReactDOM.unmountComponentAtNode(modal);
            app.removeChild(modal);
        }, 500);
    };
    ReactDOM.render(
    // We HAVE to explicitly set the theme here or this doesn't work.
    React.createElement(Theme_1.default, { theme: colors_1.theme },
        React.createElement(ConfirmNavigate_1.default, { message: message, callback: withCleanup, onSaveClick: formPaperLayoutState.onSaveClick })), modal);
};
exports.default = getUserConfirmation;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\getUserConfirmation.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\getUserConfirmation.tsx"); } } })();

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dialog_1 = __webpack_require__(181);
var ActionButton_1 = __webpack_require__(49);
var react_event_listener_1 = __webpack_require__(68);
var Callout_1 = __webpack_require__(58);
var ConfirmNavigate = (function (_super) {
    __extends(ConfirmNavigate, _super);
    function ConfirmNavigate(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTouchTap = function (navigate) {
            _this.setState({
                show: false
            });
            _this.props.callback(navigate);
        };
        _this.handleKeyDown = function (event) {
            if (event.keyCode === 27 /*esc*/) {
                _this.handleTouchTap(false);
            }
        };
        _this.onSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.onSaveClick()];
                    case 1:
                        success = _a.sent();
                        this.setState({ success: success });
                        if (!!success) {
                            this.handleTouchTap(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            show: true,
            success: true
        };
        return _this;
    }
    ConfirmNavigate.prototype.render = function () {
        var _this = this;
        var actions = [
            React.createElement(ActionButton_1.default, { style: { marginRight: "5px" }, key: "SaveChanges", label: "Save Changes", onClick: this.onSaveClick }),
            React.createElement(ActionButton_1.default, { style: { marginRight: "5px" }, key: "discard", label: "Discard Changes", onClick: function () { return _this.handleTouchTap(true); } }),
            React.createElement(ActionButton_1.default, { key: "cancel", label: "Cancel", type: ActionButton_1.ActionButtonType.Primary, keyboardFocused: true, onClick: function () { return _this.handleTouchTap(false); } })
        ];
        return React.createElement(Dialog_1.default, { title: "Unsaved Changes", actions: actions, modal: true, open: this.state.show, autoScrollBodyContent: true },
            React.createElement(react_event_listener_1.default, { target: "document", onKeyDown: this.handleKeyDown }),
            this.props.message,
            !this.state.success && React.createElement(Callout_1.default, { title: "Errors found", type: Callout_1.CalloutType.Danger }, "Please cancel this dialog to review the errors (or discard your changes)."));
    };
    return ConfirmNavigate;
}(React.Component));
exports.default = ConfirmNavigate;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\ConfirmNavigate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\ConfirmNavigate\\ConfirmNavigate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var MuiThemeProvider_1 = __webpack_require__(619);
var getMuiTheme_1 = __webpack_require__(620);
var Theme = function (props) {
    return React.createElement(MuiThemeProvider_1.default, { muiTheme: getMuiTheme_1.default(props.theme) }, props.children);
};
exports.default = Theme;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Theme\\Theme.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Theme\\Theme.tsx"); } } })();

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationLayout_1 = __webpack_require__(2035);
exports.default = AuthenticationLayout_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\index.tsx"); } } })();

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationLayoutInternal_1 = __webpack_require__(2036);
var react_redux_1 = __webpack_require__(64);
var AuthenticationLayout = react_redux_1.connect(function (state) {
    return {
        unhandledError: state.unhandledError
    };
})(AuthenticationLayoutInternal_1.default);
exports.default = AuthenticationLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayout.tsx"); } } })();

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CenteredLayout_1 = __webpack_require__(746);
var ErrorPanel_1 = __webpack_require__(85);
var AuthenticationLayoutInternal = (function (_super) {
    __extends(AuthenticationLayoutInternal, _super);
    function AuthenticationLayoutInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthenticationLayoutInternal.prototype.render = function () {
        return React.createElement(CenteredLayout_1.default, null,
            this.props.unhandledError && React.createElement(ErrorPanel_1.default, { message: this.props.unhandledError.message, details: this.props.unhandledError.details }),
            this.props.children);
    };
    return AuthenticationLayoutInternal;
}(React.Component));
exports.default = AuthenticationLayoutInternal;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayoutInternal.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\areas\\authentication\\AuthenticationLayout\\AuthenticationLayoutInternal.tsx"); } } })();

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2038);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../node_modules/less-loader/dist/cjs.js!./index.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../node_modules/less-loader/dist/cjs.js!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports
exports.i(__webpack_require__(2039), "");

// module
exports.push([module.i, "@media (max-width:37.4rem){.hide-sm{display:none!important}}@media (min-width:37.4rem){.visible-sm{display:none!important}}@media (max-width:79.9rem){.hide-md{display:none!important}}@media (min-width:79.9rem){.visible-md{display:none!important}}@font-face{font-family:Roboto;src:url(" + __webpack_require__(434) + ");font-weight:400}@font-face{font-family:Roboto;src:url(" + __webpack_require__(435) + ");font-weight:400;font-style:italic}@font-face{font-family:Roboto;src:url(" + __webpack_require__(436) + ");font-weight:300}@font-face{font-family:Roboto;src:url(" + __webpack_require__(437) + ");font-weight:500}@font-face{font-family:Roboto;src:url(" + __webpack_require__(438) + ");font-weight:600}@font-face{font-family:fontoctopus;src:url(" + __webpack_require__(235) + ");src:url(" + __webpack_require__(235) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(439) + ") format(\"woff\"),url(" + __webpack_require__(440) + ") format(\"truetype\"),url(" + __webpack_require__(441) + ") format(\"svg\");font-weight:400;font-style:normal}.fontoctopus-octopus{display:inline-block;font:normal normal normal 1em fontoctopus;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none}.fontoctopus-octopus:before{content:\"\\E800\"}@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(442) + ");src:url(" + __webpack_require__(443) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(444) + ") format(\"woff2\"),url(" + __webpack_require__(445) + ") format(\"woff\"),url(" + __webpack_require__(446) + ") format(\"truetype\"),url(" + __webpack_require__(447) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes index_fa-spin__2DYmt{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes index_fa-spin__2DYmt{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.monospace{font-family:Consolas,Menlo,Monaco,Courier New,monospace;line-height:1.2rem}h1{font-size:1.625rem;font-weight:400}@media (max-width:37.4rem){h1{font-size:1.4375rem}}h2{font-size:1.25rem;font-weight:400}@media (max-width:37.4rem){h2{font-size:1.0625rem}}h3{font-size:1.125rem;font-weight:400}@media (max-width:37.4rem){h3{font-size:1.0625rem}}h4{font-size:1.0625rem;font-weight:500;margin:1rem 0 .5rem}h5{font-size:.8125rem;font-weight:400}hr{display:block;height:.0625rem;border:0;border-top:.0625rem solid #ccc;margin:1em 0;padding:0}a{color:#2f93e0}a:hover{color:#0a67b1}p{margin:1rem 0;color:#333}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset!important}input::-ms-clear{width:0;height:0}small{font-size:.875rem;line-height:1.1875rem}.secondary{color:#9e9e9e}a{text-decoration:none}ol,ul{list-style-type:none;padding:0}code{font-family:Menlo,Monaco,Consolas,Courier New,monospace;color:#441c7f;border-radius:.125rem;padding:.125rem .25rem;line-height:normal}code,pre{background-color:#f4ebf9}pre{border:.0625rem solid #ccc;padding:.4rem;margin:0 0 .4rem;word-break:break-all;word-wrap:break-word;white-space:pre-wrap}", ""]);

// exports
exports.locals = {
	"fa-spin": "index_fa-spin__2DYmt",
	"faSpin": "index_fa-spin__2DYmt"
};

/***/ }),
/* 2039 */,
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(2041);
__webpack_require__(234);
__webpack_require__(2043);
__webpack_require__(427);
__webpack_require__(2044);
__webpack_require__(2045);
__webpack_require__(2046);
__webpack_require__(2048);
__webpack_require__(2050);
__webpack_require__(2052);
__webpack_require__(2054);
__webpack_require__(2072);
__webpack_require__(2073);
__webpack_require__(2074);
__webpack_require__(2077);
__webpack_require__(2081);
__webpack_require__(2082);
__webpack_require__(2084);
__webpack_require__(2085);
__webpack_require__(2087);
__webpack_require__(2088);
__webpack_require__(2089);
__webpack_require__(2091);
__webpack_require__(2092);
__webpack_require__(2094);
__webpack_require__(2095);
__webpack_require__(2098);
__webpack_require__(2099);
__webpack_require__(2100);
__webpack_require__(2101);
__webpack_require__(2102);
__webpack_require__(2103);
__webpack_require__(2109);
__webpack_require__(2111);
__webpack_require__(2114);
__webpack_require__(2115);
__webpack_require__(2116);
__webpack_require__(2122);
__webpack_require__(2123);
__webpack_require__(2124);
__webpack_require__(2125);
__webpack_require__(2126);
__webpack_require__(763);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\index.ts"); } } })();

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var tentaclePackageAction_1 = __webpack_require__(427);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var resources_1 = __webpack_require__(17);
var IISActionSummary = (function (_super) {
    __extends(IISActionSummary, _super);
    function IISActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    IISActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    IISActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy to IIS using package ",
            React.createElement("strong", null,
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return IISActionSummary;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.IIS",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(IISActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: tentaclePackageAction_1.TentaclePackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.IISWebSite"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\iis\\iisAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\iis\\iisAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var AutoComplete_1 = __webpack_require__(322);
__export(__webpack_require__(322));
exports.default = AutoComplete_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AutoComplete\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\AutoComplete\\index.ts"); } } })();

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ActionDetails_1 = __webpack_require__(25);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var specialVariables_1 = __webpack_require__(189);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var form_1 = __webpack_require__(16);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var FormSectionHeading_1 = __webpack_require__(48);
var HealthCheckActionSummary = (function (_super) {
    __extends(HealthCheckActionSummary, _super);
    function HealthCheckActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HealthCheckActionSummary.prototype.render = function () {
        var healthCheckTypeName = this.humanise(this.props.properties[specialVariables_1.default.Action.HealthCheck.Type]);
        return React.createElement("div", null,
            " Perform a ",
            healthCheckTypeName,
            " ",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                "for ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    HealthCheckActionSummary.prototype.humanise = function (type) {
        switch (type) {
            case "FullHealthCheck": return "full health check";
            case "ConnectionTest": return "connection check";
        }
        return "check";
    };
    return HealthCheckActionSummary;
}(BaseComponent_1.BaseComponent));
var HealthCheckActionEdit = (function (_super) {
    __extends(HealthCheckActionEdit, _super);
    function HealthCheckActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HealthCheckActionEdit.prototype.componentDidMount = function () {
        var properties = this.props.properties;
        this.props.setProperties((_a = {},
            _a["Octopus.Action.HealthCheck.Type"] = properties["Octopus.Action.HealthCheck.Type"] || "FullHealthCheck",
            _a["Octopus.Action.HealthCheck.ErrorHandling"] = properties["Octopus.Action.HealthCheck.ErrorHandling"] || "TreatExceptionsAsErrors",
            _a["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] || "DoNotAlterMachines",
            _a), true);
        var _a;
    };
    HealthCheckActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Health check" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.Type", isExpandedByDefault: this.props.expandedByDefault, title: "Health check type", summary: properties["Octopus.Action.HealthCheck.Type"] === "FullHealthCheck"
                    ? form_1.Summary.default("Perform a full health check")
                    : form_1.Summary.summary("Perform a connection-only test"), help: "Choose to perform a full health check or a connection-only test" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.Type"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.Type"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "FullHealthCheck", label: "Perform a full health check", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "ConnectionTest", label: "Perform a connection-only test" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.ErrorHandling", isExpandedByDefault: this.props.expandedByDefault, title: "Health check errors", summary: properties["Octopus.Action.HealthCheck.ErrorHandling"] === "TreatExceptionsAsErrors"
                    ? form_1.Summary.default("Fail the deployment if any targets are unavailable")
                    : form_1.Summary.summary("Skip deployment targets that are unavailable"), help: "Select which action to take on a health check error" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.ErrorHandling"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.ErrorHandling"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "TreatExceptionsAsErrors", label: "Fail the deployment", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "TreatExceptionsAsWarnings", label: "Skip deployment targets that are unavailable" }))),
            React.createElement(FormSectionHeading_1.default, { title: "Machine Selection" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.HealthCheck.IncludeMachinesInDeployment", isExpandedByDefault: this.props.expandedByDefault, title: "New Deployment Targets", summary: properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] === "DoNotAlterMachines"
                    ? form_1.Summary.default("Ignore any newly available deployment targets")
                    : form_1.Summary.summary("Include new deployment targets in the deployment"), help: "Select which action to take on new machines." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "DoNotAlterMachines", label: "Ignore any newly available deployment targets", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "IncludeCheckedMachines", label: "Include new deployment targets in the deployment" }))));
    };
    return HealthCheckActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    actionType: "Octopus.HealthCheck",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(HealthCheckActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: HealthCheckActionEdit,
    canHaveChildren: function (step) { return false; },
    canBeChild: false,
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    canRunOnWorker: false,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\healthCheck\\healthCheckAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\healthCheck\\healthCheckAction.tsx"); } } })();

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var tentaclePackageAction_1 = __webpack_require__(427);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var resources_1 = __webpack_require__(17);
var WindowsServiceActionSummary = (function (_super) {
    __extends(WindowsServiceActionSummary, _super);
    function WindowsServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    WindowsServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    WindowsServiceActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy Windows Service using package ",
            React.createElement("strong", null,
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return WindowsServiceActionSummary;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WindowsService",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(WindowsServiceActionSummary, { properties: properties, packages: packages, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: tentaclePackageAction_1.TentaclePackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.WindowsService"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\windowsService\\windowsServiceAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\windowsService\\windowsServiceAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var index_1 = __webpack_require__(24);
var form_1 = __webpack_require__(16);
var TeamMultiSelect_1 = __webpack_require__(320);
var ParseHelper_1 = __webpack_require__(66);
var actionExecutionLocation_1 = __webpack_require__(46);
var ActionDetails_1 = __webpack_require__(25);
var MarkdownEditor_1 = __webpack_require__(304);
var ManualActionSummary = (function (_super) {
    __extends(ManualActionSummary, _super);
    function ManualActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManualActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Manual intervention");
    };
    return ManualActionSummary;
}(BaseComponent_1.BaseComponent));
var ManualActionEdit = (function (_super) {
    __extends(ManualActionEdit, _super);
    function ManualActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
        };
        return _this;
    }
    ManualActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ManualActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Manual Intervention" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Manual.Instructions", isExpandedByDefault: this.props.expandedByDefault, title: "Instructions", help: "These instructions will be presented to the user to follow.", summary: this.instructionsSummary() },
                React.createElement(MarkdownEditor_1.VariableLookupMarkdownEditor, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Manual.Instructions"], label: "Instructions", error: this.props.getFieldError("Octopus.Action.Manual.Instructions"), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Manual.Instructions"] = val, _a));
                        var _a;
                    }, validate: form_1.required("Please provide instructions to display during the step") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Manual.ResponsibleTeamIds", isExpandedByDefault: this.props.expandedByDefault, title: "Responsible Teams", summary: this.teamSummary(), help: "Select the teams responsible for this manual step." },
                React.createElement(TeamMultiSelect_1.default, { label: "Responsible teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Manual.ResponsibleTeamIds"]), error: this.props.getFieldError("Octopus.Action.Manual.ResponsibleTeamIds"), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Manual.ResponsibleTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } }),
                React.createElement(form_1.Note, null, "If no teams are specified, all users who have permission to deploy the project will be able to perform the manual step. When one or more teams are specified, as in the case of an approval workflow, then only members of those teams will be able to perform the step."),
                React.createElement(form_1.Note, null, "Specifying responsible teams will make the step unable to be skipped.")));
    };
    ManualActionEdit.prototype.instructionsSummary = function () {
        var instructions = this.props.properties["Octopus.Action.Manual.Instructions"];
        return instructions
            ? form_1.Summary.summary("Instructions have been provided")
            : form_1.Summary.placeholder("Instructions have not been provided");
    };
    ManualActionEdit.prototype.teamSummary = function () {
        var teams = ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Manual.ResponsibleTeamIds"]);
        if (teams.length === 0) {
            return form_1.Summary.placeholder("All authorized teams");
        }
        var chips = this.state.teams.filter(function (t) { return teams.indexOf(t.Id) !== -1; }).map(function (t) { return React.createElement(index_1.TeamChip, { team: t, key: t.Id }); });
        return form_1.Summary.summary(React.createElement("div", null, chips));
    };
    return ManualActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    canRunOnWorker: false,
    actionType: "Octopus.Manual",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ManualActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.None; },
    hasPackages: function (action) { return false; },
    edit: ManualActionEdit
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\manual\\manualAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\manual\\manualAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var specialVariables_1 = __webpack_require__(189);
var clientInstance_1 = __webpack_require__(10);
var EmailLink_1 = __webpack_require__(2047);
var Targets_1 = __webpack_require__(734);
var Chips_1 = __webpack_require__(24);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var TeamMultiSelect_1 = __webpack_require__(320);
var ParseHelper_1 = __webpack_require__(66);
var actionExecutionLocation_1 = __webpack_require__(46);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var MoreInfo_1 = __webpack_require__(326);
var emailPriority_1 = __webpack_require__(855);
var ActionDetails_1 = __webpack_require__(25);
var LookupResourceChip_1 = __webpack_require__(160);
var TeamsList = (function (_super) {
    __extends(TeamsList, _super);
    function TeamsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TeamsList;
}(Targets_1.default));
var LookupTeamChip = LookupResourceChip_1.default();
var EmailActionSummary = (function (_super) {
    __extends(EmailActionSummary, _super);
    function EmailActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    EmailActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailActionSummary.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var toTeamIds = properties[specialVariables_1.default.Action.Email.ToTeamIds];
        var teamIds = toTeamIds ? toTeamIds.split(",") : [];
        return React.createElement("div", null,
            "Send an email to ",
            React.createElement(EmailLink_1.default, { emailAddress: properties[specialVariables_1.default.Action.Email.To] }),
            teamIds && this.state.teams && React.createElement("span", null,
                React.createElement(TeamsList, { targets: teamIds.map(function (id) {
                        return React.createElement(LookupTeamChip, { lookupCollection: _this.state.teams, key: id, lookupId: id, type: Chips_1.ChipIcon.Team, chipRender: function (team) { return React.createElement(Chips_1.TeamChip, { team: team }); } });
                    }) })),
            properties[specialVariables_1.default.Action.Email.CC] || properties[specialVariables_1.default.Action.Email.CCTeamIds] ||
                properties[specialVariables_1.default.Action.Email.Bcc] || properties[specialVariables_1.default.Action.Email.BccTeamIds] ? " (including CC/BCC)" : null);
    };
    return EmailActionSummary;
}(BaseComponent_1.BaseComponent));
var EmailActionEdit = (function (_super) {
    __extends(EmailActionEdit, _super);
    function EmailActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
            bodyHelpExpanded: false
        };
        return _this;
    }
    EmailActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    EmailActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Send an Email" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.To", isExpandedByDefault: this.props.expandedByDefault, title: "To", summary: this.toSummary(), help: React.createElement("div", null,
                    "At least one ",
                    React.createElement("em", null, "To"),
                    " address or ",
                    React.createElement("em", null, "Team"),
                    " must be entered.") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "To", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.To"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.To"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Email.To") }),
                React.createElement(TeamMultiSelect_1.default, { label: "To Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.ToTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.ToTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.CC", isExpandedByDefault: this.props.expandedByDefault, title: "CC", summary: this.ccSummary() },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "CC", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.CC"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.CC"] = val, _a));
                        var _a;
                    } }),
                React.createElement(TeamMultiSelect_1.default, { label: "CC Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.CCTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.CCTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Bcc", isExpandedByDefault: this.props.expandedByDefault, title: "BCC", summary: this.bccSummary() },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "BCC", hintText: "Separate multiple email addresses with ; or ,", value: properties["Octopus.Action.Email.Bcc"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Bcc"] = val, _a));
                        var _a;
                    } }),
                React.createElement(TeamMultiSelect_1.default, { label: "CC Teams", items: this.state.teams, value: ParseHelper_1.default.parseCSV(properties["Octopus.Action.Email.BccTeamIds"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.BccTeamIds"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Priority", isExpandedByDefault: this.props.expandedByDefault, title: "Priority", help: "Select the priority of the email.", summary: this.prioritySummary() },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Email.Priority"] || emailPriority_1.EmailPriority.Normal, onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Priority"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.Low, label: "Low" }),
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.Normal, label: "Normal" }),
                    React.createElement(RadioButton_1.default, { value: emailPriority_1.EmailPriority.High, label: "High" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Subject", isExpandedByDefault: this.props.expandedByDefault, title: "Subject", help: "Provide the subject line of the email.", summary: this.subjectSummary() },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Subject", value: properties["Octopus.Action.Email.Subject"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Subject"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Email.Subject") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Email.Body", isExpandedByDefault: this.props.expandedByDefault, title: "Body", help: "Provide the email body as raw text or HTML.", summary: this.bodySummary() },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Body", multiLine: true, value: properties["Octopus.Action.Email.Body"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.Body"] = val, _a));
                        var _a;
                    } }),
                React.createElement(MoreInfo_1.default, { label: "This field supports extended template syntax.", content: React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("b", null, "Extended template syntax")),
                        React.createElement("span", null,
                            "Conditional ",
                            React.createElement("code", null, "if"),
                            " and ",
                            React.createElement("code", null, "unless"),
                            ":",
                            React.createElement("pre", null, "#{if MyVar}...#{/if}")),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Iteration over variable sets or comma-separated values with ",
                            React.createElement("code", null, "each"),
                            ":",
                            React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}"))) }),
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Email body format", value: properties["Octopus.Action.Email.IsHtml"] || "False", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Email.IsHtml"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Body is plain text", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Body is HTML" }))));
    };
    EmailActionEdit.prototype.toSummary = function () {
        return this.emailSummary("No recipient addresses set", "Octopus.Action.Email.To", "Octopus.Action.Email.ToTeamIds");
    };
    EmailActionEdit.prototype.ccSummary = function () {
        return this.emailSummary("No CC addresses set", "Octopus.Action.Email.CC", "Octopus.Action.Email.CCTeamIds");
    };
    EmailActionEdit.prototype.bccSummary = function () {
        return this.emailSummary("No BCC addresses set", "Octopus.Action.Email.Bcc", "Octopus.Action.Email.BccTeamIds");
    };
    EmailActionEdit.prototype.emailSummary = function (nothing, text, teamIds) {
        var _this = this;
        var bcc = this.props.properties[text];
        var teams = ParseHelper_1.default.parseCSV(this.props.properties[teamIds]);
        if (!bcc && teams.length === 0) {
            return form_1.Summary.placeholder(nothing);
        }
        var chips = teams.map(function (t) {
            return React.createElement(LookupTeamChip, { lookupCollection: _this.state.teams, key: t, lookupId: t, type: Chips_1.ChipIcon.Environment, chipRender: function (team) { return React.createElement(Chips_1.TeamChip, { team: team }); } });
        });
        return form_1.Summary.summary(React.createElement("div", null,
            bcc,
            " ",
            chips));
    };
    EmailActionEdit.prototype.subjectSummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Subject"];
        return val
            ? form_1.Summary.summary(val)
            : form_1.Summary.placeholder("The email subject has not been provided");
    };
    EmailActionEdit.prototype.prioritySummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Priority"] || emailPriority_1.EmailPriority.Normal;
        return val === emailPriority_1.EmailPriority.Normal ? form_1.Summary.default("Normal") : form_1.Summary.summary(val);
    };
    EmailActionEdit.prototype.bodySummary = function () {
        var val = this.props.properties["Octopus.Action.Email.Body"];
        return val
            ? form_1.Summary.summary("The email body has been provided")
            : form_1.Summary.placeholder("An email body has not been provided");
    };
    return EmailActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    canRunOnWorker: false,
    actionType: "Octopus.Email",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(EmailActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: true,
    edit: EmailActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.None; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\email\\emailAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\email\\emailAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmailLink_1 = __webpack_require__(857);
exports.default = EmailLink_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EmailLink\\index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EmailLink\\index.tsx"); } } })();

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var actionExecutionLocation_1 = __webpack_require__(46);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var ActionDetails_1 = __webpack_require__(25);
var EditList_1 = __webpack_require__(2049);
var ExpandableFormSection_1 = __webpack_require__(30);
var Select_1 = __webpack_require__(40);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var InternalLink_1 = __webpack_require__(43);
var routeLinks_1 = __webpack_require__(22);
var DeployReleaseSummary = (function (_super) {
    __extends(DeployReleaseSummary, _super);
    function DeployReleaseSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    DeployReleaseSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
                        if (!id.includes("#{")) return [3 /*break*/, 1];
                        _a = null;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, clientInstance_1.repository.Projects.get(id)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({ project: project });
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployReleaseSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a release from project ",
            React.createElement("b", null, this.state.project ? this.state.project.Name : this.props.properties["Octopus.Action.DeployRelease.ProjectId"]),
            ".");
    };
    return DeployReleaseSummary;
}(BaseComponent_1.BaseComponent));
var DeploymentCondition;
(function (DeploymentCondition) {
    DeploymentCondition["Always"] = "Always";
    DeploymentCondition["IfNotCurrentVersion"] = "IfNotCurrentVersion";
    DeploymentCondition["IfNewer"] = "IfNewer";
})(DeploymentCondition || (DeploymentCondition = {}));
var DeployReleaseEdit = (function (_super) {
    __extends(DeployReleaseEdit, _super);
    function DeployReleaseEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            projects: []
        };
        return _this;
    }
    DeployReleaseEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var projects, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"]) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.DeploymentCondition"] = DeploymentCondition.Always, _a));
                        }
                        return [4 /*yield*/, clientInstance_1.repository.Projects.all()];
                    case 1:
                        projects = _b.sent();
                        this.setState({ projects: projects.filter(function (p) { return p.Id !== _this.props.projectId; }).map(function (p) { return ({ value: p.Id, text: p.Name }); }) });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DeployReleaseEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Deploy a release" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.ProjectId", isExpandedByDefault: this.props.expandedByDefault, title: "Project", summary: this.summary(), help: React.createElement("div", null, "Select a project that will be deployed.") },
                React.createElement(Select_1.BoundSelect, { label: "Select a Project", variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", items: this.state.projects, onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.ProjectId"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.DeployRelease.ProjectId"), allowFilter: true, autoFocus: true, value: this.props.properties["Octopus.Action.DeployRelease.ProjectId"] }),
                React.createElement(Note_1.default, null,
                    "See our ",
                    React.createElement(ExternalLink_1.default, { href: "DeployReleaseStep" }, "documentation"),
                    " for more information on deploying projects with the Deploy Release step.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.DeploymentCondition", isExpandedByDefault: this.props.expandedByDefault, title: "Deployment condition", summary: this.summaryDeployment(), help: React.createElement("span", null, "Control when this deployment should run.") },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: DeploymentCondition.Always, value: this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.DeploymentCondition"] = x, _a));
                        var _a;
                    }, label: "Deployment condition" },
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.Always, label: "Always", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.IfNotCurrentVersion, label: "If the selected release is not the current release in the environment" }),
                    React.createElement(RadioButton_1.default, { value: DeploymentCondition.IfNewer, label: "If the selected release has a higher version than the current release in the environment" }))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.DeployRelease.Variables", isExpandedByDefault: this.props.expandedByDefault, title: "Variables", summary: this.summaryVariables(), fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, help: React.createElement("span", null, "Pass variables through to the child deployment.") },
                React.createElement(EditList_1.KeyValueEditList, { items: this.props.properties["Octopus.Action.DeployRelease.Variables"], name: "Variable", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.DeployRelease.Variables"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Variable name", hideBindOnKey: true, localNames: this.props.localNames, projectId: this.props.projectId }),
                React.createElement(Note_1.default, null,
                    "See our ",
                    React.createElement(ExternalLink_1.default, { href: "DeployReleaseStepVariables" }, "documentation"),
                    " for more information on passing variables to deployments triggered by the Create Release step.")));
    };
    DeployReleaseEdit.prototype.summary = function () {
        var type = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
        if (!type) {
            return form_1.Summary.placeholder("Select a project that will be deployed");
        }
        var projectId = this.props.properties["Octopus.Action.DeployRelease.ProjectId"];
        var projectName = this.getProjectName(projectId);
        // Don't link to bound fields
        var link = projectId.includes("#{") ?
            React.createElement("b", null, projectName) :
            React.createElement(InternalLink_1.default, { to: routeLinks_1.default.project(encodeURIComponent(projectId)).root }, projectName);
        return form_1.Summary.summary(React.createElement("span", null,
            "Deploy a release from project ",
            link));
    };
    DeployReleaseEdit.prototype.summaryDeployment = function () {
        var condition = this.props.properties["Octopus.Action.DeployRelease.DeploymentCondition"];
        if (condition === DeploymentCondition.IfNotCurrentVersion) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploy the release if it is ",
                React.createElement("b", null, "not the current release"),
                " in the environment"));
        }
        if (condition === DeploymentCondition.IfNewer) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deploy the release if it has a ",
                React.createElement("b", null, "higher version"),
                " than the current release in the environment"));
        }
        return form_1.Summary.default(React.createElement("span", null, "Deploy every time"));
    };
    DeployReleaseEdit.prototype.summaryVariables = function () {
        var variables = JSON.parse(this.props.properties["Octopus.Action.DeployRelease.Variables"] || "{}");
        if (Object.keys(variables).length === 0) {
            return form_1.Summary.placeholder("No variables specified");
        }
        else {
            var text = Object.keys(variables).map(function (m) { return m + " = " + variables[m]; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DeployReleaseEdit.prototype.getProjectName = function (projectId) {
        var project = this.state.projects.find(function (p) { return p.value === projectId; });
        return project ? project.text : projectId;
    };
    return DeployReleaseEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.DeployRelease",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployReleaseSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return false; },
    canBeChild: false,
    edit: DeployReleaseEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.None; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\deployRelease\\deployReleaseAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\deployRelease\\deployReleaseAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KeyValueEditList_1 = __webpack_require__(87);
exports.KeyValueEditList = KeyValueEditList_1.default;
var StringEditList_1 = __webpack_require__(329);
exports.StringEditList = StringEditList_1.default;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\EditList\\index.ts"); } } })();

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(54);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var form_1 = __webpack_require__(16);
var resources_1 = __webpack_require__(17);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var ExternalLink_1 = __webpack_require__(26);
var AccountSelect_1 = __webpack_require__(202);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var AzureServerTargetRolesInfo_1 = __webpack_require__(299);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var AzureCloudServiceSelector_1 = __webpack_require__(2051);
var WarningFormSection_1 = __webpack_require__(134);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var Select_1 = __webpack_require__(40);
var Callout_1 = __webpack_require__(57);
var PermissionCheck_1 = __webpack_require__(42);
var AzureCloudServiceActionSummary = (function (_super) {
    __extends(AzureCloudServiceActionSummary, _super);
    function AzureCloudServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureCloudServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy Azure Cloud Service",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return AzureCloudServiceActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureCloudServiceActionEdit = (function (_super) {
    __extends(AzureCloudServiceActionEdit, _super);
    function AzureCloudServiceActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false)
        };
        return _this;
    }
    AzureCloudServiceActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, properties, isLegacyActionType;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!(!!(this.props.properties["Octopus.Action.Azure.AccountId"]) && PermissionCheck_1.isAllowed({ permission: resources_1.Permission.AccountView, wildcard: true }))) return [3 /*break*/, 2];
                                        _a = this.setState;
                                        _b = {};
                                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        _a.apply(this, [(_b.accounts = _c.sent(),
                                                _b)]);
                                        _c.label = 2;
                                    case 2:
                                        properties = {};
                                        isLegacyActionType = !!(properties["Octopus.Action.Azure.AccountId"]);
                                        if (isLegacyActionType) {
                                            if (!this.props.properties["Octopus.Action.Azure.Slot"]) {
                                                properties["Octopus.Action.Azure.Slot"] = resources_1.AzureCloudServiceEndpointDeploymentSlot.Staging;
                                            }
                                            if (!this.props.properties["Octopus.Action.Azure.SwapIfPossible"]) {
                                                properties["Octopus.Action.Azure.SwapIfPossible"] = true;
                                            }
                                            if (!this.props.properties["Octopus.Action.Azure.UseCurrentInstanceCount"]) {
                                                properties["Octopus.Action.Azure.UseCurrentInstanceCount"] = true;
                                            }
                                        }
                                        this.props.setProperties(properties, true);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceActionEdit.prototype.accountSummary = function () {
        var summary = [];
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (accountId) {
            var account = this.state.accounts.find(function (x) { return x.Id === accountId; });
            if (account) {
                summary.push(React.createElement("span", null,
                    "Using the ",
                    React.createElement("strong", null, account.Name),
                    " account"));
                (this.props.properties["Octopus.Action.Azure.CloudServiceName"])
                    ? summary.push(React.createElement("span", null,
                        ", with the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.CloudServiceName"]),
                        " cloud service"))
                    : summary.push(React.createElement("span", null,
                        ", with ",
                        React.createElement("em", null, "(no cloud service selected)")));
                (this.props.properties["Octopus.Action.Azure.StorageAccountName"])
                    ? summary.push(React.createElement("span", null,
                        ", and the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.StorageAccountName"]),
                        " storage account"))
                    : summary.push(React.createElement("span", null,
                        ", and ",
                        React.createElement("em", null, "(no storage account selected)")));
                return form_1.Summary.summary(React.Children.toArray(summary));
            }
            if (isBound_1.default(accountId, false)) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
        }
        return form_1.Summary.placeholder("No account has been selected");
    };
    AzureCloudServiceActionEdit.prototype.slotSummary = function () {
        var slot = this.props.properties["Octopus.Action.Azure.Slot"];
        if (slot) {
            if (slot === resources_1.AzureCloudServiceEndpointDeploymentSlot.Staging) {
                return form_1.Summary.default(React.createElement("span", null,
                    "Using the ",
                    slot,
                    " deployment slot"));
            }
            return form_1.Summary.summary(React.createElement("span", null,
                "Using the ",
                slot,
                " deployment slot"));
        }
        return form_1.Summary.placeholder("Deployment slot not specified");
    };
    AzureCloudServiceActionEdit.prototype.swapSummary = function () {
        var swap = this.props.properties["Octopus.Action.Azure.SwapIfPossible"];
        if (swap === "True") {
            return form_1.Summary.default("When deploying to production swap staging to production, if possible");
        }
        if (swap === "False") {
            return form_1.Summary.summary("When deploying to production always perform a new deployment");
        }
        return form_1.Summary.placeholder("Swap setting not specified");
    };
    AzureCloudServiceActionEdit.prototype.instanceCountSummary = function () {
        var instanceCount = this.props.properties["Octopus.Action.Azure.UseCurrentInstanceCount"];
        if (instanceCount === "True") {
            return form_1.Summary.default("Using the instance count from the current Azure deployment");
        }
        if (instanceCount === "False") {
            return form_1.Summary.summary("Using the instance count defined in the service configuration XML file");
        }
        return form_1.Summary.placeholder("Instance count not specified");
    };
    AzureCloudServiceActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var properties = this.props.properties;
        var isLegacyActionType = !!(properties["Octopus.Action.Azure.AccountId"]);
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy the contents of a package. The package that you wish to deploy should contain all the files needed to run your application. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning, title: "Cloud Services are considered legacy" },
                    "Azure have announced that Cloud Services are now a legacy service and ",
                    React.createElement("i", null, "Service Fabric"),
                    " is recommended for new development. Please consider ",
                    React.createElement(ExternalLink_1.default, { href: "WindowsAzure" }, "alternate applications"),
                    " that you can deploy to Azure.")),
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles, isCompatibleWithCloudRegions: false }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(form_1.FormSectionHeading, { title: "Package" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
            isLegacyActionType &&
                React.createElement("div", null,
                    React.createElement(form_1.FormSectionHeading, { title: "Azure" }),
                    React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.AccountView, wildcard: true, alternate: React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "The ",
                            resources_1.Permission.AccountView,
                            " permission is required to change the Azure settings.") },
                        React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.AccountId", isExpandedByDefault: this.props.expandedByDefault, title: "Account", summary: this.accountSummary(), help: "Select the account to use for the connection. Only Azure management-certificate accounts may be selected." },
                            (this.props.properties["Octopus.Action.Azure.SubscriptionId"] && !this.props.properties["Octopus.Action.Azure.AccountId"]) &&
                                React.createElement(form_1.UnstructuredFormSection, null,
                                    React.createElement(form_1.Note, null, "This step is using a subscription ID value imported from Octopus Deploy 2. This value, along with the default Azure certificate, will be used until an Account is selected below. From then on the subscription details from the selected Account will be used."),
                                    React.createElement(form_1.Text, { value: this.props.properties["Octopus.Action.Azure.SubscriptionId"], label: "Subscription", disabled: true, onChange: null })),
                            React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                                    localNames: this.props.localNames,
                                    projectId: this.props.projectId
                                }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_1.AccountType.AzureSubscription], allowClear: true, onChange: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                            React.createElement(AzureCloudServiceSelector_1.default, { doBusyTask: this.props.doBusyTask, properties: this.props.properties, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, localNames: this.props.localNames })),
                        React.createElement(form_1.FormSectionHeading, { title: "Deployment" }),
                        React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.Slot", isExpandedByDefault: this.props.expandedByDefault, title: "Slot", summary: this.slotSummary(), help: "Select a slot to deploy to." },
                            React.createElement(form_1.Note, null,
                                "Deployment Slots provide a nice way to implement Blue-Green deployments. Learn more about ",
                                React.createElement(ExternalLink_1.default, { href: "VipSwap" }, "Deployment Slots")),
                            React.createElement(Select_1.BoundSelect, { variableLookup: {
                                    localNames: this.props.localNames,
                                    projectId: this.props.projectId
                                }, resetValue: "", label: "Slot", value: this.props.properties["Octopus.Action.Azure.Slot"], items: ["Staging", "Production"].map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.Slot"] = val, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.Azure.Slot") })),
                        React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.SwapIfPossible", isExpandedByDefault: this.props.expandedByDefault, title: "Swap", summary: this.swapSummary(), help: "Specify to swap staging to production rather than a new deployment." },
                            React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.SwapIfPossible"], onChange: function (val) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.SwapIfPossible"] = val, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.Azure.SwapIfPossible") },
                                React.createElement(RadioButton_1.default, { value: "True", label: "Swap staging to production if possible" }),
                                React.createElement(form_1.Note, null, "Azure can swap staging to production deployments by switching virtual IP addresses."),
                                React.createElement(RadioButton_1.default, { value: "False", label: "Always deploy" }))),
                        React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.UseCurrentInstanceCount", isExpandedByDefault: this.props.expandedByDefault, title: "Instance Count", summary: this.instanceCountSummary(), help: "Select the source to use the instance count from." },
                            React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.UseCurrentInstanceCount"], onChange: function (val) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.UseCurrentInstanceCount"] = val, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.Azure.UseCurrentInstanceCount") },
                                React.createElement(RadioButton_1.default, { value: "True", label: "Use the instance count from the current Azure deployment" }),
                                React.createElement(RadioButton_1.default, { value: "False", label: "Use the instance count defined in the service configuration XML file" })),
                            React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information }, "If you have previously scaled your service by changing the number of instances using the Azure management portal, Octopus can retrieve these values and use them in the deployment, so that the instance count remains unchanged.")))));
    };
    return AzureCloudServiceActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureCloudService",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(AzureCloudServiceActionSummary, { properties: properties, packages: packages, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzureCloudServiceActionEdit,
    canHaveChildren: function (step) { return false; },
    canBeChild: true,
    targetRoleOption: function (action) {
        // Azure steps (pre Q1.2018) allowed you to select accounts directly on the step, making target selection optional.
        var isLegacyActionType = !!(action ? action.Properties["Octopus.Action.Azure.AccountId"] : null);
        return isLegacyActionType ? ActionDetails_1.TargetRoles.Optional : ActionDetails_1.TargetRoles.Required;
    },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureCloudService\\azureCloudServiceAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureCloudService\\azureCloudServiceAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(40);
var isBound_1 = __webpack_require__(54);
var Note_1 = __webpack_require__(20);
var BusyRefreshContainer_1 = __webpack_require__(205);
var IconButton_1 = __webpack_require__(52);
var InputWithActions_1 = __webpack_require__(136);
var toggleBusy = function (value) { return function (prev, props) { return (__assign({}, prev, { busy: value ? value : !prev.busy })); }; };
var AzureCloudServiceSelector = (function (_super) {
    __extends(AzureCloudServiceSelector, _super);
    function AzureCloudServiceSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            account: null,
            cloudServices: [],
            storageAccounts: [],
            serviceIsBound: isBound_1.default(_this.props.properties["Octopus.Action.Azure.CloudServiceName"], false),
            storageIsBound: isBound_1.default(_this.props.properties["Octopus.Action.Azure.StorageAccountName"], false),
            busy: false
        };
        return _this;
    }
    AzureCloudServiceSelector.prototype.componentDidMount = function () {
        if (!this.props.isAccountBound) {
            this.loadData();
        }
    };
    AzureCloudServiceSelector.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureCloudServiceSelector.prototype.componentWillReceiveProps = function (newprops) {
        if (newprops.isAccountBound && !this.state.serviceIsBound) {
            this.setState({ serviceIsBound: true });
        }
        if (newprops.isAccountBound && !this.state.storageIsBound) {
            this.setState({ storageIsBound: true });
        }
    };
    AzureCloudServiceSelector.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(toggleBusy(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var account, _a, cloudServices_1, storageAccounts_1;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!(!this.props.isAccountBound && this.props.accountId)) return [3 /*break*/, 3];
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.get(this.props.accountId)];
                                        case 1:
                                            account = _b.sent();
                                            return [4 /*yield*/, Promise.all([
                                                    clientInstance_1.repository.Accounts.getCloudServices(account),
                                                    clientInstance_1.repository.Accounts.getStorageAccounts(account)
                                                ])];
                                        case 2:
                                            _a = _b.sent(), cloudServices_1 = _a[0], storageAccounts_1 = _a[1];
                                            this.setState({
                                                account: account,
                                                cloudServices: Object.keys(cloudServices_1).map(function (item) { return cloudServices_1[item]; }),
                                                storageAccounts: Object.keys(storageAccounts_1).map(function (item) { return storageAccounts_1[item]; })
                                            });
                                            return [3 /*break*/, 4];
                                        case 3:
                                            this.setState({
                                                account: null,
                                                cloudServices: [],
                                                storageAccounts: []
                                            });
                                            _b.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState(toggleBusy(false));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
                    React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.BoundSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: this.props.properties["Octopus.Action.Azure.CloudServiceName"], isBound: this.state.serviceIsBound, onIsBoundChanged: function (value) { return _this.setState({ serviceIsBound: _this.props.isAccountBound || value }); }, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.CloudServiceName"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.CloudServiceName"] = val, _a));
                                var _a;
                            }, items: this.state.cloudServices.map(function (item) { return ({ value: item.Name, text: item.Name + " - " + item.Location }); }), label: "Cloud service", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.CloudServiceName") }), actions: !this.props.isAccountBound && !this.state.serviceIsBound && React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.loadData(); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }) })),
                React.createElement(Note_1.default, null, "The name of the cloud service to which files will be deployed.")),
            React.createElement("div", null,
                React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
                    React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.BoundSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: this.props.properties["Octopus.Action.Azure.StorageAccountName"], isBound: this.state.storageIsBound, onIsBoundChanged: function (value) { return _this.setState({ storageIsBound: _this.props.isAccountBound || value }); }, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.StorageAccountName"], onChange: function (val) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.StorageAccountName"] = val, _a));
                                var _a;
                            }, items: this.state.storageAccounts.map(function (item) { return ({ value: item.Name, text: item.Name + " - " + item.Location }); }), label: "Storage account", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.StorageAccountName") }), actions: !this.props.isAccountBound && !this.state.storageIsBound && React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.loadData(); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }) })),
                React.createElement(Note_1.default, null, "The name of a storage account that CSPKG files will be uploaded to before deployment.")));
    };
    return AzureCloudServiceSelector;
}(React.Component));
exports.default = AzureCloudServiceSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureCloudService\\AzureCloudServiceSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureCloudService\\AzureCloudServiceSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(54);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var clientInstance_1 = __webpack_require__(10);
var Summary_1 = __webpack_require__(44);
var FormSectionHeading_1 = __webpack_require__(48);
var ExpandableFormSection_1 = __webpack_require__(30);
var BoundField_1 = __webpack_require__(100);
var AzureServerTargetRolesInfo_1 = __webpack_require__(299);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var resources_1 = __webpack_require__(17);
var AzurePowerShellAccountInfo_1 = __webpack_require__(2053);
var WarningFormSection_1 = __webpack_require__(134);
var AccountSelect_1 = __webpack_require__(202);
var scriptAction_1 = __webpack_require__(234);
var ActionDetails_1 = __webpack_require__(25);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var AzurePowerShellActionSummary = (function (_super) {
    __extends(AzurePowerShellActionSummary, _super);
    function AzurePowerShellActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzurePowerShellActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Run a PowerShell script using an Azure subscription with Azure modules loaded",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzurePowerShellActionSummary;
}(BaseComponent_1.BaseComponent));
var BoundAccountSelect = BoundField_1.withBoundField(AccountSelect_1.default);
var AzurePowerShellActionEdit = (function (_super) {
    __extends(AzurePowerShellActionEdit, _super);
    function AzurePowerShellActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            accounts: [],
            account: null
        };
        return _this;
    }
    AzurePowerShellActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 1:
                        _a.apply(this, [(_b.accounts = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AzurePowerShellActionEdit.prototype.accountSummary = function () {
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (!accountId) {
            return Summary_1.default.placeholder("No account has been selected");
        }
        var account = this.state.accounts.find(function (a) { return a.Id === accountId; });
        if (account) {
            return Summary_1.default.summary(account.Name);
        }
        if (isBound_1.default(accountId, false)) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Account is bound to ",
                React.createElement("strong", null, accountId)));
        }
        return Summary_1.default.placeholder("No account has been selected");
    };
    AzurePowerShellActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var account = this.state.accounts.find(function (a) { return a.Id === properties["Octopus.Action.Azure.AccountId"]; });
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles, isCompatibleWithCloudRegions: true }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType }),
                React.createElement(AzurePowerShellAccountInfo_1.default, { accountType: account && account.AccountType })),
            React.createElement(FormSectionHeading_1.default, { title: "Azure" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AccountId", isExpandedByDefault: this.props.expandedByDefault, title: "Account", summary: this.accountSummary(), help: "Select the Azure account to use to run the script" },
                React.createElement(BoundAccountSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: this.props.properties["Octopus.Action.Azure.AccountId"], type: [resources_1.AccountType.AzureSubscription, resources_1.AccountType.AzureServicePrincipal], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts })),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault, supportedLanguages: ScriptingLanguageSelector_1.SupportedLanguage.PowerShell }));
    };
    return AzurePowerShellActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzurePowerShell",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzurePowerShellActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzurePowerShellActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
    features: {
        optional: ["Octopus.Features.SubstituteInFiles", "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\azurePowerShellAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\azurePowerShellAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Callout_1 = __webpack_require__(58);
var ExternalLink_1 = __webpack_require__(26);
var resources_1 = __webpack_require__(17);
var AzurePowerShellAccountInfo = function (props) {
    if (props.accountType === resources_1.AccountType.AzureSubscription) {
        return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "When using an Azure Management Certificate account, ",
            React.createElement(ExternalLink_1.default, { href: "AzureResourceManagerCmdlets" }, "Resource Manager"),
            " cmdlets can not be used. To use Resource Manager cmdlets, select an ",
            React.createElement(ExternalLink_1.default, { href: "DocumentationCreatingAzureAccount" }, "Azure Service Principal account"),
            ".");
    }
    if (props.accountType === resources_1.AccountType.AzureServicePrincipal) {
        return React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
            "When using an Azure Service Principal account, ",
            React.createElement(ExternalLink_1.default, { href: "AzureServiceManagementCmdlets" }, "Service Management"),
            " cmdlets can not be used. To use Service Management cmdlets, select an ",
            React.createElement(ExternalLink_1.default, { href: "DocumentationCreatingAzureAccount" }, "Azure Management Certificate account"),
            ".");
    }
    return null;
};
exports.default = AzurePowerShellAccountInfo;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellAccountInfo.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azurePowerShell\\AzurePowerShellAccountInfo.tsx"); } } })();

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var isBound_1 = __webpack_require__(54);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var resources_2 = __webpack_require__(17);
var clientInstance_1 = __webpack_require__(10);
var form_1 = __webpack_require__(16);
var AccountSelect_1 = __webpack_require__(202);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var AzureServerTargetRolesInfo_1 = __webpack_require__(299);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var WarningFormSection_1 = __webpack_require__(134);
var CodeEditor_1 = __webpack_require__(107);
var OpenDialogButton_1 = __webpack_require__(72);
var AzureResourceGroupSelector_1 = __webpack_require__(2055);
var AzureResourceGroupParameters_1 = __webpack_require__(2056);
var AzureResourceGroupSourceCodeDialog_1 = __webpack_require__(2057);
var ExpandableFormSection_1 = __webpack_require__(30);
var ActionDetails_1 = __webpack_require__(25);
var Select_1 = __webpack_require__(40);
var VariableLookupText_1 = __webpack_require__(21);
var PermissionCheck_1 = __webpack_require__(42);
var Callout_1 = __webpack_require__(58);
var AzureResourceGroupActionSummary = (function (_super) {
    __extends(AzureResourceGroupActionSummary, _super);
    function AzureResourceGroupActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzureResourceGroupActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy an Azure Resource Manager Template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzureResourceGroupActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureResourceGroupActionEdit = (function (_super) {
    __extends(AzureResourceGroupActionEdit, _super);
    function AzureResourceGroupActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.armJsonParamTypeArray = "array";
        _this.armJsonParamTypes = [_this.armJsonParamTypeArray, "object", "secureObject"];
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false),
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus", azureKeyVault: "azureKeyVault" };
        return _this;
    }
    AzureResourceGroupActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        if (!PermissionCheck_1.isAllowed({ permission: resources_2.Permission.AccountView, wildcard: true })) return [3 /*break*/, 2];
                                        _a = this.setState;
                                        _b = {};
                                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        _a.apply(this, [(_b.accounts = _e.sent(),
                                                _b)]);
                                        _e.label = 2;
                                    case 2:
                                        this.props.setPackages(resources_2.InitialisePrimaryPackageReference(this.props.packages), true);
                                        if (!this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"]) {
                                            this.props.setProperties((_c = {}, _c["Octopus.Action.Azure.ResourceGroupDeploymentMode"] = "Incremental", _c), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Azure.TemplateSource"]) {
                                            this.props.setProperties((_d = {}, _d["Octopus.Action.Azure.TemplateSource"] = "Inline", _d), true);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureResourceGroupActionEdit.prototype.accountSummary = function () {
        var summary = [];
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (accountId) {
            var account = this.state.accounts.find(function (x) { return x.Id === accountId; });
            if (account) {
                summary.push(React.createElement("span", null,
                    "Using the ",
                    React.createElement("strong", null, account.Name),
                    " account"));
                (this.props.properties["Octopus.Action.Azure.ResourceGroupName"])
                    ? summary.push(React.createElement("span", null,
                        " and the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupName"]),
                        " resource group"))
                    : summary.push(React.createElement("span", null,
                        " and ",
                        React.createElement("em", null, "(no resource group selected)")));
                (this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"])
                    ? summary.push(React.createElement("span", null,
                        " with the ",
                        React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"]),
                        " deployment mode"))
                    : summary.push(React.createElement("span", null,
                        " with ",
                        React.createElement("em", null, "no deployment mode selected")));
                return form_1.Summary.summary(React.Children.toArray(summary));
            }
            if (isBound_1.default(accountId, false)) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
        }
        return form_1.Summary.placeholder("No account has been selected");
    };
    AzureResourceGroupActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Azure.TemplateSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    AzureResourceGroupActionEdit.prototype.pathsSummary = function () {
        var summary = [];
        (this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"])
            ? summary.push(React.createElement("span", null,
                "Using the template in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no template path specified")));
        (this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"])
            ? summary.push(React.createElement("span", null,
                " with the parameters in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no parameters path specified")));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    AzureResourceGroupActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Azure.TemplateSource"] = value,
            _a["Octopus.Action.Azure.ResourceGroupTemplate"] = "",
            _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = "",
            _a));
        // If the inline option is selected, we clear out the package selection
        if (value === "Inline") {
            this.props.setPackages(resources_2.RemovePrimaryPackageReference(this.props.packages));
        }
        else {
            this.props.setPackages(resources_2.InitialisePrimaryPackageReference(this.props.packages));
        }
        var _a;
    };
    AzureResourceGroupActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles, isCompatibleWithCloudRegions: true }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(form_1.FormSectionHeading, { title: "Azure" }),
            React.createElement(PermissionCheck_1.default, { permission: resources_2.Permission.AccountView, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                    "The ",
                    resources_2.Permission.AccountView,
                    " permission is required to change the Azure settings.") },
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.AccountId", isExpandedByDefault: this.props.expandedByDefault, title: "Account", summary: this.accountSummary(), help: "Select the account to use for the connection." },
                    React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_2.AccountType.AzureServicePrincipal], allowClear: true, onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                    React.createElement(AzureResourceGroupSelector_1.default, { doBusyTask: this.props.doBusyTask, properties: this.props.properties, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, localNames: this.props.localNames }),
                    React.createElement(Select_1.BoundSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "", label: "Deployment mode", value: this.props.properties["Octopus.Action.Azure.ResourceGroupDeploymentMode"], items: ["Incremental", "Complete"].map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupDeploymentMode"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupDeploymentMode") }))),
            React.createElement(form_1.FormSectionHeading, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.TemplateSource", isExpandedByDefault: this.props.expandedByDefault, title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(form_1.Note, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Azure.TemplateSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Azure.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"] ? "Edit Source Code" : "Add Source Code", wideDialog: true, renderDialog: function (renderProps) {
                                return React.createElement(AzureResourceGroupSourceCodeDialog_1.default, { close: renderProps.closeDialog, open: renderProps.open, template: _this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], saveDone: function (val) {
                                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplate"] = val, _a));
                                        var _a;
                                    } });
                            } })))),
            this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Azure.ResourceGroupTemplate|Octopus.Action.Azure.ResourceGroupTemplateParameters", isExpandedByDefault: this.props.expandedByDefault, title: "Paths", summary: this.pathsSummary(), help: "Enter the relative paths for the template and parameter files in the package." },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Template file path", value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplate"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupTemplate") }),
                    React.createElement(form_1.Note, null, "Relative path to the JSON template file contained in the package e.g. template.json or path\\template.json"),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Parameter file path", value: this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupTemplateParameters") }),
                    React.createElement(form_1.Note, null, "Relative path to the JSON parameters file contained in the package e.g. parameters.json or path\\parameters.json"))),
            this.props.properties["Octopus.Action.Azure.TemplateSource"] === "Inline" && React.createElement("div", null,
                React.createElement(form_1.FormSectionHeading, { title: "Parameters" }),
                React.createElement(AzureResourceGroupParameters_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, doBusyTask: this.props.doBusyTask })));
    };
    return AzureResourceGroupActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureResourceGroup",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureResourceGroupActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AzureResourceGroupActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
    features: {
        optional: ["Octopus.Features.CustomScripts"]
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\azureResourceGroupAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\azureResourceGroupAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var clientInstance_1 = __webpack_require__(10);
var Select_1 = __webpack_require__(40);
var Note_1 = __webpack_require__(20);
var BusyRefreshContainer_1 = __webpack_require__(205);
var IconButton_1 = __webpack_require__(52);
var InputWithActions_1 = __webpack_require__(136);
var toggleBusy = function (value) { return function (prev, props) { return (__assign({}, prev, { busy: value ? value : !prev.busy })); }; };
var AzureResourceGroupSelector = (function (_super) {
    __extends(AzureResourceGroupSelector, _super);
    function AzureResourceGroupSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            account: null,
            resourceGroups: [],
            busy: false
        };
        return _this;
    }
    AzureResourceGroupSelector.prototype.componentDidMount = function () {
        this.loadData();
    };
    AzureResourceGroupSelector.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.accountId !== this.props.accountId) {
            this.loadData();
        }
    };
    AzureResourceGroupSelector.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(toggleBusy(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var account, resourceGroups_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(!this.props.isAccountBound && this.props.accountId)) return [3 /*break*/, 3];
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.get(this.props.accountId)];
                                        case 1:
                                            account = _a.sent();
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.getResourceGroups(account)];
                                        case 2:
                                            resourceGroups_1 = _a.sent();
                                            this.setState({
                                                account: account,
                                                resourceGroups: Object.keys(resourceGroups_1).map(function (item) { return resourceGroups_1[item]; })
                                            });
                                            return [3 /*break*/, 4];
                                        case 3:
                                            this.setState({
                                                account: null,
                                                resourceGroups: []
                                            });
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState(toggleBusy(false));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AzureResourceGroupSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
                React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.BoundSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: this.props.properties["Octopus.Action.Azure.ResourceGroupName"], isBound: this.props.isAccountBound, hideBindButton: this.props.isAccountBound, value: this.props.properties["Octopus.Action.Azure.ResourceGroupName"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupName"] = val, _a));
                            var _a;
                        }, items: this.state.resourceGroups.map(function (item) { return ({ value: item.Name, text: item.Name }); }), label: "Resource Group", allowClear: true, allowFilter: true, error: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupName") }), actions: !this.props.isAccountBound && React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.loadData(); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }) })),
            React.createElement(Note_1.default, null, "The name of the Azure Resource Group. The Resource Group must exist."),
            React.createElement(Note_1.default, null, "A Resource Group can be created through the Azure Portal, or by using the New-AzureRMResourceGroup PowerShell cmdlet."));
    };
    return AzureResourceGroupSelector;
}(React.Component));
exports.default = AzureResourceGroupSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var ExternalLink_1 = __webpack_require__(26);
var AzureTemplateHelper_1 = __webpack_require__(748);
var Select_1 = __webpack_require__(40);
var StringCheckbox_1 = __webpack_require__(41);
var VariableLookupText_1 = __webpack_require__(21);
var AzureResourceGroupParameters = (function (_super) {
    __extends(AzureResourceGroupParameters, _super);
    function AzureResourceGroupParameters(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            paramValues: {},
            paramErrors: []
        };
        return _this;
    }
    AzureResourceGroupParameters.prototype.componentDidMount = function () {
        this.loadParameterValues(true);
    };
    AzureResourceGroupParameters.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.properties["Octopus.Action.Azure.ResourceGroupTemplate"] !== this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"]) {
            this.loadParameterValues(false);
        }
    };
    AzureResourceGroupParameters.prototype.loadParameterValues = function (initialiseModel) {
        var _this = this;
        var paramValues = {};
        var result = AzureTemplateHelper_1.AzureTemplateHelper.extractParameters(this.props.properties["Octopus.Action.Azure.ResourceGroupTemplate"], this.props.properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"]);
        paramValues = result.value;
        this.setState(({ paramValues: paramValues }), function () { return _this.updateParameterValues(initialiseModel); });
    };
    AzureResourceGroupParameters.prototype.updateParameterValues = function (initialiseModel) {
        var result = AzureTemplateHelper_1.AzureTemplateHelper.exportParameters(this.state.paramValues);
        this.setState({ paramErrors: result.errors });
        this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = result.value, _a), initialiseModel);
        var _a;
    };
    AzureResourceGroupParameters.prototype.onParameterValueChange = function (paramName, newValue, key) {
        var _this = this;
        if (key === void 0) { key = "value"; }
        this.setState(function (prevState) {
            return ({
                paramValues: __assign({}, prevState.paramValues, (_a = {}, _a[paramName] = __assign({}, prevState.paramValues[paramName], (_b = {}, _b[key] = newValue, _b)), _a))
            });
            var _a, _b;
        }, function () { return _this.updateParameterValues(false); });
    };
    AzureResourceGroupParameters.prototype.parameterValueSummary = function (parameter) {
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.secureString && parameter.source === AzureTemplateHelper_1.Source.azureKeyVault) {
            return form_1.Summary.summary("Using Azure Key Vault");
        }
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.bool) {
            return form_1.Summary.summary((parameter.value && parameter.value !== "False") ? "True" : "False");
        }
        if (parameter.value) {
            return form_1.Summary.summary(parameter.value);
        }
        return form_1.Summary.placeholder("Value not provided");
    };
    AzureResourceGroupParameters.prototype.parameterValueHelp = function (paramName, parameter) {
        if (parameter.description) {
            return parameter.description;
        }
        if (parameter.type === AzureTemplateHelper_1.ParameterDataType.bool) {
            return "Select value for " + paramName;
        }
        return "Enter a value for " + paramName;
    };
    AzureResourceGroupParameters.prototype.getParamError = function (paramName) {
        var parameter = this.state.paramErrors.find(function (x) { return x === paramName; });
        if (parameter) {
            return parameter + " is not valid";
        }
        return null;
    };
    AzureResourceGroupParameters.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null, this.state.paramValues && Object.keys(this.state.paramValues).map(function (paramName) { return React.createElement("div", { key: paramName }, (function () {
            var paramValue = _this.state.paramValues[paramName];
            if (paramValue.allowedValues) {
                return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                    React.createElement(Select_1.BoundSelect, { variableLookup: {
                            localNames: _this.props.localNames,
                            projectId: _this.props.projectId
                        }, resetValue: "", label: paramName, value: paramValue.value, items: paramValue.allowedValues.map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
            }
            else {
                switch (paramValue.type) {
                    case AzureTemplateHelper_1.ParameterDataType.bool:
                        return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                    localNames: _this.props.localNames,
                                    projectId: _this.props.projectId
                                }, resetValue: "", key: paramName, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
                    case AzureTemplateHelper_1.ParameterDataType.int:
                        return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, type: "number", value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val && parseInt(val, 10)); } }));
                    case AzureTemplateHelper_1.ParameterDataType.string:
                        return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }));
                    case AzureTemplateHelper_1.ParameterDataType.secureString:
                        return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                            React.createElement(RadioButtonGroup_1.default, { value: paramValue.source, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "source"); } },
                                React.createElement(RadioButton_1.default, { value: AzureTemplateHelper_1.Source.octopus, label: "From Octopus" }),
                                React.createElement(RadioButton_1.default, { value: AzureTemplateHelper_1.Source.azureKeyVault, label: "From Azure Key Vault" }),
                                React.createElement(form_1.Note, null,
                                    React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started" }, "Azure Key Vault"),
                                    " allows sensitive data to be stored outside of Octopus and then used in ",
                                    React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/resource-manager-keyvault-parameter/" }, "Resource Manager templates."))),
                            paramValue.source === AzureTemplateHelper_1.Source.azureKeyVault
                                ? React.createElement("div", null,
                                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: "Resource Id", value: paramValue.keyVaultId, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "keyVaultId"); } }),
                                    React.createElement(form_1.Note, null,
                                        React.createElement(ExternalLink_1.default, { href: "https://docs.microsoft.com/en-us/powershell/module/azurerm.keyvault/get-azurermkeyvault" }, "Get-AzureRMKeyVault"),
                                        " PowerShell cmdlet can be used to retrieve this value."),
                                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: "Secret Name", value: paramValue.keyVaultSecretName, onChange: function (val) { return _this.onParameterValueChange(paramName, val, "keyVaultSecretName"); } }))
                                : React.createElement("div", null,
                                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, label: paramName, value: paramValue.value, onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }),
                                    React.createElement(form_1.Note, null,
                                        "This parameter's type is 'secureString'. To avoid it being stored in plain text, please do not enter values directly. Instead use either a ",
                                        React.createElement(ExternalLink_1.default, { href: "SensitiveVariables" }, "Sensitive Variable"),
                                        React.createElement("span", null, " or "),
                                        React.createElement(ExternalLink_1.default, { href: "https://azure.microsoft.com/en-us/documentation/articles/key-vault-get-started" }, "Azure Key Vault"))));
                    case AzureTemplateHelper_1.ParameterDataType.array:
                    default:
                        return React.createElement(form_1.ExpandableFormSection, { errorKey: paramName, title: paramName, summary: _this.parameterValueSummary(paramValue), help: _this.parameterValueHelp(paramName, paramValue) },
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: _this.props.localNames, projectId: _this.props.projectId, key: paramName, label: paramName, multiLine: true, rows: 5, value: paramValue.value, error: _this.getParamError(paramName), onChange: function (val) { return _this.onParameterValueChange(paramName, val); } }),
                            paramValue.type === AzureTemplateHelper_1.ParameterDataType.array &&
                                React.createElement(form_1.Note, null,
                                    "This parameter's type is 'array'. Data should be entered in array format. Examples: ",
                                    React.createElement("code", null, "[10, 100, 1000]"),
                                    ", ",
                                    React.createElement("code", null, "[\"Rick\", \"Morty\"]")));
                }
            }
        })()); })));
    };
    return AzureResourceGroupParameters;
}(React.Component));
exports.default = AzureResourceGroupParameters;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupParameters.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupParameters.tsx"); } } })();

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(60);
var CodeEditor_1 = __webpack_require__(107);
var AzureTemplateHelper_1 = __webpack_require__(748);
var SaveDialogLayout_1 = __webpack_require__(300);
var CopyToClipboardButton_1 = __webpack_require__(415);
var SaveDialogLayout_2 = __webpack_require__(300);
var DialogActions_1 = __webpack_require__(749);
var AzureResourceGroupSourceCodeDialog = (function (_super) {
    __extends(AzureResourceGroupSourceCodeDialog, _super);
    function AzureResourceGroupSourceCodeDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            template: _this.props.template
        };
        return _this;
    }
    AzureResourceGroupSourceCodeDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = AzureTemplateHelper_1.AzureTemplateHelper.extractParameters(this.state.template);
                        if (!(result.errors.length > 0)) return [3 /*break*/, 1];
                        this.setState({
                            errors: {
                                message: "The source code contains errors",
                                details: result.errors.slice(),
                                fieldErrors: {}
                            }
                        });
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.props.saveDone(this.state.template)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AzureResourceGroupSourceCodeDialog.prototype.onFocusedEditorEscapePressed = function () {
        if (this.editor) {
            this.editor.blur();
        }
    };
    AzureResourceGroupSourceCodeDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { close: this.props.close, open: this.props.open, renderTitle: function () { return React.createElement(SaveDialogLayout_2.SaveDialogTitleBar, { title: "Edit ARM Template" }); }, busy: null, errors: this.state.errors, onSaveClick: function () { return _this.save(); }, renderActions: function (renderProps) { return (React.createElement(DialogActions_1.default, { actions: React.createElement(SaveDialogLayout_2.SaveDialogActions, { close: renderProps.close, onSaveClick: renderProps.onSaveClick, savePermission: renderProps.savePermission }), additionalActions: React.createElement(CopyToClipboardButton_1.default, { value: _this.state.template }) })); } },
            React.createElement(CodeEditor_1.default, { value: this.state.template, ref: function (e) { return _this.editor = e; }, language: CodeEditor_1.TextFormat.JSON, allowFullScreen: false, onChange: function (template) { return _this.setState({ template: template }); }, autoFocus: this.props.template == null || this.props.template === undefined || this.props.template.length === 0, onEscPressed: function () { return _this.onFocusedEditorEscapePressed(); } }));
    };
    return AzureResourceGroupSourceCodeDialog;
}(BaseComponent_1.default));
exports.default = AzureResourceGroupSourceCodeDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSourceCodeDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureResourceGroup\\AzureResourceGroupSourceCodeDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var CustomDialog_1 = __webpack_require__(2059);
var TransitionAnimation_1 = __webpack_require__(82);
var KeyboardHandler_1 = __webpack_require__(377);
var BaseDialogLayout = (function (_super) {
    __extends(BaseDialogLayout, _super);
    function BaseDialogLayout(props) {
        return _super.call(this, props) || this;
    }
    BaseDialogLayout.prototype.render = function () {
        var _a = this.props, render = _a.render, open = _a.open, close = _a.close;
        var keyboardRegistrations = [{ key: KeyboardHandler_1.Key.Esc, onKeyPressed: this.onEscKeyPressed.bind(this) }];
        return React.createElement(CustomDialog_1.default, { open: open, close: close, render: function (renderProps) {
                return React.createElement(TransitionAnimation_1.default, null,
                    React.createElement(KeyboardHandler_1.default, { registrations: keyboardRegistrations },
                        render(renderProps),
                        ";"));
            } });
    };
    BaseDialogLayout.prototype.onEscKeyPressed = function () {
        if (this.props.close) {
            this.props.close();
            return true;
        }
        return false;
    };
    return BaseDialogLayout;
}(React.Component));
exports.BaseDialogLayout = BaseDialogLayout;
exports.default = BaseDialogLayout;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\BaseLayout.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\BaseLayout.tsx"); } } })();

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(33);
var cn = __webpack_require__(19);
var styles = __webpack_require__(2060);
var BodyPortal = (function (_super) {
    __extends(BodyPortal, _super);
    function BodyPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.mount = document.createElement("div");
        return _this;
    }
    BodyPortal.prototype.componentDidMount = function () {
        document.body.className = cn(document.body.className, this.props.bodyClasses);
        document.body.appendChild(this.mount);
    };
    BodyPortal.prototype.componentWillUnmount = function () {
        document.body.classList.remove(this.props.bodyClasses);
        document.body.removeChild(this.mount);
    };
    BodyPortal.prototype.render = function () {
        return ReactDOM.createPortal(this.props.children, this.mount);
    };
    return BodyPortal;
}(React.Component));
exports.Overlay = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement(BodyPortal, { bodyClasses: styles.noscroll },
        React.createElement("div", { className: cn(styles.overlay, className) }, children));
};
exports.CustomDialog = function (_a) {
    var open = _a.open, close = _a.close, render = _a.render;
    if (!open) {
        return null;
    }
    var renderProps = { open: open, close: close };
    return React.createElement(exports.Overlay, null, render(renderProps));
};
exports.default = exports.CustomDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\CustomDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Dialog\\CustomDialog.tsx"); } } })();

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2061);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CustomDialog.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../node_modules/less-loader/dist/cjs.js!./CustomDialog.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.CustomDialog_hide-sm__1IXko{display:none!important}}@media (min-width:37.4rem){.CustomDialog_visible-sm__521U3{display:none!important}}@media (max-width:79.9rem){.CustomDialog_hide-md__1k62K{display:none!important}}@media (min-width:79.9rem){.CustomDialog_visible-md__3IQ_a{display:none!important}}.CustomDialog_root__OySTg{flex:auto;display:flex;flex-direction:column}.CustomDialog_root__OySTg>*{flex:auto}.CustomDialog_overlay__OyXqY{background-color:rgba(0,0,0,.6);position:fixed;top:0;left:0;right:0;bottom:0;z-index:10}.CustomDialog_noscroll__33ReA{overflow-x:hidden;overflow-y:hidden}", ""]);

// exports
exports.locals = {
	"hide-sm": "CustomDialog_hide-sm__1IXko",
	"hideSm": "CustomDialog_hide-sm__1IXko",
	"visible-sm": "CustomDialog_visible-sm__521U3",
	"visibleSm": "CustomDialog_visible-sm__521U3",
	"hide-md": "CustomDialog_hide-md__1k62K",
	"hideMd": "CustomDialog_hide-md__1k62K",
	"visible-md": "CustomDialog_visible-md__3IQ_a",
	"visibleMd": "CustomDialog_visible-md__3IQ_a",
	"root": "CustomDialog_root__OySTg",
	"overlay": "CustomDialog_overlay__OyXqY",
	"noscroll": "CustomDialog_noscroll__33ReA"
};

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(2063);
exports.DialogFrame = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("div", { className: cn(styles.frame, className) }, children);
};
exports.FullScreenDialogFrame = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement(exports.DialogFrame, { className: cn(styles.fullscreen, className) }, children);
};
exports.HugeDialogFrame = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement(exports.DialogFrame, { className: cn(styles.huge, className) }, children);
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogFrames.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogFrames.tsx"); } } })();

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2064);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogFrames.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogFrames.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.DialogFrames_hide-sm__31WAW{display:none!important}}@media (min-width:37.4rem){.DialogFrames_visible-sm__2yIR8{display:none!important}}@media (max-width:79.9rem){.DialogFrames_hide-md__3Zk03{display:none!important}}@media (min-width:79.9rem){.DialogFrames_visible-md__BeoMB{display:none!important}}.DialogFrames_frame__3Bpma{position:fixed;background:#fff;display:flex;flex-direction:column}.DialogFrames_fullscreen__2mX8f{top:0;left:0;right:0;bottom:0}.DialogFrames_huge__3CxJU{top:5%;left:5%;bottom:5%;right:5%;box-shadow:0 14px 45px rgba(0,0,0,.25),0 10px 18px rgba(0,0,0,.22);border-radius:2px}@media (max-width:37.4rem){.DialogFrames_huge__3CxJU{top:0;left:0;bottom:0;right:0}}", ""]);

// exports
exports.locals = {
	"hide-sm": "DialogFrames_hide-sm__31WAW",
	"hideSm": "DialogFrames_hide-sm__31WAW",
	"visible-sm": "DialogFrames_visible-sm__2yIR8",
	"visibleSm": "DialogFrames_visible-sm__2yIR8",
	"hide-md": "DialogFrames_hide-md__3Zk03",
	"hideMd": "DialogFrames_hide-md__3Zk03",
	"visible-md": "DialogFrames_visible-md__BeoMB",
	"visibleMd": "DialogFrames_visible-md__BeoMB",
	"frame": "DialogFrames_frame__3Bpma",
	"fullscreen": "DialogFrames_fullscreen__2mX8f",
	"huge": "DialogFrames_huge__3CxJU"
};

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var cn = __webpack_require__(19);
var styles = __webpack_require__(2066);
exports.DialogTitleBar = function (_a) {
    var title = _a.title, actions = _a.actions, className = _a.className;
    return React.createElement("div", { className: cn(styles.titleBar, className) },
        React.createElement("div", { className: styles.title },
            React.createElement("h1", null, title)),
        React.createElement("div", { className: styles.actions }, actions));
};
exports.default = exports.DialogTitleBar;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogTitleBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\DialogLayout\\Custom\\DialogTitleBar.tsx"); } } })();

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2067);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogTitleBar.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogTitleBar.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".DialogTitleBar_titleBar__2KVye{background-color:#fff;height:3rem;display:flex;justify-content:space-between;align-items:center;padding:0 1rem;z-index:1}.DialogTitleBar_title__29SiO{flex-grow:1;font-size:1.25rem}.DialogTitleBar_title__29SiO h1,.DialogTitleBar_title__29SiO h2{font-size:1.25rem;margin:0;padding:0}.DialogTitleBar_actions__22Xed{padding:.5rem 1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.DialogTitleBar_actions__22Xed>*{margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"titleBar": "DialogTitleBar_titleBar__2KVye",
	"title": "DialogTitleBar_title__29SiO",
	"actions": "DialogTitleBar_actions__22Xed"
};

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2069);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./SaveDialogLayout.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./SaveDialogLayout.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.SaveDialogLayout_hide-sm__xakpY{display:none!important}}@media (min-width:37.4rem){.SaveDialogLayout_visible-sm__1TaHc{display:none!important}}@media (max-width:79.9rem){.SaveDialogLayout_hide-md__Jfwt2{display:none!important}}@media (min-width:79.9rem){.SaveDialogLayout_visible-md__qLvIy{display:none!important}}.SaveDialogLayout_errorsContainer__UA1uK{flex:none}.SaveDialogLayout_content__2gmCr{flex:auto;display:flex;flex-direction:column}.SaveDialogLayout_content__2gmCr>*{flex:auto}", ""]);

// exports
exports.locals = {
	"hide-sm": "SaveDialogLayout_hide-sm__xakpY",
	"hideSm": "SaveDialogLayout_hide-sm__xakpY",
	"visible-sm": "SaveDialogLayout_visible-sm__1TaHc",
	"visibleSm": "SaveDialogLayout_visible-sm__1TaHc",
	"hide-md": "SaveDialogLayout_hide-md__Jfwt2",
	"hideMd": "SaveDialogLayout_hide-md__Jfwt2",
	"visible-md": "SaveDialogLayout_visible-md__qLvIy",
	"visibleMd": "SaveDialogLayout_visible-md__qLvIy",
	"errorsContainer": "SaveDialogLayout_errorsContainer__UA1uK",
	"content": "SaveDialogLayout_content__2gmCr"
};

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2071);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogActions.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./DialogActions.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".DialogActions_actions__1oT1D{padding:.75rem 1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.DialogActions_primaryActions__1i-Iz>*{margin-left:.5rem}.DialogActions_secondaryActions__1D1nP>*{margin-right:.5rem}", ""]);

// exports
exports.locals = {
	"actions": "DialogActions_actions__1oT1D",
	"primaryActions": "DialogActions_primaryActions__1i-Iz",
	"secondaryActions": "DialogActions_secondaryActions__1D1nP"
};

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var PackageSelector_1 = __webpack_require__(53);
var ExternalLink_1 = __webpack_require__(26);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(30);
var FormSectionHeading_1 = __webpack_require__(48);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var WarningFormSection_1 = __webpack_require__(134);
var AzureServiceFabricSdkRequiredInfo_1 = __webpack_require__(750);
var VariableLookupText_1 = __webpack_require__(21);
var AzureServiceFabricAccountSelector_1 = __webpack_require__(751);
var Note_1 = __webpack_require__(20);
var Summary_1 = __webpack_require__(44);
var StringCheckbox_1 = __webpack_require__(41);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var resources_1 = __webpack_require__(17);
var Callout_1 = __webpack_require__(57);
var AzureServiceFabricAppActionSummary = (function (_super) {
    __extends(AzureServiceFabricAppActionSummary, _super);
    function AzureServiceFabricAppActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureServiceFabricAppActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureServiceFabricAppActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy Azure Service Fabric Application",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return AzureServiceFabricAppActionSummary;
}(BaseComponent_1.BaseComponent));
var UpgradeBehavior;
(function (UpgradeBehavior) {
    UpgradeBehavior["None"] = "None";
    UpgradeBehavior["ForceUpgrade"] = "ForceUpgrade";
    UpgradeBehavior["VetoUpgrade"] = "VetoUpgrade";
})(UpgradeBehavior || (UpgradeBehavior = {}));
var OverwriteBehavior;
(function (OverwriteBehavior) {
    OverwriteBehavior["Never"] = "Never";
    OverwriteBehavior["Always"] = "Always";
    OverwriteBehavior["SameAppTypeAndVersion"] = "SameAppTypeAndVersion";
})(OverwriteBehavior || (OverwriteBehavior = {}));
var AzureServiceFabricAppActionEdit = (function (_super) {
    __extends(AzureServiceFabricAppActionEdit, _super);
    function AzureServiceFabricAppActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            resetValues: {
                ClientCertVariable: props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]
            }
        };
        return _this;
    }
    AzureServiceFabricAppActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var properties, isLegacyActionType;
                            return __generator(this, function (_a) {
                                properties = {};
                                isLegacyActionType = !!(properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
                                if (isLegacyActionType) {
                                    if (!this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"]) {
                                        properties["Octopus.Action.ServiceFabric.SecurityMode"] = resources_1.AzureServiceFabricSecurityMode.Unsecure;
                                    }
                                    if (!this.props.properties["Octopus.Action.ServiceFabric.AadCredentialType"]) {
                                        properties["Octopus.Action.ServiceFabric.AadCredentialType"] = resources_1.AADCredentialType.UserCredential;
                                    }
                                }
                                if (!this.props.properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"]) {
                                    properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"] = UpgradeBehavior.None;
                                }
                                if (!this.props.properties["Octopus.Action.ServiceFabric.OverwriteBehavior"]) {
                                    properties["Octopus.Action.ServiceFabric.OverwriteBehavior"] = OverwriteBehavior.SameAppTypeAndVersion;
                                }
                                this.props.setProperties(properties, true);
                                return [2 /*return*/];
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureServiceFabricAppActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var properties = this.props.properties;
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var isLegacyActionType = !!(properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                React.createElement(AzureServiceFabricSdkRequiredInfo_1.default, null),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(FormSectionHeading_1.default, { title: "Package" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: React.createElement("span", null,
                    "This step is used to deploy the contents of a Service Fabric package. The package that you wish to deploy should contain your ",
                    React.createElement("em", null, "ApplicationParameters"),
                    " and ",
                    React.createElement("em", null, "PublishProfiles"),
                    " folders, as well as your application package folder(s). Please see the ",
                    React.createElement(ExternalLink_1.default, { href: "ServiceFabricPackaging" }, "Service Fabric Packaging guide"),
                    " to learn about what your package should contain, and how to create them.") },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
            isLegacyActionType &&
                React.createElement("div", null,
                    React.createElement(FormSectionHeading_1.default, { title: "Service Fabric Cluster" }),
                    React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                        React.createElement("strong", null,
                            "This step is referencing a Service Fabric cluster directly, instead of referencing a ",
                            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "Service Fabric Cluster Target"),
                            " through Roles. Please read ",
                            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "our documentation"),
                            " to learn how to get started with Azure Targets.")),
                    React.createElement(AzureServiceFabricAccountSelector_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, clientCertVariableResetValue: this.state.resetValues.ClientCertVariable, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, expandedByDefault: this.props.expandedByDefault })),
            React.createElement(FormSectionHeading_1.default, { title: "Deployment" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.PublishProfileFile", isExpandedByDefault: this.props.expandedByDefault, title: "Publish Profile File", summary: properties["Octopus.Action.ServiceFabric.PublishProfileFile"]
                    ? Summary_1.default.summary(properties["Octopus.Action.ServiceFabric.PublishProfileFile"])
                    : Summary_1.default.placeholder("Publish profile file not provided"), help: "Select the path to your publish profile file." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.PublishProfileFile"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.PublishProfileFile"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.PublishProfileFile"), hintText: "eg. PublishProfiles\\Cloud.xml", label: "Publish profile file" }),
                React.createElement(Note_1.default, null,
                    "Octopus will use the ApplicationParameters file referenced in this publish profile. This value is typically ",
                    React.createElement("code", null, "PublishProfiles\\Cloud.xml"))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.DeployOnly", isExpandedByDefault: this.props.expandedByDefault, title: "Deploy Only", summary: properties["Octopus.Action.ServiceFabric.DeployOnly"] && properties["Octopus.Action.ServiceFabric.DeployOnly"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The application will ",
                        React.createElement("strong", null, "not"),
                        " but created or updated"))
                    : Summary_1.default.default("The application will be created or updated"), help: "If selected, the Service Fabric application will not be created or upgraded after registering the application type." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.DeployOnly"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.DeployOnly"] = x, _a));
                        var _a;
                    }, label: "Deploy only" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade", isExpandedByDefault: this.props.expandedByDefault, title: "Unregister Unused Versions", summary: properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"]
                    && properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Unused versions ",
                        React.createElement("strong", null, "will"),
                        " be unregistered"))
                    : Summary_1.default.default("Unused versions will not be unregistered"), help: "Select to unregister any unused application versions that exist after an upgrade is finished." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.UnregisterUnusedApplicationVersionsAfterUpgrade"] = x, _a));
                        var _a;
                    }, label: "Unregister" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.OverrideUpgradeBehavior", isExpandedByDefault: this.props.expandedByDefault, title: "Override Upgrade Behavior", summary: this.upgradeBehaviorSummary(), help: "Indicates the behavior used to override the upgrade settings specified by the publish profile." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: UpgradeBehavior.None, value: properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"] = x, _a));
                        var _a;
                    }, label: "Upgrade behavior" },
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.None, label: "None", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.ForceUpgrade, label: "Force upgrade" }),
                    React.createElement(RadioButton_1.default, { value: UpgradeBehavior.VetoUpgrade, label: "Veto upgrade" }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.OverwriteBehavior", isExpandedByDefault: this.props.expandedByDefault, title: "Overwrite Behavior", summary: this.overwriteBehaviorSummary(), help: "Overwrite behavior if an application exists in the cluster with the same name. This setting is not applicable when upgrading an application." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: OverwriteBehavior.SameAppTypeAndVersion, value: properties["Octopus.Action.ServiceFabric.OverwriteBehavior"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.OverwriteBehavior"] = x, _a));
                        var _a;
                    }, label: "Overwrite behavior" },
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.Never, label: "Never" }),
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.Always, label: "Always" }),
                    React.createElement(RadioButton_1.default, { value: OverwriteBehavior.SameAppTypeAndVersion, label: "Same app type and version", isDefault: true }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.SkipPackageValidation", isExpandedByDefault: this.props.expandedByDefault, title: "Skip Package Validation", summary: properties["Octopus.Action.ServiceFabric.SkipPackageValidation"]
                    && properties["Octopus.Action.ServiceFabric.SkipPackageValidation"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Tell Service Fabric ",
                        React.createElement("strong", null, "not"),
                        " to perform package validation"))
                    : Summary_1.default.default("Service Fabric will perform package validation"), help: "Select to tell Service Fabric not to validate the package before deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.ServiceFabric.SkipPackageValidation"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.SkipPackageValidation"] = x, _a));
                        var _a;
                    }, label: "Skip validation" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.CopyPackageTimeoutSec", isExpandedByDefault: this.props.expandedByDefault, title: "Copy Package Timeout", summary: properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"]
                    ? Summary_1.default.summary(React.createElement("span", null,
                        properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"],
                        " seconds"))
                    : Summary_1.default.default("Unchanged"), help: "Enter a value in seconds to override the timeout for copying an application package to the image store." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.CopyPackageTimeoutSec"), label: "Copy package timeout (seconds)" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec", isExpandedByDefault: this.props.expandedByDefault, title: "Register Application Type Timeout", summary: properties["Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec"]
                    ? Summary_1.default.summary(React.createElement("span", null,
                        properties["Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec"],
                        " seconds"))
                    : Summary_1.default.default("Unchanged"), help: "Enter a value in seconds to override the timeout for registering application type." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.ServiceFabric.RegisterApplicationTypeTimeoutSec"), label: "Register Application Type Timeout (seconds)" })));
    };
    AzureServiceFabricAppActionEdit.prototype.upgradeBehaviorSummary = function () {
        var behavior = this.props.properties["Octopus.Action.ServiceFabric.OverrideUpgradeBehavior"];
        if (behavior === UpgradeBehavior.None) {
            return Summary_1.default.default("None");
        }
        if (behavior === UpgradeBehavior.ForceUpgrade) {
            return Summary_1.default.summary("Force upgrade");
        }
        if (behavior === UpgradeBehavior.VetoUpgrade) {
            return Summary_1.default.summary("Veto upgrade");
        }
        return Summary_1.default.summary("Bound to a project variable");
    };
    AzureServiceFabricAppActionEdit.prototype.overwriteBehaviorSummary = function () {
        var behavior = this.props.properties["Octopus.Action.ServiceFabric.OverwriteBehavior"];
        if (behavior === OverwriteBehavior.Never) {
            return Summary_1.default.summary("Never");
        }
        if (behavior === OverwriteBehavior.Always) {
            return Summary_1.default.summary("Always");
        }
        if (behavior === OverwriteBehavior.SameAppTypeAndVersion) {
            return Summary_1.default.default("Same app type and version");
        }
        return Summary_1.default.summary("Bound to a project variable");
    };
    return AzureServiceFabricAppActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureServiceFabricApp",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(AzureServiceFabricAppActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: AzureServiceFabricAppActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) {
        // Azure steps (pre Q1.2018) allowed you to select connection endpoint directly on the step, making target selection optional.
        var isLegacyActionType = !!(action ? action.Properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"] : null);
        return isLegacyActionType ? ActionDetails_1.TargetRoles.Optional : ActionDetails_1.TargetRoles.Required;
    },
    hasPackages: function (action) { return true; },
    features: {
        optional: [
            "Octopus.Features.ConfigurationTransforms",
            "Octopus.Features.ConfigurationVariables",
            "Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"
        ]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\azureServiceFabricAppAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricApp\\azureServiceFabricAppAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var FormSectionHeading_1 = __webpack_require__(48);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var WarningFormSection_1 = __webpack_require__(134);
var AzureServiceFabricSdkRequiredInfo_1 = __webpack_require__(750);
var AzureServiceFabricAccountSelector_1 = __webpack_require__(751);
var scriptAction_1 = __webpack_require__(234);
var ActionDetails_1 = __webpack_require__(25);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var resources_1 = __webpack_require__(17);
var ExternalLink_1 = __webpack_require__(91);
var Callout_1 = __webpack_require__(58);
var AzureServiceFabricPowerShellSummary = (function (_super) {
    __extends(AzureServiceFabricPowerShellSummary, _super);
    function AzureServiceFabricPowerShellSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AzureServiceFabricPowerShellSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Run a PowerShell script using an Azure Service Fabric cluster context",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AzureServiceFabricPowerShellSummary;
}(BaseComponent_1.BaseComponent));
var AzureServiceFabricPowerShellActionEdit = (function (_super) {
    __extends(AzureServiceFabricPowerShellActionEdit, _super);
    function AzureServiceFabricPowerShellActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            resetValues: {
                ClientCertVariable: props.properties["Octopus.Action.ServiceFabric.ClientCertVariable"]
            }
        };
        return _this;
    }
    AzureServiceFabricPowerShellActionEdit.prototype.componentDidMount = function () {
        var properties = {};
        var isLegacyActionType = !!(properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
        if (isLegacyActionType) {
            if (!this.props.properties["Octopus.Action.ServiceFabric.SecurityMode"]) {
                properties["Octopus.Action.ServiceFabric.SecurityMode"] = resources_1.AzureServiceFabricSecurityMode.Unsecure;
            }
            if (!this.props.properties["Octopus.Action.ServiceFabric.AadCredentialType"]) {
                properties["Octopus.Action.ServiceFabric.AadCredentialType"] = resources_1.AADCredentialType.UserCredential;
            }
        }
        this.props.setProperties(properties, true);
    };
    AzureServiceFabricPowerShellActionEdit.prototype.render = function () {
        var properties = this.props.properties;
        var isLegacyActionType = !!(properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"]);
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                React.createElement(AzureServiceFabricSdkRequiredInfo_1.default, null),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            isLegacyActionType &&
                React.createElement("div", null,
                    React.createElement(FormSectionHeading_1.default, { title: "Service Fabric Cluster" }),
                    React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                        React.createElement("strong", null,
                            "This step is referencing a Service Fabric cluster directly, instead of referencing a ",
                            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "Service Fabric Cluster Target"),
                            " through Roles. Please read ",
                            React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "our documentation"),
                            " to learn how to get started with Azure Targets.")),
                    React.createElement(AzureServiceFabricAccountSelector_1.default, { projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, clientCertVariableResetValue: this.state.resetValues.ClientCertVariable, setProperties: this.props.setProperties, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, expandedByDefault: this.props.expandedByDefault })),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, supportedLanguages: ScriptingLanguageSelector_1.SupportedLanguage.PowerShell, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }));
    };
    return AzureServiceFabricPowerShellActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureServiceFabricPowerShell",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AzureServiceFabricPowerShellSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AzureServiceFabricPowerShellActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) {
        // Azure steps (pre Q1.2018) allowed you to select connection endpoint directly on the step, making target selection optional.
        var isLegacyActionType = !!(action ? action.Properties["Octopus.Action.ServiceFabric.ConnectionEndpoint"] : null);
        return isLegacyActionType ? ActionDetails_1.TargetRoles.Optional : ActionDetails_1.TargetRoles.Required;
    },
    hasPackages: function (action) { return false; },
    features: {
        optional: ["Octopus.Features.SubstituteInFiles", "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricPowerShell\\azureServiceFabricPowerShellAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureServiceFabricPowerShell\\azureServiceFabricPowerShellAction.tsx"); } } })();

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var ExpandableFormSection_1 = __webpack_require__(30);
var PackageSelector_1 = __webpack_require__(53);
var ExternalLink_1 = __webpack_require__(26);
var CommonSummaryHelper_1 = __webpack_require__(62);
var Summary_1 = __webpack_require__(44);
var AzurePowerShellScriptInfo_1 = __webpack_require__(192);
var resources_1 = __webpack_require__(17);
var AzureServerTargetRolesInfo_1 = __webpack_require__(299);
var isBound_1 = __webpack_require__(54);
var AzureWebSiteSelector_1 = __webpack_require__(2075);
var AzureWebSlotSelector_1 = __webpack_require__(2076);
var FormSectionHeading_1 = __webpack_require__(48);
var WarningFormSection_1 = __webpack_require__(134);
var StringCheckbox_1 = __webpack_require__(41);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var AccountSelect_1 = __webpack_require__(202);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var Callout_1 = __webpack_require__(57);
var PermissionCheck_1 = __webpack_require__(42);
var AzureWebAppActionSummary = (function (_super) {
    __extends(AzureWebAppActionSummary, _super);
    function AzureWebAppActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureWebAppActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureWebAppActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy an Azure Web App",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return AzureWebAppActionSummary;
}(BaseComponent_1.BaseComponent));
var AzureWebAppEdit = (function (_super) {
    __extends(AzureWebAppEdit, _super);
    function AzureWebAppEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.getAccountId = function () {
            return isBound_1.default(_this.props.properties["Octopus.Action.Azure.AccountId"]) ? undefined : _this.props.properties["Octopus.Action.Azure.AccountId"];
        };
        _this.refreshAccounts = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                        case 1:
                            _a.apply(this, [(_b.accounts = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            accountIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.AccountId"], false),
            webAppIsBound: isBound_1.default(props.properties["Octopus.Action.Azure.WebAppName"], false)
        };
        return _this;
    }
    AzureWebAppEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, properties;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!(!!(this.props.properties["Octopus.Action.Azure.AccountId"]) && PermissionCheck_1.isAllowed({ permission: resources_1.Permission.AccountView, wildcard: true }))) return [3 /*break*/, 2];
                                        _a = this.setState;
                                        _b = {};
                                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        _a.apply(this, [(_b.accounts = _c.sent(),
                                                _b)]);
                                        _c.label = 2;
                                    case 2:
                                        properties = {};
                                        if (this.props.properties["Octopus.Action.Azure.UseChecksum"] === undefined) {
                                            properties["Octopus.Action.Azure.UseChecksum"] = "False";
                                        }
                                        this.convertAzureWebAppNameAndSlot();
                                        this.props.setProperties(properties, true);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureWebAppEdit.prototype.convertAzureWebAppNameAndSlot = function () {
        var webAppName = this.props.properties["Octopus.Action.Azure.WebAppName"];
        var slotName = this.props.properties["Octopus.Action.Azure.DeploymentSlot"];
        if (!webAppName) {
            return;
        }
        var slashPosition = webAppName.indexOf("/");
        var parenPosition = webAppName.indexOf("(");
        if (slashPosition > 0) {
            slotName = webAppName.substring(slashPosition + 1).trim();
            webAppName = webAppName.substring(0, slashPosition).trim();
        }
        else if (parenPosition > 0) {
            slotName = webAppName.substring(parenPosition + 1).replace(")", "").trim();
            webAppName = webAppName.substring(0, parenPosition).trim();
        }
        this.props.properties["Octopus.Action.Azure.WebAppName"] = webAppName;
        this.props.properties["Octopus.Action.Azure.DeploymentSlot"] = slotName;
    };
    AzureWebAppEdit.prototype.accountSummary = function () {
        var accountId = this.props.properties["Octopus.Action.Azure.AccountId"];
        if (!accountId) {
            return Summary_1.default.placeholder("No account has been selected");
        }
        var account = this.state.accounts.find(function (a) { return a.Id === accountId; });
        if (!account) {
            if (isBound_1.default(accountId, false)) {
                return Summary_1.default.summary(React.createElement("span", null,
                    "Account is bound to ",
                    React.createElement("strong", null, accountId)));
            }
            return Summary_1.default.placeholder("No account has been selected");
        }
        var webAppName = this.props.properties["Octopus.Action.Azure.WebAppName"];
        var resourceGroup = this.props.properties["Octopus.Action.Azure.ResourceGroupName"];
        var webAppSlot = this.props.properties["Octopus.Action.Azure.DeploymentSlot"];
        if (!webAppName) {
            return Summary_1.default.placeholder("No Web App has been selected");
        }
        var summary = [];
        summary.push(React.createElement("span", null,
            "Account ",
            React.createElement("strong", null, account.Name),
            " will be used to deploy to Web App ",
            React.createElement("strong", null, webAppName)));
        if (webAppSlot) {
            summary.push(React.createElement("span", null,
                ", deployment slot ",
                React.createElement("strong", null, webAppSlot),
                ","));
        }
        if (resourceGroup) {
            summary.push(React.createElement("span", null,
                " in resource group ",
                React.createElement("strong", null, resourceGroup)));
        }
        return Summary_1.default.summary(React.Children.toArray(summary));
    };
    AzureWebAppEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var properties = this.props.properties;
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var isLegacyActionType = !!(properties["Octopus.Action.Azure.AccountId"]);
        return React.createElement("div", null,
            React.createElement(WarningFormSection_1.default, null,
                this.props.additionalActions && React.createElement(AzureServerTargetRolesInfo_1.default, { stepTargetRoles: this.props.additionalActions.stepTargetRoles, isCompatibleWithCloudRegions: false }),
                React.createElement(AzurePowerShellScriptInfo_1.default, { actionType: this.props.plugin.actionType })),
            React.createElement(FormSectionHeading_1.default, { title: "Package" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "package", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: React.createElement("span", null,
                    "This step is used to deploy an Azure Web App. The package that you select should contain your all the files needed to run your application. ",
                    React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more about what your packages should contain, and how to create them"),
                    ".") },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
            isLegacyActionType &&
                React.createElement("div", null,
                    React.createElement(FormSectionHeading_1.default, { title: "Azure" }),
                    React.createElement(PermissionCheck_1.default, { permission: resources_1.Permission.AccountView, wildcard: true, alternate: React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Information },
                            "The ",
                            resources_1.Permission.AccountView,
                            " permission is required to change the Azure settings.") },
                        React.createElement(Callout_1.default, { type: Callout_1.CalloutType.Warning },
                            React.createElement("strong", null,
                                "This step is referencing an Azure Account directly, instead of referencing an ",
                                React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "Azure Web Application Target"),
                                " through Roles. Please read ",
                                React.createElement(ExternalLink_1.default, { href: "http://g.octopushq.com/AzureTargets" }, "our documentation"),
                                " to learn how to get started with Azure Targets.")),
                        React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AccountId|Octopus.Action.Azure.WebAppName|Octopus.Action.Azure.ResourceGroupName", isExpandedByDefault: this.props.expandedByDefault, title: "Account and Web App", summary: this.accountSummary(), help: "Select the Azure account and Web App for the deployment." },
                            React.createElement(AccountSelect_1.BoundAccountSelect, { variableLookup: {
                                    localNames: this.props.localNames,
                                    projectId: this.props.projectId
                                }, resetValue: properties["Octopus.Action.Azure.AccountId"], label: "Account", value: properties["Octopus.Action.Azure.AccountId"], isBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ accountIsBound: value }); }, type: [resources_1.AccountType.AzureServicePrincipal], allowClear: true, onChange: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AccountId"] = x, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.Azure.AccountId"), items: this.state.accounts, onRequestRefresh: this.refreshAccounts }),
                            React.createElement(AzureWebSiteSelector_1.default, { doBusyTask: this.props.doBusyTask, webAppName: properties["Octopus.Action.Azure.WebAppName"], webAppNameError: this.props.getFieldError("Octopus.Action.Azure.WebAppName"), resourceGroupName: properties["Octopus.Action.Azure.ResourceGroupName"], resourceGroupError: this.props.getFieldError("Octopus.Action.Azure.ResourceGroupName"), onWebAppNameChanged: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.WebAppName"] = x, _a));
                                    var _a;
                                }, onResourceGroupChanged: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.ResourceGroupName"] = x, _a));
                                    var _a;
                                }, projectId: this.props.projectId, accountId: this.getAccountId(), isAccountBound: this.state.accountIsBound, onIsBoundChanged: function (value) { return _this.setState({ webAppIsBound: value }); }, localNames: this.props.localNames }),
                            React.createElement(AzureWebSlotSelector_1.default, { doBusyTask: this.props.doBusyTask, projectId: this.props.projectId, accountId: this.getAccountId(), webAppName: properties["Octopus.Action.Azure.WebAppName"], resourceGroupName: properties["Octopus.Action.Azure.ResourceGroupName"], webAppSlotName: properties["Octopus.Action.Azure.DeploymentSlot"], webAppSlotNameError: this.props.getFieldError("Octopus.Action.Azure.DeploymentSlot"), onWebAppSlotNameChanged: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.DeploymentSlot"] = x, _a));
                                    var _a;
                                }, isAccountBound: this.state.accountIsBound, isWebAppBound: this.state.webAppIsBound, localNames: this.props.localNames })))),
            React.createElement(FormSectionHeading_1.default, { title: "Deployment" }),
            !isLegacyActionType &&
                React.createElement("div", null,
                    React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.DeploymentSlot", title: "Deployment Slot", summary: properties["Octopus.Action.Azure.DeploymentSlot"]
                            ? Summary_1.default.summary(React.createElement("span", null,
                                "The deployment slot is ",
                                React.createElement("strong", null, properties["Octopus.Action.Azure.DeploymentSlot"])))
                            : Summary_1.default.placeholder("No deployment slot defined"), help: "Optionally, enter the deployment slot." },
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Azure.DeploymentSlot"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.DeploymentSlot"] = x, _a));
                                var _a;
                            }, error: this.props.getFieldError("Octopus.Action.Azure.DeploymentSlot"), label: "Deployment Slot" }),
                        React.createElement(Note_1.default, null,
                            "Slots let you deploy different versions of your web app to different URLs. You can test a certain version and then swap content and configuration between slots.",
                            React.createElement("strong", null, "The slot will only apply if you have selected roles that scope to Azure Web App targets that represent the base App Service URL (and not the deployment slot URLs).")))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.PhysicalPath", isExpandedByDefault: this.props.expandedByDefault, title: "Physical Path", summary: properties["Octopus.Action.Azure.PhysicalPath"]
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The physical path is ",
                        React.createElement("strong", null, properties["Octopus.Action.Azure.PhysicalPath"])))
                    : Summary_1.default.placeholder("No physical path has been entered"), help: "Enter the physical path to the site root." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Azure.PhysicalPath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.PhysicalPath"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Azure.PhysicalPath"), label: "Physical path" }),
                React.createElement(Note_1.default, null,
                    "Physical path relative to site root. e.g. 'foo' will deploy to 'site\\wwwroot\\foo'.",
                    React.createElement("br", null),
                    "Leave blank to deploy to root.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.RemoveAdditionalFiles", isExpandedByDefault: this.props.expandedByDefault, title: "Remove Additional Files", summary: properties["Octopus.Action.Azure.RemoveAdditionalFiles"] && properties["Octopus.Action.Azure.RemoveAdditionalFiles"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Files in the destination that are not part of the deployment ",
                        React.createElement("strong", null, "will"),
                        " be removed"))
                    : Summary_1.default.default("Files in the destination that are not part of the deployment will not be removed"), help: "Select to remove additional files on the destination that are not part of the deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.RemoveAdditionalFiles"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.RemoveAdditionalFiles"] = x, _a));
                        var _a;
                    }, label: "Remove additional files" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.PreserveAppData", isExpandedByDefault: this.props.expandedByDefault, title: "Preserve App_Data", summary: properties["Octopus.Action.Azure.PreserveAppData"] && properties["Octopus.Action.Azure.PreserveAppData"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Files in the App_Data folder ",
                        React.createElement("strong", null, "will not"),
                        " be removed"))
                    : Summary_1.default.default("Files in the App_Data folder will be removed"), help: "Select to preserve files in the App_Data folder before deployment." },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.PreserveAppData"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.PreserveAppData"] = x, _a));
                        var _a;
                    }, label: "Preserve App_Data" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.AppOffline", isExpandedByDefault: this.props.expandedByDefault, title: "Enable AppOffline", summary: properties["Octopus.Action.Azure.AppOffline"] && properties["Octopus.Action.Azure.AppOffline"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "The app domain ",
                        React.createElement("strong", null, "will"),
                        " be safely brought down using a blank app_offline.html"))
                    : Summary_1.default.default("The app domain will not be safely brought down using a blank app_offline.html"), help: "Select to safely bring down the app domain with app_offline.html in root" },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.AppOffline"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.AppOffline"] = x, _a));
                        var _a;
                    }, label: "Enable AppOffline" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Azure.UseChecksum", isExpandedByDefault: this.props.expandedByDefault, title: "File Comparison Method", summary: properties["Octopus.Action.Azure.UseChecksum"] && properties["Octopus.Action.Azure.UseChecksum"] !== "False"
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "File ",
                        React.createElement("strong", null, "checksums"),
                        " will be used to compare files (may increase deployment time)"))
                    : Summary_1.default.default("File timestamps will be used to compare files"), help: "Select which method will be used to determine which files will be updated during deployment." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Octopus.Action.Azure.UseChecksum"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Azure.UseChecksum"] = x, _a));
                        var _a;
                    }, label: "File comparison method" },
                    React.createElement(RadioButton_1.default, { label: "Timestamp", value: "False", isDefault: true }),
                    React.createElement(Note_1.default, null, "Use file timestamps to compare files"),
                    React.createElement(RadioButton_1.default, { label: "Checksum", value: "True" }),
                    React.createElement(Note_1.default, null,
                        "Use file checksums to compare files",
                        React.createElement("br", null),
                        " ",
                        React.createElement("em", null, "Warning:"),
                        " the checksum method may cause deployment times to increase significantly"))));
    };
    return AzureWebAppEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AzureWebApp",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(AzureWebAppActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: AzureWebAppEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) {
        // Azure steps (pre Q1.2018) allowed you to select accounts directly on the step, making target selection optional.
        var isLegacyActionType = !!(action ? action.Properties["Octopus.Action.Azure.AccountId"] : null);
        return isLegacyActionType ? ActionDetails_1.TargetRoles.Optional : ActionDetails_1.TargetRoles.Required;
    },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\azureWebAppAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\azureWebAppAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Select_1 = __webpack_require__(40);
var ParseHelper_1 = __webpack_require__(66);
var isBound_1 = __webpack_require__(54);
var BusyRefreshContainer_1 = __webpack_require__(205);
var IconButton_1 = __webpack_require__(52);
var InputWithActions_1 = __webpack_require__(136);
var toggleBusy = function (value) { return function (prev, props) { return (__assign({}, prev, { busy: value ? value : !prev.busy })); }; };
var AzureWebSiteSelector = (function (_super) {
    __extends(AzureWebSiteSelector, _super);
    function AzureWebSiteSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectedSiteChanged = function (value) {
            var index = ParseHelper_1.default.safeParseInt(value, null);
            var selectedSite = index !== null ? _this.state.sites[index] : null;
            _this.props.onResourceGroupChanged(selectedSite ? selectedSite.ResourceGroup : null);
            _this.props.onWebAppNameChanged(selectedSite ? selectedSite.Name : null);
            _this.setState({ selectedSiteIndex: index !== null ? index.toString() : null });
        };
        _this.state = {
            reset: {
                resourceGroupName: null,
                name: null
            },
            siteIsBound: isBound_1.default(props.webAppName, false),
            sites: [],
            siteItems: [],
            selectedSiteIndex: null,
            busy: false
        };
        return _this;
    }
    AzureWebSiteSelector.prototype.componentDidMount = function () {
        if (!this.props.isAccountBound) {
            this.getWebSites(this.props.accountId);
        }
    };
    AzureWebSiteSelector.prototype.componentWillReceiveProps = function (newprops) {
        if (newprops.isAccountBound && !this.state.siteIsBound) {
            this.setState({ siteIsBound: true });
        }
        if (newprops.accountId !== this.props.accountId) {
            this.getWebsitesIfNotBound(newprops);
        }
    };
    AzureWebSiteSelector.prototype.getWebsitesIfNotBound = function (props) {
        if (!props.isAccountBound) {
            this.getWebSites(props.accountId);
        }
    };
    AzureWebSiteSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            this.state.siteIsBound && React.createElement("div", null,
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.resourceGroupName, onChange: this.props.onResourceGroupChanged, error: this.props.resourceGroupError, label: "Resource Group" }),
                React.createElement(Note_1.default, null,
                    "The Resource Group of your Azure Web App.",
                    React.createElement("br", null),
                    "If not specified then all Resource Groups are searched.")),
            React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
                React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.BoundSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: this.state.selectedSiteIndex, isBound: this.state.siteIsBound, onIsBoundChanged: function (value) {
                            _this.setState(function (prev, props) { return ({ siteIsBound: _this.props.isAccountBound || value }); }, function () {
                                if (_this.props.onIsBoundChanged) {
                                    _this.props.onIsBoundChanged(_this.state.siteIsBound);
                                }
                            });
                        }, hideBindButton: this.props.isAccountBound, value: this.state.siteIsBound ? this.props.webAppName : this.state.selectedSiteIndex, onChange: this.state.siteIsBound ? this.props.onWebAppNameChanged : this.handleSelectedSiteChanged, items: this.state.siteItems, error: this.props.webAppNameError, label: "Web app" }), actions: !this.props.isAccountBound && React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.getWebsitesIfNotBound(_this.props); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }) })),
            React.createElement(Note_1.default, null, "The name of your Azure Web App."));
    };
    AzureWebSiteSelector.prototype.resetWebSites = function () {
        this.setState({ sites: [] });
    };
    AzureWebSiteSelector.prototype.getWebSites = function (accountId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(toggleBusy(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var account, sites, selectedSiteIndex, resourceGroupName_1, selectedSite, index, siteItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!accountId) {
                                                this.setState({
                                                    sites: [],
                                                    siteItems: [],
                                                    selectedSiteIndex: null
                                                });
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.get(accountId)];
                                        case 1:
                                            account = _a.sent();
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.getWebSites(account)];
                                        case 2:
                                            sites = _a.sent();
                                            selectedSiteIndex = null;
                                            if (this.props.webAppName) {
                                                resourceGroupName_1 = this.props.resourceGroupName === undefined ? null : this.props.resourceGroupName;
                                                selectedSite = sites.find(function (s) { return s.Name === _this.props.webAppName && s.ResourceGroup === resourceGroupName_1; });
                                                if (selectedSite) {
                                                    index = sites.indexOf(selectedSite);
                                                    selectedSiteIndex = index < 0 ? null : index.toString();
                                                }
                                            }
                                            siteItems = sites.map(function (site, index) {
                                                var details = site.ResourceGroup ? site.ResourceGroup + " " + site.Region : site.Region;
                                                return {
                                                    value: index.toString(),
                                                    text: site.Name + " " + details
                                                };
                                            });
                                            this.setState({
                                                sites: sites,
                                                siteItems: siteItems,
                                                selectedSiteIndex: selectedSiteIndex,
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState(toggleBusy(false));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return AzureWebSiteSelector;
}(BaseComponent_1.BaseComponent));
exports.default = AzureWebSiteSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSiteSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSiteSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Note_1 = __webpack_require__(20);
var Select_1 = __webpack_require__(40);
var ParseHelper_1 = __webpack_require__(66);
var isBound_1 = __webpack_require__(54);
var BusyRefreshContainer_1 = __webpack_require__(205);
var IconButton_1 = __webpack_require__(52);
var InputWithActions_1 = __webpack_require__(136);
var toggleBusy = function (value) { return function (prev, props) { return (__assign({}, prev, { busy: value ? value : !prev.busy })); }; };
var AzureWebSlotSelector = (function (_super) {
    __extends(AzureWebSlotSelector, _super);
    function AzureWebSlotSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectedSlotChanged = function (value) {
            var index = ParseHelper_1.default.safeParseInt(value, null);
            var selectedSlot = index !== null ? _this.state.slots[index] : null;
            _this.props.onWebAppSlotNameChanged(selectedSlot ? selectedSlot.Name : null);
            _this.setState({ selectedSlotIndex: index !== null ? index.toString() : null });
        };
        _this.state = {
            reset: {
                slotName: null
            },
            slotIsBound: isBound_1.default(props.webAppSlotName, false),
            slots: [],
            slotItems: [],
            selectedSlotIndex: null,
            busy: false
        };
        return _this;
    }
    AzureWebSlotSelector.prototype.canQuerySlots = function (props) {
        return !props.isAccountBound && !props.isWebAppBound && !this.state.slotIsBound;
    };
    AzureWebSlotSelector.prototype.componentDidMount = function () {
        this.getWebSlotsIfNotBound(this.props);
        if (this.canQuerySlots(this.props)) {
            this.setState({ slots: [], slotItems: [], selectedSlotIndex: null });
        }
    };
    AzureWebSlotSelector.prototype.componentWillReceiveProps = function (newprops) {
        if ((newprops.isAccountBound || newprops.isWebAppBound) && !this.state.slotIsBound) {
            this.setState({ slotIsBound: true });
        }
    };
    AzureWebSlotSelector.prototype.getWebSlotsIfNotBound = function (props) {
        if (this.canQuerySlots(props)) {
            this.getWebSlots(props.accountId, props.resourceGroupName, props.webAppName);
        }
    };
    AzureWebSlotSelector.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(BusyRefreshContainer_1.default, { busy: this.state.busy },
                React.createElement(InputWithActions_1.default, { input: React.createElement(Select_1.BoundSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: this.state.selectedSlotIndex, isBound: this.state.slotIsBound, onIsBoundChanged: function (value) { return _this.setState({ slotIsBound: (_this.props.isAccountBound && _this.props.isWebAppBound) || value }); }, hideBindButton: this.props.isAccountBound || this.props.isWebAppBound, value: this.state.slotIsBound ? this.props.webAppSlotName : this.state.selectedSlotIndex, onChange: this.state.slotIsBound ? this.props.onWebAppSlotNameChanged : this.handleSelectedSlotChanged, items: this.state.slotItems, allowClear: true, error: this.props.webAppSlotNameError, label: "Web App Slot" }), actions: !this.state.slotIsBound && React.createElement(IconButton_1.default, { disabled: this.state.busy, onClick: function () { return _this.getWebSlotsIfNotBound(_this.props); }, toolTipContent: "Refresh", icon: IconButton_1.Icon.Refresh }) })),
            React.createElement(Note_1.default, null, "The name of your Azure Web App Deployment Slot."));
    };
    AzureWebSlotSelector.prototype.getWebSlots = function (accountId, resourceGroupName, siteName) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState(toggleBusy(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var account, slots, selectedSlotIndex, selectedSite, index, slotItems;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(accountId && siteName && resourceGroupName)) {
                                                this.setState({
                                                    slots: [],
                                                    slotItems: [],
                                                    selectedSlotIndex: null
                                                });
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.get(accountId)];
                                        case 1:
                                            account = _a.sent();
                                            return [4 /*yield*/, clientInstance_1.repository.Accounts.getWebSiteSlots(account, resourceGroupName, siteName)];
                                        case 2:
                                            slots = _a.sent();
                                            selectedSlotIndex = null;
                                            if (this.props.webAppSlotName) {
                                                selectedSite = slots.find(function (s) { return s.Name === _this.props.webAppSlotName
                                                    && s.ResourceGroupName === resourceGroupName
                                                    && s.Site === siteName; });
                                                if (selectedSite) {
                                                    index = slots.indexOf(selectedSite);
                                                    selectedSlotIndex = index < 0 ? null : index.toString();
                                                }
                                            }
                                            slotItems = slots.map(function (slot, index) {
                                                return {
                                                    value: index.toString(),
                                                    text: slot.Name
                                                };
                                            });
                                            this.setState({
                                                slots: slots,
                                                slotItems: slotItems,
                                                selectedSlotIndex: selectedSlotIndex
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState(toggleBusy(false));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return AzureWebSlotSelector;
}(BaseComponent_1.BaseComponent));
exports.default = AzureWebSlotSelector;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSlotSelector.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\azureWebApp\\AzureWebSlotSelector.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var specialVariables_1 = __webpack_require__(189);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var form_1 = __webpack_require__(16);
var CertificateVariableSelect_1 = __webpack_require__(191);
var Button_1 = __webpack_require__(47);
var OpenDialogButton_1 = __webpack_require__(72);
var SimpleDataTable_1 = __webpack_require__(313);
var clientInstance_1 = __webpack_require__(10);
var CertificateImportTypes_1 = __webpack_require__(752);
var PrivateKeyAccessRuleDialog_1 = __webpack_require__(2078);
var styles = __webpack_require__(2079);
var ActionDetails_1 = __webpack_require__(25);
var VariableLookupText_1 = __webpack_require__(21);
var Select_1 = __webpack_require__(40);
var StringCheckbox_1 = __webpack_require__(41);
var CertificateImportActionSummary = (function (_super) {
    __extends(CertificateImportActionSummary, _super);
    function CertificateImportActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CertificateImportActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Import Certificate from variable ",
            React.createElement("strong", null, this.props.properties[specialVariables_1.default.Action.Certificate.Variable]),
            " into Windows Certificate Store ",
            React.createElement("strong", null, this.props.properties[specialVariables_1.default.Action.Certificate.StoreLocation]),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return CertificateImportActionSummary;
}(BaseComponent_1.BaseComponent));
var CertificateImportActionEdit = (function (_super) {
    __extends(CertificateImportActionEdit, _super);
    function CertificateImportActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null,
            storeLocation: null,
            storeName: null,
            customStoreName: null,
            accessRules: []
        };
        return _this;
    }
    CertificateImportActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({
                            project: project
                        });
                        _a.label = 2;
                    case 2:
                        this.initializeStoreLocation();
                        this.initializeStoreName();
                        this.initializePrivateKeyAccess();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CertificateImportActionEdit.prototype.initializeStoreLocation = function () {
        var _this = this;
        var currentStoreLocation = this.props.properties["Octopus.Action.Certificate.StoreLocation"];
        var currentStoreUser = this.props.properties["Octopus.Action.Certificate.StoreUser"];
        var storeLocation = null;
        storeLocation = currentStoreLocation
            ? currentStoreLocation
            : currentStoreUser
                ? CertificateImportTypes_1.StoreLocations.CustomUser
                : CertificateImportTypes_1.StoreLocations.LocalMachine;
        this.setState({ storeLocation: storeLocation }, function () { return _this.updateStoreLocation(); });
    };
    CertificateImportActionEdit.prototype.initializeStoreName = function () {
        var _this = this;
        var currentStoreName = this.props.properties["Octopus.Action.Certificate.StoreName"];
        var storeName = null;
        var customStoreName = null;
        if (!currentStoreName) {
            // If this is the first time, default the store name to 'My'
            storeName = CertificateImportTypes_1.StoreNames.My;
        }
        else if (currentStoreName in CertificateImportTypes_1.StoreNames) {
            // If the store name has been previously set to one of the pre-defined values, then use it
            storeName = currentStoreName;
        }
        else {
            // Else, a custom value has been used
            storeName = CertificateImportTypes_1.StoreNames.Other;
            customStoreName = currentStoreName;
        }
        this.setState({ storeName: storeName, customStoreName: customStoreName }, function () { return _this.updateStoreName(); });
    };
    CertificateImportActionEdit.prototype.initializePrivateKeyAccess = function () {
        if (this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"] === undefined) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyExportable"] = "False", _a), true);
        }
        if (!this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]) {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.PrivateKeyAccessRules"] = "[]", _b), true);
        }
        if (this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]) {
            var privateKeyAccessRules = JSON.parse(this.props.properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]);
            this.setState({ accessRules: privateKeyAccessRules });
        }
        var _a, _b;
    };
    CertificateImportActionEdit.prototype.updateStoreLocation = function () {
        if (this.state.storeLocation === CertificateImportTypes_1.StoreLocations.CustomUser) {
            if (this.props.properties["Octopus.Action.Certificate.StoreLocation"]) {
                this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreLocation"] = null, _a));
            }
        }
        else {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.StoreLocation"] = this.state.storeLocation, _b));
            if (this.props.properties["Octopus.Action.Certificate.StoreUser"]) {
                this.props.setProperties((_c = {}, _c["Octopus.Action.Certificate.StoreUser"] = null, _c));
            }
        }
        var _a, _b, _c;
    };
    CertificateImportActionEdit.prototype.updateStoreName = function () {
        if (this.state.storeName === CertificateImportTypes_1.StoreNames.Other) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreName"] = this.state.customStoreName, _a));
        }
        else {
            this.props.setProperties((_b = {}, _b["Octopus.Action.Certificate.StoreName"] = this.state.storeName, _b));
        }
        var _a, _b;
    };
    CertificateImportActionEdit.prototype.updatePrivateKeyAccess = function () {
        this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyAccessRules"] = JSON.stringify(this.state.accessRules), _a));
        var _a;
    };
    CertificateImportActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Certificate" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.Variable", isExpandedByDefault: this.props.expandedByDefault, title: "Certificate Variable", help: "The variable representing the certificate to be imported", summary: this.certificateSummary() }, this.props.projectId
                ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, projectId: this.props.projectId, resetValue: "", doBusyTask: this.props.doBusyTask, value: this.props.properties["Octopus.Action.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.Variable"] = val, _a));
                        var _a;
                    }, allowClear: true })
                : React.createElement(VariableLookupText_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Certificate.Variable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.Variable"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.FormSectionHeading, { title: "Store" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.StoreLocation|Octopus.Action.Certificate.StoreUser", isExpandedByDefault: this.props.expandedByDefault, title: "Store Location", help: "Select the location of the certificate store.", summary: this.storeLocationSummary() },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Store location", value: this.state.storeLocation, items: Object.values(CertificateImportTypes_1.StoreLocations).map(function (item) { return ({ value: item, text: item }); }), onChange: function (storeLocation) { return _this.setState({ storeLocation: storeLocation }, function () { return _this.updateStoreLocation(); }); }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreLocation") }),
                this.state.storeLocation === CertificateImportTypes_1.StoreLocations.CustomUser && React.createElement("div", null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Custom user", hintText: "Enter a user name", value: this.props.properties["Octopus.Action.Certificate.StoreUser"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.StoreUser"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreUser") }),
                    React.createElement(form_1.Note, null,
                        "A user to use as the certificate store location. Examples: ",
                        React.createElement("em", null, "MachineA\\UserA"),
                        ", ",
                        React.createElement("em", null, "DomainB\\UserB")))),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.StoreName", isExpandedByDefault: this.props.expandedByDefault, title: "Store Name", help: "Select the name of the Windows certificate store.", summary: this.storeNameSummary() },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Store name", value: this.state.storeName, items: Object.values(CertificateImportTypes_1.StoreNames).map(function (item) { return ({ value: item, text: item }); }), onChange: function (storeName) { return _this.setState({ storeName: storeName }, function () { return _this.updateStoreName(); }); }, error: this.props.getFieldError("Octopus.Action.Certificate.StoreName") }),
                React.createElement(form_1.Note, null,
                    "The name of the Windows certificate store. Use one of the pre-defined stores, or choose ",
                    React.createElement("em", null, "Other"),
                    " to enter a custom store name."),
                this.state.storeName === CertificateImportTypes_1.StoreNames.Other &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Custom store name", hintText: "Enter a store name", value: this.state.customStoreName, onChange: function (customStoreName) { return _this.setState({ customStoreName: customStoreName }, function () { return _this.updateStoreName(); }); } })),
            React.createElement(form_1.FormSectionHeading, { title: "Private Key" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.PrivateKeyExportable", isExpandedByDefault: this.props.expandedByDefault, title: "Private Key Exportable", help: "Select whether the private-key is exportable.", summary: this.privateKeyExportableSummary() },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", label: "Private key exportable", value: this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Certificate.PrivateKeyExportable"] = val, _a));
                        var _a;
                    }, note: React.createElement("span", null, "If the certificate includes a private-key it will be marked as exportable.") })),
            this.state.storeLocation === CertificateImportTypes_1.StoreLocations.LocalMachine &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Certificate.PrivateKeyAccessRules", isExpandedByDefault: this.props.expandedByDefault, title: "Private Key Access", help: "Define who has access to the private-key on the target machine", summary: this.privateKeyAccessSummary() },
                    React.createElement(SimpleDataTable_1.default, { data: this.state.accessRules, headerColumns: ["Identity", "Access", "Actions"], headerColumnClassName: styles.headerColumn, rowColumnClassName: styles.rowColumn, onRow: function (rule) { return [
                            rule.Identity,
                            rule.Access,
                            React.createElement("span", null,
                                React.createElement(OpenDialogButton_1.default, { label: "Edit" },
                                    React.createElement(PrivateKeyAccessRuleDialog_1.default, { rule: _.clone(rule), saveDone: function (newRule) { return _this.setState(function (prevState) {
                                            return ({ accessRules: prevState.accessRules.map(function (r) { return (r === rule) ? newRule : r; }) });
                                        }, function () { return _this.updatePrivateKeyAccess(); }); } })),
                                React.createElement(Button_1.ActionButton, { label: "Delete", onClick: function () { return _this.setState(function (prevState) {
                                        return ({ accessRules: prevState.accessRules.filter(function (r) { return r !== rule; }) });
                                    }, function () { return _this.updatePrivateKeyAccess(); }); } }))
                        ]; } }),
                    React.createElement("div", { className: styles.addRule },
                        React.createElement(OpenDialogButton_1.default, { label: "Add Access Rule" },
                            React.createElement(PrivateKeyAccessRuleDialog_1.default, { rule: { Identity: null, Access: CertificateImportTypes_1.AccessType.ReadOnly }, saveDone: function (newRule) { return _this.setState(function (prevState) {
                                    return ({ accessRules: _this.state.accessRules.concat([newRule]) });
                                }, function () { return _this.updatePrivateKeyAccess(); }); } }))),
                    React.createElement(form_1.Note, null, "By default, both the machine Administrators group and the account the Tentacle Service is executing as will be granted access.")));
    };
    CertificateImportActionEdit.prototype.certificateSummary = function () {
        var certificateVariable = this.props.properties["Octopus.Action.Certificate.Variable"];
        return certificateVariable
            ? form_1.Summary.summary(React.createElement("span", null,
                "The certificate ",
                React.createElement("b", null, certificateVariable),
                " will be imported"))
            : form_1.Summary.placeholder("The certificate variable has not been provided");
    };
    CertificateImportActionEdit.prototype.storeLocationSummary = function () {
        var storeLocation = this.props.properties["Octopus.Action.Certificate.StoreLocation"]
            ? this.props.properties["Octopus.Action.Certificate.StoreLocation"]
            : this.props.properties["Octopus.Action.Certificate.StoreUser"];
        return form_1.Summary.summary(React.createElement("span", null,
            "The selected certificate store is ",
            React.createElement("b", null, storeLocation)));
    };
    CertificateImportActionEdit.prototype.storeNameSummary = function () {
        var storeName = this.props.properties["Octopus.Action.Certificate.StoreName"];
        return form_1.Summary.summary(React.createElement("span", null,
            "The selected store name is ",
            React.createElement("b", null, storeName)));
    };
    CertificateImportActionEdit.prototype.privateKeyAccessSummary = function () {
        return (this.state.accessRules && this.state.accessRules.length > 0)
            ? this.state.accessRules.length > 1
                ? form_1.Summary.summary(React.createElement("span", null,
                    "There are ",
                    React.createElement("b", null, this.state.accessRules.length),
                    " access rules defined"))
                : form_1.Summary.summary(React.createElement("span", null,
                    "There is ",
                    React.createElement("b", null, "1"),
                    " access rule defined"))
            : form_1.Summary.placeholder("There are no access rules defined");
    };
    CertificateImportActionEdit.prototype.privateKeyExportableSummary = function () {
        var exportable = this.props.properties["Octopus.Action.Certificate.PrivateKeyExportable"];
        return exportable === "True"
            ? form_1.Summary.summary(React.createElement("span", null, "The private-key is exportable"))
            : form_1.Summary.summary(React.createElement("span", null, "The private-key is not exportable"));
    };
    return CertificateImportActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    canRunOnWorker: false,
    actionType: "Octopus.Certificate.Import",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(CertificateImportActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
    edit: CertificateImportActionEdit
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\certificateImportAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\certificateImportAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(90);
var SaveDialogLayout_1 = __webpack_require__(153);
var form_1 = __webpack_require__(16);
var CertificateImportTypes_1 = __webpack_require__(752);
var PrivateKeyAccessRuleDialog = (function (_super) {
    __extends(PrivateKeyAccessRuleDialog, _super);
    function PrivateKeyAccessRuleDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            identity: _this.props.rule.Identity,
            access: _this.props.rule.Access,
        };
        return _this;
    }
    PrivateKeyAccessRuleDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.identity) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.saveDone({ Identity: this.state.identity, Access: this.state.access })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        this.setState({
                            errors: {
                                message: "Identity must be provided",
                                details: ["Please enter an identity"],
                                fieldErrors: {}
                            }
                        });
                        return [2 /*return*/, false];
                }
            });
        });
    };
    PrivateKeyAccessRuleDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(SaveDialogLayout_1.default, { title: this.props.rule.Identity ? "Edit Access Rule" : "Add Access Rule", busy: this.state.busy, errors: this.state.errors, onSaveClick: function () { return _this.save(); } },
            React.createElement(form_1.Text, { label: "Identity", hintText: "Enter an identity", value: this.state.identity, validate: form_1.required("Please enter an identity"), onChange: function (val) { return _this.setState({ identity: val }); }, autoFocus: true }),
            React.createElement(form_1.Note, null,
                "The user or group identity. e.g. ",
                React.createElement("em", null, "DOMAIN\\userOrGroup")),
            React.createElement(form_1.Select, { label: "Access", value: this.state.access, items: Object.values(CertificateImportTypes_1.AccessType).map(function (item) { return ({ value: item, text: item }); }), onChange: function (val) { return _this.setState({ access: val }); } }));
    };
    return PrivateKeyAccessRuleDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = PrivateKeyAccessRuleDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\PrivateKeyAccessRuleDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\certificateImport\\PrivateKeyAccessRuleDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2080);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_headerColumn__1rN3h:nth-child(3){padding-left:2.95rem}.style_rowColumn__3VYV1{word-break:break-all;word-wrap:break-word;white-space:normal;padding:.175rem 1.125rem!important;vertical-align:middle!important}.style_addRule__1-q6f{margin:1rem 0}", ""]);

// exports
exports.locals = {
	"headerColumn": "style_headerColumn__1rN3h",
	"rowColumn": "style_rowColumn__3VYV1",
	"addRule": "style_addRule__1-q6f"
};

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var FormSectionHeading_1 = __webpack_require__(48);
var clientInstance_1 = __webpack_require__(10);
var Text_1 = __webpack_require__(50);
var Select_1 = __webpack_require__(40);
var StringEditList_1 = __webpack_require__(329);
var ActionDetails_1 = __webpack_require__(25);
var VariableLookupText_1 = __webpack_require__(21);
var DockerNetworkActionSummary = (function (_super) {
    __extends(DockerNetworkActionSummary, _super);
    function DockerNetworkActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DockerNetworkActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Create a Docker Network",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return DockerNetworkActionSummary;
}(BaseComponent_1.BaseComponent));
var NetworkTypes = {
    bridge: {
        name: "Bridge (Default)",
        description: "Connect the container to the bridge via veth interfaces."
    },
    other: {
        name: "Custom",
        description: "Use an installed third party or own custom network driver."
    }
};
var DockerNetworkAction = (function (_super) {
    __extends(DockerNetworkAction, _super);
    function DockerNetworkAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            teams: [],
        };
        return _this;
    }
    DockerNetworkAction.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.props.properties["Octopus.Action.Docker.NetworkType"]) {
            this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = "bridge", _a), true);
        }
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var teams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Teams.all()];
                    case 1:
                        teams = _a.sent();
                        this.setState({ teams: teams });
                        return [2 /*return*/];
                }
            });
        }); });
        var _a;
    };
    DockerNetworkAction.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Networking Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkType", isExpandedByDefault: this.props.expandedByDefault, title: "Network Type", summary: this.networkTypeSummary(), help: "Proxy used to communicate with this deployment target." },
                React.createElement(Select_1.default, { label: "Network type", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = val, _a));
                        var _a;
                    }, value: this.props.properties["Octopus.Action.Docker.NetworkType"], items: Object.keys(NetworkTypes).map(function (nt) { return ({ value: nt, text: NetworkTypes[nt].name }); }) }),
                this.props.properties["Octopus.Action.Docker.NetworkType"] &&
                    React.createElement(Note_1.default, null, NetworkTypes[this.props.properties["Octopus.Action.Docker.NetworkType"]].description),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "other" &&
                    React.createElement(Text_1.default, { label: "Custom Driver", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkCustomDriver"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkCustomDriver"] })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkSubnet", isExpandedByDefault: this.props.expandedByDefault, title: "Subnets", summary: this.propertySummary("Octopus.Action.Docker.NetworkSubnet", "No specific subnet specified"), help: "Subnet in CIDR format that represents a network segment. On a bridge network you can only specify a single subnet" },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkSubnet"], label: "Subnet", hintText: "CIDR format (e.g. 172.28.5.0/24)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkSubnet"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkIPRange", isExpandedByDefault: this.props.expandedByDefault, title: "IP Range", summary: this.propertySummary("Octopus.Action.Docker.NetworkIPRange", "No specific IP range specified"), help: "Allocate container ip from a sub-range." },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkIPRange"], label: "IP range", hintText: "CIDR format (e.g. 172.28.5.0/24)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkIPRange"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkGateway", isExpandedByDefault: this.props.expandedByDefault, title: "Network Gateway", summary: this.propertySummary("Octopus.Action.Docker.NetworkGateway", "No specific network gateway specified"), help: "IPv4 or IPv6 gateway for the master subnet. By default the Docker engine will select one from inside a preferred pool." },
                React.createElement(StringEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.NetworkGateway"], label: "Network gateway", hintText: "IPv4 or IPv6 (e.g. 172.28.5.1)", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkGateway"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Args", isExpandedByDefault: this.props.expandedByDefault, title: "Additional Arguments", summary: this.propertySummary("Octopus.Action.Docker.Args", "No additional arguments specified"), help: React.createElement("span", null,
                    "Provide any other arguments that will be passed to the ",
                    React.createElement("code", null, "docker network create"),
                    " command.") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Additional arguments", value: this.props.properties["Octopus.Action.Docker.Args"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Args"] = val, _a));
                        var _a;
                    } })));
    };
    DockerNetworkAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? form_1.Summary.summary(subnet)
            : form_1.Summary.placeholder(defaultValue);
    };
    DockerNetworkAction.prototype.networkTypeSummary = function () {
        var type = this.props.properties["Octopus.Action.Docker.NetworkType"];
        if (!type) {
            return form_1.Summary.default(NetworkTypes.bridge.description);
        }
        if (type === "other") {
            return form_1.Summary.summary(this.props.properties["Octopus.Action.Docker.NetworkCustomDriver"] + " (custom)");
        }
        return form_1.Summary.summary(NetworkTypes[type].description);
    };
    return DockerNetworkAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerNetwork",
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DockerNetworkActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: DockerNetworkAction
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerNetwork\\dockerNetworkAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerNetwork\\dockerNetworkAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var Text_1 = __webpack_require__(50);
var PackageSelector_1 = __webpack_require__(53);
var ExternalLink_1 = __webpack_require__(26);
var feedResource_1 = __webpack_require__(73);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var StringCheckbox_1 = __webpack_require__(41);
var lodash_1 = __webpack_require__(11);
var RemoveItemsList_1 = __webpack_require__(84);
var ActionButton_1 = __webpack_require__(49);
var DialogOpener_1 = __webpack_require__(110);
var VolumeBindingDialog_1 = __webpack_require__(2083);
var ParseHelper_1 = __webpack_require__(66);
var KeyValueEditList_1 = __webpack_require__(87);
var StringEditList_1 = __webpack_require__(329);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var VariableLookupText_1 = __webpack_require__(21);
var resources_1 = __webpack_require__(17);
var CommonSummaryHelper_1 = __webpack_require__(62);
var BindingList = (function (_super) {
    __extends(BindingList, _super);
    function BindingList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BindingList;
}(RemoveItemsList_1.RemoveItemsList));
var DockerRunActionSummary = (function (_super) {
    __extends(DockerRunActionSummary, _super);
    function DockerRunActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DockerRunActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DockerRunActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy and Run a Docker Container",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return DockerRunActionSummary;
}(BaseComponent_1.BaseComponent));
var NetworkTypes = (_a = {},
    _a[""] = {
        name: "Default",
        description: "Provide no explicit type and use host default."
    },
    _a.none = {
        name: "None",
        description: "No networking."
    },
    _a.bridge = {
        name: "Bridge (Linux Default)",
        description: "Connect the container to the bridge via veth interfaces."
    },
    _a.host = {
        name: "Host",
        description: "Use the host's network stack inside the container."
    },
    _a.container = {
        name: "Container",
        description: "Use the network stack of another container, specified via its name or id."
    },
    _a.network = {
        name: "Custom network",
        description: "Connects the container to a user created network."
    },
    _a);
var RestartPolicies = (_b = {
        no: {
            name: "No (default)",
            description: "Do not automatically restart the container when it exits."
        }
    },
    _b["on-failure"] = {
        name: "On failure",
        description: "Restart only if the container exits with a non-zero exit status. " +
            "Optionally, limit the number of restart retries the Docker daemon attempts."
    },
    _b.always = {
        name: "Always",
        description: "Always restart the container regardless of the exit status. " +
            "When you specify always, the Docker daemon will try to restart the container indefinitely. " +
            "The container will also always start on daemon startup, regardless of the current state of the container."
    },
    _b["unless-stopped"] = {
        name: "Unless stopped",
        description: "Always restart the container regardless of the exit status, but do not start it on daemon startup if the container has been put to a stopped state before."
    },
    _b);
var DockerRunAction = (function (_super) {
    __extends(DockerRunAction, _super);
    function DockerRunAction(props) {
        var _this = _super.call(this, props) || this;
        _this.addBinding = function () {
            var binding = {
                host: "",
                container: "",
                readOnly: "False",
                noCopy: "False"
            };
            _this.setState({
                editBinding: binding,
                editBindingIndex: null
            });
        };
        _this.removeBinding = function (b) {
            var bindings = _this.state.volumeBindings.slice();
            bindings.splice(_this.state.volumeBindings.indexOf(b), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeBindings"] = _this.bindingsToString(bindings), _a));
            var _a;
        };
        _this.saveBinding = function (binding) {
            var bindings = _this.state.volumeBindings.slice();
            if (_this.state.editBindingIndex === null) {
                bindings.push(binding);
            }
            else {
                bindings[_this.state.editBindingIndex] = binding;
            }
            _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeBindings"] = _this.bindingsToString(bindings), _a));
            _this.resetSelectedBinding();
            return true;
            var _a;
        };
        _this.resetSelectedBinding = function () {
            _this.setState({
                editBinding: null,
                editBindingIndex: null
            });
        };
        _this.editBinding = function (binding) {
            _this.setState({
                editBinding: lodash_1.clone(binding),
                editBindingIndex: _this.state.volumeBindings.indexOf(binding)
            });
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            editBinding: null,
            editBindingIndex: 0,
            volumeBindings: []
        };
        return _this;
    }
    DockerRunAction.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.setState({
                                    volumeBindings: this.bindingsFromString(this.props.properties["Octopus.Action.Docker.VolumeBindings"])
                                });
                                return [2 /*return*/];
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DockerRunAction.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.Docker.VolumeBindings"] !== nextProps.properties["Octopus.Action.Docker.VolumeBindings"]) {
            this.setState({ volumeBindings: this.bindingsFromString(nextProps.properties["Octopus.Action.Docker.VolumeBindings"]) });
        }
    };
    DockerRunAction.prototype.bindingsFromString = function (rawProperty) {
        if (!rawProperty) {
            return [];
        }
        var bindings = JSON.parse(rawProperty);
        return Object.keys(bindings).map(function (t) { return ({
            container: t,
            host: bindings[t].host,
            readOnly: bindings[t].readOnly,
            noCopy: bindings[t].noCopy
        }); });
    };
    DockerRunAction.prototype.bindingsToString = function (bindings) {
        var bindingObject = bindings.reduce(function (idx, b) {
            idx[b.container] = {
                host: b.host,
                readOnly: b.readOnly,
                noCopy: b.noCopy
            };
            return idx;
        }, {});
        return JSON.stringify(bindingObject);
    };
    DockerRunAction.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var editBindingDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editBinding, onClose: this.resetSelectedBinding },
            React.createElement(VolumeBindingDialog_1.default, { existingContainerMappings: this.state.volumeBindings
                    .filter(function (p) { return !_this.state.editBinding || p.container !== _this.state.editBinding.container; }).map(function (vm) { return vm.container; }), binding: this.state.editBinding, project: undefined, projectId: this.props.projectId, localNames: this.props.localNames, onAdd: this.saveBinding }));
        return React.createElement("div", null,
            editBindingDialog,
            React.createElement(FormSectionHeading_1.default, { title: "Docker Image details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Docker Image", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: React.createElement("span", null,
                    "This step is used to run a docker container. The package that you wish to deploy should contain all the files needed to run your application. ",
                    React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "Learn more about what your packages should contain, and how to create them"),
                    ".") },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), feedType: [feedResource_1.FeedType.Docker, feedResource_1.FeedType.AwsElasticContainerRegistry], projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
            React.createElement(FormSectionHeading_1.default, { title: "Networking Options" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkType|Octopus.Action.Docker.NetworkContainer|Octopus.Action.Docker.NetworkName", isExpandedByDefault: this.props.expandedByDefault, title: "Network Type", summary: this.summaryNetworkType(), help: "Connect a container to a network." },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.Docker.NetworkType"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkType"] = val, _a));
                        var _a;
                    } }, Object.keys(NetworkTypes).map(function (type) { return [
                    React.createElement(RadioButton_1.default, { value: type, label: NetworkTypes[type].name, key: "rdo-" + type }),
                    React.createElement(Note_1.default, { key: "note-" + type }, NetworkTypes[type].description)
                ]; })
                    .reduce(function (arr, dom) { return arr.concat(dom); }, [])),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "container" &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Container name or ID", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkContainer"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkContainer"] }),
                this.props.properties["Octopus.Action.Docker.NetworkType"] === "network" &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Network name or ID", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkName"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkName"] })),
            this.props.properties["Octopus.Action.Docker.NetworkType"] === "network" &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.NetworkAlias", isExpandedByDefault: this.props.expandedByDefault, title: "Network Alias", summary: this.propertySummary("Octopus.Action.Docker.NetworkAlias", "No network alias specified"), help: "Add network-scoped alias for the container." },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Network alias", onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.NetworkAlias"] = val, _a));
                            var _a;
                        }, value: this.props.properties["Octopus.Action.Docker.NetworkAlias"] })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.PortMapping|Octopus.Action.Docker.PortAutoMap", isExpandedByDefault: this.props.expandedByDefault, title: "Port Mapping", summary: this.summaryPortMappings(), help: React.createElement("div", null,
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#/expose-incoming-ports" }, "Publish"),
                    " a container's port or a range of ports to the host.") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.PortMapping"], separator: ":", name: "Port Mapping", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.PortMapping"] = val, _a));
                        var _a;
                    }, valueLabel: "Host port", keyLabel: "Container port", projectId: this.props.projectId, reverseLayout: true }),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.PortAutoMap"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.PortAutoMap"] = x, _a));
                        var _a;
                    }, label: "Automatically map to ephemeral port", note: React.createElement("span", null,
                        "Allows mapping exposed network port in the container to ports on the host. See ",
                        React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/userguide/networking/default_network/dockerlinks/#/connect-using-network-port-mapping" }, "Docker docs"),
                        " for more information about network port mapping.") })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.AddedHost", isExpandedByDefault: this.props.expandedByDefault, title: "Host Entry", summary: this.summaryAddedHost(), help: "Adds a line to /etc/hosts." },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.AddedHost"], name: "Host Entry", separator: ":", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.AddedHost"] = val, _a));
                        var _a;
                    }, valueLabel: "Host name", projectId: this.props.projectId, keyLabel: "IP" })),
            React.createElement(FormSectionHeading_1.default, { title: "Volumes" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumeBindings", isExpandedByDefault: this.props.expandedByDefault, title: "Bind Mounts", summary: this.summaryBindMounts(), help: React.createElement("span", null,
                    "A ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/tutorials/dockervolumes/" }, "data volume"),
                    " is a specially-designated directory within one or more containers that bypasses the ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/glossary/#union-file-system" }, "Union File System"),
                    ".") },
                React.createElement(BindingList, { listActions: [React.createElement(ActionButton_1.default, { label: "Add volume binding", onClick: function () { return _this.addBinding(); } })], data: this.state.volumeBindings, onRow: function (binding) {
                        return React.createElement("div", { key: binding.container },
                            binding.host ?
                                React.createElement("span", null,
                                    React.createElement("b", null, "Host: "),
                                    binding.host,
                                    " : ",
                                    React.createElement("b", null, "Container: "),
                                    binding.container) :
                                binding.container,
                            _this.isTrue(binding.readOnly, "readonly") && React.createElement("b", null, " readonly"),
                            _this.isTrue(binding.noCopy, "nocopy") && React.createElement("b", null, " nocopy"));
                    }, onRowTouch: function (binding) { return _this.editBinding(binding); }, onRemoveRow: function (binding) { return _this.removeBinding(binding); } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumeDriver", isExpandedByDefault: this.props.expandedByDefault, title: "Volume Driver", summary: this.propertySummary("Octopus.Action.Docker.VolumeDriver", "No volume driver specified"), help: "Optional volume driver for the container." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Volume driver", value: this.props.properties["Octopus.Action.Docker.VolumeDriver"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumeDriver"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.VolumesFrom", isExpandedByDefault: this.props.expandedByDefault, title: "Volumes From", summary: this.summaryVolumesFromContainers(), help: "Mount all volumes from the given container(s)." },
                React.createElement(StringEditList_1.default, { label: "Container Volumes", items: this.props.properties["Octopus.Action.Docker.VolumesFrom"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.VolumesFrom"] = val, _a));
                        var _a;
                    } })),
            React.createElement(FormSectionHeading_1.default, { title: "Variables" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.EnvVariable", isExpandedByDefault: this.props.expandedByDefault, title: "Explicit Variable Mapping", summary: this.summaryVariables(), help: React.createElement("span", null,
                    "Passes through variables into the container accessible as environment variables. See ",
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#/env-environment-variables" }, "Docker docs"),
                    " for more information about environment variables.") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.EnvVariable"], name: "Variable Mapping", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.EnvVariable"] = val, _a));
                        var _a;
                    }, valueLabel: "Mapping", projectId: this.props.projectId, keyLabel: "Variable name" })),
            React.createElement(FormSectionHeading_1.default, { title: "Additional Arguments" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.RestartPolicy|Octopus.Action.Docker.RestartPolicyMax", isExpandedByDefault: this.props.expandedByDefault, title: "Restart Policy", summary: this.summaryRestartPolicy(), help: React.createElement("span", null,
                    "Restart policy to apply when a container exits. See ",
                    React.createElement(ExternalLink_1.default, { href: "'https://docs.docker.com/engine/reference/run/#restart-policies-restart" }, "Docker docs"),
                    " for more information.") },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.Docker.RestartPolicy"] || "no", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RestartPolicy"] = val, _a));
                        var _a;
                    } }, Object.keys(RestartPolicies).map(function (type) { return [
                    React.createElement(RadioButton_1.default, { value: type, label: RestartPolicies[type].name, key: "rdo-" + type }),
                    React.createElement(Note_1.default, { key: "note-" + type }, RestartPolicies[type].description)
                ]; })
                    .reduce(function (arr, dom) { return arr.concat(dom); }, [])),
                this.props.properties["Octopus.Action.Docker.RestartPolicy"] === "on-failure" &&
                    React.createElement(Text_1.default, { label: "Maximum retry count", hintText: "Unlimited retry", value: this.props.properties["Octopus.Action.Docker.RestartPolicyMax"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RestartPolicyMax"] = val, _a));
                            var _a;
                        } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.DontRun", isExpandedByDefault: this.props.expandedByDefault, title: "Don't Auto-run", summary: this.summaryAutoRun(), help: React.createElement("span", null, "This creates the writable layer on top of the image and prepares it for running without actually starting it . This may be useful if there is other configuration you would like to perform before startup.") },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", label: React.createElement("span", null,
                        "Perform ",
                        React.createElement("code", null, "create"),
                        " command instead of ",
                        React.createElement("code", null, "run")), value: this.props.properties["Octopus.Action.Docker.DontRun"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.DontRun"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Command", isExpandedByDefault: this.props.expandedByDefault, title: "Command", summary: this.propertySummary("Octopus.Action.Docker.Command", "No custom command specified"), help: React.createElement("span", null,
                    React.createElement(ExternalLink_1.default, { href: "https://docs.docker.com/engine/reference/run/#cmd-default-command-or-options" }, "Override default"),
                    " ",
                    React.createElement("code", null, "CMD"),
                    " instruction provided by the image.") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Command", value: this.props.properties["Octopus.Action.Docker.Command"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Command"] = val, _a));
                        var _a;
                    } })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Docker.Args", isExpandedByDefault: this.props.expandedByDefault, title: "Additional Arguments", summary: this.propertySummary("Octopus.Action.Docker.Args", "No additional arguments specified."), help: React.createElement("span", null,
                    "Provide any other arguments that will be passed to the ",
                    React.createElement("code", null, "docker run"),
                    " command.") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, label: "Additional arguments", value: this.props.properties["Octopus.Action.Docker.Args"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Args"] = val, _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null,
                    "A full description of the additional arguments which can be supplied can be found on the ",
                    React.createElement(ExternalLink_1.default, { href: "DockerRun" }, "Docker reference page"),
                    ".")));
    };
    DockerRunAction.prototype.isTrue = function (noCopy, trueString) {
        return (!!noCopy && (noCopy === true || noCopy.toLowerCase() === "true" || noCopy.toLowerCase() === trueString));
    };
    DockerRunAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? form_1.Summary.summary(subnet)
            : form_1.Summary.placeholder(defaultValue);
    };
    DockerRunAction.prototype.summaryNetworkType = function () {
        var type = this.props.properties["Octopus.Action.Docker.NetworkType"] || "";
        var text = NetworkTypes[type].description;
        if (type === "") {
            return form_1.Summary.default(text);
        }
        if (type === "container") {
            text += " (" + this.props.properties["Octopus.Action.Docker.NetworkContainer"] + ")";
        }
        else if (type === "network") {
            text += " (" + this.props.properties["Octopus.Action.Docker.NetworkName"] + ")";
        }
        return form_1.Summary.summary(text);
    };
    DockerRunAction.prototype.summaryPortMappings = function () {
        var portMappings = JSON.parse(this.props.properties["Octopus.Action.Docker.PortMapping"] || "{}");
        if (Object.keys(portMappings).length === 0) {
            return form_1.Summary.placeholder("No port mappings provided");
        }
        else {
            var text = Object.keys(portMappings).map(function (m) { return (portMappings[m] ? portMappings[m] + " : " : "") + m; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DockerRunAction.prototype.summaryAddedHost = function () {
        var hosts = JSON.parse(this.props.properties["Octopus.Action.Docker.AddedHost"] || "{}");
        if (Object.keys(hosts).length === 0) {
            return form_1.Summary.placeholder("No host entries added");
        }
        else {
            var text = Object.keys(hosts).map(function (m) { return m + (hosts[m] ? " : " + hosts[m] : ""); }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    DockerRunAction.prototype.summaryVolumesFromContainers = function () {
        var raw = ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Docker.VolumesFrom"] || "");
        if (raw.length === 0) {
            return form_1.Summary.placeholder("No container volumes specified");
        }
        var pluralized = (raw.length === 1 ? "" : "s");
        return form_1.Summary.summary(React.createElement("span", null,
            "Volume",
            pluralized,
            " mounted from container",
            pluralized,
            " ",
            React.createElement("b", null, raw.join(", "))));
    };
    DockerRunAction.prototype.summaryBindMounts = function () {
        if (this.state.volumeBindings.length === 0) {
            return form_1.Summary.placeholder("No volume bindings specified");
        }
        var containerBindings = this.state.volumeBindings.map(function (b) { return b.container; });
        var pluralized = (containerBindings.length === 1 ? "" : "s");
        return form_1.Summary.summary(React.createElement("span", null,
            "Volume binding",
            pluralized,
            " mapped to mount",
            pluralized,
            " ",
            React.createElement("b", null, containerBindings.join(", "))));
    };
    DockerRunAction.prototype.summaryAutoRun = function () {
        var val = this.props.properties["Octopus.Action.Docker.DontRun"] || "false";
        if (val.toLowerCase() === "true") {
            return form_1.Summary.summary("Container will be created in stopped mode");
        }
        return form_1.Summary.placeholder("Container will run when created");
    };
    DockerRunAction.prototype.summaryRestartPolicy = function () {
        var policy = this.props.properties["Octopus.Action.Docker.RestartPolicy"];
        var restartPolicyMax = this.props.properties["Octopus.Action.Docker.RestartPolicyMax"];
        if (!policy) {
            policy = "no";
        }
        var text = RestartPolicies[policy].description;
        if (policy === "no") {
            return form_1.Summary.default(text);
        }
        if (policy === "on-failure") {
            text += restartPolicyMax ? " (max " + restartPolicyMax + " restarts)" : "(unlimited restarts)";
        }
        return form_1.Summary.summary(text);
    };
    DockerRunAction.prototype.summaryVariables = function () {
        var variables = JSON.parse(this.props.properties["Octopus.Action.Docker.EnvVariable"] || "{}");
        if (Object.keys(variables).length === 0) {
            return form_1.Summary.placeholder("No environment variables specified");
        }
        else {
            var text = Object.keys(variables).map(function (m) { return m + " = " + variables[m]; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    return DockerRunAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerRun",
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    summary: function (properties, targetRolesAsCSV, packages) {
        return React.createElement(DockerRunActionSummary, { properties: properties, packages: packages, targetRolesAsCSV: targetRolesAsCSV });
    },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: DockerRunAction
});
var _a, _b;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerRun\\dockerRunAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerRun\\dockerRunAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var VolumeBindingDialog = (function (_super) {
    __extends(VolumeBindingDialog, _super);
    function VolumeBindingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            return _this.props.onAdd(_this.state.binding);
        };
        _this.state = {
            binding: props.binding,
        };
        return _this;
    }
    VolumeBindingDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); });
    };
    VolumeBindingDialog.prototype.render = function () {
        var _this = this;
        var existingError = this.props.existingContainerMappings.indexOf(this.state.binding.container) === -1 ?
            null :
            "A volume binding already exists for this path";
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, okButtonDisabled: existingError !== null || this.state.binding.container === "", busy: this.state.busy, errors: this.state.errors, title: "Add Volume Binding" }, this.state.binding && React.createElement("div", null,
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.container, onChange: function (x) { return _this.setChildState1("binding", { container: x }); }, error: existingError, label: "Container Dest" }),
            React.createElement(Note_1.default, null,
                " ",
                existingError === null && "Mount point inside container to create volume."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.host, onChange: function (x) { return _this.setChildState1("binding", { host: x }); }, label: "Host Source" }),
            React.createElement(Note_1.default, null, "An optional absolute path or a name value to a resource on the host."),
            React.createElement("br", null),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "false", value: this.state.binding.readOnly, onChange: function (x) { return _this.setChildState1("binding", { readOnly: x }); }, label: "Read Only", note: React.createElement("span", null, "Volume defaults mode to read-write.") }),
            React.createElement("br", null),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "false", value: this.state.binding.noCopy, onChange: function (x) { return _this.setChildState1("binding", { noCopy: x }); }, label: "No Copy", note: React.createElement("span", null, "Disable automatic copying volume path in the container to the volume storage location.") })));
    };
    return VolumeBindingDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = VolumeBindingDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerRun\\VolumeBindingDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerRun\\VolumeBindingDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var Roles_1 = __webpack_require__(37);
var actionExecutionLocation_1 = __webpack_require__(46);
var FormSectionHeading_1 = __webpack_require__(48);
var ExpandableFormSection_1 = __webpack_require__(30);
var Summary_1 = __webpack_require__(44);
var RadioButton_1 = __webpack_require__(32);
var RadioButtonGroup_1 = __webpack_require__(36);
var StepMultiSelect_1 = __webpack_require__(470);
var ParseHelper_1 = __webpack_require__(66);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var KeyValueEditList_1 = __webpack_require__(87);
var VariableLookupText_1 = __webpack_require__(21);
var clientInstance_1 = __webpack_require__(10);
var lodash_1 = __webpack_require__(11);
var ActionDetails_1 = __webpack_require__(25);
var DockerStopActionSummary = (function (_super) {
    __extends(DockerStopActionSummary, _super);
    function DockerStopActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DockerStopActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Stop a Docker Resource",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return DockerStopActionSummary;
}(BaseComponent_1.BaseComponent));
var DockerStopAction = (function (_super) {
    __extends(DockerStopAction, _super);
    function DockerStopAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            name: "XX",
            steps: []
        };
        return _this;
    }
    DockerStopAction.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var project, deployment, actions;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.props.projectId) return [3 /*break*/, 3];
                                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                                    case 1:
                                        project = _a.sent();
                                        return [4 /*yield*/, clientInstance_1.repository.DeploymentProcesses.get(project.DeploymentProcessId)];
                                    case 2:
                                        deployment = _a.sent();
                                        actions = lodash_1.flatten(deployment.Steps.map(function (step, stepIndex) {
                                            return step.Actions.map(function (action, actionIndex) {
                                                var num = "" + stepIndex + 1;
                                                if (step.Actions.length > 1) {
                                                    num = num + "." + (actionIndex + 1);
                                                }
                                                return __assign({}, action, { NumberedName: num + ". " + action.Name });
                                            });
                                        })).filter(function (action) { return action.ActionType === "Octopus.DockerNetwork" || action.ActionType === "Octopus.DockerRun"; });
                                        this.setState({ steps: actions });
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DockerStopAction.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Removal Rules" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.Remove", isExpandedByDefault: this.props.expandedByDefault, title: "Perform", summary: this.summaryRemove(), help: "Action to take place." },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: this.props.properties["Octopus.Action.Docker.Remove"] || "False", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.Remove"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Stop", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Stop and remove" }))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveSteps", isExpandedByDefault: this.props.expandedByDefault, title: "From Steps", summary: this.summarySteps(), help: "Resources created from these Docker steps should be removed." },
                React.createElement(StepMultiSelect_1.default, { items: this.state.steps, label: "Docker steps", value: ParseHelper_1.default.parseCSV(this.props.properties["Octopus.Action.Docker.RemoveSteps"]), onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveSteps"] = ParseHelper_1.default.encodeCSV(val), _a));
                        var _a;
                    } }),
                React.createElement(Note_1.default, null,
                    "Note that leaving blank will remove resources created from ",
                    React.createElement("em", null, "all"),
                    " docker steps and therefore may remove resources from the same release if this step runs after other Docker steps.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveByEnvironment|Octopus.Action.Docker.RemoveByRelease|Octopus.Action.Docker.RemoveByTenant", isExpandedByDefault: this.props.expandedByDefault, title: "Resources Matching", summary: this.summaryMatches(), help: "Containers created though Octopus are tagged with the relevant context to allow the following selection during this stop process." },
                React.createElement(StringCheckbox_1.default, { value: "True", onChange: function (x) { return undefined; }, disabled: true, label: "Project", note: React.createElement("span", null, "Resources will be removed where they match the current project. This cannot be disabled.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByEnvironment"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByEnvironment"] = x, _a));
                        var _a;
                    }, label: "Environment", note: React.createElement("span", null, "Resources will be removed only where they also match the current environment.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByRelease"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByRelease"] = x, _a));
                        var _a;
                    }, label: "Release", note: React.createElement("span", null, "Resources will be removed only where they also match the current release.") }),
                React.createElement("br", null),
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Docker.RemoveByTenant"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveByTenant"] = x, _a));
                        var _a;
                    }, label: "Tenant (if applicable)", note: React.createElement("span", null, "If the release includes tenants then resources will be removed only where they also match the currently deploying tenant.") })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.RemoveCustomTags", isExpandedByDefault: this.props.expandedByDefault, title: "Custom Tag Filters", summary: this.summaryTags(), help: React.createElement("span", null,
                    "These tags will be included when searching for resources using the ",
                    React.createElement("code", null, "--filter \"label=X\""),
                    " argument. If the value is not provided, the resource will be included so long as the tag is present with any value") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Docker.RemoveCustomTags"], separator: "=", name: "Custom tag", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.RemoveCustomTags"] = val, _a));
                        var _a;
                    }, keyLabel: "Label", valueLabel: "Value" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Docker.StopTimeout", isExpandedByDefault: this.props.expandedByDefault, title: "Timeout (sec)", summary: this.propertySummary("Octopus.Action.Docker.StopTimeout", "No timeout value supplied"), help: React.createElement("span", null,
                    "Seconds to wait for process to stop before killing it (Docker default 10) . The main process inside the container will receive ",
                    React.createElement("code", null, "SIGTERM"),
                    ", and after a grace period, ",
                    React.createElement("code", null, "SIGKILL"),
                    ".") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Docker.StopTimeout"], label: "Timeout (sec)", hintText: "10", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Docker.StopTimeout"] = val, _a));
                        var _a;
                    } })));
    };
    DockerStopAction.prototype.summaryTags = function () {
        var tags = JSON.parse(this.props.properties["Octopus.Action.Docker.RemoveCustomTags"] || "{}");
        if (Object.keys(tags).length === 0) {
            return Summary_1.default.placeholder("No custom tags specified");
        }
        else {
            var text = Object.keys(tags).map(function (m) { return m + " = " + tags[m]; }).join(", ");
            return Summary_1.default.summary(text);
        }
    };
    DockerStopAction.prototype.summarySteps = function () {
        var removeSteps = this.props.properties["Octopus.Action.Docker.RemoveSteps"];
        return Summary_1.default.placeholder("No steps have been selected");
    };
    DockerStopAction.prototype.summaryMatches = function () {
        var matches = [];
        if ((this.props.properties["Octopus.Action.Docker.RemoveByEnvironment"] || "true").toLowerCase() === "true") {
            matches.push("environment");
        }
        if ((this.props.properties["Octopus.Action.Docker.RemoveByRelease"] || "true").toLowerCase() === "true") {
            matches.push("release");
        }
        if ((this.props.properties["Octopus.Action.Docker.RemoveByTenant"] || "true").toLowerCase() === "true") {
            matches.push("tenant (if applicable)");
        }
        if (matches.length === 0) {
            return Summary_1.default.default("This project");
        }
        return Summary_1.default.summary("The relevant " + matches.join(", ") + " and this project");
    };
    DockerStopAction.prototype.propertySummary = function (property, defaultValue) {
        var subnet = this.props.properties[property];
        return subnet
            ? Summary_1.default.summary(subnet)
            : Summary_1.default.placeholder(defaultValue);
    };
    DockerStopAction.prototype.summaryRemove = function () {
        var remove = this.props.properties["Octopus.Action.Docker.Remove"];
        if (!remove || remove === "False") {
            return Summary_1.default.default("Stop");
        }
        else if (remove === "True") {
            return Summary_1.default.summary("Stop and Remove");
        }
        return Summary_1.default.summary(remove);
    };
    return DockerStopAction;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.DockerStop",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DockerStopActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    edit: DockerStopAction
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerStop\\dockerStopAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\dockerStop\\dockerStopAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var ActionDetails_1 = __webpack_require__(25);
var pluginRegistry_1 = __webpack_require__(18);
var resources_1 = __webpack_require__(17);
var CommonSummaryHelper_1 = __webpack_require__(62);
var feedResource_1 = __webpack_require__(73);
var PackageSelector_1 = __webpack_require__(53);
var FormSectionHeading_1 = __webpack_require__(48);
var ExpandableFormSection_1 = __webpack_require__(30);
var _ = __webpack_require__(11);
var ExternalLink_1 = __webpack_require__(26);
var form_1 = __webpack_require__(16);
var StringCheckbox_1 = __webpack_require__(41);
var Text_1 = __webpack_require__(50);
var KeyValueEditList_1 = __webpack_require__(87);
var Button_1 = __webpack_require__(47);
var RemoveItemsList_1 = __webpack_require__(84);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var DialogOpener_1 = __webpack_require__(110);
var PackagedHelmValuesDialog_1 = __webpack_require__(2086);
var VariableLookupText_1 = __webpack_require__(21);
var CodeEditor_1 = __webpack_require__(107);
var RadioButton_1 = __webpack_require__(32);
var HelmChartUpgradeActionSummary = (function (_super) {
    __extends(HelmChartUpgradeActionSummary, _super);
    function HelmChartUpgradeActionSummary(props) {
        return _super.call(this, props) || this;
    }
    HelmChartUpgradeActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Upgrade a Helm chart");
    };
    return HelmChartUpgradeActionSummary;
}(BaseComponent_1.BaseComponent));
var PackageReferenceList = (function (_super) {
    __extends(PackageReferenceList, _super);
    function PackageReferenceList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageReferenceList;
}(RemoveItemsList_1.RemoveItemsList));
var HelmLocation;
(function (HelmLocation) {
    HelmLocation["Default"] = "default";
    HelmLocation["Local"] = "local";
    HelmLocation["Package"] = "package";
})(HelmLocation || (HelmLocation = {}));
var HelmChartUpgradeActionEdit = (function (_super) {
    __extends(HelmChartUpgradeActionEdit, _super);
    function HelmChartUpgradeActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.packagesFormSection = function () {
            var packageReferences = resources_1.GetNamedPackageReferences(_this.props.packages).filter(function (pkg) { return !IsHelmExePackageReference(pkg); });
            return React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Script.Packages", title: React.createElement("span", null, "Files in Additional Packages"), summary: _this.packageReferenceSummary(), help: React.createElement("span", null, "Includes yaml files from packages") },
                React.createElement(form_1.Note, null, "Acquired files have Octopus variable replacement on them and must result in the standard yaml format"),
                React.createElement(PackageReferenceList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add", onClick: function () { return _this.addPackageReference(); } })], data: packageReferences, onRow: function (p) { return _this.packageReferenceListItem(p); }, onRowTouch: function (pkg) { return _this.editPackageReference(pkg); }, onRemoveRow: function (pkg) { return _this.removePackageReference(pkg); } }));
        };
        _this.packageVariableNames = function () {
            return _.flatten(resources_1.GetNamedPackageReferences(_this.props.packages)
                .map(function (pkg) { return [
                "Octopus.Action.Package[" + pkg.Name + "].PackageId",
                "Octopus.Action.Package[" + pkg.Name + "].FeedId",
                "Octopus.Action.Package[" + pkg.Name + "].PackageVersion",
                "Octopus.Action.Package[" + pkg.Name + "].Path"
            ]; }));
        };
        _this.packageReferenceSummary = function () {
            var packageReferences = resources_1.GetNamedPackageReferences(_this.props.packages)
                .filter(function (pkg) { return !IsHelmExePackageReference(pkg) && !resources_1.IsPrimaryPackageReference(pkg); });
            if (!packageReferences || packageReferences.length === 0) {
                return form_1.Summary.placeholder("No additional value files");
            }
            return form_1.Summary.summary(packageReferences.length + " package references");
        };
        _this.addPackageReference = function () {
            var additionalPackage = {
                Name: null,
                FeedId: null,
                PackageId: null,
                AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget,
                Properties: { ValuesFilePath: "", PerformVariableReplace: "False" }
            };
            _this.setState({ editPackageReference: additionalPackage, editPackageReferenceIndex: null });
        };
        _this.summaryCustomHelmExePackage = function (pkg) {
            var helmPkg = GetHelmExePackageReference(_this.props.packages);
            var helmPath = _this.props.properties["Octopus.Action.Helm.CustomHelmExecutable"];
            if (helmPkg) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Helm client available at ",
                    React.createElement("strong", null, helmPath),
                    " will be invoked from inside package ",
                    React.createElement("strong", null, helmPkg.PackageId)));
                //this.setState({customHelmExecutable: HelmLocation.Package});
            }
            else if (helmPath) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "Helm client available at ",
                    React.createElement("strong", null, helmPath),
                    " will be invoked"));
            }
            else {
                return form_1.Summary.default(React.createElement("span", null,
                    "Default helm client available via ",
                    React.createElement("code", null, "helm"),
                    " path will be invoked"));
            }
        };
        _this.summaryChartPackageVariables = function (pkg) {
            var valuesFilePath = pkg.Properties["ValuesFilePath"];
            if (valuesFilePath) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "values file(s) ",
                    React.createElement("strong", null, valuesFilePath),
                    " from the chart package will be included in the upgrade"));
            }
            return form_1.Summary.placeholder("No additional values files provided");
        };
        _this.editPackageReference = function (pkg) {
            _this.setState({
                editPackageReference: _.clone(pkg),
                editPackageReferenceIndex: _this.props.packages.indexOf(pkg)
            });
        };
        _this.removePackageReference = function (pkg) {
            var packages = _this.props.packages.slice();
            packages.splice(packages.indexOf(pkg), 1);
            _this.props.setPackages(packages);
        };
        _this.packageReferenceListItem = function (pkg) {
            var feed = _this.state.feeds.find(function (f) { return f.Id === pkg.FeedId; });
            return React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("strong", null, pkg.Properties["ValuesFilePath"]),
                    " in ",
                    React.createElement("strong", null, pkg.PackageId),
                    " from feed ",
                    React.createElement("strong", null, feed !== null ? feed.Name : pkg.FeedId)));
        };
        _this.resetSelectedPackageReference = function () {
            _this.setState({
                editPackageReference: null,
                editPackageReferenceIndex: null
            });
        };
        _this.summaryRawYaml = function () {
            var rawYaml = _this.props.properties["Octopus.Action.Helm.YamlValues"];
            if (rawYaml) {
                return form_1.Summary.summary("An inline YAML values file has been provided");
            }
            return form_1.Summary.placeholder("No inline YAML file has been provided");
        };
        _this.releaseNameSummary = function () {
            var releaseName = _this.props.properties["Octopus.Action.Helm.ReleaseName"];
            if (_this.props.properties["Octopus.Action.Helm.ReleaseName"]) {
                return form_1.Summary.summary(React.createElement("span", null,
                    "The release name will be ",
                    React.createElement("strong", null, releaseName)));
            }
            return form_1.Summary.default(React.createElement("span", null,
                "The default release name is ",
                React.createElement("strong", null,
                    "#", "{Octopus.Action.Name}",
                    "-#", "{Octopus.Environment}")));
        };
        // private installSummary = () => {
        //     if (this.props.properties["Octopus.Action.Helm.Install"]) {
        //         return Summary.default("The release will be created if none yet exist with this name");
        //     }
        //     return Summary.placeholder(<span>The release will <strong>not</strong> be created if none yet exist with this name</span>);
        // }
        _this.resetSummary = function () {
            if (_this.props.properties["Octopus.Action.Helm.ResetValues"]) {
                return form_1.Summary.default("Previous deployment variables will be replaced");
            }
            return form_1.Summary.placeholder(React.createElement("span", null,
                "Previous deployment variables will ",
                React.createElement("code", null, "not"),
                " be replaced if no new values are provided"));
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            customHelmExecutable: HelmLocation.Default
        };
        return _this;
    }
    HelmChartUpgradeActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _b.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                                if (GetHelmExePackageReference(this.props.packages)) {
                                    this.setState({ customHelmExecutable: HelmLocation.Package });
                                }
                                else if (this.props.properties["Octopus.Action.Helm.CustomHelmExecutable"]) {
                                    this.setState({ customHelmExecutable: HelmLocation.Local });
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        if (this.props.properties["Octopus.Action.Helm.ResetValues"] === undefined) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.ResetValues"] = "True", _a), true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HelmChartUpgradeActionEdit.prototype.render = function () {
        var _this = this;
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var localNames = _.concat(this.props.localNames ? this.props.localNames : [], this.packageVariableNames());
        var editPackageReferenceDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editPackageReference, onClose: this.resetSelectedPackageReference },
            React.createElement(PackagedHelmValuesDialog_1.PackagedHelmValuesDialog, { packageReference: this.state.editPackageReference, runOn: this.props.runOn, feeds: this.state.feeds, localNames: localNames, projectId: this.props.projectId, onChange: function (packageReference) { return _this.savePackageReference(packageReference); }, refreshFeeds: this.loadFeeds }));
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var helmExepkg = GetHelmExePackageReference(this.props.packages);
        return React.createElement("div", null,
            editPackageReferenceDialog,
            React.createElement(FormSectionHeading_1.default, { title: "Chart" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "package", isExpandedByDefault: this.props.expandedByDefault, title: "Chart", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: React.createElement("span", null, "Choose the chart you which to deploy") },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Helm], refreshFeeds: this.loadFeeds })),
            React.createElement(FormSectionHeading_1.default, { title: "Upgrade Options" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "ReleaseName", isExpandedByDefault: this.props.expandedByDefault, title: "Kubernetes Release", summary: this.releaseNameSummary(), help: "if a release by this name doesn't already exist, run an install" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Helm.ReleaseName"], hintText: "#{Octopus.Action.Name | ToLower}-#{Octopus.Environment.Name | ToLower}", onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.ReleaseName"] = x, _a));
                        var _a;
                    }, label: "Kubernetes Release Name" }),
                React.createElement(form_1.Note, null,
                    "Due to Helm limitations, the release name must be unique across a cluster as the name is shared across namespace boundaries.",
                    React.createElement("br", null),
                    "The Octopus variable syntax is supported, however the final release name must consist of only lower case alphanumeric and dash characters.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "ResetValues", title: "Reset Values", summary: this.resetSummary(), help: "When upgrading, reset the values to the ones built into the chart with those provided in the current deployment" },
                React.createElement(StringCheckbox_1.default, { value: this.props.properties["Octopus.Action.Helm.ResetValues"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.ResetValues"] = x, _a));
                        var _a;
                    }, label: "Reset Values", note: React.createElement("span", null,
                        "Corresponds to ",
                        React.createElement("code", null, "--reset-values"),
                        " helm argument") })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "HelmExePackage", title: "Helm Client Tool", summary: this.summaryCustomHelmExePackage(helmExepkg), help: React.createElement("span", null, "Select the Helm client tool to invoke") },
                React.createElement(form_1.Note, null,
                    "Helm requires that the client tool be the same minor version as the tiller service installed in the kubernetes cluster. By default this Helm Upgrade step invokes the ",
                    React.createElement("code", null, "helm"),
                    " command."),
                React.createElement(form_1.StringRadioButtonGroup, { value: this.state.customHelmExecutable, onChange: function (val) {
                        _this.setState({ customHelmExecutable: val }, function () {
                            if (val !== HelmLocation.Package) {
                                _this.props.setPackages(ClearHelmExePackage(_this.props.packages));
                            }
                            if (val === HelmLocation.Default) {
                                _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.CustomHelmExecutable"] = null, _a));
                            }
                            var _a;
                        });
                    } },
                    React.createElement(RadioButton_1.default, { value: HelmLocation.Default, label: React.createElement("span", null,
                            "Invoke ",
                            React.createElement("code", null, "helm"),
                            " command") }),
                    React.createElement(form_1.Note, null,
                        "The helm client will be available on the worker as the ",
                        React.createElement("code", null, "helm"),
                        " command, and is the correct version that can interact with the tiller version in the kubernetes cluster."),
                    React.createElement(RadioButton_1.default, { value: HelmLocation.Local, label: "Helm client tool available from another path" }),
                    React.createElement(form_1.Note, null, "The helm client is available via a specific path."),
                    this.state.customHelmExecutable === HelmLocation.Local && React.createElement("div", null,
                        React.createElement(Text_1.default, { label: "Helm executable location", value: this.props.properties["Octopus.Action.Helm.CustomHelmExecutable"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.CustomHelmExecutable"] = x, _a));
                                var _a;
                            } }),
                        React.createElement(form_1.Note, null, "The path to the helm executable.")),
                    React.createElement(RadioButton_1.default, { value: HelmLocation.Package, label: "Custom packaged helm client tool" }),
                    React.createElement(form_1.Note, null,
                        "Upload a custom helm client to use during deployment. See our ",
                        React.createElement(ExternalLink_1.default, { href: "HelmClient" }, "documentation"),
                        " for more information on client requirements."),
                    this.state.customHelmExecutable === HelmLocation.Package && React.createElement(PackageSelector_1.default, { packageId: helmExepkg ? helmExepkg.PackageId : null, feedId: helmExepkg ? helmExepkg.FeedId : null, onPackageIdChange: function (packageId) { return _this.props.setPackages(SetHelmExePackage({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(SetHelmExePackage({ FeedId: feedId }, _this.props.packages)); }, projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget], refreshFeeds: this.loadFeeds }),
                    this.state.customHelmExecutable === HelmLocation.Package && React.createElement("div", null,
                        React.createElement(Text_1.default, { label: "Helm executable location", value: this.props.properties["Octopus.Action.Helm.CustomHelmExecutable"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.CustomHelmExecutable"] = x, _a));
                                var _a;
                            } }),
                        React.createElement(form_1.Note, null, "The path to the helm executable. This can be a path relative to the package root.")))),
            React.createElement(FormSectionHeading_1.default, { title: "Template Values" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Helm.KeyValues", title: "Explicit Key Values", summary: this.summaryVariables(), help: React.createElement("span", null,
                    "Adds values into custom ",
                    React.createElement("code", null, "values.yaml"),
                    " and includes via ",
                    React.createElement("code", null, "--values"),
                    " helm argument") },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.Helm.KeyValues"], name: "Key/Value", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.KeyValues"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", projectId: this.props.projectId, keyLabel: "Key" })),
            React.createElement(ExpandableFormSection_1.default, { summary: this.summaryRawYaml(), title: "Raw Values YAML", errorKey: "Octopus.Action.Helm.YamlValues" },
                React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Helm.YamlValues"], language: CodeEditor_1.TextFormat.YAML, onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Helm.YamlValues"] = x, _a));
                        var _a;
                    } }),
                React.createElement(form_1.Note, null,
                    "Enter the raw YAML that will be provided as a values file. This field supports the ",
                    React.createElement(ExternalLink_1.default, { href: "VariableSubstitutionSyntaxExtended" }, "extended template syntax"),
                    ".")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.ValuesFilePath", title: "Files in Chart Package", summary: this.summaryChartPackageVariables(pkg), help: React.createElement("span", null, "Files sourced from the Chart package") },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: pkg.Properties["ValuesFilePath"], onChange: function (x) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ Properties: __assign({}, pkg.Properties, { ValuesFilePath: x }) }, _this.props.packages)); }, label: "File(s)" }),
                React.createElement(form_1.Note, null,
                    "A newline-separated list of file names, relative to the chart root to be included as additional ",
                    React.createElement("code", null, "--values"),
                    " files. Variable replacement will be run on these files before used. Extended template and wildcard syntax is supported. E.g., ",
                    React.createElement("em", null,
                        "values.", "#{Octopus.Environment.Name}",
                        ".yaml"),
                    ", ",
                    React.createElement("em", null, "**\\specific-folder\\*.yaml"),
                    ".")),
            this.packagesFormSection());
    };
    HelmChartUpgradeActionEdit.prototype.savePackageReference = function (packageReference) {
        var packageReferences = this.props.packages.slice();
        packageReference = __assign({}, packageReference, { Name: "ValuesPack-" + (this.state.editPackageReferenceIndex || packageReferences.length) });
        if (this.state.editPackageReferenceIndex === null) {
            packageReferences.push(packageReference);
        }
        else {
            packageReferences[this.state.editPackageReferenceIndex] = packageReference;
        }
        this.props.setPackages(packageReferences);
        this.resetSelectedPackageReference();
        return true;
    };
    HelmChartUpgradeActionEdit.prototype.summaryVariables = function () {
        var variables = JSON.parse(this.props.properties["Octopus.Action.Helm.KeyValues"] || "{}");
        if (Object.keys(variables).length === 0) {
            return form_1.Summary.placeholder("No explicit value overrides supplied");
        }
        else {
            var text = Object.keys(variables).map(function (m) { return m + " = " + variables[m]; }).join(", ");
            return form_1.Summary.summary(text);
        }
    };
    return HelmChartUpgradeActionEdit;
}(BaseComponent_1.BaseComponent));
function GetHelmExePackageReference(packages) {
    return packages.find(function (pkg) { return IsHelmExePackageReference(pkg); });
}
function IsHelmExePackageReference(pkg) {
    return pkg.Name === "HelmExe";
}
function ClearHelmExePackage(packages) {
    return packages.filter(function (pkg) { return !IsHelmExePackageReference(pkg); });
}
function SetHelmExePackage(updated, packages) {
    var helmExePkg = __assign({ FeedId: null, PackageId: null, AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget, Properties: { PerformVariableReplace: "False", Extract: "True" } }, GetHelmExePackageReference(packages), updated, { Name: "HelmExe" });
    var newPackages = _.map(packages, function (pkg) {
        if (!IsHelmExePackageReference(pkg)) {
            return pkg;
        }
        return helmExePkg;
    });
    if (!newPackages.includes(GetHelmExePackageReference(newPackages))) {
        newPackages.push(helmExePkg);
    }
    return newPackages;
}
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.HelmChartUpgrade",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(HelmChartUpgradeActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: HelmChartUpgradeActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\helmChartUpgrade\\helmChartUpgradeAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\helmChartUpgrade\\helmChartUpgradeAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(90);
var OkDialogLayout_1 = __webpack_require__(65);
var VariableLookupText_1 = __webpack_require__(21);
var PackageSelector_1 = __webpack_require__(53);
var feedResource_1 = __webpack_require__(73);
var PackageDownloadOptions_1 = __webpack_require__(118);
var _ = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var DefaultYamlFileLocation = "values.yaml";
var PackagedHelmValuesDialog = (function (_super) {
    __extends(PackagedHelmValuesDialog, _super);
    function PackagedHelmValuesDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            var packageReference = {
                PackageId: _this.state.packageId,
                FeedId: _this.state.feedId,
                Properties: {
                    ValuesFilePath: _this.state.valuesFilePath || DefaultYamlFileLocation
                },
                AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.ExecutionTarget
            };
            return _this.props.onChange(packageReference);
        };
        _this.state = {
            packageId: _this.props.packageReference.PackageId,
            feedId: _this.props.packageReference.FeedId,
            acquisitionLocation: _this.props.packageReference.AcquisitionLocation,
            valuesFilePath: _this.props.packageReference.Properties["ValuesFilePath"]
        };
        return _this;
    }
    PackagedHelmValuesDialog.prototype.render = function () {
        var _this = this;
        var feed = _.find(this.props.feeds, function (f) { return f.Id === _this.state.feedId; });
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Reference a Package" }, this.props.packageReference && React.createElement("div", null,
            React.createElement(PackageSelector_1.default, { packageId: this.state.packageId, feedId: this.state.feedId, onPackageIdChange: function (packageId) { return _this.setState({ packageId: packageId }); }, onFeedIdChange: function (feedId) { return _this.setState({ feedId: feedId }); }, localNames: this.props.localNames, projectId: this.props.projectId, feeds: this.props.feeds, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.GitHub], refreshFeeds: this.props.refreshFeeds }),
            React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: this.state.acquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) { return _this.setState({ acquisitionLocation: acquisitionLocation }); }, runOn: this.props.runOn, showNotAcquiredOption: true, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames }),
            React.createElement("div", { style: { paddingTop: "1rem" } },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.valuesFilePath, onChange: function (x) { return _this.setState({ valuesFilePath: x }); }, hintText: DefaultYamlFileLocation, label: "Relative path to values file" }),
                React.createElement(Note_1.default, null,
                    "A newline-separated list of file names, relative to the package root to be included as additional ",
                    React.createElement("code", null, "--values"),
                    " files. Variable replacement will be run on these files before used. Extended template and wildcard syntax is supported. E.g., ",
                    React.createElement("em", null,
                        "values.", "#{Octopus.Environment.Name}",
                        ".yaml"),
                    ", ",
                    React.createElement("em", null, "**\\specific-folder\\*.yaml"),
                    "."))));
    };
    return PackagedHelmValuesDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.PackagedHelmValuesDialog = PackagedHelmValuesDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\helmChartUpgrade\\PackagedHelmValuesDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\helmChartUpgrade\\PackagedHelmValuesDialog.tsx"); } } })();

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var feedResource_1 = __webpack_require__(73);
var InternalLink_1 = __webpack_require__(43);
var ExpandableFormSection_1 = __webpack_require__(30);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var Summary_1 = __webpack_require__(44);
var routeLinks_1 = __webpack_require__(22);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var resources_2 = __webpack_require__(17);
var AzureCloudServiceActionSummary = (function (_super) {
    __extends(AzureCloudServiceActionSummary, _super);
    function AzureCloudServiceActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    AzureCloudServiceActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureCloudServiceActionSummary.prototype.render = function () {
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Transfer package",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return AzureCloudServiceActionSummary;
}(BaseComponent_1.BaseComponent));
var TransferPackageActionEdit = (function (_super) {
    __extends(TransferPackageActionEdit, _super);
    function TransferPackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    TransferPackageActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.setPackages(resources_2.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    TransferPackageActionEdit.prototype.transferPathSummary = function () {
        var transferPath = this.props.properties["Octopus.Action.Package.TransferPath"];
        if (!transferPath) {
            return Summary_1.default.placeholder("The transfer path has not been configured");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "The package will be moved to ",
            React.createElement("strong", null, transferPath),
            " once it is transfered"));
    };
    TransferPackageActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to push the contents of a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you which to transfer");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven, feedResource_1.FeedType.GitHub], refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.TransferPath", isExpandedByDefault: this.props.expandedByDefault, title: "Transfer Path", summary: this.transferPathSummary(), help: "Enter the path the package should be moved to on the remote target." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Package.TransferPath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.TransferPath"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Package.TransferPath"), label: "Transfer path" }),
                React.createElement(Note_1.default, null, "The location that the package should be moved to once it is uploaded to the remote target.")));
    };
    return TransferPackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.TransferPackageActionEdit = TransferPackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TransferPackage",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(AzureCloudServiceActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: TransferPackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\transferPackage\\transferPackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\transferPackage\\transferPackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var feedResource_1 = __webpack_require__(73);
var InternalLink_1 = __webpack_require__(43);
var ExpandableFormSection_1 = __webpack_require__(30);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var routeLinks_1 = __webpack_require__(22);
var ActionDetails_1 = __webpack_require__(25);
var resources_2 = __webpack_require__(17);
var DataBaseComponent_1 = __webpack_require__(90);
var DeployToWildflyActionSummary = (function (_super) {
    __extends(DeployToWildflyActionSummary, _super);
    function DeployToWildflyActionSummary(props) {
        return _super.call(this, props) || this;
    }
    DeployToWildflyActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy a Java application to Wildfly 10+ and Red Hat JBoss EAP 6+");
    };
    return DeployToWildflyActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployToWildflyActionEdit = (function (_super) {
    __extends(DeployToWildflyActionEdit, _super);
    function DeployToWildflyActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployToWildflyActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.setPackages(resources_2.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployToWildflyActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy.");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven], refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_2.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })));
    };
    return DeployToWildflyActionEdit;
}(DataBaseComponent_1.DataBaseComponent));
exports.DeployToWildflyActionEdit = DeployToWildflyActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WildFlyDeploy",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(DeployToWildflyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: DeployToWildflyActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        permanent: ["Octopus.Features.WildflyDeployCLI"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var wildflyFeatureTemplate_1 = __webpack_require__(753);
var ActionDetails_1 = __webpack_require__(25);
var ChangeStateInWildflyActionSummary = (function (_super) {
    __extends(ChangeStateInWildflyActionSummary, _super);
    function ChangeStateInWildflyActionSummary(props) {
        return _super.call(this, props) || this;
    }
    ChangeStateInWildflyActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Enable or disable an application in WildFly 10+ or Red Hat JBoss EAP 6+");
    };
    return ChangeStateInWildflyActionSummary;
}(BaseComponent_1.BaseComponent));
var ChangeStateInWildflyActionEdit = (function (_super) {
    __extends(ChangeStateInWildflyActionEdit, _super);
    function ChangeStateInWildflyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeStateInWildflyActionEdit.prototype.render = function () {
        return React.createElement(wildflyFeatureTemplate_1.default, { actionDescription: "Modifying", domainDefaultMessage: "Modifying an application in a domain.", properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, applicationNameNote: React.createElement("span", null, "This is the name of the deployment to enable or disable."), applicationStateNote: React.createElement("span", null,
                "This option allows you to enable or disable an application deployed to a standalone server. This value has no effect when deploying to domain servers. Set the ",
                React.createElement("em", null, "Standalone or Domain Server"),
                " option to ",
                React.createElement("em", null, "Domain"),
                " to see the ",
                React.createElement("em", null, "Enabled Server Groups"),
                " and ",
                React.createElement("em", null, "Disabled Server Groups"),
                " options, which allow you to configure the state of the application during a deployment to a domain."), applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server hosting the application to be enabled or disabled."), expandedByDefault: this.props.expandedByDefault });
    };
    return ChangeStateInWildflyActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ChangeStateInWildflyActionEdit = ChangeStateInWildflyActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.WildFlyState",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ChangeStateInWildflyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: ChangeStateInWildflyActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\changeStateInWildflyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\changeStateInWildflyAction.tsx"); } } })();

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WildflyStringProperties = {
    "WildFly.Deploy.Port": "",
    "WildFly.Deploy.Controller": "",
    "WildFly.Deploy.User": "",
    "WildFly.Deploy.Protocol": "",
    "WildFly.Deploy.ServerType": "",
    "WildFly.Deploy.DisabledServerGroup": "",
    "WildFly.Deploy.EnabledServerGroup": "",
};
exports.WildflySensitiveStringProperties = {
    "WildFly.Deploy.Password": ""
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyProperties.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyProperties.ts"); } } })();

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var wildflyFeatureTemplate_1 = __webpack_require__(753);
var DeplotToWildflyFeature = (function (_super) {
    __extends(DeplotToWildflyFeature, _super);
    function DeplotToWildflyFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeplotToWildflyFeature.prototype.render = function () {
        return React.createElement(wildflyFeatureTemplate_1.default, { actionDescription: "Deploying", domainDefaultMessage: "Deploying an application to a domain.", properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, projectId: this.props.projectId, applicationNameNote: React.createElement("span", null,
                "This optional field can be used to override the name of the deployed artifact. For example, setting this field to ",
                React.createElement("em", null, "myapp.war"),
                " will result in the deployment being having that name in WildFly regardless of the name of the package that was selected above."), applicationStateNote: React.createElement("span", null,
                "This option allows you to deploy the application in either an enabled or disabled state to a standalone server. This value has no effect when deploying to domain servers. Set the ",
                React.createElement("em", null, "Standalone or Domain Server"),
                " option to ",
                React.createElement("em", null, "Domain"),
                " to see the ",
                React.createElement("em", null, "Enabled Server Groups"),
                " and ",
                React.createElement("em", null, "Disabled Server Groups"),
                " options, which allow you to configure the state of the application during a deployment to a domain."), applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server that the package will be uploaded to."), expandedByDefault: this.props.expandedByDefault });
    };
    return DeplotToWildflyFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.WildflyDeployCLI",
    title: "Wildfly deployment feature",
    description: "Deploys packages to Wildfly via the manager API",
    edit: DeplotToWildflyFeature,
    priority: 1
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployToWildflyFeature.tsx"); } } })();

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var pluginRegistry_1 = __webpack_require__(18);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var wildflyConnectionDetailsComponent_1 = __webpack_require__(754);
var javaKeystoreComponent_1 = __webpack_require__(755);
var ExpandableFormSection_1 = __webpack_require__(30);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Summary_1 = __webpack_require__(44);
var FormSectionHeading_1 = __webpack_require__(48);
var wildflyRelativeLocationComponent_1 = __webpack_require__(2093);
var RadioButtonGroup_1 = __webpack_require__(36);
var material_ui_1 = __webpack_require__(101);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var DeployCertificateToTomcatActionSummary = (function (_super) {
    __extends(DeployCertificateToTomcatActionSummary, _super);
    function DeployCertificateToTomcatActionSummary(props) {
        return _super.call(this, props) || this;
    }
    DeployCertificateToTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Configure a certificate in WildFly 10+ or JBoss EAP 6+ standalone server to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return DeployCertificateToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployCertificateToTomcatActionEdit = (function (_super) {
    __extends(DeployCertificateToTomcatActionEdit, _super);
    function DeployCertificateToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null,
        };
        return _this;
    }
    DeployCertificateToTomcatActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var properties;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                this.setState({ project: project });
                                return [2 /*return*/];
                        }
                    });
                }); });
                properties = this.props.properties;
                if (properties["WildFly.Deploy.DeployCertificate"] !== "True" &&
                    properties["WildFly.Deploy.DeployCertificate"] !== "False") {
                    properties["WildFly.Deploy.DeployCertificate"] = "True";
                }
                if (properties["WildFly.Deploy.ServerType"] !== "Standalone" &&
                    properties["WildFly.Deploy.ServerType"] !== "Domain") {
                    properties["WildFly.Deploy.ServerType"] = "Standalone";
                }
                if (!properties["WildFly.Deploy.CertificateRelativeTo"]) {
                    properties["WildFly.Deploy.CertificateRelativeTo"] = "NONE";
                }
                if (!properties["WildFly.Deploy.CertificateProfiles"]) {
                    properties["WildFly.Deploy.CertificateProfiles"] = "default";
                }
                this.props.setProperties(properties);
                return [2 /*return*/];
            });
        });
    };
    DeployCertificateToTomcatActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var serverDetailsErrorKey = "WildFly.Deploy.ServerType|" +
            "Java.Certificate.KeystoreFilename|" +
            "WildFly.Deploy.CertificateRelativeTo|" +
            "Java.Certificate.Password|" +
            "Java.Certificate.KeystoreAlias|" +
            "Java.Certificate.Variable";
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Application Server Details" }),
            React.createElement(wildflyConnectionDetailsComponent_1.default, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, applicationServerHostnameNote: React.createElement("span", null, "This is the hostname or IP address of the application server that the certificate will be configured in."), actionDescription: React.createElement("span", null, "Deploy a certificate via the management interface listening on"), expandedByDefault: this.props.expandedByDefault }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: serverDetailsErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Certificate Configuration", summary: this.keystoreSummary(), help: "Specify the certificate details" },
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["WildFly.Deploy.ServerType"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ServerType"] = x, _a));
                        var _a;
                    }, label: "Standalone or domain server" },
                    React.createElement(material_ui_1.RadioButton, { value: "Standalone", label: "Standalone" }),
                    React.createElement(material_ui_1.RadioButton, { value: "Domain", label: "Domain" })),
                React.createElement(Note_1.default, null, "Select the kind of server you are deploying to."),
                properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                    React.createElement("div", null,
                        React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "NONE", value: properties["WildFly.Deploy.DeployCertificate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.DeployCertificate"] = x, _a));
                                var _a;
                            }, label: "Keystore creation" },
                            React.createElement(material_ui_1.RadioButton, { value: "True", label: "Create a new keystore" }),
                            React.createElement(material_ui_1.RadioButton, { value: "False", label: "Reference an existing keystore" })),
                        properties["WildFly.Deploy.DeployCertificate"] === "True" &&
                            React.createElement(javaKeystoreComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, keystoreFilenameMessage: React.createElement("span", null,
                                    React.createElement("p", null,
                                        "The optional path of the keystore file to create. If defined, this must be an absolute path, the parent directory must exist, and the path must include the keystore filename e.g. ",
                                        React.createElement("em", null, "C:\\Keys\\my.keystore"),
                                        " or ",
                                        React.createElement("em", null, "/opt/server/conf/keys.store"),
                                        "."),
                                    React.createElement("p", null, "If the file exists, it will be overwritten."),
                                    React.createElement("p", null,
                                        "If this value is not defined a new certificate will be created in the application server's ",
                                        React.createElement("em", null, "configuration"),
                                        " directory.")), expandedByDefault: this.props.expandedByDefault })),
                properties["WildFly.Deploy.ServerType"] === "Domain" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.CertificateProfiles"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.CertificateProfiles"] = x, _a));
                                var _a;
                            }, label: "Domain profiles" }),
                        React.createElement(Note_1.default, null, "A comma separated list that defines the domain server groups where the certificate will be configured.")),
                (properties["WildFly.Deploy.ServerType"] === "Domain" ||
                    properties["WildFly.Deploy.DeployCertificate"] !== "True") &&
                    React.createElement(wildflyRelativeLocationComponent_1.default, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "AdvancedOptions", isExpandedByDefault: this.props.expandedByDefault, title: "Advanced Options", summary: this.advancedSummary(), help: "Specify optional advanced security options" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.HTTPSPortBindingName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.HTTPSPortBindingName"] = x, _a));
                        var _a;
                    }, label: "HTTPS socket binding name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the port binding that is used to listen to HTTPS requests in the application server. If left blank, it will default to ",
                    React.createElement("em", null, "https"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.SecurityRealmName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.SecurityRealmName"] = x, _a));
                        var _a;
                    }, label: "Legacy security realm name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the security realm that will be created in applicable application servers. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttps"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronKeystoreName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronKeystoreName"] = x, _a));
                        var _a;
                    }, label: "Elytron key store name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron key store. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsKS"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronKeymanagerName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronKeymanagerName"] = x, _a));
                        var _a;
                    }, label: "Elytron key manager name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron key manager. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsKM"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["WildFly.Deploy.ElytronSSLContextName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.ElytronSSLContextName"] = x, _a));
                        var _a;
                    }, label: "Elytron server SSL context name" }),
                React.createElement(Note_1.default, null,
                    "This field defines the name of the the Elytron server SSL context. If left blank, this value will default to ",
                    React.createElement("em", null, "OctopusHttpsSSC"),
                    ".")));
    };
    DeployCertificateToTomcatActionEdit.prototype.advancedSummary = function () {
        var properties = this.props.properties;
        var customPortBinding = properties["WildFly.Deploy.HTTPSPortBindingName"] && properties["WildFly.Deploy.HTTPSPortBindingName"] !== "https";
        var customSecurityRealm = properties["WildFly.Deploy.SecurityRealmName"] && properties["WildFly.Deploy.SecurityRealmName"] !== "OctopusHTTPS";
        var customKeystore = properties["WildFly.Deploy.ElytronKeystoreName"] && properties["WildFly.Deploy.ElytronKeystoreName"] !== "octopusHttpsKS";
        var customKeymanager = properties["WildFly.Deploy.ElytronKeymanagerName"] && properties["WildFly.Deploy.ElytronKeymanagerName"] !== "octopusHttpsKM";
        var customSSLContext = properties["WildFly.Deploy.ElytronSSLContextName"] && properties["WildFly.Deploy.ElytronSSLContextName"] !== "octopusHttpsSSC";
        if (customPortBinding ||
            customSecurityRealm ||
            customKeystore ||
            customKeymanager ||
            customSSLContext) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Configuring HTTPS with",
                customPortBinding &&
                    React.createElement("span", null,
                        "\u00A0a port binding called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.HTTPSPortBindingName"])),
                customPortBinding &&
                    React.createElement("span", null, ","),
                customPortBinding && !(customKeystore || customKeymanager || customSSLContext) &&
                    React.createElement("span", null, " and"),
                customSecurityRealm &&
                    React.createElement("span", null,
                        "\u00A0a security realm called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.SecurityRealmName"])),
                (customPortBinding || customSecurityRealm) &&
                    React.createElement("span", null, ","),
                customKeystore && !(customKeymanager || customSSLContext) &&
                    React.createElement("span", null, " and"),
                customKeystore &&
                    React.createElement("span", null,
                        "\u00A0an Elytron KeyStore called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronKeystoreName"])),
                (customPortBinding || customSecurityRealm || customKeystore) &&
                    React.createElement("span", null, ","),
                customKeymanager && !customSSLContext &&
                    React.createElement("span", null, " and"),
                customKeymanager &&
                    React.createElement("span", null,
                        "\u00A0an Elyton KeyManager called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronKeymanagerName"])),
                (customPortBinding || customSecurityRealm || customKeystore || customKeymanager) &&
                    React.createElement("span", null, ", and"),
                customSSLContext &&
                    React.createElement("span", null,
                        "\u00A0an Elytron SSL Context called ",
                        React.createElement("strong", null, properties["WildFly.Deploy.ElytronSSLContextName"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define optional advanced security settings."));
    };
    DeployCertificateToTomcatActionEdit.prototype.keystoreSummary = function () {
        var properties = this.props.properties;
        return Summary_1.default.summary(React.createElement("span", null,
            "Deploying to a ",
            properties["WildFly.Deploy.ServerType"],
            " server",
            properties["WildFly.Deploy.ServerType"] === "Standalone" &&
                properties["WildFly.Deploy.DeployCertificate"] === "True" &&
                React.createElement("span", null,
                    "\u00A0creating a new keystore",
                    properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null,
                            "\u00A0at ",
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])),
                    !properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null, "\u00A0in the default location"),
                    properties["Java.Certificate.Password"] &&
                        React.createElement("span", null,
                            "\u00A0with a custom password",
                            properties["Java.Certificate.KeystoreAlias"] &&
                                React.createElement("span", null, "\u00A0and")),
                    properties["Java.Certificate.KeystoreAlias"] &&
                        React.createElement("span", null,
                            "\u00A0with a custom alias ",
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreAlias"]))),
            (properties["WildFly.Deploy.ServerType"] === "Domain" ||
                properties["WildFly.Deploy.DeployCertificate"] !== "True") &&
                React.createElement("span", null,
                    "\u00A0referencing the existing keystore",
                    properties["Java.Certificate.KeystoreFilename"] &&
                        React.createElement("span", null,
                            "\u00A0at\u00A0",
                            properties["WildFly.Deploy.CertificateRelativeTo"] !== "NONE" &&
                                React.createElement("strong", null,
                                    "$",
                                    "{",
                                    properties["WildFly.Deploy.CertificateRelativeTo"],
                                    "}",
                                    "/"),
                            React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])))));
    };
    return DeployCertificateToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployCertificateToTomcatActionEdit = DeployCertificateToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.default.AlwaysOnTarget,
    actionType: "Octopus.WildFlyCertificateDeploy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployCertificateToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployCertificateToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployCertificate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\deployCertificate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Select_1 = __webpack_require__(40);
var Sensitive_1 = __webpack_require__(93);
/**
 * A component that displays the details of a keystore to reference
 */
var WildflyRelativeLocationComponent = (function (_super) {
    __extends(WildflyRelativeLocationComponent, _super);
    function WildflyRelativeLocationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildflyRelativeLocationComponent.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                    var _a;
                }, label: "Keystore Filename", error: this.props.getFieldError("Java.Certificate.KeystoreFilename") }),
            React.createElement(Note_1.default, null,
                "The path to the existing keystore file. This can be an absolute file path, or can be relative to one of the standard base paths defined by the application server, which can be selected in the ",
                React.createElement("em", null, "Relative base path"),
                " list."),
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "NONE", value: properties["WildFly.Deploy.CertificateRelativeTo"], items: this.getBasePaths(), label: "Relative base path", onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["WildFly.Deploy.CertificateRelativeTo"] = x, _a));
                    var _a;
                } }),
            React.createElement(Note_1.default, null,
                "This defines the relative path that the keystore file will be resolved from. Select ",
                React.createElement("em", null, "No relative path base"),
                " if the keystore filename is an absolute path."),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                    var _a;
                }, label: "Private Key Password" }),
            React.createElement(Note_1.default, null,
                "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password of ",
                React.createElement("em", null, "changeit"),
                " will be used."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                    var _a;
                }, label: "Keystore Alias" }),
            React.createElement(Note_1.default, null,
                "The optional alias to assign the private key to. If left blank, the default alias of ",
                React.createElement("em", null, "Octopus"),
                " will be used"));
    };
    WildflyRelativeLocationComponent.prototype.getBasePaths = function () {
        var commonItems = [
            { text: "none: Keystore Filename is an absolute path", value: "NONE" },
            { text: "jboss.home.dir: Root directory of the application server distribution", value: "jboss.home.dir" },
            { text: "user.home: Application server user's home directory", value: "user.home" },
            { text: "user.dir: Application server user's current working directory", value: "user.dir" },
            { text: "java.home: Java installation directory", value: "java.home" }
        ];
        if (this.props.properties["WildFly.Deploy.ServerType"] === "Domain") {
            commonItems.push({ text: "jboss.domain.base.dir: Base directory for domain content.", value: "jboss.domain.base.dir" }, { text: "jboss.domain.config.dir: Directory that contains the domain configuration.", value: "jboss.domain.config.dir" }, { text: "jboss.domain.data.dir: Directory that the domain will use for persistent data file storage.", value: "jboss.domain.data.dir" }, { text: "jboss.domain.log.dir: Directory that the domain will use for persistent log file storage.", value: "jboss.domain.log.dir" }, { text: "jboss.domain.temp.dir: Directory that the domain will use for temporary file storage.", value: "jboss.domain.temp.dir" }, { text: "jboss.domain.deployment.dir: Directory that the domain will use for storing deployed content.", value: "jboss.domain.deployment.dir" }, {
                text: "jboss.domain.servers.dir: Directory that the domain will use for storing outputs of the managed domain instances.",
                value: "jboss.domain.servers.dir"
            });
        }
        else {
            commonItems.push({ text: "jboss.server.base.dir: Root directory for an individual server instance", value: "jboss.server.base.dir" }, { text: "jboss.server.config.dir: Directory the server will use for configuration file storage", value: "jboss.server.config.dir" }, { text: "jboss.server.data.dir: Directory the server will use for persistent data file storage", value: "jboss.server.data.dir" }, { text: "jboss.server.log.dir: Directory the server will use for log file storage", value: "jboss.server.log.dir" }, { text: "jboss.server.temp.dir: Directory the server will use for temporary file storage", value: "jboss.server.temp.dir" }, { text: "jboss.controller.temp.dir: Directory the server will use for temporary file storage", value: "jboss.controller.temp.dir" });
        }
        return commonItems;
    };
    return WildflyRelativeLocationComponent;
}(BaseComponent_1.BaseComponent));
exports.default = WildflyRelativeLocationComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyRelativeLocationComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\wildfly\\wildflyRelativeLocationComponent.tsx"); } } })();

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var FormSectionHeading_1 = __webpack_require__(48);
var feedResource_1 = __webpack_require__(73);
var InternalLink_1 = __webpack_require__(43);
var ExpandableFormSection_1 = __webpack_require__(30);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var routeLinks_1 = __webpack_require__(22);
var getFeedName_1 = __webpack_require__(88);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var resources_1 = __webpack_require__(17);
var DeployToTomcatActionSummary = (function (_super) {
    __extends(DeployToTomcatActionSummary, _super);
    function DeployToTomcatActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DeployToTomcatActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployToTomcatActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy a Java application to Tomcat 7+ using package  ",
            React.createElement("strong", null,
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return DeployToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployToTomcatActionEdit = (function (_super) {
    __extends(DeployToTomcatActionEdit, _super);
    function DeployToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployToTomcatActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployToTomcatActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a package to one or more machines which may be sourced from an external feed or the Octopus built-in feed. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy");
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven], refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })));
    };
    return DeployToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployToTomcatActionEdit = DeployToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TomcatDeploy",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(DeployToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: DeployToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        permanent: ["Octopus.Features.TomcatDeployManager"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var actionExecutionLocation_1 = __webpack_require__(46);
var tomcatFeatureTemplate_1 = __webpack_require__(756);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var ChangeStateInTomcatActionSummary = (function (_super) {
    __extends(ChangeStateInTomcatActionSummary, _super);
    function ChangeStateInTomcatActionSummary(props) {
        return _super.call(this, props) || this;
    }
    ChangeStateInTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Change the state of an application in Tomcat 7+ ",
            this.props.targetRolesAsCSV &&
                React.createElement("span", null,
                    " to deployment targets in ",
                    React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                    " "));
    };
    return ChangeStateInTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var ChangeStateInTomcatActionEdit = (function (_super) {
    __extends(ChangeStateInTomcatActionEdit, _super);
    function ChangeStateInTomcatActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeStateInTomcatActionEdit.prototype.render = function () {
        return React.createElement(tomcatFeatureTemplate_1.default, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault, projectId: this.props.projectId });
    };
    return ChangeStateInTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.ChangeStateInTomcatActionEdit = ChangeStateInTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TomcatState",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(ChangeStateInTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: ChangeStateInTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\changeStateInTomcatAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\changeStateInTomcatAction.tsx"); } } })();

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2097);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".style_nowrap__3WQwQ{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"nowrap": "style_nowrap__3WQwQ"
};

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var tomcatFeatureTemplate_1 = __webpack_require__(756);
var DeployToTomcatFeature = (function (_super) {
    __extends(DeployToTomcatFeature, _super);
    function DeployToTomcatFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeployToTomcatFeature.prototype.render = function () {
        return React.createElement(tomcatFeatureTemplate_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault });
    };
    return DeployToTomcatFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.TomcatDeployManager",
    title: "Tomcat deployment feature",
    description: "Deploys packages to Tomcat via the manager API",
    edit: DeployToTomcatFeature,
    priority: 1
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployToTomcatFeature.tsx"); } } })();

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var pluginRegistry_1 = __webpack_require__(18);
var ExpandableFormSection_1 = __webpack_require__(30);
var Summary_1 = __webpack_require__(44);
var VariableLookupText_1 = __webpack_require__(21);
var CertificateVariableSelect_1 = __webpack_require__(191);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var Note_1 = __webpack_require__(20);
var Sensitive_1 = __webpack_require__(93);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var DeployCertificateToTomcatActionSummary = (function (_super) {
    __extends(DeployCertificateToTomcatActionSummary, _super);
    function DeployCertificateToTomcatActionSummary(props) {
        return _super.call(this, props) || this;
    }
    DeployCertificateToTomcatActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a certificate to Tomcat 7+ to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return DeployCertificateToTomcatActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployCertificateToTomcatActionEdit = (function (_super) {
    __extends(DeployCertificateToTomcatActionEdit, _super);
    function DeployCertificateToTomcatActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    DeployCertificateToTomcatActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var properties;
            return __generator(this, function (_a) {
                this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                    var project;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                            case 1:
                                project = _a.sent();
                                this.setState({ project: project });
                                return [2 /*return*/];
                        }
                    });
                }); });
                properties = this.props.properties;
                if (!properties["Tomcat.Certificate.Service"]) {
                    properties["Tomcat.Certificate.Service"] = "Catalina";
                }
                if (!properties["Tomcat.Certificate.Implementation"]) {
                    properties["Tomcat.Certificate.Implementation"] = "NIO";
                }
                if (!properties["Tomcat.Certificate.Default"]) {
                    properties["Tomcat.Certificate.Default"] = "False";
                }
                this.props.setProperties(properties);
                return [2 /*return*/];
            });
        });
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatLocationSummary = function () {
        if (this.props.properties["Tomcat.Certificate.CatalinaHome"]) {
            /*
                Guess the path splitter based on the kinds of slashes that exist in
                the base location
             */
            var pathSplit = this.props.properties["Tomcat.Certificate.CatalinaHome"].indexOf("/") !== -1
                ? "/" : "\\";
            return Summary_1.default.summary(React.createElement("span", null,
                "Adding the certificate to the ",
                React.createElement("strong", null,
                    this.props.properties["Tomcat.Certificate.CatalinaBase"] ||
                        this.props.properties["Tomcat.Certificate.CatalinaHome"],
                    pathSplit,
                    "config",
                    pathSplit,
                    "server.xml"),
                " configuration file"));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the CATALINA_BASE directory"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatCertificateSummary = function () {
        if (this.props.properties["Java.Certificate.Variable"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying the ",
                this.props.properties["Java.Certificate.Variable"],
                " certificate",
                this.props.properties["Tomcat.Certificate.Service"] &&
                    React.createElement("span", null,
                        " to the service named ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Service"])),
                this.props.properties["Tomcat.Certificate.Port"] &&
                    React.createElement("span", null,
                        " under the connector listening on port ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Port"])),
                this.props.properties["Tomcat.Certificate.Hostname"] &&
                    React.createElement("span", null,
                        " configured with the SNI hostname ",
                        React.createElement("strong", null, this.props.properties["Tomcat.Certificate.Hostname"]))));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the certificate to deploy"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatSNISummary = function () {
        if (this.props.properties["Tomcat.Certificate.Hostname"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Mapping certificate to the ",
                this.props.properties["Tomcat.Certificate.Hostname"],
                " host name"));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Map a certificate to a host name (Tomcat 8.5+ only)"));
    };
    DeployCertificateToTomcatActionEdit.prototype.tomcatOptionsSummary = function () {
        if (this.props.properties["Java.Certificate.Password"] ||
            this.props.properties["Tomcat.Certificate.PrivateKeyFilename"] ||
            this.props.properties["Tomcat.Certificate.PublicKeyFilename"] ||
            this.props.properties["Java.Certificate.KeystoreFilename"] ||
            this.props.properties["Java.Certificate.KeystoreAlias"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying the certificate",
                (this.props.properties["Tomcat.Certificate.PrivateKeyFilename"] ||
                    this.props.properties["Tomcat.Certificate.PublicKeyFilename"] ||
                    this.props.properties["Java.Certificate.KeystoreFilename"]) &&
                    React.createElement("span", null, " to a custom location"),
                this.props.properties["Java.Certificate.Password"] &&
                    React.createElement("span", null,
                        " with a custom password",
                        this.props.properties["Java.Certificate.KeystoreAlias"] &&
                            React.createElement("span", null, " and")),
                this.props.properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null, " with a custom alias")));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the optional certificate properties"));
    };
    DeployCertificateToTomcatActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var serverDetailsErrorKey = "Tomcat.Certificate.CatalinaHome|" +
            "Tomcat.Certificate.CatalinaBase";
        var certificateDetailsErrorKey = "Java.Certificate.Variable|" +
            "Tomcat.Certificate.Service|" +
            "Tomcat.Certificate.Implementation|" +
            "Tomcat.Certificate.Port";
        return React.createElement("div", null,
            React.createElement(ExpandableFormSection_1.default, { errorKey: serverDetailsErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat Location", summary: this.tomcatLocationSummary(), help: "Specify the path to the Tomcat CATALINA_HOME and CATALINA_BASE directories" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.CatalinaHome"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.CatalinaHome"] = x, _a));
                        var _a;
                    }, label: "Tomcat CATALINA_HOME path", error: this.props.getFieldError("Tomcat.Certificate.CatalinaHome") }),
                React.createElement(Note_1.default, null, "This is the root directory of the \"binary\" distribution of Tomcat."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.CatalinaBase"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.CatalinaBase"] = x, _a));
                        var _a;
                    }, label: "Tomcat CATALINA_BASE path", error: this.props.getFieldError("Java.Certificate.TomcatLocation") }),
                React.createElement(Note_1.default, null, "This is the root directory of the \"active configuration\" of Tomcat. This can be left blank if the Tomcat root directory CATALINA_HOME directory also holds the configuration (i.e. leave this blank if the CATALINA_HOME and CATALINA_BASE directories are the same).")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: certificateDetailsErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat Certificate", summary: this.tomcatCertificateSummary(), help: "Specify the details of the certificate to install" },
                this.props.projectId
                    ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "", doBusyTask: this.props.doBusyTask, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Java.Certificate.Variable"), allowClear: true })
                    : React.createElement(VariableLookupText_1.VariableLookupText, { label: "Certificate variable", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Java.Certificate.Variable"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Java.Certificate.Variable"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Java.Certificate.Variable") }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Service"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Service"] = x, _a));
                        var _a;
                    }, label: "Tomcat service name", error: this.props.getFieldError("Tomcat.Certificate.Service") }),
                React.createElement(Note_1.default, null,
                    "This is the name of the Service element in the server.xml file e.g. ",
                    "<",
                    "Service name=\"Catalina\"",
                    ">",
                    "."),
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "NIO", value: properties["Tomcat.Certificate.Implementation"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Implementation"] = x, _a));
                        var _a;
                    }, label: "SSL implementation" },
                    React.createElement(RadioButton_1.default, { value: "BIO", label: "Blocking IO (BIO - Tomcat 8 and below only)" }),
                    React.createElement(RadioButton_1.default, { value: "NIO", label: "Non-Blocking IO (NIO)" }),
                    React.createElement(RadioButton_1.default, { value: "NIO2", label: "Non-Blocking IO 2 (NIO2 - Tomcat 8 and above only)" }),
                    React.createElement(RadioButton_1.default, { value: "APR", label: "Apache Portable Runtime (APR)" })),
                React.createElement(Note_1.default, null, "These are the standard implementations provided by Tomcat to support HTTPS. Note that not all versions of Tomcat support all implementations."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Port"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Port"] = x, _a));
                        var _a;
                    }, label: "HTTPS port", error: this.props.getFieldError("Tomcat.Certificate.Port") }),
                React.createElement(Note_1.default, null, "This is the HTTPS port that this certificate will be bound to.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "tomcatSNIOptions", isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat SNI Options (Tomcat 8.5+ only)", summary: this.tomcatSNISummary(), help: "Specify the SNI details" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.Hostname"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Hostname"] = x, _a));
                        var _a;
                    }, label: "Certificate SNI hostname" }),
                React.createElement(Note_1.default, null, "In Tomcat 8.5 and above certificates can be bound to a host name using SNI. This field defines the host name that this certificate is bound to. Leave this field blank when deploying to Tomcat 7 or 8. If you leave this field blank when deploying to Tomcat 8.5 and above, the certificate will be assigned a default host name by Tomcat."),
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Tomcat.Certificate.Default"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.Default"] = x, _a));
                        var _a;
                    }, label: "Default certificate" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Make this the default certificate" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Leave this certificate's default status unchanged" })),
                React.createElement(Note_1.default, null,
                    "In Tomcat 8.5 and above a certificate can be designated as the default one to respond to any request to a host that does not have a specific certificate assigned. Selecting ",
                    React.createElement("em", null, "Make this the default certificate"),
                    " will configure the certificate to be the default one. This field has no effect when deploying to Tomcat 7 or Tomcat 8.")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "tomcatCertificateOptions", isExpandedByDefault: this.props.expandedByDefault, title: "Tomcat Certificate Options", summary: this.tomcatOptionsSummary(), help: "Specify the optional certificate details" },
                React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "", value: properties["Java.Certificate.Password"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Java.Certificate.Password"] = x, _a));
                        var _a;
                    }, label: "Private key password" }),
                React.createElement(Note_1.default, null, "You can set an optional password which will be assigned to the private key. If this field is left blank, the default password defined by Tomcat will be used where possible, or the private key will remain unencrypted."),
                this.props.properties["Tomcat.Certificate.Implementation"] === "APR" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.PrivateKeyFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.PrivateKeyFilename"] = x, _a));
                                var _a;
                            }, label: "Private key filename" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the path of the private key that will be generated when configuring the APR implementation. If this file exists it will be overwritten. If this field is left blank a new file will be created in the Tomcat ",
                            React.createElement("em", null, "conf"),
                            " directory."),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Tomcat.Certificate.PublicKeyFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Tomcat.Certificate.PublicKeyFilename"] = x, _a));
                                var _a;
                            }, label: "Public key filename" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the path of the public key that will be generated when configuring the APR implementation. If this file exists it will be overwritten. If this field is left blank a new file will be created in the Tomcat ",
                            React.createElement("em", null, "conf"),
                            " directory.")),
                this.props.properties["Tomcat.Certificate.Implementation"] !== "APR" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreFilename"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreFilename"] = x, _a));
                                var _a;
                            }, label: "Keystore filename" }),
                        React.createElement(Note_1.default, null,
                            React.createElement("p", null,
                                "You can optionally set the path of the keystore that will be generated when configuring the BIO, NIO and NIO2 implementations. If this file exists it will be overwritten. If this field is left blank a keystore file will be created in the Tomcat ",
                                React.createElement("em", null, "conf"),
                                " directory."),
                            React.createElement("p", null, "If the specified file exists it will be overwritten.")),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Java.Certificate.KeystoreAlias"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Java.Certificate.KeystoreAlias"] = x, _a));
                                var _a;
                            }, label: "Keystore alias" }),
                        React.createElement(Note_1.default, null,
                            "You can optionally set the alias under which the certificate information will be stored when configuring the BIO, NIO and NIO2 implementations. If this field is left blank the default alias of ",
                            React.createElement("em", null, "octopus"),
                            " will be used."))));
    };
    return DeployCertificateToTomcatActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployCertificateToTomcatActionEdit = DeployCertificateToTomcatActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.default.AlwaysOnTarget,
    actionType: "Octopus.TomcatDeployCertificate",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(DeployCertificateToTomcatActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: DeployCertificateToTomcatActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployCertificate.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\tomcat\\deployCertificate.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var feedResource_1 = __webpack_require__(73);
var InternalLink_1 = __webpack_require__(43);
var ExpandableFormSection_1 = __webpack_require__(30);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var Summary_1 = __webpack_require__(44);
var StringCheckbox_1 = __webpack_require__(41);
var routeLinks_1 = __webpack_require__(22);
var getFeedName_1 = __webpack_require__(88);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var DeployJavaPackageActionSummary = (function (_super) {
    __extends(DeployJavaPackageActionSummary, _super);
    function DeployJavaPackageActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    DeployJavaPackageActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployJavaPackageActionSummary.prototype.render = function () {
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy a Java package ",
            React.createElement("strong", null,
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return DeployJavaPackageActionSummary;
}(BaseComponent_1.BaseComponent));
var DeployJavaPackageActionEdit = (function (_super) {
    __extends(DeployJavaPackageActionEdit, _super);
    function DeployJavaPackageActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    DeployJavaPackageActionEdit.prototype.deploymentSummary = function () {
        var properties = this.props.properties;
        return Summary_1.default.summary(React.createElement("span", null,
            "Deploying the",
            properties["Octopus.Action.JavaArchive.DeployExploded"] === "True" &&
                React.createElement("span", null, "\u00A0exploded"),
            "\u00A0package",
            properties["Octopus.Action.Package.CustomPackageFileName"] &&
                React.createElement("span", null,
                    "\u00A0named ",
                    React.createElement("strong", null, properties["Octopus.Action.Package.CustomPackageFileName"])),
            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                React.createElement("span", null,
                    "\u00A0to ",
                    React.createElement("strong", null, properties["Octopus.Action.Package.CustomInstallationDirectory"])),
            properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "False" &&
                React.createElement("span", null, "\u00A0to the default location"),
            properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True" &&
                properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                React.createElement("span", null,
                    "\u00A0purging the destination",
                    properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] &&
                        React.createElement("span", null, "\u00A0with exclusions"))));
    };
    DeployJavaPackageActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var properties;
                            return __generator(this, function (_a) {
                                properties = {};
                                if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"]) {
                                    properties["Octopus.Action.Package.UseCustomInstallationDirectory"] = "True";
                                }
                                else if (this.props.properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True" &&
                                    this.props.properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "False") {
                                    properties["Octopus.Action.Package.UseCustomInstallationDirectory"] = "False";
                                }
                                if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] !== "True" &&
                                    this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] !== "False") {
                                    properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = "False";
                                }
                                if (!this.props.properties["Octopus.Action.JavaArchive.DeployExploded"]) {
                                    properties["Octopus.Action.JavaArchive.DeployExploded"] = "False";
                                }
                                this.props.setProperties(properties, true);
                                return [2 /*return*/];
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    DeployJavaPackageActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var properties = this.props.properties;
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a Java archive (.jar, .war, .ear) to one or more machines. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab.")
            : React.createElement("span", null, "Choose the package you wish to deploy");
        var deploymentErrorKey = "Octopus.Action.JavaArchive.DeployExploded|"
            + "Octopus.Action.Package.CustomPackageFileName|"
            + "Octopus.Action.Package.UseCustomInstallationDirectory|"
            + "Octopus.Action.Package.CustomInstallationDirectory|"
            + "Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment|"
            + "Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions";
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Package Details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, feedType: [feedResource_1.FeedType.Nuget, feedResource_1.FeedType.Maven], refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: deploymentErrorKey, isExpandedByDefault: this.props.expandedByDefault, title: "Deployment", summary: this.deploymentSummary(), help: React.createElement("span", null, "Choose how and where the package will be deployed.") },
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.JavaArchive.DeployExploded"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.JavaArchive.DeployExploded"] = x, _a));
                        var _a;
                    }, label: "Deploy the extracted package", note: React.createElement("span", null, " If selected, the package will be deployed extracted.") }),
                React.createElement(Note_1.default, null,
                    React.createElement("p", null, "Note: The package is always extracted as part of the deployment process, to allow features such as substituting variables in files. By default the package is re-created before deploying to the destination. If the option above is selected it remains extracted.")),
                properties["Octopus.Action.JavaArchive.DeployExploded"] === "False" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomPackageFileName"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomPackageFileName"] = x, _a));
                                var _a;
                            }, label: "Deployed package file name" }),
                        React.createElement(Note_1.default, null, "The optional filename of the copied package. If left blank, the original filename from the feed will be retained.")),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: properties["Octopus.Action.Package.UseCustomInstallationDirectory"], onChange: function (x) {
                        _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UseCustomInstallationDirectory"] = x, _a));
                        if (properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True") {
                            _this.props.setProperties((_b = {}, _b["Octopus.Action.Package.CustomInstallationDirectory"] = "", _b));
                        }
                        var _a, _b;
                    }, label: "Use custom deployment directory", note: React.createElement("span", null, "By default the package will be deployed to the target's application directory. This options allows setting a custom deployment directory.") }),
                properties["Octopus.Action.Package.UseCustomInstallationDirectory"] === "True" &&
                    React.createElement("div", null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectory"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectory"] = x, _a));
                                var _a;
                            }, label: "Deploy Directory" }),
                        React.createElement(Note_1.default, null, "The installed package will be copied to this location on the remote machine."),
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = x, _a));
                                var _a;
                            }, label: "Purge" }),
                        React.createElement(Note_1.default, null, "Before the installed package is copied, all files in this location will be removed."),
                        properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True" &&
                            React.createElement("div", null,
                                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"], onChange: function (x) {
                                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] = x, _a));
                                        var _a;
                                    }, label: "Exclude from purge", multiLine: true, rows: 5 }),
                                React.createElement(Note_1.default, null,
                                    "A newline-separated list of file or directory names, relative to the installation directory, to leave when it is purged. To exclude a whole directory, specify it by name without a wildcard. Extended wildcard syntax is supported. E.g., ",
                                    React.createElement("em", null, "appsettings.config"),
                                    ", ",
                                    React.createElement("em", null, "Config"),
                                    ",",
                                    React.createElement("em", null, "Config\\*.config"),
                                    ", ",
                                    React.createElement("em", null, "**\\*.config"))))));
    };
    return DeployJavaPackageActionEdit;
}(BaseComponent_1.BaseComponent));
exports.DeployJavaPackageActionEdit = DeployJavaPackageActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.JavaArchive",
    summary: function (properties, targetRolesAsCSV, packages) {
        return React.createElement(DeployJavaPackageActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages });
    },
    edit: DeployJavaPackageActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.CustomScripts",
            "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaPackage\\javaPackageAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaPackage\\javaPackageAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var javaKeystoreComponent_1 = __webpack_require__(755);
var FormSectionHeading_1 = __webpack_require__(48);
var ExpandableFormSection_1 = __webpack_require__(30);
var Summary_1 = __webpack_require__(44);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var JavaKeystoreActionSummary = (function (_super) {
    __extends(JavaKeystoreActionSummary, _super);
    function JavaKeystoreActionSummary(props) {
        return _super.call(this, props) || this;
    }
    JavaKeystoreActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy a Java keystore to the target filesystem to deployment targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }));
    };
    return JavaKeystoreActionSummary;
}(BaseComponent_1.BaseComponent));
var JavaKeystoreActionEdit = (function (_super) {
    __extends(JavaKeystoreActionEdit, _super);
    function JavaKeystoreActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            project: null
        };
        return _this;
    }
    JavaKeystoreActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        project = _a.sent();
                        this.setState({ project: project });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    JavaKeystoreActionEdit.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "Keystore details" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Java.Certificate.Variable|Java.Certificate.KeystoreFilename", isExpandedByDefault: this.props.expandedByDefault, title: "Keystore Details", summary: this.keystoreSummary(), help: "Specify the keystore details" },
                React.createElement(javaKeystoreComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, keystoreFilenameMessage: React.createElement("span", null,
                        React.createElement("p", null,
                            "The path of the keystore file to create. This must be an absolute path, the parent directory must exist, and the path must include the keystore filename e.g. ",
                            React.createElement("em", null, "C:\\Keys\\my.keystore"),
                            " or ",
                            React.createElement("em", null, "/opt/server/conf/keys.store"),
                            "."),
                        React.createElement("p", null, "If the file exists, it will be overwritten.")), expandedByDefault: this.props.expandedByDefault })));
    };
    JavaKeystoreActionEdit.prototype.keystoreSummary = function () {
        var properties = this.props.properties;
        if (properties["Java.Certificate.Variable"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Deploying certificate referenced by the ",
                React.createElement("strong", null, properties["Java.Certificate.Variable"]),
                " variable",
                properties["Java.Certificate.KeystoreFilename"] &&
                    React.createElement("span", null,
                        "\u00A0to the file ",
                        React.createElement("strong", null, properties["Java.Certificate.KeystoreFilename"])),
                properties["Java.Certificate.Password"] &&
                    React.createElement("span", null, "\u00A0with a custom password"),
                !properties["Java.Certificate.Password"] &&
                    React.createElement("span", null, "\u00A0with the default password"),
                properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null,
                        "\u00A0and with the alias ",
                        React.createElement("strong", null, properties["Java.Certificate.KeystoreAlias"])),
                !properties["Java.Certificate.KeystoreAlias"] &&
                    React.createElement("span", null, "\u00A0and with the default alias")));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the keystore details"));
    };
    return JavaKeystoreActionEdit;
}(BaseComponent_1.BaseComponent));
exports.JavaKeystoreActionEdit = JavaKeystoreActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.JavaDeployCertificate",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(JavaKeystoreActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: JavaKeystoreActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\javaKeystore\\javaKeystoreAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var scriptAction_1 = __webpack_require__(234);
var ActionDetails_1 = __webpack_require__(25);
var pluginRegistry_1 = __webpack_require__(18);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var KubernetesRunScriptActionSummary = (function (_super) {
    __extends(KubernetesRunScriptActionSummary, _super);
    function KubernetesRunScriptActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesRunScriptActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Run a script within an environment configured using the Kubernetes target.");
    };
    return KubernetesRunScriptActionSummary;
}(BaseComponent_1.BaseComponent));
var KubernetesRunScriptActionEdit = (function (_super) {
    __extends(KubernetesRunScriptActionEdit, _super);
    function KubernetesRunScriptActionEdit(props) {
        return _super.call(this, props) || this;
    }
    KubernetesRunScriptActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 1:
                        _a.apply(this, [(_b.accounts = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    KubernetesRunScriptActionEdit.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(scriptAction_1.ScriptActionEdit, { busy: this.props.busy, plugin: this.props.plugin, projectId: this.props.projectId, localNames: this.props.localNames, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, getFieldError: this.props.getFieldError, supportedLanguages: ScriptingLanguageSelector_1.SupportedLanguage.PowerShellAndBash, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }));
    };
    return KubernetesRunScriptActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesRunScript",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesRunScriptActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: KubernetesRunScriptActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return true; },
    features: {
        optional: ["Octopus.Features.SubstituteInFiles", "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesRunScriptAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesRunScriptAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var pluginRegistry_1 = __webpack_require__(18);
var clientInstance_1 = __webpack_require__(10);
var DialogOpener_1 = __webpack_require__(110);
var containerDialog_1 = __webpack_require__(2104);
var Summary_1 = __webpack_require__(44);
var ExpandableFormSection_1 = __webpack_require__(30);
var VariableLookupText_1 = __webpack_require__(21);
var KeyValueEditList_1 = __webpack_require__(87);
var Button_1 = __webpack_require__(47);
var RemoveItemsList_1 = __webpack_require__(84);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var lodash_1 = __webpack_require__(11);
var ListTitle_1 = __webpack_require__(196);
var _ = __webpack_require__(11);
var jsonUtils_1 = __webpack_require__(106);
var packageAcquisitionLocation_1 = __webpack_require__(166);
var form_1 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var Note_1 = __webpack_require__(20);
var combinedVolumeDialog_1 = __webpack_require__(2106);
var DataTable_1 = __webpack_require__(306);
var styles = __webpack_require__(2107);
var ExternalLink_1 = __webpack_require__(26);
var isBound_1 = __webpack_require__(54);
var RadioButtonGroup_1 = __webpack_require__(36);
var ContainerList = (function (_super) {
    __extends(ContainerList, _super);
    function ContainerList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ContainerList;
}(RemoveItemsList_1.RemoveItemsList));
var KubernetesDeployContainersActionSummary = (function (_super) {
    __extends(KubernetesDeployContainersActionSummary, _super);
    function KubernetesDeployContainersActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployContainersActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy containers to Kubernetes, optionally exposed by a service and an ingress rule.");
    };
    return KubernetesDeployContainersActionSummary;
}(BaseComponent_1.BaseComponent));
var CombinedVolumeList = (function (_super) {
    __extends(CombinedVolumeList, _super);
    function CombinedVolumeList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CombinedVolumeList;
}(RemoveItemsList_1.RemoveItemsList));
var KubernetesDeployContainersActionEdit = (function (_super) {
    __extends(KubernetesDeployContainersActionEdit, _super);
    function KubernetesDeployContainersActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.newContainer = function () {
            var item = {
                IsNew: true,
                Ports: [],
                EnvironmentVariables: [],
                SecretEnvironmentVariables: [],
                ConfigMapEnvironmentVariables: [],
                VolumeMounts: [],
                Name: "",
                PackageId: "",
                FeedId: "",
                AcquisitionLocation: packageAcquisitionLocation_1.PackageAcquisitionLocation.NotAcquired,
                Properties: {},
                Command: [],
                Args: [],
                Resources: {
                    requests: {
                        memory: "",
                        cpu: "",
                    },
                    limits: {
                        memory: "",
                        cpu: ""
                    }
                },
                LivenessProbe: {
                    failureThreshold: "",
                    initialDelaySeconds: "",
                    periodSeconds: "",
                    successThreshold: "",
                    timeoutSeconds: "",
                    type: "",
                    exec: {
                        command: []
                    },
                    httpGet: {
                        host: "",
                        path: "",
                        port: "",
                        scheme: "",
                        httpHeaders: []
                    },
                    tcpSocket: {
                        host: "",
                        port: ""
                    }
                },
                ReadinessProbe: {
                    failureThreshold: "",
                    initialDelaySeconds: "",
                    periodSeconds: "",
                    successThreshold: "",
                    timeoutSeconds: "",
                    type: "",
                    exec: {
                        command: []
                    },
                    httpGet: {
                        host: "",
                        path: "",
                        port: "",
                        scheme: "",
                        httpHeaders: []
                    },
                    tcpSocket: {
                        host: "",
                        port: ""
                    }
                },
                SecurityContext: {
                    allowPrivilegeEscalation: "",
                    privileged: "",
                    readOnlyRootFilesystem: "",
                    runAsGroup: "",
                    runAsNonRoot: "",
                    runAsUser: "",
                    capabilities: {
                        add: [],
                        drop: []
                    },
                    seLinuxOptions: {
                        level: "",
                        role: "",
                        type: "",
                        user: ""
                    }
                }
            };
            return item;
        };
        _this.addContainerViaDialog = function () {
            var item = _this.newContainer();
            _this.setState({
                editContainer: item,
                editContainerIndex: null
            });
        };
        _this.editContainerViaDialog = function (item) {
            _this.setState({
                editContainer: lodash_1.clone(item),
                editContainerIndex: _this.state.containers.indexOf(item)
            });
        };
        _this.removeContainerViaDialog = function (item) {
            var packages = _this.props.packages.slice();
            packages.splice(packages.findIndex(function (pkg) { return pkg.Name === item.Name; }), 1);
            _this.props.setPackages(packages);
            var items = _this.state.containers.slice().filter(function (container) { return packages.findIndex(function (pkg) { return pkg.Name === container.Name; }) !== -1; });
            _this.saveContainersJson(items);
        };
        _this.resetContainers = function () {
            _this.setState({
                editContainer: null,
                editContainerIndex: null
            });
        };
        _this.saveContainer = function (item) {
            var packageReferences = _this.props.packages.slice();
            var items = _this.state.containers.slice();
            if (_this.state.editContainerIndex === null) {
                packageReferences.push(item);
                items.push(item);
            }
            else {
                packageReferences[_this.state.editContainerIndex] = item;
                items[_this.state.editContainerIndex] = item;
            }
            _this.props.setPackages(packageReferences);
            _this.saveContainersJson(items);
            _this.resetContainers();
            return true;
        };
        _this.containerListItem = function (pkg) {
            var feed = _this.state.feeds.find(function (f) { return f.Id === pkg.FeedId; });
            return React.createElement("div", null,
                React.createElement(ListTitle_1.default, null, pkg.Name),
                React.createElement("div", { className: styles.summaryText },
                    "Configuring the ",
                    React.createElement("strong", null, pkg.PackageId),
                    " ",
                    pkg.InitContainer === "True" && React.createElement("strong", null, "init"),
                    " container from feed ",
                    React.createElement("strong", null, feed != null ? feed.Name : pkg.FeedId)),
                _.get(pkg, "Resources.requests.memory") && React.createElement("div", { className: styles.summaryText },
                    "Requesting ",
                    React.createElement("strong", null, pkg.Resources.requests.memory),
                    " of memory",
                    pkg.Resources.limits.memory && React.createElement("span", null,
                        " with a limit of ",
                        React.createElement("strong", null, pkg.Resources.limits.memory))),
                !_.get(pkg, "Resources.requests.memory") && _.get(pkg, "Resources.limits.memory") && React.createElement("div", { className: styles.summaryText },
                    "Limited to ",
                    React.createElement("strong", null, pkg.Resources.limits.memory),
                    " of memory"),
                _.get(pkg, "Resources.requests.cpu") && React.createElement("div", { className: styles.summaryText },
                    "Requesting ",
                    React.createElement("strong", null, pkg.Resources.requests.cpu),
                    " of CPU",
                    pkg.Resources.limits.cpu && React.createElement("span", null,
                        " with a limit of ",
                        React.createElement("strong", null, pkg.Resources.limits.cpu))),
                !_.get(pkg, "Resources.requests.cpu") && _.get(pkg, "Resources.limits.cpu") && React.createElement("div", { className: styles.summaryText },
                    "Limited to ",
                    React.createElement("strong", null, pkg.Resources.limits.cpu),
                    " of CPU"),
                pkg.Ports && _.isArray(pkg.Ports) && pkg.Ports.length !== 0 && React.createElement("div", { className: styles.summarySection },
                    React.createElement("div", { className: styles.summarySectionKey }, "Ports"),
                    pkg.Ports.map(function (rule) {
                        return React.createElement("div", { className: styles.summarySectionValue },
                            rule.key && React.createElement("span", null,
                                rule.key,
                                ": "),
                            rule.value,
                            "/",
                            rule.option || "TCP");
                    })),
                pkg.EnvironmentVariables && _.isArray(pkg.EnvironmentVariables) && pkg.EnvironmentVariables.length !== 0 && React.createElement("div", { className: styles.summarySection },
                    React.createElement("div", { className: styles.summarySectionKey }, "Environment Variables"),
                    pkg.EnvironmentVariables.map(function (envVar) {
                        return React.createElement("div", { className: styles.summarySectionValue },
                            envVar.key,
                            " = \"",
                            envVar.value,
                            "\"");
                    })),
                pkg.SecretEnvironmentVariables && _.isArray(pkg.SecretEnvironmentVariables) && pkg.SecretEnvironmentVariables.length !== 0 && React.createElement("div", { className: styles.summarySection },
                    React.createElement("div", { className: styles.summarySectionKey }, "Secret Environment Variables"),
                    pkg.SecretEnvironmentVariables.map(function (envVar) {
                        return React.createElement("div", { className: styles.summarySectionValue },
                            envVar.key,
                            " = ",
                            envVar.value,
                            "/",
                            envVar.option);
                    })),
                pkg.ConfigMapEnvironmentVariables && _.isArray(pkg.ConfigMapEnvironmentVariables) && pkg.ConfigMapEnvironmentVariables.length !== 0 && React.createElement("div", { className: styles.summarySection },
                    React.createElement("div", { className: styles.summarySectionKey }, "ConfigMap Environment Variables"),
                    pkg.ConfigMapEnvironmentVariables.map(function (envVar) {
                        return React.createElement("div", { className: styles.summarySectionValue },
                            envVar.key,
                            " = ",
                            envVar.value,
                            "/",
                            envVar.option);
                    })),
                pkg.VolumeMounts && _.isArray(pkg.VolumeMounts) && pkg.VolumeMounts.length !== 0 && React.createElement("div", { className: styles.summarySection },
                    React.createElement("div", { className: styles.summarySectionKey }, "Volume Mounts"),
                    pkg.VolumeMounts.map(function (volMount) { return React.createElement("div", { className: styles.summaryTable },
                        React.createElement(DataTable_1.DataTable, null,
                            React.createElement(DataTable_1.DataTableBody, null,
                                React.createElement(DataTable_1.DataTableRow, null,
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableKey }, "Name"),
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableValue },
                                        volMount.key,
                                        " ")),
                                React.createElement(DataTable_1.DataTableRow, null,
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableKey }, "Path"),
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableValue }, volMount.value)),
                                volMount.option && React.createElement(DataTable_1.DataTableRow, null,
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableKey }, "SubPath"),
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableValue }, volMount.option)),
                                React.createElement(DataTable_1.DataTableRow, null,
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableKey }, "Read Only"),
                                    React.createElement(DataTable_1.DataTableRowColumn, { className: styles.summaryTableValue }, volMount.option === "True" ? "True" : "False"))))); })),
                pkg.ReadinessProbe && pkg.ReadinessProbe.type &&
                    React.createElement("div", { className: styles.summaryText },
                        "Performing a",
                        pkg.ReadinessProbe.type === containerDialog_1.CommandCheck && React.createElement("strong", null, " exec "),
                        pkg.ReadinessProbe.type === containerDialog_1.HttpGetCheck && React.createElement("strong", null, " HTTP "),
                        pkg.ReadinessProbe.type === containerDialog_1.TcpSocketCheck && React.createElement("strong", null, " TCP socket "),
                        "readiness probe check",
                        pkg.ReadinessProbe.initialDelaySeconds && React.createElement("span", null,
                            " after an initial delay of ",
                            React.createElement("strong", null, pkg.ReadinessProbe.initialDelaySeconds),
                            " seconds"),
                        pkg.ReadinessProbe.periodSeconds && React.createElement("span", null,
                            " every ",
                            React.createElement("strong", null, pkg.ReadinessProbe.periodSeconds),
                            " seconds"),
                        pkg.ReadinessProbe.timeoutSeconds && React.createElement("span", null,
                            " timing out after ",
                            React.createElement("strong", null, pkg.ReadinessProbe.timeoutSeconds),
                            " seconds"),
                        pkg.ReadinessProbe.failureThreshold && React.createElement("span", null,
                            " failing after ",
                            React.createElement("strong", null, pkg.ReadinessProbe.failureThreshold),
                            " consecutive errors")),
                pkg.LivenessProbe && pkg.LivenessProbe.type &&
                    React.createElement("div", { className: styles.summaryText },
                        "Performing a",
                        pkg.LivenessProbe.type === containerDialog_1.CommandCheck && React.createElement("strong", null, " exec "),
                        pkg.LivenessProbe.type === containerDialog_1.HttpGetCheck && React.createElement("strong", null, " HTTP "),
                        pkg.LivenessProbe.type === containerDialog_1.TcpSocketCheck && React.createElement("strong", null, " TCP socket "),
                        "liveness probe check",
                        pkg.LivenessProbe.initialDelaySeconds && React.createElement("span", null,
                            " after an initial delay of ",
                            React.createElement("strong", null, pkg.ReadinessProbe.initialDelaySeconds),
                            " seconds"),
                        pkg.LivenessProbe.periodSeconds && React.createElement("span", null,
                            " every ",
                            React.createElement("strong", null, pkg.LivenessProbe.periodSeconds),
                            " seconds"),
                        pkg.LivenessProbe.timeoutSeconds && React.createElement("span", null,
                            " timing out after ",
                            React.createElement("strong", null, pkg.LivenessProbe.timeoutSeconds),
                            " seconds"),
                        pkg.LivenessProbe.successThreshold && React.createElement("span", null,
                            " succeeding after ",
                            React.createElement("strong", null, pkg.LivenessProbe.failureThreshold),
                            " consecutive successes"),
                        pkg.LivenessProbe.failureThreshold && React.createElement("span", null,
                            " restarting after ",
                            React.createElement("strong", null, pkg.LivenessProbe.failureThreshold),
                            " consecutive errors")),
                pkg.Command && pkg.Command.filter(function (c) { return c && c.trim(); }).length !== 0 && React.createElement("div", { className: styles.summaryText },
                    "Overriding container command with ",
                    React.createElement("strong", null, pkg.Command.filter(function (c) { return c && c.trim(); }).join(" "))),
                pkg.Args && pkg.Args.filter(function (c) { return c && c.trim(); }).length !== 0 && React.createElement("div", { className: styles.summaryText },
                    "Passing the arguments ",
                    React.createElement("strong", null, pkg.Args.filter(function (c) { return c && c.trim(); }).join(" "))),
                pkg.SecurityContext &&
                    React.createElement("div", { className: styles.summaryText },
                        pkg.SecurityContext.allowPrivilegeEscalation &&
                            pkg.SecurityContext.allowPrivilegeEscalation.trim().toUpperCase() === "TRUE" &&
                            React.createElement("div", null,
                                "Privilege escalation ",
                                React.createElement("strong", null, "enabled")),
                        pkg.SecurityContext.privileged &&
                            pkg.SecurityContext.privileged.trim().toUpperCase() === "TRUE" &&
                            React.createElement("div", null,
                                "Privileged mode ",
                                React.createElement("strong", null, "enabled")),
                        pkg.SecurityContext.runAsNonRoot &&
                            pkg.SecurityContext.runAsNonRoot.trim().toUpperCase() === "TRUE" &&
                            React.createElement("div", null,
                                "Run as non-root ",
                                React.createElement("strong", null, "enabled")),
                        pkg.SecurityContext.readOnlyRootFilesystem &&
                            pkg.SecurityContext.readOnlyRootFilesystem.trim().toUpperCase() === "TRUE" &&
                            React.createElement("div", null,
                                "Read only root filesystem ",
                                React.createElement("strong", null, "enabled")),
                        pkg.SecurityContext.allowPrivilegeEscalation &&
                            isBound_1.default(pkg.SecurityContext.allowPrivilegeEscalation) &&
                            React.createElement("div", null,
                                "Privilege escalation set to ",
                                React.createElement("strong", null, pkg.SecurityContext.allowPrivilegeEscalation.trim())),
                        pkg.SecurityContext.privileged &&
                            isBound_1.default(pkg.SecurityContext.privileged) &&
                            React.createElement("div", null,
                                "Privileged mode set to ",
                                React.createElement("strong", null, pkg.SecurityContext.privileged.trim())),
                        pkg.SecurityContext.runAsNonRoot &&
                            isBound_1.default(pkg.SecurityContext.runAsNonRoot) &&
                            React.createElement("div", null,
                                "Run as non-root set to ",
                                React.createElement("strong", null, pkg.SecurityContext.runAsNonRoot.trim())),
                        pkg.SecurityContext.readOnlyRootFilesystem &&
                            isBound_1.default(pkg.SecurityContext.readOnlyRootFilesystem) &&
                            React.createElement("div", null,
                                "Read only root file system set to ",
                                React.createElement("strong", null, pkg.SecurityContext.readOnlyRootFilesystem.trim())),
                        pkg.SecurityContext.runAsUser &&
                            pkg.SecurityContext.runAsUser.trim() &&
                            React.createElement("div", null,
                                "Run as user ",
                                React.createElement("strong", null, pkg.SecurityContext.runAsUser.trim())),
                        pkg.SecurityContext.runAsGroup &&
                            pkg.SecurityContext.runAsGroup.trim() &&
                            React.createElement("div", null,
                                "Run as group ",
                                React.createElement("strong", null, pkg.SecurityContext.runAsGroup.trim())),
                        _.get(pkg, "SecurityContext.capabilities.add") &&
                            pkg.SecurityContext.capabilities.add.length !== 0 &&
                            React.createElement("div", null,
                                "Adding the capabilities ",
                                React.createElement("strong", null, pkg.SecurityContext.capabilities.add.join(", "))),
                        _.get(pkg, "SecurityContext.capabilities.drop") &&
                            pkg.SecurityContext.capabilities.drop.length !== 0 &&
                            React.createElement("div", null,
                                "Dropping the capabilities ",
                                React.createElement("strong", null, pkg.SecurityContext.capabilities.drop.join(", "))),
                        _.get(pkg, "SecurityContext.seLinuxOptions.level") &&
                            pkg.SecurityContext.seLinuxOptions.level.trim() &&
                            React.createElement("div", null,
                                "Setting the SELinux level to ",
                                React.createElement("strong", null, pkg.SecurityContext.seLinuxOptions.level.trim())),
                        _.get(pkg, "SecurityContext.seLinuxOptions.role") &&
                            pkg.SecurityContext.seLinuxOptions.role.trim() &&
                            React.createElement("div", null,
                                "Setting the SELinux role to ",
                                React.createElement("strong", null, pkg.SecurityContext.seLinuxOptions.role.trim())),
                        _.get(pkg, "SecurityContext.seLinuxOptions.type") &&
                            pkg.SecurityContext.seLinuxOptions.type.trim() &&
                            React.createElement("div", null,
                                "Setting the SELinux type to ",
                                React.createElement("strong", null, pkg.SecurityContext.seLinuxOptions.type.trim())),
                        _.get(pkg, "SecurityContext.seLinuxOptions.user") &&
                            pkg.SecurityContext.seLinuxOptions.user.trim() &&
                            React.createElement("div", null,
                                "Setting the SELinux user to ",
                                React.createElement("strong", null, pkg.SecurityContext.seLinuxOptions.user.trim()))));
        };
        _this.addCombinedVolume = function () {
            var item = {
                Items: [],
                Name: "",
                ReferenceName: "",
                ReferenceNameType: "Custom",
                EmptyDirMedium: "",
                HostPathType: "Directory",
                HostPathPath: "",
                LocalPath: "",
                Type: "ConfigMap",
                RawYaml: "",
                Repository: "",
                Revision: ""
            };
            _this.setState({
                editSecretVolume: item,
                editSecretVolumeIndex: null
            });
        };
        _this.editCombinedVolume = function (item) {
            _this.setState({
                editSecretVolume: lodash_1.clone(item),
                editSecretVolumeIndex: _this.state.combinedVolumes.indexOf(item)
            });
        };
        _this.removeCombinedVolume = function (item) {
            var volumes = _this.state.combinedVolumes.slice();
            volumes.splice(_this.state.combinedVolumes.indexOf(item), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.CombinedVolumes"] = JSON.stringify(volumes), _a));
            var _a;
        };
        _this.resetCombinedVolume = function () {
            _this.setState({
                editSecretVolume: null,
                editSecretVolumeIndex: null
            });
        };
        _this.saveCombinedVolume = function (item) {
            var volumes = _this.state.combinedVolumes.slice();
            if (_this.state.editSecretVolumeIndex === null) {
                volumes.push(item);
            }
            else {
                volumes[_this.state.editSecretVolumeIndex] = item;
            }
            _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.CombinedVolumes"] = JSON.stringify(volumes), _a));
            _this.resetCombinedVolume();
            return true;
            var _a;
        };
        _this.combinedVolumeListItem = function (volume) {
            return React.createElement("div", null,
                _this.configMapSummary(volume, false),
                _this.secretSummary(volume, false),
                _this.emptyDirSummary(volume, false),
                _this.hostPathSummary(volume, false),
                _this.persistentVOlumeClaimSummary(volume, false),
                _this.rawYamlSummary(volume, false));
        };
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            containers: _this.getContainerPackageDetails(_this.props.properties["Octopus.Action.KubernetesContainers.Containers"], _this.props.packages),
            editContainer: null,
            editContainerIndex: null,
            combinedVolumes: jsonUtils_1.JsonUtils.tryParseArray(_this.props.properties["Octopus.Action.KubernetesContainers.CombinedVolumes"], []),
            editSecretVolume: null,
            editSecretVolumeIndex: null
        };
        return _this;
    }
    KubernetesDeployContainersActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _f.sent();
                        // Default to one replica
                        if (!this.props.properties["Octopus.Action.KubernetesContainers.Replicas"]) {
                            this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.Replicas"] = "1", _a));
                        }
                        // Default to a Recreate
                        if (!this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"]) {
                            this.props.setProperties((_b = {}, _b["Octopus.Action.KubernetesContainers.DeploymentStyle"] = "Recreate", _b));
                        }
                        // Default to a Wait
                        if (!this.props.properties["Octopus.Action.KubernetesContainers.DeploymentWait"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.KubernetesContainers.DeploymentWait"] = "Wait", _c));
                        }
                        // This step never has unnamed packages
                        if (this.props.properties["Octopus.Action.Package.FeedId"] || this.props.properties["Octopus.Action.Package.PackageId"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Package.FeedId"] = "", _d));
                            this.props.setProperties((_e = {}, _e["Octopus.Action.Package.PackageId"] = "", _e));
                            this.props.setPackages(this.props.packages.filter(function (pkg) { return pkg.Name; }));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    KubernetesDeployContainersActionEdit.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.KubernetesContainers.Containers"] !==
            nextProps.properties["Octopus.Action.KubernetesContainers.Containers"] ||
            this.props.properties["Octopus.Action.KubernetesContainers.CombinedVolumes"] !==
                nextProps.properties["Octopus.Action.KubernetesContainers.CombinedVolumes"] ||
            this.props.properties["Octopus.Action.Package.FeedId"] !==
                nextProps.properties["Octopus.Action.Package.FeedId"] ||
            this.props.properties["Octopus.Action.Package.PackageId"] !==
                nextProps.properties["Octopus.Action.Package.PackageId"]) {
            this.setState({
                containers: this.getContainerPackageDetails(nextProps.properties["Octopus.Action.KubernetesContainers.Containers"], nextProps.packages),
                combinedVolumes: jsonUtils_1.JsonUtils.tryParseArray(nextProps.properties["Octopus.Action.KubernetesContainers.CombinedVolumes"], [])
            });
        }
    };
    KubernetesDeployContainersActionEdit.prototype.render = function () {
        var _this = this;
        var editContainerDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editContainer, onClose: this.resetContainers, wideDialog: true },
            React.createElement(containerDialog_1.default, { containerDetails: this.state.editContainer, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, onAdd: function (item) { return _this.saveContainer(item); }, feeds: this.state.feeds, volumes: this.state.combinedVolumes, refreshFeeds: this.loadFeeds }));
        var editSecretVolumeDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editSecretVolume, onClose: this.resetCombinedVolume, wideDialog: true, repositionOnUpdate: true },
            React.createElement(combinedVolumeDialog_1.default, { combinedVolumeDetails: this.state.editSecretVolume, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, featuresEnabled: this.props.properties["Octopus.Action.EnabledFeatures"], onAdd: function (item) { return _this.saveCombinedVolume(item); } }));
        return React.createElement("div", null,
            editContainerDialog,
            editSecretVolumeDialog,
            React.createElement(form_1.FormSectionHeading, { title: "Deployment" }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentName|" +
                    "Octopus.Action.KubernetesContainers.Replicas|" +
                    "Octopus.Action.KubernetesContainers.ProgressDeadlineSeconds|" +
                    "Octopus.Action.KubernetesContainers.DeploymentLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Deployment", summary: this.deploymentSummary(), help: "Enter the details for the deployment." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.DeploymentName"), label: "Deployment name" }),
                React.createElement(Note_1.default, null, "The name of the deployment must be unique, and is used by Kubernetes when updating an existing deployment."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#deployment-name" }, "deployment names"),
                    "."),
                React.createElement(Note_1.default, null,
                    "Blue/green deployment strategies create a new uniquely named deployment resource each time, and directs the service to the new pods. The Octopus deployment ID will be appended to the deployment name e.g. ",
                    React.createElement("code", null, "my-deployment"),
                    "will become\u00A0",
                    React.createElement("code", null, "my-deployment-deployments-981"),
                    "."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#bluegreen-deployment-strategy" }, "blue/green deployments"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.Replicas"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.Replicas"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.Replicas"), label: "Replicas", hintText: "1 (default)" }),
                React.createElement(Note_1.default, null, "The number of pod replicas to create from this deployment."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#replicas" }, "replicas"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.ProgressDeadlineSeconds"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.ProgressDeadlineSeconds"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.ProgressDeadlineSeconds"), label: "Progression deadline in seconds", hintText: "600 (default)" }),
                React.createElement(Note_1.default, null, "The maximum time for a deployment to make progress before it's considered to be failed. Blue/Green deployments will point the service to the new deployment only once the new deployments has succeeded."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#progression-deadline" }, "progression deadlines"),
                    "."),
                React.createElement("p", null,
                    React.createElement("strong", null, "Labels"),
                    React.createElement("br", null),
                    "Add labels to be applied to the deployment resource, pods managed by the deployment resource, the service and the ingress."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#add-label" }, "labels"),
                    "."),
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], name: "Label", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentStyle", isExpandedByDefault: this.props.expandedByDefault, title: "Deployment Strategy", summary: this.deploymentStyleSummary(), help: "Choose how the deployment will be updated." },
                React.createElement(form_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentStyle"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "Recreate", label: React.createElement("span", null,
                            React.createElement("strong", null, "Recreate deployments"),
                            "\u00A0delete existing pods before creating new pods") }),
                    React.createElement(Note_1.default, null, "Use this option when container versions can not be mixed. This strategy does result in downtime."),
                    React.createElement(Note_1.default, null,
                        "Learn more about the ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#recreate-deployment-strategy" }, "recreate strategy"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: "RollingUpdate", label: React.createElement("span", null,
                            React.createElement("strong", null, "Rolling update deployments"),
                            " deploys new pods while remove older pods") }),
                    React.createElement(Note_1.default, null, "This option requires that two container versions can run side by side, and avoids downtime."),
                    React.createElement(Note_1.default, null,
                        "Learn more about the ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#rolling-update-deployment-strategy" }, "rolling update strategy"),
                        "."),
                    React.createElement(RadioButton_1.default, { value: "BlueGreen", label: React.createElement("span", null,
                            React.createElement("strong", null, "Blue/Green deployments"),
                            " create a new deployment resource and points the service to new pods") }),
                    React.createElement(Note_1.default, null, "This strategy requires that two container versions can run side by side, and ensures that traffic is cut over to the new pods in a single operation with no downtime."),
                    React.createElement(Note_1.default, null,
                        "Learn more about the ",
                        React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#bluegreen-deployment-strategy" }, "blue/green strategy"),
                        "."),
                    this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "RollingUpdate" &&
                        React.createElement("div", null,
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.MaxUnavailable"], onChange: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.MaxUnavailable"] = x, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.MaxUnavailable"), label: "Max Unavailable" }),
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.MaxSurge"], onChange: function (x) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.MaxSurge"] = x, _a));
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.MaxSurge"), label: "Max Surge" })),
                    (this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "RollingUpdate" ||
                        this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "Recreate") &&
                        React.createElement("div", null,
                            React.createElement(form_1.StringRadioButtonGroup, { value: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentWait"], onChange: function (val) {
                                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentWait"] = val, _a));
                                    var _a;
                                } },
                                React.createElement(RadioButton_1.default, { value: "Wait", label: React.createElement("span", null, "Wait for the deployment to succeed") }),
                                React.createElement(RadioButton_1.default, { value: "NoWait", label: React.createElement("span", null, "Do not wait for the deployment to succeed") }))))),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Kubernetes.SecretVolumes", isExpandedByDefault: this.props.expandedByDefault, title: "Volumes", summary: this.volumeSummary(), help: "Add volumes to be exposed to the containers in this step." },
                React.createElement(Note_1.default, null,
                    "Volumes can reference externally managed storage devices, or can reference config map and secret resources managed by this step through the ",
                    React.createElement("strong", null, "ConfigMap"),
                    " and ",
                    React.createElement("strong", null, "Secret"),
                    " features."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#volumes" }, "volumes"),
                    "."),
                React.createElement(CombinedVolumeList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add Volume", onClick: function () { return _this.addCombinedVolume(); } })], data: this.state.combinedVolumes, onRow: this.combinedVolumeListItem, onRowTouch: function (item) { return _this.editCombinedVolume(item); }, onRemoveRow: function (item) { return _this.removeCombinedVolume(item); } })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.Containers", isExpandedByDefault: this.props.expandedByDefault, title: "Containers", summary: this.containersSummary(), help: "Add containers that make up the pod managed by this deployment" },
                React.createElement(ContainerList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add Container", onClick: function () { return _this.addContainerViaDialog(); } })], data: this.state.containers, onRow: this.containerListItem, onRowTouch: function (item) { return _this.editContainerViaDialog(item); }, onRemoveRow: function (item) { return _this.removeContainerViaDialog(item); } })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Kubernetes.PodSecurityFsGroup|" +
                    "Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup|" +
                    "Octopus.Action.KubernetesContainers.PodSecurityRunAsUser|" +
                    "Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot|" +
                    "Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups", isExpandedByDefault: this.props.expandedByDefault, title: "Pod Security Context", summary: this.podSecuritySummary(), help: "The security context to be applied to the pods." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityFsGroup"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecurityFsGroup"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecurityFsGroup"), label: "FSGroup" }),
                React.createElement(Note_1.default, null,
                    "A special supplemental group ID that applies to all containers in a pod. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContext" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"), label: "Run as group ID" }),
                React.createElement(Note_1.default, null,
                    "The group ID to run the entrypoint of the container process. Introduced in Kubernetes 1.10. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContext" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"), label: "Run as user ID" }),
                React.createElement(Note_1.default, null,
                    "The user ID to run the entrypoint of the container process. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContext" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"] = 
                        // get the items
                        x.split(",")
                            .map(function (y) { return y.trim(); })
                            .filter(function (y) { return y; })
                            .join(", ") +
                            // was the last char a comma and optional whitespace? If so, add it back on
                            ((/,\s*$/.exec(x) || [""])[0]), _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"), label: "Supplemental groups" }),
                React.createElement(Note_1.default, null,
                    "A comma separated list of group IDs applied to the first process run in each container, in addition to the container's primary group ID. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextSupplementalGroups" }, "More information"),
                    "."),
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"), label: "Run as non-root" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Enable run as non-root" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Do not enable run as non-root" })),
                React.createElement(Note_1.default, null,
                    "Require that containers run as a non-root user. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextRunAsNonRoot" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"), label: "SELinux level" }),
                React.createElement(Note_1.default, null,
                    "The SELinux level that applies to the container. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextSELinux" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"), label: "SELinux role" }),
                React.createElement(Note_1.default, null,
                    "The SELinux role that applies to the container. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextSELinux" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"), label: "SELinux type" }),
                React.createElement(Note_1.default, null,
                    "The SELinux type that applies to the container. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextSELinux" }, "More information"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"), label: "SELinux user" }),
                React.createElement(Note_1.default, null,
                    "The SELinux user that applies to the container. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecurityContextSELinux" }, "More information"),
                    "."),
                React.createElement(ExtendedKeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySysctls"], name: "Sysctl", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.PodSecuritySysctls"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId }),
                React.createElement(Note_1.default, null,
                    "The list of namespaced sysctls used for the pod. Introduced in Kubernetes 1.11. ",
                    React.createElement(ExternalLink_1.default, { href: "KubernetesSecuritySysctl" }, "More information"),
                    ".")),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentAnnotations", isExpandedByDefault: this.props.expandedByDefault, title: "Deployment Annotations", summary: this.deploymentAnnotationsSummary(), help: "Add annotations to configure the deployment resource." },
                React.createElement(ExtendedKeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentAnnotations"], name: "Annotation", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentAnnotations"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })));
    };
    /**
     * We only want to save the container specific information in the step property. Package details are saved
     * on a property on the step, and so we don't duplicate that information here.
     */
    KubernetesDeployContainersActionEdit.prototype.saveContainersJson = function (items) {
        var containerDetails = items.map(function (item) { return ({
            Name: item.Name,
            Ports: item.Ports,
            EnvironmentVariables: item.EnvironmentVariables,
            SecretEnvironmentVariables: item.SecretEnvironmentVariables,
            ConfigMapEnvironmentVariables: item.ConfigMapEnvironmentVariables,
            VolumeMounts: item.VolumeMounts,
            Resources: item.Resources,
            LivenessProbe: item.LivenessProbe,
            ReadinessProbe: item.ReadinessProbe,
            Command: item.Command,
            Args: item.Args,
            InitContainer: item.InitContainer,
            SecurityContext: item.SecurityContext
        }); });
        this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.Containers"] = JSON.stringify(containerDetails), _a));
        var _a;
    };
    KubernetesDeployContainersActionEdit.prototype.deploymentStyleSummary = function () {
        if (!this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"]) {
            return Summary_1.default.placeholder("The deployment strategy has not been defined");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Update the deployment with the",
            this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "RollingUpdate" &&
                React.createElement("span", null,
                    " ",
                    React.createElement("strong", null, "rolling deployment"),
                    " strategy",
                    this.props.properties["Octopus.Action.KubernetesContainers.MaxUnavailable"] &&
                        React.createElement("span", null,
                            " with a maximum of ",
                            React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.MaxUnavailable"]),
                            " unavailable",
                            this.props.properties["Octopus.Action.KubernetesContainers.MaxSurge"] && React.createElement("span", null, " and")),
                    this.props.properties["Octopus.Action.KubernetesContainers.MaxSurge"] &&
                        React.createElement("span", null,
                            " a maximum surge of ",
                            React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.MaxSurge"]))),
            this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "BlueGreen" &&
                React.createElement("span", null,
                    " ",
                    React.createElement("strong", null, "blue/green deployment"),
                    " strategy"),
            this.props.properties["Octopus.Action.KubernetesContainers.DeploymentStyle"] === "Recreate" &&
                React.createElement("span", null,
                    " ",
                    React.createElement("strong", null, "recreate deployment "),
                    " strategy")));
    };
    KubernetesDeployContainersActionEdit.prototype.deploymentSummary = function () {
        if (!(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentName"] ||
            this.props.properties["Octopus.Action.KubernetesContainers.Replicas"] ||
            this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"])) {
            return Summary_1.default.placeholder("No Kubernetes deployment resource has been defined");
        }
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], {}));
        return Summary_1.default.summary(React.createElement("span", null,
            React.createElement("span", null, "Create a deployment"),
            this.props.properties["Octopus.Action.KubernetesContainers.DeploymentName"] &&
                React.createElement("span", null,
                    " called ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.DeploymentName"])),
            this.props.properties["Octopus.Action.KubernetesContainers.Replicas"] &&
                React.createElement("span", null,
                    " with ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.Replicas"]),
                    " replicas"),
            labels.length !== 0 &&
                React.createElement("span", null,
                    " and the label",
                    labels.length > 1 && React.createElement("span", null, "s"),
                    " ",
                    _.chain(labels)
                        .flatMap(function (pair) { return [React.createElement("strong", null,
                            pair[0],
                            ": ",
                            pair[1]), React.createElement("span", null, ", ")]; })
                        .slice(0, -1)
                        .value())));
    };
    KubernetesDeployContainersActionEdit.prototype.getContainerPackageDetails = function (containers, packages) {
        var containerArray = jsonUtils_1.JsonUtils.tryParseArray(containers, []);
        return packages
            .map(function (packageReference) { return _.assign({ Id: null }, packageReference, containerArray.find(function (container) { return packageReference.Name === container.Name; })); });
    };
    KubernetesDeployContainersActionEdit.prototype.configMapSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.ConfigMapType) {
            return React.createElement("span", null,
                prefix && React.createElement("span", null, " the "),
                React.createElement("strong", null, volume.Type),
                volume.ReferenceNameType !== combinedVolumeDialog_1.LinkedResource &&
                    React.createElement("span", null,
                        " named ",
                        React.createElement("strong", null, volume.ReferenceName)),
                volume.ReferenceNameType === combinedVolumeDialog_1.LinkedResource &&
                    React.createElement("span", null, " defined in the feature below"),
                volume.Items && volume.Items.length !== 0 &&
                    React.createElement("span", null,
                        React.createElement("span", null, " with items: "),
                        _.chain(volume.Items)
                            .flatMap(function (item) { return [React.createElement("strong", null,
                                item.key,
                                " => ",
                                item.value), React.createElement("span", null, ", ")]; })
                            .slice(0, -1)
                            .value()));
        }
    };
    KubernetesDeployContainersActionEdit.prototype.secretSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.SecretType) {
            return React.createElement("span", null,
                prefix && React.createElement("span", null, " the "),
                React.createElement("strong", null, volume.Type),
                volume.ReferenceNameType !== combinedVolumeDialog_1.LinkedResource &&
                    React.createElement("span", null,
                        " named ",
                        React.createElement("strong", null, volume.ReferenceName)),
                volume.ReferenceNameType === combinedVolumeDialog_1.LinkedResource &&
                    React.createElement("span", null, " defined in the feature below"),
                volume.Items && volume.Items.length !== 0 &&
                    React.createElement("span", null,
                        React.createElement("span", null, " with items: "),
                        _.chain(volume.Items)
                            .flatMap(function (item) { return [React.createElement("strong", null,
                                item.key,
                                " => ",
                                item.value), React.createElement("span", null, ", ")]; })
                            .slice(0, -1)
                            .value()));
        }
    };
    KubernetesDeployContainersActionEdit.prototype.emptyDirSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.EmptyDirType) {
            return React.createElement("span", null,
                prefix && React.createElement("span", null, " an "),
                React.createElement("strong", null, "Empty Dir"),
                volume.EmptyDirMedium && React.createElement("span", null,
                    " using medium ",
                    React.createElement("strong", null, volume.EmptyDirMedium)));
        }
    };
    KubernetesDeployContainersActionEdit.prototype.hostPathSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.HostPathType) {
            return React.createElement("span", null,
                " a ",
                React.createElement("strong", null, "Host Path"),
                volume.HostPathType && React.createElement("span", null,
                    " of type ",
                    React.createElement("strong", null, volume.HostPathType)),
                volume.HostPathPath && React.createElement("span", null,
                    " from path ",
                    React.createElement("strong", null, volume.HostPathPath)));
        }
    };
    KubernetesDeployContainersActionEdit.prototype.persistentVOlumeClaimSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.PersistentVolumeClaimType) {
            return React.createElement("span", null,
                prefix && React.createElement("span", null, " the "),
                React.createElement("strong", null, "Persistent Volume Claim"),
                volume.ReferenceName && React.createElement("span", null,
                    " called ",
                    React.createElement("strong", null, volume.ReferenceName)));
        }
    };
    KubernetesDeployContainersActionEdit.prototype.rawYamlSummary = function (volume, prefix) {
        if (volume.Type === combinedVolumeDialog_1.RawYamlType) {
            return React.createElement("span", null,
                prefix && React.createElement("span", null, " the "),
                React.createElement("strong", null, "Raw YAML"),
                " definition");
        }
    };
    KubernetesDeployContainersActionEdit.prototype.volumeSummary = function () {
        var _this = this;
        if (this.state.combinedVolumes.length === 0) {
            return Summary_1.default.placeholder("No volumes have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            React.createElement("span", null, "Deploy "),
            React.createElement("span", null, _.chain(this.state.combinedVolumes)
                .flatMap(function (volume) { return [
                React.createElement("span", null,
                    "a volume called ",
                    React.createElement("strong", null, volume.Name),
                    " from",
                    _this.configMapSummary(volume, true),
                    _this.secretSummary(volume, true),
                    _this.emptyDirSummary(volume, true),
                    _this.hostPathSummary(volume, true),
                    _this.persistentVOlumeClaimSummary(volume, true),
                    _this.rawYamlSummary(volume, true)), React.createElement("span", null, "; ")
            ]; })
                .slice(0, -1)
                .value())));
    };
    KubernetesDeployContainersActionEdit.prototype.podSecuritySummary = function () {
        if (!this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityFsGroup"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySysctls"] &&
            !this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"]) {
            return Summary_1.default.default("No pod security settings configured.");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityFsGroup"] &&
                React.createElement("span", null,
                    "FSGroup set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityFsGroup"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"] &&
                React.createElement("span", null,
                    "Run as group set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsGroup"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"] &&
                React.createElement("span", null,
                    "Run as user set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsUser"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"] &&
                React.createElement("span", null,
                    "Run as non-root set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecurityRunAsNonRoot"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"] &&
                React.createElement("span", null,
                    "SELinux level set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxLevel"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"] &&
                React.createElement("span", null,
                    "SELinux role set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxRole"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"] &&
                React.createElement("span", null,
                    "SELinux type set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxType"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"] &&
                React.createElement("span", null,
                    "SELinux user set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySeLinuxUser"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"] &&
                React.createElement("span", null,
                    "Supplemental groups set to ",
                    React.createElement("strong", null, this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySupplementalGroups"]),
                    ". "),
            this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySysctls"] &&
                JSON.parse(this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySysctls"]).length !== 0 &&
                React.createElement("span", null,
                    "Sysctls set to ",
                    React.createElement("strong", null, _.chain(JSON.parse(this.props.properties["Octopus.Action.KubernetesContainers.PodSecuritySysctls"]))
                        .flatMap(function (item) { return [React.createElement("span", null,
                            item.key,
                            "=",
                            item.value), React.createElement("span", null, ", ")]; })
                        .slice(0, -1)
                        .value()),
                    ". ")));
    };
    KubernetesDeployContainersActionEdit.prototype.containersSummary = function () {
        if (this.state.containers.length === 0) {
            return Summary_1.default.placeholder("No containers have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            React.createElement("span", null, "Deploy "),
            React.createElement("span", null, _.chain(this.state.containers)
                .filter(function (c) { return c.InitContainer !== "True"; })
                .flatMap(function (container) { return [
                React.createElement("span", null,
                    "image ",
                    React.createElement("strong", null, container.PackageId),
                    container.Ports && container.Ports.length !== 0 &&
                        React.createElement("span", null,
                            " exposing port",
                            container.Ports.length > 1 && React.createElement("span", null, "s"),
                            ": ",
                            _.chain(container.Ports)
                                .flatMap(function (port) { return [React.createElement("strong", null,
                                    port.value,
                                    ":",
                                    port.option || "TCP"), React.createElement("span", null, ", ")]; })
                                .slice(0, -1)
                                .value())),
                React.createElement("span", null, "; ")
            ]; })
                .slice(0, -1)
                .value())));
    };
    KubernetesDeployContainersActionEdit.prototype.deploymentAnnotationsSummary = function () {
        var annotations = jsonUtils_1.JsonUtils.tryParseArray(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentAnnotations"], []);
        if (annotations.length === 0) {
            return Summary_1.default.placeholder("No annotations have been included");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the annotation",
            annotations.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(annotations)
                .flatMap(function (annotation) { return [React.createElement("strong", null,
                    annotation.key,
                    ": ",
                    annotation.value), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    return KubernetesDeployContainersActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesDeployContainers",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesDeployContainersActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: KubernetesDeployContainersActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return true; },
    features: {
        initial: [
            "Octopus.Features.KubernetesService",
            "Octopus.Features.KubernetesIngress",
            "Octopus.Features.KubernetesConfigMap",
            "Octopus.Features.KubernetesSecret"
        ],
        optional: [
            "Octopus.Features.KubernetesService",
            "Octopus.Features.KubernetesIngress",
            "Octopus.Features.KubernetesConfigMap",
            "Octopus.Features.KubernetesSecret",
            "Octopus.Features.KubernetesCustomResource"
        ]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesDeployContainersAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesDeployContainersAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var clientInstance_1 = __webpack_require__(10);
var PackageSelector_1 = __webpack_require__(53);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var feedResource_1 = __webpack_require__(73);
var _ = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var ExpandableFormSection_1 = __webpack_require__(30);
var Summary_1 = __webpack_require__(44);
var Select_1 = __webpack_require__(40);
var ExternalLink_1 = __webpack_require__(26);
var form_1 = __webpack_require__(16);
var Fragment_1 = __webpack_require__(92);
var isBound_1 = __webpack_require__(54);
var kubernetesValidation_1 = __webpack_require__(301);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var posixCapabilitiesSuggestions_1 = __webpack_require__(2105);
exports.CommandCheck = "Command";
exports.HttpGetCheck = "HttpGet";
exports.TcpSocketCheck = "TcpSocket";
var ContainerDialog = (function (_super) {
    __extends(ContainerDialog, _super);
    function ContainerDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            var valid = true;
            var binding = _this.state.containerDetails;
            if (!binding.Name || (!isBound_1.default(binding.Name) && !kubernetesValidation_1.KubernetesNameRegex.exec(binding.Name))) {
                _this.setError("The container name must consist of lower case alphanumeric characters or '-', and must start and end with an alphanumeric character.", [], { ContainerDetailsName: "The container name must consist of lower case alphanumeric characters or '-', and must start and end with an alphanumeric character." });
                valid = false;
            }
            if (!binding.PackageId) {
                _this.setError("A package ID must be selected from the feed.", [], { ContainerDetailsPackage: "A package ID must be selected from the feed." });
                valid = false;
            }
            binding.ConfigMapEnvironmentVariables.forEach(function (p) {
                p.keyError = p.key && p.key.trim()
                    ? null
                    : "The environment variable needs a name.";
                p.valueError = p.value && p.value.trim()
                    ? null
                    : "The ConfigMap name must be defined when referenced as an environment variable.";
                p.optionError = p.option && p.option.trim()
                    ? null
                    : "The ConfigMap key must be defined when referenced as an environment variable.";
            });
            if (binding.ConfigMapEnvironmentVariables.find(function (p) { return !!p.valueError || !!p.keyError || !!p.optionError; })) {
                _this.setError("The ConfigMap environment variables are incorrectly configured.");
                valid = false;
            }
            binding.SecretEnvironmentVariables.forEach(function (p) {
                p.keyError = p.key && p.key.trim()
                    ? null
                    : "The environment variable needs a name.";
                p.valueError = p.value && p.value.trim()
                    ? null
                    : "The secret name must be defined when referenced as an environment variable.";
                p.optionError = p.option && p.option.trim()
                    ? null
                    : "The secret key must be defined when referenced as an environment variable.";
            });
            if (binding.SecretEnvironmentVariables.find(function (p) { return !!p.valueError || !!p.keyError || !!p.optionError; })) {
                _this.setError("The secret environment variables are incorrectly configured.");
                valid = false;
            }
            binding.EnvironmentVariables.forEach(function (p) {
                p.keyError = p.key && p.key.trim()
                    ? null
                    : "The environment variable needs a name.";
            });
            if (binding.EnvironmentVariables.find(function (p) { return !!p.valueError || !!p.keyError || !!p.optionError; })) {
                _this.setError("The environment variables are incorrectly configured.");
                valid = false;
            }
            binding.Ports.forEach(function (p) {
                p.valueError = (isBound_1.default(p.value) || (kubernetesValidation_1.NumberRegex.exec(p.value) && parseInt(p.value, 10) >= 1 && parseInt(p.value, 10) <= 65535))
                    ? null
                    : "Port numbers must be between 1 and 65535.";
            });
            if (binding.Ports.find(function (p) { return !!p.valueError; })) {
                _this.setError("The ports are incorrectly configured.");
                valid = false;
            }
            if (binding.Resources.requests.memory &&
                !isBound_1.default(binding.Resources.requests.memory) &&
                !kubernetesValidation_1.KubernetesResourceQuantityRegex.exec(binding.Resources.requests.memory)) {
                _this.setError("Container memory resource requests must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. 129M, 123Mi, 1G, 1Gi.", [], {
                    ContainerDetailsResourcesMemoryRequest: "Container memory resource requests must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. 129M, 123Mi, 1G, 1Gi."
                });
                valid = false;
            }
            if (binding.Resources.requests.cpu &&
                !isBound_1.default(binding.Resources.requests.cpu) &&
                !kubernetesValidation_1.KubernetesResourceQuantityRegex.exec(binding.Resources.requests.cpu)) {
                _this.setError("Container cpu resource requests must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. e.g. 200m, 0.1.", [], {
                    ContainerDetailsResourcesMemoryRequest: "Container cpu resource requests must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. e.g. 200m, 0.1."
                });
                valid = false;
            }
            if (binding.Resources.limits.memory &&
                !isBound_1.default(binding.Resources.limits.memory) &&
                !kubernetesValidation_1.KubernetesResourceQuantityRegex.exec(binding.Resources.limits.memory)) {
                _this.setError("Container memory resource limits must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. 129M, 123Mi, 1G, 1Gi.", [], {
                    ContainerDetailsResourcesMemoryRequest: "Container memory resource limits must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. 129M, 123Mi, 1G, 1Gi."
                });
                valid = false;
            }
            if (binding.Resources.limits.cpu &&
                !isBound_1.default(binding.Resources.limits.cpu) &&
                !kubernetesValidation_1.KubernetesResourceQuantityRegex.exec(binding.Resources.limits.cpu)) {
                _this.setError("Container cpu resource limits must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. e.g. 200m, 0.1.", [], {
                    ContainerDetailsResourcesMemoryRequest: "Container cpu resource limits must match the regular expression '^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$', e.g. e.g. 200m, 0.1."
                });
                valid = false;
            }
            if (!isBound_1.default(binding.LivenessProbe.periodSeconds) &&
                binding.LivenessProbe.periodSeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.periodSeconds)) {
                _this.setError("The period must be a whole number.", [], { ContainerLivenessProbePeriodSeconds: "The period must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.LivenessProbe.initialDelaySeconds) &&
                binding.LivenessProbe.initialDelaySeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.initialDelaySeconds)) {
                _this.setError("The initial delay must be a whole number.", [], { ContainerLivenessProbeInitialDelaySeconds: "The initial delay must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.LivenessProbe.successThreshold) &&
                binding.LivenessProbe.successThreshold &&
                !kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.successThreshold)) {
                _this.setError("The success threshold must be a whole number.", [], { ContainerLivenessProbeSuccessThreshold: "The success threshold must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.LivenessProbe.timeoutSeconds) &&
                binding.LivenessProbe.timeoutSeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.timeoutSeconds)) {
                _this.setError("The timeout must be a whole number.", [], { ContainerLivenessProbeTimeoutSeconds: "The timeout must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.LivenessProbe.failureThreshold) &&
                binding.LivenessProbe.failureThreshold &&
                !kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.failureThreshold)) {
                _this.setError("The failure threshold must be a whole number.", [], { ContainerLivenessProbeFailureThreshold: "The failure threshold must be a whole number." });
                valid = false;
            }
            if ((binding.LivenessProbe.failureThreshold ||
                binding.LivenessProbe.timeoutSeconds ||
                binding.LivenessProbe.initialDelaySeconds ||
                binding.LivenessProbe.periodSeconds) &&
                !(binding.LivenessProbe.type && binding.LivenessProbe.type.trim())) {
                _this.setError("The liveness check type must be specified, or all liveness fields must be cleared.", [], { ContainerLivenessProbeType: "The liveness check type must be specified." });
                valid = false;
            }
            if (binding.LivenessProbe.type === exports.CommandCheck) {
                if (!binding.LivenessProbe.exec.command || binding.LivenessProbe.exec.command.filter(function (c) { return c && c.trim(); }).length === 0) {
                    _this.setError("The command must be specified.", [], { ContainerLivenessProbeExecCommand: "The command must be specified." });
                    valid = false;
                }
            }
            if (binding.LivenessProbe.type === exports.HttpGetCheck) {
                if (!binding.LivenessProbe.httpGet.port || !binding.LivenessProbe.httpGet.port.trim()) {
                    _this.setError("The HTTP port must be specified.", [], { ContainerLivenessProbeHttpGetPort: "The HTTP port must be specified." });
                    valid = false;
                }
                else if (!isBound_1.default(binding.LivenessProbe.httpGet.port) &&
                    (kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.httpGet.port) &&
                        !(parseInt(binding.LivenessProbe.httpGet.port, 10) >= 1 &&
                            parseInt(binding.LivenessProbe.httpGet.port, 10) <= 65535))) {
                    _this.setError("The HTTP port must be a number between 1 and 65535.", [], { ContainerLivenessProbeHttpGetPort: "The HTTP port must be a number between 1 and 65535." });
                    valid = false;
                }
                if (!binding.LivenessProbe.httpGet.path || !binding.LivenessProbe.httpGet.path.trim()) {
                    _this.setError("The HTTP path must be specified.", [], { ContainerLivenessHttpGetPath: "The HTTP path must be specified." });
                    valid = false;
                }
            }
            if (binding.LivenessProbe.type === exports.TcpSocketCheck) {
                if (!binding.LivenessProbe.tcpSocket.port || !binding.LivenessProbe.tcpSocket.port.trim()) {
                    _this.setError("The TCP socket port must be specified.", [], { ContainerLivenessProbeTcpSocketPort: "The HTTP port must be specified." });
                    valid = false;
                }
                else if (!isBound_1.default(binding.LivenessProbe.tcpSocket.port) &&
                    (kubernetesValidation_1.NumberRegex.exec(binding.LivenessProbe.tcpSocket.port) &&
                        !(parseInt(binding.LivenessProbe.tcpSocket.port, 10) >= 1 &&
                            parseInt(binding.LivenessProbe.tcpSocket.port, 10) <= 65535))) {
                    _this.setError("The HTTP port must be a number between 1 and 65535.", [], { ContainerLivenessProbeTcpSocketPort: "The HTTP port must be a number between 1 and 65535." });
                    valid = false;
                }
            }
            if (!isBound_1.default(binding.ReadinessProbe.periodSeconds) &&
                binding.ReadinessProbe.periodSeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.periodSeconds)) {
                _this.setError("The period must be a whole number.", [], { ContainerReadinessProbePeriodSeconds: "The period must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.ReadinessProbe.initialDelaySeconds) &&
                binding.ReadinessProbe.initialDelaySeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.initialDelaySeconds)) {
                _this.setError("The initial delay must be a whole number.", [], { ContainerReadinessProbeInitialDelaySeconds: "The initial delay must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.ReadinessProbe.successThreshold) &&
                binding.ReadinessProbe.successThreshold &&
                !kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.successThreshold)) {
                _this.setError("The success threshold must be a whole number.", [], { ContainerReadinessProbeSuccessThreshold: "The success threshold must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.ReadinessProbe.timeoutSeconds) &&
                binding.ReadinessProbe.timeoutSeconds &&
                !kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.timeoutSeconds)) {
                _this.setError("The timeout must be a whole number.", [], { ContainerReadinessProbeTimeoutSeconds: "The timeout must be a whole number." });
                valid = false;
            }
            if (!isBound_1.default(binding.ReadinessProbe.failureThreshold) &&
                binding.ReadinessProbe.failureThreshold &&
                !kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.failureThreshold)) {
                _this.setError("The failure threshold must be a whole number.", [], { ContainerReadinessProbeFailureThreshold: "The failure threshold must be a whole number." });
                valid = false;
            }
            if ((binding.ReadinessProbe.failureThreshold ||
                binding.ReadinessProbe.timeoutSeconds ||
                binding.ReadinessProbe.initialDelaySeconds ||
                binding.ReadinessProbe.periodSeconds) &&
                !(binding.ReadinessProbe.type && binding.ReadinessProbe.type.trim())) {
                _this.setError("The readiness check type must be specified.", [], { ContainerReadinessProbeType: "The readiness check type must be specified, or all readiness fields must be cleared." });
                valid = false;
            }
            if (binding.ReadinessProbe.type === exports.CommandCheck) {
                if (!binding.ReadinessProbe.exec.command || binding.ReadinessProbe.exec.command.filter(function (c) { return c && c.trim(); }).length === 0) {
                    _this.setError("The command must be specified.", [], { ContainerReadinessProbeExecCommand: "The command must be specified." });
                    valid = false;
                }
            }
            if (binding.ReadinessProbe.type === exports.HttpGetCheck) {
                if (!binding.ReadinessProbe.httpGet.port || !binding.ReadinessProbe.httpGet.port.trim()) {
                    _this.setError("The HTTP port must be specified.", [], { ContainerReadinessHttpGetPort: "The HTTP port must be specified." });
                    valid = false;
                }
                else if (!isBound_1.default(binding.ReadinessProbe.httpGet.port) &&
                    (kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.httpGet.port) &&
                        !(parseInt(binding.ReadinessProbe.httpGet.port, 10) >= 1 &&
                            parseInt(binding.ReadinessProbe.httpGet.port, 10) <= 65535))) {
                    _this.setError("The HTTP port must be a number between 1 and 65535.", [], { ContainerReadinessHttpGetPort: "The HTTP port must be a number between 1 and 65535." });
                    valid = false;
                }
                if (!binding.ReadinessProbe.httpGet.path || !binding.ReadinessProbe.httpGet.path.trim()) {
                    _this.setError("The HTTP path must be specified.", [], { ContainerReadinessHttpGetPath: "The HTTP path must be specified." });
                    valid = false;
                }
            }
            if (binding.ReadinessProbe.type === exports.TcpSocketCheck) {
                if (!binding.ReadinessProbe.tcpSocket.port || !binding.ReadinessProbe.tcpSocket.port.trim()) {
                    _this.setError("The TCP socket port must be specified.", [], { ContainerReadinessProbeTcpSocketPort: "The HTTP port must be specified." });
                    valid = false;
                }
                else if (!isBound_1.default(binding.ReadinessProbe.tcpSocket.port) &&
                    (kubernetesValidation_1.NumberRegex.exec(binding.ReadinessProbe.tcpSocket.port) &&
                        !(parseInt(binding.ReadinessProbe.tcpSocket.port, 10) >= 1 &&
                            parseInt(binding.ReadinessProbe.tcpSocket.port, 10) <= 65535))) {
                    _this.setError("The HTTP port must be a number between 1 and 65535.", [], { ContainerReadinessProbeTcpSocketPort: "The HTTP port must be a number between 1 and 65535." });
                    valid = false;
                }
            }
            binding.VolumeMounts.forEach(function (v) {
                v.keyError = v.key
                    ? null
                    : "Volumes require a name.";
                v.valueError = v.value && v.value.indexOf(":") === -1
                    ? null
                    : "Volumes must define a mount path, and the path must not contain \":\"";
            });
            if (binding.VolumeMounts.find(function (p) { return !!p.valueError || !!p.keyError; })) {
                _this.setError("The volume mounts are incorrectly configured.");
                valid = false;
            }
            if (binding.Ports.find(function (p) { return !!p.valueError; })) {
                _this.setError("Port numbers must be between 1 and 65535.", [], { ContainerDetailsPorts: "Port numbers must be between 1 and 65535." });
                valid = false;
            }
            if (!isBound_1.default(binding.SecurityContext.allowPrivilegeEscalation) &&
                binding.SecurityContext.allowPrivilegeEscalation &&
                !kubernetesValidation_1.BooleanRegex.exec(binding.SecurityContext.allowPrivilegeEscalation.trim())) {
                _this.setError("The allow privilege escalation value must be True or False.", [], { ContainerDetailsSecurityContextAllowPrivilegeEscalation: "The allow privilege escalation value must be True or False."
                });
                valid = false;
            }
            if (!isBound_1.default(binding.SecurityContext.privileged) &&
                binding.SecurityContext.privileged &&
                !kubernetesValidation_1.BooleanRegex.exec(binding.SecurityContext.privileged.trim())) {
                _this.setError("The privileged value must be True or False.", [], { ContainerDetailsSecurityContextPrivileged: "The privileged value must be True or False."
                });
                valid = false;
            }
            if (!isBound_1.default(binding.SecurityContext.runAsNonRoot) &&
                binding.SecurityContext.runAsNonRoot &&
                !kubernetesValidation_1.BooleanRegex.exec(binding.SecurityContext.runAsNonRoot.trim())) {
                _this.setError("The run as non-root value must be True or False.", [], { ContainerDetailsSecurityContextRunAsNonRoot: "The run as non-root value must be True or False."
                });
                valid = false;
            }
            if (!isBound_1.default(binding.SecurityContext.runAsUser) &&
                binding.SecurityContext.runAsUser &&
                !kubernetesValidation_1.NumberRegex.exec(binding.SecurityContext.runAsUser.trim())) {
                _this.setError("The run as user value must be a number.", [], { ContainerDetailsSecurityContextRunAsUser: "The run as user value must be a number."
                });
                valid = false;
            }
            if (!isBound_1.default(binding.SecurityContext.runAsGroup) &&
                binding.SecurityContext.runAsGroup &&
                !kubernetesValidation_1.NumberRegex.exec(binding.SecurityContext.runAsGroup.trim())) {
                _this.setError("The run as group value must be a number.", [], { ContainerDetailsSecurityContextRunAsGroup: "The run as group value must be a number."
                });
                valid = false;
            }
            if (valid) {
                return _this.props.onAdd(binding);
            }
            return false;
        };
        _this.getVolumeOptions = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(this.props.volumes)
                    .filter(function (v) { return !!v && !!v.Name; })
                    .filter(function (v) { return v.Name.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f.Name, Name: f.Name }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        _this.getCapabilities = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(posixCapabilitiesSuggestions_1.PosixCapabilities)
                    .filter(function (v) { return !!v; })
                    .filter(function (v) { return v.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f, Name: f }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        _this.state = {
            containerDetails: null,
            project: null
        };
        return _this;
    }
    ContainerDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            containerDetails: this.props.containerDetails,
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ContainerDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Container" }, this.state.containerDetails && React.createElement(Fragment_1.Fragment, null,
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Image Details", errorKey: "ContainerDetailsName", summary: !!this.state.containerDetails.Name
                    ? Summary_1.default.summary(this.state.containerDetails.Name)
                    : Summary_1.default.placeholder("Please provide a image details for the container image"), help: "Provide a name and a package image for the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(form_1.Text, { label: "Name", value: this.state.containerDetails.Name, error: this.getFieldError("ContainerDetailsName"), onChange: function (Name) { return _this.setContainerState({ Name: Name }); } }),
                React.createElement("p", null,
                    React.createElement("strong", null, "Package Image")),
                React.createElement(PackageSelector_1.default, { packageId: this.state.containerDetails.PackageId, feedId: this.state.containerDetails.FeedId, onPackageIdChange: function (PackageId) { return _this.setContainerState({ PackageId: PackageId }); }, onFeedIdChange: function (FeedId) { return _this.setContainerState({ FeedId: FeedId }); }, projectId: this.props.projectId, feeds: this.props.feeds, feedType: [feedResource_1.FeedType.Docker, feedResource_1.FeedType.AwsElasticContainerRegistry], localNames: this.props.localNames, refreshFeeds: this.props.refreshFeeds })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Ports", errorKey: "ContainerDetailsPorts", summary: this.kubernetesPortSummary(), help: "Add ports to be referenced by the target node in the associated service.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement("p", null,
                    "Containers expose network services through their ports. Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#ports" }, "ports"),
                    "."),
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.containerDetails.Ports) ? _this.state.containerDetails.Ports : []; }, name: "Port", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ Ports: val }); }, valueLabel: "Port", keyLabel: "Name", optionLabel: "Protocol", optionValues: [{ text: "TCP", value: "TCP" }, { text: "UDP", value: "UDP" }], optionReset: "TCP", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Volume Mounts", errorKey: "ContainerDetailsVolumeMounts", summary: this.kubernetesVolumeSummary(), help: "Include volume mount points to be exposed on the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement("p", null,
                    "Volumes that were exposed to the containers are mounted to the container filesystem here. Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#volume-mounts" }, "volume mounts"),
                    "."),
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.containerDetails.VolumeMounts) ? _this.state.containerDetails.VolumeMounts : []; }, name: "Volume Mount", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ VolumeMounts: val }); }, keyLabel: "Name", getOptions: this.getVolumeOptions, valueLabel: "Mount path", optionLabel: "Sub path", option2Label: "Read only", option2Values: [{ text: "True", value: "true" }, { text: "False", value: "false" }], option2Reset: "false", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Container Type", errorKey: "ContainerDetailsType", summary: this.initContainerSummary(), help: "Select the type of container to be defined.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: this.state.containerDetails.InitContainer || "False", onChange: function (InitContainer) { return _this.setContainerState({ InitContainer: InitContainer }); }, label: "Container Type" },
                    React.createElement(RadioButton_1.default, { value: "False", label: "Regular container" }),
                    React.createElement(RadioButton_1.default, { value: "True", label: "Init container" })),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#container-type" }, "container types"),
                    ".")),
            React.createElement(form_1.FormSectionHeading, { title: "Resources" }),
            React.createElement("p", null,
                "The CPU and memory resources required by the container are defined as resource requests and limits. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#resources" }, "resource requests and limits"),
                "."),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "CPU Request", errorKey: "ContainerDetailsResourcesCpuRequest", summary: this.kubernetesCpuRequestSummary(), help: "Specify the minimum amount of CPU resources that's always available to the container. ", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "Resources.requests.cpu"), onChange: function (x) { return _this.setContainerResourcesRequestState({ cpu: x }); }, label: "CPU request" }),
                React.createElement(Note_1.default, null, "If left blank, the CPU request will be set to the same value as the CPU limit. If the CPU limit is not set it will use the default value specified in the Kubernetes namespace.")),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "CPU Limit", errorKey: "ContainerDetailsResourcesCpuLimit", summary: this.kubernetesCpuLimitSummary(), help: "Set the maximum amount of CPU resources the container can use.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "Resources.limits.cpu"), onChange: function (x) { return _this.setContainerResourcesLimitState({ cpu: x }); }, label: "CPU limit" }),
                React.createElement(Note_1.default, null, "If the CPU limit is not set it will use the default value specified in the Kubernetes namespace.")),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Memory Request", errorKey: "ContainerDetailsResourcesMemoryRequest", summary: this.kubernetesMemoryRequestSummary(), help: "Specify the minimum amount of memory to always be available to the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "Resources.requests.memory"), onChange: function (x) { return _this.setContainerResourcesRequestState({ memory: x }); }, label: "Memory request" }),
                React.createElement(Note_1.default, null, "If left blank, the memory request will be set to the same value as the memory limit. If the memory limit is not set it will use the default value specified in the Kubernetes namespace.")),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Memory Limit", errorKey: "ContainerDetailsResourcesMemoryLimit", summary: this.kubernetesMemoryLimitSummary(), help: "Set the maximum amount of memory that this container can use.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "Resources.limits.memory"), onChange: function (x) { return _this.setContainerResourcesLimitState({ memory: x }); }, label: "Memory limit" }),
                React.createElement(Note_1.default, null, "If this value is not set it will use the default value specified in the Kubernetes namespace.")),
            React.createElement(form_1.FormSectionHeading, { title: "Environment Variables" }),
            React.createElement("p", null,
                "Environment variables can be defined in the container from key/value pairs, or from data held in secret or config map resources. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#environment-variables" }, "environment variables"),
                "."),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Environment Variable", errorKey: "ContainerDetailsEnvironmentVariablesEnvironmentVariable", summary: this.kubernetesEnvironmentVarsSummary(), help: "Define environment variables for the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.containerDetails.EnvironmentVariables) ? _this.state.containerDetails.EnvironmentVariables : []; }, name: "Environment Variable", onChange: function (val) { return _this.setContainerState({ EnvironmentVariables: val }); }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "ConfigMap Environment Variable", errorKey: "ContainerDetailsEnvironmentVariablesConfigMapEnvironmentVariable", summary: this.kubernetesConfigMapEnvironmentVarsSummary(), help: "Define environment variables, sourced from a ConfigMap, for the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.containerDetails.ConfigMapEnvironmentVariables) ? _this.state.containerDetails.ConfigMapEnvironmentVariables : []; }, name: "ConfigMap Environment Variable", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ ConfigMapEnvironmentVariables: val }); }, valueLabel: "ConfigMap name", keyLabel: "Name", optionLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Secret Environment Variable", errorKey: "ContainerDetailsEnvironmentVariablesSecretEnvironmentVariable", summary: this.kubernetesSecretEnvironmentVarsSummary(), help: "Define environment variables, sourced from a secret, for the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.containerDetails.SecretEnvironmentVariables) ? _this.state.containerDetails.SecretEnvironmentVariables : []; }, name: "Secret Environment Variable", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ SecretEnvironmentVariables: val }); }, valueLabel: "Secret name", keyLabel: "Name", optionLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(form_1.FormSectionHeading, { title: "Liveness Probe" }),
            React.createElement("p", null,
                "Liveness probes are used to confirm that a container is still running and healthy. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#liveness-probe" }, "liveness probes"),
                "."),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Failure Threshold", errorKey: "ContainerDetailsLivenessFailureThreshold", summary: !!_.get(this.state.containerDetails, "LivenessProbe.failureThreshold")
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Pod is restarted after ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.failureThreshold),
                        this.state.containerDetails.LivenessProbe.failureThreshold === "1" ? React.createElement("span", null, " failure") : React.createElement("span", null, " consecutive failures")))
                    : Summary_1.default.placeholder("No failure threshold specified"), help: "Set how many times the probe can fail after the pod has been started.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeFailureThreshold"), value: _.get(this.state.containerDetails, "LivenessProbe.failureThreshold"), onChange: function (x) { return _this.setContainerLivenessState({ failureThreshold: x }); }, label: "Failure threshold", hintText: "3 (default)" }),
                React.createElement(Note_1.default, null, "After this many consecutive failures, the pod is restarted.")),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Timeout", errorKey: "ContainerDetailsLivenessTimeoutSeconds", summary: !!_.get(this.state.containerDetails, "LivenessProbe.timeoutSeconds")
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Probe will wait ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.timeoutSeconds),
                        " second",
                        this.state.containerDetails.LivenessProbe.timeoutSeconds !== "1" && React.createElement("span", null, "s"),
                        " for a response"))
                    : Summary_1.default.placeholder("No timeout specified"), help: "Specify the number of seconds to wait for a probe response.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeTimeoutSeconds"), value: _.get(this.state.containerDetails, "LivenessProbe.timeoutSeconds"), onChange: function (x) { return _this.setContainerLivenessState({ timeoutSeconds: x }); }, label: "Timeout in seconds", hintText: "1 (default)" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Initial Delay", errorKey: "ContainerDetailsLivenessInitialDelaySeconds", summary: !!_.get(this.state.containerDetails, "LivenessProbe.initialDelaySeconds")
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Probe will wait ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.initialDelaySeconds),
                        " second",
                        this.state.containerDetails.LivenessProbe.initialDelaySeconds !== "1" && React.createElement("span", null, "s"),
                        " before being initiated"))
                    : Summary_1.default.placeholder("No initial delay specified"), help: "Set the number of seconds to wait before the probe is initiated.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeInitialDelaySeconds"), value: _.get(this.state.containerDetails, "LivenessProbe.initialDelaySeconds"), onChange: function (x) { return _this.setContainerLivenessState({ initialDelaySeconds: x }); }, label: "Initial delay in seconds" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Period", errorKey: "ContainerDetailsLivenessPeriodSeconds", summary: !!_.get(this.state.containerDetails, "LivenessProbe.periodSeconds")
                    ? Summary_1.default.summary(React.createElement("span", null,
                        "Probe will be run every ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.periodSeconds),
                        " second",
                        this.state.containerDetails.LivenessProbe.periodSeconds !== "1" && React.createElement("span", null, "s")))
                    : Summary_1.default.placeholder("No period specified"), help: "How frequently should the probe be executed.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbePeriodSeconds"), value: _.get(this.state.containerDetails, "LivenessProbe.periodSeconds"), onChange: function (x) { return _this.setContainerLivenessState({ periodSeconds: x }); }, label: "Period in seconds", hintText: "10 (default)" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Liveness Probe Type", errorKey: "ContainerDetailsLivenessType", summary: this.kubernetesLivenessProbeTypeSummary(), help: "Select the liveness probe type.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(Select_1.default, { error: this.getFieldError("ContainerLivenessProbeType"), value: _.get(this.state.containerDetails, "LivenessProbe.type"), items: [
                        { text: "", value: "" },
                        { text: "Command", value: exports.CommandCheck },
                        { text: "Http", value: exports.HttpGetCheck },
                        { text: "TCP Socket", value: exports.TcpSocketCheck }
                    ], label: "Liveness probe type", onChange: function (type) { return _this.setContainerLivenessState({ type: type }); } }),
                _.get(this.state.containerDetails, "LivenessProbe.type") === exports.CommandCheck && React.createElement(Fragment_1.Fragment, null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeExecCommand"), value: (_.get(this.state.containerDetails, "LivenessProbe.exec.command") || []).join("\n"), onChange: function (x) { return _this.setContainerLivenessCommandsState({ command: (x || "").split("\n") }); }, label: "Health check commands", multiLine: true, rows: 5, rowsMax: 5 }),
                    React.createElement(Note_1.default, null, "These commands are run in the container, and if the return value is zero, the container is considered to be healthy.")),
                _.get(this.state.containerDetails, "LivenessProbe.type") === exports.HttpGetCheck && React.createElement(Fragment_1.Fragment, null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeHttpGetHost"), value: _.get(this.state.containerDetails, "LivenessProbe.httpGet.host"), onChange: function (x) { return _this.setContainerLivenessHttpGetState({ host: x }); }, label: "Host" }),
                    React.createElement(Note_1.default, null, "The optional host name to connect to. If not defined, this value will default to the IP address of the pod."),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeHttpGetPath"), value: _.get(this.state.containerDetails, "LivenessProbe.httpGet.path"), onChange: function (x) { return _this.setContainerLivenessHttpGetState({ path: x }); }, label: "Path" }),
                    React.createElement(Note_1.default, null, "The path to access on the HTTP server."),
                    React.createElement(Select_1.BoundSelect, { error: this.getFieldError("ContainerLivenessProbeHttpGetScheme"), value: _.get(this.state.containerDetails, "LivenessProbe.httpGet.scheme"), onChange: function (x) { return _this.setContainerLivenessHttpGetState({ scheme: x }); }, label: "Scheme", items: [{ value: "HTTP", text: "HTTP" }, { value: "HTTPS", text: "HTTPS" }], resetValue: "HTTP" }),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeHttpGetPort"), value: _.get(this.state.containerDetails, "LivenessProbe.httpGet.port"), onChange: function (x) { return _this.setContainerLivenessHttpGetState({ port: x }); }, label: "Port" }),
                    React.createElement(Note_1.default, null,
                        "The port number to use when connecting to the HTTP server. Alternatively this value can be an ",
                        React.createElement(ExternalLink_1.default, { href: "IANA" }, "IANA"),
                        " port name."),
                    React.createElement("p", null,
                        React.createElement("strong", null, "HTTP Header")),
                    React.createElement("p", null, "Add HTTP headers to be sent with the request."),
                    React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_.get(_this.state.containerDetails, "LivenessProbe.httpGet.httpHeaders"))
                            ? _.get(_this.state.containerDetails, "LivenessProbe.httpGet.httpHeaders")
                            : []; }, name: "HTTP Header", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerLivenessHttpGetState({ httpHeaders: val }); }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
                _.get(this.state.containerDetails, "LivenessProbe.type") === exports.TcpSocketCheck && React.createElement(Fragment_1.Fragment, null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeTcpSocketHost"), value: _.get(this.state.containerDetails, "LivenessProbe.tcpSocket.host"), onChange: function (x) { return _this.setContainerLivenessSocketState({ host: x }); }, label: "Host" }),
                    React.createElement(Note_1.default, null, "The optional host name to connect to. If not defined, this value will default to the IP address of the pod."),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerLivenessProbeTcpSocketPort"), value: _.get(this.state.containerDetails, "LivenessProbe.tcpSocket.port"), onChange: function (x) { return _this.setContainerLivenessSocketState({ port: x }); }, label: "Port" }),
                    React.createElement(Note_1.default, null,
                        "The port number to use when connecting to the container. Alternatively this value can be an ",
                        React.createElement(ExternalLink_1.default, { href: "IANA" }, "IANA"),
                        " port name."))),
            this.state.containerDetails.InitContainer !== "True" && React.createElement(Fragment_1.Fragment, null,
                React.createElement(form_1.FormSectionHeading, { title: "Readiness probe" }),
                React.createElement("p", null,
                    "Readiness probes are used to confirm that a container has started. Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#readiness-probe" }, "readiness probes"),
                    "."),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Success threshold", errorKey: "ContainerDetailsReadinessSuccessThreshold", summary: !!_.get(this.state.containerDetails, "ReadinessProbe.successThreshold")
                        ? Summary_1.default.summary(React.createElement("span", null,
                            "Container is considered ready after ",
                            React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.successThreshold),
                            this.state.containerDetails.ReadinessProbe.successThreshold === "1" ? React.createElement("span", null, " successes") : React.createElement("span", null, " consecutive successes")))
                        : Summary_1.default.placeholder("No success threshold specified"), help: "Specify how many consecutive times the probe must succeed for the container to be considered ready after a failure.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeSuccessThreshold"), value: _.get(this.state.containerDetails, "ReadinessProbe.successThreshold"), onChange: function (x) { return _this.setContainerReadinessState({ successThreshold: x }); }, label: "Success threshold", hintText: "1 (default)" })),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Failure threshold", errorKey: "ContainerDetailsReadinessFailureThreshold", summary: !!_.get(this.state.containerDetails, "ReadinessProbe.failureThreshold")
                        ? Summary_1.default.summary(React.createElement("span", null,
                            "Pod is marked unready after ",
                            React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.failureThreshold),
                            this.state.containerDetails.ReadinessProbe.failureThreshold === "1" ? React.createElement("span", null, " failure") : React.createElement("span", null, " consecutive failures")))
                        : Summary_1.default.placeholder("No failure threshold specified"), help: "Set how many times the probe can fail after the pod has been started.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeFailureThreshold"), value: _.get(this.state.containerDetails, "ReadinessProbe.failureThreshold"), onChange: function (x) { return _this.setContainerReadinessState({ failureThreshold: x }); }, label: "Failure threshold", hintText: "3 (default)" }),
                    React.createElement(Note_1.default, null, "After this many failures, the pod will restart.")),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Timeout", errorKey: "ContainerDetailsReadinessTimeoutSeconds", summary: !!_.get(this.state.containerDetails, "ReadinessProbe.timeoutSeconds")
                        ? Summary_1.default.summary(React.createElement("span", null,
                            "Probe will wait ",
                            React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.timeoutSeconds),
                            " second",
                            this.state.containerDetails.ReadinessProbe.timeoutSeconds !== "1" && React.createElement("span", null, "s"),
                            " for a response"))
                        : Summary_1.default.placeholder("No timeout specified"), help: "Specify the number of seconds to wait for a probe response.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeTimeoutSeconds"), value: _.get(this.state.containerDetails, "ReadinessProbe.timeoutSeconds"), onChange: function (x) { return _this.setContainerReadinessState({ timeoutSeconds: x }); }, label: "Timeout in seconds", hintText: "1 (default)" })),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Initial Delay", errorKey: "ContainerDetailsReadiness", summary: !!_.get(this.state.containerDetails, "ReadinessProbe.initialDelaySeconds")
                        ? Summary_1.default.summary(React.createElement("span", null,
                            "Probe will wait ",
                            React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.initialDelaySeconds),
                            " second",
                            this.state.containerDetails.ReadinessProbe.initialDelaySeconds !== "1" && React.createElement("span", null, "s"),
                            " before being initiated"))
                        : Summary_1.default.placeholder("No initial delay specified"), help: "Specify the number of seconds to wait before the probe is initiated.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeInitialDelaySeconds"), value: _.get(this.state.containerDetails, "ReadinessProbe.initialDelaySeconds"), onChange: function (x) { return _this.setContainerReadinessState({ initialDelaySeconds: x }); }, label: "Initial delay in seconds" })),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Period", errorKey: "ContainerDetailsReadinessPeriodSeconds", summary: !!_.get(this.state.containerDetails, "ReadinessProbe.periodSeconds")
                        ? Summary_1.default.summary(React.createElement("span", null,
                            "Probe will be run every ",
                            React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.periodSeconds),
                            " second",
                            this.state.containerDetails.ReadinessProbe.periodSeconds !== "1" && React.createElement("span", null, "s")))
                        : Summary_1.default.placeholder("No period specified"), help: "Specify how frequently the probe is executed.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbePeriodSeconds"), value: _.get(this.state.containerDetails, "ReadinessProbe.periodSeconds"), onChange: function (x) { return _this.setContainerReadinessState({ periodSeconds: x }); }, label: "Period in seconds", hintText: "10 (default)" })),
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Readiness Probe Type", errorKey: "ContainerDetailsReadinessType", summary: this.kubernetesReadinessProbeTypeSummary(), help: "Select the readiness probe type.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(Select_1.default, { error: this.getFieldError("ContainerReadinessProbeType"), value: _.get(this.state.containerDetails, "ReadinessProbe.type"), items: [
                            { text: "", value: "" },
                            { text: "Command", value: exports.CommandCheck },
                            { text: "Http", value: exports.HttpGetCheck },
                            { text: "TCP Socket", value: exports.TcpSocketCheck }
                        ], label: "Readiness probe type", onChange: function (type) { return _this.setContainerReadinessState({ type: type }); } }),
                    _.get(this.state.containerDetails, "ReadinessProbe.type") === exports.CommandCheck && React.createElement(Fragment_1.Fragment, null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeExecCommand"), value: (_.get(this.state.containerDetails, "ReadinessProbe.exec.command") || []).join("\n"), onChange: function (x) { return _this.setContainerReadinessCommandsState({ command: (x || "").split("\n") }); }, label: "Health check commands", multiLine: true, rows: 5, rowsMax: 5 }),
                        React.createElement(Note_1.default, null, "These commands are run in the container, and if the return value is zero, the container is considered to be healthy.")),
                    _.get(this.state.containerDetails, "ReadinessProbe.type") === exports.HttpGetCheck && React.createElement(Fragment_1.Fragment, null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeHttpGetHost"), value: _.get(this.state.containerDetails, "ReadinessProbe.httpGet.host"), onChange: function (x) { return _this.setContainerReadinessHttpGetState({ host: x }); }, label: "Host" }),
                        React.createElement(Note_1.default, null, "The optional host name to connect to. If not defined, this value will default to the IP address of the pod."),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeHttpGetPath"), value: _.get(this.state.containerDetails, "ReadinessProbe.httpGet.path"), onChange: function (x) { return _this.setContainerReadinessHttpGetState({ path: x }); }, label: "Path" }),
                        React.createElement(Note_1.default, null, "The path to access on the HTTP server."),
                        React.createElement(Select_1.BoundSelect, { error: this.getFieldError("ContainerReadinessProbeHttpGetScheme"), value: _.get(this.state.containerDetails, "ReadinessProbe.httpGet.scheme"), onChange: function (x) { return _this.setContainerReadinessHttpGetState({ scheme: x }); }, label: "Scheme", items: [{ value: "HTTP", text: "HTTP" }, { value: "HTTPS", text: "HTTPS" }], resetValue: "HTTP" }),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeHttpGetPort"), value: _.get(this.state.containerDetails, "ReadinessProbe.httpGet.port"), onChange: function (x) { return _this.setContainerReadinessHttpGetState({ port: x }); }, label: "Port" }),
                        React.createElement(Note_1.default, null,
                            "The port number to use when connecting to the HTTP server. Alternatively this value can be an ",
                            React.createElement(ExternalLink_1.default, { href: "IANA" }, "IANA"),
                            " port name."),
                        React.createElement("p", null,
                            React.createElement("strong", null, "HTTP Header")),
                        React.createElement("p", null, "Add HTTP headers to be sent with the request."),
                        React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_.get(_this.state.containerDetails, "ReadinessProbe.httpGet.httpHeaders"))
                                ? _.get(_this.state.containerDetails, "ReadinessProbe.httpGet.httpHeaders")
                                : []; }, name: "HTTP Header", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerReadinessHttpGetState({ httpHeaders: val }); }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
                    _.get(this.state.containerDetails, "ReadinessProbe.type") === exports.TcpSocketCheck && React.createElement(Fragment_1.Fragment, null,
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeTcpSocketHost"), value: _.get(this.state.containerDetails, "ReadinessProbe.tcpSocket.host"), onChange: function (x) { return _this.setContainerReadinessSocketState({ host: x }); }, label: "Host" }),
                        React.createElement(Note_1.default, null, "The optional host name to connect to. If not defined, this value will default to the IP address of the pod."),
                        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("ContainerReadinessProbeTcpSocketPort"), value: _.get(this.state.containerDetails, "ReadinessProbe.tcpSocket.port"), onChange: function (x) { return _this.setContainerReadinessSocketState({ port: x }); }, label: "Port" }),
                        React.createElement(Note_1.default, null,
                            "The port number to use when connecting to the container. Alternatively this value can be an ",
                            React.createElement(ExternalLink_1.default, { href: "IANA" }, "IANA"),
                            " port name.")))),
            React.createElement(form_1.FormSectionHeading, { title: "Command" }),
            React.createElement("p", null,
                "The command used to launch the container, or the arguments passed to the command, can be defined or overwritten here. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#command" }, "commands"),
                "."),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Command", errorKey: "ContainerDetailsCommand", summary: this.kubernetesCommandSummary(), help: "Enter the command to run when launching the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: (_.isArray(this.state.containerDetails.Command) ? this.state.containerDetails.Command : []).join("\n"), onChange: function (x) { return _this.setContainerState({ Command: (x || "").split("\n") }); }, rows: 5, rowsMax: 5, multiLine: true, label: "Command" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: false, title: "Command arguments", errorKey: "ContainerDetailsCommandArgs", summary: this.kubernetesCommandArgumentsSummary(), help: "Enter command arguments.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: (_.isArray(this.state.containerDetails.Args) ? this.state.containerDetails.Args : []).join("\n"), onChange: function (x) { return _this.setContainerState({ Args: (x || "").split("\n") }); }, label: "Command arguments", multiLine: true, rows: 5, rowsMax: 5 })),
            React.createElement(form_1.FormSectionHeading, { title: "Security Context" }),
            React.createElement("p", null,
                "The security context defines privilege and access control settings for a container. Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#security-contexts" }, "security contexts"),
                "."),
            (_.get(this.state.containerDetails, "SecurityContext.privileged") || "False").toString().toUpperCase().trim() !== "TRUE" &&
                React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Privilege escalation", errorKey: "ContainerDetailsSecurityContextAllowPrivilegeEscalation", error: this.getFieldError("ContainerDetailsSecurityContextAllowPrivilegeEscalation"), summary: this.kubernetesSecurityContextAllowPrivilegeEscalationSummary(), help: "Allow a container to gain more privileges than its parent.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                    React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: _.get(this.state.containerDetails, "SecurityContext.allowPrivilegeEscalation") || "False", onChange: function (x) { return _this.setContainerSecurityContextState({ allowPrivilegeEscalation: x }); }, label: "Privilege escalation" },
                        React.createElement(RadioButton_1.default, { value: "True", label: "Allow privilege escalation" }),
                        React.createElement(RadioButton_1.default, { value: "False", label: "Do not allow privilege escalation" }))),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Privileged mode", errorKey: "ContainerDetailsSecurityContextPrivileged", error: this.getFieldError("ContainerDetailsSecurityContextPrivileged"), summary: this.kubernetesSecurityContextPrivilegedSummary(), help: "Run container in privileged mode.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: _.get(this.state.containerDetails, "SecurityContext.privileged") || "False", onChange: function (x) {
                        _this.setContainerSecurityContextState({ privileged: x });
                        /*
                         privileged implies allowPrivilegeEscalation, and if privileged
                         is true you can not set allowPrivilegeEscalation to anything other than true.
                         So if we are setting privileged to true, clear out the allowPrivilegeEscalation
                         setting.
                        */
                        if (x.toUpperCase().trim() === "TRUE") {
                            _this.setContainerSecurityContextState({ allowPrivilegeEscalation: "" });
                        }
                    }, label: "Privileged mode" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Enable privileged mode" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Do not enable privileged mode" }))),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Read only root file system", errorKey: "ContainerDetailsSecurityContextReadOnlyRootFilesystem", error: this.getFieldError("ContainerDetailsSecurityContextReadOnlyRootFilesystem"), summary: this.kubernetesSecurityContextReadOnlyRootFilesystemSummary(), help: "Require that containers run with a read-only root filesystem.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: _.get(this.state.containerDetails, "SecurityContext.readOnlyRootFilesystem") || "False", onChange: function (x) { return _this.setContainerSecurityContextState({ readOnlyRootFilesystem: x }); }, label: "Read only root file system" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Enable read only root file system" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Do not enable read only root file system" }))),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Run as non-root", errorKey: "ContainerDetailsSecurityContextRunAsNonRoot", error: this.getFieldError("ContainerDetailsSecurityContextRunAsNonRoot"), summary: this.kubernetesSecurityContextRunAsNonRootSummary(), help: "Require that containers run as a non-root user.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(RadioButtonGroup_1.BoundStringRadioButtonGroup, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", value: _.get(this.state.containerDetails, "SecurityContext.runAsNonRoot") || "False", onChange: function (x) { return _this.setContainerSecurityContextState({ runAsNonRoot: x }); }, label: "Run as non-root" },
                    React.createElement(RadioButton_1.default, { value: "True", label: "Enable run as non-root" }),
                    React.createElement(RadioButton_1.default, { value: "False", label: "Do not enable run as non-root" }))),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Run as user", errorKey: "ContainerDetailsSecurityContextRunAsUser", error: this.getFieldError("ContainerDetailsSecurityContextRunAsUser"), summary: this.kubernetesSecurityContextRunAsUserSummary(), help: "The UID to run the entrypoint of the container process.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.runAsUser") || "", onChange: function (x) { return _this.setContainerSecurityContextState({ runAsUser: x }); }, error: this.getFieldError("ContainerDetailsSecurityContextRunAsUser"), label: "Run as user ID" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "Run as group", errorKey: "ContainerDetailsSecurityContextRunAsGroup", error: this.getFieldError("ContainerDetailsSecurityContextRunAsGroup"), summary: this.kubernetesSecurityContextRunAsGroupSummary(), help: "The GID to run the entrypoint of the container process. Introduced in Kubernetes 1.10.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.runAsGroup") || "", onChange: function (x) { return _this.setContainerSecurityContextState({ runAsGroup: x }); }, error: this.getFieldError("ContainerDetailsSecurityContextRunAsGroup"), label: "Run as group ID" })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "POSIX capabilities", errorKey: "ContainerDetailsSecurityContextCapabilities", error: this.getFieldError("ContainerDetailsSecurityContextCapabilities"), summary: this.kubernetesSecurityContextCapabilitiesSummary(), help: "POSIX capabilities to add or drop from the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () {
                        return (_.get(_this.state.containerDetails, "SecurityContext.capabilities.add") || [])
                            .map(function (y) {
                            return {
                                key: y,
                                value: null,
                                option: null,
                                option2: null
                            };
                        });
                    }, name: "Added POSIX Capability", verb: "Define", onChange: function (x) {
                        _this.setContainerSecurityContextCapabilitiesState({
                            add: x.map(function (y) { return y.key.trim(); }).filter(function (y) { return y; })
                        });
                    }, keyLabel: "Capability", getOptions: this.getCapabilities, hideBindOnKey: false, projectId: this.props.projectId, addToTop: true }),
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () {
                        return (_.get(_this.state.containerDetails, "SecurityContext.capabilities.drop") || [])
                            .map(function (y) {
                            return {
                                key: y,
                                value: null,
                                option: null,
                                option2: null
                            };
                        });
                    }, name: "Dropped POSIX Capability", verb: "Define", onChange: function (x) {
                        _this.setContainerSecurityContextCapabilitiesState({
                            drop: x.map(function (y) { return y.key.trim(); }).filter(function (y) { return y; })
                        });
                    }, keyLabel: "Capability", getOptions: this.getCapabilities, hideBindOnKey: false, projectId: this.props.projectId, addToTop: true })),
            React.createElement(ExpandableFormSection_1.default, { isExpandedByDefault: this.state.containerDetails.IsNew, title: "SELinux options", errorKey: "ContainerDetailsSecurityContextSELinuxOptions", error: this.getFieldError("ContainerDetailsSecurityContextSELinuxOptions"), summary: this.kubernetesSecurityContextSELinuxOptionsSummary(), help: "The SELinux context to be applied to the container.", fillCardWidth: ExpandableFormSection_1.CardFill.FillAll, forceMobileBehaviour: true },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.seLinuxOptions.level"), onChange: function (level) { return _this.setContainerSecurityContextSELinuxOptionsState({ level: level }); }, label: "SELinux level" }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.seLinuxOptions.role"), onChange: function (role) { return _this.setContainerSecurityContextSELinuxOptionsState({ role: role }); }, label: "SELinux role" }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.seLinuxOptions.type"), onChange: function (type) { return _this.setContainerSecurityContextSELinuxOptionsState({ type: type }); }, label: "SELinux type" }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: _.get(this.state.containerDetails, "SecurityContext.seLinuxOptions.user"), onChange: function (user) { return _this.setContainerSecurityContextSELinuxOptionsState({ user: user }); }, label: "SELinux user" }))));
    };
    ContainerDialog.prototype.setContainerState = function (state, callback) {
        this.repositionDialog();
        this.setChildState1("containerDetails", state, callback);
    };
    ContainerDialog.prototype.setContainerResourcesLimitState = function (state, callback) {
        this.repositionDialog();
        this.configureResources();
        this.setChildState3("containerDetails", "Resources", "limits", state, callback);
    };
    ContainerDialog.prototype.setContainerResourcesRequestState = function (state, callback) {
        this.repositionDialog();
        this.configureResources();
        this.setChildState3("containerDetails", "Resources", "requests", state, callback);
    };
    ContainerDialog.prototype.setContainerLivenessState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState2("containerDetails", "LivenessProbe", state, callback);
    };
    ContainerDialog.prototype.setContainerLivenessCommandsState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "LivenessProbe", "exec", state, callback);
    };
    ContainerDialog.prototype.setContainerLivenessHttpGetState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "LivenessProbe", "httpGet", state, callback);
    };
    ContainerDialog.prototype.setContainerLivenessSocketState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "LivenessProbe", "tcpSocket", state, callback);
    };
    ContainerDialog.prototype.setContainerReadinessState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState2("containerDetails", "ReadinessProbe", state, callback);
    };
    ContainerDialog.prototype.setContainerReadinessCommandsState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "ReadinessProbe", "exec", state, callback);
    };
    ContainerDialog.prototype.setContainerReadinessHttpGetState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "ReadinessProbe", "httpGet", state, callback);
    };
    ContainerDialog.prototype.setContainerReadinessSocketState = function (state, callback) {
        this.repositionDialog();
        this.configureLivenessProbe();
        this.setChildState3("containerDetails", "ReadinessProbe", "tcpSocket", state, callback);
    };
    ContainerDialog.prototype.setContainerSecurityContextState = function (state, callback) {
        this.repositionDialog();
        this.configureSecurityContext();
        this.setChildState2("containerDetails", "SecurityContext", state, callback);
    };
    ContainerDialog.prototype.setContainerSecurityContextSELinuxOptionsState = function (state, callback) {
        this.repositionDialog();
        this.configureSecurityContext();
        this.setChildState3("containerDetails", "SecurityContext", "seLinuxOptions", state, callback);
    };
    ContainerDialog.prototype.setContainerSecurityContextCapabilitiesState = function (state, callback) {
        this.repositionDialog();
        this.configureSecurityContext();
        this.setChildState3("containerDetails", "SecurityContext", "capabilities", state, callback);
    };
    /**
     * A safety check in case the container details did not initialise the LivenessProbe property
     */
    ContainerDialog.prototype.configureLivenessProbe = function () {
        if (!this.state.containerDetails.LivenessProbe) {
            this.setChildState1("containerDetails", {
                LivenessProbe: {
                    failureThreshold: "",
                    initialDelaySeconds: "",
                    periodSeconds: "",
                    successThreshold: "",
                    timeoutSeconds: "",
                    type: "",
                    exec: {
                        command: []
                    },
                    httpGet: {
                        host: "",
                        path: "",
                        port: "",
                        scheme: "",
                        httpHeaders: []
                    },
                    tcpSocket: {
                        host: "",
                        port: ""
                    }
                },
                ReadinessProbe: {
                    failureThreshold: "",
                    initialDelaySeconds: "",
                    periodSeconds: "",
                    successThreshold: "",
                    timeoutSeconds: "",
                    type: "",
                    exec: {
                        command: []
                    },
                    httpGet: {
                        host: "",
                        path: "",
                        port: "",
                        scheme: "",
                        httpHeaders: []
                    },
                    tcpSocket: {
                        host: "",
                        port: ""
                    }
                }
            });
        }
    };
    /**
     * A safety check in case the container details did not initialise the Resources property
     */
    ContainerDialog.prototype.configureResources = function () {
        if (!this.state.containerDetails.Resources) {
            this.setChildState1("containerDetails", {
                Resources: {
                    requests: {
                        memory: "",
                        cpu: "",
                    },
                    limits: {
                        memory: "",
                        cpu: ""
                    }
                }
            });
        }
    };
    /**
     * A safety check in case the container details did not initialise the SecurityContext property
     */
    ContainerDialog.prototype.configureSecurityContext = function () {
        if (!this.state.containerDetails.SecurityContext) {
            this.setChildState1("containerDetails", {
                SecurityContext: {
                    allowPrivilegeEscalation: "",
                    privileged: "",
                    readOnlyRootFilesystem: "",
                    runAsGroup: "",
                    runAsNonRoot: "",
                    runAsUser: "",
                    capabilities: {
                        add: [],
                        drop: []
                    },
                    seLinuxOptions: {
                        level: "",
                        role: "",
                        user: "",
                        type: ""
                    }
                }
            });
        }
        if (!this.state.containerDetails.SecurityContext.capabilities) {
            this.setChildState2("containerDetails", "SecurityContext", {
                capabilities: {
                    add: [],
                    drop: []
                }
            });
        }
        if (!this.state.containerDetails.SecurityContext.seLinuxOptions) {
            this.setChildState2("containerDetails", "SecurityContext", {
                seLinuxOptions: {
                    level: "",
                    role: "",
                    user: "",
                    type: ""
                }
            });
        }
    };
    /**
     * https://github.com/mui-org/material-ui/issues/1676
     * https://github.com/mui-org/material-ui/issues/5793
     * When adding or removing items from a list, the dialog needs to be repositioned, otherwise
     * the list may disappear off the screen. A resize event is the commonly suggested workaround.
     */
    ContainerDialog.prototype.repositionDialog = function () {
        window.dispatchEvent(new Event("resize"));
    };
    ContainerDialog.prototype.initContainerSummary = function () {
        if (this.state.containerDetails.InitContainer === "True") {
            return Summary_1.default.summary("Configure an init container");
        }
        return Summary_1.default.summary("Configure a regular container");
    };
    ContainerDialog.prototype.kubernetesPortSummary = function () {
        if (this.state.containerDetails.Ports && _.isArray(this.state.containerDetails.Ports) && this.state.containerDetails.Ports.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null, _.chain(this.state.containerDetails.Ports)
                .flatMap(function (rule) { return [
                React.createElement("span", null,
                    "Exposing port ",
                    React.createElement("strong", null, rule.value),
                    "/",
                    React.createElement("strong", null, rule.option || "TCP"),
                    rule.key && React.createElement("span", null,
                        " called ",
                        React.createElement("strong", null, rule.key))),
                React.createElement("br", null)
            ]; })
                .slice(0, -1)
                .value()));
        }
        return Summary_1.default.placeholder("No exposed container ports included");
    };
    ContainerDialog.prototype.kubernetesCpuRequestSummary = function () {
        if (this.state.containerDetails.Resources.requests.cpu && this.state.containerDetails.Resources.requests.cpu.trim()) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Requesting ",
                React.createElement("strong", null, this.state.containerDetails.Resources.requests.cpu),
                " of CPU resources"));
        }
        return Summary_1.default.placeholder("No required CPU resources specified");
    };
    ContainerDialog.prototype.kubernetesMemoryRequestSummary = function () {
        if (this.state.containerDetails.Resources.requests.memory && this.state.containerDetails.Resources.requests.memory.trim()) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Requesting ",
                React.createElement("strong", null, this.state.containerDetails.Resources.requests.memory),
                " of memory"));
        }
        return Summary_1.default.placeholder("No required memory resources specified");
    };
    ContainerDialog.prototype.kubernetesCpuLimitSummary = function () {
        if (this.state.containerDetails.Resources.limits.cpu && this.state.containerDetails.Resources.limits.cpu.trim()) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Limiting CPU resources to ",
                React.createElement("strong", null, this.state.containerDetails.Resources.limits.cpu)));
        }
        return Summary_1.default.placeholder("No CPU resource limit set");
    };
    ContainerDialog.prototype.kubernetesMemoryLimitSummary = function () {
        if (this.state.containerDetails.Resources.limits.memory && this.state.containerDetails.Resources.limits.memory.trim()) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Limiting memory to ",
                React.createElement("strong", null, this.state.containerDetails.Resources.limits.memory)));
        }
        return Summary_1.default.placeholder("No memory resource limit set");
    };
    ContainerDialog.prototype.kubernetesConfigMapEnvironmentVarsSummary = function () {
        if (this.state.containerDetails.ConfigMapEnvironmentVariables && this.state.containerDetails.ConfigMapEnvironmentVariables.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null, _.chain(this.state.containerDetails.ConfigMapEnvironmentVariables)
                .flatMap(function (envVar) { return [
                React.createElement("span", null,
                    "Setting environment variable ",
                    React.createElement("strong", null, envVar.key),
                    " to value ",
                    React.createElement("strong", null, envVar.option),
                    " from config map ",
                    React.createElement("strong", null, envVar.value)),
                React.createElement("br", null)
            ]; })
                .slice(0, -1)
                .value()));
        }
        return Summary_1.default.placeholder("No environment variables from ConfigMap entries included");
    };
    ContainerDialog.prototype.kubernetesSecretEnvironmentVarsSummary = function () {
        if (this.state.containerDetails.SecretEnvironmentVariables && this.state.containerDetails.SecretEnvironmentVariables.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null, _.chain(this.state.containerDetails.SecretEnvironmentVariables)
                .flatMap(function (envVar) { return [
                React.createElement("span", null,
                    "Setting environment variable ",
                    React.createElement("strong", null, envVar.key),
                    " to value ",
                    React.createElement("strong", null, envVar.option),
                    " from secret ",
                    React.createElement("strong", null, envVar.value)),
                React.createElement("br", null)
            ]; })
                .slice(0, -1)
                .value()));
        }
        return Summary_1.default.placeholder("No environment variables from secret entries included");
    };
    ContainerDialog.prototype.kubernetesEnvironmentVarsSummary = function () {
        if (this.state.containerDetails.EnvironmentVariables && this.state.containerDetails.EnvironmentVariables.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null, _.chain(this.state.containerDetails.EnvironmentVariables)
                .flatMap(function (envVar) { return [
                React.createElement("span", null,
                    "Setting environment variable ",
                    React.createElement("strong", null, envVar.key),
                    " to ",
                    React.createElement("strong", null, envVar.value)),
                React.createElement("br", null)
            ]; })
                .slice(0, -1)
                .value()));
        }
        return Summary_1.default.placeholder("No environment variables included");
    };
    ContainerDialog.prototype.kubernetesVolumeSummary = function () {
        if (this.state.containerDetails.VolumeMounts && this.state.containerDetails.VolumeMounts.length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null, _.chain(this.state.containerDetails.VolumeMounts)
                .flatMap(function (volMount) { return [
                React.createElement("span", null,
                    "Mounting ",
                    React.createElement("strong", null,
                        volMount.key,
                        volMount.option && React.createElement("span", null,
                            "/",
                            volMount.option)),
                    React.createElement("span", null,
                        " under path ",
                        React.createElement("strong", null, volMount.value)),
                    React.createElement("span", null,
                        " in ",
                        React.createElement("strong", null, volMount.option === "True" ? "Read Only" : "Read Write"),
                        " mode")),
                React.createElement("br", null)
            ]; })
                .slice(0, -1)
                .value()));
        }
        return Summary_1.default.placeholder("No volume mounts included");
    };
    ContainerDialog.prototype.kubernetesLivenessProbeTypeSummary = function () {
        if (!!this.state.containerDetails.LivenessProbe.type) {
            return Summary_1.default.summary(React.createElement("span", null,
                this.state.containerDetails.LivenessProbe.type === exports.CommandCheck &&
                    this.state.containerDetails.LivenessProbe.exec.command &&
                    React.createElement("span", null,
                        "Command: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.exec.command.join(" ")),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.LivenessProbe.httpGet.host &&
                    React.createElement("span", null,
                        "HTTP host: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.httpGet.host),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.LivenessProbe.httpGet.path &&
                    React.createElement("span", null,
                        "HTTP path: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.httpGet.path),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.LivenessProbe.httpGet.port &&
                    React.createElement("span", null,
                        "HTTP port: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.httpGet.port),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.LivenessProbe.httpGet.scheme &&
                    React.createElement("span", null,
                        "HTTP scheme: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.httpGet.scheme),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.LivenessProbe.httpGet.httpHeaders &&
                    this.state.containerDetails.LivenessProbe.httpGet.httpHeaders.length !== 0 &&
                    React.createElement("span", null,
                        "HTTP headers:",
                        _.chain(this.state.containerDetails.LivenessProbe.httpGet.httpHeaders)
                            .flatMap(function (header) { return [
                            React.createElement("span", null,
                                React.createElement("strong", null, header.key),
                                " = ",
                                React.createElement("strong", null, header.value)),
                            React.createElement("span", null, ", ")
                        ]; })
                            .slice(0, -1)
                            .value()),
                this.state.containerDetails.LivenessProbe.type === exports.TcpSocketCheck &&
                    this.state.containerDetails.LivenessProbe.tcpSocket.host &&
                    React.createElement("span", null,
                        "TCP host: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.tcpSocket.host),
                        " "),
                this.state.containerDetails.LivenessProbe.type === exports.TcpSocketCheck &&
                    this.state.containerDetails.LivenessProbe.tcpSocket.port &&
                    React.createElement("span", null,
                        "TCP port: ",
                        React.createElement("strong", null, this.state.containerDetails.LivenessProbe.tcpSocket.port),
                        " ")));
        }
        return Summary_1.default.placeholder("No liveness probe type selected");
    };
    ContainerDialog.prototype.kubernetesReadinessProbeTypeSummary = function () {
        if (!!this.state.containerDetails.ReadinessProbe.type) {
            return Summary_1.default.summary(React.createElement("span", null,
                this.state.containerDetails.ReadinessProbe.type === exports.CommandCheck &&
                    this.state.containerDetails.ReadinessProbe.exec.command &&
                    React.createElement("span", null,
                        "Command: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.exec.command.join(" ")),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.ReadinessProbe.httpGet.host &&
                    React.createElement("span", null,
                        "HTTP host: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.httpGet.host),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.ReadinessProbe.httpGet.path &&
                    React.createElement("span", null,
                        "HTTP path: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.httpGet.path),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.ReadinessProbe.httpGet.port &&
                    React.createElement("span", null,
                        "HTTP port: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.httpGet.port),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.ReadinessProbe.httpGet.scheme &&
                    React.createElement("span", null,
                        "HTTP scheme: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.httpGet.scheme),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.HttpGetCheck &&
                    this.state.containerDetails.ReadinessProbe.httpGet.httpHeaders &&
                    this.state.containerDetails.ReadinessProbe.httpGet.httpHeaders.length !== 0 &&
                    React.createElement("span", null,
                        "HTTP headers:",
                        _.chain(this.state.containerDetails.ReadinessProbe.httpGet.httpHeaders)
                            .flatMap(function (header) { return [
                            React.createElement("span", null,
                                React.createElement("strong", null, header.key),
                                " = ",
                                React.createElement("strong", null, header.value)),
                            React.createElement("span", null, ", ")
                        ]; })
                            .slice(0, -1)
                            .value()),
                this.state.containerDetails.ReadinessProbe.type === exports.TcpSocketCheck &&
                    this.state.containerDetails.ReadinessProbe.tcpSocket.host &&
                    React.createElement("span", null,
                        "TCP host: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.tcpSocket.host),
                        " "),
                this.state.containerDetails.ReadinessProbe.type === exports.TcpSocketCheck &&
                    this.state.containerDetails.ReadinessProbe.tcpSocket.port &&
                    React.createElement("span", null,
                        "TCP port: ",
                        React.createElement("strong", null, this.state.containerDetails.ReadinessProbe.tcpSocket.port),
                        " ")));
        }
        return Summary_1.default.placeholder("No readiness probe type selected");
    };
    ContainerDialog.prototype.kubernetesCommandSummary = function () {
        if (this.state.containerDetails.Command && this.state.containerDetails.Command.filter(function (c) { return c && c.trim(); }).length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Overriding container command with ",
                React.createElement("strong", null, this.state.containerDetails.Command.filter(function (c) { return c && c.trim(); }).join(" "))));
        }
        return Summary_1.default.placeholder("No command provided");
    };
    ContainerDialog.prototype.kubernetesCommandArgumentsSummary = function () {
        if (this.state.containerDetails.Args && this.state.containerDetails.Args.filter(function (c) { return c && c.trim(); }).length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Pass the arguments ",
                React.createElement("strong", null, this.state.containerDetails.Args.filter(function (c) { return c && c.trim(); }).join(" "))));
        }
        return Summary_1.default.placeholder("No command arguments provided");
    };
    ContainerDialog.prototype.kubernetesSecurityContextAllowPrivilegeEscalationSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.allowPrivilegeEscalation");
        if (!setting || setting === "False") {
            return Summary_1.default.default(React.createElement("span", null, "Privilege escalation not enabled."));
        }
        if (setting === "True") {
            return Summary_1.default.summary(React.createElement("span", null, "Privilege escalation enabled."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Privilege escalation set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextPrivilegedSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.privileged");
        if (!setting || setting === "False") {
            return Summary_1.default.default(React.createElement("span", null, "Privileged mode not enabled."));
        }
        if (setting === "True") {
            return Summary_1.default.summary(React.createElement("span", null, "Privileged mode enabled."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Privileged mode set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextReadOnlyRootFilesystemSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.readOnlyRootFilesystem");
        if (!setting || setting === "False") {
            return Summary_1.default.default(React.createElement("span", null, "Read only root file system not enabled."));
        }
        if (setting === "True") {
            return Summary_1.default.summary(React.createElement("span", null, "Read only root file system enabled."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Read only root file system set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextRunAsNonRootSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.runAsNonRoot");
        if (!setting || setting === "False") {
            return Summary_1.default.default(React.createElement("span", null, "Run as non-root not enabled."));
        }
        if (setting === "True") {
            return Summary_1.default.summary(React.createElement("span", null, "Run as non-root enabled."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Run as non-root set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextRunAsUserSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.runAsUser");
        if (!setting || !setting.trim()) {
            return Summary_1.default.default(React.createElement("span", null, "Run as user not defined."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Run as user set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextRunAsGroupSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.runAsGroup");
        if (!setting || !setting.trim()) {
            return Summary_1.default.default(React.createElement("span", null, "Run as group not defined."));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Run as group set to ",
            React.createElement("strong", null, setting),
            "."));
    };
    ContainerDialog.prototype.kubernetesSecurityContextSELinuxOptionsSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.seLinuxOptions");
        if (!setting || (!setting.level && !setting.role && !setting.type && !setting.user)) {
            return Summary_1.default.default(React.createElement("span", null, "No SELinux options defined"));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Setting the ",
            setting.level && React.createElement("span", null,
                "level to ",
                React.createElement("strong", null, setting.level),
                (setting.role || setting.type || setting.user) && React.createElement("span", null, ", ")),
            setting.role && React.createElement("span", null,
                "role to ",
                React.createElement("strong", null, setting.role),
                (setting.type || setting.user) && React.createElement("span", null, ", ")),
            setting.type && React.createElement("span", null,
                "type to ",
                React.createElement("strong", null, setting.type),
                setting.user && React.createElement("span", null, ", ")),
            setting.user && React.createElement("span", null,
                "type to ",
                React.createElement("strong", null, setting.user))));
    };
    ContainerDialog.prototype.kubernetesSecurityContextCapabilitiesSummary = function () {
        var setting = _.get(this.state.containerDetails, "SecurityContext.capabilities");
        if (!setting || ((setting.add || []).length === 0 && (setting.drop || []).length === 0)) {
            return Summary_1.default.default(React.createElement("span", null, "No POSIX capabilities added or dropped."));
        }
        if ((setting.add || []).length !== 0 && (setting.drop || []).length === 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Added the POSIX capabilities ",
                React.createElement("strong", null, setting.add.join(", "))));
        }
        if ((setting.add || []).length === 0 && (setting.drop || []).length !== 0) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Dropped the POSIX capabilities ",
                React.createElement("strong", null, setting.drop.join(", "))));
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Added the ",
            React.createElement("strong", null, setting.add.join(", ")),
            " and dropped the ",
            React.createElement("strong", null, setting.drop.join(", ")),
            " POSIX capabilities"));
    };
    return ContainerDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = ContainerDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\containerDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\containerDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * These are sourced from http://man7.org/linux/man-pages/man7/capabilities.7.html
 */
exports.PosixCapabilities = [
    "CAP_AUDIT_CONTROL",
    "CAP_AUDIT_READ",
    "CAP_AUDIT_WRITE",
    "CAP_BLOCK_SUSPEND",
    "CAP_CHOWN",
    "CAP_DAC_OVERRIDE",
    "CAP_DAC_READ_SEARCH",
    "CAP_FOWNER",
    "CAP_FSETID",
    "CAP_IPC_LOCK",
    "CAP_IPC_OWNER",
    "CAP_KILL",
    "CAP_LEASE",
    "CAP_LINUX_IMMUTABLE",
    "CAP_MAC_ADMIN",
    "CAP_MAC_OVERRIDE",
    "CAP_MKNOD",
    "CAP_NET_ADMIN",
    "CAP_NET_BIND_SERVICE",
    "CAP_NET_BROADCAST",
    "CAP_NET_RAW",
    "CAP_SETGID",
    "CAP_SETFCAP",
    "CAP_SETPCAP",
    "CAP_SETUID",
    "CAP_SYS_ADMIN",
    "CAP_SYS_BOOT",
    "CAP_SYS_CHROOT",
    "CAP_SYS_MODULE",
    "CAP_SYS_NICE",
    "CAP_SYS_PACCT",
    "CAP_SYS_PTRACE",
    "CAP_SYS_RAWIO",
    "CAP_SYS_RESOURCE",
    "CAP_SYS_TIME",
    "CAP_SYS_TTY_CONFIG",
    "CAP_SYSLOG",
    "CAP_WAKE_ALARM"
];


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\posixCapabilitiesSuggestions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\posixCapabilitiesSuggestions.ts"); } } })();

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(90);
var clientInstance_1 = __webpack_require__(10);
var _ = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var Select_1 = __webpack_require__(40);
var kubernetesValidation_1 = __webpack_require__(301);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
exports.ConfigMapType = "ConfigMap";
exports.SecretType = "Secret";
exports.EmptyDirType = "EmptyDir";
exports.HostPathType = "HostPath";
exports.PersistentVolumeClaimType = "PersistentVolumeClaim";
exports.RawYamlType = "RawYaml";
exports.CustomResource = "Custom";
exports.LinkedResource = "LinkedResource";
var CombinedVolumeDialog = (function (_super) {
    __extends(CombinedVolumeDialog, _super);
    function CombinedVolumeDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            var valid = true;
            var binding = _this.state.combinedVolumeDetails;
            if (!kubernetesValidation_1.KubernetesNameRegex.exec(binding.Name)) {
                _this.setError("The volume name must consist of lower case alphanumeric characters or '-', and must start and end with an alphanumeric character.", [], { CombinedVolumeDetailsName: "The volume name must be defined." });
                valid = false;
            }
            if (binding.Type === exports.ConfigMapType) {
                if (binding.ReferenceNameType === exports.CustomResource && (!binding.ReferenceName || !binding.ReferenceName.trim())) {
                    _this.setError("The ConfigMap name must be defined.", [], { CombinedVolumeReferenceName: "The ConfigMap name must be defined." });
                    valid = false;
                }
            }
            if (binding.Type === exports.SecretType) {
                if (binding.ReferenceNameType === exports.CustomResource && (!binding.ReferenceName || !binding.ReferenceName.trim())) {
                    _this.setError("The secret name must be defined.", [], { CombinedVolumeReferenceName: "The secret name must be defined." });
                    valid = false;
                }
            }
            if (binding.Type === exports.HostPathType) {
                if (!binding.HostPathPath || !binding.HostPathPath.trim()) {
                    _this.setError("The host path path must be defined.", [], { CombinedVolumeHostPathPath: "The host path path must be defined." });
                    valid = false;
                }
            }
            if (binding.Type === exports.PersistentVolumeClaimType) {
                if (!binding.ReferenceName || !binding.ReferenceName.trim()) {
                    _this.setError("The persistent volume claim name must be defined.", [], { CombinedVolumeReferenceName: "The persistent volume claim name must be defined." });
                    valid = false;
                }
            }
            if (binding.Type === exports.RawYamlType) {
                if (!binding.RawYaml || !binding.RawYaml.trim()) {
                    _this.setError("The YAML must be defined.", [], { CombinedVolumeRawYaml: "The YAML must be defined." });
                    valid = false;
                }
            }
            if (valid) {
                return _this.props.onAdd(binding);
            }
            return valid;
        };
        _this.state = {
            combinedVolumeDetails: null,
            project: null,
            configMapFeatureEnabled: false,
            secretFeatureEnabled: false
        };
        return _this;
    }
    CombinedVolumeDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a, configMapFeatureEnabled, secretFeatureEnabled, combinedVolumeDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        configMapFeatureEnabled = this.props.featuresEnabled.split(",").includes("Octopus.Features.KubernetesConfigMap");
                        secretFeatureEnabled = this.props.featuresEnabled.split(",").includes("Octopus.Features.KubernetesSecret");
                        combinedVolumeDetails = __assign({}, this.props.combinedVolumeDetails);
                        // If the config map feature is not enabled, then we must supply a custom name
                        if ((combinedVolumeDetails.Type === exports.ConfigMapType && !configMapFeatureEnabled) ||
                            (combinedVolumeDetails.Type === exports.SecretType && !secretFeatureEnabled) ||
                            !combinedVolumeDetails.ReferenceNameType) {
                            combinedVolumeDetails.ReferenceNameType = exports.CustomResource;
                        }
                        this.setState({
                            combinedVolumeDetails: combinedVolumeDetails,
                            project: project,
                            configMapFeatureEnabled: configMapFeatureEnabled,
                            secretFeatureEnabled: secretFeatureEnabled
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CombinedVolumeDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Volume" }, this.state.combinedVolumeDetails && React.createElement("div", null,
            React.createElement(Select_1.default, { value: this.state.combinedVolumeDetails.Type, items: [
                    { text: "Config Map", value: exports.ConfigMapType },
                    { text: "Secret", value: exports.SecretType },
                    { text: "Empty Dir", value: exports.EmptyDirType },
                    { text: "Host Path", value: exports.HostPathType },
                    { text: "Persistent Volume Claim", value: exports.PersistentVolumeClaimType },
                    { text: "Raw YAML", value: exports.RawYamlType }
                ], label: "Volume type", onChange: function (Type) {
                    _this.setContainerState({ Type: Type });
                    _this.setState({
                        errors: null
                    });
                } }),
            React.createElement(VariableLookupText_1.VariableLookupText, { label: "Name", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeDetailsName"), value: this.state.combinedVolumeDetails.Name, onChange: function (Name) { return _this.setContainerState({ Name: Name }); } }),
            this.configMapUI(),
            this.secretUI(),
            this.emptyDirUI(),
            this.hostPathUI(),
            this.rawYamlUI(),
            this.persistentVolumeClaimUI(),
            this.gitRepoUI()));
    };
    CombinedVolumeDialog.prototype.rawYamlUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "RawYaml") {
            return React.createElement("div", null,
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Raw YAML", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeRawYaml"), value: this.state.combinedVolumeDetails.RawYaml, onChange: function (RawYaml) { return _this.setContainerState({ RawYaml: RawYaml }); }, multiLine: true, rows: 5, rowsMax: 5 }),
                React.createElement(Note_1.default, null,
                    "Enter the raw YAML for the volume. The YAML must start with the volume type property, and not include other properties like name e.g.",
                    React.createElement("pre", null,
                        React.createElement("code", null, "awsElasticBlockStore:\n  volumeID: myVolumeId\n  fsType: ext4"))));
        }
    };
    CombinedVolumeDialog.prototype.hostPathUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "HostPath") {
            return React.createElement("div", null,
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "Directory", value: this.state.combinedVolumeDetails.HostPathType, items: [
                        { text: "", value: "" },
                        { text: "DirectoryOrCreate", value: "DirectoryOrCreate" },
                        { text: "Directory", value: "Directory" },
                        { text: "FileOrCreate", value: "FileOrCreate" },
                        { text: "File", value: "File" },
                        { text: "Socket", value: "Socket" },
                        { text: "CharDevice", value: "CharDevice" },
                        { text: "BlockDevice", value: "BlockDevice" }
                    ], label: "Type", onChange: function (HostPath) { return _this.setContainerState({ HostPathType: HostPath }); } }),
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Path", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeHostPathPath"), value: this.state.combinedVolumeDetails.HostPathPath, onChange: function (HostPathPath) { return _this.setContainerState({ HostPathPath: HostPathPath }); } }));
        }
    };
    CombinedVolumeDialog.prototype.emptyDirUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "EmptyDir") {
            return React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "Default", value: this.state.combinedVolumeDetails.EmptyDirMedium, items: [
                    { text: "", value: "" },
                    { text: "Memory", value: "Memory" }
                ], label: "Medium", onChange: function (EmptyDirMedium) { return _this.setContainerState({ EmptyDirMedium: EmptyDirMedium }); } });
        }
    };
    CombinedVolumeDialog.prototype.persistentVolumeClaimUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "PersistentVolumeClaim") {
            return React.createElement("div", null,
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Persistent volume claim name", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeReferenceName"), value: this.state.combinedVolumeDetails.ReferenceName, onChange: function (SecretName) { return _this.setContainerState({ ReferenceName: SecretName }); } }));
        }
    };
    CombinedVolumeDialog.prototype.configMapUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "ConfigMap") {
            return React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("strong", null, "Config map resource name")),
                this.state.configMapFeatureEnabled
                    ? React.createElement("div", null,
                        React.createElement("p", null, "The volume can be linked to the config map resource created by the feature in this step, or linked to an external config map that was created outside the step."),
                        React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.state.combinedVolumeDetails.ReferenceNameType, onChange: function (type) { return _this.setContainerState({ ReferenceNameType: type }); } },
                            React.createElement(RadioButton_1.default, { value: exports.LinkedResource, label: "Reference the config map created as part of this step" }),
                            React.createElement(RadioButton_1.default, { value: exports.CustomResource, label: "Reference an external config map resource" })))
                    : React.createElement("div", null,
                        React.createElement("p", null, "By enabling the Config Map feature, this volume can be linked to a config map resource created as part of the step.")),
                (!this.state.configMapFeatureEnabled || this.state.combinedVolumeDetails.ReferenceNameType === exports.CustomResource) &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, hintText: "The name of the config map", error: this.getFieldError("CombinedVolumeReferenceName"), value: this.state.combinedVolumeDetails.ReferenceName, onChange: function (name) { return _this.setContainerState({ ReferenceName: name }); }, label: "Config map name" }),
                React.createElement("p", null,
                    React.createElement("strong", null, "Items")),
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.combinedVolumeDetails.Items) ? _this.state.combinedVolumeDetails.Items : []; }, name: "Item", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ Items: val }, _this.repositionDialog); }, valueLabel: "Path", keyLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId }));
        }
    };
    CombinedVolumeDialog.prototype.secretUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "Secret") {
            return React.createElement("div", null,
                this.state.secretFeatureEnabled
                    ? React.createElement("div", null,
                        React.createElement("p", null, "The volume can be linked to the secret resource created by the feature in this step, or linked to an external secret that was created outside the step."),
                        React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: this.state.combinedVolumeDetails.ReferenceNameType, onChange: function (type) { return _this.setContainerState({ ReferenceNameType: type }); } },
                            React.createElement(RadioButton_1.default, { value: exports.LinkedResource, label: "Reference the secret created as part of this step" }),
                            React.createElement(RadioButton_1.default, { value: exports.CustomResource, label: "Reference an external secret resource" })))
                    : React.createElement("div", null,
                        React.createElement("p", null, "By enabling the Config Map feature, this volume can be linked to a config map resource created as part of the step.")),
                (!this.state.secretFeatureEnabled || this.state.combinedVolumeDetails.ReferenceNameType === exports.CustomResource) &&
                    React.createElement(VariableLookupText_1.VariableLookupText, { label: "Secret name", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeReferenceName"), value: this.state.combinedVolumeDetails.ReferenceName, onChange: function (SecretName) { return _this.setContainerState({ ReferenceName: SecretName }); } }),
                React.createElement("p", null,
                    React.createElement("strong", null, "Items")),
                React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _.isArray(_this.state.combinedVolumeDetails.Items) ? _this.state.combinedVolumeDetails.Items : []; }, name: "Item", onAdd: this.repositionDialog, onChange: function (val) { return _this.setContainerState({ Items: val }, _this.repositionDialog); }, valueLabel: "Path", keyLabel: "Key", hideBindOnKey: false, projectId: this.props.projectId }));
        }
    };
    CombinedVolumeDialog.prototype.gitRepoUI = function () {
        var _this = this;
        if (this.state.combinedVolumeDetails.Type === "GitRepo") {
            return React.createElement("div", null,
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Repository", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeRepository"), value: this.state.combinedVolumeDetails.Repository, onChange: function (Repository) { return _this.setContainerState({ Repository: Repository }); } }),
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Revision", localNames: this.props.localNames, projectId: this.props.projectId, error: this.getFieldError("CombinedVolumeRevision"), value: this.state.combinedVolumeDetails.Revision, onChange: function (Revision) { return _this.setContainerState({ Revision: Revision }); } }));
        }
    };
    CombinedVolumeDialog.prototype.setContainerState = function (state, callback) {
        this.setChildState1("combinedVolumeDetails", state, callback);
    };
    /**
     * https://github.com/mui-org/material-ui/issues/1676
     * https://github.com/mui-org/material-ui/issues/5793
     * When adding or removing items from a list, the dialog needs to be repositioned, otherwise
     * the list may disappear off the screen. A resize event is the commonly suggested workaround.
     */
    CombinedVolumeDialog.prototype.repositionDialog = function () {
        window.dispatchEvent(new Event("resize"));
    };
    return CombinedVolumeDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = CombinedVolumeDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\combinedVolumeDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\combinedVolumeDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2108);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!../../../../node_modules/less-loader/dist/cjs.js!./style.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@media (max-width:37.4rem){.style_hide-sm__3mLNm{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__29OiG{display:none!important}}@media (max-width:79.9rem){.style_hide-md__VcqWJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__3sC4w{display:none!important}}.style_summaryText__1xXit{text-align:left;font-weight:400;margin:.25rem 0;font-size:.875rem}.style_summarySection__215pp{margin-top:.5rem;color:#333;font-size:.875rem}.style_summarySectionKey__1VPCl{text-align:left;font-weight:600;margin:.75rem 0 .25rem}.style_summarySectionValue__3McjF{text-align:left;font-weight:400;margin:.25rem 0}.style_summaryTable__No5KO{margin-top:.5rem;padding:0 1rem;color:#333;font-size:.875rem}.style_summaryTableKey__1J0wb{text-align:left;font-weight:600;width:25%}@media (max-width:37.4rem){.style_summaryTableKey__1J0wb{width:unset;text-align:initial}}.style_summaryTableValue__21EGb{text-align:left;font-weight:400}@media (max-width:37.4rem){.style_summaryTableValue__21EGb{text-align:initial}}.style_summaryTable__No5KO table{background-color:transparent}.style_summaryTable__No5KO tr:hover{background-color:transparent!important}.style_summaryTable__No5KO tr{border:0!important}.style_summaryTable__No5KO td{padding:.125rem 0!important}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3mLNm",
	"hideSm": "style_hide-sm__3mLNm",
	"visible-sm": "style_visible-sm__29OiG",
	"visibleSm": "style_visible-sm__29OiG",
	"hide-md": "style_hide-md__VcqWJ",
	"hideMd": "style_hide-md__VcqWJ",
	"visible-md": "style_visible-md__3sC4w",
	"visibleMd": "style_visible-md__3sC4w",
	"summaryText": "style_summaryText__1xXit",
	"summarySection": "style_summarySection__215pp",
	"summarySectionKey": "style_summarySectionKey__1VPCl",
	"summarySectionValue": "style_summarySectionValue__3McjF",
	"summaryTable": "style_summaryTable__No5KO",
	"summaryTableKey": "style_summaryTableKey__1J0wb",
	"summaryTableValue": "style_summaryTableValue__21EGb"
};

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var kubernetesServiceComponent_1 = __webpack_require__(758);
var React = __webpack_require__(0);
var KeyValueEditList_1 = __webpack_require__(87);
var ExpandableFormSection_1 = __webpack_require__(30);
var jsonUtils_1 = __webpack_require__(106);
var _ = __webpack_require__(11);
var Summary_1 = __webpack_require__(44);
var pluginRegistry_1 = __webpack_require__(18);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var ExternalLink_1 = __webpack_require__(26);
var Note_1 = __webpack_require__(20);
var KubernetesDeployServiceActionSummary = (function (_super) {
    __extends(KubernetesDeployServiceActionSummary, _super);
    function KubernetesDeployServiceActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployServiceActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy a service resource to Kubernetes");
    };
    return KubernetesDeployServiceActionSummary;
}(BaseComponent_1.BaseComponent));
var KubernetesDeployServiceActionEdit = (function (_super) {
    __extends(KubernetesDeployServiceActionEdit, _super);
    function KubernetesDeployServiceActionEdit(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployServiceActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(kubernetesServiceComponent_1.KubernetesServiceComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Service Labels", summary: this.labelsSummary(), help: "The labels applied to the service resource" },
                React.createElement(Note_1.default, null, "Labels are optional name/value pairs that are assigned to the Service resource."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-service#service-labels" }, "service labels"),
                    "."),
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], name: "Label", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.SelectorLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Service Selector Labels", summary: this.selectorLabelsSummary(), help: "The selector labels used to match pod resources" },
                React.createElement(Note_1.default, null, "Service selector labels are used to match the pods that traffic will be sent to."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-service#service-selector-labels" }, "service selector labels"),
                    "."),
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.SelectorLabels"], name: "Selector Label", separator: "=", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.SelectorLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesDeployServiceActionEdit.prototype.selectorLabelsSummary = function () {
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.SelectorLabels"], {}));
        if (labels.length === 0) {
            return Summary_1.default.placeholder("The service resource selector labels");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Selecting pod resources with the label",
            labels.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(labels)
                .flatMap(function (pair) { return [React.createElement("strong", null,
                    pair[0],
                    ": ",
                    pair[1]), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    KubernetesDeployServiceActionEdit.prototype.labelsSummary = function () {
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], {}));
        if (labels.length === 0) {
            return Summary_1.default.placeholder("The service resource labels");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add label",
            labels.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(labels)
                .flatMap(function (pair) { return [React.createElement("strong", null,
                    pair[0],
                    ": ",
                    pair[1]), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    return KubernetesDeployServiceActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesDeployService",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesDeployServiceActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: KubernetesDeployServiceActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesServiceAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesServiceAction.tsx"); } } })();

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var Select_1 = __webpack_require__(40);
var clientInstance_1 = __webpack_require__(10);
var VariableLookupAutoComplete_1 = __webpack_require__(757);
var _ = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var kubernetesValidation_1 = __webpack_require__(301);
var isBound_1 = __webpack_require__(54);
var PortDialog = (function (_super) {
    __extends(PortDialog, _super);
    function PortDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            var valid = true;
            var binding = _this.state.servicePort;
            if (_this.state.servicePort.name &&
                _this.state.servicePort.name.trim() &&
                !isBound_1.default(_this.state.servicePort.name) &&
                !kubernetesValidation_1.KubernetesNameRegex.exec(_this.state.servicePort.name.trim())) {
                _this.setError("The service names must be blank, or have names that consist of lower case alphanumeric characters or '-', and must start and end with an alphanumeric character.", [], {
                    ServicePortName: "The service names must be blank, or have names that consist of lower case alphanumeric characters or '-', and must start and end with an alphanumeric character."
                });
                valid = false;
            }
            if (!_this.state.servicePort.port || !_this.state.servicePort.port.trim()) {
                _this.setError("A port is required", [], {
                    ServicePortPort: "A port is required"
                });
                valid = false;
            }
            if (_this.state.servicePort.targetPort &&
                !isBound_1.default(_this.state.servicePort.targetPort.trim()) &&
                !isNaN(parseInt(_this.state.servicePort.targetPort.trim(), 10)) &&
                !(parseInt(_this.state.servicePort.targetPort.trim(), 10) >= 1 &&
                    parseInt(_this.state.servicePort.targetPort.trim(), 10) <= 65535)) {
                _this.setError("The target port must be a number between 1 and 65535, or a port name", [], {
                    ServicePortTargetPort: "The target port must be a number between 1 and 65535, or a port name"
                });
                valid = false;
            }
            if (_this.state.servicePort.port &&
                _this.state.servicePort.port.trim() &&
                !isBound_1.default(_this.state.servicePort.port) &&
                !(kubernetesValidation_1.NumberRegex.exec(_this.state.servicePort.port.trim()) &&
                    parseInt(_this.state.servicePort.port.trim(), 10) >= 1 &&
                    parseInt(_this.state.servicePort.port.trim(), 10) <= 65535)) {
                _this.setError("Port numbers must be between 1 and 65535", [], {
                    ServicePortPort: "Port numbers must be between 1 and 65535"
                });
                valid = false;
            }
            if (_this.props.serviceType !== "ClusterIP" &&
                _this.state.servicePort.nodePort &&
                _this.state.servicePort.nodePort.trim() &&
                !isBound_1.default(_this.state.servicePort.nodePort) &&
                !(kubernetesValidation_1.NumberRegex.exec(_this.state.servicePort.nodePort.trim()) &&
                    parseInt(_this.state.servicePort.nodePort.trim(), 10) >= 1 &&
                    parseInt(_this.state.servicePort.nodePort.trim(), 10) <= 65535)) {
                _this.setError("Node port numbers must be between 1 and 65535", [], {
                    ServicePortNodePort: "Node port numbers must be between 1 and 65535"
                });
                valid = false;
            }
            if (valid) {
                return _this.props.onAdd(binding);
            }
            return valid;
        };
        /**
         * The target port is the port that is open on the container. This can be the port number, or
         * the port name.
         */
        _this.getTargetPortOptions = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(this.props.containers)
                    .flatMap(function (c) { return c.Ports; })
                    .flatMap(function (p) { return [p.key, p.value]; })
                    .filter(function (v) { return !!v; })
                    .filter(function (v) { return v.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f, Name: f }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        /**
         * The port is the port that is open on the service. Target port also defaults to the value of the port
         * if it is not specified. Port can only be a number.
         */
        _this.getPortOptions = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(this.props.containers)
                    .flatMap(function (c) { return c.Ports; })
                    .flatMap(function (p) { return p.value; })
                    .filter(function (v) { return !!v; })
                    .filter(function (v) { return v.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f, Name: f }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        _this.state = {
            servicePort: null,
            project: null
        };
        return _this;
    }
    PortDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            servicePort: this.props.servicePort,
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    PortDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Service Port" }, this.state.servicePort && React.createElement("div", null,
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.servicePort.name, error: this.getFieldError("ServicePortName"), onChange: function (x) { return _this.setPortState({ name: x }); }, label: "Name" }),
            React.createElement(Note_1.default, null, "The optional name of the port. This name can be referenced in the ingress path."),
            this.props.containers.length !== 0
                ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { localNames: this.props.localNames, projectId: this.props.projectId, hintText: "Port", value: this.state.servicePort.port, error: this.getFieldError("ServicePortPort"), getOptions: this.getPortOptions, onChange: function (x) { return _this.setPortState({ port: x }); }, allowAnyTextValue: true, label: "Port" })
                : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.servicePort.port, error: this.getFieldError("ServicePortPort"), onChange: function (x) { return _this.setPortState({ port: x }); }, label: "Port" }),
            React.createElement(Note_1.default, null, "The port internal Kubernetes workloads use to access the service."),
            this.props.containers.length !== 0
                ? React.createElement(VariableLookupAutoComplete_1.VariableLookupAutoComplete, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.servicePort.targetPort, hintText: "Target Port", getOptions: this.getTargetPortOptions, onChange: function (x) { return _this.setPortState({ targetPort: x }); }, error: this.getFieldError("ServicePortTargetPort"), allowAnyTextValue: true, label: "Target Port" })
                : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.servicePort.targetPort, onChange: function (x) { return _this.setPortState({ targetPort: x }); }, error: this.getFieldError("ServicePortTargetPort"), label: "Target Port" }),
            React.createElement(Note_1.default, null,
                "An optional value set to a port exposed by the container. This can be the name of the port, or the port number. If left blank, it will default to the value of the ",
                React.createElement("code", null, "Port"),
                " above."),
            (this.props.serviceType === "NodePort" || this.props.serviceType === "LoadBalancer") &&
                React.createElement("div", null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.servicePort.nodePort, error: this.getFieldError("ServicePortNodePort"), onChange: function (x) { return _this.setPortState({ nodePort: x }); }, label: "Node Port" }),
                    React.createElement(Note_1.default, null, "An optional value that defines the publicly accessible port exposed on all nodes used to access the service. If left blank, Kubernetes will assign a port.")),
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "TCP", value: this.state.servicePort.protocol, onChange: function (x) { return _this.setPortState({ protocol: x }); }, items: [{ value: "TCP", text: "TCP" }, { value: "UDP", text: "UDP" }], hintText: "Protocol", label: "Protocol" }),
            React.createElement(Note_1.default, null, "The protocol used by the service.")));
    };
    PortDialog.prototype.setPortState = function (state, callback) {
        this.setChildState1("servicePort", state);
    };
    return PortDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = PortDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\servicePortDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\servicePortDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var React = __webpack_require__(0);
var KeyValueEditList_1 = __webpack_require__(87);
var ExpandableFormSection_1 = __webpack_require__(30);
var jsonUtils_1 = __webpack_require__(106);
var _ = __webpack_require__(11);
var Summary_1 = __webpack_require__(44);
var pluginRegistry_1 = __webpack_require__(18);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var kubernetesIngressComponent_1 = __webpack_require__(759);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var KubernetesDeployIngressActionSummary = (function (_super) {
    __extends(KubernetesDeployIngressActionSummary, _super);
    function KubernetesDeployIngressActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployIngressActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy an ingress resource to Kubernetes");
    };
    return KubernetesDeployIngressActionSummary;
}(BaseComponent_1.BaseComponent));
var KubernetesDeployIngressActionEdit = (function (_super) {
    __extends(KubernetesDeployIngressActionEdit, _super);
    function KubernetesDeployIngressActionEdit(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployIngressActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(kubernetesIngressComponent_1.KubernetesIngressComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true, standAlone: true }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DefaultRulePort|Octopus.Action.KubernetesContainers.DefaultRuleServiceName", isExpandedByDefault: this.props.expandedByDefault, title: "Default Rule", summary: this.defaultRuleSummary(), help: "The default rule applied when no other rule matches" },
                React.createElement(Note_1.default, null, "When there are no matching ingress rules, traffic can be sent to the service configured as the default rule."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-ingress#default-rule" }, "default rules"),
                    "."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.DefaultRulePort"), value: this.props.properties["Octopus.Action.KubernetesContainers.DefaultRulePort"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DefaultRulePort"] = val, _a));
                        var _a;
                    }, label: "Port" }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, error: this.props.getFieldError("Octopus.Action.KubernetesContainers.DefaultRuleServiceName"), value: this.props.properties["Octopus.Action.KubernetesContainers.DefaultRuleServiceName"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DefaultRuleServiceName"] = val, _a));
                        var _a;
                    }, label: "Service name" })),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Ingress Labels", summary: this.labelsSummary(), help: "The labels applied to the ingress resource" },
                React.createElement(Note_1.default, null, "Labels are optional name/value pairs that are assigned to the ingress resource."),
                React.createElement(Note_1.default, null,
                    "Learn more about ",
                    React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-ingress#ingress-labels" }, "ingress labels"),
                    "."),
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], name: "Label", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesDeployIngressActionEdit.prototype.defaultRuleSummary = function () {
        if (this.props.properties["Octopus.Action.KubernetesContainers.DefaultRulePort"] &&
            this.props.properties["Octopus.Action.KubernetesContainers.DefaultRuleServiceName"]) {
            return Summary_1.default.summary(React.createElement("span", null,
                "Directing unmatched traffic to ",
                React.createElement("strong", null,
                    this.props.properties["Octopus.Action.KubernetesContainers.DefaultRuleServiceName"],
                    ":",
                    this.props.properties["Octopus.Action.KubernetesContainers.DefaultRulePort"])));
        }
        return Summary_1.default.placeholder(React.createElement("span", null, "Define the default service to recieve unmatched traffic"));
    };
    KubernetesDeployIngressActionEdit.prototype.labelsSummary = function () {
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], {}));
        if (labels.length === 0) {
            return Summary_1.default.placeholder("The service resource labels");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the label",
            labels.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(labels)
                .flatMap(function (pair) { return [React.createElement("strong", null,
                    pair[0],
                    ": ",
                    pair[1]), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    return KubernetesDeployIngressActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesDeployIngress",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesDeployIngressActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: KubernetesDeployIngressActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesIngressAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesIngressAction.tsx"); } } })();

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(90);
var clientInstance_1 = __webpack_require__(10);
var _ = __webpack_require__(11);
var Note_1 = __webpack_require__(20);
var kubernetesValidation_1 = __webpack_require__(301);
var isBound_1 = __webpack_require__(54);
var ExtendedKeyValueEditList_1 = __webpack_require__(193);
var IngressDialog = (function (_super) {
    __extends(IngressDialog, _super);
    function IngressDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.save = function () {
            var valid = true;
            var binding = _this.state.ingressRule;
            if (!!binding.host &&
                !!binding.host.trim() &&
                !isBound_1.default(binding.host.trim()) &&
                binding.host.indexOf("*") !== -1 &&
                !kubernetesValidation_1.KubernetesWildcardIngressHostRegex.exec(binding.host.trim())) {
                _this.setError("The ingress host must be empty, or a wildcard DNS-1123 subdomain that starts with '*.', followed by a valid DNS subdomain, " +
                    "which must consist of lower case alphanumeric characters, '-' or '.' and end with an alphanumeric character(e.g. '*.example.com').", [], {
                    ServicePortName: "The ingress host must be empty, or a wildcard DNS-1123 subdomain that starts with '*.', followed by a valid DNS subdomain, " +
                        "which must consist of lower case alphanumeric characters, '-' or '.' and end with an alphanumeric character(e.g. '*.example.com')."
                });
                valid = false;
            }
            if (!!binding.host &&
                !!binding.host.trim() &&
                !isBound_1.default(binding.host.trim()) &&
                binding.host.indexOf("*") === -1 &&
                !kubernetesValidation_1.KubernetesIngressHostRegex.exec(binding.host.trim())) {
                _this.setError("The ingress host must be empty, or a a DNS-1123 subdomain must consist of lower case alphanumeric characters, " +
                    "'-' or '.', and must start and end with an alphanumeric character. (e.g. example.com)", [], {
                    ServicePortName: "The ingress host must be empty, or a a DNS-1123 subdomain must consist of lower case alphanumeric characters, " +
                        "'-' or '.', and must start and end with an alphanumeric character. (e.g. example.com)"
                });
                valid = false;
            }
            if (binding.http.paths.length === 0) {
                _this.setError("At least one ingress path must be defined.");
                valid = false;
            }
            binding.http.paths.forEach(function (p) {
                p.keyError = (!!p.key && (isBound_1.default(p.key) || p.key.trim().startsWith("/")))
                    ? null
                    : "Ingress paths must all start with a forward slash.";
            });
            binding.http.paths.forEach(function (p) {
                p.valueError = !!p.value &&
                    !!p.value.trim() &&
                    (isBound_1.default(p.value.trim()) ||
                        isNaN(parseInt(p.value.trim(), 10)) ||
                        (parseInt(p.value.trim(), 10) >= 1 && parseInt(p.value.trim(), 10) <= 65535))
                    ? null
                    : "Ingress rules must have a service port between 1 and 65535, or a port name.";
            });
            binding.http.paths.forEach(function (p) {
                p.optionError = !_this.props.standAlone || (!!p.option && kubernetesValidation_1.KubernetesNameRegex.exec(p.option.trim()))
                    ? null
                    : "Ingress rules must have a valid service name.";
            });
            if (binding.http.paths.find(function (p) { return !!p.keyError || !!p.valueError || !!p.optionError; })) {
                _this.setError("The ingress rules are incorrectly configured.");
                valid = false;
            }
            if (valid) {
                return _this.props.onAdd(binding);
            }
            return valid;
        };
        _this.getPortOptions = function (searchText) { return __awaiter(_this, void 0, void 0, function () {
            var results, itemsToTake;
            return __generator(this, function (_a) {
                results = _.chain(this.props.servicePorts)
                    .flatMap(function (p) { return [p.name, p.port]; })
                    .filter(function (p) { return !!p; })
                    .sort()
                    .filter(function (v) { return v.toLowerCase().includes(searchText.toLowerCase()); })
                    .value();
                itemsToTake = 7;
                return [2 /*return*/, {
                        items: results.slice(0, itemsToTake).map(function (f) { return ({ Id: f, Name: f }); }),
                        containsAllResults: results.length <= itemsToTake
                    }];
            });
        }); };
        _this.state = {
            ingressRule: null,
            project: null
        };
        return _this;
    }
    IngressDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            ingressRule: this.props.ingressRule,
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    IngressDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Host Rule" }, this.state.ingressRule && React.createElement("div", null,
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.ingressRule.host, error: this.getFieldError("IngressRuleHost"), onChange: function (x) { return _this.setIngressState({ host: x }); }, label: "Host" }),
            React.createElement(Note_1.default, null, "An optional value that defines the host that this ingress rule applies to. If left blank, this rule will apply to all hosts."),
            this.props.standAlone
                ? React.createElement("div", null,
                    React.createElement("p", null,
                        React.createElement("strong", null, "Paths"),
                        " ",
                        React.createElement("br", null),
                        "Include the URL path and the service ",
                        React.createElement("code", null, "Port"),
                        " this ingress path directs traffic to. The service port can be the service name, or the port number."),
                    React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _this.state.ingressRule.http.paths; }, name: "Path", onChange: function (val) {
                            _this.setIngressState({ http: { paths: val } });
                            _this.repositionDialog();
                        }, valueLabel: "Service port", optionLabel: "Service name", keyLabel: "Path", hideBindOnKey: false, projectId: this.props.projectId, addToTop: true, onAdd: this.repositionDialog }),
                    " ")
                : React.createElement("div", null,
                    React.createElement("p", null,
                        React.createElement("strong", null, "Paths"),
                        " ",
                        React.createElement("br", null),
                        "Include the URL path and the service ",
                        React.createElement("code", null, "Port"),
                        " this ingress path directs traffic to. The service port can be the service name, or the port number."),
                    React.createElement(ExtendedKeyValueEditList_1.ExtendedKeyValueEditList, { items: function () { return _this.state.ingressRule.http.paths; }, name: "Path", onChange: function (val) {
                            _this.setIngressState({ http: { paths: val } });
                            _this.repositionDialog();
                        }, valueLabel: "Service port", keyLabel: "Path", hideBindOnKey: false, projectId: this.props.projectId, getValueOptions: function (searchText) { return _this.getPortOptions(searchText); }, addToTop: true, onAdd: this.repositionDialog }))));
    };
    IngressDialog.prototype.setIngressState = function (state, callback) {
        this.setChildState1("ingressRule", state);
    };
    /**
     * https://github.com/mui-org/material-ui/issues/1676
     * https://github.com/mui-org/material-ui/issues/5793
     * When adding or removing items from a list, the dialog needs to be repositioned, otherwise
     * the list may disappear off the screen. A resize event is the commonly suggested workaround.
     */
    IngressDialog.prototype.repositionDialog = function () {
        window.dispatchEvent(new Event("resize"));
    };
    return IngressDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = IngressDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\ingressRuleDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\ingressRuleDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * https://github.com/kubernetes/ingress-nginx/blob/master/docs/user-guide/nginx-configuration/annotations.md
 *
 */
var NginxIngressAnnotation = [
    "nginx.ingress.kubernetes.io/add-base-url",
    "nginx.ingress.kubernetes.io/app-root",
    "nginx.ingress.kubernetes.io/affinity",
    "nginx.ingress.kubernetes.io/auth-realm",
    "nginx.ingress.kubernetes.io/auth-secret",
    "nginx.ingress.kubernetes.io/auth-type",
    "nginx.ingress.kubernetes.io/auth-tls-secret",
    "nginx.ingress.kubernetes.io/auth-tls-verify-depth",
    "nginx.ingress.kubernetes.io/auth-tls-verify-client",
    "nginx.ingress.kubernetes.io/auth-tls-error-page",
    "nginx.ingress.kubernetes.io/auth-tls-pass-certificate-to-upstream",
    "nginx.ingress.kubernetes.io/auth-url",
    "nginx.ingress.kubernetes.io/base-url-scheme",
    "nginx.ingress.kubernetes.io/client-body-buffer-size",
    "nginx.ingress.kubernetes.io/configuration-snippet",
    "nginx.ingress.kubernetes.io/default-backend",
    "nginx.ingress.kubernetes.io/enable-cors",
    "nginx.ingress.kubernetes.io/cors-allow-origin",
    "nginx.ingress.kubernetes.io/cors-allow-methods",
    "nginx.ingress.kubernetes.io/cors-allow-headers",
    "nginx.ingress.kubernetes.io/cors-allow-credentials",
    "nginx.ingress.kubernetes.io/cors-max-age",
    "nginx.ingress.kubernetes.io/force-ssl-redirect",
    "nginx.ingress.kubernetes.io/from-to-www-redirect",
    "nginx.ingress.kubernetes.io/grpc-backend",
    "nginx.ingress.kubernetes.io/limit-connections",
    "nginx.ingress.kubernetes.io/limit-rps",
    "nginx.ingress.kubernetes.io/permanent-redirect",
    "nginx.ingress.kubernetes.io/proxy-body-size",
    "nginx.ingress.kubernetes.io/proxy-cookie-domain",
    "nginx.ingress.kubernetes.io/proxy-connect-timeout",
    "nginx.ingress.kubernetes.io/proxy-send-timeout",
    "nginx.ingress.kubernetes.io/proxy-read-timeout",
    "nginx.ingress.kubernetes.io/proxy-next-upstream",
    "nginx.ingress.kubernetes.io/proxy-next-upstream-tries",
    "nginx.ingress.kubernetes.io/proxy-request-buffering",
    "nginx.ingress.kubernetes.io/proxy-redirect-from",
    "nginx.ingress.kubernetes.io/proxy-redirect-to",
    "nginx.ingress.kubernetes.io/rewrite-log",
    "nginx.ingress.kubernetes.io/rewrite-target",
    "nginx.ingress.kubernetes.io/secure-backends",
    "nginx.ingress.kubernetes.io/secure-verify-ca-secret",
    "nginx.ingress.kubernetes.io/server-alias",
    "nginx.ingress.kubernetes.io/server-snippet",
    "nginx.ingress.kubernetes.io/service-upstream",
    "nginx.ingress.kubernetes.io/session-cookie-name",
    "nginx.ingress.kubernetes.io/session-cookie-hash",
    "nginx.ingress.kubernetes.io/ssl-redirect",
    "nginx.ingress.kubernetes.io/ssl-passthrough",
    "nginx.ingress.kubernetes.io/upstream-max-fails",
    "nginx.ingress.kubernetes.io/upstream-fail-timeout",
    "nginx.ingress.kubernetes.io/upstream-hash-by",
    "nginx.ingress.kubernetes.io/load-balance",
    "nginx.ingress.kubernetes.io/upstream-vhost",
    "nginx.ingress.kubernetes.io/whitelist-source-range",
    "nginx.ingress.kubernetes.io/proxy-buffering",
    "nginx.ingress.kubernetes.io/proxy-buffer-size",
    "nginx.ingress.kubernetes.io/ssl-ciphers",
    "nginx.ingress.kubernetes.io/connection-proxy-header",
    "nginx.ingress.kubernetes.io/enable-access-log",
    "nginx.ingress.kubernetes.io/lua-resty-waf",
    "nginx.ingress.kubernetes.io/lua-resty-waf-debug",
    "nginx.ingress.kubernetes.io/lua-resty-waf-ignore-rulesets",
    "nginx.ingress.kubernetes.io/lua-resty-waf-extra-rules",
    "nginx.ingress.kubernetes.io/enable-influxdb",
    "nginx.ingress.kubernetes.io/influxdb-measurement",
    "nginx.ingress.kubernetes.io/influxdb-port",
    "nginx.ingress.kubernetes.io/influxdb-host",
    "nginx.ingress.kubernetes.io/influxdb-server-name",
];
/**
 * https://github.com/nginxinc/kubernetes-ingress/tree/master/examples/customization
 */
var NginxPlusAnnotations = [
    "nginx.com/sticky-cookie-services",
    "nginx.com/jwt-key",
    "nginx.com/jwt-realm",
    "nginx.com/jwt-token",
    "nginx.com/jwt-login-url",
    "nginx.com/health-checks",
    "nginx.com/health-checks-mandatory",
    "nginx.com/health-checks-mandatory-queue",
    "nginx.com/slow-start"
];
var CommonIngressAnnotations = [
    "kubernetes.io/ingress.class",
    "kubernetes.io/ingress.allow-http",
    "kubernetes.io/ingress.global-static-ip-name"
];
/**
 * https://github.com/kubernetes/ingress-gce/blob/master/docs/annotations.md
 */
var GoogleIngressAnnotations = [
    "ingress.gcp.kubernetes.io/pre-shared-cert",
];
exports.IngressAnnotations = NginxIngressAnnotation
    .concat(CommonIngressAnnotations)
    .concat(GoogleIngressAnnotations)
    .concat(NginxPlusAnnotations);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\ingressAnnotationsSuggestions.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\ingressAnnotationsSuggestions.ts"); } } })();

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var pluginRegistry_1 = __webpack_require__(18);
var React = __webpack_require__(0);
var KeyValueEditList_1 = __webpack_require__(87);
var ExpandableFormSection_1 = __webpack_require__(30);
var jsonUtils_1 = __webpack_require__(106);
var Summary_1 = __webpack_require__(44);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var kubernetesConfigMapComponent_1 = __webpack_require__(760);
var _ = __webpack_require__(11);
var KubernetesDeployConfigMapActionSummary = (function (_super) {
    __extends(KubernetesDeployConfigMapActionSummary, _super);
    function KubernetesDeployConfigMapActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployConfigMapActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy a config map resource to Kubernetes");
    };
    return KubernetesDeployConfigMapActionSummary;
}(BaseComponent_1.BaseComponent));
var KubernetesDeployConfigMapActionEdit = (function (_super) {
    __extends(KubernetesDeployConfigMapActionEdit, _super);
    function KubernetesDeployConfigMapActionEdit(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeployConfigMapActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(kubernetesConfigMapComponent_1.KubernetesConfigMapComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Config Map Labels", summary: this.labelsSummary(), help: "The labels applied to the config map resource" },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], name: "Label", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesDeployConfigMapActionEdit.prototype.labelsSummary = function () {
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], {}));
        if (labels.length === 0) {
            return Summary_1.default.placeholder("The config map resource labels");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the label",
            labels.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(labels)
                .flatMap(function (pair) { return [React.createElement("strong", null,
                    pair[0],
                    ": ",
                    pair[1]), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    return KubernetesDeployConfigMapActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesDeployConfigMap",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesDeployConfigMapActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: KubernetesDeployConfigMapActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesConfigMapAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesConfigMapAction.tsx"); } } })();

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = __webpack_require__(12);
var pluginRegistry_1 = __webpack_require__(18);
var React = __webpack_require__(0);
var KeyValueEditList_1 = __webpack_require__(87);
var ExpandableFormSection_1 = __webpack_require__(30);
var jsonUtils_1 = __webpack_require__(106);
var Summary_1 = __webpack_require__(44);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var kubernetesSecretComponent_1 = __webpack_require__(761);
var _ = __webpack_require__(11);
var KubernetesDeploySecretActionSummary = (function (_super) {
    __extends(KubernetesDeploySecretActionSummary, _super);
    function KubernetesDeploySecretActionSummary(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeploySecretActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Deploy a secret resource to Kubernetes");
    };
    return KubernetesDeploySecretActionSummary;
}(BaseComponent_1.BaseComponent));
var KubernetesDeploySecretActionEdit = (function (_super) {
    __extends(KubernetesDeploySecretActionEdit, _super);
    function KubernetesDeploySecretActionEdit(props) {
        return _super.call(this, props) || this;
    }
    KubernetesDeploySecretActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(kubernetesSecretComponent_1.KubernetesSecretComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.DeploymentLabels", isExpandedByDefault: this.props.expandedByDefault, title: "Secret Labels", summary: this.labelsSummary(), help: "The labels applied to the secret resource" },
                React.createElement(KeyValueEditList_1.default, { items: this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], name: "Label", separator: "", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.DeploymentLabels"] = val, _a));
                        var _a;
                    }, valueLabel: "Value", keyLabel: "Name", hideBindOnKey: false, projectId: this.props.projectId })));
    };
    KubernetesDeploySecretActionEdit.prototype.labelsSummary = function () {
        var labels = _.toPairs(jsonUtils_1.JsonUtils.tryParse(this.props.properties["Octopus.Action.KubernetesContainers.DeploymentLabels"], {}));
        if (labels.length === 0) {
            return Summary_1.default.placeholder("The config map resource labels");
        }
        return Summary_1.default.summary(React.createElement("span", null,
            "Add the label",
            labels.length > 1 && React.createElement("span", null, "s"),
            " ",
            _.chain(labels)
                .flatMap(function (pair) { return [React.createElement("strong", null,
                    pair[0],
                    ": ",
                    pair[1]), React.createElement("span", null, ", ")]; })
                .slice(0, -1)
                .value()));
    };
    return KubernetesDeploySecretActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesDeploySecret",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(KubernetesDeploySecretActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: KubernetesDeploySecretActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Required; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesSecretAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesSecretAction.tsx"); } } })();

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var pluginRegistry_1 = __webpack_require__(18);
var awsUploadS3Action_1 = __webpack_require__(2117);
var awsDeleteCloudFormationAction_1 = __webpack_require__(2118);
var awsDeployCloudFormationAction_1 = __webpack_require__(2119);
var awsRunScriptAction_1 = __webpack_require__(2120);
var awsApplyCloudFormationAction_1 = __webpack_require__(2121);
var awsCloudFormationChangesetFeature_1 = __webpack_require__(762);
pluginRegistry_1.default.registerDeploymentAction(awsRunScriptAction_1.default());
pluginRegistry_1.default.registerDeploymentAction(awsDeleteCloudFormationAction_1.default());
pluginRegistry_1.default.registerDeploymentAction(awsDeployCloudFormationAction_1.default());
pluginRegistry_1.default.registerDeploymentAction(awsUploadS3Action_1.default());
pluginRegistry_1.default.registerDeploymentAction(awsApplyCloudFormationAction_1.default());
pluginRegistry_1.default.registerFeature(awsCloudFormationChangesetFeature_1.default());


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\register.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\register.ts"); } } })();

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var awsLoginComponent_1 = __webpack_require__(194);
var VariableLookupText_1 = __webpack_require__(21);
var resources_1 = __webpack_require__(17);
var ActionDetails_1 = __webpack_require__(25);
var CommonSummaryHelper_1 = __webpack_require__(62);
var PackageSelector_1 = __webpack_require__(53);
var lodash_1 = __webpack_require__(11);
var RadioButtonGroup_1 = __webpack_require__(36);
var KeyValueEditList_1 = __webpack_require__(87);
var StringCheckbox_1 = __webpack_require__(41);
var Button_1 = __webpack_require__(47);
var lodash_2 = __webpack_require__(11);
var form_1 = __webpack_require__(16);
var ExternalLink_1 = __webpack_require__(26);
var Fragment_1 = __webpack_require__(92);
var BucketKeyBehaviour;
(function (BucketKeyBehaviour) {
    BucketKeyBehaviour["Filename"] = "Filename";
    BucketKeyBehaviour["Custom"] = "Custom";
})(BucketKeyBehaviour = exports.BucketKeyBehaviour || (exports.BucketKeyBehaviour = {}));
var TargetMode;
(function (TargetMode) {
    TargetMode["EntirePackage"] = "EntirePackage";
    TargetMode["FileSelections"] = "FileSelections";
})(TargetMode = exports.TargetMode || (exports.TargetMode = {}));
var FileSelectionTypes;
(function (FileSelectionTypes) {
    FileSelectionTypes["SingleFile"] = "SingleFile";
    FileSelectionTypes["MultipleFiles"] = "MultipleFiles";
})(FileSelectionTypes = exports.FileSelectionTypes || (exports.FileSelectionTypes = {}));
function isMultiFileSelection(selection) {
    return selection && selection.type && selection.type === FileSelectionTypes.MultipleFiles;
}
exports.isMultiFileSelection = isMultiFileSelection;
function isSingleFileSelection(selection) {
    return selection && selection.type && selection.type === FileSelectionTypes.SingleFile;
}
exports.isSingleFileSelection = isSingleFileSelection;
exports.AwsUploadS3ActionSummary = function (props) { return (React.createElement("div", null, "Upload a package to an AWS S3 bucket.")); };
var simpleSummary = lodash_1.curry(function (property, render, placeholder, properties) {
    return properties[property] ? render(properties[property]) : placeholder();
});
exports.bucketSummary = simpleSummary("Octopus.Action.Aws.S3.BucketName", function (value) { return form_1.Summary.summary(React.createElement("span", null,
    "Using bucket ",
    React.createElement("strong", null, value))); }, function () { return form_1.Summary.placeholder("Specify the S3 bucket name"); });
exports.regionSummary = simpleSummary("Octopus.Action.Aws.Region", function (value) { return form_1.Summary.summary(React.createElement("span", null,
    "Using ",
    React.createElement("strong", null, value),
    " as the default region")); }, function () { return form_1.Summary.placeholder("Specify the default AWS region"); });
var failWith = function (message) {
    throw new Error(message);
};
exports.targetModeSummary = simpleSummary("Octopus.Action.Aws.S3.TargetMode", function (value) {
    switch (value) {
        case TargetMode.EntirePackage: return form_1.Summary.summary(React.createElement("span", null, "Entire package file (the package will not be extracted)"));
        case TargetMode.FileSelections: return form_1.Summary.summary(React.createElement("span", null, "Specific file(s) within the package"));
        default: failWith("Unknown package type");
    }
}, function () { return form_1.Summary.placeholder("Specify a target type"); });
exports.renderMetadata = function (onChange, _a) {
    var projectId = _a.projectId, localNames = _a.localNames, detail = __rest(_a, ["projectId", "localNames"]);
    var fieldProps = { projectId: projectId, localNames: localNames, separator: "=", keyLabel: "Key", valueLabel: "Value" };
    return [React.createElement(KeyValueEditList_1.KeyValueEditList, __assign({}, fieldProps, { key: "metadata", name: "metadata", onChange: function (val) { return onChange(__assign({}, detail, { metadata: val })); }, items: function () { return detail.metadata || []; } })),
        React.createElement(KeyValueEditList_1.KeyValueEditList, __assign({}, fieldProps, { key: "tags", name: "tags", onChange: function (val) { return onChange(__assign({}, detail, { tags: val })); }, items: function () { return detail.tags || []; } }))];
};
exports.CannedAclNote = function () { return (React.createElement(form_1.Note, null,
    "You can read more about available options regarding canned Acls ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3CannedAcl" }, "here"))); };
exports.PrefixNote = function () { return (React.createElement(form_1.Note, null,
    "A prefix delimited with forward slash ",
    React.createElement("code", null, "/"),
    " characters is seen in S3 as folders. ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3Prefix" }, "More examples here"),
    ".")); };
exports.CustomBucketKeyNote = function () { return (React.createElement(form_1.Note, null,
    "A custom key delimited with forward slash ",
    React.createElement("code", null, "/"),
    " characters is seen in S3 as folders. ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3CustomBucketKey" }, "More examples here"),
    ".")); };
exports.StorageClassNote = function () { return (React.createElement(form_1.Note, null,
    "Read more about S3 storage classes ",
    React.createElement(ExternalLink_1.default, { href: "AwsS3StorageClasses" }, "here"))); };
exports.CannedAclField = function (props) {
    return React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, props, { label: "Canned Acl" }));
};
exports.StorageClassField = function (props) {
    return React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, props, { label: "Storage Class" }));
};
exports.BucketKeyBehaviourEdit = function (_a) {
    var onChange = _a.onChange, localNames = _a.localNames, projectId = _a.projectId, getFieldError = _a.getFieldError, detail = __rest(_a, ["onChange", "localNames", "projectId", "getFieldError"]);
    var fieldProps = { localNames: localNames, projectId: projectId };
    var behaviour = detail.bucketKeyBehaviour || BucketKeyBehaviour.Custom;
    return React.createElement(Fragment_1.Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: BucketKeyBehaviour.Custom, value: behaviour, onChange: function (bucketKeyBehaviour) { return onChange({ bucketKeyBehaviour: bucketKeyBehaviour }); }, error: getFieldError("BucketKeyBehaviour") },
            React.createElement(form_1.RadioButton, { value: BucketKeyBehaviour.Filename, label: "Use filename" }),
            React.createElement(form_1.RadioButton, { value: BucketKeyBehaviour.Custom, label: "Use custom key" })),
        behaviour === BucketKeyBehaviour.Custom && React.createElement(Fragment_1.Fragment, null,
            React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKey, label: "Bucket Key", onChange: function (bucketKey) { return onChange({ bucketKey: bucketKey }); }, error: getFieldError("BucketKey") })),
            React.createElement(exports.CustomBucketKeyNote, null)),
        behaviour === BucketKeyBehaviour.Filename && React.createElement(Fragment_1.Fragment, null,
            React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKeyPrefix, label: "Bucket Key Prefix", onChange: function (bucketKeyPrefix) { return onChange({ bucketKeyPrefix: bucketKeyPrefix }); }, error: getFieldError("BucketKeyPrefix") })),
            React.createElement(exports.PrefixNote, null)));
};
exports.S3PackageDetailEdit = function (props) {
    var onChange = props.onChange, getFieldError = props.getFieldError, children = props.children, projectId = props.projectId, localNames = props.localNames, metadata = props.metadata, tags = props.tags, detail = __rest(props, ["onChange", "getFieldError", "children", "projectId", "localNames", "metadata", "tags"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    return React.createElement(Fragment_1.Fragment, null,
        React.createElement(exports.BucketKeyBehaviourEdit, __assign({}, fieldProps, detail, { onChange: function (val) { return onChange(__assign({}, detail, val)); }, getFieldError: getFieldError })),
        React.createElement(exports.CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(exports.CannedAclNote, null),
        React.createElement(exports.StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(exports.StorageClassNote, null),
        exports.renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
exports.S3SingleFileDetailEdit = function (props) {
    var onChange = props.onChange, onChangeType = props.onChangeType, getFieldError = props.getFieldError, children = props.children, metadata = props.metadata, tags = props.tags, localNames = props.localNames, projectId = props.projectId, detail = __rest(props, ["onChange", "onChangeType", "getFieldError", "children", "metadata", "tags", "localNames", "projectId"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    return React.createElement(Fragment_1.Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "SingleFile", value: detail.type, onChange: onChangeType, error: getFieldError("Type") },
            React.createElement(form_1.RadioButton, { value: "SingleFile", label: "Single File" }),
            React.createElement(form_1.RadioButton, { value: "MultipleFiles", label: "Multiple Files" })),
        React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { value: detail.path, label: "Path", onChange: function (val) { return onChange(__assign({}, detail, { path: val })); }, error: getFieldError("Path") })),
        React.createElement(StringCheckbox_1.default, { value: detail.performVariableSubstitution, label: "Variable Substitution", onChange: function (val) { return onChange(__assign({}, detail, { performVariableSubstitution: val })); } }),
        React.createElement(exports.BucketKeyBehaviourEdit, __assign({}, fieldProps, detail, { onChange: function (val) { return onChange(__assign({}, detail, val)); }, getFieldError: getFieldError })),
        React.createElement(exports.CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(exports.CannedAclNote, null),
        React.createElement(exports.StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(exports.StorageClassNote, null),
        exports.renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
exports.S3MultiFileDetailEdit = function (props) {
    var onChange = props.onChange, onChangeType = props.onChangeType, getFieldError = props.getFieldError, children = props.children, metadata = props.metadata, tags = props.tags, localNames = props.localNames, projectId = props.projectId, detail = __rest(props, ["onChange", "onChangeType", "getFieldError", "children", "metadata", "tags", "localNames", "projectId"]);
    var fieldProps = { projectId: projectId, localNames: localNames };
    if (detail.pattern === undefined) {
        detail.pattern = "**/*";
    }
    return React.createElement(Fragment_1.Fragment, null,
        React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: "MultipleFiles", value: detail.type, onChange: onChangeType, error: getFieldError("Type") },
            React.createElement(form_1.RadioButton, { value: "SingleFile", label: "Single File" }),
            React.createElement(form_1.RadioButton, { value: "MultipleFiles", label: "Multiple Files" })),
        React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { value: detail.pattern, label: "File Pattern", onChange: function (val) { return onChange(__assign({}, detail, { pattern: val })); }, error: getFieldError("Pattern") })),
        React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { multiLine: true, value: detail.variableSubstitutionPatterns, label: "Variable Substitution File Patterns", onChange: function (val) { return onChange(__assign({}, detail, { variableSubstitutionPatterns: val })); }, error: getFieldError("VariableSubstitutionPatterns") })),
        React.createElement(form_1.Note, null,
            "A newline-separated list of file names to transform, relative to the package contents. Extended wildcard syntax is supported. E.g., ",
            React.createElement("em", null, "Notes.txt"),
            ", ",
            React.createElement("em", null, "Config\\*.json"),
            ", ",
            React.createElement("em", null, "**\\specific-folder\\*.config."),
            React.createElement("br", null),
            "This field supports extended template syntax. Conditional ",
            React.createElement("code", null, "if"),
            " and ",
            React.createElement("code", null, "unless"),
            ":",
            React.createElement("pre", null, "#{if MyVar}...#{/if}"),
            "Iteration over variable sets or comma-separated values with ",
            React.createElement("code", null, "each"),
            ":",
            React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
        React.createElement(VariableLookupText_1.VariableLookupText, __assign({}, fieldProps, { value: detail.bucketKeyPrefix, label: "Bucket Key Prefix", onChange: function (val) { return onChange(__assign({}, detail, { bucketKeyPrefix: val })); }, error: getFieldError("BucketKeyPrefix") })),
        React.createElement(exports.PrefixNote, null),
        React.createElement(exports.CannedAclField, __assign({}, fieldProps, { value: detail.cannedAcl, onChange: function (val) { return onChange(__assign({}, detail, { cannedAcl: val })); }, error: getFieldError("CannedAcl") })),
        React.createElement(exports.CannedAclNote, null),
        React.createElement(exports.StorageClassField, __assign({}, fieldProps, { value: detail.storageClass, onChange: function (val) { return onChange(__assign({}, detail, { storageClass: val })); }, error: getFieldError("StorageClass") })),
        React.createElement(exports.StorageClassNote, null),
        exports.renderMetadata(onChange, __assign({}, fieldProps, { tags: tags, metadata: metadata })));
};
exports.FileSelectionEdit = function (_a) {
    var onChange = _a.onChange, onChangeType = _a.onChangeType, onRemove = _a.onRemove, getFieldError = _a.getFieldError, selection = __rest(_a, ["onChange", "onChangeType", "onRemove", "getFieldError"]);
    var callbacks = { onChange: onChange, onChangeType: onChangeType, getFieldError: getFieldError };
    var removeButton = React.createElement("div", { style: { textAlign: "right" } },
        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Secondary, onClick: onRemove, label: "Remove File Selection" }));
    return React.createElement(Fragment_1.Fragment, null,
        removeButton,
        isSingleFileSelection(selection) && React.createElement(exports.S3SingleFileDetailEdit, __assign({}, selection, callbacks)),
        isMultiFileSelection(selection) && React.createElement(exports.S3MultiFileDetailEdit, __assign({}, selection, callbacks)));
};
exports.getNewFileSelection = function () {
    return {
        type: FileSelectionTypes.SingleFile,
        tags: [],
        metadata: [],
        cannedAcl: "",
        path: "",
        storageClass: "STANDARD",
        bucketKey: "",
        bucketKeyPrefix: "",
        bucketKeyBehaviour: BucketKeyBehaviour.Custom,
        performVariableSubstitution: "False"
    };
};
exports.fileOptionsSummaryText = function (options) {
    return [
        options.storageClass && " on " + options.storageClass + " storage",
        options.cannedAcl && " with " + options.cannedAcl + " permissions"
    ];
};
function targetOptionsSummary(placeholder, summaryCallback) {
    return function (options) {
        if (options === undefined || options === null) {
            return form_1.Summary.placeholder(placeholder);
        }
        var summary = summaryCallback(options);
        if (!summary) {
            return form_1.Summary.placeholder(placeholder);
        }
        return form_1.Summary.summary(React.createElement("span", { children: summary }));
    };
}
exports.targetOptionsSummary = targetOptionsSummary;
var continuedTextTransform = function (value, prefix) {
    if (!value) {
        return value;
    }
    var result = "" + (prefix || "") + value.replace(/\w/, function (val) { return val.toLowerCase(); }).trim();
    return result.length > 0 ? " " + result : result;
};
exports.singleFileSelectionSummary = targetOptionsSummary("Specify file options", function (options) {
    return React.createElement(Fragment_1.Fragment, { key: "summary" },
        options.path && ("File " && React.createElement("strong", null, options.path)),
        !options.path && "No file path specified",
        options.path && React.createElement(Fragment_1.Fragment, null,
            exports.bucketKeyBehaviourSummary(options, function (val) { return continuedTextTransform(val); }),
            exports.fileOptionsSummaryText(options)));
});
exports.packageSummary = targetOptionsSummary("Specify file options", function (options) {
    return React.createElement(Fragment_1.Fragment, { key: "summary" },
        exports.bucketKeyBehaviourSummary(options),
        options.bucketKey && exports.fileOptionsSummaryText(options));
});
exports.bucketKeyBehaviourSummary = function (options, transform) {
    if (transform === void 0) { transform = lodash_2.identity; }
    return React.createElement(Fragment_1.Fragment, { key: "bucketKeyBehaviourSummary" },
        options.bucketKeyBehaviour === BucketKeyBehaviour.Custom && React.createElement(Fragment_1.Fragment, null,
            options.bucketKey && React.createElement(Fragment_1.Fragment, null,
                transform("Using bucket key"),
                React.createElement("strong", null,
                    " ",
                    options.bucketKey)),
            !options.bucketKey && transform("No bucket key provided")),
        options.bucketKeyBehaviour === BucketKeyBehaviour.Filename && React.createElement(Fragment_1.Fragment, null,
            transform("Using file name as bucket key"),
            options.bucketKeyPrefix && React.createElement(Fragment_1.Fragment, null,
                " with prefix",
                React.createElement("strong", null,
                    " ",
                    options.bucketKeyPrefix))));
};
exports.mutliFileSelectionSummary = targetOptionsSummary("Specify file options", function (options) {
    return React.createElement(Fragment_1.Fragment, { key: "summary" },
        options.pattern && ("Files matching" && React.createElement("strong", null, options.pattern)),
        !options.pattern && "No patterns specified",
        exports.fileOptionsSummaryText(options));
});
exports.fileSelectionSummary = function (selection) {
    if (isSingleFileSelection(selection)) {
        return exports.singleFileSelectionSummary(selection);
    }
    else if (isMultiFileSelection(selection)) {
        return exports.mutliFileSelectionSummary(selection);
    }
};
exports.updateFileSelection = function (index, value) {
    return function (previous, properties) {
        var patch = __assign({}, previous, { selections: previous.selections.slice() });
        patch.selections[index] = __assign({}, patch.selections[index], value);
        //We close over the state update and push it onto the queue via setProperties.
        //TODO: Invetisgate alternate way to do this, possibly redux since the same action can be handled by multiple reducers
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
exports.removeFileSelection = function (index) {
    return function (previous, properties) {
        var patch = __assign({}, previous, { selections: previous.selections.slice() });
        patch.selections.splice(index, 1);
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
exports.updatePackageOptions = function (value) {
    return function (previous, properties) {
        var result = __assign({}, previous, { package: __assign({}, previous.package, value) });
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.PackageOptions"] = JSON.stringify(result.package), _a));
        return result;
        var _a;
    };
};
exports.addFileSelection = function (value) {
    return function (previous, properties) {
        var patch = { selections: previous.selections.concat([value]) };
        properties.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.FileSelections"] = JSON.stringify(patch.selections), _a));
        return patch;
        var _a;
    };
};
var AwsUploadS3ActionEdit = (function (_super) {
    __extends(AwsUploadS3ActionEdit, _super);
    function AwsUploadS3ActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: [],
            package: {
                bucketKey: "",
                bucketKeyBehaviour: BucketKeyBehaviour.Custom,
                bucketKeyPrefix: "",
                storageClass: "STANDARD",
                cannedAcl: "",
                metadata: [],
                tags: []
            },
            selections: []
        };
        return _this;
    }
    AwsUploadS3ActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var accounts, _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        accounts = _d.sent();
                                        this.setState(function (prev) { return (__assign({}, prev, { accounts: accounts })); });
                                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                                            this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.AssumeRole"] = "False", _a), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                                            this.props.setProperties((_b = {}, _b["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _b), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Aws.S3.TargetMode"]) {
                                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.S3.TargetMode"] = TargetMode.EntirePackage, _c), true);
                                        }
                                        this.setState(function (prev, props) {
                                            if (props.properties["Octopus.Action.Aws.S3.FileSelections"]) {
                                                return { selections: (JSON.parse(props.properties["Octopus.Action.Aws.S3.FileSelections"]) || []) };
                                            }
                                        });
                                        this.setState(function (prev, props) {
                                            if (props.properties["Octopus.Action.Aws.S3.PackageOptions"]) {
                                                return { package: JSON.parse(props.properties["Octopus.Action.Aws.S3.PackageOptions"]) || {} };
                                            }
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    AwsUploadS3ActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region", isExpandedByDefault: this.props.expandedByDefault, title: "Region", summary: exports.regionSummary(this.props.properties), help: "Specify the default region" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(form_1.Note, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.BucketName", isExpandedByDefault: this.props.expandedByDefault, title: "Bucket", summary: exports.bucketSummary(this.props.properties), help: "Specify the bucket name" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.S3.BucketName"], label: "Bucket", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.BucketName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.S3.BucketName") })),
            React.createElement(form_1.FormSectionHeading, { title: "Package" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: "Choose the package or package containing the file(s) to upload." },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.TargetType", isExpandedByDefault: this.props.expandedByDefault, title: "Target", summary: exports.targetModeSummary(this.props.properties), help: "Choose how we should treat this package." },
                React.createElement(RadioButtonGroup_1.BoundRadioButtonGroup, { resetValue: TargetMode.EntirePackage, value: this.props.properties["Octopus.Action.Aws.S3.TargetMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.S3.TargetMode"] = x, _a));
                        var _a;
                    }, label: "Execute using the AWS service role for an EC2 instance" },
                    React.createElement(form_1.RadioButton, { value: TargetMode.EntirePackage, label: "Entire package file (the package will not be extracted)" }),
                    React.createElement(form_1.RadioButton, { value: TargetMode.FileSelections, label: "Specific file(s) within the package" }))),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.EntirePackage &&
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.S3.PackageOptions", isExpandedByDefault: this.props.expandedByDefault, summary: exports.packageSummary(this.state.package), title: "Package Options", help: "Package options and metadata to use when uploading the entire package to an S3 bucket" },
                    React.createElement(exports.S3PackageDetailEdit, __assign({}, this.state.package, { projectId: this.props.projectId, onChange: function (detail) { return _this.setState(exports.updatePackageOptions(detail)); }, getFieldError: function (field) { return _this.props.getFieldError("Octopus.Action.Aws.S3.PackageOptions." + field); } }))),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections && React.createElement(form_1.FormSectionHeading, { title: "Files" }),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections && this.state.selections.map(function (selection, index) {
                return React.createElement(form_1.ExpandableFormSection, { key: "IDX_" + index, errorKey: "Octopus.Action.Aws.S3.FileSelections[" + index + "]", isExpandedByDefault: _this.props.expandedByDefault, summary: exports.fileSelectionSummary(selection), title: "" + (isSingleFileSelection(selection) ? "Single File" : "Multiple Files"), help: "Package options and metadata to use when uploading the entire package to an S3 bucket" },
                    React.createElement(exports.FileSelectionEdit, __assign({}, selection, { onChange: function (value) { return _this.setState(exports.updateFileSelection(index, value)); }, onChangeType: function (type) { return _this.setState(exports.updateFileSelection(index, { type: type })); }, onRemove: function () { return _this.setState(exports.removeFileSelection(index)); }, getFieldError: function (field) { return _this.props.getFieldError("Octopus.Action.Aws.S3.FileSelections[" + index + "]." + field); }, projectId: _this.props.projectId, localNames: _this.props.localNames })));
            }),
            this.props.properties["Octopus.Action.Aws.S3.TargetMode"] === TargetMode.FileSelections &&
                React.createElement(form_1.UnstructuredFormSection, null,
                    React.createElement("div", { style: { textAlign: "right" } },
                        React.createElement(Button_1.ActionButton, { type: Button_1.ActionButtonType.Secondary, label: "" + (this.state.selections.length > 0 ? "Add another file selection" : "Add a file selection"), onClick: function () { return _this.setState(exports.addFileSelection(exports.getNewFileSelection())); } }))));
    };
    return AwsUploadS3ActionEdit;
}(BaseComponent_1.BaseComponent));
exports.AwsUploadS3ActionEdit = AwsUploadS3ActionEdit;
exports.default = function () { return ({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.TargetOrServer,
    actionType: "Octopus.AwsUploadS3",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(exports.AwsUploadS3ActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AwsUploadS3ActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        optional: [],
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsUploadS3Action.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsUploadS3Action.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var awsLoginComponent_1 = __webpack_require__(194);
var Note_1 = __webpack_require__(20);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var VariableLookupText_1 = __webpack_require__(21);
var StringCheckbox_1 = __webpack_require__(41);
var ExternalLink_1 = __webpack_require__(26);
var AwsCloudFormationActionSummary = (function (_super) {
    __extends(AwsCloudFormationActionSummary, _super);
    function AwsCloudFormationActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsCloudFormationActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Delete an AWS CloudFormation stack",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AwsCloudFormationActionSummary;
}(BaseComponent_1.BaseComponent));
var AwsRemoveCloudFormationActionEdit = (function (_super) {
    __extends(AwsRemoveCloudFormationActionEdit, _super);
    function AwsRemoveCloudFormationActionEdit(props) {
        return _super.call(this, props) || this;
    }
    AwsRemoveCloudFormationActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Aws.WaitForCompletion"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.WaitForCompletion"] = "True", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Aws.AssumeRole"] = "False", _d), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_e = {}, _e["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _e), true);
                        }
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _f.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _f.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsRemoveCloudFormationActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "AWS" }),
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region|Octopus.Action.Aws.CloudFormationStackName", isExpandedByDefault: this.props.expandedByDefault, title: "CloudFormation", summary: this.cloudFormationSummary(), help: "Specify the details of the CloudFormation stack" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationStackName"], label: "CloudFormation stack name", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationStackName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationStackName") }),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "True", value: properties["Octopus.Action.Aws.WaitForCompletion"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.WaitForCompletion"] = x, _a));
                        var _a;
                    }, label: "Wait for completion" }),
                React.createElement(Note_1.default, null, "Select this checkbox to force the step to wait until the CloudFormation stack has been deleted before finishing the step. Be aware that unselecting this option means the step will not indicate an error if the stack was not removed successfully.")));
    };
    AwsRemoveCloudFormationActionEdit.prototype.cloudFormationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.CloudFormationStackName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Deleting stack ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.CloudFormationStackName"]),
                properties["Octopus.Action.Aws.Region"] && React.createElement("span", null,
                    " in ",
                    React.createElement("strong", null, properties["Octopus.Action.Aws.Region"])),
                properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " waiting for completion"),
                !properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " not waiting for completion")));
        }
        return form_1.Summary.placeholder("Specify the details of the CloudFormation stack");
    };
    return AwsRemoveCloudFormationActionEdit;
}(BaseComponent_1.BaseComponent));
exports.default = function () { return ({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsDeleteCloudFormation",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsCloudFormationActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AwsRemoveCloudFormationActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsDeleteCloudFormationAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsDeleteCloudFormationAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var awsLoginComponent_1 = __webpack_require__(194);
var CodeEditor_1 = __webpack_require__(107);
var CommonSummaryHelper_1 = __webpack_require__(62);
var ExpandableFormSection_1 = __webpack_require__(30);
var Note_1 = __webpack_require__(20);
var RadioButton_1 = __webpack_require__(32);
var OpenDialogButton_1 = __webpack_require__(72);
var PackageSelector_1 = __webpack_require__(53);
var RadioButtonGroup_1 = __webpack_require__(36);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var DynamicForm_1 = __webpack_require__(502);
var VariableLookupText_1 = __webpack_require__(21);
var StringCheckbox_1 = __webpack_require__(41);
var ExternalLink_1 = __webpack_require__(26);
var sourceCodeDialog_1 = __webpack_require__(429);
var awsCloudFormationChangesetFeature_1 = __webpack_require__(762);
var jsonUtils_1 = __webpack_require__(106);
var AwsCloudFormationActionSummary = (function (_super) {
    __extends(AwsCloudFormationActionSummary, _super);
    function AwsCloudFormationActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwsCloudFormationActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Deploy an AWS CloudFormation template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return AwsCloudFormationActionSummary;
}(BaseComponent_1.BaseComponent));
var AwsCloudFormationActionEdit = (function (_super) {
    __extends(AwsCloudFormationActionEdit, _super);
    function AwsCloudFormationActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: [],
            accounts: []
        };
        _this.parameterValues = {};
        _this.parameters = {};
        _this.source = { octopus: "octopus" };
        return _this;
    }
    AwsCloudFormationActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return __generator(this, function (_j) {
                                switch (_j.label) {
                                    case 0:
                                        if (!this.props.properties["Octopus.Action.Aws.WaitForCompletion"]) {
                                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.WaitForCompletion"] = "True", _c), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                                            this.props.setProperties((_d = {}, _d["Octopus.Action.Aws.AssumeRole"] = "False", _d), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                                            this.props.setProperties((_e = {}, _e["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _e), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParameters"]) {
                                            this.props.setProperties((_f = {}, _f["Octopus.Action.Aws.CloudFormationTemplateParameters"] = "", _f), true);
                                        }
                                        if (!this.props.properties["Octopus.Action.Aws.TemplateSource"]) {
                                            this.props.setProperties((_g = {}, _g["Octopus.Action.Aws.TemplateSource"] = "Inline", _g), true);
                                        }
                                        // If CloudFormationTemplateParametersRaw isn't set, default it to the value of
                                        // CloudFormationTemplateParameters. This accounts for cases where people have
                                        // populated CloudFormationTemplateParameters and upgraded to an Octopus version that
                                        // expects the UI input to be saved in CloudFormationTemplateParametersRaw.
                                        if (!this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]) {
                                            this.props.setProperties((_h = {},
                                                _h["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParameters"],
                                                _h), true);
                                        }
                                        _a = this.setState;
                                        _b = {};
                                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                                    case 1:
                                        _a.apply(this, [(_b.accounts = _j.sent(),
                                                _b)]);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AwsCloudFormationActionEdit.prototype.componentWillMount = function () {
        if (this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] &&
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline") {
            this.refreshParametersFromTemplate(this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]);
        }
    };
    AwsCloudFormationActionEdit.prototype.templateSourceSummary = function () {
        var source = this.props.properties["Octopus.Action.Aws.TemplateSource"];
        if (source === "Inline") {
            return form_1.Summary.summary("Source code");
        }
        if (source === "Package") {
            return form_1.Summary.summary("File inside a package");
        }
        return form_1.Summary.placeholder("Template source not specified");
    };
    AwsCloudFormationActionEdit.prototype.pathsSummary = function () {
        var summary = [];
        (this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"])
            ? summary.push(React.createElement("span", null,
                "Using the template in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no template path specified")));
        (this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"])
            ? summary.push(React.createElement("span", null,
                " with the parameters in ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"])))
            : summary.push(React.createElement("span", null,
                " ",
                React.createElement("em", null, "no parameters path specified")));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    AwsCloudFormationActionEdit.prototype.onChangeTemplateSource = function (value) {
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.TemplateSource"] = value,
            _a["Octopus.Action.Aws.CloudFormationTemplate"] = "",
            _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = "",
            _a["Octopus.Action.Aws.CloudFormationTemplateParameters"] = "",
            _a));
        if (value === "Inline") {
            this.props.setPackages(resources_1.RemovePrimaryPackageReference(this.props.packages));
        }
        else {
            this.props.setPackages(resources_1.InitialisePrimaryPackageReference(this.props.packages));
        }
        var _a;
    };
    AwsCloudFormationActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var pkg = resources_1.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "AWS" }),
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region|Octopus.Action.Aws.CloudFormationStackName", isExpandedByDefault: this.props.expandedByDefault, title: "CloudFormation", summary: this.cloudFormationSummary(), help: "Specify the details of the CloudFormation stack" },
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Region", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes."),
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "CloudFormation stack name", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationStackName"], onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationStackName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationStackName") }),
                React.createElement(VariableLookupText_1.VariableLookupText, { label: "Role ARN", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormation.RoleArn"], onChange: function (val) { return _this.props.setProperties({ "Octopus.Action.Aws.CloudFormation.RoleArn": val }); }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormation.RoleArn") }),
                React.createElement(Note_1.default, null, "The Amazon Resource Name (ARN) of an AWS Identity and Access Management (IAM) role that AWS CloudFormation assumes when executing any operations. This role will be used for any future operations on the stack."),
                React.createElement(form_1.StringRadioButtonGroup, { label: "IAM Capabilities", value: properties["Octopus.Action.Aws.IamCapabilities"] || "NONE", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.IamCapabilities"] = val, _a));
                        var _a;
                    } },
                    React.createElement(RadioButton_1.default, { value: "NONE", label: "No additional capabilities", isDefault: true }),
                    React.createElement(RadioButton_1.default, { value: "CAPABILITY_IAM", label: "The template has IAM resources (CAPABILITY_IAM)" }),
                    React.createElement(RadioButton_1.default, { value: "CAPABILITY_NAMED_IAM", label: "The template has IAM resources with custom names (CAPABILITY_NAMED_IAM)" })),
                React.createElement(Note_1.default, null,
                    "Additional capabilities are required for templates that have IAM resources or named IAM resources. Refer to the ",
                    React.createElement(ExternalLink_1.default, { href: "AwsDocsControllingIAM" }, "AWS documentation"),
                    " for more information."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "False", value: properties["Octopus.Action.Aws.DisableRollback"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.DisableRollback"] = x, _a));
                        var _a;
                    }, label: "Disable rollback" }),
                React.createElement(Note_1.default, null, "Select this checkbox to disable the automatic rollback of a CloudFormation stack if it failed to be created successfully. This has no effect if the stack exists and is being updated."),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "True", value: properties["Octopus.Action.Aws.WaitForCompletion"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.WaitForCompletion"] = x, _a));
                        var _a;
                    }, label: "Wait for completion" }),
                React.createElement(Note_1.default, null, "Select this checkbox to force the step to wait until the CloudFormation stack has been completed before getting the outputs and finishing the step. Be aware that unselecting this option can mean that no output variables are created, or that output variables may contain outdated values, as the CloudFormation outputs may not have been created or updated before this step completed. Unselecting this option also means the step will not indicate an error if the stack was rolled back during deployment.")),
            React.createElement(FormSectionHeading_1.default, { title: "Template" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.TemplateSource|Octopus.Action.Aws.CloudFormationTemplate", isExpandedByDefault: this.props.expandedByDefault, title: "Template Source", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.templateSourceSummary(), help: "Select the source of the template." },
                React.createElement(Note_1.default, null, "Templates can be entered as source-code, or contained in a package."),
                React.createElement(RadioButtonGroup_1.default, { value: this.props.properties["Octopus.Action.Aws.TemplateSource"], onChange: function (val) { return _this.onChangeTemplateSource(val); }, error: this.props.getFieldError("Octopus.Action.Aws.TemplateSource") },
                    React.createElement(RadioButton_1.default, { value: "Inline", label: "Source code" }),
                    React.createElement(RadioButton_1.default, { value: "Package", label: "File inside a package" })),
                this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline" && React.createElement("div", null,
                    React.createElement("br", null),
                    this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] &&
                        React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], language: jsonUtils_1.JsonUtils.tryParseJson(this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]) ?
                                CodeEditor_1.TextFormat.JSON : CodeEditor_1.TextFormat.YAML, allowFullScreen: false, readOnly: true, onChange: null }),
                    React.createElement("div", null,
                        React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] ? "Edit Source Code" : "Add Source Code", renderDialog: function (_a) {
                                var open = _a.open, closeDialog = _a.closeDialog;
                                return (React.createElement(sourceCodeDialog_1.default, { title: "Edit CloudFormation Template", open: open, close: closeDialog, template: _this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], doBusyTask: _this.props.doBusyTask, saveDone: function (template, metadata) {
                                        _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplate"] = template, _a));
                                        _this.refreshParametersFromMetadata(metadata);
                                        var _a;
                                    }, textFormat: !_this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"] ||
                                        jsonUtils_1.JsonUtils.tryParseJson(_this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"]) ?
                                        CodeEditor_1.TextFormat.JSON : CodeEditor_1.TextFormat.YAML, metadata: "CloudFormation" }));
                            } })))),
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Package" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.PackageId|Octopus.Action.Package.FeedId", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: "Choose the package that contains the template source." },
                    React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.CloudFormationTemplate|Octopus.Action.Aws.CloudFormationTemplateParametersRaw", isExpandedByDefault: this.props.expandedByDefault, title: "Paths", summary: this.pathsSummary(), help: "Enter relative the paths for the template and parameter files in the package." },
                    React.createElement(VariableLookupText_1.VariableLookupText, { label: "Template path", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplate"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplate"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationTemplate") }),
                    React.createElement(Note_1.default, null, "Relative path to the JSON template file contained in the package"),
                    React.createElement(VariableLookupText_1.VariableLookupText, { label: "Template parameters path", localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"], onChange: function (val) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = val, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationTemplateParametersRaw") }),
                    React.createElement(Note_1.default, null, "Relative path to the JSON parameters file contained in the package"))),
            this.props.properties["Octopus.Action.Aws.TemplateSource"] === "Inline" && this.state.parameterTypes && React.createElement("div", null,
                React.createElement(FormSectionHeading_1.default, { title: "Parameters" }),
                React.createElement(DynamicForm_1.default, { types: this.state.parameterTypes, values: this.state.parameterValues, isBindable: true, onChange: function (data) { return _this.updateParameters(data); }, getBoundFieldProps: function () { return ({ projectId: _this.props.projectId, localNames: _this.props.localNames }); } })));
    };
    AwsCloudFormationActionEdit.prototype.cloudFormationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.CloudFormationStackName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Creating stack ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.CloudFormationStackName"]),
                properties["Octopus.Action.Aws.Region"] && React.createElement("span", null,
                    " in ",
                    React.createElement("strong", null, properties["Octopus.Action.Aws.Region"])),
                properties["Octopus.Action.Aws.WaitForCompletion"] !== "False" && React.createElement("span", null, " waiting for completion"),
                properties["Octopus.Action.Aws.WaitForCompletion"] === "False" && React.createElement("span", null, " not waiting for completion"),
                properties["Octopus.Action.Aws.DisableRollback"] === "True" && React.createElement("span", null, ", with rollback disabled"),
                properties["Octopus.Action.Aws.IamCapabilities"] && properties["Octopus.Action.Aws.IamCapabilities"] !== "NONE" &&
                    React.createElement("span", null, ", and with IAM capabilities"),
                !properties["Octopus.Action.Aws.IamCapabilities"] || properties["Octopus.Action.Aws.IamCapabilities"] === "NONE" &&
                    React.createElement("span", null, ", and with no IAM capabilities")));
        }
        return form_1.Summary.placeholder("Specify the details of the CloudFormation stack");
    };
    AwsCloudFormationActionEdit.prototype.refreshParametersFromTemplate = function (template) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientInstance_1.repository.CloudTemplates.getMetadata(template, "CloudFormation")];
                    case 1:
                        response = _a.sent();
                        this.refreshParametersFromMetadata(response);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsCloudFormationActionEdit.prototype.refreshParametersFromMetadata = function (metadataResponse) {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var storedParameters, _a;
            return __generator(this, function (_b) {
                storedParameters = this.flattenParameters();
                Object.keys(metadataResponse.Values).forEach(function (key) {
                    if (storedParameters[key]) {
                        metadataResponse.Values[key] = storedParameters[key];
                    }
                });
                this.props.setProperties((_a = {},
                    _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = JSON.stringify(Object.keys(metadataResponse.Values).map(function (k) { return ({ ParameterKey: k, ParameterValue: metadataResponse.Values[k] }); })),
                    _a));
                this.syncParameters(metadataResponse.Values);
                this.setState({ parameterTypes: metadataResponse.Metadata.Types, parameterValues: metadataResponse.Values });
                return [2 /*return*/];
            });
        }); });
    };
    AwsCloudFormationActionEdit.prototype.flattenParameters = function () {
        var parameters = {};
        if (this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]) {
            var storedParameters = JSON.parse(this.props.properties["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"]);
            storedParameters.forEach(function (p) {
                parameters[p.ParameterKey] = p.ParameterValue;
            });
        }
        return parameters;
    };
    AwsCloudFormationActionEdit.prototype.updateParameters = function (data) {
        var objectKeys = Object.keys(data);
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.CloudFormationTemplateParametersRaw"] = JSON.stringify(objectKeys.map(function (k) { return ({ ParameterKey: k, ParameterValue: data[k] }); })),
            _a));
        this.syncParameters(data);
        var _a;
    };
    AwsCloudFormationActionEdit.prototype.syncParameters = function (data) {
        var objectKeys = Object.keys(data);
        /*
            Arrays are presented as new line separated strings, but are saved in the properties files
            as comma separated lists. So while Octopus.Action.Aws.CloudFormationTemplateParametersRaw
            retains the data input by the user, Octopus.Action.Aws.CloudFormationTemplateParameters
            is processed to contain the lists that CloudFormation expects.

            See https://github.com/aws/aws-cli/issues/1529 for details.
         */
        this.props.setProperties((_a = {},
            _a["Octopus.Action.Aws.CloudFormationTemplateParameters"] = JSON.stringify(objectKeys.map(function (k) {
                if (Array.isArray(data[k])) {
                    return { ParameterKey: k, ParameterValue: data[k].join(",") };
                }
                else {
                    // We can't have null values, only empty strings
                    return { ParameterKey: k, ParameterValue: data[k] || "" };
                }
            })),
            _a));
        var _a;
    };
    return AwsCloudFormationActionEdit;
}(BaseComponent_1.BaseComponent));
exports.default = function () { return ({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsRunCloudFormation",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsCloudFormationActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AwsCloudFormationActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
    features: {
        optional: [
            awsCloudFormationChangesetFeature_1.default().featureName
        ]
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsDeployCloudFormationAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsDeployCloudFormationAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var actionExecutionLocation_1 = __webpack_require__(46);
var scriptAction_1 = __webpack_require__(234);
var awsLoginComponent_1 = __webpack_require__(194);
var VariableLookupText_1 = __webpack_require__(21);
var ExpandableFormSection_1 = __webpack_require__(30);
var form_1 = __webpack_require__(16);
var ActionDetails_1 = __webpack_require__(25);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var AWSRunScriptActionSummary = (function (_super) {
    __extends(AWSRunScriptActionSummary, _super);
    function AWSRunScriptActionSummary(props) {
        return _super.call(this, props) || this;
    }
    AWSRunScriptActionSummary.prototype.render = function () {
        return React.createElement("div", null, "Log into AWS and run a script with the AWS CLI.");
    };
    return AWSRunScriptActionSummary;
}(BaseComponent_1.BaseComponent));
var AWSRunScriptActionEdit = (function (_super) {
    __extends(AWSRunScriptActionEdit, _super);
    function AWSRunScriptActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            feeds: [],
            accounts: []
        };
        return _this;
    }
    AWSRunScriptActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _e.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _e.sent(),
                                _b)]);
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.AssumeRole"] = "False", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _d), true);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AWSRunScriptActionEdit.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.Aws.Region", isExpandedByDefault: this.props.expandedByDefault, title: "Region", summary: this.regionSummary(), help: "Specify the default region" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes.")),
            React.createElement(scriptAction_1.ScriptActionEdit, { plugin: this.props.plugin, projectId: this.props.projectId, packages: this.props.packages, localNames: this.props.localNames, properties: this.props.properties, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, supportedLanguages: ScriptingLanguageSelector_1.SupportedLanguage.PowerShell, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }));
    };
    AWSRunScriptActionEdit.prototype.regionSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.Region"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Using ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.Region"]),
                " as the default region"));
        }
        return form_1.Summary.placeholder("Specify the default AWS region");
    };
    return AWSRunScriptActionEdit;
}(BaseComponent_1.BaseComponent));
exports.AWSRunScriptActionEdit = AWSRunScriptActionEdit;
exports.default = function () { return ({
    executionLocation: actionExecutionLocation_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsRunScript",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AWSRunScriptActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    edit: AWSRunScriptActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; },
    features: {
        optional: ["Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.SubstituteInFiles"],
    }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsRunScriptAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsRunScriptAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var FormSectionHeading_1 = __webpack_require__(48);
var form_1 = __webpack_require__(16);
var awsLoginComponent_1 = __webpack_require__(194);
var Note_1 = __webpack_require__(20);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var VariableLookupText_1 = __webpack_require__(21);
var StringCheckbox_1 = __webpack_require__(41);
var ExternalLink_1 = __webpack_require__(26);
var AwsApplyCloudFormationChangesetActionSummary = function (_a) {
    var targetRolesAsCSV = _a.targetRolesAsCSV;
    return React.createElement("div", null,
        "Apply a known CloudFormation change set",
        targetRolesAsCSV && React.createElement("span", null,
            " on behalf of targets in ",
            React.createElement(Roles_1.default, { rolesAsCSV: targetRolesAsCSV })));
};
var AwsApplyCloudFormationChangeSetActionEdit = (function (_super) {
    __extends(AwsApplyCloudFormationChangeSetActionEdit, _super);
    function AwsApplyCloudFormationChangeSetActionEdit(props) {
        return _super.call(this, props) || this;
    }
    AwsApplyCloudFormationChangeSetActionEdit.prototype.componentDidMount = function () {
        var _this = this;
        this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.props.properties["Octopus.Action.Aws.WaitForCompletion"]) {
                            this.props.setProperties((_c = {}, _c["Octopus.Action.Aws.WaitForCompletion"] = "True", _c), true);
                        }
                        if (!this.props.properties["Octopus.Action.Aws.AssumeRole"]) {
                            this.props.setProperties((_d = {}, _d["Octopus.Action.Aws.AssumeRole"] = "False", _d), true);
                        }
                        if (!this.props.properties["Octopus.Action.AwsAccount.UseInstanceRole"]) {
                            this.props.setProperties((_e = {}, _e["Octopus.Action.AwsAccount.UseInstanceRole"] = "False", _e), true);
                        }
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                    case 1:
                        _b.feeds = _f.sent();
                        return [4 /*yield*/, clientInstance_1.repository.Accounts.all()];
                    case 2:
                        _a.apply(this, [(_b.accounts = _f.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AwsApplyCloudFormationChangeSetActionEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(FormSectionHeading_1.default, { title: "AWS" }),
            React.createElement(awsLoginComponent_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, getFieldError: this.props.getFieldError, errors: this.props.errors, expandedByDefault: this.props.expandedByDefault }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Aws.Region|Octopus.Action.Aws.CloudFormationStackName", isExpandedByDefault: this.props.expandedByDefault, title: "CloudFormation", summary: this.cloudFormationSummary(), help: "Specify the details of the CloudFormation stack" },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.Region"], label: "Region", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.Region"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.Region") }),
                React.createElement(Note_1.default, null,
                    "View the ",
                    React.createElement(ExternalLink_1.default, { href: "AWSRegions" }, "AWS Regions and Endpoints"),
                    " documentation for a current list of the available region codes."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormationStackName"], label: "CloudFormation stack name", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormationStackName"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormationStackName") }),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.props.properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Arn"], label: "Change Set Name", onChange: function (val) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.CloudFormation.ChangeSet.Arn"] = val, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.Aws.CloudFormation.ChangeSet.Arn") }),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { resetValue: "True", value: properties["Octopus.Action.Aws.WaitForCompletion"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Aws.WaitForCompletion"] = x, _a));
                        var _a;
                    }, label: "Wait for completion" }),
                React.createElement(Note_1.default, null, "Select this checkbox to force the step to wait until the CloudFormation stack has been deleted before finishing the step. Be aware that unselecting this option means the step will not indicate an error if the stack was not removed successfully.")));
    };
    AwsApplyCloudFormationChangeSetActionEdit.prototype.cloudFormationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Aws.CloudFormationStackName"] && properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Arn"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Applying change set ",
                properties["Octopus.Action.Aws.CloudFormation.ChangeSet.Arn"],
                " to stack ",
                React.createElement("strong", null, properties["Octopus.Action.Aws.CloudFormationStackName"]),
                properties["Octopus.Action.Aws.Region"] && React.createElement("span", null,
                    " in ",
                    React.createElement("strong", null, properties["Octopus.Action.Aws.Region"])),
                properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " waiting for completion"),
                !properties["Octopus.Action.Aws.WaitForCompletion"] && React.createElement("span", null, " not waiting for completion")));
        }
        return form_1.Summary.placeholder("Specify the details of the CloudFormation stack and change set");
    };
    return AwsApplyCloudFormationChangeSetActionEdit;
}(BaseComponent_1.BaseComponent));
exports.default = function () { return ({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.AwsApplyCloudFormationChangeSet",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(AwsApplyCloudFormationChangesetActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: AwsApplyCloudFormationChangeSetActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsApplyCloudFormationAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\aws\\awsApplyCloudFormationAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var terraformAction_1 = __webpack_require__(302);
var TerraformApplyActionSummary = (function (_super) {
    __extends(TerraformApplyActionSummary, _super);
    function TerraformApplyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Apply a Terraform template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformApplyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, busy: this.props.busy, actionName: "apply", expandedByDefault: this.props.expandedByDefault });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformApply",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformApplyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformApplyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformApplyAction.tsx"); } } })();

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var terraformAction_1 = __webpack_require__(302);
var TerraformDestroyActionSummary = (function (_super) {
    __extends(TerraformDestroyActionSummary, _super);
    function TerraformDestroyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformDestroyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Destroy Terraform resources",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformDestroyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, busy: this.props.busy, actionName: "destroy", expandedByDefault: this.props.expandedByDefault });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformDestroy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformDestroyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformDestroyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformDestroyAction.tsx"); } } })();

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var terraformAction_1 = __webpack_require__(302);
var TerraformPlanActionSummary = (function (_super) {
    __extends(TerraformPlanActionSummary, _super);
    function TerraformPlanActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformPlanActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Plan a Terraform template",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformPlanActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, busy: this.props.busy, actionName: "plan", expandedByDefault: this.props.expandedByDefault });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformPlan",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformPlanActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformPlanAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformPlanAction.tsx"); } } })();

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var resources_1 = __webpack_require__(17);
var Roles_1 = __webpack_require__(37);
var ActionDetails_1 = __webpack_require__(25);
var terraformAction_1 = __webpack_require__(302);
var TerraformPlanDestroyActionSummary = (function (_super) {
    __extends(TerraformPlanDestroyActionSummary, _super);
    function TerraformPlanDestroyActionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformPlanDestroyActionSummary.prototype.render = function () {
        return React.createElement("div", null,
            "Plan the destruction of Terraform resources",
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " on behalf of targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV })));
    };
    return TerraformPlanDestroyActionSummary;
}(BaseComponent_1.BaseComponent));
var TerraformApplyActionEdit = (function (_super) {
    __extends(TerraformApplyActionEdit, _super);
    function TerraformApplyActionEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerraformApplyActionEdit.prototype.render = function () {
        return React.createElement(terraformAction_1.default, { projectId: this.props.projectId, properties: this.props.properties, packages: this.props.packages, setProperties: this.props.setProperties, setPackages: this.props.setPackages, plugin: this.props.plugin, errors: this.props.errors, getFieldError: this.props.getFieldError, doBusyTask: this.props.doBusyTask, busy: this.props.busy, actionName: "plan -destroy", expandedByDefault: this.props.expandedByDefault });
    };
    return TerraformApplyActionEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.TerraformPlanDestroy",
    summary: function (properties, targetRolesAsCSV) { return React.createElement(TerraformPlanDestroyActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV }); },
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    edit: TerraformApplyActionEdit,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return false; }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformPlanDestroyAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\terraform\\terraformPlanDestroyAction.tsx"); } } })();

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var routeLinks_1 = __webpack_require__(22);
var React = __webpack_require__(0);
var _ = __webpack_require__(11);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var clientInstance_1 = __webpack_require__(10);
var Roles_1 = __webpack_require__(37);
var resources_1 = __webpack_require__(17);
var InternalLink_1 = __webpack_require__(43);
var ExternalLink_1 = __webpack_require__(26);
var form_1 = __webpack_require__(16);
var PackageSelector_1 = __webpack_require__(53);
var PackageDownloadOptions_1 = __webpack_require__(118);
var CommonSummaryHelper_1 = __webpack_require__(62);
var getFeedName_1 = __webpack_require__(88);
var ActionDetails_1 = __webpack_require__(25);
var resources_2 = __webpack_require__(17);
var VhdActionSummary = (function (_super) {
    __extends(VhdActionSummary, _super);
    function VhdActionSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { feedName: null };
        return _this;
    }
    VhdActionSummary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pkg, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, getFeedName_1.getFeedName(pkg.FeedId)];
                    case 1:
                        _a.apply(this, [(_b.feedName = _c.sent(), _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    VhdActionSummary.prototype.render = function () {
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        return React.createElement("div", null,
            "Deploy VHD",
            React.createElement("strong", null,
                " ",
                pkg.PackageId,
                " "),
            "from ",
            this.state.feedName ? React.createElement("strong", null, this.state.feedName) : React.createElement("em", null, pkg.FeedId),
            this.props.targetRolesAsCSV && React.createElement("span", null,
                " to deployment targets in ",
                React.createElement(Roles_1.default, { rolesAsCSV: this.props.targetRolesAsCSV }),
                " "));
    };
    return VhdActionSummary;
}(BaseComponent_1.BaseComponent));
var VhdActionEdit = (function (_super) {
    __extends(VhdActionEdit, _super);
    function VhdActionEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.loadFeeds = function () {
            return _this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.setState;
                            _b = {};
                            return [4 /*yield*/, clientInstance_1.repository.Feeds.all()];
                        case 1:
                            _a.apply(this, [(_b.feeds = _c.sent(), _b)]);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.state = {
            feeds: []
        };
        return _this;
    }
    VhdActionEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFeeds()];
                    case 1:
                        _a.sent();
                        this.props.setPackages(resources_2.InitialisePrimaryPackageReference(this.props.packages), true);
                        return [2 /*return*/];
                }
            });
        });
    };
    VhdActionEdit.prototype.render = function () {
        var _this = this;
        // The package is initialized in componentDidMount, but render gets called before the update is propagated
        if (!this.props.packages || this.props.packages.length === 0) {
            return null;
        }
        var pkg = resources_2.GetPrimaryPackageReference(this.props.packages);
        var feed = _.find(this.state.feeds, function (f) { return f.Id === pkg.FeedId; });
        var help = this.state.feeds.length > 0
            ? React.createElement("span", null,
                "This step is used to deploy a VHD to one or more machines. The machines require Windows Server 2012 or newer. You can configure the remote machines to deploy to in the ",
                React.createElement(InternalLink_1.default, { to: routeLinks_1.default.infrastructure.root, openInSelf: false }, "Infrastructure"),
                " tab. The package that you wish to deploy should contain a single VHD or VHDX file in the root of the package.  Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "DocumentationPackaging" }, "what your packages should contain, and how to create them"),
                ".")
            : React.createElement("span", null, "Choose the package you which to deploy");
        return React.createElement("div", null,
            React.createElement(form_1.FormSectionHeading, { title: "Package Details" }),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "package", isExpandedByDefault: this.props.expandedByDefault, title: "Package", summary: CommonSummaryHelper_1.default.packageSummary(pkg, this.state.feeds), help: help },
                React.createElement(PackageSelector_1.default, { packageId: pkg.PackageId, feedId: pkg.FeedId, onPackageIdChange: function (packageId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ PackageId: packageId }, _this.props.packages)); }, onFeedIdChange: function (feedId) { return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ FeedId: feedId }, _this.props.packages)); }, packageIdError: this.props.getFieldError("Octopus.Action.Package.PackageId"), feedIdError: this.props.getFieldError("Octopus.Action.Package.FeedId"), projectId: this.props.projectId, feeds: this.state.feeds, localNames: this.props.localNames, refreshFeeds: this.loadFeeds }),
                React.createElement(PackageDownloadOptions_1.default, { packageAcquisitionLocation: pkg.AcquisitionLocation, onPackageAcquisitionLocationChanged: function (acquisitionLocation) {
                        return _this.props.setPackages(resources_1.SetPrimaryPackageReference({ AcquisitionLocation: acquisitionLocation }, _this.props.packages));
                    }, feed: feed, projectId: this.props.projectId, localNames: this.props.localNames })));
    };
    return VhdActionEdit;
}(BaseComponent_1.BaseComponent));
exports.VhdActionEdit = VhdActionEdit;
pluginRegistry_1.default.registerDeploymentAction({
    executionLocation: resources_1.ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.Vhd",
    summary: function (properties, targetRolesAsCSV, packages) { return React.createElement(VhdActionSummary, { properties: properties, targetRolesAsCSV: targetRolesAsCSV, packages: packages }); },
    edit: VhdActionEdit,
    canHaveChildren: function (step) { return true; },
    canBeChild: true,
    targetRoleOption: function (action) { return ActionDetails_1.TargetRoles.Optional; },
    hasPackages: function (action) { return true; },
    features: {
        permanent: ["Octopus.Features.Vhd"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.SubstituteInFiles"]
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\vhd\\vhdAction.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\vhd\\vhdAction.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var lodash_1 = __webpack_require__(11);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles": "",
    "Octopus.Action.Package.AdditionalXmlConfigurationTransforms": "",
};
var ConfigurationTransformsEdit = (function (_super) {
    __extends(ConfigurationTransformsEdit, _super);
    function ConfigurationTransformsEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationTransformsEdit.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props) || !lodash_1.isEqual(nextState, this.state);
    };
    ConfigurationTransformsEdit.prototype.summary = function () {
        var auto = this.props.properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] || "";
        var custom = this.props.properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"] || "";
        var summary = [];
        if (auto.toLowerCase() !== "false") {
            summary.push(React.createElement("span", null, "Default transforms (*.Release.config and *.EnvironmentName.config)"));
        }
        if (custom && custom.length > 0) {
            if (summary.length === 0) {
                summary.push(React.createElement("span", null, "Custom transforms"));
            }
            else {
                summary.push(React.createElement("span", null, " and custom transforms"));
            }
        }
        if (summary.length === 0) {
            return form_1.Summary.placeholder("No transforms will be run");
        }
        summary.push(React.createElement("span", null, " will be run"));
        return form_1.Summary.summary(React.Children.toArray(summary));
    };
    ConfigurationTransformsEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles|Octopus.Action.Package.AdditionalXmlConfigurationTransforms", isExpandedByDefault: this.props.expandedByDefault, title: "Configuration Transforms", summary: this.summary(), help: "Configure XML configuration transforms." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = x, _a));
                    var _a;
                }, label: "Run default XML transforms", note: React.createElement("span", null,
                    "Octopus can run configuration transformation files. By default Octopus looks for ",
                    React.createElement("em", null, "*.Release.config"),
                    " and ",
                    React.createElement("em", null, "*.<EnvironmentName>.config"),
                    ".") }),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.AdditionalXmlConfigurationTransforms"), label: "Additional transforms" }),
            React.createElement(Note_1.default, { checkboxNote: true },
                React.createElement("p", null, "A comma- or newline-separated list of additional configuration transformation file rules. Example:"),
                React.createElement("pre", null,
                    "Web.Release.config => Web.config",
                    React.createElement("br", null),
                    "*.Foo.config => *.config",
                    React.createElement("br", null),
                    "crossdomainpolicy.#",
                    "{",
                    "Octopus.Environment.Name}.xml => crossdomainpolicy.xml"),
                React.createElement("p", null,
                    "If your configuration file is named ",
                    React.createElement("em", null, "Bar.xml"),
                    ", and your transformation file is named ",
                    React.createElement("em", null, "Foo.xml"),
                    ", you should enter ",
                    React.createElement("em", null, "Foo.xml=>Bar.xml"),
                    ". Wildcards are supported so if you have config files named ",
                    React.createElement("em", null, "xyz.Bar.config"),
                    " and ",
                    React.createElement("em", null, "abc.Bar.config"),
                    ", and you have transform files named ",
                    React.createElement("em", null, "xyz.Foo.config"),
                    " and ",
                    React.createElement("em", null, "abc.Foo.config"),
                    ", you may enter ",
                    React.createElement("em", null, "*.Foo.config=>*.Bar.config"))));
    };
    return ConfigurationTransformsEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.ConfigurationTransforms",
    title: "Configuration Transforms",
    description: "Runs configuration file transforms, such as _Web.Release.config_",
    edit: ConfigurationTransformsEdit,
    priority: 21,
    enable: function (properties) {
        properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"];
        delete properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\configurationTransforms\\configurationTransforms.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\configurationTransforms\\configurationTransforms.tsx"); } } })();

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var ExternalLink_1 = __webpack_require__(26);
var StringCheckbox_1 = __webpack_require__(41);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings": "",
};
var ConfigurationVariablesEdit = (function (_super) {
    __extends(ConfigurationVariablesEdit, _super);
    function ConfigurationVariablesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationVariablesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    ConfigurationVariablesEdit.prototype.summary = function () {
        if ((this.props.properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] || "").toLowerCase() !== "false") {
            return form_1.Summary.summary(React.createElement("span", null,
                "Entries in ",
                React.createElement("em", null, ".config"),
                " files will be updated with variable values"));
        }
        return form_1.Summary.placeholder(React.createElement("span", null,
            "Entries in ",
            React.createElement("em", null, ".config"),
            " files will not be updated with variable values"));
    };
    ConfigurationVariablesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings", isExpandedByDefault: this.props.expandedByDefault, title: "Configuration Variables", summary: this.summary(), help: "If set, replace appSettings and connectionString entries in any .config files." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = x, _a));
                    var _a;
                }, label: "Replace entries in .config files", note: React.createElement("span", null,
                    "Tentacle will look inside your ",
                    React.createElement("em", null, ".config"),
                    " files and attempt to replace any `appSettings`, `applicationSettings` or `connectionStrings` entries that have a `key` or `name` that matches the name of a variable defined in Octopus. For more information, please ",
                    React.createElement(ExternalLink_1.default, { href: "ConfigurationVariables" }, "see the documentation"),
                    ".") }));
    };
    return ConfigurationVariablesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.ConfigurationVariables",
    title: "Configuration Variables",
    description: "Replace settings in any _.config_ files with variables defined in Octopus.",
    edit: ConfigurationVariablesEdit,
    priority: 20,
    enable: function (properties) {
        properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\configurationVariables\\configurationVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\configurationVariables\\configurationVariables.tsx"); } } })();

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var StringCheckbox_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Package.CustomInstallationDirectory": "",
    "Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment": "",
    "Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions": "",
    "Octopus.Action.Package.AdditionalXmlConfigurationTransforms": "",
};
var CustomDirectoryEdit = (function (_super) {
    __extends(CustomDirectoryEdit, _super);
    function CustomDirectoryEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomDirectoryEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    CustomDirectoryEdit.prototype.summary = function () {
        if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"]) {
            var nodes = [];
            nodes.push(React.createElement("span", null,
                "Package will be installed to ",
                React.createElement("strong", null, this.props.properties["Octopus.Action.Package.CustomInstallationDirectory"])));
            if (this.props.properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] === "True") {
                nodes.push(React.createElement("span", null, ", the directory will be purged before deployment"));
            }
            return form_1.Summary.summary(React.Children.toArray(nodes));
        }
        return form_1.Summary.placeholder(React.createElement("span", null, "Package will be installed to the standard location"));
    };
    CustomDirectoryEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var purge = properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"];
        var showExclude = purge && purge !== "False";
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.CustomInstallationDirectory|Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions", isExpandedByDefault: this.props.expandedByDefault, title: "Custom Install Directory", summary: this.summary(), help: "Enter a custom installation directory." },
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectory"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectory"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Package.CustomInstallationDirectory"), label: "Install to" }),
            React.createElement(Note_1.default, null, "After the package is extracted, it will be copied to this location on the remote machine."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = x, _a));
                    var _a;
                }, label: "Purge this directory before installation" }),
            React.createElement(Note_1.default, null, "Before the contents of the extracted package is copied, all files in this location will be removed."),
            showExclude &&
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] = x, _a));
                        var _a;
                    }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"), label: "Exclude from purge" }),
            showExclude && React.createElement(Note_1.default, null,
                "A newline-separated list of file or directory names, relative to the installation directory, to leave when it is purged. To exclude a whole directory, specify it by name without a wildcard. Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "appsettings.config"),
                ", ",
                React.createElement("em", null, "Config"),
                ", ",
                React.createElement("em", null, "Config\\*.config"),
                ", ",
                React.createElement("em", null, "**\\*.config")));
    };
    return CustomDirectoryEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.CustomDirectory",
    title: "Custom Installation Directory",
    description: "Change where Tentacle extracts your package",
    edit: CustomDirectoryEdit,
    priority: 5,
    disable: function (properties) {
        /*
            The java package deployment and this feature share the following properties. We can't
            delete them from the global properties object if UseCustomInstallationDirectory is defined.
         */
        if (properties["Octopus.Action.Package.UseCustomInstallationDirectory"] !== "True") {
            delete properties["Octopus.Action.Package.CustomInstallationDirectory"];
            delete properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"];
        }
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\customDirectory\\customDirectory.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\customDirectory\\customDirectory.tsx"); } } })();

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var CodeEditor_1 = __webpack_require__(107);
var Note_1 = __webpack_require__(20);
var scriptingLanguage_1 = __webpack_require__(157);
var ScriptingLanguageSelector_1 = __webpack_require__(165);
var ExpandableFormSection_1 = __webpack_require__(30);
var CustomScriptsEdit = (function (_super) {
    __extends(CustomScriptsEdit, _super);
    function CustomScriptsEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.syntaxExtensions = (_a = {}, _a[scriptingLanguage_1.ScriptingLanguage.PowerShell] = "ps1", _a[scriptingLanguage_1.ScriptingLanguage.CSharp] = "csx", _a[scriptingLanguage_1.ScriptingLanguage.Bash] = "sh", _a[scriptingLanguage_1.ScriptingLanguage.FSharp] = "fsx", _a);
        _this.extensionSyntaxes = { ps1: scriptingLanguage_1.ScriptingLanguage.PowerShell, csx: scriptingLanguage_1.ScriptingLanguage.CSharp, sh: scriptingLanguage_1.ScriptingLanguage.Bash, fsx: scriptingLanguage_1.ScriptingLanguage.FSharp };
        _this.customScriptPrefix = "Octopus.Action.CustomScripts.";
        _this.state = {
            PreDeploy: scriptingLanguage_1.ScriptingLanguage.PowerShell,
            Deploy: scriptingLanguage_1.ScriptingLanguage.PowerShell,
            PostDeploy: scriptingLanguage_1.ScriptingLanguage.PowerShell
        };
        return _this;
        var _a;
    }
    CustomScriptsEdit.prototype.componentDidMount = function () {
        var PreDeploy = this.lookupScriptSyntax("PreDeploy");
        var Deploy = this.lookupScriptSyntax("Deploy");
        var PostDeploy = this.lookupScriptSyntax("PostDeploy");
        this.setState({
            PreDeploy: PreDeploy,
            Deploy: Deploy,
            PostDeploy: PostDeploy
        });
    };
    CustomScriptsEdit.prototype.lookupScriptSyntax = function (scriptType) {
        var _this = this;
        // find the script variable, for Deploy it will look like Octopus.Action.CustomScripts.Deploy.{ps1|sh|csx|fsx}
        var syntax = scriptingLanguage_1.ScriptingLanguage.PowerShell;
        Object.keys(this.extensionSyntaxes).forEach(function (k) {
            var name = _this.customScriptPrefix + scriptType + "." + k;
            if (_this.props.properties.hasOwnProperty(name)) {
                syntax = _this.extensionSyntaxes[k];
            }
        });
        return syntax;
    };
    CustomScriptsEdit.prototype.syntaxChanged = function (scriptType, syntax, scriptBody) {
        var _this = this;
        // if changing from say ps1 to sh we need to delete Octopus.Action.CustomScripts.Deploy.ps1 and add Octopus.Action.CustomScripts.Deploy.sh
        var props = this.props.properties;
        Object.keys(this.extensionSyntaxes).forEach(function (k) {
            var name = _this.customScriptPrefix + scriptType + "." + k;
            if (_this.extensionSyntaxes[k] !== syntax && _this.props.properties.hasOwnProperty(name)) {
                delete props[name];
            }
        });
        props[this.customScriptPrefix + scriptType + "." + this.syntaxExtensions[syntax]] = scriptBody;
        this.props.setProperties(props);
        this.setState((_a = {},
            _a[scriptType] = syntax,
            _a));
        var _a;
    };
    CustomScriptsEdit.prototype.renderScriptSection = function (scriptType) {
        var _this = this;
        var syntax = this.state[scriptType];
        var scriptBody = this.getScriptBody(scriptType);
        return React.createElement("div", null,
            React.createElement(ScriptingLanguageSelector_1.default, { value: syntax, onChange: function (value) { return _this.syntaxChanged(scriptType, value, scriptBody); } }),
            React.createElement(CodeEditor_1.VariableLookupCodeEditor, { localNames: this.props.localNames, projectId: this.props.projectId, syntax: syntax, value: scriptBody, language: syntax, allowFullScreen: true, onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a[_this.customScriptPrefix + scriptType + "." + _this.syntaxExtensions[syntax]] = x, _a));
                    var _a;
                } }));
    };
    CustomScriptsEdit.prototype.getScriptBody = function (scriptType) {
        return this.props.properties[this.customScriptPrefix + scriptType + "." + this.syntaxExtensions[this.state[scriptType]]];
    };
    CustomScriptsEdit.prototype.summary = function () {
        var preDeploy = this.getScriptBody("PreDeploy");
        var deploy = this.getScriptBody("Deploy");
        var postDeploy = this.getScriptBody("PostDeploy");
        var configured = [];
        if (preDeploy) {
            configured.push("Pre-deploy");
        }
        if (deploy) {
            configured.push("Deploy");
        }
        if (postDeploy) {
            configured.push("Post-deploy");
        }
        if (configured.length === 0) {
            return form_1.Summary.placeholder("No scripts have been configured");
        }
        if (configured.length === 1) {
            return form_1.Summary.summary("A script will be run as part of the " + configured[0] + " phase");
        }
        if (configured.length === 2) {
            return form_1.Summary.summary("Scripts will be run as part of the " + configured[0] + " and " + configured[1] + " phases");
        }
        if (configured.length === 3) {
            return form_1.Summary.summary("Scripts will be run as part of the " + configured[0] + ", " + configured[1] + " and " + configured[2] + " phases");
        }
    };
    CustomScriptsEdit.prototype.render = function () {
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "customScripts", isExpandedByDefault: this.props.expandedByDefault, title: "Custom Deployment Scripts", fillCardWidth: ExpandableFormSection_1.CardFill.FillRight, summary: this.summary(), help: "Configure scripts to run as part of this step." },
            React.createElement("strong", null, "Pre-deployment script"),
            React.createElement(Note_1.default, null, "This script will run after the package is extracted, but before any configuration changes are made."),
            this.renderScriptSection("PreDeploy"),
            React.createElement("br", null),
            React.createElement("strong", null, "Deployment script"),
            React.createElement(Note_1.default, null, "This script will run after configuration changes and variable substitutions are made, but before any of the core deployment processes are made."),
            this.renderScriptSection("Deploy"),
            React.createElement("br", null),
            React.createElement("strong", null, "Post-deployment script"),
            React.createElement(Note_1.default, null, "This script will run after  core deployment processes are made."),
            this.renderScriptSection("PostDeploy"));
    };
    return CustomScriptsEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.CustomScripts",
    title: "Custom Deployment Scripts",
    description: "Execute scripts during the deployment, without embedding them in your package",
    edit: CustomScriptsEdit,
    priority: 10,
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.CustomScripts.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\customScripts\\customScripts.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\customScripts\\customScripts.tsx"); } } })();

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Package.UpdateIisWebsite": "",
    "Octopus.Action.Package.UpdateIisWebsiteName": "",
};
var IISHomeEdit = (function (_super) {
    __extends(IISHomeEdit, _super);
    function IISHomeEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IISHomeEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    IISHomeEdit.prototype.summary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.Package.UpdateIisWebsite"] !== "False") {
            if (properties["Octopus.Action.Package.UpdateIisWebsiteName"]) {
                return form_1.Summary.summary("Octopus will update the IIS website " + properties["Octopus.Action.Package.UpdateIisWebsiteName"]);
            }
            else {
                return form_1.Summary.summary("Octopus will find an IIS website based on the package name and attempt to update it");
            }
        }
        else {
            return form_1.Summary.placeholder("The IIS home directory will not be configured");
        }
    };
    IISHomeEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Package.UpdateIisWebsite|Octopus.Action.Package.UpdateIisWebsite", isExpandedByDefault: this.props.expandedByDefault, title: "IIS Home Directory", summary: this.summary(), help: "Configure whether we should automatically update IIS." },
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.Package.UpdateIisWebsite"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UpdateIisWebsite"] = x, _a));
                    var _a;
                }, label: "Attempt to automatically update IIS" }),
            React.createElement(Note_1.default, null, "Tentacle will look in IIS for a website with the same name as the current package (or the custom name below) and will attempt to change the home directory to point to the folder that the package was extracted to."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.UpdateIisWebsiteName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.UpdateIisWebsiteName"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.UpdateIisWebsiteName"), label: "Site/virtual directory" }),
            React.createElement(Note_1.default, null,
                "The name of the IIS website, or virtual directory path, to attempt to update. To specify a virtual directory, use the format:",
                React.createElement("pre", null, "WebsiteName/VirtualDirectory1/VirtualDirectory2"),
                "If no name is specified, Tentacle will look for an IIS site named with the same name as the package ID."));
    };
    return IISHomeEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.IisHome",
    title: "IIS6+ Home Directory",
    description: "Points an existing IIS website or virtual directory's 'Home' directory to the path the package was extracted to" +
        " (**not** compatible with the _IIS web site_ feature)",
    edit: IISHomeEdit,
    priority: 30,
    enable: function (properties) {
        properties["Octopus.Action.Package.UpdateIisWebsite"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.UpdateIisWebsite"];
        delete properties["Octopus.Action.Package.UpdateIisWebsiteName"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisHome\\iisHome.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisHome\\iisHome.tsx"); } } })();

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(26);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var bindingHelpers_1 = __webpack_require__(2133);
var isBound_1 = __webpack_require__(54);
var Note_1 = __webpack_require__(20);
var RadioButtonGroup_1 = __webpack_require__(36);
var RadioButton_1 = __webpack_require__(32);
var StringCheckbox_1 = __webpack_require__(41);
var VariableLookupText_1 = __webpack_require__(21);
var Callout_1 = __webpack_require__(58);
var applicationPool_1 = __webpack_require__(2134);
var RemoveItemsList_1 = __webpack_require__(84);
var Button_1 = __webpack_require__(47);
var lodash_1 = __webpack_require__(11);
var bindingDialog_1 = __webpack_require__(2135);
var ThumbprintText_1 = __webpack_require__(484);
var DialogOpener_1 = __webpack_require__(110);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var BindingList = (function (_super) {
    __extends(BindingList, _super);
    function BindingList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BindingList;
}(RemoveItemsList_1.RemoveItemsList));
var StringProperties = {
    "Octopus.Action.IISWebSite.DeploymentType": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath": "",
    "Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath": "",
    "Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate": "",
    "Octopus.Action.IISWebSite.WebApplication.WebSiteName": "",
    "Octopus.Action.IISWebSite.WebApplication.VirtualPath": "",
    "Octopus.Action.IISWebSite.WebApplication.PhysicalPath": "",
    "Octopus.Action.IISWebSite.CreateOrUpdateWebSite": "",
    "Octopus.Action.IISWebSite.StartApplicationPool": "",
    "Octopus.Action.IISWebSite.StartWebSite": "",
    "Octopus.Action.IISWebSite.Bindings": "",
    "Octopus.Action.IISWebSite.WebRootType": "",
    "Octopus.Action.IISWebSite.WebSiteName": "",
    "Octopus.Action.IISWebSite.WebRoot": "",
    "Octopus.Action.IISWebSite.EnableAnonymousAuthentication": "",
    "Octopus.Action.IISWebSite.EnableBasicAuthentication": "",
    "Octopus.Action.IISWebSite.EnableWindowsAuthentication": "",
    "Octopus.Action.IISWebSite.ApplicationPoolName": "",
    "Octopus.Action.IISWebSite.ApplicationPoolFrameworkVersion": "",
    "Octopus.Action.IISWebSite.ApplicationPoolIdentityType": "",
    "Octopus.Action.IISWebSite.ApplicationPoolUsername": "",
    "Octopus.Action.IISWebSite.ApplicationPoolPassword": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolName": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolFrameworkVersion": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolIdentityType": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolUsername": "",
    "Octopus.Action.IISWebSite.WebApplication.ApplicationPoolPassword": "",
    "Octopus.Action.WebApplication.WebRootType": ""
};
var IISWebSiteEdit = (function (_super) {
    __extends(IISWebSiteEdit, _super);
    function IISWebSiteEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.projectVariablesUnavailable = function () {
            return (!_this.props.projectId);
        };
        _this.handleWebRootTypeChanged = function (type, property, resetProperty) {
            _this.props.setProperties((_a = {}, _a[property] = type, _a));
            switch (type) {
                case "packageRoot": {
                    _this.resetPhysicalPath(resetProperty);
                }
            }
            var _a;
        };
        _this.handleDeploymentTypeChanged = function (type) {
            switch (type) {
                case "webSite": {
                    _this.selectWebSite();
                    break;
                }
                case "virtualDirectory": {
                    _this.selectVirtualDirectory();
                    break;
                }
                case "webApplication": {
                    _this.selectWebApplication();
                    break;
                }
            }
        };
        _this.selectVirtualDirectory = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "virtualDirectory",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "True",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "False",
                _a));
            var _a;
        };
        _this.selectWebSite = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "webSite",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True",
                _a));
            var _a;
        };
        _this.selectWebApplication = function () {
            _this.props.setProperties((_a = {},
                _a["Octopus.Action.IISWebSite.DeploymentType"] = "webApplication",
                _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = "False",
                _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = "True",
                _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "False",
                _a));
            var _a;
        };
        _this.checkWebSiteName = function (name) {
            _this.setState({ looksLikeVDir: name && (name.indexOf("/") !== -1 || name.indexOf("\\") !== -1) });
        };
        _this.checkWebRoot = function (path) {
            _this.setState({ looksLikeFullPath: path && path.indexOf(":") !== -1 });
        };
        _this.resetPhysicalPath = function (variableName) {
            _this.props.setProperties((_a = {}, _a[variableName] = "", _a));
            _this.setState({ looksLikeFullPath: false });
            var _a;
        };
        _this.removeBinding = function (b) {
            var bindings = _this.state.iisBindings.slice();
            bindings.splice(_this.state.iisBindings.indexOf(b), 1);
            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString(bindings), _a));
            var _a;
        };
        _this.editBinding = function (binding) {
            _this.setState({
                editBinding: lodash_1.clone(binding),
                editBindingIndex: _this.state.iisBindings.indexOf(binding)
            });
        };
        _this.addBinding = function () {
            var binding = {
                protocol: "http",
                port: "80",
                ipAddress: "*",
                host: "",
                thumbprint: null,
                enabled: true,
                requireSni: false
            };
            _this.setState({
                editBinding: binding,
                editBindingIndex: null
            });
        };
        _this.resetSelectedBinding = function () {
            _this.setState({
                editBinding: null,
                editBindingIndex: null
            });
        };
        _this.isPropTrue = function (name) {
            if (_this.props.properties[name]) {
                return _this.props.properties[name] === "True";
            }
            return true;
        };
        _this.state = {
            looksLikeVDir: false,
            looksLikeFullPath: false,
            isIISStep: false,
            iisBindings: [],
            editBinding: null,
            editBindingIndex: null,
            certificateMode: { managedByOctopus: false }
        };
        return _this;
    }
    IISWebSiteEdit.prototype.shouldComponentUpdate = function (newProps, newState) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props) || !lodash_1.isEqual(newState, this.state);
    };
    IISWebSiteEdit.prototype.saveBinding = function (binding) {
        var bindings = this.state.iisBindings.slice();
        if (this.state.editBindingIndex === null) {
            bindings.push(binding);
        }
        else {
            bindings[this.state.editBindingIndex] = binding;
        }
        this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString(bindings), _a));
        this.resetSelectedBinding();
        return true;
        var _a;
    };
    IISWebSiteEdit.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                            var hasPhysicalPath, _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                if (!this.props.properties["Octopus.Action.IISWebSite.DeploymentType"]) {
                                    this.selectWebSite();
                                }
                                hasPhysicalPath = this.props.properties["Octopus.Action.IISWebSite.WebRoot"] ||
                                    this.props.properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] ||
                                    this.props.properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"];
                                if (!this.props.properties["Octopus.Action.IISWebSite.WebRootType"] && hasPhysicalPath) {
                                    this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebRootType"] = "relativeToPackageRoot", _a));
                                }
                                else if (!this.props.properties["Octopus.Action.IISWebSite.WebRootType"] && !hasPhysicalPath) {
                                    this.props.setProperties((_b = {}, _b["Octopus.Action.IISWebSite.WebRootType"] = "packageRoot", _b));
                                }
                                if (!this.props.properties["Octopus.Action.IISWebSite.StartApplicationPool"]) {
                                    this.props.setProperties((_c = {}, _c["Octopus.Action.IISWebSite.StartApplicationPool"] = "True", _c));
                                }
                                if (!this.props.properties["Octopus.Action.IISWebSite.StartWebSite"]) {
                                    this.props.setProperties((_d = {}, _d["Octopus.Action.IISWebSite.StartWebSite"] = "True", _d));
                                }
                                this.setState({
                                    isIISStep: this.props.plugin.actionType === "Octopus.IIS",
                                    iisBindings: !!this.props.properties["Octopus.Action.IISWebSite.Bindings"] ? bindingHelpers_1.bindingsFromString(this.props.properties["Octopus.Action.IISWebSite.Bindings"]) : []
                                });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IISWebSiteEdit.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.properties["Octopus.Action.IISWebSite.Bindings"] !== nextProps.properties["Octopus.Action.IISWebSite.Bindings"]) {
            this.setState({ iisBindings: bindingHelpers_1.bindingsFromString(nextProps.properties["Octopus.Action.IISWebSite.Bindings"]) });
        }
    };
    IISWebSiteEdit.prototype.deploymentTypeSummary = function () {
        var type = this.props.properties["Octopus.Action.IISWebSite.DeploymentType"];
        if (type === "webSite") {
            return form_1.Summary.summary("IIS Web Site");
        }
        else if (type === "virtualDirectory") {
            return form_1.Summary.summary("IIS Virtual Directory");
        }
        else if (type === "webApplication") {
            return form_1.Summary.summary("IIS Web Application");
        }
        return form_1.Summary.placeholder("Deployment type not configured");
    };
    IISWebSiteEdit.prototype.webSiteSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] === "False") {
            return form_1.Summary.placeholder("The web site will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.WebSiteName"]) {
            return form_1.Summary.placeholder("The web site name has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "Web site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebSiteName"]),
            " will be created or updated"));
        if (properties["Octopus.Action.IISWebSite.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebRoot"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.authenticationSummary = function () {
        var modes = [];
        if (this.props.properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] !== "False") {
            modes.push("Anonymous");
        }
        if (this.props.properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] !== "False") {
            modes.push("Basic");
        }
        if (this.props.properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] !== "False") {
            modes.push("Windows");
        }
        if (modes.length === 0) {
            return form_1.Summary.placeholder("No authentication modes are enabled");
        }
        if (modes.length === 1) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                " authentication mode will be enabled"));
        }
        if (modes.length === 2) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                " and ",
                React.createElement("strong", null, modes[1]),
                " authentication modes will be enabled"));
        }
        if (modes.length === 3) {
            return form_1.Summary.summary(React.createElement("span", null,
                React.createElement("strong", null, modes[0]),
                ", ",
                React.createElement("strong", null, modes[1]),
                " and ",
                React.createElement("strong", null, modes[2]),
                " authentication modes will be enabled"));
        }
    };
    IISWebSiteEdit.prototype.bindingsSummary = function () {
        var length = this.state.iisBindings.length;
        if (length === 0) {
            return form_1.Summary.placeholder("No bindings have been configured");
        }
        var first = this.state.iisBindings[0];
        var address = first.ipAddress || "*";
        var summary = first.protocol + "://" + address + ":" + first.port;
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The site will listen on ",
            React.createElement("strong", null, summary)));
        if (length === 2) {
            nodes.push(React.createElement("span", null, " and one other binding"));
        }
        if (length > 2) {
            nodes.push(React.createElement("span", null,
                " and ",
                length - 1,
                " other bindings"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.virtualDirectorySummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] === "False") {
            return form_1.Summary.placeholder("The virtual directory will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"]) {
            return form_1.Summary.summary("The parent web site name has not been configured");
        }
        if (!properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"]) {
            return form_1.Summary.summary("The virtual path has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The virtual directory will be created under parent site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"])));
        nodes.push(React.createElement("span", null,
            " at virtual path ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"])));
        if (properties["Octopus.Action.IISWebSite.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.webApplicationSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] === "False") {
            return form_1.Summary.placeholder("The web application will not be created or updated");
        }
        if (!properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"]) {
            return form_1.Summary.summary("The parent web site name has not been configured");
        }
        if (!properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"]) {
            return form_1.Summary.summary("The virtual path has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "The web application will be created under parent site ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"])));
        nodes.push(React.createElement("span", null,
            " at virtual path ",
            React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"])));
        if (properties["Octopus.Action.WebApplication.WebRootType"] === "packageRoot") {
            nodes.push(React.createElement("span", null, ". Content will be served from the root of the installation directory"));
        }
        else {
            nodes.push(React.createElement("span", null,
                ". Content will be served from ",
                React.createElement("strong", null, properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] || "/"),
                " relative to the installation directory"));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    IISWebSiteEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        var editBindingDialog = React.createElement(DialogOpener_1.default, { open: !!this.state.editBinding, onClose: this.resetSelectedBinding },
            React.createElement(bindingDialog_1.default, { binding: this.state.editBinding, projectId: this.props.projectId, doBusyTask: this.props.doBusyTask, localNames: this.props.localNames, onAdd: function (binding) { return _this.saveBinding(binding); } }));
        return React.createElement("div", null,
            editBindingDialog,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.DeploymentType", isExpandedByDefault: this.props.expandedByDefault, title: "IIS Deployment Type", summary: this.deploymentTypeSummary(), help: "Configure the type of deployment." },
                React.createElement(Note_1.default, null,
                    "Learn more about deploying ",
                    React.createElement(ExternalLink_1.default, { href: "IISWebsitesAndApplications" }, "IIS Websites and Applications"),
                    "."),
                React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { value: properties["Octopus.Action.IISWebSite.DeploymentType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.DeploymentType"), onChange: function (val) { return _this.handleDeploymentTypeChanged(val); } },
                    React.createElement(RadioButton_1.default, { value: "webSite", label: "IIS Web Site" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Web Site"),
                    React.createElement(RadioButton_1.default, { value: "virtualDirectory", label: "IIS Virtual Directory" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Virtual Directory as a child of an existing IIS Web Site"),
                    React.createElement(RadioButton_1.default, { value: "webApplication", label: "IIS Web Application" }),
                    React.createElement(Note_1.default, null, "Create or update an IIS Web Application as a child of an existing IIS Web Site"))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "webSite" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.WebSiteName|Octopus.Action.IISWebSite.WebRoot", isExpandedByDefault: this.props.expandedByDefault, title: "Web Site", summary: this.webSiteSummary(), help: "Configure the details of the IIS Web Site." },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Web Site and Application Pool", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Site and Application Pool using the settings below.") })),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebSiteName"), label: "Web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                        "Hey there! It looks like you might be trying to configure a Virtual Directory. ",
                        React.createElement("em", null, "IIS Web Site"),
                        " doesn't support Virtual Directories. You might consider using either the ",
                        React.createElement("em", null, "IIS Virtual Directory"),
                        " or ",
                        React.createElement("em", null, "IIS Web Application"),
                        " deployment type for that, or check ",
                        React.createElement(ExternalLink_1.default, { href: "https://library.octopusdeploy.com" }, "the template library"),
                        " for more options."),
                    React.createElement(Note_1.default, null, "The display name of the IIS Web Site to create or reconfigure."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.IISWebSite.WebRootType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.IISWebSite.WebRootType", "Octopus.Action.IISWebSite.WebRoot"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Site to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.IISWebSite.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebRoot"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebRoot"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRoot"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this IIS Web Site to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified.")),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: this.props.properties["Octopus.Action.IISWebSite.StartWebSite"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.StartWebSite"] = x, _a));
                            var _a;
                        }, label: "Start IIS Web Site" }),
                    React.createElement(Note_1.default, null, "Whether the deployment step should start the IIS Web Site after a successful deployment or not.")),
                React.createElement(applicationPool_1.default, { properties: this.props.properties, setProperties: this.props.setProperties, projectId: this.props.projectId, localNames: this.props.localNames, pathToRootProperty: "Octopus.Action.IISWebSite", getFieldError: this.props.getFieldError, expandedByDefault: this.props.expandedByDefault }),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "bindings", isExpandedByDefault: this.props.expandedByDefault, title: "Bindings", summary: this.bindingsSummary(), help: "Bindings define what protocols, ports and host names this site will listen on" },
                    React.createElement(BindingList, { listActions: [React.createElement(Button_1.default, { key: "add", label: "Add", onClick: function () { return _this.addBinding(); } })], data: this.state.iisBindings, onRow: function (binding) { return React.createElement("div", null,
                            binding.protocol && React.createElement("p", null,
                                "Protocol: ",
                                React.createElement("strong", null, binding.protocol)),
                            binding.port && React.createElement("p", null,
                                "Port: ",
                                React.createElement("strong", null, binding.port)),
                            binding.ipAddress && React.createElement("p", null,
                                "IP Address: ",
                                React.createElement("strong", null, binding.ipAddress)),
                            binding.host && React.createElement("p", null,
                                "Host: ",
                                React.createElement("strong", null, binding.host)),
                            binding.thumbprint && React.createElement("p", null,
                                "SSL certificate thumbprint: ",
                                React.createElement(ThumbprintText_1.default, { thumbprint: binding.thumbprint })),
                            binding.certificateVariable && React.createElement("p", null,
                                "SSL certificate variable: ",
                                React.createElement("strong", null, binding.certificateVariable)),
                            binding.requireSni && React.createElement("p", null,
                                "Require Server Name Indication (SNI): ",
                                React.createElement("strong", null, binding.requireSni))); }, onRowTouch: function (binding) { return _this.editBinding(binding); }, onRemoveRow: function (binding) { return _this.removeBinding(binding); } })),
                React.createElement(form_1.ExpandableFormSection, { errorKey: "iisauthentication", isExpandedByDefault: this.props.expandedByDefault, title: "IIS Authentication", summary: this.authenticationSummary(), help: "Set which authentication modes will be enabled in IIS." },
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Anonymous authentication", note: React.createElement("span", null, "Whether IIS should allow anonymous authentication.") }),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Basic authentication", note: React.createElement("span", null, "Whether IIS should allow basic authentication with a 401 challenge.") }),
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = x, _a));
                            var _a;
                        }, label: "Enable Windows authentication", note: React.createElement("span", null, "Whether IIS should allow integrated Windows authentication with a 401 challenge.") }))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "virtualDirectory" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName|Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath", isExpandedByDefault: this.props.expandedByDefault, title: "Virtual Directory", summary: this.virtualDirectorySummary(), help: "Configure the details of the IIS Virtual Directory." },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Virtual Directory", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Virtual Directory and Application Pool using the settings below.") })),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"), label: "Parent web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information }, "Hey there! It looks like you might be trying to enter a Virtual Directory. Enter the parent web site name in this field, and the virtual path details below."),
                    React.createElement(Note_1.default, null, "The name of the parent Web Site for this Virtual Directory in IIS. The Web Site should already exist when this step runs."),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"), label: "Virtual path" }),
                    React.createElement(Note_1.default, null,
                        "The virtual path in IIS relative to the parent Web Site. E.g. ",
                        React.createElement("code", null, "/application1/directory2/mydirectory"),
                        ".",
                        React.createElement("br", null),
                        "Note: All parent directories/applications must already exist."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.IISWebSite.WebRootType"], error: this.props.getFieldError("Octopus.Action.IISWebSite.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.IISWebSite.WebRootType", "Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Site to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.IISWebSite.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.VirtualDirectory.PhysicalPath"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this Virtual Directory to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified.")))),
            properties["Octopus.Action.IISWebSite.DeploymentType"] === "webApplication" && React.createElement("div", null,
                React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.IISWebSite.WebApplication.WebSiteName|Octopus.Action.IISWebSite.WebApplication.VirtualPath", isExpandedByDefault: this.props.expandedByDefault, title: "Web Application", summary: this.webApplicationSummary(), help: "Configure the details of the IIS Web Application" },
                    !this.state.isIISStep && React.createElement("div", null,
                        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "False", value: properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"], onChange: function (x) {
                                return _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = x, _a));
                                var _a;
                            }, label: "Create or update an IIS Web Application", note: React.createElement("span", null, "If enabled, Tentacle will use the PowerShell Web Administration module to attempt to create or modify an IIS Web Application and Application Pool using the settings below.") })),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.WebSiteName"] = x, _a));
                            _this.checkWebSiteName(x);
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.WebSiteName"), label: "Parent web site name" }),
                    this.state.looksLikeVDir && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information }, "Hey there! It looks like you might be trying to enter a Virtual Directory. Enter the parent web site name in this field, and the virtual path details below."),
                    React.createElement(Note_1.default, null, "The name of the parent Web Site for this Web Application in IIS. The Web Site should already exist when this step runs."),
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"], onChange: function (x) {
                            _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.VirtualPath"] = x, _a));
                            var _a;
                        }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.VirtualPath"), label: "Virtual path" }),
                    React.createElement(Note_1.default, null,
                        "The virtual path in IIS relative to the parent Web Site. E.g. ",
                        React.createElement("code", null, "/myapplication"),
                        ".",
                        React.createElement("br", null),
                        "Note: All parent directories/applications must already exist."),
                    React.createElement(RadioButtonGroup_1.StringRadioButtonGroup, { label: "Physical path", value: properties["Octopus.Action.WebApplication.WebRootType"], error: this.props.getFieldError("Octopus.Action.WebApplication.WebRootType"), onChange: function (val) { return _this.handleWebRootTypeChanged(val, "Octopus.Action.WebApplication.WebRootType", "Octopus.Action.IISWebSite.WebApplication.PhysicalPath"); } },
                        React.createElement(RadioButton_1.default, { value: "packageRoot", label: "Package installation directory" }),
                        React.createElement(Note_1.default, null,
                            " Configure this IIS Web Application to serve content from the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified."),
                        React.createElement(RadioButton_1.default, { value: "relativeToPackageRoot", label: "Relative path under package installation directory" }),
                        properties["Octopus.Action.WebApplication.WebRootType"] === "relativeToPackageRoot" &&
                            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"], onChange: function (x) {
                                    _this.props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.WebApplication.PhysicalPath"] = x, _a));
                                    _this.checkWebRoot(x);
                                    var _a;
                                }, error: this.props.getFieldError("Octopus.Action.IISWebSite.WebApplication.PhysicalPath"), label: "Package installation directory" }),
                        this.state.looksLikeFullPath && React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Information },
                            "Hey there! It looks like you might be trying to configure the ",
                            React.createElement("em", null, "Physical Path"),
                            " as an absolute path. This will only work if the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " feature is enabled or if you are serving content that is not part of your package."),
                        React.createElement(Note_1.default, null,
                            "Configure this Web Application to serve content from a path that is relative to the folder that Octopus extracted the package to, or the ",
                            React.createElement(ExternalLink_1.default, { href: "CustomInstallationDirectory" }, "Custom Installation Directory"),
                            " if specified."))),
                React.createElement(applicationPool_1.default, { properties: this.props.properties, setProperties: this.props.setProperties, projectId: this.props.projectId, localNames: this.props.localNames, pathToRootProperty: "Octopus.Action.IISWebSite.WebApplication", getFieldError: this.props.getFieldError, expandedByDefault: this.props.expandedByDefault })));
    };
    return IISWebSiteEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.IISWebSite",
    title: "IIS Web Site and Application Pool",
    description: "Creates or reconfigures an IIS website and application pool (requires IIS7+)",
    edit: IISWebSiteEdit,
    priority: 8,
    enable: function (properties) {
        properties["Octopus.Action.IISWebSite.DeploymentType"] = "webSite";
        properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True";
        properties["Octopus.Action.IISWebSite.Bindings"] = bindingHelpers_1.bindingsToString([{ protocol: "http", port: "80", host: "", enabled: true }]);
        setupApplicationPoolDefaults(properties, "Octopus.Action.IISWebSite");
        properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = "False";
        properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = "False";
        properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = "True";
        setupApplicationPoolDefaults(properties, "Octopus.Action.IISWebSite.WebApplication");
        function setupApplicationPoolDefaults(p, pathToRootProperty) {
            p[pathToRootProperty + ".ApplicationPoolFrameworkVersion"] = "v4.0";
            p[pathToRootProperty + ".ApplicationPoolIdentityType"] = "ApplicationPoolIdentity";
        }
    },
    preSave: function (properties) {
        normalizeApplicationPoolData(properties, "Octopus.Action.IISWebSite");
        normalizeApplicationPoolData(properties, "Octopus.Action.IISWebSite.WebApplication");
        function normalizeApplicationPoolData(p, pathToRootProperty) {
            if (p[pathToRootProperty + ".ApplicationPoolIdentityType"] !== "SpecificUser" && !isBound_1.default(p[pathToRootProperty + ".ApplicationPoolIdentityType"])) {
                p[pathToRootProperty + ".ApplicationPoolUsername"] = null;
                p[pathToRootProperty + ".ApplicationPoolPassword"] = null;
            }
        }
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.IISWebSite.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\iisWebSite.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\iisWebSite.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var bindingsFromString = function (bindingString) {
    try {
        var result = parseV2Format();
        if (typeof result === "object") {
            return result;
        }
        return parseV1Format();
    }
    catch (ex) {
        return parseV1Format();
    }
    function parseV1Format() {
        var map = function (b) {
            var bindingParts = b.split("/");
            var bindingInfo = bindingParts[1].split(":");
            var enabled = bindingParts.length >= 4 ? (bindingParts[3] === "True") : true;
            var requireSni = bindingParts.length >= 5 ? (bindingParts[4] === "True") : false;
            return {
                protocol: bindingParts[0],
                enabled: enabled,
                thumbprint: bindingParts[2],
                ipAddress: bindingInfo[0],
                port: bindingInfo[1],
                host: bindingInfo[2],
                requireSni: requireSni
            };
        };
        return bindingString.split("|").map(map);
    }
    function parseV2Format() {
        return JSON.parse(bindingString);
    }
};
exports.bindingsFromString = bindingsFromString;
var bindingsToString = function (bindings) {
    var map = function (b) {
        var isHttp = (b.protocol === "http");
        //strip http etc except inside #{...} variable declarations
        b.host = b.host
            .split(/(#{.*?})/g)
            .map(function (h) {
            return /^#{.*}$/.test(h)
                ? h
                : h.replace("//", "").replace("/", "").replace("https:", "").replace("http:", "");
        })
            .join("");
        return {
            protocol: b.protocol,
            ipAddress: b.ipAddress,
            port: b.port,
            host: b.host,
            thumbprint: isHttp ? null : b.thumbprint,
            certificateVariable: isHttp ? null : b.certificateVariable,
            requireSni: isHttp ? false : b.requireSni,
            enabled: b.enabled
        };
    };
    var result = bindings.map(map);
    return JSON.stringify(result);
};
exports.bindingsToString = bindingsToString;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\bindingHelpers.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\bindingHelpers.ts"); } } })();

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var getResetValue_1 = __webpack_require__(426);
var Select_1 = __webpack_require__(40);
var isBound_1 = __webpack_require__(54);
var Sensitive_1 = __webpack_require__(93);
var StringCheckbox_1 = __webpack_require__(41);
var form_2 = __webpack_require__(16);
var applicationPool = function (props) {
    var fullPath = function (propertyName) {
        return props.pathToRootProperty + "." + propertyName;
    };
    var frameworkVersions = [
        { value: "v4.0", text: "v4.0" },
        { value: "v2.0", text: "v2.0" },
        { value: "No Managed Code", text: "No Managed Code" }
    ];
    var appPoolIdentities = [
        { value: "ApplicationPoolIdentity", text: "Application Pool Identity" },
        { value: "LocalService", text: "Local Service" },
        { value: "LocalSystem", text: "Local System" },
        { value: "NetworkService", text: "Network Service" },
        { value: "SpecificUser", text: "Custom user..." },
    ];
    var applicationPoolSummary = function () {
        if (!props.properties[fullPath("ApplicationPoolName")]) {
            return form_1.Summary.placeholder("The Application Pool has not been configured");
        }
        var nodes = [];
        nodes.push(React.createElement("span", null,
            "Application Pool ",
            React.createElement("strong", null, props.properties[fullPath("ApplicationPoolName")]),
            " will be created if required and used."));
        if (props.properties[fullPath("ApplicationPoolFrameworkVersion")] === "No Managed Code") {
            nodes.push(React.createElement("span", null, " It will be configured with no .NET CLR support"));
        }
        else {
            nodes.push(React.createElement("span", null,
                " The .NET framework version will be ",
                React.createElement("strong", null, props.properties[fullPath("ApplicationPoolFrameworkVersion")])));
        }
        var identity = appPoolIdentities.find(function (p) { return props.properties[fullPath("ApplicationPoolIdentityType")] === p.value; });
        if (identity) {
            if (identity.value === "SpecificUser") {
                if (!props.properties[fullPath("ApplicationPoolUsername")]) {
                    nodes.push(React.createElement("span", null, ", and the pool will run as a custom user that has not been configured"));
                }
                else {
                    nodes.push(React.createElement("span", null,
                        ", and the pool will run as ",
                        React.createElement("strong", null, props.properties[fullPath("ApplicationPoolUsername")])));
                }
            }
            else {
                nodes.push(React.createElement("span", null,
                    ", and the pool will run as ",
                    React.createElement("strong", null, identity.text)));
            }
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    return React.createElement(form_1.ExpandableFormSection, { errorKey: fullPath("ApplicationPoolName"), isExpandedByDefault: props.expandedByDefault, title: "Application Pool", summary: applicationPoolSummary(), help: "Configure the details of the IIS Application Pool that will be created and used." },
        React.createElement(VariableLookupText_1.VariableLookupText, { localNames: props.localNames, projectId: props.projectId, value: props.properties[fullPath("ApplicationPoolName")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolName")] = x, _a));
                var _a;
            }, label: "Application Pool name", error: props.getFieldError(fullPath("ApplicationPoolName")), validate: form_2.required("Please enter an Application Pool name") }),
        React.createElement(Note_1.default, null, "Name of the application pool in IIS to create or reconfigure."),
        React.createElement(Select_1.BoundSelect, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "v4.0", value: props.properties[fullPath("ApplicationPoolFrameworkVersion")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolFrameworkVersion")] = x, _a));
                var _a;
            }, items: frameworkVersions, error: props.getFieldError(fullPath("ApplicationPoolFrameworkVersion")), hintText: ".NET CLR version", label: ".NET CLR version" }),
        React.createElement(Note_1.default, null,
            "The version of the .NET common language runtime that this application pool will use. Choose ",
            React.createElement("strong", null, "v2.0"),
            " for applications built against .NET 2.0, 3.0 or 3.5. Choose ",
            React.createElement("strong", null, "v4.0"),
            " for .NET 4.0 or 4.5"),
        React.createElement(Select_1.BoundSelect, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "ApplicationPoolIdentity", value: props.properties[fullPath("ApplicationPoolIdentityType")], onChange: function (x) {
                return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolIdentityType")] = x, _a));
                var _a;
            }, items: appPoolIdentities, error: props.getFieldError(fullPath("ApplicationPoolIdentityType")), hintText: "Identity", label: "Identity" }),
        React.createElement(Note_1.default, null, "Which built-in account will the application pool run under."),
        (props.properties[fullPath("ApplicationPoolIdentityType")] === "SpecificUser" || isBound_1.default(props.properties[fullPath("ApplicationPoolIdentityType")])) && React.createElement("div", null,
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: props.localNames, projectId: props.projectId, value: props.properties[fullPath("ApplicationPoolUsername")], onChange: function (x) {
                    return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolUsername")] = x, _a));
                    var _a;
                }, error: props.getFieldError(fullPath("ApplicationPoolUsername")), label: "Username" }),
            React.createElement(Note_1.default, null,
                "The Windows/domain account of the custom user that the application pool will run under. Example: ",
                React.createElement("code", null, "YOURDOMAIN\\YourAccount"),
                ". You will need to ensure that this user has permissions to run as an application pool."),
            React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                    localNames: props.localNames,
                    projectId: props.projectId
                }, resetValue: getResetValue_1.default(props.properties[fullPath("ApplicationPoolPassword")]), value: props.properties[fullPath("ApplicationPoolPassword")], onChange: function (x) {
                    return props.setProperties((_a = {}, _a[fullPath("ApplicationPoolPassword")] = x, _a));
                    var _a;
                }, label: "Password" }),
            React.createElement(Note_1.default, null, "The password for the custom account given above.")),
        React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                localNames: props.localNames,
                projectId: props.projectId
            }, resetValue: "False", value: props.properties["Octopus.Action.IISWebSite.StartApplicationPool"], onChange: function (x) {
                return props.setProperties((_a = {}, _a["Octopus.Action.IISWebSite.StartApplicationPool"] = x, _a));
                var _a;
            }, label: "Start IIS Application Pool" }),
        React.createElement(Note_1.default, null, "Whether the deployment step should start the IIS Application Pool after a successful deployment or not."));
};
exports.default = applicationPool;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\applicationPool.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\applicationPool.tsx"); } } })();

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var VariableLookupText_1 = __webpack_require__(21);
var OkDialogLayout_1 = __webpack_require__(65);
var DataBaseComponent_1 = __webpack_require__(39);
var Select_1 = __webpack_require__(40);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var CertificateVariableSelect_1 = __webpack_require__(191);
var clientInstance_1 = __webpack_require__(10);
var isBound_1 = __webpack_require__(54);
var form_1 = __webpack_require__(16);
var RadioButton_1 = __webpack_require__(32);
var DialogFormSectionHeading_1 = __webpack_require__(2136);
var BindingDialog = (function (_super) {
    __extends(BindingDialog, _super);
    function BindingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProtocolChanged = function (protocol) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.setBindingState({ protocol: protocol });
                    if (protocol === "https") {
                        this.setBindingState({ port: "443" });
                    }
                    return [2 /*return*/];
                });
            }); });
        };
        _this.handleManagedByOctopusChanged = function (managed) {
            _this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!managed) {
                        this.setState(function (state) { return ({
                            binding: __assign({}, state.binding, { certificateVariable: null }),
                            managedByOctopus: managed
                        }); });
                    }
                    else {
                        this.setState(function (state) { return ({
                            binding: __assign({}, state.binding, { thumbprint: null }),
                            managedByOctopus: managed
                        }); });
                    }
                    return [2 /*return*/];
                });
            }); });
        };
        _this.save = function () {
            var binding = _this.state.binding;
            if (_this.state.binding.protocol === "https" && !_this.state.managedByOctopus) {
                if (!_this.state.binding.thumbprint || _this.state.binding.thumbprint.trim() === "") {
                    _this.setError("An SSL certificate thumbprint must be provided for HTTPS bindings.");
                    return false;
                }
                if (!isBound_1.default(_this.state.binding.thumbprint)) {
                    binding.thumbprint = binding.thumbprint.replace(/[^0-9A-z]/g, "");
                }
            }
            return _this.props.onAdd(binding);
        };
        _this.state = {
            binding: null,
            managedByOctopus: false,
            resetCertificate: null,
            project: null
        };
        return _this;
    }
    BindingDialog.prototype.componentDidMount = function () {
        var _this = this;
        this.doBusyTask(function () { return __awaiter(_this, void 0, void 0, function () {
            var project, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, clientInstance_1.repository.Projects.get(this.props.projectId)];
                    case 1:
                        _a = (_b.sent());
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        project = _a;
                        this.setState({
                            binding: this.props.binding,
                            managedByOctopus: !!this.props.binding.certificateVariable,
                            resetCertificate: this.props.binding.certificateVariable,
                            project: project
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BindingDialog.prototype.render = function () {
        var _this = this;
        return React.createElement(OkDialogLayout_1.default, { onOkClick: this.save, busy: this.state.busy, errors: this.state.errors, title: "Add Binding" }, this.state.binding && React.createElement("div", null,
            React.createElement(Select_1.BoundSelect, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "http", value: this.state.binding.protocol, onChange: this.handleProtocolChanged, items: [{ value: "http", text: "HTTP" }, { value: "https", text: "HTTPS" }], hintText: "Protocol", label: "Protocol" }),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.port, onChange: function (x) { return _this.setBindingState({ port: x }); }, label: "Port" }),
            React.createElement(Note_1.default, null, "The TCP port number that this binding will listen on."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.ipAddress, onChange: function (x) { return _this.setBindingState({ ipAddress: x }); }, label: "IP address" }),
            React.createElement(Note_1.default, null,
                "The IP address that the binding will listen on. Use ",
                React.createElement("code", null, "*"),
                " for any address, or specify an address such as ",
                React.createElement("code", null, "10.0.0.1"),
                ". If using a IPv6 address remember to enclose in square brackets such as ",
                React.createElement("code", null, "[::1]"),
                "."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.host, onChange: function (x) { return _this.setBindingState({ host: x }); }, label: "Host name" }),
            React.createElement(Note_1.default, null,
                "The host header that this binding will listen on. Example:",
                React.createElement("code", null, "www.contoso.com"),
                ". Leave empty to use any host header."),
            this.state.binding.protocol !== "http" && React.createElement("div", null,
                React.createElement(DialogFormSectionHeading_1.default, { title: "Certificate" }),
                React.createElement(form_1.BooleanRadioButtonGroup, { label: "Is the HTTPS certificate managed by Octopus or externally?", value: this.state.managedByOctopus, onChange: this.handleManagedByOctopusChanged },
                    React.createElement(RadioButton_1.default, { value: true, label: "Certificate managed by Octopus", isDefault: true }),
                    React.createElement(Note_1.default, null, "If the certificate is managed by Octopus, it will be automatically imported into the Windows Certificate Store."),
                    React.createElement(RadioButton_1.default, { value: false, label: "Certificate managed externally" }),
                    React.createElement(Note_1.default, null, "If managed externally, the certificate thumbprint is configured. The certificate must have been imported into the Windows Certificate Store.")),
                !this.state.managedByOctopus && React.createElement("div", null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.thumbprint, onChange: function (x) { return _this.setBindingState({ thumbprint: x }); }, label: "SSL thumbprint" }),
                    React.createElement(Note_1.default, null, "The X.509 certificate thumbprint to use.")),
                this.state.managedByOctopus && React.createElement("div", null,
                    this.state.project
                        ? React.createElement(CertificateVariableSelect_1.BoundCertificateVariableSelect, { variableLookup: {
                                localNames: this.props.localNames,
                                projectId: this.props.projectId
                            }, resetValue: "", projectId: this.props.projectId, doBusyTask: this.doBusyTask, value: this.state.binding.certificateVariable, onChange: function (x) { return _this.setBindingState({ certificateVariable: x }); } })
                        : React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: this.state.binding.certificateVariable, onChange: function (x) { return _this.setBindingState({ certificateVariable: x }); }, label: "Certificate variable" }),
                    React.createElement(Note_1.default, null, "A certificate variable.")),
                React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "False", title: "Server name identification", value: this.state.binding.requireSni.toString(), onChange: function (x) { return _this.setBindingState({ requireSni: x }); }, label: "Required" })),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", title: "Binding status", value: this.state.binding.enabled.toString(), onChange: function (x) { return _this.setBindingState({ enabled: x }); }, label: "Enabled", note: React.createElement("span", null, "Disable this binding to skip it (the binding will not be added).") })));
    };
    BindingDialog.prototype.setBindingState = function (state, callback) {
        this.setChildState1("binding", state);
    };
    return BindingDialog;
}(DataBaseComponent_1.DataBaseComponent));
exports.default = BindingDialog;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\bindingDialog.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\iisWebSite\\bindingDialog.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(117);
// use as a section heading in dialogs where we want it to push to the edge despite
// dialogs having margin on the content
var DialogFormSectionHeading = (function (_super) {
    __extends(DialogFormSectionHeading, _super);
    function DialogFormSectionHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFormSectionHeading.prototype.render = function () {
        return React.createElement("div", { className: styles.dialogSectionHeading },
            React.createElement("div", { className: styles.sectionHeadingTitle }, this.props.title));
    };
    return DialogFormSectionHeading;
}(React.Component));
exports.default = DialogFormSectionHeading;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\DialogFormSectionHeading.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\form\\Sections\\DialogFormSectionHeading.tsx"); } } })();

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(91);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var MoreInfo_1 = __webpack_require__(326);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Package.JsonConfigurationVariablesEnabled": "",
    "Octopus.Action.Package.JsonConfigurationVariablesTargets": "",
};
var JsonConfigurationVariablesEdit = (function (_super) {
    __extends(JsonConfigurationVariablesEdit, _super);
    function JsonConfigurationVariablesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonConfigurationVariablesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    JsonConfigurationVariablesEdit.prototype.summary = function () {
        var json = this.props.properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"] || "";
        if (json.length > 0) {
            return form_1.Summary.summary(React.createElement("span", null, "Variable substitution will be performed on configured JSON files"));
        }
        else {
            return form_1.Summary.placeholder("No JSON files configured");
        }
    };
    JsonConfigurationVariablesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "jsonvariables", isExpandedByDefault: this.props.expandedByDefault, title: "JSON Configuration Variables", summary: this.summary(), help: "Configure JSON file variable replacements." },
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Package.JsonConfigurationVariablesTargets"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.Package.JsonConfigurationVariablesTargets"), label: "Target files" }),
            React.createElement(Note_1.default, null,
                "A comma- or newline-separated list of file names to replace settings in, relative to the package contents.  Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "appsettings.json"),
                ", ",
                React.createElement("em", null, "Config\\*.json"),
                ", ",
                React.createElement("em", null, "**\\specific-folder\\*.json."),
                ". Configuration values can be replaced using a ",
                React.createElement("code", null, ":"),
                " separated key, starting from the root of the hierarchy."),
            React.createElement(MoreInfo_1.default, { content: React.createElement("div", null,
                    React.createElement("p", null,
                        "Consider the following ",
                        React.createElement("em", null, "appsettings.json"),
                        " file:"),
                    React.createElement("pre", null, "{\n    \"Data\": {\n    \"DefaultConnection\": {\n    \"ConnectionString\": \"Server=(localdb)\\SQLEXPRESS;Database=OctoFX;Trusted_Connection=True\"\n         }\n    }\n}"),
                    React.createElement("p", null,
                        "To replace the value of ",
                        React.createElement("code", null, "ConnectionString"),
                        " you would add a variable name ",
                        React.createElement("code", null, "Data:DefaultConnection:ConnectionString"),
                        " to your project variables / library variable set. The JSON also supports ",
                        React.createElement(ExternalLink_1.default, { href: "VariableSubstitutionSyntaxExtended" }, "extended template syntax"),
                        "."),
                    React.createElement("p", null,
                        "The 'Target files' field supports ",
                        React.createElement(ExternalLink_1.default, { href: "VariableSubstitutionSyntaxExtended" }, "extended template syntax"),
                        ". Conditional ",
                        React.createElement("code", null, "if"),
                        " and ",
                        React.createElement("code", null, "unless"),
                        ":"),
                    React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                    React.createElement("p", null,
                        "Iteration over variable sets or comma-separated values with ",
                        React.createElement("code", null, "each"),
                        ":"),
                    React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")) }));
    };
    return JsonConfigurationVariablesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.JsonConfigurationVariables",
    title: "JSON Configuration Variables",
    description: "Replace settings in selected JSON files with variables defined in Octopus.",
    edit: JsonConfigurationVariablesEdit,
    priority: 15,
    enable: function (properties) {
        properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"];
        delete properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\jsonConfigurationVariables\\jsonConfigurationVariables.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\jsonConfigurationVariables\\jsonConfigurationVariables.tsx"); } } })();

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(91);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var VariableLookupText_1 = __webpack_require__(21);
var Note_1 = __webpack_require__(20);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.SubstituteInFiles.TargetFiles": "",
    "Octopus.Action.SubstituteInFiles.OutputEncoding": "",
};
var SubstituteInFilesEdit = (function (_super) {
    __extends(SubstituteInFilesEdit, _super);
    function SubstituteInFilesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubstituteInFilesEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    SubstituteInFilesEdit.prototype.summary = function () {
        var json = this.props.properties["Octopus.Action.SubstituteInFiles.TargetFiles"] || "";
        if (json.length > 0) {
            return form_1.Summary.summary(React.createElement("span", null, "Variable substitution will be performed on configured files"));
        }
        else {
            return form_1.Summary.placeholder("No files configured");
        }
    };
    SubstituteInFilesEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.SubstituteInFiles.TargetFiles|Octopus.Action.SubstituteInFiles.OutputEncoding", isExpandedByDefault: this.props.expandedByDefault, title: "Substitute Variables in Files", summary: this.summary(), help: "Configure files to perform variable substitution on." },
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.SubstituteInFiles.TargetFiles"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.SubstituteInFiles.TargetFiles"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.SubstituteInFiles.TargetFiles"), multiLine: true, label: "Target files" }),
            React.createElement(Note_1.default, null,
                "A newline-separated list of file names to transform, relative to the package contents. Extended wildcard syntax is supported. E.g., ",
                React.createElement("em", null, "Notes.txt"),
                ", ",
                React.createElement("em", null, "Config\\*.json"),
                ", ",
                React.createElement("em", null, "**\\specific-folder\\*.config."),
                React.createElement("br", null),
                "This field supports extended template syntax. Conditional ",
                React.createElement("code", null, "if"),
                " and ",
                React.createElement("code", null, "unless"),
                ":",
                React.createElement("pre", null, "#{if MyVar}...#{/if}"),
                "Iteration over variable sets or comma-separated values with ",
                React.createElement("code", null, "each"),
                ":",
                React.createElement("pre", null, "#{each mv in MyVar}...#{mv}...#{/each}")),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.SubstituteInFiles.OutputEncoding"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.SubstituteInFiles.OutputEncoding"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.SubstituteInFiles.OutputEncoding"), multiLine: true, hintText: "Detect from template", label: "Output file encoding" }),
            React.createElement(Note_1.default, null,
                "The name of an encoding to use when writing the transformed file. E.g., ",
                React.createElement("em", null, "utf-8"),
                ".",
                React.createElement("br", null),
                "For a list of supported encoding names, see the Remarks section of the ",
                React.createElement(ExternalLink_1.default, { href: "EncodingNames" }, "System.Text.Encoding"),
                " class on MSDN."));
    };
    return SubstituteInFilesEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.SubstituteInFiles",
    title: "Substitute Variables in Files",
    description: "Transforms files using the Octopus <code>#{Variable}</code> substitution syntax",
    edit: SubstituteInFilesEdit,
    priority: 22,
    enable: function (properties) {
        properties["Octopus.Action.SubstituteInFiles.Enabled"] = "True";
    },
    disable: function (properties) {
        delete properties["Octopus.Action.SubstituteInFiles.TargetFiles"];
        delete properties["Octopus.Action.SubstituteInFiles.OutputEncoding"];
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\substituteInFiles\\substituteInFiles.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\substituteInFiles\\substituteInFiles.tsx"); } } })();

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalLink_1 = __webpack_require__(26);
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var StringCheckbox_1 = __webpack_require__(41);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Callout_1 = __webpack_require__(58);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.RedGateDatabase.Enabled": "",
    "Octopus.Action.RedGateDatabase.DatabaseName": "",
    "Octopus.Action.RedGateDatabase.ConnectionStrings": "",
    "Octopus.Action.RedGateDatabase.PostDeployValidationEnabled": "",
    "Octopus.Action.RedGateDatabase.SqlCiPath": "",
    "Octopus.Action.RedGateDatabase.SqlComparePath": "",
    "Octopus.Action.RedGateDatabase.CompareOptions": "",
};
var RedgateDatabaseEdit = (function (_super) {
    __extends(RedgateDatabaseEdit, _super);
    function RedgateDatabaseEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RedgateDatabaseEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    RedgateDatabaseEdit.prototype.summary = function () {
        if (this.props.properties["Octopus.Action.RedGateDatabase.Enabled"] !== "False") {
            return form_1.Summary.summary("Database package deployment is enabled");
        }
        else {
            return form_1.Summary.placeholder("Database package deployment is not enabled");
        }
    };
    RedgateDatabaseEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.RedGateDatabase.SqlCiPath|Octopus.Action.RedGateDatabase.SqlComparePathOctopus.Action.RedGateDatabase.ConnectionStrings", isExpandedByDefault: this.props.expandedByDefault, title: "Red Gate Database", summary: this.summary(), help: "Configure Red Gate database package deployment." },
            React.createElement(Callout_1.Callout, { type: Callout_1.CalloutType.Warning },
                "SQL Release has been replaced by DLM Automation. Don't worry: You can continue to use this feature until you decide to start using DLM Automation. For more information refer to our ",
                React.createElement(ExternalLink_1.default, { href: "RedGateSQLRelease" }, "documentation"),
                "."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.RedGateDatabase.Enabled"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.Enabled"] = x, _a));
                    var _a;
                }, label: "Enable Red Gate database package deployment" }),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.DatabaseName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.DatabaseName"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.DatabaseName"), label: "Database name" }),
            React.createElement(Note_1.default, null, "The name of the SQL database to deploy."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.ConnectionStrings"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.ConnectionStrings"] = x, _a));
                    var _a;
                }, multiLine: true, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.ConnectionStrings"), label: "SQL Servers" }),
            React.createElement(Note_1.default, null,
                "A list of SQL Server connection strings for the databases to deploy to. Each connection string should be on a new line.",
                React.createElement("br", null),
                "You can use variables to define different connection strings for each environment, and then reference them:",
                React.createElement("pre", null, "#{MyConnectionString}")),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "False", value: properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = x, _a));
                    var _a;
                }, label: "Validate that no other changes to the database have been made outside this deployment" }),
            React.createElement(Note_1.default, null, "Check that the deployment was successful, and that no changes were made outside of Octopus during the deployment. If validation fails, it stops the deployment after the database upgrade."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.SqlCiPath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.SqlCiPath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.SqlCiPath"), label: "SQLCI.exe path" }),
            React.createElement(Note_1.default, null, "The path to Red Gate's SQLCI.exe."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.SqlComparePath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.SqlComparePath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.SqlComparePath"), label: "SQLCompare.exe path" }),
            React.createElement(Note_1.default, null, "The path to the Red Gate's SQLCompare.exe."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.RedGateDatabase.CompareOptions"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.RedGateDatabase.CompareOptions"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.RedGateDatabase.CompareOptions"), label: "Comparison options" }),
            React.createElement(Note_1.default, null, "The options to pass to the SQL Compare engine. To use multiple options, separate each option with commas or semicolons."));
    };
    return RedgateDatabaseEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.RedGateDatabase",
    title: "Red Gate Database Deployment",
    description: "Deploy a database using SQLCI.exe from Red Gate",
    edit: RedgateDatabaseEdit,
    priority: 100,
    enable: function (properties) {
        properties["Octopus.Action.RedGateDatabase.Enabled"] = "True";
        properties["Octopus.Action.RedGateDatabase.CompareOptions"] = "IgnoreUsers,IgnoreCertificatesAndCryptoKeys,ForceColumnOrder,ThrowOnFileParseFailed";
        properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = "True";
        properties["Octopus.Action.RedGateDatabase.SqlCiPath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\sqlCI.exe";
        properties["Octopus.Action.RedGateDatabase.SqlComparePath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\SC\\SQLCompare.exe";
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.RedGateDatabase.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    },
    validate: function (properties, errors) {
        if (!properties["Octopus.Action.RedGateDatabase.SqlCiPath"]) {
            errors["Octopus.Action.RedGateDatabase.SqlCiPath"] = "Please specify a path to SQLCI.exe.";
        }
        if (!properties["Octopus.Action.RedGateDatabase.SqlComparePath"]) {
            errors["Octopus.Action.RedGateDatabase.SqlComparePath"] = "Please specify a path to SQLCompare.exe.";
        }
        if (!properties["Octopus.Action.RedGateDatabase.ConnectionStrings"]) {
            errors["Octopus.Action.RedGateDatabase.ConnectionStrings"] = "Please specify the connection strings to the databases that you wish to deploy.";
        }
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\redgateDatabase\\redgateDatabase.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\redgateDatabase\\redgateDatabase.tsx"); } } })();

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var Note_1 = __webpack_require__(20);
var StringCheckbox_1 = __webpack_require__(41);
var VariableLookupText_1 = __webpack_require__(21);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringProperties = {
    "Octopus.Action.Vhd.ApplicationPath": "",
    "Octopus.Action.Vhd.DeployVhdToVm": "",
    "Octopus.Action.Vhd.VmName": "",
};
var VhdEdit = (function (_super) {
    __extends(VhdEdit, _super);
    function VhdEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VhdEdit.prototype.shouldComponentUpdate = function (nextProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    };
    VhdEdit.prototype.summary = function () {
        var properties = this.props.properties;
        var nodes = [];
        if (properties["Octopus.Action.Vhd.ApplicationPath"]) {
            nodes.push(React.createElement("span", null,
                "The application path is ",
                React.createElement("strong", null, properties["Octopus.Action.Vhd.ApplicationPath"]),
                "."));
        }
        else {
            return form_1.Summary.placeholder("No application path has been set");
        }
        if (properties["Octopus.Action.Vhd.DeployVhdToVm"] !== "False") {
            if (properties["Octopus.Action.Vhd.VmName"]) {
                nodes.push(React.createElement("span", null,
                    " The VHD will be attached to Hyper-V VM ",
                    React.createElement("strong", null, properties["Octopus.Action.Vhd.VmName"])));
            }
            else {
                nodes.push(React.createElement("span", null, " The VHD will be attached to a Hyper-V VM, but no VM has been set"));
            }
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    VhdEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.Vhd.ApplicationPath|Octopus.Action.Vhd.VmName", isExpandedByDefault: this.props.expandedByDefault, title: "VHD Configuration", summary: this.summary(), help: "Configure operations on the VHD as part of the deployment." },
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Vhd.ApplicationPath"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.ApplicationPath"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Vhd.ApplicationPath"), label: "VHD application path" }),
            React.createElement(Note_1.default, null,
                "The folder within the VHD that contains your application. For example ",
                React.createElement("em", null, "PublishedApps\\MyApplication"),
                ". Octopus will look in this folder when performing substitutions and transforms."),
            React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }, resetValue: "", value: properties["Octopus.Action.Vhd.DeployVhdToVm"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.DeployVhdToVm"] = x, _a));
                    var _a;
                }, label: "Add VHD to Hyper-V" }),
            React.createElement(Note_1.default, null, "Attach the VHD to a Hyper-V Virtual Machine."),
            React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.Vhd.VmName"], onChange: function (x) {
                    return _this.props.setProperties((_a = {}, _a["Octopus.Action.Vhd.VmName"] = x, _a));
                    var _a;
                }, error: this.props.getFieldError("Octopus.Action.Vhd.VmName"), label: "Virtual machine name" }),
            React.createElement(Note_1.default, null, "The name of the Hyper-V Virtual Machine to update. The VM will be shut down, the VHD will be added, replacing the current first vitual drive if there is one, then the VHD will be restarted."));
    };
    return VhdEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.Vhd",
    title: "Vhd",
    description: "Allows other features to be performed on the contents of a VHD before optionally attaching it to a Virtual Machine",
    edit: VhdEdit,
    priority: 30,
    validate: function (properties, errors) {
        if (properties["Octopus.Action.Vhd.DeployVhdToVm"] && !properties["Octopus.Action.Vhd.VmName"]) {
            errors["Octopus.Action.Vhd.VmName"] = "Please enter a name for the Virtual Machine.";
        }
        if (!properties["Octopus.Action.Vhd.ApplicationPath"]) {
            errors["Octopus.Action.Vhd.ApplicationPath"] = "Please enter an application path for this VHD.";
        }
    },
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\vhd\\vhd.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\vhd\\vhd.tsx"); } } })();

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var form_1 = __webpack_require__(16);
var getResetValue_1 = __webpack_require__(426);
var isBound_1 = __webpack_require__(54);
var Note_1 = __webpack_require__(20);
var VariableLookupText_1 = __webpack_require__(21);
var Select_1 = __webpack_require__(40);
var Sensitive_1 = __webpack_require__(93);
var ValueInPropertiesHasChanged_1 = __webpack_require__(89);
var StringCheckbox_1 = __webpack_require__(41);
var StringProperties = {
    "Octopus.Action.WindowsService.CreateOrUpdateService": "",
    "Octopus.Action.WindowsService.ServiceName": "",
    "Octopus.Action.WindowsService.DisplayName": "",
    "Octopus.Action.WindowsService.Description": "",
    "Octopus.Action.WindowsService.ExecutablePath": "",
    "Octopus.Action.WindowsService.Arguments": "",
    "Octopus.Action.WindowsService.ServiceAccount": "",
    "Octopus.Action.WindowsService.CustomAccountName": "",
    "Octopus.Action.WindowsService.CustomAccountPassword": "",
    "Octopus.Action.WindowsService.StartMode": "",
    "Octopus.Action.WindowsService.Dependencies": ""
};
var WindowsServiceEdit = (function (_super) {
    __extends(WindowsServiceEdit, _super);
    function WindowsServiceEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serviceAccounts = [
            { text: "Local System", value: "LocalSystem" },
            { text: "Network Service", value: "NT Authority\\NetworkService" },
            { text: "Local Service", value: "NT Authority\\LocalService" },
            { text: "Custom user...", value: "_CUSTOM" }
        ];
        _this.startModes = [
            { text: "Automatic", value: "auto" },
            { text: "Automatic (delayed)", value: "delayed-auto" },
            { text: "Manual", value: "demand" },
            { text: "Unchanged", value: "unchanged" }
        ];
        return _this;
    }
    WindowsServiceEdit.prototype.shouldComponentUpdate = function (newProps) {
        return ValueInPropertiesHasChanged_1.ValueInPropertiesOrErrorsHasChanged(StringProperties, newProps, this.props);
    };
    WindowsServiceEdit.prototype.serviceSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.WindowsService.CreateOrUpdateService"] === "False") {
            return form_1.Summary.placeholder("No windows service will be installed");
        }
        if (properties["Octopus.Action.WindowsService.ServiceName"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "Windows service ",
                React.createElement("strong", null, properties["Octopus.Action.WindowsService.ServiceName"]),
                " will be installed"));
        }
        return form_1.Summary.summary("A windows service will be installed but a Service Name has not been configured");
    };
    WindowsServiceEdit.prototype.executableSummary = function () {
        var properties = this.props.properties;
        if (properties["Octopus.Action.WindowsService.ExecutablePath"]) {
            return form_1.Summary.summary(React.createElement("span", null,
                "The executable is ",
                React.createElement("strong", null, properties["Octopus.Action.WindowsService.ExecutablePath"])));
        }
        else {
            return form_1.Summary.placeholder("No executable has been configured for the windows service");
        }
    };
    WindowsServiceEdit.prototype.startupSummary = function () {
        var properties = this.props.properties;
        var user = this.serviceAccounts.find(function (p) { return p.value === properties["Octopus.Action.WindowsService.ServiceAccount"]; });
        var nodes = [];
        if (user && user.value === "_CUSTOM") {
            if (properties["Octopus.Action.WindowsService.CustomAccountName"]) {
                nodes.push(React.createElement("span", null,
                    "The service will run as ",
                    React.createElement("strong", null, properties["Octopus.Action.WindowsService.CustomAccountName"])));
            }
            else {
                nodes.push(React.createElement("span", null,
                    "The service will run as ",
                    React.createElement("strong", null, "Custom User Account")));
            }
        }
        else if (isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) {
            nodes.push("The service user account is set by a bound variable");
        }
        else if (user !== undefined) {
            nodes.push(React.createElement("span", null,
                "The service will run as ",
                React.createElement("strong", null, user.text)));
        }
        var startMode = this.startModes.find(function (p) { return p.value === properties["Octopus.Action.WindowsService.StartMode"]; });
        if (isBound_1.default(properties["Octopus.Action.WindowsService.StartMode"])) {
            nodes.push(", the start mode is set by a bound variable");
        }
        else if (startMode !== undefined) {
            nodes.push(React.createElement("span", null,
                ", the start mode is ",
                React.createElement("strong", null, startMode.text)));
        }
        return form_1.Summary.summary(React.Children.toArray(nodes));
    };
    WindowsServiceEdit.prototype.render = function () {
        var _this = this;
        var properties = this.props.properties;
        return React.createElement("div", null,
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ServiceName|Octopus.Action.WindowsService.DisplayName", isExpandedByDefault: this.props.expandedByDefault, title: "Windows Service", summary: this.serviceSummary(), help: "Configure a windows service deployment." },
                this.props.plugin.actionType !== "Octopus.WindowsService" && React.createElement("div", null,
                    React.createElement(StringCheckbox_1.BoundStringCheckbox, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: "False", value: properties["Octopus.Action.WindowsService.CreateOrUpdateService"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CreateOrUpdateService"] = x, _a));
                            var _a;
                        }, label: "Install a Windows Service" }),
                    React.createElement(Note_1.default, null,
                        "If enabled, Tentacle will use ",
                        React.createElement("code", null, "sc.exe"),
                        " to attempt to create a Windows Service using the settings below. If the service already exists, Tentacle will stop the service, reconfigure it, and start it again.")),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.ServiceName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ServiceName"] = x, _a));
                        var _a;
                    }, label: "Service name", error: this.props.getFieldError("Octopus.Action.WindowsService.ServiceName") }),
                React.createElement(Note_1.default, null, "The name of the Windows Service to create or configure."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.DisplayName"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.DisplayName"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.DisplayName"), label: "Display name" }),
                React.createElement(Note_1.default, null, "Optional display name of the Windows Service."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Description"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Description"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Description"), label: "Description" }),
                React.createElement(Note_1.default, null, "User-friendly description of the service.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ExecutablePath|Octopus.Action.WindowsService.Arguments", isExpandedByDefault: this.props.expandedByDefault, title: "Windows Service: Executable", summary: this.executableSummary(), help: "Configure the executable of the service." },
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.ExecutablePath"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ExecutablePath"] = x, _a));
                        var _a;
                    }, label: "Executable path", error: this.props.getFieldError("Octopus.Action.WindowsService.ExecutablePath") }),
                React.createElement(Note_1.default, null,
                    "Path to the executable file for the service. The path should be relative to the package installation directory; for example:",
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("code", null, "MyService.exe")),
                        React.createElement("li", null,
                            React.createElement("code", null, "bin\\MyService.exe")))),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Arguments"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Arguments"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Arguments"), label: "Arguments" }),
                React.createElement(Note_1.default, null, "Command line arguments that will be passed to the service when it starts each time.")),
            React.createElement(form_1.ExpandableFormSection, { errorKey: "Octopus.Action.WindowsService.ServiceAccount|Octopus.Action.WindowsService.ServiceAccount|Octopus.Action.WindowsService.Dependencies", isExpandedByDefault: this.props.expandedByDefault, title: "Windows Service: Startup", summary: this.startupSummary(), help: "Configure the startup options of the service." },
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "LocalSystem", value: properties["Octopus.Action.WindowsService.ServiceAccount"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.ServiceAccount"] = x, _a));
                        var _a;
                    }, items: this.serviceAccounts, error: this.props.getFieldError("Octopus.Action.WindowsService.ServiceAccount"), hintText: "Service account", label: "Service account" }),
                React.createElement(Note_1.default, null, "Which built-in account will the service run under."),
                (properties["Octopus.Action.WindowsService.ServiceAccount"] === "_CUSTOM" || isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) && React.createElement("div", null,
                    React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.CustomAccountName"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CustomAccountName"] = x, _a));
                            var _a;
                        }, label: "Custom account name" }),
                    React.createElement(Note_1.default, null,
                        "The Windows/domain account of the custom user that the service will run under. Example: ",
                        React.createElement("code", null, "YOURDOMAIN\\YourAccount"),
                        ". You will need to ensure that this user has the 'Log on as a service' right."),
                    React.createElement(Sensitive_1.BoundSensitive, { variableLookup: {
                            localNames: this.props.localNames,
                            projectId: this.props.projectId
                        }, resetValue: getResetValue_1.default(this.props.properties["Octopus.Action.WindowsService.CustomAccountPassword"]), value: properties["Octopus.Action.WindowsService.CustomAccountPassword"], onChange: function (x) {
                            return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.CustomAccountPassword"] = x, _a));
                            var _a;
                        }, label: "Custom account password" }),
                    React.createElement(Note_1.default, null, "The password for the custom account given above.")),
                React.createElement(Select_1.BoundSelect, { variableLookup: {
                        localNames: this.props.localNames,
                        projectId: this.props.projectId
                    }, resetValue: "auto", value: properties["Octopus.Action.WindowsService.StartMode"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.StartMode"] = x, _a));
                        var _a;
                    }, items: this.startModes, error: this.props.getFieldError("Octopus.Action.WindowsService.StartMode"), hintText: "Start mode", label: "Start mode" }),
                React.createElement(Note_1.default, null,
                    "When will the service start? Use ",
                    React.createElement("em", null, "Unchanged"),
                    " to use the current status."),
                React.createElement(VariableLookupText_1.VariableLookupText, { localNames: this.props.localNames, projectId: this.props.projectId, value: properties["Octopus.Action.WindowsService.Dependencies"], onChange: function (x) {
                        return _this.props.setProperties((_a = {}, _a["Octopus.Action.WindowsService.Dependencies"] = x, _a));
                        var _a;
                    }, error: this.props.getFieldError("Octopus.Action.WindowsService.Dependencies"), label: "Dependencies" }),
                React.createElement(Note_1.default, null,
                    "Any dependencies that the service has. Separate the names using forward slashes (/). For example: ",
                    React.createElement("code", null, "LanmanWorkstation/TCPIP/MSSQL"),
                    ".")));
    };
    return WindowsServiceEdit;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.WindowsService",
    title: "Windows Service",
    description: "Creates or reconfigures a Windows Service using _sc.exe_",
    edit: WindowsServiceEdit,
    priority: 8,
    enable: function (properties) {
        properties["Octopus.Action.WindowsService.CreateOrUpdateService"] = "True";
        properties["Octopus.Action.WindowsService.ServiceAccount"] = "LocalSystem";
        properties["Octopus.Action.WindowsService.StartMode"] = "auto";
    },
    preSave: function (properties) {
        if (properties["Octopus.Action.WindowsService.ServiceAccount"] !== "_CUSTOM"
            && !isBound_1.default(properties["Octopus.Action.WindowsService.ServiceAccount"])) {
            properties["Octopus.Action.WindowsService.CustomAccountName"] = null;
            properties["Octopus.Action.WindowsService.CustomAccountPassword"] = null;
        }
    },
    validate: function (properties, errors) {
        if (!properties["Octopus.Action.WindowsService.ServiceName"]) {
            errors["Octopus.Action.WindowsService.ServiceName"] = "Please enter a service name for the Windows Service.";
        }
        if (!properties["Octopus.Action.WindowsService.ExecutablePath"]) {
            errors["Octopus.Action.WindowsService.ExecutablePath"] = "Please enter an executable path for this Windows Service.";
        }
    },
    disable: function (properties) {
        Object.keys(properties).filter(function (name) {
            return name.indexOf("Octopus.Action.WindowsService.") === 0;
        }).forEach(function (name) {
            delete properties[name];
        });
    }
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\windowsService\\windowsService.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\windowsService\\windowsService.tsx"); } } })();

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var kubernetesIngressComponent_1 = __webpack_require__(759);
var KubernetesIngressEditFeature = (function (_super) {
    __extends(KubernetesIngressEditFeature, _super);
    function KubernetesIngressEditFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KubernetesIngressEditFeature.prototype.render = function () {
        return React.createElement(kubernetesIngressComponent_1.KubernetesIngressComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true, standAlone: false });
    };
    return KubernetesIngressEditFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.KubernetesIngress",
    title: "Ingress",
    description: "Defines a Kubernetes Ingress resource, which is used to map HTTP traffic to Service resources based on host name and URL path",
    edit: KubernetesIngressEditFeature,
    priority: 10
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesIngressFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesIngressFeature.tsx"); } } })();

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var BaseComponent_1 = __webpack_require__(12);
var kubernetesServiceComponent_1 = __webpack_require__(758);
var pluginRegistry_1 = __webpack_require__(18);
var KubernetesServiceEditFeature = (function (_super) {
    __extends(KubernetesServiceEditFeature, _super);
    function KubernetesServiceEditFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KubernetesServiceEditFeature.prototype.render = function () {
        return React.createElement(kubernetesServiceComponent_1.KubernetesServiceComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true });
    };
    return KubernetesServiceEditFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.KubernetesService",
    title: "Service",
    description: "Defines a Kubernetes Service resource, which is used to expose Pod resources",
    edit: KubernetesServiceEditFeature,
    priority: 10
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesServiceFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesServiceFeature.tsx"); } } })();

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var kubernetesConfigMapComponent_1 = __webpack_require__(760);
var KubernetesConfigMapFeature = (function (_super) {
    __extends(KubernetesConfigMapFeature, _super);
    function KubernetesConfigMapFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KubernetesConfigMapFeature.prototype.render = function () {
        return React.createElement(kubernetesConfigMapComponent_1.KubernetesConfigMapComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true });
    };
    return KubernetesConfigMapFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.KubernetesConfigMap",
    title: "Config Map",
    description: "Defines a Kubernetes ConfigMap resource, which is a collection of key/value settings",
    edit: KubernetesConfigMapFeature,
    priority: 20
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesConfigMapFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesConfigMapFeature.tsx"); } } })();

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var kubernetesSecretComponent_1 = __webpack_require__(761);
var KubernetesSecretFeature = (function (_super) {
    __extends(KubernetesSecretFeature, _super);
    function KubernetesSecretFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KubernetesSecretFeature.prototype.render = function () {
        return React.createElement(kubernetesSecretComponent_1.KubernetesSecretComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true });
    };
    return KubernetesSecretFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.KubernetesSecret",
    title: "Secret",
    description: "Defines a Kubernetes Secret resource, which is a collection of key/value settings",
    edit: KubernetesSecretFeature,
    priority: 20
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesSecretFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesSecretFeature.tsx"); } } })();

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var pluginRegistry_1 = __webpack_require__(18);
var BaseComponent_1 = __webpack_require__(12);
var kubernetesCustomResourceComponent_1 = __webpack_require__(2147);
var KubernetesCustomResourceFeature = (function (_super) {
    __extends(KubernetesCustomResourceFeature, _super);
    function KubernetesCustomResourceFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KubernetesCustomResourceFeature.prototype.render = function () {
        return React.createElement(kubernetesCustomResourceComponent_1.KubernetesCustomResourceComponent, { properties: this.props.properties, packages: this.props.packages, plugin: this.props.plugin, getFieldError: this.props.getFieldError, setProperties: this.props.setProperties, setPackages: this.props.setPackages, doBusyTask: this.props.doBusyTask, busy: this.props.busy, errors: this.props.errors, projectId: this.props.projectId, expandedByDefault: true });
    };
    return KubernetesCustomResourceFeature;
}(BaseComponent_1.BaseComponent));
pluginRegistry_1.default.registerFeature({
    featureName: "Octopus.Features.KubernetesCustomResource",
    title: "Custom Resource",
    description: "Create Kubernetes resources from raw YAML",
    edit: KubernetesCustomResourceFeature,
    priority: 20
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesCustomResourceFeature.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Features\\kubernetes\\kubernetesCustomResourceFeature.tsx"); } } })();

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DataBaseComponent_1 = __webpack_require__(90);
var ExpandableFormSection_1 = __webpack_require__(30);
var Summary_1 = __webpack_require__(44);
var CodeEditor_1 = __webpack_require__(107);
var OpenDialogButton_1 = __webpack_require__(72);
var sourceCodeDialog_1 = __webpack_require__(429);
var Note_1 = __webpack_require__(20);
var ExternalLink_1 = __webpack_require__(26);
var KubernetesCustomResourceComponent = (function (_super) {
    __extends(KubernetesCustomResourceComponent, _super);
    function KubernetesCustomResourceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    KubernetesCustomResourceComponent.prototype.render = function () {
        var _this = this;
        return React.createElement(ExpandableFormSection_1.default, { errorKey: "Octopus.Action.KubernetesContainers.CustomResourceYaml", isExpandedByDefault: this.props.expandedByDefault, title: "Custom resource YAML", summary: this.resourceYamlSummary(), help: "Define the YAML for additional Kubernetes resources to be managed as part of this deployment." },
            React.createElement(Note_1.default, null, "A new instance of each resource listed in the editor below will be created with each deployment, and old resources will be cleaned up."),
            React.createElement(Note_1.default, null,
                "Multiple resources can be defined by separating the individual YAML documents with a triple dash i.e. ",
                React.createElement("code", null, "---"),
                "."),
            React.createElement(Note_1.default, null,
                "Learn more about ",
                React.createElement(ExternalLink_1.default, { href: "https://octopus.com/docs/deployment-examples/kubernetes-deployments/deploy-container#custom-resources-yaml" }, "custom resources"),
                "."),
            React.createElement(CodeEditor_1.default, { value: this.props.properties["Octopus.Action.KubernetesContainers.CustomResourceYaml"], language: CodeEditor_1.TextFormat.YAML, allowFullScreen: false, readOnly: true, onChange: null }),
            React.createElement("div", null,
                React.createElement(OpenDialogButton_1.default, { label: this.props.properties["Octopus.Action.KubernetesContainers.CustomResourceYaml"] ? "Edit Resource" : "Add Resource", renderDialog: function (_a) {
                        var open = _a.open, closeDialog = _a.closeDialog;
                        return (React.createElement(sourceCodeDialog_1.default, { title: "Edit Kubernetes Resource", open: open, close: closeDialog, template: _this.props.properties["Octopus.Action.KubernetesContainers.CustomResourceYaml"], doBusyTask: _this.props.doBusyTask, saveDone: function (template, metadata) {
                                _this.props.setProperties((_a = {}, _a["Octopus.Action.KubernetesContainers.CustomResourceYaml"] = template, _a));
                                var _a;
                            }, textFormat: CodeEditor_1.TextFormat.YAML, metadata: "Kubernetes" }));
                    } })));
    };
    KubernetesCustomResourceComponent.prototype.resourceYamlSummary = function () {
        if (this.props.properties["Octopus.Action.KubernetesContainers.CustomResourceYaml"]) {
            return Summary_1.default.summary("Additional resources have been defined");
        }
        return Summary_1.default.default("No additional resources have been defined");
    };
    return KubernetesCustomResourceComponent;
}(DataBaseComponent_1.DataBaseComponent));
exports.KubernetesCustomResourceComponent = KubernetesCustomResourceComponent;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesCustomResourceComponent.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "Z:\\buildAgent\\workDir\\abb2fbfce959a439\\newportal\\app\\components\\Actions\\kubernetes\\kubernetesCustomResourceComponent.tsx"); } } })();

/***/ })
],[858]);


// WEBPACK FOOTER //
// main.443927215839d912c531.hashedasset.js